angular.module('pascalprecht.translate').factory('$translationCache', ['$cacheFactory', function ($cacheFactory) {
        var $cache = $cacheFactory('results-app-translations');
        'use strict';
        $cache.put('DA', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "Adgangskode",
                "ACCESS_CODE_PROTECTION": "Beskyttelse af adgangskode",
                "ADD": "Tilføj",
                "ADD_BREAKOUT": "Tilføj rapportopdeling",
                "ADD_NOTE": "Tilføj bemærkning",
                "ADD_SCHEDULED_REPORT": "Tilføj planlagt rapport",
                "ADD_WIDGET": "Tilføj visualisering",
                "ALL_PROJECTS": "Alle projekter",
                "ALL_QUESTIONS": "Spørgsmålssider",
                "ANSWER": "Svar",
                "ANY_CHANGES_LOST": "Hvis du forlader Qualtrics XM Platform, mister du evt. rappportændringer, du har foretaget.",
                "APPENDED_COPY_IN_PARENS": "(kopi)",
                "AREA_CHART": "Områdediagram",
                "AREA_CHART_DESC": "Et kurvediagram med to akser, hvor området under stregen er udfyldt.",
                "ATTACHMENT": "Vedhæftning",
                "BACKUP_CURRENT_REPORT": "Gem en sikkerhedskopi af denne rapport, før visualiseringer påvirkes",
                "BACKUP_CURRENT_REPORT_LINE2": "Bemærk: Sikkerhedskopien får navnet \"{{nameOfReportCopy}}\"",
                "BACK_TO_REPORTS": "Tilbage til rapporter",
                "BACK_TO_TOP": "Tilbage til toppen",
                "BACK_TO_VIEW_RESULTS": "Tilbage til gamle visningsresultater",
                "BAR_CHART": "Søjlediagram",
                "BAR_CHART_DESC": "Et søjlediagram med to akser, der muliggør yderligere konfiguration som f.eks.  transposition af akser og omarrangering af datapunkter.",
                "BREAKDOWN_BAR_CHART": "Opsplitningsdiagram",
                "BREAKDOWN_BAR_CHART_DESC": "Et vandret stablet søjlediagram, der oftest anvendes til visuel vægtning af metrikker i forhold til hinanden som et alternativ til et cirkeldiagram.",
                "CANCEL": "Annuller",
                "CANCEL_CONF_TEXT": "Er du sikker på, at du vil annullere?<br/>Alle ændringer går tabt.",
                "CANCEL_EDITS": "Annuller redigeringer",
                "CHART": "Diagram",
                "CHOICE": "Valg",
                "CHOICES_COUNT_METRIC": "Antal valg",
                "CHOOSE_PAGES_TO_DISPLAY": "Vælg sider, der skal vises",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "Denne rapport indeholder {{maxReportPageCount}} sider, men Resultater kan kun indeholde op til {{reportSizeLimit}}. Vælg en delmængde inden for grænsen.",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "Rapporter kan kun indeholde op til {{reportSizeLimit}} sider. Vælg de sider, du ønsker.",
                "CLEAR_ALL": "Ryd alle",
                "CLOSE": "Luk",
                "CLOUD": "EN BESKRIVELSE TIL SKYEN",
                "COLLABORATED_NEW": "Ejeren af denne undersøgelse bruger Qualtrics XM Platform! Rapporter til denne undersøgelse redigeres med brug af nye resultater.",
                "COMMA_SEPARATED_LIST": "Kommasepareret liste",
                "COMPACTNESS": "Skrifttyper og mellemrum",
                "COMPACTNESS_INFO": "Denne indstilling påvirker tabeludfyldning, skrifttypestørrelse og søjlestørrelse i diagrammer. Den anvendes også til de fleste eksporter.",
                "CONFIRM": "OK",
                "CONFIRM_DELETE": "Bekræft sletning",
                "CONFIRM_DELETE_PAGE": "Er du sikker på, at du vil slette denne side?",
                "CONTINUE": "Fortsæt",
                "CONTINUE_EDITING": "Fortsæt redigering",
                "COPY": "Kopiér",
                "COPY_OF_REPORT_NAME": "Kopi af {{nameOfCurrentReport}}",
                "COPY_REPORT": "Kopiér rapport",
                "COPY_REPORT_ELLIPSIS": "Kopier rapport...",
                "COPY_TO_NEW_REPORT": "Kopier til ny rapport...",
                "CREATE": "Opret",
                "CREATED": "Oprettet",
                "CREATE_CUSTOM_PAGE": "Opret brugerdefineret side",
                "CREATE_NEW_REPORT": "Opret ny rapport",
                "CREATE_NEW_REPORT_ELLIPSIS": "Opret ny rapport...",
                "CSV_FILE": "CSV-fil",
                "CUSTOM_PAGES": "Brugerdefinerede sider",
                "DATE": "Dato",
                "DEFAULT_PALETTE": "Standardfarvepalet",
                "DEFAULT_REPORT": "Standardrapport",
                "DEFAULT_VISUALIZATIONS": "Standardvisualiseringer",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "Dette er standardvisualiseringstyper, der bruges til at udarbejde standardresultatrapporter. Opdatering og anvendelse af disse indstillinger vil genopbygge din aktuelle rapport med de nye standardindstillinger. Du har mulighed for at sikkerhedskopiere din aktuelle rapport.",
                "DEFAULT_VISUALIZATIONS_NOTE": "Bemærk: Det er ikke enhver visualiseringstype, der er tilgængelig for alle spørgsmålstyper. Nogle ikke-standardvisualiseringer kan automatisk blive erstattet.",
                "DEFAULT_VISUALS_DISCLAIMER": "Qualtrics opdaterer denne rapport med de nye indstillinger for standardvisualisering.",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "Denne opdatering vil påvirke {{amountOfWidgetsAffected}} visualiseringer i denne rapport.",
                "DEFAULT_VISUAL_EDIT_DETECTED": "Redigering af standardvisualisering registreret",
                "DELETE_BUTTON": "Slet",
                "DELETE_DISABLED_EXPLANATION": "Sletning af rapporter, der er oprettet i den tidligere rapporteringsbrugerflade, er ikke tilladt, før din organisation har foretaget en komplet migrering til Qualtrics XM Platform.",
                "DELETE_PAGE": "Slet side",
                "DELETE_PAGE_ELLIPSIS": "Slet side...",
                "DELETE_REPORT": "Slet rapport",
                "DELETE_REPORT_ELLIPSIS": "Slet rapport...",
                "DELETE_WIDGET_QUESTION": "Slet?",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "Dette felt er krypteret og kan ikke bruges til sortering.",
                "DISCARD_EDITS": "Kasser redigeringer",
                "DISTRIBUTION_PAUSED": "Rapportdistribution er midlertidigt afbrudt.",
                "DONE_BUTTON": "Færdig",
                "DONE_EDITING": "Færdig med redigering",
                "DOWNLOAD": "Download",
                "DOWNLOAD_AS_CSV": "Download som CSV",
                "DOWNLOAD_AS_PDF": "Download som PDF",
                "DOWNLOAD_FAILED": "Download mislykkedes",
                "DOWNLOAD_PREVIOUS_EXPORTS": "Download tidligere eksporter...",
                "DO_YOU_WISH_TO_DELETE": "Vil du slette:",
                "DUPLICATE_PAGE": "Dubletark",
                "EDIT_REPORT": "Rediger rapport",
                "EDIT_REPORT_ELLIPSIS": "Rediger rapport...",
                "EDIT_VISUALIZATION": "Rediger visualisering",
                "EMAIL_ADDRESS": "E-mailadresse",
                "EMAIL_SENT": "E--mail sendt...",
                "END_OF_REPORT": "Slutning af rapport",
                "ENTER_NAME": "Indtast navn",
                "ERROR_COPYING": "Der opstod en fejl under kopiering af rapporten.",
                "ERROR_DELETING": "Der opstod en fejl under sletning af rapporten.",
                "ERROR_DELETING_EXPORT": "Der opstod en fejl under sletning af eksporten.",
                "ERROR_HEADING": "Fejl",
                "ERROR_PUBLISHING": "Der opstod en fejl under lagring af indstillingerne.",
                "ERROR_RENAMING": "Der opstod en fejl under omdøbning af rapporten.",
                "ERROR_REQUESTING_EXPORT": "Der opstod en fejl under anmodning om eksporten.",
                "ERROR_SAVING_GLOBAL_OPTIONS": "Der opstod en fejl under lagring af globale visualiseringsindstillinger.",
                "ERROR_SEND_TEST_EMAIL": "Der opstod en fejl under afsendelse af test-e-mailen.",
                "EVERY_FRIDAY": "Hver fredag",
                "EVERY_MONDAY": "Hver mandag",
                "EVERY_MONTH": "Månedligt den",
                "EVERY_SATURDAY": "Hver lørdag",
                "EVERY_SUNDAY": "Hver søndag",
                "EVERY_THURSDAY": "Hver torsdag",
                "EVERY_TUESDAY": "Hver tirsdag",
                "EVERY_WEDNESDAY": "Hver onsdag",
                "EVERY_WEEK": "Ugentligt hver",
                "EXAMPLE_GROUP_NUM": "Gruppe {{num}}",
                "EXAMPLE_SERIES_NUM": "Serie {{num}}",
                "EXPORT": "Eksportér",
                "EXPORT_CSV": "CSV (kommasepareret )",
                "EXPORT_EXCEL_SPREADSHEET": "Excel-regneark",
                "EXPORT_IMAGE": "Eksporter billede",
                "EXPORT_PAGES": "Eksporter sider",
                "EXPORT_PDF": "PDF-dokument",
                "EXPORT_PPT_SLIDES": "PowerPoint-slides",
                "EXPORT_RAW_DATA": "Eksporter rådata",
                "EXPORT_REPORT": "Eksporter rapport",
                "EXPORT_VISUALIZATION": "Eksporter visualisering",
                "EXPORT_WORD_DOC": "Word-dokument",
                "FAILED_SAVE_TXT": "Der kunne ikke gemmes",
                "FILTERED": "Filtreret",
                "FIRST_PAGE": "Første side",
                "FIRST_WEEKDAY": "Første ugedag i måneden",
                "FROM": "Fra",
                "FROM_EMAIL": "Fra e-mail",
                "FROM_NAME": "Fra navn",
                "GAUGE_CHART": "Målerdiagram",
                "GAUGE_CHART_DESC": "Et diagram, der ligner et målerværktøj, til sammenligning af aktuelle værdier med et mål eller en serie tærskler.",
                "GENERATING_FILE": "Genererer fil...",
                "GENERATING_IMAGE": "Genererer billede...",
                "GENERATING_PDF": "Genererer PDF...",
                "GENERIC_ERROR": "En fejl forhindrede, at vi kunne indlæse det projekt, du har anmodet om.",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "Globale indstillinger...",
                "GLOBAL_METRIC": "Standardmetrik",
                "GLOBAL_MODAL_PAGE_TITLE": "Eksempelvisualisering med brug af globale indstillinger til afsnittet Resultater i Qualtrics Research Suite",
                "GLOBAL_MODAL_WIDGET_TITLE": "Visualiseringstitel",
                "GLOBAL_OPTIONS": "Globale indstillinger",
                "GLOBAL_PRECISION": "Standarddecimaler",
                "GLOBAL_SETTINGS_APPLY": "Anvend mine standardindstillinger",
                "GLOBAL_SETTINGS_SAVE": "Gem som mine standardindstillinger",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "Anvend Qualtrics-standard",
                "GROUP": "Gruppe",
                "HEAT_MAP_CHART": "Heatmap-diagram",
                "HEAT_MAP_CHART_DESC": "En klyngeopdelt visualisering i \"heat\"-stil, der bruges til at tilknytte distribution af brugerinput (f.eks. klik) til det oprindelige billede.",
                "HIDDEN": "Skjult",
                "HIDDEN_PAGE": "Denne side vises ikke i offentlige rapporter og fravælges som standard i eksporter af rapporter.",
                "HIDE": "Skjul",
                "HIDE_ALL_PAGES": "Skjul alle sider",
                "HIDE_PAGE": "Skjul side",
                "IMAGE_FILE": "Billedfil",
                "INVALID_BRAND_DOMAIN": "Det domæne, du har indtastet, findes ikke på dit mærkes liste over godkendte e-maildomæner. Kontakt administratoren af dit mærke for at få løst problemet.",
                "INVALID_SPF_RECORD": "Det domæne, du har indtastet, har ikke godkendt, at Qualtrics kan sende fra det. Det vil påvirke leveringsmulighederne. Brug venligst et andet domæne, eller kontakt Qualtrics vedrørende løsning af dette problem.",
                "ISSUE_SAVING_REPORTS": "En eller flere rapporter registrerede et problem i forbindelse med lagring. Prøv venligst igen.",
                "ISSUE_SENDING_TEST": "Der opstod en fejl ved afsendelse af en test-e-mail. Prøv igen.",
                "LARGE_SURVEY": "Resultater vises ikke, fordi undersøgelsen er for stor.",
                "LAST_DAY": "Sidste dag i måned",
                "LAST_MODIFIED_COLON_WITH_DATE": "Senest ændret: %1",
                "LAST_PAGE": "Sidste side",
                "LAST_WEEKDAY": "Sidste ugedag i måned",
                "LATER": "Senere",
                "LEARN_MORE": "Få mere at vide",
                "LINE_CHART": "Kurvediagram",
                "LINE_CHART_DESC": "Et kurvediagram med to akser, som ofte bruges til grafisk afbildning i forhold til tid på x-aksen.",
                "LOG_OUT_WARNING": "Klik et vilkårligt sted inden for {{countdown}} sekunder for at forblive logget på",
                "MESSAGE": "Meddelelse",
                "MONTHLY": "Månedligt",
                "MOVE_DOWN": "Flyt visualisering ned",
                "MOVE_PAGE_TO_BOTTOM": "Flyt til bund",
                "MOVE_PAGE_TO_TOP": "Flyt til top",
                "MOVE_UP": "Flyt visualisering op",
                "MY_SURVEYS": "Mine projekter",
                "NAME": "Navn",
                "NEW_CUSTOM_PAGE_NAME": "Ny brugerdefineret side",
                "NEW_REPORT": "Ny rapport",
                "NEXT_PAGE": "Næste side",
                "NEXT_RUN": "Næste kørsel",
                "NO_EXPORTS": "Der er endnu ikke anmodet om eksporter for denne rapport.",
                "NO_ITEMS_TO_DISPLAY": "Ingen elementer til visning",
                "NO_MATCHING_CUSTOM_PAGES": "Ingen matchende brugerdefinerede sider",
                "NO_MATCHING_PAGES": "Der blev ikke fundet nogen sider til søgning",
                "NO_MATCHING_REPORTS": "Ingen matchende rapporter.",
                "NO_PROJECT": "Angiv venligst et projekt for at fortsætte.",
                "NO_PROJECTS_TO_MIGRATE": "Der er ingen projekter at opdatere.",
                "NO_QUESTIONS": "Ingen matchende spørgsmål",
                "NO_RESULTS_YET": "Der er endnu ingen resultater at vise. Distribuer din undersøgelse for at indsamle svar.",
                "OFF": "Fra",
                "ON": "Til",
                "PAGES_SELECTED": "Valgte sider",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "Dette valg vil betyde, at rapporten indeholder {{currentSelectedPageCount}} sider, hvilket er højere end det tilladte maksimum på {{reportSizeLimit}}. Vælg et mindre interval.",
                "PAGES_SELECTION_INVALID_RANGE": "Vælg et gyldigt interval.",
                "PAGE_OPTIONS": "Sideindstillinger",
                "PDF_ROW_TRUNCATION_MESSAGE": "For mange rækker½< til PDF-eksport, prøv at eksportere til Word eller CSV",
                "PERCENTAGE_METRIC": "Procentdel",
                "PIE_CHART": "Cirkeldiagram",
                "PIE_CHART_DESC": "En cirkulær opdeling af værdier for et givet datapunkt. Er nyttig til at måle relative forhold for valgte værdier.",
                "PREVIEW": "Eksempelvisning",
                "PREVIOUS_PAGE": "Forrige side",
                "PRINT_PAGE": "Udskriv side",
                "PUBLIC_LINK": "Offentligt link",
                "PUBLIC_REPORT_AVAILABLE": "Tilgængelig offentlig rapport",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "Adgangskode",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "Forkert adgangskode. Prøv igen.",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "Send",
                "PUBLIC_RESULTS_LOGIN_TITLE": "Logon til offentlig rapport | Qualtrics-undersøgelsessoftware",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "Offentlig rapport blev ikke fundet. Kontakt ejeren af denne rapport, og bed om et gyldigt link.",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "Offentlig rapport ikke fundet",
                "PUBLIC_RESULTS_NOT_UPDATED": "Links i offentlige rapporter og planlagte rapport-e-mails vil ikke bruge Qualtrics XM Platform, før du opdaterer dem.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "Session er udløbet. Log på igen for at fortsætte med at vise offentlige resultatrapporter.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "Sessionen er udløbet",
                "PUBLIC_RESULTS_TITLE": "Offentlig rapport",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "Du er ikke autoriseret til at se denne side. Kontakt venligst ejeren af rapporten, og bed dem om at gøre den offentlig.",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "Offentlig rapport ikke autoriseret",
                "PUBLISHED_LINK_GENERATING_LINK": "Genererer link...",
                "PUBLISHED_REPORT_FOUND_HERE": "Alle kan se denne rapport på følgende link:",
                "PUBLISH_REPORT": "Administrer offentlig rapport",
                "PUBLISH_REPORT_ELLIPSIS": "Administrer offentlig rapport...",
                "QUESTION": "Spørgsmål",
                "RANK": "Rangorden",
                "REMOVE_WIDGET": "Fjern visualisering",
                "RENAME_PAGE": "Omdøb side",
                "RENAME_REPORT": "Omdøb rapport",
                "RENAME_REPORT_ELLIPSIS": "Omdøb rapport...",
                "REPLY_TO_EMAIL": "E-mail til besvarelse",
                "REPORT_COLON": "Rapport:",
                "REPORT_SETTINGS": "Rapportindstillinger",
                "REPORT_SETTINGS_ELLIPSIS": "Rapportindstillinger...",
                "RESPONSE_COUNTS": "Svarantal",
                "RESULTS_DASHBOARDS_BANNER": "og prøv den nye, forbedrede version af undersøgelse resultater, med moderne, tilgængelig UI og datavisualiseringer, nye analyse- og udforskningsfunktioner og mere.",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "Produktbemærkninger",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "Vis den seneste",
                "RESULTS_OPTIONS": "Rapportindstillinger",
                "RESULTS_TITLE": "Rapport:",
                "RESUME_DISTRIBUTION": "Genoptag distribution",
                "REVERT": "Annuller",
                "RICH_TEXT_LIMIT_REACHED": "Indholdslænge har nået grænsen!",
                "SAVE": "Gem",
                "SAVE_AND_CLOSE": "Gem og luk",
                "SAVE_AS_CSV": "Gem visualiseringer som CSV",
                "SAVE_AS_IMAGE": "Gem visualiseringer som billede",
                "SAVE_CONFIRMATION": "Gem bekræftelse",
                "SAVE_PAGE_AS_ELLIPSIS": "Eksporter side som...",
                "SAVE_SETTINGS": "Gem indstillinger",
                "SCHEDULE_REPORT_EMAIL": "Planlæg rapport-e-mail",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "Planlæg rapport-e-mail...",
                "SEARCH_ELLIPSIS": "Søg...",
                "SEARCH_PAGES": "Søg efter spørgsmål",
                "SEARCH_PAGES_ELLIPSIS": "Søg efter sider...",
                "SEARCH_REPORTS_ELLIPSIS": "Søg efter rapporter...",
                "SELECTED": "Valgt:",
                "SELECT_ALL": "Vælg alle",
                "SELECT_A_FIELD": "Vælg et felt",
                "SELECT_A_WIDGET": "Vælg en visualisering",
                "SELECT_PAGES": "Vælg sider",
                "SELECT_PAGES_ELLIPSIS": "Vælg sider...",
                "SEND": "Send",
                "SEND_TEST_EMAIL": "Send test-e-mail",
                "SETTING_DEFAULT": "Standard",
                "SETTING_HIGH": "Høj",
                "SETTING_LARGE": "Stor",
                "SETTING_LOW": "Lav",
                "SETTING_NORMAL": "Normal",
                "SETTING_SMALL": "Lille",
                "SHARE_REPORT": "Del rapport",
                "SHOW_ALL_PAGES": "Vis alle sider",
                "SHOW_FULL_QTEXT": "Vis hele spørgsmålsteksten i sidetitler",
                "SIMPLE_TABLE": "Simpel tabel",
                "SIMPLE_TABLE_DESC": "En fleksibel tabel, der kan vise flere værdier som rækker eller kolonner.",
                "SIZE": "Størrelse",
                "SPLINE_CHART": "Sløjfediagram",
                "SPLINE_CHART_DESC": "Et afrundet kurvediagram med to akser, som ofte bruges til grafisk afbildning i forhold til tid på x-aksen.",
                "STATISTICS_TABLE": "Statistiktabel",
                "SUBJECT": "Emne",
                "SURVEY_ANALYSIS": "Undersøgelsesanalyse",
                "SURVEY_SUMMARY": "Sammendrag af undersøgelser",
                "TABLE": "EN BESKRIVELSE TIL TABEL",
                "TIME": "Tidspunkt",
                "TO": "Til",
                "TOTAL": "Samlet",
                "TRANSPOSE_STATS_TABLES": "Transponer statistiktabeller",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "Transponer opdelinger af statistiktabeller",
                "TRUNCATE_PAGE_TITLES": "Afkort spørgsmålstekst i sidetitler",
                "TRY_IT_NOW": "Prøv den nu",
                "TYPE": "Indtast",
                "UNABLE_TO_CHECK_SPF": "SPF-posten kan ikke kontrolleres. Prøv igen.",
                "UNAUTHORIZED": "Du har ikke tilladelse til at se denne rapport. Kontakt venligst ejeren for at få adgang.",
                "UNHIDE_PAGE": "Vis side",
                "UPDATE": "Opdater",
                "UPDATED_SUCCESSFULLY": "Er opdateret.",
                "UPDATE_ALL_IN_THIS_PROJECT": "Opdater alt i dette projekt",
                "UPDATE_ALL_PROJECTS": "Opdater alle projekter",
                "UPDATE_NOW": "Opdater nu",
                "UPDATE_REPORTS": "Opdater rapporter...",
                "UPDATE_REPORT_ELEMENTS": "Opdater links i offentlige rapporter og planlagte rapport-e-mails",
                "UPGRADE_MY_ACCOUNT": "Opgrader min konto",
                "USE_EXPORT_TAGS": "Inkluder spørgsmålsnumre",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "Brug kolonnetotaler for simpel tabel",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "Brug svarpersonantal for simpel tabel",
                "USE_WEIGHTED_METRICS": "Brug vægtede metrikker",
                "VIEW": "Vis",
                "WEEKLY": "Ugentligt",
                "WELCOME_TO_NEW_RESULTS": "Velkommen til rapportering på Qualtrics XM Platform.",
                "WHEN": "Når",
                "WIDGET_LOADING": "Indlæser...",
                "WIDGET_OPTIONS_ERR": "Visualiseringsindstillinger kunne ikke indlæses",
                "WIDGET_TYPE": "Visualisering",
                "WORD_CLOUD": "Ordsky",
                "WORD_CLOUD_DESC": "En vægtet visualisering af ordfrekvens i tekstdata med ekstra indstillinger til farvekodning."
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Husk, at der er ressourcer i din organisation til at hjælpe dig med at tolke din feedback, f.eks. HR-partnere, din leder og/eller en mentor.",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Tag dig en kop kaffe, og fordyb dig i din feedback.",
                "ABOUT_YOUR_REPORT_HEADER": "Om din rapport",
                "ABOUT_YOUR_REPORT_LINE1": "Velkommen til din 360-graders feedback-rapport. Dette er en fantastisk mulighed for at fremme din professionelle udvikling. Sørg for at afsætte tilstrækkelig tid til at gennemgå feedback, så du får mest muligt ud af resultaterne. Det kan i starten være svært at lytte til feedback, men husk at formålet med denne feedback er at accelerere din vækst og udvikling.",
                "ABOUT_YOUR_REPORT_LINE2": "Her er nogle ting, du bør huske på, når du gennemgår din rapport.",
                "ADD_CONDITIONAL_TEXT": "Tilføj betinget tekst",
                "ADD_CUSTOM_PALETTE": "Tilføj brugerdefineret palet",
                "ADD_DATA_SOURCE": "Tilføj datakilde",
                "ADD_FOLLOWING": "Tilføj følgende",
                "ADD_LABEL": "Tilføj etiket",
                "ADVANCED_FILTER": "Avanceret filter",
                "AGREEMENT_CHART": "Overensstemmelsesdiagram",
                "AGREEMENT_CHART_FOOTER": "Overensstemmelsesdiagrammet angiver, hvor meget scoringen stemmer overens. Hver prik repræsenterer, hvordan individer har bedømt dig for hvert element. Størrelsen på prikken viser, hvor mange bedømmere, der gav dig en specifik bedømmelse.",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "svar",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "svar",
                "AGREEMENT_CHART_LEGEND_TITLE": "Sådan har andre bedømt dig",
                "ALL": "Alle",
                "AND_IF": "Og hvis",
                "ANGLED": "Vinklet",
                "AREA": "Område",
                "AUTO": "Automatisk",
                "AVERAGE": "Gennemsnit",
                "AXIS_VALUES": "Akseværdier",
                "BAR": "Bjælke",
                "BASE_WORD_COLOR": "Basisordfarve",
                "BLUR": "Slør",
                "BOTTOM_BOX": "Nederste felt",
                "BREAKOUT_HEADERS": "Opdelingsoverskrifter",
                "CANCEL": "Annuller",
                "CATEGORICAL": "Efter kategori",
                "CATEGORY": "Kategori",
                "CATEGORY_NAME": "Kategorinavn",
                "CHANGE_CATEGORIES_ORDER": "Skift rækkefølge for kategorier",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "Skift rækkefølge for scoring-kategorier",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "Skift rækkefølgen, som vises i visualiseringen, ved at klikke til venstre for scoring-kategorielementet og trække det til den ønskede placering.",
                "CHANGE_QUESTIONS_ORDER": "Skift rækkefølge for spørgsmål",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "Skift rækkefølge for spørgsmål",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "Skift rækkefølgen, som vises i visualiseringen, ved at klikke til venstre for spørgsmålselementet og trække det til den ønskede placering.",
                "CHARTS": "Diagrammer",
                "CHART_TYPE": "Diagramtype",
                "CHOICE_COUNT": "Antal valg",
                "CHOICE_TOTALS": "Valg i alt",
                "CLEAR": "Ryd",
                "CLOSE": "Luk",
                "COLOR_PALETTE": "Farvepalet",
                "COLUMN_NAMES": "Kolonnenavne",
                "COLUMN_TOTALS": "Kolonnetotal",
                "COMPARED_FILTER_GROUP": "Sammenlignet filtergruppe",
                "COMPARED_FILTER_GROUPS": "Sammenlignet filtergruppe",
                "COMPARE_WITH": "sammenlign med",
                "COMPETITION_RANKING": "Brug konkurrencerangering",
                "COMPETITION_RANKING_TOOLTIP": "Hvis det står lige, får alle ens scoringer samme rangering. Det næste efterfølgende element rangeres imidlertid ens med: det samlede antal elementer, der er rangeret højere i tabellen, plus en.",
                "COMPLETED_RESPONSES": "Fuldførte svar",
                "CONDITIONAL_TEXT": "Betinget tekst",
                "COUNT": "Antal",
                "CREATE": "Opret",
                "CUSTOM_PALETTE": "Brugerdefineret palet",
                "DATA_SOURCE_TYPE": "Datakildetype",
                "DATA_SOURCE_TYPE_CATEGORY": "Kategorier for scoring",
                "DATA_SOURCE_TYPE_QUESTION": "Spørgsmål",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "Spørgsmål",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "Elementer, der kan rangordnes",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "Kategori for scoring",
                "DEFAULT": "Standard",
                "DEFAULT_TEXT": "Standardtekst",
                "DELETE": "Slet",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "Se, hvor din feedback kommer fra - om det er kolleger, direkte underordnede medarbejdere, ledere osv.",
                "DIFFERENT_EVALUATORS_HEADER": "Forskellige evaluatorer",
                "DIRECT_REPORTS": "Direkte underordnede medarbejdere",
                "DISABLED": "Deaktiveret",
                "DISPLAY_OPTIONS": "Visningsmuligheder",
                "DISPLAY_THRESHOLD_TEXTS": "Vis tekst baseret på følgende gruppeafvigelse",
                "DIVERGENT": "Divergens",
                "DONE": "Færdig",
                "DONT_HEADER": "Anbefales ikke:",
                "DONT_LINE1": "Prøv at finde ud af, hvem der sagde hvad",
                "DONT_LINE2": "Fokuser på en positiv eller negativ score/kommentar",
                "DONT_LINE3": "Opret en udviklingsplan omkring hvert element",
                "DONT_LINE4": "Lad dig afskrække af, at der er forbedringsområder",
                "DONUT": "Krans",
                "DOWNLOAD_CSV": "Download ældre CSV",
                "DOWNLOAD_ZIP": "Download alle filer",
                "DO_HEADER": "Anbefales:",
                "DO_LINE1": "Se holistisk på feedbacken",
                "DO_LINE2": "Identificer temaer inden for styrker og forbedringsområder",
                "DO_LINE3": "Prioriter enkelte fokusområder, der kan tilføjes til din udviklingsplan",
                "DO_LINE4": "Forstå, at alle har forbedringsområder",
                "DROPOFF": "Drop-off",
                "DUPLICATE": "Duplikeret",
                "EDIT_CONDITIONAL_TEXT": "Rediger betinget tekst",
                "EDIT_CUSTOM_PALETTE": "Rediger brugerdefineret palet",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "Ellers vises følgende tekst",
                "ENABLED": "Aktiveret",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "Aktiver rækkefølge efter visningslogik for kategorier af bedømmere",
                "ENABLE_ORDERING_FOR": "Aktiver rækkefølge af",
                "EQUAL_TO": "Lig med",
                "FIELD": "Felt",
                "FILTER_NAMES": "Filtrer navne",
                "FOLLOWING_PARENTHESES": "(efterfølgende)",
                "FOOTER": "Sidefod",
                "GAP": "Hul",
                "GAP_CHART": "Gap-diagram",
                "GAP_CHART_DESCRIPTION": "Gap-diagrammet viser differencen i scorer mellem to grupper af bedømmere. For eksempel i tilfælde af selvbedømmelse i forhold til hvordan andre har bedømt dig betyder en positiv (+) difference, at andre har bedømt dig højere end den bedømmelse, du har givet dig selv. En negativ (-) difference betyder, at andre har bedømt dig lavere end den bedømmelse, du har givet dig selv.",
                "GAP_CHART_FOOTER": "Gap-diagrammet angiver differencen (+/-) mellem to grupper af bedømmere.",
                "GAP_TABLE_DESCRIPTION": "Skjulte styrker viser, hvor andre har bedømt dig højere, end du har bedømt dig selv. Forbedringsområder viser, hvor andre har bedømt dig lavere, end du har bedømt dig selv. Begge afsnit vises i rangorden fra største til mindste difference.",
                "GAP_TABLE_FOOTER": "Den første kolonne med resultater angiver, med hvilken score du har bedømt dig selv. Den anden kolonne angiver den gennemsnitlige score fra andre. Den tredje kolonne angiver differencen mellem den score, du har givet dig selv, og den score andre har givet dig.",
                "GAP_TABLE_TITLE": "Skjulte styrker/forbedringsområder",
                "GREATER_OR_EQUAL": "Større end eller lig med",
                "GREATER_THAN": "Større end",
                "GROUP": "Gruppe",
                "GROUPED_FOR_ANONYMITY": "Grupperet af hensyn til anonymitet",
                "HEADER_NAMES": "Sidehovednavne",
                "HIGHEST_SCORES": "Højeste score",
                "HIGHLIGHT_THRESHOLD": "Tærskel for fremhævning af huller",
                "HIGHLOW_TABLE": "Høj og lav score",
                "HIGHLOW_TABLE_FOOTER": "Dette afsnit viser de fem højest og lavest bedømte typer af adfærd (på tværs af alle typer af adfærd) fra gennemsnittene for de relevante kategorier af bedømmere. For at få mest muligt ud af denne side, er det nyttigt at søge efter mulige tendenser. Hvis f.eks. størstedelen af din lavest bedømte adfærd er koncentreret i en eller to kategorier, kan der være områder, hvor der er behov for udvikling. Den højest bedømte adfærd kan identificere styrker, der kan udnyttes på andre områder.",
                "HIGH_LOW_TABLE_DESCRIPTION": "Diagrammet med højeste/laveste viser elementer baseret på de områder, hvor andre har bedømt dig højest og lavest.",
                "HORIZONTAL": "Vandret",
                "HORIZONTAL_AND_VERTICAL": "Vandret og lodret",
                "HORIZONTAL_BAR": "Vandret bjælke",
                "HOW_TO_INTERPRET_RESULT_HEADER": "Sådan fortolker du resultaterne og fastlægger handling:",
                "IF": "Hvis",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "Inkluder skjulte etiketter i procentdele",
                "INNER_RIM": "Indre kant",
                "IS": "Er",
                "IS_NOT": "Er ikke",
                "IS_SAME_AS_SUBJECT": "Er samme som emne",
                "ITEM": "Element",
                "LABEL": "etiket",
                "LABELS": "Etiketter",
                "LARGE_LABELS": "Store etiketter",
                "LEGEND": "Forklaring",
                "LEGEND_POSITION": "Placering af forklaring",
                "LEGEND_VALUES": "Værdier i forklaring",
                "LESS_OR_EQUAL": "Mindre end eller lig med",
                "LESS_THAN": "Mindre end",
                "LINE": "Linje",
                "LOWEST_SCORES": "Laveste score",
                "MANAGERS": "Ledere",
                "MANUAL_FONT_SIZE": "Angiv skriftstørrelse manuelt",
                "MAX": "Maks.",
                "MEAN": "Middel",
                "MEDIAN": "Median",
                "METRIC_TYPE": "Metriktype",
                "MIN": "Min.",
                "MODIFY_CUSTOM_PALETTES": "Rediger brugerdefinerede paletter",
                "MOVE_DOWN": "Flyt ned",
                "MOVE_UP": "Flyt op",
                "MULTI_SELECT_ITEMS_SELECTED": "valgt",
                "NEGATIVE_GAPS": "Forbedringsområder",
                "NO": "Nej",
                "NONE": "Ingen",
                "NOT_APPLICABLE": "Ikke relevant",
                "NOT_EQUAL_TO": "Ikke lig med",
                "NO_DATA_AVAILABLE_WARNING": "Ingen data tilgængelige",
                "NO_FILTER": "Nej filter",
                "NO_FILTER_IS_APPLIED": "Intet filter er anvendt.",
                "NO_VALUE": "Ingen værdi",
                "NPS": "Net Promoter® Score",
                "NUMBER": "nummer",
                "NUMBERS": "Tal",
                "NUMBER_OF_GAPS_NEGATIVE": "Antal negative gaps",
                "NUMBER_OF_GAPS_POSITIVE": "Antal positive gaps",
                "NUMBER_OF_ROWS_HIGH": "Antal høje rækker",
                "NUMBER_OF_ROWS_LOW": "Antal lave rækker",
                "OPTIONS": {
                    "HEADER_NAME": "Sidehovednavn",
                    "LEGEND": "Forklaring",
                    "SCALE_AXIS_CHANGER_TITLE": "Interval"
                },
                "ORIENTATION": "Retning",
                "OR_IF": "Eller hvis",
                "OTHER": "Andre",
                "OTHERS": "Andre",
                "PAGE_OF": "Side: %1 af %2",
                "PALETTE_REMOVED": "Palet fjernet",
                "PEERS": "Kolleger",
                "PERCENT": "Procent",
                "PERCENTAGE": "Procentdel",
                "PERCENTAGE_OF_CHOICES": "Procentdel af valgmuligheder",
                "PERCENTAGE_OF_RESPONSES": "Procentdel af svar",
                "PERCENT_COMPLETE": "% fuldført",
                "PERSON_METADATA": "Personmetadata",
                "PERSON_METADATA_EVALUATOR": "Evaluators",
                "PERSON_METADATA_SUBJECT": "Emnes",
                "PERSON_METADATA_VIEWER": "Fremvisers",
                "POSITIVE_GAPS": "Skjulte styrker",
                "PRIMARY_PARENTHESES": "(primært)",
                "QUESTIONS": "Spørgsmål",
                "RADIUS": "Radius",
                "RANK": "Rangorden",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "Højeste score",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "Højeste scorer",
                "RANKABLE_ITEMS_ITEM_HAS": "Elementet har",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "Elementet er øverst",
                "RANKABLE_ITEMS_LOWEST_SCORE": "Laveste score",
                "RANKABLE_ITEMS_LOWEST_SCORES": "Laveste scorer",
                "RATER_CATEGORY_DISPLAY_LOGIC": "visningslogik for kategorier af bedømmere",
                "RATIO": "Forhold",
                "RECORD": "Post",
                "REFERENCE_GROUP": "Referencegruppe",
                "RELATIONSHIP": "Relation",
                "RELATIONSHIP_FILTERS": "Relationsfiltre",
                "RELATIONSHIP_FILTERS_INFO": "For at tilføje et relationsfilter (f.eks. en direkte underordnet medarbejder, kollega eller leder) skal du vælge at administrere dine filtre og kun bruge Relationsbetingelse fra rullemenuen.",
                "REMOVE": "Fjern",
                "REMOVE_DATA_SOURCE": "Fjern datakilde",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Husk, at der er ressourcer i din organisation til at hjælpe dig med at tolke din feedback, f.eks. HR-partnere, din leder og/eller en mentor.",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Tag dig en kop kaffe, og fordyb dig i din feedback.",
                    "ABOUT_YOUR_REPORT_HEADER": "Om din rapport",
                    "ABOUT_YOUR_REPORT_LINE1": "Velkommen til din 360-graders feedback-rapport. Dette er en fantastisk mulighed for at fremme din professionelle udvikling. Sørg for at afsætte tilstrækkelig tid til at gennemgå feedback, så du får mest muligt ud af resultaterne. Det kan i starten være svært at lytte til feedback, men husk at formålet med denne feedback er at accelerere din vækst og udvikling.",
                    "ABOUT_YOUR_REPORT_LINE2": "Her er nogle ting, du bør huske på, når du gennemgår din rapport.",
                    "ADVANCED_FILTER": "Avanceret filter",
                    "AGREEMENT_CHART": "Overensstemmelsesdiagram",
                    "AGREEMENT_CHART_FOOTER": "Overensstemmelsesdiagrammet angiver, hvor meget scoringen stemmer overens. Hver prik repræsenterer, hvordan individer har bedømt dig for hvert element. Størrelsen på prikken viser, hvor mange bedømmere, der gav dig en specifik bedømmelse.",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "svar",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "svar",
                    "AGREEMENT_CHART_LEGEND_TITLE": "Sådan har andre bedømt dig",
                    "ALL": "Alle",
                    "AVERAGE": "Gennemsnit",
                    "BOTTOM_BOX": "Nederste felt",
                    "CHOICE_COUNT": "Antal valg",
                    "CHOICE_TOTALS": "Valg i alt",
                    "COMPARISON": "Sammenligning",
                    "COMPARISON_GAP_COLUMN_HEADER": "Sammenligningsforskel",
                    "COMPLETED_RESPONSES": "Fuldførte svar",
                    "COUNT": "Antal",
                    "DEFAULT": "Standard",
                    "DEFAULT_TEXT": "Standardtekst",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "Se, hvem din feedback kommer fra - om det er kolleger, direkte underordnede medarbejdere, ledere osv.",
                    "DIFFERENT_EVALUATORS_HEADER": "Forskellige evaluatorer",
                    "DONE": "Færdig",
                    "DONT_HEADER": "Anbefales ikke:",
                    "DONT_LINE1": "Prøv at finde ud af, hvem der sagde hvad",
                    "DONT_LINE2": "Fokuser på en positiv eller negativ score/kommentar",
                    "DONT_LINE3": "Opret en udviklingsplan omkring hvert element",
                    "DONT_LINE4": "Lad dig afskrække af, at der er muligheder for forbedring",
                    "DO_HEADER": "Sådan:",
                    "DO_LINE1": "Se holistisk på feedbacken",
                    "DO_LINE2": "Identificer temaer inden for styrker og muligheder for forbedring",
                    "DO_LINE3": "Prioriter enkelte fokusområder, der kan tilføjes til din udviklingsplan",
                    "DO_LINE4": "Forstå, at alle har forbedringsområder",
                    "FIELD": "Felt",
                    "GAP": "Hul",
                    "GAP_CHART": "Gap-diagram",
                    "GAP_CHART_DESCRIPTION": "Gap-diagrammet viser differencen i scorer mellem to grupper af bedømmelser. For eksempel i tilfælde af selvbedømmelse i forhold til hvordan andre har bedømt dig betyder en positiv (+) difference, at andre har bedømt dig højere end den bedømmelse, du har givet dig selv. En negativ (-) difference betyder, at andre har bedømt dig lavere end den bedømmelse, du har givet dig selv.",
                    "GAP_CHART_FOOTER": "Gap-diagrammet angiver differencen (+/-) mellem to grupper af",
                    "GAP_TABLE_DESCRIPTION": "Skjulte styrker viser, hvor andre har bedømt dig højere, end du har bedømt dig selv. Forbedringsområder viser, hvor andre har bedømt dig lavere, end du har bedømt dig selv. Begge afsnit vises i rangorden fra største til mindste difference.",
                    "GAP_TABLE_FOOTER": "Den første kolonne med resultater angiver, med hvilken score du har bedømt dig selv. Den anden kolonne angiver den gennemsnitlige score fra andre. Den tredje kolonne angiver differencen mellem den score, du har givet dig selv, og den score andre har givet dig.",
                    "GAP_TABLE_TITLE": "Skjulte styrker/forbedringsområder",
                    "GROUP": "Gruppe",
                    "HIDE_REPORT_ALERT": "Du opfylder ikke kravene for at vise din rapport. Kontakt din organisations administrator.",
                    "HIGHEST_SCORES": "Højeste score",
                    "HIGHLOW_TABLE": "Høj og lav score",
                    "HIGHLOW_TABLE_FOOTER": "Dette afsnit viser de fem højest og lavest bedømte typer af adfærd (på tværs af alle typer af adfærd) fra gennemsnittene for de relevante kategorier af bedømmere. For at få mest muligt ud af denne side, er det nyttigt at søge efter mulige tendenser. Hvis f.eks. størstedelen af din lavest bedømte adfærd er koncentreret i en eller to kategorier, kan der være områder, hvor der er behov for udvikling. Den højest bedømte adfærd kan identificere styrker, der kan udnyttes på andre områder.",
                    "HIGH_LOW_TABLE_DESCRIPTION": "Diagrammet med højeste/laveste viser elementer baseret på de områder, hvor andre har bedømt dig højest og lavest.",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "Sådan fortolker du resultaterne og fastlægger handling:",
                    "ITEM": "Element",
                    "LOWEST_SCORES": "Laveste score",
                    "MAX": "Maks.",
                    "MEAN": "Middel",
                    "MEDIAN": "Median",
                    "MIN": "Min.",
                    "NEGATIVE_GAPS": "Forbedringsområder",
                    "NO_COMPARISON_SET": "Intet sammenligningssæt",
                    "NO_DATA_AVAILABLE_WARNING": "Ingen data tilgængelige",
                    "NO_FILTER_IS_APPLIED": "Intet filter er anvendt.",
                    "NO_VALUE": "Ingen værdi",
                    "NPS": "Net Promoter® Score",
                    "OTHERS": "Andre",
                    "PERCENTAGE": "Procentdel",
                    "PERCENTAGE_OF_CHOICES": "Procentdel af valgmuligheder",
                    "PERCENTAGE_OF_RESPONSES": "Procentdel af svar",
                    "PERCENT_COMPLETE": "% fuldført",
                    "POSITIVE_GAPS": "Skjulte styrker",
                    "QUESTIONS": "Spørgsmål",
                    "RANK": "Rangorden",
                    "RELATIONSHIPS": {
                        "ANYONE": "Alle",
                        "DIRECT_REPORT": "Direkte underordnet medarbejder",
                        "MANAGER": "Leder",
                        "PEER": "Kollega",
                        "SELF": "Selv"
                    },
                    "REPORT_SUMMARY": "Rapportoversigt",
                    "REPORT_SUMMARY_TABLE_FOOTER": "Sammenlign antallet af personer, der har afsluttet din bedømmelse, med antallet af personer, der er inviteret til at deltage.",
                    "REPORT_SUMMARY_TABLE_HEADER": "Statistik over svarpersoner",
                    "RESPONSES": "Svar",
                    "RESPONSE_COUNT": "{{responseCount}} svar",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> svar",
                    "SCORING_CATEGORY": "Kategori for scoring",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Ingen svar for denne kategori",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Ingen svar for dette spørgsmål",
                    "SCORING_OVERVIEW": "Scoring-oversigt",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "Du og andre evaluatorer mener, at dette område er en topstyrke.",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Anerkendt styrke",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Et anerkendt forbedringsområde betyder, at både selvbedømmelse og bedømmelser fra andre er under gennemsnittet for denne kompetence.",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Anerkendt forbedringsområde",
                    "SCORING_OVERVIEW_DESCRIPTION": "Ovenfor er de kompetencer eller typer af adfærd, hvor du blev evalueret som del af denne proces med feedback fra flere bedømmere. Sammenlignende bedømmelser er angivet efter gruppe.",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "Mindste difference",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Mindste difference mellem referencegrupper for tekster, der skal vises.",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "Intervallet af score for hver kompetence/adfærd vises. Bjælken repræsenterer det numeriske gennemsnit.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Ikke-anerkendt styrke kommer fra differencen mellem selvbedømmelsen og bedømmelserne fra andre.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Ikke-anerkendt styrke",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Ikke-anerkendt forbedringsområde kommer fra differencen mellem selvbedømmelsen og bedømmelserne fra andre.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Ikke-anerkendt forbedringsområde",
                    "SELF": "Selv",
                    "SELF_ASSESSMENT": "Selvbedømmelse",
                    "STANDARD_DEVIATION": "Standardafvigelse",
                    "SUM": "Total",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Sæt dig grundigt ind i vurderingsskalaen for at sikre korrekt fortolkning",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "Bemærk skalaen",
                    "THINGS_YOU_WILL_SEE_HEADER": "Det vil du se:",
                    "THREE_SIXTY_PERCENTILE": "Percentil",
                    "TOP_BOTTOM_BOX": "Øverste felt/nederste felt",
                    "TOP_BOX": "Øverste felt",
                    "TOTAL": "Samlet",
                    "TO_DO": "Opgaver",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Kvalitativt: Denne feedback vil være i form af åbne tekstkommentarer",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Kvantitativt: Denne feedback vil være numerisk og kan være repræsenteret i grafer, søjlediagrammer, tabeller osv.",
                    "TYPES_OF_FEEDBACK_HEADER": "Forskellige typer af feedback",
                    "VALUE": "Værdi",
                    "VARIANCE": "Afvigelse",
                    "YOUR_RATINGS": "Dine bedømmelser"
                },
                "REPORT_SUMMARY": "Rapportoversigt",
                "REPORT_SUMMARY_TABLE_FOOTER": "Sammenlign antallet af personer, der har afsluttet din bedømmelse, med antallet af personer, der er inviteret til at deltage.",
                "REPORT_SUMMARY_TABLE_HEADER": "Statistik over svarpersoner",
                "RESET": "Nulstil",
                "RESPONDENT_TOTALS": "Svarpersontotaler",
                "RESPONSES": "Svar",
                "RESPONSE_COUNT": "{{responseCount}} svar",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> svar",
                "RESULT": "Resultat",
                "REVERSE_COLORS": "Modsatte farver",
                "ROW_TOTALS": "Rækketotaler",
                "SAVE": "Gem",
                "SAVE_AND_APPLY": "Gem og anvend",
                "SCORING_CATEGORY": "Scoring-kategori",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Ingen svar for denne kategori",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Ingen svar for dette spørgsmål",
                "SCORING_OVERVIEW": "Scoring-oversigt",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "Du og andre evaluatorer mener, at dette område er en topstyrke.",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Anerkendt styrke",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Et anerkendt forbedringsområde betyder, at både selvbedømmelse og bedømmelser fra andre er under gennemsnittet for denne kompetence.",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Anerkendt forbedringsområde",
                "SCORING_OVERVIEW_DESCRIPTION": "Ovenfor er de kompetencer eller typer af adfærd, hvor du blev evalueret som del af denne proces med feedback fra flere bedømmere. Sammenlignende bedømmelser er angivet efter gruppe.",
                "SCORING_OVERVIEW_MINIMUM_GAP": "Mindste difference",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Mindste difference mellem referencegrupper for tekster, der skal vises.",
                "SCORING_OVERVIEW_TABLE_FOOTER": "Intervallet af score for hver kompetence/adfærd vises. Bjælken repræsenterer det numeriske gennemsnit.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Ikke-genkendt styrke kommer fra differencen mellem selvbedømmelsen og bedømmelserne fra andre.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Ikke-genkendt styrke",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Ikke-anerkendt forbedringsområde kommer fra differencen mellem selvbedømmelsen og bedømmelserne fra andre.",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Ikke-anerkendt forbedringsområde",
                "SELECT_CATEGORIES": "Vælg scoring-kategorier...",
                "SELECT_CATEGORY": "Vælg en scoring-kategori...",
                "SELECT_CONDITION_TYPE": "Vælg betingelsestype",
                "SELECT_DATA_SOURCE": "Vælg datakilde",
                "SELECT_DATA_SOURCE_TYPE": "Vælg datakildetype",
                "SELECT_FILTER": "Vælg filter",
                "SELECT_FILTERS": "Vælg filtre",
                "SELECT_OPERATOR_TYPE": "Vælg operatortype",
                "SELECT_PERSON": "Vælg person",
                "SELECT_PERSON_METADATA": "Vælg personmetadata",
                "SELECT_QUESTION": "Vælg spørgsmål",
                "SELECT_QUESTIONS": "Vælg spørgsmål...",
                "SELECT_RATIO_OR_DROPOFF": "Vælg forhold eller drop-off",
                "SELECT_RELATIONSHIP": "Vælg relation",
                "SELECT_SCORING_CATEGORY": "Vælg scoring-kategori",
                "SELF": "Selv",
                "SELF_ASSESSMENT": "Selvbedømmelse",
                "SEQUENTIAL": "Sekventiel",
                "SETUP_COMPARISON": "Konfigurer sammenligning",
                "SETUP_COMPARISONS": "Konfigurer sammenligninger",
                "SET_START_COLOR": "Angiv startfarve",
                "SHOULD_SHOW_FOOTER": "Vis sidefod",
                "SHOULD_SHOW_SCORING_CATEGORY": "Vis scoring-kategori",
                "SHOWING_RECORDS_OF": "Viser poster %1 - %2 af %3",
                "SHOW_COMPARISON_GAP": "Vis sammenligning gap-kolonne",
                "SHOW_DATA_LABEL": "Vis dataværdier",
                "SHOW_PERCENTAGES": "Vis procentdele",
                "SHOW_THE_FOLLOWING_TEXT": "Vis derefter følgende tekst",
                "SHOW_TIES": "Vis tilknytninger",
                "SHOW_X_AXIS": "Vis x-akse",
                "SHOW_Y_AXIS": "Vis y-akse",
                "SMALL_LABELS": "Små etiketter",
                "SORT": "Sorter",
                "SPLINE": "Sløjfe",
                "STACK_CHART": "Stablet diagram",
                "STANDARD_DEVIATION": "Standardafvigelse",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "Svaghed mindre end",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "Rediger tærskeltekster",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "Tærskeltekster",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "Aktiver tærskeltekster",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "Skyrke mere end",
                "SUM": "Total",
                "SUMMARY": "Oversigt",
                "TABLES": "Tabeller",
                "TABLE_TOTALS": "Tabeltotaler",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Sæt dig grundigt ind i vurderingsskalaen for at sikre korrekt fortolkning",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "Bemærk skalaen",
                "TEXT": "Tekst",
                "THINGS_YOU_WILL_SEE_HEADER": "Det vil du se:",
                "TOP_BOTTOM_BOX": "Øverste felt/nederste felt",
                "TOP_BOX": "Øverste felt",
                "TOTAL": "Samlet",
                "TOTAL_COUNTS": "Totalantal",
                "TO_DO": "Opgaver",
                "TRANSPOSE": "Transponer",
                "TRANSPOSE_TABLE": "Transponer tabel",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Kvalitativt: Denne feedback vil være i form af åbne tekstkommentarer",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Kvantitativt: Denne feedback vil være numerisk og kan være repræsenteret i grafer, søjlediagrammer, tabeller osv.",
                "TYPES_OF_FEEDBACK_HEADER": "Forskellige typer af feedback",
                "UNDO": "Fortryd",
                "USE_COMPARISON": "Brug sammenligning",
                "USE_LABELS_FOR_SCALES": "Brug etiketter til skalaer",
                "VALUES": "Værdier",
                "VALUE_RANGES": "Værdiområder",
                "VARIANCE": "Afvigelse",
                "VERTICAL": "Lodret",
                "VERTICAL_RANGE": "Lodret område",
                "WARNING_DATA_OUT_OF_RANGE": "Advarsel: Dataværdi overstiger områdekonfiguration",
                "WIDGET_ERROR": {
                    "ERROR": "Der opstod en uventet fejl",
                    "MISCONFIGURED": "Denne widget er ikke konfigureret korrekt. Kontrollér din widgetkonfiguration.",
                    "NEW": "Konfigurer widget",
                    "NO_DATA": "Ingen data fundet – dine filtre kan være for eksklusive!"
                },
                "WIDGET_NAME": {
                    "BAR": "Søjlediagram",
                    "BREAKDOWNBAR": "Opsplitningsdiagram",
                    "DATA_TABLE": "Datatabel",
                    "FUNNEL_CHART": "Indsnævringsdiagram",
                    "GAUGE": "Målerdiagram",
                    "GRID": "Resultattabel",
                    "HEATMAP": "Heatmap",
                    "LINE": "Kurvediagram",
                    "NEEDS_BASED": "Behovsbaseret",
                    "PIE": "Cirkeldiagram",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "Prisestimator (Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "Indtægtsmaksimering (Gabor Granger)",
                    "SCORING_OVERVIEW_CHART": "Diagram",
                    "SCORING_OVERVIEW_TABLE": "Tabel",
                    "STATS_TABLE": "Statistiktabel",
                    "WORDCLOUD": "Ordsky"
                },
                "WORD_ROTATION": "Ordrotation",
                "WORD_SPACING": "Afstand mellem ord",
                "YES": "Ja",
                "YOUR_RATINGS": "Dine bedømmelser"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "Tilføj",
                "ADD_A_WORD": "Tilføj et ord",
                "COLOR": "Farve",
                "DELETE_ALL": "Slet alt",
                "EDIT_STOP_WORDS": "Rediger stopord",
                "MAX_WORDS": "Maks. ord",
                "ROTATION_ANGLED": "Vinklet",
                "ROTATION_HORIZONTAL": "Vandret",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "Vandret og lodret",
                "WORD_ORIENTATION": "Ordretning"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "Baggrundsfarver",
                "DISPLAY_OPTIONS": "Visningsmuligheder",
                "INVERT_FONT_COLORS": "Spejlvend skrifttypefarver med lav kontrast",
                "PAGE": "Side",
                "PAGINATE": "Sideinddel"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "Middel",
                "BOTTOM_BOX_METRIC": "Nederste felt",
                "COLUMNS": "Kolonner",
                "COUNT_METRIC": "Svar i alt",
                "FIELD_NAME": "Felt",
                "MAX_METRIC": "Maksimum",
                "MIN_METRIC": "Minimum",
                "SHOW_RECODES": "Vis omkodningsværdier",
                "SHOW_ROW_NUMBERS": "Vis rækkenumre",
                "STD_DEV_METRIC": "Standardafvigelse",
                "TOP_BOX_METRIC": "Øverste felt",
                "TRANSPOSE_BREAKOUTS": "Transponer opdelinger",
                "TRANSPOSE_TABLE": "Transponer tabel",
                "VAR_METRIC": "Afvigelse"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "Yderligere kolonner",
                "ADD_COLUMNS": "Tilføj yderligere kolonner",
                "ADD_CUSTOM_PALETTE": "Tilføj brugerdefineret palet",
                "ALL_CHOICES": "Alle valg",
                "ALL_GROUPS": "Alle grupper",
                "ALL_RECODES": "Alle omkodninger",
                "AUTOMATIC": "Standard",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "Standard - klik for at redigere",
                "AXIS_VALUES": "Akseværdier",
                "BREAKOUT_BY": "Opdeling efter",
                "CANCEL": "Annuller",
                "CATEGORICAL": "Efter kategori",
                "CHOICES": "Valg",
                "CHOICE_COUNT": "Antal valg",
                "COLOR_PALETTE": "Farvepalet",
                "COLUMN_VALUES": "Kolonneværdier",
                "CONTACT_FIELDS": "Kontaktfelter",
                "COUNT": "Antal",
                "CREATE": "Opret",
                "CUSTOM": "Brugerdefineret",
                "CUSTOM_PALETTE": "Brugerdefineret palet",
                "DATA_SOURCE": "Datakilde",
                "DAY": "Dag",
                "DAY_OF_WEEK": "Dag i ugen",
                "DECIMAL_PRECISION": "Decimaler",
                "DEFAULT": "Standard",
                "DISABLED": "Deaktiveret",
                "DIVERGENT": "Divergens",
                "EDIT_CUSTOM_PALETTE": "Rediger brugerdefineret palet",
                "ENABLED": "Aktiveret",
                "ERROR_LOADING_DATA": "Fejl ved indlæsning af data",
                "FILE_SIZE": "Størrelse",
                "FILE_TYPE": "Indtast",
                "FRI": "Fre",
                "FRIDAY": "Fredag",
                "GROUP_DATE_BY": "Grupper dato efter",
                "HOUR_OF_DAY": "Dagens time",
                "LENGEND_VALUES": "Værdier i forklaring",
                "MAX": "Maks.",
                "MEAN": "Middel",
                "MIN": "Min.",
                "MISCONFIGURED_DATA": "Datakilde ikke konfigureret korrekt for denne visualisering.",
                "MISCONFIGURED_FILTERS": "Ugyldigt filter (ugyldige filtre)",
                "MODIFY_CUSTOM_PALETTES": "Rediger brugerdefinerede paletter",
                "MON": "Man",
                "MONDAY": "Mandag",
                "MONTH": "Måned",
                "NONE": "Ingen",
                "NO_FILE_ID_ERROR": "Denne visualisering kræver, at der vises et billede i undersøgelsen",
                "NO_RESULTS_TO_SHOW": "Ingen resultater til visning",
                "NPS": "Net Promoter Score®",
                "NPS_GROUP": "NPS®-gruppe",
                "NUMERIC_VALUE": "Numerisk værdi",
                "PALETTE_REMOVED": "Palet fjernet",
                "PERCENTAGE": "Procentdel",
                "PERCENTAGE_OF_CHOICES": "Procentdel af valgmuligheder",
                "PERCENTAGE_OF_RESPONSES": "Procentdel af svar",
                "QUARTER": "Kvartal",
                "REMOVE": "Fjern",
                "RESPONSE_COUNT": "Antal svar",
                "RESULTS_PER_PAGE": "Resultater pr. side",
                "RETRIEVING_DATA_ELLIPSIS": "Henter data...",
                "REVERSE_COLORS": "Modsatte farver",
                "ROW_VALUES": "Rækkeværdier",
                "SAT": "Lør",
                "SATURDAY": "Lørdag",
                "SAVE": "Gem",
                "SELECTED_CHOICE": "Valgt valg",
                "SELECT_FIELD": "Vælg felt",
                "SELECT_METRIC": "Metrik",
                "SEQUENTIAL": "Sekventiel",
                "SET_START_COLOR": "Angiv startfarve",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "Viser eksempeldata...",
                "SUM": "Total",
                "SUN": "Søn",
                "SUNDAY": "Søndag",
                "SURVEY_EMBEDDEDDATA": "Integrerede data",
                "SURVEY_METADATA": "Undersøgelsesmetadata",
                "TEXT_ENTRY": "Tekstindtastning",
                "THURS": "Tor",
                "THURSDAY": "Torsdag",
                "TITLE": "Titel",
                "TUES": "Tir",
                "TUESDAY": "Tirsdag",
                "UNBOUNDED_DOMAIN": "For mange værdier til visning.",
                "UNBOUNDED_DOMAIN_HELP": "For at tilføje dette felt til Resultatrapporter kan du tilføje et filter til rapporten til at vise færre værdier for \"{{ed_field_name}}\", eller opdatere variabeltypen for de integrerede data for \"{{ed_field_name}}\" i dit undersøgelsesflow for at gøre dette felt til en streng eller en numerisk type.",
                "UNDO": "Fortryd",
                "USE_CHOICE_TOTALS": "Brug valg i alt",
                "USE_RESPONDENT_TOTALS": "Brug svarpersoner i alt",
                "VISUALIZATION": "Visualisering",
                "VISUALIZATION_BARCHART": "Søjlediagram",
                "VISUALIZATION_BREAKDOWNBAR": "Opsplitningsdiagram",
                "VISUALIZATION_GAUGE": "Målerdiagram",
                "VISUALIZATION_HEATMAP": "Heatmap",
                "VISUALIZATION_LINECHART": "Kurvediagram",
                "VISUALIZATION_PAGINATEDTABLE": "Sideinddelt tabel",
                "VISUALIZATION_PIE": "Cirkeldiagram",
                "VISUALIZATION_SIMPLETABLE": "Simpel tabel",
                "VISUALIZATION_STATSTABLE": "Statistiktabel",
                "VISUALIZATION_TEXTHIGHLIGHTS": "Tekstfremhævninger",
                "VISUALIZATION_WORDCLOUD": "Ordsky",
                "WED": "Ons",
                "WEDNESDAY": "Onsdag",
                "WEEK": "Uge",
                "WEIGHTING": "Vægtning",
                "WRONG_QUESTION_TYPE_ERROR": "Denne visualiseringstype kan ikke bruges for dette spørgsmål",
                "YEAR": "År"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "Gennemsnit",
                "CHOICE_COUNT": "Antal valg",
                "COUNT": "Antal",
                "DISPLAY_OPTIONS": "Visningsmuligheder",
                "MAX": "Maksimum",
                "MIN": "Minimum",
                "NPS": "NPS®",
                "PAGE_OF": "Side: %1 af %2",
                "PERCENT": "Procentdel",
                "RESPONSE_COUNT": "Antal svar",
                "ROWS_PER_TABLE": "Rækker pr. tabel",
                "SHOWING_ROWS_OF": "Viser %1 - %2 af %3",
                "SHOW_PERCENTAGES": "Vis procentdele",
                "SHOW_RECODES": "Vis omkodningsværdier",
                "SHOW_ROW_NUMBERS": "Vis rækkenumre",
                "SUM": "Total",
                "TOTAL": "Samlet",
                "TRANSPOSE": "Transponer",
                "USE_COLUMN_TOTALS": "Brug kolonnetotaler",
                "USE_ROW_TOTALS": "Brug rækketotaler",
                "VALUE": "Værdi"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "Stigende",
                "COUNT": "Antal",
                "DESCENDING": "Faldende",
                "DIAGONAL": "Diagonal",
                "DISPLAY_OPTIONS": "Visningsmuligheder",
                "ERROR_COLON": "Fejl:",
                "ERROR_GENERIC": "Der opstod en fejl under indlæsning af visualiseringen.",
                "HORIZONTAL": "Vandret",
                "HORIZONTAL_BARS": "Vandrette søjler",
                "INCORRECTLY_CONFIGURED": "Vælg en værdi for at vise diagram",
                "LEGEND_AUTO": "Automatisk",
                "LEGEND_BOTTOM": "Nederst",
                "LEGEND_INSET": "Sænket",
                "LEGEND_RIGHT": "Højre",
                "NORMALIZE_TO_PERCENTAGES": "Normaliser til procentdele",
                "SHOW_BAR_LABELS": "Vis søjleetiketter",
                "SHOW_LEGEND": "Vis forklaring",
                "SHOW_X_AXIS": "Vis x-akse",
                "SHOW_Y_AXIS": "Vis y-akse",
                "SORT_BAR_VALUES": "Sorter søjleværdier",
                "STACKED_BARS": "Stablede søjler",
                "TRANSPOSE": "Transponer",
                "TRUNCATE_LABELS": "Afkort etiketter",
                "VERTICAL": "Lodret"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "Alle andre",
                "COULD_NOT_LOAD_DATA": "Kunne ikke indlæse data med angivne konfiguration — prøv et andet kildefelt eller et større datointerval.",
                "GROUPING_PERCENTAGE_THRESHOLD": "Tærskel for grupperingsprocent",
                "NO_DATA": "Ingen data",
                "RADIUS": "Indre radius",
                "SHOW_AS_PERCENTAGES": "Vis som procentdele"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "Luk",
                "DOWNLOAD_CSV": "Download CSV",
                "DOWNLOAD_ZIP": "Download alle filer",
                "NO_DATA": "Ingen data",
                "PAGE_OF": "Side: %1 af %2",
                "RESULTS_PER_PAGE": "Resultater pr. side",
                "SHOWING_RECORDS_OF": "Viser poster %1 - %2 af %3",
                "SINGLE_RESPONSE": "Enkelt svar",
                "VIEW_RESPONSE": "Vis svar"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "Visningsmuligheder",
                "ERROR_COLON": "Fejl:",
                "ERROR_GENERIC": "Der opstod en fejl under indlæsning af visualiseringen.",
                "HORIZONTAL_BARS": "Vandrette søjler",
                "INCORRECTLY_CONFIGURED": "Vælg en værdi for at vise diagram",
                "LEGEND_AUTO": "Automatisk",
                "LEGEND_BOTTOM": "Nederst",
                "LEGEND_INSET": "Sænket",
                "LEGEND_RIGHT": "Højre",
                "NORMALIZE_TO_PERCENTAGES": "Normaliser til procentdele",
                "SHOW_AREA": "Vis område",
                "SHOW_LEGEND": "Vis forklaring",
                "SHOW_X_AXIS": "Vis x-akse",
                "SHOW_Y_AXIS": "Vis y-akse",
                "SMOOTH_LINES": "Jævne kurver",
                "SORT_X_AXIS_LABELS": "Sorter x-akseetiketter",
                "STACKED_BARS": "Stablede søjler",
                "TRANSPOSE": "Transponer"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "Blokeringstilstand",
                "BLUR": "Slør",
                "COULD_NOT_LOAD_DATA": "Kunne ikke indlæse data med angivne konfiguration — prøv et andet kildefelt eller et større datointerval.",
                "FIELD": "Felt",
                "RADIUS": "Radius",
                "SHOW_REGIONS": "Vis regioner",
                "SHOW_REGION_LABELS": "Vis regionsetiketter"
            },
            "GAUGEWIDGET": {
                "MAX": "Maks.",
                "MIN": "Min.",
                "VALUE_RANGES": "Værdiområder"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "Nederste etiketter",
                "CATEGORY_NAME": "Kategorinavn",
                "ERROR_COLON": "Fejl:",
                "INCLUDE_HIDDEN_GROUPS": "Medtag skjulte grupper i procentdele",
                "LARGE_LABELS": "Store etiketter",
                "NO": "Nej",
                "PERCENT": "Procent",
                "RESPONSE_COUNT": "Svarantal",
                "RESPONSE_COUNT_WITH_VALUE": "{{ responseCount }} svar",
                "SMALL_LABELS": "Små etiketter",
                "YES": "Ja"
            }
        });
        $cache.put('DE', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "Zugriffscode",
                "ACCESS_CODE_PROTECTION": "Zugriffscodeschutz",
                "ADD": "Hinzufügen",
                "ADD_BREAKOUT": "Aufschlüsselung hinzufügen",
                "ADD_NOTE": "Notiz hinzufügen",
                "ADD_SCHEDULED_REPORT": "Geplanten Bericht hinzufügen",
                "ADD_WIDGET": "Visualisierung hinzufügen",
                "ALL_PROJECTS": "Alle Projekte",
                "ALL_QUESTIONS": "Frageseiten",
                "ANSWER": "Antwort",
                "ANY_CHANGES_LOST": "Änderungen an Berichten gehen verloren, wenn Sie die Qualtrics XM Plattform verlassen.",
                "APPENDED_COPY_IN_PARENS": "(Kopie)",
                "AREA_CHART": "Flächendiagramm",
                "AREA_CHART_DESC": "Ein Liniendiagramm mit zwei Achsen, bei dem der Bereich unter der Linie ausgefüllt ist.",
                "ATTACHMENT": "Anhang",
                "BACKUP_CURRENT_REPORT": "Sichern Sie eine Backup-Kopie dieses Berichts, bevor Sie Visualisierungen ändern.",
                "BACKUP_CURRENT_REPORT_LINE2": "Anmerkung: Die Backup-Kopie wird „{{nameOfReportCopy}}“ genannt.",
                "BACK_TO_REPORTS": "Zurück zu den Berichten",
                "BACK_TO_TOP": "Zurück nach oben",
                "BACK_TO_VIEW_RESULTS": "Zurück zum alten „Ergebnisse anzeigen“",
                "BAR_CHART": "Balkendiagramm",
                "BAR_CHART_DESC": "Ein Balkendiagramm mit zwei Achsen, das eine zusätzliche Konfiguration ermöglicht, z. B. eine Achsenumstellung und Neuanordnung von Datenpunkten.",
                "BREAKDOWN_BAR_CHART": "Strukturdiagramm",
                "BREAKDOWN_BAR_CHART_DESC": "Ein horizontales, gestapeltes Balkendiagramm, das in aller Regel zur visuellen Bewertung von Metriken untereinander alternativ zum Kreisdiagramm verwendet wird.",
                "CANCEL": "Abbrechen",
                "CANCEL_CONF_TEXT": "Möchten Sie wirklich abbrechen?<br/>Alle Änderungen gehen verloren.",
                "CANCEL_EDITS": "Bearbeitung abbrechen",
                "CHART": "Diagramm",
                "CHOICE": "Antwortmöglichkeit",
                "CHOICES_COUNT_METRIC": "Anzahl der Antworten",
                "CHOOSE_PAGES_TO_DISPLAY": "Anzuzeigende Seiten auswählen",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "Dieser Bericht umfasst {{maxReportPageCount}} Seiten, die Ergebnisse können aber nur bis zu {{reportSizeLimit}} Seiten umfassen. Bitte wählen Sie eine Untermenge innerhalb dieses Bereichs aus.",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "Berichte dürfen nur bis zu {{reportSizeLimit}} Seiten umfassen. Bitte wählen Sie die gewünschten Seiten aus.",
                "CLEAR_ALL": "Alle entfernen",
                "CLOSE": "Schließen",
                "CLOUD": "EINE BESCHREIBUNG FÜR DIE WORTWOLKE",
                "COLLABORATED_NEW": "Der Besitzer dieser Umfrage verwendet die Qualtrics XM Plattform! Berichte für diese Umfrage werden über den neuen Ergebnisbereich bearbeitet.",
                "COMMA_SEPARATED_LIST": "Komma getrennte Liste",
                "COMPACTNESS": "Schriftarten und Abstände",
                "COMPACTNESS_INFO": "Diese Einstellung wirkt sich auf den Tabellenabstand, die Schriftgröße und die Balkengröße in Diagrammen aus. Sie wird auch auf die meisten Exporte angewendet.",
                "CONFIRM": "OK",
                "CONFIRM_DELETE": "Löschung bestätigen",
                "CONFIRM_DELETE_PAGE": "Sind Sie sicher, dass Sie diese Seite entfernen möchten?",
                "CONTINUE": "Weiter",
                "CONTINUE_EDITING": "Bearbeiten fortsetzen",
                "COPY": "Kopie",
                "COPY_OF_REPORT_NAME": "Kopie von {{nameOfCurrentReport}}",
                "COPY_REPORT": "Bericht kopieren",
                "COPY_REPORT_ELLIPSIS": "Bericht kopieren...",
                "COPY_TO_NEW_REPORT": "In neuen Bericht kopieren...",
                "CREATE": "Erstellen",
                "CREATED": "Erstellt",
                "CREATE_CUSTOM_PAGE": "Benutzerdefinierte Seite erstellen",
                "CREATE_NEW_REPORT": "Neuen Bericht erstellen",
                "CREATE_NEW_REPORT_ELLIPSIS": "Neuen Bericht erstellen...",
                "CSV_FILE": "CSV-Datei",
                "CUSTOM_PAGES": "Benutzerdef. Seiten",
                "DATE": "Datum",
                "DEFAULT_PALETTE": "Standard-Farbpalette",
                "DEFAULT_REPORT": "Standardbericht",
                "DEFAULT_VISUALIZATIONS": "Standardvisualisierungen",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "Dies sind die Standardvisualisierungstypen zur Erstellung von Standardergebnisberichten. Wenn Sie diese Einstellungen aktualisieren und verwenden, wird Ihr Bericht auf Basis der neuen Standardeinstellungen erneut erstellt. Sie haben die Möglichkeit, Ihren aktuellen Bericht zu sichern.",
                "DEFAULT_VISUALIZATIONS_NOTE": "Anmerkung: Nicht jeder Visualisierungstyp ist für alle Fragetypen verfügbar. Einige Nicht-Standard-Visualisierungen können automatisch ersetzt werden.",
                "DEFAULT_VISUALS_DISCLAIMER": "Qualtrics aktualisiert diesen Bericht mit den neuen Standardvisualisierungseinstellungen.",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "Diese Aktualisierung beeinflusst {{amountOfWidgetsAffected}} Visualisierungen in diesem Bericht.",
                "DEFAULT_VISUAL_EDIT_DETECTED": "Überarbeitung der Standardvisualisierung erkannt",
                "DELETE_BUTTON": "Löschen",
                "DELETE_DISABLED_EXPLANATION": "Das Löschen von Berichten, die in der vorherigen Berichtsoberfläche erstellt wurden, ist nur zulässig, wenn Ihr Unternehmen bereits eine vollständige Umstellung auf die Qualtrics XM Plattform durchgeführt hat.",
                "DELETE_PAGE": "Seite löschen",
                "DELETE_PAGE_ELLIPSIS": "Seite löschen...",
                "DELETE_REPORT": "Bericht löschen",
                "DELETE_REPORT_ELLIPSIS": "Bericht löschen...",
                "DELETE_WIDGET_QUESTION": "Löschen?",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "Dieses Feld ist verschlüsselt und kann nicht zum Sortieren verwendet werden.",
                "DISCARD_EDITS": "Bearbeitung verwerfen",
                "DISTRIBUTION_PAUSED": "Verteilung des Berichts angehalten.",
                "DONE_BUTTON": "Fertig",
                "DONE_EDITING": "Bearbeitung beendet",
                "DOWNLOAD": "Herunterladen",
                "DOWNLOAD_AS_CSV": "Im CSV-Format herunterladen",
                "DOWNLOAD_AS_PDF": "Im PDF-Format herunterladen",
                "DOWNLOAD_FAILED": "Download fehlgeschlagen",
                "DOWNLOAD_PREVIOUS_EXPORTS": "Vorherige Exporte herunterladen...",
                "DO_YOU_WISH_TO_DELETE": "Möchten Sie folgende Elemente löschen:",
                "DUPLICATE_PAGE": "Blatt duplizieren",
                "EDIT_REPORT": "Bericht bearbeiten",
                "EDIT_REPORT_ELLIPSIS": "Bericht bearbeiten...",
                "EDIT_VISUALIZATION": "Visualisierung bearbeiten",
                "EMAIL_ADDRESS": "E-Mail-Adresse",
                "EMAIL_SENT": "E-Mail gesendet...",
                "END_OF_REPORT": "Ende des Berichts",
                "ENTER_NAME": "Name eingeben",
                "ERROR_COPYING": "Beim Kopieren des Berichts ist ein Fehler aufgetreten.",
                "ERROR_DELETING": "Beim Löschen des Berichts ist ein Fehler aufgetreten.",
                "ERROR_DELETING_EXPORT": "Beim Löschen des Exports ist ein Fehler aufgetreten.",
                "ERROR_HEADING": "Fehler",
                "ERROR_PUBLISHING": "Beim Speichern der Einstellungen ist ein Fehler aufgetreten.",
                "ERROR_RENAMING": "Beim Umbenennen des Berichts ist ein Fehler aufgetreten.",
                "ERROR_REQUESTING_EXPORT": "Beim Anfordern des Exports ist ein Fehler aufgetreten.",
                "ERROR_SAVING_GLOBAL_OPTIONS": "Beim Speichern der globalen Visualisierungsoptionen ist ein Fehler aufgetreten.",
                "ERROR_SEND_TEST_EMAIL": "Beim Senden der Test-E-Mail ist ein Fehler aufgetreten.",
                "EVERY_FRIDAY": "Jeden Freitag",
                "EVERY_MONDAY": "Jeden Montag",
                "EVERY_MONTH": "Monatlich am",
                "EVERY_SATURDAY": "Jeden Samstag",
                "EVERY_SUNDAY": "Jeden Sonntag",
                "EVERY_THURSDAY": "Jeden Donnerstag",
                "EVERY_TUESDAY": "Jeden Dienstag",
                "EVERY_WEDNESDAY": "Jeden Mittwoch",
                "EVERY_WEEK": "Wöchentlich am",
                "EXAMPLE_GROUP_NUM": "Gruppe {{num}}",
                "EXAMPLE_SERIES_NUM": "Serie {{num}}",
                "EXPORT": "Exportieren",
                "EXPORT_CSV": "CSV (durch Trennzeichen gegliedert)",
                "EXPORT_EXCEL_SPREADSHEET": "Excel-Tabelle",
                "EXPORT_IMAGE": "Bild exportieren",
                "EXPORT_PAGES": "Seiten exportieren",
                "EXPORT_PDF": "PDF-Dokument",
                "EXPORT_PPT_SLIDES": "PowerPoint-Folien",
                "EXPORT_RAW_DATA": "Ausgangsdaten exportieren",
                "EXPORT_REPORT": "Bericht exportieren",
                "EXPORT_VISUALIZATION": "Visualisierung exportieren",
                "EXPORT_WORD_DOC": "Word-Dokument",
                "FAILED_SAVE_TXT": "Speichern nicht möglich",
                "FILTERED": "Gefiltert",
                "FIRST_PAGE": "Erste Seite",
                "FIRST_WEEKDAY": "Erster Wochentag des Monats",
                "FROM": "Von",
                "FROM_EMAIL": "Absenderaddresse",
                "FROM_NAME": "Absendername",
                "GAUGE_CHART": "Barometerdiagramm",
                "GAUGE_CHART_DESC": "Ein Pegel-ähnliches Diagramm zum Vergleichen aktueller Werte mit einem Ziel oder einer Serie von Schwellenwerten.",
                "GENERATING_FILE": "Datei wird vorbereitet...",
                "GENERATING_IMAGE": "Bild wird vorbereitet...",
                "GENERATING_PDF": "PDF wird erstellt...",
                "GENERIC_ERROR": "Das angeforderte Projekt konnte aufgrund eines Fehlers nicht geladen werden.",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "Globale Optionen...",
                "GLOBAL_METRIC": "Standardmetrik",
                "GLOBAL_MODAL_PAGE_TITLE": "Beispielvisualisierung mithilfe der globalen Optionen für den Abschnitt „Ergebnisse“ der Qualtrics Research Suite",
                "GLOBAL_MODAL_WIDGET_TITLE": "Visualisierungstitel",
                "GLOBAL_OPTIONS": "Globale Optionen",
                "GLOBAL_PRECISION": "Standard-Dezimalstellen",
                "GLOBAL_SETTINGS_APPLY": "Meine Standardeinstellungen verwenden",
                "GLOBAL_SETTINGS_SAVE": "Als meine Standardeinstellungen sichern",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "Qualtrics-Standardeinstellungen verwenden",
                "GROUP": "Gruppe",
                "HEAT_MAP_CHART": "Heatmap-Diagramm",
                "HEAT_MAP_CHART_DESC": "Eine gruppierte „Wärme“-Visualisierung, die zum Zuordnen der Verteilung von Benutzereingaben (z. B. Klicks) auf das ursprüngliche Bild verwendet wird.",
                "HIDDEN": "Ausgeblendet",
                "HIDDEN_PAGE": "Diese Seite erscheint nicht in öffentlichen Berichten und wird bei Berichtexporten standardmäßig übersprungen.",
                "HIDE": "Ausblenden",
                "HIDE_ALL_PAGES": "Alle Seiten ausblenden",
                "HIDE_PAGE": "Seite ausblenden",
                "IMAGE_FILE": "Bilddatei",
                "INVALID_BRAND_DOMAIN": "Die von Ihnen eingegebene Domäne befindet sich nicht in Ihrer Organisationskontaktliste der genehmigten E-Mail-Domänen. Zur Behebung des Fehlers wenden Sie sich bitte an Ihren Administrator.",
                "INVALID_SPF_RECORD": "Die zum Versand von E-Mails eingegebene Domäne ist von Qualtrics nicht zugelassen. Die Zustellbarkeit ist daher beeinträchtigt. Zur Behebung dieses Problems verwenden Sie bitte eine andere Domäne oder wenden Sie sich an Qualtrics.",
                "ISSUE_SAVING_REPORTS": "Beim Speichern von einem oder mehreren Berichten ist ein Problem aufgetreten. Versuchen Sie es bitte erneut.",
                "ISSUE_SENDING_TEST": "Beim Senden einer Test-E-Mail ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
                "LARGE_SURVEY": "Ergebnisse werden nicht angezeigt, da die Umfrage zu groß ist.",
                "LAST_DAY": "Letzter Tag des Monats",
                "LAST_MODIFIED_COLON_WITH_DATE": "Zuletzt bearbeitet: %1",
                "LAST_PAGE": "Letzte Seite",
                "LAST_WEEKDAY": "Letzter Wochentag des Monats",
                "LATER": "Später",
                "LEARN_MORE": "Weitere Informationen",
                "LINE_CHART": "Liniendiagramm",
                "LINE_CHART_DESC": "Ein Liniendiagramm mit zwei Achsen, das häufig zur Diagrammdarstellung in Relation zur Zeit auf der X-Achse verwendet wird.",
                "LOG_OUT_WARNING": "Klicken Sie innerhalb von {{countdown}} Sekunden auf eine beliebige Position, um angemeldet zu bleiben",
                "MESSAGE": "Nachricht",
                "MONTHLY": "Monatlich",
                "MOVE_DOWN": "Visualisierung nach unten verschieben",
                "MOVE_PAGE_TO_BOTTOM": "Nach unten verschieben",
                "MOVE_PAGE_TO_TOP": "Nach oben verschieben",
                "MOVE_UP": "Visualisierung nach oben verschieben",
                "MY_SURVEYS": "Meine Projekte",
                "NAME": "Name",
                "NEW_CUSTOM_PAGE_NAME": "Neue benutzerdefinierte Seite",
                "NEW_REPORT": "Neuer Bericht",
                "NEXT_PAGE": "Nächste Seite",
                "NEXT_RUN": "Nächste Ausführung",
                "NO_EXPORTS": "Für diesen Bericht wurden noch keine Exporte angefordert.",
                "NO_ITEMS_TO_DISPLAY": "Keine anzuzeigenden Elemente",
                "NO_MATCHING_CUSTOM_PAGES": "Keine übereinstimmenden benutzerdefinierten Seiten",
                "NO_MATCHING_PAGES": "Für die Suche wurden keine Seiten gefunden",
                "NO_MATCHING_REPORTS": "Keine passenden Berichte.",
                "NO_PROJECT": "Geben Sie ein Projekt an, um fortzufahren.",
                "NO_PROJECTS_TO_MIGRATE": "Keine zu aktualisierenden Projekte vorhanden.",
                "NO_QUESTIONS": "Keine übereinstimmenden Fragen",
                "NO_RESULTS_YET": "Es gibt noch keine Ergebnisse, die angezeigt werden könnten. Verteilen Sie Ihre Umfrage, um Antworten zu sammeln.",
                "OFF": "Aus",
                "ON": "An",
                "PAGES_SELECTED": "Ausgewählte Seiten",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "Bei dieser Auswahl würde der Bericht {{currentSelectedPageCount}} Seiten umfassen, was jedoch über der maximal zugelassenen Seitenanzahl von {{reportSizeLimit}} liegt. Wählen Sie bitte eine geringere Seitenanzahl aus.",
                "PAGES_SELECTION_INVALID_RANGE": "Bitte wählen Sie einen gültigen Bereich aus.",
                "PAGE_OPTIONS": "Seitenoptionen",
                "PDF_ROW_TRUNCATION_MESSAGE": "Zu viele Zeilen für einen PDF-Export, versuchen Sie einen Export in Word oder CSV",
                "PERCENTAGE_METRIC": "Prozent",
                "PIE_CHART": "Kreisdiagramm",
                "PIE_CHART_DESC": "Eine kreisförmige Struktur von Werten für einen angegebenen Datenpunkt. Nützlich zum Messen relativer Proportionen ausgewählter Werte.",
                "PREVIEW": "Vorschau",
                "PREVIOUS_PAGE": "Vorherige Seite",
                "PRINT_PAGE": "Seite drucken",
                "PUBLIC_LINK": "Öffentlicher Link",
                "PUBLIC_REPORT_AVAILABLE": "Öffentlicher Bericht verfügbar",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "Zugriffscode",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "Falscher Zugriffscode. Bitte erneut versuchen.",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "Abschicken",
                "PUBLIC_RESULTS_LOGIN_TITLE": "Anmeldung für öffentlichen Bericht | Qualtrics Umfrage-Software",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "Der öffentliche Bericht wurde nicht gefunden. Bitte wenden Sie sich an den Besitzer dieses Berichts und bitten Sie ihn um einen gültigen Link.",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "Öffentlicher Bericht wurde nicht gefunden",
                "PUBLIC_RESULTS_NOT_UPDATED": "Links zu öffentlichen Berichten und geplante Berichts-E-Mails greifen nicht auf die Qualtrics XM Plattform zurück, solange sie nicht aktualisiert worden sind.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "Die Sitzung ist abgelaufen. Bitte melden Sie sich erneut an, um mit der Vorschau auf die öffentlichen Ergebnisse fortzufahren.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "Sitzung ist abgelaufen",
                "PUBLIC_RESULTS_TITLE": "Öffentlicher Bericht",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "Sie sind nicht berechtigt, diese Seite anzuzeigen. Bitte wenden Sie sich an den Besitzer dieses Berichts und bitten Sie ihn um Veröffentlichung.",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "Öffentlicher Bericht nicht berechtigt",
                "PUBLISHED_LINK_GENERATING_LINK": "Link wird generiert...",
                "PUBLISHED_REPORT_FOUND_HERE": "Jeder kann diesen Bericht unter folgendem Link einsehen:",
                "PUBLISH_REPORT": "Öffentlichen Bericht verwalten",
                "PUBLISH_REPORT_ELLIPSIS": "Öffentlichen Bericht verwalten...",
                "QUESTION": "Frage",
                "RANK": "Platzierung",
                "REMOVE_WIDGET": "Visualisierung entfernen",
                "RENAME_PAGE": "Seite umbenennen",
                "RENAME_REPORT": "Bericht umbenennen",
                "RENAME_REPORT_ELLIPSIS": "Bericht umbenennen...",
                "REPLY_TO_EMAIL": "Antwortadresse",
                "REPORT_COLON": "Bericht:",
                "REPORT_SETTINGS": "Berichteinstellungen",
                "REPORT_SETTINGS_ELLIPSIS": "Berichteinstellungen ...",
                "RESPONSE_COUNTS": "Anzahl der Antworten",
                "RESULTS_DASHBOARDS_BANNER": "und probieren Sie die neue, verbesserte Version der Umfrageergebnisse aus, die sich durch eine moderne, barrierefreie Benutzeroberfläche und Datenvisualisierungen, neue Analyse- und Erkundungsfunktionen und mehr auszeichnet.",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "Release-Hinweise",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "Neueste anzeigen",
                "RESULTS_OPTIONS": "Berichtsoptionen",
                "RESULTS_TITLE": "Bericht",
                "RESUME_DISTRIBUTION": "Verteilung wiederaufnehmen",
                "REVERT": "Zurücksetzen",
                "RICH_TEXT_LIMIT_REACHED": "Die Inhaltslänge hat den Grenzwert erreicht.",
                "SAVE": "Speichern",
                "SAVE_AND_CLOSE": "Speichern und schließen",
                "SAVE_AS_CSV": "Visualisierung als CSV-Datei speichern",
                "SAVE_AS_IMAGE": "Visualisierung als Bild speichern",
                "SAVE_CONFIRMATION": "Bestätigung speichern",
                "SAVE_PAGE_AS_ELLIPSIS": "Seite exportieren als...",
                "SAVE_SETTINGS": "Einstellungen speichern",
                "SCHEDULE_REPORT_EMAIL": "Berichts-E-Mail planen",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "Berichts-E-Mail planen...",
                "SEARCH_ELLIPSIS": "Suchen...",
                "SEARCH_PAGES": "Fragen durchsuchen",
                "SEARCH_PAGES_ELLIPSIS": "Seiten durchsuchen...",
                "SEARCH_REPORTS_ELLIPSIS": "Berichte durchsuchen...",
                "SELECTED": "Ausgewählt:",
                "SELECT_ALL": "Alle auswählen",
                "SELECT_A_FIELD": "Feld auswählen",
                "SELECT_A_WIDGET": "Visualisierung auswählen",
                "SELECT_PAGES": "Seiten auswählen",
                "SELECT_PAGES_ELLIPSIS": "Seiten auswählen...",
                "SEND": "Senden",
                "SEND_TEST_EMAIL": "Test-E-Mail senden",
                "SETTING_DEFAULT": "Standard",
                "SETTING_HIGH": "Hoch",
                "SETTING_LARGE": "Groß",
                "SETTING_LOW": "Niedrig",
                "SETTING_NORMAL": "Normal",
                "SETTING_SMALL": "Klein",
                "SHARE_REPORT": "Bericht teilen",
                "SHOW_ALL_PAGES": "Alle Seiten anzeigen",
                "SHOW_FULL_QTEXT": "Vollständigen Fragentext in Seitentiteln anzeigen",
                "SIMPLE_TABLE": "Einfache Tabelle",
                "SIMPLE_TABLE_DESC": "Eine flexible Tabelle, die mehrere Werte in Zeilen- oder Spaltenform anzeigen kann.",
                "SIZE": "Größe",
                "SPLINE_CHART": "Spline-Diagramm",
                "SPLINE_CHART_DESC": "Ein abgerundetes Liniendiagramm mit zwei Achsen, das häufig zur Diagrammdarstellung in Relation zur Zeit auf der X-Achse verwendet wird.",
                "STATISTICS_TABLE": "Statistiktabelle",
                "SUBJECT": "Betreff",
                "SURVEY_ANALYSIS": "Umfragenanalyse",
                "SURVEY_SUMMARY": "Umfragenzusammenfassung",
                "TABLE": "EINE BESCHREIBUNG FÜR DIE TABELLE",
                "TIME": "Uhrzeit",
                "TO": "An",
                "TOTAL": "Gesamt",
                "TRANSPOSE_STATS_TABLES": "Statistiktabellen spiegeln",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "Statistiktabellenaufschlüsselung spiegeln",
                "TRUNCATE_PAGE_TITLES": "Fragetext in Seitentiteln kürzen",
                "TRY_IT_NOW": "Jetzt ausprobieren",
                "TYPE": "Typ",
                "UNABLE_TO_CHECK_SPF": "SPF-Datensätze können nicht geprüft werden. Bitte versuchen Sie es erneut.",
                "UNAUTHORIZED": "Sie sind nicht berechtigt, diesen Bericht anzuzeigen. Wenden Sie sich an den Besitzer und bitten Sie ihn um Zugriff.",
                "UNHIDE_PAGE": "Seite einblenden",
                "UPDATE": "Aktualisieren",
                "UPDATED_SUCCESSFULLY": "Aktualisierung erfolgreich.",
                "UPDATE_ALL_IN_THIS_PROJECT": "Alle Elemente des Projekts aktualisieren",
                "UPDATE_ALL_PROJECTS": "Alle Projekte aktualisieren",
                "UPDATE_NOW": "Jetzt aktualisieren",
                "UPDATE_REPORTS": "Berichte aktualisieren...",
                "UPDATE_REPORT_ELEMENTS": "Links für öffentliche Berichte und geplante Berichts-E-Mails aktualisieren",
                "UPGRADE_MY_ACCOUNT": "Mein Konto erweitern",
                "USE_EXPORT_TAGS": "Fragennummern einbeziehen",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "Einfache Spaltensummen in Tabelle verwenden",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "Einfache Teilnehmeranzahlen in Tabelle verwenden",
                "USE_WEIGHTED_METRICS": "Gewichtete Metriken verwenden",
                "VIEW": "Anzeigen",
                "WEEKLY": "Wöchentlich",
                "WELCOME_TO_NEW_RESULTS": "Willkommen zur Berichterstellung in der Qualtrics XM Plattform!",
                "WHEN": "Wann",
                "WIDGET_LOADING": "Lädt...",
                "WIDGET_OPTIONS_ERR": "Visualisierungsoptionen konnten nicht geladen werden",
                "WIDGET_TYPE": "Visualisierung",
                "WORD_CLOUD": "Wortwolke",
                "WORD_CLOUD_DESC": "Eine gewichtete Visualisierung der Worthäufigkeit in Textdaten mit zusätzlichen Optionen zur Farbcodierung."
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Beachten Sie, dass es innerhalb Ihres Unternehmens Ressourcen gibt, die Sie bei der Interpretation des Feedbacks unterstützen können. Hierzu gehören HR-Partner, Ihr Vorgesetzter und/oder ein Mentor.",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Machen Sie sich bereit, und analysieren Sie das Feedback.",
                "ABOUT_YOUR_REPORT_HEADER": "Über Ihren Bericht",
                "ABOUT_YOUR_REPORT_LINE1": "Willkommen zum 360-Feedbackbericht. Dies ist eine großartige Möglichkeit für Sie, sich als Experte weiterzuentwickeln. Nehmen Sie sich ausreichend Zeit für das Feedback, damit Sie beim Durcharbeiten der Ergebnisse auf Erfolgskurs bleiben. Feedback kann am Anfang sehr hart sein, aber bedenken Sie, dass Sie mit diesem Feedback Ihr Wachstum und Ihre Weiterentwicklung voranbringen möchten.",
                "ABOUT_YOUR_REPORT_LINE2": "Wenn Sie den Bericht durcharbeiten, sollten Sie einige Dinge beachten.",
                "ADD_CONDITIONAL_TEXT": "Bedingten Text hinzufügen",
                "ADD_CUSTOM_PALETTE": "Benutzerdefinierte Palette hinzufügen",
                "ADD_DATA_SOURCE": "Datenquelle hinzufügen",
                "ADD_FOLLOWING": "Folgende hinzufügen",
                "ADD_LABEL": "Label hinzufügen",
                "ADVANCED_FILTER": "Erweiterter Filter",
                "AGREEMENT_CHART": "Zustimmungsdiagramm",
                "AGREEMENT_CHART_FOOTER": "Das Zustimmungsdiagramm gibt die Ähnlichkeit der Punktwertungen an. Jeder Punkt stellt dar, wie Sie von Einzelnen für jedes Objekt bewertet wurden. Die Größe des Punkts zeigt an, wie viele Bewerter Ihnen eine bestimmte Bewertung gegeben haben.",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "Antworten",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "Antwort",
                "AGREEMENT_CHART_LEGEND_TITLE": "Wie andere Sie bewertet haben",
                "ALL": "Alle",
                "AND_IF": "und wenn",
                "ANGLED": "Gewinkelt",
                "AREA": "Bereich",
                "AUTO": "Automatisch",
                "AVERAGE": "Durchschnitt",
                "AXIS_VALUES": "Achsenwerte",
                "BAR": "Leiste",
                "BASE_WORD_COLOR": "Basiswortfarbe",
                "BLUR": "Weichzeichnen",
                "BOTTOM_BOX": "Unteres Feld",
                "BREAKOUT_HEADERS": "Aufschlüsselungsköpfe",
                "CANCEL": "Abbrechen",
                "CATEGORICAL": "Kategorisch",
                "CATEGORY": "Kategorie",
                "CATEGORY_NAME": "Kategoriename",
                "CHANGE_CATEGORIES_ORDER": "Reihenfolge der Kategorien ändern",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "Reihenfolge der Punktewertungskategorien ändern",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "Ändern Sie die Reihenfolge, die in der Visualisierung erscheint, indem Sie links neben das Element der Punktewertungskategorie klicken und dieses an die gewünschte Position ziehen.",
                "CHANGE_QUESTIONS_ORDER": "Reihenfolge der Fragen ändern",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "Reihenfolge der Fragen ändern",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "Ändern Sie die Reihenfolge, die in der Visualisierung erscheint, indem Sie links neben das Element der Frage klicken und dieses an die gewünschte Position ziehen.",
                "CHARTS": "Diagramme",
                "CHART_TYPE": "Diagrammtyp",
                "CHOICE_COUNT": "Antwortanzahl",
                "CHOICE_TOTALS": "Auswahlmöglichkeiten insgesamt",
                "CLEAR": "Löschen",
                "CLOSE": "Schließen",
                "COLOR_PALETTE": "Farbpalette",
                "COLUMN_NAMES": "Spaltennamen",
                "COLUMN_TOTALS": "Spaltensummen",
                "COMPARED_FILTER_GROUP": "Verglichene Filtergruppe",
                "COMPARED_FILTER_GROUPS": "Verglichene Filtergruppen",
                "COMPARE_WITH": "vergleichen mit",
                "COMPETITION_RANKING": "Wettbewerbs-Ranking verwenden",
                "COMPETITION_RANKING_TOOLTIP": "Im Falle eines Gleichstands, erhalten alle gleichen Bewertungen das gleiche Ranking. Das nächstfolgende Element wird jedoch wie folgt eingestuft: die Gesamtzahl der Elemente, die in der Tabelle höher eingestuft sind, plus eins.",
                "COMPLETED_RESPONSES": "Abgeschlossene Antworten",
                "CONDITIONAL_TEXT": "Bedingter Text",
                "COUNT": "Anzahl",
                "CREATE": "Erstellen",
                "CUSTOM_PALETTE": "Benutzerdefinierte Palette",
                "DATA_SOURCE_TYPE": "Datenquelltyp",
                "DATA_SOURCE_TYPE_CATEGORY": "Punktewertungskategorien",
                "DATA_SOURCE_TYPE_QUESTION": "Fragen",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "Frage",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "Klassifizierbare Elemente",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "Punktewertungskategorie",
                "DEFAULT": "Standard",
                "DEFAULT_TEXT": "Standardtext",
                "DELETE": "Löschen",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "Ermitteln Sie, von wem Ihr Feedback kommt, z.B. Kollegen, direkt unterstellten Mitarbeitern, Führungskräften usw.",
                "DIFFERENT_EVALUATORS_HEADER": "Unterschiedliche Bewerter",
                "DIRECT_REPORTS": "Direkt unterstellte Mitarbeiter",
                "DISABLED": "Deaktiviert",
                "DISPLAY_OPTIONS": "Anzeigeoptionen",
                "DISPLAY_THRESHOLD_TEXTS": "Text anhand der folgenden Gruppenlücke anzeigen",
                "DIVERGENT": "Divergent",
                "DONE": "Fertig",
                "DONT_HEADER": "Was Sie nicht tun sollten:",
                "DONT_LINE1": "Versuchen Sie nicht herauszufinden, wer was gesagt hat",
                "DONT_LINE2": "Konzentrieren Sie sich nicht auf eine(n) positive(n) oder negative(n) Bewertung/Kommentar",
                "DONT_LINE3": "Erstellen Sie keinen Entwicklungsplan zu jedem Objekt",
                "DONT_LINE4": "Lassen Sie sich nicht entmutigen, wenn es noch Verbesserungspotenzial gibt",
                "DONUT": "Donut",
                "DOWNLOAD_CSV": "Legacy-CSV herunterladen",
                "DOWNLOAD_ZIP": "Alle Dateien herunterladen",
                "DO_HEADER": "Was Sie tun sollten:",
                "DO_LINE1": "Betrachten Sie das Feedback in seiner Gesamtheit",
                "DO_LINE2": "Ermitteln Sie Themen für Stärken und Verbesserungspotenzial",
                "DO_LINE3": "Priorisieren Sie einige wenige Schwerpunktbereiche, die Sie ihrem Entwicklungsplan hinzufügen möchten",
                "DO_LINE4": "Erkennen Sie, dass es für jeden Verbesserungspotenzial gibt",
                "DROPOFF": "Rückgang",
                "DUPLICATE": "Dupliziert",
                "EDIT_CONDITIONAL_TEXT": "Bedingten Text bearbeiten",
                "EDIT_CUSTOM_PALETTE": "Benutzerdefinierte Palette bearbeiten",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "Andernfalls den folgenden Text anzeigen",
                "ENABLED": "Aktiviert",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "Reihenfolge nach Anzeigelogik für Bewerterkategorie aktivieren",
                "ENABLE_ORDERING_FOR": "Reihenfolge aktivieren für",
                "EQUAL_TO": "Gleich",
                "FIELD": "Feld",
                "FILTER_NAMES": "Filternamen",
                "FOLLOWING_PARENTHESES": "(folgende)",
                "FOOTER": "Fußzeile",
                "GAP": "Abweichung",
                "GAP_CHART": "Lückendiagramm",
                "GAP_CHART_DESCRIPTION": "Im Lückendiagramm wird der Unterschied in der Punktwertung zwischen zwei Bewertergruppen angezeigt. Bei einem Vergleich Ihrer Selbstbewertung und der Bewertung durch andere bedeutet ein positiver (+) Unterschied z.B., dass die Bewertung durch andere höher war als Ihre eigene Selbstbewertung. Ein negativer (-) Unterschied bedeutet, dass Sie von anderen niedriger bewertet wurden, als Sie sich selbst bewertet haben.",
                "GAP_CHART_FOOTER": "Das Lückendiagramm zeigt den Unterschied (+/-) zwischen zwei Bewertergruppen an.",
                "GAP_TABLE_DESCRIPTION": "Versteckte Stärken zeigen, wo andere Sie höher bewertet haben, als Sie sich selbst. Verbesserungswürdige Bereiche zeigen, wo andere Sie niedriger bewertet haben, als Sie sich selbst. Beide Abschnitte haben eine Rangfolge von der größten zu kleinsten Lücke.",
                "GAP_TABLE_FOOTER": "Die erste Wertungsspalte zeigt an, wie Sie sich selbst bewertet haben. Die zweite Spalte gibt die durchschnittliche Bewertung anderer an. In der dritten Spalte sehen Sie den Unterschied zwischen Ihrer Bewertung und wie andere Sie bewertet haben.",
                "GAP_TABLE_TITLE": "Versteckte Stärken/Verbesserungsbereiche",
                "GREATER_OR_EQUAL": "Größer oder gleich",
                "GREATER_THAN": "Größer als",
                "GROUP": "Gruppe",
                "GROUPED_FOR_ANONYMITY": "Gruppiert zur Anonymisierung",
                "HEADER_NAMES": "Headernamen",
                "HIGHEST_SCORES": "Höchste Bewertungen",
                "HIGHLIGHT_THRESHOLD": "Schwellenwert zum Hervorheben von Lücken",
                "HIGHLOW_TABLE": "Hohe und niedrige Bewertungen",
                "HIGHLOW_TABLE_FOOTER": "In diesem Abschnitt werden die fünf Verhaltensweisen mit den höchsten und niedrigsten Bewertungen (über alle Verhaltensweisen hinweg) aus den jeweiligen Durchschnittswerten der Bewerterkategorien angezeigt. Um diese Seite optimal nutzen zu können, ist es hilfreich, nach möglichen aufkommenden Trends zu suchen. Wenn zum Beispiel die Mehrheit Ihrer Verhaltensweisen mit der niedrigsten Bewertung auf eine oder zwei Kategorien konzentriert ist, handelt es sich dabei möglicherweise um Bereiche mit Verbesserungsbedarf. Die am besten bewerteten Verhaltensweisen können Stärken aufweisen, die in anderen Bereichen genutzt werden können.",
                "HIGH_LOW_TABLE_DESCRIPTION": "Das Diagramm mit hoher/niedriger Bewertung zeigt Objekte auf Basis von Bereichen an, in denen Sie von anderen am höchsten und niedrigsten bewertet wurden.",
                "HORIZONTAL": "Horizontal",
                "HORIZONTAL_AND_VERTICAL": "Horizontal und vertikal",
                "HORIZONTAL_BAR": "Horizontale Balken",
                "HOW_TO_INTERPRET_RESULT_HEADER": "So interpretieren Sie die Ergebnisse und ermitteln Aktionen:",
                "IF": "Wenn",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "Ausgeblendete Labels in Prozenten berücksichtigen",
                "INNER_RIM": "Innenrand",
                "IS": "Ist",
                "IS_NOT": "Ist nicht",
                "IS_SAME_AS_SUBJECT": "Gleich dem Feedbacknehmer",
                "ITEM": "Element",
                "LABEL": "Label",
                "LABELS": "Labels",
                "LARGE_LABELS": "Große Labels",
                "LEGEND": "Legende",
                "LEGEND_POSITION": "Legendenposition",
                "LEGEND_VALUES": "Legendenwerte",
                "LESS_OR_EQUAL": "Kleiner oder gleich",
                "LESS_THAN": "Kleiner als",
                "LINE": "Linie",
                "LOWEST_SCORES": "Niedrigste Bewertungen",
                "MANAGERS": "Manager",
                "MANUAL_FONT_SIZE": "Schriftgröße manuell einstellen",
                "MAX": "Max",
                "MEAN": "Mittelwert",
                "MEDIAN": "Median",
                "METRIC_TYPE": "Metriktyp",
                "MIN": "Min",
                "MODIFY_CUSTOM_PALETTES": "Benutzerdefinierte Paletten ändern",
                "MOVE_DOWN": "Nach unten verschieben",
                "MOVE_UP": "Nach oben verschieben",
                "MULTI_SELECT_ITEMS_SELECTED": "ausgewählt",
                "NEGATIVE_GAPS": "Verbesserungswürdige Bereiche",
                "NO": "Nein",
                "NONE": "Ohne",
                "NOT_APPLICABLE": "k. A.",
                "NOT_EQUAL_TO": "Ungleich",
                "NO_DATA_AVAILABLE_WARNING": "Keine Daten verfügbar",
                "NO_FILTER": "Kein Filter",
                "NO_FILTER_IS_APPLIED": "Es ist kein Filter angewendet.",
                "NO_VALUE": "Kein Wert",
                "NPS": "Net Promoter Score",
                "NUMBER": "Nummer",
                "NUMBERS": "Zahlen",
                "NUMBER_OF_GAPS_NEGATIVE": "Anzahl negativer Lücken",
                "NUMBER_OF_GAPS_POSITIVE": "Anzahl positiver Lücken",
                "NUMBER_OF_ROWS_HIGH": "Anzahl an hohen Zeilen",
                "NUMBER_OF_ROWS_LOW": "Anzahl an niedrigen Zeilen",
                "OPTIONS": {
                    "HEADER_NAME": "Headername",
                    "LEGEND": "Legende",
                    "SCALE_AXIS_CHANGER_TITLE": "Bereich"
                },
                "ORIENTATION": "Ausrichtung",
                "OR_IF": "oder wenn",
                "OTHER": "Andere",
                "OTHERS": "Andere",
                "PAGE_OF": "Seite: %1 von %2",
                "PALETTE_REMOVED": "Palette entfernt",
                "PEERS": "Kollegen",
                "PERCENT": "Prozent",
                "PERCENTAGE": "Prozent",
                "PERCENTAGE_OF_CHOICES": "Anteil der Auswahlmöglichkeiten",
                "PERCENTAGE_OF_RESPONSES": "Anteil der Antworten",
                "PERCENT_COMPLETE": "% abgeschlossen",
                "PERSON_METADATA": "Personen-Metadaten",
                "PERSON_METADATA_EVALUATOR": "Bewerters",
                "PERSON_METADATA_SUBJECT": "Feedbacknehmers",
                "PERSON_METADATA_VIEWER": "Anzeiger",
                "POSITIVE_GAPS": "Versteckte Stärken",
                "PRIMARY_PARENTHESES": "(primär)",
                "QUESTIONS": "Fragen",
                "RADIUS": "Radius",
                "RANK": "Platzierung",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "Höchste Bewertung",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "Höchste Bewertungen",
                "RANKABLE_ITEMS_ITEM_HAS": "Element hat",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "Element ist in Top",
                "RANKABLE_ITEMS_LOWEST_SCORE": "Niedrigste Bewertung",
                "RANKABLE_ITEMS_LOWEST_SCORES": "Niedrigste Bewertungen",
                "RATER_CATEGORY_DISPLAY_LOGIC": "Anzeigelogik für Bewerterkategorie",
                "RATIO": "Verhältnis",
                "RECORD": "Datensatz",
                "REFERENCE_GROUP": "Referenzgruppe",
                "RELATIONSHIP": "Beziehung",
                "RELATIONSHIP_FILTERS": "Beziehungsfilter",
                "RELATIONSHIP_FILTERS_INFO": "Um einen Beziehungsfilter (z.B. direkt unterstellter Mitarbeiter, Kollege oder Vorgesetzter) hinzuzufügen, wählen Sie die Option zum Verwalten der Filter und verwenden Sie die Beziehungsbedingung aus dem Dropdown-Menü.",
                "REMOVE": "Entfernen",
                "REMOVE_DATA_SOURCE": "Datenquelle entfernen",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Beachten Sie, dass es innerhalb Ihres Unternehmens Ressourcen gibt, die Sie bei der Interpretation des Feedbacks unterstützen können. Hierzu gehören HR-Partner, Ihr Vorgesetzter und/oder ein Mentor.",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Machen Sie sich bereit, und analysieren Sie das Feedback.",
                    "ABOUT_YOUR_REPORT_HEADER": "Über Ihren Bericht",
                    "ABOUT_YOUR_REPORT_LINE1": "Willkommen zum 360-Feedbackbericht. Dies ist eine großartige Möglichkeit für Sie, sich als Experte weiterzuentwickeln. Nehmen Sie sich ausreichend Zeit für das Feedback, damit Sie beim Durcharbeiten der Ergebnisse auf Erfolgskurs bleiben. Feedback kann am Anfang sehr hart sein, aber bedenken Sie, dass Sie mit diesem Feedback Ihr Wachstum und Ihre Weiterentwicklung voranbringen möchten.",
                    "ABOUT_YOUR_REPORT_LINE2": "Wenn Sie den Bericht durcharbeiten, sollten Sie einige Dinge beachten.",
                    "ADVANCED_FILTER": "Erweiterter Filter",
                    "AGREEMENT_CHART": "Zustimmungsdiagramm",
                    "AGREEMENT_CHART_FOOTER": "Das Zustimmungsdiagramm gibt die Ähnlichkeit der Punktwertungen an. Jeder Punkt stellt dar, wie Sie von Einzelnen für jedes Objekt bewertet wurden. Die Größe des Punkts zeigt an, wie viele Bewerter Ihnen eine bestimmte Bewertung gegeben haben.",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "Antworten",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "Antwort",
                    "AGREEMENT_CHART_LEGEND_TITLE": "Wie andere Sie bewertet haben",
                    "ALL": "Alle",
                    "AVERAGE": "Durchschnitt",
                    "BOTTOM_BOX": "Unteres Feld",
                    "CHOICE_COUNT": "Antwortanzahl",
                    "CHOICE_TOTALS": "Auswahlmöglichkeiten insgesamt",
                    "COMPARISON": "Vergleich",
                    "COMPARISON_GAP_COLUMN_HEADER": "Abweichung Vergleich",
                    "COMPLETED_RESPONSES": "Abgeschlossene Antworten",
                    "COUNT": "Anzahl",
                    "DEFAULT": "Standard",
                    "DEFAULT_TEXT": "Standardtext",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "Ermitteln Sie, von wem Ihr Feedback kommt, z.B. Kollegen, direkt unterstellten Mitarbeitern, Führungskräften usw.",
                    "DIFFERENT_EVALUATORS_HEADER": "Unterschiedliche Bewerter",
                    "DONE": "Fertig",
                    "DONT_HEADER": "Was Sie nicht tun sollten:",
                    "DONT_LINE1": "Versuchen Sie nicht herauszufinden, wer was gesagt hat",
                    "DONT_LINE2": "Konzentrieren Sie sich nicht auf eine(n) positive(n) oder negative(n) Bewertung/Kommentar",
                    "DONT_LINE3": "Erstellen Sie keinen Entwicklungsplan zu jedem Objekt",
                    "DONT_LINE4": "Lassen Sie sich nicht entmutigen, wenn es noch Verbesserungspotenzial gibt",
                    "DO_HEADER": "Was Sie tun sollten:",
                    "DO_LINE1": "Betrachten Sie das Feedback in seiner Gesamtheit",
                    "DO_LINE2": "Ermitteln Sie Themen für Stärken und Verbesserungspotenzial",
                    "DO_LINE3": "Priorisieren Sie einige wenige Schwerpunktbereiche, die Sie ihrem Entwicklungsplan hinzufügen möchten",
                    "DO_LINE4": "Erkennen Sie, dass es für jeden Verbesserungspotenzial gibt",
                    "FIELD": "Feld",
                    "GAP": "Abweichung",
                    "GAP_CHART": "Lückendiagramm",
                    "GAP_CHART_DESCRIPTION": "Im Lückendiagramm wird der Unterschied in der Punktwertung zwischen zwei Bewertergruppen angezeigt. Bei einem Vergleich Ihrer Selbstbewertung und der Bewertung durch andere bedeutet ein positiver (+) Unterschied z.B., dass die Bewertung durch andere höher war als Ihre eigene Selbstbewertung. Ein negativer (-) Unterschied bedeutet, dass Sie von anderen niedriger bewertet wurden, als Sie sich selbst bewertet haben.",
                    "GAP_CHART_FOOTER": "Das Lückendiagramm zeigt den Unterschied (+/-) zwischen zwei Bewertergruppen an.",
                    "GAP_TABLE_DESCRIPTION": "Versteckte Stärken zeigen, wo andere Sie höher bewertet haben, als Sie sich selbst. Verbesserungswürdige Bereiche zeigen, wo andere Sie niedriger bewertet haben, als Sie sich selbst. Beide Abschnitte haben eine Rangfolge von der größten zu kleinsten Lücke.",
                    "GAP_TABLE_FOOTER": "Die erste Wertungsspalte zeigt an, wie Sie sich selbst bewertet haben. Die zweite Spalte gibt die durchschnittliche Bewertung anderer an. In der dritten Spalte sehen Sie den Unterschied zwischen Ihrer Bewertung und wie andere Sie bewertet haben.",
                    "GAP_TABLE_TITLE": "Versteckte Stärken/Verbesserungsbereiche",
                    "GROUP": "Gruppe",
                    "HIDE_REPORT_ALERT": "Sie erfüllen nicht die nötigen Anforderungen, um Ihren Bericht einzusehen. Kontaktieren Sie Ihren Organisationsadministrator.",
                    "HIGHEST_SCORES": "Höchste Bewertungen",
                    "HIGHLOW_TABLE": "Hohe und niedrige Bewertungen",
                    "HIGHLOW_TABLE_FOOTER": "In diesem Abschnitt werden die fünf Verhaltensweisen mit den höchsten und niedrigsten Bewertungen (über alle Verhaltensweisen hinweg) aus den jeweiligen Durchschnittswerten der Bewerterkategorien angezeigt. Um diese Seite optimal nutzen zu können, ist es hilfreich, nach möglichen aufkommenden Trends zu suchen. Wenn zum Beispiel die Mehrheit Ihrer Verhaltensweisen mit der niedrigsten Bewertung auf eine oder zwei Kategorien konzentriert ist, handelt es sich dabei möglicherweise um Bereiche mit Verbesserungsbedarf. Die am besten bewerteten Verhaltensweisen können Stärken aufweisen, die in anderen Bereichen genutzt werden können.",
                    "HIGH_LOW_TABLE_DESCRIPTION": "Das Diagramm mit hoher/niedriger Bewertung zeigt Objekte auf Basis von Bereichen an, in denen Sie von anderen am höchsten und niedrigsten bewertet wurden.",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "So interpretieren Sie die Ergebnisse und ermitteln Aktionen:",
                    "ITEM": "Element",
                    "LOWEST_SCORES": "Niedrigste Bewertungen",
                    "MAX": "Max",
                    "MEAN": "Mittelwert",
                    "MEDIAN": "Median",
                    "MIN": "Min",
                    "NEGATIVE_GAPS": "Verbesserungswürdige Bereiche",
                    "NO_COMPARISON_SET": "Kein Vergleich festgelegt",
                    "NO_DATA_AVAILABLE_WARNING": "Keine Daten verfügbar",
                    "NO_FILTER_IS_APPLIED": "Es ist kein Filter angewendet.",
                    "NO_VALUE": "Kein Wert",
                    "NPS": "Net Promoter Score",
                    "OTHERS": "Andere",
                    "PERCENTAGE": "Prozentsatz",
                    "PERCENTAGE_OF_CHOICES": "Anteil der Auswahlmöglichkeiten",
                    "PERCENTAGE_OF_RESPONSES": "Anteil der Antworten",
                    "PERCENT_COMPLETE": "% abgeschlossen",
                    "POSITIVE_GAPS": "Versteckte Stärken",
                    "QUESTIONS": "Fragen",
                    "RANK": "Platzierung",
                    "RELATIONSHIPS": {
                        "ANYONE": "Jeder",
                        "DIRECT_REPORT": "Direkt unterstellter Mitarbeiter",
                        "MANAGER": "Manager",
                        "PEER": "Kollege",
                        "SELF": "Selbst"
                    },
                    "REPORT_SUMMARY": "Berichtszusammenfassung",
                    "REPORT_SUMMARY_TABLE_FOOTER": "Vergleichen Sie die Anzahl der Personen, die die Bewertung abgeschlossen haben, mit der Anzahl der Personen, die zur Bewertung eingeladen wurden.",
                    "REPORT_SUMMARY_TABLE_HEADER": "Teilnehmerstatistiken",
                    "RESPONSES": "Antworten",
                    "RESPONSE_COUNT": "{{responseCount}} Antworten",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Antworten",
                    "SCORING_CATEGORY": "Punktewertungskategorie",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Keine Antworten für diese Kategorie",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Keine Antworten für diese Frage",
                    "SCORING_OVERVIEW": "Bewertungsübersicht",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "Sie und andere Bewerter sind der Meinung, dass dieser Bereich eine Top-Stärke ist.",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Erkannte Stärke",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Bei einem erkannten Verbesserungsbereich liegen sowohl die Selbstbewertungen als auch die Bewertungen durch Dritte unter dem Durchschnitt für diese Kompetenz.",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Erkannter Verbesserungsbereich",
                    "SCORING_OVERVIEW_DESCRIPTION": "Oben finden Sie die Kompetenzen oder Verhaltensweisen, für die Sie als Teil dieses Feedbackprozesses mit Mehrfachbewertung bewertet wurden. Vergleichsbewertungen werden nach Gruppe bereitgestellt.",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "Mindestabweichung",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Mindestunterschied zwischen den Referenzgruppen für die anzuzeigenden Texte.",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "Es wird der Bewertungsbereich für jede Kompetenz/jedes Verhalten angezeigt. Der Balken stellt den numerischen Durchschnitt dar.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Eine nicht erkannte Stärke resultiert aus der Diskrepanz zwischen der Selbstbewertung und der Bewertung durch andere.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Nicht erkannte Stärke",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Ein nicht erkannter Verbesserungsbereich resultiert aus der Diskrepanz zwischen der Selbstbewertung und der Bewertung durch andere.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Nicht erkannter Verbesserungsbereich",
                    "SELF": "Selbst",
                    "SELF_ASSESSMENT": "Selbstbewertung",
                    "STANDARD_DEVIATION": "Standardabweichung",
                    "SUM": "Summe",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Machen Sie sich mit der Bewertungsskala vertraut, um eine genaue Interpretation sicherzustellen",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "Beachten Sie die Skala",
                    "THINGS_YOU_WILL_SEE_HEADER": "Das wird Ihnen angezeigt:",
                    "THREE_SIXTY_PERCENTILE": "Perzentil",
                    "TOP_BOTTOM_BOX": "Obere Box/Untere Box",
                    "TOP_BOX": "Oberes Feld",
                    "TOTAL": "Gesamt",
                    "TO_DO": "Zu erledigen",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Qualitativ: Dieses Feedback wird in Form von Kommentaren mit offenem Text erstellt",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Quantitativ: Dieses Feedback wird in numerischer Form erstellt und kann in Grafiken, Balkendiagrammen, Tabellen usw. dargestellt werden",
                    "TYPES_OF_FEEDBACK_HEADER": "Verschiedene Arten von Feedback",
                    "VALUE": "Wert",
                    "VARIANCE": "Abweichung",
                    "YOUR_RATINGS": "Ihre Bewertungen"
                },
                "REPORT_SUMMARY": "Berichtszusammenfassung",
                "REPORT_SUMMARY_TABLE_FOOTER": "Vergleichen Sie die Anzahl der Personen, die die Bewertung abgeschlossen haben, mit der Anzahl der Personen, die zur Bewertung eingeladen wurden.",
                "REPORT_SUMMARY_TABLE_HEADER": "Teilnehmerstatistiken",
                "RESET": "Zurücksetzen",
                "RESPONDENT_TOTALS": "Gesamtwerte für Teilnehmer",
                "RESPONSES": "Antworten",
                "RESPONSE_COUNT": "{{responseCount}} Antworten",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Antworten",
                "RESULT": "Ergebnis",
                "REVERSE_COLORS": "Farben umkehren",
                "ROW_TOTALS": "Zeilensummen",
                "SAVE": "Speichern",
                "SAVE_AND_APPLY": "Speichern und anwenden",
                "SCORING_CATEGORY": "Punktewertungskategorie",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Keine Antworten für diese Kategorie",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Keine Antworten für diese Frage",
                "SCORING_OVERVIEW": "Bewertungsübersicht",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "Sie und andere Bewerter sind der Meinung, dass dieser Bereich eine Top-Stärke ist.",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Erkannte Stärke",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Bei einem erkannten Verbesserungsbereich liegen sowohl die Selbstbewertungen als auch die Bewertungen durch Dritte unter dem Durchschnitt für diese Kompetenz.",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Erkannter Verbesserungsbereich",
                "SCORING_OVERVIEW_DESCRIPTION": "Oben finden Sie die Kompetenzen oder Verhaltensweisen, für die Sie als Teil dieses Feedbackprozesses mit Mehrfachbewertung bewertet wurden. Vergleichsbewertungen werden nach Gruppe bereitgestellt.",
                "SCORING_OVERVIEW_MINIMUM_GAP": "Mindestabweichung",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Mindestunterschied zwischen den Referenzgruppen für die anzuzeigenden Texte.",
                "SCORING_OVERVIEW_TABLE_FOOTER": "Es wird der Bewertungsbereich für jede Kompetenz/jedes Verhalten angezeigt. Der Balken stellt den numerischen Durchschnitt dar.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Eine nicht erkannte Stärke resultiert aus der Diskrepanz zwischen der Selbstbewertung und der Bewertung durch andere.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Nicht erkannte Stärke",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Ein nicht erkannter Verbesserungsbereich resultiert aus der Diskrepanz zwischen der Selbstbewertung und der Bewertung durch andere.",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Nicht erkannter Verbesserungsbereich",
                "SELECT_CATEGORIES": "Punktewertungskategorien auswählen...",
                "SELECT_CATEGORY": "Punktewertungskategorie auswählen...",
                "SELECT_CONDITION_TYPE": "Bedingungstyp auswählen",
                "SELECT_DATA_SOURCE": "Datenquelle auswählen",
                "SELECT_DATA_SOURCE_TYPE": "Datenquelltyp auswählen",
                "SELECT_FILTER": "Filter auswählen",
                "SELECT_FILTERS": "Filter auswählen",
                "SELECT_OPERATOR_TYPE": "Operatortyp auswählen",
                "SELECT_PERSON": "Person auswählen",
                "SELECT_PERSON_METADATA": "Personen-Metadaten auswählen",
                "SELECT_QUESTION": "Frage auswählen",
                "SELECT_QUESTIONS": "Fragen auswählen...",
                "SELECT_RATIO_OR_DROPOFF": "Verhältnis oder Rückgang auswählen",
                "SELECT_RELATIONSHIP": "Beziehung auswählen",
                "SELECT_SCORING_CATEGORY": "Punktewertungskategorie auswählen",
                "SELF": "Selbst",
                "SELF_ASSESSMENT": "Selbstbewertung",
                "SEQUENTIAL": "Sequenziell",
                "SETUP_COMPARISON": "Einrichtungsvergleich",
                "SETUP_COMPARISONS": "Einrichtungsvergleiche",
                "SET_START_COLOR": "Startfarbe einstellen",
                "SHOULD_SHOW_FOOTER": "Fußzeile anzeigen",
                "SHOULD_SHOW_SCORING_CATEGORY": "Punktewertungskategorie anzeigen",
                "SHOWING_RECORDS_OF": "Datensätze %1 - %2 von %3 werden angezeigt",
                "SHOW_COMPARISON_GAP": "Spalte Abweichung Vergleich anzeigen",
                "SHOW_DATA_LABEL": "Datenwerte anzeigen",
                "SHOW_PERCENTAGES": "Prozentsätze anzeigen",
                "SHOW_THE_FOLLOWING_TEXT": "Anschließend den folgenden Text anzeigen",
                "SHOW_TIES": "Zusammenhänge anzeigen",
                "SHOW_X_AXIS": "X-Achse anzeigen",
                "SHOW_Y_AXIS": "Y-Achse anzeigen",
                "SMALL_LABELS": "Kleine Labels",
                "SORT": "Sortieren",
                "SPLINE": "Spline",
                "STACK_CHART": "Diagramm stapeln",
                "STANDARD_DEVIATION": "Standardabweichung",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "Schwäche weniger als",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "Schwellenwerttexte bearbeiten",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "Schwellenwerttexte",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "Schwellenwerttexte aktivieren",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "Stärke mehr als",
                "SUM": "Summe",
                "SUMMARY": "Zusammenfassung",
                "TABLES": "Tabellen",
                "TABLE_TOTALS": "Zwischensummen der Tabelle",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Machen Sie sich mit der Bewertungsskala vertraut, um eine genaue Interpretation sicherzustellen",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "Beachten Sie die Skala",
                "TEXT": "Text",
                "THINGS_YOU_WILL_SEE_HEADER": "Das wird Ihnen angezeigt:",
                "TOP_BOTTOM_BOX": "Obere Box/Untere Box",
                "TOP_BOX": "Oberes Feld",
                "TOTAL": "Gesamt",
                "TOTAL_COUNTS": "Gesamtanzahl",
                "TO_DO": "Zu erledigen",
                "TRANSPOSE": "Spiegeln",
                "TRANSPOSE_TABLE": "Tabelle spiegeln",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Qualitativ: Dieses Feedback wird in Form von Kommentaren mit offenem Text erstellt",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Quantitativ: Dieses Feedback wird in numerischer Form erstellt und kann in Grafiken, Balkendiagrammen, Tabellen usw. dargestellt werden",
                "TYPES_OF_FEEDBACK_HEADER": "Verschiedene Arten von Feedback",
                "UNDO": "Rückgängig machen",
                "USE_COMPARISON": "Vergleich verwenden",
                "USE_LABELS_FOR_SCALES": "Label für Skalen verwenden",
                "VALUES": "Werte",
                "VALUE_RANGES": "Wertbereiche",
                "VARIANCE": "Abweichung",
                "VERTICAL": "Vertikal",
                "VERTICAL_RANGE": "Vertikaler Bereich",
                "WARNING_DATA_OUT_OF_RANGE": "Warnung: Datenwert überschreitet die Bereichskonfiguration",
                "WIDGET_ERROR": {
                    "ERROR": "Ein unerwarteter Fehler ist aufgetreten",
                    "MISCONFIGURED": "Dieses Widget ist nicht korrekt konfiguriert. Überprüfen Sie bitte Ihre Widget-Konfiguration.",
                    "NEW": "Bitte Widget konfigurieren",
                    "NO_DATA": "Keine Daten gefunden – Ihre Filter sind unter Umständen zu exklusiv!"
                },
                "WIDGET_NAME": {
                    "BAR": "Balkendiagramm",
                    "BREAKDOWNBAR": "Strukturdiagramm",
                    "DATA_TABLE": "Datentabelle",
                    "FUNNEL_CHART": "Trichterdiagramm",
                    "GAUGE": "Barometerdiagramm",
                    "GRID": "Ergebnistabelle",
                    "HEATMAP": "Heatmap",
                    "LINE": "Liniendiagramm",
                    "NEEDS_BASED": "Bedarfsbasiert",
                    "PIE": "Kreisdiagramm",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "Preiskalkulator (Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "Umsatzmaximierer (Gabor Granger)",
                    "SCORING_OVERVIEW_CHART": "Diagramm",
                    "SCORING_OVERVIEW_TABLE": "Tabelle",
                    "STATS_TABLE": "Statistiktabelle",
                    "WORDCLOUD": "Wortwolke"
                },
                "WORD_ROTATION": "Wortdrehung",
                "WORD_SPACING": "Leerzeichen zwischen Wörtern",
                "YES": "Ja",
                "YOUR_RATINGS": "Ihre Bewertungen"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "Hinzufügen",
                "ADD_A_WORD": "Wort hinzufügen",
                "COLOR": "Farbe",
                "DELETE_ALL": "Alle löschen",
                "EDIT_STOP_WORDS": "Stoppwörter ändern",
                "MAX_WORDS": "Max. Wörter",
                "ROTATION_ANGLED": "Gewinkelt",
                "ROTATION_HORIZONTAL": "Horizontal",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "Horizontal und vertikal",
                "WORD_ORIENTATION": "Wortausrichtung"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "Hintergrundfarben",
                "DISPLAY_OPTIONS": "Anzeigeoptionen",
                "INVERT_FONT_COLORS": "Schriftfarben mit geringem Kontrast invertieren",
                "PAGE": "Seite",
                "PAGINATE": "Paginieren"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "Mittelwert",
                "BOTTOM_BOX_METRIC": "Unteres Feld",
                "COLUMNS": "Spalten",
                "COUNT_METRIC": "Antworten insgesamt",
                "FIELD_NAME": "Feld",
                "MAX_METRIC": "Maximum",
                "MIN_METRIC": "Minimum",
                "SHOW_RECODES": "Umkodierungswerte anzeigen",
                "SHOW_ROW_NUMBERS": "Zeilennummerierung anzeigen",
                "STD_DEV_METRIC": "Standardabweichung",
                "TOP_BOX_METRIC": "Oberes Feld",
                "TRANSPOSE_BREAKOUTS": "Aufschlüsselungen umgruppieren",
                "TRANSPOSE_TABLE": "Gespiegelte Tabelle",
                "VAR_METRIC": "Abweichung"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "Zusätzliche Spalten",
                "ADD_COLUMNS": "Zusätzliche Spalten hinzufügen",
                "ADD_CUSTOM_PALETTE": "Benutzerdefinierte Palette hinzufügen",
                "ALL_CHOICES": "Alle Antwortmöglichkeiten",
                "ALL_GROUPS": "Alle Gruppen",
                "ALL_RECODES": "Alle neu kodierten Werte",
                "AUTOMATIC": "Standard",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "Standard – Zum Bearbeiten hier klicken",
                "AXIS_VALUES": "Achsenwerte",
                "BREAKOUT_BY": "Aufschlüsselung nach",
                "CANCEL": "Abbrechen",
                "CATEGORICAL": "Kategorisch",
                "CHOICES": "Antwortmöglichkeiten",
                "CHOICE_COUNT": "Antwortanzahl",
                "COLOR_PALETTE": "Farbpalette",
                "COLUMN_VALUES": "Spaltenwerte",
                "CONTACT_FIELDS": "Kontaktfelder",
                "COUNT": "Anzahl",
                "CREATE": "Erstellen",
                "CUSTOM": "Benutzerdefiniert",
                "CUSTOM_PALETTE": "Benutzerdefinierte Palette",
                "DATA_SOURCE": "Datenquelle",
                "DAY": "Tag",
                "DAY_OF_WEEK": "Wochentag",
                "DECIMAL_PRECISION": "Dezimalstellen",
                "DEFAULT": "Standard",
                "DISABLED": "Deaktiviert",
                "DIVERGENT": "Divergent",
                "EDIT_CUSTOM_PALETTE": "Benutzerdefinierte Palette bearbeiten",
                "ENABLED": "Aktiviert",
                "ERROR_LOADING_DATA": "Fehler beim Laden der Daten",
                "FILE_SIZE": "Größe",
                "FILE_TYPE": "Typ",
                "FRI": "Fr",
                "FRIDAY": "Freitag",
                "GROUP_DATE_BY": "Datum gruppieren nach",
                "HOUR_OF_DAY": "Zeit",
                "LENGEND_VALUES": "Legendenwerte",
                "MAX": "Max",
                "MEAN": "Mittelwert",
                "MIN": "Min",
                "MISCONFIGURED_DATA": "Datenquelle für diese Visualisierung falsch konfiguriert.",
                "MISCONFIGURED_FILTERS": "Ungültige(r) Filter",
                "MODIFY_CUSTOM_PALETTES": "Benutzerdefinierte Paletten ändern",
                "MON": "Mo",
                "MONDAY": "Montag",
                "MONTH": "Monat",
                "NONE": "Ohne",
                "NO_FILE_ID_ERROR": "Für diese Visualisierung ist ein Bild erforderlich, das in der Umfrage platziert wird",
                "NO_RESULTS_TO_SHOW": "Keine anzuzeigenden Ergebnisse",
                "NPS": "Net Promoter Score®",
                "NPS_GROUP": "NPS®-Gruppe",
                "NUMERIC_VALUE": "Numerischer Wert",
                "PALETTE_REMOVED": "Palette entfernt",
                "PERCENTAGE": "Prozent",
                "PERCENTAGE_OF_CHOICES": "Anteil der Auswahlmöglichkeiten",
                "PERCENTAGE_OF_RESPONSES": "Anteil der Antworten",
                "QUARTER": "Quartal",
                "REMOVE": "Entfernen",
                "RESPONSE_COUNT": "Anzahl der Antworten",
                "RESULTS_PER_PAGE": "Ergebnisse pro Seite",
                "RETRIEVING_DATA_ELLIPSIS": "Daten werden abgerufen...",
                "REVERSE_COLORS": "Farben umkehren",
                "ROW_VALUES": "Zeilenwerte",
                "SAT": "Sa",
                "SATURDAY": "Samstag",
                "SAVE": "Speichern",
                "SELECTED_CHOICE": "Ausgewählte Antwortmöglichkeit",
                "SELECT_FIELD": "Feld auswählen",
                "SELECT_METRIC": "Metrik",
                "SEQUENTIAL": "Sequenziell",
                "SET_START_COLOR": "Startfarbe einstellen",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "Stichprobendaten werden angezeigt...",
                "SUM": "Summe",
                "SUN": "So",
                "SUNDAY": "Sonntag",
                "SURVEY_EMBEDDEDDATA": "Eingebettete Daten",
                "SURVEY_METADATA": "Metadaten der Umfrage",
                "TEXT_ENTRY": "Texteingabe",
                "THURS": "Do",
                "THURSDAY": "Donnerstag",
                "TITLE": "Titel",
                "TUES": "Di",
                "TUESDAY": "Dienstag",
                "UNBOUNDED_DOMAIN": "Zu viele Werte, Anzeige nicht möglich.",
                "UNBOUNDED_DOMAIN_HELP": "Um dieses Feld den Ergebnisberichten hinzuzufügen, können Sie den Bericht mit einem Filter versehen, damit für „{{ed_field_name}}“ weniger Werte angezeigt werden. Alternativ können Sie in Ihrem Umfrageverlauf auch den Variablentyp für eingebettete Daten von „{{ed_field_name}}“ in ein String oder ein numerisches Feld ändern.",
                "UNDO": "Rückgängig machen",
                "USE_CHOICE_TOTALS": "Gesamtwerte für Auswahl verwenden",
                "USE_RESPONDENT_TOTALS": "Gesamtwerte für Teilnehmer verwenden",
                "VISUALIZATION": "Visualisierung",
                "VISUALIZATION_BARCHART": "Balkendiagramm",
                "VISUALIZATION_BREAKDOWNBAR": "Strukturdiagramm",
                "VISUALIZATION_GAUGE": "Barometerdiagramm",
                "VISUALIZATION_HEATMAP": "Heatmap",
                "VISUALIZATION_LINECHART": "Liniendiagramm",
                "VISUALIZATION_PAGINATEDTABLE": "Paginierte Tabelle",
                "VISUALIZATION_PIE": "Kreisdiagramm",
                "VISUALIZATION_SIMPLETABLE": "Einfache Tabelle",
                "VISUALIZATION_STATSTABLE": "Statistiktabelle",
                "VISUALIZATION_TEXTHIGHLIGHTS": "Texthervorhebungen",
                "VISUALIZATION_WORDCLOUD": "Wortwolke",
                "WED": "Mi",
                "WEDNESDAY": "Mittwoch",
                "WEEK": "Woche",
                "WEIGHTING": "Gewichtung",
                "WRONG_QUESTION_TYPE_ERROR": "Dieser Visualisierungstyp kann für diese Frage nicht verwendet werden",
                "YEAR": "Jahr"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "Durchschnittlich",
                "CHOICE_COUNT": "Antwortanzahl",
                "COUNT": "Anzahl",
                "DISPLAY_OPTIONS": "Anzeigeoptionen",
                "MAX": "Maximum",
                "MIN": "Minimum",
                "NPS": "NPS®",
                "PAGE_OF": "Seite: %1 von %2",
                "PERCENT": "Prozent",
                "RESPONSE_COUNT": "Anzahl der Antworten",
                "ROWS_PER_TABLE": "Zeilen pro Tabelle",
                "SHOWING_ROWS_OF": "Zeilen %1 - %2 von %3 werden angezeigt",
                "SHOW_PERCENTAGES": "Prozentsätze anzeigen",
                "SHOW_RECODES": "Umkodierungswerte anzeigen",
                "SHOW_ROW_NUMBERS": "Zeilennummerierung anzeigen",
                "SUM": "Summe",
                "TOTAL": "Gesamt",
                "TRANSPOSE": "Spiegeln",
                "USE_COLUMN_TOTALS": "Spaltensummen verwenden",
                "USE_ROW_TOTALS": "Zeilensummen verwenden",
                "VALUE": "Wert"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "Aufsteigend",
                "COUNT": "Anzahl",
                "DESCENDING": "Absteigend",
                "DIAGONAL": "Diagonal",
                "DISPLAY_OPTIONS": "Anzeigeoptionen",
                "ERROR_COLON": "Fehler:",
                "ERROR_GENERIC": "Beim Laden der Visualisierung ist ein Fehler aufgetreten.",
                "HORIZONTAL": "Horizontal",
                "HORIZONTAL_BARS": "Horizontale Balken",
                "INCORRECTLY_CONFIGURED": "Wählen Sie zum Anzeigen des Diagramms einen Wert aus",
                "LEGEND_AUTO": "Automatisch",
                "LEGEND_BOTTOM": "Unten",
                "LEGEND_INSET": "Eingebettet",
                "LEGEND_RIGHT": "Rechts",
                "NORMALIZE_TO_PERCENTAGES": "Als Prozentwerte normalisieren",
                "SHOW_BAR_LABELS": "Balkenbeschriftungen anzeigen",
                "SHOW_LEGEND": "Legende anzeigen",
                "SHOW_X_AXIS": "X-Achse anzeigen",
                "SHOW_Y_AXIS": "Y-Achse anzeigen",
                "SORT_BAR_VALUES": "Balkenwerte sortieren",
                "STACKED_BARS": "Gestapelte Balken",
                "TRANSPOSE": "Spiegeln",
                "TRUNCATE_LABELS": "Labels kürzen",
                "VERTICAL": "Vertikal"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "Alle Anderen",
                "COULD_NOT_LOAD_DATA": "Daten mit angegebener Konfiguration konnten nicht geladen werden. Versuchen Sie es mit einem anderen Quellfeld oder einem größeren Datenbereich.",
                "GROUPING_PERCENTAGE_THRESHOLD": "Schwellenwert für Gruppierung in Prozent",
                "NO_DATA": "Keine Daten",
                "RADIUS": "Innerer Radius",
                "SHOW_AS_PERCENTAGES": "Als Prozentsätze anzeigen"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "Schließen",
                "DOWNLOAD_CSV": "CSV-Daten herunterladen",
                "DOWNLOAD_ZIP": "Alle Dateien herunterladen",
                "NO_DATA": "Keine Daten",
                "PAGE_OF": "Seite: %1 von %2",
                "RESULTS_PER_PAGE": "Ergebnisse pro Seite",
                "SHOWING_RECORDS_OF": "Datensätze %1 - %2 von %3 werden angezeigt",
                "SINGLE_RESPONSE": "Einzelne Antwort",
                "VIEW_RESPONSE": "Antwort anzeigen"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "Anzeigeoptionen",
                "ERROR_COLON": "Fehler:",
                "ERROR_GENERIC": "Beim Laden der Visualisierung ist ein Fehler aufgetreten.",
                "HORIZONTAL_BARS": "Horizontale Balken",
                "INCORRECTLY_CONFIGURED": "Wählen Sie zum Anzeigen des Diagramms einen Wert aus",
                "LEGEND_AUTO": "Automatisch",
                "LEGEND_BOTTOM": "Unten",
                "LEGEND_INSET": "Eingebettet",
                "LEGEND_RIGHT": "Rechts",
                "NORMALIZE_TO_PERCENTAGES": "Als Prozentwerte normalisieren",
                "SHOW_AREA": "Bereich anzeigen",
                "SHOW_LEGEND": "Legende anzeigen",
                "SHOW_X_AXIS": "X-Achse anzeigen",
                "SHOW_Y_AXIS": "Y-Achse anzeigen",
                "SMOOTH_LINES": "Weiche Linien",
                "SORT_X_AXIS_LABELS": "X-Achsenbezeichner sortieren",
                "STACKED_BARS": "Gestapelte Balken",
                "TRANSPOSE": "Spiegeln"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "Blockmodus",
                "BLUR": "Weichzeichnen",
                "COULD_NOT_LOAD_DATA": "Daten mit angegebener Konfiguration konnten nicht geladen werden. Versuchen Sie es mit einem anderen Quellfeld oder einem größeren Datenbereich.",
                "FIELD": "Feld",
                "RADIUS": "Radius",
                "SHOW_REGIONS": "Regionen anzeigen",
                "SHOW_REGION_LABELS": "Regionslabel anzeigen"
            },
            "GAUGEWIDGET": {
                "MAX": "Max",
                "MIN": "Min",
                "VALUE_RANGES": "Wertbereiche"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "Untere Labels",
                "CATEGORY_NAME": "Kategoriename",
                "ERROR_COLON": "Fehler:",
                "INCLUDE_HIDDEN_GROUPS": "Ausgeblendete Gruppen in Prozenten einschließen",
                "LARGE_LABELS": "Große Labels",
                "NO": "Nein",
                "PERCENT": "Prozent",
                "RESPONSE_COUNT": "Anzahl der Antworten",
                "RESPONSE_COUNT_WITH_VALUE": "{{ responseCount }} Antworten",
                "SMALL_LABELS": "Kleine Labels",
                "YES": "Ja"
            }
        });
        $cache.put('EL', {
            "VIEWRESULTS": {},
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Να θυμάστε ότι υπάρχουν πόροι στον οργανισμό σας που θα σας βοηθήσουν να ερμηνεύσετε τα σχόλιά σας όπως Συνεργάτες HR, ο διευθυντής σας και/ή ο μέντοράς σας.",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Βάλτε ένα φλιτζάνι καφέ και ασχοληθείτε με τα σχόλιά σας.",
                "ABOUT_YOUR_REPORT_HEADER": "Σχετικά με την αναφορά σας",
                "ABOUT_YOUR_REPORT_LINE1": "Καλωσορίσατε στην 360 αναφορά σχολίων. Αυτή είναι μια σπουδαία ευκαιρία να αναπτυχθείτε ως επαγγελματίας. Προκειμένου να προετοιμάσετε τον εαυτό σας για την επιτυχία όταν περιηγήστε στα αποτελέσματα, δώστε στον εαυτό σας αρκετό χρόνο για να ασχοληθεί με τα σχόλια. Ο σχολιασμός μπορεί να φαίνεται δύσκολος να τον παρακολουθήσετε στην αρχή αλλά να θυμάστε ότι ο σκοπός του είναι να επιταχύνει την ανάπτυξή σας.",
                "ABOUT_YOUR_REPORT_LINE2": "Καθώς διαβάζετε την αναφορά σας, ορίστε μερικά πράγματα που πρέπει να θυμάστε.",
                "ADD_CONDITIONAL_TEXT": "Εισαγωγή υπό συνθήκης κειμένου",
                "ADD_CUSTOM_PALETTE": "Προσθήκη προσαρμοσμένης παλέτας",
                "ADD_DATA_SOURCE": "Προσθήκη πηγής δεδομένων",
                "ADD_FOLLOWING": "Αποθήκευση και εφαρμογή",
                "ADD_LABEL": "Προσθήκη ετικέτας",
                "ADVANCED_FILTER": "Σύνθετο φίλτρο",
                "AGREEMENT_CHART": "Διάγραμμα συμβάσεων",
                "AGREEMENT_CHART_FOOTER": "Το διάγραμμα συμβάσεων υποδεικνύει την ομοιότητα των βαθμολογιών.",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "απαντήσεις",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "απάντηση",
                "AGREEMENT_CHART_LEGEND_TITLE": "Πώς σας βαθμολόγησαν οι άλλοι",
                "ALL": "Όλα",
                "AND_IF": "Και αν",
                "ANGLED": "Με κλίση",
                "AREA": "Εμβαδόν",
                "AUTO": "Αυτόματο",
                "AVERAGE": "Μέσος όρος",
                "AXIS_VALUES": "Τιμές άξονα",
                "BAR": "Ράβδος",
                "BASE_WORD_COLOR": "Χρώμα λέξης βάσης",
                "BLUR": "Θάμπωμα",
                "BOTTOM_BOX": "Κάτω πλαίσιο",
                "BREAKOUT_HEADERS": "Κεφαλίδες Διαχωρισμού",
                "CANCEL": "Άκυρο",
                "CATEGORICAL": "Κατηγορικό",
                "CATEGORY": "Κατηγορία",
                "CATEGORY_NAME": "Όνομα κατηγορίας",
                "CHANGE_CATEGORIES_ORDER": "Αλλάξτε τη σειρά των κατηγοριών",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "Αλλάξτε τη σειρά των κατηγοριών βαθμολογίας",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "Αλλάξτε τη σειρά που εμφανίζεται στην απεικόνιση κάνοντας κλικ στα αριστερά του στοιχείου της κατηγορίας βαθμολογίας και μεταφέροντάς το στην επιθυμητή του θέση.",
                "CHANGE_QUESTIONS_ORDER": "Αλλάξτε τη σειρά των ερωτήσεων",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "Αλλάξτε τη σειρά των ερωτήσεων",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "Αλλάξτε τη σειρά που εμφανίζεται στην απεικόνιση κάνοντας κλικ στα αριστερά του στοιχείου της ερώτησης και μεταφέροντάς το στην επιθυμητή του θέση.",
                "CHARTS": "Διαγράμματα",
                "CHART_TYPE": "Τύπος διαγράμματος",
                "CHOICE_COUNT": "Καταμέτρηση επιλογών",
                "CHOICE_TOTALS": "Σύνολα επιλογών",
                "CLEAR": "Απαλοιφή",
                "CLOSE": "Κλείσιμο",
                "COLOR_PALETTE": "Παλέτα χρωμάτων",
                "COLUMN_NAMES": "Ονόματα στηλών",
                "COLUMN_TOTALS": "Σύνολα στηλών",
                "COMPARED_FILTER_GROUP": "Σύγκριση Ομάδας Φίλτρων",
                "COMPARED_FILTER_GROUPS": "Σύγκριση ομάδων φίλτρων",
                "COMPARE_WITH": "σύγκριση με",
                "COMPETITION_RANKING": "Χρησιμοποιήστε κατάταξη βάσει ανταγωνισμού",
                "COMPETITION_RANKING_TOOLTIP": "Σε περίπτωση ισοπαλίας, όλες οι ισοδύναμες βαθμολογίες αποκτούν την ίδια κατάταξη. Ωστόσο, το επόμενο στοιχείο θα καταταχθεί ως: ο συνολικός αριθμός των στοιχείων με ανώτερη κατάταξη στον πίνακα, συν ένα.",
                "COMPLETED_RESPONSES": "Συμπληρωμένες απαντήσεις",
                "CONDITIONAL_TEXT": "Υπό συνθήκη κείμενο",
                "COUNT": "Πλήθος",
                "CREATE": "Δημιουργία",
                "CUSTOM_PALETTE": "Προσαρμοσμένη παλέτα",
                "DATA_SOURCE_TYPE": "Τύπος πηγής δεδομένων",
                "DATA_SOURCE_TYPE_CATEGORY": "Κατηγορίες βαθμολόγησης",
                "DATA_SOURCE_TYPE_QUESTION": "Ερωτήσεις",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "Ερώτηση",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "Στοιχεία με δυνατότητα ταξινόμησης",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "Κατηγορία βαθμολόγησης",
                "DEFAULT": "Προεπιλογή",
                "DEFAULT_TEXT": "Προεπιλεγμένο κείμενο",
                "DELETE": "Διαγραφή",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "Κατανοήστε από ποιον προέρχονται τα σχόλια, αν είναι από συναδέλφους, άμεσους υφιστάμενους, στελέχη, κλπ",
                "DIFFERENT_EVALUATORS_HEADER": "Διαφορετικοί αξιολογητές",
                "DIRECT_REPORTS": "Άμεσοι υφιστάμενοι",
                "DISABLED": "Απενεργοποιημένο",
                "DISPLAY_OPTIONS": "Επιλογές εμφάνισης",
                "DISPLAY_THRESHOLD_TEXTS": "Εμφάνιση κειμένου που βασίζεται στο κενό των ακόλουθων ομάδων",
                "DIVERGENT": "Με απόκλιση",
                "DONE": "Ολοκληρώθηκε",
                "DONT_HEADER": "Δεν πρέπει:",
                "DONT_LINE1": "Να προσπαθείτε να καταλάβετε ποιος το είπε αυτό",
                "DONT_LINE2": "Να εστιάσετε σε ένα/μία θετικό/ή ή αρνητικό/ή βαθμολογία/σχόλιο",
                "DONT_LINE3": "Να δημιουργήσετε ένα πρόγραμμα ανάπτυξης γύρω από κάθε στοιχείο",
                "DONT_LINE4": "Να αποθαρρύνεστε ότι δεν έχετε ευκαιρίες για βελτίωση",
                "DONUT": "Διάγραμμα δακτυλίου (Donut)",
                "DOWNLOAD_CSV": "Λήψη CSV παλαιού τύπου",
                "DOWNLOAD_ZIP": "Λήψη όλων των αρχείων",
                "DO_HEADER": "Πρέπει:",
                "DO_LINE1": "Να βλέπετε τα σχόλια ολιστικά",
                "DO_LINE2": "Να προσδιορίζετε θέματα σε δυνατότητες και ευκαιρίες βελτίωσης",
                "DO_LINE3": "Να προτεραιοποιείτε μερικές περιοχές εστίασης για να τις προσθέσετε στο πρόγραμμα ανάπτυξής σας",
                "DO_LINE4": "Να κατανοήσετε ότι όλοι έχουν ευκαιρίες για βελτίωση",
                "DROPOFF": "Απόθεση",
                "DUPLICATE": "Διπλότυπο",
                "EDIT_CONDITIONAL_TEXT": "Επεξεργασία υπό συνθήκης κειμένου",
                "EDIT_CUSTOM_PALETTE": "Επεξεργασία προσαρμοσμένης παλέτας",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "Διαφορετικά εμφάνιση του εξής κειμένου",
                "ENABLED": "Ενεργοποιημένο",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "Ενεργοποίηση παραγγελιών κατά λογική εμφάνισης της κατηγορίας αξιολογητή",
                "ENABLE_ORDERING_FOR": "Ενεργοποίηση παραγγελίας για",
                "EQUAL_TO": "Ισοδυναμεί με",
                "FIELD": "Πεδίο",
                "FILTER_NAMES": "Ονόματα φίλτρου",
                "FOLLOWING_PARENTHESES": "(επόμενο)",
                "FOOTER": "Υποσέλιδο",
                "GAP": "Χάσμα",
                "GAP_CHART": "Γράφημα χασμάτων",
                "GAP_CHART_DESCRIPTION": "Το διάγραμμα χασμάτων εμφανίζει τη διαφορά στις βαθμολογίες μεταξύ δύο ομάδων αξιολογητών. Για παράδειγμα, στην περίπτωση των αυτοαξιολογήσεων έν.πώς σας βαθμολόγησαν οι άλλοι, μια θετική(+) διαφορά σημαίνει ότι οι άλλοι σας αξιολόγησαν υψηλότερα απ'ότι εσείς τον εαυτό σας. Μια αρνητική(-) διαφορά σημαίνει ότι οι άλλοι σας βαθμολόγησαν χαμηλότερα απ'ότι εσείς τον εαυτό σας.",
                "GAP_CHART_FOOTER": "Το διάγραμμα χασμάτων υποδεικνύει τη διαφορά +/- μεταξύ δύο ομάδων αξιολογητών.",
                "GAP_TABLE_DESCRIPTION": "Οι κρυμμένες δυναμικές δείχνουν πότε οι άλλοι σας βαθμολόγησαν υψηλότερ απ'ότι εσείς τον εαυτό σας. Περιοχές για βελτίωση εμφανίζουν πότε οι άλλοι σας βαθμολόγησαν χαμηλότερα απ'ότι εσείς τον εαυτό σε. Και οι δύο τομείς αξιολογήθηκαν από το μεγαλύτερο στο μικρότερο χάσμα.",
                "GAP_TABLE_FOOTER": "Η πρώτη στήλη βαθμολογιών υποδεικνύει πώς βαθμολογήσατε τον εαυτό σας. Η δεύτερη στήλη υποδεικνύει τη μέση βαθμολογία των άλλων. Η τρίτη στήλη υποδεικνύει τη διαφορά μεταξύ του πώς βαθμολογήσατε τον εαυτό σας και πώς βαθμολόγησαν οι άλλοι εσάς.",
                "GAP_TABLE_TITLE": "Κρυμμένες δυναμικές/Περιοχές βελτίωσης",
                "GREATER_OR_EQUAL": "Μεγαλύτερο ή ίσο με",
                "GREATER_THAN": "Μεγαλύτερο από",
                "GROUP": "Ομάδα",
                "GROUPED_FOR_ANONYMITY": "Ομαδοποίηση για ανωνυμία",
                "HEADER_NAMES": "Ονόματα κεφαλίδας",
                "HIGHEST_SCORES": "Υψηλότερες βαθμολογίες",
                "HIGHLIGHT_THRESHOLD": "Όριο για την επισήμανση χασμάτων",
                "HIGHLOW_TABLE": "Υψηλές και χαμηλές βαθμολογίες",
                "HIGHLOW_TABLE_FOOTER": "Αυτή η ενότητα δείχνει τις πέντε συμπεριφορές με την υψηλότερη και χαμηλότερη βαθμολογία (σε όλες τις συμπεριφορές) από τους εφαρμοζόμενους μέσους όρους των κατηγοριών βαθμολογητών. Για να αξιοποιήσετε στο έπακρο αυτήν τη σελίδα, είναι χρήσιμο να αναζητείτε τάσεις που μπορεί να παρουσιαστούν. Για παράδειγμα, εάν η πλειονότητα των συμπεριφορών σας με τη χαμηλότερη βαθμολογία είναι συγκεντρωμένη σε μία ή δύο κατηγορίες, αυτοί μπορεί να είναι τομείς που χρειάζονται ανάπτυξη. Οι συμπεριφορές με την υψηλότερη βαθμολογία μπορούν να αναγνωρίσουν ισχυρά σημεία που μπορούν να αξιοποιηθούν σε άλλους τομείς.",
                "HIGH_LOW_TABLE_DESCRIPTION": "Το διάγραμμα υψηλής/χαμηλής βαθμολογίας εμφανίζει στοιχεία βάσει των περιοχών που σας αξιολόγησαν οι άλλοι υψηλότερα και χαμηλότερα.",
                "HORIZONTAL": "Οριζόντιο",
                "HORIZONTAL_AND_VERTICAL": "Οριζόντια και κάθετα",
                "HORIZONTAL_BAR": "Οριζόντια ράβδος",
                "HOW_TO_INTERPRET_RESULT_HEADER": "Πώς να ερμηνεύσετε αποτελέσματα και να καθορίσετε ενέργεια:",
                "IF": "Εάν",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "Συμπερίληψη κρυμμένων ετικετών σε ποσοστά",
                "INNER_RIM": "Εσωτερική στεφάνη",
                "IS": "Είναι",
                "IS_NOT": "Δεν είναι",
                "IS_SAME_AS_SUBJECT": "Είναι ίδιο με του ενδιαφερόμενου",
                "ITEM": "Στοιχείο",
                "LABEL": "ετικέτα",
                "LABELS": "Ετικέτες",
                "LARGE_LABELS": "Μεγάλες ετικέτες",
                "LEGEND": "Υπόμνημα",
                "LEGEND_POSITION": "Θέση υπομνήματος",
                "LEGEND_VALUES": "Τιμές υπομνήματος",
                "LESS_OR_EQUAL": "Μικρότερο από ή ίσο με",
                "LESS_THAN": "Μικρότερο από",
                "LINE": "Γραμμή",
                "LOWEST_SCORES": "Χαμηλότερες βαθμολογίες",
                "MANAGERS": "Διευθυντές",
                "MANUAL_FONT_SIZE": "Χειροκίνητη ρύθμιση γραμματοσειράς",
                "MAX": "Μέγιστη",
                "MEAN": "Μέση τιμή",
                "MEDIAN": "Διάμεση",
                "METRIC_TYPE": "Τύπος μετρικής",
                "MIN": "Ελάχιστη",
                "MODIFY_CUSTOM_PALETTES": "Τροποποίηση προσαρμοσμένων παλετών",
                "MOVE_DOWN": "Μετακίνηση προς τα κάτω",
                "MOVE_UP": "Μετακίνηση προς τα πάνω",
                "MULTI_SELECT_ITEMS_SELECTED": "επιλέχθηκε",
                "NEGATIVE_GAPS": "Περιοχές για βελτίωση",
                "NO": "Όχι",
                "NONE": "Κανένα",
                "NOT_APPLICABLE": "Δεν ισχύει",
                "NOT_EQUAL_TO": "Δεν ισοδυναμεί με",
                "NO_DATA_AVAILABLE_WARNING": "Δεν υπάρχουν διαθέσιμα δεδομένα",
                "NO_FILTER": "Κανένα φίλτρο",
                "NO_FILTER_IS_APPLIED": "Δεν εφαρμόζεται φίλτρο.",
                "NO_VALUE": "Χωρίς τιμή",
                "NPS": "Βαθμολογία Θετικής Αξιολόγησης Δικτύου",
                "NUMBER": "αριθμός",
                "NUMBERS": "Αριθμοί",
                "NUMBER_OF_GAPS_NEGATIVE": "Αριθμός αρνητικών κενών",
                "NUMBER_OF_GAPS_POSITIVE": "Αριθμός θετικών κενών",
                "NUMBER_OF_ROWS_HIGH": "Αριθμός υψηλών σειρών",
                "NUMBER_OF_ROWS_LOW": "Αριθμός χαμηλών σειρών",
                "OPTIONS": {
                    "HEADER_NAME": "Όνομα κεφαλίδας",
                    "LEGEND": "Υπόμνημα",
                    "SCALE_AXIS_CHANGER_TITLE": "Εύρος"
                },
                "ORIENTATION": "Προσανατολισμός",
                "OR_IF": "Ή εάν",
                "OTHER": "Άλλο",
                "OTHERS": "Άλλα",
                "PAGE_OF": "Σελίδα: %1 Από %2",
                "PALETTE_REMOVED": "Αφαιρέθηκε η παλέτα",
                "PEERS": "Ομότιμοι",
                "PERCENT": "Ποσοστό",
                "PERCENTAGE": "Ποσοστό",
                "PERCENTAGE_OF_CHOICES": "Ποσοστό επιλογών",
                "PERCENTAGE_OF_RESPONSES": "Ποσοστό απαντήσεων",
                "PERCENT_COMPLETE": "% συμπληρώθηκαν",
                "PERSON_METADATA": "Μεταδεδομένα ατόμου",
                "PERSON_METADATA_EVALUATOR": "Του βαθμολογητή",
                "PERSON_METADATA_SUBJECT": "Του ενδιαφερόμενου",
                "PERSON_METADATA_VIEWER": "Του παρατηρητή",
                "POSITIVE_GAPS": "Κρυμμένες δυναμικές",
                "PRIMARY_PARENTHESES": "(πρωταρχικό)",
                "QUESTIONS": "Ερωτήσεις",
                "RADIUS": "Ακτίνα",
                "RANK": "Σειρά",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "Υψηλότερη βαθμολογία",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "Υψηλότερες βαθμολογίες",
                "RANKABLE_ITEMS_ITEM_HAS": "Το στοιχείο έχει",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "Το στοιχείο είναι στην κορυφή",
                "RANKABLE_ITEMS_LOWEST_SCORE": "Χαμηλότερη βαθμολογία",
                "RANKABLE_ITEMS_LOWEST_SCORES": "Χαμηλότερες βαθμολογίες",
                "RATER_CATEGORY_DISPLAY_LOGIC": "λογική εμφάνισης κατηγορίας αξιολόγησης",
                "RATIO": "Αναλογία",
                "RECORD": "Εγγραφή",
                "REFERENCE_GROUP": "Ομάδα αναφοράς",
                "RELATIONSHIP": "Σχέση",
                "RELATIONSHIP_FILTERS": "Φίλτρα σχέσης",
                "RELATIONSHIP_FILTERS_INFO": "Για να προσθέσετε ένα φίλτρο σχέσης (όπως άμεσο υφιστάμενο,  συνάδελφο ή προϊστάμενο), επιλέξτε Διαχείριση φίλτρων, και χρησιμοποιήστε Συνθήκη σχέσης μόνο από το αναπτυσσόμενο μενού.",
                "REMOVE": "Κατάργηση",
                "REMOVE_DATA_SOURCE": "Διαγραφή πηγής δεδομένων",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Να θυμάστε ότι υπάρχουν πόροι στον οργανισμό σας που θα σας βοηθήσουν να ερμηνεύσετε τα σχόλιά σας όπως Συνεργάτες HR, ο διευθυντής σας και/ή ο μέντοράς σας.",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Βάλτε ένα φλιτζάνι καφέ και ασχοληθείτε με τα σχόλιά σας.",
                    "ABOUT_YOUR_REPORT_HEADER": "Σχετικά με την αναφορά σας",
                    "ABOUT_YOUR_REPORT_LINE1": "Καλωσορίσατε στην 360 αναφορά σχολίων. Αυτή είναι μια σπουδαία ευκαιρία να αναπτυχθείτε ως επαγγελματίας. Προκειμένου να προετοιμάσετε τον εαυτό σας για την επιτυχία όταν περιηγήστε στα αποτελέσματα, δώστε στον εαυτό σας αρκετό χρόνο για να ασχοληθεί με τα σχόλια. Ο σχολιασμός μπορεί να φαίνεται δύσκολος να τον παρακολουθήσετε στην αρχή αλλά να θυμάστε ότι ο σκοπός του είναι να επιταχύνει την ανάπτυξή σας.",
                    "ABOUT_YOUR_REPORT_LINE2": "Καθώς διαβάζετε την αναφορά σας, ορίστε μερικά πράγματα που πρέπει να θυμάστε.",
                    "ADVANCED_FILTER": "Σύνθετο φίλτρο",
                    "AGREEMENT_CHART": "Διάγραμμα συμβάσεων",
                    "AGREEMENT_CHART_FOOTER": "Το διάγραμμα συμβάσεων υποδεικνύει την ομοιότητα των βαθμολογιών.",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "απαντήσεις",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "απάντηση",
                    "AGREEMENT_CHART_LEGEND_TITLE": "Πώς σας βαθμολόγησαν οι άλλοι",
                    "ALL": "Όλα",
                    "AVERAGE": "Μέσος όρος",
                    "BOTTOM_BOX": "Κάτω πλαίσιο",
                    "CHOICE_COUNT": "Καταμέτρηση επιλογών",
                    "CHOICE_TOTALS": "Σύνολα επιλογών",
                    "COMPARISON": "Σύγκριση",
                    "COMPARISON_GAP_COLUMN_HEADER": "Κενό σύγκρισης",
                    "COMPLETED_RESPONSES": "Συμπληρωμένες απαντήσεις",
                    "COUNT": "Πλήθος",
                    "DEFAULT": "Προεπιλογή",
                    "DEFAULT_TEXT": "Προεπιλεγμένο κείμενο",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "Κατανοήστε από ποιον προέρxονται τα σχόλια, αν είναι από συναδέλφους, άμεσους υφιστάμενους, στελέχη, κλπ",
                    "DIFFERENT_EVALUATORS_HEADER": "Διαφορετικοί αξιολογητές",
                    "DONE": "Ολοκληρώθηκε",
                    "DONT_HEADER": "Δεν πρέπει:",
                    "DONT_LINE1": "Να προσπαθείτε να καταλάβετε ποιος το είπε αυτό",
                    "DONT_LINE2": "Να εστιάσετε σε ένα/μία θετικό/ή ή αρνητικό/ή βαθμολογία/σχόλιο",
                    "DONT_LINE3": "Να δημιουργήσετε ένα πρόγραμμα ανάπτυξης γύρω από κάθε στοιχείο",
                    "DONT_LINE4": "Να αποθαρρύνεστε ότι δεν έχετε ευκαιρίες για βελτίωση",
                    "DO_HEADER": "Πρέπει:",
                    "DO_LINE1": "Να βλέπετε τα σχόλια ολιστικά",
                    "DO_LINE2": "Να προσδιορίζετε θέματα σε δυνατότητες και ευκαιρίες βελτίωσης",
                    "DO_LINE3": "Να προτεραιοποιείτε μερικές περιοχές εστίασης για να τις προσθέσετε στο πρόγραμμα ανάπτυξής σας",
                    "DO_LINE4": "Να κατανοήσετε ότι όλοι έχουν ευκαιρίες για βελτίωση",
                    "FIELD": "Πεδίο",
                    "GAP": "Χάσμα",
                    "GAP_CHART": "Γράφημα χασμάτων",
                    "GAP_CHART_DESCRIPTION": "Το διάγραμμα χασμάτων εμφανίζει τη διαφορά στις βαθμολογίες μεταξύ δύο ομάδων αξιολογητών. Για παράδειγμα, στην περίπτωση των αυτοαξιολογήσεων έν.πώς σας βαθμολόγησαν οι άλλοι, μια θετική(+) διαφορά σημαίνει ότι οι άλλοι σας αξιολόγησαν υψηλότερα απ'ότι εσείς τον εαυτό σας. Μια αρνητική(-) διαφορά σημαίνει ότι οι άλλοι σας βοθμολόγησης χαμηλότερα απ'ότι εσείς τον εαυτό σας.",
                    "GAP_CHART_FOOTER": "Το διάγραμμα χασμάτων υποδεικνύει τη διαφορά +/- μεταξύ δύο ομάδων αξιολογητών.",
                    "GAP_TABLE_DESCRIPTION": "Οι κρυμμένες δυναμικές δείχνουν πότε οι άλλοι σας βαθμολόγησαν υψηλότερα απ'ότι εσείς τον εαυτό σας. Περιοχές για βελτίωση εμφανίζουν πότε οι άλλοι σας βαθμολόγησαν χαμηλότερα απ'ότι εσείς τον εαυτό σε. Και οι δύο τομείς αξιολογήθηκαν από το μεγαλύτερο στο μικρότερο χάσμα.",
                    "GAP_TABLE_FOOTER": "Η πρώτη στήλη βαθμολογιών υποδεικνύει πώς βαθμολογήσατε τον εαυτό σας. Η δεύτερη στήλη υποδεικνύει τη μέση βαθμολογία των άλλων. Η τρίτη στήλη υποδεικνύει τη διαφορά μεταξύ του πώς βαθμολογήσατε τον εαυτό σας και πώς βαθμολόγησαν οι άλλοι εσάς.",
                    "GAP_TABLE_TITLE": "Κρυμμένες δυναμικές/Περιοχές βελτίωσης",
                    "GROUP": "Ομάδα",
                    "HIDE_REPORT_ALERT": "Δεν πληρείτε τις απαιτήσεις εμφάνισης της αναφοράς σας. Απευθυνθείτε στο διαχειριστή του οργανισμού σας.",
                    "HIGHEST_SCORES": "Υψηλότερες βαθμολογίες",
                    "HIGHLOW_TABLE": "Υψηλές και χαμηλές βαθμολογίες",
                    "HIGHLOW_TABLE_FOOTER": "Αυτή η ενότητα δείχνει τις πέντε συμπεριφορές με την υψηλότερη και χαμηλότερη βαθμολογία (σε όλες τις συμπεριφορές) από τους εφαρμοζόμενους μέσους όρους των κατηγοριών βαθμολογητών. Για να αξιοποιήσετε στο έπακρο αυτήν τη σελίδα, είναι χρήσιμο να αναζητείτε τάσεις που μπορεί να παρουσιαστούν. Για παράδειγμα, εάν η πλειονότητα των συμπεριφορών σας με τη χαμηλότερη βαθμολογία είναι συγκεντρωμένη σε μία ή δύο κατηγορίες, αυτοί μπορεί να είναι τομείς που χρειάζονται ανάπτυξη. Οι συμπεριφορές με την υψηλότερη βαθμολογία μπορούν να αναγνωρίσουν ισχυρά σημεία που μπορούν να αξιοποιηθούν σε άλλους τομείς.",
                    "HIGH_LOW_TABLE_DESCRIPTION": "Το διάγραμμα υψηλής/χαμηλής βαθμολογίας εμφανίζει στοιχεία βάσει των περιοχών που σας αξιολόγησαν οι άλλοι υψηλότερα και χαμηλότερα.",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "Πώς να ερμηνεύσετε αποτελέσματα και να καθορίσετε ενέργεια:",
                    "ITEM": "Στοιχείο",
                    "LOWEST_SCORES": "Χαμηλότερες βαθμολογίες",
                    "MAX": "Μέγιστη",
                    "MEAN": "Μεσαία",
                    "MEDIAN": "Διάμεση",
                    "MIN": "Ελάχιστη",
                    "NEGATIVE_GAPS": "Περιοχές για βελτίωση",
                    "NO_COMPARISON_SET": "Χωρίς ρύθμιση σύγκρισης",
                    "NO_DATA_AVAILABLE_WARNING": "Δεν υπάρχουν διαθέσιμα δεδομένα",
                    "NO_FILTER_IS_APPLIED": "Δεν εφαρμόζεται φίλτρο.",
                    "NO_VALUE": "Χωρίς τιμή",
                    "NPS": "Βαθμολογία Θετικής Αξιολόγησης Δικτύου",
                    "OTHERS": "Άλλα",
                    "PERCENTAGE": "Ποσοστό",
                    "PERCENTAGE_OF_CHOICES": "Ποσοστό επιλογών",
                    "PERCENTAGE_OF_RESPONSES": "Ποσοστό απαντήσεων",
                    "PERCENT_COMPLETE": "% συμπληρώθηκε",
                    "POSITIVE_GAPS": "Κρυμμένες δυναμικές",
                    "QUESTIONS": "Ερωτήσεις",
                    "RANK": "Κατάταξη",
                    "RELATIONSHIPS": {
                        "ANYONE": "Οποιοσδήποτε",
                        "DIRECT_REPORT": "Άμεσος υφιστάμενος",
                        "MANAGER": "Διευθυντής",
                        "PEER": "Ομότιμος",
                        "SELF": "Εαυτός"
                    },
                    "REPORT_SUMMARY": "Περίληψη αναφοράς",
                    "REPORT_SUMMARY_TABLE_FOOTER": "Σύγκριση του αριθμού ατόμων που ολοκλήρωσαν την αξιολόγησή σας με τον αριθμό ατόμων που προσκλήθηκαν να συμμετάσχουν.",
                    "REPORT_SUMMARY_TABLE_HEADER": "Στατιστικά στοιχεία ερωτηθέντων",
                    "RESPONSES": "Απαντήσεις",
                    "RESPONSE_COUNT": "{{responseCount}} Απαντήσεις",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Απαντήσεις",
                    "SCORING_CATEGORY": "Κατηγορία βαθμολογίας",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Χωρίς απαντήσεις για αυτή την κατηγορία",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Χωρίς απαντήσεις για αυτήν την ερώτηση",
                    "SCORING_OVERVIEW": "Επισκόπηση βαθμολογίας",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "Εσείς και οι αξιολογητές σας πιστεύετε ότι αυτή η περιοχή είναι κορυφαίας δυναμικής.",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Αναγνωρισμένη ισχύς",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Μια αναγνωρισμένη περιοχή βελτίωσης έχει την έννοια ότι οι αυτο-αξιολογήσεις και κριτικές από άλλους είναι κάτω από το μέσο όρο για αυτή την ικανότητα.",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Αναγνωρισμένη περιοχή βελτίωσης",
                    "SCORING_OVERVIEW_DESCRIPTION": "Παραπάνω βρίσκονται οι ικανότητες ή οι συμπεριφορές που τις οποίες αξιολογηθήκατε ως μέρος αυτής της διαδικασίας αξιολόγησης από πολλούς αξιολογητές. Η σύγκριση των κατατάξεων παρέχεται κατά ομάδα.",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "Ελάχιστο χάσμα",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Ελάχιστη διαφορά μεταξύ ομάδων αναφοράς για κείμενα προς εμφάνιση.",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "Εμφανίζεται στο εύρος των βαθμολογιών για κάθε ικανότητα/συμπεριφορά. Η γραμμή αναπαραριστά τον αριθμητικό μέσο όρο.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Μη προσδιορισμένη δυναμική προέρχεται από ασυμφωνία μεταξύ της αυτοαξιολόγησης και των αξιολογήσεων από άλλους.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Μη προσδιορισμένη δυναμική",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Η μη αναγνωρισμένη περιοχή βελτίωσης προέρχεται από κάποια διαφορά μεταξύ της αυτο-αξιολόγησης και της κριτικής που προέρχεται από τρίτους.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Μη αναγνωρισμένη περιοχή βελτίωσης",
                    "SELF": "Εαυτός",
                    "SELF_ASSESSMENT": "Αυτοεκτίμηση",
                    "STANDARD_DEVIATION": "Τυπική απόκλιση",
                    "SUM": "Άθροισμα",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Εξοικειωθείτε με την κλίμακα αξιολογήσεων για να διασφαλίσετε την ακριβή ερμηνεία",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "Σημειώστε την κλίμακα",
                    "THINGS_YOU_WILL_SEE_HEADER": "Τι θα δείτε:",
                    "THREE_SIXTY_PERCENTILE": "Εκατοστημόριο",
                    "TOP_BOTTOM_BOX": "Επάνω πλαίσιο / Κάτω πλαίσιο",
                    "TOP_BOX": "Άνω πλαίσιο",
                    "TOTAL": "Σύνολο",
                    "TO_DO": "Εκκρεμής εργασία",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Ποιοτικό: Αυτό το σχόλιο θα βρίσκεται στη φόρμα των εκκρεμών σχολίων κειμένου",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Ποσοτικό: Αυτό το σχόλιο θα είναι αριθμητικό, και θα αναπαρίσταται σε γραφήματα, ραβδογράμματα, πίνακες, κλπ",
                    "TYPES_OF_FEEDBACK_HEADER": "Διάφοροι τύποι σχολίου",
                    "VALUE": "Τιμή",
                    "VARIANCE": "Απόκλιση",
                    "YOUR_RATINGS": "Οι αξιολογήσεις σας"
                },
                "REPORT_SUMMARY": "Περίληψη αναφοράς",
                "REPORT_SUMMARY_TABLE_FOOTER": "Σύγκριση του αριθμού ατόμων που ολοκλήρωσαν την αξιολόγησή σας με τον αριθμό ατόμων που προσκλήθηκαν να συμμετάσχουν.",
                "REPORT_SUMMARY_TABLE_HEADER": "Στατιστικά στοιχεία ερωτηθέντων",
                "RESET": "Επαναφορά",
                "RESPONDENT_TOTALS": "Σύνολα απαντώντων",
                "RESPONSES": "Απαντήσεις",
                "RESPONSE_COUNT": "{{responseCount}} Απαντήσεις",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Απαντήσεις",
                "RESULT": "Αποτέλεσμα",
                "REVERSE_COLORS": "Αντίστροφα χρώματα",
                "ROW_TOTALS": "Σύνολα γραμμών",
                "SAVE": "Αποθήκευση",
                "SAVE_AND_APPLY": "Αποθήκευση και εφαρμογή",
                "SCORING_CATEGORY": "Κατηγορία βαθμολογίας",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Χωρίς απαντήσεις για αυτή την κατηγορία",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Χωρίς απαντήσεις για αυτήν την ερώτηση",
                "SCORING_OVERVIEW": "Επισκόπηση βαθμολογίας",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "Εσείς και οι αξιολογητές σας πιστεύετε ότι αυτή η περιοχή είναι κορυφαίας δυναμικής.",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Αναγνωρισμένη ισχύς",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Μια αναγνωρισμένη περιοχή βελτίωσης έχει την έννοια ότι οι αυτο-αξιολογήσεις και κριτικές από άλλους είναι κάτω από το μέσο όρο για αυτή την ικανότητα.",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Αναγνωρισμένη περιοχή βελτίωσης",
                "SCORING_OVERVIEW_DESCRIPTION": "Παραπάνω βρίσκονται οι ικανότητες ή οι συμπεριφορές που τις οποίες αξιολογηθήκατε ως μέρος αυτής της διαδικασίας αξιολόγησης από πολλούς αξιολογητές. Η σύγκριση των κατατάξεων παρέχεται κατά ομάδα.",
                "SCORING_OVERVIEW_MINIMUM_GAP": "Ελάχιστο χάσμα",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Ελάχιστη διαφορά μεταξύ ομάδων αναφοράς για κείμενα προς εμφάνιση.",
                "SCORING_OVERVIEW_TABLE_FOOTER": "Εμφανίζεται στο εύρος των βαθμολογιών για κάθε ικανότητα/συμπεριφορά. Η γραμμή αναπαριστά τον αριθμητικό μέσο όρο.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Μη προσδιορισμένη δυναμική προέρχεται από ασυμφωνία μεταξύ της αυτοαξιολόγησης και των αξιολογήσεων από άλλους.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Μη προσδιορισμένη δυναμική",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Η μη αναγνωρισμένη περιοχή βελτίωσης προέρχεται από κάποια διαφορά μεταξύ της αυτο-αξιολόγησης και της κριτικής που προέρχεται από τρίτους.",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Μη αναγνωρισμένη περιοχή βελτίωσης",
                "SELECT_CATEGORIES": "Παρακαλούμε επιλέξτε κατηγορίες βαθμολόγησης...",
                "SELECT_CATEGORY": "Παρακαλούμε επιλέξτε κατηγορία βαθμολόγησης...",
                "SELECT_CONDITION_TYPE": "Επιλογή τύπου συνθήκης",
                "SELECT_DATA_SOURCE": "Επιλογή πηγής δεδομένων",
                "SELECT_DATA_SOURCE_TYPE": "Επιλέξτε τύπο πηγής δεδομένων",
                "SELECT_FILTER": "Επιλογή φίλτρου",
                "SELECT_FILTERS": "Επιλογή φίλτρων",
                "SELECT_OPERATOR_TYPE": "Επιλογή τύπου τελεστή",
                "SELECT_PERSON": "Επιλογή ατόμου",
                "SELECT_PERSON_METADATA": "Επιλέξτε τα μεταδεδομένα του ατόμου",
                "SELECT_QUESTION": "Επιλογή ερώτησης",
                "SELECT_QUESTIONS": "Παρακαλούμε επιλέξτε ερωτήσεις...",
                "SELECT_RATIO_OR_DROPOFF": "Επιλέξτε αναλογία ή απόθεση",
                "SELECT_RELATIONSHIP": "Επιλογή σχέσης",
                "SELECT_SCORING_CATEGORY": "Επιλογή κατηγορίας βαθμολογίας",
                "SELF": "Εαυτός",
                "SELF_ASSESSMENT": "Αυτοεκτίμηση",
                "SEQUENTIAL": "Διαδοχικό",
                "SETUP_COMPARISON": "Διαμόρφωση σύγκρισης",
                "SETUP_COMPARISONS": "Διαμόρφωση συγκρίσεων",
                "SET_START_COLOR": "Ρύθμιση χρώματος έναρξης",
                "SHOULD_SHOW_FOOTER": "Εμφάνιση υποσέλιδου",
                "SHOULD_SHOW_SCORING_CATEGORY": "Εμφάνιση Κατηγορίας Βαθμολογίας",
                "SHOWING_RECORDS_OF": "Εμφάνιση εγγραφών %1 - %2 από %3",
                "SHOW_COMPARISON_GAP": "Εμφάνιση στήλης απόκλισης σύγκρισης",
                "SHOW_DATA_LABEL": "Εμφάνιση τιμών δεδομένων",
                "SHOW_PERCENTAGES": "Εμφάνιση ποσοστών",
                "SHOW_THE_FOLLOWING_TEXT": "Στη συνέχεια εμφάνιση του εξής κειμένου",
                "SHOW_TIES": "Εμφάνιση ισοψηφιών",
                "SHOW_X_AXIS": "Εμφάνιση άξονα X",
                "SHOW_Y_AXIS": "Εμφάνιση άξονα Y",
                "SMALL_LABELS": "Μικρές ετικέτες",
                "SORT": "Ταξινόμηση",
                "SPLINE": "Καμπύλη",
                "STACK_CHART": "Διάγραμμα στοίβας",
                "STANDARD_DEVIATION": "Τυπική απόκλιση",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "Αδυναμία μικρότερη από",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "Επεξεργασία κειμένων ορίου",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "Κείμενα ορίου",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "Ενεργοποίηση κειμένων ορίου",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "Δυναμική μεγαλύτερη από",
                "SUM": "Άθροισμα",
                "SUMMARY": "Σύνοψη",
                "TABLES": "Πίνακες",
                "TABLE_TOTALS": "Σύνολα πινάκων",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Εξοικειωθείτε με την κλίμακα αξιολογήσεων για να διασφαλίσετε την ακριβή ερμηνεία",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "Σημειώστε την κλίμακα",
                "TEXT": "Κείμενο",
                "THINGS_YOU_WILL_SEE_HEADER": "Τι θα δείτε:",
                "TOP_BOTTOM_BOX": "Επάνω πλαίσιο / Κάτω πλαίσιο",
                "TOP_BOX": "Άνω πλαίσιο",
                "TOTAL": "Σύνολο",
                "TOTAL_COUNTS": "Συνολικοί αριθμοί",
                "TO_DO": "Εκκρεμής εργασία",
                "TRANSPOSE": "Αντιμετάθεση",
                "TRANSPOSE_TABLE": "Αντιμετάθεση πίνακα",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Ποιοτικό: Αυτό το σχόλιο θα βρίσκεται στην φόρμα των εκκρεμών σχολίων κειμένου",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Ποσοτικό: Αυτό το σχόλιο θα είναι αριθμητικό, και θα αναπαρίσταται σε γραφήματα, ραβδογράμματα, πίνακες, κλπ",
                "TYPES_OF_FEEDBACK_HEADER": "Διάφοροι τύποι σχολίου",
                "UNDO": "Αναίρεση",
                "USE_COMPARISON": "Χρήση σύγκρισης",
                "USE_LABELS_FOR_SCALES": "Χρήση ετικετών για κλίμακες",
                "VALUES": "Τιμές",
                "VALUE_RANGES": "Εύρη τιμών",
                "VARIANCE": "Απόκλιση",
                "VERTICAL": "Κάθετα",
                "VERTICAL_RANGE": "Κάθετο εύρος",
                "WARNING_DATA_OUT_OF_RANGE": "Προειδοποίηση: η τιμή δεδομένων υπερβαίνει τη ρύθμιση παραμέτρων εύρους",
                "WIDGET_ERROR": {
                    "ERROR": "Παρουσιάστηκε μη αναμενόμενο σφάλμα",
                    "MISCONFIGURED": "Το γραφικό στοιχείο δεν έχει ρυθμιστεί σωστά. Ελέγξτε τη ρύθμιση παραμέτρων του γραφικού στοιχείου σας.",
                    "NEW": "Διαμορφώστε γραφικό στοιχείο",
                    "NO_DATA": "Δεν βρέθηκαν δεδομένα - τα φίλτρα σας μπορεί να είναι πολύ περιοριστικά!"
                },
                "WIDGET_NAME": {
                    "BAR": "Ραβδόγραμμα",
                    "BREAKDOWNBAR": "Ράβδος αναλυτικής παρουσίασης",
                    "DATA_TABLE": "Πίνακας δεδομένων",
                    "FUNNEL_CHART": "Γράφημα Ομαδοποίησης",
                    "GAUGE": "Συνδυασμένο διάγραμμα δακτυλίου-πίτας",
                    "GRID": "Πίνακας αποτελεσμάτων",
                    "HEATMAP": "Χάρτης θερμότητας",
                    "LINE": "Γραμμικό διάγραμμα",
                    "NEEDS_BASED": "Βάσει Αναγκών",
                    "PIE": "Διάγραμμα πίτας",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "Υπεύθυνος Υπολογισμού Τιμής (Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "Υπεύθυνος Μεγιστοποίησης Εσόδων (Gabor Granger)",
                    "SCORING_OVERVIEW_CHART": "Διάγραμμα",
                    "SCORING_OVERVIEW_TABLE": "Πίνακας",
                    "STATS_TABLE": "Πίνακας στατιστικών στοιχείων",
                    "WORDCLOUD": "Σύννεφο λέξεων"
                },
                "WORD_ROTATION": "Εναλλαγή λέξεων",
                "WORD_SPACING": "Διάκενο λέξεων",
                "YES": "Ναι",
                "YOUR_RATINGS": "Οι αξιολογήσεις σας"
            },
            "WORDCLOUDWIDGET": {},
            "TEXTHIGHLIGHTSWIDGET": {},
            "STATSTABLEWIDGET": {},
            "SOURCECONFIGDEP": {},
            "SIMPLETABLEWIDGET": {},
            "BARCHARTWIDGET": {},
            "PIEWIDGET": {},
            "PAGINATEDTABLEWIDGET": {},
            "LINECHARTWIDGET": {},
            "HEATMAPWIDGET": {},
            "GAUGEWIDGET": {},
            "BREAKDOWNBARWIDGET": {}
        });
        $cache.put('EN-GB', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "Access Code",
                "ACCESS_CODE_PROTECTION": "Access Code Protection",
                "ADD": "Add",
                "ADD_BREAKOUT": "Add Report Breakout",
                "ADD_NOTE": "Add Note",
                "ADD_SCHEDULED_REPORT": "Add Scheduled Report",
                "ADD_WIDGET": "Add Visualisation",
                "ALL_PROJECTS": "All Projects",
                "ALL_QUESTIONS": "Question Pages",
                "ANSWER": "Answer",
                "ANY_CHANGES_LOST": "Any changes to reports will be lost if you leave the Qualtrics XM Platform.",
                "APPENDED_COPY_IN_PARENS": "(Copy)",
                "AREA_CHART": "Area Chart",
                "AREA_CHART_DESC": "A two-axis line chart with the area under the line filled in.",
                "ATTACHMENT": "Attachment",
                "BACKUP_CURRENT_REPORT": "Save a back-up copy of this report before affecting the visualisations",
                "BACKUP_CURRENT_REPORT_LINE2": "Note: The back-up copy will be named '{{nameOfReportCopy}}'",
                "BACK_TO_REPORTS": "Back to Reports",
                "BACK_TO_TOP": "Back to Top",
                "BACK_TO_VIEW_RESULTS": "Back to old view results",
                "BAR_CHART": "Bar Chart",
                "BAR_CHART_DESC": "A two-axis bar chart that allows additional configuration such as axis transposition and rearrangement of data points.",
                "BREAKDOWN_BAR_CHART": "Breakdown Bar",
                "BREAKDOWN_BAR_CHART_DESC": "A horizontal stacked bar chart most commonly used for visually weighing metrics against each other as an alternative to a pie chart.",
                "CANCEL": "Cancel",
                "CANCEL_CONF_TEXT": "Are you sure you want to cancel?<br/>All changes will be lost.",
                "CANCEL_EDITS": "Cancel Edits",
                "CHART": "Chart",
                "CHOICE": "Choice",
                "CHOICES_COUNT_METRIC": "Choices Count",
                "CHOOSE_PAGES_TO_DISPLAY": "Choose Pages to Display",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "This report contains {{maxReportPageCount}} pages, but Results can only contain up to {{reportSizeLimit}}. Please select a subset within the limit.",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "Reports can only contain up to {{reportSizeLimit}} pages, please select the pages you would like.",
                "CLEAR_ALL": "Clear All",
                "CLOSE": "Close",
                "CLOUD": "A DESCRIPTION FOR CLOUD",
                "COLLABORATED_NEW": "The owner of this survey is using the Qualtrics XM Platform! Reports for this survey will be edited using New Results.",
                "COMMA_SEPARATED_LIST": "Comma-Separated List",
                "COMPACTNESS": "Fonts and Spacing",
                "COMPACTNESS_INFO": "This setting affects table padding, font size and bar size in charts. It will also be applied to most exports.",
                "CONFIRM": "OK",
                "CONFIRM_DELETE": "Confirm Deletion",
                "CONFIRM_DELETE_PAGE": "Are you sure you want to delete this page?",
                "CONTINUE": "Continue",
                "CONTINUE_EDITING": "Continue Editing",
                "COPY": "Copy",
                "COPY_OF_REPORT_NAME": "Copy of {{nameOfCurrentReport}}",
                "COPY_REPORT": "Copy Report",
                "COPY_REPORT_ELLIPSIS": "Copy Report...",
                "COPY_TO_NEW_REPORT": "Copy to New Report...",
                "CREATE": "Create",
                "CREATED": "Created",
                "CREATE_CUSTOM_PAGE": "Create Custom Page",
                "CREATE_NEW_REPORT": "Create New Report",
                "CREATE_NEW_REPORT_ELLIPSIS": "Create New Report...",
                "CSV_FILE": "CSV File",
                "CUSTOM_PAGES": "Custom Pages",
                "DATE": "Date",
                "DEFAULT_PALETTE": "Default Colour Palette",
                "DEFAULT_REPORT": "Default Report",
                "DEFAULT_VISUALIZATIONS": "Default Visualisations",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "These are the default visualisation types used to construct default results reports. Updating and applying these settings will rebuild your current report with the new default settings. You will have the option to back up your current report.",
                "DEFAULT_VISUALIZATIONS_NOTE": "Note: Not every visualisation type is available for all question types. Some non-default visualisations may automatically be substituted.",
                "DEFAULT_VISUALS_DISCLAIMER": "Qualtrics will update this report with the new default visualisation settings.",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "This update will affect {{amountOfWidgetsAffected}} visualisations in this report.",
                "DEFAULT_VISUAL_EDIT_DETECTED": "Default Visualisation Edit Detected",
                "DELETE_BUTTON": "Delete",
                "DELETE_DISABLED_EXPLANATION": "Deleting reports created in the previous reporting interface is not allowed until your organisation has performed a full migration to the Qualtrics XM Platform.",
                "DELETE_PAGE": "Delete Page",
                "DELETE_PAGE_ELLIPSIS": "Delete Page...",
                "DELETE_REPORT": "Delete Report",
                "DELETE_REPORT_ELLIPSIS": "Delete Report...",
                "DELETE_WIDGET_QUESTION": "Delete?",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "This field is encrypted and cannot be used for sorting.",
                "DISCARD_EDITS": "Discard Edits",
                "DISTRIBUTION_PAUSED": "Report distribution paused.",
                "DONE_BUTTON": "Done",
                "DONE_EDITING": "Finished Editing",
                "DOWNLOAD": "Download",
                "DOWNLOAD_AS_CSV": "Download as CSV",
                "DOWNLOAD_AS_PDF": "Download as PDF",
                "DOWNLOAD_FAILED": "Download failed",
                "DOWNLOAD_PREVIOUS_EXPORTS": "Download Previous Exports...",
                "DO_YOU_WISH_TO_DELETE": "Do you want to delete:",
                "DUPLICATE_PAGE": "Duplicate Sheet",
                "EDIT_REPORT": "Edit Report",
                "EDIT_REPORT_ELLIPSIS": "Edit Report...",
                "EDIT_VISUALIZATION": "Edit Visualisation",
                "EMAIL_ADDRESS": "Email Address",
                "EMAIL_SENT": "Email sent...",
                "END_OF_REPORT": "End of Report",
                "ENTER_NAME": "Enter Name",
                "ERROR_COPYING": "There was an error copying the report.",
                "ERROR_DELETING": "There was an error deleting the report.",
                "ERROR_DELETING_EXPORT": "There was an error deleting the export.",
                "ERROR_HEADING": "Error",
                "ERROR_PUBLISHING": "There was an error saving the settings.",
                "ERROR_RENAMING": "There was an error renaming the report.",
                "ERROR_REQUESTING_EXPORT": "There was an error requesting the export.",
                "ERROR_SAVING_GLOBAL_OPTIONS": "There was an error saving global visualisation options.",
                "ERROR_SEND_TEST_EMAIL": "There was an error sending the test email.",
                "EVERY_FRIDAY": "Every Friday",
                "EVERY_MONDAY": "Every Monday",
                "EVERY_MONTH": "Monthly on",
                "EVERY_SATURDAY": "Every Saturday",
                "EVERY_SUNDAY": "Every Sunday",
                "EVERY_THURSDAY": "Every Thursday",
                "EVERY_TUESDAY": "Every Tuesday",
                "EVERY_WEDNESDAY": "Every Wednesday",
                "EVERY_WEEK": "Weekly every",
                "EXAMPLE_GROUP_NUM": "Group {{num}}",
                "EXAMPLE_SERIES_NUM": "Series {{num}}",
                "EXPORT": "Export",
                "EXPORT_CSV": "CSV (Comma Separated)",
                "EXPORT_EXCEL_SPREADSHEET": "Excel Spreadsheet",
                "EXPORT_IMAGE": "Export Image",
                "EXPORT_PAGES": "Export Pages",
                "EXPORT_PDF": "PDF Document",
                "EXPORT_PPT_SLIDES": "PowerPoint Slides",
                "EXPORT_RAW_DATA": "Export Raw Data",
                "EXPORT_REPORT": "Export Report",
                "EXPORT_VISUALIZATION": "Export Visualisation",
                "EXPORT_WORD_DOC": "Word Document",
                "FAILED_SAVE_TXT": "Failed to save",
                "FILTERED": "Filtered",
                "FIRST_PAGE": "First Page",
                "FIRST_WEEKDAY": "First Weekday of Month",
                "FROM": "From",
                "FROM_EMAIL": "From Email",
                "FROM_NAME": "From Name",
                "GAUGE_CHART": "Gauge Chart",
                "GAUGE_CHART_DESC": "A chart resembling a gauge measurement tool for comparing current values to a goal or series of thresholds.",
                "GENERATING_FILE": "Generating file...",
                "GENERATING_IMAGE": "Generating Image...",
                "GENERATING_PDF": "Generating PDF...",
                "GENERIC_ERROR": "An error prevented us from loading the project you requested.",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "Global Options...",
                "GLOBAL_METRIC": "Default Metric",
                "GLOBAL_MODAL_PAGE_TITLE": "Example visualisation using the global options for the Results section of the Qualtrics Research Suite",
                "GLOBAL_MODAL_WIDGET_TITLE": "Visualisation Title",
                "GLOBAL_OPTIONS": "Global Options",
                "GLOBAL_PRECISION": "Default Decimal Places",
                "GLOBAL_SETTINGS_APPLY": "Apply my default settings",
                "GLOBAL_SETTINGS_SAVE": "Save as my default settings",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "Apply Qualtrics default",
                "GROUP": "Group",
                "HEAT_MAP_CHART": "Heat Map Chart",
                "HEAT_MAP_CHART_DESC": "A clustered 'heat' style visualisation used for mapping distribution of user input (such as clicks) to the original image.",
                "HIDDEN": "Hidden",
                "HIDDEN_PAGE": "This page will not appear in public reports and will be deselected by default in report exports.",
                "HIDE": "Hide",
                "HIDE_ALL_PAGES": "Hide All Pages",
                "HIDE_PAGE": "Hide Page",
                "IMAGE_FILE": "Image File",
                "INVALID_BRAND_DOMAIN": "The domain you have entered is not in your brand's list of approved email domains. Please contact your brand admin to fix.",
                "INVALID_SPF_RECORD": "The domain you have entered has not approved Qualtrics to send from it. This will affect deliverability. Please use another domain or contact Qualtrics about resolving this issue.",
                "ISSUE_SAVING_REPORTS": "One or more reports encountered a problem saving. Please try again.",
                "ISSUE_SENDING_TEST": "There was an error sending a test email. Please try again.",
                "LARGE_SURVEY": "Results will not be displayed because the survey is too large.",
                "LAST_DAY": "Last Day of Month",
                "LAST_MODIFIED_COLON_WITH_DATE": "Last Modified: %1",
                "LAST_PAGE": "Last Page",
                "LAST_WEEKDAY": "Last Weekday of Month",
                "LATER": "Later",
                "LEARN_MORE": "Learn More",
                "LINE_CHART": "Line Chart",
                "LINE_CHART_DESC": "A two-axis line chart commonly used when graphing against time on the x-axis.",
                "LOG_OUT_WARNING": "Click anywhere within {{countdown}} seconds to remain logged in",
                "MESSAGE": "Message",
                "MONTHLY": "Monthly",
                "MOVE_DOWN": "Move Visualisation Down",
                "MOVE_PAGE_TO_BOTTOM": "Move to Bottom",
                "MOVE_PAGE_TO_TOP": "Move to Top",
                "MOVE_UP": "Move Visualisation Up",
                "MY_SURVEYS": "My Projects",
                "NAME": "Name",
                "NEW_CUSTOM_PAGE_NAME": "New Custom Page",
                "NEW_REPORT": "New Report",
                "NEXT_PAGE": "Next Page",
                "NEXT_RUN": "Next Run",
                "NO_EXPORTS": "No exports have been requested for this report yet.",
                "NO_ITEMS_TO_DISPLAY": "No items to display",
                "NO_MATCHING_CUSTOM_PAGES": "No matching custom pages",
                "NO_MATCHING_PAGES": "No pages found for search",
                "NO_MATCHING_REPORTS": "No matching reports.",
                "NO_PROJECT": "Please specify a project to continue.",
                "NO_PROJECTS_TO_MIGRATE": "There are no projects to update.",
                "NO_QUESTIONS": "No matching questions",
                "NO_RESULTS_YET": "There are no results to show yet. Please distribute your survey to gather responses.",
                "OFF": "Off",
                "ON": "On",
                "PAGES_SELECTED": "Pages Selected",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "This selection would make the report contain {{currentSelectedPageCount}} pages, which is above the {{reportSizeLimit}} maximum allowed. Please select a smaller range.",
                "PAGES_SELECTION_INVALID_RANGE": "Please select a valid range.",
                "PAGE_OPTIONS": "Page Options",
                "PDF_ROW_TRUNCATION_MESSAGE": "Too many rows for PDF export, try exporting to Word or CSV",
                "PERCENTAGE_METRIC": "Percentage",
                "PIE_CHART": "Pie Chart",
                "PIE_CHART_DESC": "A circular breakdown of values for a given data point. Useful for measuring relative proportions of selected values.",
                "PREVIEW": "Preview",
                "PREVIOUS_PAGE": "Previous Page",
                "PRINT_PAGE": "Print Page",
                "PUBLIC_LINK": "Public Link",
                "PUBLIC_REPORT_AVAILABLE": "Public Report Available",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "Access Code",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "Incorrect Access Code. Please try again.",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "Submit",
                "PUBLIC_RESULTS_LOGIN_TITLE": "Public Report Login | Qualtrics Survey Software",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "Public report not found. Please contact the owner of this report and ask them for a valid link.",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "Public Report Not Found",
                "PUBLIC_RESULTS_NOT_UPDATED": "Public report links and scheduled report emails will not use the Qualtrics XM Platform until you update them.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "Session Expired. Please log in again to continue previewing Public Results Report.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "Session Expired",
                "PUBLIC_RESULTS_TITLE": "Public Report",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "You are not authorised to view this page. Please contact the owner of this report and ask them to make it public.",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "Public Report Unauthorised",
                "PUBLISHED_LINK_GENERATING_LINK": "Generating Link...",
                "PUBLISHED_REPORT_FOUND_HERE": "Anyone can view this report at the following link:",
                "PUBLISH_REPORT": "Manage Public Report",
                "PUBLISH_REPORT_ELLIPSIS": "Manage Public Report...",
                "QUESTION": "Question",
                "RANK": "Rank",
                "REMOVE_WIDGET": "Remove Visualisation",
                "RENAME_PAGE": "Rename Page",
                "RENAME_REPORT": "Rename Report",
                "RENAME_REPORT_ELLIPSIS": "Rename Report...",
                "REPLY_TO_EMAIL": "Reply-To Email",
                "REPORT_COLON": "Report:",
                "REPORT_SETTINGS": "Report Settings",
                "REPORT_SETTINGS_ELLIPSIS": "Report Settings...",
                "RESPONSE_COUNTS": "Response Counts",
                "RESULTS_DASHBOARDS_BANNER": "and try new, improved version of survey results, featuring modern, accessible UI and data visualisations, new analysis and exploration features, and more.",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "Release Notes",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "View the latest",
                "RESULTS_OPTIONS": "Report Options",
                "RESULTS_TITLE": "Report",
                "RESUME_DISTRIBUTION": "Resume Distribution",
                "REVERT": "Revert",
                "RICH_TEXT_LIMIT_REACHED": "Content length has reached the limit!",
                "SAVE": "Save",
                "SAVE_AND_CLOSE": "Save and Close",
                "SAVE_AS_CSV": "Save Visualisation as CSV",
                "SAVE_AS_IMAGE": "Save Visualisation as Image",
                "SAVE_CONFIRMATION": "Save Confirmation",
                "SAVE_PAGE_AS_ELLIPSIS": "Export Page As...",
                "SAVE_SETTINGS": "Save Settings",
                "SCHEDULE_REPORT_EMAIL": "Schedule Report Email",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "Schedule Report Email...",
                "SEARCH_ELLIPSIS": "Search...",
                "SEARCH_PAGES": "Search Questions",
                "SEARCH_PAGES_ELLIPSIS": "Search Pages...",
                "SEARCH_REPORTS_ELLIPSIS": "Search Reports...",
                "SELECTED": "Selected:",
                "SELECT_ALL": "Select All",
                "SELECT_A_FIELD": "Select a field",
                "SELECT_A_WIDGET": "Select a visualisation",
                "SELECT_PAGES": "Select Pages",
                "SELECT_PAGES_ELLIPSIS": "Select Pages...",
                "SEND": "Send",
                "SEND_TEST_EMAIL": "Send Test Email",
                "SETTING_DEFAULT": "Default",
                "SETTING_HIGH": "High",
                "SETTING_LARGE": "Large",
                "SETTING_LOW": "Low",
                "SETTING_NORMAL": "Normal",
                "SETTING_SMALL": "Small",
                "SHARE_REPORT": "Share Report",
                "SHOW_ALL_PAGES": "Show All Pages",
                "SHOW_FULL_QTEXT": "Show full question text in page titles",
                "SIMPLE_TABLE": "Simple Table",
                "SIMPLE_TABLE_DESC": "A flexible table that can show multiple values as rows or columns.",
                "SIZE": "Size",
                "SPLINE_CHART": "Spline Chart",
                "SPLINE_CHART_DESC": "A two-axis rounded line chart commonly used when graphing against time on the x-axis.",
                "STATISTICS_TABLE": "Statistics Table",
                "SUBJECT": "Subject",
                "SURVEY_ANALYSIS": "Survey Analysis",
                "SURVEY_SUMMARY": "Survey Summary",
                "TABLE": "A DESCRIPTION FOR TABLE",
                "TIME": "Time",
                "TO": "To",
                "TOTAL": "Total",
                "TRANSPOSE_STATS_TABLES": "Transpose Stats Tables",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "Transpose Stats Table Breakouts",
                "TRUNCATE_PAGE_TITLES": "Truncate question text in page titles",
                "TRY_IT_NOW": "Try it now",
                "TYPE": "Type",
                "UNABLE_TO_CHECK_SPF": "Unable to check the SPF record. Please try again.",
                "UNAUTHORIZED": "You are not allowed to view this report. Please contact the owner for access.",
                "UNHIDE_PAGE": "Unhide Page",
                "UPDATE": "Update",
                "UPDATED_SUCCESSFULLY": "Updated Successfully.",
                "UPDATE_ALL_IN_THIS_PROJECT": "Update All in this Project",
                "UPDATE_ALL_PROJECTS": "Update All Projects",
                "UPDATE_NOW": "Update Now",
                "UPDATE_REPORTS": "Update Reports...",
                "UPDATE_REPORT_ELEMENTS": "Update Public Report Links and Scheduled Report Emails",
                "UPGRADE_MY_ACCOUNT": "Upgrade My Account",
                "USE_EXPORT_TAGS": "Include question numbers",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "Use Simple Table Column Totals",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "Use Simple Table Respondent Counts",
                "USE_WEIGHTED_METRICS": "Use weighted metrics",
                "VIEW": "View",
                "WEEKLY": "Weekly",
                "WELCOME_TO_NEW_RESULTS": "Welcome to Qualtrics XM Platform Reporting!",
                "WHEN": "When",
                "WIDGET_LOADING": "Loading...",
                "WIDGET_OPTIONS_ERR": "Failed to load visualisation options",
                "WIDGET_TYPE": "Visualisation",
                "WORD_CLOUD": "Word Cloud",
                "WORD_CLOUD_DESC": "A weighted visualisation of word frequency in text data with additional colour-coding options."
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Remember, there are resources within your organisation to help you interpret your feedback, such as HR Partners, your manager and/or a mentor.",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Pour yourself a cup of coffee and dive into your feedback.",
                "ABOUT_YOUR_REPORT_HEADER": "About your report",
                "ABOUT_YOUR_REPORT_LINE1": "Welcome to your 360 feedback report. This is a great opportunity to grow and develop yourself as a professional. In order to set yourself up for success when going through results, allow yourself sufficient time to go over the feedback. Feedback can be difficult to hear initially, but keep in mind that the purpose of this feedback is to accelerate your growth and development.",
                "ABOUT_YOUR_REPORT_LINE2": "As you go through your report, here are a few things to keep in mind.",
                "ADD_CONDITIONAL_TEXT": "Add conditional text",
                "ADD_CUSTOM_PALETTE": "Add Custom Palette",
                "ADD_DATA_SOURCE": "Add data source",
                "ADD_FOLLOWING": "Add following",
                "ADD_LABEL": "Add label",
                "ADVANCED_FILTER": "Advanced Filter",
                "AGREEMENT_CHART": "Agreement chart",
                "AGREEMENT_CHART_FOOTER": "The agreement chart indicates the similarity of scores. Each dot represents how individuals rated you for each item. The size of the dot shows how many raters gave you a specific rating.",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "responses",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "response",
                "AGREEMENT_CHART_LEGEND_TITLE": "How others rated you",
                "ALL": "All",
                "AND_IF": "And if",
                "ANGLED": "Angled",
                "AREA": "Area",
                "AUTO": "Auto",
                "AVERAGE": "Average",
                "AXIS_VALUES": "Axis Values",
                "BAR": "Bar",
                "BASE_WORD_COLOR": "Base Word Colour",
                "BLUR": "Blur",
                "BOTTOM_BOX": "Bottom Box",
                "BREAKOUT_HEADERS": "Breakout Headers",
                "CANCEL": "Cancel",
                "CATEGORICAL": "Categorical",
                "CATEGORY": "Category",
                "CATEGORY_NAME": "Category Name",
                "CHANGE_CATEGORIES_ORDER": "Change categories order",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "Change the scoring categories order",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "Change the order that appears in the visualisation by clicking on the left of the scoring category element and dragging it to its desired position.",
                "CHANGE_QUESTIONS_ORDER": "Change questions order",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "Change the questions order",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "Change the order that appears in the visualisation by clicking on the left of the question element and dragging it to its desired position.",
                "CHARTS": "Charts",
                "CHART_TYPE": "Chart Type",
                "CHOICE_COUNT": "Choice Count",
                "CHOICE_TOTALS": "Choice Totals",
                "CLEAR": "Clear",
                "CLOSE": "Close",
                "COLOR_PALETTE": "Colour Palette",
                "COLUMN_NAMES": "Column Names",
                "COLUMN_TOTALS": "Column Totals",
                "COMPARED_FILTER_GROUP": "Compared Filter Group",
                "COMPARED_FILTER_GROUPS": "Compared Filter Groups",
                "COMPARE_WITH": "compare with",
                "COMPETITION_RANKING": "Use competition ranking",
                "COMPETITION_RANKING_TOOLTIP": "In the event of a tie, all equal scores are given the same ranking. However, the next subsequent Item will be ranked equal to: the total number of Items ranked higher in the table, plus one.",
                "COMPLETED_RESPONSES": "Completed responses",
                "CONDITIONAL_TEXT": "Conditional text",
                "COUNT": "Count",
                "CREATE": "Create",
                "CUSTOM_PALETTE": "Custom Palette",
                "DATA_SOURCE_TYPE": "Data Source Type",
                "DATA_SOURCE_TYPE_CATEGORY": "Scoring Categories",
                "DATA_SOURCE_TYPE_QUESTION": "Questions",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "Question",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "Rankable Items",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "Scoring Category",
                "DEFAULT": "Default",
                "DEFAULT_TEXT": "Default text",
                "DELETE": "Delete",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "Understand who your feedback is coming from, whether it’s peers, direct reports, leaders, etc",
                "DIFFERENT_EVALUATORS_HEADER": "Different evaluators",
                "DIRECT_REPORTS": "Direct reports",
                "DISABLED": "Disabled",
                "DISPLAY_OPTIONS": "Display Options",
                "DISPLAY_THRESHOLD_TEXTS": "Display text based on the following groups gap",
                "DIVERGENT": "Divergent",
                "DONE": "Done",
                "DONT_HEADER": "Don't:",
                "DONT_LINE1": "Try to figure out who said what",
                "DONT_LINE2": "Focus on one positive or negative score/comment",
                "DONT_LINE3": "Create a development plan around every item",
                "DONT_LINE4": "Be discouraged that you have opportunities for improvement",
                "DONUT": "Doughnut",
                "DOWNLOAD_CSV": "Download Legacy CSV",
                "DOWNLOAD_ZIP": "Download all files",
                "DO_HEADER": "Do:",
                "DO_LINE1": "Look at feedback holistically",
                "DO_LINE2": "Identify themes in strengths and opportunities for improvement",
                "DO_LINE3": "Prioritise a few focus areas to add to your development plan",
                "DO_LINE4": "Understand that everyone has opportunities for improvement",
                "DROPOFF": "Dropoff",
                "DUPLICATE": "Duplicate",
                "EDIT_CONDITIONAL_TEXT": "Edit conditional text",
                "EDIT_CUSTOM_PALETTE": "Edit Custom Palette",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "Else show the following text",
                "ENABLED": "Enabled",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "Enable ordering by rater category display logic",
                "ENABLE_ORDERING_FOR": "Enable ordering for",
                "EQUAL_TO": "Equal to",
                "FIELD": "Field",
                "FILTER_NAMES": "Filter Names",
                "FOLLOWING_PARENTHESES": "(following)",
                "FOOTER": "Footer",
                "GAP": "Gap",
                "GAP_CHART": "Gap chart",
                "GAP_CHART_DESCRIPTION": "The gap chart displays the difference in scores between two rater groups. For example, in the case of self-ratings vs. how others rated you, a positive(+) difference means others rated you higher than the rating you provided for yourself. A negative(-) difference means others rated you lower than the rating you provided for yourself.",
                "GAP_CHART_FOOTER": "The gap chart indicates the +/- difference between two rater groups.",
                "GAP_TABLE_DESCRIPTION": "Hidden strengths shows where others rated you higher than you rated yourself. Areas for improvement shows where others rated you lower than you rated yourself. Both sections are ranked from largest to smallest gap.",
                "GAP_TABLE_FOOTER": "The first column of scores indicates how you scored yourself. The second column indicates the average score of others. The third column indicates the difference between how you scored yourself and how others scored you.",
                "GAP_TABLE_TITLE": "Hidden strengths/Improvement areas",
                "GREATER_OR_EQUAL": "Greater or equal",
                "GREATER_THAN": "Greater than",
                "GROUP": "Group",
                "GROUPED_FOR_ANONYMITY": "Grouped for Anonymity",
                "HEADER_NAMES": "Header Names",
                "HIGHEST_SCORES": "Highest scores",
                "HIGHLIGHT_THRESHOLD": "Threshold to highlight gaps",
                "HIGHLOW_TABLE": "High and low scores",
                "HIGHLOW_TABLE_FOOTER": "This section shows the five highest and lowest rated behaviours (across all behaviours) from the applicable rater category averages. To get the most from this page, it is helpful to look for trends that may emerge. For example, if the majority of your lowest rated behaviours are concentrated in one or two categories; these may be areas in need of development. The highest rated behaviours can identify strengths that can be leveraged in other areas.",
                "HIGH_LOW_TABLE_DESCRIPTION": "The high/low chart displays items based on the areas where others rated you highest and lowest.",
                "HORIZONTAL": "Horizontal",
                "HORIZONTAL_AND_VERTICAL": "Horizontal & Vertical",
                "HORIZONTAL_BAR": "Horizontal Bar",
                "HOW_TO_INTERPRET_RESULT_HEADER": "How to interpret results and determine action:",
                "IF": "If",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "Include hidden labels in per cent",
                "INNER_RIM": "Inner Rim",
                "IS": "Is",
                "IS_NOT": "Is not",
                "IS_SAME_AS_SUBJECT": "Is same as subject",
                "ITEM": "Item",
                "LABEL": "label",
                "LABELS": "Labels",
                "LARGE_LABELS": "Large Labels",
                "LEGEND": "Legend",
                "LEGEND_POSITION": "Legend Position",
                "LEGEND_VALUES": "Legend Values",
                "LESS_OR_EQUAL": "Less or equal",
                "LESS_THAN": "Less than",
                "LINE": "Line",
                "LOWEST_SCORES": "Lowest scores",
                "MANAGERS": "Managers",
                "MANUAL_FONT_SIZE": "Set font size manually",
                "MAX": "Max",
                "MEAN": "Mean",
                "MEDIAN": "Median",
                "METRIC_TYPE": "Metric type",
                "MIN": "Min",
                "MODIFY_CUSTOM_PALETTES": "Modify Custom Palettes",
                "MOVE_DOWN": "Move down",
                "MOVE_UP": "Move up",
                "MULTI_SELECT_ITEMS_SELECTED": "selected",
                "NEGATIVE_GAPS": "Areas for improvement",
                "NO": "No",
                "NONE": "None",
                "NOT_APPLICABLE": "N/A",
                "NOT_EQUAL_TO": "Not equal to",
                "NO_DATA_AVAILABLE_WARNING": "No data available",
                "NO_FILTER": "No filter",
                "NO_FILTER_IS_APPLIED": "No filter is applied.",
                "NO_VALUE": "No value",
                "NPS": "Net Promoter Score",
                "NUMBER": "number",
                "NUMBERS": "Numbers",
                "NUMBER_OF_GAPS_NEGATIVE": "Number of Negative Gaps",
                "NUMBER_OF_GAPS_POSITIVE": "Number of Positive Gaps",
                "NUMBER_OF_ROWS_HIGH": "Number of High Rows",
                "NUMBER_OF_ROWS_LOW": "Number of Low Rows",
                "OPTIONS": {
                    "HEADER_NAME": "Header name",
                    "LEGEND": "Legend",
                    "SCALE_AXIS_CHANGER_TITLE": "Range"
                },
                "ORIENTATION": "Orientation",
                "OR_IF": "Or if",
                "OTHER": "Other",
                "OTHERS": "Others",
                "PAGE_OF": "Page: %1 of %2",
                "PALETTE_REMOVED": "Palette Removed",
                "PEERS": "Peers",
                "PERCENT": "Per Cent",
                "PERCENTAGE": "Percentage",
                "PERCENTAGE_OF_CHOICES": "Percentage of Choices",
                "PERCENTAGE_OF_RESPONSES": "Percentage of Responses",
                "PERCENT_COMPLETE": "% complete",
                "PERSON_METADATA": "Person metadata",
                "PERSON_METADATA_EVALUATOR": "Evaluator's",
                "PERSON_METADATA_SUBJECT": "Subject's",
                "PERSON_METADATA_VIEWER": "Viewer's",
                "POSITIVE_GAPS": "Hidden strengths",
                "PRIMARY_PARENTHESES": "(primary)",
                "QUESTIONS": "Questions",
                "RADIUS": "Radius",
                "RANK": "Rank",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "Highest score",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "Highest scores",
                "RANKABLE_ITEMS_ITEM_HAS": "Item has",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "Item is in top",
                "RANKABLE_ITEMS_LOWEST_SCORE": "Lowest score",
                "RANKABLE_ITEMS_LOWEST_SCORES": "Lowest scores",
                "RATER_CATEGORY_DISPLAY_LOGIC": "rater category display logic",
                "RATIO": "Ratio",
                "RECORD": "Record",
                "REFERENCE_GROUP": "Reference group",
                "RELATIONSHIP": "Relationship",
                "RELATIONSHIP_FILTERS": "Relationship filters",
                "RELATIONSHIP_FILTERS_INFO": "To add a relationship filter (such as a direct report, peer or manager), select Manage your filters, and use Relationship condition only from the dropdown menu.",
                "REMOVE": "Remove",
                "REMOVE_DATA_SOURCE": "Remove data source",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Remember, there are resources within your organisation to help you interpret your feedback, such as HR Partners, your manager and/or a mentor.",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Pour yourself a cup of coffee and dive into your feedback.",
                    "ABOUT_YOUR_REPORT_HEADER": "About your report",
                    "ABOUT_YOUR_REPORT_LINE1": "Welcome to your 360 feedback report. This is a great opportunity to grow and develop yourself as a professional. In order to set yourself up for success when going through results, allow yourself sufficient time to go over the feedback. Feedback can be difficult to hear initially, but keep in mind that the purpose of this feedback is to accelerate your growth and development.",
                    "ABOUT_YOUR_REPORT_LINE2": "As you go through your report, here are a few things to keep in mind.",
                    "ADVANCED_FILTER": "Advanced Filter",
                    "AGREEMENT_CHART": "Agreement chart",
                    "AGREEMENT_CHART_FOOTER": "The agreement chart indicates the similarity of scores. Each dot represents how individuals rated you for each item. The size of the dot shows how many raters gave you a specific rating.",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "responses",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "response",
                    "AGREEMENT_CHART_LEGEND_TITLE": "How others rated you",
                    "ALL": "All",
                    "AVERAGE": "Average",
                    "BOTTOM_BOX": "Bottom Box",
                    "CHOICE_COUNT": "Choice Count",
                    "CHOICE_TOTALS": "Choice Totals",
                    "COMPARISON": "Comparison",
                    "COMPARISON_GAP_COLUMN_HEADER": "Comparison gap",
                    "COMPLETED_RESPONSES": "Completed responses",
                    "COUNT": "Count",
                    "DEFAULT": "Default",
                    "DEFAULT_TEXT": "Default text",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "Understand who your feedback is coming from, whether it’s peers, direct reports, leaders, etc",
                    "DIFFERENT_EVALUATORS_HEADER": "Different evaluators",
                    "DONE": "Done",
                    "DONT_HEADER": "Don't:",
                    "DONT_LINE1": "Try to figure out who said what",
                    "DONT_LINE2": "Focus on one positive or negative score/comment",
                    "DONT_LINE3": "Create a development plan around every item",
                    "DONT_LINE4": "Be discouraged that you have opportunities for improvement",
                    "DO_HEADER": "Do:",
                    "DO_LINE1": "Look at feedback holistically",
                    "DO_LINE2": "Identify themes in strengths and opportunities for improvement",
                    "DO_LINE3": "Prioritise a few focus areas to add to your development plan",
                    "DO_LINE4": "Understand that everyone has opportunities for improvement",
                    "FIELD": "Field",
                    "GAP": "Gap",
                    "GAP_CHART": "Gap chart",
                    "GAP_CHART_DESCRIPTION": "The gap chart displays the difference in scores between two rater groups. For example, in the case of self-ratings vs. how others rated you, a positive(+) difference means others rated you higher than the rating you provided for yourself. A negative(-) difference means others rated you lower than the rating you provided for yourself.",
                    "GAP_CHART_FOOTER": "The gap chart indicates the +/- difference between two rater groups.",
                    "GAP_TABLE_DESCRIPTION": "Hidden strengths shows where others rated you higher than you rated yourself. Areas for improvement shows where others rated you lower than you rated yourself. Both sections are ranked from largest to smallest gap.",
                    "GAP_TABLE_FOOTER": "The first column of scores indicates how you scored yourself. The second column indicates the average score of others. The third column indicates the difference between how you scored yourself and how others scored you.",
                    "GAP_TABLE_TITLE": "Hidden strengths/Improvement areas",
                    "GROUP": "Group",
                    "HIDE_REPORT_ALERT": "You do not meet the requirements to view your report. Contact your organisation administrator.",
                    "HIGHEST_SCORES": "Highest scores",
                    "HIGHLOW_TABLE": "High and low scores",
                    "HIGHLOW_TABLE_FOOTER": "This section shows the five highest and lowest rated behaviours (across all behaviours) from the applicable rater category averages. To get the most from this page, it is helpful to look for trends that may emerge. For example, if the majority of your lowest rated behaviours are concentrated in one or two categories; these may be areas in need of development. The highest rated behaviours can identify strengths that can be leveraged in other areas.",
                    "HIGH_LOW_TABLE_DESCRIPTION": "The high/low chart displays items based on the areas where others rated you highest and lowest.",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "How to interpret results and determine action:",
                    "ITEM": "Item",
                    "LOWEST_SCORES": "Lowest scores",
                    "MAX": "Max",
                    "MEAN": "Mean",
                    "MEDIAN": "Median",
                    "MIN": "Min",
                    "NEGATIVE_GAPS": "Areas for improvement",
                    "NO_COMPARISON_SET": "No comparison set",
                    "NO_DATA_AVAILABLE_WARNING": "No data available",
                    "NO_FILTER_IS_APPLIED": "No filter is applied.",
                    "NO_VALUE": "No value",
                    "NPS": "Net Promoter Score",
                    "OTHERS": "Others",
                    "PERCENTAGE": "Percentage",
                    "PERCENTAGE_OF_CHOICES": "Percentage of Choices",
                    "PERCENTAGE_OF_RESPONSES": "Percentage of Responses",
                    "PERCENT_COMPLETE": "% complete",
                    "POSITIVE_GAPS": "Hidden strengths",
                    "QUESTIONS": "Questions",
                    "RANK": "Rank",
                    "RELATIONSHIPS": {
                        "ANYONE": "Anyone",
                        "DIRECT_REPORT": "Direct Report",
                        "MANAGER": "Manager",
                        "PEER": "Peer",
                        "SELF": "Self"
                    },
                    "REPORT_SUMMARY": "Report summary",
                    "REPORT_SUMMARY_TABLE_FOOTER": "Compare the number of people who finished your assessment with the number of people invited to participate.",
                    "REPORT_SUMMARY_TABLE_HEADER": "Respondent statistics",
                    "RESPONSES": "Responses",
                    "RESPONSE_COUNT": "{{responseCount}} Responses",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Responses",
                    "SCORING_CATEGORY": "Scoring category",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "No responses for this category",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "No responses for this question",
                    "SCORING_OVERVIEW": "Scoring overview",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "You and other evaluators think this area is a top strength.",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Recognised strength",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "A recognised improvement area means self-rating and ratings from others are both below the average for this competency.",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Recognised improvement area",
                    "SCORING_OVERVIEW_DESCRIPTION": "Above are the competencies or behaviours that you were evaluated on as a part of this multi-rater feedback process. Comparison ratings are provided by group.",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "Minimum gap",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Minimum difference between reference groups for texts to be shown.",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "The range of scores for each competency/behaviour is displayed. The bar represents the numerical average.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Unrecognised strength comes from discrepancy between the self-rating and the ratings from others.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Unrecognised strength",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Unrecognised improvement area comes from discrepancy between the self-rating and the ratings from others.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Unrecognised improvement area",
                    "SELF": "Self",
                    "SELF_ASSESSMENT": "Self-assessment",
                    "STANDARD_DEVIATION": "Standard Deviation",
                    "SUM": "Sum",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Familiarise yourself with the rating scale to ensure accurate interpretation",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "Take note of the scale",
                    "THINGS_YOU_WILL_SEE_HEADER": "Things you will see:",
                    "THREE_SIXTY_PERCENTILE": "Percentile",
                    "TOP_BOTTOM_BOX": "Top Box/Bottom Box",
                    "TOP_BOX": "Top Box",
                    "TOTAL": "Total",
                    "TO_DO": "To do",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Qualitative: This feedback will be in the form of open text comments",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Quantitative: This feedback will be numerical, and could be represented in graphs, bar charts, tables, etc.",
                    "TYPES_OF_FEEDBACK_HEADER": "Various types of feedback",
                    "VALUE": "Value",
                    "VARIANCE": "Variance",
                    "YOUR_RATINGS": "Your ratings"
                },
                "REPORT_SUMMARY": "Report summary",
                "REPORT_SUMMARY_TABLE_FOOTER": "Compare the number of people who finished your assessment with the number of people invited to participate.",
                "REPORT_SUMMARY_TABLE_HEADER": "Respondent statistics",
                "RESET": "Reset",
                "RESPONDENT_TOTALS": "Respondent Totals",
                "RESPONSES": "Responses",
                "RESPONSE_COUNT": "{{responseCount}} Responses",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Responses",
                "RESULT": "Result",
                "REVERSE_COLORS": "Reverse Colours",
                "ROW_TOTALS": "Row Totals",
                "SAVE": "Save",
                "SAVE_AND_APPLY": "Save and apply",
                "SCORING_CATEGORY": "Scoring category",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "No responses for this category",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "No responses for this question",
                "SCORING_OVERVIEW": "Scoring overview",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "You and other evaluators think this area is a top strength.",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Recognised strength",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "A recognised improvement area means self-rating and ratings from others are both below the average for this competency.",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Recognised improvement area",
                "SCORING_OVERVIEW_DESCRIPTION": "Above are the competencies or behaviours that you were evaluated on as a part of this multi-rater feedback process. Comparison ratings are provided by group.",
                "SCORING_OVERVIEW_MINIMUM_GAP": "Minimum gap",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Minimum difference between reference groups for texts to be shown.",
                "SCORING_OVERVIEW_TABLE_FOOTER": "The range of scores for each competency/behaviour is displayed. The bar represents the numerical average.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Unrecognised strength comes from discrepancy between the self-rating and the ratings from others.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Unrecognised strength",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Unrecognised improvement area comes from discrepancy between the self-rating and the ratings from others.",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Unrecognised improvement area",
                "SELECT_CATEGORIES": "Please select Scoring Categories...",
                "SELECT_CATEGORY": "Please select a Scoring Category...",
                "SELECT_CONDITION_TYPE": "Select condition type",
                "SELECT_DATA_SOURCE": "Select data source",
                "SELECT_DATA_SOURCE_TYPE": "Select data source type",
                "SELECT_FILTER": "Select filter",
                "SELECT_FILTERS": "Select filters",
                "SELECT_OPERATOR_TYPE": "Select operator type",
                "SELECT_PERSON": "Select person",
                "SELECT_PERSON_METADATA": "Select person metadata",
                "SELECT_QUESTION": "Select question",
                "SELECT_QUESTIONS": "Please select Questions...",
                "SELECT_RATIO_OR_DROPOFF": "Select ratio or dropoff",
                "SELECT_RELATIONSHIP": "Select relationship",
                "SELECT_SCORING_CATEGORY": "Select scoring category",
                "SELF": "Self",
                "SELF_ASSESSMENT": "Self-assessment",
                "SEQUENTIAL": "Sequential",
                "SETUP_COMPARISON": "Setup comparison",
                "SETUP_COMPARISONS": "Setup comparisons",
                "SET_START_COLOR": "Set Start Colour",
                "SHOULD_SHOW_FOOTER": "Show Footer",
                "SHOULD_SHOW_SCORING_CATEGORY": "Show Scoring Category",
                "SHOWING_RECORDS_OF": "Showing records %1 - %2 of %3",
                "SHOW_COMPARISON_GAP": "Show comparison gap column",
                "SHOW_DATA_LABEL": "Show data values",
                "SHOW_PERCENTAGES": "Show Percentages",
                "SHOW_THE_FOLLOWING_TEXT": "Then show the following text",
                "SHOW_TIES": "Show Ties",
                "SHOW_X_AXIS": "Show X Axis",
                "SHOW_Y_AXIS": "Show Y Axis",
                "SMALL_LABELS": "Small Labels",
                "SORT": "Sort",
                "SPLINE": "Spline",
                "STACK_CHART": "Stack Chart",
                "STANDARD_DEVIATION": "Standard Deviation",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "Weakness less than",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "Edit threshold texts",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "Threshold texts",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "Enable threshold texts",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "Strength more than",
                "SUM": "Sum",
                "SUMMARY": "Summary",
                "TABLES": "Tables",
                "TABLE_TOTALS": "Table Totals",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Familiarise yourself with the rating scale to ensure accurate interpretation",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "Take note of the scale",
                "TEXT": "Text",
                "THINGS_YOU_WILL_SEE_HEADER": "Things you will see:",
                "TOP_BOTTOM_BOX": "Top Box/Bottom Box",
                "TOP_BOX": "Top Box",
                "TOTAL": "Total",
                "TOTAL_COUNTS": "Total Counts",
                "TO_DO": "To do",
                "TRANSPOSE": "Transpose",
                "TRANSPOSE_TABLE": "Transpose table",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Qualitative: This feedback will be in the form of open text comments",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Quantitative: This feedback will be numerical, and could be represented in graphs, bar charts, tables, etc.",
                "TYPES_OF_FEEDBACK_HEADER": "Various types of feedback",
                "UNDO": "Undo",
                "USE_COMPARISON": "Use comparison",
                "USE_LABELS_FOR_SCALES": "Use labels for scales",
                "VALUES": "Values",
                "VALUE_RANGES": "Value Ranges",
                "VARIANCE": "Variance",
                "VERTICAL": "Vertical",
                "VERTICAL_RANGE": "Vertical Range",
                "WARNING_DATA_OUT_OF_RANGE": "Warning: data value exceeds range configuration",
                "WIDGET_ERROR": {
                    "ERROR": "An unexpected error has occurred",
                    "MISCONFIGURED": "This widget is not configured correctly. Please check your widget configuration.",
                    "NEW": "Please configure widget",
                    "NO_DATA": "No data found – your filters may be too exclusive!"
                },
                "WIDGET_NAME": {
                    "BAR": "Bar Chart",
                    "BREAKDOWNBAR": "Breakdown Bar",
                    "DATA_TABLE": "Data Table",
                    "FUNNEL_CHART": "Funnel Chart",
                    "GAUGE": "Gauge Chart",
                    "GRID": "Results Table",
                    "HEATMAP": "Heat Map",
                    "LINE": "Line Chart",
                    "NEEDS_BASED": "Needs Based",
                    "PIE": "Pie Chart",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "Price Estimator (Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "Revenue Maximiser (Gabor Granger)",
                    "SCORING_OVERVIEW_CHART": "Chart",
                    "SCORING_OVERVIEW_TABLE": "Table",
                    "STATS_TABLE": "Statistics Table",
                    "WORDCLOUD": "Word Cloud"
                },
                "WORD_ROTATION": "Word rotation",
                "WORD_SPACING": "Word spacing",
                "YES": "Yes",
                "YOUR_RATINGS": "Your ratings"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "Add",
                "ADD_A_WORD": "Add a word",
                "COLOR": "Colour",
                "DELETE_ALL": "Delete all",
                "EDIT_STOP_WORDS": "Edit Stop Words",
                "MAX_WORDS": "Max Words",
                "ROTATION_ANGLED": "Angled",
                "ROTATION_HORIZONTAL": "Horizontal",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "Horizontal and Vertical",
                "WORD_ORIENTATION": "Word Orientation"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "Background Colours",
                "DISPLAY_OPTIONS": "Display Options",
                "INVERT_FONT_COLORS": "Invert Low Contrast Font Colors",
                "PAGE": "Page",
                "PAGINATE": "Paginate"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "Mean",
                "BOTTOM_BOX_METRIC": "Bottom Box",
                "COLUMNS": "Columns",
                "COUNT_METRIC": "Total Responses",
                "FIELD_NAME": "Field",
                "MAX_METRIC": "Maximum",
                "MIN_METRIC": "Minimum",
                "SHOW_RECODES": "Show Recode Values",
                "SHOW_ROW_NUMBERS": "Show Row Numbers",
                "STD_DEV_METRIC": "Std Deviation",
                "TOP_BOX_METRIC": "Top Box",
                "TRANSPOSE_BREAKOUTS": "Transpose Breakouts",
                "TRANSPOSE_TABLE": "Transpose Table",
                "VAR_METRIC": "Variance"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "Additional Columns",
                "ADD_COLUMNS": "Add Additional Columns",
                "ADD_CUSTOM_PALETTE": "Add Custom Palette",
                "ALL_CHOICES": "All Choices",
                "ALL_GROUPS": "All Groups",
                "ALL_RECODES": "All Recodes",
                "AUTOMATIC": "Default",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "Default – Click to edit",
                "AXIS_VALUES": "Axis Values",
                "BREAKOUT_BY": "Breakout By",
                "CANCEL": "Cancel",
                "CATEGORICAL": "Categorical",
                "CHOICES": "Choices",
                "CHOICE_COUNT": "Choice Count",
                "COLOR_PALETTE": "Colour Palette",
                "COLUMN_VALUES": "Column Values",
                "CONTACT_FIELDS": "Contact Fields",
                "COUNT": "Count",
                "CREATE": "Create",
                "CUSTOM": "Custom",
                "CUSTOM_PALETTE": "Custom Palette",
                "DATA_SOURCE": "Data Source",
                "DAY": "Day",
                "DAY_OF_WEEK": "Day of Week",
                "DECIMAL_PRECISION": "Decimal Places",
                "DEFAULT": "Default",
                "DISABLED": "Disabled",
                "DIVERGENT": "Divergent",
                "EDIT_CUSTOM_PALETTE": "Edit Custom Palette",
                "ENABLED": "Enabled",
                "ERROR_LOADING_DATA": "Error loading data",
                "FILE_SIZE": "Size",
                "FILE_TYPE": "Type",
                "FRI": "Fri",
                "FRIDAY": "Friday",
                "GROUP_DATE_BY": "Group Date By",
                "HOUR_OF_DAY": "Hour of Day",
                "LENGEND_VALUES": "Legend Values",
                "MAX": "Max",
                "MEAN": "Mean",
                "MIN": "Min",
                "MISCONFIGURED_DATA": "Data source misconfigured for this visualisation.",
                "MISCONFIGURED_FILTERS": "Invalid Filter(s)",
                "MODIFY_CUSTOM_PALETTES": "Modify Custom Palettes",
                "MON": "Mon",
                "MONDAY": "Monday",
                "MONTH": "Month",
                "NONE": "None",
                "NO_FILE_ID_ERROR": "This visualisation requires an image to be set in the survey",
                "NO_RESULTS_TO_SHOW": "No results to show",
                "NPS": "Net Promoter Score®",
                "NPS_GROUP": "NPS® group",
                "NUMERIC_VALUE": "Numeric Value",
                "PALETTE_REMOVED": "Palette Removed",
                "PERCENTAGE": "Percentage",
                "PERCENTAGE_OF_CHOICES": "Percentage of Choices",
                "PERCENTAGE_OF_RESPONSES": "Percentage of Responses",
                "QUARTER": "Quarter",
                "REMOVE": "Remove",
                "RESPONSE_COUNT": "Response Count",
                "RESULTS_PER_PAGE": "Results per page",
                "RETRIEVING_DATA_ELLIPSIS": "Retrieving data...",
                "REVERSE_COLORS": "Reverse Colours",
                "ROW_VALUES": "Row Values",
                "SAT": "Sat",
                "SATURDAY": "Saturday",
                "SAVE": "Save",
                "SELECTED_CHOICE": "Selected Choice",
                "SELECT_FIELD": "Select Field",
                "SELECT_METRIC": "Metric",
                "SEQUENTIAL": "Sequential",
                "SET_START_COLOR": "Set Start Colour",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "Showing sample data...",
                "SUM": "Sum",
                "SUN": "Sun",
                "SUNDAY": "Sunday",
                "SURVEY_EMBEDDEDDATA": "Embedded Data",
                "SURVEY_METADATA": "Survey Metadata",
                "TEXT_ENTRY": "Text entry",
                "THURS": "Thurs",
                "THURSDAY": "Thursday",
                "TITLE": "Title",
                "TUES": "Tues",
                "TUESDAY": "Tuesday",
                "UNBOUNDED_DOMAIN": "Too many values to display.",
                "UNBOUNDED_DOMAIN_HELP": "To add this field to Results Reports, you can add a filter to report to display fewer values for '{{ed_field_name}}' or update the embedded data variable type of '{{ed_field_name}}' in your survey flow to make this field a string or numeric type.",
                "UNDO": "Undo",
                "USE_CHOICE_TOTALS": "Use Choice Totals",
                "USE_RESPONDENT_TOTALS": "Use Respondent Totals",
                "VISUALIZATION": "Visualisation",
                "VISUALIZATION_BARCHART": "Bar Chart",
                "VISUALIZATION_BREAKDOWNBAR": "Breakdown Bar",
                "VISUALIZATION_GAUGE": "Gauge Chart",
                "VISUALIZATION_HEATMAP": "Heat Map",
                "VISUALIZATION_LINECHART": "Line Chart",
                "VISUALIZATION_PAGINATEDTABLE": "Paginated Table",
                "VISUALIZATION_PIE": "Pie Chart",
                "VISUALIZATION_SIMPLETABLE": "Simple Table",
                "VISUALIZATION_STATSTABLE": "Statistics Table",
                "VISUALIZATION_TEXTHIGHLIGHTS": "Text Highlights",
                "VISUALIZATION_WORDCLOUD": "Word Cloud",
                "WED": "Wed",
                "WEDNESDAY": "Wednesday",
                "WEEK": "Week",
                "WEIGHTING": "Weighting",
                "WRONG_QUESTION_TYPE_ERROR": "This visualisation type cannot be used for this question",
                "YEAR": "Year"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "Average",
                "CHOICE_COUNT": "Choice Count",
                "COUNT": "Count",
                "DISPLAY_OPTIONS": "Display Options",
                "MAX": "Maximum",
                "MIN": "Minimum",
                "NPS": "NPS®",
                "PAGE_OF": "Page: %1 of %2",
                "PERCENT": "Percentage",
                "RESPONSE_COUNT": "Response Count",
                "ROWS_PER_TABLE": "Rows Per Table",
                "SHOWING_ROWS_OF": "Showing rows %1 - %2 of %3",
                "SHOW_PERCENTAGES": "Show Percentages",
                "SHOW_RECODES": "Show Recode Values",
                "SHOW_ROW_NUMBERS": "Show Row Numbers",
                "SUM": "Sum",
                "TOTAL": "Total",
                "TRANSPOSE": "Transpose",
                "USE_COLUMN_TOTALS": "Use Column Totals",
                "USE_ROW_TOTALS": "Use Row Totals",
                "VALUE": "Value"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "Ascending",
                "COUNT": "Count",
                "DESCENDING": "Descending",
                "DIAGONAL": "Diagonal",
                "DISPLAY_OPTIONS": "Display Options",
                "ERROR_COLON": "Error:",
                "ERROR_GENERIC": "An error occurred while loading the visualisation.",
                "HORIZONTAL": "Horizontal",
                "HORIZONTAL_BARS": "Horizontal Bars",
                "INCORRECTLY_CONFIGURED": "Choose a value to display chart",
                "LEGEND_AUTO": "Auto",
                "LEGEND_BOTTOM": "Bottom",
                "LEGEND_INSET": "Inset",
                "LEGEND_RIGHT": "Right",
                "NORMALIZE_TO_PERCENTAGES": "Normalise to Percentages",
                "SHOW_BAR_LABELS": "Show Bar Labels",
                "SHOW_LEGEND": "Show Legend",
                "SHOW_X_AXIS": "Show X Axis",
                "SHOW_Y_AXIS": "Show Y Axis",
                "SORT_BAR_VALUES": "Sort Bar Values",
                "STACKED_BARS": "Stacked Bars",
                "TRANSPOSE": "Transpose",
                "TRUNCATE_LABELS": "Truncate Labels",
                "VERTICAL": "Vertical"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "All Others",
                "COULD_NOT_LOAD_DATA": "Couldn't load data with specified configuration – try a different source field or a larger date range.",
                "GROUPING_PERCENTAGE_THRESHOLD": "Grouping Percentage Threshold",
                "NO_DATA": "No Data",
                "RADIUS": "Inner Radius",
                "SHOW_AS_PERCENTAGES": "Show As Percentages"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "Close",
                "DOWNLOAD_CSV": "Download CSV",
                "DOWNLOAD_ZIP": "Download all files",
                "NO_DATA": "No Data",
                "PAGE_OF": "Page: %1 of %2",
                "RESULTS_PER_PAGE": "Results per page",
                "SHOWING_RECORDS_OF": "Showing records %1 - %2 of %3",
                "SINGLE_RESPONSE": "Single Response",
                "VIEW_RESPONSE": "View Response"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "Display Options",
                "ERROR_COLON": "Error:",
                "ERROR_GENERIC": "An error occurred while loading the visualisation.",
                "HORIZONTAL_BARS": "Horizontal Bars",
                "INCORRECTLY_CONFIGURED": "Choose a value to display chart",
                "LEGEND_AUTO": "Auto",
                "LEGEND_BOTTOM": "Bottom",
                "LEGEND_INSET": "Inset",
                "LEGEND_RIGHT": "Right",
                "NORMALIZE_TO_PERCENTAGES": "Normalise to Percentages",
                "SHOW_AREA": "Show Area",
                "SHOW_LEGEND": "Show Legend",
                "SHOW_X_AXIS": "Show X Axis",
                "SHOW_Y_AXIS": "Show Y Axis",
                "SMOOTH_LINES": "Smooth Lines",
                "SORT_X_AXIS_LABELS": "Sort X Axis Labels",
                "STACKED_BARS": "Stacked Bars",
                "TRANSPOSE": "Transpose"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "Block Mode",
                "BLUR": "Blur",
                "COULD_NOT_LOAD_DATA": "Couldn't load data with specified configuration – try a different source field or a larger date range.",
                "FIELD": "Field",
                "RADIUS": "Radius",
                "SHOW_REGIONS": "Show Regions",
                "SHOW_REGION_LABELS": "Show Region Labels"
            },
            "GAUGEWIDGET": {
                "MAX": "Max",
                "MIN": "Min",
                "VALUE_RANGES": "Value ranges"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "Bottom labels",
                "CATEGORY_NAME": "Category name",
                "ERROR_COLON": "Error:",
                "INCLUDE_HIDDEN_GROUPS": "Include hidden groups in per cent",
                "LARGE_LABELS": "Large labels",
                "NO": "No",
                "PERCENT": "Per Cent",
                "RESPONSE_COUNT": "Response count",
                "RESPONSE_COUNT_WITH_VALUE": "{{ responseCount }} responses",
                "SMALL_LABELS": "Small labels",
                "YES": "Yes"
            }
        });
        $cache.put('EN', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "Access Code",
                "ACCESS_CODE_PROTECTION": "Access Code Protection",
                "ADD": "Add",
                "ADD_BREAKOUT": "Add Report Breakout",
                "ADD_NOTE": "Add Note",
                "ADD_SCHEDULED_REPORT": "Add Scheduled Report",
                "ADD_WIDGET": "Add Visualization",
                "ALL_PROJECTS": "All Projects",
                "ALL_QUESTIONS": "Question Pages",
                "ANSWER": "Answer",
                "ANY_CHANGES_LOST": "Any changes to reports will be lost if you leave the Qualtrics XM Platform.",
                "APPENDED_COPY_IN_PARENS": "(Copy)",
                "AREA_CHART": "Area Chart",
                "AREA_CHART_DESC": "A two-axis line chart with the area under the line filled in.",
                "ATTACHMENT": "Attachment",
                "BACKUP_CURRENT_REPORT": "Save a backup copy of this report before affecting the visualizations",
                "BACKUP_CURRENT_REPORT_LINE2": "Note: The backup copy will be named \"{{nameOfReportCopy}}\"",
                "BACK_TO_REPORTS": "Back to Reports",
                "BACK_TO_TOP": "Back to Top",
                "BACK_TO_VIEW_RESULTS": "Back to old view results",
                "BAR_CHART": "Bar Chart",
                "BAR_CHART_DESC": "A two-axis bar chart that allows additional configuration such as axis transposition and rearrangement of data points.",
                "BREAKDOWN_BAR_CHART": "Breakdown Bar",
                "BREAKDOWN_BAR_CHART_DESC": "A horizontal stacked bar chart most commonly used for for visually weighing metrics against each other as an alternative to a pie chart.",
                "CANCEL": "Cancel",
                "CANCEL_CONF_TEXT": "Are you sure you want to cancel?<br/>All changes will be lost.",
                "CANCEL_EDITS": "Cancel Edits",
                "CHART": "Chart",
                "CHOICE": "Choice",
                "CHOICES_COUNT_METRIC": "Choices Count",
                "CHOOSE_PAGES_TO_DISPLAY": "Choose Pages to Display",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "This report contains {{maxReportPageCount}} pages, but Results can only contain up to {{reportSizeLimit}}. Please select a subset within the limit.",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "Reports can only contain up to {{reportSizeLimit}} pages, please select the pages you would like.",
                "CLEAR_ALL": "Clear All",
                "CLOSE": "Close",
                "CLOUD": "A DESCRIPTION FOR CLOUD",
                "COLLABORATED_NEW": "The owner of this survey is using the Qualtrics XM Platform! Reports for this survey will be edited using New Results.",
                "COMMA_SEPARATED_LIST": "Comma Separated List",
                "COMPACTNESS": "Fonts and Spacing",
                "COMPACTNESS_INFO": "This setting affects table padding, font size, and bar size in charts. It will also be applied to most exports.",
                "CONFIRM": "Ok",
                "CONFIRM_DELETE": "Confirm Deletion",
                "CONFIRM_DELETE_PAGE": "Are you sure you want to delete this page?",
                "CONTINUE": "Continue",
                "CONTINUE_EDITING": "Continue Editing",
                "COPY": "Copy",
                "COPY_OF_REPORT_NAME": "Copy of {{nameOfCurrentReport}}",
                "COPY_REPORT": "Copy Report",
                "COPY_REPORT_ELLIPSIS": "Copy Report...",
                "COPY_TO_NEW_REPORT": "Copy to New Report...",
                "CREATE": "Create",
                "CREATED": "Created",
                "CREATE_CUSTOM_PAGE": "Create Custom Page",
                "CREATE_NEW_REPORT": "Create New Report",
                "CREATE_NEW_REPORT_ELLIPSIS": "Create New Report...",
                "CSV_FILE": "CSV File",
                "CUSTOM_PAGES": "Custom Pages",
                "DATE": "Date",
                "DEFAULT_PALETTE": "Default Color Palette",
                "DEFAULT_REPORT": "Default Report",
                "DEFAULT_VISUALIZATIONS": "Default Visualizations",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "These are the default visualization types used to construct default results reports. Updating and applying these settings will rebuild your current report with the new default settings. You will have the option to back up your current report.",
                "DEFAULT_VISUALIZATIONS_NOTE": "Note: Not every visualization type is available for all question types. Some non-default visualizations may automatically be substituted.",
                "DEFAULT_VISUALS_DISCLAIMER": "Qualtrics will update this report with the new default visualization settings.",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "This update will affect {{amountOfWidgetsAffected}} visualizations in this report.",
                "DEFAULT_VISUAL_EDIT_DETECTED": "Default Visualization Edit Detected",
                "DELETE_BUTTON": "Delete",
                "DELETE_DISABLED_EXPLANATION": "Deleting reports created in the previous reporting interface is not allowed until your organization has performed a full migration to the Qualtrics XM Platform.",
                "DELETE_PAGE": "Delete Page",
                "DELETE_PAGE_ELLIPSIS": "Delete Page...",
                "DELETE_REPORT": "Delete Report",
                "DELETE_REPORT_ELLIPSIS": "Delete Report...",
                "DELETE_WIDGET_QUESTION": "Delete?",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "This field is encrypted and cannot be used for sorting.",
                "DISCARD_EDITS": "Discard Edits",
                "DISTRIBUTION_PAUSED": "Report distribution paused.",
                "DONE_BUTTON": "Done",
                "DONE_EDITING": "Done Editing",
                "DOWNLOAD": "Download",
                "DOWNLOAD_AS_CSV": "Download as CSV",
                "DOWNLOAD_AS_PDF": "Download as PDF",
                "DOWNLOAD_FAILED": "Download failed",
                "DOWNLOAD_PREVIOUS_EXPORTS": "Download Previous Exports...",
                "DO_YOU_WISH_TO_DELETE": "Do you wish to delete:",
                "DUPLICATE_PAGE": "Duplicate Sheet",
                "EDIT_REPORT": "Edit Report",
                "EDIT_REPORT_ELLIPSIS": "Edit Report...",
                "EDIT_VISUALIZATION": "Edit Visualization",
                "EMAIL_ADDRESS": "Email Address",
                "EMAIL_SENT": "Email sent...",
                "END_OF_REPORT": "End of Report",
                "ENTER_NAME": "Enter Name",
                "ERROR_COPYING": "There was an error copying the report.",
                "ERROR_DELETING": "There was an error deleting the report.",
                "ERROR_DELETING_EXPORT": "There was an error deleting the export.",
                "ERROR_HEADING": "Error",
                "ERROR_PUBLISHING": "There was an error saving the settings.",
                "ERROR_RENAMING": "There was an error renaming the report.",
                "ERROR_REQUESTING_EXPORT": "There was an error requesting the export.",
                "ERROR_SAVING_GLOBAL_OPTIONS": "There was an error saving global visualization options.",
                "ERROR_SEND_TEST_EMAIL": "There was an error sending the test email.",
                "EVERY_FRIDAY": "Every Friday",
                "EVERY_MONDAY": "Every Monday",
                "EVERY_MONTH": "Monthly on",
                "EVERY_SATURDAY": "Every Saturday",
                "EVERY_SUNDAY": "Every Sunday",
                "EVERY_THURSDAY": "Every Thursday",
                "EVERY_TUESDAY": "Every Tuesday",
                "EVERY_WEDNESDAY": "Every Wednesday",
                "EVERY_WEEK": "Weekly every",
                "EXAMPLE_GROUP_NUM": "Group {{num}}",
                "EXAMPLE_SERIES_NUM": "Series {{num}}",
                "EXPORT": "Export",
                "EXPORT_CSV": "CSV (Comma Separated)",
                "EXPORT_EXCEL_SPREADSHEET": "Excel Spreadsheet",
                "EXPORT_IMAGE": "Export Image",
                "EXPORT_PAGES": "Export Pages",
                "EXPORT_PDF": "PDF Document",
                "EXPORT_PPT_SLIDES": "PowerPoint Slides",
                "EXPORT_RAW_DATA": "Export Raw Data",
                "EXPORT_REPORT": "Export Report",
                "EXPORT_VISUALIZATION": "Export Visualization",
                "EXPORT_WORD_DOC": "Word Document",
                "FAILED_SAVE_TXT": "Failed to save",
                "FILTERED": "Filtered",
                "FIRST_PAGE": "First Page",
                "FIRST_WEEKDAY": "First Weekday of Month",
                "FROM": "From",
                "FROM_EMAIL": "From Email",
                "FROM_NAME": "From Name",
                "GAUGE_CHART": "Gauge Chart",
                "GAUGE_CHART_DESC": "A chart resembling a gauge measurement tool for comparing current values to a goal or series of thresholds.",
                "GENERATING_FILE": "Generating file...",
                "GENERATING_IMAGE": "Generating Image...",
                "GENERATING_PDF": "Generating PDF...",
                "GENERIC_ERROR": "An error prevented us from loading the project you requested.",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "Global Options...",
                "GLOBAL_METRIC": "Default Metric",
                "GLOBAL_MODAL_PAGE_TITLE": "Example visualization using the global options for the Results section of the Qualtrics Research Suite",
                "GLOBAL_MODAL_WIDGET_TITLE": "Visualization Title",
                "GLOBAL_OPTIONS": "Global Options",
                "GLOBAL_PRECISION": "Default Decimal Places",
                "GLOBAL_SETTINGS_APPLY": "Apply my default settings",
                "GLOBAL_SETTINGS_SAVE": "Save as my default settings",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "Apply Qualtrics default",
                "GROUP": "Group",
                "HEAT_MAP_CHART": "Heat Map Chart",
                "HEAT_MAP_CHART_DESC": "A clustered “heat” style visualization used for mapping distribution of user input (such as clicks) to the original image.",
                "HIDDEN": "Hidden",
                "HIDDEN_PAGE": "This page will not appear in public reports and will be deselected by default in report exports.",
                "HIDE": "Hide",
                "HIDE_ALL_PAGES": "Hide All Pages",
                "HIDE_PAGE": "Hide Page",
                "IMAGE_FILE": "Image File",
                "INVALID_BRAND_DOMAIN": "The domain you have entered is not in your brand's list of approved email domains. Please contact your brand admin to fix.",
                "INVALID_SPF_RECORD": "The domain you have entered has not approved Qualtrics to send from it. This will affect deliverability. Please use another domain or contact Qualtrics about resolving this issue.",
                "ISSUE_SAVING_REPORTS": "One or more reports encountered a problem saving. Please try again.",
                "ISSUE_SENDING_TEST": "There was an error sending a test email. Please try again.",
                "LARGE_SURVEY": "Results will not be displayed because the survey is too large.",
                "LAST_DAY": "Last Day of Month",
                "LAST_MODIFIED_COLON_WITH_DATE": "Last Modified: %1",
                "LAST_PAGE": "Last Page",
                "LAST_WEEKDAY": "Last Weekday of Month",
                "LATER": "Later",
                "LEARN_MORE": "Learn More",
                "LINE_CHART": "Line Chart",
                "LINE_CHART_DESC": "A two-axis line chart commonly used when graphing against time on the x-axis.",
                "LOG_OUT_WARNING": "Click anywhere within {{countdown}} seconds to remain logged in",
                "MESSAGE": "Message",
                "MONTHLY": "Monthly",
                "MOVE_DOWN": "Move Visualization Down",
                "MOVE_PAGE_TO_BOTTOM": "Move to Bottom",
                "MOVE_PAGE_TO_TOP": "Move to Top",
                "MOVE_UP": "Move Visualization Up",
                "MY_SURVEYS": "My Projects",
                "NAME": "Name",
                "NEW_CUSTOM_PAGE_NAME": "New Custom Page",
                "NEW_REPORT": "New Report",
                "NEXT_PAGE": "Next Page",
                "NEXT_RUN": "Next Run",
                "NO_EXPORTS": "No exports have been requested for this report yet.",
                "NO_ITEMS_TO_DISPLAY": "No items to display",
                "NO_MATCHING_CUSTOM_PAGES": "No matching custom pages",
                "NO_MATCHING_PAGES": "No pages found for search",
                "NO_MATCHING_REPORTS": "No matching reports.",
                "NO_PROJECT": "Please specify a project to continue.",
                "NO_PROJECTS_TO_MIGRATE": "There are no projects to update.",
                "NO_QUESTIONS": "No matching questions",
                "NO_RESULTS_YET": "There are no results yet to show. Please distribute your survey to gather responses.",
                "OFF": "Off",
                "ON": "On",
                "PAGES_SELECTED": "Pages Selected",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "This selection would make the report contain {{currentSelectedPageCount}} pages, which is above the {{reportSizeLimit}} maximum allowed. Please select a smaller range.",
                "PAGES_SELECTION_INVALID_RANGE": "Please select a valid range.",
                "PAGE_OPTIONS": "Page Options",
                "PDF_ROW_TRUNCATION_MESSAGE": "Too many rows for PDF export, try exporting to Word or CSV",
                "PERCENTAGE_METRIC": "Percentage",
                "PIE_CHART": "Pie Chart",
                "PIE_CHART_DESC": "A circular breakdown of values for a given data point. Useful for measuring relative proportions of selected values.",
                "PREVIEW": "Preview",
                "PREVIOUS_PAGE": "Previous Page",
                "PRINT_PAGE": "Print Page",
                "PUBLIC_LINK": "Public Link",
                "PUBLIC_REPORT_AVAILABLE": "Public Report Available",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "Access Code",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "Incorrect Access Code. Please try again.",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "Submit",
                "PUBLIC_RESULTS_LOGIN_TITLE": "Public Report Login | Qualtrics Survey Software",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "Public report not found. Please contact the owner of this report and ask them for a valid link.",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "Public Report Not Found",
                "PUBLIC_RESULTS_NOT_UPDATED": "Public report links and scheduled report emails will not use the Qualtrics XM Platform until you update them.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "Session Expired. Please log in again to continue previewing Public Results Report.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "Session Expired",
                "PUBLIC_RESULTS_TITLE": "Public Report",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "You are not authorized to view this page. Please contact the owner of this report and ask them to make it public.",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "Public Report Unauthorized",
                "PUBLISHED_LINK_GENERATING_LINK": "Generating Link...",
                "PUBLISHED_REPORT_FOUND_HERE": "Anyone can view this report at the following link:",
                "PUBLISH_REPORT": "Manage Public Report",
                "PUBLISH_REPORT_ELLIPSIS": "Manage Public Report...",
                "QUESTION": "Question",
                "RANK": "Rank",
                "REMOVE_WIDGET": "Remove Visualization",
                "RENAME_PAGE": "Rename Page",
                "RENAME_REPORT": "Rename Report",
                "RENAME_REPORT_ELLIPSIS": "Rename Report...",
                "REPLY_TO_EMAIL": "Reply-To Email",
                "REPORT_COLON": "Report:",
                "REPORT_SETTINGS": "Report Settings",
                "REPORT_SETTINGS_ELLIPSIS": "Report Settings...",
                "RESPONSE_COUNTS": "Response Counts",
                "RESULTS_DASHBOARDS_BANNER": "and try the new, improved version of survey results, featuring modern, accessible UI and data visualizations, new analysis and exploration features, and more.",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "Release Notes",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "View the latest",
                "RESULTS_OPTIONS": "Report Options",
                "RESULTS_TITLE": "Report",
                "RESUME_DISTRIBUTION": "Resume Distribution",
                "REVERT": "Revert",
                "RICH_TEXT_LIMIT_REACHED": "Content length has reached the limit!",
                "SAVE": "Save",
                "SAVE_AND_CLOSE": "Save and Close",
                "SAVE_AS_CSV": "Save Visualization as CSV",
                "SAVE_AS_IMAGE": "Save Visualization as Image",
                "SAVE_CONFIRMATION": "Save Confirmation",
                "SAVE_PAGE_AS_ELLIPSIS": "Export Page As...",
                "SAVE_SETTINGS": "Save Settings",
                "SCHEDULE_REPORT_EMAIL": "Schedule Report Email",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "Schedule Report Email...",
                "SEARCH_ELLIPSIS": "Search...",
                "SEARCH_PAGES": "Search Questions",
                "SEARCH_PAGES_ELLIPSIS": "Search Pages...",
                "SEARCH_REPORTS_ELLIPSIS": "Search Reports...",
                "SELECTED": "Selected:",
                "SELECT_ALL": "Select All",
                "SELECT_A_FIELD": "Select a field",
                "SELECT_A_WIDGET": "Select a visualization",
                "SELECT_PAGES": "Select Pages",
                "SELECT_PAGES_ELLIPSIS": "Select Pages...",
                "SEND": "Send",
                "SEND_TEST_EMAIL": "Send Test Email",
                "SETTING_DEFAULT": "Default",
                "SETTING_HIGH": "High",
                "SETTING_LARGE": "Large",
                "SETTING_LOW": "Low",
                "SETTING_NORMAL": "Normal",
                "SETTING_SMALL": "Small",
                "SHARE_REPORT": "Share Report",
                "SHOW_ALL_PAGES": "Show All Pages",
                "SHOW_FULL_QTEXT": "Show full question text in page titles",
                "SIMPLE_TABLE": "Simple Table",
                "SIMPLE_TABLE_DESC": "A flexible table that can show multiple values as rows or columns.",
                "SIZE": "Size",
                "SPLINE_CHART": "Spline Chart",
                "SPLINE_CHART_DESC": "A two-axis rounded line chart commonly used when graphing against time on the x-axis.",
                "STATISTICS_TABLE": "Statistics Table",
                "SUBJECT": "Subject",
                "SURVEY_ANALYSIS": "Survey Analysis",
                "SURVEY_SUMMARY": "Survey Summary",
                "TABLE": "A DESCRIPTION FOR TABLE",
                "TIME": "Time",
                "TO": "To",
                "TOTAL": "Total",
                "TRANSPOSE_STATS_TABLES": "Transpose Stats Tables",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "Transpose Stats Table Breakouts",
                "TRUNCATE_PAGE_TITLES": "Truncate question text in page titles",
                "TRY_IT_NOW": "Try it now",
                "TYPE": "Type",
                "UNABLE_TO_CHECK_SPF": "Unable to check the SPF record. Please try again.",
                "UNAUTHORIZED": "You are not allowed to view this report. Please contact the owner for access.",
                "UNHIDE_PAGE": "Unhide Page",
                "UPDATE": "Update",
                "UPDATED_SUCCESSFULLY": "Updated Successfully.",
                "UPDATE_ALL_IN_THIS_PROJECT": "Update All in this Project",
                "UPDATE_ALL_PROJECTS": "Update All Projects",
                "UPDATE_NOW": "Update Now",
                "UPDATE_REPORTS": "Update Reports...",
                "UPDATE_REPORT_ELEMENTS": "Update Public Report Links and Scheduled Report Emails",
                "UPGRADE_MY_ACCOUNT": "Upgrade My Account",
                "USE_EXPORT_TAGS": "Include question numbers",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "Use Simple Table Column Totals",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "Use Simple Table Respondent Counts",
                "USE_WEIGHTED_METRICS": "Use weighted metrics",
                "VIEW": "View",
                "WEEKLY": "Weekly",
                "WELCOME_TO_NEW_RESULTS": "Welcome to Qualtrics XM Platform Reporting!",
                "WHEN": "When",
                "WIDGET_LOADING": "Loading...",
                "WIDGET_OPTIONS_ERR": "Failed to load visualization options",
                "WIDGET_TYPE": "Visualization",
                "WORD_CLOUD": "Word Cloud",
                "WORD_CLOUD_DESC": "A weighted visualization of word frequency in text data with additional color coding options."
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Remember, there are resources within your organization to help you interpret your feedback such as HR Partners, your manager, and/or a mentor.",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Pour yourself a cup of coffee and dive into your feedback.",
                "ABOUT_YOUR_REPORT_HEADER": "About your report",
                "ABOUT_YOUR_REPORT_LINE1": "Welcome to your 360 feedback report. This is a great opportunity to grow and develop yourself as a professional. In order to set yourself up for success when going through results, allow yourself sufficient time to go over the feedback. Feedback can be difficult to hear initially, but keep in mind that the purpose of this feedback is to accelerate your growth and development.",
                "ABOUT_YOUR_REPORT_LINE2": "As you go through your report, here are a few things to keep in mind.",
                "ADD_CONDITIONAL_TEXT": "Add conditional text",
                "ADD_CUSTOM_PALETTE": "Add Custom Palette",
                "ADD_DATA_SOURCE": "Add data source",
                "ADD_FOLLOWING": "Add following",
                "ADD_LABEL": "Add label",
                "ADVANCED_FILTER": "Advanced Filter",
                "AGREEMENT_CHART": "Agreement chart",
                "AGREEMENT_CHART_FOOTER": "The agreement chart indicates the similarity of scores. Each dot represents how individuals rated you for each item. The size of the dot shows how many raters gave you a specific rating.",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "responses",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "response",
                "AGREEMENT_CHART_LEGEND_TITLE": "How others rated you",
                "ALL": "All",
                "AND_IF": "And if",
                "ANGLED": "Angled",
                "AREA": "Area",
                "AUTO": "Auto",
                "AVERAGE": "Average",
                "AXIS_VALUES": "Axis Values",
                "BAR": "Bar",
                "BASE_WORD_COLOR": "Base Word Color",
                "BLUR": "Blur",
                "BOTTOM_BOX": "Bottom Box",
                "BREAKOUT_HEADERS": "Breakout Headers",
                "CANCEL": "Cancel",
                "CATEGORICAL": "Categorical",
                "CATEGORY": "Category",
                "CATEGORY_NAME": "Category Name",
                "CHANGE_CATEGORIES_ORDER": "Change categories order",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "Change the scoring categories order",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "Change the order that appears in the visualization by clicking on the left of the scoring category element and dragging it to its desired position.",
                "CHANGE_QUESTIONS_ORDER": "Change questions order",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "Change the questions order",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "Change the order that appears in the visualization by clicking on the left of the question element and dragging it to its desired position.",
                "CHARTS": "Charts",
                "CHART_TYPE": "Chart Type",
                "CHOICE_COUNT": "Choice Count",
                "CHOICE_TOTALS": "Choice Totals",
                "CLEAR": "Clear",
                "CLOSE": "Close",
                "COLOR_PALETTE": "Color Palette",
                "COLUMN_NAMES": "Column Names",
                "COLUMN_TOTALS": "Column Totals",
                "COMPARED_FILTER_GROUP": "Compared Filter Group",
                "COMPARED_FILTER_GROUPS": "Compared Filter Groups",
                "COMPARE_WITH": "compare with",
                "COMPETITION_RANKING": "Use competition ranking",
                "COMPETITION_RANKING_TOOLTIP": "In the event of a tie, all equal scores are given the same ranking. However, the next subsequent Item will be ranked equal to: the total number of Items ranked higher in the table, plus one.",
                "COMPLETED_RESPONSES": "Completed responses",
                "CONDITIONAL_TEXT": "Conditional text",
                "COUNT": "Count",
                "CREATE": "Create",
                "CUSTOM_PALETTE": "Custom Palette",
                "DATA_SOURCE_TYPE": "Data Source Type",
                "DATA_SOURCE_TYPE_CATEGORY": "Scoring Categories",
                "DATA_SOURCE_TYPE_QUESTION": "Questions",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "Question",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "Rankable Items",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "Scoring Category",
                "DEFAULT": "Default",
                "DEFAULT_TEXT": "Default text",
                "DELETE": "Delete",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "Understand who your feedback is coming from, whether it’s peers, direct reports, leaders, etc",
                "DIFFERENT_EVALUATORS_HEADER": "Different evaluators",
                "DIRECT_REPORTS": "Direct reports",
                "DISABLED": "Disabled",
                "DISPLAY_OPTIONS": "Display Options",
                "DISPLAY_THRESHOLD_TEXTS": "Display text based on the following groups gap",
                "DIVERGENT": "Divergent",
                "DONE": "Done",
                "DONT_HEADER": "Don't:",
                "DONT_LINE1": "Try to figure out who said what",
                "DONT_LINE2": "Focus on one positive or negative score/comment",
                "DONT_LINE3": "Create a development plan around every item",
                "DONT_LINE4": "Be discouraged that you have opportunities for improvement",
                "DONUT": "Donut",
                "DOWNLOAD_CSV": "Download Legacy CSV",
                "DOWNLOAD_ZIP": "Download all files",
                "DO_HEADER": "Do:",
                "DO_LINE1": "Look at feedback holistically",
                "DO_LINE2": "Identify themes in strengths and opportunities for improvement",
                "DO_LINE3": "Prioritize a few focus areas to add to your development plan",
                "DO_LINE4": "Understand that everyone has opportunities for improvement",
                "DROPOFF": "Dropoff",
                "DUPLICATE": "Duplicate",
                "EDIT_CONDITIONAL_TEXT": "Edit conditional text",
                "EDIT_CUSTOM_PALETTE": "Edit Custom Palette",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "Else show the following text",
                "ENABLED": "Enabled",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "Enable ordering by rater category display logic",
                "ENABLE_ORDERING_FOR": "Enable ordering for",
                "EQUAL_TO": "Equal to",
                "FIELD": "Field",
                "FILTER_NAMES": "Filter Names",
                "FOLLOWING_PARENTHESES": "(following)",
                "FOOTER": "Footer",
                "GAP": "Gap",
                "GAP_CHART": "Gap chart",
                "GAP_CHART_DESCRIPTION": "The gap chart displays the difference in scores between two rater groups. For example, in the case of self-ratings vs. how others rated you, a positive(+) difference means others rated you higher than the rating you provided for yourself. A negative(-) difference means others rated you lower than you provided for yourself.",
                "GAP_CHART_FOOTER": "The gap chart indicates the +/- difference between two rater groups.",
                "GAP_TABLE_DESCRIPTION": "Hidden strengths shows where others rated you higher than you rated yourself. Areas for improvement shows where others rated you lower than you rated yourself. Both sections are ranked from largest to smallest gap.",
                "GAP_TABLE_FOOTER": "The first column of scores indicates how you scored yourself. The second column indicates the average score of others. The third column indicates the difference between how you scored yourself and how others scored you.",
                "GAP_TABLE_TITLE": "Hidden strengths/Improvement areas",
                "GREATER_OR_EQUAL": "Greater or equal",
                "GREATER_THAN": "Greater than",
                "GROUP": "Group",
                "GROUPED_FOR_ANONYMITY": "Grouped for Anonymity",
                "HEADER_NAMES": "Header Names",
                "HIGHEST_SCORES": "Highest scores",
                "HIGHLIGHT_THRESHOLD": "Threshold to highlight gaps",
                "HIGHLOW_TABLE": "High and low scores",
                "HIGHLOW_TABLE_FOOTER": "This section shows the five highest and lowest rated behaviors (across all behaviors) from the applicable rater category averages. To get the most from this page, it is helpful to look for trends that may emerge. For example, if the majority of your lowest rated behaviors are concentrated in one or two categories; these may be areas in need of development. The highest rated behaviors can identify strengths that can be leveraged in other areas.",
                "HIGH_LOW_TABLE_DESCRIPTION": "The high/low chart displays items based on the areas where others rated you highest and lowest.",
                "HORIZONTAL": "Horizontal",
                "HORIZONTAL_AND_VERTICAL": "Horizontal & Vertical",
                "HORIZONTAL_BAR": "Horizontal Bar",
                "HOW_TO_INTERPRET_RESULT_HEADER": "How to interpret results and determine action:",
                "IF": "If",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "Include hidden labels in percents",
                "INNER_RIM": "Inner Rim",
                "IS": "Is",
                "IS_NOT": "Is not",
                "IS_SAME_AS_SUBJECT": "Is same as subject",
                "ITEM": "Item",
                "LABEL": "label",
                "LABELS": "Labels",
                "LARGE_LABELS": "Large Labels",
                "LEGEND": "Legend",
                "LEGEND_POSITION": "Legend Position",
                "LEGEND_VALUES": "Legend Values",
                "LESS_OR_EQUAL": "Less or equal",
                "LESS_THAN": "Less than",
                "LINE": "Line",
                "LOWEST_SCORES": "Lowest scores",
                "MANAGERS": "Managers",
                "MANUAL_FONT_SIZE": "Set font size manually",
                "MAX": "Max",
                "MEAN": "Mean",
                "MEDIAN": "Median",
                "METRIC_TYPE": "Metric type",
                "MIN": "Min",
                "MODIFY_CUSTOM_PALETTES": "Modify Custom Palettes",
                "MOVE_DOWN": "Move down",
                "MOVE_UP": "Move up",
                "MULTI_SELECT_ITEMS_SELECTED": "selected",
                "NEGATIVE_GAPS": "Areas for improvement",
                "NO": "No",
                "NONE": "None",
                "NOT_APPLICABLE": "N/A",
                "NOT_EQUAL_TO": "Not equal to",
                "NO_DATA_AVAILABLE_WARNING": "No data available",
                "NO_FILTER": "No filter",
                "NO_FILTER_IS_APPLIED": "No filter is applied.",
                "NO_VALUE": "No value",
                "NPS": "Net Promoter Score",
                "NUMBER": "number",
                "NUMBERS": "Numbers",
                "NUMBER_OF_GAPS_NEGATIVE": "Number of Negative Gaps",
                "NUMBER_OF_GAPS_POSITIVE": "Number of Positive Gaps",
                "NUMBER_OF_ROWS_HIGH": "Number of High Rows",
                "NUMBER_OF_ROWS_LOW": "Number of Low Rows",
                "OPTIONS": {
                    "HEADER_NAME": "Header name",
                    "LEGEND": "Legend",
                    "SCALE_AXIS_CHANGER_TITLE": "Range"
                },
                "ORIENTATION": "Orientation",
                "OR_IF": "Or if",
                "OTHER": "Other",
                "OTHERS": "Others",
                "PAGE_OF": "Page: %1 Of %2",
                "PALETTE_REMOVED": "Palette Removed",
                "PEERS": "Peers",
                "PERCENT": "Percent",
                "PERCENTAGE": "Percentage",
                "PERCENTAGE_OF_CHOICES": "Percentage of Choices",
                "PERCENTAGE_OF_RESPONSES": "Percentage of Responses",
                "PERCENT_COMPLETE": "% complete",
                "PERSON_METADATA": "Person metadata",
                "PERSON_METADATA_EVALUATOR": "Evaluator's",
                "PERSON_METADATA_SUBJECT": "Subject's",
                "PERSON_METADATA_VIEWER": "Viewer's",
                "POSITIVE_GAPS": "Hidden strengths",
                "PRIMARY_PARENTHESES": "(primary)",
                "QUESTIONS": "Questions",
                "RADIUS": "Radius",
                "RANK": "Rank",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "Highest score",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "Highest scores",
                "RANKABLE_ITEMS_ITEM_HAS": "Item has",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "Item is in top",
                "RANKABLE_ITEMS_LOWEST_SCORE": "Lowest score",
                "RANKABLE_ITEMS_LOWEST_SCORES": "Lowest scores",
                "RATER_CATEGORY_DISPLAY_LOGIC": "rater category display logic",
                "RATIO": "Ratio",
                "RECORD": "Record",
                "REFERENCE_GROUP": "Reference group",
                "RELATIONSHIP": "Relationship",
                "RELATIONSHIP_FILTERS": "Relationship filters",
                "RELATIONSHIP_FILTERS_INFO": "To add a relationship filter (such as a direct report, peer, or manager), select Manage your filters, and use Relationship condition only from the drop-down menu.",
                "REMOVE": "Remove",
                "REMOVE_DATA_SOURCE": "Remove data source",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Remember, there are resources within your organization to help you interpret your feedback such as HR Partners, your manager, and/or a mentor.",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Pour yourself a cup of coffee and dive into your feedback.",
                    "ABOUT_YOUR_REPORT_HEADER": "About your report",
                    "ABOUT_YOUR_REPORT_LINE1": "Welcome to your 360 feedback report. This is a great opportunity to grow and develop yourself as a professional. In order to set yourself up for success when going through results, allow yourself sufficient time to go over the feedback. Feedback can be difficult to hear initially, but keep in mind that the purpose of this feedback is to accelerate your growth and development.",
                    "ABOUT_YOUR_REPORT_LINE2": "As you go through your report, here are a few things to keep in mind.",
                    "ADVANCED_FILTER": "Advanced Filter",
                    "AGREEMENT_CHART": "Agreement chart",
                    "AGREEMENT_CHART_FOOTER": "The agreement chart indicates the similarity of scores. Each dot represents how individuals rated you for each item. The size of the dot shows how many raters gave you a specific rating.",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "responses",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "response",
                    "AGREEMENT_CHART_LEGEND_TITLE": "How others rated you",
                    "ALL": "All",
                    "AVERAGE": "Average",
                    "BOTTOM_BOX": "Bottom Box",
                    "CHOICE_COUNT": "Choice Count",
                    "CHOICE_TOTALS": "Choice Totals",
                    "COMPARISON": "Comparison",
                    "COMPARISON_GAP_COLUMN_HEADER": "Comparison gap",
                    "COMPLETED_RESPONSES": "Completed responses",
                    "COUNT": "Count",
                    "DEFAULT": "Default",
                    "DEFAULT_TEXT": "Default text",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "Understand who your feedback is coming from, whether it’s peers, direct reports, leaders, etc",
                    "DIFFERENT_EVALUATORS_HEADER": "Different evaluators",
                    "DONE": "Done",
                    "DONT_HEADER": "Don't:",
                    "DONT_LINE1": "Try to figure out who said what",
                    "DONT_LINE2": "Focus on one positive or negative score/comment",
                    "DONT_LINE3": "Create a development plan around every item",
                    "DONT_LINE4": "Be discouraged that you have opportunities for improvement",
                    "DO_HEADER": "Do:",
                    "DO_LINE1": "Look at feedback holistically",
                    "DO_LINE2": "Identify themes in strengths and opportunities for improvement",
                    "DO_LINE3": "Prioritize a few focus areas to add to your development plan",
                    "DO_LINE4": "Understand that everyone has opportunities for improvement",
                    "FIELD": "Field",
                    "GAP": "Gap",
                    "GAP_CHART": "Gap chart",
                    "GAP_CHART_DESCRIPTION": "The gap chart displays the difference in scores between two rater groups. For example, in the case of self-ratings vs. how others rated you, a positive(+) difference means others rated you higher than the rating you provided for yourself. A negative(-) difference means others rated you lower than you provided for yourself.",
                    "GAP_CHART_FOOTER": "The gap chart indicates the +/- difference between two rater groups.",
                    "GAP_TABLE_DESCRIPTION": "Hidden strengths shows where others rated you higher than you rated yourself. Areas for improvement shows where others rated you lower than you rated yourself. Both sections are ranked from largest to smallest gap.",
                    "GAP_TABLE_FOOTER": "The first column of scores indicates how you scored yourself. The second column indicates the average score of others. The third column indicates the difference between how you scored yourself and how others scored you.",
                    "GAP_TABLE_TITLE": "Hidden strengths/Improvement areas",
                    "GROUP": "Group",
                    "HIDE_REPORT_ALERT": "You do not meet the requirements to view your report. Contact your organization administrator.",
                    "HIGHEST_SCORES": "Highest scores",
                    "HIGHLOW_TABLE": "High and low scores",
                    "HIGHLOW_TABLE_FOOTER": "This section shows the five highest and lowest rated behaviors (across all behaviors) from the applicable rater category averages. To get the most from this page, it is helpful to look for trends that may emerge. For example, if the majority of your lowest rated behaviors are concentrated in one or two categories; these may be areas in need of development. The highest rated behaviors can identify strengths that can be leveraged in other areas.",
                    "HIGH_LOW_TABLE_DESCRIPTION": "The high/low chart displays items based on the areas where others rated you highest and lowest.",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "How to interpret results and determine action:",
                    "ITEM": "Item",
                    "LOWEST_SCORES": "Lowest scores",
                    "MAX": "Max",
                    "MEAN": "Mean",
                    "MEDIAN": "Median",
                    "MIN": "Min",
                    "NEGATIVE_GAPS": "Areas for improvement",
                    "NO_COMPARISON_SET": "No comparison set",
                    "NO_DATA_AVAILABLE_WARNING": "No data available",
                    "NO_FILTER_IS_APPLIED": "No filter is applied.",
                    "NO_VALUE": "No value",
                    "NPS": "Net Promoter Score",
                    "OTHERS": "Others",
                    "PERCENTAGE": "Percentage",
                    "PERCENTAGE_OF_CHOICES": "Percentage of Choices",
                    "PERCENTAGE_OF_RESPONSES": "Percentage of Responses",
                    "PERCENT_COMPLETE": "% complete",
                    "POSITIVE_GAPS": "Hidden strengths",
                    "QUESTIONS": "Questions",
                    "RANK": "Rank",
                    "RELATIONSHIPS": {
                        "ANYONE": "Anyone",
                        "DIRECT_REPORT": "Direct Report",
                        "MANAGER": "Manager",
                        "PEER": "Peer",
                        "SELF": "Self"
                    },
                    "REPORT_SUMMARY": "Report summary",
                    "REPORT_SUMMARY_TABLE_FOOTER": "Compare the number of people who finished your assessment to the number of people invited to participate.",
                    "REPORT_SUMMARY_TABLE_HEADER": "Respondent statistics",
                    "RESPONSES": "Responses",
                    "RESPONSE_COUNT": "{{responseCount}} Responses",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Responses",
                    "SCORING_CATEGORY": "Scoring category",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "No responses for this category",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "No responses for this question",
                    "SCORING_OVERVIEW": "Scoring overview",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "You and other evaluators think this area is a top strength.",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Recognized strength",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "A recognized improvement area means self-rating and ratings from others are both below the average for this competency.",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Recognized improvement area",
                    "SCORING_OVERVIEW_DESCRIPTION": "Above are the competencies or behaviors that you were evaluated on as a part of this multi-rater feedback process. Comparison ratings are provided by group.",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "Minimum gap",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Minimum difference between reference groups for texts to be shown.",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "Displayed is the range of scores for each competency/behavior. The bar represents the numerical average.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Unrecognized strength comes from discrepancy between the self-rating and the ratings from others.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Unrecognized strength",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Unrecognized improvement area comes from discrepancy between the self-rating and the ratings from others.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Unrecognized improvement area",
                    "SELF": "Self",
                    "SELF_ASSESSMENT": "Self-assessment",
                    "STANDARD_DEVIATION": "Standard Deviation",
                    "SUM": "Sum",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Familiarize yourself with the rating scale to ensure accurate interpretation",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "Take note of the scale",
                    "THINGS_YOU_WILL_SEE_HEADER": "Things you will see:",
                    "THREE_SIXTY_PERCENTILE": "Percentile",
                    "TOP_BOTTOM_BOX": "Top Box / Bottom Box",
                    "TOP_BOX": "Top Box",
                    "TOTAL": "Total",
                    "TO_DO": "To do",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Qualitative: This feedback will be in the form of open text comments",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Quantitative: This feedback will be numerical, and could be represented in graphs, bar charts, tables, etc.",
                    "TYPES_OF_FEEDBACK_HEADER": "Various types of feedback",
                    "VALUE": "Value",
                    "VARIANCE": "Variance",
                    "YOUR_RATINGS": "Your ratings"
                },
                "REPORT_SUMMARY": "Report summary",
                "REPORT_SUMMARY_TABLE_FOOTER": "Compare the number of people who finished your assessment to the number of people invited to participate.",
                "REPORT_SUMMARY_TABLE_HEADER": "Respondent statistics",
                "RESET": "Reset",
                "RESPONDENT_TOTALS": "Respondent Totals",
                "RESPONSES": "Responses",
                "RESPONSE_COUNT": "{{responseCount}} Responses",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Responses",
                "RESULT": "Result",
                "REVERSE_COLORS": "Reverse Colors",
                "ROW_TOTALS": "Row Totals",
                "SAVE": "Save",
                "SAVE_AND_APPLY": "Save and apply",
                "SCORING_CATEGORY": "Scoring category",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "No responses for this category",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "No responses for this question",
                "SCORING_OVERVIEW": "Scoring overview",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "You and other evaluators think this area is a top strength.",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Recognized strength",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "A recognized improvement area means self-rating and ratings from others are both below the average for this competency.",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Recognized improvement area",
                "SCORING_OVERVIEW_DESCRIPTION": "Above are the competencies or behaviors that you were evaluated on as a part of this multi-rater feedback process. Comparison ratings are provided by group.",
                "SCORING_OVERVIEW_MINIMUM_GAP": "Minimum gap",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Minimum difference between reference groups for texts to be shown.",
                "SCORING_OVERVIEW_TABLE_FOOTER": "Displayed is the range of scores for each competency/behavior. The bar represents the numerical average.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Unrecognized strength comes from discrepancy between the self-rating and the ratings from others.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Unrecognized strength",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Unrecognized improvement area comes from discrepancy between the self-rating and the ratings from others.",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Unrecognized improvement area",
                "SELECT_CATEGORIES": "Please select Scoring Categories...",
                "SELECT_CATEGORY": "Please select a Scoring Category...",
                "SELECT_CONDITION_TYPE": "Select condition type",
                "SELECT_DATA_SOURCE": "Select data source",
                "SELECT_DATA_SOURCE_TYPE": "Select data source type",
                "SELECT_FILTER": "Select filter",
                "SELECT_FILTERS": "Select filters",
                "SELECT_OPERATOR_TYPE": "Select operator type",
                "SELECT_PERSON": "Select person",
                "SELECT_PERSON_METADATA": "Select person metadata",
                "SELECT_QUESTION": "Select question",
                "SELECT_QUESTIONS": "Please select Questions...",
                "SELECT_RATIO_OR_DROPOFF": "Select ratio or dropoff",
                "SELECT_RELATIONSHIP": "Select relationship",
                "SELECT_SCORING_CATEGORY": "Select scoring category",
                "SELF": "Self",
                "SELF_ASSESSMENT": "Self-assessment",
                "SEQUENTIAL": "Sequential",
                "SETUP_COMPARISON": "Setup comparison",
                "SETUP_COMPARISONS": "Setup comparisons",
                "SET_START_COLOR": "Set Start Color",
                "SHOULD_SHOW_FOOTER": "Show Footer",
                "SHOULD_SHOW_SCORING_CATEGORY": "Show Scoring Category",
                "SHOWING_RECORDS_OF": "Showing records %1 - %2 of %3",
                "SHOW_COMPARISON_GAP": "Show comparison gap column",
                "SHOW_DATA_LABEL": "Show data values",
                "SHOW_PERCENTAGES": "Show Percentages",
                "SHOW_THE_FOLLOWING_TEXT": "Then show the following text",
                "SHOW_TIES": "Show Ties",
                "SHOW_X_AXIS": "Show X Axis",
                "SHOW_Y_AXIS": "Show Y Axis",
                "SMALL_LABELS": "Small Labels",
                "SORT": "Sort",
                "SPLINE": "Spline",
                "STACK_CHART": "Stack Chart",
                "STANDARD_DEVIATION": "Standard Deviation",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "Weakness less than",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "Edit threshold texts",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "Threshold texts",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "Enable threshold texts",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "Strength more than",
                "SUM": "Sum",
                "SUMMARY": "Summary",
                "TABLES": "Tables",
                "TABLE_TOTALS": "Table Totals",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Familiarize yourself with the rating scale to ensure accurate interpretation",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "Take note of the scale",
                "TEXT": "Text",
                "THINGS_YOU_WILL_SEE_HEADER": "Things you will see:",
                "TOP_BOTTOM_BOX": "Top Box / Bottom Box",
                "TOP_BOX": "Top Box",
                "TOTAL": "Total",
                "TOTAL_COUNTS": "Total Counts",
                "TO_DO": "To do",
                "TRANSPOSE": "Transpose",
                "TRANSPOSE_TABLE": "Transpose table",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Qualitative: This feedback will be in the form of open text comments",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Quantitative: This feedback will be numerical, and could be represented in graphs, bar charts, tables, etc.",
                "TYPES_OF_FEEDBACK_HEADER": "Various types of feedback",
                "UNDO": "Undo",
                "USE_COMPARISON": "Use comparison",
                "USE_LABELS_FOR_SCALES": "Use labels for scales",
                "VALUES": "Values",
                "VALUE_RANGES": "Value Ranges",
                "VARIANCE": "Variance",
                "VERTICAL": "Vertical",
                "VERTICAL_RANGE": "Vertical Range",
                "WARNING_DATA_OUT_OF_RANGE": "Warning: data value exceeds range configuration",
                "WIDGET_ERROR": {
                    "ERROR": "An unexpected error has occurred",
                    "MISCONFIGURED": "This widget is not configured correctly. Please check your widget configuration.",
                    "NEW": "Please configure widget",
                    "NO_DATA": "No data found - your filters may be too exclusive!"
                },
                "WIDGET_NAME": {
                    "BAR": "Bar Chart",
                    "BREAKDOWNBAR": "Breakdown Bar",
                    "DATA_TABLE": "Data Table",
                    "FUNNEL_CHART": "Funnel Chart",
                    "GAUGE": "Gauge Chart",
                    "GRID": "Results Table",
                    "HEATMAP": "Heat Map",
                    "LINE": "Line Chart",
                    "NEEDS_BASED": "Needs Based",
                    "PIE": "Pie Chart",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "Price Estimator (Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "Revenue Maximizer (Gabor Granger)",
                    "SCORING_OVERVIEW_CHART": "Chart",
                    "SCORING_OVERVIEW_TABLE": "Table",
                    "STATS_TABLE": "Statistics Table",
                    "WORDCLOUD": "Word Cloud"
                },
                "WORD_ROTATION": "Word rotation",
                "WORD_SPACING": "Word spacing",
                "YES": "Yes",
                "YOUR_RATINGS": "Your ratings"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "Add",
                "ADD_A_WORD": "Add a word",
                "COLOR": "Color",
                "DELETE_ALL": "Delete all",
                "EDIT_STOP_WORDS": "Edit Stop Words",
                "MAX_WORDS": "Max Words",
                "ROTATION_ANGLED": "Angled",
                "ROTATION_HORIZONTAL": "Horizontal",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "Horizontal and Vertical",
                "WORD_ORIENTATION": "Word Orientation"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "Background Colors",
                "DISPLAY_OPTIONS": "Display Options",
                "INVERT_FONT_COLORS": "Invert Low Contrast Font Colors",
                "PAGE": "Page",
                "PAGINATE": "Paginate"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "Mean",
                "BOTTOM_BOX_METRIC": "Bottom Box",
                "COLUMNS": "Columns",
                "COUNT_METRIC": "Total Responses",
                "FIELD_NAME": "Field",
                "MAX_METRIC": "Maximum",
                "MIN_METRIC": "Minimum",
                "SHOW_RECODES": "Show Recode Values",
                "SHOW_ROW_NUMBERS": "Show Row Numbers",
                "STD_DEV_METRIC": "Std Deviation",
                "TOP_BOX_METRIC": "Top Box",
                "TRANSPOSE_BREAKOUTS": "Transpose Breakouts",
                "TRANSPOSE_TABLE": "Transpose Table",
                "VAR_METRIC": "Variance"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "Additional Columns",
                "ADD_COLUMNS": "Add Additional Columns",
                "ADD_CUSTOM_PALETTE": "Add Custom Palette",
                "ALL_CHOICES": "All Choices",
                "ALL_GROUPS": "All Groups",
                "ALL_RECODES": "All Recodes",
                "AUTOMATIC": "Default",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "Default - Click to edit",
                "AXIS_VALUES": "Axis Values",
                "BREAKOUT_BY": "Breakout By",
                "CANCEL": "Cancel",
                "CATEGORICAL": "Categorical",
                "CHOICES": "Choices",
                "CHOICE_COUNT": "Choice Count",
                "COLOR_PALETTE": "Color Palette",
                "COLUMN_VALUES": "Column Values",
                "CONTACT_FIELDS": "Contact Fields",
                "COUNT": "Count",
                "CREATE": "Create",
                "CUSTOM": "Custom",
                "CUSTOM_PALETTE": "Custom Palette",
                "DATA_SOURCE": "Data Source",
                "DAY": "Day",
                "DAY_OF_WEEK": "Day of Week",
                "DECIMAL_PRECISION": "Decimal Places",
                "DEFAULT": "Default",
                "DISABLED": "Disabled",
                "DIVERGENT": "Divergent",
                "EDIT_CUSTOM_PALETTE": "Edit Custom Palette",
                "ENABLED": "Enabled",
                "ERROR_LOADING_DATA": "Error loading data",
                "FILE_SIZE": "Size",
                "FILE_TYPE": "Type",
                "FRI": "Fri",
                "FRIDAY": "Friday",
                "GROUP_DATE_BY": "Group Date By",
                "HOUR_OF_DAY": "Hour of Day",
                "LENGEND_VALUES": "Legend Values",
                "MAX": "Max",
                "MEAN": "Mean",
                "MIN": "Min",
                "MISCONFIGURED_DATA": "Data source misconfigured for this visualization.",
                "MISCONFIGURED_FILTERS": "Invalid Filter(s)",
                "MODIFY_CUSTOM_PALETTES": "Modify Custom Palettes",
                "MON": "Mon",
                "MONDAY": "Monday",
                "MONTH": "Month",
                "NONE": "None",
                "NO_FILE_ID_ERROR": "This visualization requires an image to be set in the survey",
                "NO_RESULTS_TO_SHOW": "No results to show",
                "NPS": "Net Promoter Score®",
                "NPS_GROUP": "NPS® group",
                "NUMERIC_VALUE": "Numeric Value",
                "PALETTE_REMOVED": "Palette Removed",
                "PERCENTAGE": "Percentage",
                "PERCENTAGE_OF_CHOICES": "Percentage of Choices",
                "PERCENTAGE_OF_RESPONSES": "Percentage of Responses",
                "QUARTER": "Quarter",
                "REMOVE": "Remove",
                "RESPONSE_COUNT": "Response Count",
                "RESULTS_PER_PAGE": "Results per page",
                "RETRIEVING_DATA_ELLIPSIS": "Retrieving data...",
                "REVERSE_COLORS": "Reverse Colors",
                "ROW_VALUES": "Row Values",
                "SAT": "Sat",
                "SATURDAY": "Saturday",
                "SAVE": "Save",
                "SELECTED_CHOICE": "Selected Choice",
                "SELECT_FIELD": "Select Field",
                "SELECT_METRIC": "Metric",
                "SEQUENTIAL": "Sequential",
                "SET_START_COLOR": "Set Start Color",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "Showing sample data...",
                "SUM": "Sum",
                "SUN": "Sun",
                "SUNDAY": "Sunday",
                "SURVEY_EMBEDDEDDATA": "Embedded Data",
                "SURVEY_METADATA": "Survey Metadata",
                "TEXT_ENTRY": "Text entry",
                "THURS": "Thurs",
                "THURSDAY": "Thursday",
                "TITLE": "Title",
                "TUES": "Tues",
                "TUESDAY": "Tuesday",
                "UNBOUNDED_DOMAIN": "Too many values to display.",
                "UNBOUNDED_DOMAIN_HELP": "To add this field to Results Reports, you can add a filter to report to display fewer values for \"{{ed_field_name}}\" or update the embedded data variable type of \"{{ed_field_name}}\" in your survey flow to make this field a string or numeric type.",
                "UNDO": "Undo",
                "USE_CHOICE_TOTALS": "Use Choice Totals",
                "USE_RESPONDENT_TOTALS": "Use Respondent Totals",
                "VISUALIZATION": "Visualization",
                "VISUALIZATION_BARCHART": "Bar Chart",
                "VISUALIZATION_BREAKDOWNBAR": "Breakdown Bar",
                "VISUALIZATION_GAUGE": "Gauge Chart",
                "VISUALIZATION_HEATMAP": "Heat Map",
                "VISUALIZATION_LINECHART": "Line Chart",
                "VISUALIZATION_PAGINATEDTABLE": "Paginated Table",
                "VISUALIZATION_PIE": "Pie Chart",
                "VISUALIZATION_SIMPLETABLE": "Simple Table",
                "VISUALIZATION_STATSTABLE": "Statistics Table",
                "VISUALIZATION_TEXTHIGHLIGHTS": "Text Highlights",
                "VISUALIZATION_WORDCLOUD": "Word Cloud",
                "WED": "Wed",
                "WEDNESDAY": "Wednesday",
                "WEEK": "Week",
                "WEIGHTING": "Weighting",
                "WRONG_QUESTION_TYPE_ERROR": "This visualization type cannot be used for this question",
                "YEAR": "Year"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "Average",
                "CHOICE_COUNT": "Choice Count",
                "COUNT": "Count",
                "DISPLAY_OPTIONS": "Display Options",
                "MAX": "Maximum",
                "MIN": "Minimum",
                "NPS": "NPS®",
                "PAGE_OF": "Page: %1 Of %2",
                "PERCENT": "Percentage",
                "RESPONSE_COUNT": "Response Count",
                "ROWS_PER_TABLE": "Rows Per Table",
                "SHOWING_ROWS_OF": "Showing rows %1 - %2 of %3",
                "SHOW_PERCENTAGES": "Show Percentages",
                "SHOW_RECODES": "Show Recode Values",
                "SHOW_ROW_NUMBERS": "Show Row Numbers",
                "SUM": "Sum",
                "TOTAL": "Total",
                "TRANSPOSE": "Transpose",
                "USE_COLUMN_TOTALS": "Use Column Totals",
                "USE_ROW_TOTALS": "Use Row Totals",
                "VALUE": "Value"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "Ascending",
                "COUNT": "Count",
                "DESCENDING": "Descending",
                "DIAGONAL": "Diagonal",
                "DISPLAY_OPTIONS": "Display Options",
                "ERROR_COLON": "Error:",
                "ERROR_GENERIC": "An error occurred while loading the visualization.",
                "HORIZONTAL": "Horizontal",
                "HORIZONTAL_BARS": "Horizontal Bars",
                "INCORRECTLY_CONFIGURED": "Choose a value to display chart",
                "LEGEND_AUTO": "Auto",
                "LEGEND_BOTTOM": "Bottom",
                "LEGEND_INSET": "Inset",
                "LEGEND_RIGHT": "Right",
                "NORMALIZE_TO_PERCENTAGES": "Normalize to Percentages",
                "SHOW_BAR_LABELS": "Show Bar Labels",
                "SHOW_LEGEND": "Show Legend",
                "SHOW_X_AXIS": "Show X Axis",
                "SHOW_Y_AXIS": "Show Y Axis",
                "SORT_BAR_VALUES": "Sort Bar Values",
                "STACKED_BARS": "Stacked Bars",
                "TRANSPOSE": "Transpose",
                "TRUNCATE_LABELS": "Truncate Labels",
                "VERTICAL": "Vertical"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "All Others",
                "COULD_NOT_LOAD_DATA": "Couldn't load data with specified configuration — try a different source field or a larger date range.",
                "GROUPING_PERCENTAGE_THRESHOLD": "Grouping Percentage Threshold",
                "NO_DATA": "No Data",
                "RADIUS": "Inner Radius",
                "SHOW_AS_PERCENTAGES": "Show As Percentages"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "Close",
                "DOWNLOAD_CSV": "Download CSV",
                "DOWNLOAD_ZIP": "Download all files",
                "NO_DATA": "No Data",
                "PAGE_OF": "Page: %1 Of %2",
                "RESULTS_PER_PAGE": "Results per page",
                "SHOWING_RECORDS_OF": "Showing records %1 - %2 of %3",
                "SINGLE_RESPONSE": "Single Response",
                "VIEW_RESPONSE": "View Response"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "Display Options",
                "ERROR_COLON": "Error:",
                "ERROR_GENERIC": "An error occurred while loading the visualization.",
                "HORIZONTAL_BARS": "Horizontal Bars",
                "INCORRECTLY_CONFIGURED": "Choose a value to display chart",
                "LEGEND_AUTO": "Auto",
                "LEGEND_BOTTOM": "Bottom",
                "LEGEND_INSET": "Inset",
                "LEGEND_RIGHT": "Right",
                "NORMALIZE_TO_PERCENTAGES": "Normalize to Percentages",
                "SHOW_AREA": "Show Area",
                "SHOW_LEGEND": "Show Legend",
                "SHOW_X_AXIS": "Show X Axis",
                "SHOW_Y_AXIS": "Show Y Axis",
                "SMOOTH_LINES": "Smooth Lines",
                "SORT_X_AXIS_LABELS": "Sort X Axis Labels",
                "STACKED_BARS": "Stacked Bars",
                "TRANSPOSE": "Transpose"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "Block Mode",
                "BLUR": "Blur",
                "COULD_NOT_LOAD_DATA": "Couldn't load data with specified configuration — try a different source field or a larger date range.",
                "FIELD": "Field",
                "RADIUS": "Radius",
                "SHOW_REGIONS": "Show Regions",
                "SHOW_REGION_LABELS": "Show Region Labels"
            },
            "GAUGEWIDGET": {
                "MAX": "Max",
                "MIN": "Min",
                "VALUE_RANGES": "Value ranges"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "Bottom labels",
                "CATEGORY_NAME": "Category name",
                "ERROR_COLON": "Error:",
                "INCLUDE_HIDDEN_GROUPS": "Include hidden groups in percents",
                "LARGE_LABELS": "Large labels",
                "NO": "No",
                "PERCENT": "Percent",
                "RESPONSE_COUNT": "Response count",
                "RESPONSE_COUNT_WITH_VALUE": "{{ responseCount }} responses",
                "SMALL_LABELS": "Small labels",
                "YES": "Yes"
            }
        });
        $cache.put('ES-ES', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "Código de acceso",
                "ACCESS_CODE_PROTECTION": "Protección de código de acceso",
                "ADD": "Añadir",
                "ADD_BREAKOUT": "Añadir desglose de informe",
                "ADD_NOTE": "Añadir nota",
                "ADD_SCHEDULED_REPORT": "Añadir informe programado",
                "ADD_WIDGET": "Añadir visualización",
                "ALL_PROJECTS": "Todos los proyectos",
                "ALL_QUESTIONS": "Páginas de preguntas",
                "ANSWER": "Respuesta",
                "ANY_CHANGES_LOST": "Cualquier cambio en los informes se perderá al salir de plataforma Qualtrics XM.",
                "APPENDED_COPY_IN_PARENS": "(Copiar)",
                "AREA_CHART": "Gráfico de área",
                "AREA_CHART_DESC": "Un gráfico de líneas de dos ejes con el área bajo la línea completa.",
                "ATTACHMENT": "Adjunto",
                "BACKUP_CURRENT_REPORT": "Guarde una copia de seguridad de este informe antes de que se vean afectadas las visualizaciones",
                "BACKUP_CURRENT_REPORT_LINE2": "Nota: La copia de seguridad se llamará \"{{nameOfReportCopy}}\"",
                "BACK_TO_REPORTS": "Volver a informes",
                "BACK_TO_TOP": "Volver arriba",
                "BACK_TO_VIEW_RESULTS": "Volver a los resultados de la vista anterior",
                "BAR_CHART": "Gráfico de barras",
                "BAR_CHART_DESC": "Un gráfico de barras de dos ejes que permite la configuración adicional de transposición de ejes y reorganización de puntos de datos.",
                "BREAKDOWN_BAR_CHART": "Barra de desglose",
                "BREAKDOWN_BAR_CHART_DESC": "Un gráfico de barras horizontales apiladas que generalmente se utiliza para sopesar visualmente las medidas entre sí como alternativa al gráfico circular.",
                "CANCEL": "Cancelar",
                "CANCEL_CONF_TEXT": "¿Seguro que desea cancelar?<br/>Se perderán todos los cambios.",
                "CANCEL_EDITS": "Cancelar ediciones",
                "CHART": "Gráfico",
                "CHOICE": "Opción",
                "CHOICES_COUNT_METRIC": "Recuento de opciones",
                "CHOOSE_PAGES_TO_DISPLAY": "Elegir páginas que mostrar",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "Este informe contiene {{maxReportPageCount}} páginas, pero los resultados solo pueden incluir hasta {{reportSizeLimit}}. Seleccione un subconjunto dentro del límite.",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "Los informes solo pueden contener un máximo de {{reportSizeLimit}} páginas; seleccione las páginas que desea.",
                "CLEAR_ALL": "Borrar todo",
                "CLOSE": "Cerrar",
                "CLOUD": "UNA DESCRIPCIÓN PARA LA NUBE",
                "COLLABORATED_NEW": "El propietario de esta encuesta está usando plataforma Qualtrics XM. Los informes de esta encuesta se editarán con la función Nuevos resultados.",
                "COMMA_SEPARATED_LIST": "Lista de elementos separados por comas",
                "COMPACTNESS": "Fuentes y espaciado",
                "COMPACTNESS_INFO": "Esta configuración afecta al relleno de tablas, al tamaño de fuente y al tamaño de barras de los gráficos. También se aplicará a la mayoría de las exportaciones.",
                "CONFIRM": "Aceptar",
                "CONFIRM_DELETE": "Confirmar eliminación",
                "CONFIRM_DELETE_PAGE": "¿Seguro que desea eliminar esta página?",
                "CONTINUE": "Continuar",
                "CONTINUE_EDITING": "Continuar la edición",
                "COPY": "Copiar",
                "COPY_OF_REPORT_NAME": "Copia de {{nameOfCurrentReport}}",
                "COPY_REPORT": "Copiar informe",
                "COPY_REPORT_ELLIPSIS": "Copiar informe...",
                "COPY_TO_NEW_REPORT": "Copiar al nuevo informe...",
                "CREATE": "Crear",
                "CREATED": "Creado",
                "CREATE_CUSTOM_PAGE": "Crear página personalizada",
                "CREATE_NEW_REPORT": "Crear nuevo informe",
                "CREATE_NEW_REPORT_ELLIPSIS": "Crear nuevo informe...",
                "CSV_FILE": "Archivo CSV",
                "CUSTOM_PAGES": "Páginas personalizadas",
                "DATE": "Fecha",
                "DEFAULT_PALETTE": "Paleta de colores por defecto",
                "DEFAULT_REPORT": "Informe por defecto",
                "DEFAULT_VISUALIZATIONS": "Visualizaciones predeterminadas",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "Estos son los tipos de visualización predeterminados empleados para generar informes de resultados predeterminados. Al actualizar y aplicar esta configuración, se volverá a generar su informe actual con la nueva configuración predeterminada. Contará con la opción para realizar una copia de seguridad del informe actual.",
                "DEFAULT_VISUALIZATIONS_NOTE": "Nota: No todos los tipos de visualizaciones se encuentran disponibles para todos los tipos de preguntas. Algunas visualizaciones no predeterminadas se pueden sustituir de forma automática.",
                "DEFAULT_VISUALS_DISCLAIMER": "Qualtrics actualizará este informe con la nueva configuración de visualización predeterminada.",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "Esta actualización afectará a {{amountOfWidgetsAffected}} visualizaciones en este informe.",
                "DEFAULT_VISUAL_EDIT_DETECTED": "Edición de visualización predeterminada detectada",
                "DELETE_BUTTON": "Eliminar",
                "DELETE_DISABLED_EXPLANATION": "No se permite eliminar los informes creados en la interfaz de informes anterior hasta que su organización haya realizado una migración completa a plataforma Qualtrics XM.",
                "DELETE_PAGE": "Eliminar página",
                "DELETE_PAGE_ELLIPSIS": "Eliminar página...",
                "DELETE_REPORT": "Eliminar informe",
                "DELETE_REPORT_ELLIPSIS": "Eliminar informe...",
                "DELETE_WIDGET_QUESTION": "¿Eliminar?",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "Este campo está cifrado y no se puede usar para ordenar.",
                "DISCARD_EDITS": "Descartar ediciones",
                "DISTRIBUTION_PAUSED": "Distribución de informe pausada.",
                "DONE_BUTTON": "Listo",
                "DONE_EDITING": "Edición realizada",
                "DOWNLOAD": "Descargar",
                "DOWNLOAD_AS_CSV": "Descargar como CSV",
                "DOWNLOAD_AS_PDF": "Descargar como PDF",
                "DOWNLOAD_FAILED": "Error en la descarga",
                "DOWNLOAD_PREVIOUS_EXPORTS": "Descargar exportaciones anteriores...",
                "DO_YOU_WISH_TO_DELETE": "Desea eliminar:",
                "DUPLICATE_PAGE": "Duplicar hoja",
                "EDIT_REPORT": "Editar informe",
                "EDIT_REPORT_ELLIPSIS": "Editar informe...",
                "EDIT_VISUALIZATION": "Editar visualización",
                "EMAIL_ADDRESS": "Dirección de correo electrónico",
                "EMAIL_SENT": "Correo electrónico enviado...",
                "END_OF_REPORT": "Final del informe",
                "ENTER_NAME": "Introducir nombre",
                "ERROR_COPYING": "Se ha producido un error al copiar el informe.",
                "ERROR_DELETING": "Se ha producido un error al eliminar el informe.",
                "ERROR_DELETING_EXPORT": "Se ha producido un error al eliminar la exportación.",
                "ERROR_HEADING": "Error",
                "ERROR_PUBLISHING": "Se ha producido un error al guardar la configuración.",
                "ERROR_RENAMING": "Se ha producido un error al cambiar el nombre del informe.",
                "ERROR_REQUESTING_EXPORT": "Se ha producido un error al solicitar la exportación.",
                "ERROR_SAVING_GLOBAL_OPTIONS": "Se ha producido un error al guardar las opciones de visualización global.",
                "ERROR_SEND_TEST_EMAIL": "Se ha producido un error al enviar el correo electrónico de prueba.",
                "EVERY_FRIDAY": "Todos los viernes",
                "EVERY_MONDAY": "Todos los lunes",
                "EVERY_MONTH": "Mensualmente, los",
                "EVERY_SATURDAY": "Todos los sábados",
                "EVERY_SUNDAY": "Todos los domingos",
                "EVERY_THURSDAY": "Todos los jueves",
                "EVERY_TUESDAY": "Todos los martes",
                "EVERY_WEDNESDAY": "Todos los miércoles",
                "EVERY_WEEK": "Semanalmente, todos los",
                "EXAMPLE_GROUP_NUM": "Grupo {{num}}",
                "EXAMPLE_SERIES_NUM": "Serie {{num}}",
                "EXPORT": "Exportar",
                "EXPORT_CSV": "CSV (separado por comas)",
                "EXPORT_EXCEL_SPREADSHEET": "Hoja de cálculo de Excel",
                "EXPORT_IMAGE": "Imagen de exportación",
                "EXPORT_PAGES": "Páginas de exportación",
                "EXPORT_PDF": "Documento PDF",
                "EXPORT_PPT_SLIDES": "Diapositivas de PowerPoint",
                "EXPORT_RAW_DATA": "Exportar datos sin procesar",
                "EXPORT_REPORT": "Exportar informe",
                "EXPORT_VISUALIZATION": "Visualización de exportación",
                "EXPORT_WORD_DOC": "Documento de Word",
                "FAILED_SAVE_TXT": "No se pudo guardar",
                "FILTERED": "Filtrado",
                "FIRST_PAGE": "Primera página",
                "FIRST_WEEKDAY": "Primer día laborable del mes",
                "FROM": "De",
                "FROM_EMAIL": "Dirección de correo electrónico de remitente",
                "FROM_NAME": "Nombre de remitente",
                "GAUGE_CHART": "Gráfico de indicadores",
                "GAUGE_CHART_DESC": "Un gráfico que se asemeja a una herramienta de medición para comparar valores actuales con un objetivo o una serie de umbrales.",
                "GENERATING_FILE": "Generando archivo...",
                "GENERATING_IMAGE": "Generando imagen...",
                "GENERATING_PDF": "Generando PDF...",
                "GENERIC_ERROR": "Un error no nos permite cargar el proyecto solicitado.",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "Opciones globales...",
                "GLOBAL_METRIC": "Métrica predeterminada",
                "GLOBAL_MODAL_PAGE_TITLE": "Visualización de ejemplo según las opciones globales de la sección Resultados de Qualtrics Research Suite",
                "GLOBAL_MODAL_WIDGET_TITLE": "Título de visualización",
                "GLOBAL_OPTIONS": "Opciones globales",
                "GLOBAL_PRECISION": "Cifras decimales predeterminadas",
                "GLOBAL_SETTINGS_APPLY": "Aplicar mi configuración predeterminada",
                "GLOBAL_SETTINGS_SAVE": "Guardar como mi configuración predeterminada",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "Aplicar configuración predeterminada de Qualtrics",
                "GROUP": "Grupo",
                "HEAT_MAP_CHART": "Gráfico de mapa de calor",
                "HEAT_MAP_CHART_DESC": "Una visualización agrupada en clústeres con el estilo \"calor\" que se utiliza para asignar la distribución de la entrada del usuario (como, por ejemplo, los clics) en la imagen original.",
                "HIDDEN": "Oculta",
                "HIDDEN_PAGE": "Esta página no aparecerá en los informes públicos y su selección se anulará por defecto en las exportaciones de informes.",
                "HIDE": "Ocultar",
                "HIDE_ALL_PAGES": "Ocultar todas las páginas",
                "HIDE_PAGE": "Ocultar página",
                "IMAGE_FILE": "Archivo de imagen",
                "INVALID_BRAND_DOMAIN": "El dominio que ha especificado no está en la lista de dominios de correo electrónico aprobados de su organización. Póngase en contacto con el administrador de la organización para corregirlo.",
                "INVALID_SPF_RECORD": "El dominio que ha especificado no permite que Qualtrics realice un envío desde el mismo. Esto afectará a la capacidad de entrega. Utilice otro dominio o póngase en contacto con Qualtrics para ver cómo resolver este problema.",
                "ISSUE_SAVING_REPORTS": "Se ha producido un error al guardar uno o más informes. Vuelva a intentarlo.",
                "ISSUE_SENDING_TEST": "Hubo un error al enviar un correo electrónico de prueba. Vuelva a intentarlo.",
                "LARGE_SURVEY": "Los resultados no se pueden visualizar porque la encuesta es demasiado larga.",
                "LAST_DAY": "Último día del mes",
                "LAST_MODIFIED_COLON_WITH_DATE": "Fecha de última modificación: %1",
                "LAST_PAGE": "Última página",
                "LAST_WEEKDAY": "Último día laborable del mes",
                "LATER": "Más tarde",
                "LEARN_MORE": "Obtener más información",
                "LINE_CHART": "Gráfico de líneas",
                "LINE_CHART_DESC": "Un gráfico de líneas de dos ejes que generalmente se utiliza cuando se realiza una representación gráfica respecto al tiempo en el eje x.",
                "LOG_OUT_WARNING": "Haga clic en cualquier lugar en un plazo de {{countdown}} segundos para permanecer conectado",
                "MESSAGE": "Mensaje",
                "MONTHLY": "Mensualmente",
                "MOVE_DOWN": "Mover visualización hacia abajo",
                "MOVE_PAGE_TO_BOTTOM": "Mover al final",
                "MOVE_PAGE_TO_TOP": "Mover al principio",
                "MOVE_UP": "Mover visualización hacia arriba",
                "MY_SURVEYS": "Mis proyectos",
                "NAME": "Nombre",
                "NEW_CUSTOM_PAGE_NAME": "Nueva página personalizada",
                "NEW_REPORT": "Nuevo informe",
                "NEXT_PAGE": "Página siguiente",
                "NEXT_RUN": "Próxima ejecución",
                "NO_EXPORTS": "Aún no se solicitaron exportaciones para este informe.",
                "NO_ITEMS_TO_DISPLAY": "No hay elementos para mostrar",
                "NO_MATCHING_CUSTOM_PAGES": "No hay páginas personalizadas coincidentes",
                "NO_MATCHING_PAGES": "No se han encontrado páginas para la búsqueda",
                "NO_MATCHING_REPORTS": "No hay informes coincidentes.",
                "NO_PROJECT": "Especifique un proyecto para continuar.",
                "NO_PROJECTS_TO_MIGRATE": "No hay proyectos para actualizar.",
                "NO_QUESTIONS": "No hay preguntas coincidentes",
                "NO_RESULTS_YET": "Aún no hay resultados para mostrar. Distribuya la encuesta para reunir respuestas.",
                "OFF": "Desactivado",
                "ON": "Activado",
                "PAGES_SELECTED": "Páginas seleccionadas",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "Esta selección provocaría que el informe incluyera {{currentSelectedPageCount}} páginas, lo que superaría el máximo de {{reportSizeLimit}} permitido. Seleccione un rango más pequeño.",
                "PAGES_SELECTION_INVALID_RANGE": "Seleccionar un intervalo válido.",
                "PAGE_OPTIONS": "Opciones de página",
                "PDF_ROW_TRUNCATION_MESSAGE": "Demasiadas filas que exportar a PDF. Pruebe la exportación a Word o CSV.",
                "PERCENTAGE_METRIC": "Porcentaje",
                "PIE_CHART": "Gráfico circular",
                "PIE_CHART_DESC": "Un desglose circular de valores para un determinado punto de datos. Útil para medir proporciones relativas de valores seleccionados.",
                "PREVIEW": "Vista previa",
                "PREVIOUS_PAGE": "Página anterior",
                "PRINT_PAGE": "Imprimir página",
                "PUBLIC_LINK": "Enlace público",
                "PUBLIC_REPORT_AVAILABLE": "Informe público disponible",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "Código de acceso",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "Código de acceso incorrecto. Vuelva a intentarlo.",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "Enviar",
                "PUBLIC_RESULTS_LOGIN_TITLE": "Inicio de sesión de informe público | Software para encuestas de Qualtrics",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "No se ha encontrado el informe público. Póngase en contacto con el propietario de este informe y pídale un enlace válido.",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "No se ha encontrado el informe público",
                "PUBLIC_RESULTS_NOT_UPDATED": "Ni los enlaces al informe público ni los correos electrónicos programados usarán plataforma Qualtrics XM hasta que los actualice.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "La sesión ha caducado. Vuelva a iniciar sesión para continuar con la vista previa del informe de resultados públicos.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "Sesión caducada",
                "PUBLIC_RESULTS_TITLE": "Informe público",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "No tiene autorización para ver esta página. Póngase en contacto con el propietario de este informe y pídale que lo haga público.",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "Informe público no autorizado",
                "PUBLISHED_LINK_GENERATING_LINK": "Generando enlace...",
                "PUBLISHED_REPORT_FOUND_HERE": "Cualquiera puede ver este informe en el siguiente enlace:",
                "PUBLISH_REPORT": "Gestión de informe público",
                "PUBLISH_REPORT_ELLIPSIS": "Gestión de informe público...",
                "QUESTION": "Pregunta",
                "RANK": "Clasificación",
                "REMOVE_WIDGET": "Quitar visualización",
                "RENAME_PAGE": "Cambiar nombre de la página",
                "RENAME_REPORT": "Cambiar nombre del informe",
                "RENAME_REPORT_ELLIPSIS": "Cambiar nombre del informe...",
                "REPLY_TO_EMAIL": "Dirección de correo electrónico de respuesta",
                "REPORT_COLON": "Informe:",
                "REPORT_SETTINGS": "Configuración de informe",
                "REPORT_SETTINGS_ELLIPSIS": "Configuración de informe...",
                "RESPONSE_COUNTS": "Cuentas de respuestas",
                "RESULTS_DASHBOARDS_BANNER": "y pruebe la nueva versión mejorada de los resultados de encuesta, la IU con funcionalidades más modernas y accesibles, las visualizaciones de datos, los nuevos análisis, las nuevas funciones de exploración, etc.",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "Notas de la versión",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "Ver lo más nuevo",
                "RESULTS_OPTIONS": "Opciones de informe",
                "RESULTS_TITLE": "Informe",
                "RESUME_DISTRIBUTION": "Reanudar distribución",
                "REVERT": "Revertir",
                "RICH_TEXT_LIMIT_REACHED": "La longitud del contenido ha alcanzado el límite",
                "SAVE": "Guardar",
                "SAVE_AND_CLOSE": "Guardar y cerrar",
                "SAVE_AS_CSV": "Guardar visualización como CSV",
                "SAVE_AS_IMAGE": "Guardar visualización como imagen",
                "SAVE_CONFIRMATION": "Guardar confirmación",
                "SAVE_PAGE_AS_ELLIPSIS": "Exportar página como....",
                "SAVE_SETTINGS": "Guardar configuración",
                "SCHEDULE_REPORT_EMAIL": "Programar el envío de un informe por correo electrónico",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "Programar el envío de un informe por correo electrónico...",
                "SEARCH_ELLIPSIS": "Buscar...",
                "SEARCH_PAGES": "Buscar preguntas",
                "SEARCH_PAGES_ELLIPSIS": "Buscar páginas...",
                "SEARCH_REPORTS_ELLIPSIS": "Buscar informes...",
                "SELECTED": "Seleccionado:",
                "SELECT_ALL": "Seleccionar todo",
                "SELECT_A_FIELD": "Seleccionar un campo",
                "SELECT_A_WIDGET": "Seleccionar una visualización",
                "SELECT_PAGES": "Seleccionar páginas",
                "SELECT_PAGES_ELLIPSIS": "Seleccionar páginas...",
                "SEND": "Enviar",
                "SEND_TEST_EMAIL": "Enviar prueba",
                "SETTING_DEFAULT": "Predeterminado",
                "SETTING_HIGH": "Alto",
                "SETTING_LARGE": "Grande",
                "SETTING_LOW": "Bajo",
                "SETTING_NORMAL": "Normal",
                "SETTING_SMALL": "Pequeño",
                "SHARE_REPORT": "Compartir informe",
                "SHOW_ALL_PAGES": "Mostrar todas las páginas",
                "SHOW_FULL_QTEXT": "Mostrar el texto completo de la pregunta en los títulos de la página",
                "SIMPLE_TABLE": "Tabla sencilla",
                "SIMPLE_TABLE_DESC": "Una tabla flexible que puede mostrar valores múltiples como filas o columnas.",
                "SIZE": "Tamaño",
                "SPLINE_CHART": "Gráfico de spline",
                "SPLINE_CHART_DESC": "Un gráfico de líneas redondeado de dos ejes que generalmente se usa cuando se realiza una representación gráfica respecto al tiempo en un eje X.",
                "STATISTICS_TABLE": "Tabla de estadísticas",
                "SUBJECT": "Asunto",
                "SURVEY_ANALYSIS": "Análisis de encuesta",
                "SURVEY_SUMMARY": "Resumen de encuesta",
                "TABLE": "UNA DESCRIPCIÓN PARA LA TABLA",
                "TIME": "Hora",
                "TO": "A",
                "TOTAL": "Total",
                "TRANSPOSE_STATS_TABLES": "Trasponer tablas de estadísticas",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "Transponer desgloses de tendencia de tabla de estadísticas",
                "TRUNCATE_PAGE_TITLES": "Truncar el texto de la pregunta en los títulos de la página",
                "TRY_IT_NOW": "Pruébelo ahora",
                "TYPE": "Tipo",
                "UNABLE_TO_CHECK_SPF": "No se ha podido comprobar el registro SPF. Vuelva a intentarlo.",
                "UNAUTHORIZED": "No tiene permiso para ver este informe. Póngase en contacto con el propietario para obtener acceso.",
                "UNHIDE_PAGE": "Mostrar página",
                "UPDATE": "Actualizar",
                "UPDATED_SUCCESSFULLY": "Actualización correcta.",
                "UPDATE_ALL_IN_THIS_PROJECT": "Actualizar todo en este proyecto",
                "UPDATE_ALL_PROJECTS": "Actualizar todos los proyectos",
                "UPDATE_NOW": "Actualizar ahora",
                "UPDATE_REPORTS": "Actualizar informes...",
                "UPDATE_REPORT_ELEMENTS": "Actualizar enlaces al informe público y correos electrónicos programados de envío de informes",
                "UPGRADE_MY_ACCOUNT": "Actualizar mi cuenta",
                "USE_EXPORT_TAGS": "Incluir numeración de preguntas",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "Utilizar totales de columnas de tabla sencilla",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "Utilizar recuentos de encuestados de tabla sencilla",
                "USE_WEIGHTED_METRICS": "Usar métricas ponderadas",
                "VIEW": "Ver",
                "WEEKLY": "Semanalmente",
                "WELCOME_TO_NEW_RESULTS": "Le damos la bienvenida a Reporting della plataforma Qualtrics XM.",
                "WHEN": "Cuando",
                "WIDGET_LOADING": "Cargando...",
                "WIDGET_OPTIONS_ERR": "No se han podido cargar las opciones de visualización",
                "WIDGET_TYPE": "Visualización",
                "WORD_CLOUD": "Nube de palabras",
                "WORD_CLOUD_DESC": "Una visualización ponderada de la frecuencia de palabras en los datos de texto con opciones adicionales de codificación de colores."
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Recuerde que existen recursos en su organización que le permiten interpretar su opinión como interlocutores de recursos humanos, su gestor y/o un mentor.",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Tómese un café y sumérjase en las opiniones.",
                "ABOUT_YOUR_REPORT_HEADER": "Acerca de su informe",
                "ABOUT_YOUR_REPORT_LINE1": "Bienvenido a nuestro informe de opiniones 360. Es una gran oportunidad para crecer y desarrollarse como profesional. Con el fin de estar preparado para el éxito al consultar los resultados, permítase el tiempo suficiente para revisar las opiniones. En un principio, las opiniones pueden ser difíciles de escuchar, pero tenga en cuenta que el propósito de este informe es acelerar su crecimiento y desarrollo.",
                "ABOUT_YOUR_REPORT_LINE2": "A medida que revise su informe, hay algunos aspectos que debe tener en cuenta.",
                "ADD_CONDITIONAL_TEXT": "Añadir texto condicional",
                "ADD_CUSTOM_PALETTE": "Añadir paleta personalizada",
                "ADD_DATA_SOURCE": "Añadir fuente de datos",
                "ADD_FOLLOWING": "Añadir siguientes",
                "ADD_LABEL": "Añadir etiqueta",
                "ADVANCED_FILTER": "Filtro avanzado",
                "AGREEMENT_CHART": "Gráfico de acuerdo",
                "AGREEMENT_CHART_FOOTER": "El gráfico de acuerdo indica la similitud de las puntuaciones. Cada punto representa cómo una persona le calificó para cada elemento. El tamaño de los puntos muestra cuántos calificadores le otorgaron una calificación en concreto.",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "respuestas",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "respuesta",
                "AGREEMENT_CHART_LEGEND_TITLE": "Cómo le han puntuado otros",
                "ALL": "Todas",
                "AND_IF": "Y si",
                "ANGLED": "En ángulo",
                "AREA": "Área",
                "AUTO": "Auto",
                "AVERAGE": "Promedio",
                "AXIS_VALUES": "Valores de ejes",
                "BAR": "Barra",
                "BASE_WORD_COLOR": "Color base de la palabra",
                "BLUR": "Difuso",
                "BOTTOM_BOX": "Cuadro inferior",
                "BREAKOUT_HEADERS": "Encabezados de desglose",
                "CANCEL": "Cancelar",
                "CATEGORICAL": "Categórico",
                "CATEGORY": "Categoría",
                "CATEGORY_NAME": "Nombre de la categoría",
                "CHANGE_CATEGORIES_ORDER": "Cambiar el orden de las categorías",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "Cambiar el orden de las categorías de puntuación",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "Cambiar el orden que se muestra en la visualización haciendo clic a la izquierda del elemento de categoría de puntuación y arrastrándolo a la posición requerida.",
                "CHANGE_QUESTIONS_ORDER": "Cambiar el orden de las preguntas",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "Cambiar el orden de las preguntas",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "Cambiar el orden que se muestra en la visualización haciendo clic a la izquierda del elemento de pregunta y arrastrándolo a la posición requerida.",
                "CHARTS": "Gráficos",
                "CHART_TYPE": "Tipo de gráfico",
                "CHOICE_COUNT": "Seleccionar recuento",
                "CHOICE_TOTALS": "Seleccionar total",
                "CLEAR": "Borrar",
                "CLOSE": "Cerrar",
                "COLOR_PALETTE": "Paleta de colores",
                "COLUMN_NAMES": "Nombres de columnas",
                "COLUMN_TOTALS": "Totales de columnas",
                "COMPARED_FILTER_GROUP": "Grupo de filtros comparados",
                "COMPARED_FILTER_GROUPS": "Grupos de filtros comparados",
                "COMPARE_WITH": "comparar con",
                "COMPETITION_RANKING": "Utilizar clasificación de la competencia",
                "COMPETITION_RANKING_TOOLTIP": "En caso de empate, todas las puntuaciones iguales reciben la misma clasificación. Sin embargo, el próximo elemento subsiguiente se clasificará igual que: el número total de elementos mejor clasificados de la tabla, más uno.",
                "COMPLETED_RESPONSES": "Respuestas completadas",
                "CONDITIONAL_TEXT": "Texto condicional",
                "COUNT": "Recuento",
                "CREATE": "Crear",
                "CUSTOM_PALETTE": "Paleta personalizada",
                "DATA_SOURCE_TYPE": "Tipo de fuente de datos",
                "DATA_SOURCE_TYPE_CATEGORY": "Categorías de puntuación",
                "DATA_SOURCE_TYPE_QUESTION": "Preguntas",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "Pregunta",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "Elementos clasificables",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "Categoría de puntuación",
                "DEFAULT": "Predeterminado",
                "DEFAULT_TEXT": "Texto predeterminado",
                "DELETE": "Eliminar",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "Comprenda de quién son las opiniones, si son de compañeros, de subordinados directos, de líderes, etc.",
                "DIFFERENT_EVALUATORS_HEADER": "Diferentes evaluadores",
                "DIRECT_REPORTS": "Subordinados directos",
                "DISABLED": "Desactivado",
                "DISPLAY_OPTIONS": "Opciones de visualización",
                "DISPLAY_THRESHOLD_TEXTS": "Mostrar texto basado en la siguiente diferencia de grupos",
                "DIVERGENT": "Divergente",
                "DONE": "Listo",
                "DONT_HEADER": "No:",
                "DONT_LINE1": "Trate averiguar quién ha dicho qué",
                "DONT_LINE2": "Céntrese en una puntuación/comentario positivo o negativo",
                "DONT_LINE3": "Cree un plan de desarrollo acerca de cada elemento",
                "DONT_LINE4": "Se desanime si tiene oportunidades de mejora",
                "DONUT": "Donut",
                "DOWNLOAD_CSV": "Descargar archivo CSV heredado",
                "DOWNLOAD_ZIP": "Descargar todos los archivos",
                "DO_HEADER": "Sí:",
                "DO_LINE1": "Observe de forma holística las opiniones",
                "DO_LINE2": "Identifique temas en puntos positivos y oportunidades de mejora",
                "DO_LINE3": "Priorice nuevas áreas de enfoque para añadir a su plan de desarrollo",
                "DO_LINE4": "Comprenda que todos tienen oportunidades de mejora",
                "DROPOFF": "Reducción",
                "DUPLICATE": "Duplicado",
                "EDIT_CONDITIONAL_TEXT": "Editar texto condicional",
                "EDIT_CUSTOM_PALETTE": "Editar paleta personalizada",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "Si no, mostrar el texto siguiente",
                "ENABLED": "Activada",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "Activar clasificación por lógica de visualización de la categoría de valorador",
                "ENABLE_ORDERING_FOR": "Activar solicitud de",
                "EQUAL_TO": "Igual a",
                "FIELD": "Campo",
                "FILTER_NAMES": "Nombres de filtro",
                "FOLLOWING_PARENTHESES": "(siguiente)",
                "FOOTER": "Pie de página",
                "GAP": "Diferencia",
                "GAP_CHART": "Gráfico diferencial",
                "GAP_CHART_DESCRIPTION": "El gráfico diferencial muestra la diferencia en la puntuación entre dos grupos de calificadores. Por ejemplo, en el caso de una autocalificación y las calificaciones de otros, una diferencia positiva (+) significa que los otros le han puntuado más alto que la calificación que se ha dado a sí mismo. Una diferencia negativa (-) indica que los otros le han puntuado más bajo que lo que se ha puntuado usted.",
                "GAP_CHART_FOOTER": "El gráfico diferencial muestra la +/- diferencia entre los dos grupos calificados.",
                "GAP_TABLE_DESCRIPTION": "Los puntos positivos ocultos muestran las áreas en las que los otros le han calificado más alto de lo que hizo usted. Las áreas de mejora indican dónde los otros le han calificado más bajo que la calificación que se dio. Ambas secciones están clasificadas de mayor a menor diferencia.",
                "GAP_TABLE_FOOTER": "Esta primera columna de puntuaciones indica cómo se ha puntuado a sí mismo. La segunda columna indica la puntuación media de los demás. La tercera columna indica la diferencia entre cómo se ha puntuado a sí mismo y cómo le han puntuado los demás.",
                "GAP_TABLE_TITLE": "Puntos fuertes ocultos/Áreas de mejora",
                "GREATER_OR_EQUAL": "Mayor o igual que",
                "GREATER_THAN": "Mayor que",
                "GROUP": "Grupo",
                "GROUPED_FOR_ANONYMITY": "Agrupados por anonimato",
                "HEADER_NAMES": "Nombres de encabezados",
                "HIGHEST_SCORES": "Puntuaciones más altas",
                "HIGHLIGHT_THRESHOLD": "Umbral para resaltar diferencias",
                "HIGHLOW_TABLE": "Puntuaciones altas y bajas",
                "HIGHLOW_TABLE_FOOTER": "Esta sección muestra los cinco comportamientos con la calificación más alta y más baja (en todos los comportamientos) de los promedios de categoría de calificador aplicables. Para aprovechar al máximo esta página, resulta útil buscar tendencias que puedan surgir. Por ejemplo, si la mayoría de sus comportamientos con la calificación más baja se concentran en una o dos categorías, estas pueden ser áreas que precisan desarrollo. Los comportamientos mejor calificados pueden identificar fortalezas aprovechables en otras áreas.",
                "HIGH_LOW_TABLE_DESCRIPTION": "El gráfico de alto/bajo muestra elementos según las áreas en las que otros le han calificado más alto y más bajo.",
                "HORIZONTAL": "Horizontal",
                "HORIZONTAL_AND_VERTICAL": "Horizontal y vertical",
                "HORIZONTAL_BAR": "Barra horizontal",
                "HOW_TO_INTERPRET_RESULT_HEADER": "Cómo interpretar los resultafos y determinar una acción:",
                "IF": "Si",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "Incluir etiquetas ocultas en porcentajes",
                "INNER_RIM": "Borde interno",
                "IS": "Es",
                "IS_NOT": "No es",
                "IS_SAME_AS_SUBJECT": "Es el mismo que el evaluado",
                "ITEM": "Elemento",
                "LABEL": "etiqueta",
                "LABELS": "Etiquetas",
                "LARGE_LABELS": "Etiquetas grandes",
                "LEGEND": "Leyenda",
                "LEGEND_POSITION": "Posición de leyenda",
                "LEGEND_VALUES": "Valores de leyendas",
                "LESS_OR_EQUAL": "Menor o igual que",
                "LESS_THAN": "Menor que",
                "LINE": "Línea",
                "LOWEST_SCORES": "Puntuaciones más bajas",
                "MANAGERS": "Mánagers",
                "MANUAL_FONT_SIZE": "Establecer el tamaño de fuente manualmente",
                "MAX": "Máx.",
                "MEAN": "Media",
                "MEDIAN": "Mediana",
                "METRIC_TYPE": "Tipo de métrica",
                "MIN": "Mín.",
                "MODIFY_CUSTOM_PALETTES": "Modificar paletas personalizadas",
                "MOVE_DOWN": "Mover abajo",
                "MOVE_UP": "Mover arriba",
                "MULTI_SELECT_ITEMS_SELECTED": "seleccionado",
                "NEGATIVE_GAPS": "Áreas de mejora",
                "NO": "No",
                "NONE": "Ninguno",
                "NOT_APPLICABLE": "N/C",
                "NOT_EQUAL_TO": "No es igual a",
                "NO_DATA_AVAILABLE_WARNING": "No hay datos disponibles",
                "NO_FILTER": "Sin filtro",
                "NO_FILTER_IS_APPLIED": "Ningún filtro aplicado",
                "NO_VALUE": "Sin valor",
                "NPS": "Net Promoter Score",
                "NUMBER": "número",
                "NUMBERS": "Números",
                "NUMBER_OF_GAPS_NEGATIVE": "Número de diferencias negativas",
                "NUMBER_OF_GAPS_POSITIVE": "Número de diferencias positivas",
                "NUMBER_OF_ROWS_HIGH": "Número de filas altas",
                "NUMBER_OF_ROWS_LOW": "Número de filas bajas",
                "OPTIONS": {
                    "HEADER_NAME": "Nombres de cabecera",
                    "LEGEND": "Leyenda",
                    "SCALE_AXIS_CHANGER_TITLE": "Rango"
                },
                "ORIENTATION": "Orientación",
                "OR_IF": "O si",
                "OTHER": "Otro",
                "OTHERS": "Otros",
                "PAGE_OF": "Página: %1 de %2",
                "PALETTE_REMOVED": "Paleta quitada",
                "PEERS": "Compañeros",
                "PERCENT": "Porcentaje",
                "PERCENTAGE": "Porcentaje",
                "PERCENTAGE_OF_CHOICES": "Porcentaje de opciones",
                "PERCENTAGE_OF_RESPONSES": "Porcentaje de respuestas",
                "PERCENT_COMPLETE": "% completo",
                "PERSON_METADATA": "Metadatos de persona",
                "PERSON_METADATA_EVALUATOR": "Del evaluador",
                "PERSON_METADATA_SUBJECT": "Del evaluado",
                "PERSON_METADATA_VIEWER": "Del espectador",
                "POSITIVE_GAPS": "Puntos positivos",
                "PRIMARY_PARENTHESES": "(primario)",
                "QUESTIONS": "Preguntas",
                "RADIUS": "Radio",
                "RANK": "Clasificación",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "Puntuación más alta",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "Puntuaciones más altas",
                "RANKABLE_ITEMS_ITEM_HAS": "El elemento tiene",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "El elemento está en el top",
                "RANKABLE_ITEMS_LOWEST_SCORE": "Puntuación más baja",
                "RANKABLE_ITEMS_LOWEST_SCORES": "Puntuaciones más bajas",
                "RATER_CATEGORY_DISPLAY_LOGIC": "lógica de visualización de la categoría de calificador",
                "RATIO": "Ratio",
                "RECORD": "Registro",
                "REFERENCE_GROUP": "Grupo de referencia",
                "RELATIONSHIP": "Relación",
                "RELATIONSHIP_FILTERS": "Filtros de relación",
                "RELATIONSHIP_FILTERS_INFO": "Para añadir un filtro de relación (como subordinado directo, compañero o mánager), seleccione Gestionar filtros y utilice la condición de relación solo desde el menú desplegable.",
                "REMOVE": "Quitar",
                "REMOVE_DATA_SOURCE": "Quitar fuente de datos",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Recuerde que existen recursos en su organización que le permiten interpretar su opinión como interlocutores de recursos humanos, su gestor y/o un mentor.",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Tómese un café y sumérjase en las opiniones.",
                    "ABOUT_YOUR_REPORT_HEADER": "Acerca de su informe",
                    "ABOUT_YOUR_REPORT_LINE1": "Bienvenido a nuestro informe de opiniones 360. Es una gran oportunidad para crecer y desarrollarse como profesional. Con el fin de estar preparado para el éxito al consultar los resultados, permítase el tiempo suficiente para revisar las opiniones. En un principio, las opiniones pueden ser difíciles de escuchar, pero tenga en cuenta que el propósito de este informe es acelerar su crecimiento y desarrollo.",
                    "ABOUT_YOUR_REPORT_LINE2": "A medida que revise su informe, hay algunos aspectos que debe tener en cuenta.",
                    "ADVANCED_FILTER": "Filtro avanzado",
                    "AGREEMENT_CHART": "Gráfico de acuerdo",
                    "AGREEMENT_CHART_FOOTER": "El gráfico de acuerdo indica la similitud de las puntuaciones. Cada punto representa cómo una persona le calificó para cada elemento. El tamaño de los puntos muestra cuántos calificadores le otorgaron una calificación en concreto.",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "respuestas",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "respuesta",
                    "AGREEMENT_CHART_LEGEND_TITLE": "Cómo le han puntuado otros",
                    "ALL": "Todas",
                    "AVERAGE": "Promedio",
                    "BOTTOM_BOX": "Cuadro inferior",
                    "CHOICE_COUNT": "Seleccionar recuento",
                    "CHOICE_TOTALS": "Seleccionar total",
                    "COMPARISON": "Comparación",
                    "COMPARISON_GAP_COLUMN_HEADER": "Intervalo de comparación",
                    "COMPLETED_RESPONSES": "Respuestas completadas",
                    "COUNT": "Recuento",
                    "DEFAULT": "Predeterminado",
                    "DEFAULT_TEXT": "Texto predeterminado",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "Comprenda de quién son las opiniones, si son de compañeros, de subordinados directos, de líderes, etc.",
                    "DIFFERENT_EVALUATORS_HEADER": "Diferentes evaluadores",
                    "DONE": "Finalizado",
                    "DONT_HEADER": "No:",
                    "DONT_LINE1": "Trate averiguar quién ha dicho qué",
                    "DONT_LINE2": "Céntrese en una puntuación/comentario positivo o negativo",
                    "DONT_LINE3": "Cree un plan de desarrollo acerca de cada elemento",
                    "DONT_LINE4": "Se desanime si tiene oportunidades de mejora",
                    "DO_HEADER": "Sí:",
                    "DO_LINE1": "Observe de forma holística las opiniones",
                    "DO_LINE2": "Identifique temas en puntos positivos y oportunidades de mejora",
                    "DO_LINE3": "Priorice nuevas áreas de enfoque para añadir a su plan de desarrollo",
                    "DO_LINE4": "Comprenda que todos tienen oportunidades de mejora",
                    "FIELD": "Campo",
                    "GAP": "Diferencia",
                    "GAP_CHART": "Gráfico diferencial",
                    "GAP_CHART_DESCRIPTION": "El gráfico diferencial muestra la diferencia en la puntuación entre dos grupos de calificadores. Por ejemplo, en el caso de una autocalificación y las calificaciones de otros, una diferencia positiva (+) significa que los otros le han puntuado más alto que la calificación que se ha dado a sí mismo. Una diferencia negativa (-) indica que los otros le han puntuado más bajo que lo que se ha puntuado usted.",
                    "GAP_CHART_FOOTER": "El gráfico diferencial muestra la +/- diferencia entre los dos grupos calificados.",
                    "GAP_TABLE_DESCRIPTION": "Los puntos positivos ocultos muestran las áreas en las que los otros le han calificado más alto de lo que hizo usted. Las áreas de mejora indican dónde los otros le han calificado más bajo que la calificación que se dio. Ambas secciones están clasificadas de mayor a menor diferencia.",
                    "GAP_TABLE_FOOTER": "Esta primera columna de puntuaciones indica cómo se ha puntuado a sí mismo. La segunda columna indica la puntuación media de los demás. La tercera columna indica la diferencia entre cómo se ha puntuado a sí mismo y cómo le han puntuado los demás.",
                    "GAP_TABLE_TITLE": "Puntos fuertes ocultos/Áreas de mejora",
                    "GROUP": "Grupo",
                    "HIDE_REPORT_ALERT": "Usted no cumple con los requisitos para ver el informe. Póngase en contacto con el administrador de su organización.",
                    "HIGHEST_SCORES": "Puntuaciones más altas",
                    "HIGHLOW_TABLE": "Puntuaciones altas y bajas",
                    "HIGHLOW_TABLE_FOOTER": "Esta sección muestra los cinco comportamientos con la calificación más alta y más baja (en todos los comportamientos) de los promedios de categoría de calificador aplicables. Para aprovechar al máximo esta página, resulta útil buscar tendencias que puedan surgir. Por ejemplo, si la mayoría de sus comportamientos con la calificación más baja se concentran en una o dos categorías, estas pueden ser áreas que precisan desarrollo. Los comportamientos mejor calificados pueden identificar puntos fuertes aprovechables en otras áreas.",
                    "HIGH_LOW_TABLE_DESCRIPTION": "El gráfico de alto/bajo muestra elementos según las áreas en las que otros le han calificado más alto y más bajo.",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "Cómo interpretar los resultafos y determinar una acción:",
                    "ITEM": "Elemento",
                    "LOWEST_SCORES": "Puntuaciones más bajas",
                    "MAX": "Máx.",
                    "MEAN": "Media",
                    "MEDIAN": "Mediana",
                    "MIN": "Mín.",
                    "NEGATIVE_GAPS": "Áreas de mejora",
                    "NO_COMPARISON_SET": "No se ha fijado ninguna comparación",
                    "NO_DATA_AVAILABLE_WARNING": "No hay datos disponibles",
                    "NO_FILTER_IS_APPLIED": "Ningún filtro aplicado",
                    "NO_VALUE": "Sin valor",
                    "NPS": "Net Promoter Score",
                    "OTHERS": "Otros",
                    "PERCENTAGE": "Porcentaje",
                    "PERCENTAGE_OF_CHOICES": "Porcentaje de opciones",
                    "PERCENTAGE_OF_RESPONSES": "Porcentaje de respuestas",
                    "PERCENT_COMPLETE": "% completo",
                    "POSITIVE_GAPS": "Puntos positivos",
                    "QUESTIONS": "Preguntas",
                    "RANK": "Clasificación",
                    "RELATIONSHIPS": {
                        "ANYONE": "Cualquiera",
                        "DIRECT_REPORT": "Subordinado directo",
                        "MANAGER": "Gestor",
                        "PEER": "Compañero",
                        "SELF": "Propio"
                    },
                    "REPORT_SUMMARY": "Resumen del informe",
                    "REPORT_SUMMARY_TABLE_FOOTER": "Comparación del número de personas que han finalizado la valoración versus al número de personas invitadas a participar en la valoración.",
                    "REPORT_SUMMARY_TABLE_HEADER": "Estadísticas de encuestados",
                    "RESPONSES": "Respuestas",
                    "RESPONSE_COUNT": "{{responseCount}} respuestas",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Respuestas",
                    "SCORING_CATEGORY": "Categoría de puntuación",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Sin respuestas para esta categoría",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Sin respuestas para esta pregunta.",
                    "SCORING_OVERVIEW": "Resumen de puntuación",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "Usted y otros evaluadores piensan que está área es un punto fuerte principal.",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Punto fuerte reconocido",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Un área de mejora reconocida significa que las autocalificaciones y las calificaciones de otros están ambas por debajo de la media para esta competencia.",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Área de mejora reconocida",
                    "SCORING_OVERVIEW_DESCRIPTION": "Arriba están las competencias o las conductas en las que se le ha evaluado como parte del proceso de opinión de varios calificadores. Las calificaciones de comparación se dan por grupo.",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "Diferencia mínima",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Diferencia mínima entre grupos de referencia para textos a visualizar.",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "Se muestra el rango de puntuaciones de cada competencia/comportamiento. La barra representa el promedio numérico.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Punto fuerte no reconocido que procede de la discrepancia entre la autocalificación y las calificaciones procedentes de terceros.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Punto fuerte no reconocido",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Un área de mejora no reconocida procede de la discrepancia entre la autocalificación y las calificaciones procedentes de terceros.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Área de mejora no reconocida",
                    "SELF": "Propio",
                    "SELF_ASSESSMENT": "Autovaloración",
                    "STANDARD_DEVIATION": "Desviación estándar",
                    "SUM": "Suma",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Familiarícese con la escala de calificación para asegurarse una interpretación precisa.",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "Tener en cuenta la escala",
                    "THINGS_YOU_WILL_SEE_HEADER": "Cosas que verá:",
                    "THREE_SIXTY_PERCENTILE": "Percentil",
                    "TOP_BOTTOM_BOX": "Cuadro superior/cuadro inferior",
                    "TOP_BOX": "Cuadro superior",
                    "TOTAL": "Total",
                    "TO_DO": "Pendiente",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Cualitativa: esta opinión se presenta en forma de comentarios de texto libres",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Cuantitativa: esta opinión será numérica y se representa en gráficos, gráficos de barras, tablas, etc.",
                    "TYPES_OF_FEEDBACK_HEADER": "Varios tipos de opinión",
                    "VALUE": "Valor",
                    "VARIANCE": "Varianza",
                    "YOUR_RATINGS": "Sus calificaciones"
                },
                "REPORT_SUMMARY": "Resumen del informe",
                "REPORT_SUMMARY_TABLE_FOOTER": "Comparación del número de personas que han finalizado la valoración versus al número de personas invitadas a participar en la valoración.",
                "REPORT_SUMMARY_TABLE_HEADER": "Estadísticas de encuestados",
                "RESET": "Restablecer",
                "RESPONDENT_TOTALS": "Totales de encuestados",
                "RESPONSES": "Respuestas",
                "RESPONSE_COUNT": "{{responseCount}} respuestas",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Respuestas",
                "RESULT": "Resultado",
                "REVERSE_COLORS": "Invertir colores",
                "ROW_TOTALS": "Totales de filas",
                "SAVE": "Guardar",
                "SAVE_AND_APPLY": "Guardar y aplicar",
                "SCORING_CATEGORY": "Categoría de puntuación",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "No hay respuestas para esta categoría.",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "No hay respuestas para esta pregunta.",
                "SCORING_OVERVIEW": "Resumen de puntuación",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "Usted y otros evaluadores piensan que está área es un punto fuerte principal.",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Punto fuerte reconocido",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Un área de mejora reconocida significa que las autocalificaciones y las calificaciones de otros están ambas por debajo de la media para esta competencia.",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Área de mejora reconocida",
                "SCORING_OVERVIEW_DESCRIPTION": "Arriba están las competencias o las conductas en las que se le ha evaluado como parte del proceso de opinión de varios calificadores. Las clasificaciones de comparación se dan por grupo.",
                "SCORING_OVERVIEW_MINIMUM_GAP": "Diferencia mínima",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Diferencia mínima entre grupos de referencia para textos a visualizar.",
                "SCORING_OVERVIEW_TABLE_FOOTER": "Se muestra el rango de puntuaciones de cada competencia/comportamiento. La barra representa el promedio numérico.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Punto fuerte no reconocido que procede de la discrepancia entre la autocalificación y las calificaciones procedentes de terceros.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Punto fuerte no reconocido",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Un área de mejora no reconocida procede de la discrepancia entre la autocalificación y las calificaciones procedentes de terceros.",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Área de mejora no reconocida",
                "SELECT_CATEGORIES": "Seleccione las categorías de puntuación...",
                "SELECT_CATEGORY": "Seleccione una categoría de puntuación...",
                "SELECT_CONDITION_TYPE": "Seleccionar tipo de condición",
                "SELECT_DATA_SOURCE": "Seleccionar fuente de datos",
                "SELECT_DATA_SOURCE_TYPE": "Seleccionar tipo de fuente de datos",
                "SELECT_FILTER": "Seleccionar filtro",
                "SELECT_FILTERS": "Seleccionar filtros",
                "SELECT_OPERATOR_TYPE": "Seleccionar tipo de operador",
                "SELECT_PERSON": "Seleccionar persona",
                "SELECT_PERSON_METADATA": "Seleccionar metadatos de persona",
                "SELECT_QUESTION": "Seleccionar pregunta",
                "SELECT_QUESTIONS": "Seleccione preguntas...",
                "SELECT_RATIO_OR_DROPOFF": "Seleccionar ratio o reducción",
                "SELECT_RELATIONSHIP": "Seleccionar relación",
                "SELECT_SCORING_CATEGORY": "Seleccionar categoría de puntuación",
                "SELF": "Propio",
                "SELF_ASSESSMENT": "Autovaloración",
                "SEQUENTIAL": "Secuencial",
                "SETUP_COMPARISON": "Configurar comparación",
                "SETUP_COMPARISONS": "Configurar comparaciones",
                "SET_START_COLOR": "Establecer color de inicio",
                "SHOULD_SHOW_FOOTER": "Mostrar pie de página",
                "SHOULD_SHOW_SCORING_CATEGORY": "Mostrar categoría de puntuación",
                "SHOWING_RECORDS_OF": "Mostrando registros: %1 - %2 de %3",
                "SHOW_COMPARISON_GAP": "Mostrar columna de intervalo de comparación",
                "SHOW_DATA_LABEL": "Mostrar valores de datos",
                "SHOW_PERCENTAGES": "Mostrar porcentajes",
                "SHOW_THE_FOLLOWING_TEXT": "A continuación, mostrar el texto siguiente",
                "SHOW_TIES": "Mostrar empatados",
                "SHOW_X_AXIS": "Mostrar eje X",
                "SHOW_Y_AXIS": "Mostrar eje Y",
                "SMALL_LABELS": "Etiquetas pequeñas",
                "SORT": "Clasificar",
                "SPLINE": "Línea curva",
                "STACK_CHART": "Gráfico de pilas",
                "STANDARD_DEVIATION": "Desviación estándar",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "Punto débil inferior a",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "Editar textos de umbral",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "Textos de umbral",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "Activar textos de umbral",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "Punto fuerte superior a",
                "SUM": "Suma",
                "SUMMARY": "Resumen",
                "TABLES": "Tablas",
                "TABLE_TOTALS": "Totales de tabla",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Familiarícese con la escala de calificación para asegurarse una interpretación precisa.",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "Tener en cuenta la escala",
                "TEXT": "Texto",
                "THINGS_YOU_WILL_SEE_HEADER": "Cosas que verá:",
                "TOP_BOTTOM_BOX": "Cuadro superior/cuadro inferior",
                "TOP_BOX": "Casilla superior",
                "TOTAL": "Total",
                "TOTAL_COUNTS": "Recuentos totales",
                "TO_DO": "Pendiente",
                "TRANSPOSE": "Trasponer",
                "TRANSPOSE_TABLE": "Trasponer tabla",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Cualitativa: esta opinión se presenta en forma de comentarios de texto libres",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Cuantitativa: esta opinión será numérica y se representa en gráficos, gráficos de barras, tablas, etc.",
                "TYPES_OF_FEEDBACK_HEADER": "Varios tipos de opinión",
                "UNDO": "Deshacer",
                "USE_COMPARISON": "Usar comparación",
                "USE_LABELS_FOR_SCALES": "Utilizar etiquetas para escalas",
                "VALUES": "Valores",
                "VALUE_RANGES": "Rangos de valores",
                "VARIANCE": "Varianza",
                "VERTICAL": "Vertical",
                "VERTICAL_RANGE": "Rango vertical",
                "WARNING_DATA_OUT_OF_RANGE": "Advertencia: el valor de datos excede la configuración de rango",
                "WIDGET_ERROR": {
                    "ERROR": "Se ha producido un error inesperado",
                    "MISCONFIGURED": "Este widget no se ha configurado correctamente. Compruebe la configuración.",
                    "NEW": "Configure el widget",
                    "NO_DATA": "No se encontraron datos. Es posible que los filtros sean demasiado exclusivos."
                },
                "WIDGET_NAME": {
                    "BAR": "Gráfico de barras",
                    "BREAKDOWNBAR": "Barra de desglose",
                    "DATA_TABLE": "Tabla de datos",
                    "FUNNEL_CHART": "Gráfico de embudo",
                    "GAUGE": "Gráfico de indicadores",
                    "GRID": "Tabla de resultados",
                    "HEATMAP": "Mapa de calor",
                    "LINE": "Gráfico de líneas",
                    "NEEDS_BASED": "Basado en necesidades",
                    "PIE": "Gráfico circular",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "Medidor de sensibilidad de precios (Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "Maximizador de ingresos (Gabor Granger)",
                    "SCORING_OVERVIEW_CHART": "Gráfico",
                    "SCORING_OVERVIEW_TABLE": "Tabla",
                    "STATS_TABLE": "Tabla de estadísticas",
                    "WORDCLOUD": "Nube de palabras"
                },
                "WORD_ROTATION": "Rotación de palabra",
                "WORD_SPACING": "Espaciado entre palabras",
                "YES": "Sí",
                "YOUR_RATINGS": "Su valoración"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "Añadir",
                "ADD_A_WORD": "Añadir una palabra",
                "COLOR": "Color",
                "DELETE_ALL": "Eliminar todo",
                "EDIT_STOP_WORDS": "Editar palabras vacías",
                "MAX_WORDS": "Máximo de palabras",
                "ROTATION_ANGLED": "En ángulo",
                "ROTATION_HORIZONTAL": "Horizontal",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "Horizontal y vertical",
                "WORD_ORIENTATION": "Orientación de palabras"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "Colores de fondo",
                "DISPLAY_OPTIONS": "Opciones de visualización",
                "INVERT_FONT_COLORS": "Invertir colores de fuentes de bajo contraste",
                "PAGE": "Página",
                "PAGINATE": "Paginar"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "Media",
                "BOTTOM_BOX_METRIC": "Casilla inferior",
                "COLUMNS": "Columnas",
                "COUNT_METRIC": "Respuestas totales",
                "FIELD_NAME": "Campo",
                "MAX_METRIC": "Máximo",
                "MIN_METRIC": "Mínimo",
                "SHOW_RECODES": "Mostrar valores recodificados",
                "SHOW_ROW_NUMBERS": "Mostrar números de fila",
                "STD_DEV_METRIC": "Desviación estándar",
                "TOP_BOX_METRIC": "Casilla superior",
                "TRANSPOSE_BREAKOUTS": "Trasponer rupturas de tendencia",
                "TRANSPOSE_TABLE": "Trasponer tabla",
                "VAR_METRIC": "Varianza"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "Columnas adicionales",
                "ADD_COLUMNS": "Añadir columnas adicionales",
                "ADD_CUSTOM_PALETTE": "Añadir paleta personalizada",
                "ALL_CHOICES": "Todas las opciones",
                "ALL_GROUPS": "Todos los grupos",
                "ALL_RECODES": "Todas las recodificaciones",
                "AUTOMATIC": "Predeterminado",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "Predeterminado - Haga clic para editar",
                "AXIS_VALUES": "Valores de ejes",
                "BREAKOUT_BY": "Desglosar por",
                "CANCEL": "Cancelar",
                "CATEGORICAL": "Categórico",
                "CHOICES": "Opciones",
                "CHOICE_COUNT": "Seleccionar recuento",
                "COLOR_PALETTE": "Paleta de colores",
                "COLUMN_VALUES": "Valores de columna",
                "CONTACT_FIELDS": "Campos de contacto",
                "COUNT": "Recuento",
                "CREATE": "Crear",
                "CUSTOM": "Personalizado",
                "CUSTOM_PALETTE": "Paleta personalizada",
                "DATA_SOURCE": "Fuente de datos",
                "DAY": "Día",
                "DAY_OF_WEEK": "Día de la semana",
                "DECIMAL_PRECISION": "Cifras decimales",
                "DEFAULT": "Predeterminado",
                "DISABLED": "Desactivado",
                "DIVERGENT": "Divergente",
                "EDIT_CUSTOM_PALETTE": "Editar paleta personalizada",
                "ENABLED": "Activada",
                "ERROR_LOADING_DATA": "Error al cargar los datos",
                "FILE_SIZE": "Tamaño",
                "FILE_TYPE": "Tipo",
                "FRI": "Vie",
                "FRIDAY": "Viernes",
                "GROUP_DATE_BY": "Agrupar fecha por",
                "HOUR_OF_DAY": "Hora del día",
                "LENGEND_VALUES": "Valores de leyendas",
                "MAX": "Máx.",
                "MEAN": "Media",
                "MIN": "Mín.",
                "MISCONFIGURED_DATA": "Fuente de datos mal configurada para esta visualización.",
                "MISCONFIGURED_FILTERS": "Filtros no válidos",
                "MODIFY_CUSTOM_PALETTES": "Modificar paletas personalizadas",
                "MON": "Lun",
                "MONDAY": "Lunes",
                "MONTH": "Mes",
                "NONE": "Ninguno",
                "NO_FILE_ID_ERROR": "Esta visualización requiere que se configure una imagen en la encuesta",
                "NO_RESULTS_TO_SHOW": "No hay resultados para mostrar",
                "NPS": "Net Promoter Score®",
                "NPS_GROUP": "Grupo NPS®",
                "NUMERIC_VALUE": "Valor numérico",
                "PALETTE_REMOVED": "Paleta quitada",
                "PERCENTAGE": "Porcentaje",
                "PERCENTAGE_OF_CHOICES": "Porcentaje de opciones",
                "PERCENTAGE_OF_RESPONSES": "Porcentaje de respuestas",
                "QUARTER": "Trimestre",
                "REMOVE": "Quitar",
                "RESPONSE_COUNT": "Recuento de respuestas",
                "RESULTS_PER_PAGE": "Resultados por página",
                "RETRIEVING_DATA_ELLIPSIS": "Recuperando datos...",
                "REVERSE_COLORS": "Invertir colores",
                "ROW_VALUES": "Valores de fila",
                "SAT": "Sáb",
                "SATURDAY": "Sábado",
                "SAVE": "Guardar",
                "SELECTED_CHOICE": "Opción seleccionada",
                "SELECT_FIELD": "Elegir campo",
                "SELECT_METRIC": "Métrica",
                "SEQUENTIAL": "Secuencial",
                "SET_START_COLOR": "Establecer color de inicio",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "Mostrando datos de la muestra...",
                "SUM": "Suma",
                "SUN": "Dom",
                "SUNDAY": "Domingo",
                "SURVEY_EMBEDDEDDATA": "Datos embebidos",
                "SURVEY_METADATA": "Metadatos de la encuesta",
                "TEXT_ENTRY": "Entrada de texto",
                "THURS": "Jue",
                "THURSDAY": "Jueves",
                "TITLE": "Título",
                "TUES": "Mar",
                "TUESDAY": "Martes",
                "UNBOUNDED_DOMAIN": "Los valores que se deben mostrar son demasiados.",
                "UNBOUNDED_DOMAIN_HELP": "Para añadir este campo a los informes de resultados, puede incluir un filtro en el informe para ver menos valores de \"{{ed_field_name}}\" o actualizar el tipo de variable de datos embebidos de \"{{ed_field_name}}\" en el flujo de la encuesta para convertir este campo en uno de tipo cadena o numérico.",
                "UNDO": "Deshacer",
                "USE_CHOICE_TOTALS": "Utilizar totales de opciones",
                "USE_RESPONDENT_TOTALS": "Utilizar totales de encuestados",
                "VISUALIZATION": "Visualización",
                "VISUALIZATION_BARCHART": "Gráfico de barras",
                "VISUALIZATION_BREAKDOWNBAR": "Barra de desglose",
                "VISUALIZATION_GAUGE": "Gráfico de medición",
                "VISUALIZATION_HEATMAP": "Mapa de calor",
                "VISUALIZATION_LINECHART": "Gráfico de líneas",
                "VISUALIZATION_PAGINATEDTABLE": "Tabla paginada",
                "VISUALIZATION_PIE": "Gráfico circular",
                "VISUALIZATION_SIMPLETABLE": "Tabla sencilla",
                "VISUALIZATION_STATSTABLE": "Tabla de estadísticas",
                "VISUALIZATION_TEXTHIGHLIGHTS": "Texto resaltado",
                "VISUALIZATION_WORDCLOUD": "Nube de palabras",
                "WED": "Mié",
                "WEDNESDAY": "Miércoles",
                "WEEK": "Semana",
                "WEIGHTING": "Ponderación",
                "WRONG_QUESTION_TYPE_ERROR": "Este tipo de visualización no se puede utilizar para esta pregunta",
                "YEAR": "Año"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "Media",
                "CHOICE_COUNT": "Seleccionar recuento",
                "COUNT": "Recuento",
                "DISPLAY_OPTIONS": "Opciones de visualización",
                "MAX": "Máximo",
                "MIN": "Mínimo",
                "NPS": "NPS®",
                "PAGE_OF": "Página: %1 de %2",
                "PERCENT": "Porcentaje",
                "RESPONSE_COUNT": "Recuento de respuestas",
                "ROWS_PER_TABLE": "Filas por tabla",
                "SHOWING_ROWS_OF": "Mostrando filas %1 - %2 de %3",
                "SHOW_PERCENTAGES": "Mostrar porcentajes",
                "SHOW_RECODES": "Mostrar valores recodificados",
                "SHOW_ROW_NUMBERS": "Mostrar números de fila",
                "SUM": "Suma",
                "TOTAL": "Total",
                "TRANSPOSE": "Trasponer",
                "USE_COLUMN_TOTALS": "Usar totales de columna",
                "USE_ROW_TOTALS": "Usar totales de fila",
                "VALUE": "Valor"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "Ascendiendo",
                "COUNT": "Recuento",
                "DESCENDING": "Descendiendo",
                "DIAGONAL": "Diagonal",
                "DISPLAY_OPTIONS": "Opciones de visualización",
                "ERROR_COLON": "Error:",
                "ERROR_GENERIC": "Se ha producido un error al cargar la visualización.",
                "HORIZONTAL": "Horizontal",
                "HORIZONTAL_BARS": "Barras horizontales",
                "INCORRECTLY_CONFIGURED": "Seleccionar un valor para mostrar el gráfico",
                "LEGEND_AUTO": "Auto",
                "LEGEND_BOTTOM": "Inferior",
                "LEGEND_INSET": "Diagrama",
                "LEGEND_RIGHT": "Derecha",
                "NORMALIZE_TO_PERCENTAGES": "Normalizar a porcentajes",
                "SHOW_BAR_LABELS": "Mostrar etiquetas de barras",
                "SHOW_LEGEND": "Mostrar leyenda",
                "SHOW_X_AXIS": "Mostrar eje X",
                "SHOW_Y_AXIS": "Mostrar eje Y",
                "SORT_BAR_VALUES": "Ordenar valores de barra",
                "STACKED_BARS": "Barras apiladas",
                "TRANSPOSE": "Trasponer",
                "TRUNCATE_LABELS": "Truncar etiquetas",
                "VERTICAL": "Vertical"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "Solicitudes restantes",
                "COULD_NOT_LOAD_DATA": "No se han podido cargar datos con la configuración especificada; pruebe con un campo fuente diferente o un rango de datos más amplio.",
                "GROUPING_PERCENTAGE_THRESHOLD": "Umbral de porcentaje de grupos",
                "NO_DATA": "Sin datos",
                "RADIUS": "Radio interno",
                "SHOW_AS_PERCENTAGES": "Mostrar como porcentajes"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "Cerrar",
                "DOWNLOAD_CSV": "Descargar CSV",
                "DOWNLOAD_ZIP": "Descargar todos los archivos",
                "NO_DATA": "Sin datos",
                "PAGE_OF": "Página: %1 de %2",
                "RESULTS_PER_PAGE": "Resultados por página",
                "SHOWING_RECORDS_OF": "Mostrando registros: %1 - %2 de %3",
                "SINGLE_RESPONSE": "Respuesta única",
                "VIEW_RESPONSE": "Ver respuesta"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "Opciones de visualización",
                "ERROR_COLON": "Error:",
                "ERROR_GENERIC": "Se ha producido un error al cargar la visualización.",
                "HORIZONTAL_BARS": "Barras horizontales",
                "INCORRECTLY_CONFIGURED": "Seleccionar un valor para mostrar el gráfico",
                "LEGEND_AUTO": "Auto",
                "LEGEND_BOTTOM": "Inferior",
                "LEGEND_INSET": "Diagrama",
                "LEGEND_RIGHT": "Derecha",
                "NORMALIZE_TO_PERCENTAGES": "Normalizar a porcentajes",
                "SHOW_AREA": "Mostrar área",
                "SHOW_LEGEND": "Mostrar leyenda",
                "SHOW_X_AXIS": "Mostrar eje X",
                "SHOW_Y_AXIS": "Mostrar eje Y",
                "SMOOTH_LINES": "Suavizar líneas",
                "SORT_X_AXIS_LABELS": "Clasificación de etiquetas del eje X",
                "STACKED_BARS": "Barras apiladas",
                "TRANSPOSE": "Trasponer"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "Modo de bloque",
                "BLUR": "Difuso",
                "COULD_NOT_LOAD_DATA": "No se han podido cargar datos con la configuración especificada; pruebe con un campo fuente diferente o un rango de datos más amplio.",
                "FIELD": "Campo",
                "RADIUS": "Radio",
                "SHOW_REGIONS": "Mostrar regiones",
                "SHOW_REGION_LABELS": "Mostrar etiquetas de regiones"
            },
            "GAUGEWIDGET": {
                "MAX": "Máx.",
                "MIN": "Mín.",
                "VALUE_RANGES": "Rangos de valores"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "Etiquetas inferiores",
                "CATEGORY_NAME": "Nombre de la categoría",
                "ERROR_COLON": "Error:",
                "INCLUDE_HIDDEN_GROUPS": "Incluir grupos ocultos en porcentajes",
                "LARGE_LABELS": "Etiquetas grandes",
                "NO": "No",
                "PERCENT": "Porcentaje",
                "RESPONSE_COUNT": "Recuento de respuestas",
                "RESPONSE_COUNT_WITH_VALUE": "{{ responseCount }} respuestas",
                "SMALL_LABELS": "Etiquetas pequeñas",
                "YES": "Sí"
            }
        });
        $cache.put('ES', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "Código de acceso",
                "ACCESS_CODE_PROTECTION": "Protección de código de acceso",
                "ADD": "Agregar",
                "ADD_BREAKOUT": "Agregar ruptura",
                "ADD_NOTE": "Agregar nota",
                "ADD_SCHEDULED_REPORT": "Agregar informe programado",
                "ADD_WIDGET": "Agregar visualización",
                "ALL_PROJECTS": "Todos los proyectos",
                "ALL_QUESTIONS": "Páginas de preguntas",
                "ANSWER": "Respuesta",
                "ANY_CHANGES_LOST": "Todos los cambios realizados en los informes se perderán si sale de la Plataforma Qualtrics XM.",
                "APPENDED_COPY_IN_PARENS": "(Copiar)",
                "AREA_CHART": "Gráfico de área",
                "AREA_CHART_DESC": "Un gráfico de líneas de dos ejes con el área debajo de línea completa.",
                "ATTACHMENT": "Adjunto",
                "BACKUP_CURRENT_REPORT": "Guarde una copia de seguridad de este informe antes de afectar las visualizaciones",
                "BACKUP_CURRENT_REPORT_LINE2": "Nota: La copia de seguridad se llamará \"{{nameOfReportCopy}}\"",
                "BACK_TO_REPORTS": "Volver a informes",
                "BACK_TO_TOP": "Volver arriba",
                "BACK_TO_VIEW_RESULTS": "Volver a los resultados de la vista anterior",
                "BAR_CHART": "Gráfico de barras",
                "BAR_CHART_DESC": "Un gráfico de barras de dos ejes que permite configuración adicional como transposición de ejes y reorganización de puntos de datos.",
                "BREAKDOWN_BAR_CHART": "Barra de desglose",
                "BREAKDOWN_BAR_CHART_DESC": "Un gráfico de barras horizontales apiladas que generalmente se utiliza para sopesar parámetros visualmente entre sí como alternativa al gráfico circular.",
                "CANCEL": "Cancelar",
                "CANCEL_CONF_TEXT": "¿Seguro que desea cancelar?<br/>Se perderán todos los cambios.",
                "CANCEL_EDITS": "Cancelar ediciones",
                "CHART": "Gráfico",
                "CHOICE": "Opción",
                "CHOICES_COUNT_METRIC": "Recuento de opciones",
                "CHOOSE_PAGES_TO_DISPLAY": "Elija páginas para mostrar",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "Este informe contiene {{maxReportPageCount}} páginas, pero los Resultados solo pueden contener hasta {{reportSizeLimit}}. Seleccione un subconjunto dentro del límite.",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "Los informes solo pueden contener hasta {{reportSizeLimit}} páginas. Seleccione las páginas que desee.",
                "CLEAR_ALL": "Borrar todo",
                "CLOSE": "Cerrar",
                "CLOUD": "UNA DESCRIPCIÓN PARA LA NUBE",
                "COLLABORATED_NEW": "El propietario de esta encuesta está utilizando la Plataforma Qualtrics XM. Los informes de esta encuesta se editarán utilizando Nuevos resultados.",
                "COMMA_SEPARATED_LIST": "Lista de elementos separados por comas",
                "COMPACTNESS": "Fuentes y espaciado",
                "COMPACTNESS_INFO": "Este ajuste afecta el relleno de la tabla, el tamaño de la fuente y el tamaño de las barras en los gráficos. También se aplica a la mayoría de las exportaciones.",
                "CONFIRM": "Aceptar",
                "CONFIRM_DELETE": "Confirmar eliminación",
                "CONFIRM_DELETE_PAGE": "¿Seguro que quiere eliminar esta página?",
                "CONTINUE": "Continuar",
                "CONTINUE_EDITING": "Continuar la edición",
                "COPY": "Copiar",
                "COPY_OF_REPORT_NAME": "Copia de {{nameOfCurrentReport}}",
                "COPY_REPORT": "Copiar informe",
                "COPY_REPORT_ELLIPSIS": "Copiar informe...",
                "COPY_TO_NEW_REPORT": "Copiar al nuevo informe...",
                "CREATE": "Crear",
                "CREATED": "Creada",
                "CREATE_CUSTOM_PAGE": "Crear página personalizada",
                "CREATE_NEW_REPORT": "Crear nuevo informe",
                "CREATE_NEW_REPORT_ELLIPSIS": "Crear nuevo informe...",
                "CSV_FILE": "Archivo CSV",
                "CUSTOM_PAGES": "Páginas personalizadas",
                "DATE": "Fecha",
                "DEFAULT_PALETTE": "Paleta de colores por defecto",
                "DEFAULT_REPORT": "Informe por defecto",
                "DEFAULT_VISUALIZATIONS": "Visualizaciones predeterminadas",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "Estos son los tipos de visualización predeterminados utilizados para elaborar informes de resultados predeterminados. La actualización y aplicación de esta configuración volverá a elaborar su informe actual con la nueva configuración predeterminada. Tendrá la opción de realizar una copia de seguridad de su informe actual.",
                "DEFAULT_VISUALIZATIONS_NOTE": "Nota: No todos los tipos de visualización están disponibles para todos los tipos de preguntas. Algunas visualizaciones no predeterminadas podrían sustituirse automáticamente.",
                "DEFAULT_VISUALS_DISCLAIMER": "Qualtrics actualizará este informe con la nueva configuración de visualización predeterminada.",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "Esta actualización afectará a {{amountOfWidgetsAffected}} visualizaciones en este informe.",
                "DEFAULT_VISUAL_EDIT_DETECTED": "Visualización predeterminada Editar detectada",
                "DELETE_BUTTON": "Eliminar",
                "DELETE_DISABLED_EXPLANATION": "No se pueden borrar informes creados en la interfaz anterior de informes hasta que su organización haya realizado la migración completa a la Plataforma Qualtrics XM.",
                "DELETE_PAGE": "Eliminar página",
                "DELETE_PAGE_ELLIPSIS": "Eliminar página...",
                "DELETE_REPORT": "Suprimir informe",
                "DELETE_REPORT_ELLIPSIS": "Eliminar informe...",
                "DELETE_WIDGET_QUESTION": "¿Eliminar?",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "Este campo está cifrado y no se puede utilizar para ordenar.",
                "DISCARD_EDITS": "Descartar ediciones",
                "DISTRIBUTION_PAUSED": "Distribución de informes pausada.",
                "DONE_BUTTON": "Listo",
                "DONE_EDITING": "Edición realizada",
                "DOWNLOAD": "Descargar",
                "DOWNLOAD_AS_CSV": "Descargar como CSV",
                "DOWNLOAD_AS_PDF": "Descargar como PDF",
                "DOWNLOAD_FAILED": "La descarga falló",
                "DOWNLOAD_PREVIOUS_EXPORTS": "Descargar exportaciones anteriores...",
                "DO_YOU_WISH_TO_DELETE": "Desea eliminar:",
                "DUPLICATE_PAGE": "Duplicar hoja",
                "EDIT_REPORT": "Editar informe",
                "EDIT_REPORT_ELLIPSIS": "Editar informe...",
                "EDIT_VISUALIZATION": "Editar visualización",
                "EMAIL_ADDRESS": "Dirección de correo electrónico",
                "EMAIL_SENT": "Se envió el correo electrónico...",
                "END_OF_REPORT": "Fin del informe",
                "ENTER_NAME": "Introducir nombre",
                "ERROR_COPYING": "Se produjo un error al copiar el informe.",
                "ERROR_DELETING": "Se produjo un error al eliminar el informe.",
                "ERROR_DELETING_EXPORT": "Se produjo un error al eliminar la exportación.",
                "ERROR_HEADING": "Error",
                "ERROR_PUBLISHING": "Ocurrió un error al guardar la configuración.",
                "ERROR_RENAMING": "Se produjo un error al cambiarle el nombre al informe.",
                "ERROR_REQUESTING_EXPORT": "Se produjo un error al solicitar la exportación.",
                "ERROR_SAVING_GLOBAL_OPTIONS": "Se produjo un error al guardar las opciones de visualización globales.",
                "ERROR_SEND_TEST_EMAIL": "Se produjo un error al enviar el correo electrónico de prueba.",
                "EVERY_FRIDAY": "Todos los viernes",
                "EVERY_MONDAY": "Todos los lunes",
                "EVERY_MONTH": "Mensualmente, el",
                "EVERY_SATURDAY": "Todos los sábados",
                "EVERY_SUNDAY": "Todos los domingos",
                "EVERY_THURSDAY": "Todos los jueves",
                "EVERY_TUESDAY": "Todos los martes",
                "EVERY_WEDNESDAY": "Todos los miércoles",
                "EVERY_WEEK": "Semanalmente, cada",
                "EXAMPLE_GROUP_NUM": "Grupo {{num}}",
                "EXAMPLE_SERIES_NUM": "Serie {{num}}",
                "EXPORT": "Exportar",
                "EXPORT_CSV": "CSV (valores separados por comas)",
                "EXPORT_EXCEL_SPREADSHEET": "Hoja de cálculo de Excel",
                "EXPORT_IMAGE": "Exportar imagen",
                "EXPORT_PAGES": "Exportar páginas",
                "EXPORT_PDF": "Documento PDF",
                "EXPORT_PPT_SLIDES": "Diapositivas de PowerPoint",
                "EXPORT_RAW_DATA": "Exportar datos sin procesar",
                "EXPORT_REPORT": "Exportar informe",
                "EXPORT_VISUALIZATION": "Exportar visualización",
                "EXPORT_WORD_DOC": "Documento de Word",
                "FAILED_SAVE_TXT": "No se pudo guardar",
                "FILTERED": "Filtrados",
                "FIRST_PAGE": "Primera página",
                "FIRST_WEEKDAY": "Primer día de la semana del mes",
                "FROM": "De",
                "FROM_EMAIL": "Correo electrónico del emisor",
                "FROM_NAME": "Nombre del emisor",
                "GAUGE_CHART": "Gráfico de medición",
                "GAUGE_CHART_DESC": "Un gráfico que se asemeja a una herramienta de medición para comparar valores actuales con un objetivo o una serie de límites.",
                "GENERATING_FILE": "Generando archivo...",
                "GENERATING_IMAGE": "Generando imagen...",
                "GENERATING_PDF": "Generando PDF...",
                "GENERIC_ERROR": "Un error no nos permite cargar el proyecto solicitado.",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "Opciones globales...",
                "GLOBAL_METRIC": "Métrica predeterminada",
                "GLOBAL_MODAL_PAGE_TITLE": "Ejemplo de visualización con las opciones globales para la sección Resultados de Qualtrics Research Suite",
                "GLOBAL_MODAL_WIDGET_TITLE": "Título de la visualización",
                "GLOBAL_OPTIONS": "Opciones globales",
                "GLOBAL_PRECISION": "Cantidad de decimales predeterminada",
                "GLOBAL_SETTINGS_APPLY": "Aplicar mi configuración predeterminada",
                "GLOBAL_SETTINGS_SAVE": "Guardar como mi configuración predeterminada",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "Aplicar configuración predeterminada de Qualtrics",
                "GROUP": "Grupo",
                "HEAT_MAP_CHART": "Gráfico de mapa de calor",
                "HEAT_MAP_CHART_DESC": "Una visualización agrupada de estilo “calor” que se utiliza para asignar la distribución de la entrada del usuario (como, por ejemplo, los clics) a la imagen original.",
                "HIDDEN": "Oculto",
                "HIDDEN_PAGE": "Esta página no aparecerá en los informes públicos y su selección se anulará por defecto en exportaciones de informes.",
                "HIDE": "Ocultar",
                "HIDE_ALL_PAGES": "Ocultar todas las páginas",
                "HIDE_PAGE": "Ocultar página",
                "IMAGE_FILE": "Archivo de imagen",
                "INVALID_BRAND_DOMAIN": "El dominio que ha ingresado no está en la lista de dominios de correo electrónico aprobados de su organización. Póngase en contacto con el administrador de su organización para corregirlo.",
                "INVALID_SPF_RECORD": "El dominio que ha ingresado no ha aprobado a Qualtrics para que realice un envío a partir de este. Esto afectará la capacidad de entrega. Utilice otro dominio o póngase en contacto con Qualtrics para ver cómo resolver este problema.",
                "ISSUE_SAVING_REPORTS": "Hubo un error al guardar uno o más informes. Vuelva a intentarlo.",
                "ISSUE_SENDING_TEST": "Hubo un error al enviar un correo electrónico de prueba. Vuelva a intentarlo.",
                "LARGE_SURVEY": "Los resultados no se mostrarán porque la encuesta es demasiado larga.",
                "LAST_DAY": "Último día del mes",
                "LAST_MODIFIED_COLON_WITH_DATE": "Última modificación: %1",
                "LAST_PAGE": "Última página",
                "LAST_WEEKDAY": "Último día de la semana del mes",
                "LATER": "Más tarde",
                "LEARN_MORE": "Más información",
                "LINE_CHART": "Gráfico de líneas",
                "LINE_CHART_DESC": "Un gráfico de líneas de dos ejes que generalmente se utiliza cuando se realiza una representación gráfica respecto al tiempo en el eje x.",
                "LOG_OUT_WARNING": "Haga clic en cualquier lugar dentro de los {{countdown}} segundos para permanecer conectado",
                "MESSAGE": "Mensaje",
                "MONTHLY": "Mensualmente",
                "MOVE_DOWN": "Mover visualización hacia abajo",
                "MOVE_PAGE_TO_BOTTOM": "Mover a la parte inferior",
                "MOVE_PAGE_TO_TOP": "Mover a la parte superior",
                "MOVE_UP": "Mover visualización hacia arriba",
                "MY_SURVEYS": "Mis proyectos",
                "NAME": "Nombre",
                "NEW_CUSTOM_PAGE_NAME": "Nueva página personalizada",
                "NEW_REPORT": "Nuevo informe",
                "NEXT_PAGE": "Página siguiente",
                "NEXT_RUN": "Próxima ejecución",
                "NO_EXPORTS": "Aún no se solicitaron exportaciones para este informe.",
                "NO_ITEMS_TO_DISPLAY": "No hay elementos para mostrar",
                "NO_MATCHING_CUSTOM_PAGES": "No hay páginas personalizadas coincidentes",
                "NO_MATCHING_PAGES": "No se han encontrado páginas para la búsqueda",
                "NO_MATCHING_REPORTS": "No hay informes coincidentes.",
                "NO_PROJECT": "Especifique un proyecto para continuar.",
                "NO_PROJECTS_TO_MIGRATE": "No hay proyectos para actualizar.",
                "NO_QUESTIONS": "No hay preguntas coincidentes",
                "NO_RESULTS_YET": "Aún no hay resultados para mostrar. Distribuya la encuesta para reunir respuestas.",
                "OFF": "Desactivado",
                "ON": "Activado",
                "PAGES_SELECTED": "Páginas seleccionadas",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "Esta selección haría que el informe contenga {{currentSelectedPageCount}} páginas, lo cual supera el máximo de {{reportSizeLimit}} permitido. Seleccione un rango más pequeño.",
                "PAGES_SELECTION_INVALID_RANGE": "Seleccione un rango válido.",
                "PAGE_OPTIONS": "Opciones de página",
                "PDF_ROW_TRUNCATION_MESSAGE": "Hay demasiadas filas para la exportación a PDF; intente exportar a Word o CSV",
                "PERCENTAGE_METRIC": "Porcentaje",
                "PIE_CHART": "Gráfico circular",
                "PIE_CHART_DESC": "Un desglose circular de valores para un determinado punto de datos. Útil para medir proporciones relativas de valores seleccionados.",
                "PREVIEW": "Vista previa",
                "PREVIOUS_PAGE": "Página anterior",
                "PRINT_PAGE": "Imprimir página",
                "PUBLIC_LINK": "Enlace público",
                "PUBLIC_REPORT_AVAILABLE": "Informe público disponible",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "Código de acceso",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "El código de acceso es incorrecto. Intente nuevamente.",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "Enviar",
                "PUBLIC_RESULTS_LOGIN_TITLE": "Iniciar sesión en informe público | Software para encuestas de Qualtrics",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "Informe público no encontrado. Comuníquese con el propietario de este informe y pídale un enlace válido.",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "Informe público no encontrado",
                "PUBLIC_RESULTS_NOT_UPDATED": "Los enlaces a informes públicos y los correos electrónicos de informes programados no usarán la Plataforma Qualtrics XM hasta que los actualice.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "La sesión caducó. Inicie sesión nuevamente para continuar previsualizando el informe de resultados públicos.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "Sesión caducada",
                "PUBLIC_RESULTS_TITLE": "Informe público",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "No tiene autorización para ver esta página. Comuníquese con el propietario de este informe y pídale que lo haga público.",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "Informe público no autorizado",
                "PUBLISHED_LINK_GENERATING_LINK": "Generando enlace…",
                "PUBLISHED_REPORT_FOUND_HERE": "Cualquier persona puede ver este informe en el siguiente enlace:",
                "PUBLISH_REPORT": "Administrar informe público",
                "PUBLISH_REPORT_ELLIPSIS": "Administrar informe público...",
                "QUESTION": "Pregunta",
                "RANK": "Clasificación",
                "REMOVE_WIDGET": "Eliminar visualización",
                "RENAME_PAGE": "Cambiar nombre de la página",
                "RENAME_REPORT": "Cambiar nombre del informe",
                "RENAME_REPORT_ELLIPSIS": "Cambiar nombre del informe...",
                "REPLY_TO_EMAIL": "Dirección de respuesta",
                "REPORT_COLON": "Informe:",
                "REPORT_SETTINGS": "Configuración del informe",
                "REPORT_SETTINGS_ELLIPSIS": "Configuración del informe...",
                "RESPONSE_COUNTS": "Cuentas de respuestas",
                "RESULTS_DASHBOARDS_BANNER": "Y pruebe esta nueva versión mejorada de resultados de encuestas, que incluye una IU y visualizaciones de datos modernos y accesibles, nuevas funciones de análisis y exploración, y mucho más.",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "Notas de publicación",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "Ver las más recientes",
                "RESULTS_OPTIONS": "Opciones de informe",
                "RESULTS_TITLE": "Informe",
                "RESUME_DISTRIBUTION": "Reanudar distribución",
                "REVERT": "Revertir",
                "RICH_TEXT_LIMIT_REACHED": "¡La longitud del contenido ha llegado al límite!",
                "SAVE": "Guardar",
                "SAVE_AND_CLOSE": "Guardar y cerrar",
                "SAVE_AS_CSV": "Guardar visualización como CSV",
                "SAVE_AS_IMAGE": "Guardar visualización como imagen",
                "SAVE_CONFIRMATION": "Guardar confirmación",
                "SAVE_PAGE_AS_ELLIPSIS": "Exportar página como....",
                "SAVE_SETTINGS": "Guardar configuración",
                "SCHEDULE_REPORT_EMAIL": "Programar el envío de un informe por correo electrónico",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "Programar el envío de un informe por correo electrónico...",
                "SEARCH_ELLIPSIS": "Buscar grupos...",
                "SEARCH_PAGES": "Buscar preguntas",
                "SEARCH_PAGES_ELLIPSIS": "Buscar páginas...",
                "SEARCH_REPORTS_ELLIPSIS": "Buscar informes...",
                "SELECTED": "Seleccionado:",
                "SELECT_ALL": "Seleccionar todas",
                "SELECT_A_FIELD": "Seleccionar un campo",
                "SELECT_A_WIDGET": "Seleccionar una visualización",
                "SELECT_PAGES": "Seleccionar páginas",
                "SELECT_PAGES_ELLIPSIS": "Seleccionar páginas...",
                "SEND": "Enviar",
                "SEND_TEST_EMAIL": "Enviar correo electrónico de prueba",
                "SETTING_DEFAULT": "Predeterminado",
                "SETTING_HIGH": "Alto",
                "SETTING_LARGE": "Grande",
                "SETTING_LOW": "Bajo",
                "SETTING_NORMAL": "Normal",
                "SETTING_SMALL": "Pequeño",
                "SHARE_REPORT": "Compartir informe",
                "SHOW_ALL_PAGES": "Mostrar todas las páginas",
                "SHOW_FULL_QTEXT": "Mostrar todo el texto de la pregunta en los títulos de página",
                "SIMPLE_TABLE": "Tabla simple",
                "SIMPLE_TABLE_DESC": "Una tabla flexible que puede mostrar valores múltiples como filas o columnas.",
                "SIZE": "Tamaño",
                "SPLINE_CHART": "Gráfico de spline",
                "SPLINE_CHART_DESC": "Un gráfico de líneas redondeadas de dos ejes que generalmente se usa cuando se realiza una representación gráfica respecto al tiempo en un eje x.",
                "STATISTICS_TABLE": "Tabla de estadísticas",
                "SUBJECT": "Asunto",
                "SURVEY_ANALYSIS": "Análisis de encuesta",
                "SURVEY_SUMMARY": "Resumen de encuesta",
                "TABLE": "UNA DESCRIPCIÓN PARA LA TABLA",
                "TIME": "Hora",
                "TO": "Para",
                "TOTAL": "Total",
                "TRANSPOSE_STATS_TABLES": "Transponer tablas de estadísticas",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "Transponer rupturas de tablas de estadísticas",
                "TRUNCATE_PAGE_TITLES": "Cortar el texto de la pregunta en los títulos de página",
                "TRY_IT_NOW": "Inténtelo de nuevo",
                "TYPE": "Tipo",
                "UNABLE_TO_CHECK_SPF": "No se ha podido comprobar el registro SPF. Vuelva a intentarlo.",
                "UNAUTHORIZED": "No tiene permisos para ver este informe. Póngase en contacto con el propietario para obtener acceso.",
                "UNHIDE_PAGE": "Mostrar página",
                "UPDATE": "Actualizar",
                "UPDATED_SUCCESSFULLY": "La actualización se llevó a cabo con éxito.",
                "UPDATE_ALL_IN_THIS_PROJECT": "Actualizar todos en este proyecto",
                "UPDATE_ALL_PROJECTS": "Actualizar todos los proyectos",
                "UPDATE_NOW": "Actualizar ahora",
                "UPDATE_REPORTS": "Actualizar informes...",
                "UPDATE_REPORT_ELEMENTS": "Actualizar los enlaces a informes públicos y los Correos electrónicos de informes programados",
                "UPGRADE_MY_ACCOUNT": "Actualizar mi cuenta",
                "USE_EXPORT_TAGS": "Incluir números de preguntas",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "Usar totales de columna de tabla simple",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "Usar recuentos de encuestados de tabla simple",
                "USE_WEIGHTED_METRICS": "Use las métricas ponderadas",
                "VIEW": "Ver",
                "WEEKLY": "Semanalmente",
                "WELCOME_TO_NEW_RESULTS": "¡Bienvenido/a a la Elaboración de informes de la Plataforma Qualtrics XM!",
                "WHEN": "Cuándo",
                "WIDGET_LOADING": "Cargando...",
                "WIDGET_OPTIONS_ERR": "No se han podido cargar las opciones de visualización",
                "WIDGET_TYPE": "Visualización",
                "WORD_CLOUD": "Nube de palabras",
                "WORD_CLOUD_DESC": "Una visualización ponderada de frecuencia de palabras en datos de texto con opciones adicionales de codificación de colores."
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Recuerde que existen recursos en su organización para ayudar a interpretar las opiniones como los compañeros de RR. HH., el líder y/o el mentor.",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Sírvase un taza de café y sumérjase en las opiniones.",
                "ABOUT_YOUR_REPORT_HEADER": "Sobre su informe",
                "ABOUT_YOUR_REPORT_LINE1": "Bienvenido a nuestro informe global de las opiniones. Es una gran oportunidad para crecer y desarrollarse como profesional. Con el fin de estar preparado para el éxito al consultar los resultados, permítase el tiempo suficiente para repasar las opiniones. En un principio, las opiniones pueden ser difíciles de escuchar, pero tenga en cuenta que el propósito de este informe es acelerar su crecimiento y desarrollo.",
                "ABOUT_YOUR_REPORT_LINE2": "A medida que repase su informe, hay algunos aspectos que debe tener en cuenta.",
                "ADD_CONDITIONAL_TEXT": "Agregar texto condicional",
                "ADD_CUSTOM_PALETTE": "Agregar paleta personalizada",
                "ADD_DATA_SOURCE": "Agregar fuente de datos",
                "ADD_FOLLOWING": "Agregar lo siguiente",
                "ADD_LABEL": "Agregar etiqueta",
                "ADVANCED_FILTER": "Filtro avanzado",
                "AGREEMENT_CHART": "Gráfico de acuerdo",
                "AGREEMENT_CHART_FOOTER": "El gráfico de acuerdo indica la similitud de las puntuaciones. Cada punto representa cómo una persona le calificó para cada elemento. El tamaño de los puntos muestra cuántos calificadores le otorgaron una clasificación en concreto.",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "respuestas",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "respuesta",
                "AGREEMENT_CHART_LEGEND_TITLE": "Cómo otros le calificaron",
                "ALL": "Todo",
                "AND_IF": "Y si",
                "ANGLED": "En ángulo",
                "AREA": "Área",
                "AUTO": "Auto",
                "AVERAGE": "Promedio",
                "AXIS_VALUES": "Valores de ejes",
                "BAR": "Barra",
                "BASE_WORD_COLOR": "Color de la palabra base",
                "BLUR": "Difuso",
                "BOTTOM_BOX": "Casilla inferior",
                "BREAKOUT_HEADERS": "Encabezados desglosados",
                "CANCEL": "Cancelar",
                "CATEGORICAL": "Categórico",
                "CATEGORY": "Categoría",
                "CATEGORY_NAME": "Nombre de la categoría",
                "CHANGE_CATEGORIES_ORDER": "Modificar el orden de las categorías",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "Modificar el orden de las categorías de puntuación",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "Modificar el orden que se muestra en la visualización haciendo clic a la izquierda del elemento de categoría de puntuación y arrastrándolo a la posición requerida.",
                "CHANGE_QUESTIONS_ORDER": "Modificar el orden de las preguntas",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "Modificar el orden de las preguntas",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "Modificar el orden que se muestra en la visualización haciendo clic a la izquierda del elemento de pregunta y arrastrándolo a la posición requerida.",
                "CHARTS": "Gráficos",
                "CHART_TYPE": "Tipo de gráfico",
                "CHOICE_COUNT": "Recuento de opciones",
                "CHOICE_TOTALS": "Total de opciones",
                "CLEAR": "Borrar",
                "CLOSE": "Cerrar",
                "COLOR_PALETTE": "Paleta de colores",
                "COLUMN_NAMES": "Nombres de columnas",
                "COLUMN_TOTALS": "Total de columnas",
                "COMPARED_FILTER_GROUP": "Grupos por filtros comparados",
                "COMPARED_FILTER_GROUPS": "Grupos por filtros comparados",
                "COMPARE_WITH": "comparar con",
                "COMPETITION_RANKING": "Utilizar la clasificación de competición",
                "COMPETITION_RANKING_TOOLTIP": "En caso de empate, todas las puntuaciones iguales reciben la misma clasificación. Sin embargo, el elemento subsiguiente tendrá una clasificación igual a: el número total de elementos clasificados más arriba en la tabla, más uno.",
                "COMPLETED_RESPONSES": "Respuestas completas",
                "CONDITIONAL_TEXT": "Texto condicional",
                "COUNT": "Recuento",
                "CREATE": "Crear",
                "CUSTOM_PALETTE": "Paleta personalizada",
                "DATA_SOURCE_TYPE": "Tipo de fuente de datos",
                "DATA_SOURCE_TYPE_CATEGORY": "Categorías de puntuación",
                "DATA_SOURCE_TYPE_QUESTION": "Preguntas",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "Pregunta",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "Elementos clasificables",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "Categoría de puntuación",
                "DEFAULT": "Predeterminado",
                "DEFAULT_TEXT": "Texto predeterminado",
                "DELETE": "Eliminar",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "Comprenda de quién son las opiniones, si son de compañeros, de subalternos directos, de directivos, etc.",
                "DIFFERENT_EVALUATORS_HEADER": "Diferentes evaluadores",
                "DIRECT_REPORTS": "Reportes directos",
                "DISABLED": "Desactivado",
                "DISPLAY_OPTIONS": "Opciones de visualización",
                "DISPLAY_THRESHOLD_TEXTS": "Mostrar texto según la siguiente brecha de grupos",
                "DIVERGENT": "Divergente",
                "DONE": "Listo",
                "DONT_HEADER": "No:",
                "DONT_LINE1": "Trate de averiguar quién dijo qué",
                "DONT_LINE2": "Se focalice en una puntuación o comentario positivo o negativo",
                "DONT_LINE3": "Cree un plan de desarrollo para cada elemento",
                "DONT_LINE4": "Esté desalentado si tiene oportunidades de mejora",
                "DONUT": "Rosquilla",
                "DOWNLOAD_CSV": "Descargar CSV antiguo",
                "DOWNLOAD_ZIP": "Descargar todos los archivos",
                "DO_HEADER": "Sí:",
                "DO_LINE1": "Observe las opiniones de una forma global",
                "DO_LINE2": "Identifique temas de fortalezas y oportunidades de mejora",
                "DO_LINE3": "Priorice algunas áreas de enfoque para agregar a su plan de desarrollo",
                "DO_LINE4": "Comprenda que todos tenemos oportunidades de mejora",
                "DROPOFF": "Reducción",
                "DUPLICATE": "Duplicado",
                "EDIT_CONDITIONAL_TEXT": "Editar texto condicional",
                "EDIT_CUSTOM_PALETTE": "Editar paleta personalizada",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "Si no, mostrar el texto siguiente",
                "ENABLED": "Activada",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "Activar ordenación por lógica de visualización de categoría del clasificador",
                "ENABLE_ORDERING_FOR": "Activar ordenación por",
                "EQUAL_TO": "Igual a",
                "FIELD": "Campo",
                "FILTER_NAMES": "Nombres del filtro",
                "FOLLOWING_PARENTHESES": "(siguiente)",
                "FOOTER": "Pie de página",
                "GAP": "Brecha",
                "GAP_CHART": "Gráfico de brecha",
                "GAP_CHART_DESCRIPTION": "El gráfico de brecha muestra la diferencia en la puntuación entre dos grupos de calificadores. Por ejemplo, en el caso de una autocalificación y las calificaciones de otros, una diferencia positiva (+) significa que los otros le puntuaron más alto que la calificación que se dio a sí mismo. Una diferencia negativa (-) indica que los otros le puntuaron más bajo que lo que se puntuó usted.",
                "GAP_CHART_FOOTER": "El gráfico de brecha indica la diferencia +/- entre dos grupos de clasificadores.",
                "GAP_TABLE_DESCRIPTION": "Las fortalezas ocultas muestras las áreas en las que los otros le calificaron más alto de lo que hizo usted. Las áreas de mejora indican dónde los otros le calificaron más bajo que la calificación que se dio. Ambas secciones están clasificadas de mayor a menor brecha.",
                "GAP_TABLE_FOOTER": "La primera columna de las puntuaciones indica cómo se puntuó a usted mismo. La segunda columna indica la puntuación media de los demás. La tercera columna indica la diferencia entre la puntuación que se otorgó a sí mismo y la de los demás.",
                "GAP_TABLE_TITLE": "Fortalezas ocultas/Áreas de mejora",
                "GREATER_OR_EQUAL": "Mayor o igual",
                "GREATER_THAN": "Mayor que",
                "GROUP": "Grupo",
                "GROUPED_FOR_ANONYMITY": "Agrupado para anonimato",
                "HEADER_NAMES": "Nombres de encabezados",
                "HIGHEST_SCORES": "Puntuación más alta",
                "HIGHLIGHT_THRESHOLD": "Umbral para resaltar gaps",
                "HIGHLOW_TABLE": "Puntuaciones altas y bajas",
                "HIGHLOW_TABLE_FOOTER": "En esta sección, se muestran los cinco comportamientos con la calificación más alta y más baja (en todos los comportamientos) de los promedios de categoría de calificador aplicables. Para aprovechar al máximo esta página, puede resultar útil buscar tendencias que puedan surgir. Por ejemplo, si la mayoría de sus comportamientos con la calificación más baja se concentran en una o dos categorías, estas pueden ser áreas que necesiten desarrollo. Los comportamientos mejor calificados pueden identificar fortalezas que pueden aprovecharse en otras áreas.",
                "HIGH_LOW_TABLE_DESCRIPTION": "El gráfico de alto/bajo muestra los elementos en función de las áreas en las que los otros le calificaron más alto y mas bajo.",
                "HORIZONTAL": "Horizontal",
                "HORIZONTAL_AND_VERTICAL": "Horizontal y vertical",
                "HORIZONTAL_BAR": "Barra horizontal",
                "HOW_TO_INTERPRET_RESULT_HEADER": "Cómo interpretar los resultados y establecer cómo proceder:",
                "IF": "Si",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "Incluir etiquetas ocultas en porcentajes",
                "INNER_RIM": "Borde interno",
                "IS": "Es",
                "IS_NOT": "No es",
                "IS_SAME_AS_SUBJECT": "Igual que el asunto",
                "ITEM": "Elemento",
                "LABEL": "etiqueta",
                "LABELS": "Etiquetas",
                "LARGE_LABELS": "Etiquetas grandes",
                "LEGEND": "Leyenda",
                "LEGEND_POSITION": "Posición de la leyenda",
                "LEGEND_VALUES": "Valores de leyendas",
                "LESS_OR_EQUAL": "Menor o igual",
                "LESS_THAN": "Menor que",
                "LINE": "Línea",
                "LOWEST_SCORES": "Puntuación más baja",
                "MANAGERS": "Líderes",
                "MANUAL_FONT_SIZE": "Establecer el tamaño de fuente manualmente",
                "MAX": "Máx.",
                "MEAN": "Promedio",
                "MEDIAN": "Mediana",
                "METRIC_TYPE": "Tipo de métrica",
                "MIN": "Mín.",
                "MODIFY_CUSTOM_PALETTES": "Modificar paletas personalizadas",
                "MOVE_DOWN": "Mover abajo",
                "MOVE_UP": "Mover arriba",
                "MULTI_SELECT_ITEMS_SELECTED": "seleccionado",
                "NEGATIVE_GAPS": "Áreas de mejora",
                "NO": "No",
                "NONE": "Ninguno",
                "NOT_APPLICABLE": "N/C",
                "NOT_EQUAL_TO": "No es igual a",
                "NO_DATA_AVAILABLE_WARNING": "No hay datos disponibles",
                "NO_FILTER": "Sin filtro",
                "NO_FILTER_IS_APPLIED": "No se ha aplicado ningún filtro.",
                "NO_VALUE": "Sin valor",
                "NPS": "Net Promoter Score",
                "NUMBER": "número",
                "NUMBERS": "Números",
                "NUMBER_OF_GAPS_NEGATIVE": "Número de brechas negativas",
                "NUMBER_OF_GAPS_POSITIVE": "Número de brechas positivas",
                "NUMBER_OF_ROWS_HIGH": "Número de filas altas",
                "NUMBER_OF_ROWS_LOW": "Número de filas bajas",
                "OPTIONS": {
                    "HEADER_NAME": "Nombre de encabezado",
                    "LEGEND": "Leyenda",
                    "SCALE_AXIS_CHANGER_TITLE": "Rango"
                },
                "ORIENTATION": "Orientación",
                "OR_IF": "O si",
                "OTHER": "Otro",
                "OTHERS": "Otros",
                "PAGE_OF": "Página: %1 de %2",
                "PALETTE_REMOVED": "Paleta eliminada",
                "PEERS": "Compañeros",
                "PERCENT": "Por ciento",
                "PERCENTAGE": "Porcentaje",
                "PERCENTAGE_OF_CHOICES": "Porcentaje de opciones",
                "PERCENTAGE_OF_RESPONSES": "Porcentaje de respuestas",
                "PERCENT_COMPLETE": "% completo",
                "PERSON_METADATA": "Metadatos de persona",
                "PERSON_METADATA_EVALUATOR": "Del evaluador",
                "PERSON_METADATA_SUBJECT": "Del sujeto",
                "PERSON_METADATA_VIEWER": "Del espectador",
                "POSITIVE_GAPS": "Fortalezas ocultas",
                "PRIMARY_PARENTHESES": "(primario)",
                "QUESTIONS": "Preguntas",
                "RADIUS": "Radio",
                "RANK": "Clasificación",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "Puntuación más alta",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "Puntuaciones más altas",
                "RANKABLE_ITEMS_ITEM_HAS": "El elemento tiene",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "El elemento está en la parte superior",
                "RANKABLE_ITEMS_LOWEST_SCORE": "Puntuación más baja",
                "RANKABLE_ITEMS_LOWEST_SCORES": "Puntuaciones más bajas",
                "RATER_CATEGORY_DISPLAY_LOGIC": "Lógica sofisticada de categoría del clasificador",
                "RATIO": "Proporción",
                "RECORD": "Registro",
                "REFERENCE_GROUP": "Grupo de referencia",
                "RELATIONSHIP": "Relación",
                "RELATIONSHIP_FILTERS": "Filtros de relación",
                "RELATIONSHIP_FILTERS_INFO": "Para agregar filtros de relación (como un informe directo, entre iguales o del líder) seleccione Gestionar los filtros y use Condición de relación solo desde el menú desplegable.",
                "REMOVE": "Eliminar",
                "REMOVE_DATA_SOURCE": "Eliminar fuente de datos",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Recuerde que existen recursos en su organización para ayudar a interpretar las opiniones como los compañeros de RR. HH., el líder y/o el mentor.",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Sírvase un taza de café y sumérjase en las opiniones.",
                    "ABOUT_YOUR_REPORT_HEADER": "Sobre su informe",
                    "ABOUT_YOUR_REPORT_LINE1": "Bienvenido a nuestro informe global de las opiniones. Es una gran oportunidad para crecer y desarrollarse como profesional. Con el fin de estar preparado para el éxito al consultar los resultados, permítase el tiempo suficiente para repasar las opiniones. En un principio, las opiniones pueden ser difíciles de escuchar, pero tenga en cuenta que el propósito de este informe es acelerar su crecimiento y desarrollo.",
                    "ABOUT_YOUR_REPORT_LINE2": "A medida que repase su informe, hay algunos aspectos que debe tener en cuenta.",
                    "ADVANCED_FILTER": "Filtro avanzado",
                    "AGREEMENT_CHART": "Gráfico de acuerdo",
                    "AGREEMENT_CHART_FOOTER": "El gráfico de acuerdo indica la similitud de las puntuaciones. Cada punto representa cómo una persona le calificó para cada elemento. El tamaño de los puntos muestra cuántos calificadores le otorgaron una clasificación en concreto.",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "respuestas",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "respuesta",
                    "AGREEMENT_CHART_LEGEND_TITLE": "Cómo otros le calificaron",
                    "ALL": "Todo",
                    "AVERAGE": "Promedio",
                    "BOTTOM_BOX": "Casilla inferior",
                    "CHOICE_COUNT": "Recuento de opciones",
                    "CHOICE_TOTALS": "Total de opciones",
                    "COMPARISON": "Comparación",
                    "COMPARISON_GAP_COLUMN_HEADER": "Brecha de comparación",
                    "COMPLETED_RESPONSES": "Respuestas completas",
                    "COUNT": "Recuento",
                    "DEFAULT": "Predeterminado",
                    "DEFAULT_TEXT": "Texto predeterminado",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "Comprenda de quién son las opiniones, si son de compañeros, de subalternos directos, de directivos, etc.",
                    "DIFFERENT_EVALUATORS_HEADER": "Diferentes evaluadores",
                    "DONE": "Listo",
                    "DONT_HEADER": "No:",
                    "DONT_LINE1": "Trate de averiguar quién dijo qué",
                    "DONT_LINE2": "Se focalice en una puntuación o comentario positivo o negativo",
                    "DONT_LINE3": "Cree un plan de desarrollo para cada elemento",
                    "DONT_LINE4": "Esté desalentado si tiene oportunidades de mejora",
                    "DO_HEADER": "Sí:",
                    "DO_LINE1": "Observe las opiniones de una forma global",
                    "DO_LINE2": "Identifique temas de fortalezas y oportunidades de mejora",
                    "DO_LINE3": "Priorice algunas áreas de enfoque para agregar a su plan de desarrollo",
                    "DO_LINE4": "Comprenda que todos tenemos oportunidades de mejora",
                    "FIELD": "Campo",
                    "GAP": "Brecha",
                    "GAP_CHART": "Gráfico de brecha",
                    "GAP_CHART_DESCRIPTION": "El gráfico de brecha muestra la diferencia en la puntuación entre dos grupos de calificadores. Por ejemplo, en el caso de una autocalificación y las calificaciones de otros, una diferencia positiva (+) significa que los otros le puntuaron más alto que la calificación que se dio a sí mismo. Una diferencia negativa (-) indica que los otros le puntuaron más bajo que lo que se puntuó usted.",
                    "GAP_CHART_FOOTER": "El gráfico de brecha indica la diferencia +/- entre dos grupos de clasificadores.",
                    "GAP_TABLE_DESCRIPTION": "Las fortalezas ocultas muestras las áreas en las que los otros le calificaron más alto de lo que hizo usted. Las áreas de mejora indican dónde los otros le calificaron más bajo que la calificación que se dio. Ambas secciones están clasificadas de mayor a menor brecha.",
                    "GAP_TABLE_FOOTER": "La primera columna de las puntuaciones indica cómo se puntuó a usted mismo. La segunda columna indica la puntuación media de los demás. La tercera columna indica la diferencia entre la puntuación que se otorgó a sí mismo y la de los demás.",
                    "GAP_TABLE_TITLE": "Fortalezas ocultas/Áreas de mejora",
                    "GROUP": "Grupo",
                    "HIDE_REPORT_ALERT": "Usted no cumple con los requisitos para ver el informe. Póngase en contacto con el administrador de su organización.",
                    "HIGHEST_SCORES": "Puntuación más alta",
                    "HIGHLOW_TABLE": "Puntuaciones altas y bajas",
                    "HIGHLOW_TABLE_FOOTER": "En esta sección, se muestran los cinco comportamientos con la calificación más alta y más baja (en todos los comportamientos) de los promedios de categoría de calificador aplicables. Para aprovechar al máximo esta página, puede resultar útil buscar tendencias que puedan surgir. Por ejemplo, si la mayoría de sus comportamientos con la calificación más baja se concentran en una o dos categorías, estas pueden ser áreas que necesiten desarrollo. Los comportamientos mejor calificados pueden identificar fortalezas que pueden aprovecharse en otras áreas.",
                    "HIGH_LOW_TABLE_DESCRIPTION": "El gráfico de alto/bajo muestra los elementos en función de las áreas en las que los otros le calificaron más alto y mas bajo.",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "Cómo interpretar los resultados y establecer cómo proceder:",
                    "ITEM": "Elemento",
                    "LOWEST_SCORES": "Puntuación más baja",
                    "MAX": "Máx.",
                    "MEAN": "Media",
                    "MEDIAN": "Mediana",
                    "MIN": "Mín.",
                    "NEGATIVE_GAPS": "Áreas de mejora",
                    "NO_COMPARISON_SET": "No se fijó ninguna comparación",
                    "NO_DATA_AVAILABLE_WARNING": "No hay datos disponibles",
                    "NO_FILTER_IS_APPLIED": "No se ha aplicado ningún filtro.",
                    "NO_VALUE": "Sin valor",
                    "NPS": "Net Promoter Score",
                    "OTHERS": "Otros",
                    "PERCENTAGE": "Porcentaje",
                    "PERCENTAGE_OF_CHOICES": "Porcentaje de opciones",
                    "PERCENTAGE_OF_RESPONSES": "Porcentaje de respuestas",
                    "PERCENT_COMPLETE": "% completo",
                    "POSITIVE_GAPS": "Fortalezas ocultas",
                    "QUESTIONS": "Preguntas",
                    "RANK": "Clasificación",
                    "RELATIONSHIPS": {
                        "ANYONE": "Cualquier persona",
                        "DIRECT_REPORT": "Reporte directo",
                        "MANAGER": "Líder",
                        "PEER": "Compañero",
                        "SELF": "Propio"
                    },
                    "REPORT_SUMMARY": "Resumen del informe",
                    "REPORT_SUMMARY_TABLE_FOOTER": "Compare el número de personas que han finalizado la valoración versus al número de personas invitadas a participar.",
                    "REPORT_SUMMARY_TABLE_HEADER": "Estadísticas de encuestado",
                    "RESPONSES": "Respuestas",
                    "RESPONSE_COUNT": "{{responseCount}} respuestas",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> respuestas",
                    "SCORING_CATEGORY": "Categoría de puntuación",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "No hay respuestas para esta categoría",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "No hay respuestas para esta pregunta",
                    "SCORING_OVERVIEW": "Resumen de puntuación",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "Usted y otros evaluadores opinan que esta área es una de las principales fortalezas",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Fortaleza reconocida",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Un área de mejora reconocida significa que la autocalificación y las calificaciones de otros son inferiores al promedio para esta competencia.",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Área de mejora reconocida",
                    "SCORING_OVERVIEW_DESCRIPTION": "Arriba están las competencias o las conductas en las que fue evaluado como parte del proceso de opinión de varios calificadores. Las clasificaciones de comparación se dan por grupo.",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "Brecha mínima",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Diferencia mínima entre los grupos de referencia para textos a mostrar",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "Se visualiza el rango de puntuaciones para cada competencia o comportamiento. La barra representa el promedio numérico.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "La fortaleza no reconocida proviene de una discrepancia entre su autocalificación y las calificaciones de otros.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Fortaleza no reconocida",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "El área de mejora no reconocida proviene de una discrepancia entre su autocalificación y las calificaciones de otros.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Área de mejora no reconocida",
                    "SELF": "Propio",
                    "SELF_ASSESSMENT": "Autoevaluación",
                    "STANDARD_DEVIATION": "Desviación estándar",
                    "SUM": "Suma",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Familiarícese con la escala de clasificación para asegurarse una interpretación precisa.",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "Tener en cuenta la escala",
                    "THINGS_YOU_WILL_SEE_HEADER": "Aspectos que verá:",
                    "THREE_SIXTY_PERCENTILE": "Percentil",
                    "TOP_BOTTOM_BOX": "Cuadro superior/cuadro inferior",
                    "TOP_BOX": "Casilla superior",
                    "TOTAL": "Total",
                    "TO_DO": "Pendiente",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Cualitativo: esta opinión será en formato de comentarios de texto abiertos.",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Cuantitativo: esta opinión será numérica y puede estar representada en gráficos, diagrama de barras, tablas, etc.",
                    "TYPES_OF_FEEDBACK_HEADER": "Varios tipos de opinión",
                    "VALUE": "Valor",
                    "VARIANCE": "Varianza",
                    "YOUR_RATINGS": "Sus clasificaciones"
                },
                "REPORT_SUMMARY": "Resumen del informe",
                "REPORT_SUMMARY_TABLE_FOOTER": "Compare el número de personas que han finalizado la valoración versus al número de personas invitadas a participar.",
                "REPORT_SUMMARY_TABLE_HEADER": "Estadísticas de encuestado",
                "RESET": "Restablecer",
                "RESPONDENT_TOTALS": "Total de encuestados",
                "RESPONSES": "Respuestas",
                "RESPONSE_COUNT": "{{responseCount}} respuestas",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> respuestas",
                "RESULT": "Resultado",
                "REVERSE_COLORS": "Invertir colores",
                "ROW_TOTALS": "Totales de la fila",
                "SAVE": "Guardar",
                "SAVE_AND_APPLY": "Guardar y aplicar",
                "SCORING_CATEGORY": "Categoría de puntuación",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "No hay respuestas para esta categoría",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "No hay respuestas para esta pregunta",
                "SCORING_OVERVIEW": "Resumen de puntuación",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "Usted y otros evaluadores opinan que esta área es una de las principales fortalezas",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Fortaleza reconocida",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Un área de mejora reconocida significa que la autocalificación y las calificaciones de otros son inferiores al promedio para esta competencia.",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Área de mejora reconocida",
                "SCORING_OVERVIEW_DESCRIPTION": "Arriba están las competencias o las conductas en las que fue evaluado como parte del proceso de opinión de varios calificadores. Las clasificaciones de comparación se dan por grupo.",
                "SCORING_OVERVIEW_MINIMUM_GAP": "Brecha mínima",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Diferencia mínima entre los grupos de referencia para textos a mostrar",
                "SCORING_OVERVIEW_TABLE_FOOTER": "Se visualiza el rango de puntuaciones para cada competencia o comportamiento. La barra representa el promedio numérico.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "La fortaleza no reconocida proviene de una discrepancia entre su autocalificación y las calificaciones de otros.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Fortaleza no reconocida",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "El área de mejora no reconocida proviene de una discrepancia entre su autocalificación y las calificaciones de otros.",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Área de mejora no reconocida",
                "SELECT_CATEGORIES": "Seleccione categorías de puntuación...",
                "SELECT_CATEGORY": "Seleccione una categoría de puntuación...",
                "SELECT_CONDITION_TYPE": "Seleccione un tipo de condición",
                "SELECT_DATA_SOURCE": "Seleccionar fuente de datos",
                "SELECT_DATA_SOURCE_TYPE": "Seleccionar tipo de fuente de datos",
                "SELECT_FILTER": "Seleccionar filtro",
                "SELECT_FILTERS": "Seleccionar filtros",
                "SELECT_OPERATOR_TYPE": "Seleccionar tipo de operador",
                "SELECT_PERSON": "Seleccionar persona",
                "SELECT_PERSON_METADATA": "Seleccionar metadatos de persona",
                "SELECT_QUESTION": "Seleccionar pregunta",
                "SELECT_QUESTIONS": "Seleccione preguntas...",
                "SELECT_RATIO_OR_DROPOFF": "Seleccionar proporción o reducción",
                "SELECT_RELATIONSHIP": "Seleccionar relación",
                "SELECT_SCORING_CATEGORY": "Seleccionar categoría de puntuación",
                "SELF": "Propio",
                "SELF_ASSESSMENT": "Autoevaluación",
                "SEQUENTIAL": "Secuencial",
                "SETUP_COMPARISON": "Configurar comparación",
                "SETUP_COMPARISONS": "Configurar comparaciones",
                "SET_START_COLOR": "Establecer color de inicio",
                "SHOULD_SHOW_FOOTER": "Mostrar pie de página",
                "SHOULD_SHOW_SCORING_CATEGORY": "Mostar categoría de puntuación",
                "SHOWING_RECORDS_OF": "Mostrando registros %1 - %2 de %3",
                "SHOW_COMPARISON_GAP": "Mostrar columna de separación de comparación",
                "SHOW_DATA_LABEL": "Mostrar valores de datos",
                "SHOW_PERCENTAGES": "Mostrar porcentajes",
                "SHOW_THE_FOLLOWING_TEXT": "A continuación, mostrar el texto siguiente",
                "SHOW_TIES": "Mostrar empatados",
                "SHOW_X_AXIS": "Mostrar eje X",
                "SHOW_Y_AXIS": "Mostrar eje Y",
                "SMALL_LABELS": "Etiquetas pequeñas",
                "SORT": "Ordenar",
                "SPLINE": "Spline",
                "STACK_CHART": "Gráfico de pilas",
                "STANDARD_DEVIATION": "Desviación estándar",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "Debilidad inferior a",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "Editar textos de umbral",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "Texto de umbral",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "Habilitar textos de umbral",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "Fortaleza superior a",
                "SUM": "Suma",
                "SUMMARY": "Resumen",
                "TABLES": "Tablas",
                "TABLE_TOTALS": "Totales de la tabla",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Familiarícese con la escala de clasificación para asegurarse una interpretación precisa.",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "Tener en cuenta la escala",
                "TEXT": "Texto",
                "THINGS_YOU_WILL_SEE_HEADER": "Aspectos que verá:",
                "TOP_BOTTOM_BOX": "Cuadro superior/cuadro inferior",
                "TOP_BOX": "Casilla superior",
                "TOTAL": "Total",
                "TOTAL_COUNTS": "Recuentos totales",
                "TO_DO": "Pendiente",
                "TRANSPOSE": "Transponer",
                "TRANSPOSE_TABLE": "Transponer tabla",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Cualitativo: esta opinión será en formato de comentarios de texto abiertos.",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Cuantitativo: esta opinión será numérica y puede estar representada en gráficos, diagrama de barras, tablas, etc.",
                "TYPES_OF_FEEDBACK_HEADER": "Varios tipos de opinión",
                "UNDO": "Deshacer",
                "USE_COMPARISON": "Usar comparación",
                "USE_LABELS_FOR_SCALES": "Usar etiquetas para las escalas",
                "VALUES": "Valores",
                "VALUE_RANGES": "Rangos de valores",
                "VARIANCE": "Varianza",
                "VERTICAL": "Vertical",
                "VERTICAL_RANGE": "Rango vertical",
                "WARNING_DATA_OUT_OF_RANGE": "Advertencia: El valor de los datos supera la configuración del rango",
                "WIDGET_ERROR": {
                    "ERROR": "Se produjo un error inesperado",
                    "MISCONFIGURED": "Este widget no está configurado correctamente. Compruebe la configuración del widget.",
                    "NEW": "Configure el widget",
                    "NO_DATA": "No se encontraron datos. Es posible que los filtros sean demasiado exclusivos."
                },
                "WIDGET_NAME": {
                    "BAR": "Gráfico de barras",
                    "BREAKDOWNBAR": "Barra de desglose",
                    "DATA_TABLE": "Tabla de datos",
                    "FUNNEL_CHART": "Gráfico de embudo",
                    "GAUGE": "Gráfico de medición",
                    "GRID": "Tabla de resultados",
                    "HEATMAP": "Mapa de calor",
                    "LINE": "Gráfico de líneas",
                    "NEEDS_BASED": "Basado en las necesidades",
                    "PIE": "Gráfico circular",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "Medidor de sensibilidad de precios (Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "Maximizador de ingresos (Gabor Granger)",
                    "SCORING_OVERVIEW_CHART": "Gráfico",
                    "SCORING_OVERVIEW_TABLE": "Tabla",
                    "STATS_TABLE": "Tabla de estadística",
                    "WORDCLOUD": "Nube de palabras"
                },
                "WORD_ROTATION": "Rotación de palabra",
                "WORD_SPACING": "Espaciado entre palabras",
                "YES": "Sí",
                "YOUR_RATINGS": "Sus clasificaciones"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "Agregar",
                "ADD_A_WORD": "Agregar una palabra",
                "COLOR": "Color",
                "DELETE_ALL": "Eliminar todo",
                "EDIT_STOP_WORDS": "Editar palabras de detención",
                "MAX_WORDS": "Máximo de palabras",
                "ROTATION_ANGLED": "En ángulo",
                "ROTATION_HORIZONTAL": "Horizontal",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "Horizontal y vertical",
                "WORD_ORIENTATION": "Orientación de palabras"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "Colores de fondo",
                "DISPLAY_OPTIONS": "Opciones de visualización",
                "INVERT_FONT_COLORS": "Invertir colores de fuente de bajo contraste",
                "PAGE": "Página",
                "PAGINATE": "Paginar"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "Promedio",
                "BOTTOM_BOX_METRIC": "Casilla inferior",
                "COLUMNS": "Columnas",
                "COUNT_METRIC": "Total de respuestas",
                "FIELD_NAME": "Campo",
                "MAX_METRIC": "Máximo",
                "MIN_METRIC": "Mínimo",
                "SHOW_RECODES": "Mostrar valores recodificados",
                "SHOW_ROW_NUMBERS": "Mostrar números de fila",
                "STD_DEV_METRIC": "Desviación estándar",
                "TOP_BOX_METRIC": "Casilla superior",
                "TRANSPOSE_BREAKOUTS": "Transponer rupturas",
                "TRANSPOSE_TABLE": "Transponer tabla",
                "VAR_METRIC": "Varianza"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "Columnas adicionales",
                "ADD_COLUMNS": "Agregar columnas adicionales",
                "ADD_CUSTOM_PALETTE": "Agregar paleta personalizada",
                "ALL_CHOICES": "Todas las opciones",
                "ALL_GROUPS": "Todos los grupos",
                "ALL_RECODES": "Todas las recodificaciones",
                "AUTOMATIC": "Predeterminado",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "Predeterminado - Haga clic para editar",
                "AXIS_VALUES": "Valores de ejes",
                "BREAKOUT_BY": "Desglosar por",
                "CANCEL": "Cancelar",
                "CATEGORICAL": "Categórico",
                "CHOICES": "Opciones",
                "CHOICE_COUNT": "Recuento de opciones",
                "COLOR_PALETTE": "Paleta de colores",
                "COLUMN_VALUES": "Valores de columna",
                "CONTACT_FIELDS": "Campos de contacto",
                "COUNT": "Recuento",
                "CREATE": "Crear",
                "CUSTOM": "Personalizada",
                "CUSTOM_PALETTE": "Paleta personalizada",
                "DATA_SOURCE": "Fuente de datos",
                "DAY": "Día",
                "DAY_OF_WEEK": "Día de la semana",
                "DECIMAL_PRECISION": "Cifras decimales",
                "DEFAULT": "Predeterminado",
                "DISABLED": "Desactivado",
                "DIVERGENT": "Divergente",
                "EDIT_CUSTOM_PALETTE": "Editar paleta personalizada",
                "ENABLED": "Activada",
                "ERROR_LOADING_DATA": "Error al cargar los datos",
                "FILE_SIZE": "Tamaño",
                "FILE_TYPE": "Tipo",
                "FRI": "Vie",
                "FRIDAY": "Viernes",
                "GROUP_DATE_BY": "Agrupar fecha por",
                "HOUR_OF_DAY": "Hora del día",
                "LENGEND_VALUES": "Valores de leyendas",
                "MAX": "Máx.",
                "MEAN": "Promedio",
                "MIN": "Mín.",
                "MISCONFIGURED_DATA": "Fuente de datos mal configurada para esta visualización.",
                "MISCONFIGURED_FILTERS": "Filtro(s) no válido(s)",
                "MODIFY_CUSTOM_PALETTES": "Modificar paletas personalizadas",
                "MON": "Lun",
                "MONDAY": "Lunes",
                "MONTH": "Mes",
                "NONE": "Ninguno",
                "NO_FILE_ID_ERROR": "Esta visualización necesita que se establezca una imagen en la encuesta",
                "NO_RESULTS_TO_SHOW": "No hay resultados para mostrar",
                "NPS": "Net Promoter Score®",
                "NPS_GROUP": "Grupo NPS®",
                "NUMERIC_VALUE": "Valor numérico",
                "PALETTE_REMOVED": "Paleta eliminada",
                "PERCENTAGE": "Porcentaje",
                "PERCENTAGE_OF_CHOICES": "Porcentaje de opciones",
                "PERCENTAGE_OF_RESPONSES": "Porcentaje de respuestas",
                "QUARTER": "Trimestre",
                "REMOVE": "Eliminar",
                "RESPONSE_COUNT": "Recuento de respuestas",
                "RESULTS_PER_PAGE": "Resultados por página",
                "RETRIEVING_DATA_ELLIPSIS": "Recuperando datos...",
                "REVERSE_COLORS": "Invertir colores",
                "ROW_VALUES": "Valores de fila",
                "SAT": "Sáb",
                "SATURDAY": "Sábado",
                "SAVE": "Guardar",
                "SELECTED_CHOICE": "Opción seleccionada",
                "SELECT_FIELD": "Elegir campo",
                "SELECT_METRIC": "Métrica",
                "SEQUENTIAL": "Secuencial",
                "SET_START_COLOR": "Establecer color de inicio",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "Mostrando datos de la muestra...",
                "SUM": "Suma",
                "SUN": "Dom",
                "SUNDAY": "Domingo",
                "SURVEY_EMBEDDEDDATA": "Datos embebidos",
                "SURVEY_METADATA": "Metadatos de la encuesta",
                "TEXT_ENTRY": "Entrada de texto",
                "THURS": "Jue",
                "THURSDAY": "Jueves",
                "TITLE": "Título",
                "TUES": "Mar",
                "TUESDAY": "Martes",
                "UNBOUNDED_DOMAIN": "Demasiados valores para mostrar.",
                "UNBOUNDED_DOMAIN_HELP": "Para agregar este campo a Informes de resultados, puede agregar un filtro al informe para mostrar una menor cantidad de valores para \"{{ed_field_name}}\" o actualizar el tipo de variable de datos embebidos \"{{ed_field_name}}\" en su flujo de encuesta para que este campo sea de tipo numérico a cadena.",
                "UNDO": "Deshacer",
                "USE_CHOICE_TOTALS": "Usar totales de elecciones",
                "USE_RESPONDENT_TOTALS": "Usar totales de encuestados",
                "VISUALIZATION": "Visualización",
                "VISUALIZATION_BARCHART": "Gráfico de barras",
                "VISUALIZATION_BREAKDOWNBAR": "Barra de desglose",
                "VISUALIZATION_GAUGE": "Gráfico de medición",
                "VISUALIZATION_HEATMAP": "Mapa de calor",
                "VISUALIZATION_LINECHART": "Gráfico de líneas",
                "VISUALIZATION_PAGINATEDTABLE": "Tabla paginada",
                "VISUALIZATION_PIE": "Gráfico circular",
                "VISUALIZATION_SIMPLETABLE": "Tabla simple",
                "VISUALIZATION_STATSTABLE": "Tabla de estadística",
                "VISUALIZATION_TEXTHIGHLIGHTS": "Resaltados de texto",
                "VISUALIZATION_WORDCLOUD": "Nube de palabras",
                "WED": "Mié",
                "WEDNESDAY": "Miércoles",
                "WEEK": "Semana",
                "WEIGHTING": "Ponderación",
                "WRONG_QUESTION_TYPE_ERROR": "Este tipo de visualización no se puede utilizar para esta pregunta",
                "YEAR": "Año"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "Promedio",
                "CHOICE_COUNT": "Recuento de opciones",
                "COUNT": "Recuento",
                "DISPLAY_OPTIONS": "Opciones de visualización",
                "MAX": "Máximo",
                "MIN": "Mínimo",
                "NPS": "NPS®",
                "PAGE_OF": "Página: %1 de %2",
                "PERCENT": "Porcentaje",
                "RESPONSE_COUNT": "Recuento de respuestas",
                "ROWS_PER_TABLE": "Filas por tabla",
                "SHOWING_ROWS_OF": "Mostrando filas %1 - %2 de %3",
                "SHOW_PERCENTAGES": "Mostrar porcentajes",
                "SHOW_RECODES": "Mostrar valores recodificados",
                "SHOW_ROW_NUMBERS": "Mostrar números de fila",
                "SUM": "Suma",
                "TOTAL": "Total",
                "TRANSPOSE": "Transponer",
                "USE_COLUMN_TOTALS": "Utilizar los totales de la columna",
                "USE_ROW_TOTALS": "Utilizar los totales de la fila",
                "VALUE": "Valor"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "Ascendiendo",
                "COUNT": "Recuento",
                "DESCENDING": "Descendiendo",
                "DIAGONAL": "Diagonal",
                "DISPLAY_OPTIONS": "Opciones de visualización",
                "ERROR_COLON": "Error:",
                "ERROR_GENERIC": "Ocurrió un error al cargar la visualización.",
                "HORIZONTAL": "Horizontal",
                "HORIZONTAL_BARS": "Barras horizontales",
                "INCORRECTLY_CONFIGURED": "Elegir un valor para mostrar el gráfico",
                "LEGEND_AUTO": "Auto",
                "LEGEND_BOTTOM": "Inferior",
                "LEGEND_INSET": "Diagrama",
                "LEGEND_RIGHT": "Derecha",
                "NORMALIZE_TO_PERCENTAGES": "Normalizar a porcentajes",
                "SHOW_BAR_LABELS": "Mostrar etiquetas de barra",
                "SHOW_LEGEND": "Mostrar leyenda",
                "SHOW_X_AXIS": "Mostrar eje X",
                "SHOW_Y_AXIS": "Mostrar eje Y",
                "SORT_BAR_VALUES": "Ordenar valores de barra",
                "STACKED_BARS": "Barras apiladas",
                "TRANSPOSE": "Transponer",
                "TRUNCATE_LABELS": "Truncar etiquetas",
                "VERTICAL": "Vertical"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "Todas las otras opciones",
                "COULD_NOT_LOAD_DATA": "No se pudieron cargar los datos con la configuración especificada; intente con un campo fuente diferente o un rango de datos más grande.",
                "GROUPING_PERCENTAGE_THRESHOLD": "Umbral de porcentaje de agrupación",
                "NO_DATA": "Sin datos",
                "RADIUS": "Radio interno",
                "SHOW_AS_PERCENTAGES": "Mostrar como porcentajes"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "Cerrar",
                "DOWNLOAD_CSV": "Descargar CSV",
                "DOWNLOAD_ZIP": "Descargar todos los archivos",
                "NO_DATA": "Sin datos",
                "PAGE_OF": "Página: %1 de %2",
                "RESULTS_PER_PAGE": "Resultados por página",
                "SHOWING_RECORDS_OF": "Mostrando registros %1 - %2 de %3",
                "SINGLE_RESPONSE": "Respuesta única",
                "VIEW_RESPONSE": "Ver respuesta"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "Opciones de visualización",
                "ERROR_COLON": "Error:",
                "ERROR_GENERIC": "Ocurrió un error al cargar la visualización.",
                "HORIZONTAL_BARS": "Barras horizontales",
                "INCORRECTLY_CONFIGURED": "Elegir un valor para mostrar el gráfico",
                "LEGEND_AUTO": "Auto",
                "LEGEND_BOTTOM": "Inferior",
                "LEGEND_INSET": "Diagrama",
                "LEGEND_RIGHT": "Derecha",
                "NORMALIZE_TO_PERCENTAGES": "Normalizar a porcentajes",
                "SHOW_AREA": "Mostrar área",
                "SHOW_LEGEND": "Mostrar leyenda",
                "SHOW_X_AXIS": "Mostrar eje X",
                "SHOW_Y_AXIS": "Mostrar eje Y",
                "SMOOTH_LINES": "Suavizar líneas",
                "SORT_X_AXIS_LABELS": "Clasificar etiquetas de eje X",
                "STACKED_BARS": "Barras apiladas",
                "TRANSPOSE": "Transponer"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "Modo de bloque",
                "BLUR": "Difuso",
                "COULD_NOT_LOAD_DATA": "No se pudieron cargar los datos con la configuración especificada; intente con un campo fuente diferente o un rango de datos más grande.",
                "FIELD": "Campo",
                "RADIUS": "Radio",
                "SHOW_REGIONS": "Mostrar regiones",
                "SHOW_REGION_LABELS": "Mostrar etiquetas de la región"
            },
            "GAUGEWIDGET": {
                "MAX": "Máx.",
                "MIN": "Mín.",
                "VALUE_RANGES": "Rangos de valores"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "Etiquetas inferiores",
                "CATEGORY_NAME": "Nombre de la categoría",
                "ERROR_COLON": "Error:",
                "INCLUDE_HIDDEN_GROUPS": "Incluir grupos ocultos en porcentajes",
                "LARGE_LABELS": "Etiquetas grandes",
                "NO": "No",
                "PERCENT": "Por ciento",
                "RESPONSE_COUNT": "Recuento de respuestas",
                "RESPONSE_COUNT_WITH_VALUE": "{{ responseCount }} respuestas",
                "SMALL_LABELS": "Etiquetas pequeñas",
                "YES": "Sí"
            }
        });
        $cache.put('FI', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "Hakukoodi",
                "ACCESS_CODE_PROTECTION": "Hakukoodin suojaus",
                "ADD": "Lisää",
                "ADD_BREAKOUT": "Lisää raporttijako",
                "ADD_NOTE": "Lisää huomautus",
                "ADD_SCHEDULED_REPORT": "Lisää ajoitettu raportti",
                "ADD_WIDGET": "Lisää visualisointi",
                "ALL_PROJECTS": "Kaikki projektit",
                "ALL_QUESTIONS": "Kysymyssivut",
                "ANSWER": "Vastaus",
                "ANY_CHANGES_LOST": "Kaikki raporttien muutokset häviävät, jos poistut Qualtrics XM Platformista.",
                "APPENDED_COPY_IN_PARENS": "(Kopio)",
                "AREA_CHART": "Aluekaavio",
                "AREA_CHART_DESC": "Kahden akselin viivakaavio, jossa viivan alla oleva alue on täytetty.",
                "ATTACHMENT": "Liite",
                "BACKUP_CURRENT_REPORT": "Tallenna varmuuskopio tästä raportista ennen visualisointien muuttamista",
                "BACKUP_CURRENT_REPORT_LINE2": "Huomautus: varmuuskopion nimi on {{nameOfReportCopy}}",
                "BACK_TO_REPORTS": "Takaisin raportteihin",
                "BACK_TO_TOP": "Takaisin alkuun",
                "BACK_TO_VIEW_RESULTS": "Takaisin vanhaan tulosten näyttöön",
                "BAR_CHART": "Pylväskaavio",
                "BAR_CHART_DESC": "Kahden akselin pylväskaavio, joka voidaan määrittää uudelleen esimerkiksi vaihtamalla akselien paikkaa ja järjestämällä datapisteet uudelleen.",
                "BREAKDOWN_BAR_CHART": "Erittelypalkki",
                "BREAKDOWN_BAR_CHART_DESC": "Vaakasuora pinottu pylväskaavio, jota käytetään yleisimmin mittojen visuaaliseen vertailuun toisiinsa nähden vaihtoehtona ympyräkaaviolle.",
                "CANCEL": "Peruuta",
                "CANCEL_CONF_TEXT": "Haluatko varmasti perua?<br/>Kaikki muutokset menetetään.",
                "CANCEL_EDITS": "Peruuta muokkaukset",
                "CHART": "Kaavio",
                "CHOICE": "Valinta",
                "CHOICES_COUNT_METRIC": "Valintojen määrä",
                "CHOOSE_PAGES_TO_DISPLAY": "Valitse näytettävät sivut",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "Tämä raportti sisältää {{maxReportPageCount}} sivua, mutta tulokset voivat sisältää enintään {{reportSizeLimit}} sivua. Valitse raja-arvon sisällä oleva osajoukko.",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "Raportit voivat sisältää enintään {{reportSizeLimit}} sivua. Valitse haluamasi sivut.",
                "CLEAR_ALL": "Poista valinta kaikista",
                "CLOSE": "Sulje",
                "CLOUD": "PILVEN KUVAUS",
                "COLLABORATED_NEW": "Tämän kyselyn omistaja käyttää Qualtrics XM Platformia! Tämän kyselyn raportit muokataan uusien tulosten avulla.",
                "COMMA_SEPARATED_LIST": "Pilkuin erotettu lista",
                "COMPACTNESS": "Fontit ja välit",
                "COMPACTNESS_INFO": "Tämä asetus vaikuttaa taulukoiden täyttöön, fonttikokoon ja kaavioiden palkkien kokoon. Sitä käytetään myös useimpiin vientitoimintoihin.",
                "CONFIRM": "OK",
                "CONFIRM_DELETE": "Vahvista poisto",
                "CONFIRM_DELETE_PAGE": "Haluatko varmasti poistaa tämän sivun?",
                "CONTINUE": "Jatka",
                "CONTINUE_EDITING": "Jatka muokkausta",
                "COPY": "Kopioi",
                "COPY_OF_REPORT_NAME": "Kopio kohteesta {{nameOfCurrentReport}}",
                "COPY_REPORT": "Kopioi raportti",
                "COPY_REPORT_ELLIPSIS": "Kopioi raportti...",
                "COPY_TO_NEW_REPORT": "Kopioi uuteen raporttiin...",
                "CREATE": "Luo",
                "CREATED": "Luotu",
                "CREATE_CUSTOM_PAGE": "Luo mukautettu sivu",
                "CREATE_NEW_REPORT": "Luo uusi raportti",
                "CREATE_NEW_REPORT_ELLIPSIS": "Luo uusi raportti...",
                "CSV_FILE": "CSV-tiedosto",
                "CUSTOM_PAGES": "Mukautetut sivut",
                "DATE": "Päivämäärä",
                "DEFAULT_PALETTE": "Oletusvärivalikoima",
                "DEFAULT_REPORT": "Oletusraportti",
                "DEFAULT_VISUALIZATIONS": "Oletusvisualisoinnit",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "Nämä ovat oletusvisualisointityypit, joita käytetään oletustulosraporttien muodostamiseen. Näiden asetusten päivitys ja käyttö muodostaa nykyisen raportin uudelleen uusilla oletusasetuksilla. Prosessin aikana on mahdollisuus varmuuskopioida nykyinen raportti.",
                "DEFAULT_VISUALIZATIONS_NOTE": "Huomautus: Kaikki visualisointityypit eivät ole käytettävissä kaikille kysymystyypeille. Muita kuin oletusvisualisointeja saatetaan käyttää automaattisesti.",
                "DEFAULT_VISUALS_DISCLAIMER": "Qualtrics päivittää tämän raportin uusilla oletusvisualisointiasetuksilla.",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "Tämä päivitys vaikuttaa {{amountOfWidgetsAffected}} visualisointeihin tässä raportissa.",
                "DEFAULT_VISUAL_EDIT_DETECTED": "Oletusvisualisoinnin muokkaus havaittu",
                "DELETE_BUTTON": "Poista",
                "DELETE_DISABLED_EXPLANATION": "Edellisellä raporttikäyttöliittymällä luotujen raporttien poistaminen on sallittua vasta sitten, kun organisaatiosi on siirtynyt kokonaan Qualtrics XM Platform -järjestelmään.",
                "DELETE_PAGE": "Poista sivu",
                "DELETE_PAGE_ELLIPSIS": "Poista sivu...",
                "DELETE_REPORT": "Poista raportti",
                "DELETE_REPORT_ELLIPSIS": "Poista raportti...",
                "DELETE_WIDGET_QUESTION": "Poista?",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "Tämä on salattu kenttä, jota ei voida käyttää lajitteluun.",
                "DISCARD_EDITS": "Hylkää muokkaukset",
                "DISTRIBUTION_PAUSED": "Raportin jakelu keskeytetty.",
                "DONE_BUTTON": "Valmis",
                "DONE_EDITING": "Muokkaus valmis",
                "DOWNLOAD": "Lataa",
                "DOWNLOAD_AS_CSV": "Lataa CSV-tiedostona",
                "DOWNLOAD_AS_PDF": "Lataa PDF-tiedostona",
                "DOWNLOAD_FAILED": "Lataus epäonnistui",
                "DOWNLOAD_PREVIOUS_EXPORTS": "Lataa edelliset viennit...",
                "DO_YOU_WISH_TO_DELETE": "Haluatko poistaa:",
                "DUPLICATE_PAGE": "Monista arkki",
                "EDIT_REPORT": "Muokkaa raporttia",
                "EDIT_REPORT_ELLIPSIS": "Muokkaa raporttia...",
                "EDIT_VISUALIZATION": "Muokkaa visualisointia",
                "EMAIL_ADDRESS": "Sähköpostiosoite",
                "EMAIL_SENT": "Sähköposti lähetetty...",
                "END_OF_REPORT": "Raportin loppu",
                "ENTER_NAME": "Anna nimi",
                "ERROR_COPYING": "Virhe kopioitaessa raporttia.",
                "ERROR_DELETING": "Virhe poistettaessa raporttia.",
                "ERROR_DELETING_EXPORT": "Virhe poistettaessa vientiä.",
                "ERROR_HEADING": "Virhe",
                "ERROR_PUBLISHING": "Virhe tallennettaessa asetuksia.",
                "ERROR_RENAMING": "Virhe nimettäessä uudelleen raporttia.",
                "ERROR_REQUESTING_EXPORT": "Virhe pyydettäessä vientiä.",
                "ERROR_SAVING_GLOBAL_OPTIONS": "Virhe tallennettaessa yleisiä visualisoinnin asetuksia.",
                "ERROR_SEND_TEST_EMAIL": "Virhe lähetettäessä testisähköpostia.",
                "EVERY_FRIDAY": "Joka perjantai",
                "EVERY_MONDAY": "Joka maanantai",
                "EVERY_MONTH": "Kuukausittain,",
                "EVERY_SATURDAY": "Joka lauantai",
                "EVERY_SUNDAY": "Joka sunnuntai",
                "EVERY_THURSDAY": "Joka torstai",
                "EVERY_TUESDAY": "Joka tiistai",
                "EVERY_WEDNESDAY": "Joka keskiviikko",
                "EVERY_WEEK": "Viikoittain, joka",
                "EXAMPLE_GROUP_NUM": "Ryhmä {{num}}",
                "EXAMPLE_SERIES_NUM": "Sarja {{num}}",
                "EXPORT": "Vie",
                "EXPORT_CSV": "CSV (pilkuin erotettu)",
                "EXPORT_EXCEL_SPREADSHEET": "Excel-taulukko",
                "EXPORT_IMAGE": "Vie kuva",
                "EXPORT_PAGES": "Vie sivut",
                "EXPORT_PDF": "PDF-asiakirja",
                "EXPORT_PPT_SLIDES": "PowerPoint-diat",
                "EXPORT_RAW_DATA": "Vie raakatiedot",
                "EXPORT_REPORT": "Vie raportti",
                "EXPORT_VISUALIZATION": "Vie visualisointi",
                "EXPORT_WORD_DOC": "Word-asiakirja",
                "FAILED_SAVE_TXT": "Tallennus epäonnistui",
                "FILTERED": "Suodatettu",
                "FIRST_PAGE": "Ensimmäinen sivu",
                "FIRST_WEEKDAY": "Kuukauden ensimmäinen arkipäivä",
                "FROM": "Lähettäjä",
                "FROM_EMAIL": "Lähettäjän sähköpostiosoite",
                "FROM_NAME": "Lähettäjän nimi",
                "GAUGE_CHART": "Mittarikaavio",
                "GAUGE_CHART_DESC": "Kaavio, joka muistuttaa mittarityökalua ja jolla voi vertailla nykyisiä arvoja tavoitteeseen tai sarjaan kynnysarvoja.",
                "GENERATING_FILE": "Muodostetaan tiedosto...",
                "GENERATING_IMAGE": "Muodostetaan kuva...",
                "GENERATING_PDF": "Muodostetaan PDF...",
                "GENERIC_ERROR": "Virhe esti meitä lataamasta pyydettyä projektia.",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "Yleiset asetukset...",
                "GLOBAL_METRIC": "Oletusmitta",
                "GLOBAL_MODAL_PAGE_TITLE": "Esimerkkivisualisointi käyttämällä Qualtrics Research Suiten tulososion yleisiä asetuksia",
                "GLOBAL_MODAL_WIDGET_TITLE": "Visualisoinnin otsikko",
                "GLOBAL_OPTIONS": "Yleiset asetukset",
                "GLOBAL_PRECISION": "Desimaalien oletusmäärä",
                "GLOBAL_SETTINGS_APPLY": "Käytä omia oletusasetuksia",
                "GLOBAL_SETTINGS_SAVE": "Tallenna omiksi oletusasetuksiksi",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "Käytä Qualtrics-oletusasetuksia",
                "GROUP": "Ryhmä",
                "HEAT_MAP_CHART": "Lämpökarttataulukko",
                "HEAT_MAP_CHART_DESC": "Klusteroitu lämpötilakartta-tyylinen visualisointi, jota käytetään kartoittamaan käyttäjäsyötteen (kuten napsautusten) jakautumista alkuperäisessä kuvassa.",
                "HIDDEN": "Piilotettu",
                "HIDDEN_PAGE": "Tämä sivu ei näy julkisissa raporteissa, eikä sitä valita oletusarvoisesti raporttien vienneissä.",
                "HIDE": "Piilota",
                "HIDE_ALL_PAGES": "Piilota kaikki sivut",
                "HIDE_PAGE": "Piilota sivu",
                "IMAGE_FILE": "Kuvatiedosto",
                "INVALID_BRAND_DOMAIN": "Antamasi verkkotunnus ei ole lisenssisi hyväksyttyjen sähköpostin verkkotunnuksien listassa. Ota yhteys lisenssin hallinnoijaan korjausta varten.",
                "INVALID_SPF_RECORD": "Antamasi verkkotunnus ei ole hyväksynyt Qualtricsia lähettäjäksi. Tämä vaikuttaa toimitettavuuteen. Käytä toista verkkotunnusta tai ota yhteys Qualtricsiin ongelman ratkaisemiseksi.",
                "ISSUE_SAVING_REPORTS": "Ongelma yhden tai useamman raportin tallennuksessa. Yritä uudelleen.",
                "ISSUE_SENDING_TEST": "Virhe lähetettäessä testisähköpostia. Yritä uudelleen.",
                "LARGE_SURVEY": "Tuloksia ei näytetä, koska kysely on liian suuri.",
                "LAST_DAY": "Kuukauden viimeinen päivä",
                "LAST_MODIFIED_COLON_WITH_DATE": "Muokattu viimeksi: %1",
                "LAST_PAGE": "Viimeinen sivu",
                "LAST_WEEKDAY": "Kuukauden viimeinen viikonpäivä",
                "LATER": "Myöhempi",
                "LEARN_MORE": "Lisätietoja",
                "LINE_CHART": "Viivakaavio",
                "LINE_CHART_DESC": "Kahden akselin viivakaavio, jota käytetään yleisesti kuvaajan piirtämisen ajan suhteen X-akselilla.",
                "LOG_OUT_WARNING": "Napsauta mitä tahansa kohtaa {{countdown}} sekunnin sisällä, jos haluat pysyä kirjautuneena sisään",
                "MESSAGE": "Viesti",
                "MONTHLY": "Kuukausittain",
                "MOVE_DOWN": "Siirrä visualisointia alas",
                "MOVE_PAGE_TO_BOTTOM": "Siirrä alimmaksi",
                "MOVE_PAGE_TO_TOP": "Siirrä ylimmäksi",
                "MOVE_UP": "Siirrä visualisointia ylös",
                "MY_SURVEYS": "Omat projektit",
                "NAME": "Nimi",
                "NEW_CUSTOM_PAGE_NAME": "Uusi mukautettu sivu",
                "NEW_REPORT": "Uusi raportti",
                "NEXT_PAGE": "Seuraava sivu",
                "NEXT_RUN": "Seuraava suoritus",
                "NO_EXPORTS": "Tälle raportille ei ole vielä pyydetty vientejä.",
                "NO_ITEMS_TO_DISPLAY": "Näytettäviä kohteita ei ole",
                "NO_MATCHING_CUSTOM_PAGES": "Ei vastaavia mukautettuja sivuja",
                "NO_MATCHING_PAGES": "Haulla ei löytynyt sivuja",
                "NO_MATCHING_REPORTS": "Ei vastaavia raportteja.",
                "NO_PROJECT": "Määritä projekti, jotta voit jatkaa.",
                "NO_PROJECTS_TO_MIGRATE": "Ei päivitettäviä projekteja.",
                "NO_QUESTIONS": "Ei vastaavia kysymyksiä",
                "NO_RESULTS_YET": "Näytettäviä tuloksia ei vielä ole. Kerää vastauksia jakelemalla kyselyä.",
                "OFF": "Ei käytössä",
                "ON": "Käytössä",
                "PAGES_SELECTED": "Valitut sivut",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "Tämän valinnan jälkeen raportti sisältää {{currentSelectedPageCount}} sivua, joka ylittää enimmäisrajan {{reportSizeLimit}}. Valitse pienempi alue.",
                "PAGES_SELECTION_INVALID_RANGE": "Valitse kelvollinen alue.",
                "PAGE_OPTIONS": "Sivun asetukset",
                "PDF_ROW_TRUNCATION_MESSAGE": "Rivien määrä liian suuri PDF-muodossa viemiseen. Kokeile Word- tai CSV-muotoon viemistä.",
                "PERCENTAGE_METRIC": "Prosenttiosuus",
                "PIE_CHART": "Ympyräkaavio",
                "PIE_CHART_DESC": "Tietyn datapisteen arvojen esitys pyöreänä kaaviona. Hyödyllinen valittujen arvojen suhteellisten kokojen arvioinnissa.",
                "PREVIEW": "Esikatselu",
                "PREVIOUS_PAGE": "Edellinen sivu",
                "PRINT_PAGE": "Tulosta sivu",
                "PUBLIC_LINK": "Julkinen linkki",
                "PUBLIC_REPORT_AVAILABLE": "Julkinen raportti saatavilla",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "Hakukoodi",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "Virheellinen hakukoodi. Yritä uudelleen.",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "Lähetä",
                "PUBLIC_RESULTS_LOGIN_TITLE": "Julkiseen raporttiin sisäänkirjautuminen | Qualtrics-kyselyohjelmisto",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "Julkista raporttia ei löytynyt. Ota yhteys tämän raportin omistajaan ja pyydä voimassaoleva linkki.",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "Julkista raporttia ei löytynyt",
                "PUBLIC_RESULTS_NOT_UPDATED": "Julkisten raporttien linkit ja ajoitetut raporttisähköpostit eivät käytä Qualtrics XM Platformia, ennen kuin ne päivitetään.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "Istunto on vanhentunut. Kirjaudu sisään uudelleen, jotta voit jatkaa julkisen tulosraportin esikatselua.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "Istunto vanhentui",
                "PUBLIC_RESULTS_TITLE": "Julkinen raportti",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "Sinulla ei ole oikeuksia tarkastella tätä sivua. Ota yhteys tämän raportin omistajaan ja pyydä muuttamaan sivu julkiseksi.",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "Julkinen raportti valtuuttamaton",
                "PUBLISHED_LINK_GENERATING_LINK": "Luodaan linkkiä...",
                "PUBLISHED_REPORT_FOUND_HERE": "Kuka tahansa voi tarkastella tätä raporttia seuraavan linkin kautta:",
                "PUBLISH_REPORT": "Hallitse julkista raporttia",
                "PUBLISH_REPORT_ELLIPSIS": "Hallitse julkista raporttia...",
                "QUESTION": "Kysymys",
                "RANK": "Sija",
                "REMOVE_WIDGET": "Poista visualisointi",
                "RENAME_PAGE": "Nimeä sivu uudelleen",
                "RENAME_REPORT": "Nimeä raportti uudelleen",
                "RENAME_REPORT_ELLIPSIS": "Nimeä raportti uudelleen...",
                "REPLY_TO_EMAIL": "Vastaussähköpostiosoite",
                "REPORT_COLON": "Raportti:",
                "REPORT_SETTINGS": "Raporttiasetukset",
                "REPORT_SETTINGS_ELLIPSIS": "Raporttiasetukset...",
                "RESPONSE_COUNTS": "Vastausten määrät",
                "RESULTS_DASHBOARDS_BANNER": "ja kokeile uutta, parannettua versiota kyselytutkimusten tuloksista, jossa on moderni, esteettömän esteettömyys ja helppokäyttöinen käyttöliittymä ja tietojen visualisointi, uusia analyysi- ja tutkimusominaisuuksia ja paljon muuta.",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "Versiotiedot",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "Näytä uusimmat",
                "RESULTS_OPTIONS": "Raporttiasetukset",
                "RESULTS_TITLE": "Raportti",
                "RESUME_DISTRIBUTION": "Jatka jakelua",
                "REVERT": "Palauta",
                "RICH_TEXT_LIMIT_REACHED": "Sisällön pituus on saavuttanut rajan!",
                "SAVE": "Tallenna",
                "SAVE_AND_CLOSE": "Tallenna ja sulje",
                "SAVE_AS_CSV": "Tallenna visualisointi CSV-tiedostona",
                "SAVE_AS_IMAGE": "Tallenna visualisointi kuvana",
                "SAVE_CONFIRMATION": "Tallenna vahvistus",
                "SAVE_PAGE_AS_ELLIPSIS": "Vie sivu muodossa...",
                "SAVE_SETTINGS": "Tallenna asetukset",
                "SCHEDULE_REPORT_EMAIL": "Ajoita raporttisähköposti",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "Ajoita raporttisähköposti...",
                "SEARCH_ELLIPSIS": "Hae...",
                "SEARCH_PAGES": "Hae kysymykset",
                "SEARCH_PAGES_ELLIPSIS": "Hae sivut...",
                "SEARCH_REPORTS_ELLIPSIS": "Hae raportit...",
                "SELECTED": "Valittu:",
                "SELECT_ALL": "Valitse kaikki",
                "SELECT_A_FIELD": "Valitse kenttä",
                "SELECT_A_WIDGET": "Valitse visualisointi",
                "SELECT_PAGES": "Valitse sivut",
                "SELECT_PAGES_ELLIPSIS": "Valitse sivut...",
                "SEND": "Lähetä",
                "SEND_TEST_EMAIL": "Lähetä testisähköposti",
                "SETTING_DEFAULT": "Oletusasetus",
                "SETTING_HIGH": "Korkea",
                "SETTING_LARGE": "Suuri",
                "SETTING_LOW": "Matala",
                "SETTING_NORMAL": "Normaali",
                "SETTING_SMALL": "Pieni",
                "SHARE_REPORT": "Jaa raportti",
                "SHOW_ALL_PAGES": "Näytä kaikki sivut",
                "SHOW_FULL_QTEXT": "Näytä koko kysymysteksti sivuotsikoissa",
                "SIMPLE_TABLE": "Yksinkertainen taulukko",
                "SIMPLE_TABLE_DESC": "Joustava taulukko, joka voi näyttää useita arvoja riveinä tai sarakkeina.",
                "SIZE": "Koko",
                "SPLINE_CHART": "Splinikäyrä",
                "SPLINE_CHART_DESC": "Kahden akselin pyöristetty viivakaavio, jota käytetään yleisesti kuvaajan piirtämisen ajan suhteen X-akselilla.",
                "STATISTICS_TABLE": "Tilastotaulukko",
                "SUBJECT": "Aihe",
                "SURVEY_ANALYSIS": "Kyselyn analyysi",
                "SURVEY_SUMMARY": "Kyselyn yhteenveto",
                "TABLE": "TAULUKON KUVAUS",
                "TIME": "Aika",
                "TO": "Vastaanottaja",
                "TOTAL": "Yhteensä",
                "TRANSPOSE_STATS_TABLES": "Transponoi tilastotaulukot",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "Transponoi tilastotaulukoiden erittelyt",
                "TRUNCATE_PAGE_TITLES": "Katkaise kysymysteksti sivuotsikoissa",
                "TRY_IT_NOW": "Kokeile nyt",
                "TYPE": "Tyyppi",
                "UNABLE_TO_CHECK_SPF": "SPF-tallennetta ei voi tarkistaa. Yritä uudelleen.",
                "UNAUTHORIZED": "Sinulla ei ole lupaa tarkastella tätä raporttia. Ota yhteys omistajaan, jos haluat pääsyn tietoihin.",
                "UNHIDE_PAGE": "Tuo sivu esiin",
                "UPDATE": "Päivitys",
                "UPDATED_SUCCESSFULLY": "Päivitys onnistui.",
                "UPDATE_ALL_IN_THIS_PROJECT": "Päivitä kaikki tässä projektissa",
                "UPDATE_ALL_PROJECTS": "Päivitä kaikki projektit",
                "UPDATE_NOW": "Päivitä nyt",
                "UPDATE_REPORTS": "Päivitä raportit...",
                "UPDATE_REPORT_ELEMENTS": "Päivitä julkisten raporttien linkit ja ajoitetut raporttisähköpostit",
                "UPGRADE_MY_ACCOUNT": "Päivitä oma tili",
                "USE_EXPORT_TAGS": "Sisällytä kysymysten numerot",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "Käytä yksinkertaisen taulukon sarakesummia",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "Käytä yksinkertaisen taulukon vastaajalukuja",
                "USE_WEIGHTED_METRICS": "Käytä painotettuja mittauksia",
                "VIEW": "Näytä",
                "WEEKLY": "Viikoittain",
                "WELCOME_TO_NEW_RESULTS": "Tervetuloa Qualtrics XM Platformin raportointiin!",
                "WHEN": "Kun",
                "WIDGET_LOADING": "Ladataan...",
                "WIDGET_OPTIONS_ERR": "Visualisointiasetusten lataus epäonnistui",
                "WIDGET_TYPE": "Visualisointi",
                "WORD_CLOUD": "Avainsanapilvi",
                "WORD_CLOUD_DESC": "Tekstimuotoisen tiedon sisältämien sanojen esiintymistaajuuden painotettu visualisointi värikoodauksin täydennettynä."
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Muista, että organisaatiossasi on resursseja, jotka voivat auttaa sinua tulkitsemaan saamaasi palautetta, kuten HR-tiimi, esimiehesi ja/tai mentorisi.",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Ota kuppi kahvia ja ryhdy tarkastelemaan saamaasi palautetta.",
                "ABOUT_YOUR_REPORT_HEADER": "Tietoja raportistasi",
                "ABOUT_YOUR_REPORT_LINE1": "Tervetuloa 360-palauteraportin pariin. Tämä on loistava mahdollisuus kasvaa ja kehittyä ammattilaisena. Jotta raportista on sinulle mahdollisimman paljon hyötyä, varaa riittävästi aikaa palautteen käsittelyyn. Aluksi palautteen lukeminen voi tuntua vaikealta, mutta muista, että palautteen tarkoituksena on auttaa sinua kasvamaan ja kehittymään.",
                "ABOUT_YOUR_REPORT_LINE2": "Kun käyt raporttia läpi, nämä asiat kannattaa pitää mielessä.",
                "ADD_CONDITIONAL_TEXT": "Lisää ehdollinen teksti",
                "ADD_CUSTOM_PALETTE": "Lisää mukautettu värivalikoima",
                "ADD_DATA_SOURCE": "Lisää tiedon lähde",
                "ADD_FOLLOWING": "Lisää seuraavat",
                "ADD_LABEL": "Lisää selite",
                "ADVANCED_FILTER": "Edistynyt suodatin",
                "AGREEMENT_CHART": "Yhdenmukaisuuskaavio",
                "AGREEMENT_CHART_FOOTER": "Yhdenmukaisuuskaaviosta ilmenee pisteiden samankaltaisuus. Kukin piste esittää yksittäistä arviota kustakin arvioitavasta alueesta. Pisteen koko osoittaa, kuinka moni arvioija on antanut saman arvion.",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "vastausta",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "vastaus",
                "AGREEMENT_CHART_LEGEND_TITLE": "Kuinka muut arvioivat sinut",
                "ALL": "Kaikki",
                "AND_IF": "Ja jos",
                "ANGLED": "Kulmikas",
                "AREA": "Alue",
                "AUTO": "Autom.",
                "AVERAGE": "Keskitaso",
                "AXIS_VALUES": "Akselien arvot",
                "BAR": "Palkki",
                "BASE_WORD_COLOR": "Perussanaväri",
                "BLUR": "Sumenna",
                "BOTTOM_BOX": "Alin osuus",
                "BREAKOUT_HEADERS": "Irrottamisten ylätunnisteet",
                "CANCEL": "Peruuta",
                "CATEGORICAL": "Luokkiin jakautuva",
                "CATEGORY": "Kategoria",
                "CATEGORY_NAME": "Tuotekatalogin nimi",
                "CHANGE_CATEGORIES_ORDER": "Muuta kategoriajärjestystä",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "Muuta pisteytyskategorioiden järjestystä",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "Muuta visualisoinnissa näytettävää järjestystä napsauttamalla pisteytyskategoriaelementin vasemmalla puolella ja vetämällä sen haluttuun kohtaan.",
                "CHANGE_QUESTIONS_ORDER": "Muuta kysymysjärjestystä",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "Muuta kysymysjärjestystä",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "Muuta visualisoinnissa näytettävää järjestystä napsauttamalla kysymyselementin vasemmalla puolella ja vetämällä sen haluttuun kohtaan.",
                "CHARTS": "Kaaviot",
                "CHART_TYPE": "Kaaviotyyppi",
                "CHOICE_COUNT": "Valintamäärä",
                "CHOICE_TOTALS": "Valintojen summat",
                "CLEAR": "Tyhjennä",
                "CLOSE": "Sulje",
                "COLOR_PALETTE": "Väripaletti",
                "COLUMN_NAMES": "Sarakkeiden nimet",
                "COLUMN_TOTALS": "Sarakkeen summat",
                "COMPARED_FILTER_GROUP": "Verrattu suodatinryhmä",
                "COMPARED_FILTER_GROUPS": "Verratut suodatinryhmät",
                "COMPARE_WITH": "vertaa kohteeseen",
                "COMPETITION_RANKING": "Käytä kilpailuluokittelua",
                "COMPETITION_RANKING_TOOLTIP": "Tasatilanteessa kaikille samanarvoisille pisteille annetaan sama sija. Seuraava kohde pisteytetään seuraavasti: kohteiden kokonaismäärä, jotka on arvioitu taulukossa korkeammaksi, plus yksi.",
                "COMPLETED_RESPONSES": "Valmiit vastaukset",
                "CONDITIONAL_TEXT": "Ehdollinen teksti",
                "COUNT": "Määrä",
                "CREATE": "Luo",
                "CUSTOM_PALETTE": "Mukautettu värivalikoima",
                "DATA_SOURCE_TYPE": "Tietolähteen tyyppi",
                "DATA_SOURCE_TYPE_CATEGORY": "Pisteytyskategoriat",
                "DATA_SOURCE_TYPE_QUESTION": "Kysymykset",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "Kysymys",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "Paremmuusjärjestykseen laitettavat kohteet",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "Pisteytyskategoria",
                "DEFAULT": "Oletusasetus",
                "DEFAULT_TEXT": "Oletusteksti",
                "DELETE": "Poista",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "Ymmärrä, keneltä palaute on saatu, onko kyseessä työtoverit, suorat alaiset, esimiehet jne.",
                "DIFFERENT_EVALUATORS_HEADER": "Eri arvioijat",
                "DIRECT_REPORTS": "Suorat alaiset",
                "DISABLED": "Poistettu käytöstä",
                "DISPLAY_OPTIONS": "Näyttöasetukset",
                "DISPLAY_THRESHOLD_TEXTS": "Näytä teksti seuraavien ryhmien aukon perusteella",
                "DIVERGENT": "Poikkeava",
                "DONE": "Valmis",
                "DONT_HEADER": "Vältä seuraavia:",
                "DONT_LINE1": "Pohdinta, kuka on sanonut mitäkin",
                "DONT_LINE2": "Keskittyminen yksittäiseen positiiviseen tai negatiiviseen pistemäärään tai kommenttiin",
                "DONT_LINE3": "Kehityssuunnitelman luonti jokaisesta alueesta",
                "DONT_LINE4": "Lannistuminen siitä, että kehityskohteita löytyy",
                "DONUT": "Donitsi",
                "DOWNLOAD_CSV": "Lataa vanha CSV",
                "DOWNLOAD_ZIP": "Lataa kaikki tiedostot",
                "DO_HEADER": "Keskity seuraaviin:",
                "DO_LINE1": "Suhtaudu palautteeseen kokonaisvaltaisesti",
                "DO_LINE2": "Tunnista vahvuuksia ja kehityskohteita koskevat teemat",
                "DO_LINE3": "Priorisoi muutamaa aluetta, jotka lisäät kehityssuunnitelmaan",
                "DO_LINE4": "Ymmärrä, että kaikilla on omat kehityskohteensa",
                "DROPOFF": "Pudotus",
                "DUPLICATE": "Kaksoiskappale",
                "EDIT_CONDITIONAL_TEXT": "Muokkaa ehdollista tekstiä",
                "EDIT_CUSTOM_PALETTE": "Muokkaa mukautettua värivalikoimaa",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "Näytä muutoin seuraava teksti",
                "ENABLED": "Käytössä",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "Ota käyttöön tilaaminen arvioijakategorian näyttölogiikan perusteella",
                "ENABLE_ORDERING_FOR": "Ota käyttöön tilaaminen seuraavaa varten:",
                "EQUAL_TO": "Sama kuin",
                "FIELD": "Kenttä",
                "FILTER_NAMES": "Suodatinten nimet",
                "FOLLOWING_PARENTHESES": "(seurattu)",
                "FOOTER": "Alatunniste",
                "GAP": "Aukko",
                "GAP_CHART": "Aukkokaavio",
                "GAP_CHART_DESCRIPTION": "Aukkokaaviossa näkyy kahden arvioijaryhmän antamien pisteiden välinen ero. Esimerkiksi tapauksessa, jossa voidaan tarkastella sekä itsearviointia että muiden antamia arvioita, positiivinen (+) ero tarkoittaa, että muut ovat antaneet korkeampia arvioita kuin olet itse antanut. Negatiivinen (-) ero tarkoittaa, että muut ovat antaneet matalampia arvioita kuin olet itse antanut.",
                "GAP_CHART_FOOTER": "Aukkokaaviossa näkyy kahden arvioijaryhmän välinen ero +/-.",
                "GAP_TABLE_DESCRIPTION": "Piilevät vahvuudet näyttävät, missä muut ovat antaneet korkeampia arvioita kuin olet itse antanut. Kehitettävät alueet näyttävät, missä muut ovat antaneet matalampia arvioita kuin olet itse antanut. Molemmat osiot on järjestetty isoimmasta aukosta pienimpään.",
                "GAP_TABLE_FOOTER": "Ensimmäisessä pisteiden sarakkeessa näkyy, miten olet itse arvioinut itseäsi. Toisessa sarakkeessa näkyy muiden keskimääräiset pisteet. Kolmannessa sarakkeessa näkyy itse antamiesi pisteiden ja muiden antamien pisteiden välinen ero.",
                "GAP_TABLE_TITLE": "Piilevät vahvuudet / kehitettävät alueet",
                "GREATER_OR_EQUAL": "Suurempi tai yhtä suuri",
                "GREATER_THAN": "Suurempi kuin",
                "GROUP": "Ryhmä",
                "GROUPED_FOR_ANONYMITY": "Anonyymisti ryhmitelty",
                "HEADER_NAMES": "Ylätunnisteiden nimet",
                "HIGHEST_SCORES": "Korkeimmat pisteet",
                "HIGHLIGHT_THRESHOLD": "Aukkojen korostuskynnys",
                "HIGHLOW_TABLE": "Korkeimmat ja alimmat pisteet",
                "HIGHLOW_TABLE_FOOTER": "Tässä osassa esitetään viisi korkeimman ja alhaisimman arvion saanutta käyttäytymistä (kaikista käyttäytymistä) soveltuvien arvostelijaluokkien keskiarvoista. Jotta saisit eniten hyötyä tästä sivusta, on hyödyllistä etsiä mahdollisesti muodostuvia trendejä. Jos esimerkiksi suurin osa alhaisimman arvion saaneista käyttäytymisistä on keskittynyt yhteen tai kahteen kategoriaan, nämä alueet voivat olla kehittämisen tarpeessa. Korkeimman arvion saaneet käyttäytymiset voivat ilmentää vahvuuksia, joita voidaan hyödyntää muilla alueilla.",
                "HIGH_LOW_TABLE_DESCRIPTION": "Korkeimmat/alimmat-kaaviossa näkyvät ne kohteet, joista on annettu korkeimpia ja alimpia pisteitä.",
                "HORIZONTAL": "Vaaka",
                "HORIZONTAL_AND_VERTICAL": "Vaaka- ja pystysuuntainen",
                "HORIZONTAL_BAR": "Vaakapalkki",
                "HOW_TO_INTERPRET_RESULT_HEADER": "Miten tulkita tuloksia ja määrittää jatkotoimenpiteitä:",
                "IF": "Jos",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "Sisällytä piilotetut otsikot prosentteihin",
                "INNER_RIM": "Sisäreuna",
                "IS": "On",
                "IS_NOT": "Ei ole",
                "IS_SAME_AS_SUBJECT": "On sama kuin kohde",
                "ITEM": "Kohde",
                "LABEL": "tunniste",
                "LABELS": "Otsikot",
                "LARGE_LABELS": "Suuret otsikot",
                "LEGEND": "Seloste",
                "LEGEND_POSITION": "Selosteen sijainti",
                "LEGEND_VALUES": "Selosteiden arvot",
                "LESS_OR_EQUAL": "Pienempi tai yhtä suuri",
                "LESS_THAN": "Pienempi kuin",
                "LINE": "Viiva",
                "LOWEST_SCORES": "Alimmat pisteet",
                "MANAGERS": "Päälliköt",
                "MANUAL_FONT_SIZE": "Määritä kirjasinkoko manuaalisesti",
                "MAX": "Maksimi",
                "MEAN": "Keskiarvo",
                "MEDIAN": "Mediaani",
                "METRIC_TYPE": "Mittausarvon tyyppi",
                "MIN": "Väh.",
                "MODIFY_CUSTOM_PALETTES": "Muokkaa mukautettuja värivalikoimia",
                "MOVE_DOWN": "Siirrä alas",
                "MOVE_UP": "Siirrä ylös",
                "MULTI_SELECT_ITEMS_SELECTED": "valittu",
                "NEGATIVE_GAPS": "Kehitettävät alueet",
                "NO": "Ei",
                "NONE": "Ei mitään",
                "NOT_APPLICABLE": "-",
                "NOT_EQUAL_TO": "Eri kuin",
                "NO_DATA_AVAILABLE_WARNING": "Ei tietoja käytettävissä",
                "NO_FILTER": "Ei suodatin",
                "NO_FILTER_IS_APPLIED": "Mikään suodatin ei ole käytössä.",
                "NO_VALUE": "Ei arvoa",
                "NPS": "Net Promoter Score",
                "NUMBER": "numero",
                "NUMBERS": "Numerot",
                "NUMBER_OF_GAPS_NEGATIVE": "Negatiivisten aukkojen määrä",
                "NUMBER_OF_GAPS_POSITIVE": "Positiivisten aukkojen määrä",
                "NUMBER_OF_ROWS_HIGH": "Ylärivien lukumäärä",
                "NUMBER_OF_ROWS_LOW": "Alarivien lukumäärä",
                "OPTIONS": {
                    "HEADER_NAME": "Otsikon nimi",
                    "LEGEND": "Seloste",
                    "SCALE_AXIS_CHANGER_TITLE": "Sarja"
                },
                "ORIENTATION": "Suunta",
                "OR_IF": "Tai jos",
                "OTHER": "Muu",
                "OTHERS": "Muut",
                "PAGE_OF": "Sivu %1/%2",
                "PALETTE_REMOVED": "Värivalikoima poistettu",
                "PEERS": "Kollegat",
                "PERCENT": "Prosentti",
                "PERCENTAGE": "Prosenttiosuus",
                "PERCENTAGE_OF_CHOICES": "Valintojen osuudet",
                "PERCENTAGE_OF_RESPONSES": "Vastausprosentti",
                "PERCENT_COMPLETE": "% valmis",
                "PERSON_METADATA": "Henkilön metatiedot",
                "PERSON_METADATA_EVALUATOR": "Arvioijan",
                "PERSON_METADATA_SUBJECT": "Kohteen",
                "PERSON_METADATA_VIEWER": "Katsojan",
                "POSITIVE_GAPS": "Piilevät vahvuudet",
                "PRIMARY_PARENTHESES": "(ensisijainen)",
                "QUESTIONS": "Kysymykset",
                "RADIUS": "Säde",
                "RANK": "Sija",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "korkeimmat pisteet",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "korkeimmista pisteistä",
                "RANKABLE_ITEMS_ITEM_HAS": "Kohteella on",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "Kohteella on yksi",
                "RANKABLE_ITEMS_LOWEST_SCORE": "alimmat pisteet",
                "RANKABLE_ITEMS_LOWEST_SCORES": "alimmista pisteistä",
                "RATER_CATEGORY_DISPLAY_LOGIC": "arvioijakategorian näyttölogiikka",
                "RATIO": "Suhde",
                "RECORD": "Tallenne",
                "REFERENCE_GROUP": "viiteryhmä",
                "RELATIONSHIP": "Suhde",
                "RELATIONSHIP_FILTERS": "Suhdesuodattimet",
                "RELATIONSHIP_FILTERS_INFO": "Voit lisätä suhdesuodattimen (kuten suoran alaisen, kollegan tai päällikön) valitsemalla Hallitse omia suodattimia ja käyttämällä vain suhde-ehtoa pudotusvalikosta.",
                "REMOVE": "Poista",
                "REMOVE_DATA_SOURCE": "Poista tiedon lähde",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Muista, että organisaatiossasi on resursseja, jotka voivat auttaa sinua tulkitsemaan saamaasi palautetta, kuten HR-tiimi, esimiehesi ja/tai mentorisi.",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Ota kuppi kahvia ja ryhdy tarkastelemaan saamaasi palautetta.",
                    "ABOUT_YOUR_REPORT_HEADER": "Tietoja raportistasi",
                    "ABOUT_YOUR_REPORT_LINE1": "Tervetuloa 360-palauteraportin pariin. Tämä on loistava mahdollisuus kasvaa ja kehittyä ammattilaisena. Jotta raportista on sinulle mahdollisimman paljon hyötyä, varaa riittävästi aikaa palautteen käsittelyyn. Aluksi palautteen lukeminen voi tuntua vaikealta, mutta muista, että palautteen tarkoituksena on auttaa sinua kasvamaan ja kehittymään.",
                    "ABOUT_YOUR_REPORT_LINE2": "Kun käyt raporttia läpi, nämä asiat kannattaa pitää mielessä.",
                    "ADVANCED_FILTER": "Edistynyt suodatin",
                    "AGREEMENT_CHART": "Yhdenmukaisuuskaavio",
                    "AGREEMENT_CHART_FOOTER": "Yhdenmukaisuuskaaviosta ilmenee pisteiden samankaltaisuus. Kukin piste esittää yksittäistä arviota kustakin arvioitavasta alueesta. Pisteen koko osoittaa, kuinka moni arvioija on antanut saman arvion.",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "vastausta",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "vastaus",
                    "AGREEMENT_CHART_LEGEND_TITLE": "Kuinka muut arvioivat sinut",
                    "ALL": "Kaikki",
                    "AVERAGE": "Keskiarvo",
                    "BOTTOM_BOX": "Alin osuus",
                    "CHOICE_COUNT": "Valintamäärä",
                    "CHOICE_TOTALS": "Valintojen summat",
                    "COMPARISON": "Vertailu",
                    "COMPARISON_GAP_COLUMN_HEADER": "Vertailuero",
                    "COMPLETED_RESPONSES": "Valmiit vastaukset",
                    "COUNT": "Määrä",
                    "DEFAULT": "Oletusasetus",
                    "DEFAULT_TEXT": "Oletusteksti",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "Ymmärrä, keneltä palaute on saatu, onko kyseessä työtoverit, suorat alaiset, esimiehet jne.",
                    "DIFFERENT_EVALUATORS_HEADER": "Eri arvioijat",
                    "DONE": "Valmis",
                    "DONT_HEADER": "Vältä seuraavia:",
                    "DONT_LINE1": "Pohdinta, kuka on sanonut mitäkin",
                    "DONT_LINE2": "Keskittyminen yksittäiseen positiiviseen tai negatiiviseen pistemäärään tai kommenttiin",
                    "DONT_LINE3": "Kehityssuunnitelman luonti jokaisesta alueesta",
                    "DONT_LINE4": "Lannistuminen siitä, että kehityskohteita löytyy",
                    "DO_HEADER": "Keskity seuraaviin:",
                    "DO_LINE1": "Suhtaudu palautteeseen kokonaisvaltaisesti",
                    "DO_LINE2": "Tunnista vahvuuksia ja kehityskohteita koskevat teemat",
                    "DO_LINE3": "Priorisoi muutamaa aluetta, jotka lisäät kehityssuunnitelmaan",
                    "DO_LINE4": "Ymmärrä, että kaikilla on omat kehityskohteensa",
                    "FIELD": "Kenttä",
                    "GAP": "Aukko",
                    "GAP_CHART": "Aukkokaavio",
                    "GAP_CHART_DESCRIPTION": "Aukkokaaviossa näkyy kahden arvioijaryhmän antamien pisteiden välinen ero. Esimerkiksi tapauksessa, jossa voidaan tarkastella sekä itsearviointia että muiden antamia arvioita, positiivinen (+) ero tarkoittaa, että muut ovat antaneet korkeampia arvioita kuin olet itse antanut. Negatiivinen (-) ero tarkoittaa, että muut ovat antaneet matalampia arvioita kuin olet itse antanut.",
                    "GAP_CHART_FOOTER": "Aukkokaaviossa näkyy kahden arvioijaryhmän välinen ero +/-.",
                    "GAP_TABLE_DESCRIPTION": "Piilevät vahvuudet näyttävät, missä muut ovat antaneet korkeampia arvioita kuin olet itse antanut. Kehitettävät alueet näyttävät, missä muut ovat antaneet matalampia arvioita kuin olet itse antanut. Molemmat osiot on järjestetty isoimmasta aukosta pienimpään.",
                    "GAP_TABLE_FOOTER": "Ensimmäisessä pisteiden sarakkeessa näkyy, miten olet itse arvioinut itseäsi. Toisessa sarakkeessa näkyy muiden keskimääräiset pisteet. Kolmannessa sarakkeessa näkyy itse antamiesi pisteiden ja muiden antamien pisteiden välinen ero.",
                    "GAP_TABLE_TITLE": "Piilevät vahvuudet / kehitettävät alueet",
                    "GROUP": "Ryhmä",
                    "HIDE_REPORT_ALERT": "Et täytä raportin näyttämisen vaatimuksia. Ota yhteys organisaation hallinnoijaan.",
                    "HIGHEST_SCORES": "Korkeimmat pisteet",
                    "HIGHLOW_TABLE": "Korkeimmat ja alimmat pisteet",
                    "HIGHLOW_TABLE_FOOTER": "Tässä osassa esitetään viisi korkeimman ja alhaisimman arvion saanutta käyttäytymistä (kaikista käyttäytymistä) soveltuvien arvostelijaluokkien keskiarvoista. Jotta saisit eniten hyötyä tästä sivusta, on hyödyllistä etsiä mahdollisesti muodostuvia trendejä. Jos esimerkiksi suurin osa alhaisimman arvion saaneista käyttäytymisistä on keskittynyt yhteen tai kahteen kategoriaan, nämä alueet voivat olla kehittämisen tarpeessa. Korkeimman arvion saaneet käyttäytymiset voivat ilmentää vahvuuksia, joita voidaan hyödyntää muilla alueilla.",
                    "HIGH_LOW_TABLE_DESCRIPTION": "Korkeimmat/alimmat-kaaviossa näkyvät ne kohteet, joista on annettu korkeimpia ja alimpia pisteitä.",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "Miten tulkita tuloksia ja määrittää jatkotoimenpiteitä:",
                    "ITEM": "Kohde",
                    "LOWEST_SCORES": "Alimmat pisteet",
                    "MAX": "Maksimi",
                    "MEAN": "Keskiarvo",
                    "MEDIAN": "Mediaani",
                    "MIN": "Väh.",
                    "NEGATIVE_GAPS": "Kehitettävät alueet",
                    "NO_COMPARISON_SET": "Ei vertailujoukkoa",
                    "NO_DATA_AVAILABLE_WARNING": "Ei tietoja käytettävissä",
                    "NO_FILTER_IS_APPLIED": "Mikään suodatin ei ole käytössä.",
                    "NO_VALUE": "Ei arvoa",
                    "NPS": "Net Promoter Score",
                    "OTHERS": "Muut",
                    "PERCENTAGE": "Prosenttiosuus",
                    "PERCENTAGE_OF_CHOICES": "Valintojen osuudet",
                    "PERCENTAGE_OF_RESPONSES": "Vastausprosentti",
                    "PERCENT_COMPLETE": "% valmis",
                    "POSITIVE_GAPS": "Piilevät vahvuudet",
                    "QUESTIONS": "Kysymykset",
                    "RANK": "Sija",
                    "RELATIONSHIPS": {
                        "ANYONE": "Kuka tahansa",
                        "DIRECT_REPORT": "Suora alainen",
                        "MANAGER": "Päällikkö",
                        "PEER": "Kollega",
                        "SELF": "Itse"
                    },
                    "REPORT_SUMMARY": "Raportin yhteenveto",
                    "REPORT_SUMMARY_TABLE_FOOTER": "Vertaa arvioinnin suorittaneiden henkilöiden lukumäärää osallistumaan kutsuttujen henkilöiden lukumäärään.",
                    "REPORT_SUMMARY_TABLE_HEADER": "Vastaajatilasto",
                    "RESPONSES": "Vastaukset",
                    "RESPONSE_COUNT": "{{responseCount}} vastausta",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> vastausta",
                    "SCORING_CATEGORY": "Pisteytyskategoria",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Ei vastauksia tähän kategoriaan",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Ei vastauksia tähän kysymykseen",
                    "SCORING_OVERVIEW": "Pisteytyksen yleiskatsaus",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "Sinun ja muiden arvioijien mielestä tämä on huipputason vahvuusalue.",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Tunnistettu vahvuus",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Tunnistetun kehitysalueen kohdalla oma arviointi ja muiden tekemät arvioinnit ovat kumpikin tämän pätevyyden keskiarvon alapuolella.",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Tunnistettu kehitysalue",
                    "SCORING_OVERVIEW_DESCRIPTION": "Edellä on pätevyydet tai käyttäytymiset, jotka on arvioitu osana tätä usean arvioijan palauteprosessia. Vertailuarviot on annettu ryhmittäin.",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "Minimiaukko",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Näytettävien tekstien viiteryhmien välinen minimiero.",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "Näkyvissä on kunkin pätevyyden/käyttäytymisen pisteiden arvoalue. Palkki edustaa numeerista keskiarvoa.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Tunnistamaton vahvuus johtuu epäyhtenäisyydestä oman arvioinnin ja muiden tekemien arviointien välillä.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Tunnistamaton vahvuus",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Tunnistamaton kehitysalue johtuu epäyhtenäisyydestä oman arvioinnin ja muiden tekemien arviointien välillä.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Tunnistamaton kehitysalue",
                    "SELF": "Itse",
                    "SELF_ASSESSMENT": "Itsearviointi",
                    "STANDARD_DEVIATION": "Keskihajonta",
                    "SUM": "Summa",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Tutustu arviointiasteikkoon, jotta osaat tulkita tuloksia oikein",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "Kiinnitä huomiota asteikkoon",
                    "THINGS_YOU_WILL_SEE_HEADER": "Tarkasteltavia asioita:",
                    "THREE_SIXTY_PERCENTILE": "Prosenttipiste",
                    "TOP_BOTTOM_BOX": "Ylin osuus / alin osuus",
                    "TOP_BOX": "Ylin osuus",
                    "TOTAL": "Yhteensä",
                    "TO_DO": "Tehtävä",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Kvalitatiivinen: palaute annetaan vapaan tekstin muodossa",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Kvantitatiivinen: palaute on numeerista ja voidaan esittää kaavioina, pylväskaavioina, taulukkoina jne.",
                    "TYPES_OF_FEEDBACK_HEADER": "Eri palautetyypit",
                    "VALUE": "Arvo",
                    "VARIANCE": "Varianssi",
                    "YOUR_RATINGS": "Omat arviointisi"
                },
                "REPORT_SUMMARY": "Raportin yhteenveto",
                "REPORT_SUMMARY_TABLE_FOOTER": "Vertaa arvioinnin suorittaneiden henkilöiden lukumäärää osallistumaan kutsuttujen henkilöiden lukumäärään.",
                "REPORT_SUMMARY_TABLE_HEADER": "Vastaajatilasto",
                "RESET": "Nollaa",
                "RESPONDENT_TOTALS": "Vastaajat yhteensä",
                "RESPONSES": "Vastaukset",
                "RESPONSE_COUNT": "{{responseCount}} vastausta",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> vastausta",
                "RESULT": "Tulos",
                "REVERSE_COLORS": "Käänteiset värit",
                "ROW_TOTALS": "Rivin summat",
                "SAVE": "Tallenna",
                "SAVE_AND_APPLY": "Tallenna ja käytä",
                "SCORING_CATEGORY": "Pisteytyskategoria",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Ei vastauksia tähän kategoriaan",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Ei vastauksia tähän kysymykseen",
                "SCORING_OVERVIEW": "Pisteytyksen yleiskatsaus",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "Sinun ja muiden arvioijien mielestä tämä on huipputason vahvuusalue.",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Tunnistettu vahvuus",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Tunnistetun kehitysalueen kohdalla oma arviointi ja muiden tekemät arvioinnit ovat kumpikin tämän pätevyyden keskiarvon alapuolella.",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Tunnistettu kehitysalue",
                "SCORING_OVERVIEW_DESCRIPTION": "Edellä on pätevyydet tai käyttäytymiset, jotka on arvioitu osana tätä usean arvioijan palauteprosessia. Vertailuarviot on annettu ryhmittäin.",
                "SCORING_OVERVIEW_MINIMUM_GAP": "Minimiaukko",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Näytettävien tekstien viiteryhmien välinen minimiero.",
                "SCORING_OVERVIEW_TABLE_FOOTER": "Näkyvissä on kunkin pätevyyden/käyttäytymisen pisteiden arvoalue. Palkki edustaa numeerista keskiarvoa.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Tunnistamaton vahvuus johtuu epäyhtenäisyydestä oman arvioinnin ja muiden tekemien arviointien välillä.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Tunnistamaton vahvuus",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Tunnistamaton kehitysalue johtuu epäyhtenäisyydestä oman arvioinnin ja muiden tekemien arviointien välillä.",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Tunnistamaton kehitysalue",
                "SELECT_CATEGORIES": "Valitse pisteytyskategoriat…",
                "SELECT_CATEGORY": "Valitse pisteytyskategoria...",
                "SELECT_CONDITION_TYPE": "Valitse ehtotyyppi",
                "SELECT_DATA_SOURCE": "Valitse tiedon lähde",
                "SELECT_DATA_SOURCE_TYPE": "Valitse tietolähdetyyppi",
                "SELECT_FILTER": "Valitse suodatin",
                "SELECT_FILTERS": "Valitse suodattimet",
                "SELECT_OPERATOR_TYPE": "Valitse operaattorityyppi",
                "SELECT_PERSON": "Valitse henkilö",
                "SELECT_PERSON_METADATA": "Valitse henkilön metatiedot",
                "SELECT_QUESTION": "Valitse kysymys",
                "SELECT_QUESTIONS": "Valitse kysymykset...",
                "SELECT_RATIO_OR_DROPOFF": "Valitse suhde tai pudotus",
                "SELECT_RELATIONSHIP": "Valitse suhde",
                "SELECT_SCORING_CATEGORY": "Valitse pisteytyskategoria",
                "SELF": "Itse",
                "SELF_ASSESSMENT": "Itsearviointi",
                "SEQUENTIAL": "Peräkkäinen",
                "SETUP_COMPARISON": "Määritä vertailu",
                "SETUP_COMPARISONS": "Määritä vertailut",
                "SET_START_COLOR": "Aseta aloitusväri",
                "SHOULD_SHOW_FOOTER": "Näytä alatunniste",
                "SHOULD_SHOW_SCORING_CATEGORY": "Näytä pisteytyskategoria",
                "SHOWING_RECORDS_OF": "Näytetään tietueet %1–%2/%3",
                "SHOW_COMPARISON_GAP": "Näytä vertailu aukkosarake",
                "SHOW_DATA_LABEL": "Näytä tietoarvot",
                "SHOW_PERCENTAGES": "Näytä prosenttiosuudet",
                "SHOW_THE_FOLLOWING_TEXT": "Näytä sitten seuraava teksti",
                "SHOW_TIES": "Näytä tasatulokset",
                "SHOW_X_AXIS": "Näytä X-akseli",
                "SHOW_Y_AXIS": "Näytä Y-akseli",
                "SMALL_LABELS": "Pienet otsikot",
                "SORT": "Lajittele",
                "SPLINE": "Splini",
                "STACK_CHART": "Pinottu kaavio",
                "STANDARD_DEVIATION": "Keskihajonta",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "Heikkous pienempi kuin",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "Muokkaa kynnysarvotekstejä",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "Kynnysarvotekstit",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "Ota kynnysarvotekstit käyttöön",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "Vahvuus suurempi kuin",
                "SUM": "Summa",
                "SUMMARY": "Yhteenveto",
                "TABLES": "Taulukot",
                "TABLE_TOTALS": "Taulukon summat",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Tutustu arviointiasteikkoon, jotta osaat tulkita tuloksia oikein",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "Kiinnitä huomiota asteikkoon",
                "TEXT": "Teksti",
                "THINGS_YOU_WILL_SEE_HEADER": "Tarkasteltavia asioita:",
                "TOP_BOTTOM_BOX": "Ylin osuus / alin osuus",
                "TOP_BOX": "Ylin osuus",
                "TOTAL": "Yhteensä",
                "TOTAL_COUNTS": "Määrä yhteensä",
                "TO_DO": "Tehtävä",
                "TRANSPOSE": "Transponoi",
                "TRANSPOSE_TABLE": "Transponoi taulukko",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Kvalitatiivinen: palaute annetaan vapaan tekstin muodossa",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Kvantitatiivinen: palaute on numeerista ja voidaan esittää kaavioina, pylväskaavioina, taulukkoina jne.",
                "TYPES_OF_FEEDBACK_HEADER": "Eri palautetyypit",
                "UNDO": "Kumoa",
                "USE_COMPARISON": "Käytä vertailua",
                "USE_LABELS_FOR_SCALES": "Käytä otsikoita asteikoille",
                "VALUES": "Arvoa",
                "VALUE_RANGES": "Arvovälit",
                "VARIANCE": "Varianssi",
                "VERTICAL": "Pystysuuntainen",
                "VERTICAL_RANGE": "Pystysuuntainen alue",
                "WARNING_DATA_OUT_OF_RANGE": "Varoitus: tiedon arvo ylittää määritellyn alueen",
                "WIDGET_ERROR": {
                    "ERROR": "Tapahtui odottamaton virhe",
                    "MISCONFIGURED": "Tätä pienoissovellusta ei ole määritetty oikein. Tarkista pienoissovelluksen kokoonpano.",
                    "NEW": "Määritä pienoissovellus",
                    "NO_DATA": "Tietoja ei löytynyt – suodattimet voivat olla liian tiukat!"
                },
                "WIDGET_NAME": {
                    "BAR": "Pylväskaavio",
                    "BREAKDOWNBAR": "Erittelypalkki",
                    "DATA_TABLE": "Tietotaulukko",
                    "FUNNEL_CHART": "Suppilokaavio",
                    "GAUGE": "Mittarikaavio",
                    "GRID": "Tulostaulu",
                    "HEATMAP": "Lämpökartta",
                    "LINE": "Viivakaavio",
                    "NEEDS_BASED": "Tarveperusteinen",
                    "PIE": "Ympyräkaavio",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "Hinta-arvio (Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "Tuoton maksimointi (Gabor Granger)",
                    "SCORING_OVERVIEW_CHART": "Kaavio",
                    "SCORING_OVERVIEW_TABLE": "Taulukko",
                    "STATS_TABLE": "Tilastotaulukko",
                    "WORDCLOUD": "Avainsanapilvi"
                },
                "WORD_ROTATION": "Sanan kierto",
                "WORD_SPACING": "Sanaväli",
                "YES": "Kyllä",
                "YOUR_RATINGS": "Omat arviointisi"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "Lisää",
                "ADD_A_WORD": "Lisää sana",
                "COLOR": "Väri",
                "DELETE_ALL": "Poista kaikki",
                "EDIT_STOP_WORDS": "Muokkaa hukkasanoja",
                "MAX_WORDS": "Sanoja enintään",
                "ROTATION_ANGLED": "Kulmikas",
                "ROTATION_HORIZONTAL": "Vaaka",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "Vaaka ja pysty",
                "WORD_ORIENTATION": "Sanojen suunta"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "Taustavärit",
                "DISPLAY_OPTIONS": "Näyttöasetukset",
                "INVERT_FONT_COLORS": "Vaihda alhaisen kontrastin fonttien värit päinvastaisiksi",
                "PAGE": "Sivu",
                "PAGINATE": "Sivuta"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "Keskiarvo",
                "BOTTOM_BOX_METRIC": "Alin osuus",
                "COLUMNS": "Sarakkeet",
                "COUNT_METRIC": "Vastaukset yhteensä",
                "FIELD_NAME": "Kenttä",
                "MAX_METRIC": "Maksimi",
                "MIN_METRIC": "Minimi",
                "SHOW_RECODES": "Näytä uudelleenkoodauksen arvot",
                "SHOW_ROW_NUMBERS": "Näytä rivinumerot",
                "STD_DEV_METRIC": "Keskihajonta",
                "TOP_BOX_METRIC": "Ylin osuus",
                "TRANSPOSE_BREAKOUTS": "Transponoi irrottamiset",
                "TRANSPOSE_TABLE": "Transponoi taulukko",
                "VAR_METRIC": "Varianssi"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "Lisäsarakkeet",
                "ADD_COLUMNS": "Lisää lisäsarakkeita",
                "ADD_CUSTOM_PALETTE": "Lisää mukautettu värivalikoima",
                "ALL_CHOICES": "Kaikki valinnat",
                "ALL_GROUPS": "Kaikki ryhmät",
                "ALL_RECODES": "Kaikki uudelleenkoodaukset",
                "AUTOMATIC": "Oletusasetus",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "Oletus – muokkaa napsauttamalla",
                "AXIS_VALUES": "Akselien arvot",
                "BREAKOUT_BY": "Jakoperuste",
                "CANCEL": "Peruuta",
                "CATEGORICAL": "Luokkiin jakautuva",
                "CHOICES": "Valinnat",
                "CHOICE_COUNT": "Valintamäärä",
                "COLOR_PALETTE": "Väripaletti",
                "COLUMN_VALUES": "Sarakkeen arvot",
                "CONTACT_FIELDS": "Yhteystietokentät",
                "COUNT": "Määrä",
                "CREATE": "Luo",
                "CUSTOM": "Mukautettu",
                "CUSTOM_PALETTE": "Mukautettu värivalikoima",
                "DATA_SOURCE": "Tiedon lähde",
                "DAY": "Päivä",
                "DAY_OF_WEEK": "Viikonpäivä",
                "DECIMAL_PRECISION": "Desimaalit",
                "DEFAULT": "Oletusasetus",
                "DISABLED": "Poistettu käytöstä",
                "DIVERGENT": "Poikkeava",
                "EDIT_CUSTOM_PALETTE": "Muokkaa mukautettua värivalikoimaa",
                "ENABLED": "Käytössä",
                "ERROR_LOADING_DATA": "Virhe ladattaessa tietoja",
                "FILE_SIZE": "Koko",
                "FILE_TYPE": "Tyyppi",
                "FRI": "Pe",
                "FRIDAY": "Perjantai",
                "GROUP_DATE_BY": "Päivämäärien ryhmittelyperuste",
                "HOUR_OF_DAY": "Kellonaika",
                "LENGEND_VALUES": "Selosteiden arvot",
                "MAX": "Maksimi",
                "MEAN": "Keskiarvo",
                "MIN": "Väh.",
                "MISCONFIGURED_DATA": "Tiedon lähde määritetty virheellisesti tälle visualisoinnille.",
                "MISCONFIGURED_FILTERS": "Virheelliset suodattimet",
                "MODIFY_CUSTOM_PALETTES": "Muokkaa mukautettuja värivalikoimia",
                "MON": "Ma",
                "MONDAY": "Maanantai",
                "MONTH": "Kuukausi",
                "NONE": "Ei mitään",
                "NO_FILE_ID_ERROR": "Tämä visualisointi edellyttää kuvan määrittämistä kyselyyn",
                "NO_RESULTS_TO_SHOW": "Ei näytettäviä tuloksia",
                "NPS": "Net Promoter Score®",
                "NPS_GROUP": "NPS®-ryhmä",
                "NUMERIC_VALUE": "Numeerinen arvo",
                "PALETTE_REMOVED": "Värivalikoima poistettu",
                "PERCENTAGE": "Prosenttiosuus",
                "PERCENTAGE_OF_CHOICES": "Valintojen osuudet",
                "PERCENTAGE_OF_RESPONSES": "Vastausprosentti",
                "QUARTER": "Vuosineljännes",
                "REMOVE": "Poista",
                "RESPONSE_COUNT": "Vastausten määrä",
                "RESULTS_PER_PAGE": "Tuloksia sivulla",
                "RETRIEVING_DATA_ELLIPSIS": "Haetaan tietoja...",
                "REVERSE_COLORS": "Käänteiset värit",
                "ROW_VALUES": "Rivin arvot",
                "SAT": "La",
                "SATURDAY": "Lauantai",
                "SAVE": "Tallenna",
                "SELECTED_CHOICE": "Valittu valinta",
                "SELECT_FIELD": "Valitse kenttä",
                "SELECT_METRIC": "Mitta",
                "SEQUENTIAL": "Peräkkäinen",
                "SET_START_COLOR": "Aseta aloitusväri",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "Näytetään otoksen tiedot...",
                "SUM": "Summa",
                "SUN": "Su",
                "SUNDAY": "Sunnuntai",
                "SURVEY_EMBEDDEDDATA": "Taustatiedot",
                "SURVEY_METADATA": "Kyselyn metatiedot",
                "TEXT_ENTRY": "Tekstin syöttö",
                "THURS": "To",
                "THURSDAY": "Torstai",
                "TITLE": "Otsikko",
                "TUES": "Ti",
                "TUESDAY": "Tiistai",
                "UNBOUNDED_DOMAIN": "Liikaa näytettäviä arvoja.",
                "UNBOUNDED_DOMAIN_HELP": "Jos haluat lisätä tämän kentän tulosraportteihin, voit lisätä raporttiin suodattimen ja näyttää vähemmän arvoja kohteelle \"{{ed_field_name}}\" tai päivittää kohteen \"{{ed_field_name}}\" taustatietojen muuttujatyypin kyselyn etenemisessä niin, että tämä kenttä on merkkijono tai numeerinen tyyppi.",
                "UNDO": "Kumoa",
                "USE_CHOICE_TOTALS": "Käytä valintojen summia",
                "USE_RESPONDENT_TOTALS": "Käytä vastaajien summia",
                "VISUALIZATION": "Visualisointi",
                "VISUALIZATION_BARCHART": "Pylväskaavio",
                "VISUALIZATION_BREAKDOWNBAR": "Erittelypalkki",
                "VISUALIZATION_GAUGE": "Mittarikaavio",
                "VISUALIZATION_HEATMAP": "Lämpökartta",
                "VISUALIZATION_LINECHART": "Viivakaavio",
                "VISUALIZATION_PAGINATEDTABLE": "Sivunumeroitu taulukko",
                "VISUALIZATION_PIE": "Ympyräkaavio",
                "VISUALIZATION_SIMPLETABLE": "Yksinkertainen taulukko",
                "VISUALIZATION_STATSTABLE": "Tilastotaulukko",
                "VISUALIZATION_TEXTHIGHLIGHTS": "Tekstin korostukset",
                "VISUALIZATION_WORDCLOUD": "Avainsanapilvi",
                "WED": "Ke",
                "WEDNESDAY": "Keskiviikko",
                "WEEK": "Viikko",
                "WEIGHTING": "Painotus",
                "WRONG_QUESTION_TYPE_ERROR": "Tätä visualisointityyppiä ei voida käyttää tähän kysymykseen",
                "YEAR": "Vuosi"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "Keskitaso",
                "CHOICE_COUNT": "Valintamäärä",
                "COUNT": "Määrä",
                "DISPLAY_OPTIONS": "Näyttöasetukset",
                "MAX": "Maksimi",
                "MIN": "Minimi",
                "NPS": "NPS®",
                "PAGE_OF": "Sivu %1/%2",
                "PERCENT": "Prosenttiosuus",
                "RESPONSE_COUNT": "Vastausten määrä",
                "ROWS_PER_TABLE": "Rivejä taulukkoa kohden",
                "SHOWING_ROWS_OF": "Näytetään rivit %1–%2/%3",
                "SHOW_PERCENTAGES": "Näytä prosenttiosuudet",
                "SHOW_RECODES": "Näytä uudelleenkoodauksen arvot",
                "SHOW_ROW_NUMBERS": "Näytä rivinumerot",
                "SUM": "Summa",
                "TOTAL": "Yhteensä",
                "TRANSPOSE": "Transponoi",
                "USE_COLUMN_TOTALS": "Käytä sarakkeen summia",
                "USE_ROW_TOTALS": "Käytä rivin summia",
                "VALUE": "Arvo"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "Nouseva järjestys",
                "COUNT": "Määrä",
                "DESCENDING": "Laskeva järjestys",
                "DIAGONAL": "Vinottainen",
                "DISPLAY_OPTIONS": "Näyttöasetukset",
                "ERROR_COLON": "Virhe:",
                "ERROR_GENERIC": "Virhe visualisoinnin latauksen yhteydessä.",
                "HORIZONTAL": "Vaaka",
                "HORIZONTAL_BARS": "Vaakapalkit",
                "INCORRECTLY_CONFIGURED": "Valitse kaaviossa näytettävä arvo",
                "LEGEND_AUTO": "Autom.",
                "LEGEND_BOTTOM": "Alin",
                "LEGEND_INSET": "Upote",
                "LEGEND_RIGHT": "Oikea",
                "NORMALIZE_TO_PERCENTAGES": "Normalisoi prosenttiosuuksiksi",
                "SHOW_BAR_LABELS": "Näytä palkkien otsikot",
                "SHOW_LEGEND": "Näytä seloste",
                "SHOW_X_AXIS": "Näytä X-akseli",
                "SHOW_Y_AXIS": "Näytä Y-akseli",
                "SORT_BAR_VALUES": "Lajittele palkkien arvot",
                "STACKED_BARS": "Pinotut palkit",
                "TRANSPOSE": "Transponoi",
                "TRUNCATE_LABELS": "Katkaise otsikot",
                "VERTICAL": "Pystysuuntainen"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "Kaikki muut",
                "COULD_NOT_LOAD_DATA": "Ei voitu ladata tietoja, joilla on tietty kokoonpano – kokeile eri lähdekenttää tai suurempaa aikaväliä.",
                "GROUPING_PERCENTAGE_THRESHOLD": "Ryhmittelyprosentin kynnysarvo",
                "NO_DATA": "Ei tietoja",
                "RADIUS": "Sisäsäde",
                "SHOW_AS_PERCENTAGES": "Näytä prosentteina"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "Sulje",
                "DOWNLOAD_CSV": "Lataa CSV",
                "DOWNLOAD_ZIP": "Lataa kaikki tiedostot",
                "NO_DATA": "Ei tietoja",
                "PAGE_OF": "Sivu %1/%2",
                "RESULTS_PER_PAGE": "Tuloksia sivulla",
                "SHOWING_RECORDS_OF": "Näytetään tietueet %1–%2/%3",
                "SINGLE_RESPONSE": "Yksi vastaus",
                "VIEW_RESPONSE": "Näytä vastaus"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "Näyttöasetukset",
                "ERROR_COLON": "Virhe:",
                "ERROR_GENERIC": "Virhe visualisoinnin latauksen yhteydessä.",
                "HORIZONTAL_BARS": "Vaakapalkit",
                "INCORRECTLY_CONFIGURED": "Valitse kaaviossa näytettävä arvo",
                "LEGEND_AUTO": "Autom.",
                "LEGEND_BOTTOM": "Alin",
                "LEGEND_INSET": "Upote",
                "LEGEND_RIGHT": "Oikea",
                "NORMALIZE_TO_PERCENTAGES": "Normalisoi prosenttiosuuksiksi",
                "SHOW_AREA": "Näytä alue",
                "SHOW_LEGEND": "Näytä seloste",
                "SHOW_X_AXIS": "Näytä X-akseli",
                "SHOW_Y_AXIS": "Näytä Y-akseli",
                "SMOOTH_LINES": "Pehmeät viivat",
                "SORT_X_AXIS_LABELS": "Lajittele X-akseliotsikot",
                "STACKED_BARS": "Pinotut palkit",
                "TRANSPOSE": "Transponoi"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "Ryhmätila",
                "BLUR": "Sumenna",
                "COULD_NOT_LOAD_DATA": "Ei voitu ladata tietoja, joilla on tietty kokoonpano – kokeile eri lähdekenttää tai suurempaa aikaväliä.",
                "FIELD": "Kenttä",
                "RADIUS": "Säde",
                "SHOW_REGIONS": "Näytä alueet",
                "SHOW_REGION_LABELS": "Näytä alueiden otsikot"
            },
            "GAUGEWIDGET": {
                "MAX": "Maksimi",
                "MIN": "Väh.",
                "VALUE_RANGES": "Arvovälit"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "Alaotsikot",
                "CATEGORY_NAME": "Kategorian nimi",
                "ERROR_COLON": "Virhe:",
                "INCLUDE_HIDDEN_GROUPS": "Sisällytä piilotetut ryhmät prosentteina",
                "LARGE_LABELS": "Suuret otsikot",
                "NO": "Ei",
                "PERCENT": "Prosentti",
                "RESPONSE_COUNT": "Vastausten määrä",
                "RESPONSE_COUNT_WITH_VALUE": "{{ responseCount }} vastausta",
                "SMALL_LABELS": "Pienet otsikot",
                "YES": "Kyllä"
            }
        });
        $cache.put('FR-CA', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "Code d'accès",
                "ACCESS_CODE_PROTECTION": "Protection par code d'accès",
                "ADD": "Ajouter",
                "ADD_BREAKOUT": "Ajouter le découpage du rapport",
                "ADD_NOTE": "Ajouter un commentaire",
                "ADD_SCHEDULED_REPORT": "Ajouter le rapport planifié",
                "ADD_WIDGET": "Ajouter la visualisation",
                "ALL_PROJECTS": "Tous les projets",
                "ALL_QUESTIONS": "Pages de questions",
                "ANSWER": "Réponse",
                "ANY_CHANGES_LOST": "Toute modification apportée aux rapports sera perdue si vous quittez Qualtrics XM Platform.",
                "APPENDED_COPY_IN_PARENS": "(Copier)",
                "AREA_CHART": "Diagramme à aires",
                "AREA_CHART_DESC": "Graphique linéaire à deux axes dont la surface sous la ligne est remplie.",
                "ATTACHMENT": "Pièce jointe",
                "BACKUP_CURRENT_REPORT": "Enregistrez une copie de ce rapport avant de modifier les visualisations",
                "BACKUP_CURRENT_REPORT_LINE2": "Remarque : la copie de sauvegarde sera nommée « {{nameOfReportCopy}} »",
                "BACK_TO_REPORTS": "Revenir aux rapports",
                "BACK_TO_TOP": "Haut de page",
                "BACK_TO_VIEW_RESULTS": "Retour à l'affichage des anciens résultats",
                "BAR_CHART": "Diagramme à barres",
                "BAR_CHART_DESC": "Diagramme à barres à deux axes qui autorise une configuration supplémentaire, telle que la transposition des axes et la réorganisation des points de données.",
                "BREAKDOWN_BAR_CHART": "Barre de répartition",
                "BREAKDOWN_BAR_CHART_DESC": "Diagramme à barres horizontales empilées, généralement utilisé comme alternative au diagramme circulaire afin de comparer visuellement des données.",
                "CANCEL": "Annuler",
                "CANCEL_CONF_TEXT": "Êtes-vous sûr(e) de vouloir annuler?<br/>Toutes les modifications seront perdues.",
                "CANCEL_EDITS": "Annuler les modifications",
                "CHART": "Graphique",
                "CHOICE": "Choix",
                "CHOICES_COUNT_METRIC": "Nombre de choix",
                "CHOOSE_PAGES_TO_DISPLAY": "Choisir les pages à afficher",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "Ce rapport contient {{maxReportPageCount}} pages, mais les résultats ne peuvent en contenir qu'un maximum de {{reportSizeLimit}}. Veuillez sélectionner un sous-ensemble inclus dans la limite.",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "Les rapports ne peuvent contenir que {{reportSizeLimit}} pages maximum. Veuillez sélectionner les pages souhaitées.",
                "CLEAR_ALL": "Effacer tout",
                "CLOSE": "Clôturer",
                "CLOUD": "UNE DESCRIPTION POUR LE NUAGE",
                "COLLABORATED_NEW": "Le propriétaire de cette enquête utilise Qualtrics XM Platform! Les rapports de cette enquête sont modifiés à l'aide de la section « Nouveaux résultats ».",
                "COMMA_SEPARATED_LIST": "Liste séparée par des virgules",
                "COMPACTNESS": "Polices et espacement",
                "COMPACTNESS_INFO": "Ce paramètre affecte le remplissage des tableaux, la taille de police et la taille des bâtons des diagrammes. Il sera également appliqué à la plupart des exportations.",
                "CONFIRM": "Ok",
                "CONFIRM_DELETE": "Confirmer la suppression",
                "CONFIRM_DELETE_PAGE": "Êtes-vous sûr de vouloir supprimer cette page?",
                "CONTINUE": "Continuer",
                "CONTINUE_EDITING": "Continuer à modifier",
                "COPY": "Copier",
                "COPY_OF_REPORT_NAME": "Copie de {{nameOfCurrentReport}}",
                "COPY_REPORT": "Copier le rapport",
                "COPY_REPORT_ELLIPSIS": "Copier le rapport…",
                "COPY_TO_NEW_REPORT": "Copier vers un nouveau rapport…",
                "CREATE": "Créer",
                "CREATED": "Créé",
                "CREATE_CUSTOM_PAGE": "Créer une page personnalisée",
                "CREATE_NEW_REPORT": "Créer un nouveau rapport",
                "CREATE_NEW_REPORT_ELLIPSIS": "Créer un nouveau rapport…",
                "CSV_FILE": "Fichier CSV",
                "CUSTOM_PAGES": "Pages personnalisées",
                "DATE": "Date",
                "DEFAULT_PALETTE": "Palette de couleurs par défaut",
                "DEFAULT_REPORT": "Rapport par défaut",
                "DEFAULT_VISUALIZATIONS": "Visualisations par défaut",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "Il s'agit des types de visualisations utilisées pour établir les rapports de résultats par défaut. La mise à jour et l'application de ces paramètres créeront un nouveau rapport avec les nouveaux paramètres par défaut. Vous aurez la possibilité d'enregistrer une copie de votre rapport actuel.",
                "DEFAULT_VISUALIZATIONS_NOTE": "Remarque : tous les types de visualisation ne sont pas disponibles pour tous les types de questions. Il se peut que certaines visualisations par défaut soient automatiquement remplacées.",
                "DEFAULT_VISUALS_DISCLAIMER": "Qualtrics mettra à jour ce rapport avec les nouveaux paramètres de visualisation par défaut.",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "Cette mise à jour aura une incidence sur {{amountOfWidgetsAffected}} visualisations de ce rapport.",
                "DEFAULT_VISUAL_EDIT_DETECTED": "Modification de la visualisation par défaut détectée",
                "DELETE_BUTTON": "Supprimer",
                "DELETE_DISABLED_EXPLANATION": "La suppression des rapports créés dans l'ancienne interface de rapport n'est possible qu'une fois que votre organisation a terminé la migration complète vers Qualtrics XM Platform.",
                "DELETE_PAGE": "Supprimer la page",
                "DELETE_PAGE_ELLIPSIS": "Supprimer la page…",
                "DELETE_REPORT": "Supprimer le rapport",
                "DELETE_REPORT_ELLIPSIS": "Supprimer le rapport…",
                "DELETE_WIDGET_QUESTION": "Supprimer?",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "Ce champ est crypté et ne peut pas être utilisé pour le tri.",
                "DISCARD_EDITS": "Rejeter les modifications",
                "DISTRIBUTION_PAUSED": "Distribution de rapports interrompue.",
                "DONE_BUTTON": "Terminé",
                "DONE_EDITING": "Modification terminée",
                "DOWNLOAD": "Télécharger",
                "DOWNLOAD_AS_CSV": "Télécharger en tant que fichier CSV",
                "DOWNLOAD_AS_PDF": "Télécharger en tant que PDF",
                "DOWNLOAD_FAILED": "Échec du téléchargement",
                "DOWNLOAD_PREVIOUS_EXPORTS": "Télécharger les exportations précédentes…",
                "DO_YOU_WISH_TO_DELETE": "Souhaitez-vous supprimer :",
                "DUPLICATE_PAGE": "Dupliquer la feuille",
                "EDIT_REPORT": "Modifier le rapport",
                "EDIT_REPORT_ELLIPSIS": "Modifier le rapport…",
                "EDIT_VISUALIZATION": "Modifier la visualisation",
                "EMAIL_ADDRESS": "Adresse courriel",
                "EMAIL_SENT": "Courriel envoyé…",
                "END_OF_REPORT": "Fin du rapport",
                "ENTER_NAME": "Saisir un nom",
                "ERROR_COPYING": "Une erreur s'est produite lors de la copie du rapport.",
                "ERROR_DELETING": "Une erreur s'est produite lors de la suppression du rapport.",
                "ERROR_DELETING_EXPORT": "Une erreur s'est produite lors de la suppression de l'exportation.",
                "ERROR_HEADING": "Erreur",
                "ERROR_PUBLISHING": "Une erreur s'est produite lors de l'enregistrement des paramètres.",
                "ERROR_RENAMING": "Une erreur s'est produite lors du changement du nom du rapport.",
                "ERROR_REQUESTING_EXPORT": "Une erreur s'est produite lors de la demande d'exportation.",
                "ERROR_SAVING_GLOBAL_OPTIONS": "Une erreur s'est produite lors de l'enregistrement des options de visualisation globales.",
                "ERROR_SEND_TEST_EMAIL": "Une erreur s'est produite lors de l'envoi de le courriel test.",
                "EVERY_FRIDAY": "Tous les vendredis",
                "EVERY_MONDAY": "Tous les lundis",
                "EVERY_MONTH": "Tous les mois, le",
                "EVERY_SATURDAY": "Tous les samedis",
                "EVERY_SUNDAY": "Tous les dimanches",
                "EVERY_THURSDAY": "Tous les jeudis",
                "EVERY_TUESDAY": "Tous les mardis",
                "EVERY_WEDNESDAY": "Tous les mercredis",
                "EVERY_WEEK": "Toutes les semaines, tous les",
                "EXAMPLE_GROUP_NUM": "Groupe {{num}}",
                "EXAMPLE_SERIES_NUM": "Série {{num}}",
                "EXPORT": "Exporter",
                "EXPORT_CSV": "CSV (Séparées par des virgules)",
                "EXPORT_EXCEL_SPREADSHEET": "Feuille de calcul Excel",
                "EXPORT_IMAGE": "Exporter l'image",
                "EXPORT_PAGES": "Exporter les pages",
                "EXPORT_PDF": "Document PDF",
                "EXPORT_PPT_SLIDES": "Diapositives PowerPoint",
                "EXPORT_RAW_DATA": "Exporter les données brutes",
                "EXPORT_REPORT": "Exporter le rapport",
                "EXPORT_VISUALIZATION": "Exporter la visualisation",
                "EXPORT_WORD_DOC": "Document Word",
                "FAILED_SAVE_TXT": "Échec de l'enregistrement",
                "FILTERED": "Filtré",
                "FIRST_PAGE": "Première page",
                "FIRST_WEEKDAY": "Premier jour de la semaine du mois",
                "FROM": "De",
                "FROM_EMAIL": "Adresse courriel de l'expéditeur",
                "FROM_NAME": "Nom de l'expéditeur",
                "GAUGE_CHART": "Graphique jauge",
                "GAUGE_CHART_DESC": "Graphique semblable à un outil de mesure à jauges, utilisé afin de comparer les valeurs actuelles à un objectif ou à un ensemble de seuils.",
                "GENERATING_FILE": "Génération du fichier…",
                "GENERATING_IMAGE": "Génération de l'image…",
                "GENERATING_PDF": "Création du PDF…",
                "GENERIC_ERROR": "Une erreur nous a empêché de charger le projet souhaité.",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "Options globales…",
                "GLOBAL_METRIC": "Mesure par défaut",
                "GLOBAL_MODAL_PAGE_TITLE": "Exemple de visualisation avec les options globales de la section Résultats de Research Suite de Qualtrics",
                "GLOBAL_MODAL_WIDGET_TITLE": "Titre de la visualisation",
                "GLOBAL_OPTIONS": "Options globales",
                "GLOBAL_PRECISION": "Décimales par défaut",
                "GLOBAL_SETTINGS_APPLY": "Appliquer mes paramètres par défaut",
                "GLOBAL_SETTINGS_SAVE": "Enregistrer en tant que paramètres par défaut",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "Appliquer les paramètres par défaut de Qualtrics",
                "GROUP": "Groupe",
                "HEAT_MAP_CHART": "Graphique de carte thermique",
                "HEAT_MAP_CHART_DESC": "Visualisation en cluster de style « carte thermique », utilisée pour le mappage de la distribution des saisies de l'utilisateur (telles que les clics) sur l'image d'origine.",
                "HIDDEN": "Masqué",
                "HIDDEN_PAGE": "Cette page est masquée. Elle n'apparaîtra pas dans les rapports publics et sera désélectionnée par défaut dans les exportations de rapport.",
                "HIDE": "Masquer",
                "HIDE_ALL_PAGES": "Masquer toutes les pages",
                "HIDE_PAGE": "Masque la page",
                "IMAGE_FILE": "Fichier image",
                "INVALID_BRAND_DOMAIN": "Le domaine saisi ne figure pas dans la liste des domaines de courriel approuvés de votre organisation. Veuillez prendre contact avec votre administrateur pour résoudre ce problème.",
                "INVALID_SPF_RECORD": "Le domaine saisi n'a pas autorisé Qualtrics à envoyer des courriels à partir de celui-ci. Cela affectera votre capacité à envoyer des courriels. Veuillez utiliser un domaine différent ou prendre contact avec Qualtrics pour résoudre ce problème.",
                "ISSUE_SAVING_REPORTS": "Un problème est survenu lors de l'enregistrement d'un ou de plusieurs rapports. Veuillez réessayer.",
                "ISSUE_SENDING_TEST": "Une erreur s'est produite lors de l'envoi d'un courriel test. Veuillez réessayer.",
                "LARGE_SURVEY": "Les résultats ne seront pas affichés car l'enquête est trop volumineuse.",
                "LAST_DAY": "Dernier jour du mois",
                "LAST_MODIFIED_COLON_WITH_DATE": "Dernière modification : %1",
                "LAST_PAGE": "Dernière page",
                "LAST_WEEKDAY": "Dernier jour de semaine du mois",
                "LATER": "Plus tard",
                "LEARN_MORE": "En savoir plus",
                "LINE_CHART": "Graphique linéaire",
                "LINE_CHART_DESC": "Graphique linéaire à deux axes généralement utilisé pour représenter graphiquement des valeurs par rapport au temps sur l'axe X.",
                "LOG_OUT_WARNING": "Cliquez n'importe où dans les {{countdown}} secondes pour rester connecté",
                "MESSAGE": "Message",
                "MONTHLY": "Tous les mois",
                "MOVE_DOWN": "Déplacer la visualisation vers le bas",
                "MOVE_PAGE_TO_BOTTOM": "Déplacer en bas",
                "MOVE_PAGE_TO_TOP": "Déplacer en haut",
                "MOVE_UP": "Déplacer la visualisation vers le haut",
                "MY_SURVEYS": "Mes projets",
                "NAME": "Nom",
                "NEW_CUSTOM_PAGE_NAME": "Nouvelle page personnalisée",
                "NEW_REPORT": "Nouveau rapport",
                "NEXT_PAGE": "Page suivante",
                "NEXT_RUN": "Exécution suivante",
                "NO_EXPORTS": "Aucune exportation n'a encore été demandée pour ce rapport.",
                "NO_ITEMS_TO_DISPLAY": "Aucun élément à afficher",
                "NO_MATCHING_CUSTOM_PAGES": "Aucune page personnalisée correspondante",
                "NO_MATCHING_PAGES": "Aucune page pour la recherche",
                "NO_MATCHING_REPORTS": "Aucun rapport correspondant.",
                "NO_PROJECT": "Veuillez spécifier un projet pour continuer.",
                "NO_PROJECTS_TO_MIGRATE": "Il n'y a aucun projet à mettre à jour.",
                "NO_QUESTIONS": "Aucune question correspondante",
                "NO_RESULTS_YET": "Aucun résultat ne peut encore être affiché. Veuillez distribuer votre enquête pour recueillir des réponses.",
                "OFF": "Désactivé",
                "ON": "Activé",
                "PAGES_SELECTED": "Pages sélectionnées",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "Avec cette sélection, le rapport contiendrait {{currentSelectedPageCount}} pages, ce qui est supérieur au maximum autorisé de {{reportSizeLimit}}. Veuillez sélectionner une gamme plus restreinte.",
                "PAGES_SELECTION_INVALID_RANGE": "Veuillez sélectionner une plage valide.",
                "PAGE_OPTIONS": "Options de page",
                "PDF_ROW_TRUNCATION_MESSAGE": "Trop de lignes pour une exportation PDF, essayez une exportation vers un format Word ou CSV.",
                "PERCENTAGE_METRIC": "Pourcentage",
                "PIE_CHART": "Diagramme circulaire",
                "PIE_CHART_DESC": "Répartition circulaire des valeurs pour un certain point de données. Utile pour mesurer les proportions relatives des valeurs sélectionnées.",
                "PREVIEW": "Aperçu",
                "PREVIOUS_PAGE": "Page précédente",
                "PRINT_PAGE": "Imprimer la page",
                "PUBLIC_LINK": "Lien public",
                "PUBLIC_REPORT_AVAILABLE": "Rapport public disponible",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "Code d'accès",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "Code d'accès incorrect. Veuillez réessayer.",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "Soumettre",
                "PUBLIC_RESULTS_LOGIN_TITLE": "Connexion au rapport public | Logiciel d'enquêtes Qualtrics",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "Impossible de trouver le rapport public. Veuillez contacter le propriétaire de ce rapport et lui demander un lien valide.",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "Rapport public introuvable",
                "PUBLIC_RESULTS_NOT_UPDATED": "Les liens des rapports publics et des courriels de rapport programmé n'utiliseront pas Qualtrics XM Platform tant que vous ne les aurez pas mis à jour.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "Session expirée. Veuillez vous reconnecter pour continuer à visualiser le Rapport de résultats publié.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "Session expirée",
                "PUBLIC_RESULTS_TITLE": "Rapport public",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "Vous n'êtes pas autorisé à visualiser cette page. Veuillez contacter le propriétaire de ce rapport et lui demander de les rendre publics.",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "Rapport public non autorisé",
                "PUBLISHED_LINK_GENERATING_LINK": "Génération du lien…",
                "PUBLISHED_REPORT_FOUND_HERE": "N’importe qui peut voir ce rapport en cliquant sur le lien suivant :",
                "PUBLISH_REPORT": "Gérer le rapport public",
                "PUBLISH_REPORT_ELLIPSIS": "Gérer le rapport public…",
                "QUESTION": "Question",
                "RANK": "Classement",
                "REMOVE_WIDGET": "Supprimer la visualisation",
                "RENAME_PAGE": "Renommer la page",
                "RENAME_REPORT": "Renommer le rapport",
                "RENAME_REPORT_ELLIPSIS": "Renommer le rapport…",
                "REPLY_TO_EMAIL": "Adresse courriel de réponse",
                "REPORT_COLON": "Rapport :",
                "REPORT_SETTINGS": "Paramètres du rapport",
                "REPORT_SETTINGS_ELLIPSIS": "Paramètres du rapport…",
                "RESPONSE_COUNTS": "Comptes de réponses",
                "RESULTS_DASHBOARDS_BANNER": "et essayez la nouvelle version améliorée des résultats d'enquête. Cette nouvelle version propose une interface utilisateur moderne et accessible, des visualisations de données, une nouvelle analyse, des fonctionnalités d'exploration, et bien plus encore.",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "Notes de mise à jour",
                "RESULTS_DASHBOARDS_RELEASE_NOTES_PREFIX": "Afficher la/le plus récent(e)",
                "RESULTS_OPTIONS": "Options du rapport",
                "RESULTS_TITLE": "Rapport",
                "RESUME_DISTRIBUTION": "Reprendre une distribution",
                "REVERT": "Rétablir",
                "RICH_TEXT_LIMIT_REACHED": "La longueur du contenu a atteint la limite.",
                "SAVE": "Enregistrer",
                "SAVE_AND_CLOSE": "Enregistrer et fermer",
                "SAVE_AS_CSV": "Enregistrer la visualisation au format CSV",
                "SAVE_AS_IMAGE": "Enregistrer la visualisation en tant qu'image",
                "SAVE_CONFIRMATION": "Enregistrer la confirmation",
                "SAVE_PAGE_AS_ELLIPSIS": "Exporter la page sous…",
                "SAVE_SETTINGS": "Enregistrer les paramètres",
                "SCHEDULE_REPORT_EMAIL": "Planifier un courriel de rapport",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "Planifier un courriel de rapport…",
                "SEARCH_ELLIPSIS": "Recherche…",
                "SEARCH_PAGES": "Rechercher des questions",
                "SEARCH_PAGES_ELLIPSIS": "Rechercher les pages…",
                "SEARCH_REPORTS_ELLIPSIS": "Rechercher dans les rapports…",
                "SELECTED": "Sélectionné :",
                "SELECT_ALL": "Tout sélectionner",
                "SELECT_A_FIELD": "Sélectionner un champ",
                "SELECT_A_WIDGET": "Sélectionner une visualisation",
                "SELECT_PAGES": "Sélectionner des pages",
                "SELECT_PAGES_ELLIPSIS": "Sélectionner des pages…",
                "SEND": "Envoyer",
                "SEND_TEST_EMAIL": "Envoyer le courriel test",
                "SETTING_DEFAULT": "Par défaut",
                "SETTING_HIGH": "Haut",
                "SETTING_LARGE": "Grand",
                "SETTING_LOW": "Faible",
                "SETTING_NORMAL": "Normal",
                "SETTING_SMALL": "Réduit",
                "SHARE_REPORT": "Rapport de partage",
                "SHOW_ALL_PAGES": "Afficher toutes les pages",
                "SHOW_FULL_QTEXT": "Afficher le texte complet de la question dans les titres de page",
                "SIMPLE_TABLE": "Tableau simple",
                "SIMPLE_TABLE_DESC": "Tableau flexible permettant d'afficher plusieurs valeurs sous la forme de rangées ou de colonnes.",
                "SIZE": "Taille",
                "SPLINE_CHART": "Diagramme linéaire",
                "SPLINE_CHART_DESC": "Graphique linéaire arrondi à deux axes généralement utilisé pour représenter graphiquement des valeurs par rapport au temps sur l'axe X.",
                "STATISTICS_TABLE": "Tableau de statistiques",
                "SUBJECT": "Objet",
                "SURVEY_ANALYSIS": "Analyse de l'enquête",
                "SURVEY_SUMMARY": "Résumé de l'enquête",
                "TABLE": "UNE DESCRIPTION POUR LE TABLEAU",
                "TIME": "Heure",
                "TO": "À",
                "TOTAL": "Total",
                "TRANSPOSE_STATS_TABLES": "Transposer les tableaux de statistiques",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "Transposer les découpages des tableaux de statistiques",
                "TRUNCATE_PAGE_TITLES": "Tronquer le texte de la question dans les titres de page",
                "TRY_IT_NOW": "Essayer dès maintenant",
                "TYPE": "Type",
                "UNABLE_TO_CHECK_SPF": "Impossible de vérifier l'enregistrement SPF. Veuillez réessayer.",
                "UNAUTHORIZED": "Vous n'êtes pas autorisé à afficher ce rapport. Veuillez contacter le propriétaire pour y avoir accès.",
                "UNHIDE_PAGE": "Afficher la page",
                "UPDATE": "Mettre à jour",
                "UPDATED_SUCCESSFULLY": "Mise à jour réussie.",
                "UPDATE_ALL_IN_THIS_PROJECT": "Mettre à jour tout ce projet",
                "UPDATE_ALL_PROJECTS": "Mettre à jour Tous les projets",
                "UPDATE_NOW": "Mettre à jour maintenant",
                "UPDATE_REPORTS": "Mettre à jour le rapport…",
                "UPDATE_REPORT_ELEMENTS": "Mettre à jour les liens de rapports publics et les courriels de rapports planifiés",
                "UPGRADE_MY_ACCOUNT": "Mettre mon compte à niveau",
                "USE_EXPORT_TAGS": "Inclure les numéros des questions",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "Utiliser les totaux des colonnes des tableaux simples",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "Utiliser le nombre de répondants des tableaux simples",
                "USE_WEIGHTED_METRICS": "Utiliser des données pondérées",
                "VIEW": "Afficher",
                "WEEKLY": "Toutes les semaines",
                "WELCOME_TO_NEW_RESULTS": "Bienvenue sur Qualtrics XM Platform!",
                "WHEN": "Quand",
                "WIDGET_LOADING": "Téléchargement…",
                "WIDGET_OPTIONS_ERR": "Impossible de charger les options de visualisation",
                "WIDGET_TYPE": "Visualisation",
                "WORD_CLOUD": "Nuage de mots",
                "WORD_CLOUD_DESC": "Visualisation pondérée de la fréquence des mots dans les données de texte avec des options supplémentaires de codage par couleur."
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Rappelez-vous qu'il existe des ressources au sein de votre organisation pour vous aider à interpréter vos appréciations, comme les partenaires RH, votre gestionnaire et/ou un mentor.",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Servez-vous une tasse de café et plongez-vous dans vos appréciations.",
                "ABOUT_YOUR_REPORT_HEADER": "Concernant votre rapport",
                "ABOUT_YOUR_REPORT_LINE1": "Bienvenue dans votre rapport d'appréciations à 360. Il s'agit d'une formidable opportunité de développement professionnel. Afin de mettre toutes les chances de votre côté lorsque vous consultez les résultats, laissez-vous suffisamment de temps pour prendre connaissance de vos appréciations. Les appréciations sont parfois difficiles à lire au début, mais n'oubliez pas que l'objectif consiste à accélérer votre croissance et votre développement.",
                "ABOUT_YOUR_REPORT_LINE2": "Durant la consultation de votre rapport, gardez les informations suivantes en tête",
                "ADD_CONDITIONAL_TEXT": "Ajouter du texte conditionnel",
                "ADD_CUSTOM_PALETTE": "Ajouter une palette personnalisée",
                "ADD_DATA_SOURCE": "Ajouter une source de données",
                "ADD_FOLLOWING": "Ajouter suivants",
                "ADD_LABEL": "Ajouter une étiquette",
                "ADVANCED_FILTER": "Filtre avancé",
                "AGREEMENT_CHART": "Diagramme d'accord",
                "AGREEMENT_CHART_FOOTER": "Le diagramme d'accord indique la similarité des notes. Chaque point représente la note donnée par des individus pour chaque élément. La taille du point montre le nombre d'évaluateurs qui vous ont donné une note spécifique.",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "réponses",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "réponses",
                "AGREEMENT_CHART_LEGEND_TITLE": "Notes données par les autres",
                "ALL": "Tout",
                "AND_IF": "Et si",
                "ANGLED": "Avec angle",
                "AREA": "Zone",
                "AUTO": "Automatique",
                "AVERAGE": "Moyenne",
                "AXIS_VALUES": "Valeurs des axes",
                "BAR": "Barre",
                "BASE_WORD_COLOR": "Couleur de base des mots",
                "BLUR": "Flou",
                "BOTTOM_BOX": "Zone du bas",
                "BREAKOUT_HEADERS": "En-têtes de découpage",
                "CANCEL": "Annuler",
                "CATEGORICAL": "Par catégorie",
                "CATEGORY": "Catégorie",
                "CATEGORY_NAME": "Nom de catégorie",
                "CHANGE_CATEGORIES_ORDER": "Modifier l'ordre des catégories",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "Modifier l'ordre des catégories de notation",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "Modifiez l'ordre qui apparaît dans la visualisation en cliquant à gauche de l'élément de catégorie et en le déplaçant à la position de votre choix.",
                "CHANGE_QUESTIONS_ORDER": "Modifier l'ordre des questions",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "Modifier l'ordre des questions",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "Modifiez l'ordre qui apparaît dans la visualisation en cliquant à gauche de l'élément de question et en le déplaçant à la position de votre choix.",
                "CHARTS": "Diagrammes",
                "CHART_TYPE": "Type de diagramme",
                "CHOICE_COUNT": "Nombre de choix",
                "CHOICE_TOTALS": "Nombre total de choix",
                "CLEAR": "Effacer",
                "CLOSE": "Fermer",
                "COLOR_PALETTE": "Palette de couleurs",
                "COLUMN_NAMES": "Noms des colonnes",
                "COLUMN_TOTALS": "Nombre total de colonnes",
                "COMPARED_FILTER_GROUP": "Groupes de filtres comparés",
                "COMPARED_FILTER_GROUPS": "Groupes de filtres comparés",
                "COMPARE_WITH": "comparer avec",
                "COMPETITION_RANKING": "Utiliser le classement de la concurrence",
                "COMPETITION_RANKING_TOOLTIP": "En cas d'égalité, toutes les notes égales reçoivent le même classement. Cependant, le classement de l'élément suivant correspondra au nombre total d'éléments mieux classés dans le tableau, plus un.",
                "COMPLETED_RESPONSES": "Réponses terminées",
                "CONDITIONAL_TEXT": "Texte conditionnel",
                "COUNT": "Nombre",
                "CREATE": "Créer",
                "CUSTOM_PALETTE": "Palette personnalisée",
                "DATA_SOURCE_TYPE": "Type de source de données",
                "DATA_SOURCE_TYPE_CATEGORY": "Catégories de notation",
                "DATA_SOURCE_TYPE_QUESTION": "Questions",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "Question",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "Éléments pouvant faire l'objet d'un classement",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "Catégorie",
                "DEFAULT": "Par défaut",
                "DEFAULT_TEXT": "Texte par défaut",
                "DELETE": "Supprimer",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "Comprendre d'où proviennent vos appréciations, que ce soit de pairs, de subordonnés directs, de responsables, etc.",
                "DIFFERENT_EVALUATORS_HEADER": "Évaluateurs différents",
                "DIRECT_REPORTS": "Subordonnés directs",
                "DISABLED": "Désactivé",
                "DISPLAY_OPTIONS": "Options d'affichage",
                "DISPLAY_THRESHOLD_TEXTS": "Afficher le texte en fonction de l'écart des groupes suivants",
                "DIVERGENT": "Divergent",
                "DONE": "Terminée",
                "DONT_HEADER": "Choses à ne pas faire :",
                "DONT_LINE1": "Chercher à savoir qui a dit quoi",
                "DONT_LINE2": "Se focaliser sur un commentaire/une note positive ou négative",
                "DONT_LINE3": "Créer un plan de développement pour chaque élément",
                "DONT_LINE4": "Se sentir découragé d'avoir des opportunités d'améliorations",
                "DONUT": "Anneau",
                "DOWNLOAD_CSV": "Télécharger le fichier CSV hérité",
                "DOWNLOAD_ZIP": "Télécharger tous les fichiers",
                "DO_HEADER": "Choses à faire :",
                "DO_LINE1": "Voir les appréciations de façon globale",
                "DO_LINE2": "Identifier des thèmes dans les forces et les opportunités d’améliorations",
                "DO_LINE3": "Prioriser quelques domaines stratégiques à ajouter à votre plan de développement",
                "DO_LINE4": "Comprendre que tout le monde peut s’améliorer",
                "DROPOFF": "Dépôt",
                "DUPLICATE": "Dupliqué",
                "EDIT_CONDITIONAL_TEXT": "Modifier le texte conditionnel",
                "EDIT_CUSTOM_PALETTE": "Modifier la palette personnalisée",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "Sinon afficher le texte suivant",
                "ENABLED": "Activé",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "Activer la réorganisation par logique d'affichage de catégorie d'évaluateur",
                "ENABLE_ORDERING_FOR": "Activer le classement pour",
                "EQUAL_TO": "Est égal à",
                "FIELD": "Champ",
                "FILTER_NAMES": "Noms des filtres",
                "FOLLOWING_PARENTHESES": "(suivant)",
                "FOOTER": "Pied de page",
                "GAP": "Écart",
                "GAP_CHART": "Diagramme d’écart",
                "GAP_CHART_DESCRIPTION": "Le diagramme d’écart affiche la différence de notes entre deux groupes d'évaluateurs. Par exemple, dans le cas d'auto-notations vs. les notes données par les autres, une différence positive (+) signifie que les autres vous ont donné des notes plus élevées que celles que vous vous êtes données. Une différence négative (-) signifie que les autres vous ont donné des notes plus basses que celles que vous vous êtes données.",
                "GAP_CHART_FOOTER": "Le diagramme d’écart indique la différence +/- entre les deux groupes d'évaluateurs.",
                "GAP_TABLE_DESCRIPTION": "Les forces cachées montrent les points sur lesquels les autres vous ont donné des notes plus élevées que celles que vous vous êtes données. Les domaines d'amélioration montrent les points sur lesquels les autres vous ont donné des notes plus basses que celles que vous vous êtes données. Les deux sections sont classées de l'écart le plus grand à l'écart le plus petit.",
                "GAP_TABLE_FOOTER": "La première colonne de notes indique comment vous vous êtes noté. La deuxième colonne indique la note moyenne des autres. La troisième colonne indique la différence entre la façon dont vous vous êtes noté et la façon dont les autres vous ont noté.",
                "GAP_TABLE_TITLE": "Forces cachées/Domaines d’amélioration",
                "GREATER_OR_EQUAL": "Est supérieur ou égal à",
                "GREATER_THAN": "Est supérieur à",
                "GROUP": "Groupe",
                "GROUPED_FOR_ANONYMITY": "Regroupé pour anonymat",
                "HEADER_NAMES": "Noms des en-têtes",
                "HIGHEST_SCORES": "Notes les plus élevées",
                "HIGHLIGHT_THRESHOLD": "Seuil pour surligner les écarts",
                "HIGHLOW_TABLE": "Notes élevées et basses",
                "HIGHLOW_TABLE_FOOTER": "Cette section indique les cinq comportements avec les notes les plus élevées et les cinq comportements avec les notes les plus basses (parmi tous les comportements) à partir des moyennes des catégories des évaluateurs applicables. Pour tirer au mieux profit de cette page, il est utile d'observer les tendances qui peuvent en ressortir. Par exemple, si la majorité de vos comportements avec les notes les plus basses sont concentrés dans une ou deux catégories, il peut s'agir des axes à développer. Les comportements avec les notes les plus élevées peuvent identifier les forces à exploiter dans d'autres axes.",
                "HIGH_LOW_TABLE_DESCRIPTION": "Le diagramme d'écart affiche les éléments en fonction des domaines dans lesquels les autres vous ont donné les notes les plus élevées et les plus basses.",
                "HORIZONTAL": "Horizontal",
                "HORIZONTAL_AND_VERTICAL": "Horizontal et vertical",
                "HORIZONTAL_BAR": "Barre horizontale",
                "HOW_TO_INTERPRET_RESULT_HEADER": "Comment interpréter les résultats et déterminer les actions :",
                "IF": "Si",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "Inclure les libellés masqués dans les pourcentages",
                "INNER_RIM": "Bord intérieur",
                "IS": "Est",
                "IS_NOT": "N'est pas",
                "IS_SAME_AS_SUBJECT": "Est identique à la personne évaluée",
                "ITEM": "Énoncé",
                "LABEL": "l’étiquette",
                "LABELS": "Libellés",
                "LARGE_LABELS": "Grands libellés",
                "LEGEND": "Légende",
                "LEGEND_POSITION": "Position des légendes",
                "LEGEND_VALUES": "Valeurs des légendes",
                "LESS_OR_EQUAL": "Est inférieur ou égal à",
                "LESS_THAN": "Est inférieur à",
                "LINE": "Ligne",
                "LOWEST_SCORES": "Notes les plus basses",
                "MANAGERS": "Gestionnaires",
                "MANUAL_FONT_SIZE": "Définir la taille de police manuellement",
                "MAX": "Maximum",
                "MEAN": "Moyenne",
                "MEDIAN": "Médiane",
                "METRIC_TYPE": "Type de métrique",
                "MIN": "Minimum",
                "MODIFY_CUSTOM_PALETTES": "Modifier les palettes personnalisées",
                "MOVE_DOWN": "Déplacer vers le bas",
                "MOVE_UP": "Déplacer vers le haut",
                "MULTI_SELECT_ITEMS_SELECTED": "sélectionné",
                "NEGATIVE_GAPS": "Domaines d'amélioration",
                "NO": "Non",
                "NONE": "Aucune",
                "NOT_APPLICABLE": "N/A",
                "NOT_EQUAL_TO": "N'est pas égal à",
                "NO_DATA_AVAILABLE_WARNING": "Aucune donnée disponible",
                "NO_FILTER": "Aucun filtre",
                "NO_FILTER_IS_APPLIED": "Aucun filtre appliqué",
                "NO_VALUE": "Aucune valeur",
                "NPS": "Taux de recommandation net",
                "NUMBER": "nombre",
                "NUMBERS": "Chiffres",
                "NUMBER_OF_GAPS_NEGATIVE": "Nombre d'écarts négatifs",
                "NUMBER_OF_GAPS_POSITIVE": "Nombre d'écarts positifs",
                "NUMBER_OF_ROWS_HIGH": "Nombre de lignes élevées",
                "NUMBER_OF_ROWS_LOW": "Nombre de lignes basses",
                "OPTIONS": {
                    "HEADER_NAME": "Nom de l'en-tête",
                    "LEGEND": "Légende",
                    "SCALE_AXIS_CHANGER_TITLE": "Plage"
                },
                "ORIENTATION": "Orientation",
                "OR_IF": "Ou si",
                "OTHER": "Autre",
                "OTHERS": "Autres",
                "PAGE_OF": "Page: %1 sur %2",
                "PALETTE_REMOVED": "Palette retirée",
                "PEERS": "Pairs",
                "PERCENT": "Pour cent",
                "PERCENTAGE": "Pourcentage",
                "PERCENTAGE_OF_CHOICES": "Pourcentage de choix",
                "PERCENTAGE_OF_RESPONSES": "Pourcentage de réponses",
                "PERCENT_COMPLETE": "% terminées",
                "PERSON_METADATA": "Métadonnées de la personne",
                "PERSON_METADATA_EVALUATOR": "Pour l'évaluateur:",
                "PERSON_METADATA_SUBJECT": "Pour la personne évaluée:",
                "PERSON_METADATA_VIEWER": "Pour l'observateur",
                "POSITIVE_GAPS": "Forces cachées",
                "PRIMARY_PARENTHESES": "(premier)",
                "QUESTIONS": "Questions",
                "RADIUS": "Rayon",
                "RANK": "Classement",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "Note la plus élevée",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "Notes les plus élevées",
                "RANKABLE_ITEMS_ITEM_HAS": "L'élément détient",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "L'élément figure parmi les",
                "RANKABLE_ITEMS_LOWEST_SCORE": "Note la plus basse",
                "RANKABLE_ITEMS_LOWEST_SCORES": "Notes les plus basses",
                "RATER_CATEGORY_DISPLAY_LOGIC": "logique d'affichage de catégorie d'évaluateur",
                "RATIO": "Ratio",
                "RECORD": "Enregistrement",
                "REFERENCE_GROUP": "Groupe de référence",
                "RELATIONSHIP": "Relation",
                "RELATIONSHIP_FILTERS": "Filtres de relations",
                "RELATIONSHIP_FILTERS_INFO": "Pour ajouter un filtre de relations (tel qu'un subordonné direct, un pair ou un gestionnaire), sélectionnez Gérer vos filtres, puis utilisez une condition de relations uniquement dans le menu déroulant.",
                "REMOVE": "Retirer",
                "REMOVE_DATA_SOURCE": "Retirer la source de données",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Rappelez-vous qu'il existe des ressources au sein de votre organisation pour vous aider à interpréter vos appréciations, comme les partenaires RH, votre gestionnaire et/ou un mentor.",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Servez-vous une tasse de café et plongez-vous dans vos appréciations.",
                    "ABOUT_YOUR_REPORT_HEADER": "Concernant votre rapport",
                    "ABOUT_YOUR_REPORT_LINE1": "Bienvenu dans votre rapport d'appréciations à 360. Il s'agit d'une formidable opportunité de développement professionnel. Afin de mettre toutes les chances de votre côté lorsque vous consultez les résultats, laissez-vous suffisamment de temps pour prendre connaissance de vos appréciations. Les appréciations sont parfois difficiles à lire au début, mais n'oubliez pas que l'objectif consiste à accélérer votre croissance et votre développement.",
                    "ABOUT_YOUR_REPORT_LINE2": "Durant la consultation de votre rapport, gardez les informations suivantes en tête",
                    "ADVANCED_FILTER": "Filtre avancé",
                    "AGREEMENT_CHART": "Diagramme d'accord",
                    "AGREEMENT_CHART_FOOTER": "Le diagramme d'accord indique la similarité des notes. Chaque point représente la note donnée par des individus pour chaque élément. La taille du point montre le nombre d'évaluateurs qui vous ont donné une note spécifique.",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "réponses",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "réponses",
                    "AGREEMENT_CHART_LEGEND_TITLE": "Notes données par les autres",
                    "ALL": "Tout",
                    "AVERAGE": "Moyenne",
                    "BOTTOM_BOX": "Zone du bas",
                    "CHOICE_COUNT": "Nombre de choix",
                    "CHOICE_TOTALS": "Nombre total de choix",
                    "COMPARISON": "Comparaison",
                    "COMPARISON_GAP_COLUMN_HEADER": "Écart de comparaison",
                    "COMPLETED_RESPONSES": "Réponses terminées",
                    "COUNT": "Nombre",
                    "DEFAULT": "Par défaut",
                    "DEFAULT_TEXT": "Texte par défaut",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "Comprendre d'où proviennent vos appréciations, que ce soit de pairs, de subordonnés directs, de responsables, etc.",
                    "DIFFERENT_EVALUATORS_HEADER": "Évaluateurs différents",
                    "DONE": "Terminée",
                    "DONT_HEADER": "Choses à ne pas faire :",
                    "DONT_LINE1": "Chercher à savoir qui a dit quoi",
                    "DONT_LINE2": "Se focaliser sur un commentaire/une note positive ou négative",
                    "DONT_LINE3": "Créer un plan de développement pour chaque élément",
                    "DONT_LINE4": "Se sentir découragé d'avoir des opportunités d'améliorations",
                    "DO_HEADER": "Choses à faire :",
                    "DO_LINE1": "Voir les appréciations de façon globale",
                    "DO_LINE2": "Identifier des thèmes dans les forces et les opportunités d’améliorations",
                    "DO_LINE3": "Prioriser quelques domaines stratégiques à ajouter à votre plan de développement",
                    "DO_LINE4": "Comprendre que tout le monde peut s’améliorer",
                    "FIELD": "Champ",
                    "GAP": "Écart",
                    "GAP_CHART": "Diagramme d’écart",
                    "GAP_CHART_DESCRIPTION": "Le diagramme d’écart affiche la différence de notes entre deux groupes d'évaluateurs. Par exemple, dans le cas d'auto-notations vs. les notes données par les autres, une différence positive (+) signifie que les autres vous ont donné des notes plus élevées que celles que vous vous êtes données. Une différence négative (-) signifie que les autres vous ont donné des notes plus basses que celles que vous vous êtes données.",
                    "GAP_CHART_FOOTER": "Le diagramme d’écart indique la différence +/- entre les deux groupes d'évaluateurs.",
                    "GAP_TABLE_DESCRIPTION": "Les forces cachées montrent les points sur lesquels les autres vous ont donné des notes plus élevées que celles que vous vous êtes données. Les domaines d'amélioration montrent les points sur lesquels les autres vous ont donné des notes plus basses que celles que vous vous êtes données. Les deux sections sont classées de l'écart le plus grand à l'écart le plus petit.",
                    "GAP_TABLE_FOOTER": "La première colonne de notes indique comment vous vous êtes noté. La deuxième colonne indique la note moyenne des autres. La troisième colonne indique la différence entre la façon dont vous vous êtes noté et la façon dont les autres vous ont noté.",
                    "GAP_TABLE_TITLE": "Forces cachées/Domaines d’amélioration",
                    "GROUP": "Groupe",
                    "HIDE_REPORT_ALERT": "Toutes les exigences ne sont pas remplies pour afficher votre rapport. Contactez l'administrateur de votre organisation.",
                    "HIGHEST_SCORES": "Notes les plus élevées",
                    "HIGHLOW_TABLE": "Notes élevées et basses",
                    "HIGHLOW_TABLE_FOOTER": "Cette section indique les cinq comportements avec les notes les plus élevées et les cinq comportements avec les notes les plus basses (parmi tous les comportements) à partir des moyennes des catégories des évaluateurs applicables. Pour tirer au mieux profit de cette page, il est utile d'observer les tendances qui peuvent en ressortir. Par exemple, si la majorité de vos comportements avec les notes les plus basses sont concentrés dans une ou deux catégories, il peut s'agir des axes à développer. Les comportements avec les notes les plus élevées peuvent identifier les forces à exploiter dans d'autres axes.",
                    "HIGH_LOW_TABLE_DESCRIPTION": "Le diagramme d'écart affiche les éléments en fonction des domaines dans lesquels les autres vous ont donné les notes les plus élevées et les plus basses.",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "Comment interpréter les résultats et déterminer les actions :",
                    "ITEM": "Énoncé",
                    "LOWEST_SCORES": "Notes les plus basses",
                    "MAX": "Maximum",
                    "MEAN": "Moyenne",
                    "MEDIAN": "Médiane",
                    "MIN": "Minimum",
                    "NEGATIVE_GAPS": "Domaines d'amélioration",
                    "NO_COMPARISON_SET": "Aucune comparaison définie",
                    "NO_DATA_AVAILABLE_WARNING": "Aucune donnée disponible",
                    "NO_FILTER_IS_APPLIED": "Aucun filtre appliqué",
                    "NO_VALUE": "Aucune valeur",
                    "NPS": "Taux de recommandation net",
                    "OTHERS": "Autres",
                    "PERCENTAGE": "Pourcentage",
                    "PERCENTAGE_OF_CHOICES": "Pourcentage de choix",
                    "PERCENTAGE_OF_RESPONSES": "Pourcentage de réponses",
                    "PERCENT_COMPLETE": "% terminées",
                    "POSITIVE_GAPS": "Forces cachées",
                    "QUESTIONS": "Questions",
                    "RANK": "Classement",
                    "RELATIONSHIPS": {
                        "ANYONE": "Tout le monde",
                        "DIRECT_REPORT": "Subordonné direct",
                        "MANAGER": "Gestionnaire",
                        "PEER": "Pair",
                        "SELF": "Soi-même"
                    },
                    "REPORT_SUMMARY": "Résumé du rapport",
                    "REPORT_SUMMARY_TABLE_FOOTER": "Comparez le nombre de personnes qui ont terminé votre évaluation avec le nombre de personnes invitées à participer",
                    "REPORT_SUMMARY_TABLE_HEADER": "Statistiques des répondants",
                    "RESPONSES": "Réponses",
                    "RESPONSE_COUNT": "{{responseCount}} Réponses",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Réponses",
                    "SCORING_CATEGORY": "Catégorie",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Aucune réponse pour cette catégorie",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Aucune réponse pour cette question",
                    "SCORING_OVERVIEW": "Vue d'ensemble de la notation",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "Vous et d'autres évaluateurs pensez que ce domaine est la plus grande force",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Forces reconnues",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Un domaine d’amélioration reconnu signifie que l'auto-notation et les notations des autres sont en-dessous de la moyenne pour cette compétence.",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Domaine d’amélioration reconnu",
                    "SCORING_OVERVIEW_DESCRIPTION": "Ci-dessus se trouvent les compétences ou les comportements sur lesquels vous avez été évalué dans le cadre du processus d’appréciation à plusieurs évaluateurs. Les notations de comparaison sont fournies par groupe.",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "Écart minimum",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Différence minimum entre les groupes de référence pour les textes à afficher.",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "La plage de notes pour chaque compétence/comportement s'affiche. La barre représente la moyenne numérique.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Les forces non reconnues proviennent des écarts entre l'auto-notation et les notations des autres.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Forces non reconnues",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Le domaine d'amélioration non reconnu provient des écarts entre l'auto-notation et les notations des autres.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Domaine d’amélioration non reconnu",
                    "SELF": "Soi-même",
                    "SELF_ASSESSMENT": "Autoévaluation",
                    "STANDARD_DEVIATION": "Écart standard",
                    "SUM": "Somme",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Familiarisez-vous avec l'échelle de notation pour assurer une interprétation précise",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "Prenez note de l'échelle",
                    "THINGS_YOU_WILL_SEE_HEADER": "Éléments que vous allez voir :",
                    "THREE_SIXTY_PERCENTILE": "Centile",
                    "TOP_BOTTOM_BOX": "Valeurs hautes/basse",
                    "TOP_BOX": "Zone du haut",
                    "TOTAL": "Total",
                    "TO_DO": "À faire",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Qualitatif : cette appréciation prendra la forme de commentaires en texte libre",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Qualitatif : cette appréciation sera numérique et peut être représentée par des graphiques, diagrammes à barres, tables, etc.",
                    "TYPES_OF_FEEDBACK_HEADER": "Différents types d'appréciations",
                    "VALUE": "Valeur",
                    "VARIANCE": "Variance",
                    "YOUR_RATINGS": "Votre notation"
                },
                "REPORT_SUMMARY": "Résumé du rapport",
                "REPORT_SUMMARY_TABLE_FOOTER": "Comparez le nombre de personnes qui ont terminé votre évaluation avec le nombre de personnes invitées à participer",
                "REPORT_SUMMARY_TABLE_HEADER": "Statistiques des répondants",
                "RESET": "Réinitialiser",
                "RESPONDENT_TOTALS": "Nombre total de répondants",
                "RESPONSES": "Réponses",
                "RESPONSE_COUNT": "{{responseCount}} réponses",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> réponses",
                "RESULT": "Résultat",
                "REVERSE_COLORS": "Inverser les couleurs",
                "ROW_TOTALS": "Nombre total de lignes",
                "SAVE": "Enregistrer",
                "SAVE_AND_APPLY": "Enregistrer et appliquer",
                "SCORING_CATEGORY": "Catégorie",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Aucune réponse pour cette catégorie",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Aucune réponse pour cette question",
                "SCORING_OVERVIEW": "Vue d'ensemble de la notation",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "Vous et d'autres évaluateurs pensez que ce domaine est la plus grande force",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Forces reconnues",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Un domaine d’amélioration reconnu signifie que l'auto-notation et les notations des autres sont en-dessous de la moyenne pour cette compétence.",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Domaine d’amélioration reconnu",
                "SCORING_OVERVIEW_DESCRIPTION": "Ci-dessus se trouvent les compétences ou les comportements sur lesquels vous avez été évalué dans le cadre du processus d’appréciation à plusieurs évaluateurs. Les notations de comparaison sont fournies par groupe.",
                "SCORING_OVERVIEW_MINIMUM_GAP": "Écart minimum",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Différence minimum entre les groupes de référence pour les textes à afficher.",
                "SCORING_OVERVIEW_TABLE_FOOTER": "La plage de notes pour chaque compétence/comportement s'affiche. La barre représente la moyenne numérique.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Les forces non reconnues proviennent des écarts entre l'auto-notation et les notations des autres.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Forces non reconnues",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Le domaine d'amélioration non reconnu provient des écarts entre l'auto-notation et les notations des autres.",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Domaine d’amélioration non reconnu",
                "SELECT_CATEGORIES": "Veuillez sélectionner les catégories de notation...",
                "SELECT_CATEGORY": "Veuillez sélectionner une catégorie...",
                "SELECT_CONDITION_TYPE": "Sélectionner le type de condition",
                "SELECT_DATA_SOURCE": "Sélectionner la source de données",
                "SELECT_DATA_SOURCE_TYPE": "Sélectionner le type de source de données",
                "SELECT_FILTER": "Sélectionner le filtre",
                "SELECT_FILTERS": "Sélectionner les filtres",
                "SELECT_OPERATOR_TYPE": "Sélectionner le type d'opérateur",
                "SELECT_PERSON": "Sélectionner la personne",
                "SELECT_PERSON_METADATA": "Sélectionner les métadonnées de la personne",
                "SELECT_QUESTION": "Sélectionner la question",
                "SELECT_QUESTIONS": "Veuillez sélectionner les questions...",
                "SELECT_RATIO_OR_DROPOFF": "Sélectionner un ratio ou un dépôt",
                "SELECT_RELATIONSHIP": "Sélectionner la relation",
                "SELECT_SCORING_CATEGORY": "Sélectionner la catégorie",
                "SELF": "Soi-même",
                "SELF_ASSESSMENT": "Autoévaluation",
                "SEQUENTIAL": "Séquentiel",
                "SETUP_COMPARISON": "Configurer une comparaison",
                "SETUP_COMPARISONS": "Configurer les comparaisons",
                "SET_START_COLOR": "Définir la couleur de départ",
                "SHOULD_SHOW_FOOTER": "Afficher le pied de page",
                "SHOULD_SHOW_SCORING_CATEGORY": "Afficher la catégorie",
                "SHOWING_RECORDS_OF": "Affichage des enregistrements %1 à %2 sur %3",
                "SHOW_COMPARISON_GAP": "Montrer la colonne de l'écart de comparaison",
                "SHOW_DATA_LABEL": "Afficher les valeurs des données",
                "SHOW_PERCENTAGES": "Afficher les pourcentages",
                "SHOW_THE_FOLLOWING_TEXT": "Alors afficher le texte suivant",
                "SHOW_TIES": "Afficher les titres",
                "SHOW_X_AXIS": "Afficher l'axe X",
                "SHOW_Y_AXIS": "Afficher l'axe Y",
                "SMALL_LABELS": "Petits libellés",
                "SORT": "Trier",
                "SPLINE": "Courbe",
                "STACK_CHART": "Diagramme empilé",
                "STANDARD_DEVIATION": "Écart standard",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "Faiblesse inférieure à",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "Modifier les textes de seuil",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "Textes de seuil",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "Activer les textes de seuil",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "Force supérieure à",
                "SUM": "Somme",
                "SUMMARY": "Résumé",
                "TABLES": "Tables",
                "TABLE_TOTALS": "Nombre total de tables",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Familiarisez-vous avec l'échelle de notation pour assurer une interprétation précise",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "Prenez note de l'échelle",
                "TEXT": "Texte",
                "THINGS_YOU_WILL_SEE_HEADER": "Éléments que vous allez voir :",
                "TOP_BOTTOM_BOX": "Valeurs hautes/basse",
                "TOP_BOX": "Zone du haut",
                "TOTAL": "Total",
                "TOTAL_COUNTS": "Nombre total",
                "TO_DO": "À faire",
                "TRANSPOSE": "Transposer",
                "TRANSPOSE_TABLE": "Transposer le tableau",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Qualitatif : cette appréciation prendra la forme de commentaires en texte libre",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Qualitatif : cette appréciation sera numérique et peut être représentée par des graphiques, diagrammes à barres, tables, etc.",
                "TYPES_OF_FEEDBACK_HEADER": "Différents types d'appréciations",
                "UNDO": "Annuler",
                "USE_COMPARISON": "Utiliser la comparaison",
                "USE_LABELS_FOR_SCALES": "Utiliser des étiquettes pour les balances",
                "VALUES": "Valeurs",
                "VALUE_RANGES": "Plages de valeurs",
                "VARIANCE": "Variance",
                "VERTICAL": "Vertical",
                "VERTICAL_RANGE": "Plage verticale",
                "WARNING_DATA_OUT_OF_RANGE": "Avertissement: la valeur des données dépasse la configuration de la plage",
                "WIDGET_ERROR": {
                    "ERROR": "Une erreur inattendue s'est produite.",
                    "MISCONFIGURED": "Le widget n'est pas configuré correctement. Veuillez vérifier la configuration de votre widget.",
                    "NEW": "Veuillez configurer le widget",
                    "NO_DATA": "Aucune donnée trouvée. Vos filtres sont peut-être trop exclusifs."
                },
                "WIDGET_NAME": {
                    "BAR": "Diagramme à barres",
                    "BREAKDOWNBAR": "Barre de répartition",
                    "DATA_TABLE": "Table de données",
                    "FUNNEL_CHART": "Diagramme en entonnoir",
                    "GAUGE": "Jauge",
                    "GRID": "Table de résultats",
                    "HEATMAP": "Carte thermique",
                    "LINE": "Graphique linéaire",
                    "NEEDS_BASED": "Basé sur les besoins",
                    "PIE": "Diagrammes circulaire",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "Estimation des prix (Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "Maximisation des recettes (Gabor Granger)",
                    "SCORING_OVERVIEW_CHART": "Diagramme",
                    "SCORING_OVERVIEW_TABLE": "Table",
                    "STATS_TABLE": "Tables de statistiques",
                    "WORDCLOUD": "Nuage de mots"
                },
                "WORD_ROTATION": "Rotation des mots",
                "WORD_SPACING": "Espacement des mots",
                "YES": "Oui",
                "YOUR_RATINGS": "Vos notations"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "Ajouter",
                "ADD_A_WORD": "Ajouter un mot",
                "COLOR": "Couleur",
                "DELETE_ALL": "Supprimer tout",
                "EDIT_STOP_WORDS": "Éditer les mots vides",
                "MAX_WORDS": "Nombre max. de mots",
                "ROTATION_ANGLED": "Angulaire",
                "ROTATION_HORIZONTAL": "Horizontale",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "Horizontal et vertical",
                "WORD_ORIENTATION": "Orientation des mots"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "Couleurs d'arrière-plan",
                "DISPLAY_OPTIONS": "Options d'affichage",
                "INVERT_FONT_COLORS": "Inverser les couleurs du texte à faible contraste",
                "PAGE": "Page",
                "PAGINATE": "Paginer"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "Moyenne",
                "BOTTOM_BOX_METRIC": "Case du bas",
                "COLUMNS": "Colonnes",
                "COUNT_METRIC": "Nombre total de réponses",
                "FIELD_NAME": "Champ",
                "MAX_METRIC": "Maximum",
                "MIN_METRIC": "Minimum",
                "SHOW_RECODES": "Afficher les valeurs recodées",
                "SHOW_ROW_NUMBERS": "Afficher les numéros des colonnes",
                "STD_DEV_METRIC": "Écart-type",
                "TOP_BOX_METRIC": "Case du haut",
                "TRANSPOSE_BREAKOUTS": "Transposer les découpages",
                "TRANSPOSE_TABLE": "Transposer le tableau",
                "VAR_METRIC": "Variance"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "Colonnes supplémentaires",
                "ADD_COLUMNS": "Ajouter des colonnes supplémentaires",
                "ADD_CUSTOM_PALETTE": "Ajouter une palette personnalisée",
                "ALL_CHOICES": "Tous les choix",
                "ALL_GROUPS": "Tous les groupes",
                "ALL_RECODES": "Tous les recodages",
                "AUTOMATIC": "Par défaut",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "Par défaut : cliquer pour modifier",
                "AXIS_VALUES": "Valeurs de l'axe",
                "BREAKOUT_BY": "Découpage par",
                "CANCEL": "Annuler",
                "CATEGORICAL": "Catégorique",
                "CHOICES": "Choix",
                "CHOICE_COUNT": "Nombre de choix",
                "COLOR_PALETTE": "Palette de couleurs",
                "COLUMN_VALUES": "Valeurs de colonne",
                "CONTACT_FIELDS": "Champs de contact",
                "COUNT": "Nombre",
                "CREATE": "Créer",
                "CUSTOM": "Personnalisé",
                "CUSTOM_PALETTE": "Palette personnalisée",
                "DATA_SOURCE": "Source de données",
                "DAY": "Jour",
                "DAY_OF_WEEK": "Jour de la semaine",
                "DECIMAL_PRECISION": "Décimales",
                "DEFAULT": "Par défaut",
                "DISABLED": "Désactivé",
                "DIVERGENT": "Divergent",
                "EDIT_CUSTOM_PALETTE": "Modifier la palette personnalisée",
                "ENABLED": "Activé",
                "ERROR_LOADING_DATA": "Erreur de chargement des données",
                "FILE_SIZE": "Taille",
                "FILE_TYPE": "Type",
                "FRI": "Ven.",
                "FRIDAY": "Vendredi",
                "GROUP_DATE_BY": "Grouper les dates par",
                "HOUR_OF_DAY": "Heure de la journée",
                "LENGEND_VALUES": "Valeurs de la légende",
                "MAX": "Max.",
                "MEAN": "Moyenne",
                "MIN": "Min.",
                "MISCONFIGURED_DATA": "Source de données mal configurée pour cette visualisation.",
                "MISCONFIGURED_FILTERS": "Filtre(s) non valide(s)",
                "MODIFY_CUSTOM_PALETTES": "Modifier les palettes personnalisées",
                "MON": "Lun.",
                "MONDAY": "Lundi",
                "MONTH": "Mois",
                "NONE": "Aucun",
                "NO_FILE_ID_ERROR": "Cette visualisation nécessite de définir une image dans l’enquête",
                "NO_RESULTS_TO_SHOW": "Aucun résultat à afficher",
                "NPS": "Taux de recommandation net®",
                "NPS_GROUP": "Groupe NPS®",
                "NUMERIC_VALUE": "Valeur numérique",
                "PALETTE_REMOVED": "Palette supprimée",
                "PERCENTAGE": "Pourcentage",
                "PERCENTAGE_OF_CHOICES": "Pourcentage de choix",
                "PERCENTAGE_OF_RESPONSES": "Pourcentage de réponses",
                "QUARTER": "Trimestre",
                "REMOVE": "Retirer",
                "RESPONSE_COUNT": "Compte de réponses",
                "RESULTS_PER_PAGE": "Nombre de résultats par page",
                "RETRIEVING_DATA_ELLIPSIS": "Récupération des données…",
                "REVERSE_COLORS": "Inverser les couleurs",
                "ROW_VALUES": "Valeurs de ligne",
                "SAT": "Sam.",
                "SATURDAY": "Samedi",
                "SAVE": "Enregistrer",
                "SELECTED_CHOICE": "Choix sélectionné",
                "SELECT_FIELD": "Sélectionnez un champ",
                "SELECT_METRIC": "Statistique",
                "SEQUENTIAL": "Séquentiel",
                "SET_START_COLOR": "Définir la couleur de début",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "Affichage des données relatives aux échantillons…",
                "SUM": "Somme",
                "SUN": "Dim.",
                "SUNDAY": "Dimanche",
                "SURVEY_EMBEDDEDDATA": "Données intégrées",
                "SURVEY_METADATA": "Métadonnées de l'enquête",
                "TEXT_ENTRY": "Saisie de texte",
                "THURS": "Jeu.",
                "THURSDAY": "Jeudi",
                "TITLE": "Titre",
                "TUES": "Mar.",
                "TUESDAY": "Mardi",
                "UNBOUNDED_DOMAIN": "Trop grand nombre de valeurs à afficher.",
                "UNBOUNDED_DOMAIN_HELP": "Pour ajouter ce champ aux Rapports de résultats, vous pouvez ajouter un filtre au rapport afin d’afficher moins de valeurs pour « {{ed_field_name}} » ou mettre à jour le type de variable des données intégrées de « {{ed_field_name}} » dans votre flux d'enquête afin que ce champ adopte le type chaîne ou numérique.",
                "UNDO": "Annuler",
                "USE_CHOICE_TOTALS": "Utiliser les totaux de choix",
                "USE_RESPONDENT_TOTALS": "Utiliser les totaux de répondants",
                "VISUALIZATION": "Visualisation",
                "VISUALIZATION_BARCHART": "Diagramme à barres",
                "VISUALIZATION_BREAKDOWNBAR": "Barre de répartition",
                "VISUALIZATION_GAUGE": "Graphique jauge",
                "VISUALIZATION_HEATMAP": "Carte thermique",
                "VISUALIZATION_LINECHART": "Graphique linéaire",
                "VISUALIZATION_PAGINATEDTABLE": "Tableau de questions",
                "VISUALIZATION_PIE": "Diagramme circulaire",
                "VISUALIZATION_SIMPLETABLE": "Tableau simple",
                "VISUALIZATION_STATSTABLE": "Tableau de statistiques",
                "VISUALIZATION_TEXTHIGHLIGHTS": "Éléments importants du texte",
                "VISUALIZATION_WORDCLOUD": "Nuage de mots",
                "WED": "Mer.",
                "WEDNESDAY": "Mercredi",
                "WEEK": "Semaine",
                "WEIGHTING": "Pondération",
                "WRONG_QUESTION_TYPE_ERROR": "Ce type de visualisation ne peut pas être utilisé pour cette question",
                "YEAR": "Année"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "Moyen",
                "CHOICE_COUNT": "Nombre de choix",
                "COUNT": "Nombre",
                "DISPLAY_OPTIONS": "Options d'affichage",
                "MAX": "Maximum",
                "MIN": "Minimum",
                "NPS": "NPS®",
                "PAGE_OF": "Page : %1 sur %2",
                "PERCENT": "Pourcentage",
                "RESPONSE_COUNT": "Compte de réponses",
                "ROWS_PER_TABLE": "Lignes par tableau",
                "SHOWING_ROWS_OF": "Affichage des lignes %1 à %2 sur %3",
                "SHOW_PERCENTAGES": "Afficher les pourcentages",
                "SHOW_RECODES": "Afficher les valeurs recodées",
                "SHOW_ROW_NUMBERS": "Afficher les numéros des colonnes",
                "SUM": "Somme",
                "TOTAL": "Total",
                "TRANSPOSE": "Transposer",
                "USE_COLUMN_TOTALS": "Utiliser les totaux de colonne",
                "USE_ROW_TOTALS": "Utiliser les totaux de ligne",
                "VALUE": "Valeur"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "Croissant",
                "COUNT": "Nombre",
                "DESCENDING": "Décroissant",
                "DIAGONAL": "Diagonale",
                "DISPLAY_OPTIONS": "Options d'affichage",
                "ERROR_COLON": "Erreur :",
                "ERROR_GENERIC": "Une erreur s'est produite lors du chargement de la visualisation.",
                "HORIZONTAL": "Horizontale",
                "HORIZONTAL_BARS": "Barres horizontales",
                "INCORRECTLY_CONFIGURED": "Choisir une valeur afin d'afficher le tableau",
                "LEGEND_AUTO": "Automatique",
                "LEGEND_BOTTOM": "Bas",
                "LEGEND_INSET": "Encart",
                "LEGEND_RIGHT": "À droite",
                "NORMALIZE_TO_PERCENTAGES": "Normaliser aux pourcentages",
                "SHOW_BAR_LABELS": "Afficher les étiquettes de barres",
                "SHOW_LEGEND": "Afficher la légende",
                "SHOW_X_AXIS": "Afficher l'axe X",
                "SHOW_Y_AXIS": "Afficher l'axe Y",
                "SORT_BAR_VALUES": "Trier valeurs de barres",
                "STACKED_BARS": "Barres en pile",
                "TRANSPOSE": "Transposer",
                "TRUNCATE_LABELS": "Réduire les étiquettes",
                "VERTICAL": "Verticale"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "Toutes les autres",
                "COULD_NOT_LOAD_DATA": "Impossible de charger les données avec la configuration spécifiée – essayez un champ source différent ou une plage de dates plus grande.",
                "GROUPING_PERCENTAGE_THRESHOLD": "Seuil de pourcentage du groupe",
                "NO_DATA": "Aucune donnée",
                "RADIUS": "Rayon intérieur",
                "SHOW_AS_PERCENTAGES": "Afficher sous la forme de pourcentages"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "Clôturer",
                "DOWNLOAD_CSV": "Télécharger un fichier CSV",
                "DOWNLOAD_ZIP": "Télécharger tous les fichiers",
                "NO_DATA": "Aucune donnée",
                "PAGE_OF": "Page : %1 sur %2",
                "RESULTS_PER_PAGE": "Nombre de résultats par page",
                "SHOWING_RECORDS_OF": "Affichage des enregistrements %1 à %2 sur %3",
                "SINGLE_RESPONSE": "Réponse unique",
                "VIEW_RESPONSE": "Afficher la réponse"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "Options d'affichage",
                "ERROR_COLON": "Erreur :",
                "ERROR_GENERIC": "Une erreur s'est produite lors du chargement de la visualisation.",
                "HORIZONTAL_BARS": "Barres horizontales",
                "INCORRECTLY_CONFIGURED": "Choisir une valeur afin d'afficher le tableau",
                "LEGEND_AUTO": "Automatique",
                "LEGEND_BOTTOM": "Bas",
                "LEGEND_INSET": "Encart",
                "LEGEND_RIGHT": "À droite",
                "NORMALIZE_TO_PERCENTAGES": "Normaliser aux pourcentages",
                "SHOW_AREA": "Afficher la zone",
                "SHOW_LEGEND": "Afficher la légende",
                "SHOW_X_AXIS": "Afficher l'axe X",
                "SHOW_Y_AXIS": "Afficher l'axe Y",
                "SMOOTH_LINES": "Lignes nettes",
                "SORT_X_AXIS_LABELS": "Trier les étiquettes de l'axe X",
                "STACKED_BARS": "Barres en pile",
                "TRANSPOSE": "Transposer"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "Mode bloc",
                "BLUR": "Flou",
                "COULD_NOT_LOAD_DATA": "Impossible de charger les données avec la configuration spécifiée – essayez un champ source différent ou une plage de dates plus grande.",
                "FIELD": "Champ",
                "RADIUS": "Rayon",
                "SHOW_REGIONS": "Afficher les régions",
                "SHOW_REGION_LABELS": "Afficher les étiquettes de région"
            },
            "GAUGEWIDGET": {
                "MAX": "Max.",
                "MIN": "Min.",
                "VALUE_RANGES": "Plages de valeurs"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "Étiquettes du bas",
                "CATEGORY_NAME": "Nom de la catégorie",
                "ERROR_COLON": "Erreur :",
                "INCLUDE_HIDDEN_GROUPS": "Inclure les groupes masqués dans les pourcentages",
                "LARGE_LABELS": "Grandes étiquettes",
                "NO": "Non",
                "PERCENT": "Pourcentage",
                "RESPONSE_COUNT": "Compte de réponses",
                "RESPONSE_COUNT_WITH_VALUE": "{{ responseCount }} réponses",
                "SMALL_LABELS": "Petites étiquettes",
                "YES": "Oui"
            }
        });
        $cache.put('FR', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "Code d'accès",
                "ACCESS_CODE_PROTECTION": "Protection par code d'accès",
                "ADD": "Ajouter",
                "ADD_BREAKOUT": "Ajouter le découpage du rapport",
                "ADD_NOTE": "Ajouter un commentaire",
                "ADD_SCHEDULED_REPORT": "Ajouter le rapport planifié",
                "ADD_WIDGET": "Ajouter la visualisation",
                "ALL_PROJECTS": "Tous les projets",
                "ALL_QUESTIONS": "Pages de questions",
                "ANSWER": "Réponse",
                "ANY_CHANGES_LOST": "Toute modification apportée aux rapports sera perdue si vous quittez Qualtrics XM Platform.",
                "APPENDED_COPY_IN_PARENS": "(Copier)",
                "AREA_CHART": "Diagramme à aires",
                "AREA_CHART_DESC": "Graphique linéaire à deux axes dont la surface sous la ligne est remplie.",
                "ATTACHMENT": "Pièce jointe",
                "BACKUP_CURRENT_REPORT": "Enregistrez une copie de ce rapport avant de modifier les visualisations",
                "BACKUP_CURRENT_REPORT_LINE2": "Remarque : la copie de sauvegarde sera nommée « {{nameOfReportCopy}} »",
                "BACK_TO_REPORTS": "Revenir aux rapports",
                "BACK_TO_TOP": "Haut de page",
                "BACK_TO_VIEW_RESULTS": "Retour à l'affichage des anciens résultats",
                "BAR_CHART": "Diagramme à barres",
                "BAR_CHART_DESC": "Diagramme à barres à deux axes qui autorise une configuration supplémentaire, telle que la transposition des axes et la réorganisation des points de données.",
                "BREAKDOWN_BAR_CHART": "Barre de répartition",
                "BREAKDOWN_BAR_CHART_DESC": "Diagramme à barres horizontales empilées, généralement utilisé comme alternative au diagramme circulaire afin de comparer visuellement des données.",
                "CANCEL": "Annuler",
                "CANCEL_CONF_TEXT": "Êtes-vous sûr(e) de vouloir annuler ?<br/>Toutes les modifications seront perdues.",
                "CANCEL_EDITS": "Annuler les modifications",
                "CHART": "Graphique",
                "CHOICE": "Choix",
                "CHOICES_COUNT_METRIC": "Nombre de choix",
                "CHOOSE_PAGES_TO_DISPLAY": "Choisir les pages à afficher",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "Ce rapport contient {{maxReportPageCount}} pages, mais les résultats ne peuvent en contenir qu'un maximum de {{reportSizeLimit}}. Veuillez sélectionner un sous-ensemble inclus dans la limite.",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "Les rapports ne peuvent contenir que {{reportSizeLimit}} pages maximum. Veuillez sélectionner les pages souhaitées.",
                "CLEAR_ALL": "Effacer tout",
                "CLOSE": "Clôturer",
                "CLOUD": "UNE DESCRIPTION POUR LE NUAGE",
                "COLLABORATED_NEW": "Le propriétaire de cette enquête utilise Qualtrics XM Platform ! Les rapports de cette enquête sont modifiés à l'aide de la section « Nouveaux résultats ».",
                "COMMA_SEPARATED_LIST": "Liste séparée par des virgules",
                "COMPACTNESS": "Polices et espacement",
                "COMPACTNESS_INFO": "Ce paramètre affecte le remplissage des tableaux, la taille de police et la taille des bâtons des diagrammes. Il sera également appliqué à la plupart des exportations.",
                "CONFIRM": "Ok",
                "CONFIRM_DELETE": "Confirmer la suppression",
                "CONFIRM_DELETE_PAGE": "Êtes-vous sûr de vouloir supprimer cette page ?",
                "CONTINUE": "Continuer",
                "CONTINUE_EDITING": "Continuer à modifier",
                "COPY": "Copier",
                "COPY_OF_REPORT_NAME": "Copie de {{nameOfCurrentReport}}",
                "COPY_REPORT": "Copier le rapport",
                "COPY_REPORT_ELLIPSIS": "Copier le rapport...",
                "COPY_TO_NEW_REPORT": "Copier vers un nouveau rapport...",
                "CREATE": "Créer",
                "CREATED": "Créé",
                "CREATE_CUSTOM_PAGE": "Créer une page personnalisée",
                "CREATE_NEW_REPORT": "Créer un nouveau rapport",
                "CREATE_NEW_REPORT_ELLIPSIS": "Créer un nouveau rapport...",
                "CSV_FILE": "Fichier CSV",
                "CUSTOM_PAGES": "Pages personnalisées",
                "DATE": "Date",
                "DEFAULT_PALETTE": "Palette de couleurs par défaut",
                "DEFAULT_REPORT": "Rapport par défaut",
                "DEFAULT_VISUALIZATIONS": "Visualisations par défaut",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "Il s'agit des types de visualisations utilisées pour établir les rapports de résultats par défaut. La mise à jour et l'application de ces paramètres créeront un nouveau rapport avec les nouveaux paramètres par défaut. Vous aurez la possibilité d'enregistrer une copie de votre rapport actuel.",
                "DEFAULT_VISUALIZATIONS_NOTE": "Remarque : tous les types de visualisation ne sont pas disponibles pour tous les types de questions. Il se peut que certaines visualisations par défaut soient automatiquement remplacées.",
                "DEFAULT_VISUALS_DISCLAIMER": "Qualtrics mettra à jour ce rapport avec les nouveaux paramètres de visualisation par défaut.",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "Cette mise à jour aura une incidence sur {{amountOfWidgetsAffected}} visualisations de ce rapport.",
                "DEFAULT_VISUAL_EDIT_DETECTED": "Modification de la visualisation par défaut détectée",
                "DELETE_BUTTON": "Supprimer",
                "DELETE_DISABLED_EXPLANATION": "La suppression des rapports créés dans l'ancienne interface de rapport n'est possible qu'une fois que votre organisation a terminé la migration complète vers Qualtrics XM Platform.",
                "DELETE_PAGE": "Supprimer la page",
                "DELETE_PAGE_ELLIPSIS": "Supprimer la page...",
                "DELETE_REPORT": "Supprimer le rapport",
                "DELETE_REPORT_ELLIPSIS": "Supprimer le rapport...",
                "DELETE_WIDGET_QUESTION": "Supprimer ?",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "Ce champ est crypté et ne peut pas être utilisé pour le tri.",
                "DISCARD_EDITS": "Rejeter les modifications",
                "DISTRIBUTION_PAUSED": "Distribution de rapports interrompue.",
                "DONE_BUTTON": "Terminé",
                "DONE_EDITING": "Modification terminée",
                "DOWNLOAD": "Télécharger",
                "DOWNLOAD_AS_CSV": "Télécharger en tant que fichier CSV",
                "DOWNLOAD_AS_PDF": "Télécharger en tant que PDF",
                "DOWNLOAD_FAILED": "Échec du téléchargement",
                "DOWNLOAD_PREVIOUS_EXPORTS": "Télécharger les exportations précédentes...",
                "DO_YOU_WISH_TO_DELETE": "Souhaitez-vous supprimer :",
                "DUPLICATE_PAGE": "Dupliquer la feuille",
                "EDIT_REPORT": "Modifier le rapport",
                "EDIT_REPORT_ELLIPSIS": "Modifier le rapport…",
                "EDIT_VISUALIZATION": "Modifier la visualisation",
                "EMAIL_ADDRESS": "Adresse e-mail",
                "EMAIL_SENT": "E-mail envoyé...",
                "END_OF_REPORT": "Fin du rapport",
                "ENTER_NAME": "Saisir un nom",
                "ERROR_COPYING": "Une erreur s'est produite lors de la copie du rapport.",
                "ERROR_DELETING": "Une erreur s'est produite lors de la suppression du rapport.",
                "ERROR_DELETING_EXPORT": "Une erreur s'est produite lors de la suppression de l'exportation.",
                "ERROR_HEADING": "Erreur",
                "ERROR_PUBLISHING": "Une erreur s'est produite lors de l'enregistrement des paramètres.",
                "ERROR_RENAMING": "Une erreur s'est produite lors du changement du nom du rapport.",
                "ERROR_REQUESTING_EXPORT": "Une erreur s'est produite lors de la demande d'exportation.",
                "ERROR_SAVING_GLOBAL_OPTIONS": "Une erreur s'est produite lors de l'enregistrement des options de visualisation globales.",
                "ERROR_SEND_TEST_EMAIL": "Une erreur s'est produite lors de l'envoi de l'e-mail test.",
                "EVERY_FRIDAY": "Tous les vendredis",
                "EVERY_MONDAY": "Tous les lundis",
                "EVERY_MONTH": "Tous les mois, le",
                "EVERY_SATURDAY": "Tous les samedis",
                "EVERY_SUNDAY": "Tous les dimanches",
                "EVERY_THURSDAY": "Tous les jeudis",
                "EVERY_TUESDAY": "Tous les mardis",
                "EVERY_WEDNESDAY": "Tous les mercredis",
                "EVERY_WEEK": "Toutes les semaines, tous les",
                "EXAMPLE_GROUP_NUM": "Groupe {{num}}",
                "EXAMPLE_SERIES_NUM": "Série {{num}}",
                "EXPORT": "Exporter",
                "EXPORT_CSV": "CSV (Séparées par des virgules)",
                "EXPORT_EXCEL_SPREADSHEET": "Feuille de calcul Excel",
                "EXPORT_IMAGE": "Exporter l'image",
                "EXPORT_PAGES": "Exporter les pages",
                "EXPORT_PDF": "Document PDF",
                "EXPORT_PPT_SLIDES": "Diapositives PowerPoint",
                "EXPORT_RAW_DATA": "Exporter les données brutes",
                "EXPORT_REPORT": "Exporter le rapport",
                "EXPORT_VISUALIZATION": "Exporter la visualisation",
                "EXPORT_WORD_DOC": "Document Word",
                "FAILED_SAVE_TXT": "Échec de l'enregistrement",
                "FILTERED": "Filtré",
                "FIRST_PAGE": "Première page",
                "FIRST_WEEKDAY": "Premier jour de la semaine du mois",
                "FROM": "De",
                "FROM_EMAIL": "E-mail de l'expéditeur",
                "FROM_NAME": "Nom de l'expéditeur",
                "GAUGE_CHART": "Graphique jauge",
                "GAUGE_CHART_DESC": "Graphique semblable à un outil de mesure à jauges, utilisé afin de comparer les valeurs actuelles à un objectif ou à un ensemble de seuils.",
                "GENERATING_FILE": "Génération du fichier...",
                "GENERATING_IMAGE": "Génération de l'image...",
                "GENERATING_PDF": "Création du PDF...",
                "GENERIC_ERROR": "Une erreur nous a empêché de charger le projet souhaité.",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "Options globales...",
                "GLOBAL_METRIC": "Mesure par défaut",
                "GLOBAL_MODAL_PAGE_TITLE": "Exemple de visualisation avec les options globales de la section Résultats de Research Suite de Qualtrics",
                "GLOBAL_MODAL_WIDGET_TITLE": "Titre de la visualisation",
                "GLOBAL_OPTIONS": "Options globales",
                "GLOBAL_PRECISION": "Décimales par défaut",
                "GLOBAL_SETTINGS_APPLY": "Appliquer mes paramètres par défaut",
                "GLOBAL_SETTINGS_SAVE": "Enregistrer en tant que paramètres par défaut",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "Appliquer les paramètres par défaut de Qualtrics",
                "GROUP": "Groupe",
                "HEAT_MAP_CHART": "Graphique de carte thermique",
                "HEAT_MAP_CHART_DESC": "Visualisation en cluster de style « carte thermique », utilisée pour le mappage de la distribution des saisies de l'utilisateur (telles que les clics) sur l'image d'origine.",
                "HIDDEN": "Masqué",
                "HIDDEN_PAGE": "Cette page est masquée. Elle n'apparaîtra pas dans les rapports publics et sera désélectionnée par défaut dans les exportations de rapport.",
                "HIDE": "Masquer",
                "HIDE_ALL_PAGES": "Masquer toutes les pages",
                "HIDE_PAGE": "Masque la page",
                "IMAGE_FILE": "Fichier image",
                "INVALID_BRAND_DOMAIN": "Le domaine saisi ne figure pas dans la liste des domaines d'e-mail approuvés de votre organisation. Veuillez prendre contact avec votre administrateur pour résoudre ce problème.",
                "INVALID_SPF_RECORD": "Le domaine saisi n'a pas autorisé Qualtrics à envoyer des e-mails à partir de celui-ci. Cela affectera votre capacité à envoyer des e-mails. Veuillez utiliser un domaine différent ou prendre contact avec Qualtrics pour résoudre ce problème.",
                "ISSUE_SAVING_REPORTS": "Un problème est survenu lors de l'enregistrement d'un ou de plusieurs rapports. Veuillez réessayer.",
                "ISSUE_SENDING_TEST": "Une erreur s'est produite lors de l'envoi d'un e-mail test. Veuillez réessayer.",
                "LARGE_SURVEY": "Les résultats ne seront pas affichés car l'enquête est trop volumineuse.",
                "LAST_DAY": "Dernier jour du mois",
                "LAST_MODIFIED_COLON_WITH_DATE": "Dernière modification : %1",
                "LAST_PAGE": "Dernière page",
                "LAST_WEEKDAY": "Dernier jour de semaine du mois",
                "LATER": "Plus tard",
                "LEARN_MORE": "En savoir plus",
                "LINE_CHART": "Graphique linéaire",
                "LINE_CHART_DESC": "Graphique linéaire à deux axes généralement utilisé pour représenter graphiquement des valeurs par rapport au temps sur l'axe X.",
                "LOG_OUT_WARNING": "Cliquez n'importe où dans les {{countdown}} secondes pour rester connecté",
                "MESSAGE": "Message",
                "MONTHLY": "Tous les mois",
                "MOVE_DOWN": "Déplacer la visualisation vers le bas",
                "MOVE_PAGE_TO_BOTTOM": "Déplacer en bas",
                "MOVE_PAGE_TO_TOP": "Déplacer en haut",
                "MOVE_UP": "Déplacer la visualisation vers le haut",
                "MY_SURVEYS": "Mes projets",
                "NAME": "Nom",
                "NEW_CUSTOM_PAGE_NAME": "Nouvelle page personnalisée",
                "NEW_REPORT": "Nouveau rapport",
                "NEXT_PAGE": "Page suivante",
                "NEXT_RUN": "Exécution suivante",
                "NO_EXPORTS": "Aucune exportation n'a encore été demandée pour ce rapport.",
                "NO_ITEMS_TO_DISPLAY": "Aucun élément à afficher",
                "NO_MATCHING_CUSTOM_PAGES": "Aucune page personnalisée correspondante",
                "NO_MATCHING_PAGES": "Aucune page pour la recherche",
                "NO_MATCHING_REPORTS": "Aucun rapport correspondant.",
                "NO_PROJECT": "Veuillez spécifier un projet pour continuer.",
                "NO_PROJECTS_TO_MIGRATE": "Il n'y a aucun projet à mettre à jour.",
                "NO_QUESTIONS": "Aucune question correspondante",
                "NO_RESULTS_YET": "Aucun résultat ne peut encore être affiché. Veuillez distribuer votre enquête pour recueillir des réponses.",
                "OFF": "Désactivé",
                "ON": "Activé",
                "PAGES_SELECTED": "Pages sélectionnées",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "Avec cette sélection, le rapport contiendrait {{currentSelectedPageCount}} pages, ce qui est supérieur au maximum autorisé de {{reportSizeLimit}}. Veuillez sélectionner une gamme plus restreinte.",
                "PAGES_SELECTION_INVALID_RANGE": "Veuillez sélectionner une plage valide.",
                "PAGE_OPTIONS": "Options de page",
                "PDF_ROW_TRUNCATION_MESSAGE": "Trop de lignes pour une exportation PDF, essayez une exportation vers un format Word ou CSV.",
                "PERCENTAGE_METRIC": "Pourcentage",
                "PIE_CHART": "Diagramme circulaire",
                "PIE_CHART_DESC": "Répartition circulaire des valeurs pour un certain point de données. Utile pour mesurer les proportions relatives des valeurs sélectionnées.",
                "PREVIEW": "Aperçu",
                "PREVIOUS_PAGE": "Page précédente",
                "PRINT_PAGE": "Imprimer la page",
                "PUBLIC_LINK": "Lien public",
                "PUBLIC_REPORT_AVAILABLE": "Rapport public disponible",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "Code d'accès",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "Code d'accès incorrect. Veuillez réessayer.",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "Soumettre",
                "PUBLIC_RESULTS_LOGIN_TITLE": "Connexion au rapport public | Logiciel d'enquêtes Qualtrics",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "Impossible de trouver le rapport public. Veuillez contacter le propriétaire de ce rapport et lui demander un lien valide.",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "Rapport public introuvable",
                "PUBLIC_RESULTS_NOT_UPDATED": "Les liens des rapports publics et des e-mails de rapport programmé n'utiliseront pas Qualtrics XM Platform tant que vous ne les aurez pas mis à jour.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "Session expirée. Veuillez vous reconnecter pour continuer à visualiser le Rapport de résultats publié.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "Session expirée",
                "PUBLIC_RESULTS_TITLE": "Rapport public",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "Vous n'êtes pas autorisé à visualiser cette page. Veuillez contacter le propriétaire de ce rapport et lui demander de les rendre publics.",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "Rapport public non autorisé",
                "PUBLISHED_LINK_GENERATING_LINK": "Génération du lien...",
                "PUBLISHED_REPORT_FOUND_HERE": "N’importe qui peut voir ce rapport en cliquant sur le lien suivant :",
                "PUBLISH_REPORT": "Gérer le rapport public",
                "PUBLISH_REPORT_ELLIPSIS": "Gérer le rapport public...",
                "QUESTION": "Question",
                "RANK": "Classement",
                "REMOVE_WIDGET": "Supprimer la visualisation",
                "RENAME_PAGE": "Renommer la page",
                "RENAME_REPORT": "Renommer le rapport",
                "RENAME_REPORT_ELLIPSIS": "Renommer le rapport...",
                "REPLY_TO_EMAIL": "E-mail de réponse",
                "REPORT_COLON": "Rapport :",
                "REPORT_SETTINGS": "Paramètres du rapport",
                "REPORT_SETTINGS_ELLIPSIS": "Paramètres du rapport...",
                "RESPONSE_COUNTS": "Comptes de réponses",
                "RESULTS_DASHBOARDS_BANNER": "et essayez la nouvelle version améliorée des résultats d'enquête. Cette nouvelle version propose une interface utilisateur moderne et accessible, des visualisations de données, une nouvelle analyse, des fonctionnalités d'exploration, et bien plus encore.",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "Notes de mise à jour",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "Afficher la/le plus récent(e)",
                "RESULTS_OPTIONS": "Options du rapport",
                "RESULTS_TITLE": "Rapport",
                "RESUME_DISTRIBUTION": "Reprendre une distribution",
                "REVERT": "Rétablir",
                "RICH_TEXT_LIMIT_REACHED": "La longueur du contenu a atteint la limite.",
                "SAVE": "Enregistrer",
                "SAVE_AND_CLOSE": "Enregistrer et fermer",
                "SAVE_AS_CSV": "Enregistrer la visualisation au format CSV",
                "SAVE_AS_IMAGE": "Enregistrer la visualisation en tant qu'image",
                "SAVE_CONFIRMATION": "Enregistrer la confirmation",
                "SAVE_PAGE_AS_ELLIPSIS": "Exporter la page sous...",
                "SAVE_SETTINGS": "Enregistrer les paramètres",
                "SCHEDULE_REPORT_EMAIL": "Planifier un e-mail de rapport",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "Planifier un e-mail de rapport...",
                "SEARCH_ELLIPSIS": "Recherche...",
                "SEARCH_PAGES": "Rechercher des questions",
                "SEARCH_PAGES_ELLIPSIS": "Rechercher les pages...",
                "SEARCH_REPORTS_ELLIPSIS": "Rechercher dans les rapports...",
                "SELECTED": "Sélectionné :",
                "SELECT_ALL": "Tout sélectionner",
                "SELECT_A_FIELD": "Sélectionner un champ",
                "SELECT_A_WIDGET": "Sélectionner une visualisation",
                "SELECT_PAGES": "Sélectionner des pages",
                "SELECT_PAGES_ELLIPSIS": "Sélectionner des pages…",
                "SEND": "Envoyer",
                "SEND_TEST_EMAIL": "Envoyer l'email test",
                "SETTING_DEFAULT": "Par défaut",
                "SETTING_HIGH": "Haut",
                "SETTING_LARGE": "Grand",
                "SETTING_LOW": "Faible",
                "SETTING_NORMAL": "Normal",
                "SETTING_SMALL": "Réduit",
                "SHARE_REPORT": "Rapport de partage",
                "SHOW_ALL_PAGES": "Afficher toutes les pages",
                "SHOW_FULL_QTEXT": "Afficher le texte complet de la question dans les titres de page",
                "SIMPLE_TABLE": "Tableau simple",
                "SIMPLE_TABLE_DESC": "Tableau flexible permettant d'afficher plusieurs valeurs sous la forme de rangées ou de colonnes.",
                "SIZE": "Taille",
                "SPLINE_CHART": "Diagramme linéaire",
                "SPLINE_CHART_DESC": "Graphique linéaire arrondi à deux axes généralement utilisé pour représenter graphiquement des valeurs par rapport au temps sur l'axe X.",
                "STATISTICS_TABLE": "Tableau de statistiques",
                "SUBJECT": "Objet",
                "SURVEY_ANALYSIS": "Analyse de l'enquête",
                "SURVEY_SUMMARY": "Résumé de l'enquête",
                "TABLE": "UNE DESCRIPTION POUR LE TABLEAU",
                "TIME": "Heure",
                "TO": "À",
                "TOTAL": "Total",
                "TRANSPOSE_STATS_TABLES": "Transposer les tableaux de statistiques",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "Transposer les découpages des tableaux de statistiques",
                "TRUNCATE_PAGE_TITLES": "Tronquer le texte de la question dans les titres de page",
                "TRY_IT_NOW": "Essayer dès maintenant",
                "TYPE": "Type",
                "UNABLE_TO_CHECK_SPF": "Impossible de vérifier l'enregistrement SPF. Veuillez réessayer.",
                "UNAUTHORIZED": "Vous n'êtes pas autorisé à afficher ce rapport. Veuillez contacter le propriétaire pour y avoir accès.",
                "UNHIDE_PAGE": "Afficher la page",
                "UPDATE": "Mettre à jour",
                "UPDATED_SUCCESSFULLY": "Mise à jour réussie.",
                "UPDATE_ALL_IN_THIS_PROJECT": "Mettre à jour tout ce projet",
                "UPDATE_ALL_PROJECTS": "Mettre à jour Tous les projets",
                "UPDATE_NOW": "Mettre à jour maintenant",
                "UPDATE_REPORTS": "Mettre à jour le rapport...",
                "UPDATE_REPORT_ELEMENTS": "Mettre à jour les liens de rapports publics et les e-mails de rapports planifiés",
                "UPGRADE_MY_ACCOUNT": "Mettre mon compte à niveau",
                "USE_EXPORT_TAGS": "Inclure les numéros des questions",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "Utiliser les totaux des colonnes des tableaux simples",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "Utiliser le nombre de répondants des tableaux simples",
                "USE_WEIGHTED_METRICS": "Utiliser des données pondérées",
                "VIEW": "Afficher",
                "WEEKLY": "Toutes les semaines",
                "WELCOME_TO_NEW_RESULTS": "Bienvenue sur Qualtrics XM Platform !",
                "WHEN": "Quand",
                "WIDGET_LOADING": "Téléchargement...",
                "WIDGET_OPTIONS_ERR": "Impossible de charger les options de visualisation",
                "WIDGET_TYPE": "Visualisation",
                "WORD_CLOUD": "Nuage de mots",
                "WORD_CLOUD_DESC": "Visualisation pondérée de la fréquence des mots dans les données de texte avec des options supplémentaires de codage par couleur."
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Rappelez-vous que vous disposez de ressources au sein de votre organisation pour vous aider à interpréter vos avis, comme des partenaires RH, votre manager et/ou un conseiller.",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Préparez-vous une tasse de café et plongez-vous dans vos avis.",
                "ABOUT_YOUR_REPORT_HEADER": "À propos de votre rapport",
                "ABOUT_YOUR_REPORT_LINE1": "Bienvenue dans votre rapport d'avis 360. C'est une excellente opportunité d'accroître et de développer votre activité en tant que professionnel. Pour vous engager sur la voie de la réussite, prenez bien le temps de consulter chaque avis lorsque que vous passerez les résultats en revue. Au début, les avis peuvent être difficiles à entendre, mais gardez à l'esprit que l'objectif de ces avis est d'accélérer votre croissance et votre développement.",
                "ABOUT_YOUR_REPORT_LINE2": "Lorsque vous parcourez votre rapport, il y a certaines choses que vous devez garder à l'esprit.",
                "ADD_CONDITIONAL_TEXT": "Ajouter du texte conditionnel",
                "ADD_CUSTOM_PALETTE": "Ajouter une palette personnalisée",
                "ADD_DATA_SOURCE": "Ajouter une source de données",
                "ADD_FOLLOWING": "Ajouter",
                "ADD_LABEL": "Ajouter une étiquette",
                "ADVANCED_FILTER": "Filtre avancé",
                "AGREEMENT_CHART": "Graphique de consensus",
                "AGREEMENT_CHART_FOOTER": "Le graphique de consensus indique la similarité des scores. Chaque point indique comment les personnes vous ont noté pour chaque élément. La taille d'un point indique combien d'évaluateurs vous ont donné une note spécifique.",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "réponses",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "réponse",
                "AGREEMENT_CHART_LEGEND_TITLE": "Comment les autres vous ont noté",
                "ALL": "Tous",
                "AND_IF": "Et si",
                "ANGLED": "Angulaire",
                "AREA": "Zone",
                "AUTO": "Automatique",
                "AVERAGE": "Moyenne",
                "AXIS_VALUES": "Valeurs de l'axe",
                "BAR": "Barre",
                "BASE_WORD_COLOR": "Couleur de mot de base",
                "BLUR": "Flou",
                "BOTTOM_BOX": "Case du bas",
                "BREAKOUT_HEADERS": "En-têtes de découpage",
                "CANCEL": "Annuler",
                "CATEGORICAL": "Catégorique",
                "CATEGORY": "Catégorie",
                "CATEGORY_NAME": "Nom de la catégorie",
                "CHANGE_CATEGORIES_ORDER": "Modifier l'ordre des catégories",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "Modifier l'ordre des catégories de notation",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "Modifiez l'ordre qui apparait dans la visualisation en cliquant à gauche de l'élément de catégorie de notation et en le déplaçant à la position de votre choix.",
                "CHANGE_QUESTIONS_ORDER": "Modifier l'ordre des questions",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "Modifier l'ordre des questions",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "Modifiez l'ordre qui apparait dans la visualisation en cliquant à gauche de l'élément de question et en le déplaçant à la position de votre choix.",
                "CHARTS": "Graphiques",
                "CHART_TYPE": "Type de graphique",
                "CHOICE_COUNT": "Nombre de choix",
                "CHOICE_TOTALS": "Totaux de choix",
                "CLEAR": "Réinitialiser",
                "CLOSE": "Clôturer",
                "COLOR_PALETTE": "Palette de couleurs",
                "COLUMN_NAMES": "Noms de colonne",
                "COLUMN_TOTALS": "Totaux de colonne",
                "COMPARED_FILTER_GROUP": "Groupe de filtres comparés",
                "COMPARED_FILTER_GROUPS": "Groupes de filtres comparés",
                "COMPARE_WITH": "comparer à",
                "COMPETITION_RANKING": "Utiliser le classement de la concurrence",
                "COMPETITION_RANKING_TOOLTIP": "En cas d'égalité, tous les scores égaux reçoivent le même classement. Cependant, le classement de l'élément suivant correspondra au nombre total d'éléments mieux classés dans le tableau, plus un.",
                "COMPLETED_RESPONSES": "Réponses complétées",
                "CONDITIONAL_TEXT": "Texte conditionnel",
                "COUNT": "Nombre",
                "CREATE": "Créer",
                "CUSTOM_PALETTE": "Palette personnalisée",
                "DATA_SOURCE_TYPE": "Type de source de données",
                "DATA_SOURCE_TYPE_CATEGORY": "Catégories de notation",
                "DATA_SOURCE_TYPE_QUESTION": "Questions",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "Question",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "Éléments classables",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "Catégorie de score",
                "DEFAULT": "Par défaut",
                "DEFAULT_TEXT": "Texte par défaut",
                "DELETE": "Supprimer",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "Vos avis peuvent provenir de différents évaluateurs : des pairs, des subordonnés, des leaders, etc.",
                "DIFFERENT_EVALUATORS_HEADER": "Différents évaluateurs",
                "DIRECT_REPORTS": "Subordonnés",
                "DISABLED": "Désactivé",
                "DISPLAY_OPTIONS": "Options d'affichage",
                "DISPLAY_THRESHOLD_TEXTS": "Afficher le texte en fonction de l'écart des groupes suivants",
                "DIVERGENT": "Divergent",
                "DONE": "Terminé",
                "DONT_HEADER": "À ne pas faire :",
                "DONT_LINE1": "Essayer de savoir qui est l'auteur d'un avis",
                "DONT_LINE2": "Se focaliser sur un seul commentaire/score positif ou négatif",
                "DONT_LINE3": "Élaborer un plan de développement pour chaque élément",
                "DONT_LINE4": "Penser que vous n'avez aucune possibilité d'amélioration",
                "DONUT": "Bouée",
                "DOWNLOAD_CSV": "Télécharger l’ancien fichier CSV",
                "DOWNLOAD_ZIP": "Télécharger tous les fichiers",
                "DO_HEADER": "À faire :",
                "DO_LINE1": "Regarder les avis dans leur globalité",
                "DO_LINE2": "Identifier des thèmes sur vos forces et possibilités d'amélioration",
                "DO_LINE3": "Prioriser quelques domaines clés à ajouter à votre plan de développement",
                "DO_LINE4": "Comprendre que tout le monde a la possibilité de s'améliorer",
                "DROPOFF": "Réduction",
                "DUPLICATE": "Dupliquer",
                "EDIT_CONDITIONAL_TEXT": "Modifier le texte conditionnel",
                "EDIT_CUSTOM_PALETTE": "Modifier la palette personnalisée",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "Sinon, afficher le texte suivant",
                "ENABLED": "Activé",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "Activer la réorganisation par logique d'affichage de catégorie d'évaluateur",
                "ENABLE_ORDERING_FOR": "Activer la réorganisation pour",
                "EQUAL_TO": "Égal à",
                "FIELD": "Champ",
                "FILTER_NAMES": "Noms des filtres",
                "FOLLOWING_PARENTHESES": "(suivant)",
                "FOOTER": "Pied de page",
                "GAP": "Écart",
                "GAP_CHART": "Graphique d'écart",
                "GAP_CHART_DESCRIPTION": "Le graphique d'écart indique la différence des scores entre deux groupes d'évaluateurs. Par exemple, en cas de comparaison entre votre propre évaluation et les évaluations d'autres personnes, une différence positive (+) signifie que les autres vous ont noté mieux que vous ne vous êtes noté vous-même. Une différence négative (-) signifie que les autres vous ont attribué des notes moins bonnes que vos propres notes.",
                "GAP_CHART_FOOTER": "Le graphique d'écart indique la différence (+/-) entre deux groupes d'évaluateurs.",
                "GAP_TABLE_DESCRIPTION": "Les forces cachées montrent sur quels points les autres vous ont mieux noté que vous ne vous êtes noté vous-même. Les points à améliorer montrent sur quels points les autres vous ont attribué des notes moins bonnes que vos propres notes.",
                "GAP_TABLE_FOOTER": "La première colonne des scores indique le score que vous vous êtes attribué. La deuxième colonne indique le score moyen des autres. La troisième colonne indique la différence entre votre score et le score que les autres vous ont attribué.",
                "GAP_TABLE_TITLE": "Forces cachées/Points à améliorer",
                "GREATER_OR_EQUAL": "Supérieur ou égal à",
                "GREATER_THAN": "Supérieur à",
                "GROUP": "Groupe",
                "GROUPED_FOR_ANONYMITY": "Groupées pour anonymat",
                "HEADER_NAMES": "Noms d’en-tête",
                "HIGHEST_SCORES": "Scores les plus élevés",
                "HIGHLIGHT_THRESHOLD": "Seuil pour mettre en évidence les écarts",
                "HIGHLOW_TABLE": "Scores les plus élevés et les plus bas",
                "HIGHLOW_TABLE_FOOTER": "Cette section présente les cinq comportements les mieux et les moins bien notés (tous comportements confondus) à partir des moyennes des catégories d'évaluateurs applicables. Pour tirer le meilleur parti de cette page, il est utile de rechercher les tendances qui peuvent se dégager. Par exemple, si la majorité de vos comportements les moins bien notés sont concentrés dans une ou deux catégories, il peut s'agir de domaines à perfectionner. Les comportements les mieux notés permettent de reconnaître les forces qui peuvent être mises à profit dans d'autres domaines.",
                "HIGH_LOW_TABLE_DESCRIPTION": "Le graphique des scores élevés/bas montre les éléments en fonction des domaines pour lesquels les autres vous ont attribué les notes les plus élevées et les plus basses.",
                "HORIZONTAL": "Horizontale",
                "HORIZONTAL_AND_VERTICAL": "Horizontal et vertical",
                "HORIZONTAL_BAR": "Barre horizontale",
                "HOW_TO_INTERPRET_RESULT_HEADER": "Comment interpréter les résultats et déterminer des actions :",
                "IF": "Si",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "Inclure les étiquettes masquées dans les pourcentages",
                "INNER_RIM": "Bord intérieur",
                "IS": "Est",
                "IS_NOT": "N'est pas",
                "IS_SAME_AS_SUBJECT": "Identique à la personne évaluée",
                "ITEM": "Élément",
                "LABEL": "étiquette",
                "LABELS": "Étiquettes",
                "LARGE_LABELS": "Grandes étiquettes",
                "LEGEND": "Légende",
                "LEGEND_POSITION": "Position de la légende",
                "LEGEND_VALUES": "Valeurs de la légende",
                "LESS_OR_EQUAL": "Inférieur ou égal à",
                "LESS_THAN": "Inférieur à",
                "LINE": "Ligne",
                "LOWEST_SCORES": "Scores les plus bas",
                "MANAGERS": "Managers",
                "MANUAL_FONT_SIZE": "Définir la taille de police manuellement",
                "MAX": "Max.",
                "MEAN": "Moyenne",
                "MEDIAN": "Médiane",
                "METRIC_TYPE": "Type de mesure",
                "MIN": "Min.",
                "MODIFY_CUSTOM_PALETTES": "Modifier les palettes personnalisées",
                "MOVE_DOWN": "Déplacer vers le bas",
                "MOVE_UP": "Déplacer vers le haut",
                "MULTI_SELECT_ITEMS_SELECTED": "sélectionné(s)",
                "NEGATIVE_GAPS": "Points à améliorer",
                "NO": "Non",
                "NONE": "Aucun",
                "NOT_APPLICABLE": "s.o.",
                "NOT_EQUAL_TO": "N'est pas égal à",
                "NO_DATA_AVAILABLE_WARNING": "Aucune donnée disponible",
                "NO_FILTER": "Aucun filtre",
                "NO_FILTER_IS_APPLIED": "Aucun filtre n'est appliqué.",
                "NO_VALUE": "Aucune valeur",
                "NPS": "Net Promoter Score®",
                "NUMBER": "nombre",
                "NUMBERS": "Nombres",
                "NUMBER_OF_GAPS_NEGATIVE": "Nombre d’écarts négatifs",
                "NUMBER_OF_GAPS_POSITIVE": "Nombre d’écarts positifs",
                "NUMBER_OF_ROWS_HIGH": "Nombre de rangées élevées",
                "NUMBER_OF_ROWS_LOW": "Nombre de rangées faibles",
                "OPTIONS": {
                    "HEADER_NAME": "Noms d'en-tête",
                    "LEGEND": "Légende",
                    "SCALE_AXIS_CHANGER_TITLE": "Plage"
                },
                "ORIENTATION": "Orientation",
                "OR_IF": "Ou si",
                "OTHER": "Autre",
                "OTHERS": "Autres",
                "PAGE_OF": "Page : %1 sur %2",
                "PALETTE_REMOVED": "Palette supprimée",
                "PEERS": "Pairs",
                "PERCENT": "Pourcentage",
                "PERCENTAGE": "Pourcentage",
                "PERCENTAGE_OF_CHOICES": "Pourcentage de choix",
                "PERCENTAGE_OF_RESPONSES": "Pourcentage de réponses",
                "PERCENT_COMPLETE": "% complété",
                "PERSON_METADATA": "Métadonnées de la personne",
                "PERSON_METADATA_EVALUATOR": "de l'évaluateur",
                "PERSON_METADATA_SUBJECT": "du sujet",
                "PERSON_METADATA_VIEWER": "de la personne qui visionne",
                "POSITIVE_GAPS": "Forces cachées",
                "PRIMARY_PARENTHESES": "(principal)",
                "QUESTIONS": "Questions",
                "RADIUS": "Rayon",
                "RANK": "Classement",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "Score le plus élevé",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "Scores les plus élevés",
                "RANKABLE_ITEMS_ITEM_HAS": "L'élément a",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "L'élément est dans le top",
                "RANKABLE_ITEMS_LOWEST_SCORE": "Score le plus bas",
                "RANKABLE_ITEMS_LOWEST_SCORES": "Scores les plus bas",
                "RATER_CATEGORY_DISPLAY_LOGIC": "logique d'affichage de catégorie d'évaluateur",
                "RATIO": "Ratio",
                "RECORD": "Registre",
                "REFERENCE_GROUP": "Groupe de référence",
                "RELATIONSHIP": "Lien",
                "RELATIONSHIP_FILTERS": "Filtres de relation",
                "RELATIONSHIP_FILTERS_INFO": "Pour ajouter un filtre de lien (par exemple avec un subordonné, un pair ou un manager), sélectionnez Gérer vos filtres et utilisez une condition de lien dans le menu déroulant.",
                "REMOVE": "Retirer",
                "REMOVE_DATA_SOURCE": "Supprimer la source de données",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Rappelez-vous que vous disposez de ressources au sein de votre organisation pour vous aider à interpréter vos avis, comme des partenaires RH, votre manager et/ou un conseiller.",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Préparez-vous une tasse de café et plongez-vous dans vos avis.",
                    "ABOUT_YOUR_REPORT_HEADER": "À propos de votre rapport",
                    "ABOUT_YOUR_REPORT_LINE1": "Bienvenue dans votre rapport d'avis 360. C'est une excellente opportunité d'accroître et de développer votre activité en tant que professionnel. Pour vous engager sur la voie de la réussite, prenez bien le temps de consulter chaque avis lorsque que vous passerez les résultats en revue. Au début, les avis peuvent être difficiles à entendre, mais gardez à l'esprit que l'objectif de ces avis est d'accélérer votre croissance et votre développement.",
                    "ABOUT_YOUR_REPORT_LINE2": "Lorsque vous parcourez votre rapport, il y a certaines choses que vous devez garder à l'esprit.",
                    "ADVANCED_FILTER": "Filtre avancé",
                    "AGREEMENT_CHART": "Graphique de consensus",
                    "AGREEMENT_CHART_FOOTER": "Le graphique de consensus indique la similarité des scores. Chaque point indique comment les personnes vous ont noté pour chaque élément. La taille d'un point indique combien d'évaluateurs vous ont donné une note spécifique.",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "réponses",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "réponse",
                    "AGREEMENT_CHART_LEGEND_TITLE": "Comment les autres vous ont noté",
                    "ALL": "Tous",
                    "AVERAGE": "Moyenne",
                    "BOTTOM_BOX": "Case du bas",
                    "CHOICE_COUNT": "Nombre de choix",
                    "CHOICE_TOTALS": "Totaux de choix",
                    "COMPARISON": "Comparaison",
                    "COMPARISON_GAP_COLUMN_HEADER": "Écart de comparaison",
                    "COMPLETED_RESPONSES": "Réponses complétées",
                    "COUNT": "Nombre",
                    "DEFAULT": "Par défaut",
                    "DEFAULT_TEXT": "Texte par défaut",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "Vos avis peuvent provenir de différents évaluateurs : des pairs, des subordonnés, des leaders, etc.",
                    "DIFFERENT_EVALUATORS_HEADER": "Différents évaluateurs",
                    "DONE": "Terminé",
                    "DONT_HEADER": "À ne pas faire :",
                    "DONT_LINE1": "Essayer de savoir qui est l'auteur d'un avis",
                    "DONT_LINE2": "Se focaliser sur un seul commentaire/score positif ou négatif",
                    "DONT_LINE3": "Élaborer un plan de développement pour chaque élément",
                    "DONT_LINE4": "Penser que vous n'avez aucune possibilité d'amélioration",
                    "DO_HEADER": "À faire :",
                    "DO_LINE1": "Regarder les avis dans leur globalité",
                    "DO_LINE2": "Identifier des thèmes sur vos forces et possibilités d'amélioration",
                    "DO_LINE3": "Prioriser quelques domaines clés à ajouter à votre plan de développement",
                    "DO_LINE4": "Comprendre que tout le monde a la possibilité de s'améliorer",
                    "FIELD": "Champ",
                    "GAP": "Écart",
                    "GAP_CHART": "Graphique d'écart",
                    "GAP_CHART_DESCRIPTION": "Le graphique d'écart indique la différence des scores entre deux groupes d'évaluateurs. Par exemple, en cas de comparaison entre votre propre évaluation et les évaluations d'autres personnes, une différence positive (+) signifie que les autres vous ont noté mieux que vous ne vous êtes noté vous-même. Une différence négative (-) signifie que les autres vous ont attribué des notes moins bonnes que vos propres notes.",
                    "GAP_CHART_FOOTER": "Le graphique d'écart indique la différence (+/-) entre deux groupes d'évaluateurs.",
                    "GAP_TABLE_DESCRIPTION": "Les forces cachées montrent sur quels points les autres vous ont mieux noté que vous ne vous êtes noté vous-même. Les points à améliorer montrent sur quels points les autres vous ont attribué des notes moins bonnes que vos propres notes.",
                    "GAP_TABLE_FOOTER": "La première colonne des scores indique le score que vous vous êtes attribué. La deuxième colonne indique le score moyen des autres. La troisième colonne indique la différence entre votre score et le score que les autres vous ont attribué.",
                    "GAP_TABLE_TITLE": "Forces cachées/Points à améliorer",
                    "GROUP": "Groupe",
                    "HIDE_REPORT_ALERT": "Vous ne remplissez pas les conditions requises pour afficher ce rapport. Contactez votre administrateur d'organisation.",
                    "HIGHEST_SCORES": "Scores les plus élevés",
                    "HIGHLOW_TABLE": "Scores les plus élevés et les plus bas",
                    "HIGHLOW_TABLE_FOOTER": "Cette section présente les cinq comportements les mieux et les moins bien notés (tous comportements confondus) à partir des moyennes des catégories d'évaluateurs applicables. Pour tirer le meilleur parti de cette page, il est utile de rechercher les tendances qui peuvent se dégager. Par exemple, si la majorité de vos comportements les moins bien notés sont concentrés dans une ou deux catégories, il peut s'agir de domaines à perfectionner. Les comportements les mieux notés permettent de reconnaître les forces qui peuvent être mises à profit dans d'autres domaines.",
                    "HIGH_LOW_TABLE_DESCRIPTION": "Le graphique des scores élevés/bas montre les éléments en fonction des domaines pour lesquels les autres vous ont attribué les notes les plus élevées et les plus basses.",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "Comment interpréter les résultats et déterminer des actions :",
                    "ITEM": "Élément",
                    "LOWEST_SCORES": "Scores les plus bas",
                    "MAX": "Max.",
                    "MEAN": "Moyenne",
                    "MEDIAN": "Médiane",
                    "MIN": "Min.",
                    "NEGATIVE_GAPS": "Points à améliorer",
                    "NO_COMPARISON_SET": "Aucune comparaison définie",
                    "NO_DATA_AVAILABLE_WARNING": "Aucune donnée disponible",
                    "NO_FILTER_IS_APPLIED": "Aucun filtre n'est appliqué.",
                    "NO_VALUE": "Aucune valeur",
                    "NPS": "Net Promoter Score",
                    "OTHERS": "Autres",
                    "PERCENTAGE": "Pourcentage",
                    "PERCENTAGE_OF_CHOICES": "Pourcentage de choix",
                    "PERCENTAGE_OF_RESPONSES": "Pourcentage de réponses",
                    "PERCENT_COMPLETE": "% terminé",
                    "POSITIVE_GAPS": "Forces cachées",
                    "QUESTIONS": "Questions",
                    "RANK": "Classement",
                    "RELATIONSHIPS": {
                        "ANYONE": "N'importe qui",
                        "DIRECT_REPORT": "Subordonné",
                        "MANAGER": "Manager",
                        "PEER": "Pairs",
                        "SELF": "Soi-même"
                    },
                    "REPORT_SUMMARY": "Résumé du rapport",
                    "REPORT_SUMMARY_TABLE_FOOTER": "Comparez le nombre de personnes qui ont terminé votre évaluation par rapport au nombre de personnes invitées à y participer.",
                    "REPORT_SUMMARY_TABLE_HEADER": "Statistiques des répondants",
                    "RESPONSES": "Réponses",
                    "RESPONSE_COUNT": "{{responseCount}} réponses",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> réponses",
                    "SCORING_CATEGORY": "Catégorie de notation",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Aucune réponse pour cette catégorie",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Aucune réponse à cette question",
                    "SCORING_OVERVIEW": "Synthèse des scores",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "Vous et les autres évaluateurs pensez que ce domaine est une force manifeste.",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Force reconnue",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Un domaine d’amélioration reconnu signifie que l'auto-évaluation et les évaluations des autres sont en dessous de la moyenne pour cette compétence.",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Domaine d’amélioration reconnu",
                    "SCORING_OVERVIEW_DESCRIPTION": "Ci-dessus se trouvent les compétences et les comportements sur lesquels vous avez été évalué dans le cadre de ce processus d'avis multi-évaluateurs. Les évaluations de comparaison sont fournies par groupe.",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "Écart minimum",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Écart minimum entre les groupes de référence pour les textes à afficher.",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "Plage des scores pour chaque compétence/comportement. La barre représente la moyenne numérique.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Une force est non reconnue lorsqu'il y a des divergences entre l'auto-évaluation et les évaluations des autres.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Force non reconnue",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Le domaine d'amélioration non reconnu provient des écarts entre l'auto-évaluation et les évaluations des autres.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Domaine d’amélioration non reconnu",
                    "SELF": "Soi-même",
                    "SELF_ASSESSMENT": "Auto-évaluation",
                    "STANDARD_DEVIATION": "Écart-type",
                    "SUM": "Somme",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Familiarisez-vous avec l'échelle d'évaluation pour interpréter correctement les résultats.",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "Tenez compte de l'échelle",
                    "THINGS_YOU_WILL_SEE_HEADER": "Voici ce que vous verrez :",
                    "THREE_SIXTY_PERCENTILE": "Centile",
                    "TOP_BOTTOM_BOX": "Case supérieure/Case inférieure",
                    "TOP_BOX": "Case supérieure",
                    "TOTAL": "Total",
                    "TO_DO": "À faire",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Qualité : ces avis seront affichés sous la forme de commentaires libres",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Quantité : ces avis seront numériques et pourront être représentés sous la forme de graphiques, de diagrammes à barres, de tableaux, etc.",
                    "TYPES_OF_FEEDBACK_HEADER": "Plusieurs types d'avis",
                    "VALUE": "Valeur",
                    "VARIANCE": "Écart",
                    "YOUR_RATINGS": "Vos évaluations"
                },
                "REPORT_SUMMARY": "Résumé du rapport",
                "REPORT_SUMMARY_TABLE_FOOTER": "Comparez le nombre de personnes qui ont terminé votre évaluation par rapport au nombre de personnes invitées à y participer.",
                "REPORT_SUMMARY_TABLE_HEADER": "Statistiques des répondants",
                "RESET": "Réinitialiser",
                "RESPONDENT_TOTALS": "Totaux de répondants",
                "RESPONSES": "Réponses",
                "RESPONSE_COUNT": "{{responseCount}} réponses",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> réponses",
                "RESULT": "Résultat",
                "REVERSE_COLORS": "Inverser les couleurs",
                "ROW_TOTALS": "Totaux de ligne",
                "SAVE": "Enregistrer",
                "SAVE_AND_APPLY": "Enregistrer et appliquer",
                "SCORING_CATEGORY": "Catégorie de notation",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Aucune réponse à cette catégorie",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Aucune réponse à cette question",
                "SCORING_OVERVIEW": "Synthèse des scores",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "Vous et les autres évaluateurs pensez que ce domaine est une force manifeste.",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Force reconnue",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Un domaine d’amélioration reconnu signifie que l'auto-évaluation et les évaluations des autres sont en dessous de la moyenne pour cette compétence.",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Domaine d’amélioration reconnu",
                "SCORING_OVERVIEW_DESCRIPTION": "Ci-dessus se trouvent les compétences et les comportements sur lesquels vous avez été évalué dans le cadre de ce processus d'avis multi-évaluateurs. Les évaluations de comparaison sont fournies par groupe.",
                "SCORING_OVERVIEW_MINIMUM_GAP": "Écart minimum",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Écart minimum entre les groupes de référence pour les textes à afficher.",
                "SCORING_OVERVIEW_TABLE_FOOTER": "Plage des scores pour chaque compétence/comportement. La barre représente la moyenne numérique.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Une force est non reconnue lorsqu'il y a des divergences entre l'auto-évaluation et les évaluations des autres.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Force non reconnue",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Le domaine d'amélioration non reconnu provient des écarts entre l'auto-évaluation et les évaluations des autres.",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Domaine d’amélioration non reconnu",
                "SELECT_CATEGORIES": "Veuillez sélectionner des catégories de notation...",
                "SELECT_CATEGORY": "Veuillez sélectionner une catégorie de score...",
                "SELECT_CONDITION_TYPE": "Sélectionner un type de condition",
                "SELECT_DATA_SOURCE": "Sélectionner une source de données",
                "SELECT_DATA_SOURCE_TYPE": "Sélectionner un type de source de données",
                "SELECT_FILTER": "Sélectionner un filtre",
                "SELECT_FILTERS": "Sélectionner des filtres",
                "SELECT_OPERATOR_TYPE": "Sélectionner un type d'opérateur",
                "SELECT_PERSON": "Sélectionner une personne",
                "SELECT_PERSON_METADATA": "Sélectionner les métadonnées de la personne",
                "SELECT_QUESTION": "Sélectionner une question",
                "SELECT_QUESTIONS": "Veuillez sélectionner des questions...",
                "SELECT_RATIO_OR_DROPOFF": "Sélectionner le ratio ou la réduction",
                "SELECT_RELATIONSHIP": "Sélectionner un lien",
                "SELECT_SCORING_CATEGORY": "Sélectionner une catégorie de notation",
                "SELF": "Soi-même",
                "SELF_ASSESSMENT": "Auto-évaluation",
                "SEQUENTIAL": "Séquentiel",
                "SETUP_COMPARISON": "Configuration de la comparaison",
                "SETUP_COMPARISONS": "Configuration des comparaisons",
                "SET_START_COLOR": "Définir la couleur de début",
                "SHOULD_SHOW_FOOTER": "Afficher le pied de page",
                "SHOULD_SHOW_SCORING_CATEGORY": "Afficher la catégorie de notation",
                "SHOWING_RECORDS_OF": "Affichage des enregistrements %1 à %2 sur %3",
                "SHOW_COMPARISON_GAP": "Afficher la colonne écart de comparaison",
                "SHOW_DATA_LABEL": "Afficher les valeurs des données",
                "SHOW_PERCENTAGES": "Afficher les pourcentages",
                "SHOW_THE_FOLLOWING_TEXT": "Afficher ensuite le texte suivant",
                "SHOW_TIES": "Afficher les égalités",
                "SHOW_X_AXIS": "Afficher l'axe X",
                "SHOW_Y_AXIS": "Afficher l'axe Y",
                "SMALL_LABELS": "Petites étiquettes",
                "SORT": "Trier",
                "SPLINE": "Cannelure",
                "STACK_CHART": "Graphique empilé",
                "STANDARD_DEVIATION": "Écart-type",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "Faiblesse inférieure à",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "Modifier les textes de seuils",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "Textes de seuils",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "Activer les textes de seuil",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "Force supérieure à",
                "SUM": "Somme",
                "SUMMARY": "Récapitulatif",
                "TABLES": "Tableaux",
                "TABLE_TOTALS": "Totaux du tableau",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Familiarisez-vous avec l'échelle d'évaluation pour interpréter correctement les résultats.",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "Tenez compte de l'échelle",
                "TEXT": "Texte",
                "THINGS_YOU_WILL_SEE_HEADER": "Voici ce que vous verrez :",
                "TOP_BOTTOM_BOX": "Cadre supérieur/Cadre inférieur",
                "TOP_BOX": "Case supérieure",
                "TOTAL": "Total",
                "TOTAL_COUNTS": "Nombre total",
                "TO_DO": "À faire",
                "TRANSPOSE": "Transposer",
                "TRANSPOSE_TABLE": "Transposer le tableau",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Qualité : ces avis seront affichés sous la forme de commentaires libres",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Quantité : ces avis seront numériques et pourront être représentés sous la forme de graphiques, de diagrammes à barres, de tableaux, etc.",
                "TYPES_OF_FEEDBACK_HEADER": "Plusieurs types d'avis",
                "UNDO": "Annuler",
                "USE_COMPARISON": "Utiliser la comparaison",
                "USE_LABELS_FOR_SCALES": "Utiliser des étiquettes pour les échelles",
                "VALUES": "Valeurs",
                "VALUE_RANGES": "Plages de valeurs",
                "VARIANCE": "Écart",
                "VERTICAL": "Verticale",
                "VERTICAL_RANGE": "Plage verticale",
                "WARNING_DATA_OUT_OF_RANGE": "Avertissement : la valeur des données dépasse la configuration de plage",
                "WIDGET_ERROR": {
                    "ERROR": "Une erreur inattendue s'est produite",
                    "MISCONFIGURED": "Ce widget n’est pas configuré correctement. Veuillez vérifier la configuration de votre widget.",
                    "NEW": "Veuillez configurer le widget",
                    "NO_DATA": "Aucune donnée trouvée : vos filtres sont peut-être trop exclusifs !"
                },
                "WIDGET_NAME": {
                    "BAR": "Diagramme à barres",
                    "BREAKDOWNBAR": "Barre de répartition",
                    "DATA_TABLE": "Tableau de données",
                    "FUNNEL_CHART": "Graphique en entonnoir",
                    "GAUGE": "Graphique jauge",
                    "GRID": "Tableau des résultats",
                    "HEATMAP": "Carte thermique",
                    "LINE": "Graphique linéaire",
                    "NEEDS_BASED": "Basé sur les besoins",
                    "PIE": "Diagramme circulaire",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "Estimation du prix (Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "Maximisation du chiffre d'affaires (Gabor-Granger)",
                    "SCORING_OVERVIEW_CHART": "Graphique",
                    "SCORING_OVERVIEW_TABLE": "Tableau",
                    "STATS_TABLE": "Tableau de statistiques",
                    "WORDCLOUD": "Nuage de mots"
                },
                "WORD_ROTATION": "Rotation des mots",
                "WORD_SPACING": "Espacement des mots",
                "YES": "Oui",
                "YOUR_RATINGS": "Vos évaluations"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "Ajouter",
                "ADD_A_WORD": "Ajouter un mot",
                "COLOR": "Couleur",
                "DELETE_ALL": "Supprimer tout",
                "EDIT_STOP_WORDS": "Éditer les mots vides",
                "MAX_WORDS": "Nombre max. de mots",
                "ROTATION_ANGLED": "Angulaire",
                "ROTATION_HORIZONTAL": "Horizontale",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "Horizontal et vertical",
                "WORD_ORIENTATION": "Orientation des mots"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "Couleurs d'arrière-plan",
                "DISPLAY_OPTIONS": "Options d'affichage",
                "INVERT_FONT_COLORS": "Inverser les couleurs du texte à faible contraste",
                "PAGE": "Page",
                "PAGINATE": "Paginer"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "Moyenne",
                "BOTTOM_BOX_METRIC": "Case du bas",
                "COLUMNS": "Colonnes",
                "COUNT_METRIC": "Nombre total de réponses",
                "FIELD_NAME": "Champ",
                "MAX_METRIC": "Maximum",
                "MIN_METRIC": "Minimum",
                "SHOW_RECODES": "Afficher les valeurs recodées",
                "SHOW_ROW_NUMBERS": "Afficher les numéros des colonnes",
                "STD_DEV_METRIC": "Écart-type",
                "TOP_BOX_METRIC": "Case du haut",
                "TRANSPOSE_BREAKOUTS": "Transposer les découpages",
                "TRANSPOSE_TABLE": "Transposer le tableau",
                "VAR_METRIC": "Variance"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "Colonnes supplémentaires",
                "ADD_COLUMNS": "Ajouter des colonnes supplémentaires",
                "ADD_CUSTOM_PALETTE": "Ajouter une palette personnalisée",
                "ALL_CHOICES": "Tous les choix",
                "ALL_GROUPS": "Tous les groupes",
                "ALL_RECODES": "Tous les recodages",
                "AUTOMATIC": "Par défaut",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "Par défaut : cliquer pour modifier",
                "AXIS_VALUES": "Valeurs de l'axe",
                "BREAKOUT_BY": "Découpage par",
                "CANCEL": "Annuler",
                "CATEGORICAL": "Catégorique",
                "CHOICES": "Choix",
                "CHOICE_COUNT": "Nombre de choix",
                "COLOR_PALETTE": "Palette de couleurs",
                "COLUMN_VALUES": "Valeurs de colonne",
                "CONTACT_FIELDS": "Champs de contact",
                "COUNT": "Nombre",
                "CREATE": "Créer",
                "CUSTOM": "Personnalisé",
                "CUSTOM_PALETTE": "Palette personnalisée",
                "DATA_SOURCE": "Source de données",
                "DAY": "Jour",
                "DAY_OF_WEEK": "Jour de la semaine",
                "DECIMAL_PRECISION": "Décimales",
                "DEFAULT": "Par défaut",
                "DISABLED": "Désactivé",
                "DIVERGENT": "Divergent",
                "EDIT_CUSTOM_PALETTE": "Modifier la palette personnalisée",
                "ENABLED": "Activé",
                "ERROR_LOADING_DATA": "Erreur de chargement des données",
                "FILE_SIZE": "Taille",
                "FILE_TYPE": "Type",
                "FRI": "Ven.",
                "FRIDAY": "Vendredi",
                "GROUP_DATE_BY": "Grouper les dates par",
                "HOUR_OF_DAY": "Heure de la journée",
                "LENGEND_VALUES": "Valeurs de la légende",
                "MAX": "Max.",
                "MEAN": "Moyenne",
                "MIN": "Min.",
                "MISCONFIGURED_DATA": "Source de données mal configurée pour cette visualisation.",
                "MISCONFIGURED_FILTERS": "Filtre(s) non valide(s)",
                "MODIFY_CUSTOM_PALETTES": "Modifier les palettes personnalisées",
                "MON": "Lun.",
                "MONDAY": "Lundi",
                "MONTH": "Mois",
                "NONE": "Aucun",
                "NO_FILE_ID_ERROR": "Cette visualisation nécessite de définir une image dans l’enquête",
                "NO_RESULTS_TO_SHOW": "Aucun résultat à afficher",
                "NPS": "Net Promoter Score®",
                "NPS_GROUP": "Groupe NPS®",
                "NUMERIC_VALUE": "Valeur numérique",
                "PALETTE_REMOVED": "Palette supprimée",
                "PERCENTAGE": "Pourcentage",
                "PERCENTAGE_OF_CHOICES": "Pourcentage de choix",
                "PERCENTAGE_OF_RESPONSES": "Pourcentage de réponses",
                "QUARTER": "Trimestre",
                "REMOVE": "Retirer",
                "RESPONSE_COUNT": "Compte de réponses",
                "RESULTS_PER_PAGE": "Nombre de résultats par page",
                "RETRIEVING_DATA_ELLIPSIS": "Récupération des données...",
                "REVERSE_COLORS": "Inverser les couleurs",
                "ROW_VALUES": "Valeurs de ligne",
                "SAT": "Sam.",
                "SATURDAY": "Samedi",
                "SAVE": "Enregistrer",
                "SELECTED_CHOICE": "Choix sélectionné",
                "SELECT_FIELD": "Sélectionnez un champ",
                "SELECT_METRIC": "Statistique",
                "SEQUENTIAL": "Séquentiel",
                "SET_START_COLOR": "Définir la couleur de début",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "Affichage des données relatives aux échantillons...",
                "SUM": "Somme",
                "SUN": "Dim.",
                "SUNDAY": "Dimanche",
                "SURVEY_EMBEDDEDDATA": "Données intégrées",
                "SURVEY_METADATA": "Métadonnées de l'enquête",
                "TEXT_ENTRY": "Saisie de texte",
                "THURS": "Jeu.",
                "THURSDAY": "Jeudi",
                "TITLE": "Titre",
                "TUES": "Mar.",
                "TUESDAY": "Mardi",
                "UNBOUNDED_DOMAIN": "Trop grand nombre de valeurs à afficher.",
                "UNBOUNDED_DOMAIN_HELP": "Pour ajouter ce champ aux Rapports de résultats, vous pouvez ajouter un filtre au rapport afin d’afficher moins de valeurs pour « {{ed_field_name}} » ou mettre à jour le type de variable des données intégrées de « {{ed_field_name}} » dans votre flux d'enquête afin que ce champ adopte le type chaîne ou numérique.",
                "UNDO": "Annuler",
                "USE_CHOICE_TOTALS": "Utiliser les totaux de choix",
                "USE_RESPONDENT_TOTALS": "Utiliser les totaux de répondants",
                "VISUALIZATION": "Visualisation",
                "VISUALIZATION_BARCHART": "Diagramme à barres",
                "VISUALIZATION_BREAKDOWNBAR": "Barre de répartition",
                "VISUALIZATION_GAUGE": "Graphique jauge",
                "VISUALIZATION_HEATMAP": "Carte thermique",
                "VISUALIZATION_LINECHART": "Graphique linéaire",
                "VISUALIZATION_PAGINATEDTABLE": "Tableau de questions",
                "VISUALIZATION_PIE": "Diagramme circulaire",
                "VISUALIZATION_SIMPLETABLE": "Tableau simple",
                "VISUALIZATION_STATSTABLE": "Tableau de statistiques",
                "VISUALIZATION_TEXTHIGHLIGHTS": "Éléments importants du texte",
                "VISUALIZATION_WORDCLOUD": "Nuage de mots",
                "WED": "Mer.",
                "WEDNESDAY": "Mercredi",
                "WEEK": "Semaine",
                "WEIGHTING": "Pondération",
                "WRONG_QUESTION_TYPE_ERROR": "Ce type de visualisation ne peut pas être utilisé pour cette question",
                "YEAR": "Année"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "Moyen",
                "CHOICE_COUNT": "Nombre de choix",
                "COUNT": "Nombre",
                "DISPLAY_OPTIONS": "Options d'affichage",
                "MAX": "Maximum",
                "MIN": "Minimum",
                "NPS": "NPS®",
                "PAGE_OF": "Page : %1 sur %2",
                "PERCENT": "Pourcentage",
                "RESPONSE_COUNT": "Compte de réponses",
                "ROWS_PER_TABLE": "Lignes par tableau",
                "SHOWING_ROWS_OF": "Affichage des lignes %1 à %2 sur %3",
                "SHOW_PERCENTAGES": "Afficher les pourcentages",
                "SHOW_RECODES": "Afficher les valeurs recodées",
                "SHOW_ROW_NUMBERS": "Afficher les numéros des colonnes",
                "SUM": "Somme",
                "TOTAL": "Total",
                "TRANSPOSE": "Transposer",
                "USE_COLUMN_TOTALS": "Utiliser les totaux de colonne",
                "USE_ROW_TOTALS": "Utiliser les totaux de ligne",
                "VALUE": "Valeur"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "Croissant",
                "COUNT": "Nombre",
                "DESCENDING": "Décroissant",
                "DIAGONAL": "Diagonale",
                "DISPLAY_OPTIONS": "Options d'affichage",
                "ERROR_COLON": "Erreur :",
                "ERROR_GENERIC": "Une erreur s'est produite lors du chargement de la visualisation.",
                "HORIZONTAL": "Horizontale",
                "HORIZONTAL_BARS": "Barres horizontales",
                "INCORRECTLY_CONFIGURED": "Choisir une valeur afin d'afficher le tableau",
                "LEGEND_AUTO": "Automatique",
                "LEGEND_BOTTOM": "Bas",
                "LEGEND_INSET": "Encart",
                "LEGEND_RIGHT": "À droite",
                "NORMALIZE_TO_PERCENTAGES": "Normaliser aux pourcentages",
                "SHOW_BAR_LABELS": "Afficher les étiquettes de barres",
                "SHOW_LEGEND": "Afficher la légende",
                "SHOW_X_AXIS": "Afficher l'axe X",
                "SHOW_Y_AXIS": "Afficher l'axe Y",
                "SORT_BAR_VALUES": "Trier valeurs de barres",
                "STACKED_BARS": "Barres en pile",
                "TRANSPOSE": "Transposer",
                "TRUNCATE_LABELS": "Réduire les étiquettes",
                "VERTICAL": "Verticale"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "Toutes les autres",
                "COULD_NOT_LOAD_DATA": "Impossible de charger les données avec la configuration spécifiée – essayez un champ source différent ou une plage de dates plus grande.",
                "GROUPING_PERCENTAGE_THRESHOLD": "Seuil de pourcentage du groupe",
                "NO_DATA": "Aucune donnée",
                "RADIUS": "Rayon intérieur",
                "SHOW_AS_PERCENTAGES": "Afficher sous la forme de pourcentages"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "Clôturer",
                "DOWNLOAD_CSV": "Télécharger un fichier CSV",
                "DOWNLOAD_ZIP": "Télécharger tous les fichiers",
                "NO_DATA": "Aucune donnée",
                "PAGE_OF": "Page : %1 sur %2",
                "RESULTS_PER_PAGE": "Nombre de résultats par page",
                "SHOWING_RECORDS_OF": "Affichage des enregistrements %1 à %2 sur %3",
                "SINGLE_RESPONSE": "Réponse unique",
                "VIEW_RESPONSE": "Afficher la réponse"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "Options d'affichage",
                "ERROR_COLON": "Erreur :",
                "ERROR_GENERIC": "Une erreur s'est produite lors du chargement de la visualisation.",
                "HORIZONTAL_BARS": "Barres horizontales",
                "INCORRECTLY_CONFIGURED": "Choisir une valeur afin d'afficher le tableau",
                "LEGEND_AUTO": "Automatique",
                "LEGEND_BOTTOM": "Bas",
                "LEGEND_INSET": "Encart",
                "LEGEND_RIGHT": "À droite",
                "NORMALIZE_TO_PERCENTAGES": "Normaliser aux pourcentages",
                "SHOW_AREA": "Afficher la zone",
                "SHOW_LEGEND": "Afficher la légende",
                "SHOW_X_AXIS": "Afficher l'axe X",
                "SHOW_Y_AXIS": "Afficher l'axe Y",
                "SMOOTH_LINES": "Lignes nettes",
                "SORT_X_AXIS_LABELS": "Trier les étiquettes de l'axe X",
                "STACKED_BARS": "Barres en pile",
                "TRANSPOSE": "Transposer"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "Mode bloc",
                "BLUR": "Flou",
                "COULD_NOT_LOAD_DATA": "Impossible de charger les données avec la configuration spécifiée – essayez un champ source différent ou une plage de dates plus grande.",
                "FIELD": "Champ",
                "RADIUS": "Rayon",
                "SHOW_REGIONS": "Afficher les régions",
                "SHOW_REGION_LABELS": "Afficher les étiquettes de région"
            },
            "GAUGEWIDGET": {
                "MAX": "Max.",
                "MIN": "Min.",
                "VALUE_RANGES": "Plages de valeurs"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "Étiquettes du bas",
                "CATEGORY_NAME": "Nom de la catégorie",
                "ERROR_COLON": "Erreur :",
                "INCLUDE_HIDDEN_GROUPS": "Inclure les groupes masqués dans les pourcentages",
                "LARGE_LABELS": "Grandes étiquettes",
                "NO": "Non",
                "PERCENT": "Pourcentage",
                "RESPONSE_COUNT": "Compte de réponses",
                "RESPONSE_COUNT_WITH_VALUE": "{{ responseCount }} réponses",
                "SMALL_LABELS": "Petites étiquettes",
                "YES": "Oui"
            }
        });
        $cache.put('ID', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "Kode Akses",
                "ACCESS_CODE_PROTECTION": "Perlindungan Kode Akses",
                "ADD": "Tambahkan",
                "ADD_BREAKOUT": "Tambahkan Pemecahan Laporan",
                "ADD_NOTE": "Tambahkan Catatan",
                "ADD_SCHEDULED_REPORT": "Tambahkan Laporan Terjadwal",
                "ADD_WIDGET": "Tambahkan Visualisasi",
                "ALL_PROJECTS": "Semua Proyek",
                "ALL_QUESTIONS": "Halaman Pertanyaan",
                "ANSWER": "Jawaban",
                "ANY_CHANGES_LOST": "Setiap perubahan yang ditambahkan pada laporan akan hilang jika Anda meninggalkan Platform Qualtrics XM.",
                "APPENDED_COPY_IN_PARENS": "(Salin)",
                "AREA_CHART": "Bagan Area",
                "AREA_CHART_DESC": "Grafik garis dua sumbu dengan area di bawah garis yang sudah diisi.",
                "ATTACHMENT": "Lampiran",
                "BACKUP_CURRENT_REPORT": "Simpan salinan cadangan dari laporan ini sebelum mempengaruhi visualisasi",
                "BACKUP_CURRENT_REPORT_LINE2": "Catatan: Salinan cadangan akan diberi nama \"{{nameOfReportCopy}}\"",
                "BACK_TO_REPORTS": "Kembali ke Laporan",
                "BACK_TO_TOP": "Kembali ke Atas",
                "BACK_TO_VIEW_RESULTS": "Kembali ke hasil tampilan lama",
                "BAR_CHART": "Grafik Bar",
                "BAR_CHART_DESC": "Grafik bar dua sumbu yang memungkinkan konfigurasi tambahan seperti transposisi sumbu dan penataan ulang titik data.",
                "BREAKDOWN_BAR_CHART": "Bar Perincian",
                "BREAKDOWN_BAR_CHART_DESC": "Grafik bar bertumpuk horizontal yang paling umum digunakan untuk menimbang metrik satu sama lain secara visual sebagai alternatif untuk diagram lingkaran.",
                "CANCEL": "Batalkan",
                "CANCEL_CONF_TEXT": "Apakah Anda yakin ingin membatalkan?<br/>Semua perubahan akan hilang.",
                "CANCEL_EDITS": "Batalkan Pengeditan",
                "CHART": "Bagan",
                "CHOICE": "Pilihan",
                "CHOICES_COUNT_METRIC": "Jumlah Pilihan",
                "CHOOSE_PAGES_TO_DISPLAY": "Pilih Halaman untuk Ditampilkan",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "Laporan ini berisi {{maxReportPageCount}} halaman, namun Hasil hanya dapat berisi hingga {{reportSizeLimit}}. Silakan pilih subset dalam cakupan batasan tersebut.",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "Laporan hanya dapat berisi hingga {{reportSizeLimit}} halaman, silakan pilih halaman yang Anda inginkan.",
                "CLEAR_ALL": "Bersihkan Semua",
                "CLOSE": "Tutup",
                "CLOUD": "PENJELASAN TENTANG CLOUD",
                "COLLABORATED_NEW": "Pemilik survei ini menggunakan Platform Qualtrics XM! Laporan untuk survei ini akan diedit menggunakan Hasil Baru.",
                "COMMA_SEPARATED_LIST": "Daftar yang Dipisah dengan Tanda Koma",
                "COMPACTNESS": "Font dan Spasi",
                "COMPACTNESS_INFO": "Pengaturan ini mempengaruhi padding tabel, ukuran font, dan ukuran bar pada grafik. Tindakan ini juga akan diterapkan pada sebagian besar ekspor.",
                "CONFIRM": "Oke",
                "CONFIRM_DELETE": "Konfirmasi Penghapusan",
                "CONFIRM_DELETE_PAGE": "Apakah Anda yakin ingin menghapus halaman ini?",
                "CONTINUE": "Lanjutkan",
                "CONTINUE_EDITING": "Lanjutkan Pengeditan",
                "COPY": "Salin",
                "COPY_OF_REPORT_NAME": "Salinan dari {{nameOfCurrentReport}}",
                "COPY_REPORT": "Salin Laporan",
                "COPY_REPORT_ELLIPSIS": "Salin Laporan...",
                "COPY_TO_NEW_REPORT": "Salin ke Laporan Baru...",
                "CREATE": "Buat",
                "CREATED": "Dibuat",
                "CREATE_CUSTOM_PAGE": "Buat Halaman Kustom",
                "CREATE_NEW_REPORT": "Buat Laporan Baru",
                "CREATE_NEW_REPORT_ELLIPSIS": "Buat Laporan Baru...",
                "CSV_FILE": "File CSV",
                "CUSTOM_PAGES": "Halaman Kustom",
                "DATE": "Tanggal",
                "DEFAULT_PALETTE": "Palet Warna Default",
                "DEFAULT_REPORT": "Laporan Default",
                "DEFAULT_VISUALIZATIONS": "Visualisasi Default",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "Ini adalah jenis visualisasi default yang digunakan untuk membuat laporan hasil default. Memperbarui dan menerapkan pengaturan ini akan membangun kembali laporan Anda saat ini dengan pengaturan default yang baru. Anda akan memiliki opsi untuk membuat cadangan laporan terbaru Anda.",
                "DEFAULT_VISUALIZATIONS_NOTE": "Catatan: Tidak semua tipe visualisasi tersedia untuk semua tipe pertanyaan. Beberapa visualisasi non-standar dapat diganti secara otomatis.",
                "DEFAULT_VISUALS_DISCLAIMER": "Qualtrics akan memperbarui laporan ini dengan pengaturan visualisasi default yang baru.",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "Pembaruan ini akan mempengaruhi visualisasi {{amountOfWidgetsAffected}} dalam laporan ini.",
                "DEFAULT_VISUAL_EDIT_DETECTED": "Edit Visualisasi Standar Terdeteksi",
                "DELETE_BUTTON": "Hapus",
                "DELETE_DISABLED_EXPLANATION": "Menghapus laporan yang dibuat di antarmuka pelaporan sebelumnya tidak diperbolehkan hingga organisasi Anda selesai melakukan migrasi penuh ke Platform Qualtrics XM.",
                "DELETE_PAGE": "Hapus Halaman",
                "DELETE_PAGE_ELLIPSIS": "Hapus Halaman...",
                "DELETE_REPORT": "Hapus Laporan",
                "DELETE_REPORT_ELLIPSIS": "Hapus Laporan...",
                "DELETE_WIDGET_QUESTION": "Hapus?",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "Bidang ini dienkripsi dan tidak dapat digunakan untuk penyortiran.",
                "DISCARD_EDITS": "Buang Pengeditan",
                "DISTRIBUTION_PAUSED": "Distribusi laporan dijeda.",
                "DONE_BUTTON": "Selesai",
                "DONE_EDITING": "Selesai Mengedit",
                "DOWNLOAD": "Unduh",
                "DOWNLOAD_AS_CSV": "Unduh sebagai CSV",
                "DOWNLOAD_AS_PDF": "Unduh sebagai PDF",
                "DOWNLOAD_FAILED": "Gagal mengunduh",
                "DOWNLOAD_PREVIOUS_EXPORTS": "Mengunduh Ekspor Sebelumnya...",
                "DO_YOU_WISH_TO_DELETE": "Apakah Anda ingin menghapus:",
                "DUPLICATE_PAGE": "Duplikatkan Lembaran",
                "EDIT_REPORT": "Edit Laporan",
                "EDIT_REPORT_ELLIPSIS": "Edit Laporan...",
                "EDIT_VISUALIZATION": "Edit Visualisasi",
                "EMAIL_ADDRESS": "Alamat Email",
                "EMAIL_SENT": "Email terkirim...",
                "END_OF_REPORT": "Akhir dari Laporan",
                "ENTER_NAME": "Masukkan Nama",
                "ERROR_COPYING": "Terjadi kesalahan saat menyalin laporan.",
                "ERROR_DELETING": "Terjadi kesalahan saat menghapus laporan.",
                "ERROR_DELETING_EXPORT": "Terjadi kesalahan saat menghapus ekspor.",
                "ERROR_HEADING": "Kesalahan",
                "ERROR_PUBLISHING": "Terjadi kesalahan saat menyimpan pengaturan.",
                "ERROR_RENAMING": "Terjadi kesalahan saat mengganti nama laporan.",
                "ERROR_REQUESTING_EXPORT": "Terjadi kesalahan saat meminta ekspor.",
                "ERROR_SAVING_GLOBAL_OPTIONS": "Terjadi kesalahan saat menyimpan pilihan visualisasi global.",
                "ERROR_SEND_TEST_EMAIL": "Terjadi kesalahan saat mengirim email pengujian.",
                "EVERY_FRIDAY": "Setiap Jumat",
                "EVERY_MONDAY": "Setiap Senin",
                "EVERY_MONTH": "Setiap Bulan pada",
                "EVERY_SATURDAY": "Setiap Sabtu",
                "EVERY_SUNDAY": "Setiap Minggu",
                "EVERY_THURSDAY": "Setiap Kamis",
                "EVERY_TUESDAY": "Setiap Selasa",
                "EVERY_WEDNESDAY": "Setiap Rabu",
                "EVERY_WEEK": "Mingguan setiap",
                "EXAMPLE_GROUP_NUM": "Grup {{num}}",
                "EXAMPLE_SERIES_NUM": "Rangkaian {{num}}",
                "EXPORT": "Ekspor",
                "EXPORT_CSV": "CSV (Dipisahkan Koma)",
                "EXPORT_EXCEL_SPREADSHEET": "Spreadsheet Excel",
                "EXPORT_IMAGE": "Ekspor Gambar",
                "EXPORT_PAGES": "Ekspor Halaman",
                "EXPORT_PDF": "Dokumen PDF",
                "EXPORT_PPT_SLIDES": "Slide PowerPoint",
                "EXPORT_RAW_DATA": "Ekspor Data Mentah",
                "EXPORT_REPORT": "Ekspor Laporan",
                "EXPORT_VISUALIZATION": "Ekspor Visualisasi",
                "EXPORT_WORD_DOC": "Dokumen Word",
                "FAILED_SAVE_TXT": "Gagal menyimpan",
                "FILTERED": "Difilter",
                "FIRST_PAGE": "Halaman Pertama",
                "FIRST_WEEKDAY": "Hari Kerja Pertama di setiap Bulan",
                "FROM": "Dari",
                "FROM_EMAIL": "Pengirim Email",
                "FROM_NAME": "Nama Pengirim",
                "GAUGE_CHART": "Grafik Gauge",
                "GAUGE_CHART_DESC": "Bagan yang menyerupai alat ukur gauge untuk membandingkan nilai saat ini dengan suatu tujuan atau rangkaian ambang batas.",
                "GENERATING_FILE": "Membuat file...",
                "GENERATING_IMAGE": "Membuat Gambar...",
                "GENERATING_PDF": "Membuat PDF...",
                "GENERIC_ERROR": "Terjadi kesalahan yang mencegah kami untuk memuat proyek yang Anda minta.",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "Opsi Global...",
                "GLOBAL_METRIC": "Metrik Standar",
                "GLOBAL_MODAL_PAGE_TITLE": "Visualisasi contoh menggunakan opsi global untuk bagian Hasil dari Qualtrics Research Suite",
                "GLOBAL_MODAL_WIDGET_TITLE": "Judul Visualisasi",
                "GLOBAL_OPTIONS": "Opsi Global",
                "GLOBAL_PRECISION": "Tempat Desimal Default",
                "GLOBAL_SETTINGS_APPLY": "Terapkan pengaturan standar saya",
                "GLOBAL_SETTINGS_SAVE": "Simpan sebagai pengaturan standar saya",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "Terapkan default Qualtrics",
                "GROUP": "Grup",
                "HEAT_MAP_CHART": "Bagan Peta Panas",
                "HEAT_MAP_CHART_DESC": "Visualisasi gaya \"panas\" diklasterkan yang digunakan untuk memetakan distribusi masukan pengguna (seperti klik) ke gambar asli.",
                "HIDDEN": "Tersembunyi",
                "HIDDEN_PAGE": "Halaman ini tidak akan muncul dalam laporan publik dan tidak akan dipilih secara default dalam ekspor laporan.",
                "HIDE": "Sembunyikan",
                "HIDE_ALL_PAGES": "Sembunyikan Semua Halaman",
                "HIDE_PAGE": "Sembunyikan Halaman",
                "IMAGE_FILE": "File Gambar",
                "INVALID_BRAND_DOMAIN": "Domain yang Anda masukkan tidak ada di dalam daftar merek Anda dari domain email yang disetujui. Silakan hubungi admin merek Anda untuk memperbaikinya.",
                "INVALID_SPF_RECORD": "Domain yang Anda masukkan belum menyetujui kiriman dari Qualtrics. Hal ini akan mempengaruhi proses pengiriman. Mohon gunakan domain lain atau hubungi Qualtrics untuk menyelesaikan masalah ini.",
                "ISSUE_SAVING_REPORTS": "Satu atau beberapa laporan mengalami masalah saat akan disimpan. Silakan coba lagi.",
                "ISSUE_SENDING_TEST": "Terjadi kesalahan saat mengirim email pengujian. Silakan coba lagi.",
                "LARGE_SURVEY": "Hasil tidak akan ditampilkan dikarenakan ukuran survei yang terlalu besar.",
                "LAST_DAY": "Hari Terakhir Bulan",
                "LAST_MODIFIED_COLON_WITH_DATE": "Terakhir diubah: %1",
                "LAST_PAGE": "Halaman Terakhir",
                "LAST_WEEKDAY": "Hari Kerja Terakhir di setiap Bulan",
                "LATER": "Nanti",
                "LEARN_MORE": "Pelajari Selengkapnya",
                "LINE_CHART": "Grafik Garis",
                "LINE_CHART_DESC": "Grafik garis dua sumbu yang biasa digunakan saat membuat grafik terhadap waktu pada sumbu x.",
                "LOG_OUT_WARNING": "Klik di mana saja dalam hitungan {{countdown}} detik untuk tetap masuk",
                "MESSAGE": "Pesan",
                "MONTHLY": "Bulanan",
                "MOVE_DOWN": "Pindahkan Visualisasi ke Bawah",
                "MOVE_PAGE_TO_BOTTOM": "Pindah ke Bawah",
                "MOVE_PAGE_TO_TOP": "Pindah ke Atas",
                "MOVE_UP": "Pindahkan Visualisasi ke Atas",
                "MY_SURVEYS": "Proyek Saya",
                "NAME": "Nama",
                "NEW_CUSTOM_PAGE_NAME": "Halaman Kustom Baru",
                "NEW_REPORT": "Laporan Baru",
                "NEXT_PAGE": "Halaman Berikutnya",
                "NEXT_RUN": "Proses Selanjutnya",
                "NO_EXPORTS": "Belum ada ekspor yang diminta untuk laporan ini.",
                "NO_ITEMS_TO_DISPLAY": "Tidak ada item untuk ditampilkan",
                "NO_MATCHING_CUSTOM_PAGES": "Tidak ada halaman kustom yang cocok",
                "NO_MATCHING_PAGES": "Tidak ada halaman yang ditemukan untuk pencarian",
                "NO_MATCHING_REPORTS": "Tidak ada laporan yang cocok.",
                "NO_PROJECT": "Mohon tentukan proyek untuk melanjutkan.",
                "NO_PROJECTS_TO_MIGRATE": "Tidak ada proyek untuk diperbarui.",
                "NO_QUESTIONS": "Tidak ada pertanyaan yang cocok",
                "NO_RESULTS_YET": "Belum ada hasil yang dapat ditampilkan. Silakan distribusikan survei Anda untuk mengumpulkan respons.",
                "OFF": "Nonaktif",
                "ON": "Aktif",
                "PAGES_SELECTED": "Halaman Dipilih",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "Pilihan ini akan membuat laporan berisi {{currentSelectedPageCount}} halaman yang melebihi jumlah maksimum {{reportSizeLimit}} yang diperbolehkan. Silakan pilih rentang yang lebih kecil.",
                "PAGES_SELECTION_INVALID_RANGE": "Silakan pilih rentang yang valid.",
                "PAGE_OPTIONS": "Opsi Halaman",
                "PDF_ROW_TRUNCATION_MESSAGE": "Terlalu banyak baris untuk ekspor PDF, coba ekspor ke Word atau CSV",
                "PERCENTAGE_METRIC": "Persentase",
                "PIE_CHART": "Diagram Lingkaran",
                "PIE_CHART_DESC": "Perincian melingkar suatu nilai untuk titik data tertentu. Berguna untuk mengukur proporsi relatif dari nilai yang dipilih.",
                "PREVIEW": "Pratinjau",
                "PREVIOUS_PAGE": "Halaman Sebelumnya",
                "PRINT_PAGE": "Cetak Halaman",
                "PUBLIC_LINK": "Tautan Publik",
                "PUBLIC_REPORT_AVAILABLE": "Laporan Publik Tersedia",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "Kode Akses",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "Kode Akses Salah. Silakan coba lagi.",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "Ajukan",
                "PUBLIC_RESULTS_LOGIN_TITLE": "Masuk Laporan Publik | Perangkat Lunak Survei Qualtrics",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "Laporan publik tidak ditemukan. Silakan hubungi pemilik laporan ini dan minta mereka untuk memberikan tautan yang valid.",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "Laporan Publik Tidak Ditemukan",
                "PUBLIC_RESULTS_NOT_UPDATED": "Tautan laporan publik dan email laporan terjadwal tidak akan menggunakan Platform Qualtrics XM hingga Anda memperbaruinya.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "Sesi Berakhir. Mohon masuk kembali untuk melanjutkan melihat pratinjau Laporan Hasil Publik.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "Sesi Berakhir",
                "PUBLIC_RESULTS_TITLE": "Laporan Publik",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "Anda tidak diizinkan untuk melihat halaman ini. Silakan hubungi pemilik laporan ini dan minta mereka untuk membuat halamannya menjadi publik.",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "Laporan Publik Tidak Diizinkan",
                "PUBLISHED_LINK_GENERATING_LINK": "Membuat Tautan...",
                "PUBLISHED_REPORT_FOUND_HERE": "Siapa saja dapat melihat laporan ini di tautan berikut:",
                "PUBLISH_REPORT": "Kelola Laporan Publik",
                "PUBLISH_REPORT_ELLIPSIS": "Kelola Laporan Publik...",
                "QUESTION": "Pertanyaan",
                "RANK": "Peringkat",
                "REMOVE_WIDGET": "Hapus Visualisasi",
                "RENAME_PAGE": "Ganti Nama Halaman",
                "RENAME_REPORT": "Ganti Nama Laporan",
                "RENAME_REPORT_ELLIPSIS": "Ganti Nama Laporan...",
                "REPLY_TO_EMAIL": "Balas Email ke",
                "REPORT_COLON": "Laporan:",
                "REPORT_SETTINGS": "Pengaturan Laporan",
                "REPORT_SETTINGS_ELLIPSIS": "Pengaturan Laporan...",
                "RESPONSE_COUNTS": "Jumlah Respons",
                "RESULTS_DASHBOARDS_BANNER": "dan coba versi hasil survei yang baru dan ditingkatkan, dengan fitur UI dan visualisasi data yang modern dan dapat diakses, fitur analisis dan eksplorasi baru, dan masih banyak lagi.",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "Catatan Rilis",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "Lihat yang terakhir",
                "RESULTS_OPTIONS": "Opsi Laporan",
                "RESULTS_TITLE": "Laporan",
                "RESUME_DISTRIBUTION": "Lanjutkan Distribusi",
                "REVERT": "Kembali",
                "RICH_TEXT_LIMIT_REACHED": "Panjang konten telah mencapai batas!",
                "SAVE": "Simpan",
                "SAVE_AND_CLOSE": "Simpan dan Tutup",
                "SAVE_AS_CSV": "Simpan Visualisasi sebagai CSV",
                "SAVE_AS_IMAGE": "Simpan Visualisasi sebagai Gambar",
                "SAVE_CONFIRMATION": "Simpan Konfirmasi",
                "SAVE_PAGE_AS_ELLIPSIS": "Ekspor Halaman Sebagai...",
                "SAVE_SETTINGS": "Simpan Pengaturan",
                "SCHEDULE_REPORT_EMAIL": "Jadwalkan Email Laporan",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "Jadwalkan Email Laporan...",
                "SEARCH_ELLIPSIS": "Pencarian...",
                "SEARCH_PAGES": "Cari Pertanyaan",
                "SEARCH_PAGES_ELLIPSIS": "Cari Halaman...",
                "SEARCH_REPORTS_ELLIPSIS": "Cari Laporan...",
                "SELECTED": "Dipilih:",
                "SELECT_ALL": "Pilih Semua",
                "SELECT_A_FIELD": "Pilih bidang",
                "SELECT_A_WIDGET": "Pilih visualisasi",
                "SELECT_PAGES": "Pilih Halaman",
                "SELECT_PAGES_ELLIPSIS": "Pilih Halaman...",
                "SEND": "Kirim",
                "SEND_TEST_EMAIL": "Kirim Email Uji",
                "SETTING_DEFAULT": "Standar",
                "SETTING_HIGH": "Tinggi",
                "SETTING_LARGE": "Besar",
                "SETTING_LOW": "Rendah",
                "SETTING_NORMAL": "Normal",
                "SETTING_SMALL": "Kecil",
                "SHARE_REPORT": "Bagikan Laporan",
                "SHOW_ALL_PAGES": "Tampilkan Semua Halaman",
                "SHOW_FULL_QTEXT": "Tampilkan teks pertanyaan lengkap di judul halaman",
                "SIMPLE_TABLE": "Tabel Sederhana",
                "SIMPLE_TABLE_DESC": "Tabel fleksibel yang dapat menampilkan beberapa nilai sebagai baris atau kolom.",
                "SIZE": "Ukuran",
                "SPLINE_CHART": "Bagan Spline",
                "SPLINE_CHART_DESC": "Grafik garis bulat dua sumbu yang biasa digunakan saat membuat grafik terhadap waktu pada sumbu x.",
                "STATISTICS_TABLE": "Tabel Statistik",
                "SUBJECT": "Subjek",
                "SURVEY_ANALYSIS": "Analisis Survei",
                "SURVEY_SUMMARY": "Ringkasan Survei",
                "TABLE": "PENJELASAN TENTANG TABEL",
                "TIME": "Waktu",
                "TO": "Kepada",
                "TOTAL": "Total",
                "TRANSPOSE_STATS_TABLES": "Ubah Urutan Tabel Statistik",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "Ubah Urutan Pemecahan Tabel Statistik",
                "TRUNCATE_PAGE_TITLES": "Persingkat teks pertanyaan di judul halaman",
                "TRY_IT_NOW": "Coba sekarang",
                "TYPE": "Tipe",
                "UNABLE_TO_CHECK_SPF": "Tidak dapat mengecek riwayat SPF. Silakan coba lagi.",
                "UNAUTHORIZED": "Anda tidak diizinkan untuk melihat laporan ini. Silakan hubungi pemiliknya untuk mendapatkan akses.",
                "UNHIDE_PAGE": "Perlihatkan Halaman",
                "UPDATE": "Perbarui",
                "UPDATED_SUCCESSFULLY": "Pengaturan berhasil diperbarui.",
                "UPDATE_ALL_IN_THIS_PROJECT": "Perbarui Semua yang ada dalam Proyek ini",
                "UPDATE_ALL_PROJECTS": "Perbarui Semua Proyek",
                "UPDATE_NOW": "Perbarui Sekarang",
                "UPDATE_REPORTS": "Perbarui Laporan...",
                "UPDATE_REPORT_ELEMENTS": "Perbarui Tautan Laporan Publik dan Jadwalkan Email Laporan",
                "UPGRADE_MY_ACCOUNT": "Tingkatkan Akun Saya",
                "USE_EXPORT_TAGS": "Sertakan nomor pertanyaan",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "Gunakan Total Kolom Tabel Sederhana",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "Gunakan Jumlah Responden Tabel Sederhana",
                "USE_WEIGHTED_METRICS": "Gunakan metrik tertimbang",
                "VIEW": "Lihat",
                "WEEKLY": "Mingguan",
                "WELCOME_TO_NEW_RESULTS": "Selamat datang di Pelaporan Platform Qualtrics XM!",
                "WHEN": "Saat",
                "WIDGET_LOADING": "Memuat...",
                "WIDGET_OPTIONS_ERR": "Gagal memuat opsi visualisasi",
                "WIDGET_TYPE": "Visualisasi",
                "WORD_CLOUD": "Word Cloud",
                "WORD_CLOUD_DESC": "Visualisasi tertimbang frekuensi kata dalam data teks dengan opsi pengkodean warna tambahan."
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Ingat, terdapat sumber daya di organisasi Anda seperti Mitra SDM, manajer Anda, dan/atau mentor untuk membantu menafsirkan umpan balik Anda.",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Siapkan segelas kopi dan mulailah membaca umpan balik Anda.",
                "ABOUT_YOUR_REPORT_HEADER": "Tentang laporan Anda",
                "ABOUT_YOUR_REPORT_LINE1": "Selamat datang di laporan umpan balik 360 Anda. Ini merupakan peluang besar untuk tumbuh dan mengembangkan diri Anda sebagai seorang profesional. Demi keberhasilan saat memeriksa hasil, luangkan waktu yang cukup untuk memeriksa umpan balik. Umpan balik mungkin sulit diterima pada awalnya, namun ingatlah bahwa tujuan dari umpan balik ini adalah untuk mempercepat pertumbuhan dan pengembangan Anda.",
                "ABOUT_YOUR_REPORT_LINE2": "Saat memeriksa laporan, berikut adalah beberapa hal yang harus Anda ingat.",
                "ADD_CONDITIONAL_TEXT": "Tambahkan teks bersyarat",
                "ADD_CUSTOM_PALETTE": "Tambahkan Palet Kustom",
                "ADD_DATA_SOURCE": "Tambahkan sumber data",
                "ADD_FOLLOWING": "Tambahkan hal berikut",
                "ADD_LABEL": "Tambahkan label",
                "ADVANCED_FILTER": "Filter Tingkat Lanjut",
                "AGREEMENT_CHART": "Bagan kesepakatan",
                "AGREEMENT_CHART_FOOTER": "Bagan kesepakatan menunjukkan kesamaan nilai. Setiap titik melambangkan bagaimana individu memberikan nilai kepada Anda untuk setiap item. Ukuran titik menunjukkan berapa banyak penilai yang memberikan nilai tertentu kepada Anda.",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "respons",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "respons",
                "AGREEMENT_CHART_LEGEND_TITLE": "Bagaimana orang lain menilai Anda",
                "ALL": "Semua",
                "AND_IF": "Dan jika",
                "ANGLED": "Miring",
                "AREA": "Area",
                "AUTO": "Otomatis",
                "AVERAGE": "Rata-rata",
                "AXIS_VALUES": "Nilai Sumbu",
                "BAR": "Bar",
                "BASE_WORD_COLOR": "Warna Kata Dasar",
                "BLUR": "Buram",
                "BOTTOM_BOX": "Kotak Bawah",
                "BREAKOUT_HEADERS": "Header Pemecahan",
                "CANCEL": "Batalkan",
                "CATEGORICAL": "Kategoris",
                "CATEGORY": "Kategori",
                "CATEGORY_NAME": "Nama Kategori",
                "CHANGE_CATEGORIES_ORDER": "Ubah urutan kategori",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "Ubah urutan kategori pemberian nilai",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "Ubah urutan yang muncul dalam visualisasi dengan mengeklik di sebelah kiri elemen kategori pemberian nilai dan menyeretnya ke posisi yang diinginkan.",
                "CHANGE_QUESTIONS_ORDER": "Ubah urutan pertanyaan",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "Ubah urutan pertanyaan",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "Ubah urutan yang muncul dalam visualisasi dengan mengeklik di sebelah kiri elemen pertanyaan dan menyeretnya ke posisi yang diinginkan.",
                "CHARTS": "Grafik",
                "CHART_TYPE": "Tipe Grafik",
                "CHOICE_COUNT": "Jumlah Pilihan",
                "CHOICE_TOTALS": "Total Pilihan",
                "CLEAR": "Bersihkan",
                "CLOSE": "Tutup",
                "COLOR_PALETTE": "Palet Warna",
                "COLUMN_NAMES": "Nama Kolom",
                "COLUMN_TOTALS": "Total Kolom",
                "COMPARED_FILTER_GROUP": "Grup Filter yang Dibandingkan",
                "COMPARED_FILTER_GROUPS": "Grup Filter yang Dibandingkan",
                "COMPARE_WITH": "bandingkan dengan",
                "COMPETITION_RANKING": "Gunakan peringkat kompetisi",
                "COMPETITION_RANKING_TOOLTIP": "Jika seri, semua nilai yang sama diberi peringkat sama. Namun, Item berikutnya akan diberi peringkat sama dengan: jumlah total Item yang berperingkat lebih tinggi dalam tabel, ditambah satu.",
                "COMPLETED_RESPONSES": "Respons yang lengkap",
                "CONDITIONAL_TEXT": "Teks bersyarat",
                "COUNT": "Jumlah",
                "CREATE": "Buat",
                "CUSTOM_PALETTE": "Palet Kustom",
                "DATA_SOURCE_TYPE": "Tipe Sumber Data",
                "DATA_SOURCE_TYPE_CATEGORY": "Kategori Pemberian Nilai",
                "DATA_SOURCE_TYPE_QUESTION": "Pertanyaan",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "Pertanyaan",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "Item Berperingkat",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "Kategori Pemberian Nilai",
                "DEFAULT": "Default",
                "DEFAULT_TEXT": "Teks standar",
                "DELETE": "Hapus",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "Mengetahui dari siapa umpan balik Anda berasal, baik dari rekan, bawahan langsung, pimpinan, dsb.",
                "DIFFERENT_EVALUATORS_HEADER": "Evaluator yang berbeda",
                "DIRECT_REPORTS": "Bawahan langsung",
                "DISABLED": "Dinonaktifkan",
                "DISPLAY_OPTIONS": "Opsi Tampilan",
                "DISPLAY_THRESHOLD_TEXTS": "Tampilkan teks berdasarkan perbedaan grup berikut",
                "DIVERGENT": "Divergen",
                "DONE": "Selesai",
                "DONT_HEADER": "Hal yang Tidak Boleh Anda Lakukan:",
                "DONT_LINE1": "Mencoba mencari tahu siapa yang mengatakan apa",
                "DONT_LINE2": "Berfokus pada satu nilai/komentar yang positif atau negatif",
                "DONT_LINE3": "Membuat rencana pengembangan seputar setiap item",
                "DONT_LINE4": "Berkecil hati bahwa Anda memiliki peluang untuk perbaikan",
                "DONUT": "Donat",
                "DOWNLOAD_CSV": "Unduh CSV Warisan",
                "DOWNLOAD_ZIP": "Unduh semua file",
                "DO_HEADER": "Hal yang Boleh Anda Lakukan:",
                "DO_LINE1": "Melihat umpan balik secara menyeluruh",
                "DO_LINE2": "Mengidentifikasi tema dalam kelebihan dan peluang untuk perbaikan",
                "DO_LINE3": "Memprioritaskan beberapa area fokus untuk ditambahkan ke rencana pengembangan Anda",
                "DO_LINE4": "Memahami bahwa setiap orang memiliki peluang untuk perbaikan",
                "DROPOFF": "Pengurangan",
                "DUPLICATE": "Duplikat",
                "EDIT_CONDITIONAL_TEXT": "Edit teks bersyarat",
                "EDIT_CUSTOM_PALETTE": "Edit Palet Kustom",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "Atau tunjukkan teks berikut",
                "ENABLED": "Diaktifkan",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "Aktifkan urutan berdasarkan logika tampilan kategori penilai",
                "ENABLE_ORDERING_FOR": "Aktifkan pengurutan untuk",
                "EQUAL_TO": "Sama dengan",
                "FIELD": "Bidang",
                "FILTER_NAMES": "Nama Filter",
                "FOLLOWING_PARENTHESES": "(mengikuti)",
                "FOOTER": "Footer",
                "GAP": "Perbedaan",
                "GAP_CHART": "Bagan perbedaan",
                "GAP_CHART_DESCRIPTION": "Bagan perbedaan menampilkan selisih nilai antara dua grup penilai. Misalnya, dalam hal pemberian nilai mandiri vs. bagaimana orang lain menilai Anda, selisih positif (+) berarti orang lain memberi Anda nilai yang lebih tinggi dari nilai yang Anda berikan untuk diri Anda sendiri. Selisih negatif (-) berarti orang lain memberikan nilai yang lebih rendah dari yang Anda berikan untuk diri Anda sendiri.",
                "GAP_CHART_FOOTER": "Bagan perbedaan menunjukkan selisih +/- antara dua grup penilai.",
                "GAP_TABLE_DESCRIPTION": "Kelebihan tersembunyi menunjukkan bahwa orang lain memberikan nilai yang lebih tinggi dari yang Anda nilai sendiri. Area untuk perbaikan menunjukkan bahwa orang lain memberikan nilai yang lebih rendah dari yang Anda nilai sendiri. Kedua bagian diurutkan dari perbedaan terbesar hingga perbedaan terkecil.",
                "GAP_TABLE_FOOTER": "Kolom pertama dari nilai menunjukkan bagaimana Anda menilai diri Anda sendiri. Kolom kedua menunjukkan rata-rata nilai orang lain. Kolom ketiga menunjukkan selisih antara bagaimana Anda menilai diri Anda sendiri dan bagaimana orang lain menilai Anda.",
                "GAP_TABLE_TITLE": "Kelebihan tersembunyi/Area perbaikan",
                "GREATER_OR_EQUAL": "Lebih dari atau sama dengan",
                "GREATER_THAN": "Lebih dari",
                "GROUP": "Grup",
                "GROUPED_FOR_ANONYMITY": "Dikelompokkan untuk Anonimitas",
                "HEADER_NAMES": "Nama Header",
                "HIGHEST_SCORES": "Nilai tertinggi",
                "HIGHLIGHT_THRESHOLD": "Ambang untuk menyoroti perbedaan",
                "HIGHLOW_TABLE": "Nilai tinggi dan rendah",
                "HIGHLOW_TABLE_FOOTER": "Bagian ini menampilkan lima perilaku dengan nilai tertinggi dan terendah (di seluruh perilaku) dari rata-rata kategori penilai yang berlaku. Untuk mendapatkan hasil yang maksimal dari halaman ini, mencari tren yang mungkin muncul akan sangat membantu. Misalnya, apabila mayoritas perilaku nilai terendah dipusatkan di satu atau dua kategori; area inilah yang mungkin perlu pengembangan. Perilaku dengan nilai tertinggi dapat mengidentifikasi kelebihan yang dapat dimanfaatkan di area lainnya.",
                "HIGH_LOW_TABLE_DESCRIPTION": "Bagan tinggi/rendah menampilkan item yang didasarkan pada area di mana orang lain memberikan nilai tertinggi dan terendah kepada Anda.",
                "HORIZONTAL": "Horizontal",
                "HORIZONTAL_AND_VERTICAL": "Horizontal & Vertikal",
                "HORIZONTAL_BAR": "Bar Horizontal",
                "HOW_TO_INTERPRET_RESULT_HEADER": "Cara menafsirkan hasil dan menentukan tindakan:",
                "IF": "Jika",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "Sertakan label tersembunyi dalam persen",
                "INNER_RIM": "Pinggiran Bagian Dalam",
                "IS": "Yaitu",
                "IS_NOT": "Tidak",
                "IS_SAME_AS_SUBJECT": "Sama seperti subjek",
                "ITEM": "Item",
                "LABEL": "label",
                "LABELS": "Label",
                "LARGE_LABELS": "Label Besar",
                "LEGEND": "Legenda",
                "LEGEND_POSITION": "Posisi Tulisan",
                "LEGEND_VALUES": "Nilai Tulisan",
                "LESS_OR_EQUAL": "Kurang dari atau sama dengan",
                "LESS_THAN": "Kurang dari",
                "LINE": "Baris",
                "LOWEST_SCORES": "Nilai terendah",
                "MANAGERS": "Manajer",
                "MANUAL_FONT_SIZE": "Atur ukuran font secara manual",
                "MAX": "Maks",
                "MEAN": "Rata-rata",
                "MEDIAN": "Median",
                "METRIC_TYPE": "Tipe metrik",
                "MIN": "Min",
                "MODIFY_CUSTOM_PALETTES": "Modifikasi Palet Kustom",
                "MOVE_DOWN": "Turunkan",
                "MOVE_UP": "Naikkan",
                "MULTI_SELECT_ITEMS_SELECTED": "dipilih",
                "NEGATIVE_GAPS": "Area untuk perbaikan",
                "NO": "Tidak",
                "NONE": "Tidak Ada",
                "NOT_APPLICABLE": "Tidak Ada",
                "NOT_EQUAL_TO": "Tidak sama dengan",
                "NO_DATA_AVAILABLE_WARNING": "Data tidak tersedia",
                "NO_FILTER": "Tanpa filter",
                "NO_FILTER_IS_APPLIED": "Tidak ada filter yang diterapkan.",
                "NO_VALUE": "Tidak ada nilai",
                "NPS": "Nilai Promotor Bersih",
                "NUMBER": "angka",
                "NUMBERS": "Angka",
                "NUMBER_OF_GAPS_NEGATIVE": "Jumlah Perbedaan Negatif",
                "NUMBER_OF_GAPS_POSITIVE": "Jumlah Perbedaan Positif",
                "NUMBER_OF_ROWS_HIGH": "Jumlah Baris Tinggi",
                "NUMBER_OF_ROWS_LOW": "Jumlah Baris Rendah",
                "OPTIONS": {
                    "HEADER_NAME": "Nama header",
                    "LEGEND": "Legenda",
                    "SCALE_AXIS_CHANGER_TITLE": "Rentang"
                },
                "ORIENTATION": "Orientasi",
                "OR_IF": "Atau jika",
                "OTHER": "Lainnya",
                "OTHERS": "Lainnya",
                "PAGE_OF": "Halaman: %1 Dari %2",
                "PALETTE_REMOVED": "Palet Dihapus",
                "PEERS": "Sejawat",
                "PERCENT": "Persen",
                "PERCENTAGE": "Persentase",
                "PERCENTAGE_OF_CHOICES": "Persentase Pilihan",
                "PERCENTAGE_OF_RESPONSES": "Persentase Respons",
                "PERCENT_COMPLETE": "% selesai",
                "PERSON_METADATA": "Metadata individu",
                "PERSON_METADATA_EVALUATOR": "Penilai",
                "PERSON_METADATA_SUBJECT": "Subjek",
                "PERSON_METADATA_VIEWER": "Pemirsa",
                "POSITIVE_GAPS": "Kelebihan tersembunyi",
                "PRIMARY_PARENTHESES": "(utama)",
                "QUESTIONS": "Pertanyaan",
                "RADIUS": "Radius",
                "RANK": "Peringkat",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "Nilai tertinggi",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "Nilai tertinggi",
                "RANKABLE_ITEMS_ITEM_HAS": "Item memiliki",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "Item berada di atas",
                "RANKABLE_ITEMS_LOWEST_SCORE": "Nilai terendah",
                "RANKABLE_ITEMS_LOWEST_SCORES": "Nilai terendah",
                "RATER_CATEGORY_DISPLAY_LOGIC": "logika tampilan kategori pemberi nilai",
                "RATIO": "Rasio",
                "RECORD": "Catatan",
                "REFERENCE_GROUP": "Grup referensi",
                "RELATIONSHIP": "Hubungan",
                "RELATIONSHIP_FILTERS": "Filter hubungan",
                "RELATIONSHIP_FILTERS_INFO": "Untuk menambahkan filter hubungan (seperti direct report, rekan kerja, atau manajer), pilih Kelola filter Anda, dan hanya gunakan kondisi Hubungan dari menu menurun.",
                "REMOVE": "Hapus",
                "REMOVE_DATA_SOURCE": "Hapus sumber data",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Ingat, terdapat sumber daya di organisasi Anda seperti Mitra SDM, manajer Anda, dan/atau mentor untuk membantu menafsirkan umpan balik Anda.",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Siapkan segelas kopi dan mulailah membaca umpan balik Anda.",
                    "ABOUT_YOUR_REPORT_HEADER": "Tentang laporan Anda",
                    "ABOUT_YOUR_REPORT_LINE1": "Selamat datang di laporan umpan balik 360 Anda. Ini merupakan peluang besar untuk tumbuh dan mengembangkan diri Anda sebagai seorang profesional. Demi keberhasilan saat memeriksa hasil, luangkan waktu yang cukup untuk memeriksa umpan balik. Umpan balik mungkin sulit diterima pada awalnya, namun ingatlah bahwa tujuan dari umpan balik ini adalah untuk mempercepat pertumbuhan dan pengembangan Anda.",
                    "ABOUT_YOUR_REPORT_LINE2": "Saat memeriksa laporan, berikut adalah beberapa hal yang harus Anda ingat.",
                    "ADVANCED_FILTER": "Filter Tingkat Lanjut",
                    "AGREEMENT_CHART": "Bagan kesepakatan",
                    "AGREEMENT_CHART_FOOTER": "Bagan kesepakatan menunjukkan kesamaan nilai. Setiap titik melambangkan bagaimana individu memberikan nilai kepada Anda untuk setiap item. Ukuran titik menunjukkan berapa banyak penilai yang memberikan nilai tertentu kepada Anda.",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "respons",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "respons",
                    "AGREEMENT_CHART_LEGEND_TITLE": "Bagaimana orang lain menilai Anda",
                    "ALL": "Semua",
                    "AVERAGE": "Rata-rata",
                    "BOTTOM_BOX": "Kotak Bawah",
                    "CHOICE_COUNT": "Jumlah Pilihan",
                    "CHOICE_TOTALS": "Total Pilihan",
                    "COMPARISON": "Perbandingan",
                    "COMPARISON_GAP_COLUMN_HEADER": "Kesenjangan perbandingan",
                    "COMPLETED_RESPONSES": "Respons yang lengkap",
                    "COUNT": "Jumlah",
                    "DEFAULT": "Default",
                    "DEFAULT_TEXT": "Teks standar",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "Mengetahui dari siapa umpan balik Anda berasal, baik dari rekan, bawahan langsung, pimpinan, dsb.",
                    "DIFFERENT_EVALUATORS_HEADER": "Evaluator yang berbeda",
                    "DONE": "Selesai",
                    "DONT_HEADER": "Hal yang Tidak Boleh Anda Lakukan:",
                    "DONT_LINE1": "Mencoba mencari tahu siapa yang mengatakan apa",
                    "DONT_LINE2": "Berfokus pada satu nilai/komentar yang positif atau negatif",
                    "DONT_LINE3": "Membuat rencana pengembangan seputar setiap item",
                    "DONT_LINE4": "Berkecil hati bahwa Anda memiliki peluang untuk perbaikan",
                    "DO_HEADER": "Hal yang Boleh Anda Lakukan:",
                    "DO_LINE1": "Melihat umpan balik secara menyeluruh",
                    "DO_LINE2": "Mengidentifikasi tema dalam kelebihan dan peluang untuk perbaikan",
                    "DO_LINE3": "Memprioritaskan beberapa area fokus untuk ditambahkan ke rencana pengembangan Anda",
                    "DO_LINE4": "Memahami bahwa setiap orang memiliki peluang untuk perbaikan",
                    "FIELD": "Bidang",
                    "GAP": "Perbedaan",
                    "GAP_CHART": "Bagan perbedaan",
                    "GAP_CHART_DESCRIPTION": "Bagan perbedaan menampilkan selisih nilai antara dua grup penilai. Misalnya, dalam hal pemberian nilai mandiri vs. bagaimana orang lain menilai Anda, selisih positif (+) berarti orang lain memberi Anda nilai yang lebih tinggi dari nilai yang Anda berikan untuk diri Anda sendiri. Selisih negatif (-) berarti orang lain memberikan nilai yang lebih rendah dari yang Anda berikan untuk diri Anda sendiri.",
                    "GAP_CHART_FOOTER": "Bagan perbedaan menunjukkan selisih +/- antara dua grup penilai.",
                    "GAP_TABLE_DESCRIPTION": "Kelebihan tersembunyi menunjukkan bahwa orang lain memberikan nilai yang lebih tinggi dari yang Anda nilai sendiri. Area untuk perbaikan menunjukkan bahwa orang lain memberikan nilai yang lebih rendah dari yang Anda nilai sendiri. Kedua bagian diurutkan dari perbedaan terbesar hingga perbedaan terkecil.",
                    "GAP_TABLE_FOOTER": "Kolom pertama dari nilai menunjukkan bagaimana Anda menilai diri Anda sendiri. Kolom kedua menunjukkan rata-rata nilai orang lain. Kolom ketiga menunjukkan selisih antara bagaimana Anda menilai diri Anda sendiri dan bagaimana orang lain menilai Anda.",
                    "GAP_TABLE_TITLE": "Kelebihan tersembunyi/Area perbaikan",
                    "GROUP": "Grup",
                    "HIDE_REPORT_ALERT": "Anda tidak memenuhi syarat untuk melihat laporan Anda. Hubungi administrator organisasi Anda.",
                    "HIGHEST_SCORES": "Nilai tertinggi",
                    "HIGHLOW_TABLE": "Nilai tinggi dan rendah",
                    "HIGHLOW_TABLE_FOOTER": "Bagian ini menampilkan lima perilaku dengan nilai tertinggi dan terendah (di seluruh perilaku) dari rata-rata kategori penilai yang berlaku. Untuk mendapatkan hasil yang maksimal dari halaman ini, mencari tren yang mungkin muncul akan sangat membantu. Misalnya, apabila mayoritas perilaku nilai terendah dipusatkan di satu atau dua kategori; area inilah yang mungkin perlu pengembangan. Perilaku dengan nilai tertinggi dapat mengidentifikasi kelebihan yang dapat dimanfaatkan di area lainnya.",
                    "HIGH_LOW_TABLE_DESCRIPTION": "Bagan tinggi/rendah menampilkan item yang didasarkan pada area di mana orang lain memberikan nilai tertinggi dan terendah kepada Anda.",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "Cara menafsirkan hasil dan menentukan tindakan:",
                    "ITEM": "Item",
                    "LOWEST_SCORES": "Nilai terendah",
                    "MAX": "Maks",
                    "MEAN": "Rata-rata",
                    "MEDIAN": "Median",
                    "MIN": "Min",
                    "NEGATIVE_GAPS": "Area untuk perbaikan",
                    "NO_COMPARISON_SET": "Tidak ada set perbandingan",
                    "NO_DATA_AVAILABLE_WARNING": "Data tidak tersedia",
                    "NO_FILTER_IS_APPLIED": "Tidak ada filter yang diterapkan.",
                    "NO_VALUE": "Tidak ada nilai",
                    "NPS": "Nilai Promotor Bersih",
                    "OTHERS": "Lainnya",
                    "PERCENTAGE": "Persentase",
                    "PERCENTAGE_OF_CHOICES": "Persentase Pilihan",
                    "PERCENTAGE_OF_RESPONSES": "Persentase Respons",
                    "PERCENT_COMPLETE": "% selesai",
                    "POSITIVE_GAPS": "Kelebihan tersembunyi",
                    "QUESTIONS": "Pertanyaan",
                    "RANK": "Peringkat",
                    "RELATIONSHIPS": {
                        "ANYONE": "Siapa saja",
                        "DIRECT_REPORT": "Bawahan Langsung",
                        "MANAGER": "Manajer",
                        "PEER": "Sejawat",
                        "SELF": "Diri"
                    },
                    "REPORT_SUMMARY": "Ringkasan laporan",
                    "REPORT_SUMMARY_TABLE_FOOTER": "Membandingkan jumlah orang yang menyelesaikan penilaian Anda dengan jumlah orang yang diundang untuk berpartisipasi.",
                    "REPORT_SUMMARY_TABLE_HEADER": "Statistik responden",
                    "RESPONSES": "Respons",
                    "RESPONSE_COUNT": "{{responseCount}} Respons",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Respons",
                    "SCORING_CATEGORY": "Kategori pemberian nilai",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Tidak ada respons untuk kategori ini",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Tidak ada respons untuk pertanyaan ini",
                    "SCORING_OVERVIEW": "Ikhtisar pemberian nilai",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "Anda dan evaluator lain berpikir bahwa area ini merupakan kelebihan teratas.",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Kelebihan yang diakui",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Area peningkatan yang diakui berarti penilaian diri dan penilaian orang lain di bawah rata-rata untuk kompetensi ini.",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Area peningkatan yang diakui",
                    "SCORING_OVERVIEW_DESCRIPTION": "Di atas adalah kompetensi atau perilaku yang Anda evaluasi sebagai bagian dari proses umpan balik multi-penilai ini. Nilai perbandingan diberikan berdasarkan grup.",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "Perbedaan minimum",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Selisih minimum antara grup referensi untuk teks yang akan ditampilkan.",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "Yang ditampilkan adalah rentang nilai untuk setiap kompetensi/perilaku. Bar mewakili rata-rata numerik.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Kelebihan yang tidak diakui berasal dari perbedaan antara penilaian mandiri dan penilaian dari orang lain.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Kelebihan yang tidak diakui",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Area peningkatan yang tidak diakui berasal dari perbedaan antara penilaian diri dan penilaian orang lain.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Area peningkatan yang tidak diakui",
                    "SELF": "Diri",
                    "SELF_ASSESSMENT": "Penilaian mandiri",
                    "STANDARD_DEVIATION": "Deviasi Standar",
                    "SUM": "Jumlah",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Biasakan diri Anda dengan skala penilaian untuk memastikan interpretasi yang akurat",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "Perhatikan skalanya",
                    "THINGS_YOU_WILL_SEE_HEADER": "Hal-hal yang akan Anda temui:",
                    "THREE_SIXTY_PERCENTILE": "Persentil",
                    "TOP_BOTTOM_BOX": "Kotak Atas / Kotak Bawah",
                    "TOP_BOX": "Kotak Atas",
                    "TOTAL": "Total",
                    "TO_DO": "Harus dilakukan",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Kualitatif: Umpan balik ini akan berupa komentar teks terbuka",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Kuantitatif: Umpan balik ini akan berupa numerik dan dapat diwakili dalam grafik, bagan bar, tabel, dsb.",
                    "TYPES_OF_FEEDBACK_HEADER": "Berbagai tipe umpan balik",
                    "VALUE": "Nilai",
                    "VARIANCE": "Varian",
                    "YOUR_RATINGS": "Nilai Anda"
                },
                "REPORT_SUMMARY": "Ringkasan laporan",
                "REPORT_SUMMARY_TABLE_FOOTER": "Membandingkan jumlah orang yang menyelesaikan penilaian Anda dengan jumlah orang yang diundang untuk berpartisipasi.",
                "REPORT_SUMMARY_TABLE_HEADER": "Statistik responden",
                "RESET": "Atur Ulang",
                "RESPONDENT_TOTALS": "Total Responden",
                "RESPONSES": "Respons",
                "RESPONSE_COUNT": "{{responseCount}} Respons",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Respons",
                "RESULT": "Hasil",
                "REVERSE_COLORS": "Balik Warna",
                "ROW_TOTALS": "Total Baris",
                "SAVE": "Simpan",
                "SAVE_AND_APPLY": "Simpan dan terapkan",
                "SCORING_CATEGORY": "Kategori pemberian nilai",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Tidak ada respons untuk kategori ini",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Tidak ada respons untuk pertanyaan ini",
                "SCORING_OVERVIEW": "Ikhtisar pemberian nilai",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "Anda dan evaluator lain berpikir bahwa area ini merupakan kelebihan teratas.",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Kelebihan yang diakui",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Area peningkatan yang diakui berarti penilaian diri dan penilaian orang lain di bawah rata-rata untuk kompetensi ini.",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Area peningkatan yang diakui",
                "SCORING_OVERVIEW_DESCRIPTION": "Di atas adalah kompetensi atau perilaku yang Anda evaluasi sebagai bagian dari proses umpan balik multi-penilai ini. Nilai perbandingan diberikan berdasarkan grup.",
                "SCORING_OVERVIEW_MINIMUM_GAP": "Perbedaan minimum",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Selisih minimum antara grup referensi untuk teks yang akan ditampilkan.",
                "SCORING_OVERVIEW_TABLE_FOOTER": "Yang ditampilkan adalah rentang nilai untuk setiap kompetensi/perilaku. Bar mewakili rata-rata numerik.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Kelebihan yang tidak diakui berasal dari perbedaan antara penilaian mandiri dan penilaian dari orang lain.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Kelebihan yang tidak diakui",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Area peningkatan yang tidak diakui berasal dari perbedaan antara penilaian diri dan penilaian orang lain.",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Area peningkatan yang tidak diakui",
                "SELECT_CATEGORIES": "Silakan pilih Kategori Pemberian Nilai...",
                "SELECT_CATEGORY": "Silakan pilih Kategori Pemberian Nilai...",
                "SELECT_CONDITION_TYPE": "Pilih tipe kondisi",
                "SELECT_DATA_SOURCE": "Pilih sumber data",
                "SELECT_DATA_SOURCE_TYPE": "Pilih sumber data",
                "SELECT_FILTER": "Pilih filter",
                "SELECT_FILTERS": "Pilih filter",
                "SELECT_OPERATOR_TYPE": "Pilih jenis operator",
                "SELECT_PERSON": "Pilih orang",
                "SELECT_PERSON_METADATA": "Pilih metadata individu",
                "SELECT_QUESTION": "Pilih pertanyaan",
                "SELECT_QUESTIONS": "Silakan pilih Pertanyaan...",
                "SELECT_RATIO_OR_DROPOFF": "Pilih rasio atau pengurangan",
                "SELECT_RELATIONSHIP": "Pilih hubungan",
                "SELECT_SCORING_CATEGORY": "Pilih kategori pemberian nilai",
                "SELF": "Diri",
                "SELF_ASSESSMENT": "Penilaian mandiri",
                "SEQUENTIAL": "Sekuensial",
                "SETUP_COMPARISON": "Atur perbandingan",
                "SETUP_COMPARISONS": "Atur perbandingan",
                "SET_START_COLOR": "Atur Warna Awal",
                "SHOULD_SHOW_FOOTER": "Tampilkan Footer",
                "SHOULD_SHOW_SCORING_CATEGORY": "Tampilkan Kategori Pemberian Nilai",
                "SHOWING_RECORDS_OF": "Menampilkan catatan %1 - %2 dari %3",
                "SHOW_COMPARISON_GAP": "Tampilkan kolom selisih perbandingan",
                "SHOW_DATA_LABEL": "Tampilkan nilai data",
                "SHOW_PERCENTAGES": "Tampilkan Persentase",
                "SHOW_THE_FOLLOWING_TEXT": "Kemudian tunjukkan teks berikut",
                "SHOW_TIES": "Tampilkan Ikatan",
                "SHOW_X_AXIS": "Tampilkan Sumbu X",
                "SHOW_Y_AXIS": "Tampilkan Sumbu Y",
                "SMALL_LABELS": "Label Kecil",
                "SORT": "Urutkan",
                "SPLINE": "Spline",
                "STACK_CHART": "Grafik Tumpuk",
                "STANDARD_DEVIATION": "Deviasi Standar",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "Kekurangan kurang dari",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "Edit teks ambang",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "Teks ambang",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "Aktifkan teks ambang",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "Kelebihan kurang dari",
                "SUM": "Jumlah",
                "SUMMARY": "Ringkasan",
                "TABLES": "Tabel",
                "TABLE_TOTALS": "Total Tabel",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Biasakan diri Anda dengan skala penilaian untuk memastikan interpretasi yang akurat",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "Perhatikan skalanya",
                "TEXT": "Teks",
                "THINGS_YOU_WILL_SEE_HEADER": "Hal-hal yang akan Anda temui:",
                "TOP_BOTTOM_BOX": "Kotak Atas / Kotak Bawah",
                "TOP_BOX": "Kotak Atas",
                "TOTAL": "Total",
                "TOTAL_COUNTS": "Jumlah Total",
                "TO_DO": "Harus dilakukan",
                "TRANSPOSE": "Transpos",
                "TRANSPOSE_TABLE": "Tabel transpos",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Kualitatif: Umpan balik ini akan berupa komentar teks terbuka",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Kuantitatif: Umpan balik ini akan berupa numerik dan dapat diwakili dalam grafik, bagan bar, tabel, dsb.",
                "TYPES_OF_FEEDBACK_HEADER": "Berbagai tipe umpan balik",
                "UNDO": "Batalkan",
                "USE_COMPARISON": "Gunakan perbandingan",
                "USE_LABELS_FOR_SCALES": "Gunakan label untuk skala",
                "VALUES": "Nilai",
                "VALUE_RANGES": "Rentang Nilai",
                "VARIANCE": "Varian",
                "VERTICAL": "Vertikal",
                "VERTICAL_RANGE": "Rentang Vertikal",
                "WARNING_DATA_OUT_OF_RANGE": "Peringatan: nilai data melebihi konfigurasi rentang",
                "WIDGET_ERROR": {
                    "ERROR": "Terjadi kesalahan yang tidak terduga",
                    "MISCONFIGURED": "Widget ini tidak dikonfigurasi dengan benar. Silakan periksa konfigurasi widget Anda.",
                    "NEW": "Silakan konfigurasi widget",
                    "NO_DATA": "Data tidak ditemukan - filter Anda mungkin terlalu khusus!"
                },
                "WIDGET_NAME": {
                    "BAR": "Grafik Bar",
                    "BREAKDOWNBAR": "Bar Perincian",
                    "DATA_TABLE": "Tabel Data",
                    "FUNNEL_CHART": "Bagan Funnel",
                    "GAUGE": "Grafik Gauge",
                    "GRID": "Tabel Hasil",
                    "HEATMAP": "Peta Panas",
                    "LINE": "Grafik Garis",
                    "NEEDS_BASED": "Berbasis Kebutuhan",
                    "PIE": "Diagram Lingkaran",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "Penaksir Harga (Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "Pemaksimal Pendapatan (Gabor Granger)",
                    "SCORING_OVERVIEW_CHART": "Bagan",
                    "SCORING_OVERVIEW_TABLE": "Tabel",
                    "STATS_TABLE": "Tabel Statistik",
                    "WORDCLOUD": "Word Cloud"
                },
                "WORD_ROTATION": "Rotasi kata",
                "WORD_SPACING": "Spasi kata",
                "YES": "Ya",
                "YOUR_RATINGS": "Nilai Anda"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "Tambahkan",
                "ADD_A_WORD": "Tambahkan satu kata",
                "COLOR": "Warna",
                "DELETE_ALL": "Hapus semua",
                "EDIT_STOP_WORDS": "Edit kata-kata henti",
                "MAX_WORDS": "Maksimum Kata",
                "ROTATION_ANGLED": "Miring",
                "ROTATION_HORIZONTAL": "Horizontal",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "Horizontal dan Vertikal",
                "WORD_ORIENTATION": "Orientasi Kata"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "Warna Latar Belakang",
                "DISPLAY_OPTIONS": "Opsi Tampilan",
                "INVERT_FONT_COLORS": "Balikkan Warna Bentuk Huruf Kontras Rendah",
                "PAGE": "Halaman",
                "PAGINATE": "Paginasi"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "Rata-Rata",
                "BOTTOM_BOX_METRIC": "Kotak Bawah",
                "COLUMNS": "Kolom",
                "COUNT_METRIC": "Total Respons",
                "FIELD_NAME": "Bidang",
                "MAX_METRIC": "Maksimum",
                "MIN_METRIC": "Minimum",
                "SHOW_RECODES": "Tampilkan Nilai yang Dapat Dikodekan Ulang",
                "SHOW_ROW_NUMBERS": "Tampilkan Nomor Baris",
                "STD_DEV_METRIC": "Deviasi Std",
                "TOP_BOX_METRIC": "Kotak Atas",
                "TRANSPOSE_BREAKOUTS": "Transpos Pemecahan",
                "TRANSPOSE_TABLE": "Tabel Transpos",
                "VAR_METRIC": "Varian"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "Kolom Tambahan",
                "ADD_COLUMNS": "Tambahkan Kolom Tambahan",
                "ADD_CUSTOM_PALETTE": "Tambahkan Palet Kustom",
                "ALL_CHOICES": "Semua Pilihan",
                "ALL_GROUPS": "Semua Grup",
                "ALL_RECODES": "Semua Kode Ulang",
                "AUTOMATIC": "Bawaan",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "Default - Klik untuk mengedit",
                "AXIS_VALUES": "Nilai Sumbu",
                "BREAKOUT_BY": "Pemecahan Berdasarkan",
                "CANCEL": "Batalkan",
                "CATEGORICAL": "Kategoris",
                "CHOICES": "Pilihan",
                "CHOICE_COUNT": "Jumlah Pilihan",
                "COLOR_PALETTE": "Palet Warna",
                "COLUMN_VALUES": "Nilai Kolom",
                "CONTACT_FIELDS": "Bidang Kontak",
                "COUNT": "Jumlah",
                "CREATE": "Buat",
                "CUSTOM": "Kustom",
                "CUSTOM_PALETTE": "Palet Kustom",
                "DATA_SOURCE": "Sumber Data",
                "DAY": "Hari",
                "DAY_OF_WEEK": "Hari dalam Seminggu",
                "DECIMAL_PRECISION": "Tempat Desimal",
                "DEFAULT": "Bawaan",
                "DISABLED": "Dinonaktifkan",
                "DIVERGENT": "Divergen",
                "EDIT_CUSTOM_PALETTE": "Edit Palet Kustom",
                "ENABLED": "Diaktifkan",
                "ERROR_LOADING_DATA": "Kesalahan memuat data",
                "FILE_SIZE": "Ukuran",
                "FILE_TYPE": "Tipe",
                "FRI": "Jum",
                "FRIDAY": "Jumat",
                "GROUP_DATE_BY": "Kelompokkan Tanggal Berdasarkan",
                "HOUR_OF_DAY": "Jam dalam Sehari",
                "LENGEND_VALUES": "Nilai Tulisan",
                "MAX": "Maks",
                "MEAN": "Rata-rata",
                "MIN": "Min",
                "MISCONFIGURED_DATA": "Sumber data salah dikonfigurasikan untuk visualisasi ini.",
                "MISCONFIGURED_FILTERS": "Filter Tidak Valid",
                "MODIFY_CUSTOM_PALETTES": "Modifikasi Palet Kustom",
                "MON": "Sen",
                "MONDAY": "Senin",
                "MONTH": "Bulan",
                "NONE": "Tidak Ada",
                "NO_FILE_ID_ERROR": "Visualisasi ini memerlukan gambar untuk diatur dalam survei",
                "NO_RESULTS_TO_SHOW": "Tidak ada hasil untuk ditampilkan",
                "NPS": "Net Promoter Score®",
                "NPS_GROUP": "NPS® group",
                "NUMERIC_VALUE": "Nilai Numerik",
                "PALETTE_REMOVED": "Palet Dihapus",
                "PERCENTAGE": "Persentase",
                "PERCENTAGE_OF_CHOICES": "Persentase Pilihan",
                "PERCENTAGE_OF_RESPONSES": "Persentase Respons",
                "QUARTER": "Triwulan",
                "REMOVE": "Hapus",
                "RESPONSE_COUNT": "Jumlah Respons",
                "RESULTS_PER_PAGE": "Hasil per halaman",
                "RETRIEVING_DATA_ELLIPSIS": "Mengambil data...",
                "REVERSE_COLORS": "Balik Warna",
                "ROW_VALUES": "Nilai Baris",
                "SAT": "Sab",
                "SATURDAY": "Sabtu",
                "SAVE": "Simpan",
                "SELECTED_CHOICE": "Pilihan Dipilih",
                "SELECT_FIELD": "Pilih Bidang",
                "SELECT_METRIC": "Metrik",
                "SEQUENTIAL": "Sekuensial",
                "SET_START_COLOR": "Atur Warna Awal",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "Tampilkan data sampel...",
                "SUM": "Jumlah",
                "SUN": "Min",
                "SUNDAY": "Minggu",
                "SURVEY_EMBEDDEDDATA": "Data Tersemat",
                "SURVEY_METADATA": "Metadata Survei",
                "TEXT_ENTRY": "Entri teks",
                "THURS": "Kam",
                "THURSDAY": "Kamis",
                "TITLE": "Judul",
                "TUES": "Sel",
                "TUESDAY": "Selasa",
                "UNBOUNDED_DOMAIN": "Terlalu banyak nilai untuk ditampilkan.",
                "UNBOUNDED_DOMAIN_HELP": "Untuk menambahkan bidang ini ke Laporan Hasil, Anda dapat menambahkan filter ke laporan untuk menampilkan lebih sedikit nilai untuk \"{{ed_field_name}}\" atau memperbarui tipe variabel data tersemat dari \"{{ed_field_name}}\" di alur survei Anda untuk menjadikan bidang ini sebagai jenis string atau numerik.",
                "UNDO": "Batalkan",
                "USE_CHOICE_TOTALS": "Gunakan Total Pilihan",
                "USE_RESPONDENT_TOTALS": "Gunakan Total Responden",
                "VISUALIZATION": "Visualisasi",
                "VISUALIZATION_BARCHART": "Grafik Bar",
                "VISUALIZATION_BREAKDOWNBAR": "Bar Perincian",
                "VISUALIZATION_GAUGE": "Grafik Gauge",
                "VISUALIZATION_HEATMAP": "Peta",
                "VISUALIZATION_LINECHART": "Grafik Garis",
                "VISUALIZATION_PAGINATEDTABLE": "Tabel Bernomor Halaman",
                "VISUALIZATION_PIE": "Diagram Lingkaran",
                "VISUALIZATION_SIMPLETABLE": "Tabel Sederhana",
                "VISUALIZATION_STATSTABLE": "Tabel Statistik",
                "VISUALIZATION_TEXTHIGHLIGHTS": "Sorotan Teks",
                "VISUALIZATION_WORDCLOUD": "Word Cloud",
                "WED": "Rab",
                "WEDNESDAY": "Rabu",
                "WEEK": "Minggu",
                "WEIGHTING": "Pembobotan",
                "WRONG_QUESTION_TYPE_ERROR": "Jenis visualisasi ini tidak dapat digunakan untuk pertanyaan ini",
                "YEAR": "Tahun"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "Rata-Rata",
                "CHOICE_COUNT": "Jumlah Pilihan",
                "COUNT": "Jumlah",
                "DISPLAY_OPTIONS": "Opsi Tampilan",
                "MAX": "Maksimum",
                "MIN": "Minimum",
                "NPS": "NPS®",
                "PAGE_OF": "Halaman: %1 Dari %2",
                "PERCENT": "Persentase",
                "RESPONSE_COUNT": "Jumlah Respons",
                "ROWS_PER_TABLE": "Baris Per Tabel",
                "SHOWING_ROWS_OF": "Menampilkan baris %1 - %2 dari %3",
                "SHOW_PERCENTAGES": "Tampilkan Persentase",
                "SHOW_RECODES": "Tampilkan Nilai yang Dapat Dikodekan Ulang",
                "SHOW_ROW_NUMBERS": "Tampilkan Nomor Baris",
                "SUM": "Jumlah",
                "TOTAL": "Total",
                "TRANSPOSE": "Transpos",
                "USE_COLUMN_TOTALS": "Gunakan Total Kolom",
                "USE_ROW_TOTALS": "Gunakan Total Baris",
                "VALUE": "Nilai"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "Urutan Naik",
                "COUNT": "Jumlah",
                "DESCENDING": "Urutan Turun",
                "DIAGONAL": "Diagonal",
                "DISPLAY_OPTIONS": "Opsi Tampilan",
                "ERROR_COLON": "Kesalahan:",
                "ERROR_GENERIC": "Terjadi kesalahan ketika memuat visualisasi.",
                "HORIZONTAL": "Horizontal",
                "HORIZONTAL_BARS": "Bar Horizontal",
                "INCORRECTLY_CONFIGURED": "Pilih nilai untuk menampilkan bagan",
                "LEGEND_AUTO": "Otomatis",
                "LEGEND_BOTTOM": "Rata bawah",
                "LEGEND_INSET": "Inset",
                "LEGEND_RIGHT": "Rata kanan",
                "NORMALIZE_TO_PERCENTAGES": "Normalisasikan ke Persentase",
                "SHOW_BAR_LABELS": "Tampilkan Label Bar",
                "SHOW_LEGEND": "Tampilkan Legenda",
                "SHOW_X_AXIS": "Tampilkan Sumbu X",
                "SHOW_Y_AXIS": "Tampilkan Sumbu Y",
                "SORT_BAR_VALUES": "Urutkan Nilai Bar",
                "STACKED_BARS": "Bar yang Ditumpuk",
                "TRANSPOSE": "Transpos",
                "TRUNCATE_LABELS": "Potong Label",
                "VERTICAL": "Vertikal"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "Semua Lainnya",
                "COULD_NOT_LOAD_DATA": "Tidak dapat memuat data dengan konfigurasi yang ditetapkan — coba bidang sumber berbeda atau rentang tanggal yang lebih luas.",
                "GROUPING_PERCENTAGE_THRESHOLD": "Ambang Batas Persentase Pengelompokan",
                "NO_DATA": "Tidak Ada Data",
                "RADIUS": "Radius Dalam",
                "SHOW_AS_PERCENTAGES": "Tampilkan Sebagai Persentase"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "Tutup",
                "DOWNLOAD_CSV": "Unduh CSV",
                "DOWNLOAD_ZIP": "Unduh semua file",
                "NO_DATA": "Tidak Ada Data",
                "PAGE_OF": "Halaman: %1 Dari %2",
                "RESULTS_PER_PAGE": "Hasil per halaman",
                "SHOWING_RECORDS_OF": "Menampilkan catatan %1 - %2 dari %3",
                "SINGLE_RESPONSE": "Respons Tunggal",
                "VIEW_RESPONSE": "Lihat Respons"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "Opsi Tampilan",
                "ERROR_COLON": "Kesalahan:",
                "ERROR_GENERIC": "Terjadi kesalahan ketika memuat visualisasi.",
                "HORIZONTAL_BARS": "Bar Horizontal",
                "INCORRECTLY_CONFIGURED": "Pilih nilai untuk menampilkan bagan",
                "LEGEND_AUTO": "Otomatis",
                "LEGEND_BOTTOM": "Rata bawah",
                "LEGEND_INSET": "Inset",
                "LEGEND_RIGHT": "Rata kanan",
                "NORMALIZE_TO_PERCENTAGES": "Normalisasikan ke Persentase",
                "SHOW_AREA": "Tampilkan Area",
                "SHOW_LEGEND": "Tampilkan Legenda",
                "SHOW_X_AXIS": "Tampilkan Sumbu X",
                "SHOW_Y_AXIS": "Tampilkan Sumbu Y",
                "SMOOTH_LINES": "Baris Lancar",
                "SORT_X_AXIS_LABELS": "Urutkan Label X Axis",
                "STACKED_BARS": "Bar yang Ditumpuk",
                "TRANSPOSE": "Transpos"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "Mode Blok",
                "BLUR": "Buram",
                "COULD_NOT_LOAD_DATA": "Tidak dapat memuat data dengan konfigurasi yang ditetapkan — coba bidang sumber berbeda atau rentang data yang lebih besar.",
                "FIELD": "Bidang",
                "RADIUS": "Radius",
                "SHOW_REGIONS": "Tampilkan Wilayah",
                "SHOW_REGION_LABELS": "Tampilkan Label Wilayah"
            },
            "GAUGEWIDGET": {
                "MAX": "Maks",
                "MIN": "Min",
                "VALUE_RANGES": "Rentang nilai"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "Label bawah",
                "CATEGORY_NAME": "Nama kategori",
                "ERROR_COLON": "Kesalahan:",
                "INCLUDE_HIDDEN_GROUPS": "Sertakan grup tersembunyi dalam persen",
                "LARGE_LABELS": "Label besar",
                "NO": "Tidak",
                "PERCENT": "Persen",
                "RESPONSE_COUNT": "Jumlah respons",
                "RESPONSE_COUNT_WITH_VALUE": "{{ responseCount }} respons",
                "SMALL_LABELS": "Label kecil",
                "YES": "Ya"
            }
        });
        $cache.put('IT', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "Codice d'accesso",
                "ACCESS_CODE_PROTECTION": "Protezione del codice di accesso",
                "ADD": "Aggiungi",
                "ADD_BREAKOUT": "Aggiungi suddivisione rapporto",
                "ADD_NOTE": "Aggiungi nota",
                "ADD_SCHEDULED_REPORT": "Aggiungi rapporto pianificato",
                "ADD_WIDGET": "Aggiungi visualizzazione",
                "ALL_PROJECTS": "Tutti i progetti",
                "ALL_QUESTIONS": "Pagine della domanda",
                "ANSWER": "Risposta",
                "ANY_CHANGES_LOST": "Qualsiasi modifica dei rapporti andrà persa se lasci la piattaforma Qualtrics XM.",
                "APPENDED_COPY_IN_PARENS": "(Copia)",
                "AREA_CHART": "Grafico ad area",
                "AREA_CHART_DESC": "Grafico a linee a due assi e area sotto la linea compilata.",
                "ATTACHMENT": "Allegato",
                "BACKUP_CURRENT_REPORT": "Salva una copia di backup di questo rapporto prima che influisca sulle visualizzazioni",
                "BACKUP_CURRENT_REPORT_LINE2": "Nota: la copia di backup verrà denominata \"{{nameOfReportCopy}}\"",
                "BACK_TO_REPORTS": "Torna ai rapporto",
                "BACK_TO_TOP": "Torna all'inizio",
                "BACK_TO_VIEW_RESULTS": "Torna ai vecchi risultati della vista",
                "BAR_CHART": "Grafico a barre",
                "BAR_CHART_DESC": "Grafico a barre con due assi che permette una configurazione aggiuntiva, come la trasposizione degli assi e la ridisposizione dei punti dati.",
                "BREAKDOWN_BAR_CHART": "Barra di suddivisione",
                "BREAKDOWN_BAR_CHART_DESC": "Grafico a barre impilate orizzontali, utilizzato più comunemente per soppesare le misurazioni una rispetto all'altra, in alternativa a un grafico a torta.",
                "CANCEL": "Annullare",
                "CANCEL_CONF_TEXT": "Annullare?<br/>Tutti i cambiamenti andranno persi.",
                "CANCEL_EDITS": "Annulla modifiche",
                "CHART": "Grafico",
                "CHOICE": "Scelta",
                "CHOICES_COUNT_METRIC": "Conteggio scelte",
                "CHOOSE_PAGES_TO_DISPLAY": "Sceglie le pagine da visualizzare",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "Questo rapporto contiene {{maxReportPageCount}} pagine, ma i risultati ne possono contenere solo fino a {{reportSizeLimit}}. Selezionane un sottoinsieme entro il limite.",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "I report possono contenere {{reportSizeLimit}} pagine al massimo, seleziona le pagine che desideri.",
                "CLEAR_ALL": "Cancella tutto",
                "CLOSE": "Chiudi",
                "CLOUD": "DESCRIZIONE PER CLOUD",
                "COLLABORATED_NEW": "Il proprietario di questo sondaggio utilizza la piattaforma Qualtrics XM! I rapporti di questo sondaggio saranno modificati utilizzando i nuovi risultati.",
                "COMMA_SEPARATED_LIST": "Lista delimitata da virgole",
                "COMPACTNESS": "Caratteri e spaziatura",
                "COMPACTNESS_INFO": "Questa impostazione influisce sul riempimento delle tabelle e sulla dimensione dei caratteri e delle barre nelle tabelle. Sarà applicata anche alla maggior parte delle esportazioni.",
                "CONFIRM": "Ok",
                "CONFIRM_DELETE": "Conferma cancellazione",
                "CONFIRM_DELETE_PAGE": "Eliminare questa pagina?",
                "CONTINUE": "Continua",
                "CONTINUE_EDITING": "Continua modifica",
                "COPY": "Copia",
                "COPY_OF_REPORT_NAME": "Copia di {{nameOfCurrentReport}}",
                "COPY_REPORT": "Copia rapporto",
                "COPY_REPORT_ELLIPSIS": "Copia rapporto...",
                "COPY_TO_NEW_REPORT": "Copia su un nuovo rapporto...",
                "CREATE": "Crea",
                "CREATED": "Creato il",
                "CREATE_CUSTOM_PAGE": "Crea pagina personalizzata",
                "CREATE_NEW_REPORT": "Crea nuovo rapporto",
                "CREATE_NEW_REPORT_ELLIPSIS": "Crea nuovo rapporto...",
                "CSV_FILE": "File CSV",
                "CUSTOM_PAGES": "Pagine personalizzate",
                "DATE": "Data",
                "DEFAULT_PALETTE": "Tavolozza colori predefinita",
                "DEFAULT_REPORT": "Rapporto predefinito",
                "DEFAULT_VISUALIZATIONS": "Visualizzazioni predefinite",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "Queste sono le visualizzazioni predefinite dei tipi utilizzati per costruire rapporti predefiniti sui risultati. Aggiornando e applicando queste impostazioni si ricostruisce il rapporto corrente con le nuove impostazioni predefinite. Avrai la possibilità di eseguire il backup del rapporto corrente.",
                "DEFAULT_VISUALIZATIONS_NOTE": "Nota: non sono disponibili tutti i tipi di visualizzazione per ogni tipo di domanda. Alcune visualizzazioni non predefinite potrebbero essere sostituite automaticamente.",
                "DEFAULT_VISUALS_DISCLAIMER": "Qualtrics aggiornerà questo rapporto con la nuova impostazione di visualizzazione predefinita.",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "Questo aggiornamento riguarda {{amountOfWidgetsAffected}} visualizzazioni di questo rapporto.",
                "DEFAULT_VISUAL_EDIT_DETECTED": "Rilevata una modifica della visualizzazione predefinita",
                "DELETE_BUTTON": "Elimina",
                "DELETE_DISABLED_EXPLANATION": "L'eliminazione dei rapporti creati nell'interfaccia di rendicontazione precedente non è consentita fino a quando l'organizzazione non ha eseguito una migrazione completa alla piattaforma Qualtrics XM.",
                "DELETE_PAGE": "Elimina pagina",
                "DELETE_PAGE_ELLIPSIS": "Elimina pagina...",
                "DELETE_REPORT": "Elimina rapporto",
                "DELETE_REPORT_ELLIPSIS": "Elimina rapporto...",
                "DELETE_WIDGET_QUESTION": "Eliminare?",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "Questo campo è criptato e non può essere utilizzato per l'ordinamento.",
                "DISCARD_EDITS": "Scarta modifiche",
                "DISTRIBUTION_PAUSED": "Distribuzione rapporto in pausa.",
                "DONE_BUTTON": "Fatto",
                "DONE_EDITING": "Modifica terminata",
                "DOWNLOAD": "Scarica",
                "DOWNLOAD_AS_CSV": "Scarica come CSV",
                "DOWNLOAD_AS_PDF": "Scarica come PDF",
                "DOWNLOAD_FAILED": "Download non riuscito",
                "DOWNLOAD_PREVIOUS_EXPORTS": "Scarica esportazioni precedenti...",
                "DO_YOU_WISH_TO_DELETE": "Desideri eliminare:",
                "DUPLICATE_PAGE": "Duplica foglio",
                "EDIT_REPORT": "Modifica rapporto",
                "EDIT_REPORT_ELLIPSIS": "Modifica rapporto...",
                "EDIT_VISUALIZATION": "Modifica visualizzazione",
                "EMAIL_ADDRESS": "Indirizzo e-mail",
                "EMAIL_SENT": "E-mail inviata...",
                "END_OF_REPORT": "Fine del rapporto",
                "ENTER_NAME": "Inserisci nome",
                "ERROR_COPYING": "Si è verificato un errore durante la copia del rapporto.",
                "ERROR_DELETING": "Si è verificato un errore nell'eliminazione del rapporto.",
                "ERROR_DELETING_EXPORT": "Errore nell'eliminazione dell'esportazione.",
                "ERROR_HEADING": "Errore",
                "ERROR_PUBLISHING": "Si è verificato un errore durante il salvataggio delle impostazioni.",
                "ERROR_RENAMING": "Si è verificato un errore nella ridenominazione del rapporto.",
                "ERROR_REQUESTING_EXPORT": "Si è verificato un errore nella richiesta di esportazione.",
                "ERROR_SAVING_GLOBAL_OPTIONS": "Si è verificato un errore durante il salvataggio delle opzioni di visualizzazione globale.",
                "ERROR_SEND_TEST_EMAIL": "Si è verificato un errore durante l'invio dell'e-mail di prova.",
                "EVERY_FRIDAY": "Ogni venerdì",
                "EVERY_MONDAY": "Ogni lunedì",
                "EVERY_MONTH": "Ogni mese, il",
                "EVERY_SATURDAY": "Ogni sabato",
                "EVERY_SUNDAY": "Ogni domenica",
                "EVERY_THURSDAY": "Ogni giovedì",
                "EVERY_TUESDAY": "Ogni martedì",
                "EVERY_WEDNESDAY": "Ogni mercoledì",
                "EVERY_WEEK": "Settimanalmente, ogni",
                "EXAMPLE_GROUP_NUM": "Gruppo {{num}}",
                "EXAMPLE_SERIES_NUM": "Serie {{num}}",
                "EXPORT": "Esporta",
                "EXPORT_CSV": "CSV (Separati da virgola)",
                "EXPORT_EXCEL_SPREADSHEET": "Foglio di lavoro Excel",
                "EXPORT_IMAGE": "Esporta immagine",
                "EXPORT_PAGES": "Esporta pagine",
                "EXPORT_PDF": "Documento PDF",
                "EXPORT_PPT_SLIDES": "Diapositive Powerpoint",
                "EXPORT_RAW_DATA": "Esporta dati grezzi",
                "EXPORT_REPORT": "Esporta rapporto",
                "EXPORT_VISUALIZATION": "Esporta visualizzazione",
                "EXPORT_WORD_DOC": "Documento Word",
                "FAILED_SAVE_TXT": "Salvataggio non riuscito",
                "FILTERED": "Filtrata",
                "FIRST_PAGE": "Prima pagina",
                "FIRST_WEEKDAY": "Primo giorno feriale del mese",
                "FROM": "Da",
                "FROM_EMAIL": "Da e-mail",
                "FROM_NAME": "Nome mittente",
                "GAUGE_CHART": "Grafico a indicatore",
                "GAUGE_CHART_DESC": "Grafico che somiglia a un calibro per confrontare i valori attuali con un obiettivo o una serie di soglie.",
                "GENERATING_FILE": "Generazione file...",
                "GENERATING_IMAGE": "Generazione immagine...",
                "GENERATING_PDF": "Generazione PDF...",
                "GENERIC_ERROR": "Un errore ha impedito di caricare il progetto richiesto.",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "Opzioni globali...",
                "GLOBAL_METRIC": "Metrica predefinita",
                "GLOBAL_MODAL_PAGE_TITLE": "Visualizzazione d'esempio che utilizza le opzioni globali per la sezione Risultati di Qualtrics Research Suite",
                "GLOBAL_MODAL_WIDGET_TITLE": "Titolo visualizzazione",
                "GLOBAL_OPTIONS": "Opzioni globali",
                "GLOBAL_PRECISION": "Posizioni decimali predefinite",
                "GLOBAL_SETTINGS_APPLY": "Applica le mie impostazioni predefinite",
                "GLOBAL_SETTINGS_SAVE": "Salva impostazioni come predefinite",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "Applica l’impostazione predefinita Qualtrics",
                "GROUP": "Gruppo",
                "HEAT_MAP_CHART": "Grafico heat map",
                "HEAT_MAP_CHART_DESC": "Una visualizzazione in stile “heat” a cluster usata per mappare la distribuzione dell'inserimento dell'utente (ad esempio i clic) sull'immagine originale.",
                "HIDDEN": "Nascosto",
                "HIDDEN_PAGE": "Questa pagina non verrà visualizzata nei rapporti pubblici e sarà deselezionata per impostazione predefinita nelle esportazioni dei rapporti.",
                "HIDE": "Nascondi",
                "HIDE_ALL_PAGES": "Nascondi tutte le pagine",
                "HIDE_PAGE": "Nascondi pagina",
                "IMAGE_FILE": "File immagine",
                "INVALID_BRAND_DOMAIN": "Il dominio immesso non è presente nella lista dei domini e-mail approvati del tuo brand. Contatta l'amministratore del tuo brand per risolvere il problema.",
                "INVALID_SPF_RECORD": "Il dominio immesso non ha autorizzato l'invio da parte di Qualtrics. Ciò influirà sulla capacità di consegna. Usare un altro dominio o contattare Qualtrics per la risoluzione di questo problema.",
                "ISSUE_SAVING_REPORTS": "Problema di salvataggio per uno o più rapporti. Riprovare.",
                "ISSUE_SENDING_TEST": "Si è verificato un errore durante l'invio dell'e-mail di prova. Riprovare.",
                "LARGE_SURVEY": "I risultati non saranno visualizzati perché il sondaggio è troppo grande.",
                "LAST_DAY": "Ultimo giorno del mese",
                "LAST_MODIFIED_COLON_WITH_DATE": "Ultima modifica: %1",
                "LAST_PAGE": "Ultima pagina",
                "LAST_WEEKDAY": "Ultimo giorno feriale del mese",
                "LATER": "Più tardi",
                "LEARN_MORE": "Per saperne di più",
                "LINE_CHART": "Grafico a linee",
                "LINE_CHART_DESC": "Grafico a linee a due assi comunemente utilizzato per una rappresentazione grafica rispetto al tempo sull'asse x.",
                "LOG_OUT_WARNING": "Fare clic ovunque entro {{countdown}} secondi per rimanere connessi",
                "MESSAGE": "Messaggio",
                "MONTHLY": "Mensilmente",
                "MOVE_DOWN": "Sposta visualizzazione in basso",
                "MOVE_PAGE_TO_BOTTOM": "Sposta in basso",
                "MOVE_PAGE_TO_TOP": "Sposta in alto",
                "MOVE_UP": "Sposta visualizzazione in alto",
                "MY_SURVEYS": "I miei progetti",
                "NAME": "Nome",
                "NEW_CUSTOM_PAGE_NAME": "Nuova pagina personalizzata",
                "NEW_REPORT": "Nuovo rapporto",
                "NEXT_PAGE": "Pagina successiva",
                "NEXT_RUN": "Esecuzione successiva",
                "NO_EXPORTS": "Nessuna esportazione è stata ancora richiesta per questo rapporto.",
                "NO_ITEMS_TO_DISPLAY": "Nessun elemento da visualizzare",
                "NO_MATCHING_CUSTOM_PAGES": "Nessuna pagina personalizzata corrispondente",
                "NO_MATCHING_PAGES": "Nessuna pagina trovata per la ricerca",
                "NO_MATCHING_REPORTS": "Nessun rapporto corrispondente.",
                "NO_PROJECT": "Specifica un progetto per continuare.",
                "NO_PROJECTS_TO_MIGRATE": "Non c'è alcun progetto da aggiornare.",
                "NO_QUESTIONS": "Nessuna domanda corrispondente",
                "NO_RESULTS_YET": "Non c'è ancora nessun risultato da visualizzare. Distribuisci il sondaggio per raccogliere le risposte.",
                "OFF": "Disattivo",
                "ON": "Attiva",
                "PAGES_SELECTED": "Pagine selezionate",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "Questa selezione farebbe in modo che il rapporto contenga {{currentSelectedPageCount}} pagine, e questo supera il valore massimo consentito di {{reportSizeLimit}}. Selezionare un intervallo più ridotto.",
                "PAGES_SELECTION_INVALID_RANGE": "Seleziona un intervallo valido.",
                "PAGE_OPTIONS": "Opzioni pagina",
                "PDF_ROW_TRUNCATION_MESSAGE": "Troppe righe per l'esportazione PDF, prova a esporta in Word o CSV",
                "PERCENTAGE_METRIC": "Percentuale",
                "PIE_CHART": "Grafico a torta",
                "PIE_CHART_DESC": "Suddivisione circolare dei valori per un dato punto dati. Utile per misurare le proporzioni relative dei valori scelti.",
                "PREVIEW": "Anteprima",
                "PREVIOUS_PAGE": "Pagina precedente",
                "PRINT_PAGE": "Stampa pagina",
                "PUBLIC_LINK": "Collegamento pubblico",
                "PUBLIC_REPORT_AVAILABLE": "Rapporto pubblico disponibile",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "Codice d'accesso",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "Codice d'accesso errato. Riprova.",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "Invia",
                "PUBLIC_RESULTS_LOGIN_TITLE": "Accesso al rapporto pubblico | Software per sondaggi Qualtrics",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "Rapporto pubblico non trovato. Contatta il proprietario del rapporto e richiedi un collegamento valido.",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "Rapporto pubblico non trovato",
                "PUBLIC_RESULTS_NOT_UPDATED": "I collegamenti ai rapporti pubblici e le e-mail dei rapporti pianificate non utilizzeranno la piattaforma Qualtrics XM fino a quando non li aggiorni.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "Sessione scaduta. Accedi nuovamente per continuare a vedere in anteprima il rapporto dei risultati pubblici.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "Sessione scaduta",
                "PUBLIC_RESULTS_TITLE": "Rapporto pubblico",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "Non sei autorizzato a visualizzare questa pagina. Contatta il proprietario del rapporto e chiedi di renderlo pubblico.",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "Rapporto pubblico non autorizzato",
                "PUBLISHED_LINK_GENERATING_LINK": "Generazione link...",
                "PUBLISHED_REPORT_FOUND_HERE": "Chiunque può visualizzare questo rapporto al seguente collegamento:",
                "PUBLISH_REPORT": "Gestisci rapporto pubblico",
                "PUBLISH_REPORT_ELLIPSIS": "Gestisci rapporto pubblico...",
                "QUESTION": "Domanda",
                "RANK": "Classificazione",
                "REMOVE_WIDGET": "Rimuovi visualizzazione",
                "RENAME_PAGE": "Rinomina pagina",
                "RENAME_REPORT": "Rinomina rapporto",
                "RENAME_REPORT_ELLIPSIS": "Rinomina rapporto...",
                "REPLY_TO_EMAIL": "Indirizzo e-mail per la risposta",
                "REPORT_COLON": "Rapporto:",
                "REPORT_SETTINGS": "Impostazioni rapporto",
                "REPORT_SETTINGS_ELLIPSIS": "Impostazioni rapporto...",
                "RESPONSE_COUNTS": "Conteggi risposte",
                "RESULTS_DASHBOARDS_BANNER": "e prova la nuova versione migliorata dei risultati del sondaggio, con UI moderna e accessibile, visualizzazioni di dati, nuove funzioni di analisi ed esplorazione e molto altro.",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "Note di rilascio",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "Visualizza le più recenti",
                "RESULTS_OPTIONS": "Opzioni rapporto",
                "RESULTS_TITLE": "Rapporto",
                "RESUME_DISTRIBUTION": "Riprendi distribuzione",
                "REVERT": "Ripristina",
                "RICH_TEXT_LIMIT_REACHED": "La lunghezza del contenuto ha raggiunto il limite!",
                "SAVE": "Salva",
                "SAVE_AND_CLOSE": "Salva e chiudi",
                "SAVE_AS_CSV": "Salva visualizzazione come CSV",
                "SAVE_AS_IMAGE": "Salva visualizzazione come immagine",
                "SAVE_CONFIRMATION": "Salva conferma",
                "SAVE_PAGE_AS_ELLIPSIS": "Esporta pagina come...",
                "SAVE_SETTINGS": "Salva impostazioni",
                "SCHEDULE_REPORT_EMAIL": "Pianifica invio rapporto tramite e-mail",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "Pianifica invio rapporto tramite e-mail...",
                "SEARCH_ELLIPSIS": "Cerca...",
                "SEARCH_PAGES": "Cerca domande",
                "SEARCH_PAGES_ELLIPSIS": "Cerca pagine...",
                "SEARCH_REPORTS_ELLIPSIS": "Cerca rapporto...",
                "SELECTED": "Selezionato:",
                "SELECT_ALL": "Seleziona tutto",
                "SELECT_A_FIELD": "Seleziona un campo",
                "SELECT_A_WIDGET": "Seleziona una visualizzazione",
                "SELECT_PAGES": "Seleziona le pagine",
                "SELECT_PAGES_ELLIPSIS": "Seleziona le pagine...",
                "SEND": "Invia il sondaggio tramite e-mail",
                "SEND_TEST_EMAIL": "Invia e-mail di prova",
                "SETTING_DEFAULT": "Impostazione predefinita",
                "SETTING_HIGH": "Alto",
                "SETTING_LARGE": "Grande",
                "SETTING_LOW": "Basso",
                "SETTING_NORMAL": "Normale",
                "SETTING_SMALL": "Piccolo",
                "SHARE_REPORT": "Condividi rapporto",
                "SHOW_ALL_PAGES": "Mostra tutte le pagine",
                "SHOW_FULL_QTEXT": "Mostra il testo completo della domanda nei titoli di pagina",
                "SIMPLE_TABLE": "Tabella semplice",
                "SIMPLE_TABLE_DESC": "Tabella flessibile che può mostrare più valori come righe o colonne.",
                "SIZE": "Dimensione",
                "SPLINE_CHART": "Grafico spline",
                "SPLINE_CHART_DESC": "Grafico a linee arrotondate a due assi comunemente utilizzato per una rappresentazione grafica rispetto al tempo sull'asse x.",
                "STATISTICS_TABLE": "Tabella statistiche",
                "SUBJECT": "Oggetto",
                "SURVEY_ANALYSIS": "Analisi sondaggio",
                "SURVEY_SUMMARY": "Riepilogo sondaggio",
                "TABLE": "DESCRIZIONE PER LA TABELLA",
                "TIME": "Ora",
                "TO": "A",
                "TOTAL": "Totale",
                "TRANSPOSE_STATS_TABLES": "Trasponi tabelle statistiche",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "Trasponi suddivisioni tabella statistiche",
                "TRUNCATE_PAGE_TITLES": "Tronca il testo della domanda nei titoli di pagina",
                "TRY_IT_NOW": "Prova ora",
                "TYPE": "Tipo",
                "UNABLE_TO_CHECK_SPF": "Impossibile controllare il record SPF. Riprovare.",
                "UNAUTHORIZED": "Non è permesso esaminare questo rapporto. Contatta il proprietario per accedere.",
                "UNHIDE_PAGE": "Scopri pagina",
                "UPDATE": "Aggiorna",
                "UPDATED_SUCCESSFULLY": "Aggiornamento eseguito correttamente.",
                "UPDATE_ALL_IN_THIS_PROJECT": "Aggiorna tutto in questo progetto",
                "UPDATE_ALL_PROJECTS": "Aggiorna tutti i progetti",
                "UPDATE_NOW": "Aggiorna ora",
                "UPDATE_REPORTS": "Aggiorna rapporti...",
                "UPDATE_REPORT_ELEMENTS": "Aggiorna i collegamenti al rapporto pubblico e le e-mail dei rapporti pianificate",
                "UPGRADE_MY_ACCOUNT": "Aggiorna il mio account",
                "USE_EXPORT_TAGS": "Includi numeri domande",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "Utilizzare Totali di colonna tabella semplice",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "Utilizzare Conteggi partecipanti tabella semplice",
                "USE_WEIGHTED_METRICS": "Usa metriche ponderate",
                "VIEW": "Visualizza",
                "WEEKLY": "Settimanalmente",
                "WELCOME_TO_NEW_RESULTS": "Benvenuto nei rapporti della piattaforma Qualtrics XM!",
                "WHEN": "Quando",
                "WIDGET_LOADING": "Caricamento...",
                "WIDGET_OPTIONS_ERR": "Impossibile caricare le opzioni di visualizzazione",
                "WIDGET_TYPE": "Visualizzazione",
                "WORD_CLOUD": "Word cloud",
                "WORD_CLOUD_DESC": "Una visualizzazione ponderata delle frequenza delle parole nei dati di testo con opzioni aggiuntive di codifica dei colori."
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Ricorda che all’interno della tua organizzazione sono presenti delle risorse che possono aiutarti a interpretare il tuo feedback, come i partner HR, il tuo manager e/o un mentore.",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Preparati un caffè e tuffati nel feedback.",
                "ABOUT_YOUR_REPORT_HEADER": "Informazioni relative al tuo rapporto",
                "ABOUT_YOUR_REPORT_LINE1": "Benvenuto/a al tuo rapporto di feedback 360. Si tratta di una fantastica opportunità per crescere e svilupparti come professionista. Se vuoi preparati al successo quando esamini i risultati, concediti del tempo sufficiente per leggere il feedback. All’inizio il primo approccio potrebbe essere difficile, ma ricordati che lo scopo di questo feedback è accelerare la tua crescita e il tuo sviluppo personale.",
                "ABOUT_YOUR_REPORT_LINE2": "Qui sono elencate alcune cose da tenere a mente quando esamini il tuo rapporto.",
                "ADD_CONDITIONAL_TEXT": "Aggiungi testo condizionale",
                "ADD_CUSTOM_PALETTE": "Aggiungi tavolozza personalizzata",
                "ADD_DATA_SOURCE": "Aggiunti origine dati",
                "ADD_FOLLOWING": "Aggiungi quanto segue",
                "ADD_LABEL": "Aggiungi etichetta",
                "ADVANCED_FILTER": "Filtro avanzato",
                "AGREEMENT_CHART": "Grafico accordo",
                "AGREEMENT_CHART_FOOTER": "Il grafico dell’accordo indica le analogie nei punteggi. Ogni punto rappresenta il modo in cui le persone ti hanno valutato per ogni voce. La dimensione del punto indica quanti valutatori ti hanno assegnato una valutazione specifica.",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "risposte",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "risposta",
                "AGREEMENT_CHART_LEGEND_TITLE": "Come gli altri ti hanno valutato",
                "ALL": "Tutto",
                "AND_IF": "E se",
                "ANGLED": "Angolato",
                "AREA": "Area",
                "AUTO": "Auto",
                "AVERAGE": "Media",
                "AXIS_VALUES": "Valori asse",
                "BAR": "Barra",
                "BASE_WORD_COLOR": "Colore parola base",
                "BLUR": "Annebbiato",
                "BOTTOM_BOX": "Casella inferiore",
                "BREAKOUT_HEADERS": "Intestazioni suddivisione",
                "CANCEL": "Annullare",
                "CATEGORICAL": "Categorico",
                "CATEGORY": "Categoria",
                "CATEGORY_NAME": "Nome categoria",
                "CHANGE_CATEGORIES_ORDER": "Modifica ordine di categorie",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "Modifica l'ordine delle categorie di punteggio",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "Cambia l'ordine che compare nella visualizzazione facendo clic sulla sinistra dell'elemento della categoria di punteggio e trascinandolo nella posizione desiderata.",
                "CHANGE_QUESTIONS_ORDER": "Modifica ordine di domande",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "Modifica l'ordine di domande",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "Cambia l'ordine che compare nella visualizzazione facendo clic sulla sinistra dell'elemento della categoria di punteggio e trascinandolo nella posizione desiderata.",
                "CHARTS": "Grafici",
                "CHART_TYPE": "Tipo di grafico",
                "CHOICE_COUNT": "Conteggio scelte",
                "CHOICE_TOTALS": "Totali della scelta",
                "CLEAR": "Cancella",
                "CLOSE": "Chiudi",
                "COLOR_PALETTE": "Tavolozza colori",
                "COLUMN_NAMES": "Nomi delle colonne",
                "COLUMN_TOTALS": "Totali della colonna",
                "COMPARED_FILTER_GROUP": "Gruppo di filtri confrontati",
                "COMPARED_FILTER_GROUPS": "Gruppi di filtro confrontati",
                "COMPARE_WITH": "Confronta con",
                "COMPETITION_RANKING": "Utilizza classificazione della concorrenza",
                "COMPETITION_RANKING_TOOLTIP": "Nell'evento di un pareggio, da tutti i punteggi uguali risulta la stessa classificazione. Tuttavia, l'elemento successivo verrà classificato uguale a: totale degli elementi classificati in posizione più elevata nella tabella più uno.",
                "COMPLETED_RESPONSES": "Risposte complete",
                "CONDITIONAL_TEXT": "Testo condizionale",
                "COUNT": "Conteggio",
                "CREATE": "Crea",
                "CUSTOM_PALETTE": "Tavolozza personalizzata",
                "DATA_SOURCE_TYPE": "Tipo di origine dati",
                "DATA_SOURCE_TYPE_CATEGORY": "Categorie di punteggio",
                "DATA_SOURCE_TYPE_QUESTION": "Domande",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "Domanda",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "Elementi classificabili",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "Categoria di punteggio",
                "DEFAULT": "Impostazione predefinita",
                "DEFAULT_TEXT": "Testo predefinito",
                "DELETE": "Elimina",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "Cerca di capire chi ha compilato il feedback, se si tratta di colleghi, riporti diretti, responsabili, ecc.",
                "DIFFERENT_EVALUATORS_HEADER": "Valutatori diversi",
                "DIRECT_REPORTS": "Riporti diretti",
                "DISABLED": "Disabilitato",
                "DISPLAY_OPTIONS": "Opzioni di visualizzazione",
                "DISPLAY_THRESHOLD_TEXTS": "Visualizza il testo in base al gap dei seguenti gruppi",
                "DIVERGENT": "Divergente",
                "DONE": "Fatto",
                "DONT_HEADER": "Non devi:",
                "DONT_LINE1": "Cercare di capire chi ha detto cosa",
                "DONT_LINE2": "Concentrarti su un punteggio/commento positivo o negativo",
                "DONT_LINE3": "Creare un piano di sviluppo per ogni voce",
                "DONT_LINE4": "Scoraggiarti sulle opportunità di miglioramento di cui disponi",
                "DONUT": "Donut",
                "DOWNLOAD_CSV": "Scarica CSV legacy",
                "DOWNLOAD_ZIP": "Scarica tutti i file",
                "DO_HEADER": "Devi:",
                "DO_LINE1": "Considerare il feedback in modo olistico",
                "DO_LINE2": "Identificare i temi in punti di forza e opportunità di miglioramento",
                "DO_LINE3": "Dare la priorità ad alcune aree di interesse da aggiungere al tuo piano di sviluppo",
                "DO_LINE4": "Capire che tutti dispongono di opportunità di miglioramento",
                "DROPOFF": "Abbandono",
                "DUPLICATE": "Duplicato",
                "EDIT_CONDITIONAL_TEXT": "Modifica testo condizionale",
                "EDIT_CUSTOM_PALETTE": "Modifica tavolozza personalizzata",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "Altrimenti mostra il seguente testo",
                "ENABLED": "Abilitato",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "Abilita la classificazione per logica di visualizzazione categoria valutatore",
                "ENABLE_ORDERING_FOR": "Abilita la classificazione per",
                "EQUAL_TO": "Uguale a",
                "FIELD": "Campo",
                "FILTER_NAMES": "Nomi del filtro",
                "FOLLOWING_PARENTHESES": "(seguente)",
                "FOOTER": "Piè di pagina",
                "GAP": "Gap",
                "GAP_CHART": "Grafico delle differenze",
                "GAP_CHART_DESCRIPTION": "Il grafico delle differenze mostra la differenza nei punteggi tra due gruppi di valutatori. Ad esempio, nel caso di autovalutazioni rispetto a come sei stato valutato da altri, una differenza positiva (+) significa che gli altri ti hanno assegnato una valutazione migliore della tua stessa valutazione. Una differenza negativa (-) significa che gli altri ti hanno assegnato una valutazione peggiore della tua stessa valutazione.",
                "GAP_CHART_FOOTER": "Il precedente grafico mostra la differenza +/- tra due gruppi di valutatori.",
                "GAP_TABLE_DESCRIPTION": "I punti di forza nascosti mostrano dove gli altri ti hanno valutato/a meglio di quanto tu abbia valutato/a te stesso/a. Le aree di miglioramento mostrano dove gli altri ti hanno valutato/a peggio di quanto tu abbia valutato/a te stesso/a. Entrambe le sezioni sono classificate dalla differenza più grande alla più piccola.",
                "GAP_TABLE_FOOTER": "La prima colonna di punteggi indica in che modo hai valutato te stesso/a. La seconda colonna indica il punteggio medio degli altri. La terza colonna indica la differenza tra la tua valutazione di te stesso/a e in che modo sei stato valutato dagli altri.",
                "GAP_TABLE_TITLE": "Punti di forza nascosti/Aree di miglioramento",
                "GREATER_OR_EQUAL": "Maggiore o uguale",
                "GREATER_THAN": "Maggiore di",
                "GROUP": "Gruppo",
                "GROUPED_FOR_ANONYMITY": "Raggruppato per l'anonimato",
                "HEADER_NAMES": "Nomi delle intestazioni",
                "HIGHEST_SCORES": "Punteggi più alti",
                "HIGHLIGHT_THRESHOLD": "Soglia per evidenziare le differenze",
                "HIGHLOW_TABLE": "Punteggi alti e bassi",
                "HIGHLOW_TABLE_FOOTER": "Questa sezione mostra i cinque comportamenti con punteggio più alto e più basso (tra tutti i comportamenti) rispetto alle medie applicabili dei valutatori di categoria. Per ottenere il massimo da questa pagina, è utile osservare le tendenze che potrebbero emergere. Ad esempio, se la maggior parte dei comportamenti con il punteggio più basso è concentrata in una o due categorie; queste potrebbero essere aree che necessitano di sviluppo. I comportamenti più votati possono identificare punti di forza che possono essere sfruttati in altre aree.",
                "HIGH_LOW_TABLE_DESCRIPTION": "Il grafico meglio/peggio visualizza le voci in base alle aree in cui gli altri ti hanno assegnato le valutazioni migliori e peggiori.",
                "HORIZONTAL": "Orizzontale",
                "HORIZONTAL_AND_VERTICAL": "Orizzontale e verticale",
                "HORIZONTAL_BAR": "Barra orizzontale",
                "HOW_TO_INTERPRET_RESULT_HEADER": "Come interpretare i risultati e determinare le azioni:",
                "IF": "Se",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "Includi etichette nascoste in percentuali",
                "INNER_RIM": "Bordo interno",
                "IS": "È",
                "IS_NOT": "Non è",
                "IS_SAME_AS_SUBJECT": "È uguale al soggetto valutazione",
                "ITEM": "Elemento",
                "LABEL": "etichetta",
                "LABELS": "Etichette",
                "LARGE_LABELS": "Etichette grandi",
                "LEGEND": "Legenda",
                "LEGEND_POSITION": "Posizione legenda",
                "LEGEND_VALUES": "Valori legenda",
                "LESS_OR_EQUAL": "Minore o uguale",
                "LESS_THAN": "Minore di",
                "LINE": "Linea",
                "LOWEST_SCORES": "Punteggi più bassi",
                "MANAGERS": "Manager",
                "MANUAL_FONT_SIZE": "Imposta manualmente la dimensione del carattere",
                "MAX": "Max",
                "MEAN": "Media",
                "MEDIAN": "Mediano",
                "METRIC_TYPE": "Tipo di metrica",
                "MIN": "Min",
                "MODIFY_CUSTOM_PALETTES": "Modifica tavolozze personalizzate",
                "MOVE_DOWN": "Sposta giù",
                "MOVE_UP": "Sposta su",
                "MULTI_SELECT_ITEMS_SELECTED": "Selezionato/i",
                "NEGATIVE_GAPS": "Aree di miglioramento",
                "NO": "No",
                "NONE": "Nessuno",
                "NOT_APPLICABLE": "N/D",
                "NOT_EQUAL_TO": "Non uguale a",
                "NO_DATA_AVAILABLE_WARNING": "Nessun dato disponibile",
                "NO_FILTER": "Nessun filtro",
                "NO_FILTER_IS_APPLIED": "Non è stato applicato alcun filtro.",
                "NO_VALUE": "Nessun valore",
                "NPS": "Net Promoter Score®",
                "NUMBER": "numero",
                "NUMBERS": "Numeri",
                "NUMBER_OF_GAPS_NEGATIVE": "Numero di lacune negative",
                "NUMBER_OF_GAPS_POSITIVE": "Numero di lacune positive",
                "NUMBER_OF_ROWS_HIGH": "Numero di righe alte",
                "NUMBER_OF_ROWS_LOW": "Numero di righe basse",
                "OPTIONS": {
                    "HEADER_NAME": "Nome intestazione",
                    "LEGEND": "Legenda",
                    "SCALE_AXIS_CHANGER_TITLE": "Intervallo"
                },
                "ORIENTATION": "Orientamento",
                "OR_IF": "O se",
                "OTHER": "Altro",
                "OTHERS": "Altri",
                "PAGE_OF": "Pagina: %1 di %2",
                "PALETTE_REMOVED": "Tavolozza rimossa",
                "PEERS": "Collega",
                "PERCENT": "Percento",
                "PERCENTAGE": "Percentuale",
                "PERCENTAGE_OF_CHOICES": "Percentuale di scelte",
                "PERCENTAGE_OF_RESPONSES": "Percentuale di risposte",
                "PERCENT_COMPLETE": "% completo",
                "PERSON_METADATA": "Metadati persona",
                "PERSON_METADATA_EVALUATOR": "Del valutatore",
                "PERSON_METADATA_SUBJECT": "Del soggetto valutazione",
                "PERSON_METADATA_VIEWER": "Del visualizzatore",
                "POSITIVE_GAPS": "Punti di forza nascosti",
                "PRIMARY_PARENTHESES": "(primario)",
                "QUESTIONS": "Domande",
                "RADIUS": "Raggio",
                "RANK": "Classificazione",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "Punteggio più alto",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "Punteggi più alti",
                "RANKABLE_ITEMS_ITEM_HAS": "L'elemento ha",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "L'elemento è in alto",
                "RANKABLE_ITEMS_LOWEST_SCORE": "Punteggio più basso",
                "RANKABLE_ITEMS_LOWEST_SCORES": "Punteggi più bassi",
                "RATER_CATEGORY_DISPLAY_LOGIC": "Logica di visualizzazione categoria valutatore",
                "RATIO": "Rapporto",
                "RECORD": "Registrazione",
                "REFERENCE_GROUP": "Gruppo di riferimento",
                "RELATIONSHIP": "Relazione",
                "RELATIONSHIP_FILTERS": "Filtri delle relazioni",
                "RELATIONSHIP_FILTERS_INFO": "Per aggiungere un filtro della relazione (come un riporto diretto, collega o manager), seleziona Gestisci i tuoi filtri e utilizza la condizione Relazione solo dal menu a discesa.",
                "REMOVE": "Rimuovi",
                "REMOVE_DATA_SOURCE": "Rimuovi origine dati",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Ricorda che all’interno della tua organizzazione sono presenti delle risorse che possono aiutarti a interpretare il tuo feedback, come i partner HR, il tuo manager e/o un mentore.",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Preparati un caffè e tuffati nel feedback.",
                    "ABOUT_YOUR_REPORT_HEADER": "Informazioni relative al tuo rapporto",
                    "ABOUT_YOUR_REPORT_LINE1": "Benvenuto/a al tuo rapporto di feedback 360. Si tratta di una fantastica opportunità per crescere e svilupparti come professionista. Se vuoi preparart al successo quando esamini i risultati, concediti del tempo sufficiente per leggere il feedback. All’inizio il primo approccio potrebbe essere difficile, ma ricordati che lo scopo di questo feedback è accelerare la tua crescita e il tuo sviluppo personale.",
                    "ABOUT_YOUR_REPORT_LINE2": "Qui sono elencate alcune cose da tenere a mente quando esamini il tuo rapporto.",
                    "ADVANCED_FILTER": "Filtro avanzato",
                    "AGREEMENT_CHART": "Grafico accordo",
                    "AGREEMENT_CHART_FOOTER": "Il grafico dell’accordo indica le analogie nei punteggi. Ogni punto rappresenta il modo in cui le persone ti hanno valutato per ogni voce. La dimensione del punto indica quanti valutatori ti hanno assegnato una valutazione specifica.",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "risposte",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "risposta",
                    "AGREEMENT_CHART_LEGEND_TITLE": "Come gli altri ti hanno valutato",
                    "ALL": "Tutto",
                    "AVERAGE": "Media",
                    "BOTTOM_BOX": "Casella inferiore",
                    "CHOICE_COUNT": "Conteggio scelte",
                    "CHOICE_TOTALS": "Totali della scelta",
                    "COMPARISON": "Confronto",
                    "COMPARISON_GAP_COLUMN_HEADER": "Gap di confronto",
                    "COMPLETED_RESPONSES": "Risposte complete",
                    "COUNT": "Conteggio",
                    "DEFAULT": "Impostazione predefinita",
                    "DEFAULT_TEXT": "Testo predefinito",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "Cerca di capire chi ha compilato il feedback, se si tratta di colleghi, riporti diretti, responsabili, ecc.",
                    "DIFFERENT_EVALUATORS_HEADER": "Valutatori diversi",
                    "DONE": "Fatto",
                    "DONT_HEADER": "Non devi:",
                    "DONT_LINE1": "Cercare di capire chi ha detto cosa",
                    "DONT_LINE2": "Concentrarti su un punteggio/commento positivo o negativo",
                    "DONT_LINE3": "Creare un piano di sviluppo per ogni voce",
                    "DONT_LINE4": "Scoraggiarti sulle opportunità di miglioramento di cui disponi",
                    "DO_HEADER": "Devi:",
                    "DO_LINE1": "Considerare il feedback in modo olistico",
                    "DO_LINE2": "Identificare i temi in punti di forza e opportunità di miglioramento",
                    "DO_LINE3": "Dare la priorità ad alcune aree di interesse da aggiungere al tuo piano di sviluppo",
                    "DO_LINE4": "Capire che tutti dispongono di opportunità di miglioramento",
                    "FIELD": "Campo",
                    "GAP": "Gap",
                    "GAP_CHART": "Grafico delle differenze",
                    "GAP_CHART_DESCRIPTION": "Il grafico delle differenze mostra la differenza nei punteggi tra due gruppi di valutatori. Ad esempio, nel caso di autovalutazioni rispetto a come sei stato valutato da altri, una differenza positiva (+) significa che gli altri ti hanno assegnato una valutazione migliore della tua stessa valutazione. Una differenza negativa (-) significa che gli altri ti hanno assegnato una valutazione peggiore della tua stessa valutazione.",
                    "GAP_CHART_FOOTER": "Il grafico mostra la differenza +/- tra due gruppi di valutatori.",
                    "GAP_TABLE_DESCRIPTION": "I punti di forza nascosti mostrano dove gli altri ti hanno valutato/a meglio di quanto tu abbia valutato/a te stesso/a. Le aree di miglioramento mostrano dove gli altri ti hanno valutato/a peggio di quanto tu abbia valutato/a te stesso/a. Entrambe le sezioni sono classificate dalla differenza più grande alla più piccola.",
                    "GAP_TABLE_FOOTER": "La prima colonna di punteggi indica in che modo hai valutato te stesso/a. La seconda colonna indica il punteggio medio degli altri. La terza colonna indica la differenza tra la tua valutazione di te stesso/a e in che modo sei stato valutato dagli altri.",
                    "GAP_TABLE_TITLE": "Punti di forza nascosti/Aree di miglioramento",
                    "GROUP": "Gruppo",
                    "HIDE_REPORT_ALERT": "I requisiti per visualizzare il rapporto non sono soddisfatti. Contattare l'amministratore dell'organizzazione.",
                    "HIGHEST_SCORES": "Punteggi più alti",
                    "HIGHLOW_TABLE": "Punteggi alti e bassi",
                    "HIGHLOW_TABLE_FOOTER": "Questa sezione mostra i cinque comportamenti con punteggio più alto e più basso (tra tutti i comportamenti) rispetto alle medie applicabili dei valutatori di categoria. Per ottenere il massimo da questa pagina, è utile osservare le tendenze che potrebbero emergere. Ad esempio, se la maggior parte dei comportamenti con il punteggio più basso è concentrata in una o due categorie; queste potrebbero essere aree che necessitano di sviluppo. I comportamenti più votati possono identificare punti di forza che possono essere sfruttati in altre aree.",
                    "HIGH_LOW_TABLE_DESCRIPTION": "Il grafico meglio/peggio visualizza le voci in base alle aree in cui gli altri ti hanno assegnato le valutazioni migliori e peggiori.",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "Come interpretare i risultati e determinare le azioni:",
                    "ITEM": "Elemento",
                    "LOWEST_SCORES": "Punteggi più bassi",
                    "MAX": "Max",
                    "MEAN": "Media",
                    "MEDIAN": "Mediano",
                    "MIN": "Min",
                    "NEGATIVE_GAPS": "Aree di miglioramento",
                    "NO_COMPARISON_SET": "Nessun gruppo di confronto",
                    "NO_DATA_AVAILABLE_WARNING": "Nessun dato disponibile",
                    "NO_FILTER_IS_APPLIED": "Non è stato applicato alcun filtro.",
                    "NO_VALUE": "Nessun valore",
                    "NPS": "Net Promoter Score",
                    "OTHERS": "Altri",
                    "PERCENTAGE": "Percentuale",
                    "PERCENTAGE_OF_CHOICES": "Percentuale di scelte",
                    "PERCENTAGE_OF_RESPONSES": "Percentuale di risposte",
                    "PERCENT_COMPLETE": "% completo",
                    "POSITIVE_GAPS": "Punti di forza nascosti",
                    "QUESTIONS": "Domande",
                    "RANK": "Classificazione",
                    "RELATIONSHIPS": {
                        "ANYONE": "Chiunque",
                        "DIRECT_REPORT": "Riporto diretto",
                        "MANAGER": "Manager",
                        "PEER": "Collega",
                        "SELF": "Autonomo/a"
                    },
                    "REPORT_SUMMARY": "Riepilogo rapporto",
                    "REPORT_SUMMARY_TABLE_FOOTER": "Confronta il numero di persone che hanno terminato la tua valutazione rispetto al numero di persone invitate a partecipare.",
                    "REPORT_SUMMARY_TABLE_HEADER": "Statistiche degli intervistati",
                    "RESPONSES": "Risposte",
                    "RESPONSE_COUNT": "{{responseCount}} risposte",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Risposte",
                    "SCORING_CATEGORY": "Categoria di punteggio",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Nessuna risposta per questa categoria",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Nessuna risposta per questa domanda",
                    "SCORING_OVERVIEW": "Panoramica di punteggio",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "Tu e altri valutatori credete che quest’area rappresenti una forza importante.",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Punto di forza riconosciuto",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Un'area di miglioramento riconosciuta significa che l’autovalutazione e le valutazioni degli altri sono entrambe al di sotto della media per questa competenza.",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Area di miglioramento riconosciuta",
                    "SCORING_OVERVIEW_DESCRIPTION": "In alto sono elencati le competenze o i comportamenti per i quali sei stato valutato/a come parte di questo processo di feedback a più valutatori. Le valutazioni di confronto sono fornite in base al gruppo.",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "Gap minimo",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Differenza minima tra gruppi di riferimento e testi da visualizzare.",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "Viene visualizzato l’intervallo di punteggi per ogni competenza/comportamento. La barra rappresenta la media numerica.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "La forza non riconosciuta proviene dalla differenza tra l’autovalutazione e le valutazioni degli altri.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Forza non riconosciuta",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Un'area di miglioramento non riconosciuta deriva dalla discrepanza tra l’autovalutazione e le valutazioni degli altri.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Area di miglioramento non riconosciuta",
                    "SELF": "Autonoma",
                    "SELF_ASSESSMENT": "Autovalutazione",
                    "STANDARD_DEVIATION": "Scostamento standard",
                    "SUM": "Somma",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Familiarizza con la scala di valutazione per garantire un’interpretazione accurata",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "Prendi nota della scala",
                    "THINGS_YOU_WILL_SEE_HEADER": "Le cose che vedrai:",
                    "THREE_SIXTY_PERCENTILE": "Percentile",
                    "TOP_BOTTOM_BOX": "Casella superiore / Casella inferiore",
                    "TOP_BOX": "Casella superiore",
                    "TOTAL": "Totale",
                    "TO_DO": "Da fare",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Qualitativo: questo feedback si presenterà sotto forma di commenti a testo aperto",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Quantitativo: questo feedback sarà numerico e potrebbe essere rappresentato in grafici, grafici a barre, tabelle, ecc.",
                    "TYPES_OF_FEEDBACK_HEADER": "Vari tipi di feedback",
                    "VALUE": "Valore",
                    "VARIANCE": "Varianza",
                    "YOUR_RATINGS": "Le tue valutazioni"
                },
                "REPORT_SUMMARY": "Riepilogo rapporto",
                "REPORT_SUMMARY_TABLE_FOOTER": "Confronta il numero di persone che hanno terminato la tua valutazione rispetto al numero di persone invitate a partecipare.",
                "REPORT_SUMMARY_TABLE_HEADER": "Statistiche degli intervistati",
                "RESET": "Reimposta",
                "RESPONDENT_TOTALS": "Totali partecipante",
                "RESPONSES": "Risposte",
                "RESPONSE_COUNT": "{{responseCount}} risposte",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Risposte",
                "RESULT": "Risultato",
                "REVERSE_COLORS": "Inverti colori",
                "ROW_TOTALS": "Totali riga",
                "SAVE": "Salva",
                "SAVE_AND_APPLY": "Salva e applica",
                "SCORING_CATEGORY": "Categoria di punteggio",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Nessuna risposta per questa categoria",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Nessuna risposta per questa domanda",
                "SCORING_OVERVIEW": "Panoramica di punteggio",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "Tu e gli altri valutatori credete che quest’area rappresenti una forza importante.",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Punto di forza riconosciuto",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Un'area di miglioramento riconosciuta significa che l’autovalutazione e le valutazioni degli altri sono entrambe al di sotto della media per questa competenza.",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Area di miglioramento riconosciuta",
                "SCORING_OVERVIEW_DESCRIPTION": "In alto sono elencati le competenze o i comportamenti per i quali sei stato valutato/a come parte di questo processo di feedback a più valutatori. Le valutazioni di confronto sono fornite in base al gruppo.",
                "SCORING_OVERVIEW_MINIMUM_GAP": "Gap minimo",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Differenza minima tra gruppi di riferimento e testi da visualizzare.",
                "SCORING_OVERVIEW_TABLE_FOOTER": "Viene visualizzato l’intervallo di punteggi per ogni competenza/comportamento. La barra rappresenta la media numerica.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "La forza non riconosciuta proviene dalla differenza tra l’autovalutazione e le valutazioni degli altri.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Forza non riconosciuta",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Un'area di miglioramento non riconosciuta deriva dalla discrepanza tra l’autovalutazione e le valutazioni degli altri.",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Area di miglioramento non riconosciuta",
                "SELECT_CATEGORIES": "Selezionare categorie di punteggio...",
                "SELECT_CATEGORY": "Selezionare una categoria di punteggio…",
                "SELECT_CONDITION_TYPE": "Seleziona il tipo di condizione",
                "SELECT_DATA_SOURCE": "Seleziona origine dati",
                "SELECT_DATA_SOURCE_TYPE": "Seleziona tipo di origine dati",
                "SELECT_FILTER": "Seleziona filtro",
                "SELECT_FILTERS": "Seleziona filtri",
                "SELECT_OPERATOR_TYPE": "Seleziona tipo di operatore",
                "SELECT_PERSON": "Seleziona persona",
                "SELECT_PERSON_METADATA": "Seleziona metadati della persona",
                "SELECT_QUESTION": "Seleziona la domanda",
                "SELECT_QUESTIONS": "Selezionare le domande…",
                "SELECT_RATIO_OR_DROPOFF": "Seleziona rapporto o abbandono",
                "SELECT_RELATIONSHIP": "Seleziona la relazione",
                "SELECT_SCORING_CATEGORY": "Seleziona la categoria di punteggio",
                "SELF": "Autonoma",
                "SELF_ASSESSMENT": "Autovalutazione",
                "SEQUENTIAL": "Sequenziale",
                "SETUP_COMPARISON": "Configura confronto",
                "SETUP_COMPARISONS": "Configura confronti",
                "SET_START_COLOR": "Imposta colore iniziale",
                "SHOULD_SHOW_FOOTER": "Mostra piè di pagina",
                "SHOULD_SHOW_SCORING_CATEGORY": "Mostra categoria di punteggio",
                "SHOWING_RECORDS_OF": "Visualizzazione di %1 - %2 record di %3",
                "SHOW_COMPARISON_GAP": "Mostra colonna gap di confronto",
                "SHOW_DATA_LABEL": "Mostra valori dati",
                "SHOW_PERCENTAGES": "Mostra percentuali",
                "SHOW_THE_FOLLOWING_TEXT": "Quindi mostra il seguente testo",
                "SHOW_TIES": "Mostra pareggi",
                "SHOW_X_AXIS": "Mostra asse X",
                "SHOW_Y_AXIS": "Mostra asse Y",
                "SMALL_LABELS": "Etichette piccole",
                "SORT": "Ordina",
                "SPLINE": "Spline",
                "STACK_CHART": "Grafico a barre in pila",
                "STANDARD_DEVIATION": "Scostamento standard",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "Debolezza meno di",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "Modifica testi valore soglia",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "Testi valore soglia",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "Abilita i testi valore soglia",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "Forza più di",
                "SUM": "Somma",
                "SUMMARY": "Riepilogo",
                "TABLES": "Tabelle",
                "TABLE_TOTALS": "Totali della tabella",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Familiarizza con la scala di valutazione per garantire un’interpretazione accurata",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "Prendi nota della scala",
                "TEXT": "Testo",
                "THINGS_YOU_WILL_SEE_HEADER": "Le cose che vedrai:",
                "TOP_BOTTOM_BOX": "Casella superiore / Casella inferiore",
                "TOP_BOX": "Casella superiore",
                "TOTAL": "Totale",
                "TOTAL_COUNTS": "Conteggi totali",
                "TO_DO": "Da fare",
                "TRANSPOSE": "Trasponi",
                "TRANSPOSE_TABLE": "Trasponi tabella",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Qualitativo: questo feedback si presenterà sotto forma di commenti a testo aperto",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Quantitativo: questo feedback sarà numerico e potrebbe essere rappresentato in grafici, grafici a barre, tabelle, ecc.",
                "TYPES_OF_FEEDBACK_HEADER": "Vari tipi di feedback",
                "UNDO": "Annulla",
                "USE_COMPARISON": "Usa il confronto",
                "USE_LABELS_FOR_SCALES": "Usa etichette per scale",
                "VALUES": "Valori",
                "VALUE_RANGES": "Intervalli di valori",
                "VARIANCE": "Varianza",
                "VERTICAL": "Verticale",
                "VERTICAL_RANGE": "Intervallo verticale",
                "WARNING_DATA_OUT_OF_RANGE": "Avviso: il valore dei dati supera la configurazione dell'intervallo",
                "WIDGET_ERROR": {
                    "ERROR": "Errore imprevisto",
                    "MISCONFIGURED": "Il widget non è configurato correttamente. Controlla la configurazione del widget.",
                    "NEW": "Configurare il widget",
                    "NO_DATA": "Nessun dato trovato: i filtri potrebbero essere troppo esclusivi."
                },
                "WIDGET_NAME": {
                    "BAR": "Grafico a barre",
                    "BREAKDOWNBAR": "Barra di suddivisione",
                    "DATA_TABLE": "Tabella dati",
                    "FUNNEL_CHART": "Grafico a imbuto",
                    "GAUGE": "Grafico a indicatore",
                    "GRID": "Tabella risultati",
                    "HEATMAP": "Heat map",
                    "LINE": "Grafico a linee",
                    "NEEDS_BASED": "In base alle esigenze",
                    "PIE": "Grafico a torta",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "Stimatore di prezzi (Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "Massimizzatore di fatturato (Gabor Granger)",
                    "SCORING_OVERVIEW_CHART": "Grafico",
                    "SCORING_OVERVIEW_TABLE": "Tabella",
                    "STATS_TABLE": "Tabella statistiche",
                    "WORDCLOUD": "Word cloud"
                },
                "WORD_ROTATION": "Rotazione parole",
                "WORD_SPACING": "Spaziatura parole",
                "YES": "Sì",
                "YOUR_RATINGS": "Le tue valutazioni"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "Aggiungi",
                "ADD_A_WORD": "Aggiungi una parola",
                "COLOR": "Colore",
                "DELETE_ALL": "Elimina tutto",
                "EDIT_STOP_WORDS": "Modifica parole non significative",
                "MAX_WORDS": "Max parole",
                "ROTATION_ANGLED": "Angolato",
                "ROTATION_HORIZONTAL": "Orizzontale",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "Orizzontale e verticale",
                "WORD_ORIENTATION": "Orientamento parola"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "Colori di sfondo",
                "DISPLAY_OPTIONS": "Opzioni di visualizzazione",
                "INVERT_FONT_COLORS": "Inverti colori caratteri a basso contrasto",
                "PAGE": "Pagina",
                "PAGINATE": "Impagina"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "Media",
                "BOTTOM_BOX_METRIC": "Casella inferiore",
                "COLUMNS": "Colonne",
                "COUNT_METRIC": "Risposte totali",
                "FIELD_NAME": "Campo",
                "MAX_METRIC": "Massimo",
                "MIN_METRIC": "Minimo",
                "SHOW_RECODES": "Mostra ricodifica valori",
                "SHOW_ROW_NUMBERS": "Mostra numeri righe",
                "STD_DEV_METRIC": "Deviazione std",
                "TOP_BOX_METRIC": "Casella superiore",
                "TRANSPOSE_BREAKOUTS": "Trasponi suddivisioni",
                "TRANSPOSE_TABLE": "Trasponi tabella",
                "VAR_METRIC": "Varianza"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "Colonne aggiuntive",
                "ADD_COLUMNS": "Aggiungi altre colonne",
                "ADD_CUSTOM_PALETTE": "Aggiungi tavolozza personalizzata",
                "ALL_CHOICES": "Tutte le scelte",
                "ALL_GROUPS": "Tutti i gruppi",
                "ALL_RECODES": "Tutte le ricodifiche",
                "AUTOMATIC": "Impostazione predefinita",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "Predefinito - Fare clic per modificare.",
                "AXIS_VALUES": "Valori asse",
                "BREAKOUT_BY": "Suddivisione per",
                "CANCEL": "Annullare",
                "CATEGORICAL": "Categorico",
                "CHOICES": "Scelte",
                "CHOICE_COUNT": "Conteggio scelte",
                "COLOR_PALETTE": "Tavolozza colori",
                "COLUMN_VALUES": "Valori colonna",
                "CONTACT_FIELDS": "Campi contatto",
                "COUNT": "Conteggio",
                "CREATE": "Crea",
                "CUSTOM": "Personalizza",
                "CUSTOM_PALETTE": "Tavolozza personalizzata",
                "DATA_SOURCE": "Origine dati",
                "DAY": "Giorno",
                "DAY_OF_WEEK": "Giorno della settimana",
                "DECIMAL_PRECISION": "Posizioni decimali",
                "DEFAULT": "Impostazione predefinita",
                "DISABLED": "Disabilitato",
                "DIVERGENT": "Divergente",
                "EDIT_CUSTOM_PALETTE": "Modifica tavolozza personalizzata",
                "ENABLED": "Abilitato",
                "ERROR_LOADING_DATA": "Errore durante il caricamento dei dati",
                "FILE_SIZE": "Dimensione",
                "FILE_TYPE": "Tipo",
                "FRI": "Ven",
                "FRIDAY": "Venerdì",
                "GROUP_DATE_BY": "Raggruppa data per",
                "HOUR_OF_DAY": "Ora del giorno",
                "LENGEND_VALUES": "Valori legenda",
                "MAX": "Max",
                "MEAN": "Media",
                "MIN": "Min",
                "MISCONFIGURED_DATA": "Origine dati non configurata per questa visualizzazione.",
                "MISCONFIGURED_FILTERS": "Filtro/i non valido/i",
                "MODIFY_CUSTOM_PALETTES": "Modifica tavolozze personalizzate",
                "MON": "Lun",
                "MONDAY": "Lunedì",
                "MONTH": "Mese",
                "NONE": "Nessuno",
                "NO_FILE_ID_ERROR": "Questa visualizzazione richiede l'impostazione di un'immagine nel sondaggio",
                "NO_RESULTS_TO_SHOW": "Nessun risultato da visualizzare",
                "NPS": "Net Promoter Score®",
                "NPS_GROUP": "Gruppo NPS®",
                "NUMERIC_VALUE": "Valore numerico",
                "PALETTE_REMOVED": "Tavolozza rimossa",
                "PERCENTAGE": "Percentuale",
                "PERCENTAGE_OF_CHOICES": "Percentuale di scelte",
                "PERCENTAGE_OF_RESPONSES": "Percentuale di risposte",
                "QUARTER": "Trimestre",
                "REMOVE": "Rimuovi",
                "RESPONSE_COUNT": "Conteggio risposte",
                "RESULTS_PER_PAGE": "Risultati per pagina",
                "RETRIEVING_DATA_ELLIPSIS": "Recupero dati...",
                "REVERSE_COLORS": "Inverti colori",
                "ROW_VALUES": "Valori riga",
                "SAT": "Sab",
                "SATURDAY": "Sabato",
                "SAVE": "Salva",
                "SELECTED_CHOICE": "Scelta selezionata",
                "SELECT_FIELD": "Seleziona campo",
                "SELECT_METRIC": "Metrica",
                "SEQUENTIAL": "Sequenziale",
                "SET_START_COLOR": "Imposta colore iniziale",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "Visualizzazione dati esempio...",
                "SUM": "Somma",
                "SUN": "Dom",
                "SUNDAY": "Domenica",
                "SURVEY_EMBEDDEDDATA": "Dati incorporati",
                "SURVEY_METADATA": "Metadati del sondaggio",
                "TEXT_ENTRY": "Immissione di testo",
                "THURS": "Gio",
                "THURSDAY": "Giovedì",
                "TITLE": "Titolo",
                "TUES": "Mar",
                "TUESDAY": "Martedì",
                "UNBOUNDED_DOMAIN": "Troppi valori da visualizzare.",
                "UNBOUNDED_DOMAIN_HELP": "Per aggiungere questo campo ai Rapporti dei risultati, puoi aggiungere un filtro al rapporto in modo da visualizzare meno valori per \"{{ed_field_name}}\" o aggiornare il tipo di variabile dei dati incorporati \"{{ed_field_name}}\" nel flusso del sondaggio, in modo da rendere questo campo di tipo stringa o numerico.",
                "UNDO": "Annulla",
                "USE_CHOICE_TOTALS": "Usa totali scelte",
                "USE_RESPONDENT_TOTALS": "Usa totali partecipanti",
                "VISUALIZATION": "Visualizzazione",
                "VISUALIZATION_BARCHART": "Grafico a barre",
                "VISUALIZATION_BREAKDOWNBAR": "Barra di suddivisione",
                "VISUALIZATION_GAUGE": "Grafico a indicatore",
                "VISUALIZATION_HEATMAP": "Heat map",
                "VISUALIZATION_LINECHART": "Grafico a linee",
                "VISUALIZATION_PAGINATEDTABLE": "Tabella impaginata",
                "VISUALIZATION_PIE": "Grafico a torta",
                "VISUALIZATION_SIMPLETABLE": "Tabella semplice",
                "VISUALIZATION_STATSTABLE": "Tabella statistiche",
                "VISUALIZATION_TEXTHIGHLIGHTS": "Evidenziazioni testo",
                "VISUALIZATION_WORDCLOUD": "Word cloud",
                "WED": "Mer",
                "WEDNESDAY": "Mercoledì",
                "WEEK": "Settimana",
                "WEIGHTING": "Ponderazione",
                "WRONG_QUESTION_TYPE_ERROR": "Questo tipo di visualizzazione non può essere utilizzato per questa domanda",
                "YEAR": "Anno"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "Media",
                "CHOICE_COUNT": "Conteggio scelte",
                "COUNT": "Conteggio",
                "DISPLAY_OPTIONS": "Opzioni di visualizzazione",
                "MAX": "Massimo",
                "MIN": "Minimo",
                "NPS": "NPS®",
                "PAGE_OF": "Pagina: %1 di %2",
                "PERCENT": "Percentuale",
                "RESPONSE_COUNT": "Conteggio risposte",
                "ROWS_PER_TABLE": "Righe per tabella",
                "SHOWING_ROWS_OF": "Visualizzazione delle righe %1 - %2 di %3",
                "SHOW_PERCENTAGES": "Mostra percentuali",
                "SHOW_RECODES": "Mostra ricodifica valori",
                "SHOW_ROW_NUMBERS": "Mostra numeri righe",
                "SUM": "Somma",
                "TOTAL": "Totale",
                "TRANSPOSE": "Trasponi",
                "USE_COLUMN_TOTALS": "Usa totali colonna",
                "USE_ROW_TOTALS": "Usa totali riga",
                "VALUE": "Valore"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "Ordine crescente",
                "COUNT": "Conteggio",
                "DESCENDING": "Ordine decrescente",
                "DIAGONAL": "Diagonale",
                "DISPLAY_OPTIONS": "Opzioni di visualizzazione",
                "ERROR_COLON": "Errore:",
                "ERROR_GENERIC": "Errore durante il caricamento della visualizzazione.",
                "HORIZONTAL": "Orizzontale",
                "HORIZONTAL_BARS": "Barre orizzontali",
                "INCORRECTLY_CONFIGURED": "Scegli un valore per visualizzare la tabella",
                "LEGEND_AUTO": "Auto",
                "LEGEND_BOTTOM": "Inferiore",
                "LEGEND_INSET": "Inserto",
                "LEGEND_RIGHT": "Destro",
                "NORMALIZE_TO_PERCENTAGES": "Normalizza alle percentuali",
                "SHOW_BAR_LABELS": "Mostra etichette barre",
                "SHOW_LEGEND": "Mostra legenda",
                "SHOW_X_AXIS": "Mostra asse X",
                "SHOW_Y_AXIS": "Mostra asse Y",
                "SORT_BAR_VALUES": "Ordina valori barra",
                "STACKED_BARS": "Barre sovrapposte",
                "TRANSPOSE": "Trasponi",
                "TRUNCATE_LABELS": "Tronca etichette",
                "VERTICAL": "Verticale"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "Tutti gli altri",
                "COULD_NOT_LOAD_DATA": "Impossibile caricare i dati della configurazione specificata - provare un campo di origine diverso o un intervallo di date più ampio.",
                "GROUPING_PERCENTAGE_THRESHOLD": "Soglia percentuale di raggruppamento",
                "NO_DATA": "Nessun dato",
                "RADIUS": "Raggio interno",
                "SHOW_AS_PERCENTAGES": "Mostra come percentuali"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "Chiudi",
                "DOWNLOAD_CSV": "Scarica CSV",
                "DOWNLOAD_ZIP": "Scarica tutti i file",
                "NO_DATA": "Nessun dato",
                "PAGE_OF": "Pagina: %1 di %2",
                "RESULTS_PER_PAGE": "Risultati per pagina",
                "SHOWING_RECORDS_OF": "Visualizzazione di %1 - %2 record di %3",
                "SINGLE_RESPONSE": "Risposta singola",
                "VIEW_RESPONSE": "Visualizza risposta"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "Opzioni di visualizzazione",
                "ERROR_COLON": "Errore:",
                "ERROR_GENERIC": "Errore durante il caricamento della visualizzazione.",
                "HORIZONTAL_BARS": "Barre orizzontali",
                "INCORRECTLY_CONFIGURED": "Scegli un valore per visualizzare la tabella",
                "LEGEND_AUTO": "Auto",
                "LEGEND_BOTTOM": "Inferiore",
                "LEGEND_INSET": "Inserto",
                "LEGEND_RIGHT": "Destro",
                "NORMALIZE_TO_PERCENTAGES": "Normalizza alle percentuali",
                "SHOW_AREA": "Mostra area",
                "SHOW_LEGEND": "Mostra legenda",
                "SHOW_X_AXIS": "Mostra asse X",
                "SHOW_Y_AXIS": "Mostra asse Y",
                "SMOOTH_LINES": "Linee arrotondate",
                "SORT_X_AXIS_LABELS": "Ordina etichette asse X",
                "STACKED_BARS": "Barre sovrapposte",
                "TRANSPOSE": "Trasponi"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "Modalità blocco",
                "BLUR": "Annebbiato",
                "COULD_NOT_LOAD_DATA": "Impossibile caricare i dati della configurazione specificata - provare un campo di origine diverso o un intervallo di date più ampio.",
                "FIELD": "Campo",
                "RADIUS": "Raggio",
                "SHOW_REGIONS": "Mostra regioni",
                "SHOW_REGION_LABELS": "Mostra etichette della regione"
            },
            "GAUGEWIDGET": {
                "MAX": "Max",
                "MIN": "Min",
                "VALUE_RANGES": "Intervalli di valori"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "Etichette in basso",
                "CATEGORY_NAME": "Nome categoria",
                "ERROR_COLON": "Errore:",
                "INCLUDE_HIDDEN_GROUPS": "Includi gruppi nascosti in percentuali",
                "LARGE_LABELS": "Etichette grandi",
                "NO": "No",
                "PERCENT": "Percento",
                "RESPONSE_COUNT": "Conteggio risposte",
                "RESPONSE_COUNT_WITH_VALUE": "{{ responseCount }} risposte",
                "SMALL_LABELS": "Etichette piccole",
                "YES": "Sì"
            }
        });
        $cache.put('JA', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "アクセスコード",
                "ACCESS_CODE_PROTECTION": "アクセスコードの保護",
                "ADD": "追加",
                "ADD_BREAKOUT": "レポートの詳細区分を追加",
                "ADD_NOTE": "メモを追加",
                "ADD_SCHEDULED_REPORT": "スケジュール設定したレポートを追加",
                "ADD_WIDGET": "図表を追加",
                "ALL_PROJECTS": "すべてのプロジェクト",
                "ALL_QUESTIONS": "質問ページ",
                "ANSWER": "回答",
                "ANY_CHANGES_LOST": "Qualtrics XM Platformを終了すると、レポートに対して行われた変更が失われます。",
                "APPENDED_COPY_IN_PARENS": "（コピー）",
                "AREA_CHART": "エリアチャート",
                "AREA_CHART_DESC": "線から下の領域を塗りつぶした2軸折れ線グラフ。",
                "ATTACHMENT": "添付",
                "BACKUP_CURRENT_REPORT": "図表が影響を受ける前に、このレポートのバックアップコピーを保存してください",
                "BACKUP_CURRENT_REPORT_LINE2": "注：バックアップコピーの名前は「{{nameOfReportCopy}}」になります",
                "BACK_TO_REPORTS": "レポートに戻る",
                "BACK_TO_TOP": "トップに戻る",
                "BACK_TO_VIEW_RESULTS": "過去の表示結果に戻る",
                "BAR_CHART": "棒グラフ",
                "BAR_CHART_DESC": "軸の入れ替えやデータポイントの並べ替えといった追加構成ができる2軸の棒グラフ。",
                "BREAKDOWN_BAR_CHART": "内訳棒グラフ",
                "BREAKDOWN_BAR_CHART_DESC": "円グラフに代わるものとして、各要素の比率を視覚的に把握する目的で最もよく用いられる、水平に積み重ねられた棒グラフ。",
                "CANCEL": "キャンセル",
                "CANCEL_CONF_TEXT": "キャンセルしてもよろしいですか？<br/>変更は保存されません。",
                "CANCEL_EDITS": "編集をキャンセル",
                "CHART": "グラフ",
                "CHOICE": "選択肢",
                "CHOICES_COUNT_METRIC": "選択肢数",
                "CHOOSE_PAGES_TO_DISPLAY": "表示するページを選択",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "このレポートには{{maxReportPageCount}}ページが含まれていますが、結果に含めることができるのは{{reportSizeLimit}}ページまでです。制限内でサブセットを選択してください。",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "レポートに含められるのは最大{{reportSizeLimit}}ページです。含めるページを選択してください。",
                "CLEAR_ALL": "すべてクリア",
                "CLOSE": "閉じる",
                "CLOUD": "クラウドの説明",
                "COLLABORATED_NEW": "このアンケートの所有者はQualtrics XM Platformを使用しています。このアンケートのレポートは新しい結果を使用して編集されます。",
                "COMMA_SEPARATED_LIST": "コンマ区切りのリスト",
                "COMPACTNESS": "フォントと間隔",
                "COMPACTNESS_INFO": "この設定は、グラフ内の余白、フォントサイズ、バーサイズに影響し、ほとんどのエクスポートに適用されます。",
                "CONFIRM": "OK",
                "CONFIRM_DELETE": "削除を確認",
                "CONFIRM_DELETE_PAGE": "このページを削除してもよろしいですか？",
                "CONTINUE": "続行",
                "CONTINUE_EDITING": "編集を続行",
                "COPY": "コピー",
                "COPY_OF_REPORT_NAME": "{{nameOfCurrentReport}}のコピー",
                "COPY_REPORT": "レポートをコピー",
                "COPY_REPORT_ELLIPSIS": "レポートをコピー...",
                "COPY_TO_NEW_REPORT": "新しいレポートにコピー...",
                "CREATE": "作成",
                "CREATED": "作成済み",
                "CREATE_CUSTOM_PAGE": "カスタムページを作成",
                "CREATE_NEW_REPORT": "新しいレポートを作成",
                "CREATE_NEW_REPORT_ELLIPSIS": "新しいレポートを作成...",
                "CSV_FILE": "CSVファイル",
                "CUSTOM_PAGES": "カスタムページ",
                "DATE": "日付",
                "DEFAULT_PALETTE": "デフォルトのカラーパレット",
                "DEFAULT_REPORT": "デフォルトのレポート",
                "DEFAULT_VISUALIZATIONS": "デフォルトの図表",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "これらは、デフォルトの結果レポートの作成に使用されるデフォルトの図表タイプです。これらの設定を更新して適用すると、新しいデフォルト設定で現在のレポートが再作成されます。現在のレポートをバックアップすることもできます。",
                "DEFAULT_VISUALIZATIONS_NOTE": "注：すべての質問タイプにすべての図表タイプを利用できるわけではありません。デフォルト以外の一部の図表が自動的に代用されることがあります。",
                "DEFAULT_VISUALS_DISCLAIMER": "クアルトリクスは、このレポートを新しいデフォルトの図表設定で更新します。",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "この更新はこのレポートに掲載された{{amountOfWidgetsAffected}}個の図表に影響します。",
                "DEFAULT_VISUAL_EDIT_DETECTED": "デフォルトの図表の編集が検出されました",
                "DELETE_BUTTON": "削除",
                "DELETE_DISABLED_EXPLANATION": "貴組織がQualtrics XM Platformに完全に移行するまで、以前のレポートインターフェイスで作成されたレポートの削除は許可されません。",
                "DELETE_PAGE": "ページを削除",
                "DELETE_PAGE_ELLIPSIS": "ページを削除...",
                "DELETE_REPORT": "レポートを削除",
                "DELETE_REPORT_ELLIPSIS": "レポートを削除...",
                "DELETE_WIDGET_QUESTION": "削除しますか？",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "このフィールドは暗号化されており、並べ替えには使用できません。",
                "DISCARD_EDITS": "編集を削除",
                "DISTRIBUTION_PAUSED": "レポートの配信を一時停止しました。",
                "DONE_BUTTON": "完了",
                "DONE_EDITING": "編集を完了",
                "DOWNLOAD": "ダウンロード",
                "DOWNLOAD_AS_CSV": "CSV形式でダウンロード",
                "DOWNLOAD_AS_PDF": "PDF形式でダウンロード",
                "DOWNLOAD_FAILED": "ダウンロードに失敗しました",
                "DOWNLOAD_PREVIOUS_EXPORTS": "前回のエクスポートをダウンロード...",
                "DO_YOU_WISH_TO_DELETE": "次を削除しますか：",
                "DUPLICATE_PAGE": "シートを複製",
                "EDIT_REPORT": "レポートを編集",
                "EDIT_REPORT_ELLIPSIS": "レポートを編集...",
                "EDIT_VISUALIZATION": "図表を編集",
                "EMAIL_ADDRESS": "メールアドレス",
                "EMAIL_SENT": "送信済みメール...",
                "END_OF_REPORT": "レポートの終了",
                "ENTER_NAME": "名前を入力",
                "ERROR_COPYING": "レポートのコピーでエラーが発生しました。",
                "ERROR_DELETING": "レポートの削除でエラーが発生しました。",
                "ERROR_DELETING_EXPORT": "エクスポートの削除でエラーが発生しました。",
                "ERROR_HEADING": "エラー",
                "ERROR_PUBLISHING": "設定の保存でエラーが発生しました。",
                "ERROR_RENAMING": "レポートの名称変更でエラーが発生しました。",
                "ERROR_REQUESTING_EXPORT": "レポートのリクエストでエラーが発生しました。",
                "ERROR_SAVING_GLOBAL_OPTIONS": "共通の図表オプションの保存でエラーが発生しました。",
                "ERROR_SEND_TEST_EMAIL": "テストメールの送信でエラーが発生しました。",
                "EVERY_FRIDAY": "毎週金曜日",
                "EVERY_MONDAY": "毎週月曜日",
                "EVERY_MONTH": "毎月指定日",
                "EVERY_SATURDAY": "毎週土曜日",
                "EVERY_SUNDAY": "毎週日曜日",
                "EVERY_THURSDAY": "毎週木曜日",
                "EVERY_TUESDAY": "毎週火曜日",
                "EVERY_WEDNESDAY": "毎週水曜日",
                "EVERY_WEEK": "毎週指定曜日",
                "EXAMPLE_GROUP_NUM": "グループ{{num}}",
                "EXAMPLE_SERIES_NUM": "シリーズ{{num}}",
                "EXPORT": "エクスポート",
                "EXPORT_CSV": "CSV（コンマ区切り）",
                "EXPORT_EXCEL_SPREADSHEET": "Excelスプレッドシート",
                "EXPORT_IMAGE": "画像をエクスポート",
                "EXPORT_PAGES": "ページをエクスポート",
                "EXPORT_PDF": "PDFファイル",
                "EXPORT_PPT_SLIDES": "Powerpointスライド",
                "EXPORT_RAW_DATA": "未加工データをエクスポート",
                "EXPORT_REPORT": "レポートをエクスポート",
                "EXPORT_VISUALIZATION": "図表をエクスポート",
                "EXPORT_WORD_DOC": "Word文書",
                "FAILED_SAVE_TXT": "保存できませんでした",
                "FILTERED": "フィルタリング済み",
                "FIRST_PAGE": "最初のページ",
                "FIRST_WEEKDAY": "月の最初の平日",
                "FROM": "送信者",
                "FROM_EMAIL": "送信元アドレス",
                "FROM_NAME": "送信者名",
                "GAUGE_CHART": "ゲージチャート",
                "GAUGE_CHART_DESC": "現在の値と目標値や一連のしきい値とを比較するための、ゲージ測定器のように見えるチャートです。",
                "GENERATING_FILE": "ファイルを生成しています...",
                "GENERATING_IMAGE": "画像を生成しています...",
                "GENERATING_PDF": "PDFを生成しています...",
                "GENERIC_ERROR": "エラーが発生したため、リクエストされたプロジェクトを読み込めません。",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "共通オプション...",
                "GLOBAL_METRIC": "デフォルトの指標",
                "GLOBAL_MODAL_PAGE_TITLE": "クアルトリクスResearch Suiteの結果セクションで、共通オプションを使用して図表化した例",
                "GLOBAL_MODAL_WIDGET_TITLE": "図表のタイトル",
                "GLOBAL_OPTIONS": "共通オプション",
                "GLOBAL_PRECISION": "デフォルトの小数点以下の桁数",
                "GLOBAL_SETTINGS_APPLY": "自分のデフォルト設定を適用",
                "GLOBAL_SETTINGS_SAVE": "自分のデフォルト設定として保存",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "クアルトリクスのデフォルトを適用",
                "GROUP": "グループ",
                "HEAT_MAP_CHART": "ヒートマップグラフ",
                "HEAT_MAP_CHART_DESC": "元の画像にユーザー入力（クリック数など）の分布をマッピングして「温度」分布図のように表示する図表です。",
                "HIDDEN": "非表示",
                "HIDDEN_PAGE": "このページは非表示です。公開レポートには表示されず、レポートのエクスポートはデフォルトでは選択が解除されています。",
                "HIDE": "非表示",
                "HIDE_ALL_PAGES": "すべてのページを非表示",
                "HIDE_PAGE": "ページを非表示",
                "IMAGE_FILE": "画像ファイル",
                "INVALID_BRAND_DOMAIN": "入力したドメインはブランドの承認済みメールドメインのリストに含まれません。 ブランド管理者に連絡してください。",
                "INVALID_SPF_RECORD": "入力したドメインはクアルトリクスからのメールの受信を承認していません。これはメッセージの配信に影響します。別のドメインを使うか、問題の解決についてクアルトリクスにお問い合わせください。",
                "ISSUE_SAVING_REPORTS": "1つ以上のレポートを保存する際に問題が発生しました。やり直してください。",
                "ISSUE_SENDING_TEST": "テストメールの送信でエラーが発生しました。やり直してください。",
                "LARGE_SURVEY": "アンケートが大きすぎるため、結果が表示されません。",
                "LAST_DAY": "月の最後の日",
                "LAST_MODIFIED_COLON_WITH_DATE": "最終変更日：%1",
                "LAST_PAGE": "最後のページ",
                "LAST_WEEKDAY": "月の最後の平日",
                "LATER": "後で",
                "LEARN_MORE": "詳細を見る",
                "LINE_CHART": "線グラフ",
                "LINE_CHART_DESC": "X軸で時間の変化を表す場合によく用いられる2軸の線グラフです。",
                "LOG_OUT_WARNING": "ログイン状態を保つには、{{countdown}}秒以内に画面のどこかをクリックしてください",
                "MESSAGE": "メッセージ",
                "MONTHLY": "毎月",
                "MOVE_DOWN": "図表を下げる",
                "MOVE_PAGE_TO_BOTTOM": "下に移動",
                "MOVE_PAGE_TO_TOP": "上に移動",
                "MOVE_UP": "図表を上げる",
                "MY_SURVEYS": "自分のプロジェクト",
                "NAME": "名前",
                "NEW_CUSTOM_PAGE_NAME": "新しいカスタムページ",
                "NEW_REPORT": "新しいレポート",
                "NEXT_PAGE": "次のページ",
                "NEXT_RUN": "次の実行",
                "NO_EXPORTS": "このレポートはまだエクスポートがリクエストされていません。",
                "NO_ITEMS_TO_DISPLAY": "表示する項目がありません",
                "NO_MATCHING_CUSTOM_PAGES": "一致するカスタムページなし",
                "NO_MATCHING_PAGES": "検索でページが見つかりませんでした",
                "NO_MATCHING_REPORTS": "一致するレポートがありません。",
                "NO_PROJECT": "続行するにはプロジェクトを指定してください。",
                "NO_PROJECTS_TO_MIGRATE": "更新するプロジェクトはありません。",
                "NO_QUESTIONS": "一致する質問なし",
                "NO_RESULTS_YET": "表示する結果がまだありません。アンケートを配信して回答を集めてください。",
                "OFF": "オフ",
                "ON": "オン",
                "PAGES_SELECTED": "選択されたページ",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "この選択では、レポートに{{currentSelectedPageCount}}ページが含まれます。これは、最大許容数{{reportSizeLimit}}を超えています。範囲を狭めて選択してください。",
                "PAGES_SELECTION_INVALID_RANGE": "有効な範囲を選択してください。",
                "PAGE_OPTIONS": "ページオプション",
                "PDF_ROW_TRUNCATION_MESSAGE": "行数が多いためPDFにエクスポートできません。WordまたはCSVにエクスポートしてください",
                "PERCENTAGE_METRIC": "パーセンテージ",
                "PIE_CHART": "円グラフ",
                "PIE_CHART_DESC": "取得したデータポイント値を円形に並べて内訳を表したもので、選択した値の割合を比較するのに役立ちます。",
                "PREVIEW": "プレビュー",
                "PREVIOUS_PAGE": "前のページ",
                "PRINT_PAGE": "ページを印刷",
                "PUBLIC_LINK": "公開リンク",
                "PUBLIC_REPORT_AVAILABLE": "利用できる公開レポート",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "アクセスコード",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "アクセスコードが間違っています。やり直してください。",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "送信",
                "PUBLIC_RESULTS_LOGIN_TITLE": "公開レポートのログイン | クアルトリクス調査ソフトウェア",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "公開レポートが見つかりません。所有者に連絡して有効なリンクを確認してください。",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "公開レポートが見つかりません",
                "PUBLIC_RESULTS_NOT_UPDATED": "公開レポートリンクと予約送信済みのレポートメールは、更新されるまでQualtrics XM Platformを使用しません。",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "セッションの有効期限が切れました。公開結果レポートのプレビューを続行するにはもう一度ログインしてください。",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "期限切れのセッション",
                "PUBLIC_RESULTS_TITLE": "公開レポート",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "このページを表示する権限がありません。所有者に連絡してこの報告書を公開するように依頼してください。",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "公開レポートは未承認です",
                "PUBLISHED_LINK_GENERATING_LINK": "リンクを生成しています...",
                "PUBLISHED_REPORT_FOUND_HERE": "このレポートは次のリンクから参照できます：",
                "PUBLISH_REPORT": "公開レポートを管理",
                "PUBLISH_REPORT_ELLIPSIS": "公開レポートを管理...",
                "QUESTION": "質問",
                "RANK": "ランク",
                "REMOVE_WIDGET": "図表を削除",
                "RENAME_PAGE": "ページ名を変更",
                "RENAME_REPORT": "レポート名を変更",
                "RENAME_REPORT_ELLIPSIS": "レポート名を変更...",
                "REPLY_TO_EMAIL": "返信先メールアドレス",
                "REPORT_COLON": "レポート：",
                "REPORT_SETTINGS": "レポート設定",
                "REPORT_SETTINGS_ELLIPSIS": "レポート設定...",
                "RESPONSE_COUNTS": "回答数",
                "RESULTS_DASHBOARDS_BANNER": "改良された新バージョンのアンケート結果では、モダンでアクセスしやすいUIとデータのビジュアライゼーション、新しい分析および調査機能などをお試しいただけます。",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "リリースノート",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "最新情報を表示",
                "RESULTS_OPTIONS": "レポートオプション",
                "RESULTS_TITLE": "レポート",
                "RESUME_DISTRIBUTION": "配信を再開",
                "REVERT": "元に戻す",
                "RICH_TEXT_LIMIT_REACHED": "コンテンツ長が上限に達しました。",
                "SAVE": "保存",
                "SAVE_AND_CLOSE": "保存して終了",
                "SAVE_AS_CSV": "図表をCSV形式で保存",
                "SAVE_AS_IMAGE": "図表を画像で保存",
                "SAVE_CONFIRMATION": "確認を保存",
                "SAVE_PAGE_AS_ELLIPSIS": "ページを次の形式でエクスポート...",
                "SAVE_SETTINGS": "設定を保存",
                "SCHEDULE_REPORT_EMAIL": "レポートメールを予約送信",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "レポートメールを予約送信...",
                "SEARCH_ELLIPSIS": "検索...",
                "SEARCH_PAGES": "質問を検索",
                "SEARCH_PAGES_ELLIPSIS": "ページを検索...",
                "SEARCH_REPORTS_ELLIPSIS": "レポートを検索...",
                "SELECTED": "選択済み：",
                "SELECT_ALL": "すべて選択",
                "SELECT_A_FIELD": "フィールドを選択",
                "SELECT_A_WIDGET": "図表を選択",
                "SELECT_PAGES": "ページを選択",
                "SELECT_PAGES_ELLIPSIS": "ページを選択...",
                "SEND": "送信",
                "SEND_TEST_EMAIL": "テストメールを送信",
                "SETTING_DEFAULT": "デフォルト",
                "SETTING_HIGH": "高",
                "SETTING_LARGE": "大",
                "SETTING_LOW": "低",
                "SETTING_NORMAL": "標準",
                "SETTING_SMALL": "小",
                "SHARE_REPORT": "レポートの共有",
                "SHOW_ALL_PAGES": "すべてのページを表示",
                "SHOW_FULL_QTEXT": "ページタイトルに質問文を全文表示",
                "SIMPLE_TABLE": "標準テーブル",
                "SIMPLE_TABLE_DESC": "行や列で複数の値を表示できる自由度の高いリストです。",
                "SIZE": "サイズ",
                "SPLINE_CHART": "なめらかな曲線のチャート",
                "SPLINE_CHART_DESC": "X軸で時間の変化を表す場合によく用いられる2軸の曲線グラフです。",
                "STATISTICS_TABLE": "統計テーブル",
                "SUBJECT": "件名",
                "SURVEY_ANALYSIS": "アンケート分析",
                "SURVEY_SUMMARY": "アンケート概要",
                "TABLE": "表の説明",
                "TIME": "時間",
                "TO": "宛先",
                "TOTAL": "合計",
                "TRANSPOSE_STATS_TABLES": "統計表の行列を入れ替え",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "統計表の詳細区分を入れ替え",
                "TRUNCATE_PAGE_TITLES": "ページタイトルの質問文を省略",
                "TRY_IT_NOW": "今すぐ試す",
                "TYPE": "タイプ",
                "UNABLE_TO_CHECK_SPF": "SPFレコードを確認できません。やり直してください。",
                "UNAUTHORIZED": "レポートを表示する権限がありません。アクセスするには所有者に連絡してください。",
                "UNHIDE_PAGE": "ページを再表示",
                "UPDATE": "更新",
                "UPDATED_SUCCESSFULLY": "正常に更新されました。",
                "UPDATE_ALL_IN_THIS_PROJECT": "このプロジェクトのすべてを更新",
                "UPDATE_ALL_PROJECTS": "すべてのプロジェクトを更新",
                "UPDATE_NOW": "今すぐ更新",
                "UPDATE_REPORTS": "レポートを更新...",
                "UPDATE_REPORT_ELEMENTS": "公開レポートリンクと予約送信済みのレポートメールを更新",
                "UPGRADE_MY_ACCOUNT": "マイアカウントをアップグレード",
                "USE_EXPORT_TAGS": "質問番号を含める",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "標準テーブルの列の合計を使用",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "標準テーブルの回答者数を使用",
                "USE_WEIGHTED_METRICS": "加重指標を使用",
                "VIEW": "表示",
                "WEEKLY": "毎週",
                "WELCOME_TO_NEW_RESULTS": "Qualtrics XM Platformレポーティングへようこそ",
                "WHEN": "日時",
                "WIDGET_LOADING": "読み込んでいます...",
                "WIDGET_OPTIONS_ERR": "図表オプションを読み込めませんでした",
                "WIDGET_TYPE": "図表",
                "WORD_CLOUD": "ワードクラウド",
                "WORD_CLOUD_DESC": "テキストデータ中の単語を出現頻度に応じた大きさで表示する表現手法です。色分けなども追加できます。"
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "組織内には、HRパートナーや自分のマネージャー、メンターなど、フィードバックの解釈を手助けしてくれる人がいることを忘れないでください。",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "心を落ち着けてフィードバックを確認してください。",
                "ABOUT_YOUR_REPORT_HEADER": "レポートについて",
                "ABOUT_YOUR_REPORT_LINE1": "360フィードバックレポートへようこそ。これはプロフェッショナルとして自身を成長させ、能力を開発するよい機会となります。結果を確認する際に成功に向けて準備するには、十分な時間をとってフィードバックについてよく考えてください。フィードバックは、最初は聞くのがつらい場合もありますが、このフィードバックの目的はあなたの成長と能力開発を促進することであることを念頭に置いてください。",
                "ABOUT_YOUR_REPORT_LINE2": "レポートを確認する際に留意しておくべき点は以下のとおりです。",
                "ADD_CONDITIONAL_TEXT": "条件テキストを追加",
                "ADD_CUSTOM_PALETTE": "カスタムパレットを追加",
                "ADD_DATA_SOURCE": "データソースを追加",
                "ADD_FOLLOWING": "以下を追加",
                "ADD_LABEL": "ラベルを追加",
                "ADVANCED_FILTER": "高度なフィルタ",
                "AGREEMENT_CHART": "一致度グラフ",
                "AGREEMENT_CHART_FOOTER": "一致度グラフはスコアの類似性を示します。各ドットは、各項目について個人があなたをどのように評価したかを表しています。ドットのサイズは、何人の評価者から具体的な評価をもらったかを示します。",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "回答",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "回答",
                "AGREEMENT_CHART_LEGEND_TITLE": "他者による評価",
                "ALL": "すべて",
                "AND_IF": "AND条件",
                "ANGLED": "角あり",
                "AREA": "エリア",
                "AUTO": "自動",
                "AVERAGE": "平均",
                "AXIS_VALUES": "軸の値",
                "BAR": "バー",
                "BASE_WORD_COLOR": "基本の文字色",
                "BLUR": "ぼやけ",
                "BOTTOM_BOX": "下位ボックス",
                "BREAKOUT_HEADERS": "詳細区分ヘッダー",
                "CANCEL": "キャンセル",
                "CATEGORICAL": "分類別",
                "CATEGORY": "カテゴリ",
                "CATEGORY_NAME": "カテゴリ名",
                "CHANGE_CATEGORIES_ORDER": "カテゴリの順序変更",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "スコアリングカテゴリの順序変更",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "図表内の表示順を変更するには、スコアリングカテゴリエレメントの左側をクリックして表示したい位置までドラッグします。",
                "CHANGE_QUESTIONS_ORDER": "質問の順序変更",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "質問の順序変更",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "図表内の表示順を変更するには、質問エレメントの左側をクリックして表示したい位置までドラッグします。",
                "CHARTS": "グラフ",
                "CHART_TYPE": "グラフの種類",
                "CHOICE_COUNT": "選択肢数",
                "CHOICE_TOTALS": "選択肢の合計",
                "CLEAR": "クリア",
                "CLOSE": "閉じる",
                "COLOR_PALETTE": "カラーパレット",
                "COLUMN_NAMES": "列名",
                "COLUMN_TOTALS": "列の合計",
                "COMPARED_FILTER_GROUP": "比較されたフィルタグループ",
                "COMPARED_FILTER_GROUPS": "比較されたフィルタグループ",
                "COMPARE_WITH": "比較対象：",
                "COMPETITION_RANKING": "競合ランキングを使用",
                "COMPETITION_RANKING_TOOLTIP": "同順位の場合、等しいスコアはすべて同じランキングとなりますが、その後の項目は表内で次に高いランクの項目の合計数+1としてランキングされます。",
                "COMPLETED_RESPONSES": "完了した回答",
                "CONDITIONAL_TEXT": "条件テキスト",
                "COUNT": "数",
                "CREATE": "作成",
                "CUSTOM_PALETTE": "カスタムパレット",
                "DATA_SOURCE_TYPE": "データソースタイプ",
                "DATA_SOURCE_TYPE_CATEGORY": "スコアリングカテゴリ",
                "DATA_SOURCE_TYPE_QUESTION": "質問",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "質問",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "ランク付け可能な項目",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "スコアリングカテゴリ",
                "DEFAULT": "デフォルト",
                "DEFAULT_TEXT": "デフォルトのテキスト",
                "DELETE": "削除",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "同僚、直属の部下、リーダーなど、フィードバックの提供者を把握します",
                "DIFFERENT_EVALUATORS_HEADER": "さまざまな評価者",
                "DIRECT_REPORTS": "直属の部下",
                "DISABLED": "無効",
                "DISPLAY_OPTIONS": "オプションを表示",
                "DISPLAY_THRESHOLD_TEXTS": "次のグループのギャップに基づいてテキストを表示",
                "DIVERGENT": "分岐型",
                "DONE": "完了",
                "DONT_HEADER": "禁止事項：",
                "DONT_LINE1": "誰が何を言ったかを解明しようとする",
                "DONT_LINE2": "1つの肯定的または否定的なスコア／コメントに着目する",
                "DONT_LINE3": "すべての項目に対応した開発計画を作成する",
                "DONT_LINE4": "改善の機会があるということに落胆する",
                "DONUT": "ドーナツ",
                "DOWNLOAD_CSV": "旧バージョンのCSVをダウンロード",
                "DOWNLOAD_ZIP": "すべてのファイルをダウンロード",
                "DO_HEADER": "推奨事項：",
                "DO_LINE1": "全体的にフィードバックを考察する",
                "DO_LINE2": "強みと改善の機会のテーマを特定する",
                "DO_LINE3": "開発計画に追加するいくつかのフォーカスエリアに優先順位を付ける",
                "DO_LINE4": "すべての人に改善の機会があるということを理解する",
                "DROPOFF": "ドロップオフ",
                "DUPLICATE": "複製",
                "EDIT_CONDITIONAL_TEXT": "条件テキストを編集",
                "EDIT_CUSTOM_PALETTE": "カスタムパレットを編集",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "それ以外の場合は、次のテキストを表示",
                "ENABLED": "有効",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "評価者カテゴリの表示ロジックによる順序を有効化",
                "ENABLE_ORDERING_FOR": "以下の順序を有効化",
                "EQUAL_TO": "次と等しい",
                "FIELD": "フィールド",
                "FILTER_NAMES": "フィルタ名",
                "FOLLOWING_PARENTHESES": "（以下）",
                "FOOTER": "フッター",
                "GAP": "ギャップ",
                "GAP_CHART": "ギャップグラフ",
                "GAP_CHART_DESCRIPTION": "ギャップグラフには、2つの評価者グループの間のスコアの差異が表示されます。たとえば、自己評価と他者評価の場合、肯定的（+）な差異は自己評価よりも他者評価の方が高いことを意味します。否定的（-）な差異は自己評価よりも他者評価の方が低いことを意味します。",
                "GAP_CHART_FOOTER": "ギャップグラフは、2つの評価者グループの間の差異を示しています。",
                "GAP_TABLE_DESCRIPTION": "［隠された強み］には、自己評価よりも他者評価が高い部分が示されます。［改善すべき領域］には、自己評価よりも他者評価が低い部分が示されます。どちらのセクションもギャップが大きい順に並べられています。",
                "GAP_TABLE_FOOTER": "1列目は自己評価のスコア、2列目は他者の平均スコア、3列目は自己評価と他者評価のスコアの差異を示します。",
                "GAP_TABLE_TITLE": "隠された強み／改善すべき領域",
                "GREATER_OR_EQUAL": "以上",
                "GREATER_THAN": "次の数より大きい",
                "GROUP": "グループ",
                "GROUPED_FOR_ANONYMITY": "匿名化のためにグループ化済み",
                "HEADER_NAMES": "ヘッダー名",
                "HIGHEST_SCORES": "最高スコア",
                "HIGHLIGHT_THRESHOLD": "ギャップを強調表示するためのしきい値",
                "HIGHLOW_TABLE": "高スコア／低スコア",
                "HIGHLOW_TABLE_FOOTER": "このセクションには、適用可能な評価者カテゴリの平均から、5つの最高／最低と評価された行動（行動全体から抽出）が表示されます。このページを最大限に活用するには、出現する可能性のある傾向を探すといいでしょう。たとえば、最低と評価された行動の大部分が1つか2つのカテゴリに集中している場合、その行動は改善が必要な分野だと考えられます。最高と評価された行動からは、他の分野で活用できる強みを特定できます。",
                "HIGH_LOW_TABLE_DESCRIPTION": "高／低グラフには、他者が最高または最低と評価した領域に基づいて項目が表示されます。",
                "HORIZONTAL": "横",
                "HORIZONTAL_AND_VERTICAL": "横と縦",
                "HORIZONTAL_BAR": "横棒",
                "HOW_TO_INTERPRET_RESULT_HEADER": "結果を解釈してアクションを決定する方法：",
                "IF": "条件",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "非表示のラベルをパーセントに含める",
                "INNER_RIM": "内部リム",
                "IS": "が",
                "IS_NOT": "でない",
                "IS_SAME_AS_SUBJECT": "被評価者と同じ",
                "ITEM": "項目",
                "LABEL": "ラベル",
                "LABELS": "ラベル",
                "LARGE_LABELS": "大きいラベル",
                "LEGEND": "凡例",
                "LEGEND_POSITION": "凡例の位置",
                "LEGEND_VALUES": "凡例の値",
                "LESS_OR_EQUAL": "以下",
                "LESS_THAN": "次の数より小さい",
                "LINE": "線",
                "LOWEST_SCORES": "最低スコア",
                "MANAGERS": "マネージャー",
                "MANUAL_FONT_SIZE": "フォントサイズを手動で設定",
                "MAX": "最大",
                "MEAN": "平均",
                "MEDIAN": "中央値",
                "METRIC_TYPE": "指標タイプ",
                "MIN": "最小",
                "MODIFY_CUSTOM_PALETTES": "カスタムパレットを変更",
                "MOVE_DOWN": "下へ移動",
                "MOVE_UP": "上へ移動",
                "MULTI_SELECT_ITEMS_SELECTED": "選択済み",
                "NEGATIVE_GAPS": "改善すべき領域",
                "NO": "いいえ",
                "NONE": "なし",
                "NOT_APPLICABLE": "該当なし",
                "NOT_EQUAL_TO": "次と等しくない",
                "NO_DATA_AVAILABLE_WARNING": "有効なデータなし",
                "NO_FILTER": "フィルタなし",
                "NO_FILTER_IS_APPLIED": "フィルタは適用されません。",
                "NO_VALUE": "値なし",
                "NPS": "Net Promoter Score",
                "NUMBER": "数値",
                "NUMBERS": "数値",
                "NUMBER_OF_GAPS_NEGATIVE": "負のギャップの数",
                "NUMBER_OF_GAPS_POSITIVE": "正のギャップの数",
                "NUMBER_OF_ROWS_HIGH": "数値の高い行の数",
                "NUMBER_OF_ROWS_LOW": "数値の低い行の数",
                "OPTIONS": {
                    "HEADER_NAME": "ヘッダー名",
                    "LEGEND": "凡例",
                    "SCALE_AXIS_CHANGER_TITLE": "範囲"
                },
                "ORIENTATION": "向き",
                "OR_IF": "OR条件",
                "OTHER": "その他",
                "OTHERS": "他の人",
                "PAGE_OF": "ページ：%1/%2",
                "PALETTE_REMOVED": "削除したパレット",
                "PEERS": "同僚",
                "PERCENT": "パーセント",
                "PERCENTAGE": "パーセンテージ",
                "PERCENTAGE_OF_CHOICES": "選択率",
                "PERCENTAGE_OF_RESPONSES": "回答率",
                "PERCENT_COMPLETE": "%完了",
                "PERSON_METADATA": "人のメタデータ",
                "PERSON_METADATA_EVALUATOR": "評価者の",
                "PERSON_METADATA_SUBJECT": "対象者の",
                "PERSON_METADATA_VIEWER": "閲覧者の",
                "POSITIVE_GAPS": "隠された強み",
                "PRIMARY_PARENTHESES": "（主）",
                "QUESTIONS": "質問",
                "RADIUS": "半径",
                "RANK": "ランク",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "最高スコア",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "最高スコア",
                "RANKABLE_ITEMS_ITEM_HAS": "項目には",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "項目は上位",
                "RANKABLE_ITEMS_LOWEST_SCORE": "最低スコア",
                "RANKABLE_ITEMS_LOWEST_SCORES": "最低スコア",
                "RATER_CATEGORY_DISPLAY_LOGIC": "評価者カテゴリの表示ロジック",
                "RATIO": "比率",
                "RECORD": "記録",
                "REFERENCE_GROUP": "参照グループ",
                "RELATIONSHIP": "関係",
                "RELATIONSHIP_FILTERS": "関係フィルタ",
                "RELATIONSHIP_FILTERS_INFO": "関係フィルタ（直属の部下、同僚、マネージャー）を追加するには、［フィルタを管理］を選択し、ドロップダウンメニューの［関係］条件のみを使用します。",
                "REMOVE": "削除",
                "REMOVE_DATA_SOURCE": "データソースを削除",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "組織内には、HRパートナーや自分のマネージャー、メンターなど、フィードバックの解釈を手助けしてくれる人がいることを忘れないでください。",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "心を落ち着けてフィードバックを確認してください。",
                    "ABOUT_YOUR_REPORT_HEADER": "レポートについて",
                    "ABOUT_YOUR_REPORT_LINE1": "360フィードバックレポートへようこそ。これはプロフェッショナルとして自身を成長させ、能力を開発するよい機会となります。結果を確認する際に成功に向けて準備するには、十分な時間をとってフィードバックについてよく考えてください。フィードバックは、最初は聞くのがつらい場合もありますが、このフィードバックの目的はあなたの成長と能力開発を促進することであることを念頭に置いてください。",
                    "ABOUT_YOUR_REPORT_LINE2": "レポートを確認する際に留意しておくべき点は以下のとおりです。",
                    "ADVANCED_FILTER": "高度なフィルタ",
                    "AGREEMENT_CHART": "一致度グラフ",
                    "AGREEMENT_CHART_FOOTER": "一致度グラフはスコアの類似性を示します。各ドットは、各項目について個人があなたをどのように評価したかを表しています。ドットのサイズは、何人の評価者から具体的な評価をもらったかを示します。",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "回答",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "回答",
                    "AGREEMENT_CHART_LEGEND_TITLE": "他者による評価",
                    "ALL": "すべて",
                    "AVERAGE": "平均",
                    "BOTTOM_BOX": "下位ボックス",
                    "CHOICE_COUNT": "選択肢数",
                    "CHOICE_TOTALS": "選択肢の合計",
                    "COMPARISON": "比較",
                    "COMPARISON_GAP_COLUMN_HEADER": "比較ギャップ",
                    "COMPLETED_RESPONSES": "完了した回答",
                    "COUNT": "数",
                    "DEFAULT": "デフォルト",
                    "DEFAULT_TEXT": "デフォルトのテキスト",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "同僚、直属の部下、リーダーなど、フィードバックの提供者を把握します",
                    "DIFFERENT_EVALUATORS_HEADER": "さまざまな評価者",
                    "DONE": "完了",
                    "DONT_HEADER": "禁止事項：",
                    "DONT_LINE1": "誰が何を言ったかを解明しようとする",
                    "DONT_LINE2": "1つの肯定的または否定的なスコア／コメントに着目する",
                    "DONT_LINE3": "すべての項目に対応した開発計画を作成する",
                    "DONT_LINE4": "改善の機会があるということに落胆する",
                    "DO_HEADER": "推奨事項：",
                    "DO_LINE1": "全体的にフィードバックを考察する",
                    "DO_LINE2": "強みと改善の機会のテーマを特定する",
                    "DO_LINE3": "開発計画に追加するいくつかのフォーカスエリアに優先順位を付ける",
                    "DO_LINE4": "すべての人に改善の機会があるということを理解する",
                    "FIELD": "フィールド",
                    "GAP": "ギャップ",
                    "GAP_CHART": "ギャップグラフ",
                    "GAP_CHART_DESCRIPTION": "ギャップグラフには、2つの評価者グループの間のスコアの差異が表示されます。たとえば、自己評価と他者評価の場合、肯定的（+）な差異は自己評価よりも他者評価の方が高いことを意味します。否定的（-）な差異は自己評価よりも他者評価の方が低いことを意味します。",
                    "GAP_CHART_FOOTER": "ギャップグラフは、2つの評価者グループの間の差異を示しています。",
                    "GAP_TABLE_DESCRIPTION": "［隠された強み］には、自己評価よりも他者評価が高い部分が示されます。［改善すべき領域］には、自己評価よりも他者評価が低い部分が示されます。どちらのセクションもギャップが大きい順に並べられています。",
                    "GAP_TABLE_FOOTER": "1列目は自己評価のスコア、2列目は他者の平均スコア、3列目は自己評価と他者評価のスコアの差異を示します。",
                    "GAP_TABLE_TITLE": "隠された強み／改善すべき領域",
                    "GROUP": "グループ",
                    "HIDE_REPORT_ALERT": "レポートの表示に必要な要件を満たしていません。組織の管理者に連絡してください。",
                    "HIGHEST_SCORES": "最高スコア",
                    "HIGHLOW_TABLE": "高スコア／低スコア",
                    "HIGHLOW_TABLE_FOOTER": "このセクションには、適用可能な評価者カテゴリの平均から、5つの最高／最低と評価された行動（行動全体から抽出）が表示されます。このページを最大限に活用するには、出現する可能性のある傾向を探すといいでしょう。たとえば、最低と評価された行動の大部分が1つか2つのカテゴリに集中している場合、その行動は改善が必要な分野だと考えられます。最高と評価された行動からは、他の分野で活用できる強みを特定できます。",
                    "HIGH_LOW_TABLE_DESCRIPTION": "高／低グラフには、他者が最高または最低と評価した領域に基づいて項目が表示されます。",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "結果を解釈してアクションを決定する方法：",
                    "ITEM": "項目",
                    "LOWEST_SCORES": "最低スコア",
                    "MAX": "最大",
                    "MEAN": "平均",
                    "MEDIAN": "中央値",
                    "MIN": "最小",
                    "NEGATIVE_GAPS": "改善すべき領域",
                    "NO_COMPARISON_SET": "比較設定なし",
                    "NO_DATA_AVAILABLE_WARNING": "有効なデータなし",
                    "NO_FILTER_IS_APPLIED": "フィルタは適用されません。",
                    "NO_VALUE": "値なし",
                    "NPS": "Net Promoter Score",
                    "OTHERS": "その他",
                    "PERCENTAGE": "パーセンテージ",
                    "PERCENTAGE_OF_CHOICES": "選択率",
                    "PERCENTAGE_OF_RESPONSES": "回答率",
                    "PERCENT_COMPLETE": "%完了",
                    "POSITIVE_GAPS": "隠された強み",
                    "QUESTIONS": "質問",
                    "RANK": "ランク",
                    "RELATIONSHIPS": {
                        "ANYONE": "任意の人",
                        "DIRECT_REPORT": "直属の部下",
                        "MANAGER": "上司",
                        "PEER": "同僚",
                        "SELF": "自分"
                    },
                    "REPORT_SUMMARY": "レポート概要",
                    "REPORT_SUMMARY_TABLE_FOOTER": "評価に招待された人数に対して、あなたへの評価を完了した人数がどのくらいかを確認しましょう。",
                    "REPORT_SUMMARY_TABLE_HEADER": "回答者の統計",
                    "RESPONSES": "回答数",
                    "RESPONSE_COUNT": "{{responseCount}}件の回答",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span>件の回答",
                    "SCORING_CATEGORY": "スコアリングカテゴリ",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "このカテゴリには回答がありません",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "この質問には回答がありません",
                    "SCORING_OVERVIEW": "スコアリング概要",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "あなたも他の評価者も、この領域はとても強みであるという認識で一致しています。",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "気づいている強み",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "気づいている改善分野とは、自己評価と他者からの評価がともにこのコンピテンシーの平均値を下回っていることを意味します。",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "気づいている改善分野",
                    "SCORING_OVERVIEW_DESCRIPTION": "上記は、この複数評価者フィードバックプロセスの一部としてあなたが評価されたコンピテンシーまたは行動です。",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "最小ギャップ",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "テキストを表示するのに必要な準拠集団間の最小の差異",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "各コンピテンシー／行動に関するスコアの範囲が表示されます。バーは数値平均を表します。",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "気づいていない強みは、自己評価と他己評価の違いにより明らかになります。",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "気づいていない強み",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "気づいていない改善分野は、自己評価と他己評価の違いにより明らかになります。",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "気づいていない改善分野",
                    "SELF": "自分",
                    "SELF_ASSESSMENT": "自己評価",
                    "STANDARD_DEVIATION": "標準偏差",
                    "SUM": "合計",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "正しく解釈できるように、評価スケールをよく理解してください",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "スケールに関する注意",
                    "THINGS_YOU_WILL_SEE_HEADER": "表示される項目：",
                    "THREE_SIXTY_PERCENTILE": "百分位数",
                    "TOP_BOTTOM_BOX": "上位ボックス／下位ボックス",
                    "TOP_BOX": "上位ボックス",
                    "TOTAL": "合計",
                    "TO_DO": "未評価",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "定性的：このフィードバックはオープンテキストコメントの形式になります",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "定量的：このフィードバックは数値になり、グラフ、棒グラフ、テーブルなどで表されることがあります",
                    "TYPES_OF_FEEDBACK_HEADER": "さまざまな種類のフィードバック",
                    "VALUE": "値",
                    "VARIANCE": "分散",
                    "YOUR_RATINGS": "あなたの評価"
                },
                "REPORT_SUMMARY": "レポート概要",
                "REPORT_SUMMARY_TABLE_FOOTER": "評価に招待された人数に対して、あなたへの評価を完了した人数がどのくらいかを確認しましょう。",
                "REPORT_SUMMARY_TABLE_HEADER": "回答者の統計",
                "RESET": "リセット",
                "RESPONDENT_TOTALS": "回答者の合計",
                "RESPONSES": "回答",
                "RESPONSE_COUNT": "{{responseCount}}件の回答",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span>件の回答",
                "RESULT": "結果",
                "REVERSE_COLORS": "色を反転",
                "ROW_TOTALS": "行の合計",
                "SAVE": "保存",
                "SAVE_AND_APPLY": "保存して適用",
                "SCORING_CATEGORY": "スコアリングカテゴリ",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "このカテゴリには回答がありません",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "この質問には回答がありません",
                "SCORING_OVERVIEW": "スコアリング概要",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "あなたも他の評価者も、この領域はとても強みであるという認識で一致しています。",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "気づいている強み",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "気づいている改善分野とは、自己評価と他者からの評価がともにこのコンピテンシーの平均値を下回っていることを意味します。",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "気づいている改善分野",
                "SCORING_OVERVIEW_DESCRIPTION": "上記は、この複数評価者フィードバックプロセスの一部としてあなたが評価されたコンピテンシーまたは行動です。",
                "SCORING_OVERVIEW_MINIMUM_GAP": "最小ギャップ",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "テキストを表示するのに必要な準拠集団間の最小の差異",
                "SCORING_OVERVIEW_TABLE_FOOTER": "各コンピテンシー／行動に関するスコアの範囲が表示されます。バーは数値平均を表します。",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "気づいていない強みは、自己評価と他己評価の違いにより明らかになります。",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "気づいていない強み",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "気づいていない改善分野は、自己評価と他己評価の違いにより明らかになります。",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "気づいていない改善分野",
                "SELECT_CATEGORIES": "スコアリングカテゴリを選択してください...",
                "SELECT_CATEGORY": "スコアリングカテゴリを選択してください...",
                "SELECT_CONDITION_TYPE": "条件タイプを選択",
                "SELECT_DATA_SOURCE": "データソースを選択",
                "SELECT_DATA_SOURCE_TYPE": "データソースタイプを選択",
                "SELECT_FILTER": "フィルタを選択",
                "SELECT_FILTERS": "フィルタを選択",
                "SELECT_OPERATOR_TYPE": "演算子タイプを選択",
                "SELECT_PERSON": "人を選択",
                "SELECT_PERSON_METADATA": "人のメタデータを選択",
                "SELECT_QUESTION": "質問を選択",
                "SELECT_QUESTIONS": "質問を選択してください...",
                "SELECT_RATIO_OR_DROPOFF": "比率またはドロップオフを選択",
                "SELECT_RELATIONSHIP": "関係を選択",
                "SELECT_SCORING_CATEGORY": "スコアリングカテゴリを選択",
                "SELF": "自分",
                "SELF_ASSESSMENT": "自己評価",
                "SEQUENTIAL": "連番",
                "SETUP_COMPARISON": "比較を設定",
                "SETUP_COMPARISONS": "比較を設定",
                "SET_START_COLOR": "始点の色を設定",
                "SHOULD_SHOW_FOOTER": "フッターを表示",
                "SHOULD_SHOW_SCORING_CATEGORY": "スコアリングカテゴリを表示",
                "SHOWING_RECORDS_OF": "%1～%2のレコード（%3のうち）を表示しています",
                "SHOW_COMPARISON_GAP": "比較ギャップ列を表示",
                "SHOW_DATA_LABEL": "データ値を表示",
                "SHOW_PERCENTAGES": "パーセンテージを表示",
                "SHOW_THE_FOLLOWING_TEXT": "その後、次のテキストを表示",
                "SHOW_TIES": "同順位を表示",
                "SHOW_X_AXIS": "X軸を表示",
                "SHOW_Y_AXIS": "Y軸を表示",
                "SMALL_LABELS": "小さいラベル",
                "SORT": "並べ替え",
                "SPLINE": "なめらかな曲線",
                "STACK_CHART": "積み上げグラフ",
                "STANDARD_DEVIATION": "標準偏差",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "この値を下回ると弱み",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "しきい値のテキストを編集",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "しきい値のテキスト",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "しきい値のテキストを表示",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "この値を上回ると強み",
                "SUM": "合計",
                "SUMMARY": "概要",
                "TABLES": "表",
                "TABLE_TOTALS": "表の合計",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "正しく解釈できるように、評価スケールをよく理解してください",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "スケールに関する注意",
                "TEXT": "テキスト",
                "THINGS_YOU_WILL_SEE_HEADER": "表示される項目：",
                "TOP_BOTTOM_BOX": "上位ボックス／下位ボックス",
                "TOP_BOX": "上位ボックス",
                "TOTAL": "合計",
                "TOTAL_COUNTS": "総数",
                "TO_DO": "未評価",
                "TRANSPOSE": "置き換え",
                "TRANSPOSE_TABLE": "表の行列を入れ替え",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "定性的：このフィードバックはオープンテキストコメントの形式になります",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "定量的：このフィードバックは数値になり、グラフ、棒グラフ、テーブルなどで表されることがあります",
                "TYPES_OF_FEEDBACK_HEADER": "さまざまな種類のフィードバック",
                "UNDO": "元に戻す",
                "USE_COMPARISON": "比較を使用",
                "USE_LABELS_FOR_SCALES": "尺度にラベルを使用",
                "VALUES": "値",
                "VALUE_RANGES": "値の範囲",
                "VARIANCE": "分散",
                "VERTICAL": "縦",
                "VERTICAL_RANGE": "縦の範囲",
                "WARNING_DATA_OUT_OF_RANGE": "警告： データ値が範囲設定を上回っています",
                "WIDGET_ERROR": {
                    "ERROR": "原因不明のエラーが発生しました",
                    "MISCONFIGURED": "このウィジェットは正しく構成されていません。ウィジェットの構成を確認してください。",
                    "NEW": "ウィジェットを構成してください",
                    "NO_DATA": "データが見つかりません。フィルタリングの範囲が狭すぎる可能性があります。"
                },
                "WIDGET_NAME": {
                    "BAR": "棒グラフ",
                    "BREAKDOWNBAR": "内訳棒グラフ",
                    "DATA_TABLE": "データテーブル",
                    "FUNNEL_CHART": "ファネルチャート",
                    "GAUGE": "ゲージチャート",
                    "GRID": "結果テーブル",
                    "HEATMAP": "ヒートマップ",
                    "LINE": "線グラフ",
                    "NEEDS_BASED": "ニーズベース",
                    "PIE": "円グラフ",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "価格見積もり（Van Westendorp）",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "収入最大化（Gabor Granger）",
                    "SCORING_OVERVIEW_CHART": "グラフ",
                    "SCORING_OVERVIEW_TABLE": "表",
                    "STATS_TABLE": "統計テーブル",
                    "WORDCLOUD": "ワードクラウド"
                },
                "WORD_ROTATION": "文字の回転",
                "WORD_SPACING": "文字間隔",
                "YES": "はい",
                "YOUR_RATINGS": "あなたの評価"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "追加",
                "ADD_A_WORD": "文字を追加",
                "COLOR": "色",
                "DELETE_ALL": "すべて削除",
                "EDIT_STOP_WORDS": "除外ワードを編集",
                "MAX_WORDS": "最大文字数",
                "ROTATION_ANGLED": "角あり",
                "ROTATION_HORIZONTAL": "横",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "横と縦",
                "WORD_ORIENTATION": "文字列の向き"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "背景色",
                "DISPLAY_OPTIONS": "オプションを表示",
                "INVERT_FONT_COLORS": "低コントラストのフォントの色を反転",
                "PAGE": "ページ",
                "PAGINATE": "テキスト入力回答リスト"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "平均",
                "BOTTOM_BOX_METRIC": "下位ボックス",
                "COLUMNS": "列",
                "COUNT_METRIC": "総回答数",
                "FIELD_NAME": "フィールド",
                "MAX_METRIC": "最大",
                "MIN_METRIC": "最小",
                "SHOW_RECODES": "識別値を表示",
                "SHOW_ROW_NUMBERS": "列番号を表示",
                "STD_DEV_METRIC": "標準偏差",
                "TOP_BOX_METRIC": "上位ボックス",
                "TRANSPOSE_BREAKOUTS": "詳細区分を入れ替え",
                "TRANSPOSE_TABLE": "表の行列を入れ替え",
                "VAR_METRIC": "分散"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "追加の列",
                "ADD_COLUMNS": "列を追加",
                "ADD_CUSTOM_PALETTE": "カスタムパレットを追加",
                "ALL_CHOICES": "すべての選択肢",
                "ALL_GROUPS": "すべてのグループ",
                "ALL_RECODES": "すべての識別値",
                "AUTOMATIC": "デフォルト",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "デフォルト - クリックして編集",
                "AXIS_VALUES": "軸の値",
                "BREAKOUT_BY": "詳細区分",
                "CANCEL": "キャンセル",
                "CATEGORICAL": "分類別",
                "CHOICES": "選択肢",
                "CHOICE_COUNT": "選択肢数",
                "COLOR_PALETTE": "カラーパレット",
                "COLUMN_VALUES": "列の値",
                "CONTACT_FIELDS": "連絡先フィールド",
                "COUNT": "数",
                "CREATE": "作成",
                "CUSTOM": "カスタム設定",
                "CUSTOM_PALETTE": "カスタムパレット",
                "DATA_SOURCE": "データソース",
                "DAY": "日",
                "DAY_OF_WEEK": "曜日",
                "DECIMAL_PRECISION": "小数点以下の桁数",
                "DEFAULT": "デフォルト",
                "DISABLED": "無効",
                "DIVERGENT": "分岐型",
                "EDIT_CUSTOM_PALETTE": "カスタムパレットを編集",
                "ENABLED": "有効",
                "ERROR_LOADING_DATA": "データの読み込みエラー",
                "FILE_SIZE": "サイズ",
                "FILE_TYPE": "タイプ",
                "FRI": "金",
                "FRIDAY": "金曜日",
                "GROUP_DATE_BY": "グループの日付",
                "HOUR_OF_DAY": "時",
                "LENGEND_VALUES": "凡例の値",
                "MAX": "最大",
                "MEAN": "平均",
                "MIN": "最小",
                "MISCONFIGURED_DATA": "この図表ではデータソースが間違って設定されています。",
                "MISCONFIGURED_FILTERS": "無効なフィルタ",
                "MODIFY_CUSTOM_PALETTES": "カスタムパレットを変更",
                "MON": "月",
                "MONDAY": "月曜日",
                "MONTH": "月",
                "NONE": "なし",
                "NO_FILE_ID_ERROR": "この図表にはアンケートに設定する画像が必要です",
                "NO_RESULTS_TO_SHOW": "表示する結果なし",
                "NPS": "Net Promoter Score®",
                "NPS_GROUP": "NPS®グループ",
                "NUMERIC_VALUE": "数値",
                "PALETTE_REMOVED": "削除したパレット",
                "PERCENTAGE": "パーセンテージ",
                "PERCENTAGE_OF_CHOICES": "選択率",
                "PERCENTAGE_OF_RESPONSES": "回答率",
                "QUARTER": "四半期",
                "REMOVE": "削除",
                "RESPONSE_COUNT": "回答数",
                "RESULTS_PER_PAGE": "ページ当たりの結果",
                "RETRIEVING_DATA_ELLIPSIS": "データを検索しています...",
                "REVERSE_COLORS": "色を反転",
                "ROW_VALUES": "行の値",
                "SAT": "土",
                "SATURDAY": "土曜日",
                "SAVE": "保存",
                "SELECTED_CHOICE": "選択された選択肢",
                "SELECT_FIELD": "フィールドを選択",
                "SELECT_METRIC": "指標",
                "SEQUENTIAL": "連番",
                "SET_START_COLOR": "始点の色を設定",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "サンプルデータを表示しています...",
                "SUM": "合計",
                "SUN": "日",
                "SUNDAY": "日曜日",
                "SURVEY_EMBEDDEDDATA": "埋め込みデータ",
                "SURVEY_METADATA": "アンケートのメタデータ",
                "TEXT_ENTRY": "自由回答",
                "THURS": "木",
                "THURSDAY": "木曜日",
                "TITLE": "タイトル",
                "TUES": "火",
                "TUESDAY": "火曜日",
                "UNBOUNDED_DOMAIN": "表示する値が多すぎます。",
                "UNBOUNDED_DOMAIN_HELP": "このフィールドを結果レポートに追加するには、「{{ed_field_name}}」で表示される値をより少なくするようレポートにフィルタを設けるか、このフィールドが文字列タイプまたは数値タイプになるようアンケートフローの「{{ed_field_name}}」の埋め込みデータの変数タイプを更新することができます。",
                "UNDO": "元に戻す",
                "USE_CHOICE_TOTALS": "選択肢の合計を使用",
                "USE_RESPONDENT_TOTALS": "回答者の合計を使用",
                "VISUALIZATION": "図表",
                "VISUALIZATION_BARCHART": "棒グラフ",
                "VISUALIZATION_BREAKDOWNBAR": "内訳棒グラフ",
                "VISUALIZATION_GAUGE": "ゲージチャート",
                "VISUALIZATION_HEATMAP": "ヒートマップ",
                "VISUALIZATION_LINECHART": "線グラフ",
                "VISUALIZATION_PAGINATEDTABLE": "テキスト回答テーブル",
                "VISUALIZATION_PIE": "円グラフ",
                "VISUALIZATION_SIMPLETABLE": "標準テーブル",
                "VISUALIZATION_STATSTABLE": "統計テーブル",
                "VISUALIZATION_TEXTHIGHLIGHTS": "テキストの強調表示",
                "VISUALIZATION_WORDCLOUD": "ワードクラウド",
                "WED": "水",
                "WEDNESDAY": "水曜日",
                "WEEK": "週",
                "WEIGHTING": "重み設定",
                "WRONG_QUESTION_TYPE_ERROR": "この図表の種類はこの質問に使用できません",
                "YEAR": "年"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "平均",
                "CHOICE_COUNT": "選択肢数",
                "COUNT": "数",
                "DISPLAY_OPTIONS": "オプションを表示",
                "MAX": "最大",
                "MIN": "最小",
                "NPS": "NPS®",
                "PAGE_OF": "ページ：%1/%2",
                "PERCENT": "パーセンテージ",
                "RESPONSE_COUNT": "回答数",
                "ROWS_PER_TABLE": "表ごとの行数",
                "SHOWING_ROWS_OF": "%1～%2/%3行を表示しています",
                "SHOW_PERCENTAGES": "パーセンテージを表示",
                "SHOW_RECODES": "識別値を表示",
                "SHOW_ROW_NUMBERS": "列番号を表示",
                "SUM": "合計",
                "TOTAL": "合計",
                "TRANSPOSE": "置き換え",
                "USE_COLUMN_TOTALS": "列の合計を使用",
                "USE_ROW_TOTALS": "行の合計を使用",
                "VALUE": "値"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "昇順",
                "COUNT": "数",
                "DESCENDING": "降順",
                "DIAGONAL": "斜め",
                "DISPLAY_OPTIONS": "オプションを表示",
                "ERROR_COLON": "エラー：",
                "ERROR_GENERIC": "図表の読み込み中にエラーが発生しました。",
                "HORIZONTAL": "横",
                "HORIZONTAL_BARS": "横棒",
                "INCORRECTLY_CONFIGURED": "グラフを表示するには値を選択してください",
                "LEGEND_AUTO": "自動",
                "LEGEND_BOTTOM": "下",
                "LEGEND_INSET": "インセット",
                "LEGEND_RIGHT": "右",
                "NORMALIZE_TO_PERCENTAGES": "パーセンテージで正規化",
                "SHOW_BAR_LABELS": "バーラベルを表示",
                "SHOW_LEGEND": "凡例を表示",
                "SHOW_X_AXIS": "X軸を表示",
                "SHOW_Y_AXIS": "Y軸を表示",
                "SORT_BAR_VALUES": "バー値で並べ替え",
                "STACKED_BARS": "積み上げ棒",
                "TRANSPOSE": "置き換え",
                "TRUNCATE_LABELS": "ラベルを切り捨て",
                "VERTICAL": "縦"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "その他すべて",
                "COULD_NOT_LOAD_DATA": "指定された設定でデータを読み込めませんでした。別のソースフィールドを指定するか、日付範囲を広げてやり直してください。",
                "GROUPING_PERCENTAGE_THRESHOLD": "パーセンテージのしきい値をグループ化",
                "NO_DATA": "データなし",
                "RADIUS": "内半径",
                "SHOW_AS_PERCENTAGES": "パーセンテージで表示"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "閉じる",
                "DOWNLOAD_CSV": "CSVをダウンロード",
                "DOWNLOAD_ZIP": "すべてのファイルをダウンロード",
                "NO_DATA": "データなし",
                "PAGE_OF": "ページ：%1/%2",
                "RESULTS_PER_PAGE": "ページ当たりの結果",
                "SHOWING_RECORDS_OF": "%1～%2のレコード（%3のうち）を表示しています",
                "SINGLE_RESPONSE": "個別回答",
                "VIEW_RESPONSE": "回答を表示"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "オプションを表示",
                "ERROR_COLON": "エラー：",
                "ERROR_GENERIC": "図表の読み込み中にエラーが発生しました。",
                "HORIZONTAL_BARS": "横棒",
                "INCORRECTLY_CONFIGURED": "グラフを表示するには値を選択してください",
                "LEGEND_AUTO": "自動",
                "LEGEND_BOTTOM": "下",
                "LEGEND_INSET": "インセット",
                "LEGEND_RIGHT": "右",
                "NORMALIZE_TO_PERCENTAGES": "パーセンテージで正規化",
                "SHOW_AREA": "エリアを表示",
                "SHOW_LEGEND": "凡例を表示",
                "SHOW_X_AXIS": "X軸を表示",
                "SHOW_Y_AXIS": "Y軸を表示",
                "SMOOTH_LINES": "線をなめらかにする",
                "SORT_X_AXIS_LABELS": "X軸のラベルで並べ替え",
                "STACKED_BARS": "積み上げ棒",
                "TRANSPOSE": "置き換え"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "ブロックモード",
                "BLUR": "ぼやけ",
                "COULD_NOT_LOAD_DATA": "指定された設定でデータを読み込めませんでした。別のソースフィールドを指定するか、日付範囲を広げてやり直してください。",
                "FIELD": "フィールド",
                "RADIUS": "半径",
                "SHOW_REGIONS": "地域を表示",
                "SHOW_REGION_LABELS": "地域のラベルを表示"
            },
            "GAUGEWIDGET": {
                "MAX": "最大",
                "MIN": "最小",
                "VALUE_RANGES": "値の範囲"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "下位ラベル",
                "CATEGORY_NAME": "カテゴリ名",
                "ERROR_COLON": "エラー：",
                "INCLUDE_HIDDEN_GROUPS": "非表示のグループをパーセントに含める",
                "LARGE_LABELS": "大きいラベル",
                "NO": "いいえ",
                "PERCENT": "パーセント",
                "RESPONSE_COUNT": "回答数",
                "RESPONSE_COUNT_WITH_VALUE": "{{ responseCount }}件の回答",
                "SMALL_LABELS": "小さいラベル",
                "YES": "はい"
            }
        });
        $cache.put('KO', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "액세스 코드",
                "ACCESS_CODE_PROTECTION": "액세스 코드 보호",
                "ADD": "추가",
                "ADD_BREAKOUT": "보고서 분류 추가",
                "ADD_NOTE": "메모 추가",
                "ADD_SCHEDULED_REPORT": "예약된 보고서 추가",
                "ADD_WIDGET": "시각화 추가",
                "ALL_PROJECTS": "모든 프로젝트",
                "ALL_QUESTIONS": "질문 페이지",
                "ANSWER": "답",
                "ANY_CHANGES_LOST": "Qualtrics XM 플랫폼을 종료하면 보고서에 대한 변경 사항이 손실됩니다.",
                "APPENDED_COPY_IN_PARENS": "(복사)",
                "AREA_CHART": "영역 차트",
                "AREA_CHART_DESC": "선 아래의 영역이 채워진 2축 꺾은선형 차트입니다.",
                "ATTACHMENT": "첨부 파일",
                "BACKUP_CURRENT_REPORT": "시각화에 영향이 미치기 전에 보고서의 백업 사본을 저장하십시오.",
                "BACKUP_CURRENT_REPORT_LINE2": "참고: 백업 사본의 이름은 ‘{{nameOfReportCopy}}’이(가) 됩니다.",
                "BACK_TO_REPORTS": "보고서로 돌아가기",
                "BACK_TO_TOP": "상단으로 돌아가기",
                "BACK_TO_VIEW_RESULTS": "이전 보기 결과로 돌아가기",
                "BAR_CHART": "막대 차트",
                "BAR_CHART_DESC": "축 변환 및 데이터 요소 재정렬 등을 추가로 구성할 수 있는 2축 막대 차트입니다.",
                "BREAKDOWN_BAR_CHART": "분석 막대",
                "BREAKDOWN_BAR_CHART_DESC": "원형 차트의 대체 차트로 서로 간에 대해 시각적으로 가중치가 적용된 메트릭을 나타내는 데 사용되는 가장 일반적인 가로 스택 막대 차트입니다.",
                "CANCEL": "취소",
                "CANCEL_CONF_TEXT": "취소하시겠습니까?<br/>모든 변경 사항이 손실됩니다.",
                "CANCEL_EDITS": "편집 사항 취소",
                "CHART": "차트",
                "CHOICE": "선택 항목",
                "CHOICES_COUNT_METRIC": "선택 항목 수",
                "CHOOSE_PAGES_TO_DISPLAY": "표시할 페이지 선택",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "이 보고서에는 {{maxReportPageCount}}개 페이지가 있지만, 결과는 최대 {{reportSizeLimit}}까지만 포함할 수 있습니다. 해당 한도 내에서 하위 집합을 선택해 주십시오.",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "보고서는 페이지를 최대 {{reportSizeLimit}}개 포함할 수 있습니다. 원하는 페이지를 선택해 주십시오.",
                "CLEAR_ALL": "모두 지우기",
                "CLOSE": "닫기",
                "CLOUD": "클라우드 설명",
                "COLLABORATED_NEW": "이 설문조사의 소유자가 Qualtrics XM 플랫폼을 사용하고 있습니다. 이 설문조사에 대한 보고서는 새 결과를 사용하여 편집됩니다.",
                "COMMA_SEPARATED_LIST": "쉼표로 구분된 리스트",
                "COMPACTNESS": "글꼴 및 여백",
                "COMPACTNESS_INFO": "이 설정은 차트에서의 테이블 여백, 글꼴 크기 및 막대 크기에 영향을 주며 대부분의 내보내기에도 적용됩니다.",
                "CONFIRM": "확인",
                "CONFIRM_DELETE": "삭제 확인",
                "CONFIRM_DELETE_PAGE": "이 페이지를 삭제하시겠습니까?",
                "CONTINUE": "계속",
                "CONTINUE_EDITING": "편집 계속",
                "COPY": "복사",
                "COPY_OF_REPORT_NAME": "{{nameOfCurrentReport}} 사본",
                "COPY_REPORT": "보고서 복사",
                "COPY_REPORT_ELLIPSIS": "보고서 복사...",
                "COPY_TO_NEW_REPORT": "새 보고서에 복사...",
                "CREATE": "생성",
                "CREATED": "생성됨",
                "CREATE_CUSTOM_PAGE": "맞춤 페이지 생성",
                "CREATE_NEW_REPORT": "새 보고서 생성",
                "CREATE_NEW_REPORT_ELLIPSIS": "새 보고서 생성...",
                "CSV_FILE": "CSV 파일",
                "CUSTOM_PAGES": "맞춤 페이지",
                "DATE": "날짜",
                "DEFAULT_PALETTE": "기본 색상표",
                "DEFAULT_REPORT": "기본 보고서",
                "DEFAULT_VISUALIZATIONS": "기본 시각화",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "기본 결과 보고서를 만드는 데 사용하는 기본 시각화 유형입니다. 이 설정을 업데이트 및 적용하면 현재 보고서가 새 기본 설정으로 다시 만들어집니다. 현재 보고서를 백업하는 옵션이 있습니다.",
                "DEFAULT_VISUALIZATIONS_NOTE": "참고: 모든 질문 유형에 모든 시각화 유형을 사용할 수 있는 것은 아닙니다. 기본값이 아닌 일부 시각화는 자동으로 대체될 수 있습니다.",
                "DEFAULT_VISUALS_DISCLAIMER": "Qualtrics는 이 보고서를 새 기본 시각화 설정으로 업데이트합니다.",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "업데이트되면 보고서의 {{amountOfWidgetsAffected}} 시각화가 영향을 받습니다.",
                "DEFAULT_VISUAL_EDIT_DETECTED": "기본 시각화 편집이 감지됨",
                "DELETE_BUTTON": "삭제",
                "DELETE_DISABLED_EXPLANATION": "조직이 Qualtrics XM 플랫폼으로의 전체 마이그레이션을 수행하기 전에는 이전의 보고 인터페이스에서 생성된 보고서를 삭제할 수 없습니다.",
                "DELETE_PAGE": "페이지 삭제",
                "DELETE_PAGE_ELLIPSIS": "페이지 삭제...",
                "DELETE_REPORT": "보고서 삭제",
                "DELETE_REPORT_ELLIPSIS": "보고서 삭제...",
                "DELETE_WIDGET_QUESTION": "삭제하시겠습니까?",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "이 필드는 암호화되어 있으므로 정렬에 사용할 수 없습니다.",
                "DISCARD_EDITS": "편집 사항 취소",
                "DISTRIBUTION_PAUSED": "보고서 배포가 일시 중지되었습니다.",
                "DONE_BUTTON": "완료",
                "DONE_EDITING": "편집 완료",
                "DOWNLOAD": "다운로드",
                "DOWNLOAD_AS_CSV": "CSV로 다운로드",
                "DOWNLOAD_AS_PDF": "PDF로 다운로드",
                "DOWNLOAD_FAILED": "다운로드하지 못함",
                "DOWNLOAD_PREVIOUS_EXPORTS": "이전 내보내기 다운로드...",
                "DO_YOU_WISH_TO_DELETE": "다음을 삭제하시겠습니까?",
                "DUPLICATE_PAGE": "시트 복제",
                "EDIT_REPORT": "보고서 편집",
                "EDIT_REPORT_ELLIPSIS": "보고서 편집...",
                "EDIT_VISUALIZATION": "시각화 편집",
                "EMAIL_ADDRESS": "이메일 주소",
                "EMAIL_SENT": "이메일을 전송함...",
                "END_OF_REPORT": "보고서 종료",
                "ENTER_NAME": "이름 입력",
                "ERROR_COPYING": "보고서를 복사하는 중 오류가 발생했습니다.",
                "ERROR_DELETING": "보고서를 삭제하는 중 오류가 발생했습니다.",
                "ERROR_DELETING_EXPORT": "내보내기를 삭제하는 중 오류가 발생했습니다.",
                "ERROR_HEADING": "오류",
                "ERROR_PUBLISHING": "설정을 저장하는 중 오류가 발생했습니다.",
                "ERROR_RENAMING": "보고서의 이름을 바꾸는 중 오류가 발생했습니다.",
                "ERROR_REQUESTING_EXPORT": "내보내기를 요청하는 중 오류가 발생했습니다.",
                "ERROR_SAVING_GLOBAL_OPTIONS": "글로벌 시각화 옵션을 저장하는 중 오류가 발생했습니다.",
                "ERROR_SEND_TEST_EMAIL": "테스트 이메일을 전송하는 중 오류가 발생했습니다.",
                "EVERY_FRIDAY": "매주 금요일",
                "EVERY_MONDAY": "매주 월요일",
                "EVERY_MONTH": "매월 다음 날짜에",
                "EVERY_SATURDAY": "매주 토요일",
                "EVERY_SUNDAY": "매주 일요일",
                "EVERY_THURSDAY": "매주 목요일",
                "EVERY_TUESDAY": "매주 화요일",
                "EVERY_WEDNESDAY": "매주 수요일",
                "EVERY_WEEK": "매주 다음 요일에",
                "EXAMPLE_GROUP_NUM": "그룹 {{num}}",
                "EXAMPLE_SERIES_NUM": "시리즈 {{num}}",
                "EXPORT": "내보내기",
                "EXPORT_CSV": "CSV(쉼표로 구분됨)",
                "EXPORT_EXCEL_SPREADSHEET": "Excel 스프레드시트",
                "EXPORT_IMAGE": "이미지 내보내기",
                "EXPORT_PAGES": "페이지 내보내기",
                "EXPORT_PDF": "PDF 문서",
                "EXPORT_PPT_SLIDES": "PowerPoint 슬라이드",
                "EXPORT_RAW_DATA": "미가공 데이터 내보내기",
                "EXPORT_REPORT": "보고서 내보내기",
                "EXPORT_VISUALIZATION": "시각화 내보내기",
                "EXPORT_WORD_DOC": "Word 문서",
                "FAILED_SAVE_TXT": "저장하지 못함",
                "FILTERED": "필터 처리됨",
                "FIRST_PAGE": "첫 번째 페이지",
                "FIRST_WEEKDAY": "매월 첫 번째 평일",
                "FROM": "시작",
                "FROM_EMAIL": "이메일에서",
                "FROM_NAME": "발신자 이름",
                "GAUGE_CHART": "게이지 차트",
                "GAUGE_CHART_DESC": "현재 값을 목표 또는 일련의 임계값과 비교하기 위한 게이지 측정 도구와 유사한 차트입니다.",
                "GENERATING_FILE": "파일 생성 중...",
                "GENERATING_IMAGE": "이미지 생성 중...",
                "GENERATING_PDF": "PDF 생성 중...",
                "GENERIC_ERROR": "오류가 발생하여 요청한 프로젝트를 로드하지 못했습니다.",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "글로벌 옵션...",
                "GLOBAL_METRIC": "기본 메트릭",
                "GLOBAL_MODAL_PAGE_TITLE": "Qualtrics Research Suite의 결과 섹션에 대해 글로벌 옵션을 사용한 시각화 예시",
                "GLOBAL_MODAL_WIDGET_TITLE": "시각화 제목",
                "GLOBAL_OPTIONS": "글로벌 옵션",
                "GLOBAL_PRECISION": "기본 소수 자릿수",
                "GLOBAL_SETTINGS_APPLY": "내 기본 설정 적용",
                "GLOBAL_SETTINGS_SAVE": "내 기본 설정으로 저장",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "Qualtrics 기본값 적용",
                "GROUP": "그룹",
                "HEAT_MAP_CHART": "히트맵 차트",
                "HEAT_MAP_CHART_DESC": "원본 이미지에 대한 사용자 입력(클릭 등)의 분포를 매핑하는 데 사용되는 클러스터링된 ‘열’ 스타일 시각화입니다.",
                "HIDDEN": "숨겨짐",
                "HIDDEN_PAGE": "이 페이지는 공개 보고서에 나타나지 않으며 보고서 내보내기에도 기본적으로 선택 취소됩니다.",
                "HIDE": "숨기기",
                "HIDE_ALL_PAGES": "모든 페이지 숨기기",
                "HIDE_PAGE": "페이지 숨기기",
                "IMAGE_FILE": "이미지 파일",
                "INVALID_BRAND_DOMAIN": "입력한 도메인이 브랜드의 승인된 이메일 도메인 목록에 없습니다. 브랜드 관리자에게 문의하여 수정해 주십시오.",
                "INVALID_SPF_RECORD": "입력한 도메인은 Qualtrics가 해당 도메인에서 전송하는 것을 승인하지 않으며, 이는 전달 기능에 영향을 줍니다. 다른 도메인을 사용하거나 이 문제 해결 방법을 Qualtrics에 문의해 주십시오.",
                "ISSUE_SAVING_REPORTS": "하나 이상의 보고서를 저장하는 중 문제가 발생했습니다. 다시 시도해 주십시오.",
                "ISSUE_SENDING_TEST": "테스트 이메일을 전송하는 중 오류가 발생했습니다. 다시 시도해 주십시오.",
                "LARGE_SURVEY": "설문조사가 너무 커서 결과가 표시되지 않습니다.",
                "LAST_DAY": "매월 마지막 날",
                "LAST_MODIFIED_COLON_WITH_DATE": "마지막 수정일: %1",
                "LAST_PAGE": "마지막 페이지",
                "LAST_WEEKDAY": "매월 마지막 평일",
                "LATER": "나중에",
                "LEARN_MORE": "자세히 알아보기",
                "LINE_CHART": "꺾은선형 차트",
                "LINE_CHART_DESC": "2축 꺾은선형 차트는 X 축의 시간을 기준으로 그래프를 그리는 경우에 주로 사용됩니다.",
                "LOG_OUT_WARNING": "로그인 상태로 유지하려면 {{countdown}}초 이내 아무 위치나 클릭해야 합니다.",
                "MESSAGE": "메시지",
                "MONTHLY": "매월",
                "MOVE_DOWN": "아래로 시각화 이동",
                "MOVE_PAGE_TO_BOTTOM": "하단으로 이동",
                "MOVE_PAGE_TO_TOP": "상단으로 이동",
                "MOVE_UP": "위로 시각화 이동",
                "MY_SURVEYS": "내 프로젝트",
                "NAME": "이름",
                "NEW_CUSTOM_PAGE_NAME": "새 맞춤 페이지",
                "NEW_REPORT": "새 보고서",
                "NEXT_PAGE": "다음 페이지",
                "NEXT_RUN": "다음 실행",
                "NO_EXPORTS": "이 보고서에 대해 요청된 내보내기가 아직 없습니다.",
                "NO_ITEMS_TO_DISPLAY": "표시할 항목이 없음",
                "NO_MATCHING_CUSTOM_PAGES": "일치하는 맞춤 페이지가 없음",
                "NO_MATCHING_PAGES": "검색할 페이지를 찾을 수 없음",
                "NO_MATCHING_REPORTS": "일치하는 보고서가 없습니다.",
                "NO_PROJECT": "계속하려면 프로젝트를 지정해 주십시오.",
                "NO_PROJECTS_TO_MIGRATE": "업데이트할 프로젝트가 없습니다.",
                "NO_QUESTIONS": "일치하는 질문이 없음",
                "NO_RESULTS_YET": "표시할 결과가 아직 없습니다. 설문조사를 배포하여 응답을 모아 주십시오.",
                "OFF": "꺼짐",
                "ON": "켜짐",
                "PAGES_SELECTED": "선택한 페이지",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "이를 선택하면 보고서에 {{currentSelectedPageCount}}페이지가 포함됩니다(최대 {{reportSizeLimit}} 이상 허용). 더 작은 범위를 선택해 주십시오.",
                "PAGES_SELECTION_INVALID_RANGE": "유효한 범위를 선택해 주십시오.",
                "PAGE_OPTIONS": "페이지 옵션",
                "PDF_ROW_TRUNCATION_MESSAGE": "PDF로 내보내기에는 행이 너무 많습니다. Word 또는 CSV로 내보내십시오.",
                "PERCENTAGE_METRIC": "비율",
                "PIE_CHART": "원형 차트",
                "PIE_CHART_DESC": "주어진 데이터 요소의 값에 대한 원형 분석입니다. 선택된 값에 대한 상대적인 비율을 측정하는 데 유용합니다.",
                "PREVIEW": "미리보기",
                "PREVIOUS_PAGE": "이전 페이지",
                "PRINT_PAGE": "페이지 인쇄",
                "PUBLIC_LINK": "공개 링크",
                "PUBLIC_REPORT_AVAILABLE": "공개 보고서 사용 가능",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "액세스 코드",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "잘못된 액세스 코드입니다. 다시 시도해 주십시오.",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "제출",
                "PUBLIC_RESULTS_LOGIN_TITLE": "공개 보고서 로그인 | Qualtrics 설문조사 소프트웨어",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "공용 보고서를 찾을 수 없습니다. 이 보고서의 소유자에게 유효한 링크를 요청해 주십시오.",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "공개 보고서를 찾을 수 없음",
                "PUBLIC_RESULTS_NOT_UPDATED": "공개 보고서 링크 및 예약된 보고서 이메일의 경우 업데이트하지 전에는 Qualtrics XM 플랫폼을 사용하지 않습니다.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "세션이 만료되었습니다. 공용 결과 보고서 미리보기를 계속하려면 다시 로그인해 주십시오.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "세션이 만료됨",
                "PUBLIC_RESULTS_TITLE": "공개 보고서",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "이 페이지를 볼 수 있는 권한이 없습니다. 이 보고서의 소유자에게 공용 보고서로 만들어줄 것을 요청해 주십시오.",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "공개 보고서 권한 없음",
                "PUBLISHED_LINK_GENERATING_LINK": "링크 생성 중...",
                "PUBLISHED_REPORT_FOUND_HERE": "모든 사람이 다음 링크에서 이 보고서를 볼 수 있습니다.",
                "PUBLISH_REPORT": "공개 보고서 관리",
                "PUBLISH_REPORT_ELLIPSIS": "공개 보고서 관리...",
                "QUESTION": "질문",
                "RANK": "순위",
                "REMOVE_WIDGET": "시각화 제거",
                "RENAME_PAGE": "페이지 이름 변경",
                "RENAME_REPORT": "보고서 이름 변경",
                "RENAME_REPORT_ELLIPSIS": "보고서 이름 변경...",
                "REPLY_TO_EMAIL": "회신 이메일",
                "REPORT_COLON": "보고서:",
                "REPORT_SETTINGS": "보고서 설정",
                "REPORT_SETTINGS_ELLIPSIS": "보고서 설정...",
                "RESPONSE_COUNTS": "응답 수",
                "RESULTS_DASHBOARDS_BANNER": "그리고 액세스할 수 있는 최신 UI 및 데이터 시각화, 새로운 분석 및 탐색 기능 등을 제공하는 개선된 새로운 버전의 설문조사 결과를 사용해 보십시오.",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "릴리스 노트",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "최신 내용 보기",
                "RESULTS_OPTIONS": "보고서 옵션",
                "RESULTS_TITLE": "보고서",
                "RESUME_DISTRIBUTION": "배포 재개",
                "REVERT": "되돌리기",
                "RICH_TEXT_LIMIT_REACHED": "콘텐츠 길이가 한도에 도달했습니다!",
                "SAVE": "저장",
                "SAVE_AND_CLOSE": "저장 후 닫기",
                "SAVE_AS_CSV": "시각화를 CSV로 저장",
                "SAVE_AS_IMAGE": "시각화를 이미지로 저장",
                "SAVE_CONFIRMATION": "저장 확인",
                "SAVE_PAGE_AS_ELLIPSIS": "다른 이름으로 페이지 내보내기...",
                "SAVE_SETTINGS": "설정 저장",
                "SCHEDULE_REPORT_EMAIL": "보고서 이메일 예약",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "보고서 이메일 예약...",
                "SEARCH_ELLIPSIS": "검색...",
                "SEARCH_PAGES": "질문 검색",
                "SEARCH_PAGES_ELLIPSIS": "페이지 검색...",
                "SEARCH_REPORTS_ELLIPSIS": "보고서 검색...",
                "SELECTED": "선택됨:",
                "SELECT_ALL": "모두 선택",
                "SELECT_A_FIELD": "필드 선택",
                "SELECT_A_WIDGET": "시각화 선택",
                "SELECT_PAGES": "페이지 선택",
                "SELECT_PAGES_ELLIPSIS": "페이지 선택...",
                "SEND": "전송",
                "SEND_TEST_EMAIL": "테스트 이메일 전송",
                "SETTING_DEFAULT": "기본값",
                "SETTING_HIGH": "높음",
                "SETTING_LARGE": "크게",
                "SETTING_LOW": "낮음",
                "SETTING_NORMAL": "일반",
                "SETTING_SMALL": "작게",
                "SHARE_REPORT": "보고서 공유",
                "SHOW_ALL_PAGES": "모든 페이지 표시",
                "SHOW_FULL_QTEXT": "페이지 제목의 전체 질문 텍스트 표시",
                "SIMPLE_TABLE": "단순 테이블",
                "SIMPLE_TABLE_DESC": "여러 값을 행이나 열로 나타낼 수 있는 유연한 테이블입니다.",
                "SIZE": "크기",
                "SPLINE_CHART": "스플라인 차트",
                "SPLINE_CHART_DESC": "2축 둥근 꺾은선형 차트는 X 축의 시간을 기준으로 그래프를 그리는 경우에 주로 사용됩니다.",
                "STATISTICS_TABLE": "통계 테이블",
                "SUBJECT": "제목",
                "SURVEY_ANALYSIS": "설문조사 분석",
                "SURVEY_SUMMARY": "설문조사 요약",
                "TABLE": "테이블 설명",
                "TIME": "시간",
                "TO": "에게",
                "TOTAL": "총합",
                "TRANSPOSE_STATS_TABLES": "통계 테이블 행/열 바꾸기",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "통계 테이블 분류 행/열 바꾸기",
                "TRUNCATE_PAGE_TITLES": "페이지 제목의 질문 텍스트 자르기",
                "TRY_IT_NOW": "지금 시도",
                "TYPE": "유형",
                "UNABLE_TO_CHECK_SPF": "SPF 레코드를 확인할 수 없습니다. 다시 시도해 주십시오.",
                "UNAUTHORIZED": "이 보고서를 볼 수 없습니다. 액세스하려면 소유자에게 문의해 주십시오.",
                "UNHIDE_PAGE": "페이지 숨기기 취소",
                "UPDATE": "업데이트",
                "UPDATED_SUCCESSFULLY": "성공적으로 업데이트되었습니다.",
                "UPDATE_ALL_IN_THIS_PROJECT": "이 프로젝트의 모든 항목 업데이트",
                "UPDATE_ALL_PROJECTS": "모든 프로젝트 업데이트",
                "UPDATE_NOW": "지금 업데이트",
                "UPDATE_REPORTS": "보고서 업데이트...",
                "UPDATE_REPORT_ELEMENTS": "공개 보고서 링크 및 예약된 보고서 이메일 업데이트",
                "UPGRADE_MY_ACCOUNT": "내 계정 업그레이드",
                "USE_EXPORT_TAGS": "질문 번호 포함",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "단순 테이블 열 총계 사용",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "단순 테이블 응답자 수 사용",
                "USE_WEIGHTED_METRICS": "가중치가 적용된 메트릭 사용",
                "VIEW": "보기",
                "WEEKLY": "매주",
                "WELCOME_TO_NEW_RESULTS": "Qualtrics XM 플랫폼 보고 시작",
                "WHEN": "다음과 같은 경우",
                "WIDGET_LOADING": "로드 중…",
                "WIDGET_OPTIONS_ERR": "시각화 옵션을 로드하지 못함",
                "WIDGET_TYPE": "시각화",
                "WORD_CLOUD": "단어 클라우드",
                "WORD_CLOUD_DESC": "추가 색상 코드 지정 옵션을 통해 텍스트 데이터 내의 단어 빈도에 따라 가중치가 적용된 시각화입니다."
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "조직 내에는 HR 파트너, 관리자 및/또는 멘토와 같은 피드백을 해석하는 데 도움이 되는 리소스가 있습니다.",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "커피 한 잔을 따르고 귀하의 피드백에 집중하십시오.",
                "ABOUT_YOUR_REPORT_HEADER": "보고서 정보",
                "ABOUT_YOUR_REPORT_LINE1": "360 피드백 보고서에 오신 것을 환영합니다. 전문가로서 성장하고 발전할 수 있는 좋은 기회입니다. 결과를 검토할 때 성공을 위해 충분한 시간을 설정하고 피드백을 검토해야 합니다. 피드백을 처음 듣는 것은 어려울 수 있지만, 이 피드백의 목적은 성장과 발전을 가속화하기 위한 것임을 명심해야 합니다.",
                "ABOUT_YOUR_REPORT_LINE2": "보고서를 검토할 때 몇 가지 유의해야 할 사항이 있습니다.",
                "ADD_CONDITIONAL_TEXT": "조건 텍스트 추가",
                "ADD_CUSTOM_PALETTE": "맞춤 색상표 추가",
                "ADD_DATA_SOURCE": "데이터 소스 추가",
                "ADD_FOLLOWING": "다음 내용 추가",
                "ADD_LABEL": "레이블 추가",
                "ADVANCED_FILTER": "고급 필터",
                "AGREEMENT_CHART": "동의 차트",
                "AGREEMENT_CHART_FOOTER": "동의 차트는 점수의 유사성을 나타냅니다. 각 점은 개인이 각 항목에 대해 귀하를 어떻게 평가했는지 나타냅니다. 점의 크기는 특정 등급을 부여한 평가자 수를 나타냅니다.",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "응답",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "응답",
                "AGREEMENT_CHART_LEGEND_TITLE": "귀하에 대한 다른 사람들의 평가",
                "ALL": "모두",
                "AND_IF": "그리고 만약",
                "ANGLED": "기울어짐",
                "AREA": "영역",
                "AUTO": "자동",
                "AVERAGE": "평균",
                "AXIS_VALUES": "축 값",
                "BAR": "막대",
                "BASE_WORD_COLOR": "기본 단어 색상",
                "BLUR": "흐리게",
                "BOTTOM_BOX": "하단 상자",
                "BREAKOUT_HEADERS": "분류 헤더",
                "CANCEL": "취소",
                "CATEGORICAL": "범주형",
                "CATEGORY": "범주",
                "CATEGORY_NAME": "범주 이름",
                "CHANGE_CATEGORIES_ORDER": "범주 순서 변경",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "채점 범주 순서 변경",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "채점 범주 요소의 왼쪽을 클릭하고 이를 원하는 위치로 끌어와서 시각화에 나타나는 순서를 변경합니다.",
                "CHANGE_QUESTIONS_ORDER": "질문 순서 변경",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "질문 순서 변경",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "질문 요소의 왼쪽을 클릭하고 이를 원하는 위치로 끌어와서 시각화에 나타나는 순서를 변경합니다.",
                "CHARTS": "차트",
                "CHART_TYPE": "차트 유형",
                "CHOICE_COUNT": "선택 항목 수",
                "CHOICE_TOTALS": "선택 항목 총합",
                "CLEAR": "지우기",
                "CLOSE": "닫기",
                "COLOR_PALETTE": "색상표",
                "COLUMN_NAMES": "열 이름",
                "COLUMN_TOTALS": "열 총합",
                "COMPARED_FILTER_GROUP": "비교된 필터 그룹",
                "COMPARED_FILTER_GROUPS": "비교된 필터 그룹",
                "COMPARE_WITH": "비교 대상",
                "COMPETITION_RANKING": "경쟁 순위 사용",
                "COMPETITION_RANKING_TOOLTIP": "등액 이벤트에서는 모든 동점자에게 동일한 순위가 부여됩니다. 그러나 다음 후속 항목의 순위는 테이블에서 더 높은 순위 항목의 총 수에 1을 더한 값과 같습니다.",
                "COMPLETED_RESPONSES": "완료된 응답",
                "CONDITIONAL_TEXT": "조건 텍스트",
                "COUNT": "카운트",
                "CREATE": "생성",
                "CUSTOM_PALETTE": "맞춤 색상표",
                "DATA_SOURCE_TYPE": "데이터 소스 유형",
                "DATA_SOURCE_TYPE_CATEGORY": "채점 범주",
                "DATA_SOURCE_TYPE_QUESTION": "질문",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "질문",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "순위를 매길 수 있는 항목",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "채점 범주",
                "DEFAULT": "기본값",
                "DEFAULT_TEXT": "기본 텍스트",
                "DELETE": "삭제",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "피드백이 누구로부터 오는지, 동료, 직접 보고서, 리더 등으로부터 오는지 파악",
                "DIFFERENT_EVALUATORS_HEADER": "다른 평가자",
                "DIRECT_REPORTS": "직속 부하 직원",
                "DISABLED": "비활성화됨",
                "DISPLAY_OPTIONS": "표시 옵션",
                "DISPLAY_THRESHOLD_TEXTS": "다음 그룹 격차에 따라 텍스트 표시",
                "DIVERGENT": "확산형",
                "DONE": "완료",
                "DONT_HEADER": "수행 금지:",
                "DONT_LINE1": "누가 무엇을 말했는지 파악",
                "DONT_LINE2": "플러스 또는 마이너스 점수/설명에 집중",
                "DONT_LINE3": "모든 항목에 대한 개발 계획 작성",
                "DONT_LINE4": "개선할 여지가 있음에 낙담",
                "DONUT": "도넛",
                "DOWNLOAD_CSV": "이전 CSV 다운로드",
                "DOWNLOAD_ZIP": "모든 파일 다운로드",
                "DO_HEADER": "수행:",
                "DO_LINE1": "전체적으로 피드백 확인",
                "DO_LINE2": "개선 정도 및 여지에 대한 테마 확인",
                "DO_LINE3": "새 중점 영역의 우선순위를 지정하여 개발 계획에 추가",
                "DO_LINE4": "모든 사용자에게 개선 여지가 있음을 파악",
                "DROPOFF": "감소",
                "DUPLICATE": "복제",
                "EDIT_CONDITIONAL_TEXT": "조건 텍스트 편집",
                "EDIT_CUSTOM_PALETTE": "맞춤 색상표 편집",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "그렇지 않으면 다음 텍스트 표시",
                "ENABLED": "활성화됨",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "평가 정보 범주 표시 로직별 정렬 활성화",
                "ENABLE_ORDERING_FOR": "다음을 대상으로 정렬 사용",
                "EQUAL_TO": "다음 값과 같음",
                "FIELD": "필드",
                "FILTER_NAMES": "필터 이름",
                "FOLLOWING_PARENTHESES": "(다음 필터)",
                "FOOTER": "바닥글",
                "GAP": "차이",
                "GAP_CHART": "격차 차트",
                "GAP_CHART_DESCRIPTION": "격차 차트는 두 평가자 그룹 간의 점수 차이를 표시합니다. 예를 들어, 자체 등급과 다른 사람이 귀하를 평가한 내용을 비교하는 경우 플러스(+) 차이는 다른 사람이 귀하가 제공한 평가보다 귀하를 더 높게 평가했음을 의미합니다. 마이너스(-) 차이는 다른 사람이 귀하가 제공한 평가보다 더 낮게 평가했음을 의미합니다.",
                "GAP_CHART_FOOTER": "격차 차트는 두 가지 평가 정보 그룹 사이의 +/- 차이를 나타냅니다.",
                "GAP_TABLE_DESCRIPTION": "숨겨진 강점은 다른 사람이 귀하를 평가한 것보다 더 높게 평가한 위치를 보여줍니다. 개선을 위한 영역은 다른 사람이 귀하를 평가한 것보다 낮게 평가한 영역을 보여줍니다. 두 섹션 모두 가장 큰 격차에서 가장 작은 격차까지 순위가 매겨집니다.",
                "GAP_TABLE_FOOTER": "점수의 첫 번째 열은 자신의 점수를 나타냅니다. 두 번째 열은 다른 사람의 평균 점수를 나타냅니다. 세 번째 열은 자신이 채점한 방법과 다른 사람이 채점한 방법의 차이를 나타냅니다.",
                "GAP_TABLE_TITLE": "숨겨진 강점/개선 영역",
                "GREATER_OR_EQUAL": "다음 값보다 크거나 같음",
                "GREATER_THAN": "다음 값보다 큼",
                "GROUP": "그룹",
                "GROUPED_FOR_ANONYMITY": "익명성을 위해 그룹화됨",
                "HEADER_NAMES": "헤더 이름",
                "HIGHEST_SCORES": "최고 점수",
                "HIGHLIGHT_THRESHOLD": "격차를 강조 표시할 임계값",
                "HIGHLOW_TABLE": "높은 점수 및 낮은 점수",
                "HIGHLOW_TABLE_FOOTER": "이 섹션에는 해당하는 평가자 범주 평균에서 최고 평점/최저 평점을 받은 동작(모든 동작 중)이 표시됩니다. 이 페이지를 최대한 활용하려면 새롭게 등장할 수 있는 추세를 찾아보는 것이 좋습니다. 예를 들어, 최저 평점을 받은 동작의 대부분은 한두 가지 범주에 집중되어 있습니다. 이 경우 개발해야 할 영역이 있을 수 있습니다. 최고 평점을 받은 동작은 다른 영역을 활용할 수 있는 강점이 있다는 것을 확인할 수 있습니다.",
                "HIGH_LOW_TABLE_DESCRIPTION": "높음/낮음 차트는 다른 사람이 가장 높게 평가한 영역과 가장 낮게 평가한 영역을 기준으로 항목을 표시합니다.",
                "HORIZONTAL": "가로",
                "HORIZONTAL_AND_VERTICAL": "가로 및 세로",
                "HORIZONTAL_BAR": "가로 막대",
                "HOW_TO_INTERPRET_RESULT_HEADER": "결과를 해석하고 액션을 결정하는 방법:",
                "IF": "만약",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "백분율에 숨겨진 레이블 포함",
                "INNER_RIM": "내부 테두리",
                "IS": "다음과 같음",
                "IS_NOT": "다음이 아님",
                "IS_SAME_AS_SUBJECT": "대상과 같음",
                "ITEM": "항목",
                "LABEL": "레이블",
                "LABELS": "레이블",
                "LARGE_LABELS": "대형 레이블",
                "LEGEND": "범례",
                "LEGEND_POSITION": "범례 위치",
                "LEGEND_VALUES": "범례 값",
                "LESS_OR_EQUAL": "다음 값보다 작거나 같음",
                "LESS_THAN": "다음 값보다 작음",
                "LINE": "라인",
                "LOWEST_SCORES": "최저 점수",
                "MANAGERS": "관리자",
                "MANUAL_FONT_SIZE": "글꼴 크기를 수동으로 설정",
                "MAX": "최대",
                "MEAN": "평균",
                "MEDIAN": "중앙값",
                "METRIC_TYPE": "메트릭 유형",
                "MIN": "최소",
                "MODIFY_CUSTOM_PALETTES": "맞춤 색상표 수정",
                "MOVE_DOWN": "아래로 이동",
                "MOVE_UP": "위로 이동",
                "MULTI_SELECT_ITEMS_SELECTED": "선택됨",
                "NEGATIVE_GAPS": "개선 영역",
                "NO": "아니요",
                "NONE": "없음",
                "NOT_APPLICABLE": "해당 없음",
                "NOT_EQUAL_TO": "다음과 같지 않음",
                "NO_DATA_AVAILABLE_WARNING": "사용 가능한 데이터 없음",
                "NO_FILTER": "필터 없음",
                "NO_FILTER_IS_APPLIED": "필터가 적용되지 않았습니다.",
                "NO_VALUE": "값이 없음",
                "NPS": "순 추천 지수",
                "NUMBER": "숫자",
                "NUMBERS": "숫자",
                "NUMBER_OF_GAPS_NEGATIVE": "차이가 마이너스 값인 항목 수",
                "NUMBER_OF_GAPS_POSITIVE": "차이가 플러스인 값인 항목 수",
                "NUMBER_OF_ROWS_HIGH": "높음 행 수",
                "NUMBER_OF_ROWS_LOW": "낮음 행 수",
                "OPTIONS": {
                    "HEADER_NAME": "헤더 이름",
                    "LEGEND": "범례",
                    "SCALE_AXIS_CHANGER_TITLE": "범위"
                },
                "ORIENTATION": "방향",
                "OR_IF": "또는 만약",
                "OTHER": "기타",
                "OTHERS": "다른 사람",
                "PAGE_OF": "페이지: %1/%2",
                "PALETTE_REMOVED": "색상표 제거됨",
                "PEERS": "동료",
                "PERCENT": "비율",
                "PERCENTAGE": "비율",
                "PERCENTAGE_OF_CHOICES": "선택 백분율",
                "PERCENTAGE_OF_RESPONSES": "응답 백분율",
                "PERCENT_COMPLETE": "% 완료",
                "PERSON_METADATA": "사람 메타데이터",
                "PERSON_METADATA_EVALUATOR": "평가자의",
                "PERSON_METADATA_SUBJECT": "대상의",
                "PERSON_METADATA_VIEWER": "뷰어의",
                "POSITIVE_GAPS": "숨겨진 강점",
                "PRIMARY_PARENTHESES": "(기본 필터)",
                "QUESTIONS": "질문",
                "RADIUS": "반경",
                "RANK": "순위",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "최고 점수",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "최고 점수",
                "RANKABLE_ITEMS_ITEM_HAS": "항목의 내용",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "항목이 맨 위에 있음",
                "RANKABLE_ITEMS_LOWEST_SCORE": "최저 점수",
                "RANKABLE_ITEMS_LOWEST_SCORES": "최저 점수",
                "RATER_CATEGORY_DISPLAY_LOGIC": "평가 정보 범주 표시 로직",
                "RATIO": "비율",
                "RECORD": "레코드",
                "REFERENCE_GROUP": "참조 그룹",
                "RELATIONSHIP": "관계",
                "RELATIONSHIP_FILTERS": "관계 필터",
                "RELATIONSHIP_FILTERS_INFO": "직속 부하 직원, 동료 또는 관리자와 같은 관계 필터를 추가하려면 필터 관리를 선택하고 드롭다운 메뉴에서 관계 조건만 사용하십시오.",
                "REMOVE": "제거",
                "REMOVE_DATA_SOURCE": "데이터 소스 제거",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "조직 내에는 HR 파트너, 관리자 및/또는 멘토와 같은 피드백을 해석하는 데 도움이 되는 리소스가 있습니다.",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "커피 한 잔을 따르고 귀하의 피드백에 집중하십시오.",
                    "ABOUT_YOUR_REPORT_HEADER": "보고서 정보",
                    "ABOUT_YOUR_REPORT_LINE1": "360 피드백 보고서에 오신 것을 환영합니다. 전문가로서 성장하고 발전할 수 있는 좋은 기회입니다. 결과를 검토할 때 성공을 위해 충분한 시간을 설정하고 피드백을 검토해야 합니다. 피드백을 처음 듣는 것은 어려울 수 있지만, 이 피드백의 목적은 성장과 발전을 가속화하기 위한 것임을 명심해야 합니다.",
                    "ABOUT_YOUR_REPORT_LINE2": "보고서를 검토할 때 몇 가지 유의해야 할 사항이 있습니다.",
                    "ADVANCED_FILTER": "고급 필터",
                    "AGREEMENT_CHART": "동의 차트",
                    "AGREEMENT_CHART_FOOTER": "동의 차트는 점수의 유사성을 나타냅니다. 각 점은 개인이 각 항목에 대해 귀하를 어떻게 평가했는지 나타냅니다. 점의 크기는 특정 등급을 부여한 평가자 수를 나타냅니다.",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "응답",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "응답",
                    "AGREEMENT_CHART_LEGEND_TITLE": "귀하에 대한 다른 사람들의 평가",
                    "ALL": "모두",
                    "AVERAGE": "평균",
                    "BOTTOM_BOX": "하단 상자",
                    "CHOICE_COUNT": "선택 항목 수",
                    "CHOICE_TOTALS": "선택 항목 총합",
                    "COMPARISON": "비교",
                    "COMPARISON_GAP_COLUMN_HEADER": "비교 차이",
                    "COMPLETED_RESPONSES": "완료된 응답",
                    "COUNT": "카운트",
                    "DEFAULT": "기본값",
                    "DEFAULT_TEXT": "기본 텍스트",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "피드백이 누구로부터 오는지, 동료, 직접 보고서, 리더 등으로부터 오는지 파악",
                    "DIFFERENT_EVALUATORS_HEADER": "다른 평가자",
                    "DONE": "완료",
                    "DONT_HEADER": "수행 금지:",
                    "DONT_LINE1": "누가 무엇을 말했는지 파악",
                    "DONT_LINE2": "플러스 또는 마이너스 점수/설명에 집중",
                    "DONT_LINE3": "모든 항목에 대한 개발 계획 작성",
                    "DONT_LINE4": "개선할 여지가 있음에 낙담",
                    "DO_HEADER": "수행:",
                    "DO_LINE1": "전체적으로 피드백 확인",
                    "DO_LINE2": "개선 정도 및 여지에 대한 테마 확인",
                    "DO_LINE3": "새 중점 영역의 우선순위를 지정하여 개발 계획에 추가",
                    "DO_LINE4": "모든 사용자에게 개선 여지가 있음을 파악",
                    "FIELD": "필드",
                    "GAP": "차이",
                    "GAP_CHART": "격차 차트",
                    "GAP_CHART_DESCRIPTION": "격차 차트는 두 평가자 그룹 간의 점수 차이를 표시합니다. 예를 들어, 자체 등급과 다른 사람이 귀하를 평가한 내용을 비교하는 경우 플러스(+) 차이는 다른 사람이 귀하가 제공한 평가보다 귀하를 더 높게 평가했음을 의미합니다. 마이너스(-) 차이는 다른 사람이 귀하가 제공한 평가보다 더 낮게 평가했음을 의미합니다.",
                    "GAP_CHART_FOOTER": "격차 차트는 두 가지 평가 정보 그룹 사이의 +/- 차이를 나타냅니다.",
                    "GAP_TABLE_DESCRIPTION": "숨겨진 강점은 다른 사람이 귀하를 평가한 것보다 더 높게 평가한 위치를 보여줍니다. 개선을 위한 영역은 다른 사람이 귀하를 평가한 것보다 낮게 평가한 영역을 보여줍니다. 두 섹션 모두 가장 큰 격차에서 가장 작은 격차까지 순위가 매겨집니다.",
                    "GAP_TABLE_FOOTER": "점수의 첫 번째 열은 자신의 점수를 나타냅니다. 두 번째 열은 다른 사람의 평균 점수를 나타냅니다. 세 번째 열은 자신이 채점한 방법과 다른 사람이 채점한 방법의 차이를 나타냅니다.",
                    "GAP_TABLE_TITLE": "숨겨진 강점/개선 영역",
                    "GROUP": "그룹",
                    "HIDE_REPORT_ALERT": "보고서를 보기 위한 요구 사항을 충족하지 않습니다. 조직 관리자에게 문의하십시오.",
                    "HIGHEST_SCORES": "최고 점수",
                    "HIGHLOW_TABLE": "높은 점수 및 낮은 점수",
                    "HIGHLOW_TABLE_FOOTER": "이 섹션에는 해당하는 평가자 범주 평균에서 최고 평점/최저 평점을 받은 동작(모든 동작 중)이 표시됩니다. 이 페이지를 최대한 활용하려면 새롭게 등장할 수 있는 추세를 찾아보는 것이 좋습니다. 예를 들어, 최저 평점을 받은 동작의 대부분은 한두 가지 범주에 집중되어 있습니다. 이 경우 개발해야 할 영역이 있을 수 있습니다. 최고 평점을 받은 동작은 다른 영역을 활용할 수 있는 강점이 있다는 것을 확인할 수 있습니다.",
                    "HIGH_LOW_TABLE_DESCRIPTION": "높음/낮음 차트는 다른 사람이 가장 높게 평가한 영역과 가장 낮게 평가한 영역을 기준으로 항목을 표시합니다.",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "결과를 해석하고 액션을 결정하는 방법:",
                    "ITEM": "항목",
                    "LOWEST_SCORES": "최저 점수",
                    "MAX": "최대",
                    "MEAN": "평균",
                    "MEDIAN": "중앙값",
                    "MIN": "최소",
                    "NEGATIVE_GAPS": "개선 영역",
                    "NO_COMPARISON_SET": "설정된 비교 없음",
                    "NO_DATA_AVAILABLE_WARNING": "사용 가능한 데이터 없음",
                    "NO_FILTER_IS_APPLIED": "필터가 적용되지 않았습니다.",
                    "NO_VALUE": "값이 없음",
                    "NPS": "순 추천 지수",
                    "OTHERS": "다른 사람",
                    "PERCENTAGE": "비율",
                    "PERCENTAGE_OF_CHOICES": "선택 백분율",
                    "PERCENTAGE_OF_RESPONSES": "응답 백분율",
                    "PERCENT_COMPLETE": "% 완료",
                    "POSITIVE_GAPS": "숨겨진 강점",
                    "QUESTIONS": "질문",
                    "RANK": "순위",
                    "RELATIONSHIPS": {
                        "ANYONE": "모든 사람",
                        "DIRECT_REPORT": "직속 부하 직원",
                        "MANAGER": "관리자",
                        "PEER": "동료",
                        "SELF": "자신"
                    },
                    "REPORT_SUMMARY": "보고서 요약",
                    "REPORT_SUMMARY_TABLE_FOOTER": "평가를 마친 사람의 수와 참여에 초청된 사람의 수를 비교해 보십시오.",
                    "REPORT_SUMMARY_TABLE_HEADER": "응답자 통계",
                    "RESPONSES": "응답",
                    "RESPONSE_COUNT": "{{responseCount}} 응답",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span>개 응답",
                    "SCORING_CATEGORY": "채점 범주",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "이 범주에 대한 응답이 없음",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "이 질문에 대한 응답이 없음",
                    "SCORING_OVERVIEW": "채점 개요",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "귀하와 다른 평가자가 이 영역이 최고의 강점이라고 생각합니다.",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "인정된 강점",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "인정된 개선 영역은 자체 평가와 다른 평가가 둘 다 이 역량의 평균보다 아래임을 의미합니다.",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "인정된 개선 영역",
                    "SCORING_OVERVIEW_DESCRIPTION": "위 내용은 복수 평가자 피드백 프로세스의 일부로 평가된 역량 또는 행동입니다. 그룹별로 비교 평가가 제공됩니다.",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "최소 차이",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "표시할 텍스트에 대한 참조 그룹 간 최소 차이입니다.",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "각 역량/동작의 점수 범위를 표시합니다. 막대는 숫자 평균을 나타냅니다.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "인정되지 않은 강점은 자체 평가와 다른 사람의 평가 간의 불일치에서 발생합니다.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "인정되지 않은 강점",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "인정되지 않은 개선 영역은 자체 평가와 다른 사람의 평가 간의 불일치에서 발생합니다.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "인정되지 않은 개선 영역",
                    "SELF": "자신",
                    "SELF_ASSESSMENT": "자체 평가",
                    "STANDARD_DEVIATION": "표준 편차",
                    "SUM": "합계",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "정확한 해석을 위해 평가 척도 숙지",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "스케일 주의",
                    "THINGS_YOU_WILL_SEE_HEADER": "표시될 항목:",
                    "THREE_SIXTY_PERCENTILE": "백분위수",
                    "TOP_BOTTOM_BOX": "상단 상자/하단 상자",
                    "TOP_BOX": "상단 상자",
                    "TOTAL": "총합",
                    "TO_DO": "할 일",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "정성적: 이 피드백은 개방형 텍스트 설명 형식으로 이루어집니다.",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "정량적: 이 피드백은 숫자로 표시되며 그래프, 막대 차트, 테이블 등으로 나타낼 수 있습니다.",
                    "TYPES_OF_FEEDBACK_HEADER": "다양한 유형의 피드백",
                    "VALUE": "값",
                    "VARIANCE": "분산",
                    "YOUR_RATINGS": "사용자 등급"
                },
                "REPORT_SUMMARY": "보고서 요약",
                "REPORT_SUMMARY_TABLE_FOOTER": "평가를 마친 사람의 수와 참여에 초청된 사람의 수를 비교해 보십시오.",
                "REPORT_SUMMARY_TABLE_HEADER": "응답자 통계",
                "RESET": "재설정",
                "RESPONDENT_TOTALS": "응답자 총합",
                "RESPONSES": "응답",
                "RESPONSE_COUNT": "{{responseCount}} 응답",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span>개의 응답",
                "RESULT": "결과",
                "REVERSE_COLORS": "색상 반전",
                "ROW_TOTALS": "행 총합",
                "SAVE": "저장",
                "SAVE_AND_APPLY": "저장 후 적용",
                "SCORING_CATEGORY": "채점 범주",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "이 범주에 대한 응답이 없음",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "이 질문에 대한 응답이 없음",
                "SCORING_OVERVIEW": "채점 개요",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "귀하와 다른 평가자가 이 영역이 최고의 강점이라고 생각합니다.",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "인정된 강점",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "인정된 개선 영역은 자체 평가와 다른 평가가 둘 다 이 역량의 평균보다 아래임을 의미합니다.",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "인정된 개선 영역",
                "SCORING_OVERVIEW_DESCRIPTION": "위 내용은 복수 평가자 피드백 프로세스의 일부로 평가된 역량 또는 행동입니다. 그룹별로 비교 평가가 제공됩니다.",
                "SCORING_OVERVIEW_MINIMUM_GAP": "최소 차이",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "표시할 텍스트에 대한 참조 그룹 간 최소 차이입니다.",
                "SCORING_OVERVIEW_TABLE_FOOTER": "각 역량/동작의 점수 범위를 표시합니다. 막대는 숫자 평균을 나타냅니다.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "인정되지 않은 강점은 자체 평가와 다른 사람의 평가 간의 불일치에서 발생합니다.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "인정되지 않은 강점",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "인정되지 않은 개선 영역은 자체 평가와 다른 사람의 평가 간의 불일치에서 발생합니다.",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "인정되지 않은 개선 영역",
                "SELECT_CATEGORIES": "채점 범주를 선택해 주십시오...",
                "SELECT_CATEGORY": "채점 범주를 선택해 주십시오...",
                "SELECT_CONDITION_TYPE": "조건 유형 선택",
                "SELECT_DATA_SOURCE": "데이터 소스 선택",
                "SELECT_DATA_SOURCE_TYPE": "데이터 소스 유형 선택",
                "SELECT_FILTER": "필터 선택",
                "SELECT_FILTERS": "필터 선택",
                "SELECT_OPERATOR_TYPE": "연산자 유형 선택",
                "SELECT_PERSON": "사람 선택",
                "SELECT_PERSON_METADATA": "사람 메타데이터 선택",
                "SELECT_QUESTION": "질문 선택",
                "SELECT_QUESTIONS": "질문을 선택해 주십시오...",
                "SELECT_RATIO_OR_DROPOFF": "비율 또는 감소 선택",
                "SELECT_RELATIONSHIP": "관계 선택",
                "SELECT_SCORING_CATEGORY": "점수 매기기 범주 선택",
                "SELF": "자신",
                "SELF_ASSESSMENT": "자체 평가",
                "SEQUENTIAL": "순차적",
                "SETUP_COMPARISON": "비교 설정",
                "SETUP_COMPARISONS": "비교 설정",
                "SET_START_COLOR": "시작 색상 설정",
                "SHOULD_SHOW_FOOTER": "바닥글 표시",
                "SHOULD_SHOW_SCORING_CATEGORY": "채점 범주 표시",
                "SHOWING_RECORDS_OF": "%3개 중 %1~%2개 레코드 표시",
                "SHOW_COMPARISON_GAP": "비교 갭 열 표시",
                "SHOW_DATA_LABEL": "데이터 값 표시",
                "SHOW_PERCENTAGES": "백분율 표시",
                "SHOW_THE_FOLLOWING_TEXT": "그러면 다음 텍스트 표시",
                "SHOW_TIES": "동점 표시",
                "SHOW_X_AXIS": "X 축 표시",
                "SHOW_Y_AXIS": "Y 축 표시",
                "SMALL_LABELS": "소형 레이블",
                "SORT": "정렬",
                "SPLINE": "스플라인",
                "STACK_CHART": "누적 차트",
                "STANDARD_DEVIATION": "표준 편차",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "다음 미만 약점",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "임계값 텍스트 편집",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "임계값 텍스트",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "임계값 텍스트 사용",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "다음 초과 강점",
                "SUM": "합계",
                "SUMMARY": "요약",
                "TABLES": "테이블",
                "TABLE_TOTALS": "테이블 총합",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "정확한 해석을 위해 평가 척도 숙지",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "스케일 주의",
                "TEXT": "텍스트",
                "THINGS_YOU_WILL_SEE_HEADER": "표시될 항목:",
                "TOP_BOTTOM_BOX": "상단 상자/하단 상자",
                "TOP_BOX": "상단 상자",
                "TOTAL": "총합",
                "TOTAL_COUNTS": "총 수",
                "TO_DO": "할 일",
                "TRANSPOSE": "행/열 바꾸기",
                "TRANSPOSE_TABLE": "테이블 행/열 바꾸기",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "정성적: 이 피드백은 개방형 텍스트 설명 형식으로 이루어집니다.",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "정량적: 이 피드백은 숫자로 표시되며 그래프, 막대 차트, 테이블 등으로 나타낼 수 있습니다.",
                "TYPES_OF_FEEDBACK_HEADER": "다양한 유형의 피드백",
                "UNDO": "실행 취소",
                "USE_COMPARISON": "비교 사용",
                "USE_LABELS_FOR_SCALES": "척도에 레이블 사용",
                "VALUES": "값",
                "VALUE_RANGES": "값 범위",
                "VARIANCE": "분산",
                "VERTICAL": "세로",
                "VERTICAL_RANGE": "세로 범위",
                "WARNING_DATA_OUT_OF_RANGE": "경고: 데이터 값이 범위 구성을 초과함",
                "WIDGET_ERROR": {
                    "ERROR": "예기치 않은 오류가 발생함",
                    "MISCONFIGURED": "일부 위젯이 올바르게 구성되지 않았습니다. 위젯 구성을 확인해 주십시오.",
                    "NEW": "위젯을 구성해 주십시오.",
                    "NO_DATA": "데이터를 찾을 수 없음 - 필터가 너무 많이 제외되었을 수 있습니다!"
                },
                "WIDGET_NAME": {
                    "BAR": "막대 차트",
                    "BREAKDOWNBAR": "분석 막대",
                    "DATA_TABLE": "데이터 테이블",
                    "FUNNEL_CHART": "깔때기형 차트",
                    "GAUGE": "게이지 차트",
                    "GRID": "결과 테이블",
                    "HEATMAP": "히트 맵",
                    "LINE": "꺾은선형 차트",
                    "NEEDS_BASED": "요구사항 기반",
                    "PIE": "원형 차트",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "가격 예측 도구(Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "수익 극대화 도구(Gabor Granger)",
                    "SCORING_OVERVIEW_CHART": "차트",
                    "SCORING_OVERVIEW_TABLE": "테이블",
                    "STATS_TABLE": "통계 테이블",
                    "WORDCLOUD": "단어 클라우드"
                },
                "WORD_ROTATION": "단어 회전",
                "WORD_SPACING": "단어 간격",
                "YES": "예",
                "YOUR_RATINGS": "사용자 등급"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "추가",
                "ADD_A_WORD": "단어 추가",
                "COLOR": "색상",
                "DELETE_ALL": "모두 삭제",
                "EDIT_STOP_WORDS": "중지 단어 편집",
                "MAX_WORDS": "최대 단어 수",
                "ROTATION_ANGLED": "기울어짐",
                "ROTATION_HORIZONTAL": "가로",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "가로 및 세로",
                "WORD_ORIENTATION": "단어 방향"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "배격 색상",
                "DISPLAY_OPTIONS": "표시 옵션",
                "INVERT_FONT_COLORS": "저대비 글꼴 색상 반전",
                "PAGE": "페이지",
                "PAGINATE": "페이지 매김"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "평균",
                "BOTTOM_BOX_METRIC": "하단 상자",
                "COLUMNS": "열",
                "COUNT_METRIC": "총 응답",
                "FIELD_NAME": "필드",
                "MAX_METRIC": "최대",
                "MIN_METRIC": "최소",
                "SHOW_RECODES": "코드 재지정 값 표시",
                "SHOW_ROW_NUMBERS": "행 번호 표시",
                "STD_DEV_METRIC": "표준 편차",
                "TOP_BOX_METRIC": "상단 상자",
                "TRANSPOSE_BREAKOUTS": "행/열 바꾸기 구분",
                "TRANSPOSE_TABLE": "테이블 행/열 바꾸기",
                "VAR_METRIC": "분산"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "추가 열",
                "ADD_COLUMNS": "열 추가",
                "ADD_CUSTOM_PALETTE": "맞춤 색상표 추가",
                "ALL_CHOICES": "모든 선택 항목",
                "ALL_GROUPS": "모든 그룹",
                "ALL_RECODES": "모든 코드 재지정 항목",
                "AUTOMATIC": "기본값",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "기본값 - 클릭하여 편집",
                "AXIS_VALUES": "축 값",
                "BREAKOUT_BY": "분류 기준",
                "CANCEL": "취소",
                "CATEGORICAL": "범주형",
                "CHOICES": "선택 항목",
                "CHOICE_COUNT": "선택 항목 수",
                "COLOR_PALETTE": "색상표",
                "COLUMN_VALUES": "열 값",
                "CONTACT_FIELDS": "연락처 필드",
                "COUNT": "카운트",
                "CREATE": "생성",
                "CUSTOM": "사용자 정의",
                "CUSTOM_PALETTE": "맞춤 색상표",
                "DATA_SOURCE": "데이터 소스",
                "DAY": "일",
                "DAY_OF_WEEK": "요일",
                "DECIMAL_PRECISION": "소수 자릿수",
                "DEFAULT": "기본값",
                "DISABLED": "비활성화됨",
                "DIVERGENT": "확산형",
                "EDIT_CUSTOM_PALETTE": "맞춤 색상표 편집",
                "ENABLED": "활성화됨",
                "ERROR_LOADING_DATA": "데이터 로드 중 오류 발생",
                "FILE_SIZE": "크기",
                "FILE_TYPE": "유형",
                "FRI": "금",
                "FRIDAY": "금요일",
                "GROUP_DATE_BY": "날짜 그룹화 기준",
                "HOUR_OF_DAY": "시간",
                "LENGEND_VALUES": "범례 값",
                "MAX": "최대",
                "MEAN": "평균",
                "MIN": "최소",
                "MISCONFIGURED_DATA": "이 시각화의 데이터 소스가 잘못 구성되었습니다.",
                "MISCONFIGURED_FILTERS": "유효하지 않은 필터",
                "MODIFY_CUSTOM_PALETTES": "맞춤 색상표 수정",
                "MON": "월",
                "MONDAY": "월요일",
                "MONTH": "월",
                "NONE": "없음",
                "NO_FILE_ID_ERROR": "이 시각화에는 설문조사에 설정할 이미지가 필요함",
                "NO_RESULTS_TO_SHOW": "표시할 결과가 없음",
                "NPS": "순 추천 지수®",
                "NPS_GROUP": "NPS® 그룹",
                "NUMERIC_VALUE": "숫자 값",
                "PALETTE_REMOVED": "색상표 제거됨",
                "PERCENTAGE": "비율",
                "PERCENTAGE_OF_CHOICES": "선택 백분율",
                "PERCENTAGE_OF_RESPONSES": "응답 백분율",
                "QUARTER": "분기",
                "REMOVE": "제거",
                "RESPONSE_COUNT": "응답 수",
                "RESULTS_PER_PAGE": "페이지당 결과 수",
                "RETRIEVING_DATA_ELLIPSIS": "데이터 검색 중...",
                "REVERSE_COLORS": "색상 반전",
                "ROW_VALUES": "행 값",
                "SAT": "토",
                "SATURDAY": "토요일",
                "SAVE": "저장",
                "SELECTED_CHOICE": "선택한 항목",
                "SELECT_FIELD": "필드 선택",
                "SELECT_METRIC": "메트릭",
                "SEQUENTIAL": "순차적",
                "SET_START_COLOR": "시작 색상 설정",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "샘플 데이터 표시 중...",
                "SUM": "합계",
                "SUN": "일",
                "SUNDAY": "일요일",
                "SURVEY_EMBEDDEDDATA": "임베드된 데이터",
                "SURVEY_METADATA": "설문조사 메타데이터",
                "TEXT_ENTRY": "텍스트 엔트리",
                "THURS": "목",
                "THURSDAY": "목요일",
                "TITLE": "제목",
                "TUES": "화",
                "TUESDAY": "화요일",
                "UNBOUNDED_DOMAIN": "표시할 값이 너무 많습니다.",
                "UNBOUNDED_DOMAIN_HELP": "이 필드를 결과 보고서에 추가하려면 보고서에 필터를 추가하여 ‘{{ed_field_name}}’에 대한 값을 더 적게 표시하거나, 설문조사 흐름에서 ‘{{ed_field_name}}’의 임베드된 데이터 변수 유형을 업데이트하여 이 필드를 문자열 또는 숫자 유형으로 만듭니다.",
                "UNDO": "실행 취소",
                "USE_CHOICE_TOTALS": "선택 항목 총합 사용",
                "USE_RESPONDENT_TOTALS": "응답자 총합 사용",
                "VISUALIZATION": "시각화",
                "VISUALIZATION_BARCHART": "막대 차트",
                "VISUALIZATION_BREAKDOWNBAR": "분석 막대",
                "VISUALIZATION_GAUGE": "게이지 차트",
                "VISUALIZATION_HEATMAP": "히트맵",
                "VISUALIZATION_LINECHART": "꺾은선형 차트",
                "VISUALIZATION_PAGINATEDTABLE": "페이지가 매겨진 테이블",
                "VISUALIZATION_PIE": "원형 차트",
                "VISUALIZATION_SIMPLETABLE": "단순 테이블",
                "VISUALIZATION_STATSTABLE": "통계 테이블",
                "VISUALIZATION_TEXTHIGHLIGHTS": "텍스트 강조 표시",
                "VISUALIZATION_WORDCLOUD": "단어 클라우드",
                "WED": "수",
                "WEDNESDAY": "수요일",
                "WEEK": "주",
                "WEIGHTING": "가중치",
                "WRONG_QUESTION_TYPE_ERROR": "이 설문조사 유형은 이 질문에 사용할 수 없음",
                "YEAR": "년"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "평균",
                "CHOICE_COUNT": "선택 항목 수",
                "COUNT": "카운트",
                "DISPLAY_OPTIONS": "표시 옵션",
                "MAX": "최대",
                "MIN": "최소",
                "NPS": "NPS®",
                "PAGE_OF": "페이지: %1/%2",
                "PERCENT": "비율",
                "RESPONSE_COUNT": "응답 수",
                "ROWS_PER_TABLE": "테이블당 행 수",
                "SHOWING_ROWS_OF": "%1~%2/%3번 행 표시 중",
                "SHOW_PERCENTAGES": "백분율 표시",
                "SHOW_RECODES": "코드 재지정 값 표시",
                "SHOW_ROW_NUMBERS": "행 번호 표시",
                "SUM": "합계",
                "TOTAL": "총합",
                "TRANSPOSE": "행/열 바꾸기",
                "USE_COLUMN_TOTALS": "열 총합 사용",
                "USE_ROW_TOTALS": "행 총합 사용",
                "VALUE": "값"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "오름차순",
                "COUNT": "카운트",
                "DESCENDING": "내림차순",
                "DIAGONAL": "대각선",
                "DISPLAY_OPTIONS": "표시 옵션",
                "ERROR_COLON": "오류:",
                "ERROR_GENERIC": "시각화를 로드하는 중 오류가 발생했습니다.",
                "HORIZONTAL": "가로",
                "HORIZONTAL_BARS": "가로 막대",
                "INCORRECTLY_CONFIGURED": "차트로 나타낼 값 선택",
                "LEGEND_AUTO": "자동",
                "LEGEND_BOTTOM": "하단",
                "LEGEND_INSET": "인셋",
                "LEGEND_RIGHT": "오른쪽",
                "NORMALIZE_TO_PERCENTAGES": "백분율로 정규화",
                "SHOW_BAR_LABELS": "막대 레이블 표시",
                "SHOW_LEGEND": "범례 표시",
                "SHOW_X_AXIS": "X 축 표시",
                "SHOW_Y_AXIS": "Y 축 표시",
                "SORT_BAR_VALUES": "막대 값 정렬",
                "STACKED_BARS": "스택 막대",
                "TRANSPOSE": "행/열 바꾸기",
                "TRUNCATE_LABELS": "레이블 자르기",
                "VERTICAL": "세로"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "다른 모든 사람",
                "COULD_NOT_LOAD_DATA": "지정된 구성으로 데이터를 로드할 수 없음 - 다른 소스 필드나 더 큰 날짜 범위를 사용해 보십시오.",
                "GROUPING_PERCENTAGE_THRESHOLD": "백분율 임계값 그룹화",
                "NO_DATA": "데이터 없음",
                "RADIUS": "내부 반경",
                "SHOW_AS_PERCENTAGES": "백분율로 표시"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "닫기",
                "DOWNLOAD_CSV": "CSV 다운로드",
                "DOWNLOAD_ZIP": "모든 파일 다운로드",
                "NO_DATA": "데이터 없음",
                "PAGE_OF": "페이지: %1/%2",
                "RESULTS_PER_PAGE": "페이지당 결과 수",
                "SHOWING_RECORDS_OF": "%3개 중 %1~%2개 레코드 표시",
                "SINGLE_RESPONSE": "단일 응답",
                "VIEW_RESPONSE": "응답 보기"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "표시 옵션",
                "ERROR_COLON": "오류:",
                "ERROR_GENERIC": "시각화를 로드하는 중 오류가 발생했습니다.",
                "HORIZONTAL_BARS": "가로 막대",
                "INCORRECTLY_CONFIGURED": "차트로 나타낼 값 선택",
                "LEGEND_AUTO": "자동",
                "LEGEND_BOTTOM": "하단",
                "LEGEND_INSET": "인셋",
                "LEGEND_RIGHT": "오른쪽",
                "NORMALIZE_TO_PERCENTAGES": "백분율로 정규화",
                "SHOW_AREA": "영역 표시",
                "SHOW_LEGEND": "범례 표시",
                "SHOW_X_AXIS": "X 축 표시",
                "SHOW_Y_AXIS": "Y 축 표시",
                "SMOOTH_LINES": "부드러운 선",
                "SORT_X_AXIS_LABELS": "X축 레이블 정렬",
                "STACKED_BARS": "스택 막대",
                "TRANSPOSE": "행/열 바꾸기"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "블록 모드",
                "BLUR": "흐리게",
                "COULD_NOT_LOAD_DATA": "지정된 구성으로 데이터를 로드할 수 없음 - 다른 소스 필드나 더 큰 날짜 범위를 사용해 보십시오.",
                "FIELD": "필드",
                "RADIUS": "반경",
                "SHOW_REGIONS": "영역 표시",
                "SHOW_REGION_LABELS": "영역 레이블 표시"
            },
            "GAUGEWIDGET": {
                "MAX": "최대",
                "MIN": "최소",
                "VALUE_RANGES": "값 범위"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "하단 레이블",
                "CATEGORY_NAME": "범주 이름",
                "ERROR_COLON": "오류:",
                "INCLUDE_HIDDEN_GROUPS": "백분율에 숨겨진 그룹 포함",
                "LARGE_LABELS": "대형 레이블",
                "NO": "아니요",
                "PERCENT": "비율",
                "RESPONSE_COUNT": "응답 수",
                "RESPONSE_COUNT_WITH_VALUE": "{{ responseCount }}개 응답",
                "SMALL_LABELS": "소형 레이블",
                "YES": "예"
            }
        });
        $cache.put('MS', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "Kod Capaian",
                "ACCESS_CODE_PROTECTION": "Perlindungan Kod Capaian",
                "ADD": "Tambah",
                "ADD_BREAKOUT": "Tambah Pisahan Laporan",
                "ADD_NOTE": "Tambah Nota",
                "ADD_SCHEDULED_REPORT": "Tambah Laporan Berjadual",
                "ADD_WIDGET": "Tambah Penggambaran",
                "ALL_PROJECTS": "Semua Projek",
                "ALL_QUESTIONS": "Halaman Soalan",
                "ANSWER": "Jawapan",
                "ANY_CHANGES_LOST": "Apa-apa perubahan pada laporan akan hilang jika anda meninggalkan Platform XM Qualtrics.",
                "APPENDED_COPY_IN_PARENS": "(Salin)",
                "AREA_CHART": "Carta Bahagian",
                "AREA_CHART_DESC": "Carta baris dua paksi dengan bahagian di bawah garis diisi.",
                "ATTACHMENT": "Lampiran",
                "BACKUP_CURRENT_REPORT": "Simpan salinan sandaran bagi laporan ini sebelum menjejaskan penggambaran",
                "BACKUP_CURRENT_REPORT_LINE2": "Nota: salinan sandaran akan dinamakan \"{{nameOfReportCopy}}\"",
                "BACK_TO_REPORTS": "Kembali ke Laporan",
                "BACK_TO_TOP": "Kembali ke Atas",
                "BACK_TO_VIEW_RESULTS": "Kembali ke hasil paparan lama",
                "BAR_CHART": "Carta Bar",
                "BAR_CHART_DESC": "Carta bar dua paksi yang membenarkan konfigurasi tambahan seperti peralihan paksi dan pengaturan semula titik data.",
                "BREAKDOWN_BAR_CHART": "Bar Pecahan",
                "BREAKDOWN_BAR_CHART_DESC": "Carta bar bertindan mendatar yang sering digunakan untuk mengukur metrik secara visual antara satu sama lain sebagai alternatif kepada carta pai.",
                "CANCEL": "Batal",
                "CANCEL_CONF_TEXT": "Adakah anda pasti ingin membatalkannya?<br/>Semua perubahan akan hilang.",
                "CANCEL_EDITS": "Batalkan Edit",
                "CHART": "Carta",
                "CHOICE": "Pilihan",
                "CHOICES_COUNT_METRIC": "Kiraan Pilihan",
                "CHOOSE_PAGES_TO_DISPLAY": "Pilih Halaman untuk Dipaparkan",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "Laporan ini mengandungi {{maxReportPageCount}} halaman, tetapi Hasil hanya boleh terkandung sehingga {{reportSizeLimit}}. Sila pilih subset mengikut had.",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "Laporan hanya boleh terkandung sehingga {{reportSizeLimit}} halaman, sila pilih halaman yang anda suka.",
                "CLEAR_ALL": "Kosongkan Semua",
                "CLOSE": "Tutup",
                "CLOUD": "PERIHALAN UNTUK CLOUD",
                "COLLABORATED_NEW": "Pemilik kaji selidik ini menggunakan Platform Qualtrics XM! Laporan kaji selidik ini akan diedit menggunakan Hasil Baharu.",
                "COMMA_SEPARATED_LIST": "Senarai Dipisahkan Koma",
                "COMPACTNESS": "Fon dan Jarak",
                "COMPACTNESS_INFO": "Tetapan ini menjejaskan ruang jadual, saiz fon, dan saiz bar dalam carta. Ia juga akan digunakan untuk kebanyakan eksport.",
                "CONFIRM": "Teruskan",
                "CONFIRM_DELETE": "Sahkan Pemadaman",
                "CONFIRM_DELETE_PAGE": "Adakah anda ingin memadam halaman ini?",
                "CONTINUE": "Teruskan",
                "CONTINUE_EDITING": "Teruskan Pengeditan",
                "COPY": "Salin",
                "COPY_OF_REPORT_NAME": "Salinan {{nameOfCurrentReport}}",
                "COPY_REPORT": "Salin Laporan",
                "COPY_REPORT_ELLIPSIS": "Salin Laporan...",
                "COPY_TO_NEW_REPORT": "Salin ke Laporan Baharu...",
                "CREATE": "Cipta",
                "CREATED": "Dicipta",
                "CREATE_CUSTOM_PAGE": "Cipta Halaman Tersuai",
                "CREATE_NEW_REPORT": "Cipta Laporan Baharu",
                "CREATE_NEW_REPORT_ELLIPSIS": "Cipta Laporan Baharu...",
                "CSV_FILE": "Fail CSV",
                "CUSTOM_PAGES": "Halaman Tersuai",
                "DATE": "Tarikh",
                "DEFAULT_PALETTE": "Palet Warna Lalai",
                "DEFAULT_REPORT": "Laporan Lalai",
                "DEFAULT_VISUALIZATIONS": "Penggambaran Lalai",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "Berikut ialah jenis penggambaran lalai yang digunakan untuk membina laporan hasil lalai. Dengan mengemas kini dan menggunakan tetapan ini, laporan semasa anda akan terbina semula dengan tetapan lalai baharu. Anda akan mempunyai pilihan untuk sandarkan laporan semasa anda.",
                "DEFAULT_VISUALIZATIONS_NOTE": "Nota: Bukan setiap jenis penggambaran tersedia untuk semua jenis soalan. Beberapa penggambaran bukan lalai boleh digantikan secara automatik.",
                "DEFAULT_VISUALS_DISCLAIMER": "Qualtrics akan mengemas kini laporan ini dengan tetapan penggambaran lalai baharu.",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "Kemas kini ini akan menjejaskan {{amountOfWidgetsAffected}} penggambaran dalam laporan ini.",
                "DEFAULT_VISUAL_EDIT_DETECTED": "Edit Penggambaran Lalai Dikesan",
                "DELETE_BUTTON": "Padam",
                "DELETE_DISABLED_EXPLANATION": "Pemadaman laporan yang dicipta dalam antara muka laporan sebelumnya tidak dibenarkan sehingga organisasi anda menjalankan penghijrahan penuh ke Platform Qualtrics XM.",
                "DELETE_PAGE": "Padam Halaman",
                "DELETE_PAGE_ELLIPSIS": "Padam Halaman...",
                "DELETE_REPORT": "Padam Laporan",
                "DELETE_REPORT_ELLIPSIS": "Padam Laporan...",
                "DELETE_WIDGET_QUESTION": "Padam?",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "Medan ini adalah sulit dan tidak boleh digunakan untuk pengisihan.",
                "DISCARD_EDITS": "Buang Pengeditan",
                "DISTRIBUTION_PAUSED": "Pengedaran laporan dihentikan seketika.",
                "DONE_BUTTON": "Selesai",
                "DONE_EDITING": "Selesai Mengedit",
                "DOWNLOAD": "Muat Turun",
                "DOWNLOAD_AS_CSV": "Muat turun sebagai CSV",
                "DOWNLOAD_AS_PDF": "Muat Turun sebagai PDF",
                "DOWNLOAD_FAILED": "Muat turun gagal",
                "DOWNLOAD_PREVIOUS_EXPORTS": "Muat Turun Pengeksportan Sebelumnya...",
                "DO_YOU_WISH_TO_DELETE": "Adakah anda ingin padam:",
                "DUPLICATE_PAGE": "Salin Helaian",
                "EDIT_REPORT": "Edit Laporan",
                "EDIT_REPORT_ELLIPSIS": "Edit Laporan...",
                "EDIT_VISUALIZATION": "Edit Penggambaran",
                "EMAIL_ADDRESS": "Alamat E-mel",
                "EMAIL_SENT": "E-mel dihantar...",
                "END_OF_REPORT": "Laporan Tamat",
                "ENTER_NAME": "Masukkan Nama",
                "ERROR_COPYING": "Terdapat ralat semasa menyalin laporan.",
                "ERROR_DELETING": "Terdapat ralat semasa memadam laporan.",
                "ERROR_DELETING_EXPORT": "Terdapat ralat semasa memadam eksport.",
                "ERROR_HEADING": "Ralat",
                "ERROR_PUBLISHING": "Terdapat ralat semasa menyimpan tetapan.",
                "ERROR_RENAMING": "Terdapat ralat semasa menamakan semula laporan.",
                "ERROR_REQUESTING_EXPORT": "Terdapat ralat semasa meminta eksport.",
                "ERROR_SAVING_GLOBAL_OPTIONS": "Terdapat ralat semasa menyimpan pilihan penggambaran global.",
                "ERROR_SEND_TEST_EMAIL": "Terdapat ralat semasa menghantar e-mel ujian.",
                "EVERY_FRIDAY": "Setiap Jumaat",
                "EVERY_MONDAY": "Setiap Isnin",
                "EVERY_MONTH": "Pada setiap bulan",
                "EVERY_SATURDAY": "Setiap Sabtu",
                "EVERY_SUNDAY": "Setiap Ahad",
                "EVERY_THURSDAY": "Setiap Khamis",
                "EVERY_TUESDAY": "Setiap Selasa",
                "EVERY_WEDNESDAY": "Setiap Rabu",
                "EVERY_WEEK": "Setiap minggu",
                "EXAMPLE_GROUP_NUM": "Kumpulan {{num}}",
                "EXAMPLE_SERIES_NUM": "Siri {{num}}",
                "EXPORT": "Eksport",
                "EXPORT_CSV": "CSV (Dipisahkan Koma)",
                "EXPORT_EXCEL_SPREADSHEET": "Hamparan Excel",
                "EXPORT_IMAGE": "Eksport Imej",
                "EXPORT_PAGES": "Eksport Halaman",
                "EXPORT_PDF": "Dokumen PDF",
                "EXPORT_PPT_SLIDES": "Slaid PowerPoint",
                "EXPORT_RAW_DATA": "Eksport Data Mentah",
                "EXPORT_REPORT": "Eksport Laporan",
                "EXPORT_VISUALIZATION": "Eksport Penggambaran",
                "EXPORT_WORD_DOC": "Dokumen Word",
                "FAILED_SAVE_TXT": "Gagal untuk simpan",
                "FILTERED": "Ditapis",
                "FIRST_PAGE": "Halaman Pertama",
                "FIRST_WEEKDAY": "Hari Minggu Pertama dalam Bulan",
                "FROM": "Daripada",
                "FROM_EMAIL": "Daripada E-mel",
                "FROM_NAME": "Daripada Nama",
                "GAUGE_CHART": "Carta Tolok",
                "GAUGE_CHART_DESC": "Carta yang menyerupai alat pengukur tolok untuk membandingkan nilai semasa dengan matlamat atau siri ambang.",
                "GENERATING_FILE": "Menjana fail...",
                "GENERATING_IMAGE": "Menjana Imej...",
                "GENERATING_PDF": "Menjana PDF...",
                "GENERIC_ERROR": "Ralat mencegah kami daripada memuat projek yang diminta.",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "Pilihan Global...",
                "GLOBAL_METRIC": "Metrik Lalai",
                "GLOBAL_MODAL_PAGE_TITLE": "Penggambaran contoh menggunakan pilihan global untuk bahagian Hasil bagi Research Suite Qualtrics",
                "GLOBAL_MODAL_WIDGET_TITLE": "Tajuk Penggambaran",
                "GLOBAL_OPTIONS": "Pilihan Global",
                "GLOBAL_PRECISION": "Tempat Perpuluhan Lalai",
                "GLOBAL_SETTINGS_APPLY": "Gunakan tetapan lalai saya",
                "GLOBAL_SETTINGS_SAVE": "Simpan sebagai tetapan lalai saya",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "Gunakan tetapan lalai Qualtrics",
                "GROUP": "Kumpulan",
                "HEAT_MAP_CHART": "Carta Peta Haba",
                "HEAT_MAP_CHART_DESC": "Penggambaran gaya “haba” kluster digunakan untuk memetakan pengedaran input pengguna (seperti klik) pada imej asal.",
                "HIDDEN": "Tersembunyi",
                "HIDDEN_PAGE": "Halaman ini tidak akan muncul dalam laporan umum dan akan dibatalkan pemilihan secara lalai dalam eksport laporan.",
                "HIDE": "Sembunyikan",
                "HIDE_ALL_PAGES": "Sembunyikan Semua Halaman",
                "HIDE_PAGE": "Sembunyikan Halaman",
                "IMAGE_FILE": "Fail Imej",
                "INVALID_BRAND_DOMAIN": "Domain yang anda masukkan tiada dalam senarai jenama anda daripada domain e-mel yang diluluskan. Sila hubungi pentadbir jenama untuk menetapkannya.",
                "INVALID_SPF_RECORD": "Domain yang anda masukkan mempunyai Qualtrics yang belum diluluskan untuk penghantarannya. Berikut akan menjejaskan kebolehhantaran. Sila gunakan domain lain atau hubungi Qualtrics untuk menyelesaikan isu ini.",
                "ISSUE_SAVING_REPORTS": "Satu atau beberapa laporan menghadapi masalah penyimpanan. Sila cuba lagi.",
                "ISSUE_SENDING_TEST": "Terdapat ralat semasa menghantar e-mel ujian. Sila cuba lagi.",
                "LARGE_SURVEY": "Hasil tidak akan dipaparkan kerana kaji selidik terlalu besar.",
                "LAST_DAY": "Hari Terakhir dalam Bulan",
                "LAST_MODIFIED_COLON_WITH_DATE": "Terakhir Diubah Suai: %1",
                "LAST_PAGE": "Halaman Akhir",
                "LAST_WEEKDAY": "Hari Bekerja Terakhir dalam Bulan",
                "LATER": "Kemudian",
                "LEARN_MORE": "Ketahui Lebih Lanjut",
                "LINE_CHART": "Carta Garis",
                "LINE_CHART_DESC": "Carta garis dua paksi biasanya digunakan semasa membuat graf masa pada paksi x.",
                "LOG_OUT_WARNING": "Klik pada mana-mana bahagian selama {{countdown}} saat untuk kekal log masuk",
                "MESSAGE": "Mesej",
                "MONTHLY": "Bulanan",
                "MOVE_DOWN": "Gerakkan Penggambaran ke Bawah",
                "MOVE_PAGE_TO_BOTTOM": "Gerakkan ke Bawah",
                "MOVE_PAGE_TO_TOP": "Gerakkan ke Atas",
                "MOVE_UP": "Gerakkan Penggambaran ke Atas",
                "MY_SURVEYS": "Projek Saya",
                "NAME": "Nama",
                "NEW_CUSTOM_PAGE_NAME": "Halaman Tersuai Baharu",
                "NEW_REPORT": "Laporan Baharu",
                "NEXT_PAGE": "Halaman Seterusnya",
                "NEXT_RUN": "Jalanan Seterusnya",
                "NO_EXPORTS": "Eksport untuk laporan ini belum diminta lagi.",
                "NO_ITEMS_TO_DISPLAY": "Tiada item untuk dipaparkan",
                "NO_MATCHING_CUSTOM_PAGES": "Tiada halaman tersuai yang sepadan",
                "NO_MATCHING_PAGES": "Tiada halaman carian ditemui",
                "NO_MATCHING_REPORTS": "Tiada laporan yang sepadan.",
                "NO_PROJECT": "Sila tentukan projek untuk meneruskannya.",
                "NO_PROJECTS_TO_MIGRATE": "Tiada projek untuk dikemas kini.",
                "NO_QUESTIONS": "Tiada soalan yang sepadan",
                "NO_RESULTS_YET": "Tiada hasil untuk ditunjukkan lagi. Sila edarkan kaji selidik anda untuk mengumpul maklum balas.",
                "OFF": "Tidak Aktif",
                "ON": "Aktif",
                "PAGES_SELECTED": "Halaman Dipilih",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "Pemilihan akan menghasilkan laporan yang mengandungi {{currentSelectedPageCount}} halaman dengan maksimum {{reportSizeLimit}} ke atas dibenarkan. Sila pilih julat yang lebih kecil.",
                "PAGES_SELECTION_INVALID_RANGE": "Sila pilih julat sah.",
                "PAGE_OPTIONS": "Pilihan Halaman",
                "PDF_ROW_TRUNCATION_MESSAGE": "Terlalu banyak baris untuk eksport PDF, cuba eksport ke Word atau CSV",
                "PERCENTAGE_METRIC": "Peratusan",
                "PIE_CHART": "Carta Pai",
                "PIE_CHART_DESC": "Pecahan membulat nilai untuk titik data yang diberikan. Berguna untuk mengira perkadaran relatif nilai yang dipilih.",
                "PREVIEW": "Pratonton",
                "PREVIOUS_PAGE": "Halaman Sebelumnya",
                "PRINT_PAGE": "Halaman Cetak",
                "PUBLIC_LINK": "Pautan Umum",
                "PUBLIC_REPORT_AVAILABLE": "Laporan Umum Tersedia",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "Kod Capaian",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "Kod Capaian Tidak Betul. Sila cuba lagi.",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "Serahkan",
                "PUBLIC_RESULTS_LOGIN_TITLE": "Log Masuk Laporan Umum | Perisian Kaji Selidik Qualtrics",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "Laporan umum tidak ditemui. Sila hubungi pemilik laporan ini dan minta pautan yang sah daripada mereka.",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "Laporan Umum Tidak Ditemui",
                "PUBLIC_RESULTS_NOT_UPDATED": "Pautan laporan umum dan e-mel laporan berjadual tidak akan menggunakan Platform Qualtrics XM sehingga anda mengemas kininya.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "Sesi Tamat Tempoh. Sila log masuk semula untuk meneruskan pratonton Laporan Hasil Umum.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "Sesi telah Tamat Tempoh",
                "PUBLIC_RESULTS_TITLE": "Laporan Umum",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "Anda tidak dibenarkan untuk memaparkan halaman ini. Sila hubungi pemilik laporan ini dan minta mereka menjadikannya umum.",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "Laporan Umum Tidak Dibenarkan",
                "PUBLISHED_LINK_GENERATING_LINK": "Menjana Pautan...",
                "PUBLISHED_REPORT_FOUND_HERE": "Setiap individu boleh memaparkan laporan ini pada pautan berikut:",
                "PUBLISH_REPORT": "Uruskan Laporan Umum",
                "PUBLISH_REPORT_ELLIPSIS": "Uruskan Laporan Umum...",
                "QUESTION": "Soalan",
                "RANK": "Kedudukan",
                "REMOVE_WIDGET": "Keluarkan Penggambaran",
                "RENAME_PAGE": "Namakan Semula Halaman",
                "RENAME_REPORT": "Namakan Semula Laporan",
                "RENAME_REPORT_ELLIPSIS": "Namakan Semula Laporan...",
                "REPLY_TO_EMAIL": "Balas ke E-mel",
                "REPORT_COLON": "Laporan:",
                "REPORT_SETTINGS": "Tetapan Laporan",
                "REPORT_SETTINGS_ELLIPSIS": "Tetapan Laporan...",
                "RESPONSE_COUNTS": "Kiraan Maklum Balas",
                "RESULTS_DASHBOARDS_BANNER": "dan cuba versi hasil kaji selidik, moden ciri, UI boleh capai dan penggambaran data, analisis baharu dan ciri penerokaan dan lain-lain.",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "Nota Keluaran",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "Paparkan yang terkini",
                "RESULTS_OPTIONS": "Pilihan Laporan",
                "RESULTS_TITLE": "Laporan",
                "RESUME_DISTRIBUTION": "Sambung Semula Pengedaran",
                "REVERT": "Kembalikan",
                "RICH_TEXT_LIMIT_REACHED": "Panjang kandungan telah mencapai had!",
                "SAVE": "Simpan",
                "SAVE_AND_CLOSE": "Simpan dan Tutup",
                "SAVE_AS_CSV": "Simpan Penggambaran sebagai CSV",
                "SAVE_AS_IMAGE": "Simpan Penggambaran sebagai Imej",
                "SAVE_CONFIRMATION": "Simpan Pengesahan",
                "SAVE_PAGE_AS_ELLIPSIS": "Eksport Halaman Sebagai...",
                "SAVE_SETTINGS": "Simpan Tetapan",
                "SCHEDULE_REPORT_EMAIL": "Jadualkan E-mel Laporan",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "Jadualkan E-mel Laporan...",
                "SEARCH_ELLIPSIS": "Cari...",
                "SEARCH_PAGES": "Cari Soalan",
                "SEARCH_PAGES_ELLIPSIS": "Cari Halaman...",
                "SEARCH_REPORTS_ELLIPSIS": "Cari Laporan...",
                "SELECTED": "Dipilih:",
                "SELECT_ALL": "Pilih Semua",
                "SELECT_A_FIELD": "Pilih medan",
                "SELECT_A_WIDGET": "Pilih penggambaran",
                "SELECT_PAGES": "Pilih Halaman",
                "SELECT_PAGES_ELLIPSIS": "Pilih Halaman...",
                "SEND": "Hantar",
                "SEND_TEST_EMAIL": "Hantar E-mel Ujian",
                "SETTING_DEFAULT": "Lalai",
                "SETTING_HIGH": "Tinggi",
                "SETTING_LARGE": "Besar",
                "SETTING_LOW": "Rendah",
                "SETTING_NORMAL": "Normal",
                "SETTING_SMALL": "Kecil",
                "SHARE_REPORT": "Kongsi Laporan",
                "SHOW_ALL_PAGES": "Tunjukkan Semua Halaman",
                "SHOW_FULL_QTEXT": "Tunjukkan teks soalan penuh dalam tajuk halaman",
                "SIMPLE_TABLE": "Jadual Ringkas",
                "SIMPLE_TABLE_DESC": "Jadual fleksibel yang boleh menunjukkan nilai berbilang sebagai baris atau lajur.",
                "SIZE": "Saiz",
                "SPLINE_CHART": "Carta Garis Lengkung",
                "SPLINE_CHART_DESC": "Carta garis bulat dua paksi biasanya digunakan semasa membuat graf masa pada paksi x.",
                "STATISTICS_TABLE": "Jadual Statistik",
                "SUBJECT": "Subjek",
                "SURVEY_ANALYSIS": "Analisis Kaji Selidik",
                "SURVEY_SUMMARY": "Ringkasan Kaji Selidik",
                "TABLE": "PERIHALAN UNTUK JADUAL",
                "TIME": "Masa",
                "TO": "Ke",
                "TOTAL": "Jumlah",
                "TRANSPOSE_STATS_TABLES": "Pindahkan Jadual Stats",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "Pindahkan Pisahan Jadual Stats",
                "TRUNCATE_PAGE_TITLES": "Pangkas teks soalan dalam tajuk halaman",
                "TRY_IT_NOW": "Cubanya sekarang",
                "TYPE": "Jenis",
                "UNABLE_TO_CHECK_SPF": "Tidak boleh menyemak rekod SPF. Sila cuba lagi.",
                "UNAUTHORIZED": "Anda tidak dibenarkan memaparkan laporan ini. Sila hubungi pemilik untuk mendapatkan capaian.",
                "UNHIDE_PAGE": "Jangan Sembunyikan Halaman",
                "UPDATE": "Kemas Kini",
                "UPDATED_SUCCESSFULLY": "Berjaya Dikemas Kini.",
                "UPDATE_ALL_IN_THIS_PROJECT": "Kemas Kini Semua dalam Projek ini",
                "UPDATE_ALL_PROJECTS": "Kemas Kini Semua Projek",
                "UPDATE_NOW": "Kemas Kini Sekarang",
                "UPDATE_REPORTS": "Kemas Kini Laporan...",
                "UPDATE_REPORT_ELEMENTS": "Kemas Kini Pautan Laporan Umum dan E-mel Laporan Berjadual",
                "UPGRADE_MY_ACCOUNT": "Naik Taraf Akaun Saya",
                "USE_EXPORT_TAGS": "Masukkan nombor soalan",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "Gunakan Jumlah Lajur Jadual Ringkas",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "Gunakan Kiraan Responden Jadual Ringkas",
                "USE_WEIGHTED_METRICS": "Gunakan metrik berpemberat",
                "VIEW": "Papar",
                "WEEKLY": "Mingguan",
                "WELCOME_TO_NEW_RESULTS": "Selamat Datang ke Laporan Platform Qualtrics XM!",
                "WHEN": "Masa",
                "WIDGET_LOADING": "Sedang memuat...",
                "WIDGET_OPTIONS_ERR": "Gagal untuk memuat pilihan penggambaran",
                "WIDGET_TYPE": "Penggambaran",
                "WORD_CLOUD": "Cloud Perkataan",
                "WORD_CLOUD_DESC": "Penggambaran berpemberat bagi kekerapan perkataan dalam data teks dengan pilihan pengekodan warna tambahan."
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Ingat, terdapat sumber dalam organisasi anda untuk membantu anda mentafsir maklum balas anda seperti Pekongsi HR, pengurus anda, dan/atau mentor.",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Luangkan masa dan fahami maklum balas anda dengan lebih mendalam.",
                "ABOUT_YOUR_REPORT_HEADER": "Mengenai laporan anda",
                "ABOUT_YOUR_REPORT_LINE1": "Selamat datang ke laporan maklum balas 360 anda. Berikut ialah peluang terbaik untuk meningkatkan dan membangunkan diri anda sebagai profesional. Untuk berjaya memahami hasil laporan, luangkan masa anda dengan meneliti maklum balas berikut. Maklum balas pada awalnya sukar untuk diterima, tetapi perlu diingat bahawa tujuan maklum balas ini adalah untuk mempercepatkan peningkatan dan pembangunan diri anda.",
                "ABOUT_YOUR_REPORT_LINE2": "Semasa meneliti laporan anda, terdapat beberapa perkara perlu diingat.",
                "ADD_CONDITIONAL_TEXT": "Tambah teks bersyarat",
                "ADD_CUSTOM_PALETTE": "Tambah Palet Tersuai",
                "ADD_DATA_SOURCE": "Tambah sumber data",
                "ADD_FOLLOWING": "Tambah penapis berikut",
                "ADD_LABEL": "Tambah label",
                "ADVANCED_FILTER": "Penapis Lanjutan",
                "AGREEMENT_CHART": "Carta perjanjian",
                "AGREEMENT_CHART_FOOTER": "Carta perjanjian menunjukkan persamaan skor. Setiap titik menunjukkan penarafan individu lain terhadap anda untuk setiap item. Saiz titik menunjukkan bilangan penilai yang memberikan anda penarafan tertentu.",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "maklum balas",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "maklum balas",
                "AGREEMENT_CHART_LEGEND_TITLE": "Penarafan individu lain terhadap anda",
                "ALL": "Semua",
                "AND_IF": "Dan jika",
                "ANGLED": "Bersudut",
                "AREA": "Bahagian",
                "AUTO": "Automatik",
                "AVERAGE": "Purata",
                "AXIS_VALUES": "Nilai Paksi",
                "BAR": "Bar",
                "BASE_WORD_COLOR": "Warna Perkataan Dasar",
                "BLUR": "Kabur",
                "BOTTOM_BOX": "Kotak Bawah",
                "BREAKOUT_HEADERS": "Pengepala Pisahan",
                "CANCEL": "Batal",
                "CATEGORICAL": "Kategori",
                "CATEGORY": "Kategori",
                "CATEGORY_NAME": "Nama Kategori",
                "CHANGE_CATEGORIES_ORDER": "Ubah susunan kategori",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "Ubah susunan kategori penskoran",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "Ubah susunan yang muncul dalam penggambaran dengan mengklik bahagian kiri elemen kategori penskoran dan menyeretnya kepada kedudukan yang diingini.",
                "CHANGE_QUESTIONS_ORDER": "Ubah susunan soalan",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "Ubah susunan soalan",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "Ubah susunan yang muncul dalam penggambaran dengan mengklik bahagian kiri elemen soalan dan menyeretnya kepada kedudukan yang diingini.",
                "CHARTS": "Carta",
                "CHART_TYPE": "Jenis Carta",
                "CHOICE_COUNT": "Kiraan Pilihan",
                "CHOICE_TOTALS": "Jumlah Pilihan",
                "CLEAR": "Kosongkan",
                "CLOSE": "Tutup",
                "COLOR_PALETTE": "Palet Warna",
                "COLUMN_NAMES": "Nama Lajur",
                "COLUMN_TOTALS": "Jumlah Lajur",
                "COMPARED_FILTER_GROUP": "Kumpulan Penapis Dibandingkan",
                "COMPARED_FILTER_GROUPS": "Kumpulan Penapis Dibandingkan",
                "COMPARE_WITH": "bandingkan dengan",
                "COMPETITION_RANKING": "Gunakan kedudukan pertandingan",
                "COMPETITION_RANKING_TOOLTIP": "Sekiranya berlaku seri, semua skor yang sama diberikan kedudukan yang sama. Walau bagaimanapun, item susulan seterusnya akan diberi kedudukan sama dengan: jumlah bilangan item diberi kedudukan lebih tinggi dalam jadual, ditambah satu",
                "COMPLETED_RESPONSES": "Maklum balas lengkap",
                "CONDITIONAL_TEXT": "Teks bersyarat",
                "COUNT": "Kiraan",
                "CREATE": "Cipta",
                "CUSTOM_PALETTE": "Palet Tersuai",
                "DATA_SOURCE_TYPE": "Jenis Sumber Data",
                "DATA_SOURCE_TYPE_CATEGORY": "Kategori Penskoran",
                "DATA_SOURCE_TYPE_QUESTION": "Soalan",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "Soalan",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "Item Boleh Kedudukan",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "Kategori Penskoran",
                "DEFAULT": "Lalai",
                "DEFAULT_TEXT": "Teks lalai",
                "DELETE": "Padam",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "Kenali individu yang memberikan maklum balas sama ada daripada rakan setara, laporan langsung, ketua, dan lain-lain.",
                "DIFFERENT_EVALUATORS_HEADER": "Penilai berbeza",
                "DIRECT_REPORTS": "Laporan langsung",
                "DISABLED": "Dinyahdayakan",
                "DISPLAY_OPTIONS": "Paparkan Pilihan",
                "DISPLAY_THRESHOLD_TEXTS": "Paparkan teks berdasarkan jurang kumpulan berikut",
                "DIVERGENT": "Perbezaan",
                "DONE": "Selesai",
                "DONT_HEADER": "Jangan lakukan:",
                "DONT_LINE1": "Cuba mentafsir maklum balas individu",
                "DONT_LINE2": "Fokus pada satu skor/komen yang positif atau negatif",
                "DONT_LINE3": "Cipta rancangan pembangunan untuk setiap item",
                "DONT_LINE4": "Tidak yakin dengan peluang yang anda ada untuk penambahbaikan",
                "DONUT": "Donat",
                "DOWNLOAD_CSV": "Muat Turun CSV Legasi",
                "DOWNLOAD_ZIP": "Muat turun semua fail",
                "DO_HEADER": "Lakukan:",
                "DO_LINE1": "Lihat maklum balas secara holistik",
                "DO_LINE2": "Kenal pasti tema dalam kelebihan dan peluang penambahbaikan",
                "DO_LINE3": "Utamakan bahagian fokus baharu untuk ditambah ke rancangan pembangunan anda",
                "DO_LINE4": "Memahami bahawa setiap individu mempunyai peluang untuk penambahbaikan",
                "DROPOFF": "Pemulangan",
                "DUPLICATE": "Salin",
                "EDIT_CONDITIONAL_TEXT": "Edit teks bersyarat",
                "EDIT_CUSTOM_PALETTE": "Edit Palet Tersuai",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "Tunjukkan lagi teks berikut",
                "ENABLED": "Didayakan",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "Dayakan pesanan mengikut logik paparan kategori penilai",
                "ENABLE_ORDERING_FOR": "Dayakan pesanan untuk",
                "EQUAL_TO": "Sama dengan",
                "FIELD": "Medan",
                "FILTER_NAMES": "Nama Penapis",
                "FOLLOWING_PARENTHESES": "(berikut)",
                "FOOTER": "Pengaki",
                "GAP": "Jurang",
                "GAP_CHART": "Carta jurang",
                "GAP_CHART_DESCRIPTION": "Carta jurang memaparkan perbezaan dalam skor antara dua kumpulan penilai. Contohnya, dalam kes penarafan kendiri berbanding penarafan individu lain terhadap anda, perbezaan positif(+) bermaksud penarafan individu lain terhadap anda adalah lebih tinggi berbanding penarafan kendiri anda. Perbezaan negatif(-) bermaksud penarafan individu lain terhadap anda adalah lebih rendah berbanding penarafan kendiri anda.",
                "GAP_CHART_FOOTER": "Carta jurang menunjukkan perbezaan +/- antara dua kumpulan penilai.",
                "GAP_TABLE_DESCRIPTION": "Kelebihan yang tersembunyi menunjukkan penarafan individu lain terhadap anda adalah lebih tinggi berbanding penarafan kendiri anda. Bahagian penambahbaikan menunjukkan penarafan individu lain lebih rendah berbanding penarafan kendiri anda. Kedudukan kedua-dua bahagian ini ialah daripada jurang yang lebih besar kepada lebih kecil.",
                "GAP_TABLE_FOOTER": "Lajur pertama skor menunjukkan skor anda terhadap diri sendiri. Lajur kedua menunjukkan purata skor individu lain. Lajur ketiga menunjukkan perbezaan antara skor kendiri anda dan skor individu lain terhadap anda.",
                "GAP_TABLE_TITLE": "Kelebihan yang tersembunyi/Bahagian penambahbaikan",
                "GREATER_OR_EQUAL": "Besar daripada atau sama dengan",
                "GREATER_THAN": "Lebih besar daripada",
                "GROUP": "Kumpulan",
                "GROUPED_FOR_ANONYMITY": "Dikumpulkan untuk Ketanpanamaan",
                "HEADER_NAMES": "Nama Pengepala",
                "HIGHEST_SCORES": "Skor tertinggi",
                "HIGHLIGHT_THRESHOLD": "Ambang untuk serlahkan jurang",
                "HIGHLOW_TABLE": "Skor tinggi dan rendah",
                "HIGHLOW_TABLE_FOOTER": "Bahagian ini menunjukkan lima kelakuan penarafan tertinggi dan terendah (keseluruhan kelakuan) daripada purata kategori penilai yang berkenaan. Bagi memanfaatkan halaman ini sepenuhnya, trend yang mungkin muncul sangat berguna untuk dilihat. Contohnya, jika majoriti kelakuan penarafan terendah anda tertumpu pada satu atau dua kategori; maka ia mungkin bahagian yang memerlukan pembangunan. Kelakuan penarafan tertinggi boleh mengenal pasti kelebihan yang dapat menyokong bahagian lain.",
                "HIGH_LOW_TABLE_DESCRIPTION": "Carta tinggi/rendah memaparkan item berdasarkan pada bahagian tertinggi dan terendah anda yang dinilai oleh individu lain.",
                "HORIZONTAL": "Mendatar",
                "HORIZONTAL_AND_VERTICAL": "Mendatar & Menegak",
                "HORIZONTAL_BAR": "Bar Mendatar",
                "HOW_TO_INTERPRET_RESULT_HEADER": "Cara mentafsir hasil dan menentukan tindakan:",
                "IF": "Jika",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "Termasuk label tersembunyi dalam peratus",
                "INNER_RIM": "Rim Dalaman",
                "IS": "Adalah",
                "IS_NOT": "Adalah bukan",
                "IS_SAME_AS_SUBJECT": "Sama seperti subjek",
                "ITEM": "Barang",
                "LABEL": "label",
                "LABELS": "Label",
                "LARGE_LABELS": "Label Besar",
                "LEGEND": "Petunjuk",
                "LEGEND_POSITION": "Kedudukan Petunjuk",
                "LEGEND_VALUES": "Nilai Petunjuk",
                "LESS_OR_EQUAL": "Kurang daripada atau sama dengan",
                "LESS_THAN": "Kurang daripada",
                "LINE": "Garis",
                "LOWEST_SCORES": "Skor terendah",
                "MANAGERS": "Pengurus",
                "MANUAL_FONT_SIZE": "Tetapkan saiz fon secara manual",
                "MAX": "Maksimum",
                "MEAN": "Min",
                "MEDIAN": "Median",
                "METRIC_TYPE": "Jenis metrik",
                "MIN": "Minimum",
                "MODIFY_CUSTOM_PALETTES": "Ubah Suai Palet Tersuai",
                "MOVE_DOWN": "Gerak ke bawah",
                "MOVE_UP": "Gerak ke atas",
                "MULTI_SELECT_ITEMS_SELECTED": "dipilih",
                "NEGATIVE_GAPS": "Bahagian penambahbaikan",
                "NO": "Tidak",
                "NONE": "Tiada",
                "NOT_APPLICABLE": "Tidak Tersedia",
                "NOT_EQUAL_TO": "Tidak sama dengan",
                "NO_DATA_AVAILABLE_WARNING": "Tiada data tersedia",
                "NO_FILTER": "Tiada penapis",
                "NO_FILTER_IS_APPLIED": "Tiada penapis digunakan.",
                "NO_VALUE": "Tiada nilai",
                "NPS": "Skor Penggalak Bersih",
                "NUMBER": "nombor",
                "NUMBERS": "Nombor",
                "NUMBER_OF_GAPS_NEGATIVE": "Bilangan Jurang Negatif",
                "NUMBER_OF_GAPS_POSITIVE": "Bilangan Jurang Positif",
                "NUMBER_OF_ROWS_HIGH": "Bilangan Baris Tinggi",
                "NUMBER_OF_ROWS_LOW": "Bilangan Baris Rendah",
                "OPTIONS": {
                    "HEADER_NAME": "Nama pengepala",
                    "LEGEND": "Petunjuk",
                    "SCALE_AXIS_CHANGER_TITLE": "Julat"
                },
                "ORIENTATION": "Orientasi",
                "OR_IF": "Atau jika",
                "OTHER": "Lain-lain",
                "OTHERS": "Lain-lain",
                "PAGE_OF": "Halaman %1 daripada %2",
                "PALETTE_REMOVED": "Palet Dikeluarkan",
                "PEERS": "Rakan Setara",
                "PERCENT": "Peratus",
                "PERCENTAGE": "Peratusan",
                "PERCENTAGE_OF_CHOICES": "Peratusan Pilihan",
                "PERCENTAGE_OF_RESPONSES": "Peratusan Maklum Balas",
                "PERCENT_COMPLETE": "% selesai",
                "PERSON_METADATA": "Metadata individu",
                "PERSON_METADATA_EVALUATOR": "Penilai",
                "PERSON_METADATA_SUBJECT": "Subjek",
                "PERSON_METADATA_VIEWER": "Pemapar",
                "POSITIVE_GAPS": "Kelebihan yang tersembunyi",
                "PRIMARY_PARENTHESES": "(utama)",
                "QUESTIONS": "Soalan",
                "RADIUS": "Jejari",
                "RANK": "Kedudukan",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "Skor tertinggi",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "Skor tertinggi",
                "RANKABLE_ITEMS_ITEM_HAS": "Item mempunyai",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "Item berada di atas",
                "RANKABLE_ITEMS_LOWEST_SCORE": "Skor terendah",
                "RANKABLE_ITEMS_LOWEST_SCORES": "Skor terendah",
                "RATER_CATEGORY_DISPLAY_LOGIC": "logik paparan kategori penilai",
                "RATIO": "Nisbah",
                "RECORD": "Rekod",
                "REFERENCE_GROUP": "Kumpulan rujukan",
                "RELATIONSHIP": "Hubungan",
                "RELATIONSHIP_FILTERS": "Penapis hubungan",
                "RELATIONSHIP_FILTERS_INFO": "Untuk menambah penapis hubungan (seperti orang bawahan, rakan setara atau pengurus), pilih Uruskan penapis anda, dan gunakan Syarat hubungan sahaja daripada menu juntai bawah.",
                "REMOVE": "Keluarkan",
                "REMOVE_DATA_SOURCE": "Keluarkan sumber data",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Ingat, terdapat sumber dalam organisasi anda untuk membantu anda mentafsir maklum balas anda seperti Pekongsi HR, pengurus anda, dan/atau mentor.",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Luangkan masa dan fahami maklum balas anda dengan lebih mendalam.",
                    "ABOUT_YOUR_REPORT_HEADER": "Mengenai laporan anda",
                    "ABOUT_YOUR_REPORT_LINE1": "Selamat datang ke laporan maklum balas 360 anda. Berikut ialah peluang terbaik untuk meningkatkan dan membangunkan diri anda sebagai profesional. Untuk berjaya memahami hasil laporan, luangkan masa anda dengan meneliti maklum balas berikut. Maklum balas pada awalnya sukar untuk diterima, tetapi perlu diingat bahawa tujuan maklum balas ini adalah untuk mempercepatkan peningkatan dan pembangunan diri anda.",
                    "ABOUT_YOUR_REPORT_LINE2": "Semasa meneliti laporan anda, terdapat beberapa perkara perlu diingat.",
                    "ADVANCED_FILTER": "Penapis Lanjutan",
                    "AGREEMENT_CHART": "Carta perjanjian",
                    "AGREEMENT_CHART_FOOTER": "Carta perjanjian menunjukkan persamaan skor. Setiap titik menunjukkan penarafan individu lain terhadap anda untuk setiap item. Saiz titik menunjukkan bilangan penilai yang memberikan anda penarafan tertentu.",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "maklum balas",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "maklum balas",
                    "AGREEMENT_CHART_LEGEND_TITLE": "Penarafan individu lain terhadap anda",
                    "ALL": "Semua",
                    "AVERAGE": "Purata",
                    "BOTTOM_BOX": "Kotak Bawah",
                    "CHOICE_COUNT": "Kiraan Pilihan",
                    "CHOICE_TOTALS": "Jumlah Pilihan",
                    "COMPARISON": "Perbandingan",
                    "COMPARISON_GAP_COLUMN_HEADER": "Jurang perbandingan",
                    "COMPLETED_RESPONSES": "Maklum balas lengkap",
                    "COUNT": "Kiraan",
                    "DEFAULT": "Lalai",
                    "DEFAULT_TEXT": "Teks lalai",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "Kenali individu yang memberikan maklum balas sama ada daripada rakan setara, laporan langsung, ketua, dan lain-lain.",
                    "DIFFERENT_EVALUATORS_HEADER": "Penilai berbeza",
                    "DONE": "Selesai",
                    "DONT_HEADER": "Jangan lakukan:",
                    "DONT_LINE1": "Cuba mentafsir maklum balas individu",
                    "DONT_LINE2": "Fokus pada satu skor/komen yang positif atau negatif",
                    "DONT_LINE3": "Cipta rancangan pembangunan untuk setiap item",
                    "DONT_LINE4": "Tidak yakin dengan peluang yang anda ada untuk penambahbaikan",
                    "DO_HEADER": "Lakukan:",
                    "DO_LINE1": "Lihat maklum balas secara holistik",
                    "DO_LINE2": "Kenal pasti tema dalam kelebihan dan peluang penambahbaikan",
                    "DO_LINE3": "Utamakan bahagian fokus baharu untuk ditambah ke rancangan pembangunan anda",
                    "DO_LINE4": "Memahami bahawa setiap individu mempunyai peluang untuk penambahbaikan",
                    "FIELD": "Medan",
                    "GAP": "Jurang",
                    "GAP_CHART": "Carta jurang",
                    "GAP_CHART_DESCRIPTION": "Carta jurang memaparkan perbezaan dalam skor antara dua kumpulan penilai. Contohnya, dalam kes penarafan kendiri berbanding penarafan individu lain terhadap anda, perbezaan positif(+) bermaksud penarafan individu lain terhadap anda adalah lebih tinggi berbanding penarafan kendiri anda. Perbezaan negatif(-) bermaksud penarafan individu lain terhadap anda adalah lebih rendah berbanding penarafan kendiri anda.",
                    "GAP_CHART_FOOTER": "Carta jurang menunjukkan perbezaan +/- antara dua kumpulan penilai.",
                    "GAP_TABLE_DESCRIPTION": "Kelebihan yang tersembunyi menunjukkan penarafan individu lain terhadap anda adalah lebih tinggi berbanding penarafan kendiri anda. Bahagian penambahbaikan menunjukkan penarafan individu lain lebih rendah berbanding penarafan kendiri anda. Kedudukan kedua-dua bahagian ini ialah daripada jurang yang lebih besar kepada lebih kecil.",
                    "GAP_TABLE_FOOTER": "Lajur pertama skor menunjukkan skor anda terhadap diri sendiri. Lajur kedua menunjukkan purata skor individu lain. Lajur ketiga menunjukkan perbezaan antara skor kendiri anda dan skor individu lain terhadap anda.",
                    "GAP_TABLE_TITLE": "Kelebihan yang tersembunyi/Bahagian penambahbaikan",
                    "GROUP": "Kumpulan",
                    "HIDE_REPORT_ALERT": "Anda tidak memenuhi keperluan untuk memaparkan laporan anda. Hubungi pentadbir organisasi anda.",
                    "HIGHEST_SCORES": "Skor tertinggi",
                    "HIGHLOW_TABLE": "Skor tinggi dan rendah",
                    "HIGHLOW_TABLE_FOOTER": "Bahagian ini menunjukkan lima kelakuan penarafan tertinggi dan terendah (keseluruhan kelakuan) daripada purata kategori penilai yang berkenaan. Bagi memanfaatkan halaman ini sepenuhnya, trend yang mungkin muncul sangat berguna untuk dilihat. Contohnya, jika majoriti kelakuan penarafan terendah anda tertumpu pada satu atau dua kategori; maka ia mungkin bahagian yang memerlukan pembangunan. Kelakuan penarafan tertinggi boleh mengenal pasti kelebihan yang dapat menyokong bahagian lain.",
                    "HIGH_LOW_TABLE_DESCRIPTION": "Carta tinggi/rendah memaparkan item berdasarkan pada bahagian tertinggi dan terendah anda yang dinilai oleh individu lain.",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "Cara mentafsir hasil dan menentukan tindakan:",
                    "ITEM": "Barang",
                    "LOWEST_SCORES": "Skor terendah",
                    "MAX": "Maksimum",
                    "MEAN": "Min",
                    "MEDIAN": "Median",
                    "MIN": "Minimum",
                    "NEGATIVE_GAPS": "Bahagian penambahbaikan",
                    "NO_COMPARISON_SET": "Tiada set perbandingan",
                    "NO_DATA_AVAILABLE_WARNING": "Tiada data tersedia",
                    "NO_FILTER_IS_APPLIED": "Tiada penapis digunakan.",
                    "NO_VALUE": "Tiada nilai",
                    "NPS": "Skor Penggalak Bersih",
                    "OTHERS": "Lain-lain",
                    "PERCENTAGE": "Peratusan",
                    "PERCENTAGE_OF_CHOICES": "Peratusan Pilihan",
                    "PERCENTAGE_OF_RESPONSES": "Peratusan Maklum Balas",
                    "PERCENT_COMPLETE": "% selesai",
                    "POSITIVE_GAPS": "Kelebihan yang tersembunyi",
                    "QUESTIONS": "Soalan",
                    "RANK": "Kedudukan",
                    "RELATIONSHIPS": {
                        "ANYONE": "Sesiapa Sahaja",
                        "DIRECT_REPORT": "Orang Bawahan",
                        "MANAGER": "Pengurus",
                        "PEER": "Rakan Setara",
                        "SELF": "Diri Sendiri"
                    },
                    "REPORT_SUMMARY": "Rumusan laporan",
                    "REPORT_SUMMARY_TABLE_FOOTER": "Bandingkan bilangan individu yang telah menyelesaikan penaksiran anda dengan bilangan individu yang dijemput untuk turut serta.",
                    "REPORT_SUMMARY_TABLE_HEADER": "Statistik responden",
                    "RESPONSES": "Maklum Balas",
                    "RESPONSE_COUNT": "{{responseCount}} Maklum balas",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Maklum balas",
                    "SCORING_CATEGORY": "Kategori penskoran",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Tiada maklum balas untuk kategori ini",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Tiada maklum balas untuk soalan ini",
                    "SCORING_OVERVIEW": "Paparan keseluruhan penskoran",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "Anda dan penilai lain beranggapan bahagian ini ialah kelebihan yang teratas.",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Kelebihan yang diperakui",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Bahagian penambahbaikan yang diperakui bermaksud penarafan kendiri dan penarafan daripada individu lain adalah di bawah purata untuk kecekapan ini.",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Bahagian penambahbaikan yang diperakui",
                    "SCORING_OVERVIEW_DESCRIPTION": "Di atas ialah kecekapan atau kelakuan anda yang dinilai sebagai sebahagian daripada proses maklum balas penilai berbilang. Penarafan perbandingan disediakan mengikut kumpulan.",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "Jurang minimum",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Perbezaan minimum antara kumpulan rujukan untuk teks yang akan ditunjukkan.",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "Julat skor dipaparkan untuk setiap kecekapan/kelakuan. Bar mewakili purata berangka.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Kelebihan yang tidak diperakui wujud daripada percanggahan antara penarafan kendiri dan penarafan daripada individu lain.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Kelebihan yang tidak diperakui",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Bahagian penambahbaikan yang tidak diperakui wujud daripada percanggahan antara penarafan kendiri dan penarafan daripada individu lain.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Bahagian penambahbaikan yang tidak diperakui",
                    "SELF": "Diri Sendiri",
                    "SELF_ASSESSMENT": "Penaksiran kendiri",
                    "STANDARD_DEVIATION": "Sisihan Piawai",
                    "SUM": "Jumlah",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Biasakan diri anda dengan skala penarafan untuk memastikan pentafsiran yang tepat",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "Ambil perhatian terhadap skala",
                    "THINGS_YOU_WILL_SEE_HEADER": "Perkara yang anda akan lihat:",
                    "THREE_SIXTY_PERCENTILE": "Persentil",
                    "TOP_BOTTOM_BOX": "Kotak Atas / Kotak Bawah",
                    "TOP_BOX": "Kotak Teratas",
                    "TOTAL": "Jumlah",
                    "TO_DO": "Untuk dilakukan",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Kualitatif: Maklum balas ini akan berbentuk komen teks terbuka",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Kuantitatif: Maklum balas ini akan menjadi berangka dan akan dikemukakan dalam bentuk graf, carta bar, jadual, dan sebagainya.",
                    "TYPES_OF_FEEDBACK_HEADER": "Pelbagai jenis maklum balas",
                    "VALUE": "Nilai",
                    "VARIANCE": "Varians",
                    "YOUR_RATINGS": "Penarafan anda"
                },
                "REPORT_SUMMARY": "Rumusan laporan",
                "REPORT_SUMMARY_TABLE_FOOTER": "Bandingkan bilangan individu yang telah menyelesaikan penaksiran anda dengan bilangan individu yang dijemput untuk turut serta.",
                "REPORT_SUMMARY_TABLE_HEADER": "Statistik responden",
                "RESET": "Tetapan Semula",
                "RESPONDENT_TOTALS": "Jumlah Responden",
                "RESPONSES": "Maklum Balas",
                "RESPONSE_COUNT": "{{responseCount}} Maklum balas",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Maklum balas",
                "RESULT": "Hasil",
                "REVERSE_COLORS": "Balikkan Warna",
                "ROW_TOTALS": "Jumlah Baris",
                "SAVE": "Simpan",
                "SAVE_AND_APPLY": "Simpan dan gunakan",
                "SCORING_CATEGORY": "Kategori penskoran",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Tiada maklum balas untuk kategori ini",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Tiada maklum balas untuk soalan ini",
                "SCORING_OVERVIEW": "Paparan keseluruhan penskoran",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "Anda dan penilai lain beranggapan bahagian ini ialah kelebihan yang teratas.",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Kelebihan yang diperakui",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Bahagian penambahbaikan yang diperakui bermaksud penarafan kendiri dan penarafan daripada individu lain adalah di bawah purata untuk kecekapan ini.",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Bahagian penambahbaikan yang diperakui",
                "SCORING_OVERVIEW_DESCRIPTION": "Di atas ialah kecekapan atau kelakuan anda yang dinilai sebagai sebahagian daripada proses maklum balas penilai berbilang. Penarafan perbandingan disediakan mengikut kumpulan.",
                "SCORING_OVERVIEW_MINIMUM_GAP": "Jurang minimum",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Perbezaan minimum antara kumpulan rujukan untuk teks yang akan ditunjukkan.",
                "SCORING_OVERVIEW_TABLE_FOOTER": "Julat skor dipaparkan untuk setiap kecekapan/kelakuan. Bar mewakili purata berangka.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Kelebihan yang tidak diperakui wujud daripada percanggahan antara penarafan kendiri dan penarafan daripada individu lain.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Kelebihan yang tidak diperakui",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Bahagian penambahbaikan yang tidak diperakui wujud daripada percanggahan antara penarafan kendiri dan penarafan daripada individu lain.",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Bahagian penambahbaikan yang tidak diperakui",
                "SELECT_CATEGORIES": "Sila pilih Kategori Penskoran...",
                "SELECT_CATEGORY": "Sila pilih Kategori Penskoran...",
                "SELECT_CONDITION_TYPE": "Pilih jenis syarat",
                "SELECT_DATA_SOURCE": "Pilih sumber data",
                "SELECT_DATA_SOURCE_TYPE": "Pilih jenis sumber data",
                "SELECT_FILTER": "Pilih penapis",
                "SELECT_FILTERS": "Pilih penapis",
                "SELECT_OPERATOR_TYPE": "Pilih jenis pengendali",
                "SELECT_PERSON": "Pilih individu",
                "SELECT_PERSON_METADATA": "Pilih metadata individu",
                "SELECT_QUESTION": "Pilih soalan",
                "SELECT_QUESTIONS": "Sila pilih Soalan...",
                "SELECT_RATIO_OR_DROPOFF": "Pilih nisbah atau pemulangan",
                "SELECT_RELATIONSHIP": "Pilih hubungan",
                "SELECT_SCORING_CATEGORY": "Pilih kategori penskoran",
                "SELF": "Diri Sendiri",
                "SELF_ASSESSMENT": "Penaksiran kendiri",
                "SEQUENTIAL": "Berjujukan",
                "SETUP_COMPARISON": "Sediakan perbandingan",
                "SETUP_COMPARISONS": "Sediakan perbandingan",
                "SET_START_COLOR": "Tetapkan Warna Permulaan",
                "SHOULD_SHOW_FOOTER": "Tunjukkan Pengaki",
                "SHOULD_SHOW_SCORING_CATEGORY": "Tunjukkan Kategori Penskoran",
                "SHOWING_RECORDS_OF": "Menunjukkan %1 - %2 daripada %3",
                "SHOW_COMPARISON_GAP": "Tunjukkan lajur jurang perbandingan",
                "SHOW_DATA_LABEL": "Tunjukkan nilai data",
                "SHOW_PERCENTAGES": "Tunjukkan Peratusan",
                "SHOW_THE_FOLLOWING_TEXT": "Kemudian tunjukkan teks berikut",
                "SHOW_TIES": "Tunjukkan Tingkat",
                "SHOW_X_AXIS": "Tunjukkan Paksi X",
                "SHOW_Y_AXIS": "Tunjukkan Paksi Y",
                "SMALL_LABELS": "Label Kecil",
                "SORT": "Isih",
                "SPLINE": "Garis Lengkung",
                "STACK_CHART": "Carta Tindanan",
                "STANDARD_DEVIATION": "Sisihan Piawai",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "Kelemahan kurang daripada",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "Edit teks ambang",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "Teks ambang",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "Dayakan teks ambang",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "Kelebihan lebih daripada",
                "SUM": "Jumlah",
                "SUMMARY": "Rumusan",
                "TABLES": "Jadual",
                "TABLE_TOTALS": "Jumlah Jadual",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Biasakan diri anda dengan skala penarafan untuk memastikan pentafsiran yang tepat",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "Ambil perhatian terhadap skala",
                "TEXT": "Teks",
                "THINGS_YOU_WILL_SEE_HEADER": "Perkara yang anda akan lihat:",
                "TOP_BOTTOM_BOX": "Kotak Atas / Kotak Bawah",
                "TOP_BOX": "Kotak Teratas",
                "TOTAL": "Jumlah",
                "TOTAL_COUNTS": "Jumlah Kiraan",
                "TO_DO": "Untuk dilakukan",
                "TRANSPOSE": "Silang Ganti",
                "TRANSPOSE_TABLE": "Pindahkan jadual",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Kualitatif: Maklum balas ini akan berbentuk komen teks terbuka",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Kuantitatif: Maklum balas ini akan menjadi berangka dan akan dikemukakan dalam bentuk graf, carta bar, jadual, dan sebagainya.",
                "TYPES_OF_FEEDBACK_HEADER": "Pelbagai jenis maklum balas",
                "UNDO": "Buat Asal",
                "USE_COMPARISON": "Guna perbandingan",
                "USE_LABELS_FOR_SCALES": "Gunakan label untuk skala",
                "VALUES": "Nilai",
                "VALUE_RANGES": "Julat Nilai",
                "VARIANCE": "Varians",
                "VERTICAL": "Menegak",
                "VERTICAL_RANGE": "Julat Menegak",
                "WARNING_DATA_OUT_OF_RANGE": "Amaran: nilai data melebihi konfigurasi julat",
                "WIDGET_ERROR": {
                    "ERROR": "Terdapat ralat yang tidak dijangka berlaku",
                    "MISCONFIGURED": "Widget ini tidak dikonfigurasikan dengan betul. Sila semak konfigurasi widget anda.",
                    "NEW": "Sila konfigurasikan widget",
                    "NO_DATA": "Tiada data ditemui - penapis anda mungkin terlalu eksklusif!"
                },
                "WIDGET_NAME": {
                    "BAR": "Carta Bar",
                    "BREAKDOWNBAR": "Bar Pecahan",
                    "DATA_TABLE": "Jadual Data",
                    "FUNNEL_CHART": "Carta Corong",
                    "GAUGE": "Carta Tolok",
                    "GRID": "Jadual Hasil",
                    "HEATMAP": "Peta Haba",
                    "LINE": "Carta Garis",
                    "NEEDS_BASED": "Berdasarkan Keperluan",
                    "PIE": "Carta Pai",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "Penganggar Harga (Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "Pemaksimum Hasil (Gabor Granger)",
                    "SCORING_OVERVIEW_CHART": "Carta",
                    "SCORING_OVERVIEW_TABLE": "Jadual",
                    "STATS_TABLE": "Jadual Statistik",
                    "WORDCLOUD": "Cloud Perkataan"
                },
                "WORD_ROTATION": "Putaran perkataan",
                "WORD_SPACING": "Ruang perkataan",
                "YES": "Ya",
                "YOUR_RATINGS": "Penarafan anda"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "Tambah",
                "ADD_A_WORD": "Tambah perkataan",
                "COLOR": "Warna",
                "DELETE_ALL": "Padam semua",
                "EDIT_STOP_WORDS": "Edit Kata Sandang",
                "MAX_WORDS": "Maksimum Perkataan",
                "ROTATION_ANGLED": "Bersudut",
                "ROTATION_HORIZONTAL": "Mendatar",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "Mendatar dan Menegak",
                "WORD_ORIENTATION": "Orientasi Perkataan"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "Warna Latar Belakang",
                "DISPLAY_OPTIONS": "Papar Pilihan",
                "INVERT_FONT_COLORS": "Balikkan Warna Fon Kontras Rendah",
                "PAGE": "Halaman",
                "PAGINATE": "Menomborkan Halaman"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "Min",
                "BOTTOM_BOX_METRIC": "Kotak Bawah",
                "COLUMNS": "Lajur",
                "COUNT_METRIC": "Jumlah Maklum Balas",
                "FIELD_NAME": "Medan",
                "MAX_METRIC": "Maksimum",
                "MIN_METRIC": "Minimum",
                "SHOW_RECODES": "Tunjukkan Nilai pengekodan Semula",
                "SHOW_ROW_NUMBERS": "Tunjukkan Nombor Baris",
                "STD_DEV_METRIC": "Sisihan Piawai",
                "TOP_BOX_METRIC": "Kotak Teratas",
                "TRANSPOSE_BREAKOUTS": "Transposisi Pisahan",
                "TRANSPOSE_TABLE": "Transposisi Jadual",
                "VAR_METRIC": "Varians"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "Lajur Tambahan",
                "ADD_COLUMNS": "Tambah Lajur Tambahan",
                "ADD_CUSTOM_PALETTE": "Tambah Palet Tersuai",
                "ALL_CHOICES": "Semua Pilihan",
                "ALL_GROUPS": "Semua Kumpulan",
                "ALL_RECODES": "Semua Pengekodan Semula",
                "AUTOMATIC": "Lalai",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "Lalai - Klik untuk edit",
                "AXIS_VALUES": "Nilai Paksi",
                "BREAKOUT_BY": "Pisahan mengikut",
                "CANCEL": "Batal",
                "CATEGORICAL": "Kategori",
                "CHOICES": "Pilihan",
                "CHOICE_COUNT": "Kiraan Pilihan",
                "COLOR_PALETTE": "Palet Warna",
                "COLUMN_VALUES": "Nilai Lajur",
                "CONTACT_FIELDS": "Medan Kenalan",
                "COUNT": "Kiraan",
                "CREATE": "Cipta",
                "CUSTOM": "Tersuai",
                "CUSTOM_PALETTE": "Palet Tersuai",
                "DATA_SOURCE": "Sumber Data",
                "DAY": "Hari",
                "DAY_OF_WEEK": "Hari dalam Minggu",
                "DECIMAL_PRECISION": "Tempat Perpuluhan",
                "DEFAULT": "Lalai",
                "DISABLED": "Dinyahdayakan",
                "DIVERGENT": "Perbezaan",
                "EDIT_CUSTOM_PALETTE": "Edit Palet Tersuai",
                "ENABLED": "Didayakan",
                "ERROR_LOADING_DATA": "Ralat memuat data",
                "FILE_SIZE": "Saiz",
                "FILE_TYPE": "Jenis",
                "FRI": "Jum",
                "FRIDAY": "Jumaat",
                "GROUP_DATE_BY": "Kumpul Tarikh mengikut",
                "HOUR_OF_DAY": "Jam dalam Hari",
                "LENGEND_VALUES": "Nilai Petunjuk",
                "MAX": "Maksimum",
                "MEAN": "Min",
                "MIN": "Minimum",
                "MISCONFIGURED_DATA": "Sumber data tidak dikonfigurasikan dengan betul untuk penggambaran ini.",
                "MISCONFIGURED_FILTERS": "Penapis Tidak Sah",
                "MODIFY_CUSTOM_PALETTES": "Ubah Suai Palet Tersuai",
                "MON": "Isn",
                "MONDAY": "Isnin",
                "MONTH": "Bulan",
                "NONE": "Tiada",
                "NO_FILE_ID_ERROR": "Penggambaran ini memerlukan imej untuk ditetapkan dalam kaji selidik",
                "NO_RESULTS_TO_SHOW": "Tiada hasil untuk ditunjukkan",
                "NPS": "Skor Penggalak Bersih®",
                "NPS_GROUP": "Kumpulan NPS®",
                "NUMERIC_VALUE": "Nilai Berangka",
                "PALETTE_REMOVED": "Palet Dikeluarkan",
                "PERCENTAGE": "Peratusan",
                "PERCENTAGE_OF_CHOICES": "Peratusan Pilihan",
                "PERCENTAGE_OF_RESPONSES": "Peratusan Maklum Balas",
                "QUARTER": "Suku",
                "REMOVE": "Keluarkan",
                "RESPONSE_COUNT": "Kiraan Maklum Balas",
                "RESULTS_PER_PAGE": "Hasil setiap halaman",
                "RETRIEVING_DATA_ELLIPSIS": "Mendapatkan semula data...",
                "REVERSE_COLORS": "Balikkan Warna",
                "ROW_VALUES": "Nilai Baris",
                "SAT": "Sab",
                "SATURDAY": "Sabtu",
                "SAVE": "Simpan",
                "SELECTED_CHOICE": "Pilihan Dipilih",
                "SELECT_FIELD": "Pilih Medan",
                "SELECT_METRIC": "Metrik",
                "SEQUENTIAL": "Berjujukan",
                "SET_START_COLOR": "Tetapkan Warna Permulaan",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "Menunjukkan data sampel...",
                "SUM": "Jumlah",
                "SUN": "Aha",
                "SUNDAY": "Ahad",
                "SURVEY_EMBEDDEDDATA": "Data Terbenam",
                "SURVEY_METADATA": "Metadata Kaji Selidik",
                "TEXT_ENTRY": "Entri teks",
                "THURS": "Khamis",
                "THURSDAY": "Khamis",
                "TITLE": "Tajuk",
                "TUES": "Selasa",
                "TUESDAY": "Selasa",
                "UNBOUNDED_DOMAIN": "Terlalu banyak nilai untuk dipaparkan.",
                "UNBOUNDED_DOMAIN_HELP": "Untuk menambah medan ini ke Laporan Hasil, anda boleh menambah penapis bagi memaparkan lebih sedikit nilai untuk \"{{ed_field_name}}\" atau mengemas kini jenis pemboleh ubah terbenam \"{{ed_field_name}}\" dalam aliran kaji selidik untuk menjadikan medan ini jenis rentetan atau berangka.",
                "UNDO": "Buat Asal",
                "USE_CHOICE_TOTALS": "Gunakan Jumlah Pilihan",
                "USE_RESPONDENT_TOTALS": "Gunakan Jumlah Responden",
                "VISUALIZATION": "Penggambaran",
                "VISUALIZATION_BARCHART": "Carta Bar",
                "VISUALIZATION_BREAKDOWNBAR": "Bar Pecahan",
                "VISUALIZATION_GAUGE": "Carta Tolok",
                "VISUALIZATION_HEATMAP": "Peta Haba",
                "VISUALIZATION_LINECHART": "Carta Garis",
                "VISUALIZATION_PAGINATEDTABLE": "Jadual Penghalamanan",
                "VISUALIZATION_PIE": "Carta Pai",
                "VISUALIZATION_SIMPLETABLE": "Jadual Ringkas",
                "VISUALIZATION_STATSTABLE": "Jadual Statistik",
                "VISUALIZATION_TEXTHIGHLIGHTS": "Serlahan Teks",
                "VISUALIZATION_WORDCLOUD": "Cloud Perkataan",
                "WED": "Rab",
                "WEDNESDAY": "Rabu",
                "WEEK": "Minggu",
                "WEIGHTING": "Pemberatan",
                "WRONG_QUESTION_TYPE_ERROR": "Jenis penggambaran ini tidak boleh digunakan untuk soalan ini",
                "YEAR": "Tahun"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "Sederhana",
                "CHOICE_COUNT": "Kiraan Pilihan",
                "COUNT": "Kiraan",
                "DISPLAY_OPTIONS": "Papar Pilihan",
                "MAX": "Maksimum",
                "MIN": "Minimum",
                "NPS": "NPS®",
                "PAGE_OF": "Halaman: %1 daripada %2",
                "PERCENT": "Peratusan",
                "RESPONSE_COUNT": "Kiraan Maklum Balas",
                "ROWS_PER_TABLE": "Baris Setiap Jadual",
                "SHOWING_ROWS_OF": "Menunjukkan baris %1 - %2 daripada %3",
                "SHOW_PERCENTAGES": "Tunjukkan Peratusan",
                "SHOW_RECODES": "Tunjukkan Nilai pengekodan Semula",
                "SHOW_ROW_NUMBERS": "Tunjukkan Nombor Baris",
                "SUM": "Jumlah",
                "TOTAL": "Jumlah",
                "TRANSPOSE": "Transposisi",
                "USE_COLUMN_TOTALS": "Gunakan Jumlah Lajur",
                "USE_ROW_TOTALS": "Gunakan Jumlah Baris",
                "VALUE": "Nilai"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "Menaik",
                "COUNT": "Kiraan",
                "DESCENDING": "Menurun",
                "DIAGONAL": "Pepenjuru",
                "DISPLAY_OPTIONS": "Papar Pilihan",
                "ERROR_COLON": "Ralat:",
                "ERROR_GENERIC": "Ralat berlaku semasa memuat penggambaran.",
                "HORIZONTAL": "Mendatar",
                "HORIZONTAL_BARS": "Bar Mendatar",
                "INCORRECTLY_CONFIGURED": "Pilih nilai untuk memaparkan carta",
                "LEGEND_AUTO": "Automatik",
                "LEGEND_BOTTOM": "Bawah",
                "LEGEND_INSET": "Sisipan",
                "LEGEND_RIGHT": "Kanan",
                "NORMALIZE_TO_PERCENTAGES": "Menormalkan Peratusan",
                "SHOW_BAR_LABELS": "Tunjukkan Label Bar",
                "SHOW_LEGEND": "Tunjukkan Petunjuk",
                "SHOW_X_AXIS": "Tunjukkan Paksi X",
                "SHOW_Y_AXIS": "Tunjukkan Paksi Y",
                "SORT_BAR_VALUES": "Isih Nilai Bar",
                "STACKED_BARS": "Bar Bertindan",
                "TRANSPOSE": "Transposisi",
                "TRUNCATE_LABELS": "Potong Label",
                "VERTICAL": "Menegak"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "Semua yang Lain",
                "COULD_NOT_LOAD_DATA": "Tidak dapat memuat data dengan konfigurasi yang ditentukan - cuba medan sumber yang berbeza atau julat tarikh yang lebih besar.",
                "GROUPING_PERCENTAGE_THRESHOLD": "Ambang Peratusan Kumpulan",
                "NO_DATA": "Tiada Data",
                "RADIUS": "Jejari Dalaman",
                "SHOW_AS_PERCENTAGES": "Tunjukkan Sebagai Peratusan"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "Tutup",
                "DOWNLOAD_CSV": "Muat turun CSV",
                "DOWNLOAD_ZIP": "Muat turun semua fail",
                "NO_DATA": "Tiada Data",
                "PAGE_OF": "Halaman: %1 daripada %2",
                "RESULTS_PER_PAGE": "Hasil setiap halaman",
                "SHOWING_RECORDS_OF": "Menunjukkan rekod %1 - %2 daripada %3",
                "SINGLE_RESPONSE": "Maklum Balas Tunggal",
                "VIEW_RESPONSE": "Paparkan Maklum Balas"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "Papar Pilihan",
                "ERROR_COLON": "Ralat:",
                "ERROR_GENERIC": "Ralat berlaku semasa memuat penggambaran.",
                "HORIZONTAL_BARS": "Bar Mendatar",
                "INCORRECTLY_CONFIGURED": "Pilih nilai untuk memaparkan carta",
                "LEGEND_AUTO": "Automatik",
                "LEGEND_BOTTOM": "Bawah",
                "LEGEND_INSET": "Sisipan",
                "LEGEND_RIGHT": "Kanan",
                "NORMALIZE_TO_PERCENTAGES": "Menormalkan Peratusan",
                "SHOW_AREA": "Tunjukkan Bahagian",
                "SHOW_LEGEND": "Tunjukkan Petunjuk",
                "SHOW_X_AXIS": "Tunjukkan Paksi X",
                "SHOW_Y_AXIS": "Tunjukkan Paksi Y",
                "SMOOTH_LINES": "Garis Licin",
                "SORT_X_AXIS_LABELS": "Isih Label Paksi X",
                "STACKED_BARS": "Bar Bertindan",
                "TRANSPOSE": "Transposisi"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "Mod Blok Soalan",
                "BLUR": "Kabur",
                "COULD_NOT_LOAD_DATA": "Tidak dapat memuat data dengan konfigurasi yang ditentukan — cuba medan sumber yang berbeza atau julat tarikh yang lebih besar.",
                "FIELD": "Medan",
                "RADIUS": "Jejari",
                "SHOW_REGIONS": "Tunjukkan Wilayah",
                "SHOW_REGION_LABELS": "Tunjukkan Label Wilayah"
            },
            "GAUGEWIDGET": {
                "MAX": "Maksimum",
                "MIN": "Minimum",
                "VALUE_RANGES": "Julat nilai"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "Label bawah",
                "CATEGORY_NAME": "Nama kategori",
                "ERROR_COLON": "Ralat:",
                "INCLUDE_HIDDEN_GROUPS": "Termasuk kumpulan tersembunyi dalam peratus",
                "LARGE_LABELS": "Label besar",
                "NO": "Tidak",
                "PERCENT": "Peratus",
                "RESPONSE_COUNT": "Kiraan maklum balas",
                "RESPONSE_COUNT_WITH_VALUE": "{{ responseCount }} maklum balas",
                "SMALL_LABELS": "Label kecil",
                "YES": "Ya"
            }
        });
        $cache.put('NL', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "Wachtwoord",
                "ACCESS_CODE_PROTECTION": "Wachtwoordbescherming",
                "ADD": "Toevoegen",
                "ADD_BREAKOUT": "Rapportuitsplitsing",
                "ADD_NOTE": "Nota toevoegen",
                "ADD_SCHEDULED_REPORT": "Gepland rapport toevoegen",
                "ADD_WIDGET": "Visualisatie toevoegen",
                "ALL_PROJECTS": "Alle projecten",
                "ALL_QUESTIONS": "Pagina's met vragen",
                "ANSWER": "Antwoord",
                "ANY_CHANGES_LOST": "Wijzigingen aan rapporten zullen verloren gaan als u het Qualtrics XM Platform verlaat.",
                "APPENDED_COPY_IN_PARENS": "(Kopiëren)",
                "AREA_CHART": "Vlakdiagram",
                "AREA_CHART_DESC": "Een lijndiagram met twee assen waarvan het vlak onder de lijn gevuld is.",
                "ATTACHMENT": "Bijlage",
                "BACKUP_CURRENT_REPORT": "Sla een back-upkopie van dit rapport op voordat de visualisaties beïnvloed worden",
                "BACKUP_CURRENT_REPORT_LINE2": "Opmerking: de back-upkopie wordt hernoemd naar '{{nameOfReportCopy}}'",
                "BACK_TO_REPORTS": "Terug naar Rapporten",
                "BACK_TO_TOP": "Terug naar boven",
                "BACK_TO_VIEW_RESULTS": "Terug naar vorige weergaveresultaten",
                "BAR_CHART": "Staafdiagram",
                "BAR_CHART_DESC": "Een staafdiagram met twee assen dat extra configuraties toelaat, zoals asverplaatsing en herschikking van gegevenspunten.",
                "BREAKDOWN_BAR_CHART": "Uitsplitsingsbalk",
                "BREAKDOWN_BAR_CHART_DESC": "Een staafdiagram met horizontaal gestapelde staven dat doorgaans gebruikt wordt voor visuele weergave van meetwaarden ten opzichte van elkaar. Vormt een alternatief voor een cirkeldiagram.",
                "CANCEL": "Annuleren",
                "CANCEL_CONF_TEXT": "Weet u zeker dat u wilt annuleren?<br/>Alle wijzigingen zullen verloren gaan.",
                "CANCEL_EDITS": "Bewerkingen annuleren",
                "CHART": "Diagram",
                "CHOICE": "Keuze",
                "CHOICES_COUNT_METRIC": "Aantal keuzes",
                "CHOOSE_PAGES_TO_DISPLAY": "Weer te geven pagina’s kiezen",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "Dit rapport bevat {{maxReportPageCount}} pagina’s, maar Resultaten mogen maar tot {{reportSizeLimit}} bevatten. Selecteer een subset binnen de limiet.",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "Rapporten mogen maximaal {{reportSizeLimit}} pagina's bevatten, selecteer de pagina's die u wilt toevoegen.",
                "CLEAR_ALL": "Alles leegmaken",
                "CLOSE": "Sluiten",
                "CLOUD": "EEN BESCHRIJVING VOOR CLOUD",
                "COLLABORATED_NEW": "De eigenaar van deze enquête gebruikt het nieuwe Qualtrics XM Platform. Rapporten voor deze enquête worden bewerkt met nieuwe resultaten.",
                "COMMA_SEPARATED_LIST": "Kommagescheiden lijst",
                "COMPACTNESS": "Lettertypes en afstand",
                "COMPACTNESS_INFO": "Deze instelling beïnvloedt de tabelopvulling, lettergrootte en staafgrootte in diagrammen. Dit wordt ook toegepast op de meeste exporten.",
                "CONFIRM": "OK",
                "CONFIRM_DELETE": "Verwijdering bevestigen",
                "CONFIRM_DELETE_PAGE": "Weet u zeker dat u deze pagina wilt verwijderen?",
                "CONTINUE": "Doorgaan",
                "CONTINUE_EDITING": "Doorgaan met bewerken",
                "COPY": "Kopiëren",
                "COPY_OF_REPORT_NAME": "Kopie van {{nameOfCurrentReport}}",
                "COPY_REPORT": "Rapport kopiëren",
                "COPY_REPORT_ELLIPSIS": "Rapport kopiëren...",
                "COPY_TO_NEW_REPORT": "Kopiëren naar nieuw rapport...",
                "CREATE": "Aanmaken",
                "CREATED": "Aangemaakt",
                "CREATE_CUSTOM_PAGE": "Aangepaste pagina aanmaken",
                "CREATE_NEW_REPORT": "Nieuw rapport aanmaken",
                "CREATE_NEW_REPORT_ELLIPSIS": "Nieuw rapport aanmaken...",
                "CSV_FILE": "CSV-bestand",
                "CUSTOM_PAGES": "Aangepaste pagina's",
                "DATE": "Datum",
                "DEFAULT_PALETTE": "Standaard kleurenpalet",
                "DEFAULT_REPORT": "Standaardrapport",
                "DEFAULT_VISUALIZATIONS": "Standaardvisualisaties",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "Dit zijn de standaardvisualisatietypes die worden gebruikt om standaardresultatenrapporten samen te stellen. Door deze instellingen bij te werken en toe te passen, wordt het huidige rapport opnieuw samengesteld met de nieuwe standaardinstellingen. Desgewenst kunt u een back-up van het huidige rapport aanmaken.",
                "DEFAULT_VISUALIZATIONS_NOTE": "Opmerking: niet elk visualisatietype is beschikbaar voor alle vraagtypes. Bepaalde niet-standaard visualisaties kunnen automatisch vervangen worden.",
                "DEFAULT_VISUALS_DISCLAIMER": "Dit rapport wordt door Qualtrics bijgewerkt met de nieuwe standaardvisualisatie-instellingen.",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "Deze update beïnvloedt {{amountOfWidgetsAffected}} visualisaties in dit rapport.",
                "DEFAULT_VISUAL_EDIT_DETECTED": "Bewerking van standaardvisualisatie gedetecteerd",
                "DELETE_BUTTON": "Verwijderen",
                "DELETE_DISABLED_EXPLANATION": "Het is niet toegestaan om rapporten te verwijderen die werden aangemaakt in de vorige rapportage-interface, totdat uw organisatie een volledige migratie naar het Qualtrics XM Platform heeft uitgevoerd.",
                "DELETE_PAGE": "Pagina verwijderen",
                "DELETE_PAGE_ELLIPSIS": "Pagina verwijderen...",
                "DELETE_REPORT": "Rapport verwijderen",
                "DELETE_REPORT_ELLIPSIS": "Rapport verwijderen...",
                "DELETE_WIDGET_QUESTION": "Verwijderen?",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "Dit veld is versleuteld en kan niet gebruikt worden voor sortering.",
                "DISCARD_EDITS": "Bewerkingen verwijderen",
                "DISTRIBUTION_PAUSED": "Rapportdistributie gepauzeerd.",
                "DONE_BUTTON": "Klaar",
                "DONE_EDITING": "Klaar met bewerken",
                "DOWNLOAD": "Downloaden",
                "DOWNLOAD_AS_CSV": "Downloaden als CSV",
                "DOWNLOAD_AS_PDF": "Als PDF downloaden",
                "DOWNLOAD_FAILED": "Download mislukt",
                "DOWNLOAD_PREVIOUS_EXPORTS": "Vorige exports downloaden...",
                "DO_YOU_WISH_TO_DELETE": "Wilt u het volgende verwijderen:",
                "DUPLICATE_PAGE": "Blad dupliceren",
                "EDIT_REPORT": "Rapport bewerken",
                "EDIT_REPORT_ELLIPSIS": "Rapport bewerken...",
                "EDIT_VISUALIZATION": "Visualisatie bewerken",
                "EMAIL_ADDRESS": "E-mailadres",
                "EMAIL_SENT": "E-mail verzonden...",
                "END_OF_REPORT": "Einde van rapport",
                "ENTER_NAME": "Naam invoeren",
                "ERROR_COPYING": "Er is een fout opgetreden bij het kopiëren van het rapport.",
                "ERROR_DELETING": "Er is een fout opgetreden bij het verwijderen van het rapport.",
                "ERROR_DELETING_EXPORT": "Er is een fout opgetreden bij het verwijderen van de export.",
                "ERROR_HEADING": "Fout",
                "ERROR_PUBLISHING": "Er is een fout opgetreden bij het opslaan van de instellingen.",
                "ERROR_RENAMING": "Er is een fout opgetreden bij de naamwijziging van het rapport.",
                "ERROR_REQUESTING_EXPORT": "Er is een fout opgetreden bij het opvragen van het rapport.",
                "ERROR_SAVING_GLOBAL_OPTIONS": "Er is een fout opgetreden bij het opslaan van de globale visualisatie-opties.",
                "ERROR_SEND_TEST_EMAIL": "Er is een fout opgetreden bij het verzenden van de teste-mail.",
                "EVERY_FRIDAY": "Elke vrijdag",
                "EVERY_MONDAY": "Elke maandag",
                "EVERY_MONTH": "Maandelijks op",
                "EVERY_SATURDAY": "Elke zaterdag",
                "EVERY_SUNDAY": "Elke zondag",
                "EVERY_THURSDAY": "Elke donderdag",
                "EVERY_TUESDAY": "Elke dinsdag",
                "EVERY_WEDNESDAY": "Elke woensdag",
                "EVERY_WEEK": "Wekelijks elke",
                "EXAMPLE_GROUP_NUM": "Groep {{num}}",
                "EXAMPLE_SERIES_NUM": "Reeks {{num}}",
                "EXPORT": "Exporteren",
                "EXPORT_CSV": "CSV (met kommascheiding)",
                "EXPORT_EXCEL_SPREADSHEET": "Excel-spreadsheet",
                "EXPORT_IMAGE": "Afbeelding exporteren",
                "EXPORT_PAGES": "Pagina's exporteren",
                "EXPORT_PDF": "PDF-document",
                "EXPORT_PPT_SLIDES": "PowerPoint",
                "EXPORT_RAW_DATA": "Onbewerkte gegevens exporteren",
                "EXPORT_REPORT": "Rapport exporteren",
                "EXPORT_VISUALIZATION": "Visualisatie exporteren",
                "EXPORT_WORD_DOC": "Word-document",
                "FAILED_SAVE_TXT": "Opslaan mislukt",
                "FILTERED": "Gefilterd",
                "FIRST_PAGE": "Eerste pagina",
                "FIRST_WEEKDAY": "Eerste weekdag van de maand",
                "FROM": "Van",
                "FROM_EMAIL": "Van e-mail",
                "FROM_NAME": "Van naam",
                "GAUGE_CHART": "Meterdiagram",
                "GAUGE_CHART_DESC": "Een diagram met snelheidsmeters om huidige waarden te vergelijken ten opzichte van een doel of een reeks drempelwaarden.",
                "GENERATING_FILE": "Bestand wordt gegenereerd...",
                "GENERATING_IMAGE": "Afbeelding wordt gegenereerd...",
                "GENERATING_PDF": "PDF-bestand wordt gegenereerd...",
                "GENERIC_ERROR": "Door een fout konden we het gevraagde project niet laden.",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "Globale opties...",
                "GLOBAL_METRIC": "Standaard meetwaarde",
                "GLOBAL_MODAL_PAGE_TITLE": "Voorbeeld van een visualisatie bij gebruik van de globale opties voor het resultatengedeelte van de Qualtrics Research Suite",
                "GLOBAL_MODAL_WIDGET_TITLE": "Visualisatietitel",
                "GLOBAL_OPTIONS": "Globale opties",
                "GLOBAL_PRECISION": "Standaard aantal decimalen",
                "GLOBAL_SETTINGS_APPLY": "Mijn standaardinstellingen toepassen",
                "GLOBAL_SETTINGS_SAVE": "Opslaan als mijn standaardinstellingen",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "Qualtrics-standaardwaarden toepassen",
                "GROUP": "Groep",
                "HEAT_MAP_CHART": "Heatmapdiagram",
                "HEAT_MAP_CHART_DESC": "Een visualisatie van de 'heatmap' om de spreiding van gebruikersinvoer (zoals muisklikken) weer te geven.",
                "HIDDEN": "Verborgen",
                "HIDDEN_PAGE": "Deze pagina zal niet worden weergegeven in openbare rapporten en wordt standaard niet aangevinkt voor export van rapporten.",
                "HIDE": "Verbergen",
                "HIDE_ALL_PAGES": "Alle pagina's verbergen",
                "HIDE_PAGE": "Pagina verbergen",
                "IMAGE_FILE": "Afbeeldingsbestand",
                "INVALID_BRAND_DOMAIN": "Het ingevoerde domein komt niet voor in de lijst met goedgekeurde e-maildomeinen van uw merk. Neem contact op met uw merkverantwoordelijke om dit te verhelpen.",
                "INVALID_SPF_RECORD": "Het ingevoerde domein heeft Qualtrics niet goedgekeurd voor verzendingen. Dit zal het goede verloop van de bezorging beïnvloeden. Gebruik een ander domein of neem contact op met Qualtrics om dit probleem op te lossen.",
                "ISSUE_SAVING_REPORTS": "Er was een probleem bij het opslaan voor een of meerdere rapporten. Probeer het opnieuw.",
                "ISSUE_SENDING_TEST": "Er is een fout opgetreden bij het verzenden van de teste-mail. Probeer het opnieuw.",
                "LARGE_SURVEY": "Resultaten worden niet weergegeven omdat de enquête te groot is.",
                "LAST_DAY": "Laatste dag van de maand",
                "LAST_MODIFIED_COLON_WITH_DATE": "Laatst gewijzigd op: %1",
                "LAST_PAGE": "Laatste pagina",
                "LAST_WEEKDAY": "Laatste weekdag van de maand",
                "LATER": "Later",
                "LEARN_MORE": "Meer info",
                "LINE_CHART": "Lijndiagram",
                "LINE_CHART_DESC": "Een lijndiagram met twee assen dat vaak wordt gebruikt voor tijdweergave op de X-as.",
                "LOG_OUT_WARNING": "Klik om het even waar binnen {{countdown}} seconden om aangemeld te blijven",
                "MESSAGE": "Bericht",
                "MONTHLY": "Maandelijks",
                "MOVE_DOWN": "Visualisatie naar onder verplaatsen",
                "MOVE_PAGE_TO_BOTTOM": "Naar onder",
                "MOVE_PAGE_TO_TOP": "Naar boven",
                "MOVE_UP": "Visualisatie naar boven verplaatsen",
                "MY_SURVEYS": "Mijn projecten",
                "NAME": "Naam",
                "NEW_CUSTOM_PAGE_NAME": "Nieuwe aangepaste pagina",
                "NEW_REPORT": "Nieuw rapport",
                "NEXT_PAGE": "Volgende pagina",
                "NEXT_RUN": "Volgende uitvoering",
                "NO_EXPORTS": "Er werden nog geen exports aangevraagd voor dit rapport.",
                "NO_ITEMS_TO_DISPLAY": "Er zijn geen items om weer te geven",
                "NO_MATCHING_CUSTOM_PAGES": "Geen overeenstemmende aangepaste pagina's",
                "NO_MATCHING_PAGES": "Geen pagina's gevonden voor zoekopdracht",
                "NO_MATCHING_REPORTS": "Geen overeenstemmende rapporten.",
                "NO_PROJECT": "Specificeer een project om door te gaan.",
                "NO_PROJECTS_TO_MIGRATE": "Er zijn geen bij te werken projecten.",
                "NO_QUESTIONS": "Geen overeenstemmende vragen",
                "NO_RESULTS_YET": "Er zijn nog geen resultaten om weer te geven. Distribueer uw enquête om antwoorden te verzamelen.",
                "OFF": "Uit",
                "ON": "Aan",
                "PAGES_SELECTED": "Pagina's geselecteerd",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "Met deze selectie bevat het rapport {{currentSelectedPageCount}} pagina’s, wat het toegestane maximum van {{reportSizeLimit}} overschrijdt. Selecteer een kleiner bereik.",
                "PAGES_SELECTION_INVALID_RANGE": "Selecteer een geldig bereik.",
                "PAGE_OPTIONS": "Paginaopties",
                "PDF_ROW_TRUNCATION_MESSAGE": "Te veel rijen voor PDF-export, probeer te exporteren naar Word of CSV",
                "PERCENTAGE_METRIC": "Procent",
                "PIE_CHART": "Cirkeldiagram",
                "PIE_CHART_DESC": "Een cirkelvormige uitsplitsing van waarden voor een bepaald gegevenspunt. Nuttig om relatieve proporties van geselecteerde waarden te meten.",
                "PREVIEW": "Voorbeeldweergave",
                "PREVIOUS_PAGE": "Vorige pagina",
                "PRINT_PAGE": "Pagina afdrukken",
                "PUBLIC_LINK": "Openbare link",
                "PUBLIC_REPORT_AVAILABLE": "Openbaar rapport beschikbaar",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "Wachtwoord",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "Verkeerd wachtwoord. Probeer het opnieuw.",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "Verzenden",
                "PUBLIC_RESULTS_LOGIN_TITLE": "Gebruikersnaam voor openbaar rapport | Qualtrics-onderzoekssoftware",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "Openbaar rapport werd niet gevonden. Neem contact op met de eigenaar van dit rapport en vraag om een geldige link.",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "Openbaar rapport werd niet gevonden",
                "PUBLIC_RESULTS_NOT_UPDATED": "Links naar openbare rapporten en geplande e-mails voor rapportage zullen geen gebruikmaken van het Qualtrics XM Platform totdat u ze bijwerkt.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "De sessie is afgelopen. Meld u opnieuw aan om het rapport met openbare resultaten te blijven bekijken.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "Deze sessie is verstreken",
                "PUBLIC_RESULTS_TITLE": "Openbaar rapport",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "U heeft geen toestemming om deze pagina te bekijken. Neem contact op met de eigenaar van dit rapport en vraag om het openbaar te maken.",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "Openbaar rapport niet toegestaan",
                "PUBLISHED_LINK_GENERATING_LINK": "Link wordt gegenereerd…",
                "PUBLISHED_REPORT_FOUND_HERE": "Iedereen kan dit rapport bekijken via de volgende link:",
                "PUBLISH_REPORT": "Openbaar rapport beheren",
                "PUBLISH_REPORT_ELLIPSIS": "Openbaar rapport beheren…",
                "QUESTION": "Vraag",
                "RANK": "Positie",
                "REMOVE_WIDGET": "Visualisatie verwijderen",
                "RENAME_PAGE": "Naam pagina wijzigen",
                "RENAME_REPORT": "Rapport hernoemen",
                "RENAME_REPORT_ELLIPSIS": "Naam rapport wijzigen...",
                "REPLY_TO_EMAIL": "Antwoordadres",
                "REPORT_COLON": "Rapport:",
                "REPORT_SETTINGS": "Rapportinstellingen",
                "REPORT_SETTINGS_ELLIPSIS": "Rapportinstellingen…",
                "RESPONSE_COUNTS": "Aantal antwoorden",
                "RESULTS_DASHBOARDS_BANNER": "en probeer de nieuwe, verbeterde versie van enquêteresultaten, met moderne, toegankelijke UI-en gegevensvisualisatie, nieuwe analyse- en verkenningsfuncties, enzovoort.",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "Release notes",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "De meest recente weergeven",
                "RESULTS_OPTIONS": "Rapportopties",
                "RESULTS_TITLE": "Rapport",
                "RESUME_DISTRIBUTION": "Distributie hervatten",
                "REVERT": "Terugdraaien",
                "RICH_TEXT_LIMIT_REACHED": "De inhoud heeft de maximale lengte bereikt!",
                "SAVE": "Opslaan",
                "SAVE_AND_CLOSE": "Opslaan en sluiten",
                "SAVE_AS_CSV": "Visualisatie opslaan als CSV",
                "SAVE_AS_IMAGE": "Visualisatie opslaan als afbeelding",
                "SAVE_CONFIRMATION": "Bevestiging opslaan",
                "SAVE_PAGE_AS_ELLIPSIS": "Pagina exporteren als...",
                "SAVE_SETTINGS": "Instellingen opslaan",
                "SCHEDULE_REPORT_EMAIL": "Rapportage-e-mail plannen",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "Rapportage-e-mail plannen...",
                "SEARCH_ELLIPSIS": "Zoeken ...",
                "SEARCH_PAGES": "Vragen zoeken",
                "SEARCH_PAGES_ELLIPSIS": "Pagina's zoeken…",
                "SEARCH_REPORTS_ELLIPSIS": "Rapporten zoeken...",
                "SELECTED": "Geselecteerd:",
                "SELECT_ALL": "Alles selecteren",
                "SELECT_A_FIELD": "Selecteer een veld",
                "SELECT_A_WIDGET": "Selecteer een visualisatie",
                "SELECT_PAGES": "Pagina’s selecteren",
                "SELECT_PAGES_ELLIPSIS": "Pagina’s selecteren...",
                "SEND": "Verzenden",
                "SEND_TEST_EMAIL": "Verstuur test e-mail",
                "SETTING_DEFAULT": "Standaard",
                "SETTING_HIGH": "Hoog",
                "SETTING_LARGE": "Groot",
                "SETTING_LOW": "Laag",
                "SETTING_NORMAL": "Normaal",
                "SETTING_SMALL": "Klein",
                "SHARE_REPORT": "Rapport delen",
                "SHOW_ALL_PAGES": "Alle pagina's weergeven",
                "SHOW_FULL_QTEXT": "Volledige vraagtekst weergeven in paginatitels",
                "SIMPLE_TABLE": "Eenvoudige tabel",
                "SIMPLE_TABLE_DESC": "Een flexibele tabel met weergave van verschillende waarden in rijen of kolommen.",
                "SIZE": "Grootte",
                "SPLINE_CHART": "Curvegrafiek",
                "SPLINE_CHART_DESC": "Een lijndiagram met twee assen en gebogen lijnen dat vaak gebruikt wordt voor tijdweergave op de X-as.",
                "STATISTICS_TABLE": "Statistiekentabel",
                "SUBJECT": "Onderwerp",
                "SURVEY_ANALYSIS": "Enquêteanalyse",
                "SURVEY_SUMMARY": "Enquêteoverzicht",
                "TABLE": "EEN BESCHRIJVING VOOR TABEL",
                "TIME": "Tijd",
                "TO": "Aan",
                "TOTAL": "Totaal",
                "TRANSPOSE_STATS_TABLES": "Statistiektabellen transponeren",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "Uitsplitsing van statistiektabellen transponeren",
                "TRUNCATE_PAGE_TITLES": "Vraagtekst in paginatitels afbreken",
                "TRY_IT_NOW": "Nu proberen",
                "TYPE": "Type",
                "UNABLE_TO_CHECK_SPF": "Het is niet mogelijk om de SPF-gegevens te controleren. Probeer het opnieuw.",
                "UNAUTHORIZED": "U heeft geen toestemming om dit rapport te bekijken. Neem contact op met de eigenaar om toegang te krijgen.",
                "UNHIDE_PAGE": "Pagina zichtbaar maken",
                "UPDATE": "Bijwerken",
                "UPDATED_SUCCESSFULLY": "Met succes bijgewerkt.",
                "UPDATE_ALL_IN_THIS_PROJECT": "Alles in dit project bijwerken",
                "UPDATE_ALL_PROJECTS": "Alle projecten bijwerken",
                "UPDATE_NOW": "Nu bijwerken",
                "UPDATE_REPORTS": "Rapporten bijwerken…",
                "UPDATE_REPORT_ELEMENTS": "Links openbare rapporten en geplande rapportage-e-mails bijwerken",
                "UPGRADE_MY_ACCOUNT": "Mijn account upgraden",
                "USE_EXPORT_TAGS": "Vraagnummers opnemen",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "Eenvoudige kolomtotalen voor tabel gebruiken",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "Eenvoudige respondenttotalen voor tabel gebruiken",
                "USE_WEIGHTED_METRICS": "Gewogen meetwaarden gebruiken",
                "VIEW": "Weergeven",
                "WEEKLY": "Wekelijks",
                "WELCOME_TO_NEW_RESULTS": "Welkom op de rapportage van het Qualtrics XM Platform.",
                "WHEN": "Wanneer",
                "WIDGET_LOADING": "Bezig met laden...",
                "WIDGET_OPTIONS_ERR": "Laden van visualisatieopties mislukt",
                "WIDGET_TYPE": "Visualisatie",
                "WORD_CLOUD": "Woordwolk",
                "WORD_CLOUD_DESC": "Een gewogen visualisatie van de woordfrequentie in tekstgegevens met extra opties voor kleurcodering."
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Bedenk dat er resources in uw organisatie zijn die u kunnen helpen met het interpreteren van de feedback, zoals HR-partners, uw manager en/of een mentor.",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Haal even koffie en verdiep u in de feedback.",
                "ABOUT_YOUR_REPORT_HEADER": "Over het rapport",
                "ABOUT_YOUR_REPORT_LINE1": "Welkom bij het 360 feedbackrapport. Dit rapport is een geweldige kans voor uw professionele groei en ontwikkeling. Neem voldoende tijd om de feedback door te nemen want alleen dan kunt u de resultaten succesvol benutten. Aanvankelijk kan het moeilijk zijn om de feedback te horen, maar houd voor ogen dat deze feedback is bedoeld om uw groei en ontwikkeling te versnellen.",
                "ABOUT_YOUR_REPORT_LINE2": "Houd een paar dingen in gedachten wanneer u het rapport doorneemt.",
                "ADD_CONDITIONAL_TEXT": "Voorwaardentekst toevoegen",
                "ADD_CUSTOM_PALETTE": "Aangepast palet toevoegen",
                "ADD_DATA_SOURCE": "Gegevensbron toevoegen",
                "ADD_FOLLOWING": "Volgende toevoegen",
                "ADD_LABEL": "Label toevoegen",
                "ADVANCED_FILTER": "Geavanceerde filter",
                "AGREEMENT_CHART": "Overeenstemmingsdiagram",
                "AGREEMENT_CHART_FOOTER": "Het overeenstemmingsdiagram geeft de overeenkomst van scores aan. Elke punt geeft aan hoe een persoon u heeft beoordeeld voor elk item. De grootte van de punt geeft aan hoeveel mensen u een specifieke beoordeling hebben gegeven.",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "antwoorden",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "antwoord",
                "AGREEMENT_CHART_LEGEND_TITLE": "Hoe anderen u hebben beoordeeld",
                "ALL": "Alle",
                "AND_IF": "En als",
                "ANGLED": "In een hoek",
                "AREA": "Vlak",
                "AUTO": "Auto",
                "AVERAGE": "Gemiddeld",
                "AXIS_VALUES": "Aswaarden",
                "BAR": "Staaf",
                "BASE_WORD_COLOR": "Basiswoordkleur",
                "BLUR": "Vervagen",
                "BOTTOM_BOX": "Onderste vak",
                "BREAKOUT_HEADERS": "Kopteksten uitsplitsing",
                "CANCEL": "Annuleren",
                "CATEGORICAL": "Categorisch",
                "CATEGORY": "Categorie",
                "CATEGORY_NAME": "Naam categorie",
                "CHANGE_CATEGORIES_ORDER": "Volgorde van categorieën wijzigen",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "Volgorde van scorecategorieën wijzigen",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "Wijzig de volgorde die in de visualisatie verschijnt: klik links van het element van de scorecategorie en sleep dit naar de gewenste positie.",
                "CHANGE_QUESTIONS_ORDER": "Volgorde van vragen wijzigen",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "Volgorde van vragen wijzigen",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "Wijzig de volgorde die in de visualisatie verschijnt: klik links van het element van de vraagcategorie en sleep dit naar de gewenste positie.",
                "CHARTS": "Diagrammen",
                "CHART_TYPE": "Diagramtype",
                "CHOICE_COUNT": "Aantal keuzes",
                "CHOICE_TOTALS": "Keuzetotalen",
                "CLEAR": "Wissen",
                "CLOSE": "Sluiten",
                "COLOR_PALETTE": "Kleurenpalet",
                "COLUMN_NAMES": "Kolomnamen",
                "COLUMN_TOTALS": "Kolomtotalen",
                "COMPARED_FILTER_GROUP": "Vergeleken filtergroep",
                "COMPARED_FILTER_GROUPS": "Vergeleken filtergroepen",
                "COMPARE_WITH": "vergelijken met",
                "COMPETITION_RANKING": "Wedstrijdrangordening gebruiken",
                "COMPETITION_RANKING_TOOLTIP": "In het geval van een gelijkspel wordt aan alle gelijke scores dezelfde rangorde gegeven. Het volgende vervolgitem wordt echter dezelfde rangorde gegeven als: het totaalaantal items dat een hogere rangorde in de tabel heeft, plus een.",
                "COMPLETED_RESPONSES": "Ingevulde antwoorden",
                "CONDITIONAL_TEXT": "Voorwaardentekst",
                "COUNT": "Aantal",
                "CREATE": "Aanmaken",
                "CUSTOM_PALETTE": "Aangepast palet",
                "DATA_SOURCE_TYPE": "Type gegevensbron",
                "DATA_SOURCE_TYPE_CATEGORY": "Scorecategorieën",
                "DATA_SOURCE_TYPE_QUESTION": "Vragen",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "Vraag",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "Rangschikbare items",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "Scorecategorie",
                "DEFAULT": "Standaard",
                "DEFAULT_TEXT": "Standaardtekst",
                "DELETE": "Verwijderen",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "Maak inzichtelijk van wie de feedback afkomstig is: een collega, een ondergeschikte, een leidinggevende, enzovoort.",
                "DIFFERENT_EVALUATORS_HEADER": "Verschillende beoordelaars",
                "DIRECT_REPORTS": "Rechtstreekse ondergeschikten",
                "DISABLED": "Uitgeschakeld",
                "DISPLAY_OPTIONS": "Weergaveopties",
                "DISPLAY_THRESHOLD_TEXTS": "Tekst weergeven op basis van het volgende groepshiaat",
                "DIVERGENT": "Divergerend",
                "DONE": "Klaar",
                "DONT_HEADER": "Niet doen:",
                "DONT_LINE1": "Proberen te achterhalen wie wat heeft gezegd",
                "DONT_LINE2": "Aandacht geven aan positieve of negatieve scores/opmerkingen",
                "DONT_LINE3": "Een ontwikkelingsplan met betrekking tot elk item aanmaken",
                "DONT_LINE4": "Ontmoedigd raken dat u verbeterpunten heeft",
                "DONUT": "Donut",
                "DOWNLOAD_CSV": "Oude versie CSV downloaden",
                "DOWNLOAD_ZIP": "Alle bestanden downloaden",
                "DO_HEADER": "Doen:",
                "DO_LINE1": "Feedback holistisch bekijken",
                "DO_LINE2": "Vaststellen wat u sterke punten zijn en waar ruimte is voor verbetering",
                "DO_LINE3": "Prioriteit geven aan een paar aandachtsgebieden om aan uw ontwikkelingsplan toe te voegen",
                "DO_LINE4": "Begrijpen dat iedereen verbeterpunten heeft",
                "DROPOFF": "Verschil",
                "DUPLICATE": "Duplicaat",
                "EDIT_CONDITIONAL_TEXT": "Voorwaardentekst bewerken",
                "EDIT_CUSTOM_PALETTE": "Aangepast palet bewerken",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "Of de volgende tekst weergeven",
                "ENABLED": "Ingeschakeld",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "Volgorde inschakelen op basis van weergavelogica beoordelaarscategorie…",
                "ENABLE_ORDERING_FOR": "Volgorde inschakelen voor",
                "EQUAL_TO": "Gelijk aan",
                "FIELD": "Veld",
                "FILTER_NAMES": "Filternamen",
                "FOLLOWING_PARENTHESES": "(volgende)",
                "FOOTER": "Voettekst",
                "GAP": "Hiaat",
                "GAP_CHART": "Hiatendiagram",
                "GAP_CHART_DESCRIPTION": "Het hiatendiagram toont het verschil in scores tussen twee groepen beoordelaars. Bijvoorbeeld bij een vergelijking van uw eigen beoordelingen en die van anderen betekent een positief (+) verschil dat anderen u hoger hebben beoordeeld dan u dat zelf heeft gedaan. Een negatief (-) verschil betekent dat anderen u lager hebben beoordeeld dan u dat zelf heeft gedaan.",
                "GAP_CHART_FOOTER": "Het hiatendiagram toont het +/- verschil tussen de twee groepen beoordelaars.",
                "GAP_TABLE_DESCRIPTION": "Verborgen sterke punten toont waar anderen u hoger hebben beoordeeld dan u dat zelf heeft gedaan. Verbeterpunten toont waar anderen u lager hebben beoordeeld dan u dat zelf heeft gedaan. Beide secties zijn gerangschikt van het grootste naar het kleinste hiaat.",
                "GAP_TABLE_FOOTER": "In de eerste kolom staan de scores die u uzelf heeft gegeven. De tweede kolom vermeldt de gemiddelde score van anderen. In de derde kolom ziet u het verschil tussen uw eigen score en de score die anderen aan u hebben toegekend.",
                "GAP_TABLE_TITLE": "Verborgen sterke punten/verbeterpunten",
                "GREATER_OR_EQUAL": "Groter dan of gelijk aan",
                "GREATER_THAN": "Groter dan",
                "GROUP": "Groep",
                "GROUPED_FOR_ANONYMITY": "Gegroepeerd voor anonimiteit",
                "HEADER_NAMES": "Headernamen",
                "HIGHEST_SCORES": "Hoogste scores",
                "HIGHLIGHT_THRESHOLD": "Drempelwaarde om hiaten te markeren",
                "HIGHLOW_TABLE": "Hoge en lage scores",
                "HIGHLOW_TABLE_FOOTER": "Deze sectie toont de vijf hoogste en laagste beoordeelde gedragingen (voor alle gedragingen) uit de toepasselijke gemiddelde beoordelingscategorie. Om het maximale uit deze pagina te halen, is het handig om te zoeken naar trends die zich kunnen voordoen. Bijvoorbeeld, als het grootste deel van uw gedragingen met de laagste score is geconcentreerd in een of twee categorieën; dit kunnen gebieden zijn die ontwikkeling behoeven. Het gedrag met de hoogste beoordelingen kan sterke punten identificeren die op andere gebieden kunnen worden benut.",
                "HIGH_LOW_TABLE_DESCRIPTION": "Het hoog/laag-diagram toont items op basis van de punten waar anderen u het hoogst en het laagst hebben beoordeeld.",
                "HORIZONTAL": "Horizontaal",
                "HORIZONTAL_AND_VERTICAL": "Horizontaal en verticaal",
                "HORIZONTAL_BAR": "Horizontale staaf",
                "HOW_TO_INTERPRET_RESULT_HEADER": "Zo interpreteert u de resultaten en bepaalt u welke actie moet worden ondernomen:",
                "IF": "Als",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "Verborgen labels in procent toevoegen",
                "INNER_RIM": "Binnenrand",
                "IS": "Is",
                "IS_NOT": "Is niet",
                "IS_SAME_AS_SUBJECT": "Is zelfde als beoordeelde",
                "ITEM": "Item",
                "LABEL": "label",
                "LABELS": "Labels",
                "LARGE_LABELS": "Grote labels",
                "LEGEND": "Legenda",
                "LEGEND_POSITION": "Positie legenda",
                "LEGEND_VALUES": "Legendawaarden",
                "LESS_OR_EQUAL": "Kleiner dan of gelijk aan",
                "LESS_THAN": "Kleiner dan",
                "LINE": "Lijn",
                "LOWEST_SCORES": "Laagste scores",
                "MANAGERS": "Managers",
                "MANUAL_FONT_SIZE": "Tekengrootte handmatig instellen",
                "MAX": "Max.",
                "MEAN": "Gemiddelde",
                "MEDIAN": "Mediaan",
                "METRIC_TYPE": "Type meetwaarde",
                "MIN": "Min.",
                "MODIFY_CUSTOM_PALETTES": "Aangepaste paletten wijzigen",
                "MOVE_DOWN": "Omlaag",
                "MOVE_UP": "Omhoog",
                "MULTI_SELECT_ITEMS_SELECTED": "geselecteerd",
                "NEGATIVE_GAPS": "Verbeterpunten",
                "NO": "Nee",
                "NONE": "Geen",
                "NOT_APPLICABLE": "N.v.t.",
                "NOT_EQUAL_TO": "Niet gelijk aan",
                "NO_DATA_AVAILABLE_WARNING": "Geen gegevens beschikbaar",
                "NO_FILTER": "Geen filter",
                "NO_FILTER_IS_APPLIED": "Er is geen filter toegepast.",
                "NO_VALUE": "Geen waarde",
                "NPS": "Net Promoter Score",
                "NUMBER": "nummer",
                "NUMBERS": "Nummers",
                "NUMBER_OF_GAPS_NEGATIVE": "Aantal negatieve verschillen",
                "NUMBER_OF_GAPS_POSITIVE": "Aantal positieve verschillen",
                "NUMBER_OF_ROWS_HIGH": "Aantal rijen ‘Hoog’",
                "NUMBER_OF_ROWS_LOW": "Aantal rijen ‘Laag’",
                "OPTIONS": {
                    "HEADER_NAME": "Koptekstnamen",
                    "LEGEND": "Legenda",
                    "SCALE_AXIS_CHANGER_TITLE": "Bereik"
                },
                "ORIENTATION": "Oriëntatie",
                "OR_IF": "Of als",
                "OTHER": "Overig",
                "OTHERS": "Andere",
                "PAGE_OF": "Pagina: %1 van %2",
                "PALETTE_REMOVED": "Palet verwijderd",
                "PEERS": "Collega's",
                "PERCENT": "Procent",
                "PERCENTAGE": "Procent",
                "PERCENTAGE_OF_CHOICES": "Percentage van keuzes",
                "PERCENTAGE_OF_RESPONSES": "Percentage van antwoorden",
                "PERCENT_COMPLETE": "% voltooid",
                "PERSON_METADATA": "Metagegevens persoon",
                "PERSON_METADATA_EVALUATOR": "Van de beoordelaar",
                "PERSON_METADATA_SUBJECT": "Van de beoordeelde",
                "PERSON_METADATA_VIEWER": "Van de kijker",
                "POSITIVE_GAPS": "Verborgen sterke punten",
                "PRIMARY_PARENTHESES": "(primair)",
                "QUESTIONS": "Vragen",
                "RADIUS": "Straal",
                "RANK": "Positie",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "Hoogste score",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "Hoogste scores",
                "RANKABLE_ITEMS_ITEM_HAS": "Item heeft",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "Item is in top",
                "RANKABLE_ITEMS_LOWEST_SCORE": "Laagste score",
                "RANKABLE_ITEMS_LOWEST_SCORES": "Laagste scores",
                "RATER_CATEGORY_DISPLAY_LOGIC": "weergavelogica beoordelaarscategorie",
                "RATIO": "Verhouding",
                "RECORD": "Document",
                "REFERENCE_GROUP": "Referentiegroep",
                "RELATIONSHIP": "Relatie",
                "RELATIONSHIP_FILTERS": "Relatiefilters",
                "RELATIONSHIP_FILTERS_INFO": "Als u een relatiefilter wilt toevoegen (zoals een direct ondergeschikte, collega of manager), selecteert u 'Filters beheren' en gebruikt u alleen de relatievoorwaarde in het vervolgkeuzemenu.",
                "REMOVE": "Verwijderen",
                "REMOVE_DATA_SOURCE": "Gegevensbron verwijderen",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Bedenk dat er resources in uw organisatie zijn die u kunnen helpen met het interpreteren van de feedback, zoals HR-partners, uw manager en/of een mentor.",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Haal even koffie en verdiep u in de feedback.",
                    "ABOUT_YOUR_REPORT_HEADER": "Over het rapport",
                    "ABOUT_YOUR_REPORT_LINE1": "Welkom bij het 360 feedbackrapport. Dit rapport is een geweldige kans voor uw professionele groei en ontwikkeling. Neem voldoende tijd om de feedback door te nemen want alleen dan kunt u de resultaten succesvol benutten. Aanvankelijk kan het moeilijk zijn om de feedback te horen, maar houd voor ogen dat deze feedback is bedoeld om uw groei en ontwikkeling te versnellen.",
                    "ABOUT_YOUR_REPORT_LINE2": "Houd een paar dingen in gedachten wanneer u het rapport doorneemt.",
                    "ADVANCED_FILTER": "Geavanceerde filter",
                    "AGREEMENT_CHART": "Overeenstemmingsdiagram",
                    "AGREEMENT_CHART_FOOTER": "Het overeenstemmingsdiagram geeft de overeenkomst van scores aan. Elke punt geeft aan hoe een persoon u heeft beoordeeld voor elk item. De grootte van de punt geeft aan hoeveel mensen u een specifieke beoordeling hebben gegeven.",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "antwoorden",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "antwoord",
                    "AGREEMENT_CHART_LEGEND_TITLE": "Hoe anderen u hebben beoordeeld",
                    "ALL": "Alle",
                    "AVERAGE": "Gemiddeld",
                    "BOTTOM_BOX": "Onderste vak",
                    "CHOICE_COUNT": "Aantal keuzes",
                    "CHOICE_TOTALS": "Keuzetotalen",
                    "COMPARISON": "Vergelijking",
                    "COMPARISON_GAP_COLUMN_HEADER": "Hiaat in vergelijking",
                    "COMPLETED_RESPONSES": "Ingevulde antwoorden",
                    "COUNT": "Aantal",
                    "DEFAULT": "Standaard",
                    "DEFAULT_TEXT": "Standaardtekst",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "Maak inzichtelijk van wie de feedback afkomstig is: een collega, een ondergeschikte, een leidinggevende, enzovoort.",
                    "DIFFERENT_EVALUATORS_HEADER": "Verschillende beoordelaars",
                    "DONE": "Gereed",
                    "DONT_HEADER": "Niet doen:",
                    "DONT_LINE1": "Proberen te achterhalen wie wat heeft gezegd",
                    "DONT_LINE2": "Aandacht geven aan positieve of negatieve scores/opmerkingen",
                    "DONT_LINE3": "Een ontwikkelingsplan met betrekking tot elk item aanmaken",
                    "DONT_LINE4": "Ontmoedigd raken dat u verbeterpunten heeft",
                    "DO_HEADER": "Doen:",
                    "DO_LINE1": "Feedback holistisch bekijken",
                    "DO_LINE2": "Vaststellen wat u sterke punten zijn en waar ruimte is voor verbetering",
                    "DO_LINE3": "Prioriteit geven aan een paar aandachtsgebieden om aan uw ontwikkelingsplan toe te voegen",
                    "DO_LINE4": "Begrijpen dat iedereen verbeterpunten heeft",
                    "FIELD": "Veld",
                    "GAP": "Hiaat",
                    "GAP_CHART": "Hiatendiagram",
                    "GAP_CHART_DESCRIPTION": "Het hiatendiagram toont het verschil in scores tussen twee groepen beoordelaars. Bijvoorbeeld bij een vergelijking van uw eigen beoordelingen en die van anderen betekent een positief (+) verschil dat anderen u hoger hebben beoordeeld dan u dat zelf heeft gedaan. Een negatief (-) verschil betekent dat anderen u lager hebben beoordeeld dan u dat zelf heeft gedaan.",
                    "GAP_CHART_FOOTER": "Het hiatendiagram toont het +/- verschil tussen de twee groepen beoordelaars.",
                    "GAP_TABLE_DESCRIPTION": "Verborgen sterke punten toont waar anderen u hoger hebben beoordeeld dan u dat zelf heeft gedaan. Verbeterpunten toont waar anderen u lager hebben beoordeeld dan u dat zelf heeft gedaan. Beide secties zijn gerangschikt van het grootste naar het kleinste hiaat.",
                    "GAP_TABLE_FOOTER": "In de eerste kolom staan de scores die u uzelf heeft gegeven. De tweede kolom vermeldt de gemiddelde score van anderen. In de derde kolom ziet u het verschil tussen uw eigen score en de score die anderen aan u hebben toegekend.",
                    "GAP_TABLE_TITLE": "Verborgen sterke punten/verbeterpunten",
                    "GROUP": "Groep",
                    "HIDE_REPORT_ALERT": "U voldoet niet aan de vereisten om het rapport te bekijken. Neem contact op met de beheerder van uw organisatie.",
                    "HIGHEST_SCORES": "Hoogste scores",
                    "HIGHLOW_TABLE": "Hoge en lage scores",
                    "HIGHLOW_TABLE_FOOTER": "Deze sectie toont de vijf hoogste en laagste beoordeelde gedragingen (voor alle gedragingen) uit de toepasselijke gemiddelde beoordelingscategorie. Om het maximale uit deze pagina te halen, is het handig om te zoeken naar trends. Als het merendeel van uw gedragingen met de laagste score bijvoorbeeld is geconcentreerd in een of twee categorieën, kunnen dit gebieden zijn die ontwikkeling behoeven. Het gedrag met de hoogste beoordelingen kan sterke punten identificeren die op andere gebieden kunnen worden benut.",
                    "HIGH_LOW_TABLE_DESCRIPTION": "Het hoog/laag-diagram toont items op basis van de punten waar anderen u het hoogst en het laagst hebben beoordeeld.",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "Zo interpreteert u de resultaten en bepaalt u welke actie moet worden ondernomen:",
                    "ITEM": "Item",
                    "LOWEST_SCORES": "Laagste scores",
                    "MAX": "Max.",
                    "MEAN": "Gemiddelde",
                    "MEDIAN": "Mediaan",
                    "MIN": "Min.",
                    "NEGATIVE_GAPS": "Verbeterpunten",
                    "NO_COMPARISON_SET": "Geen vergelijking ingesteld",
                    "NO_DATA_AVAILABLE_WARNING": "Geen gegevens beschikbaar",
                    "NO_FILTER_IS_APPLIED": "Er is geen filter toegepast.",
                    "NO_VALUE": "Geen waarde",
                    "NPS": "Net Promoter Score",
                    "OTHERS": "Anderen",
                    "PERCENTAGE": "Procent",
                    "PERCENTAGE_OF_CHOICES": "Percentage keuzes",
                    "PERCENTAGE_OF_RESPONSES": "Percentage antwoorden",
                    "PERCENT_COMPLETE": "% voltooid",
                    "POSITIVE_GAPS": "Verborgen sterke punten",
                    "QUESTIONS": "Vragen",
                    "RANK": "Positie",
                    "RELATIONSHIPS": {
                        "ANYONE": "Om het even wie",
                        "DIRECT_REPORT": "Rechtstreekse ondergeschikte",
                        "MANAGER": "Manager",
                        "PEER": "Collega",
                        "SELF": "Uzelf"
                    },
                    "REPORT_SUMMARY": "Rapportoverzicht",
                    "REPORT_SUMMARY_TABLE_FOOTER": "Vergelijk het aantal mensen dat de beoordeling heeft voltooid met het aantal mensen dat voor deelname is uitgenodigd.",
                    "REPORT_SUMMARY_TABLE_HEADER": "Statistieken van respondent",
                    "RESPONSES": "Antwoorden",
                    "RESPONSE_COUNT": "{{responseCount}} antwoorden",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> antwoorden",
                    "SCORING_CATEGORY": "Scorecategorie",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Geen antwoorden voor deze categorie",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Geen antwoorden op deze vraag",
                    "SCORING_OVERVIEW": "Scoreoverzicht",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "U en andere beoordelaars beschouwen dit gebied als een sterk punt.",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Erkend sterk punt",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Een erkend verbeterpunt betekent dat de eigen beoordeling en de beoordelingen van anderen beide onder het gemiddelde voor deze competentie liggen.",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Erkend verbeterpunt",
                    "SCORING_OVERVIEW_DESCRIPTION": "Hierboven staan de competenties en het gedrag waarop u bent geëvalueerd als onderdeel van een feedbackproces door meerdere beoordelaars. De vergelijkingsbeoordelingen worden per groep gegeven.",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "Minimumhiaat",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Minimaal verschil tussen referentiegroepen voor weer te geven teksten.",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "Hier wordt het bereik van scores per competentie/gedrag weergegeven. De staaf geeft het numerieke gemiddelde aan.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Een niet-erkend sterk punt ontstaat door een verschil tussen de eigen beoordeling en de beoordelingen van anderen.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Niet-erkend sterk punt",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Een niet-erkend verbeterpunt ontstaat door een verschil tussen de eigen beoordeling en de beoordelingen van anderen.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Niet-erkend verbeterpunt",
                    "SELF": "Uzelf",
                    "SELF_ASSESSMENT": "Zelfbeoordeling",
                    "STANDARD_DEVIATION": "Standaardafwijking",
                    "SUM": "Som",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Maak uzelf vertrouwd met de beoordelingsschaal voor een nauwkeurige interpretatie",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "Bekijk de schaal",
                    "THINGS_YOU_WILL_SEE_HEADER": "Dingen die u ziet:",
                    "THREE_SIXTY_PERCENTILE": "Percentiel",
                    "TOP_BOTTOM_BOX": "Bovenvak/ondervak",
                    "TOP_BOX": "Bovenste vak",
                    "TOTAL": "Totaal",
                    "TO_DO": "Takenlijst",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Kwalitatief: deze feedback wordt gegeven in de vorm van opmerkingen met vrije tekst",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Kwantitatief: deze feedback is numeriek en kan worden gepresenteerd in de vorm van grafieken, staafdiagrammen, tabellen, enzovoort.",
                    "TYPES_OF_FEEDBACK_HEADER": "Diverse typen feedback",
                    "VALUE": "Waarde",
                    "VARIANCE": "Variantie",
                    "YOUR_RATINGS": "Uw beoordelingen"
                },
                "REPORT_SUMMARY": "Rapportoverzicht",
                "REPORT_SUMMARY_TABLE_FOOTER": "Vergelijk het aantal mensen dat de beoordeling heeft voltooid met het aantal mensen dat voor deelname is uitgenodigd.",
                "REPORT_SUMMARY_TABLE_HEADER": "Statistieken van respondent",
                "RESET": "Opnieuw instellen",
                "RESPONDENT_TOTALS": "Respondenttotalen",
                "RESPONSES": "Antwoorden",
                "RESPONSE_COUNT": "{{responseCount}} antwoorden",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> antwoorden",
                "RESULT": "Resultaat",
                "REVERSE_COLORS": "Kleuren omkeren",
                "ROW_TOTALS": "Rijtotalen",
                "SAVE": "Opslaan",
                "SAVE_AND_APPLY": "Opslaan en toepassen",
                "SCORING_CATEGORY": "Scorecategorie",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Geen antwoorden voor deze categorie",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Geen antwoorden op deze vraag",
                "SCORING_OVERVIEW": "Scoreoverzicht",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "U en andere beoordelaars beschouwen dit gebied als een sterk punt.",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Erkend sterk punt",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Een erkend verbeterpunt betekent dat de eigen beoordeling en de beoordelingen van anderen beide onder het gemiddelde voor deze competentie liggen.",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Erkend verbeterpunt",
                "SCORING_OVERVIEW_DESCRIPTION": "Hierboven staan de competenties en het gedrag waarop u bent geëvalueerd als onderdeel van een feedbackproces door meerdere beoordelaars. De vergelijkingsbeoordelingen worden per groep gegeven.",
                "SCORING_OVERVIEW_MINIMUM_GAP": "Minimumhiaat",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Minimaal verschil tussen referentiegroepen voor weer te geven teksten.",
                "SCORING_OVERVIEW_TABLE_FOOTER": "Hier wordt het bereik van scores per competentie/gedrag weergegeven. De staaf geeft het numerieke gemiddelde aan.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Een niet-erkend sterk punt ontstaat door een verschil tussen de eigen beoordeling en de beoordelingen van anderen.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Niet-erkend sterk punt",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Een niet-erkend verbeterpunt ontstaat door een verschil tussen de eigen beoordeling en de beoordelingen van anderen.",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Niet-erkend verbeterpunt",
                "SELECT_CATEGORIES": "Selecteer scorecategorieën…",
                "SELECT_CATEGORY": "Selecteer een scorecategorie…",
                "SELECT_CONDITION_TYPE": "Voorwaardetype selecteren",
                "SELECT_DATA_SOURCE": "Gegevensbron selecteren",
                "SELECT_DATA_SOURCE_TYPE": "Type gegevensbron selecteren",
                "SELECT_FILTER": "Filter selecteren",
                "SELECT_FILTERS": "Filters selecteren",
                "SELECT_OPERATOR_TYPE": "Operatortype selecteren",
                "SELECT_PERSON": "Persoon selecteren",
                "SELECT_PERSON_METADATA": "Metagegevens persoon selecteren",
                "SELECT_QUESTION": "Vraag selecteren",
                "SELECT_QUESTIONS": "Selecteer vragen…",
                "SELECT_RATIO_OR_DROPOFF": "Verhouding of verschil selecteren",
                "SELECT_RELATIONSHIP": "Relatie selecteren",
                "SELECT_SCORING_CATEGORY": "Scorecategorie selecteren",
                "SELF": "Uzelf",
                "SELF_ASSESSMENT": "Zelfbeoordeling",
                "SEQUENTIAL": "Sequentieel",
                "SETUP_COMPARISON": "Vergelijking instellen",
                "SETUP_COMPARISONS": "Vergelijkingen instellen",
                "SET_START_COLOR": "Startkleur instellen",
                "SHOULD_SHOW_FOOTER": "Voettekst weergeven",
                "SHOULD_SHOW_SCORING_CATEGORY": "Scorecategorie weergeven",
                "SHOWING_RECORDS_OF": "Records %1 - %2 van %3 weergeven",
                "SHOW_COMPARISON_GAP": "Kolom Hiaat in vergelijking weergeven",
                "SHOW_DATA_LABEL": "Gegevenswaarden weergeven",
                "SHOW_PERCENTAGES": "Percentages weergeven",
                "SHOW_THE_FOLLOWING_TEXT": "En de volgende tekst weergeven",
                "SHOW_TIES": "Gelijke standen weergeven",
                "SHOW_X_AXIS": "X-as weergeven",
                "SHOW_Y_AXIS": "Y-as weergeven",
                "SMALL_LABELS": "Kleine labels",
                "SORT": "Sorteren",
                "SPLINE": "Curve",
                "STACK_CHART": "Stapeldiagram",
                "STANDARD_DEVIATION": "Standaardafwijking",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "Zwak punt minder dan",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "Drempelwaardeteksten bewerken",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "Drempelwaardeteksten",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "Drempelwaardeteksten inschakelen",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "Sterk punt meer dan",
                "SUM": "Som",
                "SUMMARY": "Overzicht",
                "TABLES": "Tabellen",
                "TABLE_TOTALS": "Tabeltotalen",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Maak uzelf vertrouwd met de beoordelingsschaal voor een nauwkeurige interpretatie",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "Bekijk de schaal",
                "TEXT": "Tekst",
                "THINGS_YOU_WILL_SEE_HEADER": "Dingen die u ziet:",
                "TOP_BOTTOM_BOX": "Bovenvak/ondervak",
                "TOP_BOX": "Bovenste vak",
                "TOTAL": "Totaal",
                "TOTAL_COUNTS": "Totaal aantal",
                "TO_DO": "Takenlijst",
                "TRANSPOSE": "Overbrengen",
                "TRANSPOSE_TABLE": "Tabel overbrengen",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Kwalitatief: deze feedback wordt gegeven in de vorm van opmerkingen met vrije tekst",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Kwantitatief: deze feedback is numeriek en kan worden gepresenteerd in de vorm van grafieken, staafdiagrammen, tabellen, enzovoort.",
                "TYPES_OF_FEEDBACK_HEADER": "Diverse typen feedback",
                "UNDO": "Ongedaan maken",
                "USE_COMPARISON": "Vergelijking gebruiken",
                "USE_LABELS_FOR_SCALES": "Labels gebruiken voor schalen",
                "VALUES": "Waarden",
                "VALUE_RANGES": "Waardenbereiken",
                "VARIANCE": "Variantie",
                "VERTICAL": "Verticaal",
                "VERTICAL_RANGE": "Verticaal bereik",
                "WARNING_DATA_OUT_OF_RANGE": "Waarschuwing: gegevenswaarde overschrijdt bereikconfiguratie",
                "WIDGET_ERROR": {
                    "ERROR": "Er is een onverwachte fout opgetreden",
                    "MISCONFIGURED": "Deze widget is niet correct geconfigureerd. Controleer de configuratie van uw widget.",
                    "NEW": "Configureer widget",
                    "NO_DATA": "Geen gegevens gevonden. Het is mogelijk dat uw filters te exclusief zijn!"
                },
                "WIDGET_NAME": {
                    "BAR": "Staafdiagram",
                    "BREAKDOWNBAR": "Uitsplitsingsbalk",
                    "DATA_TABLE": "Gegevenstabel",
                    "FUNNEL_CHART": "Trechterdiagram",
                    "GAUGE": "Meterdiagram",
                    "GRID": "Resultatentabel",
                    "HEATMAP": "Heatmap",
                    "LINE": "Lijndiagram",
                    "NEEDS_BASED": "Naar behoefte",
                    "PIE": "Cirkeldiagram",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "Prijs schatten (Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "Opbrengst maximaliseren (Gabor-Granger)",
                    "SCORING_OVERVIEW_CHART": "Diagram",
                    "SCORING_OVERVIEW_TABLE": "Tabel",
                    "STATS_TABLE": "Statistiekentabel",
                    "WORDCLOUD": "Woordwolk"
                },
                "WORD_ROTATION": "Woorden roteren",
                "WORD_SPACING": "Tussenafstand woorden",
                "YES": "Ja",
                "YOUR_RATINGS": "Uw beoordelingen"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "Toevoegen",
                "ADD_A_WORD": "Een woord toevoegen",
                "COLOR": "Kleur",
                "DELETE_ALL": "Alles verwijderen",
                "EDIT_STOP_WORDS": "Stopwoorden bewerken",
                "MAX_WORDS": "Max. aantal woorden",
                "ROTATION_ANGLED": "In een hoek",
                "ROTATION_HORIZONTAL": "Horizontaal",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "Horizontaal en verticaal",
                "WORD_ORIENTATION": "Tekstrichting"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "Achtergrondkleuren",
                "DISPLAY_OPTIONS": "Weergaveopties",
                "INVERT_FONT_COLORS": "Kleuren lettertype met laag contrast omkeren",
                "PAGE": "Pagina",
                "PAGINATE": "Pagineren"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "Gemiddelde",
                "BOTTOM_BOX_METRIC": "Onderste vak",
                "COLUMNS": "Kolommen",
                "COUNT_METRIC": "Totaal aantal antwoorden",
                "FIELD_NAME": "Veld",
                "MAX_METRIC": "Maximum",
                "MIN_METRIC": "Minimum",
                "SHOW_RECODES": "Hercoderingswaarden weergeven",
                "SHOW_ROW_NUMBERS": "Rijnummers weergeven",
                "STD_DEV_METRIC": "Std afwijking",
                "TOP_BOX_METRIC": "Bovenste vak",
                "TRANSPOSE_BREAKOUTS": "Uitsplitsingen overbrengen",
                "TRANSPOSE_TABLE": "Tabel overbrengen",
                "VAR_METRIC": "Variantie"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "Extra kolommen",
                "ADD_COLUMNS": "Extra kolommen toevoegen",
                "ADD_CUSTOM_PALETTE": "Aangepast palet toevoegen",
                "ALL_CHOICES": "Alle keuzes",
                "ALL_GROUPS": "Alle groepen",
                "ALL_RECODES": "Alle hercoderingen",
                "AUTOMATIC": "Standaard",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "Standaard - Klik om te bewerken",
                "AXIS_VALUES": "Aswaarden",
                "BREAKOUT_BY": "Uitsplitsen op",
                "CANCEL": "Annuleren",
                "CATEGORICAL": "Categorisch",
                "CHOICES": "Keuzes",
                "CHOICE_COUNT": "Aantal keuzes",
                "COLOR_PALETTE": "Kleurenpalet",
                "COLUMN_VALUES": "Kolomwaarden",
                "CONTACT_FIELDS": "Contactvelden",
                "COUNT": "Aantal",
                "CREATE": "Aanmaken",
                "CUSTOM": "Aangepast",
                "CUSTOM_PALETTE": "Aangepast palet",
                "DATA_SOURCE": "Gegevensbron",
                "DAY": "Dag",
                "DAY_OF_WEEK": "Dag van de week",
                "DECIMAL_PRECISION": "Aantal decimalen",
                "DEFAULT": "Standaard",
                "DISABLED": "Uitgeschakeld",
                "DIVERGENT": "Divergerend",
                "EDIT_CUSTOM_PALETTE": "Aangepast palet bewerken",
                "ENABLED": "Ingeschakeld",
                "ERROR_LOADING_DATA": "Fout bij het laden van de gegevens",
                "FILE_SIZE": "Grootte",
                "FILE_TYPE": "Type",
                "FRI": "Vr",
                "FRIDAY": "Vrijdag",
                "GROUP_DATE_BY": "Datum groeperen volgens",
                "HOUR_OF_DAY": "Uur van de dag",
                "LENGEND_VALUES": "Legendawaarden",
                "MAX": "Max.",
                "MEAN": "Gemiddelde",
                "MIN": "Min.",
                "MISCONFIGURED_DATA": "De gegevensbron is onjuist geconfigureerd voor deze visualisatie.",
                "MISCONFIGURED_FILTERS": "Ongeldige filter(s)",
                "MODIFY_CUSTOM_PALETTES": "Aangepaste paletten wijzigen",
                "MON": "Ma",
                "MONDAY": "Maandag",
                "MONTH": "Maand",
                "NONE": "Geen",
                "NO_FILE_ID_ERROR": "Voor deze visualisatie moet een afbeelding in de enquête zijn ingesteld",
                "NO_RESULTS_TO_SHOW": "Er zijn geen resultaten om weer te geven",
                "NPS": "Net Promoter Score®",
                "NPS_GROUP": "NPS®-groep",
                "NUMERIC_VALUE": "Numerieke waarde",
                "PALETTE_REMOVED": "Palet verwijderd",
                "PERCENTAGE": "Procent",
                "PERCENTAGE_OF_CHOICES": "Percentage van keuzes",
                "PERCENTAGE_OF_RESPONSES": "Percentage van antwoorden",
                "QUARTER": "Kwartaal",
                "REMOVE": "Verwijderen",
                "RESPONSE_COUNT": "Aantal antwoorden",
                "RESULTS_PER_PAGE": "Resultaten per pagina",
                "RETRIEVING_DATA_ELLIPSIS": "Gegevens worden opgehaald...",
                "REVERSE_COLORS": "Kleuren omkeren",
                "ROW_VALUES": "Rijwaarden",
                "SAT": "Za",
                "SATURDAY": "Zaterdag",
                "SAVE": "Opslaan",
                "SELECTED_CHOICE": "Geselecteerde keuze",
                "SELECT_FIELD": "Veld selecteren",
                "SELECT_METRIC": "Meeteenheid",
                "SEQUENTIAL": "Sequentieel",
                "SET_START_COLOR": "Startkleur instellen",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "Steekproefgegevens worden weergegeven...",
                "SUM": "Som",
                "SUN": "Zo",
                "SUNDAY": "Zondag",
                "SURVEY_EMBEDDEDDATA": "Ingesloten gegevens",
                "SURVEY_METADATA": "Metagegevens enquête",
                "TEXT_ENTRY": "Tekstinvoer",
                "THURS": "Do",
                "THURSDAY": "Donderdag",
                "TITLE": "Titel",
                "TUES": "Di",
                "TUESDAY": "Dinsdag",
                "UNBOUNDED_DOMAIN": "Te veel waarden om weer te geven.",
                "UNBOUNDED_DOMAIN_HELP": "Als u dit veld aan het Resultatenrapport wilt toevoegen, kunt u een filter toevoegen om minder waarden voor \"{{ed_field_name}}\" weer te geven of u kunt ingesloten gegevensvariabelen \"{{ed_field_name}}\" in uw enquêteflow bijwerken om van dit veld een string of numeriek type te maken.",
                "UNDO": "Ongedaan maken",
                "USE_CHOICE_TOTALS": "Keuzetotalen gebruiken",
                "USE_RESPONDENT_TOTALS": "Respondenttotalen gebruiken",
                "VISUALIZATION": "Visualisatie",
                "VISUALIZATION_BARCHART": "Staafdiagram",
                "VISUALIZATION_BREAKDOWNBAR": "Uitsplitsingsbalk",
                "VISUALIZATION_GAUGE": "Meterdiagram",
                "VISUALIZATION_HEATMAP": "Heatmap",
                "VISUALIZATION_LINECHART": "Lijndiagram",
                "VISUALIZATION_PAGINATEDTABLE": "Gepagineerde tabel",
                "VISUALIZATION_PIE": "Cirkeldiagram",
                "VISUALIZATION_SIMPLETABLE": "Eenvoudige tabel",
                "VISUALIZATION_STATSTABLE": "Statistiekentabel",
                "VISUALIZATION_TEXTHIGHLIGHTS": "Tekstmarkeringen",
                "VISUALIZATION_WORDCLOUD": "Woordwolk",
                "WED": "Wo",
                "WEDNESDAY": "Woensdag",
                "WEEK": "Week",
                "WEIGHTING": "Weging",
                "WRONG_QUESTION_TYPE_ERROR": "Dit type visualisatie kan niet worden gebruikt voor deze vraag",
                "YEAR": "Jaar"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "Gemiddelde",
                "CHOICE_COUNT": "Aantal keuzes",
                "COUNT": "Aantal",
                "DISPLAY_OPTIONS": "Weergaveopties",
                "MAX": "Maximum",
                "MIN": "Minimum",
                "NPS": "NPS®",
                "PAGE_OF": "Pagina: %1 van %2",
                "PERCENT": "Procent",
                "RESPONSE_COUNT": "Aantal antwoorden",
                "ROWS_PER_TABLE": "Rijen per tabel",
                "SHOWING_ROWS_OF": "Rijen %1 - %2 van %3 weergeven",
                "SHOW_PERCENTAGES": "Percentages weergeven",
                "SHOW_RECODES": "Hercoderingswaarden weergeven",
                "SHOW_ROW_NUMBERS": "Rijnummers weergeven",
                "SUM": "Som",
                "TOTAL": "Totaal",
                "TRANSPOSE": "Overbrengen",
                "USE_COLUMN_TOTALS": "Kolomtotalen gebruiken",
                "USE_ROW_TOTALS": "Rijtotalen gebruiken",
                "VALUE": "Waarde"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "Oplopend",
                "COUNT": "Aantal",
                "DESCENDING": "Aflopend",
                "DIAGONAL": "Diagonaal",
                "DISPLAY_OPTIONS": "Weergaveopties",
                "ERROR_COLON": "Fout:",
                "ERROR_GENERIC": "Er is een fout opgetreden bij het laden van de visualisatie.",
                "HORIZONTAL": "Horizontaal",
                "HORIZONTAL_BARS": "Horizontale staven",
                "INCORRECTLY_CONFIGURED": "Selecteer een waarde om het diagram weer te geven",
                "LEGEND_AUTO": "Auto",
                "LEGEND_BOTTOM": "Onderzijde",
                "LEGEND_INSET": "Inzetsel",
                "LEGEND_RIGHT": "Rechts",
                "NORMALIZE_TO_PERCENTAGES": "Normaliseren naar procent",
                "SHOW_BAR_LABELS": "Balklabels weergeven",
                "SHOW_LEGEND": "Legenda weergeven",
                "SHOW_X_AXIS": "X-as weergeven",
                "SHOW_Y_AXIS": "Y-as weergeven",
                "SORT_BAR_VALUES": "Staafwaarden sorteren",
                "STACKED_BARS": "Gestapelde staven",
                "TRANSPOSE": "Overbrengen",
                "TRUNCATE_LABELS": "Labels inkorten",
                "VERTICAL": "Verticaal"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "Alle andere",
                "COULD_NOT_LOAD_DATA": "Het was onmogelijk om de gegevens in de opgegeven configuratie te laden - probeer een ander bronveld of een ruimer datumbereik.",
                "GROUPING_PERCENTAGE_THRESHOLD": "Drempelwaarde groeperingspercentage",
                "NO_DATA": "Geen gegevens",
                "RADIUS": "Binnenstraal",
                "SHOW_AS_PERCENTAGES": "Als percentages weergeven"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "Sluiten",
                "DOWNLOAD_CSV": "CSV downloaden",
                "DOWNLOAD_ZIP": "Alle bestanden downloaden",
                "NO_DATA": "Geen gegevens",
                "PAGE_OF": "Pagina: %1 van %2",
                "RESULTS_PER_PAGE": "Resultaten per pagina",
                "SHOWING_RECORDS_OF": "Records %1 - %2 van %3 weergeven",
                "SINGLE_RESPONSE": "Enkel antwoord",
                "VIEW_RESPONSE": "Antwoord weergeven"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "Weergaveopties",
                "ERROR_COLON": "Fout:",
                "ERROR_GENERIC": "Er is een fout opgetreden bij het laden van de visualisatie.",
                "HORIZONTAL_BARS": "Horizontale staven",
                "INCORRECTLY_CONFIGURED": "Selecteer een waarde om het diagram weer te geven",
                "LEGEND_AUTO": "Auto",
                "LEGEND_BOTTOM": "Onderzijde",
                "LEGEND_INSET": "Inzetsel",
                "LEGEND_RIGHT": "Rechts",
                "NORMALIZE_TO_PERCENTAGES": "Normaliseren naar procent",
                "SHOW_AREA": "Gebied weergeven",
                "SHOW_LEGEND": "Legenda weergeven",
                "SHOW_X_AXIS": "X-as weergeven",
                "SHOW_Y_AXIS": "Y-as weergeven",
                "SMOOTH_LINES": "Vloeiende lijnen",
                "SORT_X_AXIS_LABELS": "Labels X-as sorteren",
                "STACKED_BARS": "Gestapelde staven",
                "TRANSPOSE": "Overbrengen"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "Modus blokkeren",
                "BLUR": "Vervagen",
                "COULD_NOT_LOAD_DATA": "Het was onmogelijk om de gegevens in de opgegeven configuratie te laden - probeer een ander bronveld of een ruimer datumbereik.",
                "FIELD": "Veld",
                "RADIUS": "Straal",
                "SHOW_REGIONS": "Regio's weergeven",
                "SHOW_REGION_LABELS": "Regiolabels weergeven"
            },
            "GAUGEWIDGET": {
                "MAX": "Max.",
                "MIN": "Min.",
                "VALUE_RANGES": "Waardenbereik"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "Labels onderaan",
                "CATEGORY_NAME": "Naam categorie",
                "ERROR_COLON": "Fout:",
                "INCLUDE_HIDDEN_GROUPS": "Verborgen groepen in procent opnemen",
                "LARGE_LABELS": "Grote labels",
                "NO": "Nee",
                "PERCENT": "Procent",
                "RESPONSE_COUNT": "Aantal antwoorden",
                "RESPONSE_COUNT_WITH_VALUE": "{{ responseCount }} antwoorden",
                "SMALL_LABELS": "Kleine labels",
                "YES": "Ja"
            }
        });
        $cache.put('PB', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "⟦용용용 Ά¢çēŝş Ċοďє 歴歴歴⟧",
                "ACCESS_CODE_PROTECTION": "⟦용용용용 Ãċсĕśŝ Ćσďè Ρѓóťéсτϊőή 歴歴歴歴⟧",
                "ADD": "⟦용 Ăďď 歴⟧",
                "ADD_BREAKOUT": "⟦용용용용용 Ãďď Ґēρóѓť Βґέàкόûτ 歴歴歴歴歴⟧",
                "ADD_NOTE": "⟦용용용 Ãďď Νòτĕ 歴歴歴⟧",
                "ADD_SCHEDULED_REPORT": "⟦용용용용용 Αďď Ѕ¢нêďμĺēď Ґєρσŗτ 歴歴歴歴歴⟧",
                "ADD_WIDGET": "⟦용용용용용 Āďď Vїŝūαļϊżâŧĩòή 歴歴歴歴歴⟧",
                "ALL_PROJECTS": "⟦용용용 Äļļ Ρяòĵèçţş 歴歴歴⟧",
                "ALL_QUESTIONS": "⟦용용용용 Qùêŝťїóņ Ρãġέŝ 歴歴歴歴⟧",
                "ANSWER": "⟦용용 Ãňśщēг 歴歴⟧",
                "ANY_CHANGES_LOST": "⟦용용용 Ãŋŷ čĥãηĝεŝ ŧο ŕéρòѓŧş ŵìļľ ьę ļȭѕτ īƒ ŷοŭ ľėâνė ţнė Qµáľţѓîćş ΧΜ Ρļâţƒоѓm. 歴歴歴⟧",
                "APPENDED_COPY_IN_PARENS": "⟦용용 (Čòρў) 歴歴⟧",
                "AREA_CHART": "⟦용용용 Ăгęâ Čнäřţ 歴歴歴⟧",
                "AREA_CHART_DESC": "⟦용용용 Α τщö-άхïŝ ľĩňє сħäŗť ẁιŧн τĥĕ ǻŗéą ųņďéя ţнë ĺīŋé ƒіĺļëď ίŋ. 歴歴歴⟧",
                "ATTACHMENT": "⟦용용용 Àŧŧáćĥmεņŧ 歴歴歴⟧",
                "BACKUP_CURRENT_REPORT": "⟦용용용 Ŝàνę á вáĉķµρ ĉŏρŷ оƒ τĥíŝ ґερôŗτ вĕƒȭяε âƒƒεĉťіŉġ ŧĥé νιśűăĺîźäŧιøπş 歴歴歴⟧",
                "BACKUP_CURRENT_REPORT_LINE2": "⟦용용 Ńőτє: Ţħέ вãскùρ ¢ŏρý ωїļĺ вě ňàmєď \"{{nameOfReportCopy}}\" 歴歴⟧",
                "BACK_TO_REPORTS": "⟦용용용용 Бãĉк ţô Ґęρόѓťş 歴歴歴歴⟧",
                "BACK_TO_TOP": "⟦용용용 ßãĉк ţό Ţôρ 歴歴歴⟧",
                "BACK_TO_VIEW_RESULTS": "⟦용용용용 βą¢ĸ ťō ȭĺď νïëώ ґĕśūļţѕ 歴歴歴歴⟧",
                "BAR_CHART": "⟦용용용 ßäř Çĥăŕť 歴歴歴⟧",
                "BAR_CHART_DESC": "⟦용용용용용 Å ťẃό-âхīś ьąг сħǻґť ŧĥαţ âļĺŏщş ǻďďιţìσņäĺ ĉóŉƒíĝůŗăŧϊοń ŝųсн ǻś áхιş ťřãŋśροşįŧìόň άиď ґέářѓāňĝēmĕπť ȭƒ ďäţá ρóîňťş. 歴歴歴歴歴⟧",
                "BREAKDOWN_BAR_CHART": "⟦용용용 βѓėåĸďőẁπ Бāѓ 歴歴歴⟧",
                "BREAKDOWN_BAR_CHART_DESC": "⟦용용용용용용 Α нõгįżõŉτäľ ŝŧαçκεď вăг čħάґτ mȭŝţ çоmmōπĺŷ цѕеď ƒòѓ ƒøŗ νίѕµάľľУ ώĕїĝнϊŋġ męτŕìĉş åġαιлѕţ ėã¢н öŧнëґ άś ăη áľτëґŋáŧîνë ţő ą ρïė ĉнàґτ. 歴歴歴歴歴歴⟧",
                "CANCEL": "⟦용용 Çãйсęĺ 歴歴⟧",
                "CANCEL_CONF_TEXT": "⟦용용용 Àřе ỳøμ śμгé ŷοū шåйŧ ŧö сãň¢éľ?<br/>Àĺľ ¢ĥåŋġеş щïļļ вε ĺσşť. 歴歴歴⟧",
                "CANCEL_EDITS": "⟦용용용 Ċàπçĕľ Έďϊťŝ 歴歴歴⟧",
                "CHART": "⟦용 Ĉнάґť 歴⟧",
                "CHOICE": "⟦용용 Ċĥőїċε 歴歴⟧",
                "CHOICES_COUNT_METRIC": "⟦용용용 Ċĥõіċěś Ĉȭцņť 歴歴歴⟧",
                "CHOOSE_PAGES_TO_DISPLAY": "⟦용용용용 Ċħŏőŝê Ρãğėś ŧô Ďīśρļăÿ 歴歴歴歴⟧",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "⟦용용용용용용용 Ŧĥĩѕ ŗĕρóŗţ çôπŧāîпś {{maxReportPageCount}} ρāġëŝ, вüτ Ґĕŝüĺťś čâή оиľý ċŏήťαιη üρ τō {{reportSizeLimit}}. Ρĺēǻŝē şёļėçŧ ά şŭьѕεŧ ώįţĥĩп τнĕ ľįmїŧ. 歴歴歴歴歴歴歴⟧",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "⟦용용용용 Яëρоŗťѕ ¢ăп σņľỳ ĉőηţåĩл цρ ŧó {{reportSizeLimit}} ρąğёś, ρľęáśê şęļêсţ ŧнè ρąġеѕ ўŏű ŵõµĺď ļϊķě. 歴歴歴歴⟧",
                "CLEAR_ALL": "⟦용용용 Çľεåř Āľľ 歴歴歴⟧",
                "CLOSE": "⟦용 Ĉľøѕĕ 歴⟧",
                "CLOUD": "⟦용용용용 Â ĎΕŜĈЯĪΡŤΊΘΝ ₣ǾЃ ČĽŌŬÐ 歴歴歴歴⟧",
                "COLLABORATED_NEW": "⟦용용용용용 Ťħė øẁņēя ōƒ ţĥιş śüŕνěỳ ίѕ μŝíŉĝ τĥє Qůàĺτŗϊçś χМ Ρļáŧƒοřm! Řėρогťş ƒóя ţĥιŝ ŝµřνεў шîļļ ьέ éďіŧėď ųśίņğ Ŋεώ Ŕέşųĺτś. 歴歴歴歴歴⟧",
                "COMMA_SEPARATED_LIST": "⟦용용용용용 Ċōmmå Śερåřāťèď Ļįŝť 歴歴歴歴歴⟧",
                "COMPACTNESS": "⟦용용용용용 ₣ȭπţѕ ąŋď Śρāčĭŉĝ 歴歴歴歴歴⟧",
                "COMPACTNESS_INFO": "⟦용용용용용 Ťħĭѕ śèťτίņĝ àƒƒéčŧŝ ŧáьĺę ρâďďīйğ, ƒопţ śĩźė, âŋď ьáг ŝïżέ ιŉ ¢ħǻŗťŝ. Íţ щīļĺ âľśò ьё åρρľĩĕď ŧо möŝţ έхρσřţş. 歴歴歴歴歴⟧",
                "CONFIRM": "⟦용 Οĸ 歴⟧",
                "CONFIRM_DELETE": "⟦용용용용 Čοиƒίґm Ðėľêţίòи 歴歴歴歴⟧",
                "CONFIRM_DELETE_PAGE": "⟦용용용용 Ăřę ÿòμ ŝùяě ýòц ẁâŉŧ ţȭ ďęļέŧє ťнīŝ ρăĝė? 歴歴歴歴⟧",
                "CONTINUE": "⟦용용용 Ĉȭņţϊήúĕ 歴歴歴⟧",
                "CONTINUE_EDITING": "⟦용용용용 Čóŋťîиũё Έďįŧìлġ 歴歴歴歴⟧",
                "COPY": "⟦용 Çορý 歴⟧",
                "COPY_OF_REPORT_NAME": "⟦용용용 Çöρŷ όƒ {{nameOfCurrentReport}} 歴歴歴⟧",
                "COPY_REPORT": "⟦용용용 Čõρÿ Γéρŏřτ 歴歴歴⟧",
                "COPY_REPORT_ELLIPSIS": "⟦용용용용 Ċóρý Ґеρояţ... 歴歴歴歴⟧",
                "COPY_TO_NEW_REPORT": "⟦용용용용 Çõρў ţо Ńéш Řéρȭґť... 歴歴歴歴⟧",
                "CREATE": "⟦용용 Ċяěäŧé 歴歴⟧",
                "CREATED": "⟦용용 Çřèåţėď 歴歴⟧",
                "CREATE_CUSTOM_PAGE": "⟦용용용용용 Ĉŕєαťè Çųśťσm Ράĝέ 歴歴歴歴歴⟧",
                "CREATE_NEW_REPORT": "⟦용용용용용 Ĉŕёαţĕ Ŋèш Řėρôŗŧ 歴歴歴歴歴⟧",
                "CREATE_NEW_REPORT_ELLIPSIS": "⟦용용용용용 Čґėąŧë Йëẁ Ѓěρòřŧ... 歴歴歴歴歴⟧",
                "CSV_FILE": "⟦용용용 ČŞV ₣ïĺė 歴歴歴⟧",
                "CUSTOM_PAGES": "⟦용용용 Ĉûѕţȭm Ρāĝěѕ 歴歴歴⟧",
                "DATE": "⟦용 Ďäŧë 歴⟧",
                "DEFAULT_PALETTE": "⟦용용용용 Ďëƒáũļŧ Ĉŏľŏŕ Ραĺęţţė 歴歴歴歴⟧",
                "DEFAULT_REPORT": "⟦용용용용 Ďëƒáũļť Ґέρôяţ 歴歴歴歴⟧",
                "DEFAULT_VISUALIZATIONS": "⟦용용용용 Ðєƒâúĺτ Vїŝûãľìżãţίŏńŝ 歴歴歴歴⟧",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "⟦용용용용용용용용용용용용 Ţĥêŝè äŗέ ťĥê ďèƒάûļţ νĭŝųǻļїźăţîöй ťУρěŝ ûѕěď ŧø сοлŝťґûčţ ďéƒáúļτ яèşűļťŝ ŗėρȭгτś. Ũρďąŧιпğ άлď ăρρľýīňĝ ŧнёşé ŝεţŧιйġş щîľļ яêвūįľď ўȭûŕ сμŕŗěйţ ŗēρоřτ ŵίŧн τĥé ήéŵ ďęƒǻũľť śêţťìŉğѕ. Ýőů щìĺļ нàνé ťнё ορťίσπ ţõ вάçк ųρ ўøùř čűřгéňţ ѓéρõřť. 歴歴歴歴歴歴歴歴歴歴歴歴⟧",
                "DEFAULT_VISUALIZATIONS_NOTE": "⟦용용용용용용 Ņöţè: Ńόŧ еνεяγ νįśùāľįżάťіōи τγρē іś åνάĩĺǻьĺę ƒöг äļļ qûεѕŧϊόŉ ťỳρëś. Ѕømę ņόň-ďеƒàμļť νιѕűάļíżàţïŏпŝ máŷ āüťômǻŧїċąľľŷ вέ ѕųвşťїŧũτĕď. 歴歴歴歴歴歴⟧",
                "DEFAULT_VISUALS_DISCLAIMER": "⟦용용용 Qūáĺτґіĉѕ щīļĺ ũρďąŧė ťħîѕ ґēρöŗţ шίťħ ťħê йєŵ ďēƒåüĺτ νίѕůαľіżäτįσπ ѕёţŧіņğş. 歴歴歴⟧",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "⟦용용용용 Ŧħїѕ ůρďáτε ẃϊľĺ äƒƒēсŧ {{amountOfWidgetsAffected}} νīśűąļіżăţĭòлś ĭи ţħįş řёροŗţ. 歴歴歴歴⟧",
                "DEFAULT_VISUAL_EDIT_DETECTED": "⟦용용용 Ďěƒâüĺŧ Vίşŭâľĭźάťìŏл Ęďîŧ Ďèτēсţéď 歴歴歴⟧",
                "DELETE_BUTTON": "⟦용용 Ðєļèťé 歴歴⟧",
                "DELETE_DISABLED_EXPLANATION": "⟦용용용용용용용 Ðĕļėţíήġ řèρõґţś ¢ѓёąŧęď îп ţнë ρѓëνιŏųѕ ŕєρòŕţїńĝ îлţēѓƒäčĕ īѕ ňöŧ ãļĺŏωêď цŋŧìļ γòųř øřğãлìźατíŏи нáś ρěŗƒȭřmеď ă ƒùĺĺ mιġяàťίσŋ ţō ťнé Qµāľτŕīçŝ ΧМ Ρĺαťƒòґm. 歴歴歴歴歴歴歴⟧",
                "DELETE_PAGE": "⟦용용용 Ďėĺέτε Ράğè 歴歴歴⟧",
                "DELETE_PAGE_ELLIPSIS": "⟦용용용용 Ďεļĕŧę Ρąġε... 歴歴歴歴⟧",
                "DELETE_REPORT": "⟦용용용 Ďєĺèτέ Ѓéρöŕτ 歴歴歴⟧",
                "DELETE_REPORT_ELLIPSIS": "⟦용용용용 Ðεĺėţĕ Γêρόŗŧ... 歴歴歴歴⟧",
                "DELETE_WIDGET_QUESTION": "⟦용용 Ðëļęτë? 歴歴⟧",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "⟦용용 Ŧħιѕ ƒĩĕļď їş ëлćѓŷρţěď āήď čąņŉоť ьè ũŝєď ƒȭг śôґŧïňğ. 歴歴⟧",
                "DISCARD_EDITS": "⟦용용용 Ďіŝçάѓď Ėďįτş 歴歴歴⟧",
                "DISTRIBUTION_PAUSED": "⟦용용용용용 Řéρόřţ ďіśţŕìьúτįóŋ ρǻũśėď. 歴歴歴歴歴⟧",
                "DONE_BUTTON": "⟦용 Ðолě 歴⟧",
                "DONE_EDITING": "⟦용용용 Ďőйέ Εďίŧіŋğ 歴歴歴⟧",
                "DOWNLOAD": "⟦용용용 Ðōωńĺσăď 歴歴歴⟧",
                "DOWNLOAD_AS_CSV": "⟦용용용용 Ďοẁлļȭăď ąş ČЅV 歴歴歴歴⟧",
                "DOWNLOAD_AS_PDF": "⟦용용용용 Ďôωηĺòåď āѕ ΡĎ₣ 歴歴歴歴⟧",
                "DOWNLOAD_FAILED": "⟦용용용용 Ďőωиĺõáď ƒαίĺěď 歴歴歴歴⟧",
                "DOWNLOAD_PREVIOUS_EXPORTS": "⟦용용용용용 Ďōщлļòάď Ρŗèνîоüś Êхρóґţş... 歴歴歴歴歴⟧",
                "DO_YOU_WISH_TO_DELETE": "⟦용용용용 Ðö ỳõū щíśĥ ţò ďéĺėťё: 歴歴歴歴⟧",
                "DUPLICATE_PAGE": "⟦용용용용 Ðűρļîčáťė Ŝнęĕτ 歴歴歴歴⟧",
                "EDIT_REPORT": "⟦용용용 Ĕďĩť Яêρóѓţ 歴歴歴⟧",
                "EDIT_REPORT_ELLIPSIS": "⟦용용용용 Ëďіτ Яèρőřτ... 歴歴歴歴⟧",
                "EDIT_VISUALIZATION": "⟦용용용용용 Ėďĭτ Vìѕúάļίżāŧîŏπ 歴歴歴歴歴⟧",
                "EMAIL_ADDRESS": "⟦용용용 Ĕmàĭĺ Āďďяёŝŝ 歴歴歴⟧",
                "EMAIL_SENT": "⟦용용용 Èmáįļ şěηţ... 歴歴歴⟧",
                "END_OF_REPORT": "⟦용용용 Êиď οƒ Řêρōŗţ 歴歴歴⟧",
                "ENTER_NAME": "⟦용용용 Ëŉťēѓ Иǻmé 歴歴歴⟧",
                "ERROR_COPYING": "⟦용용용 Ŧĥєяę шâѕ άл ёŗѓòг ¢òργϊņĝ ťħє яєρσґŧ. 歴歴歴⟧",
                "ERROR_DELETING": "⟦용용용 Ţнěŕē щäѕ ăŋ ėгґοґ ďεľеτίпġ ŧне ґєρōґŧ. 歴歴歴⟧",
                "ERROR_DELETING_EXPORT": "⟦용용용 Τĥєґê шąŝ áŋ έŗŕοг ďëľéτϊŋĝ τĥé ё×ρσŕτ. 歴歴歴⟧",
                "ERROR_HEADING": "⟦용 Σŕѓòŗ 歴⟧",
                "ERROR_PUBLISHING": "⟦용용용 Τнęŗε ŵãѕ äй єґŕóг ŝāνιηĝ ŧħê śęŧţιпğş. 歴歴歴⟧",
                "ERROR_RENAMING": "⟦용용용 Τнëŕє ẃäş αп èгяòя ґéŋǻmīńġ τħе řêρőгť. 歴歴歴⟧",
                "ERROR_REQUESTING_EXPORT": "⟦용용용용 Ťħéяê шäѕ ǻņ εгѓóг ŕęqūĕśŧīŉĝ τнè ēхρόŗť. 歴歴歴歴⟧",
                "ERROR_SAVING_GLOBAL_OPTIONS": "⟦용용 Τĥēřē ωāŝ āń ĕяґόŕ śäνіňġ ĝľőвάĺ νίśцαļìźåťĩőń őρτĩøлѕ. 歴歴⟧",
                "ERROR_SEND_TEST_EMAIL": "⟦용용용용 Ťħėŕė шαŝ αń éґґοŗ ŝεńďίŉĝ ţħě ŧέŝŧ ёmãіĺ. 歴歴歴歴⟧",
                "EVERY_FRIDAY": "⟦용용용 Ěνёŗŷ ₣ѓїďąў 歴歴歴⟧",
                "EVERY_MONDAY": "⟦용용용 Ёνėŗý Μöņďäý 歴歴歴⟧",
                "EVERY_MONTH": "⟦용용용 Μŏńŧħĺγ òή 歴歴歴⟧",
                "EVERY_SATURDAY": "⟦용용용용 ĖνęгУ Śąτũřďáÿ 歴歴歴歴⟧",
                "EVERY_SUNDAY": "⟦용용용 Ĕνèřỳ ŚμņďâУ 歴歴歴⟧",
                "EVERY_THURSDAY": "⟦용용용용 Ėνéяý ΤĥûřŝďàУ 歴歴歴歴⟧",
                "EVERY_TUESDAY": "⟦용용용 Ένéѓŷ Τūêŝďāý 歴歴歴⟧",
                "EVERY_WEDNESDAY": "⟦용용용용 Ένėŕŷ Ŵéďŉĕŝďάў 歴歴歴歴⟧",
                "EVERY_WEEK": "⟦용용용 ШêěκļУ éνĕґУ 歴歴歴⟧",
                "EXAMPLE_GROUP_NUM": "⟦용용용 Ġяøüρ {{num}} 歴歴歴⟧",
                "EXAMPLE_SERIES_NUM": "⟦용용용용 Şèґĭєş {{num}} 歴歴歴歴⟧",
                "EXPORT": "⟦용용 Ęхρòѓť 歴歴⟧",
                "EXPORT_CSV": "⟦용용용용 ĆЅV (Ċοmmä Şēρăŕåťěď) 歴歴歴歴⟧",
                "EXPORT_EXCEL_SPREADSHEET": "⟦용용용용용 Ε×ćéľ Ѕρґёāďŝħêèŧ 歴歴歴歴歴⟧",
                "EXPORT_IMAGE": "⟦용용용 Ėхρȭґτ Ímáġě 歴歴歴⟧",
                "EXPORT_PAGES": "⟦용용용 Ĕ×ρȭřŧ Ρąğєş 歴歴歴⟧",
                "EXPORT_PDF": "⟦용용용 ΡÐ₣ Ďôćцmĕňŧ 歴歴歴⟧",
                "EXPORT_PPT_SLIDES": "⟦용용용용용 ΡόẁёгΡôιлť Ѕĺĭďēś 歴歴歴歴歴⟧",
                "EXPORT_RAW_DATA": "⟦용용용용 Ę×ροґτ Ѓåŵ Ďàţǻ 歴歴歴歴⟧",
                "EXPORT_REPORT": "⟦용용용 É×ρóѓτ Яēρσŕŧ 歴歴歴⟧",
                "EXPORT_VISUALIZATION": "⟦용용용용용 Èхρоѓŧ Vїŝůåĺϊżαţίоŋ 歴歴歴歴歴⟧",
                "EXPORT_WORD_DOC": "⟦용용용 Щōřď Ðöĉμmèлŧ 歴歴歴⟧",
                "FAILED_SAVE_TXT": "⟦용용용용 ₣äíľёď το ѕàνë 歴歴歴歴⟧",
                "FILTERED": "⟦용용용 ₣іľťеŗéď 歴歴歴⟧",
                "FIRST_PAGE": "⟦용용용 ₣īŕѕŧ Ρǻğέ 歴歴歴⟧",
                "FIRST_WEEKDAY": "⟦용용용용 ₣ïŗśŧ Ŵêěĸďåў ȭƒ Μοήŧĥ 歴歴歴歴⟧",
                "FROM": "⟦용 ₣гöm 歴⟧",
                "FROM_EMAIL": "⟦용용용 ₣гοm Ėmăιļ 歴歴歴⟧",
                "FROM_NAME": "⟦용용용 ₣ґоm Йåmε 歴歴歴⟧",
                "GAUGE_CHART": "⟦용용용 Ğάüğё Čĥαґτ 歴歴歴⟧",
                "GAUGE_CHART_DESC": "⟦용용용용용 Â čħãŗŧ ŗёşèmьļίήğ ā ĝąцğε mëāѕµяěmеŉŧ ţőοľ ƒŏŕ ćómρãѓіňĝ çũŕгëлţ ναļűěŝ ťȭ á ġоαĺ őя śēŗĭëś ȭƒ τħřéŝħσľďş. 歴歴歴歴歴⟧",
                "GENERATING_FILE": "⟦용용용용용 Ĝєŉēгäťīлġ ƒïľε... 歴歴歴歴歴⟧",
                "GENERATING_IMAGE": "⟦용용용용용 Ğěńёŗǻţĭηĝ Ίmαġě... 歴歴歴歴歴⟧",
                "GENERATING_PDF": "⟦용용용용용 Ĝέńęŗάτīňĝ ΡĎ₣... 歴歴歴歴歴⟧",
                "GENERIC_ERROR": "⟦용용용 Âņ еŗŗõя ρŗєνęŋτēď ŭś ƒŗòm ļøāďïήĝ ŧĥé ρŕŏĵё¢ŧ ўŏц ŗεqűĕśťėď. 歴歴歴⟧",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "⟦용용용용용 Ğĺовāľ Őρţïŏлş... 歴歴歴歴歴⟧",
                "GLOBAL_METRIC": "⟦용용용용 Ďεƒäūľţ Μёťѓíç 歴歴歴歴⟧",
                "GLOBAL_MODAL_PAGE_TITLE": "⟦용용용용용 Ëхąmρļĕ νíşůáļíżåťιõň üśϊńğ τĥē ğļőьąļ õρŧĭопś ƒȭŕ ŧħè Ŕєśūļţś ѕєċťīοŉ øƒ ţнė Qűãľŧѓίċѕ Ѓєѕĕάяçħ Ŝûϊťê 歴歴歴歴歴⟧",
                "GLOBAL_MODAL_WIDGET_TITLE": "⟦용용용용용 Víŝŭąļιżąťĩóй Ţīτļé 歴歴歴歴歴⟧",
                "GLOBAL_OPTIONS": "⟦용용용용 Ġļòвàĺ Ορťϊōńŝ 歴歴歴歴⟧",
                "GLOBAL_PRECISION": "⟦용용용용 Ðεƒãµļţ Ðεčįmäļ Ρĺâčęś 歴歴歴歴⟧",
                "GLOBAL_SETTINGS_APPLY": "⟦용용용용 ÁρρĺУ mў ďēƒάùļť śеťťіŉğŝ 歴歴歴歴⟧",
                "GLOBAL_SETTINGS_SAVE": "⟦용용용용용 Śãνè åŝ mУ ďéƒàμļť ѕετŧιŉġѕ 歴歴歴歴歴⟧",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "⟦용용용용 Ąρρļÿ Qũàļτѓîċś ďěƒǻūĺτ 歴歴歴歴⟧",
                "GROUP": "⟦용 Ĝѓȭũρ 歴⟧",
                "HEAT_MAP_CHART": "⟦용용용용 Ήėąť Μαρ Čħăřτ 歴歴歴歴⟧",
                "HEAT_MAP_CHART_DESC": "⟦용용용용용용 Ą čľűѕτεŗёď “ħëάŧ” śτγļě νιśũàĺϊźåŧĭȭй ūŝęď ƒŏя màρρîпġ ďìşţŗίвµτîøň σƒ µѕеѓ ĩņρūŧ (ŝüсĥ ãŝ ċļіċĸś) ťŏ ŧĥέ огįĝĭπãĺ ïmαġę. 歴歴歴歴歴歴⟧",
                "HIDDEN": "⟦용용 Ηíďďëŉ 歴歴⟧",
                "HIDDEN_PAGE": "⟦용용용용 Ŧнįś ρǻġê ẃîľĺ ŉоτ âρρėâг ϊń ρũвļĩĉ гëρσгťś ąиď ωĩľĺ ьê ďėşеļêĉŧèď вỳ ďęƒáūľť іň гεροŕŧ ë×ρόŕŧѕ. 歴歴歴歴⟧",
                "HIDE": "⟦용 Ήїďέ 歴⟧",
                "HIDE_ALL_PAGES": "⟦용용용용 Ħϊďέ Αĺļ Ρàġèś 歴歴歴歴⟧",
                "HIDE_PAGE": "⟦용용용 Ĥīďё Ρāĝё 歴歴歴⟧",
                "IMAGE_FILE": "⟦용용용 Ìmåğę ₣íļє 歴歴歴⟧",
                "INVALID_BRAND_DOMAIN": "⟦용용용용용용 Τне ďоmάίл Уòü ĥâνė ēņţёґεď ϊş йȭŧ ίņ ÿøüг вяāлď'ŝ ĺĩşŧ óƒ äρρřöνěď êmáíĺ ďõmäíņŝ. Ρľέäşε çоŋτåĉť Уôúŗ ьŕαпď άďmĭņ ţõ ƒįх. 歴歴歴歴歴歴⟧",
                "INVALID_SPF_RECORD": "⟦용용용용용용용용 Ťĥě ďőmäïл γōμ ħάνе епťéŕεď ħåŝ πőť áρρґöνęď Qūąľţѓïсѕ ťő ŝєŉď ƒґσm їť. Ţħιѕ ωįľľ āƒƒĕĉτ ďеľïνěгǻьιľïťУ. Ρľėāşё µŝé āήõţĥёѓ ďōmäĩй σг ĉőŉŧάćţ Qüāĺŧгîċŝ αьøцτ ѓéѕőļνíлğ ťнїŝ ĩŝѕũє. 歴歴歴歴歴歴歴歴⟧",
                "ISSUE_SAVING_REPORTS": "⟦용용용 Óиε öř mòґė гěρõŕťş єлčȭúήţêřėď ά ρŕõьľέm ŝâνîňğ. Ρľèαśє ťŕУ äġáїй. 歴歴歴⟧",
                "ISSUE_SENDING_TEST": "⟦용용 Ŧнëѓę ώâѕ āл ëґяóŗ śĕņďїņğ ά ŧéşţ ęmàĭļ. Ρľεǻśè ţґУ âġâīή. 歴歴⟧",
                "LARGE_SURVEY": "⟦용용용 Яεśûļŧѕ ẁíļĺ ηȭŧ ве ďíѕρľäŷėď ьεċãůѕę τĥє ѕüѓνέУ їş ťőô ľąгġè. 歴歴歴⟧",
                "LAST_DAY": "⟦용용용용용 Ĺáѕť Ďàý ŏƒ Мŏйťħ 歴歴歴歴歴⟧",
                "LAST_MODIFIED_COLON_WITH_DATE": "⟦용용용용용 Ŀâśτ Μοďïƒïεď: %1 歴歴歴歴歴⟧",
                "LAST_PAGE": "⟦용용용 Ĺάśτ Ρàğě 歴歴歴⟧",
                "LAST_WEEKDAY": "⟦용용용용 Ļåѕτ Ẃëекďáŷ õƒ Μσήτн 歴歴歴歴⟧",
                "LATER": "⟦용 Ľäτεř 歴⟧",
                "LEARN_MORE": "⟦용용용 Ľĕąяй Мöŕę 歴歴歴⟧",
                "LINE_CHART": "⟦용용용 Ľîŋè Ĉнãяţ 歴歴歴⟧",
                "LINE_CHART_DESC": "⟦용용용 Α τŵσ-å×ίś ĺїпε ćнǻŕť ¢ômmόήļУ ùѕéď шĥёŋ ğѓâρħіηĝ ąĝâιпşţ ťїmε òή ţнε ×-âхϊŝ. 歴歴歴⟧",
                "LOG_OUT_WARNING": "⟦용용용 Čľιčĸ âňýώħёřë ωįŧħĭń {{countdown}} ѕěċŏиďş ţȭ ŕĕmāíй ļσĝğëď ĩл 歴歴歴⟧",
                "MESSAGE": "⟦용용 Мεѕśǻĝє 歴歴⟧",
                "MONTHLY": "⟦용용 Мõŉŧĥĺγ 歴歴⟧",
                "MOVE_DOWN": "⟦용용용용 Μóνє Vįşűáĺїźáťιōń Ðоẃη 歴歴歴歴⟧",
                "MOVE_PAGE_TO_BOTTOM": "⟦용용용용 Моνë ŧό βôťτоm 歴歴歴歴⟧",
                "MOVE_PAGE_TO_TOP": "⟦용용용 Μöνé ţο Τȭρ 歴歴歴⟧",
                "MOVE_UP": "⟦용용용용 Μóνè Vĭśŭáľįźάťíöη Úρ 歴歴歴歴⟧",
                "MY_SURVEYS": "⟦용용용 ΜУ Ρřõĵёĉťѕ 歴歴歴⟧",
                "NAME": "⟦용 Ņámĕ 歴⟧",
                "NEW_CUSTOM_PAGE_NAME": "⟦용용용용 Ņěщ Ćùŝťöm Ρąğē 歴歴歴歴⟧",
                "NEW_REPORT": "⟦용용용 Ńєω Ґèρȭŗţ 歴歴歴⟧",
                "NEXT_PAGE": "⟦용용용 Йέхţ Ρâĝе 歴歴歴⟧",
                "NEXT_RUN": "⟦용용용 Ńē×ŧ Γũń 歴歴歴⟧",
                "NO_EXPORTS": "⟦용용 Ŋō ехρōřŧѕ нąνε вĕеń řεqūёśţēď ƒöґ ťħįş řеρȭŕť ŷėţ. 歴歴⟧",
                "NO_ITEMS_TO_DISPLAY": "⟦용용용용용 Ńō ìţèmś τσ ďïśρľàУ 歴歴歴歴歴⟧",
                "NO_MATCHING_CUSTOM_PAGES": "⟦용용용용 Иō măť¢нιйĝ сųşťõm ρáġèŝ 歴歴歴歴⟧",
                "NO_MATCHING_PAGES": "⟦용용용용 Ņȭ ρãĝєŝ ƒōűпď ƒøř ѕêǻѓċн 歴歴歴歴⟧",
                "NO_MATCHING_REPORTS": "⟦용용용용용 Ŋό mάťčħîпĝ ŗéρöŗτś. 歴歴歴歴歴⟧",
                "NO_PROJECT": "⟦용용용 Ρĺěáśё şρëçίƒỳ à ρŕŏĵёсτ ťό сопτïлůę. 歴歴歴⟧",
                "NO_PROJECTS_TO_MIGRATE": "⟦용용용 Ţħęґε άřе ńõ ρřоĵěĉťş ŧŏ ųρďåτê. 歴歴歴⟧",
                "NO_QUESTIONS": "⟦용용용용 Ńо mαţĉнīпğ qũëŝŧìōηѕ 歴歴歴歴⟧",
                "NO_RESULTS_YET": "⟦용용용용 Ţнéŗë ãяĕ ňō ŗеśùľŧŝ ўετ ţό ŝнοẁ. Ρĺèàѕè ďìŝŧґĭвųťе ỳôцг şūґνêŷ ţô ĝāŧĥέѓ řέŝροηşеş. 歴歴歴歴⟧",
                "OFF": "⟦용 Ôƒƒ 歴⟧",
                "ON": "⟦용 Οи 歴⟧",
                "PAGES_SELECTED": "⟦용용용용 Ρąğěŝ Şёĺèĉŧеď 歴歴歴歴⟧",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "⟦용용용용용용용용 Ţħіѕ şëĺєċţĩöη ẁоцľď mäĸę ŧĥë ŗěρöŗţ çöηţάìņ {{currentSelectedPageCount}} ρǻğêş, щħįćĥ įş åвσνê τĥё {{reportSizeLimit}} mà×îmûm ăĺĺöẃεď. Ρĺеąśé ѕêļëćτ α ѕmáľļêŗ řąńğέ. 歴歴歴歴歴歴歴歴⟧",
                "PAGES_SELECTION_INVALID_RANGE": "⟦용용용용용 Ρľèàѕë ѕεļεсŧ ά νāľìď ŕàŋġê. 歴歴歴歴歴⟧",
                "PAGE_OPTIONS": "⟦용용용 Ρáġέ Óρťĩóήş 歴歴歴⟧",
                "PDF_ROW_TRUNCATION_MESSAGE": "⟦용용 Ţőο mäήỳ ґοωś ƒøř ΡĎ₣ ēхρогť, τѓÿ ë×ροŗτįņġ ŧò Ẁоѓď όя ĆЅV 歴歴⟧",
                "PERCENTAGE_METRIC": "⟦용용용 Ρèгсēŋτâğε 歴歴歴⟧",
                "PIE_CHART": "⟦용용용 Ρĭε Ćħάřŧ 歴歴歴⟧",
                "PIE_CHART_DESC": "⟦용용용용용 Ą ¢íř¢ũļąŗ вгėäкďöẁη оƒ νâľůεş ƒöѓ á ġįνęи ďάţã ρόįņţ. Џѕєƒūļ ƒóŕ mèάśūяϊņġ ŗęľâťινĕ ρяòρőгτιȭпś ŏƒ śёĺєĉτéď νâĺůėś. 歴歴歴歴歴⟧",
                "PREVIEW": "⟦용용 Ρŕĕνíêш 歴歴⟧",
                "PREVIOUS_PAGE": "⟦용용용 Ρŗęνїőµŝ Ρäġё 歴歴歴⟧",
                "PRINT_PAGE": "⟦용용용 Ρŗĭŉţ Ρǻĝє 歴歴歴⟧",
                "PUBLIC_LINK": "⟦용용용 Ρμвľĭč Ľīηĸ 歴歴歴⟧",
                "PUBLIC_REPORT_AVAILABLE": "⟦용용용용 Ρµвľĭč Γĕρõѓť Ανâϊļåьĺě 歴歴歴歴⟧",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "⟦용용용 Ά¢çēŝş Ċοďє 歴歴歴⟧",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "⟦용용용 Ϊπсôяѓêčţ Áсčêşś Ćòďê. Ρļêǻşė ťгў âĝãіή. 歴歴歴⟧",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "⟦용용 Ŝųьmįţ 歴歴⟧",
                "PUBLIC_RESULTS_LOGIN_TITLE": "⟦용용용용 Ρüвļіĉ Ŕερòґŧ Ļοġíń | Qùāľţяĩ¢ѕ Ŝŭŕνēў Ŝôƒŧŵάŕę 歴歴歴歴⟧",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "⟦용용용용 Ρűвļι¢ ѓęρõŗť иоŧ ƒöμлď. Ρľěăŝë çόйτάċţ τĥè øωňĕг øƒ ţнíѕ řέρøŗť ąпď âşĸ ťнèm ƒοř ά νåļïď ľìňк. 歴歴歴歴⟧",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "⟦용용용용 Ρûьĺίć Ŗéρöřţ Ňŏţ ₣òцлď 歴歴歴歴⟧",
                "PUBLIC_RESULTS_NOT_UPDATED": "⟦용용용용용 Ρůьĺϊç яêρоґτ ľίńкѕ ǻйď şçħёďűľêď гëρόřŧ émäϊĺş ẁίĺľ иσŧ űŝё ţне Qµãľţѓī¢ŝ χМ Ρĺäţƒőгm ûпťίĺ Уόü ũρďąţё τħěm. 歴歴歴歴歴⟧",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "⟦용용용용 Ŝєşѕĩőл Èхρíŗēď. Ρľєãѕė ľóġ їй åġăĭл ŧο ċòņτîπüę ρґеνіёщìŋġ Ρúьļìć Ѓèśůľťś Ѓéροŕŧ. 歴歴歴歴⟧",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "⟦용용용용 Şėŝѕîŏй Éхρĭřéď 歴歴歴歴⟧",
                "PUBLIC_RESULTS_TITLE": "⟦용용용 Ρцьĺî¢ Ŗёρσяτ 歴歴歴⟧",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "⟦용용용용용 Ýσµ ãґе ŉóť ãŭťħσŗìźёď ťø νιêŵ ťĥïş ρąğє. Ρľêãşē çōŋτąćţ ŧнé ȭώйėя øƒ τĥíŝ гéροŕţ āлď åѕĸ ŧħĕm ŧο mãĸè ïţ ρũьļĭĉ. 歴歴歴歴歴⟧",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "⟦용용용용용 Ρŭвĺϊс Яĕρóŕť Џŋάųτнōяїżēď 歴歴歴歴歴⟧",
                "PUBLISHED_LINK_GENERATING_LINK": "⟦용용용용용 Ġëηėřατĭиġ Ľįņķ... 歴歴歴歴歴⟧",
                "PUBLISHED_REPORT_FOUND_HERE": "⟦용용용용 Ãŉўŏйĕ ĉâи νĩέŵ ţнïŝ ŗеρȭѓť άť ţħĕ ƒσľļôшіňĝ ļíņк: 歴歴歴歴⟧",
                "PUBLISH_REPORT": "⟦용용용용용 Μåηàĝё Ρùьļï¢ Ŗеρоŕτ 歴歴歴歴歴⟧",
                "PUBLISH_REPORT_ELLIPSIS": "⟦용용용용 Мάŉàĝë Ρųвļіč Ѓερòґť... 歴歴歴歴⟧",
                "QUESTION": "⟦용용용 Qμèśţîσŋ 歴歴歴⟧",
                "RANK": "⟦용 Γǻήķ 歴⟧",
                "REMOVE_WIDGET": "⟦용용용용용 Řêmõνе Vĭѕµăľīźăτĭоή 歴歴歴歴歴⟧",
                "RENAME_PAGE": "⟦용용용 Ŗęŋámе Ρâġё 歴歴歴⟧",
                "RENAME_REPORT": "⟦용용용 Ŗεņámє Ґěρøгŧ 歴歴歴⟧",
                "RENAME_REPORT_ELLIPSIS": "⟦용용용용 Řёлàmę Ŕęρőřţ... 歴歴歴歴⟧",
                "REPLY_TO_EMAIL": "⟦용용용용 Яеρĺỳ-Ţȭ Еmάíľ 歴歴歴歴⟧",
                "REPORT_COLON": "⟦용용 Řèρøřţ: 歴歴⟧",
                "REPORT_SETTINGS": "⟦용용용용 Ŗερöŗť Śĕŧŧïйğş 歴歴歴歴⟧",
                "REPORT_SETTINGS_ELLIPSIS": "⟦용용용용용 Ŕėρôѓτ Ŝēτťϊņĝŝ... 歴歴歴歴歴⟧",
                "RESPONSE_COUNTS": "⟦용용용용 Ґėşρόηŝέ Čσůиţѕ 歴歴歴歴⟧",
                "RESULTS_DASHBOARDS_BANNER": "⟦용용용용용용용 ǻňď ťŗÿ τħè иèẁ, ímρřøνέď νęгśĭόŉ оƒ śüѓνéÿ řĕşμĺŧş, ƒéάτűгĩŉğ mοďĕґи, ä¢ċέŝşівĺĕ ЏĬ ăлď ďåťä νϊѕůąĺìżǻŧìôηş, ńěώ āņάľγşĭŝ άпď ěхρĺöґâťіőŉ ƒεáŧúřéś, αлď môяé. 歴歴歴歴歴歴歴⟧",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "⟦용용용 Γęľěåśê Ńŏτęş 歴歴歴⟧",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "⟦용용용용 Vīéẃ τĥĕ ĺãţеşţ 歴歴歴歴⟧",
                "RESULTS_OPTIONS": "⟦용용용용 Ґеρȭѓť Óρţîōйş 歴歴歴歴⟧",
                "RESULTS_TITLE": "⟦용용 Řĕρоŗţ 歴歴⟧",
                "RESUME_DISTRIBUTION": "⟦용용용용용 Ŕєѕųmέ Ðíśτяįвůťìõй 歴歴歴歴歴⟧",
                "REVERT": "⟦용용 Яένєřŧ 歴歴⟧",
                "RICH_TEXT_LIMIT_REACHED": "⟦용용용 Ĉоŉťёήť ĺεпġţн ħāś яεåснēď ťĥė ĺĭmìţ! 歴歴歴⟧",
                "SAVE": "⟦용 Şάνе 歴⟧",
                "SAVE_AND_CLOSE": "⟦용용용용 Şāνě ăήď Ĉľöśē 歴歴歴歴⟧",
                "SAVE_AS_CSV": "⟦용용용용 Şáνє Vïşůåľíżâτîоή áş ĆŞV 歴歴歴歴⟧",
                "SAVE_AS_IMAGE": "⟦용용용용용 Ŝǻνĕ Vιśųáľĭźάτįôй àŝ Įmáġе 歴歴歴歴歴⟧",
                "SAVE_CONFIRMATION": "⟦용용용용용 Śåνє Çοпƒïřmǻτϊòń 歴歴歴歴歴⟧",
                "SAVE_PAGE_AS_ELLIPSIS": "⟦용용용용용 Ėхρȭяť Ρãğĕ Αŝ... 歴歴歴歴歴⟧",
                "SAVE_SETTINGS": "⟦용용용 Ѕàνê Śєťťĭпġѕ 歴歴歴⟧",
                "SCHEDULE_REPORT_EMAIL": "⟦용용용용 Şсĥěďũľê Ŕēρöѓτ Ęmąïĺ 歴歴歴歴⟧",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "⟦용용용용 Ѕćħéďųĺë Ґеρȭґţ Εmäíĺ... 歴歴歴歴⟧",
                "SEARCH_ELLIPSIS": "⟦용용용 Şěåřčĥ... 歴歴歴⟧",
                "SEARCH_PAGES": "⟦용용용용 Ŝеãŗċн Qüêşτіóпŝ 歴歴歴歴⟧",
                "SEARCH_PAGES_ELLIPSIS": "⟦용용용용 Śêαгĉħ Ρåġёѕ... 歴歴歴歴⟧",
                "SEARCH_REPORTS_ELLIPSIS": "⟦용용용용용 Śεąřčĥ Ѓέροѓτŝ... 歴歴歴歴歴⟧",
                "SELECTED": "⟦용용용 Ŝєľεċţėď: 歴歴歴⟧",
                "SELECT_ALL": "⟦용용용 Ŝέļēсŧ Àĺĺ 歴歴歴⟧",
                "SELECT_A_FIELD": "⟦용용용용 Ŝěļё¢ť ά ƒіėľď 歴歴歴歴⟧",
                "SELECT_A_WIDGET": "⟦용용용용 Ŝεļēĉτ â νïѕůáľîżäŧīоň 歴歴歴歴⟧",
                "SELECT_PAGES": "⟦용용용 Ŝεľέćť Ρąğеş 歴歴歴⟧",
                "SELECT_PAGES_ELLIPSIS": "⟦용용용용 Ŝęľěĉţ Ρáġėś... 歴歴歴歴⟧",
                "SEND": "⟦용 Şěлď 歴⟧",
                "SEND_TEST_EMAIL": "⟦용용용용 Ѕέňď Ţěѕτ Ёmåïĺ 歴歴歴歴⟧",
                "SETTING_DEFAULT": "⟦용용 Ðęƒǻŭľţ 歴歴⟧",
                "SETTING_HIGH": "⟦용 Ήїġħ 歴⟧",
                "SETTING_LARGE": "⟦용 Ľαгğě 歴⟧",
                "SETTING_LOW": "⟦용 Ĺσш 歴⟧",
                "SETTING_NORMAL": "⟦용용 Ŋόřmãĺ 歴歴⟧",
                "SETTING_SMALL": "⟦용 Şmāļľ 歴⟧",
                "SHARE_REPORT": "⟦용용용 Ŝĥãяë Ґеρоŗť 歴歴歴⟧",
                "SHOW_ALL_PAGES": "⟦용용용용 Śĥõẃ Ǻļĺ Ράğëѕ 歴歴歴歴⟧",
                "SHOW_FULL_QTEXT": "⟦용용용 Ѕнŏŵ ƒůļľ qŭěŝťįôл ťé×ŧ іń ρāğє ţϊτĺέş 歴歴歴⟧",
                "SIMPLE_TABLE": "⟦용용용 Ŝίmρľē Ţāвĺє 歴歴歴⟧",
                "SIMPLE_TABLE_DESC": "⟦용용용 Ä ƒļëхίвļé ţąвļê ţĥåτ čāή ŝħόω mûĺŧįρļё νąļůèѕ ãś яóώś òг ċōĺůmŉѕ. 歴歴歴⟧",
                "SIZE": "⟦용 Ѕϊźе 歴⟧",
                "SPLINE_CHART": "⟦용용용 Ѕρļĭŋê Ćнåŗŧ 歴歴歴⟧",
                "SPLINE_CHART_DESC": "⟦용용용용 Â ŧщσ-ǻхїŝ ŗόűηďέď ľĭňé ćĥãѓŧ ċȭmmòņĺý ųѕєď ẁнēŉ ġѓãρħĭиğ àġάīйŝτ ţĩmĕ őŉ ŧħё ×-äхīŝ. 歴歴歴歴⟧",
                "STATISTICS_TABLE": "⟦용용용용 Śťǻŧϊŝťι¢ŝ Ţâвļë 歴歴歴歴⟧",
                "SUBJECT": "⟦용용 Śцьĵесτ 歴歴⟧",
                "SURVEY_ANALYSIS": "⟦용용용용 Şũгνέў Äńáľўŝíŝ 歴歴歴歴⟧",
                "SURVEY_SUMMARY": "⟦용용용용 Śūѓνêÿ Ѕúmmãřý 歴歴歴歴⟧",
                "TABLE": "⟦용용용용 Ă ÐÈЅĈŘĪΡŦĨÓÑ ₣ÕҐ ŤÀΒĻĔ 歴歴歴歴⟧",
                "TIME": "⟦용 Ťîmё 歴⟧",
                "TO": "⟦용 Τσ 歴⟧",
                "TOTAL": "⟦용 Ťøτăļ 歴⟧",
                "TRANSPOSE_STATS_TABLES": "⟦용용용용 Ŧřãήśρøѕé Śťάţş Ταьļēŝ 歴歴歴歴⟧",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "⟦용용용 Ţѓάηśρóśє Şŧąτş Ťάьľę ßŕεąкôüŧѕ 歴歴歴⟧",
                "TRUNCATE_PAGE_TITLES": "⟦용용용 Ťгũήçåŧē qũěşŧïσи ŧé×τ іπ ρąġè ţîŧľеѕ 歴歴歴⟧",
                "TRY_IT_NOW": "⟦용용용 Ťґŷ іţ ήōш 歴歴歴⟧",
                "TYPE": "⟦용 Τýρē 歴⟧",
                "UNABLE_TO_CHECK_SPF": "⟦용용용용 Џήåьļê ťŏ čнėċк ŧĥε ŞΡ₣ řē¢ōяď. Ρĺеäśë τŕỳ āġåíň. 歴歴歴歴⟧",
                "UNAUTHORIZED": "⟦용용용 Υοŭ åґє ŉóť âĺļσщёď τó νïēщ ŧнїѕ ŕєρőґŧ. Ρĺěǻşέ ćолťãċŧ τнě ȭẁйèѓ ƒøŗ ä¢ĉεşś. 歴歴歴⟧",
                "UNHIDE_PAGE": "⟦용용용 Ųпħìďę Ρãġě 歴歴歴⟧",
                "UPDATE": "⟦용용 Űρďáţè 歴歴⟧",
                "UPDATED_SUCCESSFULLY": "⟦용용용용 Ůρďāţέď Śų¢сęŝśƒúļľУ. 歴歴歴歴⟧",
                "UPDATE_ALL_IN_THIS_PROJECT": "⟦용용용용용 Ųρďάτё Ąĺļ ίл τнϊś Ρѓõĵêĉť 歴歴歴歴歴⟧",
                "UPDATE_ALL_PROJECTS": "⟦용용용용용 Üρďáŧë Ǻĺľ Ρгŏĵęсťŝ 歴歴歴歴歴⟧",
                "UPDATE_NOW": "⟦용용용 Џρďāτé Ňóш 歴歴歴⟧",
                "UPDATE_REPORTS": "⟦용용용용용 Ûρďáŧε Ŕëρóѓτş... 歴歴歴歴歴⟧",
                "UPDATE_REPORT_ELEMENTS": "⟦용용 Űρďàŧε Ρūьĺìć Яēρõѓŧ Ĺîлĸś áŋď Śсĥęďųļēď Řéρσяτ Ёmαϊľş 歴歴⟧",
                "UPGRADE_MY_ACCOUNT": "⟦용용용용용 Ũρġґâďε ΜУ Åćčοųйŧ 歴歴歴歴歴⟧",
                "USE_EXPORT_TAGS": "⟦용용용용 İηçļµďë qµēŝţìöή лůmьëŕś 歴歴歴歴⟧",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "⟦용용용용용 Üśě Ŝіmρļє Ţąьļε Ĉøĺµmή Ťоτåļŝ 歴歴歴歴歴⟧",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "⟦용용용 Ŭśέ Ŝímρĺé Ŧăьľé Řęѕρоŋďεйť Čŏűňţş 歴歴歴⟧",
                "USE_WEIGHTED_METRICS": "⟦용용용용용 Úśë ωéіġħτĕď mєŧѓīĉş 歴歴歴歴歴⟧",
                "VIEW": "⟦용 Vïěш 歴⟧",
                "WEEKLY": "⟦용용 Ẁέєкĺÿ 歴歴⟧",
                "WELCOME_TO_NEW_RESULTS": "⟦용용용용 Шеļċόmе ŧô Qüáľŧгĩċŝ χМ Ρĺąţƒöѓm Ŗéρøяŧïňġ! 歴歴歴歴⟧",
                "WHEN": "⟦용 Шĥєл 歴⟧",
                "WIDGET_LOADING": "⟦용용용 Ľøαďĩηğ... 歴歴歴⟧",
                "WIDGET_OPTIONS_ERR": "⟦용용용 ₣ǻīľěď ťô ĺоâď νĭŝμάľιźáţïόп ȭρťĩоňѕ 歴歴歴⟧",
                "WIDGET_TYPE": "⟦용용용 Vîѕūãļіżǻťιоń 歴歴歴⟧",
                "WORD_CLOUD": "⟦용용용 Шоŗď Çļŏμď 歴歴歴⟧",
                "WORD_CLOUD_DESC": "⟦용용용용 Ä ωęíĝħţėď νіşųąĺίźäτíόή ȭƒ ẁōґď ƒŕėqüèп¢ÿ īņ ŧé×ť ďάťã ẁįťн ąďďíţįóňãĺ сõļóŗ čоďìиĝ őρţīóиŝ. 歴歴歴歴⟧"
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "⟦용용용용용용용 Яémёmвëѓ, ŧħęŕē άґè ѓēѕőûŗсеŝ ώίτħĭņ Уòµř øгğãйιżåţίõή τø ħëľρ Уòŭ іπŧеŕρŗέŧ ўοùř ƒεєďьàçк ŝùčħ ãş ΉŖ Ραŕτлĕřŝ, ÿοũя mǻŋάġеŗ, äŉď/ȭŕ à mεлťòґ. 歴歴歴歴歴歴歴⟧",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "⟦용용 Ρőüя ỳöüřśёļƒ ã ĉцρ оƒ ċöƒƒêë ăŉď ďĭνę ιŋτό ýøųŕ ƒēëďьäčķ. 歴歴⟧",
                "ABOUT_YOUR_REPORT_HEADER": "⟦용용용용용 Àьőŭτ Уőŭг ŕèροřţ 歴歴歴歴歴⟧",
                "ABOUT_YOUR_REPORT_LINE1": "⟦용용용용용용용용용용용용용용용용용용 Шêļčömέ ťô γόũя 360 ƒěēďвâĉκ řèρόяŧ. Τнīş ϊŝ á ĝяєáτ òρρőѓŧŭňїţỳ τό ĝŕóẁ ąηď ďěνëļóρ ŷōųѓѕеĺƒ ăŝ ǻ ρѓòƒěѕşīοņąľ. Ій ȭѓďëя ťό ŝèŧ ÿομřŝęĺƒ ùρ ƒőř ŝųčćēşѕ ωнėп ġóìňġ ŧħяȭμğħ ґêŝŭĺŧѕ, âľļōώ ўōŭŗŝēļƒ ŝúƒƒï¢іёņŧ ţїmέ ŧο ĝø ŏνēŗ ţнє ƒëêďьāсκ. ₣ęέďвäćκ çάή ьē ďїƒƒïčūĺţ ŧò нěąř íηϊťίâĺĺÿ, вûť кëєρ ĭή mĭŋď ţнãţ ťħе ρúŕρőŝε øƒ ŧħϊś ƒёёďьǻ¢ķ íŝ ŧö åĉčєļēѓąŧε ÿσūŗ ġřσŵťĥ àήď ďěνëľορmεŉτ. 歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴⟧",
                "ABOUT_YOUR_REPORT_LINE2": "⟦용용용 Äş ỳòû ġõ τнѓõüġħ ỳσűя гĕρоŕŧ, ĥεѓĕ ăŗė à ƒêŵ ŧħĭлĝś ŧö кëēρ ìŋ mìйď. 歴歴歴⟧",
                "ADD_CONDITIONAL_TEXT": "⟦용용용용용 Åďď ĉȭηďíŧїοиåĺ τёхţ 歴歴歴歴歴⟧",
                "ADD_CUSTOM_PALETTE": "⟦용용용용용 Ãďď Ċųśτοm Ράĺеţτē 歴歴歴歴歴⟧",
                "ADD_DATA_SOURCE": "⟦용용용용 Αďď ďäťá śòцгċε 歴歴歴歴⟧",
                "ADD_FOLLOWING": "⟦용용용 Äďď ƒõĺľőшíŋğ 歴歴歴⟧",
                "ADD_LABEL": "⟦용용용 Åďď ľáьéĺ 歴歴歴⟧",
                "ADVANCED_FILTER": "⟦용용용용 Áďνǻŉćёď ₣įĺτєг 歴歴歴歴⟧",
                "AGREEMENT_CHART": "⟦용용용용 Ãĝгέєmêητ çнàґτ 歴歴歴歴⟧",
                "AGREEMENT_CHART_FOOTER": "⟦용용용용용용용용용 Ŧħē âġґėεmêήŧ ćĥäгţ īŉďîçăťёś ţĥê ѕįmϊĺâřϊτУ оƒ śċȭґëş. Ёαćĥ ďőτ ѓěρгęşèйťѕ нŏш íйďіνîďúàĺş яǻťëď ỳόų ƒøѓ ęα¢ĥ įťĕm. Ţħě şíźе ŏƒ ťĥέ ďöτ şħȭẁş ħòщ mαπŷ ѓåτéřş ĝâνē ÿοú ä śρéčíƒїč řãťίŋğ. 歴歴歴歴歴歴歴歴歴⟧",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "⟦용용용 ŗėŝρõлŝέś 歴歴歴⟧",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "⟦용용용 řĕşρòŋŝĕ 歴歴歴⟧",
                "AGREEMENT_CHART_LEGEND_TITLE": "⟦용용용용용 Ħσω öţнέяŝ гåτёď Уøú 歴歴歴歴歴⟧",
                "ALL": "⟦용 Ăļĺ 歴⟧",
                "AND_IF": "⟦용용 Àйď ίƒ 歴歴⟧",
                "ANGLED": "⟦용용 Ąйğľēď 歴歴⟧",
                "AREA": "⟦용 Ãґεǻ 歴⟧",
                "AUTO": "⟦용 Ǻūťô 歴⟧",
                "AVERAGE": "⟦용용 Ąνέґáğě 歴歴⟧",
                "AXIS_VALUES": "⟦용용용 Ą×ϊŝ Vāĺùёŝ 歴歴歴⟧",
                "BAR": "⟦용 βâŕ 歴⟧",
                "BASE_WORD_COLOR": "⟦용용용용 βãѕё Ẁȭґď Čοļȭŗ 歴歴歴歴⟧",
                "BLUR": "⟦용 Βĺüг 歴⟧",
                "BOTTOM_BOX": "⟦용용용 Бοťτôm ßò× 歴歴歴⟧",
                "BREAKOUT_HEADERS": "⟦용용용용 βґєąкőűţ Ηĕàďèяş 歴歴歴歴⟧",
                "CANCEL": "⟦용용 Çãйсęĺ 歴歴⟧",
                "CATEGORICAL": "⟦용용용 Ćăτéğôѓįçąĺ 歴歴歴⟧",
                "CATEGORY": "⟦용용용 ĊāţēğòŗУ 歴歴歴⟧",
                "CATEGORY_NAME": "⟦용용용 Ĉāţеġöгÿ Νąmє 歴歴歴⟧",
                "CHANGE_CATEGORIES_ORDER": "⟦용용용용 Čĥâйĝε čαţĕġоŗĩēŝ ōґďěг 歴歴歴歴⟧",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "⟦용용용 Ċĥáиĝê ŧħě ѕĉôŕïňğ ĉáţëğòѓīēş оŗďëŗ 歴歴歴⟧",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "⟦용용용용용용용 Čнαņġĕ ţнē òяďεŗ ťħαŧ ăρρёáґѕ ïŋ τħė νìşüάļĩżãťĩȭή вÿ çĺιçķϊņĝ õή ŧħε ĺéƒţ õƒ ţħē şçȭŕīлġ ¢ąτêĝŏŗỳ ēĺēmėлť ăήď ďґǻġĝїŉĝ îτ ŧó īŧś ďεşíяĕď ρöѕιŧîοй. 歴歴歴歴歴歴歴⟧",
                "CHANGE_QUESTIONS_ORDER": "⟦용용용용 Ĉнăηĝε qũεѕţїőήş οґďêŗ 歴歴歴歴⟧",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "⟦용용용용용 Čнǻπġє τħè qúêѕŧįŏπѕ οŕďèŕ 歴歴歴歴歴⟧",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "⟦용용용용용용 Çнåήğé ťħę ȭѓďёŕ ťнãť åρρеαŕŝ įη ŧħё νīѕμąľĩźαţíόл ьý сľіĉķίηġ оπ τĥē ļęƒť óƒ ţне qùĕşŧïòŋ ėľęměπť áņď ďѓàğġїйĝ ïť τò īŧŝ ďεşϊґěď ρōśιţïòŋ. 歴歴歴歴歴歴⟧",
                "CHARTS": "⟦용용 Čĥáѓτŝ 歴歴⟧",
                "CHART_TYPE": "⟦용용용 Čĥāřť ŤУρέ 歴歴歴⟧",
                "CHOICE_COUNT": "⟦용용용 Çĥσĩčė Ćőцйţ 歴歴歴⟧",
                "CHOICE_TOTALS": "⟦용용용 Ĉħôìçê Ťοταĺŝ 歴歴歴⟧",
                "CLEAR": "⟦용 Čľεàŗ 歴⟧",
                "CLOSE": "⟦용 Ĉľøѕĕ 歴⟧",
                "COLOR_PALETTE": "⟦용용용 Çόĺόř Ραľëţţè 歴歴歴⟧",
                "COLUMN_NAMES": "⟦용용용 Çόĺцmń Ŋämέş 歴歴歴⟧",
                "COLUMN_TOTALS": "⟦용용용 Ćσĺŭmŉ Ţŏťàĺş 歴歴歴⟧",
                "COMPARED_FILTER_GROUP": "⟦용용용용 Ĉómρâґėď ₣ιľτёґ Ĝяøµρ 歴歴歴歴⟧",
                "COMPARED_FILTER_GROUPS": "⟦용용용용 Čőmρàѓεď ₣ĩľţёґ Ğгοŭρś 歴歴歴歴⟧",
                "COMPARE_WITH": "⟦용용용 ¢όmρàгě ώìŧħ 歴歴歴⟧",
                "COMPETITION_RANKING": "⟦용용용용 Ůşê ćоmρėŧîţìσń ґąлķιņğ 歴歴歴歴⟧",
                "COMPETITION_RANKING_TOOLTIP": "⟦용용용용용용용용용 Ìŉ ŧħě ëνēйτ øƒ à ţíє, âĺļ еqμāĺ şćσѓёś ãŕė ğινέŉ ŧнé śämέ гάйĸιйġ. Ĥоώéνêř, ţĥē иє×ŧ ŝűвśėqűêňť Ϊŧеm ẁīĺľ ьє ŕǻηκёď éqμάļ τó: ţħе ťøŧåļ иμmвєґ ȭƒ Îţєmś ѓåπκěď нìğĥéґ їŋ ŧħе ţăьľе, ρĺũѕ ôηé. 歴歴歴歴歴歴歴歴歴⟧",
                "COMPLETED_RESPONSES": "⟦용용용용용 Ċòmρļέŧеď řêşρòпşέѕ 歴歴歴歴歴⟧",
                "CONDITIONAL_TEXT": "⟦용용용용 Ĉσлďĩŧіóйăĺ ţèхŧ 歴歴歴歴⟧",
                "COUNT": "⟦용 Çȭμлţ 歴⟧",
                "CREATE": "⟦용용 Ċяěäŧé 歴歴⟧",
                "CUSTOM_PALETTE": "⟦용용용용 Çμŝţȭm Ρąĺëτţе 歴歴歴歴⟧",
                "DATA_SOURCE_TYPE": "⟦용용용용 Ðăŧâ Ŝöũŕçέ Ťўρé 歴歴歴歴⟧",
                "DATA_SOURCE_TYPE_CATEGORY": "⟦용용용용용 Śċøгιŋġ Ċαŧėĝőяïéś 歴歴歴歴歴⟧",
                "DATA_SOURCE_TYPE_QUESTION": "⟦용용용 Qůéśτíõπś 歴歴歴⟧",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "⟦용용용 Qμèśţîσŋ 歴歴歴⟧",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "⟦용용용용 Ґåйκąьľě Ĩŧεmş 歴歴歴歴⟧",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "⟦용용용용 Ŝčőŗїиĝ Ćáťєĝöřÿ 歴歴歴歴⟧",
                "DEFAULT": "⟦용용 Ðęƒǻŭľţ 歴歴⟧",
                "DEFAULT_TEXT": "⟦용용용 Ðëƒáűľŧ ŧε×τ 歴歴歴⟧",
                "DELETE": "⟦용용 Ðєļèťé 歴歴⟧",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "⟦용용용용 Ųņďегŝţâηď ŵħŏ ўōũя ƒεêďьαčк ïŝ çómιηğ ƒŕøm, щĥєťнеř íŧ’ŝ ρеėřѕ, ďīѓēçτ řеρòґţş, ĺеǻďеŗś, ëţč 歴歴歴歴⟧",
                "DIFFERENT_EVALUATORS_HEADER": "⟦용용용용용 Ðĩƒƒегёņţ èνâľµäŧōѓş 歴歴歴歴歴⟧",
                "DIRECT_REPORTS": "⟦용용용용 Ďιґеçť яéρóяτѕ 歴歴歴歴⟧",
                "DISABLED": "⟦용용용 Ďīŝãвļėď 歴歴歴⟧",
                "DISPLAY_OPTIONS": "⟦용용용용 Ðīśρĺάŷ Öρτìоиŝ 歴歴歴歴⟧",
                "DISPLAY_THRESHOLD_TEXTS": "⟦용용용용 Ďīśρľáŷ ŧėхţ ьǻѕęď όη ŧħè ƒόļľόẁįйġ ġґöůρś ğãρ 歴歴歴歴⟧",
                "DIVERGENT": "⟦용용용 Ðĩνεŗĝёήţ 歴歴歴⟧",
                "DONE": "⟦용 Ðолě 歴⟧",
                "DONT_HEADER": "⟦용용 Ðσŋ'τ: 歴歴⟧",
                "DONT_LINE1": "⟦용용용 Τřÿ τò ƒϊĝŭŗě оūť ώĥо ѕăĩď ωĥąť 歴歴歴⟧",
                "DONT_LINE2": "⟦용용용용 ₣őčúś õň õлě ρöşįτĩνè őŕ ήέġáťїνє ŝĉȭřё/čόmmėлť 歴歴歴歴⟧",
                "DONT_LINE3": "⟦용용용용 Ĉřèàŧë ā ďěνęĺȭρmейť ρĺăи àŕőµŉď ενеяγ ĭŧëm 歴歴歴歴⟧",
                "DONT_LINE4": "⟦용용 βе ďīśĉôūŗāğëď τĥατ Уσü нáνē σρρøřťμліťīёѕ ƒóѓ ιmρяôνėměητ 歴歴⟧",
                "DONUT": "⟦용 Ðòŉŭτ 歴⟧",
                "DOWNLOAD_CSV": "⟦용용용용용 Ðοωηľōâď ĹєğąсУ ĆЅV 歴歴歴歴歴⟧",
                "DOWNLOAD_ZIP": "⟦용용용용용 Ďóωňĺȭǻď äĺľ ƒíļεş 歴歴歴歴歴⟧",
                "DO_HEADER": "⟦용 Ďø: 歴⟧",
                "DO_LINE1": "⟦용용용용용 Ľøоķ ăť ƒêеďьαĉķ ĥõľįşţîçāļĺγ 歴歴歴歴歴⟧",
                "DO_LINE2": "⟦용용용 ĪďêйţĭƒУ ťħëměѕ ϊη şťѓєиğτĥѕ ăňď óρρõŗţüйïŧīέś ƒȭґ ĩmρяονεmēŉť 歴歴歴⟧",
                "DO_LINE3": "⟦용용 Ρřĩόгīťιżě ά ƒеω ƒòčũş âгєαś τö âďď τô γŏµг ďèνеĺōρmēπŧ ρļάи 歴歴⟧",
                "DO_LINE4": "⟦용용 Ŭпďёŕśτάпď ţħάţ ěνеŕУóήë ħãŝ òρρόгτüηīŧĭёѕ ƒοя іmρŗȭνëmēņτ 歴歴⟧",
                "DROPOFF": "⟦용용 Ðґóρőƒƒ 歴歴⟧",
                "DUPLICATE": "⟦용용용 Ðüρĺíĉαţе 歴歴歴⟧",
                "EDIT_CONDITIONAL_TEXT": "⟦용용용용 Ĕďĭŧ çōŋďϊťîòńάļ ŧĕхŧ 歴歴歴歴⟧",
                "EDIT_CUSTOM_PALETTE": "⟦용용용용용 Ęďίτ Ċùśτōm Ρǻļëτţе 歴歴歴歴歴⟧",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "⟦용용용용용 Εļśę śĥòώ ţħê ƒοļľŏώīņġ τė×ŧ 歴歴歴歴歴⟧",
                "ENABLED": "⟦용용 Еńǻьľèď 歴歴⟧",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "⟦용용용용 Ėлǻьĺё øřďέŕìпĝ ьỳ ґåţėя ċåτěġöŗỳ ďїŝρĺàÿ ļоġіċ 歴歴歴歴⟧",
                "ENABLE_ORDERING_FOR": "⟦용용용용용 Εпάвľė ôŕďéŗίлğ ƒõя 歴歴歴歴歴⟧",
                "EQUAL_TO": "⟦용용용 Ëqμάľ ťō 歴歴歴⟧",
                "FIELD": "⟦용 ₣ĭёľď 歴⟧",
                "FILTER_NAMES": "⟦용용용 ₣íĺţéŕ Ņämεş 歴歴歴⟧",
                "FOLLOWING_PARENTHESES": "⟦용용용 (ƒóľļошĩŉĝ) 歴歴歴⟧",
                "FOOTER": "⟦용용 ₣оŏţея 歴歴⟧",
                "GAP": "⟦용 Ġâρ 歴⟧",
                "GAP_CHART": "⟦용용용 Ğàρ сħǻґţ 歴歴歴⟧",
                "GAP_CHART_DESCRIPTION": "⟦용용용용용용용용용용용용용용용용 Ťħė ĝàρ čнãѓτ ďíŝρĺąУś τħè ďīƒƒêяεŉĉė іл ŝçòřеş ьęŧωėêŉ τщò řáţεґ ġґőűρş. ₣ōґ ěхämρľĕ, ϊņ τĥê ċάśĕ òƒ śєļƒ-ґäŧįпğś νş. нõẃ óŧĥëřѕ řąτĕď ўоů, ă ρøŝīτįνē(+) ďίƒƒëřęπčé mёάňş οťĥєřŝ яάţęď ўȭŭ нīğнёѓ ŧнâň ţĥέ řåţĭлġ ŷŏц ρѓŏνīďėď ƒŏг ýσúřѕёĺƒ. Ā иёğăţïνè(-) ďιƒƒêґέň¢є mέąлŝ òŧнēŗş ŗǻťěď γȭų ĺôẁëѓ ŧħāή γȭų ρŕôνįďėď ƒŏŕ Уōûяѕėľƒ. 歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴⟧",
                "GAP_CHART_FOOTER": "⟦용용용 Ŧнę ğáρ čнářť ĭŉďϊċáťěś ťнè +/- ďĩƒƒéŕεиçë ьėŧẁēěń ţẃö яąťęг ĝŗóűρŝ. 歴歴歴⟧",
                "GAP_TABLE_DESCRIPTION": "⟦용용용용용용용용용용 Ήїďďėŋ ŝŧгęлġţнŝ ŝĥȭώś щħёŗë σţħέŕś ŗατěď ўõц нιġнёŗ τħãŉ ýóû ŗâţέď ŷöцŕśěļƒ. Âгęáş ƒσѓ іmρґονëmèňţ śħóẃѕ ωнěяε ŏτħêŕş гåŧέď ÿόü ļôẁêг ŧнαń γôū ŕāŧеď ўȭŭгşėľƒ. Бŏţĥ ŝēçŧιойѕ àгé ŕàикèď ƒŕöm ľăřġēşτ ťό ŝmåļľēśŧ ğåρ. 歴歴歴歴歴歴歴歴歴歴⟧",
                "GAP_TABLE_FOOTER": "⟦용용용용용용용용용용 Τнę ƒĩяѕŧ ¢οľµmл óƒ şćоѓέş ĭиďί¢âţêś ħōщ ÿоû ŝĉóřēď ÿõцѓѕēļƒ. Ŧħė şĕĉόņď ĉøļŭmņ įйďíćâτёѕ τĥε ăνęяăğе şćòґе ôƒ óţнεѓѕ. Ţħě ŧħįгď ĉσľμmή îňďîċàτėś ŧнė ďīƒƒèґєňčέ вёťŵêеň ħŏẁ ỳȭù ѕçôŕéď ýòμřѕëľƒ āиď ĥȭώ ôτħέяś ś¢óгěď ўøŭ. 歴歴歴歴歴歴歴歴歴歴⟧",
                "GAP_TABLE_TITLE": "⟦용용용 Ηίďďèŋ ѕţяēηĝŧħś/Ĩmρяȭνěmєŋţ ãґеäş 歴歴歴⟧",
                "GREATER_OR_EQUAL": "⟦용용용용 Ĝѓεãτеŕ òя еqŭâļ 歴歴歴歴⟧",
                "GREATER_THAN": "⟦용용용 Ĝŕέāŧęг ţħàπ 歴歴歴⟧",
                "GROUP": "⟦용 Ĝѓȭũρ 歴⟧",
                "GROUPED_FOR_ANONYMITY": "⟦용용용용 Ĝŗøûρéď ƒȭř ÁйøņÿmíťУ 歴歴歴歴⟧",
                "HEADER_NAMES": "⟦용용용 Ħέāďèя Ňαmèŝ 歴歴歴⟧",
                "HIGHEST_SCORES": "⟦용용용용 Ηïğĥëѕŧ şčõґέŝ 歴歴歴歴⟧",
                "HIGHLIGHT_THRESHOLD": "⟦용용용용용 Ťĥřĕşĥόľď ŧо нïğĥľìġħŧ ĝάρѕ 歴歴歴歴歴⟧",
                "HIGHLOW_TABLE": "⟦용용용용용 Ĥĭğħ ąňď ļõω śсöгêѕ 歴歴歴歴歴⟧",
                "HIGHLOW_TABLE_FOOTER": "⟦용용용용용용용용용용용용용용용용용용용용용용 Ŧħιś şēсŧĩôи şĥōẃŝ ťħє ƒīνè ĥìĝĥέŝŧ ãиď ľσщеşτ гąτëď ьëĥâνìȭѓѕ (â¢řσŝѕ ãľĺ венāνīõѓś) ƒѓóm ţнє áρρļĩсâвľę яăťëŕ ĉāŧěġőгУ ανėґâĝêŝ. Τô ğéŧ ťħě mσśţ ƒгσm ťħïś ρãġε, ĭť ĩş ĥεĺρƒцĺ ťо ļőóķ ƒȭŗ ťřëйďś ţħǻτ måў êmёŗĝέ. ₣öѓ ĕхǻmρľę, ìƒ ťħє måĵȭгîţУ öƒ ŷόũř ĺøẁèśţ яàţèď ьěнāνįôŕŝ ăгë čόиċёňτŕãťєď ĭņ οňĕ ȭґ ŧщő çăτĕġŏѓīεŝ; ţħęşĕ mǻŷ ьê ǻŗèâѕ ϊй ηеёď őƒ ďένéĺöρmęńţ. Ťĥè ħϊġħëŝŧ řåτёď вęĥάνіõгѕ сáи ĭďêŋŧíƒў śťѓēňġţħś ţĥåť ¢άπ ьé ľένέгáĝёď íп ȭťнėг άŕêâś. 歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴⟧",
                "HIGH_LOW_TABLE_DESCRIPTION": "⟦용용용용 Ţĥέ ніğĥ/ĺòш çнâяτ ďіśρļãỳś îţĕmş вáśéď οŉ τнё äŕèāş щнēŗë оŧнèѓş řǻτеď ÿôû ĥіĝĥēѕτ αńď ľòŵεśţ. 歴歴歴歴⟧",
                "HORIZONTAL": "⟦용용용 Ηőгїżȭńτåļ 歴歴歴⟧",
                "HORIZONTAL_AND_VERTICAL": "⟦용용용용 Ήōřίźȭńťáļ & Vėŕτіĉăĺ 歴歴歴歴⟧",
                "HORIZONTAL_BAR": "⟦용용용용 Ħóŗїźοйτăľ Βāґ 歴歴歴歴⟧",
                "HOW_TO_INTERPRET_RESULT_HEADER": "⟦용용용용 Ħöώ τо іиţέѓρŕęţ яėśųļτŝ àήď ďέτēѓmìле ä¢ťīöή: 歴歴歴歴⟧",
                "IF": "⟦용 Іƒ 歴⟧",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "⟦용용용 Ίп¢ľцďě ħїďďêň ĺāьеĺŝ íņ ρеѓçěпţś 歴歴歴⟧",
                "INNER_RIM": "⟦용용용 Íņńêŗ Ѓīm 歴歴歴⟧",
                "IS": "⟦용 Іѕ 歴⟧",
                "IS_NOT": "⟦용용 Ίś ŋòτ 歴歴⟧",
                "IS_SAME_AS_SUBJECT": "⟦용용용용용 Ĩş ѕāmĕ αŝ ŝúвĵĕčţ 歴歴歴歴歴⟧",
                "ITEM": "⟦용 Ĭťεm 歴⟧",
                "LABEL": "⟦용 ļąвеĺ 歴⟧",
                "LABELS": "⟦용용 Ľāьęĺѕ 歴歴⟧",
                "LARGE_LABELS": "⟦용용용 Ļαґğē Ľāьéļѕ 歴歴歴⟧",
                "LEGEND": "⟦용용 Ļėğĕŋď 歴歴⟧",
                "LEGEND_POSITION": "⟦용용용용 Ŀèĝеŉď Ρσŝìτįȭŋ 歴歴歴歴⟧",
                "LEGEND_VALUES": "⟦용용용 Ľεĝёńď Vαļůεś 歴歴歴⟧",
                "LESS_OR_EQUAL": "⟦용용용 Ļēѕѕ ôя ėqůăĺ 歴歴歴⟧",
                "LESS_THAN": "⟦용용용 Ŀēŝş τħàп 歴歴歴⟧",
                "LINE": "⟦용 Ľίйé 歴⟧",
                "LOWEST_SCORES": "⟦용용용 Ľôẃеśŧ śčôřêѕ 歴歴歴⟧",
                "MANAGERS": "⟦용용용 Μάлăġεгŝ 歴歴歴⟧",
                "MANUAL_FONT_SIZE": "⟦용용용용 Ѕĕŧ ƒöŋť ѕìżē máŋůãļĺў 歴歴歴歴⟧",
                "MAX": "⟦용 Мä× 歴⟧",
                "MEAN": "⟦용 Μêąŉ 歴⟧",
                "MEDIAN": "⟦용용 Мёďϊąй 歴歴⟧",
                "METRIC_TYPE": "⟦용용용 Μέţřїç τỳρє 歴歴歴⟧",
                "MIN": "⟦용 Мĭή 歴⟧",
                "MODIFY_CUSTOM_PALETTES": "⟦용용용용 Μőďίƒў Ĉцѕτòm Ραľęţŧέś 歴歴歴歴⟧",
                "MOVE_DOWN": "⟦용용용 Μóνē ďòẁň 歴歴歴⟧",
                "MOVE_UP": "⟦용용 Μονё ūρ 歴歴⟧",
                "MULTI_SELECT_ITEMS_SELECTED": "⟦용용용 şέľёċŧęď 歴歴歴⟧",
                "NEGATIVE_GAPS": "⟦용용용용 Αѓêåѕ ƒσя ιmρѓȭνĕmĕňţ 歴歴歴歴⟧",
                "NO": "⟦용 Йő 歴⟧",
                "NONE": "⟦용 Ňòле 歴⟧",
                "NOT_APPLICABLE": "⟦용 Ñ/Α 歴⟧",
                "NOT_EQUAL_TO": "⟦용용용 Иŏŧ єqůãĺ ţο 歴歴歴⟧",
                "NO_DATA_AVAILABLE_WARNING": "⟦용용용용용 Ŋò ďäţα αναīĺάьļė 歴歴歴歴歴⟧",
                "NO_FILTER": "⟦용용용 Йŏ ƒīľŧęя 歴歴歴⟧",
                "NO_FILTER_IS_APPLIED": "⟦용용용용 Ŋŏ ƒïĺţėŗ ìś áρρľïęď. 歴歴歴歴⟧",
                "NO_VALUE": "⟦용용용 Иô νäľũє 歴歴歴⟧",
                "NPS": "⟦용용용용용 Ńēţ Ρŕοmôτëř Ѕĉōѓě 歴歴歴歴歴⟧",
                "NUMBER": "⟦용용 ηůmьèř 歴歴⟧",
                "NUMBERS": "⟦용용 Ňümьегş 歴歴⟧",
                "NUMBER_OF_GAPS_NEGATIVE": "⟦용용용용 Ŋūmьéŕ õƒ Йėġąťĭνě Ĝάρѕ 歴歴歴歴⟧",
                "NUMBER_OF_GAPS_POSITIVE": "⟦용용용용 Νümьèř ôƒ Ρøśїτīνé Ĝâρŝ 歴歴歴歴⟧",
                "NUMBER_OF_ROWS_HIGH": "⟦용용용용용 Иùmьėŕ őƒ Ήíĝĥ Яσŵŝ 歴歴歴歴歴⟧",
                "NUMBER_OF_ROWS_LOW": "⟦용용용용용 Ňµmьéŕ øƒ Ľόш Ґòẃś 歴歴歴歴歴⟧",
                "OPTIONS": {
                    "HEADER_NAME": "⟦용용용 Ηέäďèґ йămε 歴歴歴⟧",
                    "LEGEND": "⟦용용 Ļėğĕŋď 歴歴⟧",
                    "SCALE_AXIS_CHANGER_TITLE": "⟦용 Ŗąйğę 歴⟧"
                },
                "ORIENTATION": "⟦용용용 Òŕĩĕňťãţìöŉ 歴歴歴⟧",
                "OR_IF": "⟦용 Ŏѓ ĭƒ 歴⟧",
                "OTHER": "⟦용 Ότħея 歴⟧",
                "OTHERS": "⟦용용 Θτнēřѕ 歴歴⟧",
                "PAGE_OF": "⟦용용용용 Ρåĝė: %1 Öƒ %2 歴歴歴歴⟧",
                "PALETTE_REMOVED": "⟦용용용용 Ρáľėτţê Ѓεmονέď 歴歴歴歴⟧",
                "PEERS": "⟦용 Ρєĕřś 歴⟧",
                "PERCENT": "⟦용용 Ρēґčēňŧ 歴歴⟧",
                "PERCENTAGE": "⟦용용용 Ρèгсēŋτâğε 歴歴歴⟧",
                "PERCENTAGE_OF_CHOICES": "⟦용용용용 Ρęřčêпτάġε оƒ Ĉĥõіčęś 歴歴歴歴⟧",
                "PERCENTAGE_OF_RESPONSES": "⟦용용용용 Ρèŕċěйŧãĝέ σƒ Ґëśρõņŝèѕ 歴歴歴歴⟧",
                "PERCENT_COMPLETE": "⟦용용용 % ċómρľєťє 歴歴歴⟧",
                "PERSON_METADATA": "⟦용용용용 Ρέѓşøπ mεţåďăťà 歴歴歴歴⟧",
                "PERSON_METADATA_EVALUATOR": "⟦용용용 Ĕνãĺūǻτȭг'ś 歴歴歴⟧",
                "PERSON_METADATA_SUBJECT": "⟦용용용 Ŝŭьĵéçτ'ş 歴歴歴⟧",
                "PERSON_METADATA_VIEWER": "⟦용용용 Vїêщėя'ş 歴歴歴⟧",
                "POSITIVE_GAPS": "⟦용용용용 Ĥίďďĕη śŧѓĕйğţнś 歴歴歴歴⟧",
                "PRIMARY_PARENTHESES": "⟦용용용 (ρѓїmǻŕў) 歴歴歴⟧",
                "QUESTIONS": "⟦용용용 Qůéśτíõπś 歴歴歴⟧",
                "RADIUS": "⟦용용 Яáďіцś 歴歴⟧",
                "RANK": "⟦용 Γǻήķ 歴⟧",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "⟦용용용 Ηїġħέѕť ѕĉõŕе 歴歴歴⟧",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "⟦용용용용 Ηïğĥëѕŧ şčõґέŝ 歴歴歴歴⟧",
                "RANKABLE_ITEMS_ITEM_HAS": "⟦용용용 Ìťęm нăś 歴歴歴⟧",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "⟦용용용용 Įτёm ïş ïń ťȭρ 歴歴歴歴⟧",
                "RANKABLE_ITEMS_LOWEST_SCORE": "⟦용용용 Ľόωεѕť śćŏřè 歴歴歴⟧",
                "RANKABLE_ITEMS_LOWEST_SCORES": "⟦용용용 Ľôẃеśŧ śčôřêѕ 歴歴歴⟧",
                "RATER_CATEGORY_DISPLAY_LOGIC": "⟦용용용용용 ŗáţёг čάτěĝøгŷ ďίşρĺąỳ ľōĝīç 歴歴歴歴歴⟧",
                "RATIO": "⟦용 Яáťїо 歴⟧",
                "RECORD": "⟦용용 Ѓěçóŕď 歴歴⟧",
                "REFERENCE_GROUP": "⟦용용용용 Ґєƒεřеηčё ġяøūρ 歴歴歴歴⟧",
                "RELATIONSHIP": "⟦용용용 Řєľåŧĭôňѕнìρ 歴歴歴⟧",
                "RELATIONSHIP_FILTERS": "⟦용용용용용 Ѓεĺàτіσпѕнĭρ ƒīľŧєŕѕ 歴歴歴歴歴⟧",
                "RELATIONSHIP_FILTERS_INFO": "⟦용용용용용용용용 Τό áďď ą ŗέľàŧïȭηŝĥĭρ ƒїľτєѓ (śμĉĥ άś ā ďίяèčţ гερȭŗţ, ρęёя, øř mâήαĝёґ), śěļêсτ Мąŋąġέ ýŏųŕ ƒїļťĕŗś, àπď ùśê Ґĕĺάτìòпśнĩρ çòήďíţїőŉ σήĺУ ƒґôm τĥέ ďŕоρ-ďŏωŋ mеņų. 歴歴歴歴歴歴歴歴⟧",
                "REMOVE": "⟦용용 Ŕëmσνé 歴歴⟧",
                "REMOVE_DATA_SOURCE": "⟦용용용용용 Ŗέmŏνë ďåťą şōúясё 歴歴歴歴歴⟧",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "⟦용용용용용용용 Яémёmвëѓ, ŧħęŕē άґè ѓēѕőûŗсеŝ ώίτħĭņ Уòµř øгğãйιżåţίõή τø ħëľρ Уòŭ іπŧеŕρŗέŧ ўοùř ƒεєďьàçк ŝùčħ ãş ΉŖ Ραŕτлĕřŝ, ÿοũя mǻŋάġеŗ, äŉď/ȭŕ à mεлťòґ. 歴歴歴歴歴歴歴⟧",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "⟦용용 Ρőüя ỳöüřśёļƒ ã ĉцρ оƒ ċöƒƒêë ăŉď ďĭνę ιŋτό ýøųŕ ƒēëďьäčķ. 歴歴⟧",
                    "ABOUT_YOUR_REPORT_HEADER": "⟦용용용용용 Àьőŭτ Уőŭг ŕèροřţ 歴歴歴歴歴⟧",
                    "ABOUT_YOUR_REPORT_LINE1": "⟦용용용용용용용용용용용용용용용용용용 Шêļčömέ ťô γόũя 360 ƒěēďвâĉκ řèρόяŧ. Τнīş ϊŝ á ĝяєáτ òρρőѓŧŭňїţỳ τό ĝŕóẁ ąηď ďěνëļóρ ŷōųѓѕеĺƒ ăŝ ǻ ρѓòƒěѕşīοņąľ. Ій ȭѓďëя ťό ŝèŧ ÿομřŝęĺƒ ùρ ƒőř ŝųčćēşѕ ωнėп ġóìňġ ŧħяȭμğħ ґêŝŭĺŧѕ, âľļōώ ўōŭŗŝēļƒ ŝúƒƒï¢іёņŧ ţїmέ ŧο ĝø ŏνēŗ ţнє ƒëêďьāсκ. ₣ęέďвäćκ çάή ьē ďїƒƒïčūĺţ ŧò нěąř íηϊťίâĺĺÿ, вûť кëєρ ĭή mĭŋď ţнãţ ťħе ρúŕρőŝε øƒ ŧħϊś ƒёёďьǻ¢ķ íŝ ŧö åĉčєļēѓąŧε ÿσūŗ ġřσŵťĥ àήď ďěνëľορmεŉτ. 歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴⟧",
                    "ABOUT_YOUR_REPORT_LINE2": "⟦용용용 Äş ỳòû ġõ τнѓõüġħ ỳσűя гĕρоŕŧ, ĥεѓĕ ăŗė à ƒêŵ ŧħĭлĝś ŧö кëēρ ìŋ mìйď. 歴歴歴⟧",
                    "ADVANCED_FILTER": "⟦용용용용 Áďνǻŉćёď ₣įĺτєг 歴歴歴歴⟧",
                    "AGREEMENT_CHART": "⟦용용용용 Ãĝгέєmêητ çнàґτ 歴歴歴歴⟧",
                    "AGREEMENT_CHART_FOOTER": "⟦용용용용용용용용용 Ŧħē âġґėεmêήŧ ćĥäгţ īŉďîçăťёś ţĥê ѕįmϊĺâřϊτУ оƒ śċȭґëş. Ёαćĥ ďőτ ѓěρгęşèйťѕ нŏш íйďіνîďúàĺş яǻťëď ỳόų ƒøѓ ęα¢ĥ įťĕm. Ţħě şíźе ŏƒ ťĥέ ďöτ şħȭẁş ħòщ mαπŷ ѓåτéřş ĝâνē ÿοú ä śρéčíƒїč řãťίŋğ. 歴歴歴歴歴歴歴歴歴⟧",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "⟦용용용 ŗėŝρõлŝέś 歴歴歴⟧",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "⟦용용용 řĕşρòŋŝĕ 歴歴歴⟧",
                    "AGREEMENT_CHART_LEGEND_TITLE": "⟦용용용용용 Ħσω öţнέяŝ гåτёď Уøú 歴歴歴歴歴⟧",
                    "ALL": "⟦용 Ăļĺ 歴⟧",
                    "AVERAGE": "⟦용용 Ąνέґáğě 歴歴⟧",
                    "BOTTOM_BOX": "⟦용용용 Бοťτôm ßò× 歴歴歴⟧",
                    "CHOICE_COUNT": "⟦용용용 Çĥσĩčė Ćőцйţ 歴歴歴⟧",
                    "CHOICE_TOTALS": "⟦용용용 Ĉħôìçê Ťοταĺŝ 歴歴歴⟧",
                    "COMPARISON": "⟦용용용 Čømρäяίѕöŋ 歴歴歴⟧",
                    "COMPARISON_GAP_COLUMN_HEADER": "⟦용용용용 Ĉömρǻѓїşόń ġąρ 歴歴歴歴⟧",
                    "COMPLETED_RESPONSES": "⟦용용용용용 Ċòmρļέŧеď řêşρòпşέѕ 歴歴歴歴歴⟧",
                    "COUNT": "⟦용 Çȭμлţ 歴⟧",
                    "DEFAULT": "⟦용용 Ðęƒǻŭľţ 歴歴⟧",
                    "DEFAULT_TEXT": "⟦용용용 Ðëƒáűľŧ ŧε×τ 歴歴歴⟧",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "⟦용용용용 Ųņďегŝţâηď ŵħŏ ўōũя ƒεêďьαčк ïŝ çómιηğ ƒŕøm, щĥєťнеř íŧ’ŝ ρеėřѕ, ďīѓēçτ řеρòґţş, ĺеǻďеŗś, ëţč 歴歴歴歴⟧",
                    "DIFFERENT_EVALUATORS_HEADER": "⟦용용용용용 Ðĩƒƒегёņţ èνâľµäŧōѓş 歴歴歴歴歴⟧",
                    "DONE": "⟦용 Ðолě 歴⟧",
                    "DONT_HEADER": "⟦용용 Ðσŋ'τ: 歴歴⟧",
                    "DONT_LINE1": "⟦용용용 Τřÿ τò ƒϊĝŭŗě оūť ώĥо ѕăĩď ωĥąť 歴歴歴⟧",
                    "DONT_LINE2": "⟦용용용용 ₣őčúś õň õлě ρöşįτĩνè őŕ ήέġáťїνє ŝĉȭřё/čόmmėлť 歴歴歴歴⟧",
                    "DONT_LINE3": "⟦용용용용 Ĉřèàŧë ā ďěνęĺȭρmейť ρĺăи àŕőµŉď ενеяγ ĭŧëm 歴歴歴歴⟧",
                    "DONT_LINE4": "⟦용용 βе ďīśĉôūŗāğëď τĥατ Уσü нáνē σρρøřťμліťīёѕ ƒóѓ ιmρяôνėměητ 歴歴⟧",
                    "DO_HEADER": "⟦용 Ďø: 歴⟧",
                    "DO_LINE1": "⟦용용용용용 Ľøоķ ăť ƒêеďьαĉķ ĥõľįşţîçāļĺγ 歴歴歴歴歴⟧",
                    "DO_LINE2": "⟦용용용 ĪďêйţĭƒУ ťħëměѕ ϊη şťѓєиğτĥѕ ăňď óρρõŗţüйïŧīέś ƒȭґ ĩmρяονεmēŉť 歴歴歴⟧",
                    "DO_LINE3": "⟦용용 Ρřĩόгīťιżě ά ƒеω ƒòčũş âгєαś τö âďď τô γŏµг ďèνеĺōρmēπŧ ρļάи 歴歴⟧",
                    "DO_LINE4": "⟦용용 Ŭпďёŕśτάпď ţħάţ ěνеŕУóήë ħãŝ òρρόгτüηīŧĭёѕ ƒοя іmρŗȭνëmēņτ 歴歴⟧",
                    "FIELD": "⟦용 ₣ĭёľď 歴⟧",
                    "GAP": "⟦용 Ġâρ 歴⟧",
                    "GAP_CHART": "⟦용용용 Ğàρ сħǻґţ 歴歴歴⟧",
                    "GAP_CHART_DESCRIPTION": "⟦용용용용용용용용용용용용용용용용 Ťħė ĝàρ čнãѓτ ďíŝρĺąУś τħè ďīƒƒêяεŉĉė іл ŝçòřеş ьęŧωėêŉ τщò řáţεґ ġґőűρş. ₣ōґ ěхämρľĕ, ϊņ τĥê ċάśĕ òƒ śєļƒ-ґäŧįпğś νş. нõẃ óŧĥëřѕ řąτĕď ўоů, ă ρøŝīτįνē(+) ďίƒƒëřęπčé mёάňş οťĥєřŝ яάţęď ўȭŭ нīğнёѓ ŧнâň ţĥέ řåţĭлġ ŷŏц ρѓŏνīďėď ƒŏг ýσúřѕёĺƒ. Ā иёğăţïνè(-) ďιƒƒêґέň¢є mέąлŝ òŧнēŗş ŗǻťěď γȭų ĺôẁëѓ ŧħāή γȭų ρŕôνįďėď ƒŏŕ Уōûяѕėľƒ. 歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴⟧",
                    "GAP_CHART_FOOTER": "⟦용용용 Ŧнę ğáρ čнářť ĭŉďϊċáťěś ťнè +/- ďĩƒƒéŕεиçë ьėŧẁēěń ţẃö яąťęг ĝŗóűρŝ. 歴歴歴⟧",
                    "GAP_TABLE_DESCRIPTION": "⟦용용용용용용용용용용 Ήїďďėŋ ŝŧгęлġţнŝ ŝĥȭώś щħёŗë σţħέŕś ŗατěď ўõц нιġнёŗ τħãŉ ýóû ŗâţέď ŷöцŕśěļƒ. Âгęáş ƒσѓ іmρґονëmèňţ śħóẃѕ ωнěяε ŏτħêŕş гåŧέď ÿόü ļôẁêг ŧнαń γôū ŕāŧеď ўȭŭгşėľƒ. Бŏţĥ ŝēçŧιойѕ àгé ŕàикèď ƒŕöm ľăřġēşτ ťό ŝmåļľēśŧ ğåρ. 歴歴歴歴歴歴歴歴歴歴⟧",
                    "GAP_TABLE_FOOTER": "⟦용용용용용용용용용용 Τнę ƒĩяѕŧ ¢οľµmл óƒ şćоѓέş ĭиďί¢âţêś ħōщ ÿоû ŝĉóřēď ÿõцѓѕēļƒ. Ŧħė şĕĉόņď ĉøļŭmņ įйďíćâτёѕ τĥε ăνęяăğе şćòґе ôƒ óţнεѓѕ. Ţħě ŧħįгď ĉσľμmή îňďîċàτėś ŧнė ďīƒƒèґєňčέ вёťŵêеň ħŏẁ ỳȭù ѕçôŕéď ýòμřѕëľƒ āиď ĥȭώ ôτħέяś ś¢óгěď ўøŭ. 歴歴歴歴歴歴歴歴歴歴⟧",
                    "GAP_TABLE_TITLE": "⟦용용용 Ηίďďèŋ ѕţяēηĝŧħś/Ĩmρяȭνěmєŋţ ãґеäş 歴歴歴⟧",
                    "GROUP": "⟦용 Ĝѓȭũρ 歴⟧",
                    "HIDE_REPORT_ALERT": "⟦용용용용 Ŷôú ďò ņοτ mêèţ ŧħе ŗéqŭįгёmēŋŧѕ τō νïëш γоūŗ řéρȭґť. Čοпτãĉţ Уσûѓ őѓġåηϊźâŧϊōή àďmìηіşťгāŧôґ. 歴歴歴歴⟧",
                    "HIGHEST_SCORES": "⟦용용용용 Ηïğĥëѕŧ şčõґέŝ 歴歴歴歴⟧",
                    "HIGHLOW_TABLE": "⟦용용용용용 Ĥĭğħ ąňď ļõω śсöгêѕ 歴歴歴歴歴⟧",
                    "HIGHLOW_TABLE_FOOTER": "⟦용용용용용용용용용용용용용용용용용용용용용용 Ŧħιś şēсŧĩôи şĥōẃŝ ťħє ƒīνè ĥìĝĥέŝŧ ãиď ľσщеşτ гąτëď ьëĥâνìȭѓѕ (â¢řσŝѕ ãľĺ венāνīõѓś) ƒѓóm ţнє áρρļĩсâвľę яăťëŕ ĉāŧěġőгУ ανėґâĝêŝ. Τô ğéŧ ťħě mσśţ ƒгσm ťħïś ρãġε, ĭť ĩş ĥεĺρƒцĺ ťо ļőóķ ƒȭŗ ťřëйďś ţħǻτ måў êmёŗĝέ. ₣öѓ ĕхǻmρľę, ìƒ ťħє måĵȭгîţУ öƒ ŷόũř ĺøẁèśţ яàţèď ьěнāνįôŕŝ ăгë čόиċёňτŕãťєď ĭņ οňĕ ȭґ ŧщő çăτĕġŏѓīεŝ; ţħęşĕ mǻŷ ьê ǻŗèâѕ ϊй ηеёď őƒ ďένéĺöρmęńţ. Ťĥè ħϊġħëŝŧ řåτёď вęĥάνіõгѕ сáи ĭďêŋŧíƒў śťѓēňġţħś ţĥåť ¢άπ ьé ľένέгáĝёď íп ȭťнėг άŕêâś. 歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴歴⟧",
                    "HIGH_LOW_TABLE_DESCRIPTION": "⟦용용용용 Ţĥέ ніğĥ/ĺòш çнâяτ ďіśρļãỳś îţĕmş вáśéď οŉ τнё äŕèāş щнēŗë оŧнèѓş řǻτеď ÿôû ĥіĝĥēѕτ αńď ľòŵεśţ. 歴歴歴歴⟧",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "⟦용용용용 Ħöώ τо іиţέѓρŕęţ яėśųļτŝ àήď ďέτēѓmìле ä¢ťīöή: 歴歴歴歴⟧",
                    "ITEM": "⟦용 Ĭťεm 歴⟧",
                    "LOWEST_SCORES": "⟦용용용 Ľôẃеśŧ śčôřêѕ 歴歴歴⟧",
                    "MAX": "⟦용 Мä× 歴⟧",
                    "MEAN": "⟦용 Μêąŉ 歴⟧",
                    "MEDIAN": "⟦용용 Мёďϊąй 歴歴⟧",
                    "MIN": "⟦용 Мĭή 歴⟧",
                    "NEGATIVE_GAPS": "⟦용용용용 Αѓêåѕ ƒσя ιmρѓȭνĕmĕňţ 歴歴歴歴⟧",
                    "NO_COMPARISON_SET": "⟦용용용용용 Ņő ćòmρǻгíѕŏŉ śèţ 歴歴歴歴歴⟧",
                    "NO_DATA_AVAILABLE_WARNING": "⟦용용용용용 Ŋò ďäţα αναīĺάьļė 歴歴歴歴歴⟧",
                    "NO_FILTER_IS_APPLIED": "⟦용용용용 Ŋŏ ƒïĺţėŗ ìś áρρľïęď. 歴歴歴歴⟧",
                    "NO_VALUE": "⟦용용용 Иô νäľũє 歴歴歴⟧",
                    "NPS": "⟦용용용용용 Ńēţ Ρŕοmôτëř Ѕĉōѓě 歴歴歴歴歴⟧",
                    "OTHERS": "⟦용용 Θτнēřѕ 歴歴⟧",
                    "PERCENTAGE": "⟦용용용 Ρèгсēŋτâğε 歴歴歴⟧",
                    "PERCENTAGE_OF_CHOICES": "⟦용용용용 Ρęřčêпτάġε оƒ Ĉĥõіčęś 歴歴歴歴⟧",
                    "PERCENTAGE_OF_RESPONSES": "⟦용용용용 Ρèŕċěйŧãĝέ σƒ Ґëśρõņŝèѕ 歴歴歴歴⟧",
                    "PERCENT_COMPLETE": "⟦용용용 % ċómρľєťє 歴歴歴⟧",
                    "POSITIVE_GAPS": "⟦용용용용 Ĥίďďĕη śŧѓĕйğţнś 歴歴歴歴⟧",
                    "QUESTIONS": "⟦용용용 Qůéśτíõπś 歴歴歴⟧",
                    "RANK": "⟦용 Γǻήķ 歴⟧",
                    "RELATIONSHIPS": {
                        "ANYONE": "⟦용용 Ãиýōńë 歴歴⟧",
                        "DIRECT_REPORT": "⟦용용용 Ðīґеċţ Яеρŏŕţ 歴歴歴⟧",
                        "MANAGER": "⟦용용 Μàйăĝĕя 歴歴⟧",
                        "PEER": "⟦용 Ρêёř 歴⟧",
                        "SELF": "⟦용 Ŝēļƒ 歴⟧"
                    },
                    "REPORT_SUMMARY": "⟦용용용용 Ґĕρȭґτ ŝűmmάѓγ 歴歴歴歴⟧",
                    "REPORT_SUMMARY_TABLE_FOOTER": "⟦용용용용용 Ĉόmρąŕε ŧĥë ňµmвėŗ őƒ ρёόρĺє ωħõ ƒιŋīşħέď ÿőûŕ äşŝèѕśmёπŧ ţô ťне йŭmвėя ȭƒ ρёöρľê ïиνíτēď ţò ρåѓŧίĉĭρàτέ. 歴歴歴歴歴⟧",
                    "REPORT_SUMMARY_TABLE_HEADER": "⟦용용용용 Ѓέѕρőйďέηţ şţáτϊŝτïçş 歴歴歴歴⟧",
                    "RESPONSES": "⟦용용용 Яεѕρôήѕєś 歴歴歴⟧",
                    "RESPONSE_COUNT": "⟦용용용용용 {{responseCount}} Ѓěѕρόпѕëŝ 歴歴歴歴歴⟧",
                    "RESPONSE_COUNT_HTML": "⟦용용용 <span class='response-count-value'>{{responseCount}}</span> Ѓέşρόņѕèѕ 歴歴歴⟧",
                    "SCORING_CATEGORY": "⟦용용용용 Ѕ¢οгĩηğ çąτєğȭřÿ 歴歴歴歴⟧",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "⟦용용용용용 Ŋȭ ѓєşροπŝęŝ ƒȭг τħïѕ ¢áŧěĝóгŷ 歴歴歴歴歴⟧",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "⟦용용용용용 Ŋô ŕёśρòňѕеѕ ƒőґ ťħĩś qųēѕťїõл 歴歴歴歴歴⟧",
                    "SCORING_OVERVIEW": "⟦용용용용 Śčöŗíňĝ òνёřνιëω 歴歴歴歴⟧",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "⟦용용 Ỳöц áпď őţħєŕ ένáľμãŧőŕѕ ťнĭήκ ťнίş äŕěά їś â τȭρ şťŕеиġŧн. 歴歴⟧",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "⟦용용용용용 Ŗēćоğŉïźěď ѕţгєпġťħ 歴歴歴歴歴⟧",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "⟦용용용용용 Ā řέčōğηїżèď їmρґöνèměлţ âґêá mēăŉѕ śєļƒ-ґąťίήğ ǻήď гâτїпĝѕ ƒґőm őţнěґś âŗє вöťħ ьєľσщ ţĥě àνęґâĝє ƒоř ţнιѕ ĉómρéτёńčý. 歴歴歴歴歴⟧",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "⟦용용용용용 Яēċőĝπіżĕď ïmρŕόνěmèπŧ áѓęă 歴歴歴歴歴⟧",
                    "SCORING_OVERVIEW_DESCRIPTION": "⟦용용용용용용용 Âьòνε ăŕé ťħė čȭmρеţεлсíєş òŗ вęĥåνĩόřś ŧħăτ ÿőû ẃëŕè єνǻļũàţèď оπ άş α ρāřť öƒ ŧнïś múļťī-гαŧėг ƒєеďьαčк ρŕоçêşş. Ċômρàяιşõп ґáţìŋğѕ āѓĕ ρѓòνĩďéď вŷ ġгóŭρ. 歴歴歴歴歴歴歴⟧",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "⟦용용용 Мĩηìmŭm ġãρ 歴歴歴⟧",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "⟦용용용 Мįπιmμm ďϊƒƒĕѓėиčё вêτẃèеп ŕέƒěŕęŋċε ĝяŏųρѕ ƒοѓ τě×τѕ ťσ вë ŝнóŵņ. 歴歴歴⟧",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "⟦용용용용용 Ðϊѕρĺąўĕď īś ţĥê ѓãņĝè ŏƒ ŝčôѓέŝ ƒõг еα¢ħ ćоmρёτêήçý/ьęĥäνìôґ. Ŧħé ьàѓ яёρѓēśéπţś ťĥé πůmēŕîċãĺ ανеŗâğė. 歴歴歴歴歴⟧",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "⟦용용용용 Ūπґєćόĝиіżèď śţřèňġŧĥ ċőmėş ƒгοm ďìś¢ŕéρàηçỳ вετŵееņ τħĕ ѕеļƒ-ґáţιņĝ αлď τнê ŕάťĩηğş ƒгőm őτнéѓŝ. 歴歴歴歴⟧",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "⟦용용용용 Ūŉѓĕćőğήïźēď ŝţŗέŉġŧħ 歴歴歴歴⟧",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "⟦용용용용용 Ũńґєĉοğпіźëď їmρяöνєmеŋŧ âřèα çőmêş ƒŕοm ďϊѕĉŕєρáπсγ ьеťŵėêņ ŧнê śėļƒ-řãŧíиġ αиď ŧĥè ŕãŧĩńğѕ ƒřσm оŧħέяѕ. 歴歴歴歴歴⟧",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "⟦용용용용용 Ûπяėċōğлĭźēď ímρяøνеmёйŧ àяèã 歴歴歴歴歴⟧",
                    "SELF": "⟦용 Ŝēļƒ 歴⟧",
                    "SELF_ASSESSMENT": "⟦용용용용 Şεļƒ-àŝśěşśmèηţ 歴歴歴歴⟧",
                    "STANDARD_DEVIATION": "⟦용용용용용 Şτăηďãŗď Ďеνїǻţîȭп 歴歴歴歴歴⟧",
                    "SUM": "⟦용 Ѕùm 歴⟧",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "⟦용용용 ₣αmíļíąѓіżë ỳόûŗśєļƒ ώìŧн ťнē гǻţĩηğ śċάĺė ŧõ ėŉŝůґė ąćčμґàťë îήţēґρřёŧàťīōń 歴歴歴⟧",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "⟦용용용용 Ťąķè ήóτё ȭƒ ťнè śĉâľĕ 歴歴歴歴⟧",
                    "THINGS_YOU_WILL_SEE_HEADER": "⟦용용용용용 Τнíŉğŝ ýоμ ŵїĺļ ѕęе: 歴歴歴歴歴⟧",
                    "THREE_SIXTY_PERCENTILE": "⟦용용용 Ρëг¢ėиţīľē 歴歴歴⟧",
                    "TOP_BOTTOM_BOX": "⟦용용용용용 Τōρ Бŏх / βõτţŏm ßόх 歴歴歴歴歴⟧",
                    "TOP_BOX": "⟦용용 Ţоρ Βόх 歴歴⟧",
                    "TOTAL": "⟦용 Ťøτăļ 歴⟧",
                    "TO_DO": "⟦용 Ţő ďõ 歴⟧",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "⟦용용용 Qūåļįţàŧïνє: Ŧнїś ƒêέďвãčκ ẁïľļ ьę ίŉ ŧнє ƒôгm ŏƒ ōρēņ ťé×τ ¢ømmèπţś 歴歴歴⟧",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "⟦용용용용용 Qŭäņŧïťâťįνē: Ŧнįѕ ƒеёďьαçķ ẃïĺľ ьĕ ŉŭmеŗίċáľ, ãňď ċóŭļď вé ŕĕρŗéśěηŧěď îπ ġŕǻρĥŝ, ьāґ ćħǻѓτś, τåьĺєŝ, ёτć. 歴歴歴歴歴⟧",
                    "TYPES_OF_FEEDBACK_HEADER": "⟦용용용용 Vãŕĭöųѕ τŷρĕŝ öƒ ƒëеďвǻçĸ 歴歴歴歴⟧",
                    "VALUE": "⟦용 Vâļμĕ 歴⟧",
                    "VARIANCE": "⟦용용용 Vάŗίàηčε 歴歴歴⟧",
                    "YOUR_RATINGS": "⟦용용용 Ỳóцґ ŕăţіŉğś 歴歴歴⟧"
                },
                "REPORT_SUMMARY": "⟦용용용용 Ґĕρȭґτ ŝűmmάѓγ 歴歴歴歴⟧",
                "REPORT_SUMMARY_TABLE_FOOTER": "⟦용용용용용 Ĉόmρąŕε ŧĥë ňµmвėŗ őƒ ρёόρĺє ωħõ ƒιŋīşħέď ÿőûŕ äşŝèѕśmёπŧ ţô ťне йŭmвėя ȭƒ ρёöρľê ïиνíτēď ţò ρåѓŧίĉĭρàτέ. 歴歴歴歴歴⟧",
                "REPORT_SUMMARY_TABLE_HEADER": "⟦용용용용 Ѓέѕρőйďέηţ şţáτϊŝτïçş 歴歴歴歴⟧",
                "RESET": "⟦용 Γéśёτ 歴⟧",
                "RESPONDENT_TOTALS": "⟦용용용용용 Řεśρȭήďєńŧ Ţőťáĺѕ 歴歴歴歴歴⟧",
                "RESPONSES": "⟦용용용 Яεѕρôήѕєś 歴歴歴⟧",
                "RESPONSE_COUNT": "⟦용용용용용 {{responseCount}} Ѓěѕρόпѕëŝ 歴歴歴歴歴⟧",
                "RESPONSE_COUNT_HTML": "⟦용용용 <span class='response-count-value'>{{responseCount}}</span> Ѓέşρόņѕèѕ 歴歴歴⟧",
                "RESULT": "⟦용용 Řèѕųľţ 歴歴⟧",
                "REVERSE_COLORS": "⟦용용용용 Řĕνėяŝę Ĉóļòяş 歴歴歴歴⟧",
                "ROW_TOTALS": "⟦용용용 Ŕôẃ Τõţàľş 歴歴歴⟧",
                "SAVE": "⟦용 Şάνе 歴⟧",
                "SAVE_AND_APPLY": "⟦용용용용 Ŝάνę ãηď άρρĺŷ 歴歴歴歴⟧",
                "SCORING_CATEGORY": "⟦용용용용 Ѕ¢οгĩηğ çąτєğȭřÿ 歴歴歴歴⟧",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "⟦용용용용용 Ŋȭ ѓєşροπŝęŝ ƒȭг τħïѕ ¢áŧěĝóгŷ 歴歴歴歴歴⟧",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "⟦용용용용용 Ŋô ŕёśρòňѕеѕ ƒőґ ťħĩś qųēѕťїõл 歴歴歴歴歴⟧",
                "SCORING_OVERVIEW": "⟦용용용용 Śčöŗíňĝ òνёřνιëω 歴歴歴歴⟧",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "⟦용용 Ỳöц áпď őţħєŕ ένáľμãŧőŕѕ ťнĭήκ ťнίş äŕěά їś â τȭρ şťŕеиġŧн. 歴歴⟧",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "⟦용용용용용 Ŗēćоğŉïźěď ѕţгєпġťħ 歴歴歴歴歴⟧",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "⟦용용용용용 Ā řέčōğηїżèď їmρґöνèměлţ âґêá mēăŉѕ śєļƒ-ґąťίήğ ǻήď гâτїпĝѕ ƒґőm őţнěґś âŗє вöťħ ьєľσщ ţĥě àνęґâĝє ƒоř ţнιѕ ĉómρéτёńčý. 歴歴歴歴歴⟧",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "⟦용용용용용 Яēċőĝπіżĕď ïmρŕόνěmèπŧ áѓęă 歴歴歴歴歴⟧",
                "SCORING_OVERVIEW_DESCRIPTION": "⟦용용용용용용용 Âьòνε ăŕé ťħė čȭmρеţεлсíєş òŗ вęĥåνĩόřś ŧħăτ ÿőû ẃëŕè єνǻļũàţèď оπ άş α ρāřť öƒ ŧнïś múļťī-гαŧėг ƒєеďьαčк ρŕоçêşş. Ċômρàяιşõп ґáţìŋğѕ āѓĕ ρѓòνĩďéď вŷ ġгóŭρ. 歴歴歴歴歴歴歴⟧",
                "SCORING_OVERVIEW_MINIMUM_GAP": "⟦용용용 Мĩηìmŭm ġãρ 歴歴歴⟧",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "⟦용용용 Мįπιmμm ďϊƒƒĕѓėиčё вêτẃèеп ŕέƒěŕęŋċε ĝяŏųρѕ ƒοѓ τě×τѕ ťσ вë ŝнóŵņ. 歴歴歴⟧",
                "SCORING_OVERVIEW_TABLE_FOOTER": "⟦용용용용용 Ðϊѕρĺąўĕď īś ţĥê ѓãņĝè ŏƒ ŝčôѓέŝ ƒõг еα¢ħ ćоmρёτêήçý/ьęĥäνìôґ. Ŧħé ьàѓ яёρѓēśéπţś ťĥé πůmēŕîċãĺ ανеŗâğė. 歴歴歴歴歴⟧",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "⟦용용용용 Ūπґєćόĝиіżèď śţřèňġŧĥ ċőmėş ƒгοm ďìś¢ŕéρàηçỳ вετŵееņ τħĕ ѕеļƒ-ґáţιņĝ αлď τнê ŕάťĩηğş ƒгőm őτнéѓŝ. 歴歴歴歴⟧",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "⟦용용용용 Ūŉѓĕćőğήïźēď ŝţŗέŉġŧħ 歴歴歴歴⟧",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "⟦용용용용용 Ũńґєĉοğпіźëď їmρяöνєmеŋŧ âřèα çőmêş ƒŕοm ďϊѕĉŕєρáπсγ ьеťŵėêņ ŧнê śėļƒ-řãŧíиġ αиď ŧĥè ŕãŧĩńğѕ ƒřσm оŧħέяѕ. 歴歴歴歴歴⟧",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "⟦용용용용용 Ûπяėċōğлĭźēď ímρяøνеmёйŧ àяèã 歴歴歴歴歴⟧",
                "SELECT_CATEGORIES": "⟦용용용 Ρļέäѕё ѕεľĕ¢ŧ Śçоѓîηğ Ćάτēğóŗìěŝ... 歴歴歴⟧",
                "SELECT_CATEGORY": "⟦용용용 Ρľęãśë ѕёľеćţ á Ѕčøŕϊлĝ Čáŧеĝοŕγ... 歴歴歴⟧",
                "SELECT_CONDITION_TYPE": "⟦용용용용 Ѕëļεçτ ¢óήďìţìŏή ŧỳρĕ 歴歴歴歴⟧",
                "SELECT_DATA_SOURCE": "⟦용용용용용 Ѕεĺęçť ďαŧä ѕóµѓčє 歴歴歴歴歴⟧",
                "SELECT_DATA_SOURCE_TYPE": "⟦용용용용 Şęĺēċţ ďαţá ѕόµŕćė ţўρė 歴歴歴歴⟧",
                "SELECT_FILTER": "⟦용용용 Ѕéĺēсť ƒįľŧěŕ 歴歴歴⟧",
                "SELECT_FILTERS": "⟦용용용용 Śěĺęçŧ ƒιĺτęяś 歴歴歴歴⟧",
                "SELECT_OPERATOR_TYPE": "⟦용용용용용 Śėľèćţ òρεŗáŧøř ţўρё 歴歴歴歴歴⟧",
                "SELECT_PERSON": "⟦용용용 Ѕεĺεсŧ ρέŕşσņ 歴歴歴⟧",
                "SELECT_PERSON_METADATA": "⟦용용용용 Ŝєĺėçť ρέгŝόή mĕťαďàτá 歴歴歴歴⟧",
                "SELECT_QUESTION": "⟦용용용용 Şęľęćŧ qűεşťĩóл 歴歴歴歴⟧",
                "SELECT_QUESTIONS": "⟦용용용용용 Ρĺéăśĕ ŝêľėĉť Qűéŝŧįŏпѕ... 歴歴歴歴歴⟧",
                "SELECT_RATIO_OR_DROPOFF": "⟦용용용용 Śёľë¢ť яāťϊõ ōя ďяσρоƒƒ 歴歴歴歴⟧",
                "SELECT_RELATIONSHIP": "⟦용용용용용 Ŝέĺεċť гęļάŧīøŋŝнìρ 歴歴歴歴歴⟧",
                "SELECT_SCORING_CATEGORY": "⟦용용용용 Śéľе¢τ ś¢őŗίńğ сãτέĝóґỳ 歴歴歴歴⟧",
                "SELF": "⟦용 Ŝēļƒ 歴⟧",
                "SELF_ASSESSMENT": "⟦용용용용 Şεļƒ-àŝśěşśmèηţ 歴歴歴歴⟧",
                "SEQUENTIAL": "⟦용용용 Ѕĕqŭέиτįäľ 歴歴歴⟧",
                "SETUP_COMPARISON": "⟦용용용용 Śĕťũρ čőmρǻяĩśσй 歴歴歴歴⟧",
                "SETUP_COMPARISONS": "⟦용용용용용 Şēτúρ ¢õmρăгïşοńş 歴歴歴歴歴⟧",
                "SET_START_COLOR": "⟦용용용용 Śęτ Şŧáгť Ĉσļȭя 歴歴歴歴⟧",
                "SHOULD_SHOW_FOOTER": "⟦용용용 Şĥσщ ₣őȭţēŗ 歴歴歴⟧",
                "SHOULD_SHOW_SCORING_CATEGORY": "⟦용용용용 Śĥσώ Śćóřìήğ Çāťęğоřγ 歴歴歴歴⟧",
                "SHOWING_RECORDS_OF": "⟦용용용용용 Śħσωïňĝ ŕěčôŗďş %1 - %2 όƒ %3 歴歴歴歴歴⟧",
                "SHOW_COMPARISON_GAP": "⟦용용용용용 Ѕħŏш ĉοmρâяіśõŉ ğáρ сόĺμmй 歴歴歴歴歴⟧",
                "SHOW_DATA_LABEL": "⟦용용용용 Śĥōώ ďąťà νãľũεŝ 歴歴歴歴⟧",
                "SHOW_PERCENTAGES": "⟦용용용용 Śнош Ρεŗċέйťăğêѕ 歴歴歴歴⟧",
                "SHOW_THE_FOLLOWING_TEXT": "⟦용용용용용 Ťнĕπ ѕĥóώ ŧħе ƒσľļõщĭŋğ ŧë×ť 歴歴歴歴歴⟧",
                "SHOW_TIES": "⟦용용용 Ŝнõщ Τîёѕ 歴歴歴⟧",
                "SHOW_X_AXIS": "⟦용용용 Ѕĥȭω Х Āхíѕ 歴歴歴⟧",
                "SHOW_Y_AXIS": "⟦용용용 Şħσŵ Ŷ Â×ìѕ 歴歴歴⟧",
                "SMALL_LABELS": "⟦용용용 Şmåļľ Ļåвéļŝ 歴歴歴⟧",
                "SORT": "⟦용 Śòѓŧ 歴⟧",
                "SPLINE": "⟦용용 Śρľîŉë 歴歴⟧",
                "STACK_CHART": "⟦용용용 Ѕŧăċĸ Ćĥăŗţ 歴歴歴⟧",
                "STANDARD_DEVIATION": "⟦용용용용용 Şτăηďãŗď Ďеνїǻţîȭп 歴歴歴歴歴⟧",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "⟦용용용용용 Шęåκйέşѕ ĺĕşş τнåŉ 歴歴歴歴歴⟧",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "⟦용용용용용 Ĕďíŧ ţħгēŝĥőļď ŧĕ×ŧś 歴歴歴歴歴⟧",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "⟦용용용용 Τняέśĥόĺď ţêхτś 歴歴歴歴⟧",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "⟦용용용용 Èŉάвļĕ τħѓĕşħøĺď ŧė×ţś 歴歴歴歴⟧",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "⟦용용용용용 Ŝťяёπğτĥ möŕè ţħăň 歴歴歴歴歴⟧",
                "SUM": "⟦용 Ѕùm 歴⟧",
                "SUMMARY": "⟦용용 Ѕůmmåѓỳ 歴歴⟧",
                "TABLES": "⟦용용 Ťåьľëѕ 歴歴⟧",
                "TABLE_TOTALS": "⟦용용용 Ţąвĺé Ťõţαĺŝ 歴歴歴⟧",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "⟦용용용 ₣αmíļíąѓіżë ỳόûŗśєļƒ ώìŧн ťнē гǻţĩηğ śċάĺė ŧõ ėŉŝůґė ąćčμґàťë îήţēґρřёŧàťīōń 歴歴歴⟧",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "⟦용용용용 Ťąķè ήóτё ȭƒ ťнè śĉâľĕ 歴歴歴歴⟧",
                "TEXT": "⟦용 Τè×τ 歴⟧",
                "THINGS_YOU_WILL_SEE_HEADER": "⟦용용용용용 Τнíŉğŝ ýоμ ŵїĺļ ѕęе: 歴歴歴歴歴⟧",
                "TOP_BOTTOM_BOX": "⟦용용용용용 Τōρ Бŏх / βõτţŏm ßόх 歴歴歴歴歴⟧",
                "TOP_BOX": "⟦용용 Ţоρ Βόх 歴歴⟧",
                "TOTAL": "⟦용 Ťøτăļ 歴⟧",
                "TOTAL_COUNTS": "⟦용용용 Τōţáľ Ċŏµŋťŝ 歴歴歴⟧",
                "TO_DO": "⟦용 Ţő ďõ 歴⟧",
                "TRANSPOSE": "⟦용용용 Τŕąйѕρôśĕ 歴歴歴⟧",
                "TRANSPOSE_TABLE": "⟦용용용용 Ţяαйşρōŝє ťàвľе 歴歴歴歴⟧",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "⟦용용용 Qūåļįţàŧïνє: Ŧнїś ƒêέďвãčκ ẁïľļ ьę ίŉ ŧнє ƒôгm ŏƒ ōρēņ ťé×τ ¢ømmèπţś 歴歴歴⟧",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "⟦용용용용용 Qŭäņŧïťâťįνē: Ŧнįѕ ƒеёďьαçķ ẃïĺľ ьĕ ŉŭmеŗίċáľ, ãňď ċóŭļď вé ŕĕρŗéśěηŧěď îπ ġŕǻρĥŝ, ьāґ ćħǻѓτś, τåьĺєŝ, ёτć. 歴歴歴歴歴⟧",
                "TYPES_OF_FEEDBACK_HEADER": "⟦용용용용 Vãŕĭöųѕ τŷρĕŝ öƒ ƒëеďвǻçĸ 歴歴歴歴⟧",
                "UNDO": "⟦용 Ŭлďȭ 歴⟧",
                "USE_COMPARISON": "⟦용용용용 Ũѕê čŏmρǻŗîśőη 歴歴歴歴⟧",
                "USE_LABELS_FOR_SCALES": "⟦용용용용 Џŝë ļåьёľŝ ƒόŗ śċαľеŝ 歴歴歴歴⟧",
                "VALUES": "⟦용용 Väľůёś 歴歴⟧",
                "VALUE_RANGES": "⟦용용용 Vάľũè Ѓàйğєѕ 歴歴歴⟧",
                "VARIANCE": "⟦용용용 Vάŗίàηčε 歴歴歴⟧",
                "VERTICAL": "⟦용용용 Vëяţїçαļ 歴歴歴⟧",
                "VERTICAL_RANGE": "⟦용용용용 Vĕѓŧìсαļ Řαлġê 歴歴歴歴⟧",
                "WARNING_DATA_OUT_OF_RANGE": "⟦용용용용 Ẁāѓπĩŉġ: ďăţà νàļúę ê×ċεèďś řâńĝė ċôпƒįğųгäţïòň 歴歴歴歴⟧",
                "WIDGET_ERROR": {
                    "ERROR": "⟦용용용 Ǻи ùňē×ρėсτëď έŕгōѓ ĥáѕ ŏĉċцѓŗёď 歴歴歴⟧",
                    "MISCONFIGURED": "⟦용용용 Τħìś ŵїďġēτ ιѕ пóţ čóήƒιġûŗеď čŏŕяĕčŧľў. Ρļєăśë ćнēçк ýõμг ẁíďġєť ¢őňƒіġûяǻţĩöń. 歴歴歴⟧",
                    "NEW": "⟦용용용용 Ρĺēάѕє ĉóňƒίġůŗě ẁїďğēť 歴歴歴歴⟧",
                    "NO_DATA": "⟦용용용용 Ŋø ďάťà ƒõůиď - ýоũг ƒīĺŧéŕş màý вě ţóо é×ćļüşîνе! 歴歴歴歴⟧"
                },
                "WIDGET_NAME": {
                    "BAR": "⟦용용용 ßäř Çĥăŕť 歴歴歴⟧",
                    "BREAKDOWNBAR": "⟦용용용 βѓėåĸďőẁπ Бāѓ 歴歴歴⟧",
                    "DATA_TABLE": "⟦용용용 Ďäŧά Ţáвľē 歴歴歴⟧",
                    "FUNNEL_CHART": "⟦용용용 ₣üŋŋěļ Čĥäřτ 歴歴歴⟧",
                    "GAUGE": "⟦용용용 Ğάüğё Čĥαґτ 歴歴歴⟧",
                    "GRID": "⟦용용용 Γεŝûľţś Τáьľè 歴歴歴⟧",
                    "HEATMAP": "⟦용용용 Ĥèåτ Μâρ 歴歴歴⟧",
                    "LINE": "⟦용용용 Ľîŋè Ĉнãяţ 歴歴歴⟧",
                    "NEEDS_BASED": "⟦용용용 Иêêďѕ ßâşеď 歴歴歴⟧",
                    "PIE": "⟦용용용 Ρĭε Ćħάřŧ 歴歴歴⟧",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "⟦용용용 Ρŕîčě Σŝτįmåťòŗ (Vāň Щёŝţёηďőѓρ) 歴歴歴⟧",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "⟦용용용 Ŕéνęŉµě Мα×ĭmιżёŕ (Ġâьσŗ Ġяǻпĝěя) 歴歴歴⟧",
                    "SCORING_OVERVIEW_CHART": "⟦용 Ĉнάґť 歴⟧",
                    "SCORING_OVERVIEW_TABLE": "⟦용 Τάьĺё 歴⟧",
                    "STATS_TABLE": "⟦용용용용 Śťǻŧϊŝťι¢ŝ Ţâвļë 歴歴歴歴⟧",
                    "WORDCLOUD": "⟦용용용 Шоŗď Çļŏμď 歴歴歴⟧"
                },
                "WORD_ROTATION": "⟦용용용 Шôяď яȭŧâŧϊőη 歴歴歴⟧",
                "WORD_SPACING": "⟦용용용 Ẁōґď śρåсιŉğ 歴歴歴⟧",
                "YES": "⟦용 Υεş 歴⟧",
                "YOUR_RATINGS": "⟦용용용 Ỳóцґ ŕăţіŉğś 歴歴歴⟧"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "⟦용 Ăďď 歴⟧",
                "ADD_A_WORD": "⟦용용용 Âďď α шσѓď 歴歴歴⟧",
                "COLOR": "⟦용 Čóľόŗ 歴⟧",
                "DELETE_ALL": "⟦용용용 Ďёļéţε ąĺĺ 歴歴歴⟧",
                "EDIT_STOP_WORDS": "⟦용용용용 Êďîŧ Ѕťőρ Ŵöѓďѕ 歴歴歴歴⟧",
                "MAX_WORDS": "⟦용용용 Мă× Ŵοґďś 歴歴歴⟧",
                "ROTATION_ANGLED": "⟦용용 Ąйğľēď 歴歴⟧",
                "ROTATION_HORIZONTAL": "⟦용용용 Ηőгїżȭńτåļ 歴歴歴⟧",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "⟦용용용용 Ηŏґīżŏŉťǻľ ãиď Vєяŧιĉαľ 歴歴歴歴⟧",
                "WORD_ORIENTATION": "⟦용용용용 Ẁŏŕď Òřίéлŧâţĭοŋ 歴歴歴歴⟧"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "⟦용용용용용 Βãćķĝяöµпď Ĉöĺоřŝ 歴歴歴歴歴⟧",
                "DISPLAY_OPTIONS": "⟦용용용용 Ðīśρĺάŷ Öρτìоиŝ 歴歴歴歴⟧",
                "INVERT_FONT_COLORS": "⟦용용용 Íņνеŕŧ Ŀōώ Ĉõлŧгăѕŧ ₣όŋť Ċôĺοѓş 歴歴歴⟧",
                "PAGE": "⟦용 Ρàğе 歴⟧",
                "PAGINATE": "⟦용용용 Ρãġíńăŧê 歴歴歴⟧"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "⟦용 Μêąŉ 歴⟧",
                "BOTTOM_BOX_METRIC": "⟦용용용 Бοťτôm ßò× 歴歴歴⟧",
                "COLUMNS": "⟦용용 Çŏļŭmŋŝ 歴歴⟧",
                "COUNT_METRIC": "⟦용용용용 Ţôťáľ Γèşρσйѕеś 歴歴歴歴⟧",
                "FIELD_NAME": "⟦용 ₣ĭёľď 歴⟧",
                "MAX_METRIC": "⟦용용 Мά×ϊmům 歴歴⟧",
                "MIN_METRIC": "⟦용용 Міńϊmüm 歴歴⟧",
                "SHOW_RECODES": "⟦용용용용용 Şħöш Ѓě¢őďé Vǻļūέś 歴歴歴歴歴⟧",
                "SHOW_ROW_NUMBERS": "⟦용용용용 Ѕнòẁ Ґöẁ Иµmвёґś 歴歴歴歴⟧",
                "STD_DEV_METRIC": "⟦용용용 Şţď Ðενĩǻτįòŋ 歴歴歴⟧",
                "TOP_BOX_METRIC": "⟦용용 Ţоρ Βόх 歴歴⟧",
                "TRANSPOSE_BREAKOUTS": "⟦용용용용용 Τяąиŝρőѕê Бѓěąкоµţŝ 歴歴歴歴歴⟧",
                "TRANSPOSE_TABLE": "⟦용용용용 Ŧяǻйśρòşё Ťąьĺе 歴歴歴歴⟧",
                "VAR_METRIC": "⟦용용용 Vάŗίàηčε 歴歴歴⟧"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "⟦용용용용용 Ãďďίţíоиάľ Ĉôĺµmήş 歴歴歴歴歴⟧",
                "ADD_COLUMNS": "⟦용용용용 Áďď Äďďíţïõŉàľ Ĉöľųmňŝ 歴歴歴歴⟧",
                "ADD_CUSTOM_PALETTE": "⟦용용용용용 Ãďď Ċųśτοm Ράĺеţτē 歴歴歴歴歴⟧",
                "ALL_CHOICES": "⟦용용용 Áľľ Çнöíçеş 歴歴歴⟧",
                "ALL_GROUPS": "⟦용용용 Ăļļ Ġѓóµρѕ 歴歴歴⟧",
                "ALL_RECODES": "⟦용용용 Ãļļ Ŕεĉòďęş 歴歴歴⟧",
                "AUTOMATIC": "⟦용용 Ðęƒǻŭľţ 歴歴⟧",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "⟦용용용용 Ďěƒāůļτ - Ćļϊçк ťò έďĩτ 歴歴歴歴⟧",
                "AXIS_VALUES": "⟦용용용 Ą×ϊŝ Vāĺùёŝ 歴歴歴⟧",
                "BREAKOUT_BY": "⟦용용용 Бŗêåĸöцŧ Бγ 歴歴歴⟧",
                "CANCEL": "⟦용용 Çãйсęĺ 歴歴⟧",
                "CATEGORICAL": "⟦용용용 Ćăτéğôѓįçąĺ 歴歴歴⟧",
                "CHOICES": "⟦용용 Çĥоì¢éś 歴歴⟧",
                "CHOICE_COUNT": "⟦용용용 Çĥσĩčė Ćőцйţ 歴歴歴⟧",
                "COLOR_PALETTE": "⟦용용용 Çόĺόř Ραľëţţè 歴歴歴⟧",
                "COLUMN_VALUES": "⟦용용용 Ĉоļümň Vàĺûêś 歴歴歴⟧",
                "CONTACT_FIELDS": "⟦용용용용 Ćοйťά¢ŧ ₣íěľďś 歴歴歴歴⟧",
                "COUNT": "⟦용 Çȭμлţ 歴⟧",
                "CREATE": "⟦용용 Ċяěäŧé 歴歴⟧",
                "CUSTOM": "⟦용용 Ĉũşţőm 歴歴⟧",
                "CUSTOM_PALETTE": "⟦용용용용 Çμŝţȭm Ρąĺëτţе 歴歴歴歴⟧",
                "DATA_SOURCE": "⟦용용용 Ďāτǻ Ŝόüřĉê 歴歴歴⟧",
                "DAY": "⟦용 Ďâў 歴⟧",
                "DAY_OF_WEEK": "⟦용용용 Ďáγ ōƒ Щēēκ 歴歴歴⟧",
                "DECIMAL_PRECISION": "⟦용용용용 Ðеčίmāľ Ρļǻ¢éŝ 歴歴歴歴⟧",
                "DEFAULT": "⟦용용 Ðęƒǻŭľţ 歴歴⟧",
                "DISABLED": "⟦용용용 Ďīŝãвļėď 歴歴歴⟧",
                "DIVERGENT": "⟦용용용 Ðĩνεŗĝёήţ 歴歴歴⟧",
                "EDIT_CUSTOM_PALETTE": "⟦용용용용용 Ęďίτ Ċùśτōm Ρǻļëτţе 歴歴歴歴歴⟧",
                "ENABLED": "⟦용용 Еńǻьľèď 歴歴⟧",
                "ERROR_LOADING_DATA": "⟦용용용용용 Еягоѓ ĺσāďíňġ ďǻţą 歴歴歴歴歴⟧",
                "FILE_SIZE": "⟦용 Ѕϊźе 歴⟧",
                "FILE_TYPE": "⟦용 Τýρē 歴⟧",
                "FRI": "⟦용 ₣ѓî 歴⟧",
                "FRIDAY": "⟦용용 ₣ѓϊďάў 歴歴⟧",
                "GROUP_DATE_BY": "⟦용용용 Ġґōûρ Ðáŧę Бŷ 歴歴歴⟧",
                "HOUR_OF_DAY": "⟦용용용 Ηōцŗ ŏƒ Ðâỳ 歴歴歴⟧",
                "LENGEND_VALUES": "⟦용용용 Ľεĝёńď Vαļůεś 歴歴歴⟧",
                "MAX": "⟦용 Мä× 歴⟧",
                "MEAN": "⟦용 Μêąŉ 歴⟧",
                "MIN": "⟦용 Мĭή 歴⟧",
                "MISCONFIGURED_DATA": "⟦용용용용 Ðáŧá ѕöцŗсë mĭś¢õňƒιĝцґєď ƒõŗ ťħìş νĩśũāļĩżάťìôи. 歴歴歴歴⟧",
                "MISCONFIGURED_FILTERS": "⟦용용용용용 Įńνàľïď ₣ϊļţęŗ(ś) 歴歴歴歴歴⟧",
                "MODIFY_CUSTOM_PALETTES": "⟦용용용용 Μőďίƒў Ĉцѕτòm Ραľęţŧέś 歴歴歴歴⟧",
                "MON": "⟦용 Мöņ 歴⟧",
                "MONDAY": "⟦용용 Μøŋďáŷ 歴歴⟧",
                "MONTH": "⟦용 Мôпťħ 歴⟧",
                "NONE": "⟦용 Ňòле 歴⟧",
                "NO_FILE_ID_ERROR": "⟦용용 Τĥįş νїѕűάľіżăťĭôπ ŗěqŭïŗεş âŋ ímàġé ŧŏ вè ѕėţ ĩи ŧĥė ŝüŕνеў 歴歴⟧",
                "NO_RESULTS_TO_SHOW": "⟦용용용용용 Ņò ŗєşųľţş ťö ѕнöẁ 歴歴歴歴歴⟧",
                "NPS": "⟦용용용용용 Ņëţ Ρřőmόŧéř Şçŏŕē® 歴歴歴歴歴⟧",
                "NPS_GROUP": "⟦용용용 ŃΡŞ® ġřόцρ 歴歴歴⟧",
                "NUMERIC_VALUE": "⟦용용용 Иūmєŕįč Vãļùέ 歴歴歴⟧",
                "PALETTE_REMOVED": "⟦용용용용 Ρáľėτţê Ѓεmονέď 歴歴歴歴⟧",
                "PERCENTAGE": "⟦용용용 Ρèгсēŋτâğε 歴歴歴⟧",
                "PERCENTAGE_OF_CHOICES": "⟦용용용용 Ρęřčêпτάġε оƒ Ĉĥõіčęś 歴歴歴歴⟧",
                "PERCENTAGE_OF_RESPONSES": "⟦용용용용 Ρèŕċěйŧãĝέ σƒ Ґëśρõņŝèѕ 歴歴歴歴⟧",
                "QUARTER": "⟦용용 Qцąяŧëŕ 歴歴⟧",
                "REMOVE": "⟦용용 Ŕëmσνé 歴歴⟧",
                "RESPONSE_COUNT": "⟦용용용용 Яėşρŏŋѕé Ćȭüиť 歴歴歴歴⟧",
                "RESULTS_PER_PAGE": "⟦용용용용 Ѓėŝùľţś ρęř ράğë 歴歴歴歴⟧",
                "RETRIEVING_DATA_ELLIPSIS": "⟦용용용용용 Ŗėťřïēνîиĝ ďάŧá... 歴歴歴歴歴⟧",
                "REVERSE_COLORS": "⟦용용용용 Řĕνėяŝę Ĉóļòяş 歴歴歴歴⟧",
                "ROW_VALUES": "⟦용용용 Яσш Vâļцêѕ 歴歴歴⟧",
                "SAT": "⟦용 Śāŧ 歴⟧",
                "SATURDAY": "⟦용용용 Śåţцгďάŷ 歴歴歴⟧",
                "SAVE": "⟦용 Şάνе 歴⟧",
                "SELECTED_CHOICE": "⟦용용용용 Ŝеĺê¢ţëď Čĥõі¢ē 歴歴歴歴⟧",
                "SELECT_FIELD": "⟦용용용 Śεľēсť ₣іèľď 歴歴歴⟧",
                "SELECT_METRIC": "⟦용용 Мĕτřіċ 歴歴⟧",
                "SEQUENTIAL": "⟦용용용 Ѕĕqŭέиτįäľ 歴歴歴⟧",
                "SET_START_COLOR": "⟦용용용용 Śęτ Şŧáгť Ĉσļȭя 歴歴歴歴⟧",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "⟦용용용용 Şħōшïήĝ ŝàmρļę ďàτą... 歴歴歴歴⟧",
                "SUM": "⟦용 Ѕùm 歴⟧",
                "SUN": "⟦용 Ѕũņ 歴⟧",
                "SUNDAY": "⟦용용 Şüπďäγ 歴歴⟧",
                "SURVEY_EMBEDDEDDATA": "⟦용용용 Έmвėďďêď Ðāŧà 歴歴歴⟧",
                "SURVEY_METADATA": "⟦용용용용 Ѕųґνεγ Мéταďαťâ 歴歴歴歴⟧",
                "TEXT_ENTRY": "⟦용용용 Ŧε×ŧ ēŉţѓỳ 歴歴歴⟧",
                "THURS": "⟦용 Ťнûґş 歴⟧",
                "THURSDAY": "⟦용용용 Ţĥúгşďăγ 歴歴歴⟧",
                "TITLE": "⟦용 Ţîţĺĕ 歴⟧",
                "TUES": "⟦용 Ţųèѕ 歴⟧",
                "TUESDAY": "⟦용용 Ţųеşďãŷ 歴歴⟧",
                "UNBOUNDED_DOMAIN": "⟦용용용용용 Τôо mâηУ νāĺµêŝ ţô ďϊѕρľáý. 歴歴歴歴歴⟧",
                "UNBOUNDED_DOMAIN_HELP": "⟦용용용용용용용용용용용용 Ŧó ǻďď ţнïş ƒїėĺď ťō Řëşμľτś Řĕρōгŧѕ, Уõű čαп āďď ã ƒíĺţēя ţò ґєρȭŗŧ ţó ďíşρļäў ƒέшεґ νäľμęѕ ƒóг \"{{ed_field_name}}\" όѓ ûρďäŧē τĥě ĕmьєďďęď ďãŧá ναŗįąвļє ťўρé õƒ \"{{ed_field_name}}\" ïŋ ýσµŕ ŝµřνεў ƒĺõω ţŏ mάкē ţħīş ƒїĕļď ą śţřìпğ õř ńûmêřίĉ ťýρě. 歴歴歴歴歴歴歴歴歴歴歴歴⟧",
                "UNDO": "⟦용 Ŭлďȭ 歴⟧",
                "USE_CHOICE_TOTALS": "⟦용용용용용 Üѕέ Čĥσíćē Ťøťáľś 歴歴歴歴歴⟧",
                "USE_RESPONDENT_TOTALS": "⟦용용용용 Ùşе Яėşρоňďєиŧ Ťøτăľş 歴歴歴歴⟧",
                "VISUALIZATION": "⟦용용용 Vîѕūãļіżǻťιоń 歴歴歴⟧",
                "VISUALIZATION_BARCHART": "⟦용용용 ßäř Çĥăŕť 歴歴歴⟧",
                "VISUALIZATION_BREAKDOWNBAR": "⟦용용용 βѓėåĸďőẁπ Бāѓ 歴歴歴⟧",
                "VISUALIZATION_GAUGE": "⟦용용용 Ğάüğё Čĥαґτ 歴歴歴⟧",
                "VISUALIZATION_HEATMAP": "⟦용용용 Ĥèåτ Μâρ 歴歴歴⟧",
                "VISUALIZATION_LINECHART": "⟦용용용 Ľîŋè Ĉнãяţ 歴歴歴⟧",
                "VISUALIZATION_PAGINATEDTABLE": "⟦용용용용 Ρäĝïŉǻŧęď Ŧáьĺέ 歴歴歴歴⟧",
                "VISUALIZATION_PIE": "⟦용용용 Ρĭε Ćħάřŧ 歴歴歴⟧",
                "VISUALIZATION_SIMPLETABLE": "⟦용용용 Ŝίmρľē Ţāвĺє 歴歴歴⟧",
                "VISUALIZATION_STATSTABLE": "⟦용용용용 Śťǻŧϊŝťι¢ŝ Ţâвļë 歴歴歴歴⟧",
                "VISUALIZATION_TEXTHIGHLIGHTS": "⟦용용용용 Ţĕ×ť Ηіġħļϊğħŧş 歴歴歴歴⟧",
                "VISUALIZATION_WORDCLOUD": "⟦용용용 Шоŗď Çļŏμď 歴歴歴⟧",
                "WED": "⟦용 Щéď 歴⟧",
                "WEDNESDAY": "⟦용용용 Ŵèďπėŝďάý 歴歴歴⟧",
                "WEEK": "⟦용 Ŵέęк 歴⟧",
                "WEIGHTING": "⟦용용용 Щĕïğнŧїйġ 歴歴歴⟧",
                "WRONG_QUESTION_TYPE_ERROR": "⟦용용 Τĥĩѕ νϊѕūâĺīżäťĩόη ţγρë ċäňήοŧ ьē ùşеď ƒóŕ τĥіś qűěśťîòŉ 歴歴⟧",
                "YEAR": "⟦용 Ýέàѓ 歴⟧"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "⟦용용 Ąνέґáğě 歴歴⟧",
                "CHOICE_COUNT": "⟦용용용 Çĥσĩčė Ćőцйţ 歴歴歴⟧",
                "COUNT": "⟦용 Çȭμлţ 歴⟧",
                "DISPLAY_OPTIONS": "⟦용용용용 Ðīśρĺάŷ Öρτìоиŝ 歴歴歴歴⟧",
                "MAX": "⟦용용 Мά×ϊmům 歴歴⟧",
                "MIN": "⟦용용 Міńϊmüm 歴歴⟧",
                "NPS": "⟦용 ЙΡŜ® 歴⟧",
                "PAGE_OF": "⟦용용용용 Ρåĝė: %1 Öƒ %2 歴歴歴歴⟧",
                "PERCENT": "⟦용용용 Ρèгсēŋτâğε 歴歴歴⟧",
                "RESPONSE_COUNT": "⟦용용용용 Яėşρŏŋѕé Ćȭüиť 歴歴歴歴⟧",
                "ROWS_PER_TABLE": "⟦용용용용 Řõŵş Ρėѓ Ťãвĺě 歴歴歴歴⟧",
                "SHOWING_ROWS_OF": "⟦용용용용용 Şнȭŵįńġ ѓόŵş %1 - %2 øƒ %3 歴歴歴歴歴⟧",
                "SHOW_PERCENTAGES": "⟦용용용용 Śнош Ρεŗċέйťăğêѕ 歴歴歴歴⟧",
                "SHOW_RECODES": "⟦용용용용용 Şħöш Ѓě¢őďé Vǻļūέś 歴歴歴歴歴⟧",
                "SHOW_ROW_NUMBERS": "⟦용용용용 Ѕнòẁ Ґöẁ Иµmвёґś 歴歴歴歴⟧",
                "SUM": "⟦용 Ѕùm 歴⟧",
                "TOTAL": "⟦용 Ťøτăļ 歴⟧",
                "TRANSPOSE": "⟦용용용 Τŕąйѕρôśĕ 歴歴歴⟧",
                "USE_COLUMN_TOTALS": "⟦용용용용용 Ŭŝε Čŏĺųmή Τοţǻľś 歴歴歴歴歴⟧",
                "USE_ROW_TOTALS": "⟦용용용용 Ůşě Ŗȭẃ Ťôťãļś 歴歴歴歴⟧",
                "VALUE": "⟦용 Vâļμĕ 歴⟧"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "⟦용용용 Âŝсèпďίπĝ 歴歴歴⟧",
                "COUNT": "⟦용 Çȭμлţ 歴⟧",
                "DESCENDING": "⟦용용용 Ďêśćёиďĭлĝ 歴歴歴⟧",
                "DIAGONAL": "⟦용용용 Ďîąġȭņâĺ 歴歴歴⟧",
                "DISPLAY_OPTIONS": "⟦용용용용 Ðīśρĺάŷ Öρτìоиŝ 歴歴歴歴⟧",
                "ERROR_COLON": "⟦용용 Éгґóя: 歴歴⟧",
                "ERROR_GENERIC": "⟦용용용용 Åή έяřòг οĉćūŗŕęď щĥîĺë ľöäďĩпĝ ťħè νϊŝũãļīźãŧϊσń. 歴歴歴歴⟧",
                "HORIZONTAL": "⟦용용용 Ηőгїżȭńτåļ 歴歴歴⟧",
                "HORIZONTAL_BARS": "⟦용용용용 Ĥōřϊżōηťǻĺ ßáŕŝ 歴歴歴歴⟧",
                "INCORRECTLY_CONFIGURED": "⟦용용용 Ĉнôσşė ă νäľũε ţȭ ďîѕρĺãУ ĉĥǻŗť 歴歴歴⟧",
                "LEGEND_AUTO": "⟦용 Ǻūťô 歴⟧",
                "LEGEND_BOTTOM": "⟦용용 ßøττøm 歴歴⟧",
                "LEGEND_INSET": "⟦용 Ĩňşéŧ 歴⟧",
                "LEGEND_RIGHT": "⟦용 Ŕìĝĥť 歴⟧",
                "NORMALIZE_TO_PERCENTAGES": "⟦용용용용 Ŋοґmάľіżє τô Ρέѓċέηταġέѕ 歴歴歴歴⟧",
                "SHOW_BAR_LABELS": "⟦용용용용 Ŝĥøẁ βąŕ Ĺąвëĺŝ 歴歴歴歴⟧",
                "SHOW_LEGEND": "⟦용용용 Ѕħόώ Ĺєġеήď 歴歴歴⟧",
                "SHOW_X_AXIS": "⟦용용용 Ѕĥȭω Х Āхíѕ 歴歴歴⟧",
                "SHOW_Y_AXIS": "⟦용용용 Şħσŵ Ŷ Â×ìѕ 歴歴歴⟧",
                "SORT_BAR_VALUES": "⟦용용용용 Şοŕť βαř Väľůέѕ 歴歴歴歴⟧",
                "STACKED_BARS": "⟦용용용 Ѕŧαćκēď Бάŕş 歴歴歴⟧",
                "TRANSPOSE": "⟦용용용 Τŕąйѕρôśĕ 歴歴歴⟧",
                "TRUNCATE_LABELS": "⟦용용용용 Ţяũηĉåτε Ŀαьěĺś 歴歴歴歴⟧",
                "VERTICAL": "⟦용용용 Vëяţїçαļ 歴歴歴⟧"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "⟦용용용 Āļļ Ŏŧħęŕş 歴歴歴⟧",
                "COULD_NOT_LOAD_DATA": "⟦용용용용용 Čοūĺďń'ť ĺøãď ďãτă ωïťĥ śρéčϊƒíĕď ċȭпƒĩğµгáťϊőŋ — τřỳ ã ďīƒƒèґέńτ şȭùя¢ё ƒìèľď õŕ ã ľäяĝĕŗ ďäŧê ŕάπĝē. 歴歴歴歴歴⟧",
                "GROUPING_PERCENTAGE_THRESHOLD": "⟦용용용용용 Ġŗöůρīŋġ Ρĕřсěņτάğě Ţħŗеşĥοĺď 歴歴歴歴歴⟧",
                "NO_DATA": "⟦용용 Ñσ Ďàţǻ 歴歴⟧",
                "RADIUS": "⟦용용용 Íńηέř Řάďĩцŝ 歴歴歴⟧",
                "SHOW_AS_PERCENTAGES": "⟦용용용용용 Ŝнóẁ Ãś Ρēѓċεпŧáĝêş 歴歴歴歴歴⟧"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "⟦용 Ĉľøѕĕ 歴⟧",
                "DOWNLOAD_CSV": "⟦용용용 Ðοωŋĺóǻď ĊЅV 歴歴歴⟧",
                "DOWNLOAD_ZIP": "⟦용용용용용 Ďóωňĺȭǻď äĺľ ƒíļεş 歴歴歴歴歴⟧",
                "NO_DATA": "⟦용용 Ñσ Ďàţǻ 歴歴⟧",
                "PAGE_OF": "⟦용용용용 Ρåĝė: %1 Öƒ %2 歴歴歴歴⟧",
                "RESULTS_PER_PAGE": "⟦용용용용 Ѓėŝùľţś ρęř ράğë 歴歴歴歴⟧",
                "SHOWING_RECORDS_OF": "⟦용용용용용 Śħσωïňĝ ŕěčôŗďş %1 - %2 όƒ %3 歴歴歴歴歴⟧",
                "SINGLE_RESPONSE": "⟦용용용용 Śιиĝľë Ѓєѕρøиѕê 歴歴歴歴⟧",
                "VIEW_RESPONSE": "⟦용용용 Víêщ Γέѕρøńşě 歴歴歴⟧"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "⟦용용용용 Ðīśρĺάŷ Öρτìоиŝ 歴歴歴歴⟧",
                "ERROR_COLON": "⟦용용 Éгґóя: 歴歴⟧",
                "ERROR_GENERIC": "⟦용용용용 Åή έяřòг οĉćūŗŕęď щĥîĺë ľöäďĩпĝ ťħè νϊŝũãļīźãŧϊσń. 歴歴歴歴⟧",
                "HORIZONTAL_BARS": "⟦용용용용 Ĥōřϊżōηťǻĺ ßáŕŝ 歴歴歴歴⟧",
                "INCORRECTLY_CONFIGURED": "⟦용용용 Ĉнôσşė ă νäľũε ţȭ ďîѕρĺãУ ĉĥǻŗť 歴歴歴⟧",
                "LEGEND_AUTO": "⟦용 Ǻūťô 歴⟧",
                "LEGEND_BOTTOM": "⟦용용 ßøττøm 歴歴⟧",
                "LEGEND_INSET": "⟦용 Ĩňşéŧ 歴⟧",
                "LEGEND_RIGHT": "⟦용 Ŕìĝĥť 歴⟧",
                "NORMALIZE_TO_PERCENTAGES": "⟦용용용용 Ŋοґmάľіżє τô Ρέѓċέηταġέѕ 歴歴歴歴⟧",
                "SHOW_AREA": "⟦용용용 Śĥöẃ Ãяěâ 歴歴歴⟧",
                "SHOW_LEGEND": "⟦용용용 Ѕħόώ Ĺєġеήď 歴歴歴⟧",
                "SHOW_X_AXIS": "⟦용용용 Ѕĥȭω Х Āхíѕ 歴歴歴⟧",
                "SHOW_Y_AXIS": "⟦용용용 Şħσŵ Ŷ Â×ìѕ 歴歴歴⟧",
                "SMOOTH_LINES": "⟦용용용 Şmȭȭťĥ Ĺĩńēŝ 歴歴歴⟧",
                "SORT_X_AXIS_LABELS": "⟦용용용용용 Ѕöŕť Х Ą×ĭѕ Ļäвëľş 歴歴歴歴歴⟧",
                "STACKED_BARS": "⟦용용용 Ѕŧαćκēď Бάŕş 歴歴歴⟧",
                "TRANSPOSE": "⟦용용용 Τŕąйѕρôśĕ 歴歴歴⟧"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "⟦용용용 Βľôčķ Мøďе 歴歴歴⟧",
                "BLUR": "⟦용 Βĺüг 歴⟧",
                "COULD_NOT_LOAD_DATA": "⟦용용용용용 Čοūĺďń'ť ĺøãď ďãτă ωïťĥ śρéčϊƒíĕď ċȭпƒĩğµгáťϊőŋ — τřỳ ã ďīƒƒèґέńτ şȭùя¢ё ƒìèľď õŕ ã ľäяĝĕŗ ďäŧê ŕάπĝē. 歴歴歴歴歴⟧",
                "FIELD": "⟦용 ₣ĭёľď 歴⟧",
                "RADIUS": "⟦용용 Яáďіцś 歴歴⟧",
                "SHOW_REGIONS": "⟦용용용 Şħŏώ Řěğϊõŋŝ 歴歴歴⟧",
                "SHOW_REGION_LABELS": "⟦용용용용용 Şħøẃ Ŗєġïŏη Ļäвεļѕ 歴歴歴歴歴⟧"
            },
            "GAUGEWIDGET": {
                "MAX": "⟦용 Мä× 歴⟧",
                "MIN": "⟦용 Мĭή 歴⟧",
                "VALUE_RANGES": "⟦용용용 Vαĺŭě яåŉĝèş 歴歴歴⟧"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "⟦용용용 βστŧõm ļǻвëľѕ 歴歴歴⟧",
                "CATEGORY_NAME": "⟦용용용 ĈàťëġòяУ ňămε 歴歴歴⟧",
                "ERROR_COLON": "⟦용용 Éгґóя: 歴歴⟧",
                "INCLUDE_HIDDEN_GROUPS": "⟦용용용 Ìйćĺµďέ ĥĭďďей ġѓøűρѕ ίл ρεяçêņŧŝ 歴歴歴⟧",
                "LARGE_LABELS": "⟦용용용 Ľãяĝё ĺάвêľş 歴歴歴⟧",
                "NO": "⟦용 Йő 歴⟧",
                "PERCENT": "⟦용용 Ρēґčēňŧ 歴歴⟧",
                "RESPONSE_COUNT": "⟦용용용용 Ŗêѕρöńŝε çöμпτ 歴歴歴歴⟧",
                "RESPONSE_COUNT_WITH_VALUE": "⟦용용용용용 {{ responseCount }} геѕρόηśέś 歴歴歴歴歴⟧",
                "SMALL_LABELS": "⟦용용용 Śmâľľ ľáвέļѕ 歴歴歴⟧",
                "YES": "⟦용 Υεş 歴⟧"
            }
        });
        $cache.put('PL', {
            "VIEWRESULTS": {},
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Pamiętaj, że w Twojej organizacji są osoby, które mogą pomóc Ci w interpretacji informacji zwrotnych, takie jak partnerzy HR, Twój menedżer i/lub mentor.",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Zrób sobie kawę i zapoznaj się z informacjami zwrotnymi.",
                "ABOUT_YOUR_REPORT_HEADER": "Informacje o Twoim raporcie",
                "ABOUT_YOUR_REPORT_LINE1": "Witaj w raporcie dotyczącym informacji zwrotnej w ramach oceny 360 stopni. To wspaniała szansa rozwoju zawodowego. Aby przygotować się na sukces podczas analizy wyników, zapewnij sobie wystarczająco dużo czasu na zapoznanie się z informacjami zwrotnymi. Czytanie ich może być początkowo trudne, ale pamiętaj, że celem tego procesu jest przyspieszenie Twojego rozwoju.",
                "ABOUT_YOUR_REPORT_LINE2": "Analizując raport, pamiętaj o poniższych faktach.",
                "ADD_CONDITIONAL_TEXT": "Dodaj tekst warunkowy",
                "ADD_CUSTOM_PALETTE": "Dodaj paletę niestandardową",
                "ADD_DATA_SOURCE": "Dodaj źródło danych",
                "ADD_FOLLOWING": "Dodaj następujące",
                "ADD_LABEL": "Dodaj etykietę",
                "ADVANCED_FILTER": "Filtr zaawansowany",
                "AGREEMENT_CHART": "Wykres zgodności",
                "AGREEMENT_CHART_FOOTER": "Wykres zgodności wskazuje podobieństwo punktacji. Każda kropka odpowiada ocenom, jakie poszczególne osoby wystawiły Ci za każdy element. Rozmiar kropki pokazuje, ilu oceniających wystawiło określoną ocenę.",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "odpowiedzi",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "odpowiedź",
                "AGREEMENT_CHART_LEGEND_TITLE": "Jak ocenili Cię inni",
                "ALL": "Wszystko",
                "AND_IF": "I jeśli",
                "ANGLED": "Pod kątem",
                "AREA": "Obszar",
                "AUTO": "Automatyczny",
                "AVERAGE": "Średnia",
                "AXIS_VALUES": "Wartości osi",
                "BAR": "Pasek",
                "BASE_WORD_COLOR": "Kolor podstawowego słowa",
                "BLUR": "Rozmycie",
                "BOTTOM_BOX": "Pole na dole",
                "BREAKOUT_HEADERS": "Nagłówki rozbicia",
                "CANCEL": "Anuluj",
                "CATEGORICAL": "Kategoryczny",
                "CATEGORY": "Kategoria",
                "CATEGORY_NAME": "Nazwa kategorii",
                "CHANGE_CATEGORIES_ORDER": "Zmień kolejność kategorii",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "Zmień kolejność kategorii punktacji",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "Zmień kolejność, w której pojawia się wizualizacja, klikając po lewej stronie elementu kategorii punktacji i przeciągając go do wymaganej pozycji.",
                "CHANGE_QUESTIONS_ORDER": "Zmień kolejność pytań",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "Zmień kolejność pytań",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "Zmień kolejność, w której pojawia się wizualizacja, klikając po lewej stronie elementu kategorii pytania i przeciągając go do wymaganej pozycji.",
                "CHARTS": "Wykresy",
                "CHART_TYPE": "Rodzaj wykresu",
                "CHOICE_COUNT": "Liczba wyborów",
                "CHOICE_TOTALS": "Suma wyborów",
                "CLEAR": "Wyczyść",
                "CLOSE": "Zamknij",
                "COLOR_PALETTE": "Paleta kolorów",
                "COLUMN_NAMES": "Nazwy kolumn",
                "COLUMN_TOTALS": "Suma kolumn",
                "COMPARED_FILTER_GROUP": "Porównana grupa filtrów",
                "COMPARED_FILTER_GROUPS": "Porównane grupy filtrów",
                "COMPARE_WITH": "porównaj z",
                "COMPETITION_RANKING": "Użyj rankingu konkurencyjności",
                "COMPETITION_RANKING_TOOLTIP": "W przypadku remisu wszystkie równe wyniki mają tę samą pozycję w rankingu. Jednak kolejna pozycja zostanie sklasyfikowana jako: łączna liczba pozycji sklasyfikowanych wyżej w tabeli plus jeden.",
                "COMPLETED_RESPONSES": "Ukończone odpowiedzi",
                "CONDITIONAL_TEXT": "Tekst warunkowy",
                "COUNT": "Liczba",
                "CREATE": "Utwórz",
                "CUSTOM_PALETTE": "Paleta niestandardowa",
                "DATA_SOURCE_TYPE": "Rodzaj źródła danych",
                "DATA_SOURCE_TYPE_CATEGORY": "Kategorie punktowe",
                "DATA_SOURCE_TYPE_QUESTION": "Pytania",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "Pytanie",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "Elementy z rangą",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "Kategoria punktowa",
                "DEFAULT": "Domyślny",
                "DEFAULT_TEXT": "Tekst domyślny",
                "DELETE": "Usuń",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "Zrozumieć, od kogo pochodzi informacja zwrotna - równorzędni pracownicy, bezpośredni podwładni, kierownicy itd.",
                "DIFFERENT_EVALUATORS_HEADER": "Różni ewaluatorzy",
                "DIRECT_REPORTS": "Bezpośredni podwładni",
                "DISABLED": "Wyłączono",
                "DISPLAY_OPTIONS": "Opcje wyświetlania",
                "DISPLAY_THRESHOLD_TEXTS": "Wyświetl tekst na podstawie następującej luki grup",
                "DIVERGENT": "Niezgodny",
                "DONE": "Zakończone",
                "DONT_HEADER": "Nie należy:",
                "DONT_LINE1": "Próbować odgadnąć, kto co powiedział",
                "DONT_LINE2": "Skupiać się na jednym pozytywnym lub negatywnym wyniku/komentarzu",
                "DONT_LINE3": "Tworzyć planu rozwoju dla każdego elementu",
                "DONT_LINE4": "Zniechęcać się do szans poprawy",
                "DONUT": "Koło",
                "DOWNLOAD_CSV": "Pobierz plik dziedziczony CSV",
                "DOWNLOAD_ZIP": "Pobierz wszystkie pliki",
                "DO_HEADER": "Należy:",
                "DO_LINE1": "Spoglądać na informacje zwrotne całościowo",
                "DO_LINE2": "Identyfikować tematy w kontekście mocnych stron i szans na poprawę",
                "DO_LINE3": "Priorytetowo dodać kilka stref skupienia do planu rozwoju",
                "DO_LINE4": "Zrozumieć, że każdy ma szanse na poprawę",
                "DROPOFF": "Upuszczenie",
                "DUPLICATE": "Duplikat",
                "EDIT_CONDITIONAL_TEXT": "Edytuj tekst warunkowy",
                "EDIT_CUSTOM_PALETTE": "Edytuj paletę niestandardową",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "W przeciwnym razie pokaż następujący tekst",
                "ENABLED": "Włączono",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "Włącz porządkowanie według logiki wyświetlania kategorii osób oceniających",
                "ENABLE_ORDERING_FOR": "Włącz kolejność",
                "EQUAL_TO": "Równa się",
                "FIELD": "Pole",
                "FILTER_NAMES": "Nazwy filtrów",
                "FOLLOWING_PARENTHESES": "(następujące)",
                "FOOTER": "Stopka",
                "GAP": "Luka",
                "GAP_CHART": "Wykres luk",
                "GAP_CHART_DESCRIPTION": "Wykres luk pokazuje różnicę punktacji między dwiema grupami oceniających. Na przykład w przypadku samooceny oraz ocen wystawianych przez innych różnica dodatnia (+) oznacza, że inni ocenili Cię wyżej niż Ty sam(-a). Różnica ujemna (-) oznacza, że inni ocenili Cię niżej niż Ty sam(-a).",
                "GAP_CHART_FOOTER": "Wykres luk określa różnicę +/- pomiędzy dwiema grupami oceniających.",
                "GAP_TABLE_DESCRIPTION": "Ukryte mocne strony pokazują obszary, w których inni ocenili Cię wyżej niż Ty sam(-a). Obszary do poprawy pokazują, gdzie inni ocenili Cię niżej niż Ty sam(-a). Obie sekcje są uporządkowane od największej do najmniejszej luki.",
                "GAP_TABLE_FOOTER": "Pierwsza kolumna punktów pokazuje, ile punktów przyznałeś(-aś) samemu/samej sobie. Druga kolumna określa średnią liczbę punktów przyznanych Ci przez innych. Trzecia kolumna pokazuje różnicę między tym, jak oceniłeś(-aś) siebie samego/samą i jak ocenili Cię inni.",
                "GAP_TABLE_TITLE": "Ukryte mocne strony / Obszary do poprawy",
                "GREATER_OR_EQUAL": "Większe lub równe",
                "GREATER_THAN": "Większe niż",
                "GROUP": "Grupa",
                "GROUPED_FOR_ANONYMITY": "Zgrupowane dla anonimowości",
                "HEADER_NAMES": "Nazwy nagłówków",
                "HIGHEST_SCORES": "Najwyższa punktacja",
                "HIGHLIGHT_THRESHOLD": "Próg wyróżnienia luk",
                "HIGHLOW_TABLE": "Wysoka i niska punktacja",
                "HIGHLOW_TABLE_FOOTER": "W tej sekcji przedstawiono po pięć najwyżej i najniżej ocenianych zachowań (spośród wszystkich zachowań) na podstawie stosowanych średnich kategorii oceniania. Aby jak najlepiej wykorzystać tę stronę, warto przyjrzeć się trendom, które mogą się pojawić. Jeżeli przykładowo większość Twoich najniżej ocenianych zachowań koncentruje się w jednej lub dwóch kategoriach, mogą to być obszary wymagające rozwoju. Najwyżej oceniane zachowania mogą identyfikować mocne strony, które można wykorzystać w innych obszarach.",
                "HIGH_LOW_TABLE_DESCRIPTION": "Wykres wysokich/niskich wyników wyświetla elementy obszarów, w których inni ocenili Cię najwyżej i najniżej.",
                "HORIZONTAL": "Horyzontalny",
                "HORIZONTAL_AND_VERTICAL": "Poziomy i pionowy",
                "HORIZONTAL_BAR": "Pasek poziomy",
                "HOW_TO_INTERPRET_RESULT_HEADER": "Jak interpretować wyniki i określać działanie:",
                "IF": "Jeśli",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "Uwzględnij ukryte etykiety w procentach",
                "INNER_RIM": "Obręcz wewnętrzna",
                "IS": "Jest",
                "IS_NOT": "Nie jest",
                "IS_SAME_AS_SUBJECT": "Ten sam co badany",
                "ITEM": "Element",
                "LABEL": "etykieta",
                "LABELS": "Etykiety",
                "LARGE_LABELS": "Duże etykiety",
                "LEGEND": "Legenda",
                "LEGEND_POSITION": "Pozycja legendy",
                "LEGEND_VALUES": "Wartości legendy",
                "LESS_OR_EQUAL": "Mniejsze lub równe",
                "LESS_THAN": "Mniejsze niż",
                "LINE": "Linia",
                "LOWEST_SCORES": "Najniższa punktacja",
                "MANAGERS": "Menedżerowie",
                "MANUAL_FONT_SIZE": "Ustaw rozmiar czcionki ręcznie",
                "MAX": "Maks.",
                "MEAN": "Średnia",
                "MEDIAN": "Mediana",
                "METRIC_TYPE": "Typ wskaźnika",
                "MIN": "Min.",
                "MODIFY_CUSTOM_PALETTES": "Modyfikuj palety niestandardowe",
                "MOVE_DOWN": "Przesuń w dół",
                "MOVE_UP": "Przesuń w górę",
                "MULTI_SELECT_ITEMS_SELECTED": "wybrane",
                "NEGATIVE_GAPS": "Obszary do poprawy",
                "NO": "Nie",
                "NONE": "Brak",
                "NOT_APPLICABLE": "Nie dotyczy",
                "NOT_EQUAL_TO": "Nie jest równe",
                "NO_DATA_AVAILABLE_WARNING": "Brak dostępnych danych",
                "NO_FILTER": "Brak filtra",
                "NO_FILTER_IS_APPLIED": "Nie zastosowano filtra.",
                "NO_VALUE": "Brak wartości",
                "NPS": "Wskaźnik rekomendacji netto",
                "NUMBER": "liczba",
                "NUMBERS": "Liczby",
                "NUMBER_OF_GAPS_NEGATIVE": "Liczba luk ujemnych",
                "NUMBER_OF_GAPS_POSITIVE": "Liczba luk dodatnich",
                "NUMBER_OF_ROWS_HIGH": "Liczba wysokich wierszy",
                "NUMBER_OF_ROWS_LOW": "Liczba niskich wierszy",
                "OPTIONS": {
                    "HEADER_NAME": "Nazwa nagłówka",
                    "LEGEND": "Legenda",
                    "SCALE_AXIS_CHANGER_TITLE": "Zakres"
                },
                "ORIENTATION": "Orientacja",
                "OR_IF": "Lub jeśli",
                "OTHER": "Inna",
                "OTHERS": "Inne/ Inni/ Innych",
                "PAGE_OF": "Strona: %1 z %2",
                "PALETTE_REMOVED": "Usunięto paletę",
                "PEERS": "Równorzędni",
                "PERCENT": "Procent",
                "PERCENTAGE": "Wartość procentowa",
                "PERCENTAGE_OF_CHOICES": "Wartość procentowa wyborów",
                "PERCENTAGE_OF_RESPONSES": "Wartość procentowa odpowiedzi",
                "PERCENT_COMPLETE": "% ukończ.",
                "PERSON_METADATA": "Metadane osoby",
                "PERSON_METADATA_EVALUATOR": "Ewaluatora",
                "PERSON_METADATA_SUBJECT": "Badanego",
                "PERSON_METADATA_VIEWER": "Oglądającego",
                "POSITIVE_GAPS": "Ukryte mocne strony",
                "PRIMARY_PARENTHESES": "(główne)",
                "QUESTIONS": "Pytania",
                "RADIUS": "Promień",
                "RANK": "Stopień",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "Najwyższa punktacja",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "Najwyższa punktacja",
                "RANKABLE_ITEMS_ITEM_HAS": "Element ma",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "Element jest w pierwszych",
                "RANKABLE_ITEMS_LOWEST_SCORE": "Najniższa punktacja",
                "RANKABLE_ITEMS_LOWEST_SCORES": "Najniższa punktacja",
                "RATER_CATEGORY_DISPLAY_LOGIC": "logika wyświetlania kategorii osób oceniających",
                "RATIO": "Współczynnik",
                "RECORD": "Rekord",
                "REFERENCE_GROUP": "Grupa referencyjna",
                "RELATIONSHIP": "Relacja",
                "RELATIONSHIP_FILTERS": "Filtry relacji",
                "RELATIONSHIP_FILTERS_INFO": "Aby dodać filtr relacji (np. bezpośredni podwładny, pracownik równorzędny lub menedżer), wybierz Zarządzaj swoimi filtrami i użyj warunku relacji z menu rozwijalnego.",
                "REMOVE": "Usuń",
                "REMOVE_DATA_SOURCE": "Usuń źródło danych",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Pamiętaj, że w Twojej organizacji są osoby, które mogą pomóc Ci w interpretacji informacji zwrotnych, takie jak partnerzy HR, Twój menedżer i/lub mentor.",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Zrób sobie kawę i zapoznaj się z informacjami zwrotnymi.",
                    "ABOUT_YOUR_REPORT_HEADER": "Informacje o Twoim raporcie",
                    "ABOUT_YOUR_REPORT_LINE1": "Witaj w raporcie dotyczącym informacji zwrotnej w ramach oceny 360 stopni. To wspaniała szansa rozwoju zawodowego. Aby przygotować się na sukces podczas analizy wyników, zapewnij sobie wystarczająco dużo czasu na zapoznanie się z informacjami zwrotnymi. Czytanie ich może być początkowo trudne, ale pamiętaj, że celem tego procesu jest przyspieszenie Twojego rozwoju.",
                    "ABOUT_YOUR_REPORT_LINE2": "Analizując raport, pamiętaj o poniższych faktach.",
                    "ADVANCED_FILTER": "Filtr zaawansowany",
                    "AGREEMENT_CHART": "Wykres zgodności",
                    "AGREEMENT_CHART_FOOTER": "Wykres zgodności wskazuje podobieństwo punktacji. Każda kropka odpowiada ocenom, jakie poszczególne osoby wystawiły Ci za każdy element. Rozmiar kropki pokazuje, ilu oceniających wystawiło określoną ocenę.",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "odpowiedzi",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "odpowiedź",
                    "AGREEMENT_CHART_LEGEND_TITLE": "Jak ocenili Cię inni",
                    "ALL": "Wszystko",
                    "AVERAGE": "Średnia",
                    "BOTTOM_BOX": "Pole na dole",
                    "CHOICE_COUNT": "Liczba wyborów",
                    "CHOICE_TOTALS": "Sumy wyborów",
                    "COMPARISON": "Porównanie",
                    "COMPARISON_GAP_COLUMN_HEADER": "Luka porównania",
                    "COMPLETED_RESPONSES": "Ukończone odpowiedzi",
                    "COUNT": "Liczba",
                    "DEFAULT": "Domyślny",
                    "DEFAULT_TEXT": "Tekst domyślny",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "Zrozumieć, od kogo pochodzi informacja zwrotna - równorzędni pracownicy, bezpośredni podwładni, kierownicy itd.",
                    "DIFFERENT_EVALUATORS_HEADER": "Różni ewaluatorzy",
                    "DONE": "Zakończone",
                    "DONT_HEADER": "Nie należy:",
                    "DONT_LINE1": "Próbować odgadnąć, kto co powiedział",
                    "DONT_LINE2": "Skupiać się na jednym pozytywnym lub negatywnym wyniku/komentarzu",
                    "DONT_LINE3": "Tworzyć planu rozwoju dla każdego elementu",
                    "DONT_LINE4": "Zniechęcać się do szans poprawy",
                    "DO_HEADER": "Należy:",
                    "DO_LINE1": "Spoglądać na informacje zwrotne całościowo",
                    "DO_LINE2": "Identyfikować tematy w kontekście mocnych stron i szans na poprawę",
                    "DO_LINE3": "Priorytetowo dodać kilka stref skupienia do planu rozwoju",
                    "DO_LINE4": "Zrozumieć, że każdy ma szanse na poprawę",
                    "FIELD": "Pole",
                    "GAP": "Luka",
                    "GAP_CHART": "Wykres luk",
                    "GAP_CHART_DESCRIPTION": "Wykres luk pokazuje różnicę punktacji między dwiema grupami oceniających. Na przykład w przypadku samooceny oraz ocen wystawianych przez innych różnica dodatnia (+) oznacza, że inni ocenili Cię wyżej niż Ty sam(-a). Różnica ujemna (-) oznacza, że inni ocenili Cię niżej niż Ty sam(-a).",
                    "GAP_CHART_FOOTER": "Wykres luk określa różnicę +/- pomiędzy dwiema grupami oceniających.",
                    "GAP_TABLE_DESCRIPTION": "Ukryte mocne strony pokazują obszary, w których inni ocenili Cię wyżej niż Ty sam(-a). Obszary do poprawy pokazują, gdzie inni ocenili Cię niżej niż Ty sam(-a). Obie sekcje są uporządkowane od największej do najmniejszej luki.",
                    "GAP_TABLE_FOOTER": "Pierwsza kolumna punktów pokazuje, ile punktów przyznałeś(-aś) samemu/samej sobie. Druga kolumna określa średnią liczbę punktów przyznanych Ci przez innych. Trzecia kolumna pokazuje różnicę między tym, jak oceniłeś(-aś) siebie samego/samą i jak ocenili Cię inni.",
                    "GAP_TABLE_TITLE": "Ukryte mocne strony / Obszary do poprawy",
                    "GROUP": "Grupa",
                    "HIDE_REPORT_ALERT": "Nie spełniasz wymagań przeglądania tego raportu. Skontaktuj się ze swoim administratorem organizacji.",
                    "HIGHEST_SCORES": "Najwyższa punktacja",
                    "HIGHLOW_TABLE": "Wysoka i niska punktacja",
                    "HIGHLOW_TABLE_FOOTER": "W tej sekcji przedstawiono po pięć najwyżej i najniżej ocenianych zachowań (spośród wszystkich zachowań) na podstawie stosowanych średnich kategorii oceniania. Aby jak najlepiej wykorzystać tę stronę, warto przyjrzeć się trendom, które mogą się pojawić. Jeżeli przykładowo większość Twoich najniżej ocenianych zachowań koncentruje się w jednej lub dwóch kategoriach, mogą to być obszary wymagające rozwoju. Najwyżej oceniane zachowania mogą identyfikować mocne strony, które można wykorzystać w innych obszarach.",
                    "HIGH_LOW_TABLE_DESCRIPTION": "Wykres wysokich/niskich wyników wyświetla elementy obszarów, w których inni ocenili Cię najwyżej i najniżej.",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "Jak interpretować wyniki i określać działanie:",
                    "ITEM": "Element",
                    "LOWEST_SCORES": "Najniższa punktacja",
                    "MAX": "Maks.",
                    "MEAN": "Średnia",
                    "MEDIAN": "Mediana",
                    "MIN": "Min.",
                    "NEGATIVE_GAPS": "Obszary do poprawy",
                    "NO_COMPARISON_SET": "Nie ustawiono porównania",
                    "NO_DATA_AVAILABLE_WARNING": "Brak dostępnych danych",
                    "NO_FILTER_IS_APPLIED": "Nie zastosowano filtra.",
                    "NO_VALUE": "Brak wartości",
                    "NPS": "Wskaźnik rekomendacji netto",
                    "OTHERS": "Inni",
                    "PERCENTAGE": "Wartość procentowa",
                    "PERCENTAGE_OF_CHOICES": "Wartość procentowa wyborów",
                    "PERCENTAGE_OF_RESPONSES": "Wartość procentowa odpowiedzi",
                    "PERCENT_COMPLETE": "% ukończ.",
                    "POSITIVE_GAPS": "Ukryte mocne strony",
                    "QUESTIONS": "Pytania",
                    "RANK": "Stopień",
                    "RELATIONSHIPS": {
                        "ANYONE": "Każdy",
                        "DIRECT_REPORT": "Bezpośredni podwładny",
                        "MANAGER": "Menedżer",
                        "PEER": "Równorzędny",
                        "SELF": "Sam(a)"
                    },
                    "REPORT_SUMMARY": "Podsumowanie raportu",
                    "REPORT_SUMMARY_TABLE_FOOTER": "Porównaj liczbę osób, które ukończyły Twoją ocenę, z liczbą osób zaproszonych do udziału w niej.",
                    "REPORT_SUMMARY_TABLE_HEADER": "Statystyka respondentów",
                    "RESPONSES": "Odpowiedzi",
                    "RESPONSE_COUNT": "{{responseCount}} Odpowiedzi",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Odpowiedzi",
                    "SCORING_CATEGORY": "Kategoria punktacji",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Brak odpowiedzi dla tej kategorii",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Brak odpowiedzi na to pytanie",
                    "SCORING_OVERVIEW": "Przegląd punktacji",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "Ty i inni ewaluatorzy uważacie, że ten obszar jest najważniejszą mocną stroną.",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Zidentyfikowana mocna strona",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Zidentyfikowany obszar do poprawy oznacza, że samoocena i oceny innych są poniżej średniej dla tej kompetencji.",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Zidentyfikowany obszar do poprawy",
                    "SCORING_OVERVIEW_DESCRIPTION": "Powyżej znajdują się wymienione są Twoje kompetencje lub zachowania, które były poddane ewaluacji w ramach procesu wieloźródłowej informacji zwrotnej. Oceny porównawcze są udostępniane według grup.",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "Luka minimalna",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Minimalna różnica pomiędzy grupami referencyjnymi dla tekstów do wyświetlenia.",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "Wyświetlany jest zakres punktacji dla każdej kompetencji/zachowania. Słupek reprezentuje średnią wartość numeryczną.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Niezidentyfikowana mocna strona wynika z rozbieżności pomiędzy samooceną oraz ocenami innych.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Niezidentyfikowana mocna strona",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Niezidentyfikowany obszar do poprawy wynika z rozbieżności pomiędzy samooceną oraz ocenami innych.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Niezidentyfikowany obszar do poprawy",
                    "SELF": "Sam(-a)",
                    "SELF_ASSESSMENT": "Samoocena",
                    "STANDARD_DEVIATION": "Odchylenie standardowe",
                    "SUM": "Suma",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Zapoznaj się ze skalą ocen, aby zapewnić właściwą interpretację",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "Zanotuj skalę",
                    "THINGS_YOU_WILL_SEE_HEADER": "Elementy, które zobaczysz:",
                    "THREE_SIXTY_PERCENTILE": "Percentyl",
                    "TOP_BOTTOM_BOX": "Górne pole / dolne pole",
                    "TOP_BOX": "Pole na górze",
                    "TOTAL": "Suma",
                    "TO_DO": "Do wykonania",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Jakościowo: Ta informacja zwrotna będzie mieć formę komentarzy wykorzystujących tekst otwarty",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Ilościowo: Ta informacja zwrotna będzie wartością numeryczną i będzie mogła być wyświetlana w postaci grafów, wykresów słupkowych, tabel itp.",
                    "TYPES_OF_FEEDBACK_HEADER": "Różne typy informacji zwrotnych",
                    "VALUE": "Wartość",
                    "VARIANCE": "Wariancja",
                    "YOUR_RATINGS": "Twoje oceny"
                },
                "REPORT_SUMMARY": "Podsumowanie raportu",
                "REPORT_SUMMARY_TABLE_FOOTER": "Porównaj liczbę osób, które zakończyły Twoją ocenę, z liczbą osób zaproszonych do udziału w niej.",
                "REPORT_SUMMARY_TABLE_HEADER": "Statystyka respondentów",
                "RESET": "Resetuj",
                "RESPONDENT_TOTALS": "Suma respondentów",
                "RESPONSES": "Odpowiedzi",
                "RESPONSE_COUNT": "{{responseCount}} Odpowiedzi",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Odpowiedzi",
                "RESULT": "Wynik",
                "REVERSE_COLORS": "Odwróć kolory",
                "ROW_TOTALS": "Suma wierszy",
                "SAVE": "Zapisz",
                "SAVE_AND_APPLY": "Zapisz i zastosuj",
                "SCORING_CATEGORY": "Kategoria punktacji",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Brak odpowiedzi dla tej kategorii",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Brak odpowiedzi na to pytanie",
                "SCORING_OVERVIEW": "Przegląd punktacji",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "Ty i inni ewaluatorzy uważacie, że ten obszar jest najważniejszą mocną stroną.",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Zidentyfikowana mocna strona",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Zidentyfikowany obszar do poprawy oznacza, że samoocena i oceny innych są poniżej średniej dla tej kompetencji.",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Zidentyfikowany obszar do poprawy",
                "SCORING_OVERVIEW_DESCRIPTION": "Powyżej wymienione są Twoje kompetencje lub zachowania, które były poddane ewaluacji w ramach procesu wieloźródłowej informacji zwrotnej. Oceny porównawcze są udostępniane według grup.",
                "SCORING_OVERVIEW_MINIMUM_GAP": "Luka minimalna",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Minimalna różnica pomiędzy grupami referencyjnymi dla tekstów do wyświetlenia.",
                "SCORING_OVERVIEW_TABLE_FOOTER": "Wyświetlany jest zakres punktacji dla każdej kompetencji/zachowania. Słupek reprezentuje średnią wartość numeryczną.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Niezidentyfikowana mocna strona wynika z rozbieżności pomiędzy samooceną oraz ocenami innych.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Niezidentyfikowana mocna strona",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Niezidentyfikowany obszar do poprawy wynika z rozbieżności pomiędzy samooceną oraz ocenami innych.",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Niezidentyfikowany obszar do poprawy",
                "SELECT_CATEGORIES": "Wybierz kategorie punktacji...",
                "SELECT_CATEGORY": "Wybierz kategorię punktacji...",
                "SELECT_CONDITION_TYPE": "Wybierz typ warunku",
                "SELECT_DATA_SOURCE": "Wybierz źródło danych",
                "SELECT_DATA_SOURCE_TYPE": "Wybierz typ źródła danych",
                "SELECT_FILTER": "Wybierz filtr",
                "SELECT_FILTERS": "Wybierz filtry",
                "SELECT_OPERATOR_TYPE": "Wybierz typ operatora",
                "SELECT_PERSON": "Wybierz osobę",
                "SELECT_PERSON_METADATA": "Wybierz metadane osoby",
                "SELECT_QUESTION": "Wybierz pytanie",
                "SELECT_QUESTIONS": "Wybierz pytania...",
                "SELECT_RATIO_OR_DROPOFF": "Wybierz współczynnik lub upuszczenie",
                "SELECT_RELATIONSHIP": "Wybierz relację",
                "SELECT_SCORING_CATEGORY": "Wybierz kategorię punktacji",
                "SELF": "Samodzielnie",
                "SELF_ASSESSMENT": "Samoocena",
                "SEQUENTIAL": "Sekwencyjny",
                "SETUP_COMPARISON": "Konfiguracja porównania",
                "SETUP_COMPARISONS": "Konfiguracja porównań",
                "SET_START_COLOR": "Ustaw kolor początkowy",
                "SHOULD_SHOW_FOOTER": "Pokaż stopkę",
                "SHOULD_SHOW_SCORING_CATEGORY": "Pokaż kategorię punktacji",
                "SHOWING_RECORDS_OF": "Wyświetlanie rekordów %1 - %2 z %3",
                "SHOW_COMPARISON_GAP": "Pokaż kolumnę luki porównania",
                "SHOW_DATA_LABEL": "Pokaż wartości danych",
                "SHOW_PERCENTAGES": "Pokaż wartości procentowe",
                "SHOW_THE_FOLLOWING_TEXT": "Następnie pokaż następujący tekst",
                "SHOW_TIES": "Pokaż takie same wartości",
                "SHOW_X_AXIS": "Pokaż oś X",
                "SHOW_Y_AXIS": "Pokaż oś Y",
                "SMALL_LABELS": "Małe etykiety",
                "SORT": "Sortuj",
                "SPLINE": "Krzywa składana",
                "STACK_CHART": "Wykres skumulowany",
                "STANDARD_DEVIATION": "Odchylenie standardowe",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "Słaba strona - mniej niż",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "Edytuj teksty wartości progowej",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "Teksty wartości progowej",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "Włącz teksty wartości progowej",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "Mocna strona - więcej niż",
                "SUM": "Suma",
                "SUMMARY": "Podsumowanie",
                "TABLES": "Tabele",
                "TABLE_TOTALS": "Sumy tabeli",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Zapoznaj się ze skalą ocen, aby zapewnić właściwą interpretację",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "Zanotuj skalę",
                "TEXT": "Tekst",
                "THINGS_YOU_WILL_SEE_HEADER": "Elementy, które zobaczysz:",
                "TOP_BOTTOM_BOX": "Górne pole/dolne pole",
                "TOP_BOX": "Pole na górze",
                "TOTAL": "Suma",
                "TOTAL_COUNTS": "Łączna liczba",
                "TO_DO": "Do wykonania",
                "TRANSPOSE": "Transpozycja",
                "TRANSPOSE_TABLE": "Dokonaj transpozycji tabeli",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Jakościowo: Ta informacja zwrotna będzie mieć formę komentarzy wykorzystujących tekst otwarty",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Ilościowo: Ta informacja zwrotna będzie wartością numeryczną i będzie mogła być wyświetlana w postaci grafów, wykresów słupkowych, tabel itp.",
                "TYPES_OF_FEEDBACK_HEADER": "Różne typy informacji zwrotnych",
                "UNDO": "Cofnij",
                "USE_COMPARISON": "Użyj porównania",
                "USE_LABELS_FOR_SCALES": "Używaj etykiet do skal",
                "VALUES": "Wartości",
                "VALUE_RANGES": "Zakresy wartości",
                "VARIANCE": "Wariancja",
                "VERTICAL": "Pionowy",
                "VERTICAL_RANGE": "Zakres pionowy",
                "WARNING_DATA_OUT_OF_RANGE": "Ostrzeżenie: wartość danych przekracza konfigurację zakresu",
                "WIDGET_ERROR": {
                    "ERROR": "Wystąpił nieoczekiwany błąd",
                    "MISCONFIGURED": "Ten widżet nie został prawidłowo skonfigurowany. Sprawdź konfigurację widżetu.",
                    "NEW": "Skonfiguruj widżet",
                    "NO_DATA": "Nie znaleziono danych — filtry mogą być zbyt restrykcyjne!"
                },
                "WIDGET_NAME": {
                    "BAR": "Wykres słupkowy",
                    "BREAKDOWNBAR": "Słupek podziału",
                    "DATA_TABLE": "Tabela z danymi",
                    "FUNNEL_CHART": "Wykres lejkowy",
                    "GAUGE": "Wykres wskaźnikowy",
                    "GRID": "Tabela z wynikami",
                    "HEATMAP": "Mapa cieplna",
                    "LINE": "Wykres liniowy",
                    "NEEDS_BASED": "Oparty na potrzebach",
                    "PIE": "Wykres kołowy",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "Estymator ceny (Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "Maksymalizator przychodu (Gabor Granger)",
                    "SCORING_OVERVIEW_CHART": "Wykres",
                    "SCORING_OVERVIEW_TABLE": "Tabela",
                    "STATS_TABLE": "Tabela statystyk",
                    "WORDCLOUD": "Chmura wyrazów"
                },
                "WORD_ROTATION": "Rotacja słów",
                "WORD_SPACING": "Odstęp między słowami",
                "YES": "Tak",
                "YOUR_RATINGS": "Twoje oceny"
            },
            "WORDCLOUDWIDGET": {},
            "TEXTHIGHLIGHTSWIDGET": {},
            "STATSTABLEWIDGET": {},
            "SOURCECONFIGDEP": {},
            "SIMPLETABLEWIDGET": {},
            "BARCHARTWIDGET": {},
            "PIEWIDGET": {},
            "PAGINATEDTABLEWIDGET": {},
            "LINECHARTWIDGET": {},
            "HEATMAPWIDGET": {},
            "GAUGEWIDGET": {},
            "BREAKDOWNBARWIDGET": {}
        });
        $cache.put('PT-BR', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "Código de acesso",
                "ACCESS_CODE_PROTECTION": "Código de proteção do acesso",
                "ADD": "Adicionar",
                "ADD_BREAKOUT": "Adicionar quebra",
                "ADD_NOTE": "Adicionar observação",
                "ADD_SCHEDULED_REPORT": "Adicionar relatório agendado",
                "ADD_WIDGET": "Adicionar visualização",
                "ALL_PROJECTS": "Todos os projetos",
                "ALL_QUESTIONS": "Páginas de perguntas",
                "ANSWER": "Resposta",
                "ANY_CHANGES_LOST": "Qualquer mudança nos relatórios será perdida se você sair da plataforma Qualtrics XM.",
                "APPENDED_COPY_IN_PARENS": "(Copiar)",
                "AREA_CHART": "Gráfico de áreas",
                "AREA_CHART_DESC": "Um diagrama de linhas de dois eixos com a área sob a linha preenchida.",
                "ATTACHMENT": "Anexo",
                "BACKUP_CURRENT_REPORT": "Salve como cópia de backup deste relatório antes de afetar as visualizações",
                "BACKUP_CURRENT_REPORT_LINE2": "Observação: a cópia de backup será denominada \"{{nameOfReportCopy}}\"",
                "BACK_TO_REPORTS": "Voltar a relatórios",
                "BACK_TO_TOP": "Voltar ao topo",
                "BACK_TO_VIEW_RESULTS": "Voltar para resultados de visualizações de antigas",
                "BAR_CHART": "Gráfico de barras",
                "BAR_CHART_DESC": "Um gráfico de barras de dois eixos que permite a configuração adicional, como a transposição do eixo e rearranjo de pontos de dados.",
                "BREAKDOWN_BAR_CHART": "Barra de detalhamento",
                "BREAKDOWN_BAR_CHART_DESC": "Um gráfico de barras horizontais empilhadas mais comumente usado para ponderar visualmente as métricas umas contra as outras, como uma alternativa para o gráfico de pizza.",
                "CANCEL": "Cancelar",
                "CANCEL_CONF_TEXT": "Tem certeza que deseja cancelar?<br/>Todas as alterações serão perdidas.",
                "CANCEL_EDITS": "Cancelar edições",
                "CHART": "Gráfico",
                "CHOICE": "Opção de resposta",
                "CHOICES_COUNT_METRIC": "Contagem de opções de resposta",
                "CHOOSE_PAGES_TO_DISPLAY": "Escolha as páginas a serem exibidas",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "Este relatório contém {{maxReportPageCount}} páginas, mas os Resultados podem conter, no máximo, {{reportSizeLimit}}. Selecione um subconjunto dentro do limite.",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "Os relatórios só podem conter até {{reportSizeLimit}} páginas. Selecione as páginas que deseja.",
                "CLEAR_ALL": "Limpar tudo",
                "CLOSE": "Fechar",
                "CLOUD": "DESCRIÇÃO PARA NUVEM",
                "COLLABORATED_NEW": "O proprietário desta pesquisa está usando a plataforma Qualtrics XM! Os relatórios para esta pesquisa serão editados com o New Results.",
                "COMMA_SEPARATED_LIST": "Lista separada por vírgula",
                "COMPACTNESS": "Fontes e espaçamento",
                "COMPACTNESS_INFO": "Esta definição afeta o espaçamento da tabela, o tamanho da fonte e o tamanho da barra nos gráficos. Essa definição também será aplicada à maioria das exportações.",
                "CONFIRM": "Ok",
                "CONFIRM_DELETE": "Confirmar exclusão",
                "CONFIRM_DELETE_PAGE": "Tem certeza de que deseja excluir esta página?",
                "CONTINUE": "Continuar",
                "CONTINUE_EDITING": "Continuar editando",
                "COPY": "Copiar",
                "COPY_OF_REPORT_NAME": "Copiar de {{nameOfCurrentReport}}",
                "COPY_REPORT": "Copiar relatório",
                "COPY_REPORT_ELLIPSIS": "Copiar relatório...",
                "COPY_TO_NEW_REPORT": "Copiar para novo relatório...",
                "CREATE": "Criar",
                "CREATED": "Criado",
                "CREATE_CUSTOM_PAGE": "Criar página personalizada",
                "CREATE_NEW_REPORT": "Criar novo relatório",
                "CREATE_NEW_REPORT_ELLIPSIS": "Criar novo relatório...",
                "CSV_FILE": "Arquivo CSV",
                "CUSTOM_PAGES": "Personalizar páginas",
                "DATE": "Data",
                "DEFAULT_PALETTE": "Paleta de cores padrão",
                "DEFAULT_REPORT": "Relatório padrão",
                "DEFAULT_VISUALIZATIONS": "Visualizações padrão",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "Estes são os tipos de visualização padrão usados para elaborar relatórios de resultados padrão. A atualização e aplicação dessas configurações reconstruirão seu relatório atual com as novas configurações padrão. Você terá a opção de fazer backup do relatório atual.",
                "DEFAULT_VISUALIZATIONS_NOTE": "Observação: nem todo tipo de visualização está disponível para todos os tipos de pergunta. Algumas visualizações diferentes do padrão poderão ser automaticamente substituídas.",
                "DEFAULT_VISUALS_DISCLAIMER": "A Qualtrics atualizará este relatório com as novas configurações de visualização padrão.",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "Esta atualização afetará {{amountOfWidgetsAffected}} visualizações neste relatório.",
                "DEFAULT_VISUAL_EDIT_DETECTED": "Edição de visualização padrão detectada",
                "DELETE_BUTTON": "Excluir",
                "DELETE_DISABLED_EXPLANATION": "Não é permitido excluir relatórios criados na interface de relatoria anterior até que sua organização tenha realizado a migração completa para a plataforma Qualtrics XM.",
                "DELETE_PAGE": "Excluir página",
                "DELETE_PAGE_ELLIPSIS": "Excluir página...",
                "DELETE_REPORT": "Excluir relatório",
                "DELETE_REPORT_ELLIPSIS": "Excluir relatório...",
                "DELETE_WIDGET_QUESTION": "Excluir?",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "Este campo é criptografado e não pode ser usado para classificação.",
                "DISCARD_EDITS": "Descartar edições",
                "DISTRIBUTION_PAUSED": "Distribuição de relatório interrompida.",
                "DONE_BUTTON": "Feito",
                "DONE_EDITING": "Edição concluída",
                "DOWNLOAD": "Baixar",
                "DOWNLOAD_AS_CSV": "Baixar como CSV",
                "DOWNLOAD_AS_PDF": "Baixar como PDF",
                "DOWNLOAD_FAILED": "Falha no download",
                "DOWNLOAD_PREVIOUS_EXPORTS": "Baixar exportações anteriores...",
                "DO_YOU_WISH_TO_DELETE": "Você deseja excluir:",
                "DUPLICATE_PAGE": "Planilha duplicada",
                "EDIT_REPORT": "Editar relatório",
                "EDIT_REPORT_ELLIPSIS": "Editar relatório...",
                "EDIT_VISUALIZATION": "Editar visualização",
                "EMAIL_ADDRESS": "Endereço de e-mail",
                "EMAIL_SENT": "E-mail enviado...",
                "END_OF_REPORT": "Final do relatório",
                "ENTER_NAME": "Insira o nome",
                "ERROR_COPYING": "Erro ao copiar o relatório.",
                "ERROR_DELETING": "Erro ao excluir o relatório.",
                "ERROR_DELETING_EXPORT": "Erro ao excluir a exportação.",
                "ERROR_HEADING": "Erro",
                "ERROR_PUBLISHING": "Erro ao salvar as definições.",
                "ERROR_RENAMING": "Erro ao renomear o relatório.",
                "ERROR_REQUESTING_EXPORT": "Erro ao solicitar a exportação.",
                "ERROR_SAVING_GLOBAL_OPTIONS": "Ocorreu um erro ao salvar as opções de visualização global.",
                "ERROR_SEND_TEST_EMAIL": "Erro ao enviar o relatório.",
                "EVERY_FRIDAY": "Todas as sextas-feiras",
                "EVERY_MONDAY": "Todas as segundas-feiras",
                "EVERY_MONTH": "Mensalmente em",
                "EVERY_SATURDAY": "Todos os sábados",
                "EVERY_SUNDAY": "Todos os domingos",
                "EVERY_THURSDAY": "Todas as quintas-feiras",
                "EVERY_TUESDAY": "Todas as terças-feiras",
                "EVERY_WEDNESDAY": "Todas as quartas-feiras",
                "EVERY_WEEK": "Semanalmente a cada",
                "EXAMPLE_GROUP_NUM": "Grupo {{num}}",
                "EXAMPLE_SERIES_NUM": "Série {{num}}",
                "EXPORT": "Exportar",
                "EXPORT_CSV": "CSV (Valores separados por vírgulas)",
                "EXPORT_EXCEL_SPREADSHEET": "Planilha de Excel",
                "EXPORT_IMAGE": "Exportar imagem",
                "EXPORT_PAGES": "Exportar páginas",
                "EXPORT_PDF": "Documento em PDF",
                "EXPORT_PPT_SLIDES": "Slides de Powerpoint",
                "EXPORT_RAW_DATA": "Exportar dados brutos",
                "EXPORT_REPORT": "Exportar relatório",
                "EXPORT_VISUALIZATION": "Exportar visualização",
                "EXPORT_WORD_DOC": "Documento em Word",
                "FAILED_SAVE_TXT": "Falha ao salvar",
                "FILTERED": "Filtrados",
                "FIRST_PAGE": "Primeira página",
                "FIRST_WEEKDAY": "Primeiro dia da semana do mês",
                "FROM": "De",
                "FROM_EMAIL": "De e-mail",
                "FROM_NAME": "Do nome",
                "GAUGE_CHART": "Gráfico com indicadores",
                "GAUGE_CHART_DESC": "Um gráfico que assemelha-se a uma ferramenta de medição para comparar os valores atuais com um objetivo ou com uma série de limiares.",
                "GENERATING_FILE": "Criando seu arquivo...",
                "GENERATING_IMAGE": "Criando imagem...",
                "GENERATING_PDF": "Gerando PDF...",
                "GENERIC_ERROR": "Um erro nos impediu de carregar o projeto solicitado.",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "Opções globais...",
                "GLOBAL_METRIC": "Métrica padrão",
                "GLOBAL_MODAL_PAGE_TITLE": "Visualização de exemplo usando as opções globais para a seção de Resultados da Qualtrics Research Suite",
                "GLOBAL_MODAL_WIDGET_TITLE": "Título de visualização",
                "GLOBAL_OPTIONS": "Opções globais",
                "GLOBAL_PRECISION": "Casas decimais padrão",
                "GLOBAL_SETTINGS_APPLY": "Aplicar minhas configurações padrão",
                "GLOBAL_SETTINGS_SAVE": "Salvar como minhas configurações padrão",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "Aplicar padrão da Qualtrics",
                "GROUP": "Grupo",
                "HEAT_MAP_CHART": "Gráfico de mapa de calor",
                "HEAT_MAP_CHART_DESC": "Uma visualização estilo \"calor agrupado\" usado para a distribuição de mapeamento de entrada do usuário (como cliques) para a imagem original.",
                "HIDDEN": "Oculto",
                "HIDDEN_PAGE": "Esta página não aparecerá em relatórios públicos e será desmarcada por padrão nas exportações de relatórios.",
                "HIDE": "Ocultar",
                "HIDE_ALL_PAGES": "Ocultar todas as páginas",
                "HIDE_PAGE": "Ocultar página",
                "IMAGE_FILE": "Arquivos de imagem",
                "INVALID_BRAND_DOMAIN": "O domínio que você inseriu não está na lista de domínios de e-mails aprovados da sua marca. Entre em contato com o administrador da sua marca para corrigir isso.",
                "INVALID_SPF_RECORD": "O domínio que você inseriu não aprovou o envio pela Qualtrics a partir dele. Isso afetará a entrega. Use outro domínio ou entre em contato com a Qualtrics para resolver esse problema.",
                "ISSUE_SAVING_REPORTS": "Um ou mais relatórios encontraram um problema ao salvar. Tente novamente.",
                "ISSUE_SENDING_TEST": "Ocorreu um erro ao enviar um e-mail de teste. Tente novamente.",
                "LARGE_SURVEY": "Não será possível exibir os resultados porque a pesquisa é muito ampla.",
                "LAST_DAY": "Último dia do mês",
                "LAST_MODIFIED_COLON_WITH_DATE": "Última alteração: %1",
                "LAST_PAGE": "Última página",
                "LAST_WEEKDAY": "Último dia da semana do mês",
                "LATER": "Depois",
                "LEARN_MORE": "Saiba mais",
                "LINE_CHART": "Diagrama de linhas",
                "LINE_CHART_DESC": "Um diagrama de linhas de dois eixos normalmente usado quando se representa graficamente contra o tempo no eixo x.",
                "LOG_OUT_WARNING": "Clique em qualquer lugar dentro de {{countdown}} segundos para se manter conectado.",
                "MESSAGE": "Mensagem",
                "MONTHLY": "Mensal",
                "MOVE_DOWN": "Mover visualização para baixo",
                "MOVE_PAGE_TO_BOTTOM": "Mover para baixo",
                "MOVE_PAGE_TO_TOP": "Mover para cima",
                "MOVE_UP": "Mover visualização para cima",
                "MY_SURVEYS": "Meus projetos",
                "NAME": "Nome",
                "NEW_CUSTOM_PAGE_NAME": "Nova página personalizada",
                "NEW_REPORT": "Novo relatório",
                "NEXT_PAGE": "Próxima página",
                "NEXT_RUN": "Próxima execução",
                "NO_EXPORTS": "Não há nenhuma solicitação de exportação para esse projeto ainda.",
                "NO_ITEMS_TO_DISPLAY": "Não há itens para exibir",
                "NO_MATCHING_CUSTOM_PAGES": "Não há páginas personalizadas correspondentes",
                "NO_MATCHING_PAGES": "Nenhuma página encontrada",
                "NO_MATCHING_REPORTS": "Nenhum relatório correspondente.",
                "NO_PROJECT": "Especifique um projeto para continuar.",
                "NO_PROJECTS_TO_MIGRATE": "Não há projetos para atualizar.",
                "NO_QUESTIONS": "Não há perguntas correspondentes",
                "NO_RESULTS_YET": "Ainda não há nenhum resultado para ser exibido. Distribua sua pesquisa para coletar respostas.",
                "OFF": "Desligado",
                "ON": "Ligado",
                "PAGES_SELECTED": "Páginas selecionadas",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "Essa seleção faria com que o relatório contivesse {{currentSelectedPageCount}} páginas, o que está acima do {{reportSizeLimit}} máximo permitido. Selecione um intervalo menor.",
                "PAGES_SELECTION_INVALID_RANGE": "Selecione um intervalo válido.",
                "PAGE_OPTIONS": "Opções da página",
                "PDF_ROW_TRUNCATION_MESSAGE": "Linhas demais para exportar para PDF, tente exportar para Word ou CSV.",
                "PERCENTAGE_METRIC": "Porcentagem",
                "PIE_CHART": "Gráfico de pizza",
                "PIE_CHART_DESC": "Detalhamento circular de valores para um determinado ponto de dados. Útil para medir as proporções relativas dos valores selecionados.",
                "PREVIEW": "Visualização",
                "PREVIOUS_PAGE": "Página anterior",
                "PRINT_PAGE": "Imprimir página",
                "PUBLIC_LINK": "Link Público",
                "PUBLIC_REPORT_AVAILABLE": "Relatório público disponível",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "Código de acesso",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "Código de Acesso Incorreto. Tente novamente.",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "Enviar",
                "PUBLIC_RESULTS_LOGIN_TITLE": "Login do Relatório Público | Qualtrics Survey Software",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "Relatório Público não encontrado. Entre em contato com o proprietário desse relatório e peça um link válido.",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "Relatório público não encontrado",
                "PUBLIC_RESULTS_NOT_UPDATED": "Os links para relatórios públicos e e-mails de relatórios agendados não usarão a plataforma Qualtrics XM até que você os atualize.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "Sessão expirada. Faça login novamente para continuar pré-visualizando o Relatório de Resultados Públicos.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "Sessão expirada",
                "PUBLIC_RESULTS_TITLE": "Relatório público",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "Você não está autorizado a visualizar esta página. Entre em contato com o proprietário desse relatório e peça que os torne públicos.",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "Relatório público não autorizado",
                "PUBLISHED_LINK_GENERATING_LINK": "Criando links...",
                "PUBLISHED_REPORT_FOUND_HERE": "Qualquer um pode visualizar este relatório no seguinte link:",
                "PUBLISH_REPORT": "Administrar relatório público",
                "PUBLISH_REPORT_ELLIPSIS": "Administrar relatório público...",
                "QUESTION": "Pergunta",
                "RANK": "Classificação",
                "REMOVE_WIDGET": "Remover visualização",
                "RENAME_PAGE": "Renomear página",
                "RENAME_REPORT": "Renomear relatório",
                "RENAME_REPORT_ELLIPSIS": "Renomear relatório...",
                "REPLY_TO_EMAIL": "Responder a e-mail",
                "REPORT_COLON": "Relatório:",
                "REPORT_SETTINGS": "Configurações de relatório",
                "REPORT_SETTINGS_ELLIPSIS": "Configurações de relatório...",
                "RESPONSE_COUNTS": "Contagens de respostas",
                "RESULTS_DASHBOARDS_BANNER": "e experimente a nova e aprimorada versão dos resultados de pesquisas que contém visualizações de dados e interface do usuário modernas e acessíveis, novas funções de análises e exploração e muito mais.",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "Notas de versão",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "Visualizar a mais recente",
                "RESULTS_OPTIONS": "Opções de relatório",
                "RESULTS_TITLE": "Relatório",
                "RESUME_DISTRIBUTION": "Retomar distribuição",
                "REVERT": "Reverter",
                "RICH_TEXT_LIMIT_REACHED": "O comprimento do conteúdo atingiu o limite!",
                "SAVE": "Salvar",
                "SAVE_AND_CLOSE": "Salvar e fechar",
                "SAVE_AS_CSV": "Salvar visualização como CSV",
                "SAVE_AS_IMAGE": "Salvar visualização como imagem",
                "SAVE_CONFIRMATION": "Salvar confirmação",
                "SAVE_PAGE_AS_ELLIPSIS": "Exportar páginas como...",
                "SAVE_SETTINGS": "Salvar configurações",
                "SCHEDULE_REPORT_EMAIL": "Agendar envio de e-mail de relatório",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "Agendar envio de e-mail de relatório...",
                "SEARCH_ELLIPSIS": "Pesquisar...",
                "SEARCH_PAGES": "Pesquisar perguntas",
                "SEARCH_PAGES_ELLIPSIS": "Pesquisar páginas...",
                "SEARCH_REPORTS_ELLIPSIS": "Buscar relatórios...",
                "SELECTED": "Selecionado:",
                "SELECT_ALL": "Selecionar tudo",
                "SELECT_A_FIELD": "Selecionar um campo",
                "SELECT_A_WIDGET": "Selecionar uma visualização",
                "SELECT_PAGES": "Selecionar páginas",
                "SELECT_PAGES_ELLIPSIS": "Selecionar páginas...",
                "SEND": "Enviar",
                "SEND_TEST_EMAIL": "Enviar e-mail de teste",
                "SETTING_DEFAULT": "Padrão",
                "SETTING_HIGH": "Alto",
                "SETTING_LARGE": "Grande",
                "SETTING_LOW": "Baixo",
                "SETTING_NORMAL": "Normal",
                "SETTING_SMALL": "Pequeno",
                "SHARE_REPORT": "Compartilhar arquivo",
                "SHOW_ALL_PAGES": "Exibir todas as páginas",
                "SHOW_FULL_QTEXT": "Mostrar o texto da pergunta completa em títulos da página",
                "SIMPLE_TABLE": "Tabela simples",
                "SIMPLE_TABLE_DESC": "Uma tabela flexível que pode mostrar vários valores como linhas ou colunas.",
                "SIZE": "Tamanho",
                "SPLINE_CHART": "Gráfico interpolado",
                "SPLINE_CHART_DESC": "Um diagrama de linhas arredondado de dois eixos normalmente usado quando se representa graficamente contra o tempo no eixo x.",
                "STATISTICS_TABLE": "Tabela estatística",
                "SUBJECT": "Assunto",
                "SURVEY_ANALYSIS": "Análise da pesquisa",
                "SURVEY_SUMMARY": "Resumo da pesquisa",
                "TABLE": "DESCRIÇÃO PARA TABELA",
                "TIME": "Hora",
                "TO": "Para",
                "TOTAL": "Total",
                "TRANSPOSE_STATS_TABLES": "Transponha tabelas estatísticas",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "Transponha quebras de tabelas estatísticas",
                "TRUNCATE_PAGE_TITLES": "Truncar o texto da pergunta completa em títulos da página",
                "TRY_IT_NOW": "Experimente-a agora!",
                "TYPE": "Tipo",
                "UNABLE_TO_CHECK_SPF": "Não foi possível verificar o registro de SPF. Tente novamente.",
                "UNAUTHORIZED": "Você não tem permissão para ver esse relatório. Entre em contato com o proprietário para o acesso.",
                "UNHIDE_PAGE": "Revelar página",
                "UPDATE": "Atualizar",
                "UPDATED_SUCCESSFULLY": "Atualização feita com sucesso.",
                "UPDATE_ALL_IN_THIS_PROJECT": "Atualizar todos neste projeto",
                "UPDATE_ALL_PROJECTS": "Atualizar todos os projetos",
                "UPDATE_NOW": "Atualizar agora",
                "UPDATE_REPORTS": "Atualizar relatórios..",
                "UPDATE_REPORT_ELEMENTS": "Atualizar links de relatórios públicos e e-mails de relatórios programados",
                "UPGRADE_MY_ACCOUNT": "Atualizar minha conta",
                "USE_EXPORT_TAGS": "Incluir os números das perguntas",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "Usar somatória simples de tabela",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "Usar contagem de correspondentes de tabela",
                "USE_WEIGHTED_METRICS": "Usar métrica ponderada",
                "VIEW": "Visualizar",
                "WEEKLY": "Semanal",
                "WELCOME_TO_NEW_RESULTS": "Bem-vindo à plataforma Qualtrics XM de Relatórios!",
                "WHEN": "Quando enviar e-mail(s)",
                "WIDGET_LOADING": "Carregando...",
                "WIDGET_OPTIONS_ERR": "Falha ao carregar as opções de visualização",
                "WIDGET_TYPE": "Visualização",
                "WORD_CLOUD": "Nuvem de palavras",
                "WORD_CLOUD_DESC": "A visualização ponderada de frequência de palavras em dados de texto com opções de codificação de cores adicionais."
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Lembre-se de que há pessoas na sua organização para ajudar você a interpretar seu feedback, como parceiros de RH, seu gerente e/ou um mentor.",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Pegue uma xícara de café e analise o feedback que você recebeu.",
                "ABOUT_YOUR_REPORT_HEADER": "Sobre o seu relatório",
                "ABOUT_YOUR_REPORT_LINE1": "Bem-vindo(a) ao relatório de feedback 360 graus. Esta é uma ótima oportunidade para você crescer e se desenvolver como profissional. Para extrair o máximo dos resultados, reserve tempo suficiente para analisar o feedback recebido. Sabemos que inicialmente pode ser difícil receber feedback, mas lembre-se de que o objetivo do feedback é acelerar seu crescimento e desenvolvimento.",
                "ABOUT_YOUR_REPORT_LINE2": "Tenha o seguinte em mente ao analisar seu relatório:",
                "ADD_CONDITIONAL_TEXT": "Adicionar texto condicional",
                "ADD_CUSTOM_PALETTE": "Adicionar paleta personalizada",
                "ADD_DATA_SOURCE": "Adicionar fonte de dados",
                "ADD_FOLLOWING": "Adicionar seguinte",
                "ADD_LABEL": "Adicionar rótulo",
                "ADVANCED_FILTER": "Filtro avançado",
                "AGREEMENT_CHART": "Gráfico de concordância",
                "AGREEMENT_CHART_FOOTER": "O gráfico de concordância indica a similaridade das pontuações. Cada ponto representa como os indivíduos classificaram você em cada item. O tamanho do ponto mostra quantos indivíduos lhe deram uma classificação específica.",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "respostas",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "resposta",
                "AGREEMENT_CHART_LEGEND_TITLE": "Como os outros avaliaram você",
                "ALL": "Todos",
                "AND_IF": "E se",
                "ANGLED": "Em ângulo",
                "AREA": "Área",
                "AUTO": "Automático",
                "AVERAGE": "Média",
                "AXIS_VALUES": "Valores de eixo",
                "BAR": "Barra",
                "BASE_WORD_COLOR": "Cor da palavra base",
                "BLUR": "Borrão",
                "BOTTOM_BOX": "Caixa inferior",
                "BREAKOUT_HEADERS": "Cabeçalhos de quebra",
                "CANCEL": "Cancelar",
                "CATEGORICAL": "Categórico",
                "CATEGORY": "Categoria",
                "CATEGORY_NAME": "Nome da categoria",
                "CHANGE_CATEGORIES_ORDER": "Alterar ordem de categorias",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "Alterar ordem de categorias de pontuação",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "Altere a ordem que aparece na visualização clicando à esquerda do elemento de categoria de pontuação e arrastando-o para a posição desejada.",
                "CHANGE_QUESTIONS_ORDER": "Alterar ordem de perguntas",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "Alterar ordem de perguntas",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "Altere a ordem que aparece na visualização clicando à esquerda do elemento de pergunta e arrastando-o para a posição desejada.",
                "CHARTS": "Gráficos",
                "CHART_TYPE": "Tipo de gráfico",
                "CHOICE_COUNT": "Contagem de opção de resposta",
                "CHOICE_TOTALS": "Totais de opções de resposta",
                "CLEAR": "Limpar",
                "CLOSE": "Fechar",
                "COLOR_PALETTE": "Paleta de cores",
                "COLUMN_NAMES": "Nomes de coluna",
                "COLUMN_TOTALS": "Totais de coluna",
                "COMPARED_FILTER_GROUP": "Grupo de filtros comparados",
                "COMPARED_FILTER_GROUPS": "Grupos de filtros comparados",
                "COMPARE_WITH": "comparar com",
                "COMPETITION_RANKING": "Usar classificação de competição",
                "COMPETITION_RANKING_TOOLTIP": "Em caso de empate, todas as pontuações iguais recebem a mesma classificação. No entanto, o próximo item subsequente será classificado igual a: o número total de itens com classificação mais alta na tabela, mais um.",
                "COMPLETED_RESPONSES": "Respostas concluídas",
                "CONDITIONAL_TEXT": "Texto condicional",
                "COUNT": "Contagem",
                "CREATE": "Criar",
                "CUSTOM_PALETTE": "Paleta personalizada",
                "DATA_SOURCE_TYPE": "Tipo de origem de dados",
                "DATA_SOURCE_TYPE_CATEGORY": "Categorias de pontuação",
                "DATA_SOURCE_TYPE_QUESTION": "Perguntas",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "Pergunta",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "Itens classificáveis",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "Categoria de Pontuação",
                "DEFAULT": "Padrão",
                "DEFAULT_TEXT": "Texto padrão",
                "DELETE": "Excluir",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "Entenda de quem você está recebendo o feedback (de colegas, subordinados diretos, líderes etc.)",
                "DIFFERENT_EVALUATORS_HEADER": "Diferentes avaliadores",
                "DIRECT_REPORTS": "Subordinados diretos",
                "DISABLED": "Desativado",
                "DISPLAY_OPTIONS": "Opções de exibição",
                "DISPLAY_THRESHOLD_TEXTS": "Exibir texto com base na seguinte lacuna de grupos",
                "DIVERGENT": "Divergente",
                "DONE": "Feito",
                "DONT_HEADER": "Não:",
                "DONT_LINE1": "Tente descobrir quem disse o quê",
                "DONT_LINE2": "Foque sua atenção em uma pontuação ou um comentário positivo/negativo",
                "DONT_LINE3": "Crie um plano de desenvolvimento relacionado a cada item",
                "DONT_LINE4": "Perca a motivação ao descobrir que há pontos em que precisa melhorar",
                "DONUT": "Donut",
                "DOWNLOAD_CSV": "Baixar CSV herdado",
                "DOWNLOAD_ZIP": "Baixar todos os arquivos",
                "DO_HEADER": "Sim:",
                "DO_LINE1": "Veja o feedback como um todo",
                "DO_LINE2": "Identifique temas em pontos fortes e oportunidades de aprimoramento",
                "DO_LINE3": "Priorize algumas áreas de enfoque para serem incluídas no seu plano de desenvolvimento",
                "DO_LINE4": "Compreenda que todos temos como melhorar",
                "DROPOFF": "Queda",
                "DUPLICATE": "Duplicar",
                "EDIT_CONDITIONAL_TEXT": "Editar texto condicional",
                "EDIT_CUSTOM_PALETTE": "Editar Paleta Personalizada",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "Ou exibir o seguinte texto",
                "ENABLED": "Habilitado",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "Ativar ordenação por lógica de exibição da categoria do classificador",
                "ENABLE_ORDERING_FOR": "Habilitar ordenação para",
                "EQUAL_TO": "Igual a",
                "FIELD": "Campo",
                "FILTER_NAMES": "Nomes de filtro",
                "FOLLOWING_PARENTHESES": "(seguinte)",
                "FOOTER": "Rodapé",
                "GAP": "Lacuna",
                "GAP_CHART": "Gráfico de lacunas",
                "GAP_CHART_DESCRIPTION": "O gráfico de lacunas exibe a diferença em pontuações entre os dois grupos de classificadores. Por exemplo, no caso de autoclassificações x classificações dadas por outras pessoas, uma diferença positiva (+) significa que as outras pessoas lhe deram uma classificação maior do que aquela que você se deu. Uma diferença negativa (-) significa que as outras pessoas lhe deram uma classificação menor do que aquela que você se deu.",
                "GAP_CHART_FOOTER": "O gráfico de lacunas indica a diferença +/- entre dois grupos de classificadores.",
                "GAP_TABLE_DESCRIPTION": "Pontos fortes ocultos mostram onde outras pessoas lhe deram uma classificação maior do que aquela que você se deu. Áreas de aprimoramento mostram onde outras pessoas lhe deram uma classificação menor do que aquela que você se deu. Ambas as seções são exibidas da maior lacuna para a menor.",
                "GAP_TABLE_FOOTER": "A primeira coluna de pontuações indica como você pontuou a si mesmo. A segunda coluna indica a pontuação média de resposta de outros. A terceira coluna indica a diferença entre como você pontuou a si mesmo e como outros pontuaram você.",
                "GAP_TABLE_TITLE": "Áreas de pontos fortes ocultos/de aprimoramento",
                "GREATER_OR_EQUAL": "Maior que ou igual a",
                "GREATER_THAN": "Maior que",
                "GROUP": "Grupo",
                "GROUPED_FOR_ANONYMITY": "Agrupado por unanimidade.",
                "HEADER_NAMES": "Nomes de cabeçalho",
                "HIGHEST_SCORES": "Resultados maiores",
                "HIGHLIGHT_THRESHOLD": "Limite para destaque de lacunas",
                "HIGHLOW_TABLE": "Pontuações altas e baixas",
                "HIGHLOW_TABLE_FOOTER": "Esta seção mostra os cinco comportamentos mais altos e mais baixos (em todos os comportamentos) das médias aplicáveis da categoria de avaliadores. Para aproveitar ao máximo esta página, é útil procurar tendências que possam surgir. Por exemplo, se a maioria dos seus comportamentos com classificação mais baixa estiver concentrada em uma ou duas categorias; estas podem ser áreas que precisam de desenvolvimento. Os comportamentos com classificação mais alta podem identificar pontos fortes que podem ser aproveitados em outras áreas.",
                "HIGH_LOW_TABLE_DESCRIPTION": "O gráfico de pontuações altas e baixas exibe itens com base nas áreas onde outras pessoas lhe deram a maior pontuação e nas áreas onde outras pessoas lhe deram a menor pontuação.",
                "HORIZONTAL": "Horizontal",
                "HORIZONTAL_AND_VERTICAL": "Horizontal e vertical",
                "HORIZONTAL_BAR": "Barra horizontal",
                "HOW_TO_INTERPRET_RESULT_HEADER": "Como interpretar resultados e determinar a ação a ser tomada:",
                "IF": "Se",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "Incluir etiquetas ocultas nos percentuais",
                "INNER_RIM": "Borda interna",
                "IS": "É",
                "IS_NOT": "Não é",
                "IS_SAME_AS_SUBJECT": "É o mesmo que o indivíduo",
                "ITEM": "Item",
                "LABEL": "rótulo",
                "LABELS": "Etiquetas",
                "LARGE_LABELS": "Etiquetas grandes",
                "LEGEND": "Legenda",
                "LEGEND_POSITION": "Posição da legenda",
                "LEGEND_VALUES": "Valores de legenda",
                "LESS_OR_EQUAL": "Menor que ou igual a",
                "LESS_THAN": "Menor que",
                "LINE": "Linha",
                "LOWEST_SCORES": "Resultados menores",
                "MANAGERS": "Gerentes",
                "MANUAL_FONT_SIZE": "Definir o tamanho da fonte manualmente",
                "MAX": "Máximo",
                "MEAN": "Meio",
                "MEDIAN": "Mediana",
                "METRIC_TYPE": "Tipo de métrica",
                "MIN": "Mínimo",
                "MODIFY_CUSTOM_PALETTES": "Modificar Paleta Personalizada",
                "MOVE_DOWN": "Mover para baixo",
                "MOVE_UP": "Mover para cima",
                "MULTI_SELECT_ITEMS_SELECTED": "selecionados",
                "NEGATIVE_GAPS": "Áreas de aprimoramento",
                "NO": "Não",
                "NONE": "Nenhuma",
                "NOT_APPLICABLE": "N/A",
                "NOT_EQUAL_TO": "Diferente de",
                "NO_DATA_AVAILABLE_WARNING": "Nenhum dado disponível",
                "NO_FILTER": "Nenhum filtro",
                "NO_FILTER_IS_APPLIED": "Nenhum filtro aplicado.",
                "NO_VALUE": "Nenhum valor",
                "NPS": "Net Promoter Score",
                "NUMBER": "número",
                "NUMBERS": "Números",
                "NUMBER_OF_GAPS_NEGATIVE": "Número de lacunas negativas",
                "NUMBER_OF_GAPS_POSITIVE": "Número de lacunas positivas",
                "NUMBER_OF_ROWS_HIGH": "Número de linhas altas",
                "NUMBER_OF_ROWS_LOW": "Número de linhas baixas",
                "OPTIONS": {
                    "HEADER_NAME": "Nome de cabeçalho",
                    "LEGEND": "Legenda",
                    "SCALE_AXIS_CHANGER_TITLE": "Intervalo"
                },
                "ORIENTATION": "Orientação",
                "OR_IF": "Ou se",
                "OTHER": "Outros",
                "OTHERS": "Outros",
                "PAGE_OF": "Página %1 de %2",
                "PALETTE_REMOVED": "Paleta Removida",
                "PEERS": "Colegas",
                "PERCENT": "Percentual",
                "PERCENTAGE": "Porcentagem",
                "PERCENTAGE_OF_CHOICES": "Porcentagem de opções de resposta",
                "PERCENTAGE_OF_RESPONSES": "Porcentagem de respostas",
                "PERCENT_COMPLETE": "% concluído",
                "PERSON_METADATA": "Metadados da pessoa",
                "PERSON_METADATA_EVALUATOR": "Do avaliador",
                "PERSON_METADATA_SUBJECT": "Do indivíduo",
                "PERSON_METADATA_VIEWER": "Do visualizador",
                "POSITIVE_GAPS": "Pontos fortes ocultos",
                "PRIMARY_PARENTHESES": "(principal)",
                "QUESTIONS": "Perguntas",
                "RADIUS": "Raio",
                "RANK": "Classificação",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "Pontuações mais altas",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "Pontuações mais altas",
                "RANKABLE_ITEMS_ITEM_HAS": "O item tem",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "O item está no topo",
                "RANKABLE_ITEMS_LOWEST_SCORE": "Pontuações mais baixas",
                "RANKABLE_ITEMS_LOWEST_SCORES": "Pontuações mais baixas",
                "RATER_CATEGORY_DISPLAY_LOGIC": "lógica de exibição da categoria do classificador",
                "RATIO": "Proporção",
                "RECORD": "Registro",
                "REFERENCE_GROUP": "Grupo de referência",
                "RELATIONSHIP": "Relação",
                "RELATIONSHIP_FILTERS": "Filtros de relação",
                "RELATIONSHIP_FILTERS_INFO": "Para adicionar um filtro de relação (como subordinado direto, colega ou gerente), clique em Gerenciar seus filtros e use somente a condição de relação no menu suspenso.",
                "REMOVE": "Remover",
                "REMOVE_DATA_SOURCE": "Remover fonte de dados",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Lembre-se de que há pessoas na sua organização para ajudar você a interpretar seu feedback, como parceiros de RH, seu gerente e/ou um mentor.",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Pegue uma xícara de café e analise o feedback que você recebeu.",
                    "ABOUT_YOUR_REPORT_HEADER": "Sobre o seu relatório",
                    "ABOUT_YOUR_REPORT_LINE1": "Bem-vindo(a) ao relatório de feedback 360 graus. Esta é uma ótima oportunidade para você crescer e se desenvolver como profissional. Para extrair o máximo dos resultados, reserve tempo suficiente para analisar o feedback recebido. Sabemos que inicialmente pode ser difícil receber feedback, mas lembre-se de que o objetivo do feedback é acelerar seu crescimento e desenvolvimento.",
                    "ABOUT_YOUR_REPORT_LINE2": "Tenha o seguinte em mente ao analisar seu relatório:",
                    "ADVANCED_FILTER": "Filtro avançado",
                    "AGREEMENT_CHART": "Gráfico de concordância",
                    "AGREEMENT_CHART_FOOTER": "O gráfico de concordância indica a similaridade das pontuações. Cada ponto representa como os indivíduos classificaram você em cada item. O tamanho do ponto mostra quantos indivíduos lhe deram uma classificação específica.",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "respostas",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "resposta",
                    "AGREEMENT_CHART_LEGEND_TITLE": "Como os outros avaliaram você",
                    "ALL": "Todos",
                    "AVERAGE": "Média",
                    "BOTTOM_BOX": "Caixa inferior",
                    "CHOICE_COUNT": "Contagem de opção de resposta",
                    "CHOICE_TOTALS": "Totais de opções de resposta",
                    "COMPARISON": "Comparação",
                    "COMPARISON_GAP_COLUMN_HEADER": "Lacuna de comparação",
                    "COMPLETED_RESPONSES": "Respostas concluídas",
                    "COUNT": "Contagem",
                    "DEFAULT": "Padrão",
                    "DEFAULT_TEXT": "Texto padrão",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "Entenda de quem você está recebendo o feedback (de colegas, subordinados diretos, líderes etc.)",
                    "DIFFERENT_EVALUATORS_HEADER": "Diferentes avaliadores",
                    "DONE": "Concluído",
                    "DONT_HEADER": "Não:",
                    "DONT_LINE1": "Tente descobrir quem disse o quê",
                    "DONT_LINE2": "Foque sua atenção em uma pontuação ou um comentário positivo/negativo",
                    "DONT_LINE3": "Crie um plano de desenvolvimento relacionado a cada item",
                    "DONT_LINE4": "Perca a motivação ao descobrir que há pontos em que precisa melhorar",
                    "DO_HEADER": "Sim:",
                    "DO_LINE1": "Veja o feedback como um todo",
                    "DO_LINE2": "Identifique temas em pontos fortes e oportunidades de aprimoramento",
                    "DO_LINE3": "Priorize algumas áreas de enfoque para serem incluídas no seu plano de desenvolvimento",
                    "DO_LINE4": "Compreenda que todos temos como melhorar",
                    "FIELD": "Campo",
                    "GAP": "Lacuna",
                    "GAP_CHART": "Gráfico de lacunas",
                    "GAP_CHART_DESCRIPTION": "O gráfico de lacunas exibe a diferença em pontuações entre os dois grupos de classificadores. Por exemplo, no caso de autoclassificações x classificações dadas por outras pessoas, uma diferença positiva (+) significa que as outras pessoas lhe deram uma classificação maior do que aquela que você se deu. Uma diferença negativa (-) significa que as outras pessoas lhe deram uma classificação menor do que aquela que você se deu.",
                    "GAP_CHART_FOOTER": "O gráfico de lacunas indica a diferença +/- entre dois grupos de classificadores.",
                    "GAP_TABLE_DESCRIPTION": "Pontos fortes ocultos mostram onde outras pessoas lhe deram uma classificação maior do que aquela que você se deu. Áreas de aprimoramento mostram onde outras pessoas lhe deram uma classificação menor do que aquela que você se deu. Ambas as seções são exibidas da maior lacuna para a menor.",
                    "GAP_TABLE_FOOTER": "A primeira coluna de pontuações indica como você pontuou a si mesmo. A segunda coluna indica a pontuação média de resposta de outros. A terceira coluna indica a diferença entre como você pontuou a si mesmo e como outros pontuaram você.",
                    "GAP_TABLE_TITLE": "Áreas de pontos fortes ocultos/de aprimoramento",
                    "GROUP": "Grupo",
                    "HIDE_REPORT_ALERT": "Você não cumpre com os requisitos para visualizar o seu relatório. Entre em contato com o administrador da sua organização.",
                    "HIGHEST_SCORES": "Resultados maiores",
                    "HIGHLOW_TABLE": "Pontuações altas e baixas",
                    "HIGHLOW_TABLE_FOOTER": "Esta seção mostra os cinco comportamentos mais altos e mais baixos (em todos os comportamentos) das médias aplicáveis da categoria de avaliadores. Para aproveitar ao máximo esta página, é útil procurar tendências que possam surgir. Por exemplo, se a maioria dos seus comportamentos com classificação mais baixa estiver concentrada em uma ou duas categorias; estas podem ser áreas que precisam de desenvolvimento. Os comportamentos com classificação mais alta podem identificar pontos fortes que podem ser aproveitados em outras áreas.",
                    "HIGH_LOW_TABLE_DESCRIPTION": "O gráfico de pontuações altas e baixas exibe itens com base nas áreas onde outras pessoas lhe deram a maior pontuação e nas áreas onde outras pessoas lhe deram a menor pontuação.",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "Como interpretar resultados e determinar a ação a ser tomada:",
                    "ITEM": "Item",
                    "LOWEST_SCORES": "Resultados menores",
                    "MAX": "Máximo",
                    "MEAN": "Meio",
                    "MEDIAN": "Mediana",
                    "MIN": "Mínimo",
                    "NEGATIVE_GAPS": "Áreas de aprimoramento",
                    "NO_COMPARISON_SET": "Nenhuma comparação definida",
                    "NO_DATA_AVAILABLE_WARNING": "Nenhum dado disponível",
                    "NO_FILTER_IS_APPLIED": "Nenhum filtro aplicado.",
                    "NO_VALUE": "Nenhum valor",
                    "NPS": "Net Promoter Score",
                    "OTHERS": "Outros",
                    "PERCENTAGE": "Porcentagem",
                    "PERCENTAGE_OF_CHOICES": "Porcentagem de opções de resposta",
                    "PERCENTAGE_OF_RESPONSES": "Porcentagem de respostas",
                    "PERCENT_COMPLETE": "% concluído",
                    "POSITIVE_GAPS": "Pontos fortes ocultos",
                    "QUESTIONS": "Perguntas",
                    "RANK": "Classificação",
                    "RELATIONSHIPS": {
                        "ANYONE": "Qualquer um",
                        "DIRECT_REPORT": "Subordinado direto",
                        "MANAGER": "Gestor",
                        "PEER": "Colega",
                        "SELF": "Você"
                    },
                    "REPORT_SUMMARY": "Resumo do relatório",
                    "REPORT_SUMMARY_TABLE_FOOTER": "Compare o número de pessoas que finalizaram a apreciação com o número de pessoas convidadas para participar.",
                    "REPORT_SUMMARY_TABLE_HEADER": "Estatísticas do entrevistado",
                    "RESPONSES": "Respostas",
                    "RESPONSE_COUNT": "{{responseCount}} respostas",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Respostas",
                    "SCORING_CATEGORY": "Categoria de pontuação",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Nenhuma resposta para esta categoria",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Nenhuma resposta para esta pergunta",
                    "SCORING_OVERVIEW": "Visão geral de pontuação",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "Você e outros avaliadores consideram esta área um ponto forte importante.",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Ponto forte reconhecido",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Quando uma área de melhoria é reconhecida, isso significa que tanto a nota da autoavaliação quanto as de outros avaliadores estão abaixo da média para esta competência.",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Área de melhoria reconhecida",
                    "SCORING_OVERVIEW_DESCRIPTION": "Acima estão as competências ou os comportamentos em relação aos quais é feita a avaliação como parte do processo de feedback com vários classificadores. As classificações de comparação são fornecidas pelo grupo.",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "Lacuna mínima",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Diferença mínima entre grupos de referência para que textos sejam mostrados.",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "É exibido o intervalo de pontuações para cada competência/comportamento. A barra representa a média numérica.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Quando há uma discrepância entre a nota da autoavaliação e as notas dadas pelos avaliadores, o ponto forte não é reconhecido.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Ponto forte não reconhecido",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Quando há uma discrepância entre a nota da autoavaliação e as notas de outros avaliadores, isso significa que a área de melhoria não foi reconhecida.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Área de melhoria não reconhecida",
                    "SELF": "Você",
                    "SELF_ASSESSMENT": "Autoapreciação",
                    "STANDARD_DEVIATION": "Desvio padrão",
                    "SUM": "Soma",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Familiarize-se com a escala de classificação para garantir uma interpretação precisa",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "Observe a escala",
                    "THINGS_YOU_WILL_SEE_HEADER": "Você verá:",
                    "THREE_SIXTY_PERCENTILE": "Porcentagem",
                    "TOP_BOTTOM_BOX": "Caixa superior/Caixa inferior",
                    "TOP_BOX": "Caixa superior",
                    "TOTAL": "Total",
                    "TO_DO": "Tarefa",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Pontuação qualitativa: feedback sob a forma de comentários de texto aberto",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Pontuação quantitativa: feedback sob a forma de um número, podendo ser representado em grafos, gráficos de barra, tabelas etc.",
                    "TYPES_OF_FEEDBACK_HEADER": "Vários tipos de feedback",
                    "VALUE": "Valor",
                    "VARIANCE": "Variância",
                    "YOUR_RATINGS": "Suas classificações"
                },
                "REPORT_SUMMARY": "Resumo do relatório",
                "REPORT_SUMMARY_TABLE_FOOTER": "Compare o número de pessoas que finalizaram a apreciação com o número de pessoas convidadas para participar.",
                "REPORT_SUMMARY_TABLE_HEADER": "Estatísticas do entrevistado",
                "RESET": "Redefinir",
                "RESPONDENT_TOTALS": "Totais de entrevistados",
                "RESPONSES": "Respostas",
                "RESPONSE_COUNT": "{{responseCount}} respostas",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Respostas",
                "RESULT": "Resultado",
                "REVERSE_COLORS": "Inverter cores",
                "ROW_TOTALS": "Totais de linha",
                "SAVE": "Salvar",
                "SAVE_AND_APPLY": "Salvar e aplicar",
                "SCORING_CATEGORY": "Categoria de pontuação",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Nenhuma resposta para esta categoria",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Nenhuma resposta para esta pergunta",
                "SCORING_OVERVIEW": "Visão geral de pontuação",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "Você e outros avaliadores consideram esta área um ponto forte importante.",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Ponto forte reconhecido",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Quando uma área de melhoria é reconhecida, isso significa que tanto a nota da autoavaliação quanto as de outros avaliadores estão abaixo da média para esta competência.",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Área de melhoria reconhecida",
                "SCORING_OVERVIEW_DESCRIPTION": "Acima estão as competências ou os comportamentos em relação aos quais é feita a avaliação como parte do processo de feedback com vários classificadores. As classificações de comparação são fornecidas pelo grupo.",
                "SCORING_OVERVIEW_MINIMUM_GAP": "Lacuna mínima",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Diferença mínima entre grupos de referência para que textos sejam mostrados.",
                "SCORING_OVERVIEW_TABLE_FOOTER": "É exibido o intervalo de pontuações para cada competência/comportamento. A barra representa a média numérica.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Quando há uma discrepância entre a nota da autoavaliação e as notas dadas pelos avaliadores, o ponto forte não é reconhecido.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Ponto forte não reconhecido",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Quando há uma discrepância entre a nota da autoavaliação e as notas de outros avaliadores, isso significa que a área de melhoria não foi reconhecida.",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Área de melhoria não reconhecida",
                "SELECT_CATEGORIES": "Selecione as categorias de pontuação...",
                "SELECT_CATEGORY": "Selecione uma Categoria de Pontuação...",
                "SELECT_CONDITION_TYPE": "Selecionar tipo de condição",
                "SELECT_DATA_SOURCE": "Selecionar fonte de dados",
                "SELECT_DATA_SOURCE_TYPE": "Selecionar tipo de fonte de dados",
                "SELECT_FILTER": "Selecionar filtro",
                "SELECT_FILTERS": "Selecionar filtros",
                "SELECT_OPERATOR_TYPE": "Selecionar tipo de operador",
                "SELECT_PERSON": "Selecionar pessoa",
                "SELECT_PERSON_METADATA": "Selecionar metadados da pessoa",
                "SELECT_QUESTION": "Selecionar pergunta",
                "SELECT_QUESTIONS": "Selecione as Perguntas...",
                "SELECT_RATIO_OR_DROPOFF": "Selecionar proporção ou queda",
                "SELECT_RELATIONSHIP": "Selecionar relação",
                "SELECT_SCORING_CATEGORY": "Selecionar categoria de pontuação",
                "SELF": "Você",
                "SELF_ASSESSMENT": "Autoapreciação",
                "SEQUENTIAL": "Sequencial",
                "SETUP_COMPARISON": "Configurar comparação",
                "SETUP_COMPARISONS": "Configurar comparações",
                "SET_START_COLOR": "Definir cor de início",
                "SHOULD_SHOW_FOOTER": "Mostrar rodapé",
                "SHOULD_SHOW_SCORING_CATEGORY": "Mostrar categoria de pontuação",
                "SHOWING_RECORDS_OF": "Mostrando registros %1–%2 de %3",
                "SHOW_COMPARISON_GAP": "Mostrar coluna de intervalo de comparação",
                "SHOW_DATA_LABEL": "Mostrar valores de dados",
                "SHOW_PERCENTAGES": "Exibir percentagens",
                "SHOW_THE_FOLLOWING_TEXT": "E então exibir o seguinte texto",
                "SHOW_TIES": "Exibir empates",
                "SHOW_X_AXIS": "Mostrar eixo X",
                "SHOW_Y_AXIS": "Mostrar eixo Y",
                "SMALL_LABELS": "Etiquetas pequenas",
                "SORT": "Classificar",
                "SPLINE": "Interpolação",
                "STACK_CHART": "Empilhar gráfico",
                "STANDARD_DEVIATION": "Desvio padrão",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "Ponto fraco menor que",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "Editar textos de valor limite",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "Textos de valor limite",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "Habilitar textos de valor limite",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "Ponto forte maior que",
                "SUM": "Soma",
                "SUMMARY": "Sumário",
                "TABLES": "Tabelas",
                "TABLE_TOTALS": "Totais da tabela",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Familiarize-se com a escala de classificação para garantir uma interpretação precisa",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "Observe a escala",
                "TEXT": "Texto",
                "THINGS_YOU_WILL_SEE_HEADER": "Você verá:",
                "TOP_BOTTOM_BOX": "Caixa superior/Caixa inferior",
                "TOP_BOX": "Caixa superior",
                "TOTAL": "Total",
                "TOTAL_COUNTS": "Total",
                "TO_DO": "Tarefa",
                "TRANSPOSE": "Transpor",
                "TRANSPOSE_TABLE": "Transpor tabela",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Pontuação qualitativa: feedback sob a forma de comentários de texto aberto",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Pontuação quantitativa: feedback sob a forma de um número, podendo ser representado em grafos, gráficos de barra, tabelas etc.",
                "TYPES_OF_FEEDBACK_HEADER": "Vários tipos de feedback",
                "UNDO": "Desfazer",
                "USE_COMPARISON": "Usar comparação",
                "USE_LABELS_FOR_SCALES": "Use rótulos para escalas",
                "VALUES": "Valores",
                "VALUE_RANGES": "Intervalo de valores",
                "VARIANCE": "Variância",
                "VERTICAL": "Vertical",
                "VERTICAL_RANGE": "Intervalo vertical",
                "WARNING_DATA_OUT_OF_RANGE": "Aviso: Os valores dos dados excedem a configuração de faixa",
                "WIDGET_ERROR": {
                    "ERROR": "Ocorreu um erro inesperado",
                    "MISCONFIGURED": "Este widget não está configurado corretamente. Verifique sua configuração de widget.",
                    "NEW": "Configure o widget",
                    "NO_DATA": "Nenhum dado encontrado - talvez seus filtros estejam restritos demais!"
                },
                "WIDGET_NAME": {
                    "BAR": "Gráfico de barras",
                    "BREAKDOWNBAR": "Barra de detalhamento",
                    "DATA_TABLE": "Tabela de dados",
                    "FUNNEL_CHART": "Gráfico de funil",
                    "GAUGE": "Gráfico com indicadores",
                    "GRID": "Tabela de resultados",
                    "HEATMAP": "Mapa de calor",
                    "LINE": "Diagrama de linhas",
                    "NEEDS_BASED": "Baseado em necessidades",
                    "PIE": "Gráfico de pizza",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "Ferramenta de estimativa de preços (Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "Maximizador de receita (Gabor Granger)",
                    "SCORING_OVERVIEW_CHART": "Gráfico",
                    "SCORING_OVERVIEW_TABLE": "Tabela",
                    "STATS_TABLE": "Tabela estatística",
                    "WORDCLOUD": "Nuvem de palavras"
                },
                "WORD_ROTATION": "Rotação de palavras",
                "WORD_SPACING": "Espaçamento de palavras",
                "YES": "Sim",
                "YOUR_RATINGS": "Suas classificações"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "Adicionar",
                "ADD_A_WORD": "Adicionar uma palavra",
                "COLOR": "Cor",
                "DELETE_ALL": "Excluir todos",
                "EDIT_STOP_WORDS": "Editar palavras entrecortadas",
                "MAX_WORDS": "Número máximo de palavras",
                "ROTATION_ANGLED": "Em ângulo",
                "ROTATION_HORIZONTAL": "Horizontal",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "Horizontal e vertical",
                "WORD_ORIENTATION": "Orientação das palavras"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "Cores de fundo",
                "DISPLAY_OPTIONS": "Opções de exibição",
                "INVERT_FONT_COLORS": "Inverter as cores de baixo contraste da fonte",
                "PAGE": "Página",
                "PAGINATE": "Paginar"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "Média",
                "BOTTOM_BOX_METRIC": "Caixa inferior",
                "COLUMNS": "Colunas",
                "COUNT_METRIC": "Respostas totais",
                "FIELD_NAME": "Campo",
                "MAX_METRIC": "Máximo",
                "MIN_METRIC": "Mínimo",
                "SHOW_RECODES": "Exibir valores recodificados",
                "SHOW_ROW_NUMBERS": "Exibir números de linhas",
                "STD_DEV_METRIC": "Desvio padrão",
                "TOP_BOX_METRIC": "Caixa superior",
                "TRANSPOSE_BREAKOUTS": "Transpor quebras",
                "TRANSPOSE_TABLE": "Tabela de transposição",
                "VAR_METRIC": "Variância"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "Colunas adicionais",
                "ADD_COLUMNS": "Adicionar mais colunas",
                "ADD_CUSTOM_PALETTE": "Adicionar paleta personalizada",
                "ALL_CHOICES": "Todas as opções de resposta",
                "ALL_GROUPS": "Todos os grupos",
                "ALL_RECODES": "Todas as recodificações",
                "AUTOMATIC": "Padrão",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "Padrão – Clique para editar",
                "AXIS_VALUES": "Valores de eixo",
                "BREAKOUT_BY": "Quebrar por",
                "CANCEL": "Cancelar",
                "CATEGORICAL": "Categórico",
                "CHOICES": "Opções de resposta",
                "CHOICE_COUNT": "Contagem de opção de resposta",
                "COLOR_PALETTE": "Paleta de cores",
                "COLUMN_VALUES": "Valores de coluna",
                "CONTACT_FIELDS": "Campos do contato",
                "COUNT": "Contagem",
                "CREATE": "Criar",
                "CUSTOM": "Personalizar",
                "CUSTOM_PALETTE": "Paleta personalizada",
                "DATA_SOURCE": "Fonte de dados",
                "DAY": "Dia",
                "DAY_OF_WEEK": "Dia da semana",
                "DECIMAL_PRECISION": "Casas decimais",
                "DEFAULT": "Padrão",
                "DISABLED": "Desativado",
                "DIVERGENT": "Divergente",
                "EDIT_CUSTOM_PALETTE": "Editar Paleta Personalizada",
                "ENABLED": "Habilitado",
                "ERROR_LOADING_DATA": "Erro ao carregar dados",
                "FILE_SIZE": "Tamanho",
                "FILE_TYPE": "Tipo",
                "FRI": "Sex",
                "FRIDAY": "Sexta-feira",
                "GROUP_DATE_BY": "Agrupar data por",
                "HOUR_OF_DAY": "Hora do dia",
                "LENGEND_VALUES": "Valores de legenda",
                "MAX": "Máximo",
                "MEAN": "Meio",
                "MIN": "Mínimo",
                "MISCONFIGURED_DATA": "Origem de dados desconfigurada para esta visualização.",
                "MISCONFIGURED_FILTERS": "Filtro(s) inválido(s)",
                "MODIFY_CUSTOM_PALETTES": "Modificar Paleta Personalizada",
                "MON": "Seg",
                "MONDAY": "Segunda-feira",
                "MONTH": "Mês",
                "NONE": "Nenhuma",
                "NO_FILE_ID_ERROR": "Esta visualização requer uma imagem a ser definida na pesquisa",
                "NO_RESULTS_TO_SHOW": "Nenhum resultado para exibir",
                "NPS": "Net Promoter Score®",
                "NPS_GROUP": "Grupo NPS®",
                "NUMERIC_VALUE": "Valor numérico",
                "PALETTE_REMOVED": "Paleta Removida",
                "PERCENTAGE": "Porcentagem",
                "PERCENTAGE_OF_CHOICES": "Porcentagem de opções de resposta",
                "PERCENTAGE_OF_RESPONSES": "Porcentagem de respostas",
                "QUARTER": "Trimestre",
                "REMOVE": "Remover",
                "RESPONSE_COUNT": "Contagem de respostas",
                "RESULTS_PER_PAGE": "Resultados por página",
                "RETRIEVING_DATA_ELLIPSIS": "Recuperando dados...",
                "REVERSE_COLORS": "Inverter cores",
                "ROW_VALUES": "Valores de linha",
                "SAT": "Sáb",
                "SATURDAY": "Sábado",
                "SAVE": "Salvar",
                "SELECTED_CHOICE": "Opção de resposta selecionada",
                "SELECT_FIELD": "Selecionar campo",
                "SELECT_METRIC": "Métrica",
                "SEQUENTIAL": "Sequencial",
                "SET_START_COLOR": "Definir cor de início",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "Exibindo dados de amostra...",
                "SUM": "Soma",
                "SUN": "Dom",
                "SUNDAY": "Domingo",
                "SURVEY_EMBEDDEDDATA": "Dados integrados",
                "SURVEY_METADATA": "Metadados da pesquisa",
                "TEXT_ENTRY": "Entrada de texto",
                "THURS": "Qui",
                "THURSDAY": "Quinta-feira",
                "TITLE": "Título",
                "TUES": "Ter",
                "TUESDAY": "Terça-feira",
                "UNBOUNDED_DOMAIN": "Valores demais para exibir.",
                "UNBOUNDED_DOMAIN_HELP": "Para adicionar este campo a Relatórios de Resultados, você pode adicionar um filtro ao relatório a fim de exibir menos valores para \"{{ed_field_name}}\" ou atualizar o tipo de variável de dados integrados de \"{{ed_field_name}}\" em seu fluxo da pesquisa para tornar este campo um tipo string ou numérico.",
                "UNDO": "Desfazer",
                "USE_CHOICE_TOTALS": "Usar totais de opções de resposta",
                "USE_RESPONDENT_TOTALS": "Usar Totais de Replicantes",
                "VISUALIZATION": "Visualização",
                "VISUALIZATION_BARCHART": "Gráfico de barras",
                "VISUALIZATION_BREAKDOWNBAR": "Barra de detalhamento",
                "VISUALIZATION_GAUGE": "Gráfico com indicadores",
                "VISUALIZATION_HEATMAP": "Mapa de calor",
                "VISUALIZATION_LINECHART": "Diagrama de linhas",
                "VISUALIZATION_PAGINATEDTABLE": "Tabela paginada",
                "VISUALIZATION_PIE": "Gráfico de pizza",
                "VISUALIZATION_SIMPLETABLE": "Tabela simples",
                "VISUALIZATION_STATSTABLE": "Tabela estatística",
                "VISUALIZATION_TEXTHIGHLIGHTS": "Destaques do texto",
                "VISUALIZATION_WORDCLOUD": "Nuvem de palavras",
                "WED": "Qua",
                "WEDNESDAY": "Quarta-feira",
                "WEEK": "Semana",
                "WEIGHTING": "Ponderação",
                "WRONG_QUESTION_TYPE_ERROR": "Este tipo de visualização não pode ser usada para esta questão",
                "YEAR": "Ano"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "Média",
                "CHOICE_COUNT": "Contagem de opção de resposta",
                "COUNT": "Contagem",
                "DISPLAY_OPTIONS": "Opções de exibição",
                "MAX": "Máximo",
                "MIN": "Mínimo",
                "NPS": "NPS®",
                "PAGE_OF": "Página %1 de %2",
                "PERCENT": "Porcentagem",
                "RESPONSE_COUNT": "Contagem de respostas",
                "ROWS_PER_TABLE": "Linhas por tabela",
                "SHOWING_ROWS_OF": "Mostrando linhas %1–%2 de %3",
                "SHOW_PERCENTAGES": "Exibir percentagens",
                "SHOW_RECODES": "Exibir valores recodificados",
                "SHOW_ROW_NUMBERS": "Exibir números de linhas",
                "SUM": "Soma",
                "TOTAL": "Total",
                "TRANSPOSE": "Transpor",
                "USE_COLUMN_TOTALS": "Usar totais de coluna",
                "USE_ROW_TOTALS": "Usar totais de linha",
                "VALUE": "Valor"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "Ascendente",
                "COUNT": "Contagem",
                "DESCENDING": "Descendente",
                "DIAGONAL": "Diagonal",
                "DISPLAY_OPTIONS": "Opções de exibição",
                "ERROR_COLON": "Erro:",
                "ERROR_GENERIC": "Ocorreu um erro ao carregar a visualização.",
                "HORIZONTAL": "Horizontal",
                "HORIZONTAL_BARS": "Barras horizontais",
                "INCORRECTLY_CONFIGURED": "Escolha um valor para exibir gráfico",
                "LEGEND_AUTO": "Automático",
                "LEGEND_BOTTOM": "Inferior",
                "LEGEND_INSET": "Inserção",
                "LEGEND_RIGHT": "Direita",
                "NORMALIZE_TO_PERCENTAGES": "Normalizar para percentuais",
                "SHOW_BAR_LABELS": "Exibir etiquetas da barra",
                "SHOW_LEGEND": "Mostrar legenda",
                "SHOW_X_AXIS": "Mostrar eixo X",
                "SHOW_Y_AXIS": "Mostrar eixo Y",
                "SORT_BAR_VALUES": "Ordenar os valores da barra",
                "STACKED_BARS": "Barras empilhadas",
                "TRANSPOSE": "Transpor",
                "TRUNCATE_LABELS": "Truncar etiquetas",
                "VERTICAL": "Vertical"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "Todos os outros",
                "COULD_NOT_LOAD_DATA": "Não foi possível carregar os dados com a configuração especificada — tente um campo de fonte diferente ou um intervalo de datas maior.",
                "GROUPING_PERCENTAGE_THRESHOLD": "Limiar percentual de agrupamento",
                "NO_DATA": "Sem dados",
                "RADIUS": "Raio interno",
                "SHOW_AS_PERCENTAGES": "Exibir como percentagens"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "Fechar",
                "DOWNLOAD_CSV": "Baixar CSV",
                "DOWNLOAD_ZIP": "Baixar todos os arquivos",
                "NO_DATA": "Sem dados",
                "PAGE_OF": "Página %1 de %2",
                "RESULTS_PER_PAGE": "Resultados por página",
                "SHOWING_RECORDS_OF": "Mostrando registros %1–%2 de %3",
                "SINGLE_RESPONSE": "Resposta única",
                "VIEW_RESPONSE": "Ver resposta"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "Opções de exibição",
                "ERROR_COLON": "Erro:",
                "ERROR_GENERIC": "Ocorreu um erro ao carregar a visualização.",
                "HORIZONTAL_BARS": "Barras horizontais",
                "INCORRECTLY_CONFIGURED": "Escolha um valor para exibir gráfico",
                "LEGEND_AUTO": "Automático",
                "LEGEND_BOTTOM": "Inferior",
                "LEGEND_INSET": "Inserção",
                "LEGEND_RIGHT": "Direita",
                "NORMALIZE_TO_PERCENTAGES": "Normalizar para percentuais",
                "SHOW_AREA": "Exibir área",
                "SHOW_LEGEND": "Mostrar legenda",
                "SHOW_X_AXIS": "Mostrar eixo X",
                "SHOW_Y_AXIS": "Mostrar eixo Y",
                "SMOOTH_LINES": "Linhas suaves",
                "SORT_X_AXIS_LABELS": "Ordenar rótulos do eixo X",
                "STACKED_BARS": "Barras empilhadas",
                "TRANSPOSE": "Transpor"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "Modo de bloco",
                "BLUR": "Borrão",
                "COULD_NOT_LOAD_DATA": "Não foi possível carregar os dados com a configuração especificada — tente um campo de fonte diferente ou um intervalo de datas maior.",
                "FIELD": "Campo",
                "RADIUS": "Raio",
                "SHOW_REGIONS": "Exibir regiões",
                "SHOW_REGION_LABELS": "Exibir etiquetas da região"
            },
            "GAUGEWIDGET": {
                "MAX": "Máximo",
                "MIN": "Mínimo",
                "VALUE_RANGES": "Intervalo de valores"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "Etiquetas inferiores",
                "CATEGORY_NAME": "Nome da categoria",
                "ERROR_COLON": "Erro:",
                "INCLUDE_HIDDEN_GROUPS": "Incluir grupos ocultos nos percentuais",
                "LARGE_LABELS": "Etiquetas grandes",
                "NO": "Não",
                "PERCENT": "Percentual",
                "RESPONSE_COUNT": "Contagem de respostas",
                "RESPONSE_COUNT_WITH_VALUE": "{{ responseCount }} respostas",
                "SMALL_LABELS": "Etiquetas pequenas",
                "YES": "Sim"
            }
        });
        $cache.put('PT', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "Código de acesso",
                "ACCESS_CODE_PROTECTION": "Proteção do código de acesso",
                "ADD": "Adicionar",
                "ADD_BREAKOUT": "Adicionar separação do relatório",
                "ADD_NOTE": "Adicionar nota",
                "ADD_SCHEDULED_REPORT": "Adicionar relatório agendado",
                "ADD_WIDGET": "Adicionar visualização",
                "ALL_PROJECTS": "Todos os projetos",
                "ALL_QUESTIONS": "Páginas das perguntas",
                "ANSWER": "Resposta",
                "ANY_CHANGES_LOST": "Todas as alterações efetuadas nos relatórios serão perdidas se sair da plataforma Qualtrics XM.",
                "APPENDED_COPY_IN_PARENS": "(Copiar)",
                "AREA_CHART": "Gráfico de áreas",
                "AREA_CHART_DESC": "Gráfico de linhas de dois eixos com a área abaixo da linha preenchida.",
                "ATTACHMENT": "Anexo",
                "BACKUP_CURRENT_REPORT": "Guarde uma cópia de segurança deste relatório antes de alterar as visualizações",
                "BACKUP_CURRENT_REPORT_LINE2": "Nota: Será atribuído o nome \"{{nameOfReportCopy}}\" à cópia de segurança",
                "BACK_TO_REPORTS": "Voltar a relatórios",
                "BACK_TO_TOP": "Voltar ao topo",
                "BACK_TO_VIEW_RESULTS": "Voltar à vista de resultados anterior",
                "BAR_CHART": "Gráfico de barras",
                "BAR_CHART_DESC": "Um gráfico de barras de dois eixos que permite uma configuração adicional, tal como a transposição e a reorganização dos pontos de dados.",
                "BREAKDOWN_BAR_CHART": "Barra repartida",
                "BREAKDOWN_BAR_CHART_DESC": "O gráfico de barras horizontais empilhadas mais comumente usado, para ponderar visualmente as métricas entre si, em alternativa a um gráfico circular.",
                "CANCEL": "Cancelar",
                "CANCEL_CONF_TEXT": "Tem a certeza de que pretende cancelar?<br/>Todas as alterações serão perdidas.",
                "CANCEL_EDITS": "Cancelar edição",
                "CHART": "Gráfico",
                "CHOICE": "Opção",
                "CHOICES_COUNT_METRIC": "Contagem de opções",
                "CHOOSE_PAGES_TO_DISPLAY": "Escolher páginas a apresentar",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "Este relatório tem {{maxReportPageCount}} páginas, mas Resultados apenas podem ter até {{reportSizeLimit}}. Selecione um subconjunto dentro do limite.",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "Os relatórios só podem conter até {{reportSizeLimit}} páginas, selecione as páginas pretendidas.",
                "CLEAR_ALL": "Limpar tudo",
                "CLOSE": "Fechar",
                "CLOUD": "UMA DESCRIÇÃO PARA A CLOUD",
                "COLLABORATED_NEW": "O proprietário deste inquérito está a utilizar a plataforma Qualtrics XM! Os relatórios deste inquérito serão editados utilizando os novos resultados.",
                "COMMA_SEPARATED_LIST": "Lista separada por vírgulas",
                "COMPACTNESS": "Tipos de letra e espaçamento",
                "COMPACTNESS_INFO": "Esta definição afeta o preenchimento de tabelas, o tamanho do tipo de letra e o tamanho das barras em gráficos. Também será aplicada na maioria das exportações.",
                "CONFIRM": "Ok",
                "CONFIRM_DELETE": "Confirmar eliminação",
                "CONFIRM_DELETE_PAGE": "Tem a certeza de que pretende eliminar esta página?",
                "CONTINUE": "Continuar",
                "CONTINUE_EDITING": "Continuar edição",
                "COPY": "Copiar",
                "COPY_OF_REPORT_NAME": "Cópia de {{nameOfCurrentReport}}",
                "COPY_REPORT": "Copiar relatório",
                "COPY_REPORT_ELLIPSIS": "Copiar relatório...",
                "COPY_TO_NEW_REPORT": "Copiar para novo relatório...",
                "CREATE": "Criar",
                "CREATED": "Criado",
                "CREATE_CUSTOM_PAGE": "Criar página personalizada",
                "CREATE_NEW_REPORT": "Criar novo relatório",
                "CREATE_NEW_REPORT_ELLIPSIS": "Criar novo relatório...",
                "CSV_FILE": "Ficheiro CSV",
                "CUSTOM_PAGES": "Páginas personalizadas",
                "DATE": "Data",
                "DEFAULT_PALETTE": "Paleta de cores predefinida",
                "DEFAULT_REPORT": "Relatório predefinido",
                "DEFAULT_VISUALIZATIONS": "Visualizações predefinidas",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "Estes são os tipos de visualizações predefinidas utilizadas para criar relatórios de resultados predefinidos. Atualizar ou aplicar estas definições vai voltar a criar o seu relatório atual com as novas definições predefinidas. Ser-lhe-á apresentada a opção de guardar uma cópia de segurança do relatório atual.",
                "DEFAULT_VISUALIZATIONS_NOTE": "Nota: Nem todos os tipos de visualização estão disponíveis para todos os tipos de perguntas. Algumas visualizações não predefinidas podem ser automaticamente substituídas.",
                "DEFAULT_VISUALS_DISCLAIMER": "A Qualtrics vai atualizar este relatório com as novas definições de visualização predefinidas.",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "Esta atualização vai afetar {{amountOfWidgetsAffected}} visualizações neste relatório.",
                "DEFAULT_VISUAL_EDIT_DETECTED": "Edição da visualização predefinida detetada",
                "DELETE_BUTTON": "Eliminar",
                "DELETE_DISABLED_EXPLANATION": "Só é possível eliminar relatórios criados na interface de relatórios anterior depois de a sua organização efetuar a migração completa para a plataforma Qualtrics XM.",
                "DELETE_PAGE": "Eliminar página",
                "DELETE_PAGE_ELLIPSIS": "Eliminar página...",
                "DELETE_REPORT": "Eliminar relatório",
                "DELETE_REPORT_ELLIPSIS": "Eliminar relatório...",
                "DELETE_WIDGET_QUESTION": "Eliminar?",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "Este campo está encriptado e não pode ser utilizado para ordenação.",
                "DISCARD_EDITS": "Eliminar alterações",
                "DISTRIBUTION_PAUSED": "Distribuição de relatórios em pausa.",
                "DONE_BUTTON": "Concluído",
                "DONE_EDITING": "Edição concluída",
                "DOWNLOAD": "Transferir",
                "DOWNLOAD_AS_CSV": "Transferir como CSV",
                "DOWNLOAD_AS_PDF": "Transferir como PDF",
                "DOWNLOAD_FAILED": "A transferência falhou",
                "DOWNLOAD_PREVIOUS_EXPORTS": "Transferir exportações anteriores...",
                "DO_YOU_WISH_TO_DELETE": "Pretende eliminar ...?",
                "DUPLICATE_PAGE": "Duplicar ficha",
                "EDIT_REPORT": "Editar relatório",
                "EDIT_REPORT_ELLIPSIS": "Editar relatório...",
                "EDIT_VISUALIZATION": "Editar visualização",
                "EMAIL_ADDRESS": "Endereço de e-mail",
                "EMAIL_SENT": "E-mail enviado...",
                "END_OF_REPORT": "Fim do relatório",
                "ENTER_NAME": "Introduzir nome",
                "ERROR_COPYING": "Ocorreu um erro ao copiar o relatório.",
                "ERROR_DELETING": "Ocorreu um erro ao eliminar o relatório.",
                "ERROR_DELETING_EXPORT": "Ocorreu um erro ao eliminar a exportação.",
                "ERROR_HEADING": "Erro",
                "ERROR_PUBLISHING": "Ocorreu um erro ao guardar as definições.",
                "ERROR_RENAMING": "Ocorreu um erro ao renomear o relatório.",
                "ERROR_REQUESTING_EXPORT": "Ocorreu um erro ao solicitar a exportação.",
                "ERROR_SAVING_GLOBAL_OPTIONS": "Ocorreu um erro ao guardar as opções de visualização global.",
                "ERROR_SEND_TEST_EMAIL": "Ocorreu um erro ao enviar o e-mail de teste.",
                "EVERY_FRIDAY": "Todas as sextas-feiras",
                "EVERY_MONDAY": "Todas as segundas-feiras",
                "EVERY_MONTH": "Mensalmente em",
                "EVERY_SATURDAY": "Todos os sábados",
                "EVERY_SUNDAY": "Todos os domingos",
                "EVERY_THURSDAY": "Todas as quintas-feiras",
                "EVERY_TUESDAY": "Todas as terças-feiras",
                "EVERY_WEDNESDAY": "Todas as quartas-feiras",
                "EVERY_WEEK": "Semanalmente todos(as) os(as)",
                "EXAMPLE_GROUP_NUM": "Grupo {{num}}",
                "EXAMPLE_SERIES_NUM": "Série {{num}}",
                "EXPORT": "Exportar",
                "EXPORT_CSV": "CSV (Separados por vírgula)",
                "EXPORT_EXCEL_SPREADSHEET": "Folha de cálculo do Excel",
                "EXPORT_IMAGE": "Exportar imagem",
                "EXPORT_PAGES": "Exportar páginas",
                "EXPORT_PDF": "Documento PDF",
                "EXPORT_PPT_SLIDES": "Diapositivos de PowerPoint",
                "EXPORT_RAW_DATA": "Exportar dados em bruto",
                "EXPORT_REPORT": "Exportar relatório",
                "EXPORT_VISUALIZATION": "Exportar visualização",
                "EXPORT_WORD_DOC": "Documento Word",
                "FAILED_SAVE_TXT": "Falha ao guardar",
                "FILTERED": "Filtrado",
                "FIRST_PAGE": "Primeira página",
                "FIRST_WEEKDAY": "Primeiro dia útil do mês",
                "FROM": "De",
                "FROM_EMAIL": "Email do remetente",
                "FROM_NAME": "Nome do remetente",
                "GAUGE_CHART": "Gráfico de medição",
                "GAUGE_CHART_DESC": "Um gráfico que se assemelha a uma ferramenta de medição para comparar valores atuais com uma meta ou série de valores limite.",
                "GENERATING_FILE": "A gerar o ficheiro...",
                "GENERATING_IMAGE": "A gerar a imagem...",
                "GENERATING_PDF": "A gerar PDF...",
                "GENERIC_ERROR": "Ocorreu um erro que nos impediu de carregar o projeto que solicitou.",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "Opções globais...",
                "GLOBAL_METRIC": "Métrica predefinida",
                "GLOBAL_MODAL_PAGE_TITLE": "Exemplo da visualização utilizando as opções globais para a secção de Resultados do Qualtrics Research Suite",
                "GLOBAL_MODAL_WIDGET_TITLE": "Título da visualização",
                "GLOBAL_OPTIONS": "Opções globais",
                "GLOBAL_PRECISION": "Casas decimais predefinidas",
                "GLOBAL_SETTINGS_APPLY": "Aplicar as minhas definições predefinidas",
                "GLOBAL_SETTINGS_SAVE": "Guardar como as minhas definições predefinidas",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "Aplicar predefinição da Qualtrics",
                "GROUP": "Grupo",
                "HEAT_MAP_CHART": "Gráfico de mapa térmico",
                "HEAT_MAP_CHART_DESC": "Uma visualização do tipo \"térmica\" usada para o mapeamento da distribuição das entradas do utilizador (por ex., cliques) na imagem original.",
                "HIDDEN": "Oculto",
                "HIDDEN_PAGE": "Esta página não será exibida em relatórios públicos e, por predefinição, será desmarcada nas exportações de relatórios.",
                "HIDE": "Ocultar",
                "HIDE_ALL_PAGES": "Ocultar todas as páginas",
                "HIDE_PAGE": "Ocultar página",
                "IMAGE_FILE": "Ficheiro de imagem",
                "INVALID_BRAND_DOMAIN": "O domínio que introduziu não consta da lista de domínios de e-mail aprovados da sua marca. Contacte o administrador da sua marca para corrigir o problema.",
                "INVALID_SPF_RECORD": "O domínio que introduziu não aprovou a Qualtrics para proceder ao envio a partir do mesmo. Isto irá afetar a capacidade de entrega. Utilize outro domínio ou contacte a Qualtrics para resolver este problema.",
                "ISSUE_SAVING_REPORTS": "Ocorreu um problema ao guardar um ou mais relatórios. Tente novamente.",
                "ISSUE_SENDING_TEST": "Ocorreu um erro ao enviar um e-mail de teste. Tente novamente.",
                "LARGE_SURVEY": "Não serão apresentados resultados porque o inquérito é demasiado grande.",
                "LAST_DAY": "Último dia do mês",
                "LAST_MODIFIED_COLON_WITH_DATE": "Última modificação: %1",
                "LAST_PAGE": "Última página",
                "LAST_WEEKDAY": "Último dia útil do mês",
                "LATER": "Mais tarde",
                "LEARN_MORE": "Mais informações",
                "LINE_CHART": "Gráfico de linhas",
                "LINE_CHART_DESC": "Um gráfico de linhas de dois eixos comumente usado na elaboração de gráficos de tempo no eixo x.",
                "LOG_OUT_WARNING": "Clique em qualquer local dentro de {{countdown}} segundos para permanecer com a sessão iniciada",
                "MESSAGE": "Mensagem",
                "MONTHLY": "Mensalmente",
                "MOVE_DOWN": "Mover visualização para baixo",
                "MOVE_PAGE_TO_BOTTOM": "Mover para o fim",
                "MOVE_PAGE_TO_TOP": "Mover para o início",
                "MOVE_UP": "Mover visualização para cima",
                "MY_SURVEYS": "Os meus projetos",
                "NAME": "Nome",
                "NEW_CUSTOM_PAGE_NAME": "Nova página personalizada",
                "NEW_REPORT": "Novo relatório",
                "NEXT_PAGE": "Página seguinte",
                "NEXT_RUN": "Próxima execução",
                "NO_EXPORTS": "Não foram ainda solicitadas exportações para este relatório.",
                "NO_ITEMS_TO_DISPLAY": "Nenhum item para apresentar",
                "NO_MATCHING_CUSTOM_PAGES": "Sem páginas personalizadas correspondentes",
                "NO_MATCHING_PAGES": "Não foram encontradas páginas para a pesquisa",
                "NO_MATCHING_REPORTS": "Sem relatórios de correspondência.",
                "NO_PROJECT": "Especifique um projeto para continuar.",
                "NO_PROJECTS_TO_MIGRATE": "Não há projetos para atualizar.",
                "NO_QUESTIONS": "Não existem respostas correspondentes",
                "NO_RESULTS_YET": "Não existem ainda resultados para apresentar. Distribua o inquérito para obter respostas.",
                "OFF": "Desligado",
                "ON": "Ligado",
                "PAGES_SELECTED": "Páginas selecionadas",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "Esta seleção faria com que o relatório ficasse com {{currentSelectedPageCount}} páginas, o que é mais do que o máximo permitido de {{reportSizeLimit}}. Selecione um intervalo mais pequeno.",
                "PAGES_SELECTION_INVALID_RANGE": "Selecione um intervalo válido.",
                "PAGE_OPTIONS": "Opções de página",
                "PDF_ROW_TRUNCATION_MESSAGE": "Demasiadas linhas para exportar para PDF; tente exportar para Word ou CSV",
                "PERCENTAGE_METRIC": "Percentagem",
                "PIE_CHART": "Gráfico circular",
                "PIE_CHART_DESC": "Uma repartição circular de valores para um determinado ponto de dados. Útil para a medição de proporções relativas de valores selecionados.",
                "PREVIEW": "Pré-visualização",
                "PREVIOUS_PAGE": "Página anterior",
                "PRINT_PAGE": "Imprimir página",
                "PUBLIC_LINK": "Ligação pública",
                "PUBLIC_REPORT_AVAILABLE": "Relatório público disponível",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "Código de acesso",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "Código de acesso incorreto. Por favor, tente novamente.",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "Submeter",
                "PUBLIC_RESULTS_LOGIN_TITLE": "Início de sessão no Relatório público | Software dos inquéritos Qualtrics",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "O Relatório público não foi encontrado. Entre em contacto com o proprietário deste relatório e peça-lhe uma ligação válida.",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "Relatório público não encontrado",
                "PUBLIC_RESULTS_NOT_UPDATED": "As ligações de relatórios públicos e os e-mails de relatórios agendados não irão utilizar a plataforma Qualtrics XM até o utilizador os atualizar.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "Sessão expirada. Volte a iniciar sessão para continuar a pré-visualizar o Relatório público de resultados.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "Sessão expirada",
                "PUBLIC_RESULTS_TITLE": "Relatório público",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "Não tem autorização para ver esta página. Entre em contacto com o proprietário deste relatório e peça-lhe que o torne público.",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "Relatório público não autorizado",
                "PUBLISHED_LINK_GENERATING_LINK": "A gerar ligação...",
                "PUBLISHED_REPORT_FOUND_HERE": "Qualquer pessoa pode ver este relatório na seguinte ligação:",
                "PUBLISH_REPORT": "Gerir Relatório público",
                "PUBLISH_REPORT_ELLIPSIS": "Gerir Relatório público...",
                "QUESTION": "Pergunta",
                "RANK": "Classificação",
                "REMOVE_WIDGET": "Remover visualização",
                "RENAME_PAGE": "Mudar o nome da página",
                "RENAME_REPORT": "Mudar o nome do relatório",
                "RENAME_REPORT_ELLIPSIS": "Mudar o nome do relatório...",
                "REPLY_TO_EMAIL": "E-mail responder a",
                "REPORT_COLON": "Relatório:",
                "REPORT_SETTINGS": "Definições do relatório",
                "REPORT_SETTINGS_ELLIPSIS": "Definições do relatório...",
                "RESPONSE_COUNTS": "Contagens de respostas",
                "RESULTS_DASHBOARDS_BANNER": "e experimente a nova versão melhorada dos resultados do inquérito com uma IU acessível e moderna e visualizações de dados, novas caraterísticas de análise e exploração, entre outros.",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "Notas de lançamento",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "Ver a última",
                "RESULTS_OPTIONS": "Opções de relatório",
                "RESULTS_TITLE": "Relatório",
                "RESUME_DISTRIBUTION": "Retomar distribuição",
                "REVERT": "Reverter",
                "RICH_TEXT_LIMIT_REACHED": "O comprimento do conteúdo atingiu o limite!",
                "SAVE": "Guardar",
                "SAVE_AND_CLOSE": "Guardar e fechar",
                "SAVE_AS_CSV": "Guardar visualização como CSV",
                "SAVE_AS_IMAGE": "Guardar visualização como imagem",
                "SAVE_CONFIRMATION": "Guardar confirmação",
                "SAVE_PAGE_AS_ELLIPSIS": "Exportar página como...",
                "SAVE_SETTINGS": "Guardar definições",
                "SCHEDULE_REPORT_EMAIL": "Agendar o e-mail do relatório",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "Agendar o e-mail do relatório...",
                "SEARCH_ELLIPSIS": "Pesquisar…",
                "SEARCH_PAGES": "Pesquisar questões",
                "SEARCH_PAGES_ELLIPSIS": "Pesquisar páginas…",
                "SEARCH_REPORTS_ELLIPSIS": "Pesquisar relatórios...",
                "SELECTED": "Selecionado:",
                "SELECT_ALL": "Selecionar tudo",
                "SELECT_A_FIELD": "Selecionar um campo",
                "SELECT_A_WIDGET": "Selecionar uma visualização",
                "SELECT_PAGES": "Selecionar páginas",
                "SELECT_PAGES_ELLIPSIS": "Selecionar páginas...",
                "SEND": "Enviar",
                "SEND_TEST_EMAIL": "Enviar e-mail de teste",
                "SETTING_DEFAULT": "Predefinição",
                "SETTING_HIGH": "Elevada(o)",
                "SETTING_LARGE": "Grande",
                "SETTING_LOW": "Baixo",
                "SETTING_NORMAL": "Normal",
                "SETTING_SMALL": "Pequeno",
                "SHARE_REPORT": "Partilhar relatório",
                "SHOW_ALL_PAGES": "Mostrar todas as páginas",
                "SHOW_FULL_QTEXT": "Mostrar o texto completo das perguntas nos títulos das páginas",
                "SIMPLE_TABLE": "Tabela simples",
                "SIMPLE_TABLE_DESC": "Uma tabela flexível que permite apresentar valores múltiplos em linhas ou colunas.",
                "SIZE": "Tamanho",
                "SPLINE_CHART": "Gráfico de linhas polinomiais",
                "SPLINE_CHART_DESC": "Um gráfico de linhas redondas de dois eixos comumente usado na elaboração de gráficos de tempo no eixo x.",
                "STATISTICS_TABLE": "Tabela de estatística",
                "SUBJECT": "Assunto",
                "SURVEY_ANALYSIS": "Análise do inquérito",
                "SURVEY_SUMMARY": "Resumo do inquérito",
                "TABLE": "UMA DESCRIÇÃO PARA A TABELA",
                "TIME": "Hora",
                "TO": "Para",
                "TOTAL": "Total",
                "TRANSPOSE_STATS_TABLES": "Transpor tabelas de estatísticas",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "Transpor separações de tabela de estatísticas",
                "TRUNCATE_PAGE_TITLES": "Truncar texto da pergunta nos títulos das páginas",
                "TRY_IT_NOW": "Tente agora",
                "TYPE": "Tipo",
                "UNABLE_TO_CHECK_SPF": "Não foi possível verificar o registo SPF. Tente novamente.",
                "UNAUTHORIZED": "Não lhe é permitido ver este relatório. Contacte o proprietário para obter acesso.",
                "UNHIDE_PAGE": "Mostrar página",
                "UPDATE": "Atualizar",
                "UPDATED_SUCCESSFULLY": "Atualizado com êxito.",
                "UPDATE_ALL_IN_THIS_PROJECT": "Atualizar tudo neste projeto",
                "UPDATE_ALL_PROJECTS": "Atualizar todos os projetos",
                "UPDATE_NOW": "Atualizar agora",
                "UPDATE_REPORTS": "Atualizar relatórios...",
                "UPDATE_REPORT_ELEMENTS": "Atualizar ligações de relatórios públicos e e-mails de relatórios agendados",
                "UPGRADE_MY_ACCOUNT": "Atualizar a minha conta",
                "USE_EXPORT_TAGS": "Incluir números das perguntas",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "Utilizar totais de coluna da tabela simples",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "Utilizar contagens de inquiridos da tabela simples",
                "USE_WEIGHTED_METRICS": "Utilizar métricas ponderadas",
                "VIEW": "Vista",
                "WEEKLY": "Semanalmente",
                "WELCOME_TO_NEW_RESULTS": "Bem-vindo aos relatórios da plataforma Qualtrics XM!",
                "WHEN": "Quando",
                "WIDGET_LOADING": "A carregar…",
                "WIDGET_OPTIONS_ERR": "Falha ao carregar as opções de visualização",
                "WIDGET_TYPE": "Visualização",
                "WORD_CLOUD": "Nuvem de palavras",
                "WORD_CLOUD_DESC": "Uma visualização ponderada da frequência das palavras em dados de texto com opções adicionais de codificação por cor."
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Lembre-se de que existem recursos dentro da sua organização que o ajudam a interpretar o seu feedback, tal como parceiros de RH, o seu gestor e/ou um mentor.",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Faça uma caneca de café e mergulhe no seu feedback.",
                "ABOUT_YOUR_REPORT_HEADER": "Sobre o seu relatório",
                "ABOUT_YOUR_REPORT_LINE1": "Bem-vindo ao seu relatório de feedback 360. Esta é uma ótima oportunidade para crescer e progredir como profissional. Para se preparar para o sucesso ao analisar os resultados, disponha de tempo suficiente para examinar o feedback. Inicialmente, o feedback pode ser difícil de perceber, mas não se esqueça de que o objetivo deste feedback é o de acelerar o seu crescimento e progresso.",
                "ABOUT_YOUR_REPORT_LINE2": "Aqui ficam alguns aspetos para ter em mente enquanto analisa o seu relatório.",
                "ADD_CONDITIONAL_TEXT": "Adicionar texto condicional",
                "ADD_CUSTOM_PALETTE": "Adicionar paleta personalizada",
                "ADD_DATA_SOURCE": "Adicionar origem de dados",
                "ADD_FOLLOWING": "Adicionar o seguinte",
                "ADD_LABEL": "Adicionar etiqueta",
                "ADVANCED_FILTER": "Filtro avançado",
                "AGREEMENT_CHART": "Gráfico de acordo",
                "AGREEMENT_CHART_FOOTER": "O gráfico de acordo indica a semelhança das pontuações. Cada ponto representa como um individuo o/a classificou por cada item. O tamanho do ponto mostra quantos avaliadores lhe atribuíram determinada classificação.",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "respostas",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "resposta",
                "AGREEMENT_CHART_LEGEND_TITLE": "Como os outros o/a classificam",
                "ALL": "Todos",
                "AND_IF": "E se",
                "ANGLED": "Angular",
                "AREA": "Área",
                "AUTO": "Auto",
                "AVERAGE": "Média",
                "AXIS_VALUES": "Valores do eixo",
                "BAR": "Barra",
                "BASE_WORD_COLOR": "Cor da palavra base",
                "BLUR": "Distorção",
                "BOTTOM_BOX": "Caixa inferior",
                "BREAKOUT_HEADERS": "Cabeçalhos de separação",
                "CANCEL": "Cancelar",
                "CATEGORICAL": "Categórico",
                "CATEGORY": "Categoria",
                "CATEGORY_NAME": "Nome da categoria",
                "CHANGE_CATEGORIES_ORDER": "Alterar a ordem das categorias",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "Alterar a ordem das categorias de pontuação",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "Altere a ordem que aparece na visualização ao clicar no lado esquerdo do elemento da categoria de pontuação e arrastá-lo para a posição desejada.",
                "CHANGE_QUESTIONS_ORDER": "Alterar a ordem das perguntas",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "Alterar a ordem das perguntas",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "Altere a ordem que aparece na visualização ao clicar no lado esquerdo do elemento da pergunta e arrastá-lo para a posição desejada.",
                "CHARTS": "Gráficos",
                "CHART_TYPE": "Tipo de gráfico",
                "CHOICE_COUNT": "Contagem de opções",
                "CHOICE_TOTALS": "Totais de opções",
                "CLEAR": "Limpar",
                "CLOSE": "Fechar",
                "COLOR_PALETTE": "Paleta de cores",
                "COLUMN_NAMES": "Nomes das colunas",
                "COLUMN_TOTALS": "Totais de coluna",
                "COMPARED_FILTER_GROUP": "Grupo de filtros comparados",
                "COMPARED_FILTER_GROUPS": "Grupos de filtros comparados",
                "COMPARE_WITH": "Comparar com",
                "COMPETITION_RANKING": "Usar classificação de competição",
                "COMPETITION_RANKING_TOOLTIP": "Na eventualidade de um empate, todas as pontuações iguais obtêm a mesma classificação. No entanto, o próximo item subsequente vai ser classificado de forma igual a: o número total de itens com classificação mais alta na tabela, mais um.",
                "COMPLETED_RESPONSES": "Respostas completas",
                "CONDITIONAL_TEXT": "Texto condicional",
                "COUNT": "Contagem",
                "CREATE": "Criar",
                "CUSTOM_PALETTE": "Personalizar paleta",
                "DATA_SOURCE_TYPE": "Tipo de origem de dados",
                "DATA_SOURCE_TYPE_CATEGORY": "Categorias de pontuação",
                "DATA_SOURCE_TYPE_QUESTION": "Perguntas",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "Pergunta",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "Itens ordenáveis",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "Categoria de pontuação",
                "DEFAULT": "Predefinição",
                "DEFAULT_TEXT": "Texto predefinido",
                "DELETE": "Eliminar",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "Perceber de onde vem o seu feedback, dos colegas, dos subordinados diretos, líderes, etc.",
                "DIFFERENT_EVALUATORS_HEADER": "Avaliadores diferentes",
                "DIRECT_REPORTS": "Subordinados diretos",
                "DISABLED": "Desativado",
                "DISPLAY_OPTIONS": "Apresentar opções",
                "DISPLAY_THRESHOLD_TEXTS": "Apresentar texto com base no intervalo de grupos a seguir",
                "DIVERGENT": "Divergente",
                "DONE": "Concluído",
                "DONT_HEADER": "Não:",
                "DONT_LINE1": "Tentar perceber quem disse o quê",
                "DONT_LINE2": "Concentrar-se numa pontuação/comentário positivo ou negativo",
                "DONT_LINE3": "Criar um plano de desenvolvimento em torno de cada item",
                "DONT_LINE4": "Deixar-se desencorajar em relação a oportunidades de melhoria",
                "DONUT": "Donut",
                "DOWNLOAD_CSV": "Transferir CSV antigo",
                "DOWNLOAD_ZIP": "Transferir todos os ficheiros",
                "DO_HEADER": "Sim:",
                "DO_LINE1": "Observar o feedback de forma holística",
                "DO_LINE2": "Identificar temas em pontos fortes e oportunidades de melhoria",
                "DO_LINE3": "Dar prioridade a algumas áreas de foco para adicionar ao seu plano de desenvolvimento",
                "DO_LINE4": "Perceber que todos têm oportunidades de melhoria",
                "DROPOFF": "Queda",
                "DUPLICATE": "Duplicar",
                "EDIT_CONDITIONAL_TEXT": "Editar texto condicional",
                "EDIT_CUSTOM_PALETTE": "Editar paleta personalizada",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "Além disso, mostrar o texto seguinte",
                "ENABLED": "Ativado",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "Ativar ordenação por lógica da exibição das categorias do classificador",
                "ENABLE_ORDERING_FOR": "Ativar ordenação para",
                "EQUAL_TO": "Igual a",
                "FIELD": "Campo",
                "FILTER_NAMES": "Filtrar nomes",
                "FOLLOWING_PARENTHESES": "(seguinte)",
                "FOOTER": "Rodapé",
                "GAP": "Intervalo",
                "GAP_CHART": "Gráfico de intervalos",
                "GAP_CHART_DESCRIPTION": "O gráfico de intervalos apresenta a diferença de pontuações entre dois grupos de avaliadores. Por exemplo, no caso de auto-avaliações versus classificações de outros, uma diferença positiva (+) significa que a classificação que os outros lhe atribuíram é mais alta do que a sua própria classificação. Uma diferença negativa (-) significa que a classificação que os outros lhe atribuíram é mais baixa do que a sua própria classificação.",
                "GAP_CHART_FOOTER": "O gráfico de intervalos indica a diferença +/- entre dois grupos de classificadores.",
                "GAP_TABLE_DESCRIPTION": "Os pontos fortes ocultos mostram onde a classificação dos outros é mais alta do que a sua classificação. As áreas de melhoria mostram onde a classificação dos outros é mais baixa do que a sua classificação. Ambas as secções são classificadas do intervalo maior para o mais pequeno.",
                "GAP_TABLE_FOOTER": "A primeira coluna das pontuações indica a sua própria pontuação. A segunda coluna indica a pontuação média dos outros. A terceira coluna indica a diferença entre a sua própria pontuação e a pontuação que os outros lhe atribuíram.",
                "GAP_TABLE_TITLE": "Pontos fortes ocultos/Áreas de melhoria",
                "GREATER_OR_EQUAL": "Maior ou igual",
                "GREATER_THAN": "Superior a",
                "GROUP": "Grupo",
                "GROUPED_FOR_ANONYMITY": "Agrupado para anonimato",
                "HEADER_NAMES": "Nomes dos cabeçalhos",
                "HIGHEST_SCORES": "Pontuações mais altas",
                "HIGHLIGHT_THRESHOLD": "Limite para realçar intervalos",
                "HIGHLOW_TABLE": "Pontuações altas e baixas",
                "HIGHLOW_TABLE_FOOTER": "Esta secção mostra os cinco comportamentos com maior e menor classificação (em todos os comportamentos) das médias aplicáveis da categoria de avaliadores. Para aproveitar ao máximo esta página, é útil procurar tendências que possam surgir. Por exemplo, se a maioria dos comportamentos com classificação mais baixa estiver concentrada numa ou duas categorias, estas podem ser áreas que precisam de desenvolvimento. Os comportamentos com classificação mais alta podem identificar pontos fortes que podem ser aproveitados em outras áreas.",
                "HIGH_LOW_TABLE_DESCRIPTION": "O gráfico de pontuações altas/baixas apresenta itens nas áreas em que os outros lhe atribuíram a classificação mais alta e mais baixa.",
                "HORIZONTAL": "Horizontal",
                "HORIZONTAL_AND_VERTICAL": "Horizontal e vertical",
                "HORIZONTAL_BAR": "Barra horizontal",
                "HOW_TO_INTERPRET_RESULT_HEADER": "Como interpretar os resultados e determinar a ação:",
                "IF": "Se",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "Incluir etiquetas ocultas em percentagens",
                "INNER_RIM": "Aro interior",
                "IS": "É",
                "IS_NOT": "Não é",
                "IS_SAME_AS_SUBJECT": "É igual ao participante",
                "ITEM": "Item",
                "LABEL": "etiqueta",
                "LABELS": "Etiquetas",
                "LARGE_LABELS": "Etiquetas grandes",
                "LEGEND": "Legenda",
                "LEGEND_POSITION": "Posição da legenda",
                "LEGEND_VALUES": "Valores da legenda",
                "LESS_OR_EQUAL": "Menor ou igual",
                "LESS_THAN": "Inferior a",
                "LINE": "Linha",
                "LOWEST_SCORES": "Pontuações mais baixas",
                "MANAGERS": "Gestores",
                "MANUAL_FONT_SIZE": "Definir o tamanho do tipo de letra manualmente",
                "MAX": "Máx.",
                "MEAN": "Média",
                "MEDIAN": "Mediana",
                "METRIC_TYPE": "Tipo de métrica",
                "MIN": "Mín.",
                "MODIFY_CUSTOM_PALETTES": "Modificar paletas personalizadas",
                "MOVE_DOWN": "Mover para baixo",
                "MOVE_UP": "Mover para cima",
                "MULTI_SELECT_ITEMS_SELECTED": "selecionado",
                "NEGATIVE_GAPS": "Áreas de melhoria",
                "NO": "Não",
                "NONE": "Nenhum",
                "NOT_APPLICABLE": "N/A",
                "NOT_EQUAL_TO": "Diferente de",
                "NO_DATA_AVAILABLE_WARNING": "Sem dados disponíveis",
                "NO_FILTER": "Sem filtro",
                "NO_FILTER_IS_APPLIED": "Nenhum filtro aplicado.",
                "NO_VALUE": "Sem valor",
                "NPS": "Net Promoter Score",
                "NUMBER": "número",
                "NUMBERS": "Números",
                "NUMBER_OF_GAPS_NEGATIVE": "Número de intervalos negativos",
                "NUMBER_OF_GAPS_POSITIVE": "Número de intervalos positivos",
                "NUMBER_OF_ROWS_HIGH": "Número de linhas altas",
                "NUMBER_OF_ROWS_LOW": "Número de linhas baixas",
                "OPTIONS": {
                    "HEADER_NAME": "Nome do cabeçalho",
                    "LEGEND": "Legenda",
                    "SCALE_AXIS_CHANGER_TITLE": "Intervalo"
                },
                "ORIENTATION": "Orientação",
                "OR_IF": "Ou se",
                "OTHER": "Outro",
                "OTHERS": "Outros",
                "PAGE_OF": "Página: %1 de %2",
                "PALETTE_REMOVED": "Paleta removida",
                "PEERS": "Elementos",
                "PERCENT": "Percentagem",
                "PERCENTAGE": "Percentagem",
                "PERCENTAGE_OF_CHOICES": "Percentagem de escolhas",
                "PERCENTAGE_OF_RESPONSES": "Percentagem de respostas",
                "PERCENT_COMPLETE": "% concluído",
                "PERSON_METADATA": "Metadados pessoais",
                "PERSON_METADATA_EVALUATOR": "do avaliador",
                "PERSON_METADATA_SUBJECT": "do participante",
                "PERSON_METADATA_VIEWER": "do visualizador",
                "POSITIVE_GAPS": "Pontos fortes ocultos",
                "PRIMARY_PARENTHESES": "(primário)",
                "QUESTIONS": "Perguntas",
                "RADIUS": "Raio",
                "RANK": "Classificação",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "Pontuação mais alta",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "Pontuações mais altas",
                "RANKABLE_ITEMS_ITEM_HAS": "O item tem",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "O item está nas principais",
                "RANKABLE_ITEMS_LOWEST_SCORE": "Pontuação mais baixa",
                "RANKABLE_ITEMS_LOWEST_SCORES": "Pontuações mais baixas",
                "RATER_CATEGORY_DISPLAY_LOGIC": "lógica da exibição das categorias do classificador",
                "RATIO": "Rácio",
                "RECORD": "Registo",
                "REFERENCE_GROUP": "Grupo de referência",
                "RELATIONSHIP": "Relação",
                "RELATIONSHIP_FILTERS": "Filtros de relação",
                "RELATIONSHIP_FILTERS_INFO": "Para adicionar um filtro de relação (como um subordinado direto, par ou gestor), selecione Administrar os seus filtros e use a condição Relação, só a partir do menu pendente.",
                "REMOVE": "Remover",
                "REMOVE_DATA_SOURCE": "Remover origem de dados",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Lembre-se de que existem recursos dentro da sua organização que o ajudam a interpretar o seu feedback, tal como parceiros de RH, o seu gestor e/ou um mentor.",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Faça uma caneca de café e mergulhe no seu feedback.",
                    "ABOUT_YOUR_REPORT_HEADER": "Sobre o seu relatório",
                    "ABOUT_YOUR_REPORT_LINE1": "Bem-vindo ao seu relatório de feedback 360. Esta é uma ótima oportunidade para crescer e progredir como profissional. Para se preparar para o sucesso ao analisar os resultados, disponha de tempo suficiente para examinar o feedback. Inicialmente, o feedback pode ser difícil de perceber, mas não se esqueça de que o objetivo deste feedback é o de acelerar o seu crescimento e progresso.",
                    "ABOUT_YOUR_REPORT_LINE2": "Aqui ficam alguns aspetos para ter em mente enquanto analisa o seu relatório.",
                    "ADVANCED_FILTER": "Filtro avançado",
                    "AGREEMENT_CHART": "Gráfico de acordo",
                    "AGREEMENT_CHART_FOOTER": "O gráfico de acordo indica a semelhança das pontuações. Cada ponto representa como um individuo o/a classificou por cada item. O tamanho do ponto mostra quantos avaliadores lhe atribuíram determinada classificação.",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "respostas",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "resposta",
                    "AGREEMENT_CHART_LEGEND_TITLE": "Como os outros o/a classificam",
                    "ALL": "Todos",
                    "AVERAGE": "Média",
                    "BOTTOM_BOX": "Caixa inferior",
                    "CHOICE_COUNT": "Contagem de opções",
                    "CHOICE_TOTALS": "Totais de opções",
                    "COMPARISON": "Comparação",
                    "COMPARISON_GAP_COLUMN_HEADER": "Intervalo de comparação",
                    "COMPLETED_RESPONSES": "Respostas completas",
                    "COUNT": "Contagem",
                    "DEFAULT": "Predefinição",
                    "DEFAULT_TEXT": "Texto predefinido",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "Perceber de onde vem o seu feedback, dos colegas, dos subordinados diretos, líderes, etc.",
                    "DIFFERENT_EVALUATORS_HEADER": "Avaliadores diferentes",
                    "DONE": "Concluído",
                    "DONT_HEADER": "Não:",
                    "DONT_LINE1": "Tentar perceber quem disse o quê",
                    "DONT_LINE2": "Concentrar-se numa pontuação/comentário positivo ou negativo",
                    "DONT_LINE3": "Criar um plano de desenvolvimento em torno de cada item",
                    "DONT_LINE4": "Deixar-se desencorajar em relação a oportunidades de melhoria",
                    "DO_HEADER": "Sim:",
                    "DO_LINE1": "Observar o feedback de forma holística",
                    "DO_LINE2": "Identificar temas em pontos fortes e oportunidades de melhoria",
                    "DO_LINE3": "Dar prioridade a algumas áreas de foco para adicionar ao seu plano de desenvolvimento",
                    "DO_LINE4": "Perceber que todos têm oportunidades de melhoria",
                    "FIELD": "Campo",
                    "GAP": "Intervalo",
                    "GAP_CHART": "Gráfico de intervalos",
                    "GAP_CHART_DESCRIPTION": "O gráfico de intervalos apresenta a diferença de pontuações entre dois grupos de avaliadores. Por exemplo, no caso de auto-avaliações versus classificações de outros, uma diferença positiva (+) significa que a classificação que os outros lhe atribuíram é mais alta do que a sua própria classificação. Uma diferença negativa (-) significa que a classificação que os outros lhe atribuíram é mais baixa do que a sua própria classificação.",
                    "GAP_CHART_FOOTER": "O gráfico de intervalos indica a diferença +/- entre dois grupos de classificadores.",
                    "GAP_TABLE_DESCRIPTION": "Os pontos fortes ocultos mostram onde a classificação dos outros é mais alta do que a sua classificação. As áreas de melhoria mostram onde a classificação dos outros é mais baixa do que a sua classificação. Ambas as secções são classificadas do intervalo maior para o mais pequeno.",
                    "GAP_TABLE_FOOTER": "A primeira coluna das pontuações indica a sua própria pontuação. A segunda coluna indica a pontuação média dos outros. A terceira coluna indica a diferença entre a sua própria pontuação e a pontuação que os outros lhe atribuíram.",
                    "GAP_TABLE_TITLE": "Pontos fortes ocultos/Áreas de melhoria",
                    "GROUP": "Grupo",
                    "HIDE_REPORT_ALERT": "O utilizador não cumpre os requisitos para ver o seu relatório. Contacte o administrador da sua organização.",
                    "HIGHEST_SCORES": "Pontuações mais altas",
                    "HIGHLOW_TABLE": "Pontuações altas e baixas",
                    "HIGHLOW_TABLE_FOOTER": "Esta secção mostra os cinco comportamentos com maior e menor classificação (em todos os comportamentos) das médias aplicáveis da categoria de avaliadores. Para aproveitar ao máximo esta página, é útil procurar tendências que possam surgir. Por exemplo, se a maioria dos comportamentos com classificação mais baixa estiver concentrada numa ou duas categorias, estas podem ser áreas que precisam de desenvolvimento. Os comportamentos com classificação mais alta podem identificar pontos fortes que podem ser aproveitados em outras áreas.",
                    "HIGH_LOW_TABLE_DESCRIPTION": "O gráfico de pontuações altas/baixas apresenta itens nas áreas em que os outros lhe atribuíram a classificação mais alta e mais baixa.",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "Como interpretar os resultados e determinar a ação:",
                    "ITEM": "Item",
                    "LOWEST_SCORES": "Pontuações mais baixas",
                    "MAX": "Máx.",
                    "MEAN": "Média",
                    "MEDIAN": "Mediana",
                    "MIN": "Mín.",
                    "NEGATIVE_GAPS": "Áreas de melhoria",
                    "NO_COMPARISON_SET": "Nenhum conjunto de comparação",
                    "NO_DATA_AVAILABLE_WARNING": "Sem dados disponíveis",
                    "NO_FILTER_IS_APPLIED": "Nenhum filtro aplicado.",
                    "NO_VALUE": "Sem valor",
                    "NPS": "Net Promoter Score",
                    "OTHERS": "Outros",
                    "PERCENTAGE": "Percentagem",
                    "PERCENTAGE_OF_CHOICES": "Percentagem de escolhas",
                    "PERCENTAGE_OF_RESPONSES": "Percentagem de respostas",
                    "PERCENT_COMPLETE": "% concluído",
                    "POSITIVE_GAPS": "Pontos fortes ocultos",
                    "QUESTIONS": "Perguntas",
                    "RANK": "Classificação",
                    "RELATIONSHIPS": {
                        "ANYONE": "Qualquer pessoa",
                        "DIRECT_REPORT": "Subordinado direto",
                        "MANAGER": "Gestor",
                        "PEER": "Par",
                        "SELF": "Próprio"
                    },
                    "REPORT_SUMMARY": "Resumo do relatório",
                    "REPORT_SUMMARY_TABLE_FOOTER": "Comparar o número de pessoas que terminaram a apreciação com o número de pessoas convidadas a participar.",
                    "REPORT_SUMMARY_TABLE_HEADER": "Estatística de inquiridos",
                    "RESPONSES": "Respostas",
                    "RESPONSE_COUNT": "{{responseCount}} respostas",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Respostas",
                    "SCORING_CATEGORY": "Categoria de pontuação",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Nenhuma resposta para esta categoria",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Nenhuma resposta para esta pergunta",
                    "SCORING_OVERVIEW": "Visão geral da pontuação",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "Tanto o utilizador como os outros avaliadores pensam que esta área é um dos pontos mais fortes.",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Ponto forte reconhecido",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Uma área de melhoria reconhecida significa que a auto-avaliação e as classificações de outros estão ambas abaixo da média em relação a essa competência.",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Área de melhoria reconhecida",
                    "SCORING_OVERVIEW_DESCRIPTION": "Acima estão as competências ou os comportamentos em que foi avaliado como parte deste processo de feedback com avaliadores múltiplos. As avaliações de comparação são fornecidas pelo grupo.",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "Intervalo mínimo",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Diferença mínima entre grupos de referência para textos a apresentar.",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "É exibido o intervalo de pontuações para cada competência/comportamento. A barra representa a média numérica.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Os pontos fortes não reconhecidos vêm da discrepância entre a auto-avaliação e as classificações de outros.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Pontos fortes não reconhecidos",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "As áreas de melhoria não reconhecidas vêm da discrepância entre a auto-avaliação e as classificações de outros.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Área de melhoria não reconhecida",
                    "SELF": "Próprio",
                    "SELF_ASSESSMENT": "Auto-apreciação",
                    "STANDARD_DEVIATION": "Desvio padrão",
                    "SUM": "Soma",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Familiarize-se com a escala de classificação para assegurar uma interpretação precisa",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "Tome nota da escala",
                    "THINGS_YOU_WILL_SEE_HEADER": "O que vai ver:",
                    "THREE_SIXTY_PERCENTILE": "Percentil",
                    "TOP_BOTTOM_BOX": "Caixa superior / caixa inferior",
                    "TOP_BOX": "Caixa superior",
                    "TOTAL": "Total",
                    "TO_DO": "A fazer",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Qualitativo: este feedback terá a forma de comentário de texto aberto",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Quantitativo: este feedback será numérico e pode ser representado em gráficos, gráficos de barras, tabelas, etc.",
                    "TYPES_OF_FEEDBACK_HEADER": "Vários tipos de feedback",
                    "VALUE": "Valor",
                    "VARIANCE": "Variação",
                    "YOUR_RATINGS": "As suas classificações"
                },
                "REPORT_SUMMARY": "Resumo do relatório",
                "REPORT_SUMMARY_TABLE_FOOTER": "Comparar o número de pessoas que terminaram a apreciação com o número de pessoas convidadas a participar.",
                "REPORT_SUMMARY_TABLE_HEADER": "Estatística de inquiridos",
                "RESET": "Repor",
                "RESPONDENT_TOTALS": "Totais de inquiridos",
                "RESPONSES": "Respostas",
                "RESPONSE_COUNT": "{{responseCount}} respostas",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> Respostas",
                "RESULT": "Resultado",
                "REVERSE_COLORS": "Cores invertidas",
                "ROW_TOTALS": "Totais de linha",
                "SAVE": "Guardar",
                "SAVE_AND_APPLY": "Guardar e aplicar",
                "SCORING_CATEGORY": "Categoria de pontuação",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Nenhuma resposta para esta categoria",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Nenhuma resposta para esta pergunta",
                "SCORING_OVERVIEW": "Visão geral da pontuação",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "Tanto o utilizador como os outros avaliadores pensam que esta área é um dos pontos mais fortes.",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Ponto forte reconhecido",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Uma área de melhoria reconhecida significa que a auto-avaliação e as classificações de outros estão ambas abaixo da média em relação a essa competência.",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Área de melhoria reconhecida",
                "SCORING_OVERVIEW_DESCRIPTION": "Acima estão as competências ou os comportamentos em que foi avaliado como parte deste processo de feedback com avaliadores múltiplos. As avaliações de comparação são fornecidas pelo grupo.",
                "SCORING_OVERVIEW_MINIMUM_GAP": "Intervalo mínimo",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Diferença mínima entre grupos de referência para textos a apresentar.",
                "SCORING_OVERVIEW_TABLE_FOOTER": "É exibido o intervalo de pontuações para cada competência/comportamento. A barra representa a média numérica.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Os pontos fortes não reconhecidos vêm da discrepância entre a auto-avaliação e as classificações de outros.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Pontos fortes não reconhecidos",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "As áreas de melhoria não reconhecidas vêm da discrepância entre a auto-avaliação e as classificações de outros.",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Área de melhoria não reconhecida",
                "SELECT_CATEGORIES": "Selecione categorias de pontuação...",
                "SELECT_CATEGORY": "Selecione uma Categoria de pontuação...",
                "SELECT_CONDITION_TYPE": "Selecionar tipo de condição",
                "SELECT_DATA_SOURCE": "Selecionar origem de dados",
                "SELECT_DATA_SOURCE_TYPE": "Selecionar tipo de origem de dados",
                "SELECT_FILTER": "Selecionar filtro",
                "SELECT_FILTERS": "Selecionar filtros",
                "SELECT_OPERATOR_TYPE": "Selecionar tipo de operador",
                "SELECT_PERSON": "Selecionar pessoa",
                "SELECT_PERSON_METADATA": "Selecionar metadados de pessoa",
                "SELECT_QUESTION": "Selecionar pergunta",
                "SELECT_QUESTIONS": "Selecione Perguntas...",
                "SELECT_RATIO_OR_DROPOFF": "Selecionar rácio ou queda",
                "SELECT_RELATIONSHIP": "Selecionar relação",
                "SELECT_SCORING_CATEGORY": "Selecionar categoria de pontuação",
                "SELF": "Auto",
                "SELF_ASSESSMENT": "Auto-apreciação",
                "SEQUENTIAL": "Sequencial",
                "SETUP_COMPARISON": "Configurar comparação",
                "SETUP_COMPARISONS": "Configurar comparações",
                "SET_START_COLOR": "Definir cor inicial",
                "SHOULD_SHOW_FOOTER": "Mostrar rodapé",
                "SHOULD_SHOW_SCORING_CATEGORY": "Mostrar categoria de pontuação",
                "SHOWING_RECORDS_OF": "A mostrar registos %1 - %2 de %3",
                "SHOW_COMPARISON_GAP": "Mostrar coluna de intervalo de comparação",
                "SHOW_DATA_LABEL": "Mostrar valores dos dados",
                "SHOW_PERCENTAGES": "Mostrar percentagens",
                "SHOW_THE_FOLLOWING_TEXT": "Em seguida, mostrar o texto seguinte",
                "SHOW_TIES": "Mostrar ligações",
                "SHOW_X_AXIS": "Mostrar eixo X",
                "SHOW_Y_AXIS": "Mostrar eixo Y",
                "SMALL_LABELS": "Etiquetas pequenas",
                "SORT": "Ordenar",
                "SPLINE": "Curva polinomial",
                "STACK_CHART": "Empilhar gráfico",
                "STANDARD_DEVIATION": "Desvio padrão",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "Ponto fraco inferior a",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "Editar textos sobre limites",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "Textos sobre limites",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "Ativar textos sobre limites",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "Ponto forte superior a",
                "SUM": "Soma",
                "SUMMARY": "Resumo",
                "TABLES": "Tabelas",
                "TABLE_TOTALS": "Totais de tabelas",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Familiarize-se com a escala de classificação para assegurar uma interpretação precisa",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "Tome nota da escala",
                "TEXT": "Texto",
                "THINGS_YOU_WILL_SEE_HEADER": "O que vai ver:",
                "TOP_BOTTOM_BOX": "Caixa superior/Caixa inferior",
                "TOP_BOX": "Caixa superior",
                "TOTAL": "Total",
                "TOTAL_COUNTS": "Total de contagens",
                "TO_DO": "A fazer",
                "TRANSPOSE": "Transpor",
                "TRANSPOSE_TABLE": "Transpor tabela",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Qualitativo: este feedback terá a forma de comentário de texto aberto",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Quantitativo: este feedback será numérico e pode ser representado em gráficos, gráficos de barras, tabelas, etc.",
                "TYPES_OF_FEEDBACK_HEADER": "Vários tipos de feedback",
                "UNDO": "Anular",
                "USE_COMPARISON": "Usar comparação",
                "USE_LABELS_FOR_SCALES": "Utilizar etiquetas para escalas",
                "VALUES": "Valores",
                "VALUE_RANGES": "Intervalos de valores",
                "VARIANCE": "Variação",
                "VERTICAL": "Vertical",
                "VERTICAL_RANGE": "Intervalo vertical",
                "WARNING_DATA_OUT_OF_RANGE": "Aviso: o valor dos dados ultrapassa a configuração do intervalo",
                "WIDGET_ERROR": {
                    "ERROR": "Ocorreu um erro inesperado",
                    "MISCONFIGURED": "Este widget não está configurado corretamente. Verifique a configuração do seu widget.",
                    "NEW": "Configure o widget",
                    "NO_DATA": "Nenhuns dados encontrados - os seus filtros podem ser demasiado exclusivos!"
                },
                "WIDGET_NAME": {
                    "BAR": "Gráfico de barras",
                    "BREAKDOWNBAR": "Barra repartida",
                    "DATA_TABLE": "Tabela de dados",
                    "FUNNEL_CHART": "Gráfico de funil",
                    "GAUGE": "Gráfico de medição",
                    "GRID": "Tabela de resultados",
                    "HEATMAP": "Mapa térmico",
                    "LINE": "Gráfico de linhas",
                    "NEEDS_BASED": "Baseado nas necessidades",
                    "PIE": "Gráfico circular",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "Avaliador do preço (Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "Maximizador da receita (Gabor Granger)",
                    "SCORING_OVERVIEW_CHART": "Gráfico",
                    "SCORING_OVERVIEW_TABLE": "Tabela",
                    "STATS_TABLE": "Tabela de estatística",
                    "WORDCLOUD": "Nuvem de palavras"
                },
                "WORD_ROTATION": "Rotação das palavras",
                "WORD_SPACING": "Espaçamento entre palavras",
                "YES": "Sim",
                "YOUR_RATINGS": "As suas classificações"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "Adicionar",
                "ADD_A_WORD": "Adicionar uma palavra",
                "COLOR": "Cor",
                "DELETE_ALL": "Eliminar tudo",
                "EDIT_STOP_WORDS": "Editar palavras de paragem",
                "MAX_WORDS": "Máximo de palavras",
                "ROTATION_ANGLED": "Angular",
                "ROTATION_HORIZONTAL": "Horizontal",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "Horizontal e vertical",
                "WORD_ORIENTATION": "Orientação da palavra"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "Cores de fundo",
                "DISPLAY_OPTIONS": "Apresentar opções",
                "INVERT_FONT_COLORS": "Inverter cores de baixo contraste do tipo de letra",
                "PAGE": "Página",
                "PAGINATE": "Paginar"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "Média",
                "BOTTOM_BOX_METRIC": "Caixa inferior",
                "COLUMNS": "Colunas",
                "COUNT_METRIC": "Total de respostas",
                "FIELD_NAME": "Campo",
                "MAX_METRIC": "Máximo",
                "MIN_METRIC": "Mínimo",
                "SHOW_RECODES": "Mostrar valores de recodificação",
                "SHOW_ROW_NUMBERS": "Mostrar números das linhas",
                "STD_DEV_METRIC": "Desvio padrão",
                "TOP_BOX_METRIC": "Caixa superior",
                "TRANSPOSE_BREAKOUTS": "Transpor separações",
                "TRANSPOSE_TABLE": "Transpor tabela",
                "VAR_METRIC": "Variação"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "Colunas adicionais",
                "ADD_COLUMNS": "Adicionar colunas adicionais",
                "ADD_CUSTOM_PALETTE": "Adicionar paleta personalizada",
                "ALL_CHOICES": "Todas as opções",
                "ALL_GROUPS": "Todos os grupos",
                "ALL_RECODES": "Todas as recodificações",
                "AUTOMATIC": "Predefinição",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "Predefinição - Clique para editar",
                "AXIS_VALUES": "Valores do eixo",
                "BREAKOUT_BY": "Separar por",
                "CANCEL": "Cancelar",
                "CATEGORICAL": "Categórico",
                "CHOICES": "Opções",
                "CHOICE_COUNT": "Contagem de opções",
                "COLOR_PALETTE": "Paleta de cores",
                "COLUMN_VALUES": "Valores de coluna",
                "CONTACT_FIELDS": "Campos de contactos",
                "COUNT": "Contagem",
                "CREATE": "Criar",
                "CUSTOM": "Personalizado",
                "CUSTOM_PALETTE": "Personalizar paleta",
                "DATA_SOURCE": "Origem dos dados",
                "DAY": "Dia",
                "DAY_OF_WEEK": "Dia da semana",
                "DECIMAL_PRECISION": "Casas decimais",
                "DEFAULT": "Predefinição",
                "DISABLED": "Desativado",
                "DIVERGENT": "Divergente",
                "EDIT_CUSTOM_PALETTE": "Editar paleta personalizada",
                "ENABLED": "Ativado",
                "ERROR_LOADING_DATA": "Erro ao carregar os dados",
                "FILE_SIZE": "Tamanho",
                "FILE_TYPE": "Tipo",
                "FRI": "Sex",
                "FRIDAY": "Sexta-feira",
                "GROUP_DATE_BY": "Data de grupo por",
                "HOUR_OF_DAY": "Hora do dia",
                "LENGEND_VALUES": "Valores da legenda",
                "MAX": "Máx.",
                "MEAN": "Média",
                "MIN": "Mín.",
                "MISCONFIGURED_DATA": "Configuração incorreta da origem dos dados para esta visualização.",
                "MISCONFIGURED_FILTERS": "Filtro(s) inválido(s)",
                "MODIFY_CUSTOM_PALETTES": "Modificar paletas personalizadas",
                "MON": "Seg",
                "MONDAY": "Segunda-feira",
                "MONTH": "Mês",
                "NONE": "Nenhum",
                "NO_FILE_ID_ERROR": "Esta visualização exige que uma imagem seja definida no inquérito",
                "NO_RESULTS_TO_SHOW": "Nenhuns resultados para mostrar",
                "NPS": "Net Promoter Score®",
                "NPS_GROUP": "Grupo NPS®",
                "NUMERIC_VALUE": "Valor numérico",
                "PALETTE_REMOVED": "Paleta removida",
                "PERCENTAGE": "Percentagem",
                "PERCENTAGE_OF_CHOICES": "Percentagem de escolhas",
                "PERCENTAGE_OF_RESPONSES": "Percentagem de respostas",
                "QUARTER": "Trimestre",
                "REMOVE": "Remover",
                "RESPONSE_COUNT": "Contagem de respostas",
                "RESULTS_PER_PAGE": "Resultados por página",
                "RETRIEVING_DATA_ELLIPSIS": "A obter dados...",
                "REVERSE_COLORS": "Cores invertidas",
                "ROW_VALUES": "Valores de linha",
                "SAT": "Sáb",
                "SATURDAY": "Sábado",
                "SAVE": "Guardar",
                "SELECTED_CHOICE": "Opção selecionada",
                "SELECT_FIELD": "Selecionar campo",
                "SELECT_METRIC": "Métrica",
                "SEQUENTIAL": "Sequencial",
                "SET_START_COLOR": "Definir cor inicial",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "A mostrar dados da amostra...",
                "SUM": "Soma",
                "SUN": "Dom",
                "SUNDAY": "Domingo",
                "SURVEY_EMBEDDEDDATA": "Dados incorporados",
                "SURVEY_METADATA": "Metadados do inquérito",
                "TEXT_ENTRY": "Entrada de texto",
                "THURS": "Qui",
                "THURSDAY": "Quinta-feira",
                "TITLE": "Título",
                "TUES": "Ter",
                "TUESDAY": "Terça-feira",
                "UNBOUNDED_DOMAIN": "Existem demasiados valores para apresentar.",
                "UNBOUNDED_DOMAIN_HELP": "Para adicionar este campo aos Relatórios de resultados, pode adicionar um filtro ao relatório para apresentar menos valores para \"{{ed_field_name}}\" ou atualizar o tipo de variável de dados incorporados de \"{{ed_field_name}}\" no fluxo do seu inquérito para tornar este campo num tipo numérico ou de cadeia.",
                "UNDO": "Anular",
                "USE_CHOICE_TOTALS": "Utilizar totais de opções",
                "USE_RESPONDENT_TOTALS": "Utilizar totais de inquiridos",
                "VISUALIZATION": "Visualização",
                "VISUALIZATION_BARCHART": "Gráfico de barras",
                "VISUALIZATION_BREAKDOWNBAR": "Barra repartida",
                "VISUALIZATION_GAUGE": "Gráfico de medição",
                "VISUALIZATION_HEATMAP": "Mapa térmico",
                "VISUALIZATION_LINECHART": "Gráfico de linhas",
                "VISUALIZATION_PAGINATEDTABLE": "Tabela paginada",
                "VISUALIZATION_PIE": "Gráfico circular",
                "VISUALIZATION_SIMPLETABLE": "Tabela simples",
                "VISUALIZATION_STATSTABLE": "Tabela de estatística",
                "VISUALIZATION_TEXTHIGHLIGHTS": "Marcadores de texto",
                "VISUALIZATION_WORDCLOUD": "Nuvem de palavras",
                "WED": "Qua",
                "WEDNESDAY": "Quarta-feira",
                "WEEK": "Semana",
                "WEIGHTING": "Ponderação",
                "WRONG_QUESTION_TYPE_ERROR": "Este tipo de visualização não pode ser utilizada para esta pergunta",
                "YEAR": "Ano"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "Média",
                "CHOICE_COUNT": "Contagem de opções",
                "COUNT": "Contagem",
                "DISPLAY_OPTIONS": "Apresentar opções",
                "MAX": "Máximo",
                "MIN": "Mínimo",
                "NPS": "NPS®",
                "PAGE_OF": "Página: %1 de %2",
                "PERCENT": "Percentagem",
                "RESPONSE_COUNT": "Contagem de respostas",
                "ROWS_PER_TABLE": "Linhas por tabela",
                "SHOWING_ROWS_OF": "A mostrar linhas %1 - %2 de %3",
                "SHOW_PERCENTAGES": "Mostrar percentagens",
                "SHOW_RECODES": "Mostrar valores de recodificação",
                "SHOW_ROW_NUMBERS": "Mostrar números das linhas",
                "SUM": "Soma",
                "TOTAL": "Total",
                "TRANSPOSE": "Transpor",
                "USE_COLUMN_TOTALS": "Utilizar totais de coluna",
                "USE_ROW_TOTALS": "Utilizar totais de linha",
                "VALUE": "Valor"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "Ascendente",
                "COUNT": "Contagem",
                "DESCENDING": "Descendente",
                "DIAGONAL": "Diagonal",
                "DISPLAY_OPTIONS": "Apresentar opções",
                "ERROR_COLON": "Erro:",
                "ERROR_GENERIC": "Ocorreu um erro ao carregar a visualização.",
                "HORIZONTAL": "Horizontal",
                "HORIZONTAL_BARS": "Barras horizontais",
                "INCORRECTLY_CONFIGURED": "Escolha um valor para o gráfico",
                "LEGEND_AUTO": "Auto",
                "LEGEND_BOTTOM": "Inferior",
                "LEGEND_INSET": "Inserção",
                "LEGEND_RIGHT": "Direita",
                "NORMALIZE_TO_PERCENTAGES": "Normalizar para percentagens",
                "SHOW_BAR_LABELS": "Mostrar etiquetas das barras",
                "SHOW_LEGEND": "Mostrar legenda",
                "SHOW_X_AXIS": "Mostrar eixo X",
                "SHOW_Y_AXIS": "Mostrar eixo Y",
                "SORT_BAR_VALUES": "Ordenar valores da barra",
                "STACKED_BARS": "Barras empilhadas",
                "TRANSPOSE": "Transpor",
                "TRUNCATE_LABELS": "Truncar etiquetas",
                "VERTICAL": "Vertical"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "Todos os outros",
                "COULD_NOT_LOAD_DATA": "Não foi possível carregar dados com a configuração especificada — tente um campo diferente ou um intervalo de data maior.",
                "GROUPING_PERCENTAGE_THRESHOLD": "Limite de percentagem de agrupamento",
                "NO_DATA": "Sem dados",
                "RADIUS": "Raio interior",
                "SHOW_AS_PERCENTAGES": "Mostrar como percentagens"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "Fechar",
                "DOWNLOAD_CSV": "Transferir CSV",
                "DOWNLOAD_ZIP": "Transferir todos os ficheiros",
                "NO_DATA": "Sem dados",
                "PAGE_OF": "Página: %1 de %2",
                "RESULTS_PER_PAGE": "Resultados por página",
                "SHOWING_RECORDS_OF": "A mostrar registos %1 - %2 de %3",
                "SINGLE_RESPONSE": "Resposta única",
                "VIEW_RESPONSE": "Visualizar resposta"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "Apresentar opções",
                "ERROR_COLON": "Erro:",
                "ERROR_GENERIC": "Ocorreu um erro ao carregar a visualização.",
                "HORIZONTAL_BARS": "Barras horizontais",
                "INCORRECTLY_CONFIGURED": "Escolha um valor para o gráfico",
                "LEGEND_AUTO": "Auto",
                "LEGEND_BOTTOM": "Inferior",
                "LEGEND_INSET": "Inserção",
                "LEGEND_RIGHT": "Direita",
                "NORMALIZE_TO_PERCENTAGES": "Normalizar para percentagens",
                "SHOW_AREA": "Mostrar área",
                "SHOW_LEGEND": "Mostrar legenda",
                "SHOW_X_AXIS": "Mostrar eixo X",
                "SHOW_Y_AXIS": "Mostrar eixo Y",
                "SMOOTH_LINES": "Linhas suaves",
                "SORT_X_AXIS_LABELS": "Ordenar etiquetas de eixo X",
                "STACKED_BARS": "Barras empilhadas",
                "TRANSPOSE": "Transpor"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "Modo do bloco",
                "BLUR": "Distorção",
                "COULD_NOT_LOAD_DATA": "Não foi possível carregar dados com a configuração especificada — tente um campo diferente ou um intervalo de data maior.",
                "FIELD": "Campo",
                "RADIUS": "Raio",
                "SHOW_REGIONS": "Mostrar regiões",
                "SHOW_REGION_LABELS": "Mostrar etiquetas de região"
            },
            "GAUGEWIDGET": {
                "MAX": "Máx.",
                "MIN": "Mín.",
                "VALUE_RANGES": "Intervalos de valores"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "Etiquetas inferiores",
                "CATEGORY_NAME": "Nome da categoria",
                "ERROR_COLON": "Erro:",
                "INCLUDE_HIDDEN_GROUPS": "Incluir grupos ocultos em percentagens",
                "LARGE_LABELS": "Etiquetas grandes",
                "NO": "Não",
                "PERCENT": "Percentagem",
                "RESPONSE_COUNT": "Contagem de respostas",
                "RESPONSE_COUNT_WITH_VALUE": "{{ responseCount }} respostas",
                "SMALL_LABELS": "Etiquetas pequenas",
                "YES": "Sim"
            }
        });
        $cache.put('RI-GI', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "⁪⁪⁪‍​‍‍‍​‌‍​​‌‌‌​‌​‌​‍‍‍‍‍​‍​‍‍‍‍‌‌‌‌​‌‌‍⁪Access Code⁪⁪",
                "ACCESS_CODE_PROTECTION": "⁪⁪⁪‌​‍​​‌‍​‌​​​‍‌‍‌​​‍‍​‌‍​‌‌‍‍‌‍‌​‍‍​‌‍​‍‌​⁪Access Code Protection⁪⁪",
                "ADD": "⁪⁪⁪‌‌​​‍‍‌‌‌​​​‌‌​‌‍​‌‍‍‍​‍​‍‌​​‌‌​​​‍‍​‌‍​⁪Add⁪⁪",
                "ADD_BREAKOUT": "⁪⁪⁪‌​‌​‌​​‌‍‌‍‌‍‍‍‌​‍‍​‌‌‍‌‍‍‌​‌‌‌​‍​‌‌‍‌‍​​⁪Add Report Breakout⁪⁪",
                "ADD_NOTE": "⁪⁪⁪‍‍‌‍‌‌‌​‍​‍​‌​‍​‌​​‌‌​​​‍‍​‌‍‌‍‍​‌​‌‌​‍​⁪Add Note⁪⁪",
                "ADD_SCHEDULED_REPORT": "⁪⁪⁪‍‌‌‌​​‍‌‌‌‍‍‍‌‍​‍​‌‌​​​‍‍​‍‌​​‍‌​‌‌​‌‌​⁪Add Scheduled Report⁪⁪",
                "ADD_WIDGET": "⁪⁪⁪‍​​‌‍​​​‍​‌‌​‍‌‌‍‌‌‍‌‌​​‍​​‌‍‌​​‍‌‌‌‍‍⁪Add Visualization⁪⁪",
                "ALL_PROJECTS": "⁪⁪⁪‍‌‌‍‌‌‌​​‍‌‍‌‍​‍​​​‍​‍‍‍‍‌‍​​‍‍​‍​‌​​⁪All Projects⁪⁪",
                "ALL_QUESTIONS": "⁪⁪⁪‌​​‌‍‌‍​‌‌‍‌​‌‍‍‌‌​‍​‌​‍​‍‌‍‍‌‍‍‌‍​‌‍‍​‌‌⁪Question Pages⁪⁪",
                "ANSWER": "⁪⁪⁪‍‌​‍​​​‌‌‍‍​‌‌‌‍​​‍​‍​​‌​‌​‍‍‍​‌​​​‌‍‌​⁪Answer⁪⁪",
                "ANY_CHANGES_LOST": "⁪⁪⁪‍‌​‍​‌​‍‌‍‍‍​‍‌‍‌​​‌‌​​‌‍​‌‍‍‌‌​‌‌‍‍‍‍​‌⁪Any changes to reports will be lost if you leave the Qualtrics XM Platform.⁪⁪",
                "APPENDED_COPY_IN_PARENS": "⁪⁪⁪‍‌​​​​‍​‍‍‌​‌‌‌‌‍​‌‍‍‌‍‍‌‌‌‍‍‍‌​‍​‌‍‍‍​‌⁪(Copy)⁪⁪",
                "AREA_CHART": "⁪⁪⁪‌​​‍‍​‌‌‍‌‍‍​‍​‌​‍​‌‌​​‍​‌​​‌​‌‍​​​​‍‍‌‍​⁪Area Chart⁪⁪",
                "AREA_CHART_DESC": "⁪⁪⁪‍‍‍​​‌​‍‌​​‍‌​‌‍‍‍​‌‌‍‌‍​‍​​​​‌​‌‍​‍‌​‍​⁪A two-axis line chart with the area under the line filled in.⁪⁪",
                "ATTACHMENT": "⁪⁪⁪‌​‌‌‍​‍‍​‌‌‍‌​‍‌​​‌‍​‌‌‍‌‍‍‍‍​‌​​‌‍‌‍‍‌​​⁪Attachment⁪⁪",
                "BACKUP_CURRENT_REPORT": "⁪⁪⁪‌‌‌​‍‍​​‌‌‌​‌​‍‌‍‌‍‌​‍​‍‌​‌​​‍‌‍​‌‌‌‍​‌‌​⁪Save a backup copy of this report before affecting the visualizations⁪⁪",
                "BACKUP_CURRENT_REPORT_LINE2": "⁪⁪⁪‍​‍​​‌‌‍‍‍​​​‌‍‍‌​‌‌‌‍‌​‍‌​‍​‍​​‌‍​‌‌‌‌‌⁪Note: The backup copy will be named \"​​​{{nameOfReportCopy}}‌‌‌\"⁪⁪",
                "BACK_TO_REPORTS": "⁪⁪⁪‌​​‍‍‍​‍‍​‌‌​‌​​​​​​‌‌‍​‍​‌‍​‌​‍‍‌​‍‌​‍​⁪Back to Reports⁪⁪",
                "BACK_TO_TOP": "⁪⁪⁪‍‌​​​‌‍​‌‍‍​‌‍​​​‍​​‍​​​​‌‍‌‌‌‍‍​‍‍‌‌‍‌​⁪Back to Top⁪⁪",
                "BACK_TO_VIEW_RESULTS": "⁪⁪⁪‌​​​​​‍‌​​​‌​‍​​​‌‌​​​‍​​‍‌‌‍‌​‍‌‍​​‍‌​‍⁪Back to old view results⁪⁪",
                "BAR_CHART": "⁪⁪⁪‌‌​​‍​​‍​‍‍​‍‍‌‍‍​​‍‍‍‌​‍‍‌​​‍​‌‍​‍‍​​‍​​⁪Bar Chart⁪⁪",
                "BAR_CHART_DESC": "⁪⁪⁪‌​​‌‌‌​‍‍​​‍​‌​‌​‍‍​‌​‌‍‌‌‌‌​​‍‍​​‌​‍‍‍⁪A two-axis bar chart that allows additional configuration such as axis transposition and rearrangement of data points.⁪⁪",
                "BREAKDOWN_BAR_CHART": "⁪⁪⁪‌‌‌​‌‍​​‌​‍‍‍​​​‌​‍‌​​‍‌‍‌‍​‍‍​‌​‍​​‌‌​‍​⁪Breakdown Bar⁪⁪",
                "BREAKDOWN_BAR_CHART_DESC": "⁪⁪⁪‍‍​‍‍‍‌‌​‍‍​‌‍‌‌‌‍​‍‍‍‍​​‍‌‌​‍​​​‍‌‍​​⁪A horizontal stacked bar chart most commonly used for for visually weighing metrics against each other as an alternative to a pie chart.⁪⁪",
                "CANCEL": "⁪⁪⁪‌​​​‍‌‌‌‌​‍‍‌​‌‍​​​​‍‌​​‍​‌‌‌‍​​‌​‌‍​‍​⁪Cancel⁪⁪",
                "CANCEL_CONF_TEXT": "⁪⁪⁪‍‍​​​‌‍​​‍‌​‌‌‌‍​​​​‌‍‍​​‌‌‌‍​‌​‍‌‍‌​‌⁪Are you sure you want to cancel?​​​<br/>‌‌‌All changes will be lost.⁪⁪",
                "CANCEL_EDITS": "⁪⁪⁪‌​​​​‌​‌‍‍​‍​​​​‌‌‌​‌‌‍​​‍​‌‌​​‌​‍‍‍‌​‌‍‌⁪Cancel Edits⁪⁪",
                "CHART": "⁪⁪⁪‍​​‌​​‌​​‌‍​‌‌​​‍‌‌‌​​​‍‍‌‌‌‍‌‍‍​‌‌‌‌​​⁪Chart⁪⁪",
                "CHOICE": "⁪⁪⁪‍‌‍‌‍‌‌‍​‌‌‌‌‍‍‍‌‌‌​‌‍​​​‌‍‍​‍​‌‍​​‍​‍‌⁪Choice⁪⁪",
                "CHOICES_COUNT_METRIC": "⁪⁪⁪‌​‌‍​​‍​‌​​​‍‌‍‍‌​‌‌​‍‌‌‍‌‌​‌‌‍‍‌​‍‍‍​​‍​⁪Choices Count⁪⁪",
                "CHOOSE_PAGES_TO_DISPLAY": "⁪⁪⁪‌‌​​‌​‌‌​​​‌‌‍​​​‌‌​‍​‍‍​‍‌‌​‍‍‌‍​‍‌‌‌‌‍‌⁪Choose Pages to Display⁪⁪",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "⁪⁪⁪‍‍​‍‌‌‍‌‍​‍‌‍‍​​‌‍‌​​‌‍​‌‌‍‍‍‌​​‍‌‍‌​‌‌⁪This report contains ​​​{{maxReportPageCount}}‌‌‌ pages, but Results can only contain up to ​​​{{reportSizeLimit}}‌‌‌. Please select a subset within the limit.⁪⁪",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "⁪⁪⁪‍‍​​‍​​‌‌‍‌‍​‌‍​‌​‌‍‍‌‌‌‌‌‍​‌‌​‌‍‍‌‍​‌​⁪Reports can only contain up to ​​​{{reportSizeLimit}}‌‌‌ pages, please select the pages you would like.⁪⁪",
                "CLEAR_ALL": "⁪⁪⁪‌‌‌‌​‍​‍‍‍‌​‍​‍‍‍​​‍‍​‍‍‌‌​​‍​​​‌‍‌​​‍‌‍‍⁪Clear All⁪⁪",
                "CLOSE": "⁪⁪⁪‍​‌​​‍‌‌‍‌‌‌​​‌​‍​‌‌‍‍​​‌‌‌‍‌​​‍‌​‍‌​‌‍⁪Close⁪⁪",
                "CLOUD": "⁪⁪⁪‌‌​‌‍​​‌​​‌‌‌‌‍‌‍‍​‍‍​​​​​​​‍​​‍‌‍‍‍‌​‍‍⁪A DESCRIPTION FOR CLOUD⁪⁪",
                "COLLABORATED_NEW": "⁪⁪⁪‍‍‌​‍​‍‍​​​​‍‌​‍‍‌​‌‌​‍‍​‍‍‍‍​​​‌‌​​‍‌​‍⁪The owner of this survey is using the Qualtrics XM Platform! Reports for this survey will be edited using New Results.⁪⁪",
                "COMMA_SEPARATED_LIST": "⁪⁪⁪‌​‍‌​‌‍‍‌​‍‍‌‌‍‍‌‍‌​‌‌‌​‍​‍‌‍​​‌‍‍​‍‌‌​​‌⁪Comma Separated List⁪⁪",
                "COMPACTNESS": "⁪⁪⁪‌‍‍​‌‍‍​‌‍‌​​‍‌​‍​‌‌‌​​​​​‍​​‌​‍‌‌​‍‍‍‍‌⁪Fonts and Spacing⁪⁪",
                "COMPACTNESS_INFO": "⁪⁪⁪‍‌‍‍​‍‌​‌‍‌‌‌‌‍‍​‌‍​​‌‌‍​‌‌​‍‍‌‌‍‍‌​‍​‍⁪This setting affects table padding, font size, and bar size in charts. It will also be applied to most exports.⁪⁪",
                "CONFIRM": "⁪⁪⁪‍‌​‌‌​‌‍‌‍‍‌‍‌‍‌​‍‍‌​‌​​‌‌‌‍‍‌​‌‌‌‍‌‍​‍‌⁪Ok⁪⁪",
                "CONFIRM_DELETE": "⁪⁪⁪‌‌‍‍‍‌‌‍‌‌​​​‌‍‍‍‍‍‌‍‍​‍‌‍​‍​​​​‌‍​‌​​‌‍⁪Confirm Deletion⁪⁪",
                "CONFIRM_DELETE_PAGE": "⁪⁪⁪‌​​​​‌‌‌‌‌‌‌‍‌​‌​‌​‌​‌‌‌​​‍​‌​​‌‍‌‌‌‌​​⁪Are you sure you want to delete this page?⁪⁪",
                "CONTINUE": "⁪⁪⁪‍​​​‌‍‌​​‌‍‌‍‍‌​​‍​​‍‌‍‍‌​‍‌‌​​‍‍‍‌‍​‌​‍⁪Continue⁪⁪",
                "CONTINUE_EDITING": "⁪⁪⁪‍‍​​‍‌​‌‍​‍‌​‍‌​‍‌‌​​​​‌‍‌​‍‍‍​‌‍​‍​‌‌‍​⁪Continue Editing⁪⁪",
                "COPY": "⁪⁪⁪‌​‌​‌‍‌‌‌‌‌‍​‍‍‍‍‌‍‍‌​​‌​‍‍‌‍‍​‍​‌​​​‍‌‍‍⁪Copy⁪⁪",
                "COPY_OF_REPORT_NAME": "⁪⁪⁪‍‌‌‌‍​​‌​‌‍​‍​‌​‌‍​‌​‍‌​​‍​​‍‍‍‌​​‌‌‍‍​‍⁪Copy of ​​​{{nameOfCurrentReport}}‌‌‌⁪⁪",
                "COPY_REPORT": "⁪⁪⁪‌​‌‍​‍​​‌​‍‌‌‌​‌​​​‌‍‌‍‌​​‍‍‍​​‍‍‍​​​​​‍‌⁪Copy Report⁪⁪",
                "COPY_REPORT_ELLIPSIS": "⁪⁪⁪‍‌‌‌​‌​​‌‌‌‌‍​​​‍​​​‌​‌‌​​‌‍​‌‌‍‌‍‌‌​​‍‌⁪Copy Report...⁪⁪",
                "COPY_TO_NEW_REPORT": "⁪⁪⁪‌​‍‍‍‍‌​​‍‌​​​‍​‍‌​​‌‌​‌‌‌‍​‍​‌​‌​​‌‍​​‌​⁪Copy to New Report...⁪⁪",
                "CREATE": "⁪⁪⁪‌‍​​​‌‌​‌‍‍‍‍​‌‌​​​‌‍​‍​​‍‍​​‌‍‍‍​‌​‍​​⁪Create⁪⁪",
                "CREATED": "⁪⁪⁪‌​‌‍‌‍‍‍​‍​‍‍‍‌​​‌‍​‍‌‍​‍​​‍‌‌‌‌‌​‌​‌‌‌​‌⁪Created⁪⁪",
                "CREATE_CUSTOM_PAGE": "⁪⁪⁪‌‌‌‍‍‍‍‌​​‌‌​‍‍‌‍​​​‌‍‌‌​‍‍‍​‍‌‍‌​‍‌​‌​‌⁪Create Custom Page⁪⁪",
                "CREATE_NEW_REPORT": "⁪⁪⁪‌‍‌‌​‌‍​‍‍‍‍‌‌‌‍‌‌​‍‌​‌‌‍‍‍​‌‍‍​​‌‌​‍‍​‍⁪Create New Report⁪⁪",
                "CREATE_NEW_REPORT_ELLIPSIS": "⁪⁪⁪‌​‍​​‍‌‍‍​‌‌​‌‌​​‌‌‍​‍‌‍‌​‍‌‍‍‌​‌​​‌‌‍‌​‍⁪Create New Report...⁪⁪",
                "CSV_FILE": "⁪⁪⁪‌‌​‍​​‌‌‌‌‍‌‍​​​‍​‍‍‍​‌​‌‍​‍‌​​‌‍‌‌‍‍‌‍‍‌⁪CSV File⁪⁪",
                "CUSTOM_PAGES": "⁪⁪⁪‍‌‍‌‍​‌‌‌‍‍‌‍‍‌​‌‌​‌‌‍​​‍​‍‌‌​‍​​‍​​‌​‍⁪Custom Pages⁪⁪",
                "DATE": "⁪⁪⁪‌‌​​‌‌‍​​​‌​‌‍​‍​​‌‌‍‍‍‌‌‍‌​​‌​​​‍‍‌‌‍‍​​⁪Date⁪⁪",
                "DEFAULT_PALETTE": "⁪⁪⁪‌‌‌‍​‍​‍‌‍‍​​‌​‌‌‍‌​‍​‍‍​‌‍​‌​‌​​‍​‌​‌‌‍⁪Default Color Palette⁪⁪",
                "DEFAULT_REPORT": "⁪⁪⁪‌‌‌​​‌‌‍‌‌‍‍​‌‍‍​‍‍‍​​‍​‍​‌‌​‍‍​‍​‍‌‍‌‍‍‌⁪Default Report⁪⁪",
                "DEFAULT_VISUALIZATIONS": "⁪⁪⁪‌​​‍‌‍‍‌‍‌‌‌‌‌​​​‌‌‍​‌​‍​​‌‍​‍​​‍‌‌‌​​‍‍​⁪Default Visualizations⁪⁪",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "⁪⁪⁪‍‍‌‍‌‍‍‍‌​‌​‌‍​‌‌‌​‌‌‍​​‌‌‌‍‍‌​​‍​​‌​‌‍⁪These are the default visualization types used to construct default results reports. Updating and applying these settings will rebuild your current report with the new default settings. You will have the option to back up your current report.⁪⁪",
                "DEFAULT_VISUALIZATIONS_NOTE": "⁪⁪⁪‍‌‌‍​​‌‌‍‍‍‌‍‍​‌‌‍‌‍‍‌‌‌‍​​‍‌‍​​​‌‌​‍‍​⁪Note: Not every visualization type is available for all question types. Some non-default visualizations may automatically be substituted.⁪⁪",
                "DEFAULT_VISUALS_DISCLAIMER": "⁪⁪⁪‌​‍‍‌‍​‌‌‌‌‌‍‌‌‌​‍​‍‍​‍‍‍​‌​‍‌​​‍‌​‍‍‍‍‌⁪Qualtrics will update this report with the new default visualization settings.⁪⁪",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "⁪⁪⁪‍​​‍‍​‌‌‍​‌​​‌​‌‌‍​​‌​​​‍​​​‌​‍​‌‌‌‌​​⁪This update will affect ​​​{{amountOfWidgetsAffected}}‌‌‌ visualizations in this report.⁪⁪",
                "DEFAULT_VISUAL_EDIT_DETECTED": "⁪⁪⁪‌​‌‌‍‌​​‍‍‌‌‍‍‌‌‌‌‍‌‍‍‌‍‍‍‌​​​‍‌‌‌​‍‍‍‍‌⁪Default Visualization Edit Detected⁪⁪",
                "DELETE_BUTTON": "⁪⁪⁪‍​‌‌‌‌‍‌​​‍‌​​‍‌‌‍‌​​‍‍​​‌​​‍‍​‍​‍‍​​​⁪Delete⁪⁪",
                "DELETE_DISABLED_EXPLANATION": "⁪⁪⁪‌​‌​​‌‍‌‍‍​​‌‍‍‍​‍‌‌‍​​‍‍‌‍‌‌​​‍‌‌‍​‌​​‌‍⁪Deleting reports created in the previous reporting interface is not allowed until your organization has performed a full migration to the Qualtrics XM Platform.⁪⁪",
                "DELETE_PAGE": "⁪⁪⁪‌‍​​​‌‌‍‌‍‍​​‌​‌‍‌​‌‌​‌‌‌‍‍‍‌‍‍‌‍​‌‌​‍​⁪Delete Page⁪⁪",
                "DELETE_PAGE_ELLIPSIS": "⁪⁪⁪‍​‍‍‍​​​‍‌‌‌‍‍‌​​‌‍‍‍‍​‌​‍‍‌‌​​​‌‍​‌​‌‌​⁪Delete Page...⁪⁪",
                "DELETE_REPORT": "⁪⁪⁪‌‌‍​​‌‍‍​‌‍​‍​‍‍‌​‌‌‍‍​‌​‍​‌​‍‌‌​‍‍‌‌‍​⁪Delete Report⁪⁪",
                "DELETE_REPORT_ELLIPSIS": "⁪⁪⁪‌​‍‌‍​‌‍​‍‍‌‍‍‌‍‌‌‌‍‍​‌‌‍‍​‍‍​‍‌‍‌‌​​​‌‌‌⁪Delete Report...⁪⁪",
                "DELETE_WIDGET_QUESTION": "⁪⁪⁪‌​​‌‌‍‌‌‌‌‍‌‌​​​​‍‌​​‌‍​‍‌​‍​‌‌‍‍‍‍‌‌‌‍‍‌⁪Delete?⁪⁪",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "⁪⁪⁪‌​‌​​​‌‍‌​‌​‌‍‍​‍‍‌‌​‍​‌​‍‌​‌​​‍​​​‌‌‍‍‍​⁪This field is encrypted and cannot be used for sorting.⁪⁪",
                "DISCARD_EDITS": "⁪⁪⁪‍‍‍‌‍​‌‌‍‌​‍​​​​‌​‍​‌‌​‌​‍‌​‌‍‍‍‌‍‍​⁪Discard Edits⁪⁪",
                "DISTRIBUTION_PAUSED": "⁪⁪⁪‌​‍‍‍‌‌‌‍‌​‌​​​‌‍‍​​‌‍‌‌​‍‍‌‌‌‌​‌​‌​‌‌‍​‍⁪Report distribution paused.⁪⁪",
                "DONE_BUTTON": "⁪⁪⁪‌​‍​​​​‍‌‍‍​‌​​‍​‌‌​‍‍​‌‍‍‍‌‌‍‌​​​​​‍‌‍​⁪Done⁪⁪",
                "DONE_EDITING": "⁪⁪⁪‌​‌​​‍‌‌‌‍​‌​​‍‌‌‍​​‌​​​​‍​‌‌‍‍‍‍​‌‍‌‌​⁪Done Editing⁪⁪",
                "DOWNLOAD": "⁪⁪⁪‌​‍​‌​‍‍‍​​​​​​‍‍‍​‍‌‍​‌‍​‌‍‍‌​​​‌​​‍‍‌‌​⁪Download⁪⁪",
                "DOWNLOAD_AS_CSV": "⁪⁪⁪‌​‌​​‌​​​‌‌​​​​‍​​‌‍​‍‌​​​‍​‍‍‌‍‍‌​​‍‌‍​​⁪Download as CSV⁪⁪",
                "DOWNLOAD_AS_PDF": "⁪⁪⁪‌‌​​‌‍‌‍‌​‍‍‍​​‌‍‌​​‌​‍‌​‍‍​‍‍‍‍‌‌​​‍‍​‍‍⁪Download as PDF⁪⁪",
                "DOWNLOAD_FAILED": "⁪⁪⁪‌‌‌​‌‌‌‌‍​‍​‌‌‍‍‌​​‌‍‍‌​‍​‌​‍‌‌​​‍‌‌‌‌‌‍⁪Download failed⁪⁪",
                "DOWNLOAD_PREVIOUS_EXPORTS": "⁪⁪⁪‌‍‌​‍‌‍‍​‍​‍​‌​‌‍‌‌‌‍‌‌‍‍‌​​‌​‌​‍‍‍‍‌⁪Download Previous Exports...⁪⁪",
                "DO_YOU_WISH_TO_DELETE": "⁪⁪⁪‌‌​​​‍​‍​‌‍​‌‍‌​​​‌‍‌‍‍​‌‍‌‌​​​‌‍‌​‍​​‍​‍⁪Do you wish to delete:⁪⁪",
                "DUPLICATE_PAGE": "⁪⁪⁪‌‍​‍‌‍‍​​‍​‍​​​‌‌‍‍​‌‌‌‍‍‍‌‍‌‌​‍​‌​‌‍​‍‍⁪Duplicate Sheet⁪⁪",
                "EDIT_REPORT": "⁪⁪⁪‌​​​‌‌‌‍‍​‍‌​‌‌‌​‌​‍‍​‌​​‍​‍​​​‍​​‍‌‌‌​‌​⁪Edit Report⁪⁪",
                "EDIT_REPORT_ELLIPSIS": "⁪⁪⁪‌‌‌​‌​​​‌‍‌​‍‌​‍​‍‌‌‍‌‌‌‌‌‍‌‍​‌‌‍​‍​‌​​⁪Edit Report...⁪⁪",
                "EDIT_VISUALIZATION": "⁪⁪⁪‌‍‌‍‌‍​‌‌​​​‌‍‌​‌‌‍‌‍‍‍‌‌​‍​‌​‍‍​​‌‍‌​‍⁪Edit Visualization⁪⁪",
                "EMAIL_ADDRESS": "⁪⁪⁪‌‌​‌‍​‍‌‌‌‍‍‍‍​‌​‍‍​‌‍‌‌‌‍​‌‍‍‌​​‌‌‌‍‍​‍‌⁪Email Address⁪⁪",
                "EMAIL_SENT": "⁪⁪⁪‌​​​‌‌‍‌‍​‍‍​‍​​‌​‍​‌​‌​​‌‍‌‌​​​‌‌‌‌‍‍‌‍‌⁪Email sent...⁪⁪",
                "END_OF_REPORT": "⁪⁪⁪‍‌‍​​​‌‌‍​‍‍‍‍‍‍​​‌‌‌​​‍​​‌‌‍​​​‌‍‌​‍‌‍​⁪End of Report⁪⁪",
                "ENTER_NAME": "⁪⁪⁪‌‍​‍​‍‍​‍‍​‌‍‌‌​‍​‍‍‍‍‍‍​‌‍‍‍‍‍‌​​‍‍‌​‌​⁪Enter Name⁪⁪",
                "ERROR_COPYING": "⁪⁪⁪‌‌‌‌‍​‍​​‍​​‍‌‍‍​‍​‌​‌‌‌​​‌‌‍‌​‌‍‍‍‍‍​‌‌‌⁪There was an error copying the report.⁪⁪",
                "ERROR_DELETING": "⁪⁪⁪‌​‍​‍‌‌‍​‍‍​‍‍​‍‌​‌‍‌‍‌‍‌‌​​‌‍‌‌‌‍‌​‌‌⁪There was an error deleting the report.⁪⁪",
                "ERROR_DELETING_EXPORT": "⁪⁪⁪‌‍‍‌‌​‍‌​​‍‍‍​​​‍‌‌​‌​‍‌‌​‌‍​‍‌‍‌​‍​‍‍‍​⁪There was an error deleting the export.⁪⁪",
                "ERROR_HEADING": "⁪⁪⁪‍‌​​‍​‍‌‌‍‌‌‍‌​​‌​​‌‌‍‌‍​‍​​​​‍​‍​​‌‍‍‍‌⁪Error⁪⁪",
                "ERROR_PUBLISHING": "⁪⁪⁪‍‌‌‌‌‌​​‍‍​​‌‌‍‍‌​‍​​‌​‌‍​​‌​‍​​‍‍‌​​‍​​⁪There was an error saving the settings.⁪⁪",
                "ERROR_RENAMING": "⁪⁪⁪‍‍​‍‌‍​‌‌‍​​‌‌​‌​‍‌‍‌‍‌‌​‍‌‌​‍‌​‌​‌‌‌‍‍‌⁪There was an error renaming the report.⁪⁪",
                "ERROR_REQUESTING_EXPORT": "⁪⁪⁪‍​‍‌​‍‌‌‌‍‌‍‍‍‍‍‍‍​‌‌‍​‌‍​‍​‌​‌‍​‌‌​‌‌‌‌⁪There was an error requesting the export.⁪⁪",
                "ERROR_SAVING_GLOBAL_OPTIONS": "⁪⁪⁪‌‌​‌‍​‌‌​‍‍​‌​‍​‍‌‌‌‍‍​​‌‌‍​‍‍​‍‌​‌​​​‌​‍⁪There was an error saving global visualization options.⁪⁪",
                "ERROR_SEND_TEST_EMAIL": "⁪⁪⁪‌‌​​​‍‌‍‌‌​‌‌​‌​‍​‌‍‌​‌​​‌‌‍‌‍‌‌‌‌​‍​​​‍​⁪There was an error sending the test email.⁪⁪",
                "EVERY_FRIDAY": "⁪⁪⁪‍​‌‍​​‌‍‌‌​‍​‍‍​‌​​​‍‍‌‌‍​‍‌‌​‌​‍‌‍‌‌‍‌‌⁪Every Friday⁪⁪",
                "EVERY_MONDAY": "⁪⁪⁪‌‌​‍​‍​​‍‌‌​​​​​​​‍​‌​‌‍​‌‌​‌‍‌‌​​‌‌​‌‍‌‌⁪Every Monday⁪⁪",
                "EVERY_MONTH": "⁪⁪⁪‌​‌​​‌‌​​‍‍‍​‍​‍‌‍‌‍‍‌‍‍‌​‍​‍‌​​‌​‌‌‍‌​‍‌⁪Monthly on⁪⁪",
                "EVERY_SATURDAY": "⁪⁪⁪‌‌​​​​‌‌‌‌‍‌‌‌‌‌‌​‌​‌‍‍​‌​​‌​‍‌​​‍‌​‍‌‌‌‌⁪Every Saturday⁪⁪",
                "EVERY_SUNDAY": "⁪⁪⁪‌​‍‍‌‌‌‌‍​‌​​​‌‌​​​‍‍​‌‌‍‌‌‌​‌​‍‍‌‌‍‍​‍‌​⁪Every Sunday⁪⁪",
                "EVERY_THURSDAY": "⁪⁪⁪‌‌​‍‍​‌‍​​‍​​‌‌​​‌​​‍​‍‌​‌​‍​‌‌​​​‌‍​‌‍​​⁪Every Thursday⁪⁪",
                "EVERY_TUESDAY": "⁪⁪⁪‌​​‌‍‌‌​‌‍‌‌‍‌‍​‍‍‍​​‍‌​‍‍‍‍​‌‌‍​‍‌​‍‍‍⁪Every Tuesday⁪⁪",
                "EVERY_WEDNESDAY": "⁪⁪⁪‌‌​‍‌‍‍‍​‍‌‍‌‌​​‍‌‍‌​​​‌‌‌‌‌‌‍​‍‍‍​​‍​​‌​⁪Every Wednesday⁪⁪",
                "EVERY_WEEK": "⁪⁪⁪‌‌​​‍​‌​‌​​​​‌‌‌‍​‍‌‍‌‌‌​‍‌‌‌‌‍‍‌​​​​‍‌‌​⁪Weekly every⁪⁪",
                "EXAMPLE_GROUP_NUM": "⁪⁪⁪‌‍​‍​‌​‌‍‌‌​‍‍‌‌​​‌​​‌​‌‍‍‌​​​‍‌‌‌‍​‌​‍‍⁪Group ​​​{{num}}‌‌‌⁪⁪",
                "EXAMPLE_SERIES_NUM": "⁪⁪⁪‌​‍​‌‌‌‌​​‌​‌‍​​​​‍​​​‍‌‌​​​‌‍‌​​‍​​‍‍‍‍⁪Series ​​​{{num}}‌‌‌⁪⁪",
                "EXPORT": "⁪⁪⁪‍‍‌‍​‍​‌‍​‍​‍​‌‌​‌‍​​​‍‍‌‌​‍​‌‍‍‍‍‌‌​​​‌⁪Export⁪⁪",
                "EXPORT_CSV": "⁪⁪⁪‌​‌​‌​‍​‌‌​​​​‌‌​‌‌‍​‍​​‍‍​​​‌​​‌‍‌​‌‍​⁪CSV (Comma Separated)⁪⁪",
                "EXPORT_EXCEL_SPREADSHEET": "⁪⁪⁪‌‌​‍‍‍‌‌‌​​​‌​‌‍‍‍​‌‍‌‌‍‍‍‍‌​​‍‌​​‍‍​‌​‍‍⁪Excel Spreadsheet⁪⁪",
                "EXPORT_IMAGE": "⁪⁪⁪‌​‌​‌‍‍‍‌​​​‍‍​​‌‍‌​‌​​‌‍‌‍​‌‍​‍‌​​‌‍‍‌​⁪Export Image⁪⁪",
                "EXPORT_PAGES": "⁪⁪⁪‍‌‍‍‌‌‌‌‌‍​‍​‍​‍‍​‌​​‍​‍‌​​​‌​​​‍‌‌‍​​‍​⁪Export Pages⁪⁪",
                "EXPORT_PDF": "⁪⁪⁪‌​‌‌​‌​​‌​​​‌‍‌‍‌‌‌‍‌‍‌‍‍‍‍‌​‍‌​‌‌​‌​‍‍‍‌⁪PDF Document⁪⁪",
                "EXPORT_PPT_SLIDES": "⁪⁪⁪‌‌​​​​​‍‍‌‌‍​​‍​‍‌‍‍‌‍‍​‍‌‌‌‌‍‍​‍​‌​​​‌​‍⁪PowerPoint Slides⁪⁪",
                "EXPORT_RAW_DATA": "⁪⁪⁪‌‌​‍‍‍‍‌‌​‍‍‌‌‍‌‌​‍‌​‍‍‍‌‌‌‍​‌‌​‍​‌‌​‍‌‌‌⁪Export Raw Data⁪⁪",
                "EXPORT_REPORT": "⁪⁪⁪‌‌‍‍‍‍‍​​‍‌‌‍‌​​​​​​‍‌‍​‍‍‍​‌‍‌‌‍‍‌​‍‍‍​⁪Export Report⁪⁪",
                "EXPORT_VISUALIZATION": "⁪⁪⁪‌‌‌​‍​​​​​‍‍‌​‍​‌‌‌‍‍​​‌‍‍‍‍​‌‍‍‌‍​‌‍‌‌‍⁪Export Visualization⁪⁪",
                "EXPORT_WORD_DOC": "⁪⁪⁪‌​‍​‍​‍‍​‌‍‍​‌‌‌​‍​​‌‍‌‍​​‌​​‍‌‍‌​​​‍​‌‍‌⁪Word Document⁪⁪",
                "FAILED_SAVE_TXT": "⁪⁪⁪‌​​‌‌​‌‌‌​​​‌​‍​‍‌‌‌​‌‌‌‍‌​​​‍​​‍‍​‌‍​​‌‍⁪Failed to save⁪⁪",
                "FILTERED": "⁪⁪⁪‍​​​‌​‍‌​‍‌‍‍‍​‌‍​​‌‍‌‍‍‍​‍​​​‌​‍​‍‌‌‌‍​⁪Filtered⁪⁪",
                "FIRST_PAGE": "⁪⁪⁪‌​​‍​​​​‌​‍‌‌‌‌​‌​​‍​‍‌​‌​‍‍​‍‌​‌​​‍‌‌‍‍⁪First Page⁪⁪",
                "FIRST_WEEKDAY": "⁪⁪⁪‌​‍‍​‍‌​​‍‍​‌‍​‌​‌‍‌‍‍‌‍‌​​‌‍‌‍‌‍‌​‌​‍‍‍‍⁪First Weekday of Month⁪⁪",
                "FROM": "⁪⁪⁪‌‍​‌​​‌‌​​‍​​‌‍‍​​‌‍‌‍‌‍‌‌‌‍‌‍​‍​‌‍‍‌‍​⁪From⁪⁪",
                "FROM_EMAIL": "⁪⁪⁪‌​‍‍‍‌‍‍‌‌​‍‌‍‍‍​​​​‌‌‌​‍​‍‍‍​​‌‌‌‌‍‌‌‌‌‌⁪From Email⁪⁪",
                "FROM_NAME": "⁪⁪⁪‌‌‌‍‌‌‍​‍‌‌‍​​​‌​​‍‌‍​​​​‌​‍‌​​‍‍​‌‍​‍‍‌⁪From Name⁪⁪",
                "GAUGE_CHART": "⁪⁪⁪‍‌‌‍​‌‌‍​​‍‌‌‌‌‌‍‍‌‍‌‍​‍​​​​​‌‍‍​‌​​​‍‍⁪Gauge Chart⁪⁪",
                "GAUGE_CHART_DESC": "⁪⁪⁪‍‍‌​‍‍​‌‍‌​‍‌‌​‌​‍‍‌​‍‍‌‍‍‌‍‍​‌‌‌‌‍​​‌​‌⁪A chart resembling a gauge measurement tool for comparing current values to a goal or series of thresholds.⁪⁪",
                "GENERATING_FILE": "⁪⁪⁪‌​‌‍‍‍​‍‌‌‍‌​‍‌‌‍‍​​‌‌​​‍‌​‌‍‌‍‍‍‌​​​‌⁪Generating file...⁪⁪",
                "GENERATING_IMAGE": "⁪⁪⁪‍​‌‍​​‍‍​​​‍‌​‌‍‌‍‌‍​‍​‌‌‌‌‍‌‌‍‍‍‌‌‍‍​‍​⁪Generating Image...⁪⁪",
                "GENERATING_PDF": "⁪⁪⁪‌‌​‍​‍‌‍​‌‍‍‌‍​‌‍‍​‍​‌​‌​​​​‌‌​​‍‌‍‍‌​⁪Generating PDF...⁪⁪",
                "GENERIC_ERROR": "⁪⁪⁪‍‍‍​‌‍​‌‍​‍‌​‌​​‍‍‌‍‌‌​‍‍‍‌‍‍‍​‍‍‌‌‌⁪An error prevented us from loading the project you requested.⁪⁪",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "⁪⁪⁪‌‌​​‍‍​‌‍​​‍‍‍‌‌​​‍‍‍‍​​​‌‍‌‌​​‌‌‌‌‍​‌​​​⁪Global Options...⁪⁪",
                "GLOBAL_METRIC": "⁪⁪⁪‌‌​‍‌​​‍‌‌‌​​‌‌​‍‍​‌‌‌‍​‍‌‌​‍‌‍​​‍‌‍​​‍​‍⁪Default Metric⁪⁪",
                "GLOBAL_MODAL_PAGE_TITLE": "⁪⁪⁪‌​​​​‌​‍‌‍​‍‌‍​‌‌​‌‌‌‌​‍‌​​​‌‌‌​‍​‌​​‍‍‌​⁪Example visualization using the global options for the Results section of the Qualtrics Research Suite⁪⁪",
                "GLOBAL_MODAL_WIDGET_TITLE": "⁪⁪⁪‌‍​‌​​​​​‌‌​​‍‍‍​​​​‌​‍‌​‌​‌​‌‍​​‌‍‍‌‍‍‍⁪Visualization Title⁪⁪",
                "GLOBAL_OPTIONS": "⁪⁪⁪‌​​‍‌‌​‍‌​‍​‍​‌‌​‌​‌‌‍​‌‌‌‍​‌‍​​​‍‌‌‍‍​‌⁪Global Options⁪⁪",
                "GLOBAL_PRECISION": "⁪⁪⁪‌‌‌​‌‍‍​‍‌​‍‌‌‌‌‌​‍​‌​​‍‍‍‌​‍‌‍‌‌‌‌‌​‌​‍‌⁪Default Decimal Places⁪⁪",
                "GLOBAL_SETTINGS_APPLY": "⁪⁪⁪‌​‌‍‌‌​​​‌‍‍‌‍​​‌‍​‌​‍‍‌‍‍‍‌​​‌‍​​​‍‍‍‌​​⁪Apply my default settings⁪⁪",
                "GLOBAL_SETTINGS_SAVE": "⁪⁪⁪‌‍‍​‍‌‍‌‍‍‌​​‍‌‍​‍​‌‌​‌‌‍‍‍​‌‌‍‌‍‍‍​‍‌​‍⁪Save as my default settings⁪⁪",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "⁪⁪⁪‌‌​​​​​​‍‍‌‍​‌​‌‌‍​‌‍‍​​‍​‍‌‍​‍​​‌‌‌‌‍‌⁪Apply Qualtrics default⁪⁪",
                "GROUP": "⁪⁪⁪‍‌​​‌‍​‌‌‍‍‍‍​‍​‍‌​‌‌‌‍​​‌‌‌‍‌​​​​​‌​‍‌‍⁪Group⁪⁪",
                "HEAT_MAP_CHART": "⁪⁪⁪‌​‍‍‍‌‌​‍‌‍‌​‍‍‍​​​‌​‍‌‌‌‍​‌‍‌‌‌‍‍‌‍​‍​‌‍⁪Heat Map Chart⁪⁪",
                "HEAT_MAP_CHART_DESC": "⁪⁪⁪‌‌​‍​‍‌‍​​‌‍​‌​‌‍‍‌​‌‍‌‌‍‍​​‌​‌​‍‍‌‌​‌​​​⁪A clustered “heat” style visualization used for mapping distribution of user input (such as clicks) to the original image.⁪⁪",
                "HIDDEN": "⁪⁪⁪‌​‍​​‍‌‍​‍‍‍‍​‍‌​‍‌​​‌‍‌‍‌‍​‍‌​​​‍​​‌‌‍​⁪Hidden⁪⁪",
                "HIDDEN_PAGE": "⁪⁪⁪‌​‌‌‍‌‌​‍‍‍‌‌​‌​‍‌‌​‌‌‌​‍‍‍‍‍‍‌​‍‌‍​‍‍​‍‍⁪This page will not appear in public reports and will be deselected by default in report exports.⁪⁪",
                "HIDE": "⁪⁪⁪‌‌‌‌‌​‍‍‍‌​‍​‍​​‍‍​‍‍​‍​‌​​​‍‌​​‍‌​‍​​‍​‍⁪Hide⁪⁪",
                "HIDE_ALL_PAGES": "⁪⁪⁪‍‍‍​‍​​‍‌​‍‌‍‌‍​‌‍​​​‍‌‌​​​‌‌‌​‌‌‌‍​‌‌‍​⁪Hide All Pages⁪⁪",
                "HIDE_PAGE": "⁪⁪⁪‌​‌‌‌‌‍​‌​‌‌​​‍‍‌‌‌​‌​‌‍‌​​‍‌‍‌​‍‍‌​‍‍‌​​⁪Hide Page⁪⁪",
                "IMAGE_FILE": "⁪⁪⁪‌​‍‌​‌‌‍‍​‍‌​‌​‌​​‍‌‍‍‌‍‍‍‍‌​‌‌‌‌‌‍‍​‌​‌⁪Image File⁪⁪",
                "INVALID_BRAND_DOMAIN": "⁪⁪⁪‌​‍‍‍​‌‍​‌​‌​‌​‍​‍​‍​‌‌​‌‌​‍​‍​​​‍‌‍‌‌‌‌⁪The domain you have entered is not in your brands list of approved email domains. Please contact your brand admin to fix.⁪⁪",
                "INVALID_SPF_RECORD": "⁪⁪⁪‍‍‍​‍‍‍‌​‍‍‌‌​​‌‌​‌​‍​‍​​​‌‌‌​‌‌‍‍​‌​​​​⁪The domain you have entered has not approved Qualtrics to send from it. This will affect deliverability. Please use another domain or contact Qualtrics about resolving this issue.⁪⁪",
                "ISSUE_SAVING_REPORTS": "⁪⁪⁪‌‌​‌​​​‌‍​‌​‍‌‌‍‌​‍‌​​​‌‌​​‌‍‍‌‌‍​‍‍‌​‍​​⁪One or more reports encountered a problem saving. Please try again.⁪⁪",
                "ISSUE_SENDING_TEST": "⁪⁪⁪‌‍‍​‌‌​‌‌​​‍‌​‌​​‍​​​‌‍‍​​​​‍‍‌‍‌‌​‌​‍‍​⁪There was an error sending a test email. Please try again.⁪⁪",
                "LARGE_SURVEY": "⁪⁪⁪‍‍​‌​​‍​‌​​​​‍‍‍‍‌‍‍‍‌​​‌​​​‍​​​‍‌‌‍‌‌‌​⁪Results will not be displayed because the survey is too large.⁪⁪",
                "LAST_DAY": "⁪⁪⁪‌​‍‌‍‍‌‍‍​‌‌‌‌‍‍‌‌‍‍‌‍​​‌‍​‌​​‌‌​‍‌​​‌​​‌⁪Last Day of Month⁪⁪",
                "LAST_MODIFIED_COLON_WITH_DATE": "⁪⁪⁪‌​‌​‍‌‌​‌‍‍‌‍‌‍‍​‍​‍​‍‍​‌‌‍​​‌‍‍​‌​‍​‌​‌​⁪Last Modified: %1⁪⁪",
                "LAST_PAGE": "⁪⁪⁪‌​‍‌‌‌‍‍‌‌​‍‍‍​‍‌​​​‍‌‌​‍​‍‍​‌‌‍​​‌‌‌‍‍​‍⁪Last Page⁪⁪",
                "LAST_WEEKDAY": "⁪⁪⁪‌​‌‍‍​‍‍​‍‌‍​‍‌‌​​​‌‍​​‌‍​‌‌​‍‍‍​‍‌‌‍‌​​‌⁪Last Weekday of Month⁪⁪",
                "LATER": "⁪⁪⁪‌​​‌‌‍‍​‍‌​​‌‍​​​‍‌​‌​​​‌‌‍‌​​‍‍​‍‌‌‌‌​‍‌⁪Later⁪⁪",
                "LEARN_MORE": "⁪⁪⁪‌‌​​‍‌‌‍‍​​‍​‍‍​‍​‌‍‍‌​​​​‍‍​​‌‌‍‍‍‍​‌‌‌​⁪Learn More⁪⁪",
                "LINE_CHART": "⁪⁪⁪‍‌​‌​​​​‍‍‍​​​‌‌‌​‌‍​‍​‌​‍‍​​‍​​​‌​​‍‍⁪Line Chart⁪⁪",
                "LINE_CHART_DESC": "⁪⁪⁪‌​‍‍​‍‍‌‍‍‍​​​​​‍​‌‍‌‌​​​​‍‍‌‍​​‍‌‍​​​‌‍‍⁪A two-axis line chart commonly used when graphing against time on the x-axis.⁪⁪",
                "LOG_OUT_WARNING": "⁪⁪⁪‍‍​‌​​‍‌‌​‍‍‍​‍‍‍‍‍​‍​​‍‍‍‌‌​​​‍​‍‍‍​‌‌⁪Click anywhere within ​​​{{countdown}}‌‌‌ seconds to remain logged in⁪⁪",
                "MESSAGE": "⁪⁪⁪‍‌​‌‍​​‍​​​‍‍‌‌‌‍‍​​‌​‌‍​​​​‌‍‌‍‌​‍‌‌​‍​⁪Message⁪⁪",
                "MONTHLY": "⁪⁪⁪‍​‌​‍‍‌​​‌‌‍​‍​​‍‍‍‌‌‍​‌‌​‌​‌‍‍​‍‍​‍​​‍⁪Monthly⁪⁪",
                "MOVE_DOWN": "⁪⁪⁪‌‌​​‌‌​​‍​​​​‍‍‍‌‌‍​​​​‌‍‌‌‍‍‍‍​​‍‍‍‍‍‍⁪Move Visualization Down⁪⁪",
                "MOVE_PAGE_TO_BOTTOM": "⁪⁪⁪‌​‌​‍​​‍‍‍​‌​‌​​​‍‌‌‍​‍‌​‍‍‌​​‍‍‍‍‍​​​‌‍‍⁪Move to Bottom⁪⁪",
                "MOVE_PAGE_TO_TOP": "⁪⁪⁪‌​‍​‌​​‌​‍​​‌‍‍​‌‌‍​‌​‌‌​​‌‌‍‍‌‌‌‍‌‍‍‌​​​⁪Move to Top⁪⁪",
                "MOVE_UP": "⁪⁪⁪‍‌‌​‍‍‌‌‌‌‍‍​‌‍‍‍‍‍‍‍‌‌‌‌‍‍​‍‌‍‌‌‌‍‍‍​‍​⁪Move Visualization Up⁪⁪",
                "MY_SURVEYS": "⁪⁪⁪‍​‌‍​‌‍​‍‌‌​‌​​‍‌‍​‌‍‌‍​​​​‍​‍​​‌‌‍‌​​‌‌⁪My Projects⁪⁪",
                "NAME": "⁪⁪⁪‌‍‌​‌​‍​‌​‍‍‍‍‌​​‌‌​‌‍‌​‌‍​​‍‍‌‌​‍​‍‌​‌‌⁪Name⁪⁪",
                "NEW_CUSTOM_PAGE_NAME": "⁪⁪⁪‌‌‌​‌​‍​‌‌‌‍‍‌‍​​‌‍‍‍​​​‍‍‍‌‌‍​‍​​‌​‌‍​‍‍⁪New Custom Page⁪⁪",
                "NEW_REPORT": "⁪⁪⁪‍​‌‍​‌​‍​​‌​​​‍‌‍​​‌​‌‌‌‍‌‌‍‍‍​‍‍‍‌​​‍‍⁪New Report⁪⁪",
                "NEXT_PAGE": "⁪⁪⁪‌‍​‌‌​‌​‍‍​​​​‌‍​‍‌‍‌‍​‌​‌‌‌‍‌​‌‌‍‍​‍​​​⁪Next Page⁪⁪",
                "NEXT_RUN": "⁪⁪⁪‍​‍‍‌‌​​​‌‍​​‍​‍‍‌‍‌​‌​‍‌​​‌‍‌​​​‌‌‍‍‍‌‌⁪Next Run⁪⁪",
                "NO_EXPORTS": "⁪⁪⁪‌​‍​​‍‌‍​​‍‌​​​​‌‌​‍​‍​‌‌​‌‌‌​‌‌‌​​‌​‍​​‍⁪No exports have been requested for this report yet.⁪⁪",
                "NO_ITEMS_TO_DISPLAY": "⁪⁪⁪‌​‌‌‍‌​​‌‌​‍‌‌‍‍​‌‍‌​‍‌‍​‍‌​‍​‌‌‍‌​‍‍​​​‌⁪No items to display⁪⁪",
                "NO_MATCHING_CUSTOM_PAGES": "⁪⁪⁪‌​‌‍‍‍​​‌​‌‌‌​‍​‍​‌​‌‍‍​​‌‍‍‌‍​​‍‌‍‌​‍​​‌⁪No matching custom pages⁪⁪",
                "NO_MATCHING_PAGES": "⁪⁪⁪‌​‌​‍‌‌​‍‌​‌‍​‌‍‌​​‌‌‌‍‍​‌​​​‍‌​​‍‌​‌‍‍‌‌⁪No pages found for search⁪⁪",
                "NO_MATCHING_REPORTS": "⁪⁪⁪‍​‌​‍‍‍‌​​‌‌‍‍‍​‌‍‍‍​‍‍​‍​‌‌‍‍​​‌​‌‍‍​‍‍⁪No matching reports.⁪⁪",
                "NO_PROJECT": "⁪⁪⁪‍‍‍‌‌‍‌​​‌​​‌‍‌‌​‌‌‌‍​​​‍​​‍‌‌‍​​‍​​‍‌​​⁪Please specify a project to continue.⁪⁪",
                "NO_PROJECTS_TO_MIGRATE": "⁪⁪⁪‌​‍‍​‌‌‌‍‍‍‍‍‍‌‌‍‌​‍​‍‍‌​​​‍​‍​‌‌​​‌‌‌​​‌⁪There are no projects to update.⁪⁪",
                "NO_QUESTIONS": "⁪⁪⁪‌​‌​‌‌​​‍‍‍‍‍‍‌‌​​‍‍‍‌‍​‍‍​‍‍‌​​‍​‌‌‍​‍​​⁪No matching questions⁪⁪",
                "NO_RESULTS_YET": "⁪⁪⁪‌​‌‍‌‌‌‌‌​‌‌​‍​‍​‍​‌‍‍​‌​‌‌‍‍‌​​​‌​‌‍‍‌​‍⁪There are no results yet to show. Please distribute your survey to gather responses.⁪⁪",
                "OFF": "⁪⁪⁪‌‌​​‍‌​​‌​‌‍‍‌‍‍‌‍‌‌‍​‌‌‍‍‍​‍‌‍​​‍‌​​‌‌‍‌⁪Off⁪⁪",
                "ON": "⁪⁪⁪‌​‌​‍‍‍‌‌​​‍​‍‍‌‌​‍​​​​​‌‍‍​‌​‌‍​‍​‍‍‌​‍‍⁪On⁪⁪",
                "PAGES_SELECTED": "⁪⁪⁪‌​‌‍‌‌‌‍‌​‌‍‌‌‍‌​‍‍​‌‌‍‍‍‌‍‍‌​‌​​​‌​​‍​‌‍⁪Pages Selected⁪⁪",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "⁪⁪⁪‌​‍‌‌​‍‌​‌​‍‌​​‌​​‍‌​‌​‍‌‍‍‌‌‌‍​​​​​‍‍‍‌‍⁪This selection would make the report contain ​​​{{currentSelectedPageCount}}‌‌‌ pages, which is above the ​​​{{reportSizeLimit}}‌‌‌ maximum allowed. Please select a smaller range.⁪⁪",
                "PAGES_SELECTION_INVALID_RANGE": "⁪⁪⁪‍​​‍​‍‍​‍‌‌‍‍‍‌‍‌‌​​‌​​​‌‌‌​‍‌‌‌‌​‍​‍‌‌‌⁪Please select a valid range.⁪⁪",
                "PAGE_OPTIONS": "⁪⁪⁪‍‍‌‍‍‍‌‌‌‌​‍‍‌‌​​‌‌‍‌‌‍‌‌​‌​​​​‍‌‌​​​​​‌⁪Page Options⁪⁪",
                "PDF_ROW_TRUNCATION_MESSAGE": "⁪⁪⁪‍‌‍​‌​‍‍‍‌‍‌‌‌‌‌‌​​‌‍‍‌‌‌‍‌​‌​‌‍‌​​‍​​​‌⁪Too many rows for PDF export, try exporting to Word or CSV⁪⁪",
                "PERCENTAGE_METRIC": "⁪⁪⁪‌​​‍​‌‍​​‍​‍​‍‌‌​‌‍​‍‍‍‍‌‌​​‌‌​​‌‍​‍‌‍‌‌‍⁪Percentage⁪⁪",
                "PIE_CHART": "⁪⁪⁪‌‌​‌​​‌‍‍​​‌‍‌‌‌‌‍‌‍‌‌‍‌‌‍​​​‌​​‍‍‍​‌‍​​⁪Pie Chart⁪⁪",
                "PIE_CHART_DESC": "⁪⁪⁪‌​​‌​‌‌‍​‍​​​‍‍‍‍​‍‌‍‍‌‍​‌‍‍​‌​‍‍​‍‌‍‍‌‌​⁪A circular breakdown of values for a given data point. Useful for measuring relative proportions of selected values.⁪⁪",
                "PREVIEW": "⁪⁪⁪‌​‌‌‌​‌‍​‍‍​‍‌‍​​​​​‍‍‌​​‍​​‍‌‍​‍‌‌‍​​‍‌​⁪Preview⁪⁪",
                "PREVIOUS_PAGE": "⁪⁪⁪‌‌​‌​‌‍‌‌‍​‌‌‍‌‌‍‍​‌‍‌​​‍‍‍‌​‍‍‌‌‍​‍​‍​‌‌⁪Previous Page⁪⁪",
                "PRINT_PAGE": "⁪⁪⁪‌​​‍​‌‍​‌​​‍‌​‌​‍‍‌‍​‌​‌‍‌‍​‍​​‌‌​‍​​​‍‌‌⁪Print Page⁪⁪",
                "PUBLIC_LINK": "⁪⁪⁪‍​‌‌​‌‍​‍‌​​​‍‌​‌‌‌‌‍‌‌‍‌‌​‍​‌​‌‍‍‍​​‌​⁪Public Link⁪⁪",
                "PUBLIC_REPORT_AVAILABLE": "⁪⁪⁪‌​​‌‍‍‍‍‍‌‍‍‍​​‌‌​​‍‌‍‌​‌‍​‌‍​‌‍​‌‍‌‍‌‌​‌⁪Public Report Available⁪⁪",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "⁪⁪⁪‌‌‌‌‍‌‍​‍‍​​​‌​‌‍‍‌​​‍​‌‍‍‍​‍‌‍‍‌​​​‍‌​‍‍⁪Access Code⁪⁪",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "⁪⁪⁪‍‍‌‌‌‌​‌‌‌‌‌​​‍​​​​​‌​​‌‍‍‌​​‌‌‍‍‌‌​‍​‌​⁪Incorrect Access Code. Please try again.⁪⁪",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "⁪⁪⁪‌‌‌​‍‌‍‍‌​‍‍‍‍‍‍​​‌​​​‍‌‍‌​‍‌‍‌​​‌‌​‍​​⁪Submit⁪⁪",
                "PUBLIC_RESULTS_LOGIN_TITLE": "⁪⁪⁪‌‍‍​‍‍​‍​​‍‌​‌​‌​​‌‍‍‌‌‌‌‌​​​‍​​‍​​‍​‍‍​⁪Public Report Login | Qualtrics Survey Software⁪⁪",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "⁪⁪⁪‌‌​​​​‍​‌‍‍​‍​‌‌‌‌‌​‌​‌​‍‌‍​‍‌‍‍‍‍‌‍‍‌‌‍​⁪Public report not found. Please contact the owner of this report and ask them for a valid link.⁪⁪",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "⁪⁪⁪‍‌​‍‌​‍‍​​‍‌‌‌‍‌‌‍‍‌‍‌‌‍‌‍‍‌‌​‍‌‍‌​‌‌​‌‍⁪Public Report Not Found⁪⁪",
                "PUBLIC_RESULTS_NOT_UPDATED": "⁪⁪⁪‌‌​‍‍‌​​‍​‌‍‌‍​‍‌​​‌‍‌‍‍‌‍‍​‍​​​‍‌‍‍​‌​​‍⁪Public report links and scheduled report emails will not use the Qualtrics XM Platform until you update them.⁪⁪",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "⁪⁪⁪‌​‌​​​​​‍‍‍‍​​‍‍‌​‍‍‌​​​‌​​​‍‌‍‍​​‍‌‍​​⁪Session Expired. Please log in again to continue previewing Public Results Report.⁪⁪",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "⁪⁪⁪‍‌​​​‍‌​‍​‌‍​‍‌‍​​​‌‌‍‌‌‍​​‍​​‍​‍​​​‍‍‍‍⁪Session Expired⁪⁪",
                "PUBLIC_RESULTS_TITLE": "⁪⁪⁪‌‌‌​‍‌‌​‍‌‍‍​‌‌‍​‌‌‍​‍​‍​‌‌‌​‍‌​​‍‌‍‌​‍‍​⁪Public Report⁪⁪",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "⁪⁪⁪‌​​‌‍‍‍‍‌‍‌​‍​​​‌‌‌‍‌‍​​‍‍​‍​‍​​‌‌​‌‍​‍‌​⁪You are not authorized to view this page. Please contact the owner of this report and ask them to make it public.⁪⁪",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "⁪⁪⁪‍​‌‍‌‌‍‍‌‌‍‌​‌‍‍‌​‌‌‍​‍​‍​‍​​‍​‌‍​‍​‌​‌‍⁪Public Report Unauthorized⁪⁪",
                "PUBLISHED_LINK_GENERATING_LINK": "⁪⁪⁪‍​​‌​‍​‍‌​‌‍‌​‌‌​‍​‍‌‌‍​‌‌‌‍​​‍‍‌​​​​‍‍‌⁪Generating Link...⁪⁪",
                "PUBLISHED_REPORT_FOUND_HERE": "⁪⁪⁪‌​​​‍‍​​‌​‌‍​‍‍‍​‌​‌‍‌‍​‌‌‌‌​‌‍‍‍‍‍‍​‍‍​‌⁪Anyone can view this report at the following link:⁪⁪",
                "PUBLISH_REPORT": "⁪⁪⁪‍​​‌‌‌‌​‌‍‍‌‍‌​‌‍‌‌‍‌‍‍​‌‌‍‍​‌‍‌​‍‍​​​​‍⁪Manage Public Report⁪⁪",
                "PUBLISH_REPORT_ELLIPSIS": "⁪⁪⁪‍​‍​‌‍‌‍​‌​‌‌‍‍​​‌‌​​‍​‌‌​‌‍‍​‌‍​‍‍​‌​​​⁪Manage Public Report...⁪⁪",
                "QUESTION": "⁪⁪⁪‌‌​​‍‌‌‌‌​‍‌‍​‌‍​‍‌‌‌‍‍‌‌‌‍‍​​​‌‍‍‍‌‍‌‍​‌⁪Question⁪⁪",
                "RANK": "⁪⁪⁪‍​‍​‌‍‍​‍‌‌​‍​​‍‌‌​‍​​‍​‍‍‌‌‌‌‌​‌​‌‌‍​‍⁪Rank⁪⁪",
                "REMOVE_WIDGET": "⁪⁪⁪‌​‍‍​​‌‍​‍​​‍‍‍‍​‍‌​​​‌​‌‌​‍​‌‍​‌‍​‌‌‍‍​​⁪Remove Visualization⁪⁪",
                "RENAME_PAGE": "⁪⁪⁪‌​​‌‌‌‍‍​‌​​‍​‍‌​‌‍‌​‌‍‍‌​​‍​‌‌‍‌‍​‌⁪Rename Page⁪⁪",
                "RENAME_REPORT": "⁪⁪⁪‍​‍‍‌​‌​‍​‌‌‍‍‌‍‍​​‍‍​‍‌‌​​‌​​‍​‌‍‌‌‌‍‌‌⁪Rename Report⁪⁪",
                "RENAME_REPORT_ELLIPSIS": "⁪⁪⁪‌‌​‍‌‍​​‌‌‍​‍​​‍‍​‍‍​‍‍‍‍‍​‌‍​​‍​‍‍‍‌‍‌​‍⁪Rename Report...⁪⁪",
                "REPLY_TO_EMAIL": "⁪⁪⁪‌​‍​‍‌​​‌‌​​‌‌‌‌‌‍‍‍‌‌‌‍​​‍‍‍‍​‌‌‌‌​​‌​​⁪Reply-To Email⁪⁪",
                "REPORT_COLON": "⁪⁪⁪‌‌‌‍‍‍‍​‌‌​​‍‍‍​​​‍‍‍​‌‌​​‍​‌​‍​‍​‌‍‍​​⁪Report:⁪⁪",
                "REPORT_SETTINGS": "⁪⁪⁪‌‍​‌‍​‍‍​‌​​‌‌‍‍‍​‌‍​‌‌​​​‍‌​‍‌‌‍‌‌​​​‍‍⁪Report Settings⁪⁪",
                "REPORT_SETTINGS_ELLIPSIS": "⁪⁪⁪‍​‍‍​​‍‌‍‍‌‍‌‌​‌‍‍​​‌‍‍​‍‍‍​‍‍​‌​‍‍​‌‌⁪Report Settings...⁪⁪",
                "RESPONSE_COUNTS": "⁪⁪⁪‌‍​‍‍​​‍‍​​​‌‍​‌‍‍‌‍‌​​‍‌‍‍​​‌‍‍‌‍​‌​‌‍‌⁪Response Counts⁪⁪",
                "RESULTS_DASHBOARDS_BANNER": "⁪⁪⁪‌​‍‌‍‌‍​‌​​​‌‍​‌‍‍‍‌‍‌​​‌​​​‍​‌​​​​‍‌‌‌‌‍⁪Try the new, improved version of survey results, featuring modern, accessible UI and data visualizations, new analysis and exploration features, and more.⁪⁪",
                "RESULTS_OPTIONS": "⁪⁪⁪‌‌‌​‌‍‍‌‍‍‍‌‍​​‌‌‌‌​‍‍‍‌‌​‌‌‍​‍‌‌​‍‍​‍‍‍‍⁪Report Options⁪⁪",
                "RESULTS_TITLE": "⁪⁪⁪‌‌​‌​‍‍‌‍​​​‌‌‌‌‍‍‍‌‌‍​​‍‍​​‍‌‌‌‌‌‍​‍‍​‌​⁪Report⁪⁪",
                "RESUME_DISTRIBUTION": "⁪⁪⁪‌‍‌‍​‍​‌‍​‍‍​‌‍​​‌‌​‌‍‌​‌​​‌‍‌‍​‌‌‌​‍‌‍‌⁪Resume Distribution⁪⁪",
                "REVERT": "⁪⁪⁪‌​‌‍​‍‌‍‌​‍‌‍‌​‍​‌‍​​​​​‌‍‌​‍‍‌​​‌‍‍‍‍‍‍​⁪Revert⁪⁪",
                "RICH_TEXT_LIMIT_REACHED": "⁪⁪⁪‌​‌​​‍‌‍​‌‌‌‍‍​‍​‍​‌‍​‌‌‍‍‌‍​‌​‌​‍​​‌‌​​​⁪Content length has reached the limit!⁪⁪",
                "SAVE": "⁪⁪⁪‌​​​‍​‌​‍‌‍​‌‍‍​‌‌‌​​​‌​‌​‌​‍​‌‌​‍‌‍‍‍‌‌⁪Save⁪⁪",
                "SAVE_AND_CLOSE": "⁪⁪⁪‌‌​​‍​‍​​‌‌‍‍​​‍‍​​‌‍​‍‌​‌‍​‍​​‌​‍​‌‍‌‌‌‍⁪Save and Close⁪⁪",
                "SAVE_AS_CSV": "⁪⁪⁪‍‌‌‍‍‌​‍​‍‌‍‍‌​‌​‍‌‍​‌‌‌​​‍‍‌‍‍​‍‍‍‍‌‌⁪Save Visualization as CSV⁪⁪",
                "SAVE_AS_IMAGE": "⁪⁪⁪‌‌‌​‌​​​‍​‌‍‍‌‍‍‌‌‌‌‍​‌​​‌‌‍‌‌‍​‍‌‍‍‌‌​‌‌⁪Save Visualization as Image⁪⁪",
                "SAVE_CONFIRMATION": "⁪⁪⁪‍‍‌​‌​‌‍‍​‌‌‌‌​​‍​‍​‌​‌​‌​‌​‌​‌‍‍‌‍‌​‍‌‌⁪Save Confirmation⁪⁪",
                "SAVE_PAGE_AS_ELLIPSIS": "⁪⁪⁪‍‌‍‌‍​‌​​​‌‌‍​‌‍‍‍‍‍‍‍‍‌‌‌‍‍‍‍‌​‌‌‌​​‍‌⁪Export Page As...⁪⁪",
                "SAVE_SETTINGS": "⁪⁪⁪‌​‌‌​‌‍​‍‍‌‌‌‌​‍‍‌‍​‍‍​‌‌‌‌‍‌‍‍‍​‌‌​​‍‍​​⁪Save Settings⁪⁪",
                "SCHEDULE_REPORT_EMAIL": "⁪⁪⁪‌​‌‌‍‌‍​‌‌​‌‍‍‍​‌‌‍‍‌​​‌‍​‌​‍‍​‌​​‍‍​​​⁪Schedule Report Email⁪⁪",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "⁪⁪⁪‌‌‍‍‌‌‌​‍​‍‌‍‍​‌​​‍​‌​‌‍‍‍​‌​‌‌‍‌‌​‍​‌‌‍⁪Schedule Report Email...⁪⁪",
                "SEARCH_ELLIPSIS": "⁪⁪⁪‌‌​​‍​‍‌‌​‌​‍‍‍‌‍​‌​​​‍‍​​‍‍​‌‌​​‍‍​​‌‌‍​⁪Search...⁪⁪",
                "SEARCH_PAGES": "⁪⁪⁪‍​‌‍​‍​‍​‍‌​​‍​​​​​‌‍​‍‌‌‍​​‍​‍‌‌‌‌‍​‌‌‍⁪Search Questions⁪⁪",
                "SEARCH_PAGES_ELLIPSIS": "⁪⁪⁪‌‍‍‌​‍‍​‌‍‌‍‍‍‌‌‌‍‍‌​​​‌‍‍‍‌​​​​‌‍​​‌‌‍​⁪Search Pages...⁪⁪",
                "SEARCH_REPORTS_ELLIPSIS": "⁪⁪⁪‌​‍​‌​‌‌‍‌‌‍​​‍‍‌‌​‌​‍‌​‍​‍‍‌‍‌‍‌‌‌​​‍​‌⁪Search Reports...⁪⁪",
                "SELECTED": "⁪⁪⁪‌​‍‍​‍‍‌‌‌‌‍‌​‌‌‍‌‌‌‍‍‍‌‍​‌‍​​​‌​​‍‍‌‌​‍‍⁪Selected:⁪⁪",
                "SELECT_ALL": "⁪⁪⁪‌‍‌​‍‌​​​‍‍​‌‌​‌‍‌​‌​‌​‌​‍‌‍‍‌‍‌​‌‍‍​⁪Select All⁪⁪",
                "SELECT_A_FIELD": "⁪⁪⁪‌​‍​‌‍‍​​‍‌‍‍‍‌‍​‍​​‌​‍​​‍‍​​​​‌‌‌​‍‌‌‍‍‌⁪Select a field⁪⁪",
                "SELECT_A_WIDGET": "⁪⁪⁪‌​​‌​‍​​‌‌​‍‍‌​​​​​​‌​​‍​‍‍​‌‌‍‌​‍‍​​‌‍‍​⁪Select a visualization⁪⁪",
                "SELECT_PAGES": "⁪⁪⁪‌‌‌​​‌‌‍‍‍‍‌‌​‌​‍​‍‍‍‌​‌​‍​‌‍​‍​​‍‍‍‍‍‍⁪Select Pages⁪⁪",
                "SELECT_PAGES_ELLIPSIS": "⁪⁪⁪‌‌​‍‌‌‌‍​‍​‍​​​​​‍​​‍​‍‌‌‍‍‌​​​‌​‌‌‌‍‌‌‌⁪Select Pages...⁪⁪",
                "SEND": "⁪⁪⁪‍‍​‌​‍‍‍‍‌​‍‍‍‍​​​​‍‌​‌‌‌​​‍‍‍‍‌‍‌‍‍‌‌​‍⁪Send⁪⁪",
                "SEND_TEST_EMAIL": "⁪⁪⁪‌‍‍‍​​‍‍‌‌​‌​‍‍‌‍‌​‌‌‌​‌‌​​‍​‌‍‌‍​​​​‍⁪Send Test Email⁪⁪",
                "SETTING_DEFAULT": "⁪⁪⁪‌‌‌‌‌‌‌‍‌​‌‌‍‍​‍‍‌‍​‍​‌‌​‌‌‌​‍‌‍​​​‍‌​‍‍⁪Default⁪⁪",
                "SETTING_HIGH": "⁪⁪⁪‍‌‍‍​‌​​​‍‍‌​​​‍​​‍‌‍​​‍‍‌​​‍​‌​‍‌‍‍‍‌‌⁪High⁪⁪",
                "SETTING_LARGE": "⁪⁪⁪‍‍‍‌‌‍‌‌​‍‍​​‍‍‍‌‍‌​‌​‍‌‍‌​‍‍​‌‍‌‍‍‍‌‍‍‍⁪Large⁪⁪",
                "SETTING_LOW": "⁪⁪⁪‍‍​‌‌‌‍​‍‌​​​‌‍​‌​‍‌‌‍​​‌​‍‍‍‍‌‍​‍‍​‌‌‍‌⁪Low⁪⁪",
                "SETTING_NORMAL": "⁪⁪⁪‍‍‍‌‌​​​​‌‌​‌​​‌​‌​‌​‌​‍​‌‍‌​‍‍​‍‌‍‌‍​​‌⁪Normal⁪⁪",
                "SETTING_SMALL": "⁪⁪⁪‍‌‌​​​‌‍​​​‌‍‍​‍‌‌‌‌‌​​​‍​‌​​‍‌‍‍​‍​‌​‌​⁪Small⁪⁪",
                "SHARE_REPORT": "⁪⁪⁪‌​‍‍​‍‌‍‌‍​​‌‌​​​‌​​‍​​‍‌‌​‌​​‌​‌​​​​‍​‌‌⁪Share Report⁪⁪",
                "SHOW_ALL_PAGES": "⁪⁪⁪‍‍‍‍‍‌‍‍‌​​‍​​‍‌​‍​‌‍‌‌‌‍‌‌‍‍‌​‍​​​​​‍‌⁪Show All Pages⁪⁪",
                "SHOW_FULL_QTEXT": "⁪⁪⁪‌​‌‌​​‍​​‍‍‌‍‍‍‍‍​​​​​​‍​‌‌​‍‌‍‍‌‍‌​‌‌⁪Show full question text in page titles⁪⁪",
                "SIMPLE_TABLE": "⁪⁪⁪‌‍‍​​‌​‍‍​​​​‍​‌‍​‌‍​​​​‌‌​‍‌‌​​​​‍‍‌​‌​⁪Simple Table⁪⁪",
                "SIMPLE_TABLE_DESC": "⁪⁪⁪‌‌‌‍‌‌​​‌​‍‌‌‌‌‍‌‍​‌​​‍‌‍​​​‌‍‍‌​​‌‍​​​‌⁪A flexible table that can show multiple values as rows or columns.⁪⁪",
                "SIZE": "⁪⁪⁪‌‌‌‌​‌​‍​​‌‌‍​​‍‌​​​‌‌‌‌‍​‌​‌‌​‍‍‌‍‌​‍​‍‍⁪Size⁪⁪",
                "SPLINE_CHART": "⁪⁪⁪‌‌‌​‍‌‍‌​​‍‍‌​​‍‌​‌​​​‌‍‍​‌​​​‌‍‌​‌​‌​‍‌​⁪Spline Chart⁪⁪",
                "SPLINE_CHART_DESC": "⁪⁪⁪‌​​‍‌‌‍‌​‍‌​‌‍‌​‍‌‍‌​‍‌‌​‌‍​‌​‌‍​​‌​‌​‍‍‌⁪A two-axis rounded line chart commonly used when graphing against time on the x-axis.⁪⁪",
                "STATISTICS_TABLE": "⁪⁪⁪‌​​‌​‍‍‌​‍​‍​​​‍​‌​‌‍​​​‌‍‍‌‌‌‌​​​​‍‌‌‍‍‍⁪Statistics Table⁪⁪",
                "SUBJECT": "⁪⁪⁪‌​‍‍‌‍‍‍‍​‌​‍‌​‌‌‌​‍‍​‍‍‌‍‌​‍‍‌‌‍‍​‌‍‍‌‌‌⁪Subject⁪⁪",
                "SURVEY_ANALYSIS": "⁪⁪⁪‌‍‍​​‍‌‍‌​‌‍‍​‍‌​​‌‌‌‍‍​​‌‍​‍‍‌‍‍​​‌‌‍‍‍⁪Survey Analysis⁪⁪",
                "SURVEY_SUMMARY": "⁪⁪⁪‌‌‌​‌‌‍‌‍‍‌‍‍‌‌‍‌​‌​‍‍‌​‌​‌​‌​‌‌‍​‍‍‍​‍​‍⁪Survey Summary⁪⁪",
                "TABLE": "⁪⁪⁪‌​‍​​‌​‍‌‍‍​‌‌‌​‌​​​​​​​‌​‌‌‌‌‌‍‌​‌‍‍⁪A DESCRIPTION FOR TABLE⁪⁪",
                "TIME": "⁪⁪⁪‌​‌‍‌‍‌‌‍​‍​‌​‌​​‍​‌‍‍‌​​‌​​‍‌‌‍​​​‌​​‌‌⁪Time⁪⁪",
                "TO": "⁪⁪⁪‍‌‌‍‍‍​‌​‍‌‍‍‍‌​‌​​‌‌‍‍‍​​‍‍‍​‌‌​​​​‍‍​‍⁪To⁪⁪",
                "TOTAL": "⁪⁪⁪‌‍‌‍‌‍​‍‍‌‌‍‌‍​​​‍​​‌​‌‌‌​​​​‍‌‍‍‌​‍‍‌‍⁪Total⁪⁪",
                "TRANSPOSE_STATS_TABLES": "⁪⁪⁪‌​‌​‌‍‍‌‍​​​‌‍‌‌​‌‍‍‍​​‌‌‍​​‌‌​​​‌‍‍‌​​‌‌⁪Transpose Stats Tables⁪⁪",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "⁪⁪⁪‌‌​​​‌​‌​‌‍​​‍‌‌‍​​​​​​‌‍‌‌‌‍‍​​‍‌‍‍‍‌‌‌⁪Transpose Stats Table Breakouts⁪⁪",
                "TRUNCATE_PAGE_TITLES": "⁪⁪⁪‍‍​‍​​‌‌‍‍‌​‌‌‍‍​‌‌‌​​​‍‌​​‍‌​​‍‌‍‍‍‌‍​​⁪Truncate question text in page titles⁪⁪",
                "TRY_IT_NOW": "⁪⁪⁪‌‍‍​​‍‍‌‍‍​​‌‍‌​‌‌‌‍‍‍‍‍‌‌‍‍‍‌‍‍‍‍‌​​​‌‍⁪Try it now⁪⁪",
                "TYPE": "⁪⁪⁪‍‌‌​‌​‍‌‌​‌‌‌‌‍​‍​‌‍‌‌​‌‍‍​‍​‌‍​‍​​‍‌​‍​⁪Type⁪⁪",
                "UNABLE_TO_CHECK_SPF": "⁪⁪⁪‌‌‌​‌‌‍​‍‌‍​‌‌​​‌‍‍​‍‌‌‍‍‍‌​​‌​‌‌​‍‌‍‍​‌‍⁪Unable to check the SPF record. Please try again.⁪⁪",
                "UNAUTHORIZED": "⁪⁪⁪‌​‌​‍‍​​‌‌‌‌​‌​‍‍​‌‍‌‍​‌‌​‍‌​‌‌‌​​‌‌​​‌​​⁪You are not allowed to view this report. Please contact the owner for access.⁪⁪",
                "UNHIDE_PAGE": "⁪⁪⁪‍‌​​​‍‍​‍‌‍‍​‌‍​‌‌​‌‌​​​‌‌​‍​‌‍​‌‍​‍‍​‍​⁪Unhide Page⁪⁪",
                "UPDATE": "⁪⁪⁪‌‌​​​‌‌‌‍‍‌‍​‌‍​‌​‌‌‌​‌‌​‌​‍‍‍​​‌​‍‍‍‌​​⁪Update⁪⁪",
                "UPDATED_SUCCESSFULLY": "⁪⁪⁪‌‍‌‌‍‍​‍‌‌‌‌‍‍‌‌​‌​‍‌‌‌‍‌​‍‌‍​‌‌‍​‌‌‍‍‌‌⁪Updated Successfully.⁪⁪",
                "UPDATE_ALL_IN_THIS_PROJECT": "⁪⁪⁪‌​‌‌‍​‌​​‍​​‍​‌‍​‌​​‌‌‌‌​‌‍‌‍​​‍​​​​‍​‍‌‍⁪Update All in this Project⁪⁪",
                "UPDATE_ALL_PROJECTS": "⁪⁪⁪‌​‍‌‍​‌‌‍‌‌​‌‍‌‍​​​​‍‌​‌‍​‌‍​‍‌‌‍‌‌​‌‌‌‌‌⁪Update All Projects⁪⁪",
                "UPDATE_NOW": "⁪⁪⁪‌​‌‌​​​‌‍‌​​​‍‌‌‌‍‍‍​‌​‍‌‌​‍‍​‌‍‍​​‍‍‍‌‍⁪Update Now⁪⁪",
                "UPDATE_REPORTS": "⁪⁪⁪‌​‍‌​‌‌‍‍‌‍​‌‍‍‌​​‍‌​​‌‍​‌‌​‍​​​‌‌​‌‍‌‌‍⁪Update Reports...⁪⁪",
                "UPDATE_REPORT_ELEMENTS": "⁪⁪⁪‌‍​‍​‍​​‍​​​‌‍​​‌‌‍‍‍​‍‌‌​​‍‌‌‍‌​‌​​‍​‌⁪Update Public Report Links and Scheduled Report Emails⁪⁪",
                "UPGRADE_MY_ACCOUNT": "⁪⁪⁪‌‌​‍‍‌​‌​‍‍‌‍​‌‍‌‌‍‍‍‌‌‍‍​‍‌​‌‍‍‌‌‍‌‍‍‍​​⁪Upgrade My Account⁪⁪",
                "USE_EXPORT_TAGS": "⁪⁪⁪‌​‌​‍​‌‍‌‍​‌‌‍​‌‍​​‍‌​‍​‍​‌‍​‍​​‍‍‍‌​​​‌​⁪Include question numbers⁪⁪",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "⁪⁪⁪‍​‌​‍‌‍‍​‍‌‍‍‌‌​‌‌‍‍‌​‌‌‌​‌‍​‍‌‍‍​​​​‌‍​⁪Use Simple Table Column Totals⁪⁪",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "⁪⁪⁪‌‌‌​‌‍‌​​‌​‍‍​‌​‌‌​‍​​​​​‍​‌‍​‌‍​‍‌‍‌‌‍‍⁪Use Simple Table Respondent Counts⁪⁪",
                "USE_WEIGHTED_METRICS": "⁪⁪⁪‍​‌‍‌‍‌​​​​​‌‍​‍​‌​‌‌‌‍‌‍‍​‍‌‌‍‌‌‌‍‍‌​​​⁪Use weighted metrics⁪⁪",
                "VIEW": "⁪⁪⁪‍‌‌‌‍‌‌​​‌‍‌‍‍‍​‍‍‌‍‌‌​‍​‌​‌‌​​‌‌‌‍‍‍‌‍​⁪View⁪⁪",
                "WEEKLY": "⁪⁪⁪‍‌‍‍‍​‍‌​‍‌‌​‍​​​‌‌‍​‍‍‌‍‌‌‍‌​​‌‌‍‌‌‍​‍‍⁪Weekly⁪⁪",
                "WELCOME_TO_NEW_RESULTS": "⁪⁪⁪‌‌‌​‌‍‌‍‍​‌‍​​​‌​‍‍​‍‍‌‌‌‍‍‍‍​​​​‍‍‍‍‍​‍‌⁪Welcome to Qualtrics XM Platform Reporting!⁪⁪",
                "WHEN": "⁪⁪⁪‍‌‌​‌‍​​​​​‌‌‌​​‌‌‍‍‍‍‍‍​‌​‌​‍‍‍​‌‌​‌‍​⁪When⁪⁪",
                "WIDGET_LOADING": "⁪⁪⁪‍‍‍‍‍‌‍​‍‌​‍‌‌​‌‍‌​​‌‍​​‌‌‌​​‍‌‍‌​‍​‍​‍​⁪Loading...⁪⁪",
                "WIDGET_OPTIONS_ERR": "⁪⁪⁪‌‌‌​​‍‍​​​​​‍‌‌​‌‌‍‍​‌‍‌‌​‌​‍‍‌‌‍‍‍‌‍​‍⁪Failed to load visualization options⁪⁪",
                "WIDGET_TYPE": "⁪⁪⁪‍​​​‍​‌‍‍‍‌‌‌‌​​‌​‌​​​‌‌‌​‌‍‍‍‌​‍‌‍​‌‍‌‌⁪Visualization⁪⁪",
                "WORD_CLOUD": "⁪⁪⁪‌​​‌‍‍‌​‍‍‍​‍‍‌‍‍‌‍‌‍‌‌​‌‍‌‍‌​​‌‍‌​‍​‌‌⁪Word Cloud⁪⁪",
                "WORD_CLOUD_DESC": "⁪⁪⁪‌‍‌‍‍​‍‌‌‌‌‌​​​​​‍‍‍​‌‌‌‌‌‌​‌‌‍‍‍‌‍‌​‌‌​⁪A weighted visualization of word frequency in text data with additional color coding options.⁪⁪"
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "⁪⁪⁪‌‌‍‌​‍‌‌‌‌‍​‌‍​‍‌​‌‌‌‍​‌‌‌‍‌‍‍‌‌‌‍‌​‍‌‍⁪Remember, there are resources within your organization to help you interpret your feedback such as HR Partners, your manager, and/or a mentor.⁪⁪",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "⁪⁪⁪‌‌​‌​‍‌‍‌‍​​‍​‍‍​‌​‍‍​‍​​‍‌‌​‌‍​‌‍‍‍‌​‌‍‌⁪Pour yourself a cup of coffee and dive into your feedback.⁪⁪",
                "ABOUT_YOUR_REPORT_HEADER": "⁪⁪⁪‌‍‌‍‍‌‍‌​‌‌​‌‍​​‍‍​‌​​‍​‍‍‍​‌‌‌​​‌‍‍‌‍‍‌⁪About your report⁪⁪",
                "ABOUT_YOUR_REPORT_LINE1": "⁪⁪⁪‌‌‌‍​‍‍​‍‍‍‍‌​‍​‍​‌‍‍‌‌‌‍​‍‌‍​‌‍‌​​‍‍​⁪Welcome to your 360 feedback report. This is a great opportunity to grow and develop yourself as a professional. In order to set yourself up for success when going through results, allow yourself sufficient time to go over the feedback. Feedback can be difficult to hear initially, but keep in mind that the purpose of this feedback is to accelerate your growth and development.⁪⁪",
                "ABOUT_YOUR_REPORT_LINE2": "⁪⁪⁪‌​‍‌‌‍​‌​‌​‌‍‍‍‌‍​‌‍‍‍‍‍‍​​‍​​‌‍​‌‌‍​​‍​‌⁪As you go through your report, here are a few things to keep in mind.⁪⁪",
                "ADD_CONDITIONAL_TEXT": "⁪⁪⁪‌​​​​‍‌‍​‌‌‍‌‌​​‍‌‌‌‌‌​‌‌​​‌‌‌​‌‍​​‍​‌‌‌‍⁪Add conditional text⁪⁪",
                "ADD_CUSTOM_PALETTE": "⁪⁪⁪‍‍‌‍‌​‍‍‌‍​‍​​‍‍‌‌‍‌​‍‌​‌‍‌‌​‍​‌​‍‍‌‍‌​‌⁪Add Custom Palette⁪⁪",
                "ADD_DATA_SOURCE": "⁪⁪⁪‌​‍‍‌‍‍​‌‍‌​‌‍‌‍​‌​​‍​​​‌‌​‌‍​‌‍​‍‍‍‍​‍‌​⁪Add data source⁪⁪",
                "ADD_FOLLOWING": "⁪⁪⁪‍‍‌‌‌​‌​‌‌​‍‍‍‌​​‌​‌‍‍​‍‌‌​​‍​‍‍‌‍‍‌‍​‌⁪Add following⁪⁪",
                "ADVANCED_FILTER": "⁪⁪⁪‍‌‌​‍‌​‌‌‍‍‌‌‌​‍‍​‌‍​‍​‌‌‍‍‍​‌‍‌​‌​‌‌​⁪Advanced Filter⁪⁪",
                "AGREEMENT_CHART": "⁪⁪⁪‍‌‌‌‍‍‌‌‍‍​‍‌​‍‍‌​‍‌‌​‍​​‌​​‍​‍​​‌‌‌‌‍‌‌⁪Agreement chart⁪⁪",
                "AGREEMENT_CHART_FOOTER": "⁪⁪⁪‌​​‌​​‌​‍‌‌‌​‌​‍‌‌​‌​‍‌‍​‍‍​​​‍‍​​​​‌‌‍‌‌⁪The agreement chart indicates the similarity of scores. Each dot represents how individuals rated you for each item. The size of the dot shows how many raters gave you a specific rating.⁪⁪",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "⁪⁪⁪‌‌​‌‍‍​‍​‍‌‍​‌‌‌‍‍​‍​​​‌‌‌‍‌‌‌‌​‌‍​​‌​​‍‍⁪responses⁪⁪",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "⁪⁪⁪‍​‌‍‌‍‍‍‍​​‌​​​​‍‍‌‍‍‍‍‌‍‌‍​‍‌‍​‍‍​​​‍‍‌⁪response⁪⁪",
                "AGREEMENT_CHART_LEGEND_TITLE": "⁪⁪⁪‌‌‌​‌‍‌‍​​‍​​‌​‌‌‍‌‍‌​‌‍​‌‍‍‌‌​‍​‌‌​‍‍‌‍‌⁪How others rated you⁪⁪",
                "ALL": "⁪⁪⁪‌‍‌‌‍‍​‍​‌‍‌‌​​‌​‍‌‍​​​‌‌​​‍​‌‍‌​‌‍​‌‍​‍⁪All⁪⁪",
                "AND_IF": "⁪⁪⁪‍​‍‌‌​‌‍‌‌‍‌‌‌‍​‌​‍‍‍​​‍‌​‍‌‍‍‌‌‌‌​‍​‍​‍⁪And if⁪⁪",
                "ANGLED": "⁪⁪⁪‍‌‍‍‍‌‌‍​‌‍‍‍‍​​‍‌‌‌​​‌‍‌‍​​‌‌‍‍‌‍‍​‍​‍⁪Angled⁪⁪",
                "AREA": "⁪⁪⁪‍‍‍​​​​‍​‍‌‌‌​‌​‌​‌‌‌​​‌‍‌​‌‌​​‌‌​​​‍​​‌⁪Area⁪⁪",
                "AUTO": "⁪⁪⁪‍​‍‌‍‍​​‍‍‍‍‍‍‍​​​‍‍‍‌‍‍​‌‌​‌‌​‌‌​​​​‍‍‍⁪Auto⁪⁪",
                "AVERAGE": "⁪⁪⁪‍‍​‍​‌‌‍‌​‍‌‍‍‌​​​​‌​​‍‌‍‌‍‍‍​‍​​​‍​‌​​​⁪Average⁪⁪",
                "AXIS_VALUES": "⁪⁪⁪‌‍‍‌‍​​‌​‌‌‍‌‍‍‌‍​‍‌​‍​‍​‍‍‍​​​‍‌‍‍‍‌‌​‌⁪Axis Values⁪⁪",
                "BAR": "⁪⁪⁪‌​‍​‌‌​​‍‌‍​​‍‌‍‍‍‌‌​​​‍​‌‌‍‌‌​​‍‍‍​​​‍​‌⁪Bar⁪⁪",
                "BASE_WORD_COLOR": "⁪⁪⁪‌‌‌‌​‍‌‌​‌‍‍‌‌‌​‍‌​‌‌‍‌‍​‌‍​‌​‍‍‌​‍‍‍​​‍​⁪Base Word Color⁪⁪",
                "BLUR": "⁪⁪⁪‍‍​‍‍‍‌​‌‍‌‍‌‍​​‌​‍‍‍​‌‍‍​​​‍‌‍‌‌‌​‌​‍​‌⁪Blur⁪⁪",
                "BOTTOM_BOX": "⁪⁪⁪‌‌‍‍‌​‌‌‍‍‌‌‌‍‌‌‍​‌‌​‌‍‍​‌​​‌‌‌‌​‌‍‌‍‍‍​⁪Bottom Box⁪⁪",
                "BREAKOUT_HEADERS": "⁪⁪⁪‍‌‌‍‌‌‍‌‌‌​‍‍‍‍‍‍​‌‌​​​‌‍‌‌​‍​‍‍​‍‌‍‍‌​⁪Breakout Headers⁪⁪",
                "CANCEL": "⁪⁪⁪‌‌​​​​‌‌‌‍​​​​​‍‍‌‌‌‍​‍‍‍‌‍​​‍‌‍‍‍‍‍‌‍​‌⁪Cancel⁪⁪",
                "CATEGORICAL": "⁪⁪⁪‍‌‍​​‍‍​‌‌​‌‌‍​‍​‌‍‌​​‌​‌​​​‍‌‍​​‍‌‍​‌​⁪Categorical⁪⁪",
                "CATEGORY": "⁪⁪⁪‌​‍‌‍‌‌‌‌‍​​​‌‍‌‍‍‌‌‍​‍‌​‍​​‍‍‌‍‍‌‌‍​​‌​‌⁪Category⁪⁪",
                "CATEGORY_NAME": "⁪⁪⁪‌​​‍​‍‍‍‌‍‌‍‌‍‌​​‍‍‌​‌‍​‌‍‌​​‌​​‌​​‌​‍‍‌‍⁪Category Name⁪⁪",
                "CHANGE_CATEGORIES_ORDER": "⁪⁪⁪‌‌​​‌​‍‍‌​​‌‍​‌‍‍‍‍‌‍‌​‌​‌‌‌‌‌‍‌‍‌​‌​‌‍‌⁪Change categories order⁪⁪",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "⁪⁪⁪‌‌‌​‌​‌​‌‍‌‌‌‌​‌​‌‌‌​‌​‌‍‌‍​‌‌‌‍‍‍‌‍‌‍‌‍‍⁪Change the scoring categories order⁪⁪",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "⁪⁪⁪‍‍‌‌‌‍‍​‌‍‍‌‌‌‍‌‌​‍‍​‌​‌​​​‍‌‌‌‌​‍​​​​‍⁪Change the order that appears in the visualization by clicking on the left of the scoring category element and dragging it to its desired position.⁪⁪",
                "CHANGE_QUESTIONS_ORDER": "⁪⁪⁪‌‍​​‍‍‍‍‌​​‍‍‌​‍​‌​‍‌‌‍‌‌‍‍‌‌‍‌‌‌‍​​‌‍⁪Change questions order⁪⁪",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "⁪⁪⁪‌​‌‍‌‌​​​​‍‍​‌‍​​​​​‍‍​​‍​‌‍‌‌​‌​‍‍​‌⁪Change the questions order⁪⁪",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "⁪⁪⁪‌​‌​​‌​‍‍​‌‌‌​​‍​​‍​‍‍‍‌‌‍‌‌​‌‌‍‍‌​​‍‍‍​‌⁪Change the order that appears in the visualization by clicking on the left of the question element and dragging it to its desired position.⁪⁪",
                "CHARTS": "⁪⁪⁪‌​‍‌‌‍‍‍‌‌‍‌​​​‍‌​‌​​​‍‌‌​‍‌​​‌​‍​​‌‍​‍​‍⁪Charts⁪⁪",
                "CHART_TYPE": "⁪⁪⁪‌​​‍​​‍‍‍‍​​‌​‌‍‌​‌​‍‍​​‌‌‌‌​‍​‍​‌​​‌​‍‌‌⁪Chart Type⁪⁪",
                "CHOICE_COUNT": "⁪⁪⁪‍‌​‌‍‍‍​‌‍‍‍‌‍‍‌‍‌‍‌‌‍​‌‍‍​‌​‍​‌‍‌​‌‌​​⁪Choice Count⁪⁪",
                "CHOICE_TOTALS": "⁪⁪⁪‌‌‍​​‌​​‍​‌‍‌‍‌​‌​​‍‍‍‌​‌‍​‌​‍‍​‌‍‌‍​‍‍​⁪Choice Totals⁪⁪",
                "CLEAR": "⁪⁪⁪‌‌‌‍​‍​‍‍​‌‍‌​‌‍‌​‍​​​‌‌‍‌‍​‌‌‌‌‍‍‍‍​​‌‌⁪Clear⁪⁪",
                "CLOSE": "⁪⁪⁪‌​‍​‍‌‌​​‍​​‍‍‍​​‌​‍‌‍‍‍‍‍‍​‍​‍‍‌‍‍‍​‌​​‍⁪Close⁪⁪",
                "COLOR_PALETTE": "⁪⁪⁪‌​‌‍‌​‌‌​​‍‍‌​‌​‍‍‌​​​​‌‌‌‍​‍‌​​‍‍‍‌​‌​‌‌⁪Color Palette⁪⁪",
                "COLUMN_NAMES": "⁪⁪⁪‍‌‌‍​‍​​‍​‍‍‌‌‌‍‍‌‌‍‍‍‍‍‍‌‍​​‌‍‌‌‌‌‌‍‌‌‌⁪Column Names⁪⁪",
                "COLUMN_TOTALS": "⁪⁪⁪‍‍‍​‌​‌​​‍​‌‌‍‌‍​‍‌‌​‍‌​‍‍​‌‌​‍‌‌​‍​‌​‍‍⁪Column Totals⁪⁪",
                "COMPARED_FILTER_GROUP": "⁪⁪⁪‍‍‌‌​‍​‌‌‌​​‍‌‌‌‌​​‍‌‌‌‍‍‍​‍‍‌​​​‌​‍‌‍⁪Compared Filter Group⁪⁪",
                "COMPARED_FILTER_GROUPS": "⁪⁪⁪‌‍​‌​‌​​​‍​​‌‍​‌‍‌‌‌‍‍​‍‌‌​‍‌​​‍‍​​​‌‌‌⁪Compared Filter Groups⁪⁪",
                "COMPARE_WITH": "⁪⁪⁪‌​‌‍‌‍‌​​‌​‍‍‍‌‌​​‌‍‍​​‌‍‍‌​​​‍‌​‌‌​‍‍‍​⁪compare with⁪⁪",
                "COMPETITION_RANKING": "⁪⁪⁪‍‌‌​‌​​‍‌‌‌‌​‍​‍‍‌‍‍‌‍‌‍‌‍​‍​​‌‌‍‍​‌​‍​‌⁪Use competition ranking⁪⁪",
                "COMPETITION_RANKING_TOOLTIP": "⁪⁪⁪‍​​​‍​‍‌‍​‍‍‍‍‌‌‌‍‍‍‌‌‍​‍‍‍‍‍‌‌‌‌‌‍‍​‍​⁪In the event of a tie, all equal scores are given the same ranking. However, the next subsequent Item will be ranked equal to: the total number of Items ranked higher in the table, plus one.⁪⁪",
                "COMPLETED_RESPONSES": "⁪⁪⁪‌‌​​​‌‌‍‍​‍‍‍‌​‌‍‌​​‌‍‍​‌​​‌​‍‍​​‍‍‌‌‌​​​⁪Completed responses⁪⁪",
                "CONDITIONAL_TEXT": "⁪⁪⁪‍​‌‌‍‍‍‌‌​‍​‌​‍‍​‌‍‌‍​‍‍‌‍​‍‌‍‌​​​​​​‍​‌⁪Conditional text⁪⁪",
                "COUNT": "⁪⁪⁪‌​​‌‌‍‌​​​​​‌‍‍​​‍​‌‌‌​‌‍‍​​​​​‌‌‌‍‍‌‍‌‌‌⁪Count⁪⁪",
                "CREATE": "⁪⁪⁪‍‌‌​​‌‍​‍‍‍‌​‌​‍‍​​‌​​‍‍​‍​‌‌‌​​‌‍‌‍‌‌​‍⁪Create⁪⁪",
                "CUSTOM_PALETTE": "⁪⁪⁪‍​​​‌‌​‌​‌‌​​‌‍‌‍​‍‌‌​‌‍‌‍‍‌‍​‌​‌‍​‌​‌‍​⁪Custom Palette⁪⁪",
                "DATA_SOURCE_TYPE": "⁪⁪⁪‍​‍‌‌​‍‍‍‌​​‍​​‍​‌‍‌​‌​‌‌‌‍‍‍​​​​‌‍‌‌​‍⁪Data Source Type⁪⁪",
                "DATA_SOURCE_TYPE_CATEGORY": "⁪⁪⁪‍‍‌​‌‌​‍‌‌‍​​‌‌‍​‌‌‌​‌​‌​‌‍‍‍​‍‍​‌‍‌‌​⁪Scoring Categories⁪⁪",
                "DATA_SOURCE_TYPE_QUESTION": "⁪⁪⁪‌​‌​​​‌‍‍‌‍‌‌‍​​​‍‌‍​‌‍‌​‌​‌​‍​‍​‍​‌‌‍⁪Questions⁪⁪",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "⁪⁪⁪‍‌​‍‌‍‌‍‌‍‍‍​​‍‍​​​‍‍​‍‍‌​‌‌‌‌​‌​​‌​​‍‍⁪Question⁪⁪",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "⁪⁪⁪‌‌‌‌‌​​​​‍‌​‌‍‍​‌‍‌‍‌‌‌​‌‌‌‌‍‌‌‌‍‍​​‌‌‍‍⁪Rankable Items⁪⁪",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "⁪⁪⁪‍‍‌‍​‌​‍‌‌‌​‍​‍​​​‍‍​‍​‌‍‍‌​‍‌‍​‍​‌​​‌​⁪Scoring Category⁪⁪",
                "DEFAULT": "⁪⁪⁪‌‍​‌‌‍‍​‌​‍​‌‌‌​‍‍​​‍​‍‌‌‍‍​​​‌​‌‌​‌‍‌​​⁪Default⁪⁪",
                "DEFAULT_TEXT": "⁪⁪⁪‍‌‌‍‍‍‌​‌​‌​​​‌​​​​​‍‌‌‍​​‍‍​​‍‍‍‌‍‍‍‌‍⁪Default text⁪⁪",
                "DELETE": "⁪⁪⁪‌​‌​‍‌​​‍‌​‌‍‍‌​​‌‍‍​‌​‌​​‌‍‌‌​​‌‌​​‍​‌‍​⁪Delete⁪⁪",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "⁪⁪⁪‌‌‌‍‌‌‍‌‍‍​​‌‌‍​​‍​‍​‌‌‌​‌‍​‌‌‌​​‌‍‌‍​‍‍⁪Understand who your feedback is coming from, whether it’s peers, direct reports, leaders, etc⁪⁪",
                "DIFFERENT_EVALUATORS_HEADER": "⁪⁪⁪‍‌‌‍‍‍​‌​‍​‌‍‍‍‌​‌​‌​‍​​​‌‌‌‍​‍‍​‍​‌‌​​​⁪Different evaluators⁪⁪",
                "DIRECT_REPORTS": "⁪⁪⁪‌‌‍‍​​‍‍‍‍‌‌‌‍‍‍‌‌‌‌‌‍‍‌‌‍‍‌‍‌​‍​​​​‌‌‌‌⁪Direct reports⁪⁪",
                "DISABLED": "⁪⁪⁪‍‌​‌​​​‌‍‍‍​‌​‌​‍‌‍​‌​‌‍​​‍‌‌​​​‌‍‌‌‍‌‌‌⁪Disabled⁪⁪",
                "DISPLAY_OPTIONS": "⁪⁪⁪‌‍‍​‌‌‍‌​‍‌‍‍​​‌‌‍‍​‍​‍‌‌‌​‍‌​‍​‌‌‌‌​‌​‌⁪Display Options⁪⁪",
                "DISPLAY_THRESHOLD_TEXTS": "⁪⁪⁪‍‌‌‌​‌​​‌‌‌‍‌‍​‍‍‌‍​​‍​‌‍‌‌​​​‌‌‍‍‍‍​​‌​⁪Display text based on the following groups gap⁪⁪",
                "DIVERGENT": "⁪⁪⁪‌​‌​‌‌‍​‌‌‍‌​​‍​​​‌​​‍​​‌‍​​‌‌‌​​‌​‌‌‍⁪Divergent⁪⁪",
                "DONE": "⁪⁪⁪‌​‍​‌‍‍​​​‍‍‌‌‍‍‌‍‌‌‌‍‌​​‌‌‌‌‍‌‍‍‍‍‌‍​​‌⁪Done⁪⁪",
                "DONT_HEADER": "⁪⁪⁪‌​‌‌‌‌‌‍‍​​‍‌‍‍​​‍‍​​‍‍​​‍‌‌‌‍​‌​‌​‌‍​​‌​⁪Dont:⁪⁪",
                "DONT_LINE1": "⁪⁪⁪‌‌‍‍‌​‌​‌‍‍‍‌‍‍​‌‌​​‌‍‌‌‍‌‍‌​​​‍​​​‍​​‍‍⁪Try to figure out who said what⁪⁪",
                "DONT_LINE2": "⁪⁪⁪‍​‍​​​‍​‌‍​‍‍​‌​​‌​​‍‍​‍‍‍‌‍​‌‌‌‌‍‍​‍‌​​⁪Focus on one positive or negative score/comment⁪⁪",
                "DONT_LINE3": "⁪⁪⁪‌​‍‌‌‍​‌​‍‌​‍‍​‍‌‌‌‍‌‍‍​​‌‌​‍‍‍‍‍‍‌‌‌‍​​‍⁪Create a development plan around every item⁪⁪",
                "DONT_LINE4": "⁪⁪⁪‌​​​‌‍‌‌‍‍‌‌‍​‍‍‌‌‌‌​‌​​‍​‌‍​‌​‌‌‌​‌‌‍‌‌‌⁪Be discouraged that you have opportunities for improvement⁪⁪",
                "DONUT": "⁪⁪⁪‌‍‌​​​‌​​‍​​‍‍‌‍​​‍‌​‌‌‌​‍‌​‌​​​​‍‌‌‍‍​⁪Donut⁪⁪",
                "DOWNLOAD_CSV": "⁪⁪⁪‍‌‌​‍​​​‌‌‌​‌​‌‌‌‌‍​​‍‌‍‌‍‌‍‍​‌​​‍‍‌​‍‍​⁪Download Legacy CSV⁪⁪",
                "DOWNLOAD_ZIP": "⁪⁪⁪‍​​‍‍‍​‌​‍​‍‍‍​​​​‍​‍‍​‌‌‍​​‍​‌​‍‌‌‍​‌‌​⁪Download all files⁪⁪",
                "DO_HEADER": "⁪⁪⁪‌​​‌​‍‌​‍‌​​‍‍​​‍‍‌‌​​‍‌​​‍‍​​‌‍​‌‍‍​‌​​‍⁪Do:⁪⁪",
                "DO_LINE1": "⁪⁪⁪‌​​​​‍​​​​‌​‍‍‍​‍​​​​‌‌​​​​​​‍‌‍‍‌‌​​‍‍‍‌⁪Look at feedback holistically⁪⁪",
                "DO_LINE2": "⁪⁪⁪‌​‌​​‍‌‍​‌‍​‌​‍‍​‍‌‌​‍‌‍​‌‌‍‌‍​‍‍​‌‍‍‍‍‌⁪Identify themes in strengths and opportunities for improvement⁪⁪",
                "DO_LINE3": "⁪⁪⁪‍​‌‌‌​‌‌‌‌‌​​​‍​‌‍‍‌‌‍‍​‍​‍‌‌‍‍‍‌​​‌‍‍‍⁪Prioritize a few focus areas to add to your development plan⁪⁪",
                "DO_LINE4": "⁪⁪⁪‌‌​‌‍​‌‌‍​‌‌‌‍‍‍​‌‌​‌​​‌‌‌‍‍‍​‍​‍‌‌‌​‍​‍‌⁪Understand that everyone has opportunities for improvement⁪⁪",
                "DROPOFF": "⁪⁪⁪‌​‌‌​‌‌‌‍​​‍‍‍‍‍‍‌​​‌‍​‍‍‍‌‌‍​​​‌‌‌‍‍​​⁪Dropoff⁪⁪",
                "DUPLICATE": "⁪⁪⁪‌​‍​‍​‍​‍‌​​​​‍​‌‌‍‍‍‌​​‍‌‌​​​‍​‌‌​‍‍​‍‌‍⁪Duplicate⁪⁪",
                "EDIT_CONDITIONAL_TEXT": "⁪⁪⁪‌‌​‌‍​‌​‍‍‌‍​‌​​​​‍​‌‌‌‌‍‍​‌‌‍​​‌‌‍​‍​​‍⁪Edit conditional text⁪⁪",
                "EDIT_CUSTOM_PALETTE": "⁪⁪⁪‌‌‌‍​‍‌‍‍‌​​‍​‌‍​‌‍‍‍‌​​‍​‍‍​‌‌‌​‍‍​‌‌​‌⁪Edit Custom Palette⁪⁪",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "⁪⁪⁪‍‌‌‍‍​​‍‍‍​​‌‌‌‍‌​‍‍‍‌‍‍‌​‍‍​‌​‌‌​‌‍​​‍‌⁪Else show the following text⁪⁪",
                "ENABLED": "⁪⁪⁪‌‍​‍‍​‍​​‍​‌‍​​‌‌​‌‌‍‌​​​​‌​​​‌‍​‍​‍‍‍‍​⁪Enabled⁪⁪",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "⁪⁪⁪‌​‍‌‍​‌​‌‍‍​‍‍​‌​‌‌​‌‍​​​‌‍‍‌​‌‍‍‍‌‍‍​‍​‌⁪Enable ordering by rater category display logic⁪⁪",
                "ENABLE_ORDERING_FOR": "⁪⁪⁪‌​‌​​​‌‍‍​‍‍​​‌​​‌‍‌​‌​‌​​​​‍​​​‌​​‍​​‍‍⁪Enable ordering for⁪⁪",
                "EQUAL_TO": "⁪⁪⁪‌‌​‌‍​‍​​‍​‍‌‍​​​‍‍​​‌​​​‌‌​‍​​​​‍​‍‍‌‍‍⁪Equal to⁪⁪",
                "FIELD": "⁪⁪⁪‌‌‌‌‌‍​​‌‌‌‌‌​‌‌‍​‌​​‌​​‍‍‍​‌‌‌​​​‌‌‍‍‍‍‌⁪Field⁪⁪",
                "FILTER_NAMES": "⁪⁪⁪‍‌​​‌‍‌‍‌‌‍​‌‌‌‍‌‍‌‌‍‍​​‌‌‌‌‌‌‍‍‍‌​​‌⁪Filter Names⁪⁪",
                "FOLLOWING_PARENTHESES": "⁪⁪⁪‌​​​‌​‍​‍​‍‍‌‌‌​‍‍‍​‌‌​‍‌‌‍‍‌‍‍‌‍‌‌‌​‌​‌‍⁪(following)⁪⁪",
                "FOOTER": "⁪⁪⁪‌‌‌‌‌​‌‌​‍‍‍‍‍‌‌‌‍‌‍‍​‌‍​​​​‍‌‍​‌‌‌‌‌‌‍‍‍⁪Footer⁪⁪",
                "GAP": "⁪⁪⁪‌​​‍‍​​‌​‌‌‍​‍‍‌‍‍‌‌​‌‍‍​‍‌​‌‍​​‍‌‌​​‍‌​​⁪Gap⁪⁪",
                "GAP_CHART": "⁪⁪⁪‌‌​​​‍‌​​​‍‌‍‍‍‌‍‌‍‌‌​‍​​‍‌‌‍​​‌‍​‌‍​‌‌​‌⁪Gap chart⁪⁪",
                "GAP_CHART_DESCRIPTION": "⁪⁪⁪‌‌‌‍‌​‌‌‍‌​‌​​‌‌​‌​​​‌‍​‌‍​‍​‍​‍‌‌‍‌‍​​⁪The gap chart displays the difference in scores between two rater groups. For example, in the case of self-ratings vs. how others rated you, a positive(+) difference means others rated you higher than the rating you provided for yourself. A negative(-) difference means others rated you lower than you provided for yourself.⁪⁪",
                "GAP_CHART_FOOTER": "⁪⁪⁪‌​​‍‌‌​​​‌‌‌‍‍​‍‍​​​‌​‌‌​‌‌​‍‌‍‌‍‌‌‌‌​‌‌‌⁪The gap chart indicates the +/- difference between two rater groups.⁪⁪",
                "GAP_TABLE_DESCRIPTION": "⁪⁪⁪‌​‌‌‍‌​​​‌​‌‍‍​‍‍​​​​​​‌‍‌‌​​‌‌‌​‍​‌​​​‍⁪Hidden strengths shows where others rated you higher than you rated yourself. Areas for improvement shows where others rated you lower than you rated yourself. Both sections are ranked from largest to smallest gap.⁪⁪",
                "GAP_TABLE_FOOTER": "⁪⁪⁪‌​​​‍‌​‌​‍​‍‌​‍​‌‌‌‌‍‌‍‌‍‍‌‍​‌‌‌‌‌‌‍‌‌‌‌​⁪The first column of scores indicates how you scored yourself. The second column indicates the average score of others. The third column indicates the difference between how you scored yourself and how others scored you.⁪⁪",
                "GAP_TABLE_TITLE": "⁪⁪⁪‍‌‍‍​‌​‌​‌‍‌‍​‍‌‍‍​​‍‍‌​​‍​‍‌‌‍‌​​‍​⁪Hidden strengths/Improvement areas⁪⁪",
                "GREATER_OR_EQUAL": "⁪⁪⁪‌​‍​​‍‌‌‌‍‌‍‌‌‌‌​​‌‍​‌‍‍‌​‍​‍​​​‌‍​‍​‍​​‌⁪Greater or equal⁪⁪",
                "GREATER_THAN": "⁪⁪⁪‌‌​​‌​‌‍‌‍‌‌‌‍‍‍‍‌‍​‍‌‍‍‌​​​‍‍‍‌‍‌​‌​‌‌​‌⁪Greater than⁪⁪",
                "GROUP": "⁪⁪⁪‍‌‌‍‍‌‌‍​‌​‌‌​‌‌‌‌‍‌‍‌‌‍‌​‍‍‌​‌‍​‍​​‌‍‌⁪Group⁪⁪",
                "GROUPED_FOR_ANONYMITY": "⁪⁪⁪‌‌​‌‍​‌‌‌‍‌​‍‌‌‌‍‌‌‌‍​​‌‌‍‌‍​‍‌‌‌‌‍‍‌​⁪Grouped for Anonymity⁪⁪",
                "HEADER_NAMES": "⁪⁪⁪‌‌‌‍‍‌‍‍‌‍​‌‌​‌‍‌‍‍‌‍​​‌‍‍‍‍​‍‍‌​‌‍‌‌‌​‌⁪Header Names⁪⁪",
                "HIGHEST_SCORES": "⁪⁪⁪‌​‌‍‍‍‍‍​​​‍‍​‌‌‌‌‌​‌‌‌‍‌‌‍‍​​​‌​​‌​​‌‌​​⁪Highest scores⁪⁪",
                "HIGHLIGHT_THRESHOLD": "⁪⁪⁪‌‌​​‍‌​​​‍​​‍‍​​‍‌‌‌​​‌‍​‌‌​​‌​​‍‌‌‌‌‌​‍​⁪Threshold to highlight gaps⁪⁪",
                "HIGHLOW_TABLE": "⁪⁪⁪‌​‍‌‌‍​‍‌​‌‍‍‍​​​‌‍‍​​‍​​‍​‌​​‍‍‌‌​​‍‍‌‍​⁪High and low scores⁪⁪",
                "HIGHLOW_TABLE_FOOTER": "⁪⁪⁪‌‍​​​​‍‌​‍‍​‍‍‍​‍‌​‌‌‍​‌‍‌‌‍‌‌‍‌‌‍‍‌‌​‍‌⁪This section shows the five highest and lowest rated behaviors (across all behaviors) from the applicable rater category averages. To get the most from this page, it is helpful to look for trends that may emerge. For example, if the majority of your lowest rated behaviors are concentrated in one or two categories; these may be areas in need of development. The highest rated behaviors can identify strengths that can be leveraged in other areas.⁪⁪",
                "HIGH_LOW_TABLE_DESCRIPTION": "⁪⁪⁪‌‌‍‌‌‍‍‌‌‌‌‍​‍​‍​‍‌‍​‌‍‌‌‌​‍‍‌​‍‍​‌‍‌​‍⁪The high/low chart displays items based on the areas where others rated you highest and lowest.⁪⁪",
                "HORIZONTAL": "⁪⁪⁪‍​‍‌‍‌​​​‍‌‌‌​‍‍‌​‌‍‌​​​‌​‌‌​‌​‌‌‍‍‌‍‍​‌⁪Horizontal⁪⁪",
                "HORIZONTAL_AND_VERTICAL": "⁪⁪⁪‌​‍‍‍‍‍‌‍​‌‍‍‌‌​‍‌‌‌‍​​‌‌‍‌‌‍‌‍‌‌‌​​‍‍​​‍⁪Horizontal & Vertical⁪⁪",
                "HORIZONTAL_BAR": "⁪⁪⁪‍‌‍‌​‍​‍‌‌‍‍‍‍‌​​‍​​‌‌‌‍​‍‌‍‌​​​‌‌‍​‌‍​⁪Horizontal Bar⁪⁪",
                "HOW_TO_INTERPRET_RESULT_HEADER": "⁪⁪⁪‌‌​‌‍‌‌‌​‌‍‍​​‍‌​​‌‌‍‍‌‌‌‍‌​‍​‍‍​‍‌​‌​​⁪How to interpret results and determine action:⁪⁪",
                "IF": "⁪⁪⁪‍​‌‍‍‍‍‍​‌‌​‍‌‌‌​‌‍​‌‍‍‌​​‍​‍​‌‍‍‌‌‌‍‍‌‍⁪If⁪⁪",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "⁪⁪⁪‍​​‌‍‌‌​‌​‌‌​​‌​‍‌‌‌‌‍‍‍‌‍‍​‍‌​​​​​‍​​​⁪Include hidden labels in percents⁪⁪",
                "INNER_RIM": "⁪⁪⁪‌​​​​​​‌‌‍​​​​​‌‌‌‌​‌​‌‌‌​‍​​‍‍‍​‍‍‍‍‍‍​‌⁪Inner Rim⁪⁪",
                "IS": "⁪⁪⁪‌‌‌​‍​​​‌‌​‍‌‌‍​‌‍‍​‍‌‍‌‌‍​‍‍‍​​‌‍‍‌​‍‍‍​⁪Is⁪⁪",
                "IS_NOT": "⁪⁪⁪‍‌‍​‌​‍‌​‍​​‍‌‌‍​‍‍​‍‌‌​​‍​​‌‍‍‍‍‌‌‍​‍​⁪Is not⁪⁪",
                "IS_SAME_AS_SUBJECT": "⁪⁪⁪‌‌‌‌‌‌‍‌​​‌‌‍‍‌‍‍‌‌‌‌‌‍‍‍​​‍‍‌‍‌‍‌‌​‍​‌‌⁪Is same as subject⁪⁪",
                "ITEM": "⁪⁪⁪‌‌​​‌​‌‍‍‌‌​​‌‍‌‍‌‌​‍‍​‍‌​‌​​‍​‌‌‌‌​​​‍‌⁪Item⁪⁪",
                "LABELS": "⁪⁪⁪‌​‍​​​​‍​‍‍‌‍‍‌‍​‍‍‍‌‌‌‍‌‌‍‍​​​‍​​‍‍‌‌‌​‌⁪Labels⁪⁪",
                "LARGE_LABELS": "⁪⁪⁪‍‌​​​‌‍​‌‌​‍‌​‍‌‌‌‌​‌‍‍‍‌‍‌‌​​‍‌‌‌‌​‍‌​⁪Large Labels⁪⁪",
                "LEGEND": "⁪⁪⁪‌​‌‌‌​‍‌‌‍‌​‌​​​​‌‌‍​‍‌‍‌​‍​‌​‍‌​‌‍​​‍‌​⁪Legend⁪⁪",
                "LEGEND_POSITION": "⁪⁪⁪‌​​‌‌‌‌‌‌‍​‍‍‌​‌‍‍​‍‍‌‍​​‍‌‍‍​​​‌​​​‌‌‍​​⁪Legend Position⁪⁪",
                "LEGEND_VALUES": "⁪⁪⁪‍​​​​‌‍​‍‌‌‍​‍​​‌‌‌‌​‍‍​​​‍‌‍‍​‌‌‌‌‌​‍‌⁪Legend Values⁪⁪",
                "LESS_OR_EQUAL": "⁪⁪⁪‍‍‍‍‌​​​​​‍‍​‌​‌​​‍‍‌​‌‍‌‍‌​‍‌‌​‍‌‌‍‌​‌‍⁪Less or equal⁪⁪",
                "LESS_THAN": "⁪⁪⁪‌‌​‍‍‌​‌‍‍​‍‍‌‍‍‌‍‍‌‍‌​‌‌‌‌‍​‌​​‌‌‍​‌‌‌​⁪Less than⁪⁪",
                "LINE": "⁪⁪⁪‍​‍‍‌‍​​‍‌‍‍‌‌‌​​​‌‌‌​​‍​‍‍‌​‍‍‌‍‌‍‌​​⁪Line⁪⁪",
                "LOWEST_SCORES": "⁪⁪⁪‍‌‍​‍‍‍‌‌‌​​​‍‌‌‌​‍‍‌‍‌​​​​‌‍‌‍‍‌‌​‌​‌‌​⁪Lowest scores⁪⁪",
                "MANAGERS": "⁪⁪⁪‌‌​‌‌‍​‍​‌‍‍‍‍‍​‍‍‌​​‍‌‌‌‌​​​‍‌‍‌​​​‌‌‌​​⁪Managers⁪⁪",
                "MANUAL_FONT_SIZE": "⁪⁪⁪‌​‍‌‌‍‍‌‌​‍​​‌‍​‍​​‌‍‍‍​​‍‌‍‍‌​​‍‍‍​‌‌​‍‌⁪Set font size manually⁪⁪",
                "MAX": "⁪⁪⁪‌​‌‌‌‍‍‍‌‌​​​​​‌​‍‌​​​​​‌​​‌​‌​​‌‌‍‌‌‍​‌‍⁪Max⁪⁪",
                "MEAN": "⁪⁪⁪‍​‍‍‌‌‍‍​‍​​‍‍‌‍‍​‍‌‌​​‌‌​​‌‌‌‌‌​‌‍‌​​‍‍⁪Mean⁪⁪",
                "MEDIAN": "⁪⁪⁪‍​​​‍‍​‍​​​‌​‌‍​​‌​​‍‌‍​​​‍‌‍‌‌‌‌​​​​‌​​⁪Median⁪⁪",
                "METRIC_TYPE": "⁪⁪⁪‌​‌‍‌‌‌‍‌​‍‌​‍​‍‍‍​‍‌‌‍​‍‌​‍‌‍‍‌‍‌‍​​‌​‍‍⁪Metric type⁪⁪",
                "MIN": "⁪⁪⁪‌​​​‍‌‍‌‍‌‌‌‌‌​‍​​‍‍‍‌​‌‍​‌‌‌‍​‌‍‌‍​‍​​‍‍⁪Min⁪⁪",
                "MODIFY_CUSTOM_PALETTES": "⁪⁪⁪‌‍​‍‍‌‍‍​‍‍‍​​​‍‌‌​‍‌‍‍‍‍‍‌​​‌​‍​​‍​‌‌‍‍⁪Modify Custom Palettes⁪⁪",
                "MOVE_DOWN": "⁪⁪⁪‌​‌‍​‌‍​‌‍‍‍​‌‌​‍‌‌‌‍‌‍‌‌‌‍‍​​‌‍‌‌‍​‌‍​‍‍⁪Move down⁪⁪",
                "MOVE_UP": "⁪⁪⁪‍‌‍​‌​​​​‍‌‌‌‍​​‍‌‌‌​‌‍​‌‌‌‍‍‌‍‌​​‍‍⁪Move up⁪⁪",
                "MULTI_SELECT_ITEMS_SELECTED": "⁪⁪⁪‌‌​‌‍‍​‌‌​‌​‍‍‌​‍‍‌‌‍‍‍‍‌‍​‌‌‌‍‌‍‍‍​‍‍‌​‍⁪selected⁪⁪",
                "NEGATIVE_GAPS": "⁪⁪⁪‌‍‍‍‌‌​‌​​​‍​‍​‍​‌‍‍‍‍‌‍‍‌​‌‍‍​‌‍​‍​‌‌‍⁪Areas for improvement⁪⁪",
                "NO": "⁪⁪⁪‍‌‍‍‌‍​‌​‌​‌​‍‍‌‍​‍‌​​​‍‌‌‌‌‌‍‌‍‌‍‌‌‍‍​‌⁪No⁪⁪",
                "NONE": "⁪⁪⁪‌​‍​​‌​​‍‌‍‍​​‌​‌‍​‌‍‌​​‍‍​‍‌‌‌‍‍​‍​​​‍​⁪None⁪⁪",
                "NOT_APPLICABLE": "⁪⁪⁪‍‍‌‌‍​​​‌​‌‍​‍‍‌‍‍​‌​​​‍‌‌​‌​‌‌​‍‌‌‍‍​‍‌⁪N/A⁪⁪",
                "NOT_EQUAL_TO": "⁪⁪⁪‌​‌‍‌​‌‌​‍‍‍‍​​​‍​‍‍​‍​​‍​​‍‌‍‍‌‌‌‍‍‍‍‌​‌⁪Not equal to⁪⁪",
                "NO_DATA_AVAILABLE_WARNING": "⁪⁪⁪‌‌​‌​‌‍‌‍‌‍‌‌​​‍‌‍​‌‌​‍‌‌‌​‍​‌‍​‍​‌‌‌‌‌‍⁪No data available⁪⁪",
                "NO_FILTER_IS_APPLIED": "⁪⁪⁪‌‌​‌‌​‍‍‍​‍‍‍​‍​​‍‍‌‌​‍​​​​​‍​‌‌‍‌‌​​​​​‍⁪No filter is applied.⁪⁪",
                "NO_VALUE": "⁪⁪⁪‌‌‌​‌‍‍​​‌‌‌‌​​​‍‍‍‍‌‍‍‍​‌‌‍​​‍‌‍‍‌‍​​​⁪No value⁪⁪",
                "NPS": "⁪⁪⁪‌‍‌‌‍​​​‍‌‌​‌‌​‍‍​‌‌​‌‌​‌‌‌​‍‍​​‌‍‌‌‍‍​⁪Net Promoter Score⁪⁪",
                "NUMBER_OF_GAPS_NEGATIVE": "⁪⁪⁪‌​‌​‌​‍​​​‍​‌‍​‍​​‍‌‍‍‍‍‌‍‍‌‌‍‌​‌​​‍‍‌‌‌⁪Number of Negative Gaps⁪⁪",
                "NUMBER_OF_GAPS_POSITIVE": "⁪⁪⁪‍​‌‍‍‍‌​‌‌​‌​​‌‍‌‌‍​‍‍‌‌‍‍​​​​‌‍‌‌​‍‌‌‍⁪Number of Positive Gaps⁪⁪",
                "NUMBER_OF_ROWS_HIGH": "⁪⁪⁪‍‌​​‌‌‌‌​​‌‌‍‌‌‌‍‌‍​​‌​​‌‌‍‌​‍‌‍‍​‍‌​​‍⁪Number of High Rows⁪⁪",
                "NUMBER_OF_ROWS_LOW": "⁪⁪⁪‍​‍‌‌‌‍‌​‌‍‌‌‍​​‌‍‌‍​‌​‌‌​‍​‍​‍‍‍​‌​‌‌‍‌⁪Number of Low Rows⁪⁪",
                "OPTIONS": {
                    "HEADER_NAME": "⁪⁪⁪‍​‍​‍​‍‌‌​‌‍‍‌‍​​‌‌​​​​‌​​‌‍‍​‌‍‍‍‌​​‌⁪Header name⁪⁪",
                    "LEGEND": "⁪⁪⁪‌​‌‍‍‌‍​‍‌‍​‍‍​​​​‌‌‌‍​‌‌​‌‍‍​‌‍‌​‍‌​‍​​‌⁪Legend⁪⁪",
                    "SCALE_AXIS_CHANGER_TITLE": "⁪⁪⁪‌‌​​‍‌‌‌‍‍‌‌‍‌​‌​‌‌‍‍‌​‌​​‍‌‍‍‌‌‌​‌​‍‍‌‍‍⁪Range⁪⁪"
                },
                "ORIENTATION": "⁪⁪⁪‌​‍​‍​‌‌‌‌‌‌‌​‍‌‌‌‌‌‍‌‌​​​​​‍‌​‍​‍​‍​​​‍‌⁪Orientation⁪⁪",
                "OR_IF": "⁪⁪⁪‌‌​‌​​​​​‌‌​‌‍​‍​‌​‌‍‌​​​​‍‍‌‌‌‍‌​‌‌‍‍​​‍⁪Or if⁪⁪",
                "OTHER": "⁪⁪⁪‌‌​​‍​​‍‍‍‍‌‍‌‌‌​‍‍‌​‍‍‌‌​‍‍‍‌‍‌‌​‌‍​‌‍‌​⁪Other⁪⁪",
                "OTHERS": "⁪⁪⁪‌​‍‌​‌‌‍​​‍‌​‍‍‍​​​‌‌‌‍‍‌‌‌‌‍‌​​‌‍​‍​​‍​‍⁪Others⁪⁪",
                "PAGE_OF": "⁪⁪⁪‍‌​‌‌‍‍​‍‌​‌‌‌‌‌‌​​​​‍‌‌‍‍​‍​‌​‍‌‍‍​‌‍‌​⁪Page: %1 Of %2⁪⁪",
                "PALETTE_REMOVED": "⁪⁪⁪‌‌​​‍‌‌‌​‌​‍‍​​‌‍‍‌​​​‍​‌​‌‌​‍​‍‌‌‍​‍‍‌‌‍⁪Palette Removed⁪⁪",
                "PEERS": "⁪⁪⁪‍​‍​‌‌​‌​‌‍​‍‌‍​​‌​‍​‌‌‍​‌‌‍‌‌‌‌​​‍‍​​​‍⁪Peers⁪⁪",
                "PERCENT": "⁪⁪⁪‌‌​​‍​‌‍‍‌‍‌​​‌​​​​‍‌‌‌‌​​‌‌‌‌‍‍‌‍​​‌‌​​​⁪Percent⁪⁪",
                "PERCENTAGE": "⁪⁪⁪‍​​‍‍​‍​‌‌‍‌​​​‌‍​​‌‌‍‍‌‌​‍‌‌‌‌‍​‌‌​​‍​‌⁪Percentage⁪⁪",
                "PERCENTAGE_OF_CHOICES": "⁪⁪⁪‍​‌‌‌​​‌‌‍‌‍‍‍​‍​‌​​​‌​‍‌‌​​‌​‌​‍‌​‍​‌‍‌⁪Percentage of Choices⁪⁪",
                "PERCENTAGE_OF_RESPONSES": "⁪⁪⁪‍‌‍‌‍‌​‌‌‌‌​​‍‌​‍‍‍​​‍​​‌​‌​‌‌​‌‍‌‍​​​‍‍⁪Percentage of Responses⁪⁪",
                "PERCENT_COMPLETE": "⁪⁪⁪‌‌‌‌​​‍‍‍‌‍‍​​​​‌‍‌‍‍​‌‌​​‍​‌‍​‌‌​​​‌‌‍‌‍⁪% complete⁪⁪",
                "PERSON_METADATA": "⁪⁪⁪‍‌‍​‌‌​​‍‌​​​​‌‍‍​‌​​‌​‍​‌‍‌‍​‌​‌‌​‌‍​‍⁪Person metadata⁪⁪",
                "PERSON_METADATA_EVALUATOR": "⁪⁪⁪‍‌​​​‍‍‍​​​‌‌​​​​‌‌‌‍​‌‍‍‍​​​​‌​‌​​​​‍‌‍⁪Evaluators⁪⁪",
                "PERSON_METADATA_SUBJECT": "⁪⁪⁪‌‌‌‌​‍‍‍‍‍‌​‌​‌‍​‍‌​‍​‌​‍‍‍‍‍​​‍‍​‍‌‌​​‍⁪Subjects⁪⁪",
                "PERSON_METADATA_VIEWER": "⁪⁪⁪‌​​‌​‌‌‌‍‍​‍​‌​‍‍‌‌‍‍‍​​‍‍​‍‍​‌‌​​​​​‌​‌‍⁪Viewers⁪⁪",
                "POSITIVE_GAPS": "⁪⁪⁪‍‍‍​‌​‌‍‍‌​​‍‌​‍‌​‍‍‌‌‍​​‍‌‍‌‍‌‍‌‍​‍​‍​‍⁪Hidden strengths⁪⁪",
                "PRIMARY_PARENTHESES": "⁪⁪⁪‌‌​‌‌‌‍‌‌‍‌‍​‌‍​‌​‍​‌​​‌​‌‌‌‌‌‌‍‌‍‍‌‍​‍‌​⁪(primary)⁪⁪",
                "QUESTIONS": "⁪⁪⁪‌‍‌‌‌​​‌​‍‍‍‌‍‍‌‌‌‍‌​‌​​​‌​‌‌​​‍‌​‍‍‍‌‍‌⁪Questions⁪⁪",
                "RADIUS": "⁪⁪⁪‌‌‌‌‌‍‍‍​‌​‍​‌​‍‌‌​‌‍‌​‌‍​‌​‍‍‌‍‌‍​‍​​​‍⁪Radius⁪⁪",
                "RANK": "⁪⁪⁪‍‍​‍‌‍‌‌‍‍​‌​​‌‍​‍‌​​​‍​‌‍‌​‍​‌‍‍‍‌‍​‍‌‍⁪Rank⁪⁪",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "⁪⁪⁪‍‌‍​‌​​‌​‍‍‍‍‍​​​‌‌​‍​‌​​‍​​‌‌‍‍‌‌‍​‍‌‌​⁪Highest score⁪⁪",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "⁪⁪⁪‌​‍‍‌‌‍​​​​‍‍‌​‍​​​​‍‍‌‍‌‌​‌‌‌​‍‍‍‍​‌‍‍‍⁪Highest scores⁪⁪",
                "RANKABLE_ITEMS_ITEM_HAS": "⁪⁪⁪‍​​‍‍‍‍​​‌​‍‌​‍‌‍​‍​​‌​​‌‍‍​‌​‍‍‍​​‌‌​​‌⁪Item has⁪⁪",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "⁪⁪⁪‌‌‌‍‌‍‌‍​‌‌‍‌‍​‌‍‌‍​​‍‌​‌​‍‌‍‍‌‌‍‍‍‌‌‌‍‍⁪Item is in top⁪⁪",
                "RANKABLE_ITEMS_LOWEST_SCORE": "⁪⁪⁪‌‌‌‌​‍‍​‌‍​​​​‍‌‌‌‌‍‍‍‌​​​‍‌​‍‍​‍‌​‌​​​‌‌⁪Lowest score⁪⁪",
                "RANKABLE_ITEMS_LOWEST_SCORES": "⁪⁪⁪‌​‌‍‌​‌​‌‍‌​​‍‍​‍‍‍‍‌‌​‌​​​‌‍‍‌​​‍‍​‌‌‍​‌⁪Lowest scores⁪⁪",
                "RATER_CATEGORY_DISPLAY_LOGIC": "⁪⁪⁪‍​‌​‌‌‍‍​​‍‍‌​‌​‍‌​‌​‍‍‍‍‍‌‌‌‍‍‌‌‌​‌‍‍​‌⁪rater category display logic⁪⁪",
                "RATIO": "⁪⁪⁪‌‌‌‌‍​‌‌‍‍‍‍​‌‍‍‍‌​‌‍‌‍‌‍‌‌‍​‌‌‍​‍‍‍‍​​​⁪Ratio⁪⁪",
                "RECORD": "⁪⁪⁪‍‍​‍‌​‍‍​‌​‌​‌​‍​‍​​‍‌​​​​‍​‌‍‌‌‌‌‍‍‍‌‌​⁪Record⁪⁪",
                "REFERENCE_GROUP": "⁪⁪⁪‌‌​‌​‍‌‌‌‍‌‍‍‍‍‌‌‌​‍‍​​​​‌​‍‌‍‌‌‍‌​‌‌‌​​⁪Reference group⁪⁪",
                "RELATIONSHIP": "⁪⁪⁪‌‌​​‍‌‍‍‌‍‍​‌‍​​​‍‍​‌‍‌‌​‌​‍​‌​​​‌​‍‍‍​‌⁪Relationship⁪⁪",
                "RELATIONSHIP_FILTERS": "⁪⁪⁪‍​‍‌​‌​‌​‍‍‍‌‌‌‍‌‌​‍‍​‍‍​‌‌​‌​‌‍‍‍‍​‌‍​​⁪Relationship filters⁪⁪",
                "RELATIONSHIP_FILTERS_INFO": "⁪⁪⁪‍​‍​​‍‍​​‍‌​​‍‍‌‍​‍‌‍‌‌‍‌‌‍‌​‌‌‍​‌​‍​​‌‌⁪To add a relationship filter (such as a direct report, peer, or manager), select Manage your filters, and use Relationship condition only from the drop-down menu.⁪⁪",
                "REMOVE": "⁪⁪⁪‍​‍‌‌‍‌‌‌‌​‌‍​‍‌​​‌‌‌​​​‍​​‍​‌​​‍‌‍​​​‌⁪Remove⁪⁪",
                "REMOVE_DATA_SOURCE": "⁪⁪⁪‌‌​​‍​‍​​​‌‍‍‍​‌​​​‌​‌‍‍‍‍​‌​​​‌​​​‌​‌‍​‌⁪Remove data source⁪⁪",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "⁪⁪⁪‌‍​‍‌‍‍‍​‌​‌​​‌‌‌‌‍‍​‍‌‍‌‍​‌‍‌‌​​​‌‍​​‍​⁪Remember, there are resources within your organization to help you interpret your feedback such as HR Partners, your manager, and/or a mentor.⁪⁪",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "⁪⁪⁪‍‍‍​‍​​‍‍‌​‍​​‌‌‍‍‍‍​​​‌‍‍​​‍​​‍​‍‌​‌‍​‍⁪Pour yourself a cup of coffee and dive into your feedback.⁪⁪",
                    "ABOUT_YOUR_REPORT_HEADER": "⁪⁪⁪‌‍​​​‍‌‍‍​‍‍‍‍​‌‍‌‌​‌‍‍‍​‍‍​‌‌‌‍‍​‌‍​‍​‌⁪About your report⁪⁪",
                    "ABOUT_YOUR_REPORT_LINE1": "⁪⁪⁪‌​‌​‌‍​​‌‍‍‌​‍‍‌​​‌‌‍‌‍‌‍‍‌‌‍​‌‌‌​‌‌‌‌​⁪Welcome to your 360 feedback report. This is a great opportunity to grow and develop yourself as a professional. In order to set yourself up for success when going through results, allow yourself sufficient time to go over the feedback. Feedback can be difficult to hear initially, but keep in mind that the purpose of this feedback is to accelerate your growth and development.⁪⁪",
                    "ABOUT_YOUR_REPORT_LINE2": "⁪⁪⁪‍‍‍​‍‍‌‍‍‌‍‍‌‌‌‌​‌​‌‌‍‌‍‌‍​​​‍​​​‍​​​‍​‍⁪As you go through your report, here are a few things to keep in mind.⁪⁪",
                    "ADVANCED_FILTER": "⁪⁪⁪‌​​‌‍​​‌‍​‌‌‍‍​‌​​‍‍‍‌‍​​‌‍‌‌‌‌​‌​‌‌‌​​‍‍⁪Advanced Filter⁪⁪",
                    "AGREEMENT_CHART": "⁪⁪⁪‍‍‍​‌‌​‍​‍‍‌​​‌‍​‍​‌‌​‍​‍​​​‌​‍‌‍‌‌‍​‌‌‍⁪Agreement chart⁪⁪",
                    "AGREEMENT_CHART_FOOTER": "⁪⁪⁪‍‌‌‍‌‌‍​​‍​​‌‍​‌‍‌‍‌‍‍​‍‌‌‍​‌‍‌‌​​​‍‍‌‌⁪The agreement chart indicates the similarity of scores. Each dot represents how individuals rated you for each item. The size of the dot shows how many raters gave you a specific rating.⁪⁪",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "⁪⁪⁪‌​‍​​​‍‍​‍​‍‍​​‌‍‍‌‍‌‍‌‌​‍‌​‍​‍​​‍‍‍​‌​​​⁪responses⁪⁪",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "⁪⁪⁪‌‌​​‍​​‍​‌​​​‍​‍‌‍‍‌‌​‍‌‍‌‌‍‌‌‍‍​​‍​‍‍‍‌‍⁪response⁪⁪",
                    "AGREEMENT_CHART_LEGEND_TITLE": "⁪⁪⁪‌‍‌‌‌​‌​‌‌‌‍​​​‍​‌​​‌​‍​‌‌‌‌‌‍‌‍‌‍‌​‍​‍​⁪How others rated you⁪⁪",
                    "ALL": "⁪⁪⁪‌‌​‍​‍‌​‍‍‍‍‌​‌‍‍‌​‍‌​​‍‌​‌‍‍‌‍‌​​‍‍‌‍​‌​⁪All⁪⁪",
                    "AVERAGE": "⁪⁪⁪‍‍‌‍​​‌​‌​​​​​‌‍‌​‍​‍‌​‌‍‌​‌‍​​​​‍‍​‌‌‍‍⁪Average⁪⁪",
                    "BOTTOM_BOX": "⁪⁪⁪‌‌​‌‌‍​‍​​​​‍​​‌​‌‍‍‌‍​‌​​‌‍​‌‍​‍​‌​​​‌‍‌⁪Bottom Box⁪⁪",
                    "CHOICE_COUNT": "⁪⁪⁪‍‍‌‍​‌​‍‍‍‍‌‍‍‍‌‍‌‌​‌​‍​​‌​​​‌‍‌​​‌‍​‌​‌⁪Choice Count⁪⁪",
                    "CHOICE_TOTALS": "⁪⁪⁪‌​​‍‌‍‌‌‍​​​‌‌‌‍‌‌​‍‍‍‌‌‍‌‍‌​‌‍​‍‍‍‍​‍‌​​⁪Choice Totals⁪⁪",
                    "COMPARISON": "⁪⁪⁪‍‍​‍‌‌​‍​​‍‌‌​‌‍​​‌​‍‌‌‍​‌​‌‌​​​‌‍‌‌‍​​‍⁪Comparison⁪⁪",
                    "COMPARISON_GAP_COLUMN_HEADER": "⁪⁪⁪‌​​‍‌‌‌‍‌​‍‌‍‌‌‌‍​‌‌‌‍‍‌​​‌​‌‍‌​‌​‍‌‍‌​‍‌⁪Comparison gap⁪⁪",
                    "COMPLETED_RESPONSES": "⁪⁪⁪‌‌​​‍‌‍‍​‌‌​‍‌‌‍​‌‌‌‌‌‌‍‌‍​‌‌‌‌​​‌‌‍‍‌‌⁪Completed responses⁪⁪",
                    "COUNT": "⁪⁪⁪‍‌‍‍​‍‍‌‍‌​‍‍​‍‍​‍​‌​‍​​​​‍‌‍​​‍‍‌‍‍​‌​⁪Count⁪⁪",
                    "DEFAULT": "⁪⁪⁪‍​‌‍‌​​‌‌‍‌‌​​​‌​‌‌‌‌‌​​‌‌‌​‌​‌‍‌‍‌​​‌​‍⁪Default⁪⁪",
                    "DEFAULT_TEXT": "⁪⁪⁪‌‍‍‌‍‌​‍‍‍‌‌‌‌‍​‍‌​‌​‍​‌​‍‍‍​‍‌​‍‍‍‌​‌​⁪Default text⁪⁪",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "⁪⁪⁪‌​​‌​‍​‍‍‌‍‍‌‍‍​‍‍‌‌‌​‍‍‌‍‌​‍‍‌‌‍​‌‍​​​​​⁪Understand who your feedback is coming from, whether it’s peers, direct reports, leaders, etc⁪⁪",
                    "DIFFERENT_EVALUATORS_HEADER": "⁪⁪⁪‌​‍‌​‍​‍‌​‌​‌‌‌‍​‍‍​‍‌‍​‍​‍‍‌​‌‍‌‌​‍‌​‍‌​⁪Different evaluators⁪⁪",
                    "DONE": "⁪⁪⁪‌‌​‍‌‍‌‍​​‌​‌‍‍​‌‌‍‍​‍‌‌‌​‍​‌​​‌​‍‌‍​​‌‌‌⁪Done⁪⁪",
                    "DONT_HEADER": "⁪⁪⁪‌​‌‍​​​​‍​​​‌​​​​​‌​​‌​​‌‌‍‍‌‍‌‍‌‌‍‍‍‌‌‌⁪Dont:⁪⁪",
                    "DONT_LINE1": "⁪⁪⁪‍​​‍‍‌​‍‍‍‍‍‌‌​​​​‍‍‌‍​​‌​‌​‌​‌‍‌‌‍‍‍‍‌⁪Try to figure out who said what⁪⁪",
                    "DONT_LINE2": "⁪⁪⁪‍‌​‌​‌‌‌‍‍​​‌​‌​‌‍‌‍​‌‍‍‍​‌‌​‍‌​​​‌‌​‌‍‍⁪Focus on one positive or negative score/comment⁪⁪",
                    "DONT_LINE3": "⁪⁪⁪‌​‌​‍‍‍‍​‍‌‌​​‌​‍‍‌​‌‍‌‌‌‌‌‍‍​​​‌‌​‌​‍​‌⁪Create a development plan around every item⁪⁪",
                    "DONT_LINE4": "⁪⁪⁪‌‌​​‌‌​​‌​‍‌​​‍​‍​​​‍​‍‍‌‌​​‍​‌‍​‌‍‌​​‌‍‍⁪Be discouraged that you have opportunities for improvement⁪⁪",
                    "DO_HEADER": "⁪⁪⁪‍​​‌‍‍​​‍​‌‌​‌​‍​‍‌‌‌‍‌‍​‍‌‌‍​‍‍‍​‌‌​‍‌‍⁪Do:⁪⁪",
                    "DO_LINE1": "⁪⁪⁪‍​‌‍‌​​​‍‍‌‌‌​‌​‍​‌‌‍​‍‌‌‍​​​​‌‍‍‌‍‍‍​‌​⁪Look at feedback holistically⁪⁪",
                    "DO_LINE2": "⁪⁪⁪‌‌‍‌​‍‍​​​‍​‍‍‍‍‍‌‍‍‍‍‌‌‍​‌‍‌‌‌‌‍‌​‌‍​​‌⁪Identify themes in strengths and opportunities for improvement⁪⁪",
                    "DO_LINE3": "⁪⁪⁪‌‌‌‍​​​‌​​​‍‌‍‍‍‍‍​​‌‍​‌​​‍‍‍‍​‌‍‍‌‍​‌‍⁪Prioritize a few focus areas to add to your development plan⁪⁪",
                    "DO_LINE4": "⁪⁪⁪‍‌​​‍‌‌‌​‌‌‌​‍‍‍‍‌​‍​​‍​‌‍‍​​‌‌‍​​‌‍​‍​‍⁪Understand that everyone has opportunities for improvement⁪⁪",
                    "FIELD": "⁪⁪⁪‌​‍​‌‌‌‌‌​‍​‍‌‌‌​​‌​‌‌​​‌‍‌​‌‌​‌‌‍‍​​‌​‍‌⁪Field⁪⁪",
                    "GAP": "⁪⁪⁪‌‌‍‌‌‍​‍‌​‌‍‌‍​‌​‍‍‌‍‌‍‌​‍‌‍‍​‍‌​​‍‌​‌‌​⁪Gap⁪⁪",
                    "GAP_CHART": "⁪⁪⁪‌‌​​​‍‌‍‍‍‌‍‍‌​‌‌‌‍‌‌‍‌‌‍‌‍‌‌‍‍‍‍‍‌‍​‍​​‌⁪Gap chart⁪⁪",
                    "GAP_CHART_DESCRIPTION": "⁪⁪⁪‌​​​​‍‍‍‍‌‍‍‍‍‍‍‍​‍‌​‍‍​​​‍‍‌‍​‍​‌​‌​​‌‍​⁪The gap chart displays the difference in scores between two rater groups. For example, in the case of self-ratings vs. how others rated you, a positive(+) difference means others rated you higher than the rating you provided for yourself. A negative(-) difference means others rated you lower than you provided for yourself.⁪⁪",
                    "GAP_CHART_FOOTER": "⁪⁪⁪‌‌‌​‌​​​​‍‌‍‌‌​‍​‍‌‍‌‍‍‍​‌‌​​‍​‌‍​‌​​​‌‌⁪The gap chart indicates the +/- difference between two rater groups.⁪⁪",
                    "GAP_TABLE_DESCRIPTION": "⁪⁪⁪‍‌‌​‌​‍‍‍‌‍‌‌‍‍‌​‌​​​‌​‍‍‍‍‍‍‍​‍‍‌‍‍​‌‍‍⁪Hidden strengths shows where others rated you higher than you rated yourself. Areas for improvement shows where others rated you lower than you rated yourself. Both sections are ranked from largest to smallest gap.⁪⁪",
                    "GAP_TABLE_FOOTER": "⁪⁪⁪‌​‍​‍​‌​‌‍‌​‌​‍‌‌‌‌​​‌‌​‌‍‌​‌‍‌‌‍‍‍‌‍​‌‍​⁪The first column of scores indicates how you scored yourself. The second column indicates the average score of others. The third column indicates the difference between how you scored yourself and how others scored you.⁪⁪",
                    "GAP_TABLE_TITLE": "⁪⁪⁪‌‌​‍​​​‍‌​‍‌‍‌​‌​‌‌‌​‌‌​​​‍​‍​​‍‌‍‌​‌‌‍‍​⁪Hidden strengths/Improvement areas⁪⁪",
                    "GROUP": "⁪⁪⁪‌​‌‌‌‌​‌‍‍‌‌‌‍​‍​‌​​‍‍‌‌‍​​‍​‍​‌​​​‌​​​‌⁪Group⁪⁪",
                    "HIDE_REPORT_ALERT": "⁪⁪⁪‌​‍‍‍‍​​​​​‍‍‍‍​​​‌​​‍‍‌‌​‍‍​​‌‌‌​‌​‌‌‌​⁪You do not meet the requirements to view your report. Contact your organization administrator.⁪⁪",
                    "HIGHEST_SCORES": "⁪⁪⁪‍​​​‍‍‍‌​​‍‌‌​​‌​‌‌‍‌​‌‍​‌​‍‌‍​‍‍‌​‌‍​‍​⁪Highest scores⁪⁪",
                    "HIGHLOW_TABLE": "⁪⁪⁪‌​‍‌​‌‌‌‍‌‍​​‌‍​‌‍​‍‍‌​‌‌‌‌‍‌​‍‍‍​‍‍‌‌⁪High and low scores⁪⁪",
                    "HIGHLOW_TABLE_FOOTER": "⁪⁪⁪‌‌​‌‌‍​‍‌​​‌‍​‌​‌‌‌‌‍​‌​​‍​‌​‌​​‍​‍‌​‌​​‌⁪This section shows the five highest and lowest rated behaviors (across all behaviors) from the applicable rater category averages. To get the most from this page, it is helpful to look for trends that may emerge. For example, if the majority of your lowest rated behaviors are concentrated in one or two categories; these may be areas in need of development. The highest rated behaviors can identify strengths that can be leveraged in other areas.⁪⁪",
                    "HIGH_LOW_TABLE_DESCRIPTION": "⁪⁪⁪‍​‌​‌‍​‌‍‍​‍‌‍‍‌​​‍‌‍‍‍​‌‍‌‍‍​‍‌‌​​​​‌​‍⁪The high/low chart displays items based on the areas where others rated you highest and lowest.⁪⁪",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "⁪⁪⁪‌​‌​‌​‍​‌‍‍​‌‌‌‌​‍‍‍‍‌‌‌​‍‌‌‍​‍‌‌‍​‌‍‍‍‍​⁪How to interpret results and determine action:⁪⁪",
                    "ITEM": "⁪⁪⁪‌​‍‍​​​​​​‌​‍​‍‍‌‍‍‍‍‌​‍‌​‌‌‌‍​‌‍‌‌​‌‌​‌⁪Item⁪⁪",
                    "LOWEST_SCORES": "⁪⁪⁪‍‍​‌‍‌​‍​‌‍‍​‌‌‍​‌​‌​​‍‍‍​‍‍​‍​​​‍‍‍‌‌‍‍⁪Lowest scores⁪⁪",
                    "MAX": "⁪⁪⁪‍‍‌‍‌​‍​‍‌‍​‍​‍​‍​‍‍​​‍‍​​‌‌‌‍‍​‌‍‍​‌‌‍‍⁪Max⁪⁪",
                    "MEAN": "⁪⁪⁪‌​‍​‍‌‌‌‌‌‌​‍‌‍‌‍​​‍‍​‌‍​‌‍‌‍‌‌​‌‌‌‍​‍‌​​⁪Mean⁪⁪",
                    "MEDIAN": "⁪⁪⁪‌‌​​​‌‌‍​‌​‍​‍​‌​​‌‍​‌‍‍‍‍‌​​‍‌​‍‌​​‌‍‌‍‌⁪Median⁪⁪",
                    "MIN": "⁪⁪⁪‍​​​​‌‌‍‍‍‍​​‌‍​​‍‍‍‌‍‍‌‌​‍‌‍‌​‌​‍‌‌‍‍‍​⁪Min⁪⁪",
                    "NEGATIVE_GAPS": "⁪⁪⁪‌​‍​‌​‍‍‌‍‍​‌​​‌‌‌‌‍‌‍‍‌‍‍​‌‍‌‌​​​‍‌​‌‍‌⁪Areas for improvement⁪⁪",
                    "NO_COMPARISON_SET": "⁪⁪⁪‍‍​​​​‍‌‍​​​‌‌‍​‍​‍‌‍​​‌‍‌‌​‌‍‌‍‍‍‌‌‍​‌⁪No comparison set⁪⁪",
                    "NO_DATA_AVAILABLE_WARNING": "⁪⁪⁪‌​​‌‌‍‍​‍​​‌​‌‌‌‌‌​‌‌‍‌​‍​​‍‍‍‍‌‍​​​‍​‌‌‍⁪No data available⁪⁪",
                    "NO_FILTER_IS_APPLIED": "⁪⁪⁪‌‌​​‍‍​​‍‌​​‌‌​​‍‍‍​‍‍‌‍​​​‍‌‌‍‌‍‌‌‌‍​​‍​⁪No filter is applied.⁪⁪",
                    "NO_VALUE": "⁪⁪⁪‌​‌‌​​‌‌‌‍‍​​‍‍‌‌‌‍‍‌‍‍‌‍‍​‍‌‌‌​‌‌‌‌‌‍​‍‌⁪No value⁪⁪",
                    "NPS": "⁪⁪⁪‌​​‌​​‍‌‍‍​​​‍‌‍​​‍‌‌‌‌‌‌‌​‌‍‌‌​​​‍‌‍‍‌‌‌⁪Net Promoter Score⁪⁪",
                    "OTHERS": "⁪⁪⁪‌​‌​​​‌‌‌‌​‍​‍​‍‍‍‌‌‍‌‌​​‌​‌​‍​​​‌‍‍​‌​‌‍⁪Others⁪⁪",
                    "PERCENTAGE": "⁪⁪⁪‍‍‌‌‍‍‍‍‍‌‌​​‌‌‍​‌​‌‍‍​‍‌‌‌‍‌‌‍‍‌​‌‌​‍‌⁪Percentage⁪⁪",
                    "PERCENTAGE_OF_CHOICES": "⁪⁪⁪‌‍​‌‌‌​‌‍‍‌‍‍‍‍‍‍‌‌‌‍‌​​‍‌‍​‌‍‌‍​‌​‍‍​​‌⁪Percentage of Choices⁪⁪",
                    "PERCENTAGE_OF_RESPONSES": "⁪⁪⁪‌​​​​‍‍‌​‌‍‍​‌​​‍‍‌​‌‌‍​‍​‍‌‍‍​‌‍‌‍​‍‌​‌‍⁪Percentage of Responses⁪⁪",
                    "PERCENT_COMPLETE": "⁪⁪⁪‌​​‌‌​‌​‍‍‍‍‍‍​‍‍‍‍​‌‍​‍‍​‍​​‍​‌‍​‍​‍‌‌‌​⁪% complete⁪⁪",
                    "POSITIVE_GAPS": "⁪⁪⁪‌‌​​​‌‌‌​‍‍​​‍​‌​‍‍​​​​‍​​‍‌‍​​‌​‍​‍‍​​​⁪Hidden strengths⁪⁪",
                    "QUESTIONS": "⁪⁪⁪‌‌‍‌​‍‍‌​​​​‍​‌‍‍​​‍​​‌‌‌‌‌‌​‌​‌​‌‍​​​‌​⁪Questions⁪⁪",
                    "RANK": "⁪⁪⁪‌​‍​​‍‍‍‍‍‍‌‍‌​​‍‌​‌‍‍‌​‍‌‍‍​‌​‌‍‍‍‍‍‌​‌​⁪Rank⁪⁪",
                    "RELATIONSHIPS": {
                        "ANYONE": "⁪⁪⁪‍‌‌​‌‍​‌‍‌‍‌‍‍​​‌‍‍‌​​​‌‌​​​​​‌​‌​‍‍‍‌​‍⁪Anyone⁪⁪",
                        "DIRECT_REPORT": "⁪⁪⁪‍‌​‌‍‌‍‍‍‍‍​‍‍‍‌​‍‌​‌​‌​​​‍‌​‍‌‌‌‌​‍‍‍​‍⁪Direct Report⁪⁪",
                        "MANAGER": "⁪⁪⁪‍‍​‌‍‌​​​​‍‌‌‌‌‍‍‌​‌‌​‌​‌​​‌‍‍‍‌‍‌​‍‍​‌⁪Manager⁪⁪",
                        "PEER": "⁪⁪⁪‌‌‌​‍‌‌​​‍​‍​‌‍‌‍‌​‍​‍​‍‍​‍‍​​​‌‌​‌​‍​‍​‍⁪Peer⁪⁪",
                        "SELF": "⁪⁪⁪‌‌​‍‌‍‍​‍‍‌‌‌​‌​​‌​‌​‌​‍‌‌‌‍‌‌​‌‌​‍​​‍⁪Self⁪⁪"
                    },
                    "REPORT_SUMMARY": "⁪⁪⁪‌‌​‌‍‍‌‌‍‌‍​​‍​​​​‍‌‍‍​‍​‌​‍‍​​​‍‍‍‍​‍​‍‌⁪Report summary⁪⁪",
                    "REPORT_SUMMARY_TABLE_FOOTER": "⁪⁪⁪‌​‌​​‌‌‌​‍‍​‌‌‌​‌‌​‍​‌​‍​‌​‍​‌‍‍‍‌‌‌‍​​‍‍⁪Compare the number of people who finished your assessment to the number of people invited to participate.⁪⁪",
                    "REPORT_SUMMARY_TABLE_HEADER": "⁪⁪⁪‌​​​​​‍​‌‌‍​‍‌‌‌​​‍​​​​‍‌‍​​​‍‍‍‌‌‌​​​‌⁪Respondent statistics⁪⁪",
                    "RESPONSES": "⁪⁪⁪‌​​‍​​​‍​‌‌​‌​‌‌​‍‍‍​‌‌‍‌‌‌‌​‌​​‌​‍‌‌‍‌‌‍⁪Responses⁪⁪",
                    "RESPONSE_COUNT": "⁪⁪⁪‌​​‌‍‌‌‌​‍‍‌​​​​​‍‌‍‍‍​‌‌‌‌​‌‍​​‍‍​‍‍‍​‌⁪​​​{{responseCount}}‌‌‌ Responses⁪⁪",
                    "RESPONSE_COUNT_HTML": "⁪⁪⁪‌‍‍​‍​‍‍‌‌‌‌‌‍‍‌​​​​‍‍‌‌​‌​​‍​‌‍​‌‌‌‌‍‌‍⁪​​​<span class='response-count-value'>‌‌‌​​​{{responseCount}}‌‌‌​​​</span>‌‌‌ Responses⁪⁪",
                    "SCORING_CATEGORY": "⁪⁪⁪‌‌​‍‌​‌​‌​‍‍‌‍‌​​‌‌​‌‍​​‌‌​‌​‍‌‍‌‌‌‌‍‍​‌‌⁪Scoring category⁪⁪",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "⁪⁪⁪‌‌‌‌‍‌‍​‍‍‌‍‌‍‌​​‍​‍‍‍​​​‍‍‌‌‍‌‌‍‌‌‍‌‍‌‌⁪No responses for this category⁪⁪",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "⁪⁪⁪‍‌​‍‌‌‌‍‍‌​‌​‍​‌‌‍‌​‌​‍‍‌‍‌‌​‌‌‍​​​​‌‌‍​⁪No responses for this question⁪⁪",
                    "SCORING_OVERVIEW": "⁪⁪⁪‍​‌‌‍‍‌​‌‍‌‌​​‌‍​​‍‌‍‍‌‌‌‌‌​‍‌​‌​‍‍‍‌‌‌​⁪Scoring overview⁪⁪",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "⁪⁪⁪‌​‍‍​‌‍​‌‌‍‌‌​​​​‌‍​‍‌​​‍‌‌​‍‍‌‍​​‍‌‍‍‌⁪You and other evaluators think this area is a top strength.⁪⁪",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "⁪⁪⁪‌​‍‍‌‌​‍‍‌‌‌‍​​‍‌‍​‍‌​‌‌‌​‌‌​​​​‌‌‌‌​‍​⁪Recognized strength⁪⁪",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "⁪⁪⁪‍‍​‍‍​‍​​‌‌‌‍​​‌‍‌‍​‍​‌‌​​‍‌‌‌‍‌‍‌‌‍‌‌​‍⁪A recognized improvement area means self-rating and ratings from others are both below the average for this competency.⁪⁪",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "⁪⁪⁪‍‍‌‍‍‌‍‍‍‍​‌‍‌‍‌​​​‍‌​‌‌‍​‌‍‍‍‍‌‌‌​‌‌‍‌‌⁪Recognized improvement area⁪⁪",
                    "SCORING_OVERVIEW_DESCRIPTION": "⁪⁪⁪‍​‍‍​‍‌‌‌‍‌‍‌‍​​​‍‍​‍‍​‍​​‍​​‍‌‌‌​‍​‍‌‌⁪Above are the competencies or behaviors that you were evaluated on as a part of this multi-rater feedback process. Comparison ratings are provided by group.⁪⁪",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "⁪⁪⁪‍‍‍‍​‍‌‌​‍‍‌​‍​​‍‍‌‍‌‌​‍‍‍‌‌​​​‌‌‌​‌‍‍​‍⁪Minimum gap⁪⁪",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "⁪⁪⁪‌‌‌​​‍‌​‌​‌​‍​‍​‌‍​​‌‍‍​​​‌‌‍​‍​​‌​‌‌‍​‍‌⁪Minimum difference between reference groups for texts to be shown.⁪⁪",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "⁪⁪⁪‍‌‍‌‌‌‍​​‌‍‌‌‌​​‍‌‍‌‌‍‍​​‌‌‌‌​‌‍‍‌‌‌‌‌‍​⁪Displayed is the range of scores for each competency/behavior. The bar represents the numerical average.⁪⁪",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "⁪⁪⁪‍‌‍‌‍‌‍‌​​‍​​‌‌‌‍‌‍‌‍‌‌‍​​‍​‍‍‌​‍‌‍‌​‍​‍⁪Unrecognized strength comes from discrepancy between the self-rating and the ratings from others.⁪⁪",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "⁪⁪⁪‍​‍‍‌‌‌‍​‌​​‌‍‌‌‌‌‌​​​‌‌​​‌‍‌‍‍‍‌‌‍​‌​​⁪Unrecognized strength⁪⁪",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "⁪⁪⁪‌‍‍‍​​​​‍‍​​‌​‍‌‍‍‍‍‌‍‌​‌‌‌‌‍‍‍‍​​‌​‌‌‌‌⁪Unrecognized improvement area comes from discrepancy between the self-rating and the ratings from others.⁪⁪",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "⁪⁪⁪‌‌‌‍‍‌‌‍‍​‌‌​‍​‌‍​‌​‌‍‌‌‍‌‌‍​‌​‌​‍‌‌‍‌‌​⁪Unrecognized improvement area⁪⁪",
                    "SELF": "⁪⁪⁪‌‌​‍‌‍‌‍‌​‍​‌​‌​‌​‍​‌‌​‍​‌‍​‌​‍‍​​‌​​‌‍​​⁪Self⁪⁪",
                    "SELF_ASSESSMENT": "⁪⁪⁪‍‌‍​‌​‌‍‌‌​‍‌​‌​‍​​‍​​‌‌‍‍‌​​‍‌‍‌‍​‍‌​‌​⁪Self-assessment⁪⁪",
                    "STANDARD_DEVIATION": "⁪⁪⁪‌​‌‍‍‍‌‍‌‌‍​‍​‍​‌‍​​​‍​​‌​​​‍‌​​‍​‌‍‍​‌‌​⁪Standard Deviation⁪⁪",
                    "SUM": "⁪⁪⁪‍‍‍​​‌​​‍​‍‌​‌​​​​​​‍​​​‌‌​​‌‍‍​​‌‍‍‍​‍‌⁪Sum⁪⁪",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "⁪⁪⁪‌‍‍‍‌‌‍​‍‌‍‌‌‍‍‍‍‍‌​‌​‌​‍‍​‍‍‍‍‌‌‌‌​​‍​‍⁪Familiarize yourself with the rating scale to ensure accurate interpretation⁪⁪",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "⁪⁪⁪‌​​‍​​​‍‌​​‌‌‍‍‍‌‍‌‌​‍‍​‍‌​​‍‍‍​​‌​​‌​‍​​⁪Take note of the scale⁪⁪",
                    "THINGS_YOU_WILL_SEE_HEADER": "⁪⁪⁪‌‍‌‍‌​‌‌‌​‌​​​​​​‍‌​‌​‌‍​‌‍​‍​‍‌‍‌​‌‍‌​‌⁪Things you will see:⁪⁪",
                    "THREE_SIXTY_PERCENTILE": "⁪⁪⁪‍​​​‍​​‍‌‍‌‌‌‍​​‌‌​​‍‌​‍​​‌‌​‍‍‍​​​​‌‌‌‍⁪Percentile⁪⁪",
                    "TOP_BOTTOM_BOX": "⁪⁪⁪‌‍​‌​‌‍​‍‌​‌‍​​‍​​​‌​​​‍‍‍‌‌​‌​​‍‌‍‌‌​‌‍⁪Top Box / Bottom Box⁪⁪",
                    "TOP_BOX": "⁪⁪⁪‌​​‌‌‍‌‌‌‌‌‌‍‌‌​‍‍‌​‌‌​‌‌‍‌‍‍‍​​​​‌‌‌‌‍​​⁪Top Box⁪⁪",
                    "TOTAL": "⁪⁪⁪‌​‌​‌‍​‍‍‍‍‍‍‌‍‌​​‌​‌​​​‌‍‍‌​​‍‍​​​​‌‌‍​​⁪Total⁪⁪",
                    "TO_DO": "⁪⁪⁪‌‍​‍‌​‍​​​‍​‌​‌‌​‌‍‍‍‍‍​​‍​‌‍​​​​‌‍‍‌​‌‌⁪To do⁪⁪",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "⁪⁪⁪‌​‍‌‍​​​‌​‌​‍‌​‍​​​‍​‌‌‍‍​​‍‍‍‌‌​‌‍‍‍‍‍‍⁪Qualitative: This feedback will be in the form of open text comments⁪⁪",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "⁪⁪⁪‌​‌‍‌‍‍​​‍​‌‍‌​‍‍‌‌‍​‍‌‌‌​‍​‌‍‍‌‍‌​‌‌​‌‌‌⁪Quantitative: This feedback will be numerical, and could be represented in graphs, bar charts, tables, etc.⁪⁪",
                    "TYPES_OF_FEEDBACK_HEADER": "⁪⁪⁪‌​‌‍​​‍​‌‍‌‌​‍‍‍‌‌‌‌​​‌‍‍‍‍‍‌‍‍​​‌‍‍‍​‍‌⁪Various types of feedback⁪⁪",
                    "VALUE": "⁪⁪⁪‍‌​‌‍‌‌‌‌‍‌‍‌‍‌​‌‌‌​‍​​‍​​‍‍‌​‌‍​‍​‍‌‍‌⁪Value⁪⁪",
                    "VARIANCE": "⁪⁪⁪‌​​​‌​‍‍​​‌​‌‍‌‍​‌​‌‌‍‌‍​‍‍‍‍​​‌‌‌‍​‌‍‌​‌⁪Variance⁪⁪",
                    "YOUR_RATINGS": "⁪⁪⁪‌​​​​​‍‍‍‍‌‌‍​‌‌‌​‌‍‍‍‌‍​‍‍‌‌‌​‌​​‍‍​​​⁪Your ratings⁪⁪"
                },
                "REPORT_SUMMARY": "⁪⁪⁪‌​​‍​‍​​​‍‌‍‌‍​‍‌‍​‍‌​‌‌‍​​​‍‌‌‍​​‌‌​‌​‍⁪Report summary⁪⁪",
                "REPORT_SUMMARY_TABLE_FOOTER": "⁪⁪⁪‍‌​​​​​‍‌‍​‌‌‍‌‍​‍‌‌​‍‍‌‍​‍​​‍​‍​‌​‌‍​​⁪Compare the number of people who finished your assessment to the number of people invited to participate.⁪⁪",
                "REPORT_SUMMARY_TABLE_HEADER": "⁪⁪⁪‍​‌‍‍​​​‌​‌‌‍‌​‍‌‍​‍‌‌‍​‍‍‌‌‍‌‌‌‍​​​‌‍​‌⁪Respondent statistics⁪⁪",
                "RESET": "⁪⁪⁪‌​‌‌​‍‍‌​‍‍‍‌‍‌‌‌‌‌‌​‌‍‌‌‌‍​‍​‌​‌​‍‍‍‌​‍⁪Reset⁪⁪",
                "RESPONDENT_TOTALS": "⁪⁪⁪‍​‍‌‍‍‍‌​‍​‍​‌​‍‍‌​‌​​‌​‌‍‌‌‍‌‍​​‌‍‌​‍​​⁪Respondent Totals⁪⁪",
                "RESPONSES": "⁪⁪⁪‌​‍‍‌​‌‌‌‌‍‍‍‍​‍​​​‍​​​‌‍‌‍‌‍​‍​‍​‍‌‍‌‍‍‍⁪Responses⁪⁪",
                "RESPONSE_COUNT": "⁪⁪⁪‌​​​​‌‌​​​‍​‌‍‍‌‍​​‌‌‍​‍​‌‍‌‌‍​‍‍‌‍‌​‌‌​‍⁪​​​{{responseCount}}‌‌‌ Responses⁪⁪",
                "RESPONSE_COUNT_HTML": "⁪⁪⁪‌‌‌​‍‌‌​‍‍​​‌‍‌‌​‌​​‍‍​‍‍‍‌​‌‌​‍‌‍‌​​​‌‍‌⁪​​​<span class='response-count-value'>‌‌‌​​​{{responseCount}}‌‌‌​​​</span>‌‌‌ Responses⁪⁪",
                "RESULT": "⁪⁪⁪‍​​‌‍‌‍‌‍‍‍‍‌‌​‍‍‍​​‍‌‍‍‌​‌‌​‍‍‍‍​​​‌‍​‍⁪Result⁪⁪",
                "REVERSE_COLORS": "⁪⁪⁪‌​​‌‌‌‍‍​‌‍​‌‍‌​​​​‌​‌‍​​​‌‌​‍‌‍‌‍‍​‍‌‍​​⁪Reverse Colors⁪⁪",
                "ROW_TOTALS": "⁪⁪⁪‌‌‌‍‍​​​‌​‍‌‌​‌‌‌​​​​​‍​‍‍‌​‍​‌​‌‍‌​‌‌‌⁪Row Totals⁪⁪",
                "SAVE": "⁪⁪⁪‍‌‍‍​‍​‍‌​​‌‍‍​‍‌​​‍‌​‌‍‌‍‍‍‍‍‌​​‌​‌​‍‌‍⁪Save⁪⁪",
                "SAVE_AND_APPLY": "⁪⁪⁪‌​‍‌‌‌‍‍​​‍‌​‍‍‍​‍​‌‌​‌​​‌​‍‌‍‍‌​‌​‌‌‍​‌​⁪Save and apply⁪⁪",
                "SCORING_CATEGORY": "⁪⁪⁪‍‍‍‌‌‍​‍‍‍‌​​‍​​‍‍‍‌‍​‍​‍​‍‍​‍‍​​‍‍‌‍​​‌⁪Scoring category⁪⁪",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "⁪⁪⁪‍​​‌‍​​​​‌‍​​‌‍‍‍​​‌​​‌‍​​‌​​‌‌‍​​​​​​‌⁪No responses for this category⁪⁪",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "⁪⁪⁪‌​‍​​‌‌​‍‍‍‍‍‌‌‍‍​​‌‌​‍​‌‌‌‌‌‍‍‍‌‌​‍​‍‍‍⁪No responses for this question⁪⁪",
                "SCORING_OVERVIEW": "⁪⁪⁪‍​‍‍‌‌‌‍‍‌‍‌‍‍‍‍‌​​​‍​​‌‍‍‌‌​​‍​​‍‌‍​‌‌⁪Scoring overview⁪⁪",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "⁪⁪⁪‌‍‍‍‍‌​​‌‌‌​‌‌‌​‍​‍‌​‌‌‌‍‌‍​‍‌‌‌‍​‍‌​‍​‍⁪You and other evaluators think this area is a top strength.⁪⁪",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "⁪⁪⁪‌‌‌‌​​‌‍​‍‌‌​​​‌‌‌‌​‌‌‍‌​​​‌​‌‌​‍‍​‌​‌‌‍⁪Recognized strength⁪⁪",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "⁪⁪⁪‌​​​​‍‌​‌‍‌​‌​‍‌‌‌‌​‌‍​​‍​‌‌‍‍‌‍​‍‍​‌​​​​⁪A recognized improvement area means self-rating and ratings from others are both below the average for this competency.⁪⁪",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "⁪⁪⁪‌​​‍​‍‌‍‍​‍​‌‍​‍‌​‌‍‌​​‍‌‍​‌​​‍‍​‍‍​‍‌‌‍⁪Recognized improvement area⁪⁪",
                "SCORING_OVERVIEW_DESCRIPTION": "⁪⁪⁪‌​‌​‌​​​‌​‍‍‌‍​​‍​‌‍‌‌‍‍‌‌​‌‍‍​‍​​‌​​‍‌‌⁪Above are the competencies or behaviors that you were evaluated on as a part of this multi-rater feedback process. Comparison ratings are provided by group.⁪⁪",
                "SCORING_OVERVIEW_MINIMUM_GAP": "⁪⁪⁪‌​​‌​‍‍‍‌‌‍‍‌‌‍‍‍‍‍‍‌‌​‍‌‌​‍‌‍‍‍‍‌‍​‌‍​‌‌⁪Minimum gap⁪⁪",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "⁪⁪⁪‌​​​‍‌‍‍‍‌‍‌‌‍‍‍‍‌‍‌​‌‌‍​‌​‍‍‌‍‍‍‌​​‌‍‍‍‍⁪Minimum difference between reference groups for texts to be shown.⁪⁪",
                "SCORING_OVERVIEW_TABLE_FOOTER": "⁪⁪⁪‍‍​‌‌‌​‍​‍‍​​‌‍​‍​‌​‌​​​‍‍‍‍‍‍‍‍‌​​‌​​‍‍⁪Displayed is the range of scores for each competency/behavior. The bar represents the numerical average.⁪⁪",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "⁪⁪⁪‌​​​​‌‌‌​​‍​‍‌‍‌​​​‍​‌‌‍‌‍‌‍​​‌‌‍‍‍‍‌‌​⁪Unrecognized strength comes from discrepancy between the self-rating and the ratings from others.⁪⁪",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "⁪⁪⁪‌​‍​​‌‌‍‍‌​‌‍‍‍‌​​​​‍​​‌‌‍​‌‌‌‌‌‍‌‌‍​​‌​‍⁪Unrecognized strength⁪⁪",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "⁪⁪⁪‌‌​​​‌​‍‌‌‌​​‍‍‍‍‍​​​​‍‌‍‌​‍‌​​‍​​​‍​‍​​​⁪Unrecognized improvement area comes from discrepancy between the self-rating and the ratings from others.⁪⁪",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "⁪⁪⁪‌​‍‌​​‌‍‌‌‍‌‍‌‍‌​​​‌‌​‌‌‌‌‌‍​‌​‍​‌‌‌‍​‍​⁪Unrecognized improvement area⁪⁪",
                "SELECT_CATEGORIES": "⁪⁪⁪‌​‍‍‍‌‌‌​‍‌‍‌‌​​​‌‍‌​‍​‌‌‍‌‌‍‍‍​‌‌‍‌‍‌‍‌‌⁪Please select Scoring Categories...⁪⁪",
                "SELECT_CATEGORY": "⁪⁪⁪‌‌​‍‌​​‌​‌​‍‍​‍‍‍‌‌‍‌‌‌‍​​​‌‍‌​‍‌‌​​​‍​⁪Please select a Scoring Category...⁪⁪",
                "SELECT_CONDITION_TYPE": "⁪⁪⁪‍‌‌‌​​‍​​‍​​‌‌​‍‍‌‍‍‌‍​‌​​​​‌‍‌‌‌​​‌‌​‌‌⁪Select condition type⁪⁪",
                "SELECT_DATA_SOURCE": "⁪⁪⁪‌​‍​‌​​‍‍‍‌‌​​‌​‍​‍​​​‌‍​​‌‌‌‌​‌‍‍​‍‍‍​​⁪Select data source⁪⁪",
                "SELECT_DATA_SOURCE_TYPE": "⁪⁪⁪‌​‌‍​‌‌‌‍‌‌‍‍‌​‌‍‌​​‌‌‌​​​‍‍‌‍‌​‌​​‌​‍​‌⁪Select data source type⁪⁪",
                "SELECT_FILTERS": "⁪⁪⁪‌​‍​‍‌‍‍‍‌​​‍‌‍‌‌‌‍‍‍‌​‌‌‍‍​‍‍‌‍‌‌‌‌‍‍​‌‍⁪Select filters⁪⁪",
                "SELECT_OPERATOR_TYPE": "⁪⁪⁪‌​‍‍‍‌‍​‌‌‍​​‌‌‍‌‍​‌‌‌‌​​‌​‍​‍‌​‌​​‌​​‌​‍⁪Select operator type⁪⁪",
                "SELECT_PERSON": "⁪⁪⁪‌​‍‌‌‍‍‌​‍​​‌‍​​‌‌‍‍‍​‌​‌‌​​​‌​‌‌​‍‌​‌‌‌‌⁪Select person⁪⁪",
                "SELECT_PERSON_METADATA": "⁪⁪⁪‌‌‌‌‍​​‍‍‌‍‍​‍​‍‍​​​‍‌‍‍​‍‍‌‌‌​‌​‍​​‌‌‌‌‌⁪Select person metadata⁪⁪",
                "SELECT_QUESTION": "⁪⁪⁪‌‌‌‌‍‌‍‍‍‌‍​‌‌‌‌​​‌‍‌‍​‌​‌‍‍‌​‍‌​‌‍‌​‌​‍‌⁪Select question⁪⁪",
                "SELECT_QUESTIONS": "⁪⁪⁪‌‌​‍​‌‌​​‍‍​​‌‌‌‌‍​​​​‌​‌‍‍​‍‌​​‍​‌​‌​​‌‌⁪Please select Questions...⁪⁪",
                "SELECT_RATIO_OR_DROPOFF": "⁪⁪⁪‌‌​​​‍‌‍‍‍‌‌​​​‌​‍‌‍‌‍‌‍‌‌‌‌‌​‌​‌‌‍‌‍‍‌‍‌⁪Select ratio or dropoff⁪⁪",
                "SELECT_RELATIONSHIP": "⁪⁪⁪‍‌‍​​‍‌‌​‌‌‌​‍‌‌‌​‌‍‍‍​​‌‍​​​‌‍‌‌​‌​‍‌‌​⁪Select relationship⁪⁪",
                "SELECT_SCORING_CATEGORY": "⁪⁪⁪‍​‍‌​​​‌​​‌‌​‍​‍‌‍‌​‍​‌​‌‌‌​​‍‌‌​‌​‍‌‍​‌⁪Select scoring category⁪⁪",
                "SELF": "⁪⁪⁪‌​‍‍​‌‍‍​‌‍​​​‍​​‍‌‌​‍‌​​​‍​​​‍​‍‍‍​‍‍‍‍‍⁪Self⁪⁪",
                "SELF_ASSESSMENT": "⁪⁪⁪‍‍​‌‍​‌​‍‍​​‌​​‌‍​‌‌​‍​‌​‌‍​‌​​‌‌‍‍‌‌‍‌‌⁪Self-assessment⁪⁪",
                "SEQUENTIAL": "⁪⁪⁪‌‌​​‍‍​​​​​​‌‍‍​‌‌‌‌‌‌‌‍​​‌‍‍‌‌‌​‌​‌‌​‍‍‌⁪Sequential⁪⁪",
                "SETUP_COMPARISON": "⁪⁪⁪‌​​‍‌‌​‌‌‍‌‌‍‌​​​​‍‍‌‌‌‍‍​‌​​‌‌‌‌​‍‍​‌​​​⁪Setup comparison⁪⁪",
                "SETUP_COMPARISONS": "⁪⁪⁪‌​‌​‌‌‌‌‌​‍‍‍​‍‌‍‌‍‌‍‍‍​‌​‌‌‌‍‍‌​‍‍​​‌⁪Setup comparisons⁪⁪",
                "SET_START_COLOR": "⁪⁪⁪‌​‌‍‍‌‌​‍‍‌‍‌​​‍‍‍‍​‍‍​‍‌‍‍‌‍‍‌‍​​​​​‍​​​⁪Set Start Color⁪⁪",
                "SHOULD_SHOW_FOOTER": "⁪⁪⁪‌​‍‌‍‌‍‌‍‍‌‍‍‌‍‌‍‌‍‍‍​‍‍‌‌‍‌‍‍‍‌‌‍‌‌​‍‌‌​⁪Show Footer⁪⁪",
                "SHOULD_SHOW_SCORING_CATEGORY": "⁪⁪⁪‍‌​​‍‌‌‍​‍‌​‌​‍‍‌​​​‌​‌‍‌‌‍​​​​‍‌‍‍‌​​‌‍⁪Show Scoring Category⁪⁪",
                "SHOWING_RECORDS_OF": "⁪⁪⁪‌‌‌‌‌​‍‌‍​‍​‌​‍​​‌‌‌​‍‍‌‍‍‌‌‌​​‍‍‍​‌‌‍‍‍‍⁪Showing records %1 - %2 of %3⁪⁪",
                "SHOW_DATA_LABEL": "⁪⁪⁪‌‍​‍‍‍​‍‍​‍‍‍​​‍‌‌‌‍‌​‍‌​‍‌‍‍‌​‌‍‌‍‍‌‍​‍⁪Show data values⁪⁪",
                "SHOW_PERCENTAGES": "⁪⁪⁪‌​‌‍‌​​​‍‌​‌‌​​‌‍​​​‌‌‌‌‌​​‍‍‌​​‍​​​​​‍‌​⁪Show Percentages⁪⁪",
                "SHOW_THE_FOLLOWING_TEXT": "⁪⁪⁪‌‍​‌​‌‍‌​​‍​​‍​‍‍‍‌‌​‌‌‌‌‍‌‍‌‌​‍​‌‌‍‌‌​​⁪Then show the following text⁪⁪",
                "SHOW_TIES": "⁪⁪⁪‌​‌‌‌‌‍‍‍​​‍​‍‌​‌‍‌​​‌‌​‍‌​​‍​​​​​​​​‍‍‌‌⁪Show Ties⁪⁪",
                "SHOW_X_AXIS": "⁪⁪⁪‌‌‌‌​‌‌‌‍​​‌​‌​​​‌​‍​‌‍‍‍‍​​​​‍‍​​​‍‍‍‌‍​⁪Show X Axis⁪⁪",
                "SHOW_Y_AXIS": "⁪⁪⁪‌​‌‌‌‌​‍‍‍​‍‍​‌‍​‌​‍‌​‍‍‌‌​​​‍‍‌​​‌​‌‌‌‍⁪Show Y Axis⁪⁪",
                "SMALL_LABELS": "⁪⁪⁪‍‌‌​‍‌​​‍​‍‌‍​‌‍‌‌​‍‍‌‍‍‍​‌​‌‍‌‍‌​​​‌​‌‌⁪Small Labels⁪⁪",
                "SORT": "⁪⁪⁪‍​‌‌​​‌‌‌‌‍​‍‍‌‍‍‌‌‍‌‍‌​​‍‍‍​‌‍‌‍​‍‌‍​‌⁪Sort⁪⁪",
                "SPLINE": "⁪⁪⁪‍​‌‌‌‍‍​‍​​​​‌​‍‌‌​‌​‌‌​‍​‌‍‌​​‌‍‌​‍‌‍⁪Spline⁪⁪",
                "STACK_CHART": "⁪⁪⁪‍‍​‍‍‍‌‌‍​‍​‌‌‌‍​​‌​‌‍‍​‌‌‍‌‌‍​​​​​‌‍‍‍‌⁪Stack Chart⁪⁪",
                "STANDARD_DEVIATION": "⁪⁪⁪‌​‍‍​‍‌‌‌‌‌‌‍‌‍‍‌​‍​​‍‍‍‍‍‌‌​‌‌‍‍‍‍‌‌​‍‍⁪Standard Deviation⁪⁪",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "⁪⁪⁪‌​‍‌​​​​​‍‍‌​‌‌‌‌‌‌‌‍‍‍‍​‍​‍​‍‌‍‌​​‌‍‌​‌⁪Weakness less than⁪⁪",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "⁪⁪⁪‌​‍‌​‌‌‌‌​‌‌‍‌​‍‌‌‌​​‌​‍​‌​‌‍‍‍​‌‍‍​​‌‌‍⁪Edit threshold texts⁪⁪",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "⁪⁪⁪‍​​​‌‌​​​‌‌‍​​​‍​​‌​‌‍‌​‌‌‌‍​‍‍‍‌‍‍​​​‍‍⁪Threshold texts⁪⁪",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "⁪⁪⁪‌​‌‍​​‍‌‍​‌​​‌‍‍‍‌‍‍‍‌‍‌​‍‍‌‌​​‌‌‌‌‍‍‌‌⁪Enable threshold texts⁪⁪",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "⁪⁪⁪‍‍‍​‍​‌‌‍​‌‍‌‍‍‌​​‌​‍​‌‌​‌‍​​​‍‍‍​‌‍‌‌​​⁪Strength more than⁪⁪",
                "SUM": "⁪⁪⁪‍​​‍‌‍‍‍​‍‌‌‌‍‍​​‍‌​‌​‍‌‌‌‍​‌‌‍​​‍‍​​‌‌‌⁪Sum⁪⁪",
                "SUMMARY": "⁪⁪⁪‌‌‌​‍‍​​‍‌‍‌​‌‍​‍​‌‌‍‍‍​‌‍‍‍​‌‍‍​​‍‌‍​​‌‌⁪Summary⁪⁪",
                "TABLES": "⁪⁪⁪‍‍​‍​‌​‌‍‍‌‍‌‌‍‌‌‍‌‌‌​​​​​‌‌​‍‍‌​‌​‍​‌‍​⁪Tables⁪⁪",
                "TABLE_TOTALS": "⁪⁪⁪‍​​‍​‍‌​‌‍‍​‍​​‍‍‌‌​​‍‍​‍​‌​‍‍‍​‍‌‌‍​‌​‌⁪Table Totals⁪⁪",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "⁪⁪⁪‍‌‍‍‌‍‌‌‍​​‍‍​‍‍‌‌‍​‍‍‍‌‍‍‍‌‍​‍​​‍​‍‍​‌⁪Familiarize yourself with the rating scale to ensure accurate interpretation⁪⁪",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "⁪⁪⁪‌​‍​‍‌‍‌​‍‍​​‌‌‌‍​​‍‌​‌‍‍‍‌‍​​‌‍‌‍​​​​‍​‍⁪Take note of the scale⁪⁪",
                "TEXT": "⁪⁪⁪‍​‌‍‌‌‍‍‍‍‌​​‌‍​‍​‍​‍‍​​‌‍​‌‍‍‍​‍​‌‍‌‍‍‌⁪Text⁪⁪",
                "THINGS_YOU_WILL_SEE_HEADER": "⁪⁪⁪‍​​‍​‍‍​‍​​‍‌‍‌‍‌​‍‍‌​​​‍​‍‌​​‌​‍​‍​‌‌‍‍⁪Things you will see:⁪⁪",
                "TOP_BOTTOM_BOX": "⁪⁪⁪‌‍​‍​​​‌‌‍‌‌​‌‍‌​‌​‌‍​‌‍‌​​​‍​‍‍‌‌‍‍‍‍​⁪Top Box / Bottom Box⁪⁪",
                "TOP_BOX": "⁪⁪⁪‌‌​​​‌‍‌​​​‍‍‌‌‌​​‌‍​‌‍‍‌‌‌​‍​‌‌‍‍‌‌‌‌‌‍‍⁪Top Box⁪⁪",
                "TOTAL": "⁪⁪⁪‌​‌​‍‍‍‌‌‍‌‍​‌‌‍‌​‌‌‍‌​‍‍​​‌‍‍‌​‌‌​​‌‌​​⁪Total⁪⁪",
                "TOTAL_COUNTS": "⁪⁪⁪‌​​‍​​‌‌​‌​​‌‍‌​‌​‌​‌‍‌‌​​‌‍‍​​​​​‌​​​‍‌​⁪Total Counts⁪⁪",
                "TO_DO": "⁪⁪⁪‍​‍​‍‌‍‌‍‍​‍‍‍‍‍‌‌‌‌‍‌‌‍‍‍‌‌​‌​​​‌​‍​‌‍​⁪To do⁪⁪",
                "TRANSPOSE": "⁪⁪⁪‌‌​‌​​‍‍​‍​​​​‌​​​​‍‍‌‌‍‍‍‍‍‌‍‌‌​‍‍‍​​​​‌⁪Transpose⁪⁪",
                "TRANSPOSE_TABLE": "⁪⁪⁪‌​‌​‌‍​‍‍‍​‌​‌​​‌‍‍‌​​‌‌‌‍​‍‌‌‌‌‍‍​‌‌‍​‌‍⁪Transpose table⁪⁪",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "⁪⁪⁪‌‍‍​‌‍‌‍‍‍‌​‌​‍‌‍​‌‌‍​​​​‌​‍​‍‌​​‍‌​‍⁪Qualitative: This feedback will be in the form of open text comments⁪⁪",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "⁪⁪⁪‍‍‍​‍‌‍​‌​‍‌‌‍​​​​‍‍‍‌‌​‌​​​‍​‍‌‌​‌​​‍‌‌⁪Quantitative: This feedback will be numerical, and could be represented in graphs, bar charts, tables, etc.⁪⁪",
                "TYPES_OF_FEEDBACK_HEADER": "⁪⁪⁪‌​‌​‍‌‍‍‍​‍‍​​‌‌​​​‍​​​‌​‌‌‍​‌‌‌‍‌‌‍‍‍‌‌⁪Various types of feedback⁪⁪",
                "UNDO": "⁪⁪⁪‌​​​‍‌‍​‍‌​​‍‌‌​​‍‍‍‌‍‌‍‌‌​‍‌‍​‍‌‌‌‌‌‍‌​⁪Undo⁪⁪",
                "USE_COMPARISON": "⁪⁪⁪‌​‍​‍‌‌‌​​​‌‍‍‍​‍​‍‍‌‌‍‌‌‍‍‍​‌‍​‌‍‍‍​​‍​‌⁪Use comparison⁪⁪",
                "VALUES": "⁪⁪⁪‍​‍‍​​‍‌‍‌​‍​‌‌‌‌‌‌​‍‌​​‌‍‍‍‍​‍​‍​​‌​​​⁪Values⁪⁪",
                "VALUE_RANGES": "⁪⁪⁪‍​​‌‌‍‌‌​‍‍‌‍‍‌​‍‌‍‌‍​‍‍‍‍​‍‍‌‌‍‍​‍‌​‍‌‍⁪Value Ranges⁪⁪",
                "VARIANCE": "⁪⁪⁪‌‌‌​‌‍‌‍‌​​​​‌​‌‌‍‌‌‌‍‍‍‍‍​‍‌‍‌‌‍​‍‍‌‍‍​‌⁪Variance⁪⁪",
                "VERTICAL": "⁪⁪⁪‌‍‍​‍‌‍‍​‌‍‍‍‌​‌‌​‌‌‌​‌‌‍‍‍‍‍​‌‍​​​‌​‍‍‍⁪Vertical⁪⁪",
                "VERTICAL_RANGE": "⁪⁪⁪‍‍​‌‌‍‍​‍‌‍‌‌​‌‌‌​‍​‌‌‍‍‌‍‌‍‌‌‍​​​‍‌‍​‌⁪Vertical Range⁪⁪",
                "WARNING_DATA_OUT_OF_RANGE": "⁪⁪⁪‌‍‌​​‌​‍‍​‍​​​​‌​​‍‌​‍​​‍‍​​‍‌​‌‌‌​‍​‌​​⁪Warning: data value exceeds range configuration⁪⁪",
                "WIDGET_ERROR": {
                    "ERROR": "⁪⁪⁪‌​​‌‌‍‍‌‌‌​‍​​​‍‍​‌‍‌‍‌‍‍‌‌‌‍‌​‍‌‌‍‌‍‌‍‌‌⁪An unexpected error has occurred⁪⁪",
                    "MISCONFIGURED": "⁪⁪⁪‌​​‍‍‍‍​‍‌‍‌‍​‍‌​​‌​‌‌​‍‍‌‌‍‍‍‌‍​‌‍‍‍​​‍‍⁪This widget is not configured correctly. Please check your widget configuration.⁪⁪",
                    "NEW": "⁪⁪⁪‌‍‌‌‍‍​​‌‌​​‌‍‍​‍‍‌​‌​‌​​​‌‌‌‍‌‍‌‍‍‌‌‌​‌⁪Please configure widget⁪⁪",
                    "NO_DATA": "⁪⁪⁪‌‌​‌‍‍​​‌‍‍‌‌​‍‌‌​‌​‍‍​‍‍‌‍‍‌‌‌‌‍‍​‍‌​​⁪No data found - your filters may be too exclusive!⁪⁪"
                },
                "WIDGET_NAME": {
                    "BAR": "⁪⁪⁪‌​‌‌‍​​‍‍​​‌‍​‍‌‌​‍‌​‍‍‍‌​‍‌​​​‌‍​‍‌​‍‍‍‍⁪Bar Chart⁪⁪",
                    "BREAKDOWNBAR": "⁪⁪⁪‌​‌‍‌​‍‌‍‍​‍‌‍​‍‌​​‌‌‌‌‍​‌‍‌​​‍‍‍​‍‍‍‌​‌‍⁪Breakdown Bar⁪⁪",
                    "DATA_TABLE": "⁪⁪⁪‌‍‍‌‌‌‌‌‍‌​​‍​‌‌‌‍​​‌‍​​​‍​​‍‍‌​‍‌​‍‍‍⁪Data Table⁪⁪",
                    "FUNNEL_CHART": "⁪⁪⁪‌‌‌‌‍‌​​​‌​‌‍‌​‍‍‌‍‍​​‌‌‌‌​​‌‍‍‍​​‌​​‌‍‌​⁪Funnel Chart⁪⁪",
                    "GAUGE": "⁪⁪⁪‌​​‍​​​‌‌​‌‌‌‍‍‍‍‍‍‌‍​‌​‌‍‍‍​‌‍​​‍‍‍​‍​​​⁪Gauge Chart⁪⁪",
                    "GRID": "⁪⁪⁪‌​​‍​‍​‌‌‍‌‌‌‍​‌​‌‍‌​​‍‌‍​​​‍‌‌‍​‍‍‌‍‍​​‍⁪Results Table⁪⁪",
                    "HEATMAP": "⁪⁪⁪‍​‍​‍‌‍‌‍‍‍‌‌‌‍‌‌‌​‍‍‍‍​‍‍​‌​‌‌‌‍‍‍‍‌‌‍⁪Heat Map⁪⁪",
                    "LINE": "⁪⁪⁪‍‍‌‍​‍​‌‍‌‍‍‌‌‍​‍​‍‍​‍‌​‍‍‍‍‍‌​‌‍​‍‌​​‌⁪Line Chart⁪⁪",
                    "NEEDS_BASED": "⁪⁪⁪‌​​‍​​‍‍​​​​‌​​​‌‌​‌‍​‍​​​‍​‌​‍​‍‌‍‍​​​‍‍⁪Needs Based⁪⁪",
                    "PIE": "⁪⁪⁪‌​‌‍‍‌‍‍‍‌‍‍‌​​‌‍​‌‌​‌​‌‌‌​‌‍‍‌‌‍‍‌​‌‌​⁪Pie Chart⁪⁪",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "⁪⁪⁪‍‌‌‍‌‌​‍‌‍‍‌‍​​​​‍‌​​‍‍‍​‍‌‍‌‌‍​‍​‍​​​​⁪Price Estimator (Van Westendorp)⁪⁪",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "⁪⁪⁪‌​​‌‍​​​​‌​‌‌​‍‍‍‍‍‌​‌‌‍​‌‌‍‍‌‌​‌​‌​​‌​‍‍⁪Revenue Maximizer (Gabor Granger)⁪⁪",
                    "SCORING_OVERVIEW_CHART": "⁪⁪⁪‌​‍‌‌‌‍​​‍‍​​​‌​‌‍​‍​‍​‍‍​​‍‍‌‌​‌‌​​‍‌‍‍‌⁪Chart⁪⁪",
                    "SCORING_OVERVIEW_TABLE": "⁪⁪⁪‌‌​‍‌​​​‍​‍‌‍‍​​​‍‍​‍​‍‍​‍‍‍‍‌‌‌‌‌​​​​‍‌‍⁪Table⁪⁪",
                    "STATS_TABLE": "⁪⁪⁪‌‌‍‌​​‍​‍​‌​‍‌‍​​‍‍​‌‍​‍​‍‍‍‌‌‌‍‌‍​‌​​‌‌⁪Statistics Table⁪⁪",
                    "WORDCLOUD": "⁪⁪⁪‌‌​‍‌‌‍‌​‌‍‌‌‌‌‍​‌‍‌‍‍‍​​‍‍​‌​‍‌​‌‌‍‌‍‍​⁪Word Cloud⁪⁪"
                },
                "WORD_ROTATION": "⁪⁪⁪‍​‍​‍‌‍​‍‌​​‌‍‍‌​‌‍‍‍‍‌‍​​‍‍​‍‍‌‌​‍‌‌‌​⁪Word rotation⁪⁪",
                "WORD_SPACING": "⁪⁪⁪‌​‍‍‍​​‌​‍​‌‍‍‍‌​​‍‍​‌​‍‍​‌​‌​‌​​‌​​‌‌‍⁪Word spacing⁪⁪",
                "YES": "⁪⁪⁪‍‌​‍‌‌‍‌​‍‍‌​‌‌‍‌​​‌​‌‍‍‌‍‌​‍‌​‌‍‌‍‌‌​‍​⁪Yes⁪⁪",
                "YOUR_RATINGS": "⁪⁪⁪‍​​‌​‍​‍​‌‍​​‌‌​​‍‌‌‍‍‍​‍​​​‌‍​‍​​‌​‌​‍‍⁪Your ratings⁪⁪"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "⁪⁪⁪‌​‌‍‌‌​‍‌​​​​​‍‍​​‌‌‌‌​‌​​‍​‍‌​‌​​‍​‌‌​⁪Add⁪⁪",
                "ADD_A_WORD": "⁪⁪⁪‍‌‍‍​​‌​‍‍​​‌‌‍‌‍‌‍​​​‌‍‌‍‍‍‌‌​‌‍‍​‌​​‍⁪Add a word⁪⁪",
                "COLOR": "⁪⁪⁪‌‌​‌‌‍‌‌‍‍​‍‌‌‍​‍‍‌‍​‌‍​‌​​‍‍​‍‌‌‌‌​‍​​‍‌⁪Color⁪⁪",
                "DELETE_ALL": "⁪⁪⁪‌‌‌‍​‌‌‍‌​‍‍‌‍‌‌‍​‍‌​‌‍‍‌​‍‍‍‍‌‍‌​​​‍‌‌‌⁪Delete all⁪⁪",
                "EDIT_STOP_WORDS": "⁪⁪⁪‌​​‌‌​‍‌​​​‍‍‌​‌‌‍​‍‌‌‌​‍‌​‍‌‍‌​‍‍‌‌‌​​​‌⁪Edit Stop Words⁪⁪",
                "MAX_WORDS": "⁪⁪⁪‌​‌‍‍​‍‍‍‌‌‌​‍‌‍​‍‌‍‍​‍​‌​‍‍​‍‌​​‌‍‍‌‌‌‌‌⁪Max Words⁪⁪",
                "ROTATION_ANGLED": "⁪⁪⁪‌​​​‌‌‌‌​​‍‌​‍‍​‍‍‍‌​‌‌​​​‍‍​​​​​‍‍‍‍‌‌‌​⁪Angled⁪⁪",
                "ROTATION_HORIZONTAL": "⁪⁪⁪‌‌​​‌‌‌‌‌​‌​‌‌‌‌‌​‍​‍‍‍​‍‍‍‍​‍‌‌‍‍‌‍​‌‍‌‍⁪Horizontal⁪⁪",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "⁪⁪⁪‌‍‍​‍‍‌‍​​‌‌‍​​‌‍‍‍​​‍​‍​‍‍‌‌​​​‌​‍‌‌​‌⁪Horizontal and Vertical⁪⁪",
                "WORD_ORIENTATION": "⁪⁪⁪‍​​‌‌​​‌‍​​‌​‌‌‌‌‌​‌‌‍‌‌​​‌‌​​‌‍‌‌‍‌​‌​‌⁪Word Orientation⁪⁪"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "⁪⁪⁪‌‌‌​‌‍‍‍‍‌‌‌‍‍​‌‌‌‍​​‍‌‍​​‍‌​​​‌​‌‍​‌​‍​⁪Background Colors⁪⁪",
                "DISPLAY_OPTIONS": "⁪⁪⁪‍‌​‍‍‍​‌‍‍‍​‌‌‌​‍​‍​‌​‌‌‌‍‍‍‍​​‌​​​‍​‌‌‍⁪Display Options⁪⁪",
                "INVERT_FONT_COLORS": "⁪⁪⁪‍‌‌‍‌‍​‌‍‌‌‍‌‍‍‍​‍‍​‌‍​​‌​​‍​‌‌‌​​‍‌‌‌⁪Invert Low Contrast Font Colors⁪⁪",
                "PAGE": "⁪⁪⁪‌‌​‌​​​‍‍​​‌‍‌​‍‍‍‍‌​​‌​​‌‌‍‌‌​‌‍​​‍‌‍​​​⁪Page⁪⁪",
                "PAGINATE": "⁪⁪⁪‌‌​‍‍‌​​‌​‌‌‌​‌‍‍‍‍‍‍‌​​​​‌‌‍‍‍‌‍​‌‌‍​​‌‌⁪Paginate⁪⁪"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "⁪⁪⁪‌​‌​‌​‍​‌​​‍‍‌‍‍‍​​​‍‌‍​‍‌​‌‌‍‌‌​​​‍‍‌‌‌‍⁪Mean⁪⁪",
                "BOTTOM_BOX_METRIC": "⁪⁪⁪‍​​‌​‌‌‍​‍‍‍‍​‌‌‍​‍‌‍‌‌‍​‍‌‌‌‍​‍‌​‍​‍‍​‌⁪Bottom Box⁪⁪",
                "COLUMNS": "⁪⁪⁪‌​‌​​‌‌​‌​‍​‌‍‌​​​​​​‌​‌‍​‌​​‌​​‍​​‍‍‍‍​‌⁪Columns⁪⁪",
                "COUNT_METRIC": "⁪⁪⁪‍​‌​‌‌​‌‍‌​​​‌‌‌‍‍​‍​‍‌‌​​​‍​‌‍‍‌‍​​‌‍‍‌⁪Total Responses⁪⁪",
                "FIELD_NAME": "⁪⁪⁪‌​​​‌‍​‌​​‍‍‌​‍‌‌​​‌‍‌‌‍​‌‌​​‍‍‍‍‌‌​‍‌‌‍⁪Field⁪⁪",
                "MAX_METRIC": "⁪⁪⁪‍​‌‌‍‌​‌‌‌​​‌‍‌‌​‌‌‌‍‍‍‌‌‍‌​‌‌​‌‌‍‌​‌​​⁪Maximum⁪⁪",
                "MIN_METRIC": "⁪⁪⁪‍​‍‍‍​‌‍​‍‍​​​‍​‌‌‌‍​​​‌‍​‍‌‌‍‍‌‍‍‍‌‌​​‌⁪Minimum⁪⁪",
                "SHOW_RECODES": "⁪⁪⁪‍‌​‌‍‌‌​‌‌‍‌‌​​‍​‌‍‍​‌‌‌‌‌‌‍​‍‍‍​​‌‍‍​​‍⁪Show Recode Values⁪⁪",
                "SHOW_ROW_NUMBERS": "⁪⁪⁪‌‌‌‌‍‌‍​‍‌‌‍‌​‌‍​‌​​‍​​​​‍‍‌​​‍‍​​‌‍​‍​‌⁪Show Row Numbers⁪⁪",
                "STD_DEV_METRIC": "⁪⁪⁪‍‍‌​​‌‍‍‌‌‍​‍‍​‌‌​​‍​‍​‌​​‌‌‌‍​​‌‌​‌​‌‍‌⁪Std Deviation⁪⁪",
                "TOP_BOX_METRIC": "⁪⁪⁪‍​‌‍‍‍‍‍‌​​​‍‍‍​​‌​‍‍‍‍​‌‍​​‌‍‍‍​‌​‌​‍‍‌⁪Top Box⁪⁪",
                "TRANSPOSE_BREAKOUTS": "⁪⁪⁪‍‍‍‌‌‌​‌​‍​‍‍‍‍​‍‌‍‌​‍‍​‌‍​​‍‍‌‍‍‍‌‍‍​‍⁪Transpose Breakouts⁪⁪",
                "TRANSPOSE_TABLE": "⁪⁪⁪‌​‌​‌​‌‍‍‌‍​​‌‍​‌‌​‍​‍‌‌​‌​‍‌‌‍‌​‍‌‌​‍‍‍​⁪Transpose Table⁪⁪",
                "VAR_METRIC": "⁪⁪⁪‌‌‍​​‍‍‌​​‍​​‌‌​​​‍​‌‌​​‍‌‍‍‍‌‌‍​​‌​‍‍‍⁪Variance⁪⁪"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "⁪⁪⁪‌​‌‌‌‌‌​​​‍‌‌‍‌‍​​‌‍‍​​​‌‌‍​‍‍​‍​‍‍​​​‌​​⁪Additional Columns⁪⁪",
                "ADD_COLUMNS": "⁪⁪⁪‌‌​‍​‌​‍‌‍‍‍‌‍‍​​‍‍‌‍‌​‍‍​​‌​‍​​‍‍‍​​‍‌⁪Add Additional Columns⁪⁪",
                "ADD_CUSTOM_PALETTE": "⁪⁪⁪‌​‌‍‌‌‌‌‍‌​‌‌​‍‌‍​​‍‌‌‌​​‍‍​‌​​​‌‍‍‍‌‍‌​‍⁪Add Custom Palette⁪⁪",
                "ALL_CHOICES": "⁪⁪⁪‌‌‌‌‍​‍​‌‍​​‌‌​‍‌‍​‍‍‍‌‍‍​‍‍​‌‌‍‍​‌‍‌​​‍⁪All Choices⁪⁪",
                "ALL_GROUPS": "⁪⁪⁪‌​‌‍‍‌‌‍‍‌‌‌‌​‌​‌‌‌‌​‍‍​​​​‍​‍​‌​‌‌‌​‌‌‍​⁪All Groups⁪⁪",
                "ALL_RECODES": "⁪⁪⁪‌​​​​​‍‍‌​‌‍‌‍‌‌‍‌​‍​‌​‌‌​‌‍‍​‌‌‍​‍‍‍​‌​⁪All Recodes⁪⁪",
                "AUTOMATIC": "⁪⁪⁪‍​‍​‍‍‍​‌​‍​‌‍‌‌​‍‍​‍​​‌‍‌‌‍​​‍‌​‍​‌‌‍‌​⁪Default⁪⁪",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "⁪⁪⁪‌​‍‌‍‌‍‌‍​‍‌‌​‍‌‍​‌‍‌​‍​​‌‍​‍​‍‍​‌‍‍‍‌‍‍​⁪Default - Click to edit⁪⁪",
                "AXIS_VALUES": "⁪⁪⁪‌​‌‍​‍‌​‌​​‌‌​​‍‌‍‍‍‍​​‍‍‍‌‍‌​​​‍‍‍‌‍‍‌‍‍⁪Axis Values⁪⁪",
                "BREAKOUT_BY": "⁪⁪⁪‌​​‍‍‌​​‍‌​‍‍​‍​‌‌​‌‌​‍‌‌‍‍‌​​‌‌‍​‍‍‌​‍⁪Breakout By⁪⁪",
                "CANCEL": "⁪⁪⁪‍​‌​‌‌‍​​‌‍‌‍​‌​​​‍‌‍​​​‌‍‌‍‌​‍​​​‌‌‍‌​‍⁪Cancel⁪⁪",
                "CATEGORICAL": "⁪⁪⁪‍‌‌‍‍​‍‍‍‍​‍‌‍‍​​​‌​‌​‌‍‍‌‍‍​‍‌‍‌​‌‌‌​‌⁪Categorical⁪⁪",
                "CHOICES": "⁪⁪⁪‍‌​​​‍‍​​​‍‌‌​‍‍​​‌‍‍‌‌‍‌‍‍‌‍‌‌‍​‍​​‍‍‍⁪Choices⁪⁪",
                "CHOICE_COUNT": "⁪⁪⁪‌​​​‍‍‍​‍‌​​​‌‌‌‍‌​‌​‍​‍‍​‍​‍​​‌‌​‍‌‌‍​‍‍⁪Choice Count⁪⁪",
                "COLOR_PALETTE": "⁪⁪⁪‌‌‌‌‍‌‌‌​‌​‌‌‍​‌​‌‍‌​​​‌​​​‍​‍‌‌‍‌‌‍​​‍‌⁪Color Palette⁪⁪",
                "COLUMN_VALUES": "⁪⁪⁪‌​​​​​‌​‌‍​‌​​‌‍​​​​​‌‌​​​‌‌‌​‌‍‍​‌​‌‍‌‌​⁪Column Values⁪⁪",
                "CONTACT_FIELDS": "⁪⁪⁪‍‍​‍‌​‍​​​‌‌​​‍‍‌‌‍‍​‌‍‌‌‍‍​‌​​‍‌‍‍‌‌‍​‍⁪Contact Fields⁪⁪",
                "COUNT": "⁪⁪⁪‍‌‍​​‍‌​‌‍​‌‌​​‍​‌‍​​‍‌​‌‍‌‌‍​‌‌‍​‍‍​‌⁪Count⁪⁪",
                "CREATE": "⁪⁪⁪‌​‍‌​‌‍​‌​‌​‌‌‌​‌‍​​‍‍​‍‌‌‌​​​‌‍‌​​​​​‌​‌⁪Create⁪⁪",
                "CUSTOM": "⁪⁪⁪‍​​‍​‍​‌‌‌​​‌‌‌‌‍‌‍​​‌​​‍‍‍​‌‍​‌​​‍‌​‌‍​⁪Custom⁪⁪",
                "CUSTOM_PALETTE": "⁪⁪⁪‍​​‌‌‍‌​‌‍​‍‍‍​​‌​‌​‌‍‌‌‌​‌​‌‍​‍​‌‌‌​​‍​⁪Custom Palette⁪⁪",
                "DATA_SOURCE": "⁪⁪⁪‌‌‌​‌‍​‍​‍‍​‍‌​‍​‍​‌‍​‍‌​‍​‌​‌‍​​‌‌‍‍‌​‍⁪Data Source⁪⁪",
                "DAY": "⁪⁪⁪‍‌‍‌‍‌‍‌‍​‍‍‌‍‍​‍‌‌‌‌‌‌​​‍‌​‌​‍‍‍​‍‌‍‌‌‌⁪Day⁪⁪",
                "DAY_OF_WEEK": "⁪⁪⁪‌‍‌‌‍‌‌‌‍‌​‍‌‍‍‍​‍‌‍‍‌​​​‍​‌​​​‍‌​‍‌‍​​​⁪Day of Week⁪⁪",
                "DECIMAL_PRECISION": "⁪⁪⁪‌‍​‌‍‍‌‌‍​‍‌‌‌‌​‍​‍‍‍​‍​‍‍‌​​‌‌​‍‍‍​‌‍‌‍⁪Decimal Places⁪⁪",
                "DEFAULT": "⁪⁪⁪‌​‍‍‍​​​‌​‍‌​‌‌‍​‍‍‌‍‍‌‍‌​‍​​‍‍‌‌‌‍‍‌‍‌​​⁪Default⁪⁪",
                "DISABLED": "⁪⁪⁪‌‍​​‍‌​​‌‍‌‍​‍‍‌‍‌‍‌​‍​‌​‍‍‌​‌​‍‌​‌‌‍‌​‌⁪Disabled⁪⁪",
                "DIVERGENT": "⁪⁪⁪‌‌‍​‌‌‍‍‌‌‌‌​​​‌‍‍‍‌​‌‌‍‌‍​​‍‍‌​‌​‍‍​‍‌‌⁪Divergent⁪⁪",
                "EDIT_CUSTOM_PALETTE": "⁪⁪⁪‌‍‍​‌‍‌‌‍‌​‍‍‍​‌​‌​‍​​‍‌​‍​​‌‍‍‌‌‍‌‌‍‍‍‍⁪Edit Custom Palette⁪⁪",
                "ENABLED": "⁪⁪⁪‌​‍‌‍‌‌‌​‍​‍‍‌‍​‌‌‌​​‌‍‍‍‌​‍‍‍‍​​‌​‍​‍‍⁪Enabled⁪⁪",
                "ERROR_LOADING_DATA": "⁪⁪⁪‍‌‌‌‌‌​‍‍‌​‍​‌​‍​‍‌​‍‍‌‌​‌‍‍‍‌​​‍‌‍‍‍‌‍​⁪Error loading data⁪⁪",
                "FILE_SIZE": "⁪⁪⁪‌‍‍‍‌​‌‍​‌​‍‍​‌​​‍​‌‌‌​‍‍‌​‌‌‌​‍‍‍‍‍‍‌​⁪Size⁪⁪",
                "FILE_TYPE": "⁪⁪⁪‌‍‌‌‌‍​‌‍‌​‌​​​‌‍‌‍‍​​​‌‍​‌‌​‌‍‌‌​​‍⁪Type⁪⁪",
                "FRI": "⁪⁪⁪‌‌​​‌‍‌‌‌​‌‍‍​‍​‌‌‌​‍​​‍​‍‌​​‌‍‌‌‍​‍​‌​​​⁪Fri⁪⁪",
                "FRIDAY": "⁪⁪⁪‌‍‍‌‍‍‌‍‌‌​‌‌‌​‍‍​​​​‍‌​‍‌​‍‌​‌‌‌‍‌​‌​​⁪Friday⁪⁪",
                "GROUP_DATE_BY": "⁪⁪⁪‌‌‌​‍‍​​‍‌‍‌‌​‌​​​‌‌‌​​​‍‍​‍‍‍​​‍‌​‌‌‌‍‍⁪Group Date By⁪⁪",
                "HOUR_OF_DAY": "⁪⁪⁪‌‌​‌‌‌‍‌​​​‍‍‌‍‌​​‌‍‍​​​‍‍‍‌‍‍​​‌‌​​‌​‌​​⁪Hour of Day⁪⁪",
                "LENGEND_VALUES": "⁪⁪⁪‌‌‍‌‌‍​​​‌‌‍​‍​​​​‌‍‍‌‍‍‌​​‌‍‌​‍‌​​‍‍‌‌​⁪Legend Values⁪⁪",
                "MAX": "⁪⁪⁪‍​‍‌‍‍‍​‍‍​‌‌‌​‌‌​‍‍‍‍‍‍‍​‍‌​‍​​​‌‌​‍​‍‌⁪Max⁪⁪",
                "MEAN": "⁪⁪⁪‌​‍‌​​​‌​‍‌​‌​‌‌‌‌‌​‌‌​​‍‌‌​‍​​‌​​‍‍‍​​‍‌⁪Mean⁪⁪",
                "MIN": "⁪⁪⁪‌‍​‌​​‍‌‍‌​‌‍​‌‍​​​​​‌‌‍‌​‌‍‌‍‍‍‌‌‍‍​‌‍⁪Min⁪⁪",
                "MISCONFIGURED_DATA": "⁪⁪⁪‌‌‍‍‍​‌‌‍‍​‍​‍‌​‍‌‍‌​​‍‍​​​‌‍‌​​​‌​​‌‌‍‌⁪Data source misconfigured for this visualization.⁪⁪",
                "MISCONFIGURED_FILTERS": "⁪⁪⁪‌​​‌​​‍​​‍‌​‍‌‌​​‌​‍‍‌‍‍‌‌​‌​‍‍‌​‌‍​‌‌‍​⁪Invalid Filter(s)⁪⁪",
                "MODIFY_CUSTOM_PALETTES": "⁪⁪⁪‍‍​​‍‌‍​​​‌​‌​​‍‌‌‌‍‌‍​‌​​​‍​‌​‌‍​​‍​‌⁪Modify Custom Palettes⁪⁪",
                "MON": "⁪⁪⁪‌​​‌‌​‍‌‍‌‌‌​‍‌‌‌​​‍‌​​‍‌‍​‌‍​‌‍​‌‍‍‍‍‌‍‌⁪Mon⁪⁪",
                "MONDAY": "⁪⁪⁪‌​‍‌​‌‍‍‌‍‌​‌‌‌‍‍‌‍‍‌​‌​​​​‌‌‌‌‌‍​​‍‌‌‍‌​⁪Monday⁪⁪",
                "MONTH": "⁪⁪⁪‍‍​​‌‍‍‌​‍‍​‍​‍‍​‌‍​‍‌‍‌‌‌‌‍‌​‍‌​‌​‍‍‍‌‌⁪Month⁪⁪",
                "NONE": "⁪⁪⁪‌‍‍​‍‍‌‍‍‍‌‌​​‌​‍​‍‌​‍‍​‍‌‌‍‌‍‌​​‍‍‍​‌​⁪None⁪⁪",
                "NO_FILE_ID_ERROR": "⁪⁪⁪‍‍​‍‍‌‌​‌​‍‌​‌​​‍​‍​​​​‌‍‌‌‌‌​​‍​‍​​‌‌​‌⁪This visualization requires an image to be set in the survey⁪⁪",
                "NO_RESULTS_TO_SHOW": "⁪⁪⁪‍‌‍​‍​‍‍‍‍‌‌‌​‍‌‌​‌‌‍‌​‌‌‍​‌‌​‌‌​​‍‌‍​‌‍⁪No results to show⁪⁪",
                "NPS": "⁪⁪⁪‌‌​​​‍‌‍‍​‍‍​‌‍‍‍‌​​‍​​​‍‍‌‍​‌​‌​​​​​‌‌‌⁪Net Promoter Score®⁪⁪",
                "NPS_GROUP": "⁪⁪⁪‌​‍‌​‌‍‌​‍​​‍​‌​​​‌‌‌‌‍​‌‌‍‍​‍​​‌​‍‌​‍‍‌‌⁪NPS® group⁪⁪",
                "NUMERIC_VALUE": "⁪⁪⁪‌‌​‌‍​‍‌‌​‍‍​‍‍‍​‌‌‌‌‍‌‌‍‍​‍​‌‌‍​‍‍‍‍​​​‍⁪Numeric Value⁪⁪",
                "PALETTE_REMOVED": "⁪⁪⁪‌‌​‌‌‌‍​​‍​‌​‌​‍​‌‌‍‍​‍‌‌‌‍‌​​​‌‌‍‌‍‌​​‌‍⁪Palette Removed⁪⁪",
                "PERCENTAGE": "⁪⁪⁪‌​​‍‌​‍​‍‌‍‌‍​‌​‍‌​​‍‌​​​​‍​​‍‍‌‍‍‍‍​​​‍‌⁪Percentage⁪⁪",
                "PERCENTAGE_OF_CHOICES": "⁪⁪⁪‍‍​‌​​​​​​‍‍​‍​​‍​‍​‍‍‍‌‌‍​‌‍‍‌‌​‌‌​‌‍‌​⁪Percentage of Choices⁪⁪",
                "PERCENTAGE_OF_RESPONSES": "⁪⁪⁪‍​‌‌‌​‌​‌‍​‍‌​​‍​‍​‌‌‌‌‌‍‍​​‌‌‍‌‌‍‍​‌‍‌⁪Percentage of Responses⁪⁪",
                "QUARTER": "⁪⁪⁪‌​​‌‌​‍​​‍‍​​‌​​​‌‌​​‍‌‌‌‍​‍‌​‍​​‌​‍‌‌​​‍⁪Quarter⁪⁪",
                "REMOVE": "⁪⁪⁪‌​​​‍​‍‍‍‌‌‌‍​‍​‌‌‍​​‍‌‌‍​​‌​‌‍‌‍​​​‌​‍‍​⁪Remove⁪⁪",
                "RESPONSE_COUNT": "⁪⁪⁪‌​‍‌‌​‍​‍‍‌‌​​‌‌​‌‍​‌​‌‍​‌‌‌‌​‌​‌‌‍​​‍‍⁪Response Count⁪⁪",
                "RESULTS_PER_PAGE": "⁪⁪⁪‌‍‍‍​‍‌​​‌‍‌​‌​‍‌​​‍‌​​‍‍‍‌​‍​​‌‌​‌​​‍​⁪Results per page⁪⁪",
                "RETRIEVING_DATA_ELLIPSIS": "⁪⁪⁪‍​‌​‍​​‌‍‍​​‍​‌‌‍​‌​​​‍​​‌‌‌​​​‍‍‌‌‍​‌​‌⁪Retrieving data...⁪⁪",
                "REVERSE_COLORS": "⁪⁪⁪‌​‍‍‍​‌‍‍‍‍​‍‌‍‍​​‌‌​​​‌‍​‌‍‌‌‍‌‌‍‌‌‍‍‍​⁪Reverse Colors⁪⁪",
                "ROW_VALUES": "⁪⁪⁪‌‌​‍​‌‍​‍​‍‌‌​‍​​​​‌‍​​‍​​​‍‍‍‌​‍​‍‌‍‍‌‌​⁪Row Values⁪⁪",
                "SAT": "⁪⁪⁪‍​‍‍‌​​‌​‍‍‍‍​‍​‌​‌​‍​​​​​​‍‍‍‍‍​‍​‌‍‍​​⁪Sat⁪⁪",
                "SATURDAY": "⁪⁪⁪‌​‌​​‍​‍‌‍​​‌‌‍‌‌‍‌‌​‌‌​‌‍‌​​‍‍‍‍‌​​‍‌​‌⁪Saturday⁪⁪",
                "SAVE": "⁪⁪⁪‌​​​‌​‌‍​‌​‍‍‌​‍​‍​‌‌‍‍​‌​‍‍‍‌​‌‌‍‌‍‍‌​‍​⁪Save⁪⁪",
                "SELECTED_CHOICE": "⁪⁪⁪‍‌​​‍‌‌‌‍‌‌‍​​​‌​‌‍‍​‍‌​​‌​​‌‍‌‌‌‌​‍‍​‌‍⁪Selected Choice⁪⁪",
                "SELECT_FIELD": "⁪⁪⁪‍‌‍‌‍​‌‌‍‍‍‍​‌‍​​‍‌‌​‍​‍‌​‌‌​‍‌​​‌​​​‌⁪Select Field⁪⁪",
                "SELECT_METRIC": "⁪⁪⁪‌​​‌​​‌‌​‌‌‍​‍​‍‍‌‍‍‌‌​​​​‌‌‍‍‌​‍‍​‌‍‌​‍⁪Metric⁪⁪",
                "SEQUENTIAL": "⁪⁪⁪‍‍‌‌​​‌​‍​​‌‌‍‍​​‍‍‍​​‌‍​‌‍‍​‌‍​​​‍​​​​‌⁪Sequential⁪⁪",
                "SET_START_COLOR": "⁪⁪⁪‌​​‌‌‍​‌‍​​‍​‍​​‌​‍​‌​‌​‌​​‌‍‍‌​‌​​‍‍​‍⁪Set Start Color⁪⁪",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "⁪⁪⁪‌‌​​‌‌‍​‌​‌​‌‍‍​​‌​​‍‍‌‌​​‍​‍​‌​‌‍‌‍​‌​‍​⁪Showing sample data...⁪⁪",
                "SUM": "⁪⁪⁪‌‍‌‌​‍‌‌‍‌‌​​‍​‌‍‌​‍‌‌‍​‌​​‍‌​‌​​‌‍​‌‍‍‍⁪Sum⁪⁪",
                "SUN": "⁪⁪⁪‍​‌‌‌‌​‍​‌‌​‍​‌‌​‍​‌‍‍‌​‍‍‌​‍‍‌‌​‍‍‌​‌‌⁪Sun⁪⁪",
                "SUNDAY": "⁪⁪⁪‌​​​​‌‍‌‌‍​‌‌​‍‌​‍​‍‌‌‍​​‌‌‌‌​​​‌​​‌​‌​‌‍⁪Sunday⁪⁪",
                "SURVEY_EMBEDDEDDATA": "⁪⁪⁪‍‍‍‍​‍​‌‌‍‍‍‌​​‌‌​‍‌‍‌​‌‍‌​​‌​‌‌‌‌​‍​‌​‌⁪Embedded Data⁪⁪",
                "SURVEY_METADATA": "⁪⁪⁪‌​​‍‌‌‌‍‌‍​​‌‍‍‍​‌‍‍​​‍‍‌‍​‌‍‌‍‌​‌‌‍‌‍​​‌⁪Survey Metadata⁪⁪",
                "TEXT_ENTRY": "⁪⁪⁪‍‌‌‍​‌‍‍‍‌‍‍‌​‍‌​‌​‍‌‍‍​‌‍‌​‍‌‍‌‍‌​‍‌‌‌‌⁪Text entry⁪⁪",
                "THURS": "⁪⁪⁪‌​‌‌‌‌‍‍‌‌‍‍​‌‍​‌‌‍​‍‍‍‌‌​​‌‍‍​​‍‍‍‍​‍‍⁪Thurs⁪⁪",
                "THURSDAY": "⁪⁪⁪‍​‌‌‌‍‍‍‌​​​​​‍‍‍‌‌‌‌​​‍‌‍​‌‌‍‌‌‌​‍​​⁪Thursday⁪⁪",
                "TITLE": "⁪⁪⁪‍‌‍​​‌‌‌‍‌‌​‌‍‌‍‌‌​‍​​‌‌‌‍‌‍‍​‌​‌‌‍‍​‍‌‌⁪Title⁪⁪",
                "TUES": "⁪⁪⁪‌​‍‌‌​‌‍​​‍‍‌‍‌​‍‍​​‌‌‍​‌‍‍‍‌​‍​​‍‌‍‍‍‍​‌⁪Tues⁪⁪",
                "TUESDAY": "⁪⁪⁪‌​‌​‍​​‍‌​​‍‌​​​‌​‍‍‍‌‍‌‍‌​​‌‍​‌‌​‍‌‍‌​⁪Tuesday⁪⁪",
                "UNBOUNDED_DOMAIN": "⁪⁪⁪‍​​​​​‌‍‌​​‌‌‍​‌​‍‌‌‍‍​​​‌‍‌​‍‌‌‍‌‌‍​‌‌‌⁪Too many values to display.⁪⁪",
                "UNBOUNDED_DOMAIN_HELP": "⁪⁪⁪‍​​‍‌‍​​‍‍‍‌‌‌‌​​​‌​​‌‌‌‌​‌‍​‌‍‍‍‌​‌​‍​​⁪To add this field to Results Reports, you can add a filter to report to display fewer values for \"​​​{{ed_field_name}}‌‌‌\" or update the embedded data variable type of \"​​​{{ed_field_name}}‌‌‌\" in your survey flow to make this field a string or numeric type.⁪⁪",
                "UNDO": "⁪⁪⁪‌‍​‍​‌‌​‍​‍‍‍‌‌​‌‌‍​‌‍​​‍​‌​‍‍‍‌‍‌​‌‍‌‍​⁪Undo⁪⁪",
                "USE_CHOICE_TOTALS": "⁪⁪⁪‍‌‌‍‌​​‍‌‍​​‌‌​​‍‌​​‍​‌​‌‍​​‌​​​‍‌‍‌‌​‌​⁪Use Choice Totals⁪⁪",
                "USE_RESPONDENT_TOTALS": "⁪⁪⁪‌‍‌​​​‍‍‌​‍​‍‍‌‍‍​​​​‍‌​​​‍‍‌‌​‍‍‌​‍‌​​‍⁪Use Respondent Totals⁪⁪",
                "VISUALIZATION": "⁪⁪⁪‌‌​‍‍​​‍‍‍​​​‌‌‌​​​‍‍‍‍​‍​‍​​‍​‌​‌‍​‌​​‍​⁪Visualization⁪⁪",
                "VISUALIZATION_BARCHART": "⁪⁪⁪‌​‍‌​‌‌‍‍‍​‍​‍‌​‍‍‍‍‍‌‍‍​​‌‍‍‍​‌‍​‍‌‍‌‌​‍⁪Bar Chart⁪⁪",
                "VISUALIZATION_BREAKDOWNBAR": "⁪⁪⁪‍‍​​​‍‍‍‌‌‍‍‌​​‌‌‌‍​‍‌‌​​​​‌‍​​​​​‍‌‌‌‍‍⁪Breakdown Bar⁪⁪",
                "VISUALIZATION_GAUGE": "⁪⁪⁪‌​​​​​‍​‍​‍​​​‌‌​​‍‌‍‍‌‍‌‌​​​​​‍‌‌‍​​‍‍​​⁪Gauge Chart⁪⁪",
                "VISUALIZATION_HEATMAP": "⁪⁪⁪‍​​​‌‌​‍‍‌​​‌‌​​‌‌‍‍‍‍​‌‌‌​​‍‌‌‍‍​‍‍​‌​​⁪Heat Map⁪⁪",
                "VISUALIZATION_LINECHART": "⁪⁪⁪‍‌‍‍​​​​‌‍‍‍‌​‍‍‌‌‍‍​‌‍‌‌‍‌‍‍‌‍‍‌‍‍​‌‌​⁪Line Chart⁪⁪",
                "VISUALIZATION_PAGINATEDTABLE": "⁪⁪⁪‍​‍‌‌​‍​​‍‌​‌‌​‍‌‍​‌​‌‌​‍‍‍​‌‌‍‌‍‌‍‌‌‌‌‍⁪Paginated Table⁪⁪",
                "VISUALIZATION_PIE": "⁪⁪⁪‌‌‌‌‌‌​‌‌‍‍‍‍‍​​‍​​‌‌​‍‌​​‌​‌‍‍‍​​‌‌‍‍​‍​⁪Pie Chart⁪⁪",
                "VISUALIZATION_SIMPLETABLE": "⁪⁪⁪‍‌‍​​‍‍​‌‍​‍‍​‌‌‌‍‍‌​‍​​‌‍‌‌‌‌‍​‌‍‍‌‌​‍⁪Simple Table⁪⁪",
                "VISUALIZATION_STATSTABLE": "⁪⁪⁪‌‌​‌‍​‍‌‍​​‌​​‍‌​‍‌​‍‍‍‍‌‌‌​‌​​‍‍​​‌‍​‍‌⁪Statistics Table⁪⁪",
                "VISUALIZATION_TEXTHIGHLIGHTS": "⁪⁪⁪‌‌​‍‌‍​​​‌‍​‍​‌‌​​​‌‌‌‍‌‌‍‍‍‍‌‌‍‍‍‌​‍​​​​⁪Text Highlights⁪⁪",
                "VISUALIZATION_WORDCLOUD": "⁪⁪⁪‌​‍‌‍‍‌‌​‌​​​​‌‌‌‍‌​‍​‌‍‌‌‌‌​‌‍​​‍‌‍​‍​‌‍⁪Word Cloud⁪⁪",
                "WED": "⁪⁪⁪‌‌‌​​​‍​​‌‍‍‍‍‍‍​​‌‍​‌‌‌‍​‍​‍‍​‍​‍‍‌‍‍‍⁪Wed⁪⁪",
                "WEDNESDAY": "⁪⁪⁪‌​‌‌​‍​‍​‌‌‍‍‌​‍‌‌​‌‌‌‌​​‌​​‌‌​‍​‍‌‌‍‍​‌​⁪Wednesday⁪⁪",
                "WEEK": "⁪⁪⁪‌​​‍​‌​​​‍​‍‍‌​​​‌​‌‌‍‌‍‍‍​‍‌‍​​​‌​‍​‍‌‍‍⁪Week⁪⁪",
                "WEIGHTING": "⁪⁪⁪‌‌‍​‍‍​‌‌‍‍‌‌​‍‍‌​‌​‍‌‍‌‍‌​​​‌‍‌‍‍‌‌​‌‌​⁪Weighting⁪⁪",
                "WRONG_QUESTION_TYPE_ERROR": "⁪⁪⁪‌‍‍​​‍‌‍‍​​‍‍‍‍‌‍​​​​‍​‍‍‌‌​‍‌‍‌‍‌‌‌‍‌‍‍⁪This visualization type cannot be used for this question⁪⁪",
                "YEAR": "⁪⁪⁪‌‍‍‌‌​‍‌‌‍‌​‍‍‍‍‌​​‍​‍‌​‌‍​‍‌‌‍​‍​​‍‌​‍⁪Year⁪⁪"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "⁪⁪⁪‌‍‌‌​‌​‍‌‍‍‌​‍‍​​‍‍​‌‌‍‌​‌‍‍‍‌‌‍‍‍​‍‍‍⁪Average⁪⁪",
                "CHOICE_COUNT": "⁪⁪⁪‌‌​‌‌‍​‌‌‌‍‍​​‍‍‍‌‍‌‍‌​​‍‌​‌‍‍​‍‌‍​‌‌‍​‌​⁪Choice Count⁪⁪",
                "COUNT": "⁪⁪⁪‌‍‌‍​‍‌​‍​‌​‍‍‌‍‌​‍‌​‌‍‌‌​​‌‌‌​‍‍‌‌​‍​​​⁪Count⁪⁪",
                "DISPLAY_OPTIONS": "⁪⁪⁪‍‍‍‍‍‌​‌​​​‌​‌‍‌‌​‍‍‌‍‍‌‍‌​‌‍‌‍‍​‍‌‍‌‌‍‍⁪Display Options⁪⁪",
                "MAX": "⁪⁪⁪‌​‌​‌​‌‌‍​​‍‌​‌‌‍‍​​​‌‍‌‌‌​‍​​‌‌‌‌‍‍​‌​​⁪Maximum⁪⁪",
                "MIN": "⁪⁪⁪‌​‌‌‌‌‌​‍‍‌​​‍‌‌​‍​‍‍‌‍‌‌‍‌​​‌‌‍​​‍​‍‌‌​‍⁪Minimum⁪⁪",
                "NPS": "⁪⁪⁪‌​‍​‌‍‌​‌‌‌‍​​‍​‍‍​‌‍​‌‍​​​‌‌‌‍‍‌‌​‌‍‍​‌​⁪NPS®⁪⁪",
                "PAGE_OF": "⁪⁪⁪‍‍​‍‌​‌‌‌​​​‍‌‍‌‍‍‍​‌​​‌​‍​​‍‍​‌‍‌‍‌‍‌​‌⁪Page: %1 Of %2⁪⁪",
                "PERCENT": "⁪⁪⁪‌‌​‍‍‍‌‍​‌‍‌‌‌‌​‌‌‍‌‍​‌‍‍‍​‍‍‌​‍​​‌‌​‌​‌⁪Percentage⁪⁪",
                "RESPONSE_COUNT": "⁪⁪⁪‌​‍‌‍‍​‌​​‍‌‌‍‍‌‍‌‍‍‌‍‍‌‍‍​‌‌‍‍‍‌‌‍‌‍​‌‌⁪Response Count⁪⁪",
                "ROWS_PER_TABLE": "⁪⁪⁪‌​​‍​‌‍‌‌‌‌​‍​‌‍​‌​‍‍‌​‍‍‍‌‌‍​‍​‍‌‍​‌​‍⁪Rows Per Table⁪⁪",
                "SHOWING_ROWS_OF": "⁪⁪⁪‌‌​‌‍​‌‍‍​‌‍‌‌‌​​​‍​‌‌‍​​‍‌‍‍‌‍‌​​​​‍‌‌‍‌⁪Showing rows %1 - %2 of %3⁪⁪",
                "SHOW_PERCENTAGES": "⁪⁪⁪‍‌​‍‍​‍‍‌​​‌​‌‍‍‍​​‌‌‌​‍‍‌‌‌​‍‍‌‍‍‍‌‌‍​‍⁪Show Percentages⁪⁪",
                "SHOW_RECODES": "⁪⁪⁪‌‍‍‍‌‍‌‍​​​‌‌​‍‍‌​‌‌‌‌‍​‍‌​​‌‍​‍​‍​‍‌‌⁪Show Recode Values⁪⁪",
                "SHOW_ROW_NUMBERS": "⁪⁪⁪‌​‍‍‍​‍‌‍​​‌​​​‌‍​‌‌‍‌‍‍‌​‌‍​‍‍‍‌‍‌‍​‍​‍​⁪Show Row Numbers⁪⁪",
                "SUM": "⁪⁪⁪‍‌‍​​​​‍​​​​‌‍‌​​‍‍‌​‍‍‍‌‌‍​‍‍​​‌​‌‌‍‍‌​⁪Sum⁪⁪",
                "TOTAL": "⁪⁪⁪‌​‍​​‌‌‌​‍‌​‍‍‌​‍​​‌‍‍​‍‍‌​‍‌‍‍‌​‍​‌​​​​‍⁪Total⁪⁪",
                "TRANSPOSE": "⁪⁪⁪‍​‍‌‍‌​‍‍​​‌‌​​‌‍‍​‌​‌‍‌‌‌​‍‍‌​​‌​​​​‌‍‍⁪Transpose⁪⁪",
                "USE_COLUMN_TOTALS": "⁪⁪⁪‍‌‍‍‍‍​​‌​‌​‍‍‍‍‍​‌‍​‍​‍‍​‍‌‌​​​​​‌‍​‍‍⁪Use Column Totals⁪⁪",
                "USE_ROW_TOTALS": "⁪⁪⁪‌‍‌‌‍‌‌‍‌‌‌‌‌​‍​‌​​‌​‌‌‌​​​‍‍​‌​‍‍‌‍‌‍​‌⁪Use Row Totals⁪⁪",
                "VALUE": "⁪⁪⁪‌​‌​‌‌‌‍‍​‌‍‌​​​‌‍‍​‌​​​‍‌‌‍‌‌‍‌‍‍​‍‍​‌‍​⁪Value⁪⁪"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "⁪⁪⁪‍‌​​​​‍​‌​​‌‌​​​‍‌‌‍​‍​‍‌‌​‍​​‌‌‌‍​‍‍​‌​⁪Ascending⁪⁪",
                "COUNT": "⁪⁪⁪‌‌‌‌‌‌​‌‌‍‌​​​‌‌​‌‍​‌‍​​‍‍​‍​‍​‌​​‍‍‍​‌‍⁪Count⁪⁪",
                "DESCENDING": "⁪⁪⁪‌‌​‌‍​‌​‌‍‌​​​​‌‌​‌​​‌‌‍​​‌​‌​‌‍‍‌​‌‌​​‍​⁪Descending⁪⁪",
                "DIAGONAL": "⁪⁪⁪‍‍‍‍​‌‍‌​​‌​‌​‍‍‍​‍​‍‌‌‍‍​​​‍​‍‍​‍‍‍​‌‍‍⁪Diagonal⁪⁪",
                "DISPLAY_OPTIONS": "⁪⁪⁪‌​​​‍‍‌‌​​‌​‌‍​​​‌‌‌‍‍​​‌​​​​​‍‌‌​‌‍‌‌‌​‌⁪Display Options⁪⁪",
                "ERROR_COLON": "⁪⁪⁪‌​‌​‍​‍‍‍‍‍‌‌​‍‌​​‍‌‍‌​‌‍‌‍‌‍‍​‍​‍​‍‍‍​‍⁪Error:⁪⁪",
                "ERROR_GENERIC": "⁪⁪⁪‌‍‍‌​‍‍​‍‍​‍‌‌​‌​​​‍‍‌​​​‌​‍‌​​​​​‍‍‌‌⁪An error occurred while loading the visualization.⁪⁪",
                "HORIZONTAL": "⁪⁪⁪‌‍‌‍‍‌‍‍​‌‍​‍‌​‌‍​‌‍‍​‍‌​‌‌‍​‍‌‍‍‌‍​‍‌‍⁪Horizontal⁪⁪",
                "HORIZONTAL_BARS": "⁪⁪⁪‍‍‍‍​​‌​​‍‌​‍‌​‌​‍​‍‍‍‍‌‍‌‍‌‍​‍​‍‌​‍‍‌​‌⁪Horizontal Bars⁪⁪",
                "INCORRECTLY_CONFIGURED": "⁪⁪⁪‍‍‌‌‌​‌‍‌​‌‌‍​​​​​‍​​​​‍‍‍‌​‍​‌‌‌​‍‌​‌‌‌⁪Choose a value to display chart⁪⁪",
                "LEGEND_AUTO": "⁪⁪⁪‌‍‌​​‌‍‍​‌‍‍‍‍​​​​‌​‍‌‌‍‌‌​‍‌‌‌​​​‌‍​‍​⁪Auto⁪⁪",
                "LEGEND_BOTTOM": "⁪⁪⁪‌‍‍‌‍‌‍‌‍​‌‌‌‌‌‌​‌‍‍‍‌‍‌‌‍‌‍‌‌‍​‌‌​‌‌‌​‍⁪Bottom⁪⁪",
                "LEGEND_INSET": "⁪⁪⁪‌​‌‌‍‍​​​​‍‌​‍‌‌​​‍‍‍​‌‌​​​​​‌​‌‍​‍​​​​‌‌⁪Inset⁪⁪",
                "LEGEND_RIGHT": "⁪⁪⁪‌‌‍‍‌​​​​​‌‍‌‍‌‌​‌‍‍‌‌​​‌​‍‍​​​‍‍‌​​‌‍​​⁪Right⁪⁪",
                "NORMALIZE_TO_PERCENTAGES": "⁪⁪⁪‍​‍‌‌‌‌​​‍‌​​‍‌‌‍‌‌​​​‍​​‌​‌‌‌​‍​​‌‌‍‌‌‌⁪Normalize to Percentages⁪⁪",
                "SHOW_BAR_LABELS": "⁪⁪⁪‍​‌‍​‍​‍‍‌‍‌​‍‌‍‌​‍‌‍‌‍​​​‌‌‌​‌​‍​​‌‍‌‍⁪Show Bar Labels⁪⁪",
                "SHOW_LEGEND": "⁪⁪⁪‍‍​‌​​‌​‌‌‍‍‍‌‌‍‍‌​​‍‍‌‍‌‌‌‌‌‌​‌‌‌‍‍‍‍‍‍⁪Show Legend⁪⁪",
                "SHOW_X_AXIS": "⁪⁪⁪‌‌‌‌‍‌‍​‍‍​‌‌‍​​‍​​‌​‌‌​‌‌‌‌‍​​​​‍‍‌‍​‍⁪Show X Axis⁪⁪",
                "SHOW_Y_AXIS": "⁪⁪⁪‍‌​​‍‌‍‍‍​​​‌‍‌‍‍​​‍‌‌​‍‌‌‍‍‌​​‍‌​‌‍​‍​‍⁪Show Y Axis⁪⁪",
                "SORT_BAR_VALUES": "⁪⁪⁪‌‍​‍​​​‍​‍‌‍‍‌‌​‌‌​‌‍‍​​‌​​​‌‍‍‍‍‌‍​‌​‌‌⁪Sort Bar Values⁪⁪",
                "STACKED_BARS": "⁪⁪⁪‍​‌‌​‌‌​‌​‍​‍‍‌​‍‍‍‌​‌​‌‌‍​​‍​‍‍‌‌​​​‍‌⁪Stacked Bars⁪⁪",
                "TRANSPOSE": "⁪⁪⁪‌‌​‍‍‌​‌​​‍‍​‌‍‍‍‌‌‍​‌‍‌​​‌‍​‌​​‍​‍‍​‌‌‍​⁪Transpose⁪⁪",
                "TRUNCATE_LABELS": "⁪⁪⁪‌​‌‍​​‍​‍‌‌‌​‍‍‌‌​​‍‍‌​‌​‍‌​​‌‌​‌‍‍‍‌‌​​‍⁪Truncate Labels⁪⁪",
                "VERTICAL": "⁪⁪⁪‍​‍​​‌​​‍‌‌‌‍‌‌‍​‌‌‌​‌​‍‍‍‍‌‌​‍​‌‍‌‌‍‌‍​⁪Vertical⁪⁪"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "⁪⁪⁪‌​‌​‌​‌‌‌​​‍‌‌‍‌‍​‍‌​‍​‍‌‌​‍​​‌‍​‍​​‍‍‍‌​⁪All Others⁪⁪",
                "COULD_NOT_LOAD_DATA": "⁪⁪⁪‌​‍‍‍​‌‍‌‍​​‌‍‌​​‍‌​‌‌​​​‍‍‍‍‌‌‌‍​‍​​‍​​‍⁪Couldnt load data with specified configuration — try a different source field or a larger date range.⁪⁪",
                "GROUPING_PERCENTAGE_THRESHOLD": "⁪⁪⁪‌‌‍‌​‍‍‍‍​‌‍​‍​‌​‍‌‍‍‍‌‌‍​​‌​‌‌‌​​‌‍‍‌‌‌⁪Grouping Percentage Threshold⁪⁪",
                "NO_DATA": "⁪⁪⁪‌​‍‍‌‌‌‌‌‌‌‍‌‌‍‍​‍‌‍‍​​​‌‌‍​​‌‌​‍‍​‌‍‍​‌​⁪No Data⁪⁪",
                "RADIUS": "⁪⁪⁪‌‍​‌‍​‍‌​​​​‍​‌​‍‌‍‍‍​‌‌​‍‌‍‍​‍‍​‍‍‍​‌​⁪Inner Radius⁪⁪",
                "SHOW_AS_PERCENTAGES": "⁪⁪⁪‌​‍‍‍‍​​​‌‍‌​​​‍​​​‌‌‍‍‌​​​​​​​‌‌‌‍‍‌‍‍‌⁪Show As Percentages⁪⁪"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "⁪⁪⁪‌‍‍‌​​​‍​‍‌​‌‍​‌​​‌‌‌‍‍​‌​‌​​‌​‌‍‌‌‌‌‍​‌⁪Close⁪⁪",
                "DOWNLOAD_CSV": "⁪⁪⁪‌‌​‌‍‌‍‍‍​‌‍​‌‌‌‌​‍‌‍‌​‌​​‍​‍​​​‍​‍​‌‍‍⁪Download CSV⁪⁪",
                "DOWNLOAD_ZIP": "⁪⁪⁪‌​​‌‌‌‌‍‌‍​‍‍​‍‌​‌‍‌​‍​​‌‌‌‌‍‌‍​‌​​‍‍‍​⁪Download all files⁪⁪",
                "NO_DATA": "⁪⁪⁪‌​‍‌‍​‍​‌‍‍‌​‍‍‌‌‌​‍‌‍​‌‍​‌‍‌‍​‌​​‍‍‍​‍​⁪No Data⁪⁪",
                "PAGE_OF": "⁪⁪⁪‍‍‌​​​​​​‍‍​​‌‌‌​‍‍‌‍‍‍‌​‍​​‍​​​‌‍‍‍‌‍‍‍⁪Page: %1 Of %2⁪⁪",
                "RESULTS_PER_PAGE": "⁪⁪⁪‍‌‌‍‌​‍‍‌‌‌​‍‍​‌‍‌‌‌‌​‌‌‍‍‍‌‍‌‍‍​‌​​‌​‌⁪Results per page⁪⁪",
                "SHOWING_RECORDS_OF": "⁪⁪⁪‌‌​‌​‌​‍‌​‌​‍‌‌‍​‍‍‍‍‍‌‍‌​‌‍‍‍​‌​​‌​‌‌‍​⁪Showing records %1 - %2 of %3⁪⁪",
                "SINGLE_RESPONSE": "⁪⁪⁪‌‌‍‌​​‍​​‍‍‌‍​‍‌​​‌‍​​‌‌​​​​​​‍‍​‍‍‍​‍‍‌⁪Single Response⁪⁪",
                "VIEW_RESPONSE": "⁪⁪⁪‌​‌‍​‌‍‌‌​​‌​​​‌‌‍​‌‌‌‍‌‌‍​‍‍‍‍‍‌‌‌‌‍​​‌‌⁪View Response⁪⁪"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "⁪⁪⁪‌‌‌‌‍‌​‍‌‌‌​‍‌‌​‍‍​‌​‌‌​‌‌​‍​‌‍‍​‌‍​‍​‌‌⁪Display Options⁪⁪",
                "ERROR_COLON": "⁪⁪⁪‍‌‍‌‌​‌‍‌​‌‍​‌​​​​​​​‍​‌​​​‍​‌‌‍‌​‍​‌‌‌⁪Error:⁪⁪",
                "ERROR_GENERIC": "⁪⁪⁪‌​‍‌​​‌‍‍‍‍‍​‍​‌​‌‌​​​‌‌‍​​​​‌​‌‌​​‌‌‍‍‍‍⁪An error occurred while loading the visualization.⁪⁪",
                "HORIZONTAL_BARS": "⁪⁪⁪‍‌​‍​‍‌‌​‌​‍‌‍‍‍‌​‍‌‍‍‌‌​‌‌​‍​‍​‌‍​‌‍​​​⁪Horizontal Bars⁪⁪",
                "INCORRECTLY_CONFIGURED": "⁪⁪⁪‍​‌‍‌‌‍​‍‌‍‌‍‌​‍‍‍‌‍‌​‍​‍​​‍​​‍​‍​​‌‍​⁪Choose a value to display chart⁪⁪",
                "LEGEND_AUTO": "⁪⁪⁪‌​​‍‍​‍​‍‌‍‌‍‌‍‍‌‌‍‍‌‍​‍‍‍‌‌​‍​‌‌‌​‍​​‌​‍⁪Auto⁪⁪",
                "LEGEND_BOTTOM": "⁪⁪⁪‌‌​‍​​‌​​​‌​‌​‌‍​‌​‍‍‌​‌‌‌‌​​‌​‌​​​‍‌‍‍‌⁪Bottom⁪⁪",
                "LEGEND_INSET": "⁪⁪⁪‌‌‌‍‍​‌​‍‍​​‍​​‌‍‍‍​‍‍‌​‍‍‌‌​‌​​​​‌‌‍‌‌‍⁪Inset⁪⁪",
                "LEGEND_RIGHT": "⁪⁪⁪‌‌​‍‍​‌‍‌‌‌‌‌‌‍‍‍​‍‍​​‌​‍​‌​‍‍​‌‌​​‌‌‍‍‌‌⁪Right⁪⁪",
                "NORMALIZE_TO_PERCENTAGES": "⁪⁪⁪‍​​‌‍​​​‌​‌‍​​​‍​‌​‍‍​‍‌‌‌‌‌​‍‌‍​‌​​‌‍​‌⁪Normalize to Percentages⁪⁪",
                "SHOW_AREA": "⁪⁪⁪‌​‍‍‍​‍‌‌‍‍​‌​‍‌​‍‍​‌‍‌​‌​​‌‍‌‌‌​‍​‍‍‍‌‌‌⁪Show Area⁪⁪",
                "SHOW_LEGEND": "⁪⁪⁪‌‌​‌‍‌​‌‍‍‌​‍​‌‍‍​‍‍​‍‍‌‍​‌​‌‌‍‌​​‍​‍‍‌​⁪Show Legend⁪⁪",
                "SHOW_X_AXIS": "⁪⁪⁪‍‍‌​‍​‌‍​‌‌​‍​​‍‍‍‌​‍​‌‌‌‍​‍‌‍​‍‍‍‌​‌‍‌​⁪Show X Axis⁪⁪",
                "SHOW_Y_AXIS": "⁪⁪⁪‍​​‍​‍​​‍​​‍‍‍​​​‌‌‌‍‌‍‍​‍‍‍​​‌​​‍​‌‌‍⁪Show Y Axis⁪⁪",
                "SMOOTH_LINES": "⁪⁪⁪‌‌‌‌‍​‍‌‍‌​‍‍‌‍​​‍‍​​​‌‌​‍‌‍​​‍​‌‍‌​​​‍‍‌⁪Smooth Lines⁪⁪",
                "SORT_X_AXIS_LABELS": "⁪⁪⁪‍‍​‌‍‌‌‍‌‍‌​‍​‌​‌‍​‌‌‌​‍‍‍‌‌‌​‌​‍‌‌‌​‍​⁪Sort X Axis Labels⁪⁪",
                "STACKED_BARS": "⁪⁪⁪‌​‌​‌‍​‍‍‍​​‌​​‍‌​​​​‌​​‍​​‌‌​‌‌​‌‍‍‍‍‍‍⁪Stacked Bars⁪⁪",
                "TRANSPOSE": "⁪⁪⁪‌​‌​‌‍‌‍‌​​​​​‌‌​​‌‍‍‌‌‌‍​‌‌​‍‌‍‍​‌‌‌‌​​‍⁪Transpose⁪⁪"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "⁪⁪⁪‌‌​‌‍‍‌‍​‌‍‌‌‌‌​​‍‌‍‌‍​‍‌‌‍​​‌‌‍‌​‍‌​‍‌‌‍⁪Block Mode⁪⁪",
                "BLUR": "⁪⁪⁪‍‌​‌‌‍‍‌‌​​​‌‌​‍‌‌‍‍‍‍‌​‍‌​‍​‌‍‌‌‌​‌‍‌​​⁪Blur⁪⁪",
                "COULD_NOT_LOAD_DATA": "⁪⁪⁪‌‌​‍‌‍​‍‌​‌‍‌​‌‍​‌​​‍‍‍​​‍‌‍​‍‍‌​​​‌‌‍‍‍⁪Couldnt load data with specified configuration — try a different source field or a larger date range.⁪⁪",
                "FIELD": "⁪⁪⁪‌‌​‍‍‌‌‍‍‍​​​​​‍‍​‍‌​​‌‍‍‌​‌‍‌‍​​​‍‍​‍‍‍‍⁪Field⁪⁪",
                "RADIUS": "⁪⁪⁪‌​​‌‍‌‍‍​​‍‌​‍‌‌​​​‌‌‌​‌‍​‍‍​​‌‍​‌​‍​​‍​⁪Radius⁪⁪",
                "SHOW_REGIONS": "⁪⁪⁪‌‌‌​​‍‍‍​‌‌‌​‌‌​‌‌​​​‍‍‍​​​​‍‍‍‍‌​‌‍‍‍‍‍​⁪Show Regions⁪⁪",
                "SHOW_REGION_LABELS": "⁪⁪⁪‌‌‌‌​‍​‌‌​‍​‌‍‍​‍‌‌‍​​‍‍​‍‌​‌‍​​​​‌‍​‍‌⁪Show Region Labels⁪⁪"
            },
            "GAUGEWIDGET": {
                "MAX": "⁪⁪⁪‌​​‌‌‍‌‌‌‍‌‍​‌​​‍‍‌​‍‌​​‌‌‌​‌‍‌​​​​‌‌‍​​‍⁪Max⁪⁪",
                "MIN": "⁪⁪⁪‌‌‌‍‌‍​‍‍‍‍‌‍‍‌‍‍​‌‌​​‍​​​‍​‌‌​​​​‍​‍​‍‍⁪Min⁪⁪",
                "VALUE_RANGES": "⁪⁪⁪‌​‌‍​‍‍‌‌‌‌​‍‍‌‌‌‍‌​​‍‌‌‍‌​‌‌‌‍‍​‍​‌​‌​‍⁪Value ranges⁪⁪"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "⁪⁪⁪‌​‍‌​​‍‌‍‌‍‍‌‌‌‍​‍‍​‌‍‍‍‍‌‍‌​‍‌‌‍​​‍‌‌​​‍⁪Bottom labels⁪⁪",
                "CATEGORY_NAME": "⁪⁪⁪‍‍‌‍​‌‌‌‌‍‌‍‍‍‍​‍‌‍‍‌​‍​​‍‌‌‌​‍‍‌‌‍‌‍‍‍⁪Category name⁪⁪",
                "ERROR_COLON": "⁪⁪⁪‍‍​​‍​​​‍​‌‌​​​‌‌‍‍‌​‌‌‍​​‍‍‌‌‌‍‍‍​​‍‌​‌⁪Error:⁪⁪",
                "INCLUDE_HIDDEN_GROUPS": "⁪⁪⁪‌​‌‌‌‌​‌​‍‍‌‌‌​‌​‍‍‌​‍‌‌‍‍​​‍‌‌‍‌‍‍​​‍‌​‍⁪Include hidden groups in percents⁪⁪",
                "LARGE_LABELS": "⁪⁪⁪‌​‍​‍​‌‍​‌‍‍​​‍‍​‍​​‌​‍‍‍‌​​‍​‍​‍‍​‍​‍‌‌‌⁪Large labels⁪⁪",
                "NO": "⁪⁪⁪‍‌​‍​‌‌‌‌​‍‌​​‌‌‍‍‌‍​‌‍​‌‍‌‌‌‍​​‍​‍‌​​​​⁪No⁪⁪",
                "PERCENT": "⁪⁪⁪‌‍​‍​‍‍‌‍​‍‌‍‌​‍‍‌‌‌‌‌​​‍‌‍‍‍​​‌‌‌​‍‍‍​​⁪Percent⁪⁪",
                "RESPONSE_COUNT": "⁪⁪⁪‍‌‌‌‌​‍‍‍‌‌‍​​‍‍​​‌‌‌‍‌​‍‌‌‍‍​‍‍​‌​‍​​‍⁪Response count⁪⁪",
                "RESPONSE_COUNT_WITH_VALUE": "⁪⁪⁪‌​​‍‍​‍‌‌‌‌​‌​​‌​‌‌‍‌​‍‍‌‍​‍‍‌​‍‍‌‌‌‌‌‌​​⁪​​​{{ responseCount }}‌‌‌ responses⁪⁪",
                "SMALL_LABELS": "⁪⁪⁪‍‌​​‍‍‌‌‍​‍‌‌‍​‌‍​‌​‌‌‍‌‌‍‍​​​‌​‌‌‍‌‍​‍‌⁪Small labels⁪⁪",
                "YES": "⁪⁪⁪‌​‍‍​​​‍‌​‍‍​‍‌‌​‌​‍‌‌​‍​‌‌‍‌‍​​​‍‌‌‍‍‍‍‌⁪Yes⁪⁪"
            }
        });
        $cache.put('RU', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "Код доступа",
                "ACCESS_CODE_PROTECTION": "Защита кода доступа",
                "ADD": "Добавить",
                "ADD_BREAKOUT": "Добавить разбивку отчета",
                "ADD_NOTE": "Добавить примечание",
                "ADD_SCHEDULED_REPORT": "Добавить запланированный отчет",
                "ADD_WIDGET": "Добавить визуализацию",
                "ALL_PROJECTS": "Все проекты",
                "ALL_QUESTIONS": "Страницы вопросов",
                "ANSWER": "Ответ",
                "ANY_CHANGES_LOST": "Если вы выйдете из платформы Qualtrics XM, любые изменения в отчетах будут потеряны.",
                "APPENDED_COPY_IN_PARENS": "(Копия)",
                "AREA_CHART": "Диаграмма с областями",
                "AREA_CHART_DESC": "Двухкоординатный график с заполненной областью под линией.",
                "ATTACHMENT": "Вложение",
                "BACKUP_CURRENT_REPORT": "Перед изменением визуализации сохраните резервную копию этого отчета",
                "BACKUP_CURRENT_REPORT_LINE2": "Примечание: Резервная копия будет называться \"{{nameOfReportCopy}}\"",
                "BACK_TO_REPORTS": "Назад к отчетам",
                "BACK_TO_TOP": "К началу",
                "BACK_TO_VIEW_RESULTS": "Назад к прежним результатам просмотра",
                "BAR_CHART": "Гистограмма",
                "BAR_CHART_DESC": "Двухкоординатная гистограмма, которая позволяет выполнять дополнительную настройку, например, перенос осей координат и перестановку точек данных.",
                "BREAKDOWN_BAR_CHART": "Диаграмма с накоплением",
                "BREAKDOWN_BAR_CHART_DESC": "Горизонтальная гистограмма с накоплением чаще всего используется для визуального сопоставления метрик друг с другом в качестве альтернативы круговой диаграмме.",
                "CANCEL": "Отмена",
                "CANCEL_CONF_TEXT": "Вы действительно хотите выполнить отмену?<br/>Все изменения будут потеряны.",
                "CANCEL_EDITS": "Отменить изменения",
                "CHART": "Диаграмма",
                "CHOICE": "Вариант ответа",
                "CHOICES_COUNT_METRIC": "Количество вариантов ответа",
                "CHOOSE_PAGES_TO_DISPLAY": "Выбрать страницы для отображения",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "Этот отчет содержит {{maxReportPageCount}} страниц, но результаты могут содержать не более {{reportSizeLimit}}. Выберите поднабор в пределах лимита.",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "Отчеты могут содержать не более {{reportSizeLimit}} страниц, выберите нужные страницы.",
                "CLEAR_ALL": "Очистить все",
                "CLOSE": "Закрыть",
                "CLOUD": "ОПИСАНИЕ ДЛЯ ОБЛАКА",
                "COLLABORATED_NEW": "Владелец этого опроса использует платформу Qualtrics XM! Отчеты для этого опроса будут редактироваться с использованием новых результатов.",
                "COMMA_SEPARATED_LIST": "Список элементов, разделенных запятыми",
                "COMPACTNESS": "Шрифты и интервалы",
                "COMPACTNESS_INFO": "Эта настройка влияет на заполнение таблицы, размер шрифта и размер полос в диаграммах. Он также будет применяться к большей части экспорта.",
                "CONFIRM": "ОК",
                "CONFIRM_DELETE": "Подтвердить удаление",
                "CONFIRM_DELETE_PAGE": "Вы действительны хотите удалить эту страницу?",
                "CONTINUE": "Продолжить",
                "CONTINUE_EDITING": "Продолжить редактирование",
                "COPY": "Копировать",
                "COPY_OF_REPORT_NAME": "Копия {{nameOfCurrentReport}}",
                "COPY_REPORT": "Копировать отчет",
                "COPY_REPORT_ELLIPSIS": "Копировать отчет...",
                "COPY_TO_NEW_REPORT": "Копировать в новый отчет...",
                "CREATE": "Создать",
                "CREATED": "Дата создания",
                "CREATE_CUSTOM_PAGE": "Создать пользовательскую таблицу",
                "CREATE_NEW_REPORT": "Создать новый отчет",
                "CREATE_NEW_REPORT_ELLIPSIS": "Создать новый отчет...",
                "CSV_FILE": "Файл CSV",
                "CUSTOM_PAGES": "Пользовательские страницы",
                "DATE": "Дата",
                "DEFAULT_PALETTE": "Цветовая палитра по умолчанию",
                "DEFAULT_REPORT": "Отчет по умолчанию",
                "DEFAULT_VISUALIZATIONS": "Визуализации по умолчанию",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "Эти типы визуализации по умолчанию используются для построения отчетов по результатам по умолчанию. Обновление и применение этих настроек приведет к перестройке текущего отчета с новыми настройками по умолчанию. У вас будет возможность создать резервную копию текущего отчета.",
                "DEFAULT_VISUALIZATIONS_NOTE": "Примечание: Не все типы визуализации доступны для всех типов вопросов. Некоторые нестандартные визуализации могут быть подставлены автоматически.",
                "DEFAULT_VISUALS_DISCLAIMER": "Qualtrics обновит этот отчет с учетом новых настроек визуализации по умолчанию.",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "Это обновление повлияет на {{amountOfWidgetsAffected}} визуализации в этом отчете.",
                "DEFAULT_VISUAL_EDIT_DETECTED": "Обнаружено изменение визуализации по умолчанию",
                "DELETE_BUTTON": "Удалить",
                "DELETE_DISABLED_EXPLANATION": "Удаление отчетов, созданных в предыдущем интерфейсе отчетов, не допускается, пока ваша организация не выполнит полную миграцию на платформу Qualtrics XM.",
                "DELETE_PAGE": "Удалить страницу",
                "DELETE_PAGE_ELLIPSIS": "Удалить страницу...",
                "DELETE_REPORT": "Удалить отчет",
                "DELETE_REPORT_ELLIPSIS": "Удалить отчет...",
                "DELETE_WIDGET_QUESTION": "Удалить?",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "Это поле зашифровано и не может использоваться для сортировки.",
                "DISCARD_EDITS": "Отменить изменения",
                "DISTRIBUTION_PAUSED": "Рассылка отчета приостановлена.",
                "DONE_BUTTON": "Выполнено",
                "DONE_EDITING": "Редактирование завершено",
                "DOWNLOAD": "Скачать",
                "DOWNLOAD_AS_CSV": "Скачать в формате CSV",
                "DOWNLOAD_AS_PDF": "Скачать в формате PDF",
                "DOWNLOAD_FAILED": "Не удалось выполнить скачивание",
                "DOWNLOAD_PREVIOUS_EXPORTS": "Скачать предыдущий экспорт...",
                "DO_YOU_WISH_TO_DELETE": "Вы хотите удалить:",
                "DUPLICATE_PAGE": "Дублирующийся лист",
                "EDIT_REPORT": "Редактировать отчет",
                "EDIT_REPORT_ELLIPSIS": "Редактировать отчет...",
                "EDIT_VISUALIZATION": "Редактировать визуализацию",
                "EMAIL_ADDRESS": "Адрес электронной почты",
                "EMAIL_SENT": "Электронное сообщение отправлено...",
                "END_OF_REPORT": "Конец отчета",
                "ENTER_NAME": "Ввести имя",
                "ERROR_COPYING": "При копировании отчета возникла ошибка.",
                "ERROR_DELETING": "При удалении отчета возникла ошибка.",
                "ERROR_DELETING_EXPORT": "При удалении экспорта возникла ошибка.",
                "ERROR_HEADING": "Ошибка",
                "ERROR_PUBLISHING": "При сохранении настроек произошла ошибка.",
                "ERROR_RENAMING": "При переименовании отчета возникла ошибка.",
                "ERROR_REQUESTING_EXPORT": "При запросе экспорта возникла ошибка.",
                "ERROR_SAVING_GLOBAL_OPTIONS": "При сохранении глобальных параметров визуализации возникла ошибка.",
                "ERROR_SEND_TEST_EMAIL": "При отправке тестового электронного письма произошла ошибка.",
                "EVERY_FRIDAY": "Каждую пятницу",
                "EVERY_MONDAY": "Каждый понедельник",
                "EVERY_MONTH": "Ежемесячно,",
                "EVERY_SATURDAY": "Каждую субботу",
                "EVERY_SUNDAY": "Каждое воскресенье",
                "EVERY_THURSDAY": "Каждый четверг",
                "EVERY_TUESDAY": "Каждый вторник",
                "EVERY_WEDNESDAY": "Каждую среду",
                "EVERY_WEEK": "Еженедельно, каждый",
                "EXAMPLE_GROUP_NUM": "Группа {{num}}",
                "EXAMPLE_SERIES_NUM": "Серия {{num}}",
                "EXPORT": "Экспорт",
                "EXPORT_CSV": "CSV (значения, разделенные запятыми)",
                "EXPORT_EXCEL_SPREADSHEET": "Электронная таблица Excel",
                "EXPORT_IMAGE": "Экспортировать изображение",
                "EXPORT_PAGES": "Экспортировать страницу",
                "EXPORT_PDF": "Документ PDF",
                "EXPORT_PPT_SLIDES": "Слайды в формате PowerPoint",
                "EXPORT_RAW_DATA": "Экспортировать необработанные данные",
                "EXPORT_REPORT": "Экспортировать отчет",
                "EXPORT_VISUALIZATION": "Экспортировать визуализацию",
                "EXPORT_WORD_DOC": "Документ Word",
                "FAILED_SAVE_TXT": "Не удалось сохранить",
                "FILTERED": "Отфильтровано",
                "FIRST_PAGE": "Первая страница",
                "FIRST_WEEKDAY": "Первый будний день месяца",
                "FROM": "От",
                "FROM_EMAIL": "С адреса электронной почты",
                "FROM_NAME": "От кого",
                "GAUGE_CHART": "Диаграмма масштаба",
                "GAUGE_CHART_DESC": "Диаграмма, напоминающая измерительный инструмент для сравнения текущих значений с целевыми значениями или серией пороговых значений.",
                "GENERATING_FILE": "Выполняется генерация файла...",
                "GENERATING_IMAGE": "Выполняется генерация изображения...",
                "GENERATING_PDF": "Выполняется генерация файла PDF...",
                "GENERIC_ERROR": "Не удалось загрузить запрошенный вами проект из-за возникшей ошибки.",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "Глобальные параметры...",
                "GLOBAL_METRIC": "Метрика по умолчанию",
                "GLOBAL_MODAL_PAGE_TITLE": "Типовая визуализация с использованием глобальных параметров для раздела результатов Qualtrics Research Suite",
                "GLOBAL_MODAL_WIDGET_TITLE": "Заголовок визуализации",
                "GLOBAL_OPTIONS": "Глобальные параметры",
                "GLOBAL_PRECISION": "Число десятичных знаков по умолчанию",
                "GLOBAL_SETTINGS_APPLY": "Применить мои настройки по умолчанию",
                "GLOBAL_SETTINGS_SAVE": "Сохранить как мои настройки по умолчанию",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "Применить настройку Qualtrics по умолчанию",
                "GROUP": "Группа",
                "HEAT_MAP_CHART": "Диаграмма тепловой карты",
                "HEAT_MAP_CHART_DESC": "Кластерная визуализация в виде тепловой карты, используемая для отображения рассылки пользовательского средства ввода (например, щелчков) на исходное изображение.",
                "HIDDEN": "Скрыто",
                "HIDDEN_PAGE": "Эта страница не будет отображаться в публичных отчетах и по умолчанию будет не будет выбрана при экспорте отчетов.",
                "HIDE": "Скрыть",
                "HIDE_ALL_PAGES": "Скрыть все страницы",
                "HIDE_PAGE": "Скрыть страницу",
                "IMAGE_FILE": "Файл изображений",
                "INVALID_BRAND_DOMAIN": "Введенный вами домен отсутствует в списке утвержденных вашим брендом доменов электронной почты. Чтобы исправить это, обратитесь к администратору бренда.",
                "INVALID_SPF_RECORD": "Введенный вами домен не утвердил Qualtrics для отправки с него. Это повлияет на возможность доставки. Используйте другой домен или обратитесь к Qualtrics для решения этой проблемы.",
                "ISSUE_SAVING_REPORTS": "При сохранении одного или нескольких отчетов возникла проблема. Повторите попытку.",
                "ISSUE_SENDING_TEST": "При отправке тестового электронного письма произошла ошибка. Повторите попытку.",
                "LARGE_SURVEY": "Результаты не будут отображены из-за слишком большого размера опроса.",
                "LAST_DAY": "Последний день месяца",
                "LAST_MODIFIED_COLON_WITH_DATE": "Последнее изменение: %1",
                "LAST_PAGE": "Последняя страница",
                "LAST_WEEKDAY": "Последний будний день месяца",
                "LATER": "Позднее",
                "LEARN_MORE": "Узнать больше",
                "LINE_CHART": "График",
                "LINE_CHART_DESC": "Двухкоординатный график, обычно используемый при построении графика зависимости от времени по оси x.",
                "LOG_OUT_WARNING": "Щелкните в любом месте в течение {{countdown}} секунд, чтобы оставаться в системе",
                "MESSAGE": "Сообщение",
                "MONTHLY": "Ежемесячно",
                "MOVE_DOWN": "Переместить визуализацию вниз",
                "MOVE_PAGE_TO_BOTTOM": "Переместить в конец",
                "MOVE_PAGE_TO_TOP": "Переместить в начало",
                "MOVE_UP": "Переместить визуализацию вверх",
                "MY_SURVEYS": "Мои проекты",
                "NAME": "Имя",
                "NEW_CUSTOM_PAGE_NAME": "Новая пользовательская страница",
                "NEW_REPORT": "Новый отчет",
                "NEXT_PAGE": "Следующая страница",
                "NEXT_RUN": "Следующий прогон",
                "NO_EXPORTS": "Для этого отчета экспорт еще не был запрошен.",
                "NO_ITEMS_TO_DISPLAY": "Нет элементов для отображения",
                "NO_MATCHING_CUSTOM_PAGES": "Нет соответствующих пользовательских страниц",
                "NO_MATCHING_PAGES": "Страницы для поиска не найдены",
                "NO_MATCHING_REPORTS": "Нет соответствующих отчетов.",
                "NO_PROJECT": "Чтобы продолжить, укажите проект.",
                "NO_PROJECTS_TO_MIGRATE": "Нет проектов для обновления.",
                "NO_QUESTIONS": "Нет соответствующих вопросов",
                "NO_RESULTS_YET": "Пока нет результатов для показа. Разошлите опрос, чтобы собрать ответы.",
                "OFF": "Выкл",
                "ON": "Вкл",
                "PAGES_SELECTED": "Выбранные страницы",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "При таком выборе отчет будет содержать {{currentSelectedPageCount}} страниц, что превышает максимально допустимое количество {{reportSizeLimit}}. Выберите меньший диапазон.",
                "PAGES_SELECTION_INVALID_RANGE": "Выберите допустимый диапазон.",
                "PAGE_OPTIONS": "Параметры страниц",
                "PDF_ROW_TRUNCATION_MESSAGE": "Слишком много строк для экспорта в формате PDF, попробуйте экспортировать в формате Word или CSV.",
                "PERCENTAGE_METRIC": "Доля в процентах",
                "PIE_CHART": "Круговая диаграмма",
                "PIE_CHART_DESC": "Круговая разбивка значений для заданной точки данных. Используется для измерения относительных пропорций выбранных значений.",
                "PREVIEW": "Предпросмотр",
                "PREVIOUS_PAGE": "Предыдущая страница",
                "PRINT_PAGE": "Напечатать страницу",
                "PUBLIC_LINK": "Общедоступная ссылка",
                "PUBLIC_REPORT_AVAILABLE": "Доступный публичный отчет",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "Код доступа",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "Неверный код доступа. Повторите попытку.",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "Отправить",
                "PUBLIC_RESULTS_LOGIN_TITLE": "Вход в публичный отчет | Программное обеспечение Qualtrics для опросов",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "Публичный отчет не найден. Обратитесь к владельцу этого отчета и запросите правильную ссылку.",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "Публичный отчет не найден",
                "PUBLIC_RESULTS_NOT_UPDATED": "Ссылки на публичные отчеты и запланированные электронные письма с отчетами не будут использовать платформу Qualtrics XM, пока не будет выполнено их обновление.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "Время сеанса истекло. Войдите в систему еще раз, чтобы продолжить предварительный просмотр публичного отчета по результатам.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "Сеанс просрочен",
                "PUBLIC_RESULTS_TITLE": "Публичный отчет",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "У вас нет прав для просмотра этой страницы. Обратитесь к владельцу этого отчета и попросите сделать его публичным.",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "Публичный отчет не авторизован",
                "PUBLISHED_LINK_GENERATING_LINK": "Выполняется генерация ссылки...",
                "PUBLISHED_REPORT_FOUND_HERE": "Любой может просмотреть этот отчет по следующей ссылке:",
                "PUBLISH_REPORT": "Управлять публичным отчетом",
                "PUBLISH_REPORT_ELLIPSIS": "Управлять публичным отчетом...",
                "QUESTION": "Вопрос",
                "RANK": "Ранг",
                "REMOVE_WIDGET": "Удалить визуализацию",
                "RENAME_PAGE": "Переименовать страницу",
                "RENAME_REPORT": "Переименовать отчет",
                "RENAME_REPORT_ELLIPSIS": "Переименовать отчет...",
                "REPLY_TO_EMAIL": "Адрес электронной почты для ответа",
                "REPORT_COLON": "Отчет:",
                "REPORT_SETTINGS": "Настройки отчета",
                "REPORT_SETTINGS_ELLIPSIS": "Настройки отчета...",
                "RESPONSE_COUNTS": "Число ответов",
                "RESULTS_DASHBOARDS_BANNER": "и попробовать новую, улучшенную версию результаты опрос с современным доступным пользовательским интерфейсом и визуализациями данных, новыми функциями анализа и исследования и т. д.",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "Информация по версии",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "Просмотреть последние",
                "RESULTS_OPTIONS": "Параметры отчета",
                "RESULTS_TITLE": "Отчет",
                "RESUME_DISTRIBUTION": "Возобновить рассылку",
                "REVERT": "Возврат",
                "RICH_TEXT_LIMIT_REACHED": "Достигнут предел длины контента!",
                "SAVE": "Сохранить",
                "SAVE_AND_CLOSE": "Сохранить и закрыть",
                "SAVE_AS_CSV": "Сохранить визуализацию как CSV",
                "SAVE_AS_IMAGE": "Сохранить визуализацию как изображение",
                "SAVE_CONFIRMATION": "Сохранить подтверждение",
                "SAVE_PAGE_AS_ELLIPSIS": "Экспортировать страницу как...",
                "SAVE_SETTINGS": "Сохранить настройки",
                "SCHEDULE_REPORT_EMAIL": "Запланировать отправку отчета по электронной почте",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "Запланировать отправку отчета по электронной почте...",
                "SEARCH_ELLIPSIS": "Поиск...",
                "SEARCH_PAGES": "Поиск вопросов",
                "SEARCH_PAGES_ELLIPSIS": "Поиск страниц...",
                "SEARCH_REPORTS_ELLIPSIS": "Поиск отчетов...",
                "SELECTED": "Выбрано:",
                "SELECT_ALL": "Выбрать все",
                "SELECT_A_FIELD": "Выбрать поле",
                "SELECT_A_WIDGET": "Выбрать визуализацию",
                "SELECT_PAGES": "Выбрать страницы",
                "SELECT_PAGES_ELLIPSIS": "Выбрать страницы...",
                "SEND": "Отправить",
                "SEND_TEST_EMAIL": "Отправить тестовое сообщение электронной почты",
                "SETTING_DEFAULT": "По умолчанию",
                "SETTING_HIGH": "Высокий",
                "SETTING_LARGE": "Большой",
                "SETTING_LOW": "Низкий",
                "SETTING_NORMAL": "Обычный",
                "SETTING_SMALL": "Маленький",
                "SHARE_REPORT": "Отправить отчет",
                "SHOW_ALL_PAGES": "Показать все страницы",
                "SHOW_FULL_QTEXT": "Показать весь текст вопроса в заголовках страниц",
                "SIMPLE_TABLE": "Простая таблица",
                "SIMPLE_TABLE_DESC": "Гибкая таблица, которая может отображать множество значений в виде строк или столбцов.",
                "SIZE": "Размер",
                "SPLINE_CHART": "Сплайн-диаграмма",
                "SPLINE_CHART_DESC": "Двухкоординатный скругленный график, обычно используемый при построении графика зависимости от времени по оси x.",
                "STATISTICS_TABLE": "Статистическая таблица",
                "SUBJECT": "Тема",
                "SURVEY_ANALYSIS": "Анализ опросов",
                "SURVEY_SUMMARY": "Сводка опроса",
                "TABLE": "ОПИСАНИЕ ДЛЯ ТАБЛИЦЫ",
                "TIME": "Время",
                "TO": "Получатель",
                "TOTAL": "Всего",
                "TRANSPOSE_STATS_TABLES": "Транспонировать статистические таблицы",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "Транспонировать разбивку статистической таблицы",
                "TRUNCATE_PAGE_TITLES": "Усечь текст вопроса в заголовках страниц",
                "TRY_IT_NOW": "Попробовать сейчас",
                "TYPE": "Тип",
                "UNABLE_TO_CHECK_SPF": "Невозможно проверить запись SPF. Повторите попытку.",
                "UNAUTHORIZED": "У вас нет разрешения на просмотр этого отчета. Для получения доступа обратитесь к владельцу отчета.",
                "UNHIDE_PAGE": "Показать страницу",
                "UPDATE": "Обновить",
                "UPDATED_SUCCESSFULLY": "Обновление выполнено успешно.",
                "UPDATE_ALL_IN_THIS_PROJECT": "Обновить все в этом проекте",
                "UPDATE_ALL_PROJECTS": "Обновить все проекты",
                "UPDATE_NOW": "Обновить сейчас",
                "UPDATE_REPORTS": "Обновить отчеты...",
                "UPDATE_REPORT_ELEMENTS": "Обновить ссылки на публичные отчеты и запланированные электронные письма с отчетами",
                "UPGRADE_MY_ACCOUNT": "Обновить мою учетную запись",
                "USE_EXPORT_TAGS": "Включить номера вопросов",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "Использовать итоговые значения столбцов простой таблицы",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "Использовать количество респондентов в простой таблице",
                "USE_WEIGHTED_METRICS": "Взвешенные метрики",
                "VIEW": "Просмотр",
                "WEEKLY": "Еженедельно",
                "WELCOME_TO_NEW_RESULTS": "Добро пожаловать в отчеты на платформе Qualtrics XM!",
                "WHEN": "Когда",
                "WIDGET_LOADING": "Выполняется загрузка...",
                "WIDGET_OPTIONS_ERR": "Не удалось загрузить параметры визуализации",
                "WIDGET_TYPE": "Визуализация",
                "WORD_CLOUD": "Облако слов",
                "WORD_CLOUD_DESC": "Взвешенная визуализация частоты слов в текстовых данных с дополнительными параметрами цветового кодирования."
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Не забывайте, ваши коллеги по организации (например, партнеры по HR, ваш менеджер или куратор) помогут разъяснить оставленный вам отзыв.",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Налейте себе чашечку кофе и откройте оценку вашей работы.",
                "ABOUT_YOUR_REPORT_HEADER": "Об этом отчете",
                "ABOUT_YOUR_REPORT_LINE1": "Это отчет 360 с оценкой вашей работы. Он поможет вам расти и развиваться в профессиональной среде. Чтобы настроиться на успех, не торопитесь, дайте себе время на просмотр результатов этой оценки. Может быть, их непросто принять, но помните, что цель отзыва на вашу работу – помочь вам ускорить свой профессиональный рост и развитие.",
                "ABOUT_YOUR_REPORT_LINE2": "При чтении отчета следует помнить о некоторых вещах.",
                "ADD_CONDITIONAL_TEXT": "Добавить условный текст",
                "ADD_CUSTOM_PALETTE": "Добавить пользовательскую палитру",
                "ADD_DATA_SOURCE": "Добавить источник данных",
                "ADD_FOLLOWING": "Добавить последующие",
                "ADD_LABEL": "Добавить метку",
                "ADVANCED_FILTER": "Расширенный фильтр",
                "AGREEMENT_CHART": "Диаграмма совпадения",
                "AGREEMENT_CHART_FOOTER": "Диаграмма совпадения демонстрирует, насколько похожи выставленные вам оценки. Каждая точка - это оценка по одному направлению. Размер точки показывает, сколько оценивающих лиц поставили вам эту оценку.",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "отв.",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "ответ",
                "AGREEMENT_CHART_LEGEND_TITLE": "Какую оценку дали вам другие пользователи",
                "ALL": "Все",
                "AND_IF": "И если",
                "ANGLED": "Наклонные",
                "AREA": "Область",
                "AUTO": "Автоматически",
                "AVERAGE": "Среднее",
                "AXIS_VALUES": "Значения по осям",
                "BAR": "Полоса",
                "BASE_WORD_COLOR": "Основной цвет слова",
                "BLUR": "Размытость",
                "BOTTOM_BOX": "Нижняя рамка",
                "BREAKOUT_HEADERS": "Заголовки разбивки",
                "CANCEL": "Отмена",
                "CATEGORICAL": "Категориальные",
                "CATEGORY": "Категория",
                "CATEGORY_NAME": "Название категории",
                "CHANGE_CATEGORIES_ORDER": "Изменить порядок категорий",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "Изменить порядок категорий баллов",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "Измените порядок отображения в визуализации, перетаскивая элементы категории баллов на нужные позиции.",
                "CHANGE_QUESTIONS_ORDER": "Изменить порядок вопросов",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "Изменить порядок вопросов",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "Измените порядок отображения в визуализации, перетаскивая элементы вопросов на нужные позиции.",
                "CHARTS": "Диаграммы",
                "CHART_TYPE": "Тип диаграммы",
                "CHOICE_COUNT": "Счетчик вариантов ответов",
                "CHOICE_TOTALS": "Итоги по варианту ответа",
                "CLEAR": "Очистить",
                "CLOSE": "Закрыть",
                "COLOR_PALETTE": "Цветовая палитра",
                "COLUMN_NAMES": "Названия столбцов",
                "COLUMN_TOTALS": "Итоговые значения столбцов",
                "COMPARED_FILTER_GROUP": "Сравниваемая группа фильтров",
                "COMPARED_FILTER_GROUPS": "Сравниваемые группы фильтров",
                "COMPARE_WITH": "сравнить с",
                "COMPETITION_RANKING": "Использовать конкурентное ранжирование",
                "COMPETITION_RANKING_TOOLTIP": "Все равные оценки ранжируются одинаково. Однако ранг следующей позиции в последовательности будет на единицу больше общего числа позиций, ранжированных выше в таблице.",
                "COMPLETED_RESPONSES": "Заполненные ответы",
                "CONDITIONAL_TEXT": "Условный текст",
                "COUNT": "Счетчик",
                "CREATE": "Создать",
                "CUSTOM_PALETTE": "Пользовательская палитра",
                "DATA_SOURCE_TYPE": "Тип источника данных",
                "DATA_SOURCE_TYPE_CATEGORY": "Категории оценки",
                "DATA_SOURCE_TYPE_QUESTION": "Вопросы",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "Вопрос",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "Ранжируемые элементы",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "Категория баллов",
                "DEFAULT": "По умолчанию",
                "DEFAULT_TEXT": "Текст по умолчанию",
                "DELETE": "Удалить",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "Вы можете узнать, кто оценил вашу работу: коллеги, непосредственные подчиненные, руководители и т.д.",
                "DIFFERENT_EVALUATORS_HEADER": "Разные оценивающие лица",
                "DIRECT_REPORTS": "Прямые подчиненные",
                "DISABLED": "Отключено",
                "DISPLAY_OPTIONS": "Отобразить параметры",
                "DISPLAY_THRESHOLD_TEXTS": "Отобразить текст на основе следующего несоответствия групп",
                "DIVERGENT": "Расходящиеся",
                "DONE": "Выполнено",
                "DONT_HEADER": "Не стоит:",
                "DONT_LINE1": "Угадывать, кто какой комментарий оставил",
                "DONT_LINE2": "Фокусироваться на одной положительной или отрицательной оценке либо комментарии",
                "DONT_LINE3": "Создавать план развития по каждому направлению оценки",
                "DONT_LINE4": "Огорчаться, что вам есть куда развиваться",
                "DONUT": "Кольцевая диаграмма",
                "DOWNLOAD_CSV": "Скачать предыдущую версию в формате CSV",
                "DOWNLOAD_ZIP": "Скачать все файлы",
                "DO_HEADER": "Стоит:",
                "DO_LINE1": "Воспринимать отзыв о вашей работе комплексно",
                "DO_LINE2": "Определить свои сильные стороны и возможности совершенствования",
                "DO_LINE3": "Уделить внимание нескольким направлениям, вписав их в свой план развития",
                "DO_LINE4": "Понимать, что каждый имеет слабые стороны, которые можно развивать дальше",
                "DROPOFF": "Отток",
                "DUPLICATE": "Дубликат",
                "EDIT_CONDITIONAL_TEXT": "Редактировать условный текст",
                "EDIT_CUSTOM_PALETTE": "Редактировать пользовательскую палитру",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "Иначе показать следующий текст",
                "ENABLED": "Включено",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "Активировать упорядочивание по логике отображения категорий оценивающих лиц",
                "ENABLE_ORDERING_FOR": "Активировать упорядочивание для",
                "EQUAL_TO": "Равно",
                "FIELD": "Поле",
                "FILTER_NAMES": "Названия фильтров",
                "FOLLOWING_PARENTHESES": "(послед.)",
                "FOOTER": "Нижний колонтитул",
                "GAP": "Несоответствие",
                "GAP_CHART": "Диаграмма несоответствий",
                "GAP_CHART_DESCRIPTION": "Диаграмма несоответствий показывает разницу в баллах между двумя группами оценивающих лиц. Например, самостоятельная оценка в сравнении с оценкой от других людей: положительная разница (+) означает, что другие оценили вас выше, чем вы сами, а отрицательная (-) означает, что другие оценили вас ниже, чем вы сами.",
                "GAP_CHART_FOOTER": "Диаграмма несоответствий показывает положительную или отрицательную разницу между баллами от двух групп оценивающих лиц.",
                "GAP_TABLE_DESCRIPTION": "\"Скрытые сильные стороны\" - это направления, в которых другие оценили вас выше, чем вы сами. \"Направления совершенствования\" - это области, в которых другие оценили вас ниже, чем вы сами. Оценки в обоих разделах отсортированы от наибольшего к наименьшему соответствию.",
                "GAP_TABLE_FOOTER": "Первый столбец содержит баллы, которые вы выставили себе сами. Второй содержит среднее значение по баллам, выставленным вам другими людьми. В третьем столбце указана разница между вашей оценкой и полученными от других.",
                "GAP_TABLE_TITLE": "Скрытые сильные стороны/направления совершенствования",
                "GREATER_OR_EQUAL": "Больше или равно",
                "GREATER_THAN": "Больше",
                "GROUP": "Группа",
                "GROUPED_FOR_ANONYMITY": "Сгруппированы по уровню анонимности",
                "HEADER_NAMES": "Названия заголовков",
                "HIGHEST_SCORES": "Наивысшие оценки",
                "HIGHLIGHT_THRESHOLD": "Пороговое значение для выделения несоответствий",
                "HIGHLOW_TABLE": "Самые высокие и низкие оценки",
                "HIGHLOW_TABLE_FOOTER": "В этом разделе описаны 5 наиболее высоко и 5 наиболее низко оцененных моделей поведения (из всех моделей поведения) исходя из применимых средних значений по категориям оценивающих лиц. В целях максимальной результативности рекомендуем ознакомиться с вероятной динамикой изменений. Например, если большая часть наиболее низко оцененных моделей поведения входит в одну или две категории, возможно, они требуют вашего внимания. Модели поведения, получившие самую высокую оценку, могут указывать на ваши сильные стороны, которые можно использовать и в других сферах.",
                "HIGH_LOW_TABLE_DESCRIPTION": "Диаграмма самых высоких и низких оценок иллюстрирует направления, по которым вам выставили самые высокие и самые низкие баллы.",
                "HORIZONTAL": "По горизонтали",
                "HORIZONTAL_AND_VERTICAL": "Горизонтально и вертикально",
                "HORIZONTAL_BAR": "Горизонтальная полоса",
                "HOW_TO_INTERPRET_RESULT_HEADER": "Как интерпретировать результаты и определить дальнейшие действия:",
                "IF": "Если",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "Включить скрытые заголовки в процентах",
                "INNER_RIM": "Внутреннее кольцо",
                "IS": "Равно",
                "IS_NOT": "Не является",
                "IS_SAME_AS_SUBJECT": "Совпадает с субъектом",
                "ITEM": "Элемент",
                "LABEL": "метка",
                "LABELS": "Метки",
                "LARGE_LABELS": "Крупные метки",
                "LEGEND": "Условные обозначения",
                "LEGEND_POSITION": "Расположение условных обозначений",
                "LEGEND_VALUES": "Значения условных обозначений",
                "LESS_OR_EQUAL": "Меньше или равно",
                "LESS_THAN": "Меньше",
                "LINE": "Линия",
                "LOWEST_SCORES": "Самые низкие оценки",
                "MANAGERS": "Менеджеры",
                "MANUAL_FONT_SIZE": "Установить размер шрифта вручную",
                "MAX": "Макс.",
                "MEAN": "Среднее",
                "MEDIAN": "Медиана",
                "METRIC_TYPE": "Тип метрики",
                "MIN": "Мин.",
                "MODIFY_CUSTOM_PALETTES": "Изменить пользовательские палитры",
                "MOVE_DOWN": "Переместить вниз",
                "MOVE_UP": "Переместить вверх",
                "MULTI_SELECT_ITEMS_SELECTED": "выбрано",
                "NEGATIVE_GAPS": "Направления совершенствования",
                "NO": "Нет",
                "NONE": "Нет",
                "NOT_APPLICABLE": "Не применимо",
                "NOT_EQUAL_TO": "Не равно",
                "NO_DATA_AVAILABLE_WARNING": "Нет данных",
                "NO_FILTER": "Без фильтр",
                "NO_FILTER_IS_APPLIED": "Фильтры не применены.",
                "NO_VALUE": "Нет значения",
                "NPS": "Индекс потребительской лояльности",
                "NUMBER": "число",
                "NUMBERS": "Числа",
                "NUMBER_OF_GAPS_NEGATIVE": "Количество вариантов с отрицательной разницей",
                "NUMBER_OF_GAPS_POSITIVE": "Количество вариантов с положительной разницей",
                "NUMBER_OF_ROWS_HIGH": "Количество высоких строк",
                "NUMBER_OF_ROWS_LOW": "Количество низких строк",
                "OPTIONS": {
                    "HEADER_NAME": "Название заголовка",
                    "LEGEND": "Условные обозначения",
                    "SCALE_AXIS_CHANGER_TITLE": "Диапазон"
                },
                "ORIENTATION": "Ориентация",
                "OR_IF": "Или если",
                "OTHER": "Другое",
                "OTHERS": "Другие",
                "PAGE_OF": "Стр. %1 из %2",
                "PALETTE_REMOVED": "Палитра удалена",
                "PEERS": "Коллеги",
                "PERCENT": "Процент",
                "PERCENTAGE": "Доля в процентах",
                "PERCENTAGE_OF_CHOICES": "Процент выбранных ответов",
                "PERCENTAGE_OF_RESPONSES": "Процент ответов",
                "PERCENT_COMPLETE": "% выполнено",
                "PERSON_METADATA": "Метаданные лица",
                "PERSON_METADATA_EVALUATOR": "Оценщика",
                "PERSON_METADATA_SUBJECT": "У субъекта",
                "PERSON_METADATA_VIEWER": "Наблюдателя",
                "POSITIVE_GAPS": "Скрытые сильные стороны",
                "PRIMARY_PARENTHESES": "(первич.)",
                "QUESTIONS": "Вопросы",
                "RADIUS": "Радиус",
                "RANK": "Ранг",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "Наивысшая оценка",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "Наивысшие оценки",
                "RANKABLE_ITEMS_ITEM_HAS": "Элемент имеет",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "Элемент входит в",
                "RANKABLE_ITEMS_LOWEST_SCORE": "Самая низкая оценка",
                "RANKABLE_ITEMS_LOWEST_SCORES": "Самые низкие оценки",
                "RATER_CATEGORY_DISPLAY_LOGIC": "логика просмотра категорий оценивающих лиц",
                "RATIO": "Соотношение",
                "RECORD": "Запись",
                "REFERENCE_GROUP": "Ссылочная группа",
                "RELATIONSHIP": "Отношения",
                "RELATIONSHIP_FILTERS": "Фильтры отношений",
                "RELATIONSHIP_FILTERS_INFO": "Чтобы добавить фильтр отношений (например, прямой подчиненный, коллега, руководитель), выберите \"Управление фильтрами\" и используйте условие \"Отношение\", открыв его в раскрывающемся меню.",
                "REMOVE": "Удалить",
                "REMOVE_DATA_SOURCE": "Удалить источник данных",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Помните, ваши коллеги по организации (например, партнеры по HR, ваш менеджер или куратор) помогут разъяснить оставленный вам отзыв.",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Налейте себе чашечку кофе и откройте оценку вашей работы.",
                    "ABOUT_YOUR_REPORT_HEADER": "Об этом отчете",
                    "ABOUT_YOUR_REPORT_LINE1": "Это отчет 360 с оценкой вашей работы. Он поможет вам расти и развиваться в профессиональной среде. Чтобы настроиться на успех, не торопитесь, дайте себе время на просмотр результатов этой оценки. Может быть, их непросто принять, но помните, что цель отзыва на вашу работу - помочь вам ускорить свой профессиональный рост и развитие.",
                    "ABOUT_YOUR_REPORT_LINE2": "При чтении отчета следует помнить о некоторых вещах.",
                    "ADVANCED_FILTER": "Расширенный фильтр",
                    "AGREEMENT_CHART": "Диаграмма совпадения",
                    "AGREEMENT_CHART_FOOTER": "Диаграмма совпадения демонстрирует, насколько похожи выставленные вам оценки. Каждая точка - это оценка по одному направлению. Размер точки показывает, сколько оценивающих лиц поставили вам эту оценку.",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "отв.",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "ответ",
                    "AGREEMENT_CHART_LEGEND_TITLE": "Какую оценку дали вам другие пользователи",
                    "ALL": "Все",
                    "AVERAGE": "Среднее",
                    "BOTTOM_BOX": "Нижняя рамка",
                    "CHOICE_COUNT": "Счетчик вариантов ответов",
                    "CHOICE_TOTALS": "Всего вариантов",
                    "COMPARISON": "Сравнение",
                    "COMPARISON_GAP_COLUMN_HEADER": "Разница",
                    "COMPLETED_RESPONSES": "Заполненные ответы",
                    "COUNT": "Счетчик",
                    "DEFAULT": "По умолчанию",
                    "DEFAULT_TEXT": "Текст по умолчанию",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "Узнавайте, кто оценил вашу работу: коллеги, непосредственные подчиненные, руководители и т.д.",
                    "DIFFERENT_EVALUATORS_HEADER": "Разные оценивающие лица",
                    "DONE": "Выполнено",
                    "DONT_HEADER": "Не стоит:",
                    "DONT_LINE1": "Угадывать, кто какой комментарий оставил",
                    "DONT_LINE2": "Фокусироваться на одной положительной или отрицательной оценке либо комментарии",
                    "DONT_LINE3": "Создавать план развития по каждому направлению оценки",
                    "DONT_LINE4": "Огорчаться, что вам есть куда развиваться",
                    "DO_HEADER": "Стоит:",
                    "DO_LINE1": "Воспринимать отзыв о вашей работе комплексно",
                    "DO_LINE2": "Определить свои сильные стороны и возможности совершенствования",
                    "DO_LINE3": "Уделить внимание нескольким направлениям, вписав их в свой план развития",
                    "DO_LINE4": "Понимать, что каждый имеет слабые стороны, которые можно развивать дальше",
                    "FIELD": "Поле",
                    "GAP": "Несоответствие",
                    "GAP_CHART": "Диаграмма несоответствий",
                    "GAP_CHART_DESCRIPTION": "Диаграмма несоответствий показывает разницу в баллах между двумя группами оценивающих лиц. Например, самостоятельная оценка в сравнении с оценкой от других людей: положительная разница (+) означает, что другие оценили вас выше, чем вы сами, а отрицательная (-) означает, что другие оценили вас ниже, чем вы сами.",
                    "GAP_CHART_FOOTER": "Диаграмма несоответствий показывает положительную или отрицательную разницу между баллами от двух групп оценивающих лиц.",
                    "GAP_TABLE_DESCRIPTION": "\"Скрытые сильные стороны\" - это направления, в которых другие оценили вас выше, чем вы сами. \"Направления улучшения\" - это области, в которых другие оценили вас ниже, чем вы сами. Оценки в обоих разделах отсортированы от наибольшего к наименьшему соответствию.",
                    "GAP_TABLE_FOOTER": "Первый столбец содержит баллы, которые вы выставили себе сами. Второй содержит среднее значение по баллам, выставленным вам другими людьми. В третьем столбце указана разница между вашей оценкой и полученными от других.",
                    "GAP_TABLE_TITLE": "Скрытые сильные стороны/направления совершенствования",
                    "GROUP": "Группа",
                    "HIDE_REPORT_ALERT": "Вы не соответствуете требованиям для просмотра отчета. Обратитесь к администратору вашей организации.",
                    "HIGHEST_SCORES": "Наивысшие оценки",
                    "HIGHLOW_TABLE": "Самые высокие и низкие оценки",
                    "HIGHLOW_TABLE_FOOTER": "В этом разделе описаны 5 наиболее высоко и 5 наиболее низко оцененных моделей поведения (из всех моделей поведения) исходя из применимых средних значений по категориям оценивающих лиц. В целях максимальной результативности рекомендуем ознакомиться с вероятной динамикой изменений. Например, если большая часть наиболее низко оцененных моделей поведения входит в одну или две категории, возможно, они требуют вашего внимания. Модели поведения, получившие самую высокую оценку, могут указывать на ваши сильные стороны, которые можно использовать и в других сферах.",
                    "HIGH_LOW_TABLE_DESCRIPTION": "Диаграмма самых высоких и низких оценок иллюстрирует направления, по которым вам выставили самые высокие и самые низкие баллы.",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "Как интерпретировать результаты и определить дальнейшие действия:",
                    "ITEM": "Элемент",
                    "LOWEST_SCORES": "Самые низкие оценки",
                    "MAX": "Макс.",
                    "MEAN": "Среднее",
                    "MEDIAN": "Медиана",
                    "MIN": "Мин.",
                    "NEGATIVE_GAPS": "Направления совершенствования",
                    "NO_COMPARISON_SET": "Сравнение не настроено",
                    "NO_DATA_AVAILABLE_WARNING": "Нет данных",
                    "NO_FILTER_IS_APPLIED": "Фильтры не применены.",
                    "NO_VALUE": "Нет значения",
                    "NPS": "Индекс потребительской лояльности",
                    "OTHERS": "Другие",
                    "PERCENTAGE": "Доля в процентах",
                    "PERCENTAGE_OF_CHOICES": "Процент выбранных ответов",
                    "PERCENTAGE_OF_RESPONSES": "Процент ответов",
                    "PERCENT_COMPLETE": "% выполнено",
                    "POSITIVE_GAPS": "Скрытые сильные стороны",
                    "QUESTIONS": "Вопросы",
                    "RANK": "Ранг",
                    "RELATIONSHIPS": {
                        "ANYONE": "Кто угодно",
                        "DIRECT_REPORT": "Прямой подчиненный",
                        "MANAGER": "Менеджер",
                        "PEER": "Коллега",
                        "SELF": "Сам участник"
                    },
                    "REPORT_SUMMARY": "Резюме отчета",
                    "REPORT_SUMMARY_TABLE_FOOTER": "Сравните количество принявших участие в оценке с количеством приглашенных.",
                    "REPORT_SUMMARY_TABLE_HEADER": "Статистика отвечающих",
                    "RESPONSES": "Ответы",
                    "RESPONSE_COUNT": "{{responseCount}} отв.",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> отв.",
                    "SCORING_CATEGORY": "Категория баллов",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Для этой категории нет ответов",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Для этого вопроса нет ответов",
                    "SCORING_OVERVIEW": "Обзор баллов",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "Вы и оценивающие вас лица считаете, что это ваша самая сильная сторона.",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Признанная сильная сторона",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Признанная область улучшения означает, что самостоятельная оценка и оценки другими лицами ниже среднего уровня для этой компетенции.",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Признанная область улучшения",
                    "SCORING_OVERVIEW_DESCRIPTION": "Выше представлены компетенции и модели поведения, по которым оценивалась ваша работа в ходе процесса множественной оценки. Сравнительные оценки выставляются по группам.",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "Минимальное несоответствие",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Минимальная разница между ссылочными группами для отображаемых текстов.",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "Это диапазон оценок по всем компетенциям и моделям поведения. Каждая полоса представляет собой среднее числовое значение.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Непризнанная сильная сторона выявляется из разницы между самостоятельной оценкой и оценками другими лицами.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Непризнанная сильная сторона",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Непризнанная область улучшения выявляется из разницы между самостоятельной оценкой и оценками от других лиц.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Непризнанная область улучшения",
                    "SELF": "Ваши ответы",
                    "SELF_ASSESSMENT": "Самостоятельная оценка",
                    "STANDARD_DEVIATION": "Стандартное отклонение",
                    "SUM": "Сумма",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Чтобы точнее интерпретировать результаты, ознакомьтесь со шкалой оценок",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "Обратите внимание на шкалу",
                    "THINGS_YOU_WILL_SEE_HEADER": "Здесь отображается следующее:",
                    "THREE_SIXTY_PERCENTILE": "Процентиль",
                    "TOP_BOTTOM_BOX": "Верхняя рамка / нижняя рамка",
                    "TOP_BOX": "Верхняя рамка",
                    "TOTAL": "Всего",
                    "TO_DO": "К выполнению",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Качественная обратная связь: отзыв в форме произвольных текстовых комментариев",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Количественная обратная связь: отзыв в числовом виде (графики, гистограммы, таблицы и др.)",
                    "TYPES_OF_FEEDBACK_HEADER": "Типы обратной связи",
                    "VALUE": "Значение",
                    "VARIANCE": "Отклонение",
                    "YOUR_RATINGS": "Ваши оценки"
                },
                "REPORT_SUMMARY": "Резюме отчета",
                "REPORT_SUMMARY_TABLE_FOOTER": "Сравните количество принявших участие в оценке с количеством приглашенных.",
                "REPORT_SUMMARY_TABLE_HEADER": "Статистика отвечающих",
                "RESET": "Сброс",
                "RESPONDENT_TOTALS": "Итоги респондентов",
                "RESPONSES": "Ответы",
                "RESPONSE_COUNT": "{{responseCount}} отв.",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> отв.",
                "RESULT": "Результат",
                "REVERSE_COLORS": "Обратить цвета",
                "ROW_TOTALS": "Итоговые значения строк",
                "SAVE": "Сохранить",
                "SAVE_AND_APPLY": "Сохранить и применить",
                "SCORING_CATEGORY": "Категория баллов",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Для этой категории нет ответов",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Для этого вопроса нет ответов",
                "SCORING_OVERVIEW": "Обзор баллов",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "Вы и оценивающие вас лица считаете, что это ваша самая сильная сторона.",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Признанная сильная сторона",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Признанная область улучшения означает, что самостоятельная оценка и оценки другими лицами ниже среднего уровня для этой компетенции.",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Признанная область улучшения",
                "SCORING_OVERVIEW_DESCRIPTION": "Выше представлены компетенции и модели поведения, по которым оценивалась ваша работа в ходе процесса множественной оценки. Сравнительные оценки выставляются по группам.",
                "SCORING_OVERVIEW_MINIMUM_GAP": "Минимальное несоответствие",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Минимальная разница между ссылочными группами для отображаемых текстов.",
                "SCORING_OVERVIEW_TABLE_FOOTER": "Это диапазон оценок по всем компетенциям и моделям поведения. Каждая полоса представляет собой среднее числовое значение.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Непризнанная сильная сторона выявляется из разницы между самостоятельной оценкой и оценками другими лицами.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Непризнанная сильная сторона",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Непризнанная область улучшения выявляется из разницы между самостоятельной оценкой и оценками от других лиц.",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Непризнанная область улучшения",
                "SELECT_CATEGORIES": "Выберите категории баллов...",
                "SELECT_CATEGORY": "Выберите категорию баллов...",
                "SELECT_CONDITION_TYPE": "Выбрать тип условия",
                "SELECT_DATA_SOURCE": "Выберите источник данных",
                "SELECT_DATA_SOURCE_TYPE": "Выберите тип источника данных",
                "SELECT_FILTER": "Выбрать фильтр",
                "SELECT_FILTERS": "Выбрать фильтры",
                "SELECT_OPERATOR_TYPE": "Выбрать тип оператора",
                "SELECT_PERSON": "Выберите лицо",
                "SELECT_PERSON_METADATA": "Выберите метаданные лица",
                "SELECT_QUESTION": "Выбрать вопрос",
                "SELECT_QUESTIONS": "Выберите вопросы...",
                "SELECT_RATIO_OR_DROPOFF": "Выбрать соотношение или значение оттока",
                "SELECT_RELATIONSHIP": "Выбрать отношение",
                "SELECT_SCORING_CATEGORY": "Выбрать категорию баллов",
                "SELF": "Самостоятельно",
                "SELF_ASSESSMENT": "Самостоятельная оценка",
                "SEQUENTIAL": "Последовательно",
                "SETUP_COMPARISON": "Настроить сравнение",
                "SETUP_COMPARISONS": "Настроить сравнения",
                "SET_START_COLOR": "Задать начальный цвет",
                "SHOULD_SHOW_FOOTER": "Показать нижний колонтитул",
                "SHOULD_SHOW_SCORING_CATEGORY": "Показать категорию баллов",
                "SHOWING_RECORDS_OF": "Отображается записей: %1 - %2 из %3",
                "SHOW_COMPARISON_GAP": "Показать столбец разрыва сравнение",
                "SHOW_DATA_LABEL": "Показать значения данных",
                "SHOW_PERCENTAGES": "Показать доли в процентах",
                "SHOW_THE_FOLLOWING_TEXT": "Потом показывать следующий текст",
                "SHOW_TIES": "Показать связи",
                "SHOW_X_AXIS": "Показать ось X",
                "SHOW_Y_AXIS": "Показать ось Y",
                "SMALL_LABELS": "Мелкие заголовки",
                "SORT": "Сортировать",
                "SPLINE": "Сплайн",
                "STACK_CHART": "Диаграмма с накоплением",
                "STANDARD_DEVIATION": "Стандартное отклонение",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "Слабая сторона ниже",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "Редактировать тексты пороговых значений",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "Тексты пороговых значений",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "Включить тексты пороговых значений",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "Сильная сторона выше",
                "SUM": "Сумма",
                "SUMMARY": "Сводные данные",
                "TABLES": "Таблицы",
                "TABLE_TOTALS": "Итоговые значения таблицы",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Чтобы точнее интерпретировать результаты, ознакомьтесь со шкалой оценок",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "Обратите внимание на шкалу",
                "TEXT": "Текст",
                "THINGS_YOU_WILL_SEE_HEADER": "Здесь отображается следующее:",
                "TOP_BOTTOM_BOX": "Верхняя рамка / нижняя рамка",
                "TOP_BOX": "Верхняя рамка",
                "TOTAL": "Всего",
                "TOTAL_COUNTS": "Общее число",
                "TO_DO": "К выполнению",
                "TRANSPOSE": "Транспонировать",
                "TRANSPOSE_TABLE": "Транспонировать таблицу",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Качественная обратная связь: отзыв в форме произвольных текстовых комментариев",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Количественная обратная связь: отзыв в числовом виде (графики, гистограммы, таблицы и др.)",
                "TYPES_OF_FEEDBACK_HEADER": "Типы обратной связи",
                "UNDO": "Отменить",
                "USE_COMPARISON": "Использовать сравнение",
                "USE_LABELS_FOR_SCALES": "Использовать метки для шкал",
                "VALUES": "Значения",
                "VALUE_RANGES": "Диапазоны значений",
                "VARIANCE": "Отклонение",
                "VERTICAL": "По вертикали",
                "VERTICAL_RANGE": "Вертикальный диапазон",
                "WARNING_DATA_OUT_OF_RANGE": "Предупреждение: значение данных превышает конфигурацию диапазона",
                "WIDGET_ERROR": {
                    "ERROR": "Возникла непредвиденная ошибка",
                    "MISCONFIGURED": "Этот виджет настроен неправильно. Проверьте конфигурацию виджета.",
                    "NEW": "Настройте виджет",
                    "NO_DATA": "Данные не найдены: возможно, у вас слишком исключающие фильтры!"
                },
                "WIDGET_NAME": {
                    "BAR": "Гистограмма",
                    "BREAKDOWNBAR": "Диаграмма с накоплением",
                    "DATA_TABLE": "Таблица данных",
                    "FUNNEL_CHART": "Воронкообразная диаграмма",
                    "GAUGE": "Диаграмма масштаба",
                    "GRID": "Таблица результатов",
                    "HEATMAP": "Тепловая карта",
                    "LINE": "График",
                    "NEEDS_BASED": "На основе потребностей",
                    "PIE": "Круговая диаграмма",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "Расчет цены (Ван Вестендорп)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "Максимизатор дохода (Габор — Грейнджер)",
                    "SCORING_OVERVIEW_CHART": "Диаграмма",
                    "SCORING_OVERVIEW_TABLE": "Таблица",
                    "STATS_TABLE": "Статистическая таблица",
                    "WORDCLOUD": "Облако слов"
                },
                "WORD_ROTATION": "Вращение слова",
                "WORD_SPACING": "Междусловный интервал",
                "YES": "Да",
                "YOUR_RATINGS": "Ваши оценки"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "Добавить",
                "ADD_A_WORD": "Добавить слово",
                "COLOR": "Цвет",
                "DELETE_ALL": "Удалить все",
                "EDIT_STOP_WORDS": "Редактировать стоп-слова",
                "MAX_WORDS": "Макс. слов",
                "ROTATION_ANGLED": "Под наклоном",
                "ROTATION_HORIZONTAL": "Горизонтально",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "Горизонтально и вертикально",
                "WORD_ORIENTATION": "Ориентация текста"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "Цвета фона",
                "DISPLAY_OPTIONS": "Отобразить параметры",
                "INVERT_FONT_COLORS": "Обратить низкоконтрастные цвета шрифта",
                "PAGE": "Страница",
                "PAGINATE": "Разбить на страницы"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "Среднее",
                "BOTTOM_BOX_METRIC": "Нижняя рамка",
                "COLUMNS": "Столбцы",
                "COUNT_METRIC": "Общее количество ответов",
                "FIELD_NAME": "Поле",
                "MAX_METRIC": "Максимум",
                "MIN_METRIC": "Минимум",
                "SHOW_RECODES": "Показать значения записей",
                "SHOW_ROW_NUMBERS": "Показать номера строк",
                "STD_DEV_METRIC": "Станд. отклонение",
                "TOP_BOX_METRIC": "Верхняя рамка",
                "TRANSPOSE_BREAKOUTS": "Поменять разбивку",
                "TRANSPOSE_TABLE": "Компоновать таблицу",
                "VAR_METRIC": "Отклонение"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "Дополнительные столбцы",
                "ADD_COLUMNS": "Добавить дополнительные столбцы",
                "ADD_CUSTOM_PALETTE": "Добавить пользовательскую палитру",
                "ALL_CHOICES": "Все варианты",
                "ALL_GROUPS": "Все группы",
                "ALL_RECODES": "Все перекодирования",
                "AUTOMATIC": "По умолчанию",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "По умолчанию - щелкните для редактирования",
                "AXIS_VALUES": "Значения по осям",
                "BREAKOUT_BY": "Разбивка по",
                "CANCEL": "Отмена",
                "CATEGORICAL": "Категориальные",
                "CHOICES": "Варианты ответов",
                "CHOICE_COUNT": "Счетчик вариантов ответов",
                "COLOR_PALETTE": "Цветовая палитра",
                "COLUMN_VALUES": "Значения столбца",
                "CONTACT_FIELDS": "Поля контактов",
                "COUNT": "Счетчик",
                "CREATE": "Создать",
                "CUSTOM": "Пользовательский",
                "CUSTOM_PALETTE": "Пользовательская палитра",
                "DATA_SOURCE": "Источник данных",
                "DAY": "День",
                "DAY_OF_WEEK": "День недели",
                "DECIMAL_PRECISION": "Число десятичных разрядов",
                "DEFAULT": "По умолчанию",
                "DISABLED": "Отключено",
                "DIVERGENT": "Расходящиеся",
                "EDIT_CUSTOM_PALETTE": "Редактировать пользовательскую палитру",
                "ENABLED": "Включено",
                "ERROR_LOADING_DATA": "Ошибка при загрузке данных",
                "FILE_SIZE": "Размер",
                "FILE_TYPE": "Тип",
                "FRI": "Пт",
                "FRIDAY": "Пятница",
                "GROUP_DATE_BY": "Группировать дату по",
                "HOUR_OF_DAY": "Час",
                "LENGEND_VALUES": "Значения условных обозначений",
                "MAX": "Макс.",
                "MEAN": "Среднее",
                "MIN": "Мин.",
                "MISCONFIGURED_DATA": "Источник данных для этой визуализации настроен неверно.",
                "MISCONFIGURED_FILTERS": "Недопустимые фильтры",
                "MODIFY_CUSTOM_PALETTES": "Изменить пользовательские палитры",
                "MON": "Пн",
                "MONDAY": "Понедельник",
                "MONTH": "Месяц",
                "NONE": "Нет",
                "NO_FILE_ID_ERROR": "Эта визуализация требует, чтобы в опросе было задано изображение",
                "NO_RESULTS_TO_SHOW": "Нет результатов для отображения",
                "NPS": "Net Promoter® Score",
                "NPS_GROUP": "Группа NPS®",
                "NUMERIC_VALUE": "Числовое значение",
                "PALETTE_REMOVED": "Палитра удалена",
                "PERCENTAGE": "Доля в процентах",
                "PERCENTAGE_OF_CHOICES": "Процент выбранных ответов",
                "PERCENTAGE_OF_RESPONSES": "Процент ответов",
                "QUARTER": "Квартал",
                "REMOVE": "Удалить",
                "RESPONSE_COUNT": "Число ответов",
                "RESULTS_PER_PAGE": "Результатов на страницу",
                "RETRIEVING_DATA_ELLIPSIS": "Получение данных...",
                "REVERSE_COLORS": "Обратить цвета",
                "ROW_VALUES": "Значения строки",
                "SAT": "Сб",
                "SATURDAY": "Суббота",
                "SAVE": "Сохранить",
                "SELECTED_CHOICE": "Выбранный вариант ответа",
                "SELECT_FIELD": "Выбрать поле",
                "SELECT_METRIC": "Метрика",
                "SEQUENTIAL": "Последовательно",
                "SET_START_COLOR": "Задать начальный цвет",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "Отображение данных выборки...",
                "SUM": "Сумма",
                "SUN": "Вс",
                "SUNDAY": "Воскресенье",
                "SURVEY_EMBEDDEDDATA": "Встроенные данные",
                "SURVEY_METADATA": "Метаданные опроса",
                "TEXT_ENTRY": "Текстовая запись",
                "THURS": "Чт",
                "THURSDAY": "Четверг",
                "TITLE": "Название",
                "TUES": "Вт",
                "TUESDAY": "Вторник",
                "UNBOUNDED_DOMAIN": "Слишком много значений для отображения.",
                "UNBOUNDED_DOMAIN_HELP": "Для добавления этого поля в отчеты по результатам можно добавить в отчет фильтры, чтобы отобразить меньше значений для \"{{ed_field_name}}\", или обновить тип переменной встроенных данных \"{{ed_field_name}}\" в структуре опроса, чтобы сделать это поле строковым или числовым.",
                "UNDO": "Отменить",
                "USE_CHOICE_TOTALS": "Использовать итоговые суммы по вариантам",
                "USE_RESPONDENT_TOTALS": "Использовать итоговые суммы по респондентам",
                "VISUALIZATION": "Визуализация",
                "VISUALIZATION_BARCHART": "Гистограмма",
                "VISUALIZATION_BREAKDOWNBAR": "Диаграмма с накоплением",
                "VISUALIZATION_GAUGE": "Диаграмма масштаба",
                "VISUALIZATION_HEATMAP": "Тепловая карта",
                "VISUALIZATION_LINECHART": "График",
                "VISUALIZATION_PAGINATEDTABLE": "Таблица с нумерацией страниц",
                "VISUALIZATION_PIE": "Круговая диаграмма",
                "VISUALIZATION_SIMPLETABLE": "Простая таблица",
                "VISUALIZATION_STATSTABLE": "Статистическая таблица",
                "VISUALIZATION_TEXTHIGHLIGHTS": "Выделение текста",
                "VISUALIZATION_WORDCLOUD": "Облако слов",
                "WED": "Ср",
                "WEDNESDAY": "Среда",
                "WEEK": "Неделя",
                "WEIGHTING": "Взвешивание",
                "WRONG_QUESTION_TYPE_ERROR": "Этот тип визуализации не может использоваться для данного вопроса",
                "YEAR": "Год"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "Среднее",
                "CHOICE_COUNT": "Счетчик вариантов ответов",
                "COUNT": "Счетчик",
                "DISPLAY_OPTIONS": "Отобразить параметры",
                "MAX": "Максимум",
                "MIN": "Минимум",
                "NPS": "NPS®",
                "PAGE_OF": "Стр. %1 из %2",
                "PERCENT": "Доля в процентах",
                "RESPONSE_COUNT": "Число ответов",
                "ROWS_PER_TABLE": "Строк на таблицу",
                "SHOWING_ROWS_OF": "Отображаются строки: %1 - %2 из %3",
                "SHOW_PERCENTAGES": "Показать доли в процентах",
                "SHOW_RECODES": "Показать значения записей",
                "SHOW_ROW_NUMBERS": "Показать номера строк",
                "SUM": "Сумма",
                "TOTAL": "Всего",
                "TRANSPOSE": "Транспонировать",
                "USE_COLUMN_TOTALS": "Использовать итоговые значения столбцов",
                "USE_ROW_TOTALS": "Использовать итоговые значения строк",
                "VALUE": "Значение"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "В порядке возрастания",
                "COUNT": "Счетчик",
                "DESCENDING": "По убыванию",
                "DIAGONAL": "По диагонали",
                "DISPLAY_OPTIONS": "Отобразить параметры",
                "ERROR_COLON": "Ошибка:",
                "ERROR_GENERIC": "При загрузке визуализации произошла ошибка.",
                "HORIZONTAL": "По горизонтали",
                "HORIZONTAL_BARS": "Горизонтальные полосы",
                "INCORRECTLY_CONFIGURED": "Для просмотра диаграммы выберите значение",
                "LEGEND_AUTO": "Автоматически",
                "LEGEND_BOTTOM": "Внизу",
                "LEGEND_INSET": "Вставка",
                "LEGEND_RIGHT": "Справа",
                "NORMALIZE_TO_PERCENTAGES": "Нормализация к процентам",
                "SHOW_BAR_LABELS": "Показать заголовки полос",
                "SHOW_LEGEND": "Показать условные обозначения",
                "SHOW_X_AXIS": "Показать ось X",
                "SHOW_Y_AXIS": "Показать ось Y",
                "SORT_BAR_VALUES": "Сортировать значения полосы",
                "STACKED_BARS": "Полосы с накоплением",
                "TRANSPOSE": "Транспонировать",
                "TRUNCATE_LABELS": "Усечь заголовки",
                "VERTICAL": "По вертикали"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "Все остальные",
                "COULD_NOT_LOAD_DATA": "Не удалось загрузить данные с указанной конфигурацией. Выберите другое исходное поле или расширенный диапазон дат.",
                "GROUPING_PERCENTAGE_THRESHOLD": "Порог процентного значения группирования",
                "NO_DATA": "Данные отсутствуют",
                "RADIUS": "Внутренний радиус",
                "SHOW_AS_PERCENTAGES": "Показать в процентах"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "Закрыть",
                "DOWNLOAD_CSV": "Скачать CSV",
                "DOWNLOAD_ZIP": "Скачать все файлы",
                "NO_DATA": "Данные отсутствуют",
                "PAGE_OF": "Стр. %1 из %2",
                "RESULTS_PER_PAGE": "Результатов на страницу",
                "SHOWING_RECORDS_OF": "Отображается записей: %1 - %2 из %3",
                "SINGLE_RESPONSE": "Отдельный ответ",
                "VIEW_RESPONSE": "Просмотреть ответ"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "Параметры отображения",
                "ERROR_COLON": "Ошибка:",
                "ERROR_GENERIC": "При загрузке визуализации произошла ошибка.",
                "HORIZONTAL_BARS": "Горизонтальные полосы",
                "INCORRECTLY_CONFIGURED": "Для просмотра диаграммы выберите значение",
                "LEGEND_AUTO": "Автоматически",
                "LEGEND_BOTTOM": "Внизу",
                "LEGEND_INSET": "Вставка",
                "LEGEND_RIGHT": "Справа",
                "NORMALIZE_TO_PERCENTAGES": "Нормализация к процентам",
                "SHOW_AREA": "Показать область",
                "SHOW_LEGEND": "Показать условные обозначения",
                "SHOW_X_AXIS": "Показать ось X",
                "SHOW_Y_AXIS": "Показать ось Y",
                "SMOOTH_LINES": "Сглаженные линии",
                "SORT_X_AXIS_LABELS": "Сортировать метки оси X",
                "STACKED_BARS": "Полосы с накоплением",
                "TRANSPOSE": "Транспонировать"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "Режим блоков",
                "BLUR": "Размытость",
                "COULD_NOT_LOAD_DATA": "Не удалось загрузить данные с указанной конфигурацией. Выберите другое исходное поле или расширенный диапазон дат.",
                "FIELD": "Поле",
                "RADIUS": "Радиус",
                "SHOW_REGIONS": "Показать регионы",
                "SHOW_REGION_LABELS": "Показать метки регионов"
            },
            "GAUGEWIDGET": {
                "MAX": "Макс.",
                "MIN": "Мин.",
                "VALUE_RANGES": "Диапазоны значений"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "Заголовки внизу",
                "CATEGORY_NAME": "Название категории",
                "ERROR_COLON": "Ошибка:",
                "INCLUDE_HIDDEN_GROUPS": "Включить скрытые группы в процентах",
                "LARGE_LABELS": "Большие заголовки",
                "NO": "Нет",
                "PERCENT": "Процент",
                "RESPONSE_COUNT": "Число ответов",
                "RESPONSE_COUNT_WITH_VALUE": "Ответов: {{ responseCount }}",
                "SMALL_LABELS": "Мелкие заголовки",
                "YES": "Да"
            }
        });
        $cache.put('SV', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "Åtkomstkod",
                "ACCESS_CODE_PROTECTION": "Skydd av åtkomstkod",
                "ADD": "Lägg till",
                "ADD_BREAKOUT": "Lägg till rapportutbrytning",
                "ADD_NOTE": "Lägg till anteckning",
                "ADD_SCHEDULED_REPORT": "Lägg till schemalagd rapport",
                "ADD_WIDGET": "Lägg till visualisering",
                "ALL_PROJECTS": "Alla projekt",
                "ALL_QUESTIONS": "Frågesidor",
                "ANSWER": "Svar",
                "ANY_CHANGES_LOST": "Alla ändringar i rapporter kommer gå förlorade om du lämnar Qualtrics XM Platform.",
                "APPENDED_COPY_IN_PARENS": "(Kopia)",
                "AREA_CHART": "Ytdiagram",
                "AREA_CHART_DESC": "Ett ytdiagram med två axlar med området under linjen ifyllt.",
                "ATTACHMENT": "Bilaga",
                "BACKUP_CURRENT_REPORT": "Spara en backup-kopia av denna rapport innan du påverkar visualiseringarna",
                "BACKUP_CURRENT_REPORT_LINE2": "Observera: backup-kopian kommer att heta \"{{nameOfReportCopy}}\"",
                "BACK_TO_REPORTS": "Tillbaka till Rapporter",
                "BACK_TO_TOP": "Tillbaka till toppen",
                "BACK_TO_VIEW_RESULTS": "Tillbaka till äldre visningsresultat",
                "BAR_CHART": "Stapeldiagram",
                "BAR_CHART_DESC": "Ett stapeldiagram med två axlar som tillåter extra konfigurering som t.ex. axeltransposition och arrangering av datapunkter.",
                "BREAKDOWN_BAR_CHART": "Fördelningsstapel",
                "BREAKDOWN_BAR_CHART_DESC": "Ett horisontellt stapeldiagram används oftast för att visualisera viktade mätetal mot varandra som ett alternativ till ett cirkeldiagram.",
                "CANCEL": "Avbryt",
                "CANCEL_CONF_TEXT": "Vill du avbryta? <br/> Alla ändringar går förlorade.",
                "CANCEL_EDITS": "Avbryt redigeringar",
                "CHART": "Diagram",
                "CHOICE": "Alternativ",
                "CHOICES_COUNT_METRIC": "Antal alternativ",
                "CHOOSE_PAGES_TO_DISPLAY": "Välj vilka sidor som ska visas",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "Denna rapport innehåller {{maxReportPageCount}} sidor, men resultaten kan endast innehålla upp till {{reportSizeLimit}}. Välj en delmängd inom gränsen.",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "Rapporter kan endast innehålla upp till {{reportSizeLimit}} sidor, välj de sidor du önskar.",
                "CLEAR_ALL": "Rensa alla",
                "CLOSE": "Stäng",
                "CLOUD": "EN BESKRIVNING FÖR MOLNET",
                "COLLABORATED_NEW": "Ägaren av denna undersökning använder Qualtrics XM Platform! Rapporter för denna undersökning kommer att redigeras med hjälp av Nya resultat.",
                "COMMA_SEPARATED_LIST": "Kommaseparerad lista",
                "COMPACTNESS": "Teckensnitt och radavstånd",
                "COMPACTNESS_INFO": "Denna inställning påverkar utfyllnad, teckenstorlek och stapelstorleken i diagram. Den kommer också att appliceras på de flesta exporter.",
                "CONFIRM": "OK",
                "CONFIRM_DELETE": "Bekräfta radering",
                "CONFIRM_DELETE_PAGE": "Vill du radera denna sida?",
                "CONTINUE": "Fortsätt",
                "CONTINUE_EDITING": "Fortsätt redigera",
                "COPY": "Kopiera",
                "COPY_OF_REPORT_NAME": "Kopia av {{nameOfCurrentReport}}",
                "COPY_REPORT": "Kopiera rapport",
                "COPY_REPORT_ELLIPSIS": "Kopiera rapport...",
                "COPY_TO_NEW_REPORT": "Kopiera till ny rapport...",
                "CREATE": "Skapa",
                "CREATED": "Skapad",
                "CREATE_CUSTOM_PAGE": "Skapa anpassad sida",
                "CREATE_NEW_REPORT": "Skapa ny rapport",
                "CREATE_NEW_REPORT_ELLIPSIS": "Skapa ny rapport...",
                "CSV_FILE": "CSV-fil",
                "CUSTOM_PAGES": "Anpassade sidor",
                "DATE": "Datum",
                "DEFAULT_PALETTE": "Standard färgpalett",
                "DEFAULT_REPORT": "Standardrapport",
                "DEFAULT_VISUALIZATIONS": "Standard visualisering",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "Dessa är standard visualiseringstyperna som används för att konstruera standard resultatrapporter. Om du uppdaterar och applicerar dessa inställningar kommer din aktuella rapport att byggas om med de nya standardinställningarna. Du kommer att få välja om du vill göra en backup på din aktuella rapport.",
                "DEFAULT_VISUALIZATIONS_NOTE": "Observera: Alla visualiseringstyper är inte tillgängliga för alla frågetyper. Vissa visualiseringar som inte är standard kan automatiskt ersättas.",
                "DEFAULT_VISUALS_DISCLAIMER": "Qualtrics kommer att uppdatera denna rapport med de nya standard visualiseringsinställningarna.",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "Denna uppdatering kommer att påverka {{amountOfWidgetsAffected}} visualiseringar i denna rapport.",
                "DEFAULT_VISUAL_EDIT_DETECTED": "Standard visualiseringsredigering upptäckt",
                "DELETE_BUTTON": "Radera",
                "DELETE_DISABLED_EXPLANATION": "Du kan inte radera rapporter som är skapade i det tidigare rapporteringsgränssnittet förrän din organisation har utfört en komplett migrering till Qualtrics XM Platform.",
                "DELETE_PAGE": "Radera sida",
                "DELETE_PAGE_ELLIPSIS": "Radera sida...",
                "DELETE_REPORT": "Radera rapport",
                "DELETE_REPORT_ELLIPSIS": "Radera rapport...",
                "DELETE_WIDGET_QUESTION": "Radera?",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "Detta fält är krypterat och kan inte användas för sortering.",
                "DISCARD_EDITS": "Förkasta ändringar",
                "DISTRIBUTION_PAUSED": "Rapportdistribution pausad.",
                "DONE_BUTTON": "Klar",
                "DONE_EDITING": "Redigering klar",
                "DOWNLOAD": "Hämta",
                "DOWNLOAD_AS_CSV": "Hämta som CSV",
                "DOWNLOAD_AS_PDF": "Hämta som PDF",
                "DOWNLOAD_FAILED": "Hämtningen misslyckades",
                "DOWNLOAD_PREVIOUS_EXPORTS": "Hämta tidigare exporter...",
                "DO_YOU_WISH_TO_DELETE": "Vill du radera:",
                "DUPLICATE_PAGE": "Duplicera ark",
                "EDIT_REPORT": "Redigera rapporter",
                "EDIT_REPORT_ELLIPSIS": "Redigera rapporter...",
                "EDIT_VISUALIZATION": "Redigera visualisering",
                "EMAIL_ADDRESS": "E-postadress",
                "EMAIL_SENT": "E-postmeddelande skickat...",
                "END_OF_REPORT": "Slut på rapporten",
                "ENTER_NAME": "Ange namn",
                "ERROR_COPYING": "Ett fel uppstod när rapporten kopierades.",
                "ERROR_DELETING": "Ett fel uppstod när rapporten raderades.",
                "ERROR_DELETING_EXPORT": "Ett fel uppstod när exporten raderades.",
                "ERROR_HEADING": "Fel",
                "ERROR_PUBLISHING": "Ett fel uppstod när inställningarna sparades.",
                "ERROR_RENAMING": "Ett fel uppstod när rapporten döptes om.",
                "ERROR_REQUESTING_EXPORT": "Ett fel uppstod när exporten begärdes.",
                "ERROR_SAVING_GLOBAL_OPTIONS": "Ett fel uppstod vid lagring av globala visualiseringsalternativ.",
                "ERROR_SEND_TEST_EMAIL": "Ett fel uppstod när test-e-postmeddelandet skickades.",
                "EVERY_FRIDAY": "Varje fredag",
                "EVERY_MONDAY": "Varje måndag",
                "EVERY_MONTH": "Månadsvis den",
                "EVERY_SATURDAY": "Varje lördag",
                "EVERY_SUNDAY": "Varje söndag",
                "EVERY_THURSDAY": "Varje torsdag",
                "EVERY_TUESDAY": "Varje tisdag",
                "EVERY_WEDNESDAY": "Varje onsdag",
                "EVERY_WEEK": "Veckovis varje",
                "EXAMPLE_GROUP_NUM": "Grupp {{num}}",
                "EXAMPLE_SERIES_NUM": "Serie {{num}}",
                "EXPORT": "Exportera",
                "EXPORT_CSV": "CSV (kommaseparerad)",
                "EXPORT_EXCEL_SPREADSHEET": "Excel kalkylark",
                "EXPORT_IMAGE": "Exportera bild",
                "EXPORT_PAGES": "Exportera sidor",
                "EXPORT_PDF": "PDF-dokument",
                "EXPORT_PPT_SLIDES": "PowerPoint-bilder",
                "EXPORT_RAW_DATA": "Exportera rådata",
                "EXPORT_REPORT": "Exportera rapport",
                "EXPORT_VISUALIZATION": "Exportera visualisering",
                "EXPORT_WORD_DOC": "Word-dokument",
                "FAILED_SAVE_TXT": "Kunde inte spara",
                "FILTERED": "Filtrerad",
                "FIRST_PAGE": "Första sidan",
                "FIRST_WEEKDAY": "Första veckodagen i månaden",
                "FROM": "Från",
                "FROM_EMAIL": "Från-e-postadress",
                "FROM_NAME": "Från-namn",
                "GAUGE_CHART": "Mätardiagram",
                "GAUGE_CHART_DESC": "Ett diagram som liknar ett mätverktyg för att jämföra aktuella värden med ett mål eller en serie av tröskelvärden.",
                "GENERATING_FILE": "Genererar fil...",
                "GENERATING_IMAGE": "Genererar bild...",
                "GENERATING_PDF": "Genererar PDF...",
                "GENERIC_ERROR": "Ett fel hindrade oss från att hämta projektet du begärde.",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "Globala alternativ...",
                "GLOBAL_METRIC": "Standard mätetal",
                "GLOBAL_MODAL_PAGE_TITLE": "Exempelvisualisering med hjälp av de globala alternativen för avsnittet Resultat i Qualtrics Research Suite",
                "GLOBAL_MODAL_WIDGET_TITLE": "Visualiseringstitel",
                "GLOBAL_OPTIONS": "Globala alternativ",
                "GLOBAL_PRECISION": "Standard decimal",
                "GLOBAL_SETTINGS_APPLY": "Applicera mina standardinställningar",
                "GLOBAL_SETTINGS_SAVE": "Spara som mina standardinställningar",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "Applicera Qualtrics-standard",
                "GROUP": "Grupp",
                "HEAT_MAP_CHART": "Diagram över värmekarta",
                "HEAT_MAP_CHART_DESC": "En klustrad visualisering i \"värmestil\" som används för att mappa distributionen av användarinput (som t.ex. klick) på originalbilden.",
                "HIDDEN": "Dold",
                "HIDDEN_PAGE": "Denna sida kommer inte att visas i offentliga rapporter och kommer automatiskt att avmarkeras i rapportexporter.",
                "HIDE": "Dölj",
                "HIDE_ALL_PAGES": "Dölj alla sidor",
                "HIDE_PAGE": "Dölj sida",
                "IMAGE_FILE": "Bildfil",
                "INVALID_BRAND_DOMAIN": "Domänen du har matat in finns inte med på ditt varumärkes lista över godkända e-postdomäner. Kontakta varumärkesadministratören för att åtgärda.",
                "INVALID_SPF_RECORD": "Domänen du har matat in har inte godkänt att Qualtrics skickar från den. Detta kommer att påverka leveransen. Använd en annan domän eller kontakta Qualtrics för att lösa detta.",
                "ISSUE_SAVING_REPORTS": "En eller flera filer stötte på problem vid sparande. Försök igen.",
                "ISSUE_SENDING_TEST": "Ett fel uppstod när test-e-postmeddelandet skickades.",
                "LARGE_SURVEY": "Resultat kommer inte att visas eftersom undersökningen är för stor.",
                "LAST_DAY": "Sista dagen i månaden",
                "LAST_MODIFIED_COLON_WITH_DATE": "Senaste ändring: %1",
                "LAST_PAGE": "Sista sidan",
                "LAST_WEEKDAY": "Sista veckodagen i månaden",
                "LATER": "Senare",
                "LEARN_MORE": "Lär dig mer",
                "LINE_CHART": "Linjediagram",
                "LINE_CHART_DESC": "Ett linjediagram med två axlar som ofta används för grafisk framställning mot tiden på x-axeln.",
                "LOG_OUT_WARNING": "Klicka var som helst inom {{countdown}} sekunder för att hållas inloggad.",
                "MESSAGE": "Meddelande",
                "MONTHLY": "Varje månad",
                "MOVE_DOWN": "Flytta ner visualisering",
                "MOVE_PAGE_TO_BOTTOM": "Flytta längst ned",
                "MOVE_PAGE_TO_TOP": "Flytta högst upp",
                "MOVE_UP": "Flytta upp visualisering",
                "MY_SURVEYS": "Mina projekt",
                "NAME": "Namn",
                "NEW_CUSTOM_PAGE_NAME": "Ny anpassad sida",
                "NEW_REPORT": "Ny rapport",
                "NEXT_PAGE": "Nästa sida",
                "NEXT_RUN": "Nästa körning",
                "NO_EXPORTS": "Inga exporter har begärts ännu för denna rapport.",
                "NO_ITEMS_TO_DISPLAY": "Inga objekt att visa",
                "NO_MATCHING_CUSTOM_PAGES": "Inga matchande anpassade sidor",
                "NO_MATCHING_PAGES": "Inga sidor hittades för sökningen",
                "NO_MATCHING_REPORTS": "Inga matchande rapporter.",
                "NO_PROJECT": "Specificera ett projekt för att fortsätta.",
                "NO_PROJECTS_TO_MIGRATE": "Det finns inga projekt att uppdatera.",
                "NO_QUESTIONS": "Inga matchande frågor",
                "NO_RESULTS_YET": "Det finns inga resultat att visa än. Distribuera din undersökning för att samla in svar.",
                "OFF": "Av",
                "ON": "På",
                "PAGES_SELECTED": "Valda sidor",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "Detta val skulle gör att rapporten innehåller {{currentSelectedPageCount}} sidor, vilket är större än {{reportSizeLimit}} som är maxantalet. Välj ett mindre intervall.",
                "PAGES_SELECTION_INVALID_RANGE": "Välj ett giltig intervall.",
                "PAGE_OPTIONS": "Sidalternativ",
                "PDF_ROW_TRUNCATION_MESSAGE": "För många rader för PDF-export, prova att exportera till Word eller CSV",
                "PERCENTAGE_METRIC": "Procentandel",
                "PIE_CHART": "Cirkeldiagram",
                "PIE_CHART_DESC": "En cirkulär uppdelning av värden för en given datapunkt. Användbar för mätning av relativa proportioner av valda värden.",
                "PREVIEW": "Förhandsgranskning",
                "PREVIOUS_PAGE": "Föregående sida",
                "PRINT_PAGE": "Skriv ut sida",
                "PUBLIC_LINK": "Offentlig länk",
                "PUBLIC_REPORT_AVAILABLE": "Offentlig rapport tillgänglig",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "Åtkomstkod",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "Felaktig åtkomstkod. Försök igen.",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "Skicka",
                "PUBLIC_RESULTS_LOGIN_TITLE": "Logga in i offentlig rapport | Qualtrics - mjukvara för undersökningar",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "Kunde inte hitta offentlig rapport. Kontakta ägaren för denna rapport och fråga efter en giltig länk.",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "Offentlig rapport hittades inte",
                "PUBLIC_RESULTS_NOT_UPDATED": "Länkar till offentliga rapporter och schemalagda rapport-e-postmeddelanden kommer inte att använda Qualtrics XM Platform förrän du uppdaterar dem.",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "Sessionen gick ut. Logga in igen för att fortsätta förhandsgranska offentlig resultatrapport",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "Session har gått ut",
                "PUBLIC_RESULTS_TITLE": "Offentlig rapport",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "Du saknar behörighet för att visa sidan. Kontakta ägaren av denna rapport och be dem göra den offentlig.",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "Offentlig rapport obehörig",
                "PUBLISHED_LINK_GENERATING_LINK": "Genererar länk...",
                "PUBLISHED_REPORT_FOUND_HERE": "Alla kan se denna rapport på följande länk:",
                "PUBLISH_REPORT": "Hantera offentlig rapport",
                "PUBLISH_REPORT_ELLIPSIS": "Hantera offentlig rapport...",
                "QUESTION": "Fråga",
                "RANK": "Rangordning",
                "REMOVE_WIDGET": "Ta bort visualisering",
                "RENAME_PAGE": "Döp om sida",
                "RENAME_REPORT": "Byt namn på rapport",
                "RENAME_REPORT_ELLIPSIS": "Döp om rapport...",
                "REPLY_TO_EMAIL": "Svarsadress",
                "REPORT_COLON": "Rapport:",
                "REPORT_SETTINGS": "Rapportinställningar",
                "REPORT_SETTINGS_ELLIPSIS": "Rapportinställningar...",
                "RESPONSE_COUNTS": "Antal svar",
                "RESULTS_DASHBOARDS_BANNER": "och prova den nya, förbättrade versionen av undersökning resultat, med moderna, tillgängliga UI-- och datavisualiseringar, nya analys- och utforskningsfunktioner med mera.",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "Versionsanmärkningar",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "Visa senaste",
                "RESULTS_OPTIONS": "Rapportalternativ",
                "RESULTS_TITLE": "Rapport",
                "RESUME_DISTRIBUTION": "Återuppta distribution",
                "REVERT": "Återställ",
                "RICH_TEXT_LIMIT_REACHED": "Innehållslängden har uppnått gränsen!",
                "SAVE": "Spara",
                "SAVE_AND_CLOSE": "Spara och stäng",
                "SAVE_AS_CSV": "Spara visualisering som CSV",
                "SAVE_AS_IMAGE": "Spara visualisering som bild",
                "SAVE_CONFIRMATION": "Spara bekräftelse",
                "SAVE_PAGE_AS_ELLIPSIS": "Exportera sida som...",
                "SAVE_SETTINGS": "Spara inställningar",
                "SCHEDULE_REPORT_EMAIL": "Schemalägg rapport-e-postmeddelande",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "Schemalägg rapport-e-postmeddelande...",
                "SEARCH_ELLIPSIS": "Sök...",
                "SEARCH_PAGES": "Sök frågor",
                "SEARCH_PAGES_ELLIPSIS": "Sök sidor...",
                "SEARCH_REPORTS_ELLIPSIS": "Sök rapporter...",
                "SELECTED": "Valda:",
                "SELECT_ALL": "Välj alla",
                "SELECT_A_FIELD": "Välj ett fält",
                "SELECT_A_WIDGET": "Välj en visualisering",
                "SELECT_PAGES": "Välj sidor",
                "SELECT_PAGES_ELLIPSIS": "Välj sidor...",
                "SEND": "Skicka",
                "SEND_TEST_EMAIL": "Skicka testmeddelande via e-post",
                "SETTING_DEFAULT": "Standard",
                "SETTING_HIGH": "Hög",
                "SETTING_LARGE": "Stor",
                "SETTING_LOW": "Låg",
                "SETTING_NORMAL": "Normal",
                "SETTING_SMALL": "Liten",
                "SHARE_REPORT": "Dela rapport",
                "SHOW_ALL_PAGES": "Visa alla sidor",
                "SHOW_FULL_QTEXT": "Visa hela frågetexten i sidtitlarna",
                "SIMPLE_TABLE": "Enkel tabell",
                "SIMPLE_TABLE_DESC": "En flexibel tabell som kan visa flera värden som rader eller kolumner.",
                "SIZE": "Storlek",
                "SPLINE_CHART": "Spline-diagram",
                "SPLINE_CHART_DESC": "Ett bågformat diagram med två axlar som ofta används för grafisk framställning mot tiden på x-axeln.",
                "STATISTICS_TABLE": "Statistiktabell",
                "SUBJECT": "Ämne",
                "SURVEY_ANALYSIS": "Undersökningsanalys",
                "SURVEY_SUMMARY": "Undersökningsöversikt",
                "TABLE": "EN BESKRIVNING FÖR TABELLEN",
                "TIME": "Tid",
                "TO": "Till",
                "TOTAL": "Totalt",
                "TRANSPOSE_STATS_TABLES": "Transponera statistiktabell",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "Transponera utbrytningar i statistiktabell",
                "TRUNCATE_PAGE_TITLES": "Trunkera frågetexten i sidtitlarna",
                "TRY_IT_NOW": "Testa nu",
                "TYPE": "Typ",
                "UNABLE_TO_CHECK_SPF": "Kunde inte kontrollera SPF-poster. Försök igen.",
                "UNAUTHORIZED": "Du har inte behörighet att visa denna rapport. Kontakta ägaren för åtkomst.",
                "UNHIDE_PAGE": "Visa sida",
                "UPDATE": "Uppdatera",
                "UPDATED_SUCCESSFULLY": "Uppdateringen slutförd",
                "UPDATE_ALL_IN_THIS_PROJECT": "Uppdatera alla i detta projekt",
                "UPDATE_ALL_PROJECTS": "Uppdatera alla projekt",
                "UPDATE_NOW": "Uppdatera nu",
                "UPDATE_REPORTS": "Uppdatera rapporter...",
                "UPDATE_REPORT_ELEMENTS": "Uppdatera länkar till offentliga rapporter och schemalägg rapport-e-postmeddelanden",
                "UPGRADE_MY_ACCOUNT": "Uppgradera mitt konto",
                "USE_EXPORT_TAGS": "Inkludera frågenummer",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "Använd Kolumn totalt för enkel tabell",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "Använd Antal respondenter för enkel tabell",
                "USE_WEIGHTED_METRICS": "Använd viktade mätetal",
                "VIEW": "Visning",
                "WEEKLY": "Varje vecka",
                "WELCOME_TO_NEW_RESULTS": "Välkommen till rapporteringen från Qualtrics XM Platform!",
                "WHEN": "När",
                "WIDGET_LOADING": "Läser in...",
                "WIDGET_OPTIONS_ERR": "Kunde inte läsa in visualiseringsalternativ",
                "WIDGET_TYPE": "Visualisering",
                "WORD_CLOUD": "Ordmoln",
                "WORD_CLOUD_DESC": "En viktad visualisering av ordfrekvens i textdata med ytterligare färgkodsalternativ."
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Kom ihåg att det finns resurser i din organisation som kan hjälpa dig att tolka den feedback du får, till exempel HR-partner, din chef och/eller en mentor.",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Ta en kopp kaffe och gå igenom den feedback du har fått.",
                "ABOUT_YOUR_REPORT_HEADER": "Om din rapport",
                "ABOUT_YOUR_REPORT_LINE1": "Välkommen till din 360-feedbackrapport. Det här är ett bra tillfälle att växa och utvecklas i din yrkesroll. För att du ska få ut mesta möjliga av dina resultat bör du avsätta tillräckligt med tid när du går igenom feedbacken. Feedback kan vara svårt att ta in ibland, men kom ihåg att syftet med denna feedback är att du ska utvecklas.",
                "ABOUT_YOUR_REPORT_LINE2": "När du går igenom rapporten finns det några saker att tänka på.",
                "ADD_CONDITIONAL_TEXT": "Lägg till villkorstext",
                "ADD_CUSTOM_PALETTE": "Lägg till anpassad palett",
                "ADD_DATA_SOURCE": "Lägg till datakälla",
                "ADD_FOLLOWING": "Lägg till följande",
                "ADD_LABEL": "Lägg till etikett",
                "ADVANCED_FILTER": "Avancerat filter",
                "AGREEMENT_CHART": "Överensstämmelsediagram",
                "AGREEMENT_CHART_FOOTER": "Överensstämmelsediagrammet visar hur bra poängen stämmer överens. Varje punkt visar hur enskilda personer har bedömt dig i varje fall. Punktens storlek visar hur många utvärderare som har bedömt dig på samma sätt.",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "svar",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "svar",
                "AGREEMENT_CHART_LEGEND_TITLE": "Hur andra har bedömt dig",
                "ALL": "Alla",
                "AND_IF": "Och om",
                "ANGLED": "Vinklad",
                "AREA": "Område",
                "AUTO": "Automatisk",
                "AVERAGE": "Genomsnitt",
                "AXIS_VALUES": "Axelvärden",
                "BAR": "Stapel",
                "BASE_WORD_COLOR": "Basordfärg",
                "BLUR": "Suddighet",
                "BOTTOM_BOX": "Nedersta boxen",
                "BREAKOUT_HEADERS": "Utbrytningshuvuden",
                "CANCEL": "Avbryt",
                "CATEGORICAL": "Kategorisk",
                "CATEGORY": "Kategori",
                "CATEGORY_NAME": "Kategorinamn",
                "CHANGE_CATEGORIES_ORDER": "Ändra ordning på kategorier",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "Ändra ordning på poängsättningskategorier",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "Ändra ordningen som visas i visualiseringen genom att klicka till vänster om poängsättningskategorielementet och dra det till önskad position.",
                "CHANGE_QUESTIONS_ORDER": "Ändra ordning på frågor",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "Ändra ordning på frågor",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "Ändra ordningen som visas i visualiseringen genom att klicka till vänster om frågeelementet och dra det till önskad position.",
                "CHARTS": "Diagram",
                "CHART_TYPE": "Diagramtyp",
                "CHOICE_COUNT": "Antal alternativ",
                "CHOICE_TOTALS": "Alternativ totalt",
                "CLEAR": "Rensa",
                "CLOSE": "Stäng",
                "COLOR_PALETTE": "Färgpalett",
                "COLUMN_NAMES": "Kolumnnamn",
                "COLUMN_TOTALS": "Kolumn totalt",
                "COMPARED_FILTER_GROUP": "Jämförd filtergrupp",
                "COMPARED_FILTER_GROUPS": "Jämförda filtergrupper",
                "COMPARE_WITH": "jämför med",
                "COMPETITION_RANKING": "Använd rangordning av konkurrenter",
                "COMPETITION_RANKING_TOOLTIP": "I händelse av ett lika resultat får alla lika poängsättningar samma rangordning. Efterföljande post kommer dock att rangordnas enligt följande: Totalt antal poster som rangordnas högre i tabellen, plus en.",
                "COMPLETED_RESPONSES": "Slutförda svar",
                "CONDITIONAL_TEXT": "Villkorstext",
                "COUNT": "Antal",
                "CREATE": "Skapa",
                "CUSTOM_PALETTE": "Anpassad palett",
                "DATA_SOURCE_TYPE": "Typ av datakälla",
                "DATA_SOURCE_TYPE_CATEGORY": "Poängsättningskategorier",
                "DATA_SOURCE_TYPE_QUESTION": "Frågor",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "Fråga",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "Objekt som kan rangordnas",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "Poängsättningskategori",
                "DEFAULT": "Standard",
                "DEFAULT_TEXT": "Standardtext",
                "DELETE": "Radera",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "Förstå vem som ger dig feedback, oavsett om det är kollegor, direkt underställda, ledare eller någon annan",
                "DIFFERENT_EVALUATORS_HEADER": "Olika utvärderare",
                "DIRECT_REPORTS": "Direkt underställda",
                "DISABLED": "Inaktiverad",
                "DISPLAY_OPTIONS": "Visa alternativ",
                "DISPLAY_THRESHOLD_TEXTS": "Visa text baserat på följande gruppers avstånd",
                "DIVERGENT": "Avvikande",
                "DONE": "Klar",
                "DONT_HEADER": "Vad du inte bör göra:",
                "DONT_LINE1": "Försöka lista ut vem som sade vad",
                "DONT_LINE2": "Fokusera på en positiv eller negativ poäng/kommentar",
                "DONT_LINE3": "Skapa en utvecklingsplan kring varje punkt",
                "DONT_LINE4": "Låta dig nedslås av att du har förbättringspunkter",
                "DONUT": "Ring",
                "DOWNLOAD_CSV": "Hämta gammal CSV",
                "DOWNLOAD_ZIP": "Hämta alla filer",
                "DO_HEADER": "Vad du bör göra:",
                "DO_LINE1": "Titta på feedbacken som helhet",
                "DO_LINE2": "Identifiera teman i termer av styrkor och förbättringspunkter",
                "DO_LINE3": "Prioritera några fokusområden som du kan lägga till i din utvecklingsplan",
                "DO_LINE4": "Förstå att alla har förbättringspunkter",
                "DROPOFF": "Bortfall",
                "DUPLICATE": "Dubblett",
                "EDIT_CONDITIONAL_TEXT": "Redigera villkorstext",
                "EDIT_CUSTOM_PALETTE": "Redigera anpassad palett",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "Visa annars följande text",
                "ENABLED": "Aktiverad",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "Aktivera ordningsföljd för visningslogik för utvärderarkategori",
                "ENABLE_ORDERING_FOR": "Aktivera ordningsföljd",
                "EQUAL_TO": "Lika med",
                "FIELD": "Fält",
                "FILTER_NAMES": "Filternamn",
                "FOLLOWING_PARENTHESES": "(följande)",
                "FOOTER": "Sidfot",
                "GAP": "Avstånd",
                "GAP_CHART": "Avståndsdiagram",
                "GAP_CHART_DESCRIPTION": "Avståndsdiagrammet visar hur poängen skiljer sig mellan två utvärderargrupper. Exempel: I fallet med egen bedömning kontra hur andra har bedömt dig innebär en positiv (+) differens att andra har värderat dig högre än vad du själv har. En negativ (-) differens innebär att andra har värderat dig lägre än vad du själv har.",
                "GAP_CHART_FOOTER": "Avståndsdiagrammet visar +/--differensen mellan två utvärderargrupper.",
                "GAP_TABLE_DESCRIPTION": "Dolda styrkor framträder där andra har värderat dig högre än vad du själv har. Förbättringsområden framträder där andra har värderat dig lägre än vad du själv har. Båda avsnitten rangordnas från största till minsta avstånd.",
                "GAP_TABLE_FOOTER": "Den första poängkolumnen visar hur du poängsatte dig själv. Den andra kolumnen visar den genomsnittliga poängen du fick av andra. Den tredje kolumnen visar skillnaden mellan hur du poängsatte dig själv och hur andra poängsatte dig.",
                "GAP_TABLE_TITLE": "Dolda styrkor/förbättringsområden",
                "GREATER_OR_EQUAL": "Större än eller lika med",
                "GREATER_THAN": "Större än",
                "GROUP": "Grupp",
                "GROUPED_FOR_ANONYMITY": "Grupperat för anonymitet",
                "HEADER_NAMES": "Namn på sidhuvud",
                "HIGHEST_SCORES": "Högsta poäng",
                "HIGHLIGHT_THRESHOLD": "Tröskelvärde för avståndsmarkering",
                "HIGHLOW_TABLE": "Höga och låga poäng",
                "HIGHLOW_TABLE_FOOTER": "Det här avsnittet visar de fem beteenden som har högst respektive lägst poäng (av alla beteenden) av genomsnitten i tillämpliga utvärderarkategorier. För att få ut mesta möjliga av denna sida är det bra att försöka hitta trender. Exempel: Om de flesta av dina lägst värderade beteenden är koncentrerade till en eller två kategorier kan det vara de områdena som behöver utvecklas. De högst värderade beteendena kan identifiera styrkor som kan användas inom även andra områden.",
                "HIGH_LOW_TABLE_DESCRIPTION": "Diagrammet med höga/låga visar poster baserat på de områden där andra värderade dig högst eller lägst.",
                "HORIZONTAL": "Horisontell",
                "HORIZONTAL_AND_VERTICAL": "Horisontell och vertikal",
                "HORIZONTAL_BAR": "Horisontell stapel",
                "HOW_TO_INTERPRET_RESULT_HEADER": "Hur du tolkar resultaten och fastställer åtgärder:",
                "IF": "Om",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "Inkludera dolda etiketter i procentsatser",
                "INNER_RIM": "Inre kant",
                "IS": "Är",
                "IS_NOT": "Är inte",
                "IS_SAME_AS_SUBJECT": "Är samma som subjekt",
                "ITEM": "Post",
                "LABEL": "etikett",
                "LABELS": "Etiketter",
                "LARGE_LABELS": "Stora etiketter",
                "LEGEND": "Förklaring",
                "LEGEND_POSITION": "Förklaringsposition",
                "LEGEND_VALUES": "Förklaringsvärden",
                "LESS_OR_EQUAL": "Mindre än eller lika med",
                "LESS_THAN": "Mindre än",
                "LINE": "Linje",
                "LOWEST_SCORES": "Lägsta poäng",
                "MANAGERS": "Chefer",
                "MANUAL_FONT_SIZE": "Ställ in textstorlek manuellt",
                "MAX": "Max.",
                "MEAN": "Medel",
                "MEDIAN": "Median",
                "METRIC_TYPE": "Typ av mätetal",
                "MIN": "Min.",
                "MODIFY_CUSTOM_PALETTES": "Ändra anpassade paletter",
                "MOVE_DOWN": "Flytta nedåt",
                "MOVE_UP": "Flytta uppåt",
                "MULTI_SELECT_ITEMS_SELECTED": "valda",
                "NEGATIVE_GAPS": "Förbättringsområden",
                "NO": "Nej",
                "NONE": "Inget",
                "NOT_APPLICABLE": "E/T",
                "NOT_EQUAL_TO": "Inte lika med",
                "NO_DATA_AVAILABLE_WARNING": "Inga tillgängliga data",
                "NO_FILTER": "Nej filter",
                "NO_FILTER_IS_APPLIED": "Inget filter har tillämpats.",
                "NO_VALUE": "Inget värde",
                "NPS": "Net Promoter® Score",
                "NUMBER": "nummer",
                "NUMBERS": "Nummer",
                "NUMBER_OF_GAPS_NEGATIVE": "Antal negativa avstånd",
                "NUMBER_OF_GAPS_POSITIVE": "Antal positiva avstånd",
                "NUMBER_OF_ROWS_HIGH": "Antal höga rader",
                "NUMBER_OF_ROWS_LOW": "Antal låga rader",
                "OPTIONS": {
                    "HEADER_NAME": "Namn på sidhuvud",
                    "LEGEND": "Förklaring",
                    "SCALE_AXIS_CHANGER_TITLE": "Intervall"
                },
                "ORIENTATION": "Orientering",
                "OR_IF": "Eller om",
                "OTHER": "Annan",
                "OTHERS": "Andra",
                "PAGE_OF": "Sida: %1 av %2",
                "PALETTE_REMOVED": "Palett borttagen",
                "PEERS": "Kollegor",
                "PERCENT": "Procent",
                "PERCENTAGE": "Procentandel",
                "PERCENTAGE_OF_CHOICES": "Procentandel för alternativ",
                "PERCENTAGE_OF_RESPONSES": "Procentandel för svar",
                "PERCENT_COMPLETE": "% slutfört",
                "PERSON_METADATA": "Personmetadata",
                "PERSON_METADATA_EVALUATOR": "Utvärderares",
                "PERSON_METADATA_SUBJECT": "Subjekts",
                "PERSON_METADATA_VIEWER": "Granskarens",
                "POSITIVE_GAPS": "Dolda styrkor",
                "PRIMARY_PARENTHESES": "(primärt)",
                "QUESTIONS": "Frågor",
                "RADIUS": "Radie",
                "RANK": "Rangordning",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "Högsta poäng",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "Högsta poäng",
                "RANKABLE_ITEMS_ITEM_HAS": "Objekt har",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "Objekt är i toppen",
                "RANKABLE_ITEMS_LOWEST_SCORE": "Lägsta poäng",
                "RANKABLE_ITEMS_LOWEST_SCORES": "Lägsta poäng",
                "RATER_CATEGORY_DISPLAY_LOGIC": "visningslogik för utvärderarkategori",
                "RATIO": "Andel",
                "RECORD": "Post",
                "REFERENCE_GROUP": "Referensgrupp",
                "RELATIONSHIP": "Relation",
                "RELATIONSHIP_FILTERS": "Relationsfilter",
                "RELATIONSHIP_FILTERS_INFO": "För att lägga till ett relationsfilter (till exempel en direkt underställd, kollega eller chef) väljer du Hantera dina filter och använder relationsvillkor från listrutan.",
                "REMOVE": "Ta bort",
                "REMOVE_DATA_SOURCE": "Ta bort datakälla",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "Kom ihåg att det finns resurser i din organisation som kan hjälpa dig att tolka den feedback du får, till exempel HR-partner, din chef och/eller en mentor.",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "Ta en kopp kaffe och gå igenom den feedback du har fått.",
                    "ABOUT_YOUR_REPORT_HEADER": "Om din rapport",
                    "ABOUT_YOUR_REPORT_LINE1": "Välkommen till din 360-feedbackrapport. Det här är ett bra tillfälle att växa och utvecklas i din yrkesroll. För att du ska få ut mesta möjliga av dina resultat bör du avsätta tillräckligt med tid när du går igenom feedbacken. Feedback kan vara svårt att ta in ibland, men kom ihåg att syftet med denna feedback är att du ska utvecklas.",
                    "ABOUT_YOUR_REPORT_LINE2": "När du går igenom rapporten finns det några saker att tänka på.",
                    "ADVANCED_FILTER": "Avancerat filter",
                    "AGREEMENT_CHART": "Överensstämmelsediagram",
                    "AGREEMENT_CHART_FOOTER": "Överensstämmelsediagrammet visar hur bra poängen stämmer överens. Varje punkt visar hur enskilda personer har bedömt dig i varje fall. Punktens storlek visar hur många utvärderare som har bedömt dig på samma sätt.",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "svar",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "svar",
                    "AGREEMENT_CHART_LEGEND_TITLE": "Hur andra har bedömt dig",
                    "ALL": "Alla",
                    "AVERAGE": "Genomsnitt",
                    "BOTTOM_BOX": "Nedersta boxen",
                    "CHOICE_COUNT": "Antal alternativ",
                    "CHOICE_TOTALS": "Alternativ totalt",
                    "COMPARISON": "Jämförelse",
                    "COMPARISON_GAP_COLUMN_HEADER": "Jämförelseavstånd",
                    "COMPLETED_RESPONSES": "Slutförda svar",
                    "COUNT": "Antal",
                    "DEFAULT": "Standard",
                    "DEFAULT_TEXT": "Standardtext",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "Förstå vem som ger dig feedback, oavsett om det är kollegor, direkt underställda, ledare eller någon annan",
                    "DIFFERENT_EVALUATORS_HEADER": "Olika utvärderare",
                    "DONE": "Klar",
                    "DONT_HEADER": "Vad du inte bör göra:",
                    "DONT_LINE1": "Försöka lista ut vem som sade vad",
                    "DONT_LINE2": "Fokusera på en positiv eller negativ poäng/kommentar",
                    "DONT_LINE3": "Skapa en utvecklingsplan kring varje punkt",
                    "DONT_LINE4": "Låta dig nedslås av att du har förbättringspunkter",
                    "DO_HEADER": "Vad du bör göra:",
                    "DO_LINE1": "Titta på feedbacken som helhet",
                    "DO_LINE2": "Identifiera teman i termer av styrkor och förbättringspunkter",
                    "DO_LINE3": "Prioritera några fokusområden som du kan lägga till i din utvecklingsplan",
                    "DO_LINE4": "Förstå att alla har förbättringspunkter",
                    "FIELD": "Fält",
                    "GAP": "Avstånd",
                    "GAP_CHART": "Avståndsdiagram",
                    "GAP_CHART_DESCRIPTION": "Avståndsdiagrammet visar hur poängen skiljer sig mellan två utvärderargrupper. Exempel: I fallet med egen bedömning kontra hur andra har bedömt dig innebär en positiv (+) differens att andra har värderat dig högre än vad du själv har. En negativ (-) differens innebär att andra har värderat dig lägre än vad du själv har.",
                    "GAP_CHART_FOOTER": "Avståndsdiagrammet visar +/--differensen mellan två utvärderargrupper.",
                    "GAP_TABLE_DESCRIPTION": "Dolda styrkor framträder där andra har värderat dig högre än vad du själv har. Förbättringsområden framträder där andra har värderat dig lägre än vad du själv har. Båda avsnitten rangordnas från största till minsta avstånd.",
                    "GAP_TABLE_FOOTER": "Den första poängkolumnen visar hur du poängsatte dig själv. Den andra kolumnen visar den genomsnittliga poängen du fick av andra. Den tredje kolumnen visar skillnaden mellan hur du poängsatte dig själv och hur andra poängsatte dig.",
                    "GAP_TABLE_TITLE": "Dolda styrkor/förbättringsområden",
                    "GROUP": "Grupp",
                    "HIDE_REPORT_ALERT": "Du uppfyller inte kraven för att visa rapporten. Kontakta organisationens administratör.",
                    "HIGHEST_SCORES": "Högsta poäng",
                    "HIGHLOW_TABLE": "Högsta och lägsta poäng",
                    "HIGHLOW_TABLE_FOOTER": "Det här avsnittet visar de fem beteenden som har högst respektive lägst poäng (av alla beteenden) av genomsnitten i tillämpliga utvärderarkategorier. För att få ut mesta möjliga av denna sida är det bra att försöka hitta trender. Exempel: Om de flesta av dina lägst värderade beteenden är koncentrerade till en eller två kategorier kan det vara de områdena som behöver utvecklas. De högst värderade beteendena kan identifiera styrkor som kan användas inom även andra områden.",
                    "HIGH_LOW_TABLE_DESCRIPTION": "Diagrammet med höga/låga visar poster baserat på de områden där andra värderade dig högst eller lägst.",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "Hur du tolkar resultaten och fastställer åtgärder:",
                    "ITEM": "Post",
                    "LOWEST_SCORES": "Lägsta poäng",
                    "MAX": "Max.",
                    "MEAN": "Medel",
                    "MEDIAN": "Median",
                    "MIN": "Min.",
                    "NEGATIVE_GAPS": "Förbättringsområden",
                    "NO_COMPARISON_SET": "Ingen jämförelseuppsättning",
                    "NO_DATA_AVAILABLE_WARNING": "Inga tillgängliga data",
                    "NO_FILTER_IS_APPLIED": "Inget filter har tillämpats.",
                    "NO_VALUE": "Inget värde",
                    "NPS": "Net Promoter® Score",
                    "OTHERS": "Andra",
                    "PERCENTAGE": "Procentandel",
                    "PERCENTAGE_OF_CHOICES": "Procentandel för alternativ",
                    "PERCENTAGE_OF_RESPONSES": "Procentandel för svar",
                    "PERCENT_COMPLETE": "% slutfört",
                    "POSITIVE_GAPS": "Dolda styrkor",
                    "QUESTIONS": "Frågor",
                    "RANK": "Rangordning",
                    "RELATIONSHIPS": {
                        "ANYONE": "Vem som helst",
                        "DIRECT_REPORT": "Direkt underställd",
                        "MANAGER": "Chef",
                        "PEER": "Kollega",
                        "SELF": "Jag"
                    },
                    "REPORT_SUMMARY": "Rapportöversikt",
                    "REPORT_SUMMARY_TABLE_FOOTER": "Jämför antal personer som har slutfört bedömningen med antal personer som har bjudits in att delta.",
                    "REPORT_SUMMARY_TABLE_HEADER": "Respondentstatistik",
                    "RESPONSES": "Svar",
                    "RESPONSE_COUNT": "{{responseCount}} svar",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> svar",
                    "SCORING_CATEGORY": "Poängsättningskategori",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Inga svar i denna kategori",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Inga svar på denna fråga",
                    "SCORING_OVERVIEW": "Poängsättningsöversikt",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "Du och andra utvärderare tycker att det här är en av de främsta styrkorna.",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Känd styrka",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Erkända förbättringsområden innebär att både din egen och andras värderingar ligger under genomsnittet för denna kompetens.",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Erkänt förbättringsområde",
                    "SCORING_OVERVIEW_DESCRIPTION": "Ovan visas de av dina kompetenser eller beteenden som har utvärderats i denna feedbackprocess med flera utvärderare. Jämförelsevärderingar visas efter grupp.",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "Minsta avstånd",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Minsta differens mellan referensgrupper för texter som ska visas.",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "Här visas poängintervallet för varje kompetens/beteende. Stapeln representerar det numeriskt genomsnittet.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Okänd styrka härrör från skillnaden mellan den egna värderingen och andras värderingar.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Okänd styrka",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Okänt förbättringsområde härrör från skillnaden mellan den egna värderingen och andras värderingar.",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Okänt förbättringsområde",
                    "SELF": "Jag",
                    "SELF_ASSESSMENT": "Självbedömning",
                    "STANDARD_DEVIATION": "Standardavvikelse",
                    "SUM": "Summa",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Bekanta dig med bedömningsskalan så att du är säker på att du tolkar den rätt",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "Kom ihåg skalan",
                    "THINGS_YOU_WILL_SEE_HEADER": "Saker du kommer att få se:",
                    "THREE_SIXTY_PERCENTILE": "Percentil",
                    "TOP_BOTTOM_BOX": "Översta boxen/nedersta boxen",
                    "TOP_BOX": "Översta boxen",
                    "TOTAL": "Totalt",
                    "TO_DO": "Att göra",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Kvalitativ: Denna feedback är i form av öppna textkommentarer",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Kvantitativ: Denna feedback är numerisk och kan representeras med grafer, stapeldiagram, tabeller etc.",
                    "TYPES_OF_FEEDBACK_HEADER": "Olika typer av feedback",
                    "VALUE": "Värde",
                    "VARIANCE": "Varians",
                    "YOUR_RATINGS": "Dina värderingar"
                },
                "REPORT_SUMMARY": "Rapportöversikt",
                "REPORT_SUMMARY_TABLE_FOOTER": "Jämför antal personer som har slutfört bedömningen med antalet personer som har bjudits in att delta.",
                "REPORT_SUMMARY_TABLE_HEADER": "Respondentstatistik",
                "RESET": "Återställ",
                "RESPONDENT_TOTALS": "Respondent totalt",
                "RESPONSES": "Svar",
                "RESPONSE_COUNT": "{{responseCount}} svar",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> svar",
                "RESULT": "Resultat",
                "REVERSE_COLORS": "Omvända färger",
                "ROW_TOTALS": "Rad totalt",
                "SAVE": "Spara",
                "SAVE_AND_APPLY": "Spara och tillämpa",
                "SCORING_CATEGORY": "Poängsättningskategori",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "Inga svar i denna kategori",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "Inga svar på denna fråga",
                "SCORING_OVERVIEW": "Poängsättningsöversikt",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "Du och andra utvärderare tycker att det här är en av de främsta styrkorna.",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "Erkänd styrka",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "Erkända förbättringsområden innebär att både din egen och andras värderingar ligger under genomsnittet för denna kompetens.",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "Erkänt förbättringsområde",
                "SCORING_OVERVIEW_DESCRIPTION": "Ovan visas de av dina kompetenser eller beteenden som har utvärderats i denna feedbackprocess med flera utvärderare. Jämförelsevärderingar visas efter grupp.",
                "SCORING_OVERVIEW_MINIMUM_GAP": "Minsta avstånd",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "Minsta differens mellan referensgrupper för texter som ska visas.",
                "SCORING_OVERVIEW_TABLE_FOOTER": "Här visas poängintervallet för varje kompetens/beteende. Stapeln representerar det numeriskt genomsnittet.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "Okänd styrka härrör från skillnaden mellan den egna värderingen och andras värderingar.",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "Okänd styrka",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "Okänt förbättringsområde härrör från skillnaden mellan den egna värderingen och andras värderingar.",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "Okänt förbättringsområde",
                "SELECT_CATEGORIES": "Välj poängsättningskategorier...",
                "SELECT_CATEGORY": "Välj en poängsättningskategori...",
                "SELECT_CONDITION_TYPE": "Välj villkorstyp",
                "SELECT_DATA_SOURCE": "Välj datakälla",
                "SELECT_DATA_SOURCE_TYPE": "Välj typ av datakälla",
                "SELECT_FILTER": "Välj filter",
                "SELECT_FILTERS": "Välj filter",
                "SELECT_OPERATOR_TYPE": "Välj typ av operator",
                "SELECT_PERSON": "Välj person",
                "SELECT_PERSON_METADATA": "Välj personmetadata",
                "SELECT_QUESTION": "Välj fråga",
                "SELECT_QUESTIONS": "Välj frågor...",
                "SELECT_RATIO_OR_DROPOFF": "Välj andel eller bortfall",
                "SELECT_RELATIONSHIP": "Välj relation",
                "SELECT_SCORING_CATEGORY": "Välj poängsättningskategori",
                "SELF": "Jag",
                "SELF_ASSESSMENT": "Självbedömning",
                "SEQUENTIAL": "Sekventiell",
                "SETUP_COMPARISON": "Konfigurationsjämförelse",
                "SETUP_COMPARISONS": "Konfigurationsjämförelser",
                "SET_START_COLOR": "Ange startfärg",
                "SHOULD_SHOW_FOOTER": "Visa sidfot",
                "SHOULD_SHOW_SCORING_CATEGORY": "Visa poängsättningskategori",
                "SHOWING_RECORDS_OF": "Visar %1 - %2 av %3 poster",
                "SHOW_COMPARISON_GAP": "Visa jämförelse skillnadskolumn",
                "SHOW_DATA_LABEL": "Visa datavärden",
                "SHOW_PERCENTAGES": "Visa procentandelar",
                "SHOW_THE_FOLLOWING_TEXT": "Visa sedan följande text",
                "SHOW_TIES": "Visa oavgjorda",
                "SHOW_X_AXIS": "Visa X-axel",
                "SHOW_Y_AXIS": "Visa Y-axel",
                "SMALL_LABELS": "Små etiketter",
                "SORT": "Sortera",
                "SPLINE": "Spline",
                "STACK_CHART": "Stackdiagram",
                "STANDARD_DEVIATION": "Standardavvikelse",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "Svaghet mindre än",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "Redigera tröskelvärdestexter",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "Tröskelvärdestexter",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "Aktivera tröskelvärdestexter",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "Styrka mer än",
                "SUM": "Summa",
                "SUMMARY": "Översikt",
                "TABLES": "Tabeller",
                "TABLE_TOTALS": "Tabell totalt",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "Bekanta dig med bedömningsskalan så att du är säker på att du tolkar den rätt",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "Kom ihåg skalan",
                "TEXT": "Text",
                "THINGS_YOU_WILL_SEE_HEADER": "Saker du kommer att få se:",
                "TOP_BOTTOM_BOX": "Översta boxen/nedersta boxen",
                "TOP_BOX": "Översta boxen",
                "TOTAL": "Totalt",
                "TOTAL_COUNTS": "Totalt antal",
                "TO_DO": "Att göra",
                "TRANSPOSE": "Transponera",
                "TRANSPOSE_TABLE": "Transponera tabell",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "Kvalitativ: Denna feedback är i form av öppna textkommentarer",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "Kvantitativ: Denna feedback är numerisk och kan representeras med grafer, stapeldiagram, tabeller etc.",
                "TYPES_OF_FEEDBACK_HEADER": "Olika typer av feedback",
                "UNDO": "Ångra",
                "USE_COMPARISON": "Använd jämförelse",
                "USE_LABELS_FOR_SCALES": "Använd etiketter för skalor",
                "VALUES": "Värden",
                "VALUE_RANGES": "Värdeintervall",
                "VARIANCE": "Varians",
                "VERTICAL": "Vertikal",
                "VERTICAL_RANGE": "Vertikalt intervall",
                "WARNING_DATA_OUT_OF_RANGE": "Varning: datavärde överskrider intervallkonfiguration",
                "WIDGET_ERROR": {
                    "ERROR": "Ett oväntat fel har inträffat",
                    "MISCONFIGURED": "Widgeten har inte konfigurerats korrekt. Kontrollera widgetkonfigurationen.",
                    "NEW": "Konfigurera widget",
                    "NO_DATA": "Inga data hittades - dina filter kan exkludera för mycket!"
                },
                "WIDGET_NAME": {
                    "BAR": "Stapeldiagram",
                    "BREAKDOWNBAR": "Fördelningsstapel",
                    "DATA_TABLE": "Datatabell",
                    "FUNNEL_CHART": "Trattdiagram",
                    "GAUGE": "Mätardiagram",
                    "GRID": "Resultattabell",
                    "HEATMAP": "Värmekarta",
                    "LINE": "Linjediagram",
                    "NEEDS_BASED": "Behovsbaserad",
                    "PIE": "Cirkeldiagram",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "Prisberäknare (Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "Intäktsmaximerare (Gabor Granger)",
                    "SCORING_OVERVIEW_CHART": "Diagram",
                    "SCORING_OVERVIEW_TABLE": "Tabell",
                    "STATS_TABLE": "Statistiktabell",
                    "WORDCLOUD": "Ordmoln"
                },
                "WORD_ROTATION": "Ordrotation",
                "WORD_SPACING": "Ordavstånd",
                "YES": "Ja",
                "YOUR_RATINGS": "Dina värderingar"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "Lägg till",
                "ADD_A_WORD": "Lägg till ord",
                "COLOR": "Färg",
                "DELETE_ALL": "Radera alla",
                "EDIT_STOP_WORDS": "Redigera stoppord",
                "MAX_WORDS": "Max. antal ord",
                "ROTATION_ANGLED": "Vinklad",
                "ROTATION_HORIZONTAL": "Horisontell",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "Horisontell och vertikal",
                "WORD_ORIENTATION": "Ordorientering"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "Bakgrundsfärger",
                "DISPLAY_OPTIONS": "Visa alternativ",
                "INVERT_FONT_COLORS": "Invertera teckensnittsfärger med låg kontrast",
                "PAGE": "Sida",
                "PAGINATE": "Paginera"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "Medel",
                "BOTTOM_BOX_METRIC": "Nedersta boxen",
                "COLUMNS": "Kolumner",
                "COUNT_METRIC": "Svar totalt",
                "FIELD_NAME": "Fält",
                "MAX_METRIC": "Max.",
                "MIN_METRIC": "Min.",
                "SHOW_RECODES": "Visa omkodningsvärden",
                "SHOW_ROW_NUMBERS": "Visa radnummer",
                "STD_DEV_METRIC": "Standardavvikelse",
                "TOP_BOX_METRIC": "Översta boxen",
                "TRANSPOSE_BREAKOUTS": "Transponera utbrytningar",
                "TRANSPOSE_TABLE": "Transponera tabell",
                "VAR_METRIC": "Varians"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "Extra kolumner",
                "ADD_COLUMNS": "Lägg till extra kolumner",
                "ADD_CUSTOM_PALETTE": "Lägg till anpassad palett",
                "ALL_CHOICES": "Alla alternativ",
                "ALL_GROUPS": "Alla grupper",
                "ALL_RECODES": "Alla omkodningar",
                "AUTOMATIC": "Standard",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "Standard - Klicka för att redigera",
                "AXIS_VALUES": "Axelvärden",
                "BREAKOUT_BY": "Utbrytning enligt",
                "CANCEL": "Avbryt",
                "CATEGORICAL": "Kategorisk",
                "CHOICES": "Alternativ",
                "CHOICE_COUNT": "Antal alternativ",
                "COLOR_PALETTE": "Färgpalett",
                "COLUMN_VALUES": "Kolumnvärden",
                "CONTACT_FIELDS": "Kontaktfält",
                "COUNT": "Antal",
                "CREATE": "Skapa",
                "CUSTOM": "Anpassning",
                "CUSTOM_PALETTE": "Anpassad palett",
                "DATA_SOURCE": "Datakälla",
                "DAY": "Dag",
                "DAY_OF_WEEK": "Veckodag",
                "DECIMAL_PRECISION": "Decimaler",
                "DEFAULT": "Standard",
                "DISABLED": "Inaktiverad",
                "DIVERGENT": "Avvikande",
                "EDIT_CUSTOM_PALETTE": "Redigera anpassad palett",
                "ENABLED": "Aktiverad",
                "ERROR_LOADING_DATA": "Fel vid inläsning av data",
                "FILE_SIZE": "Storlek",
                "FILE_TYPE": "Typ",
                "FRI": "Fre",
                "FRIDAY": "Fredag",
                "GROUP_DATE_BY": "Gruppera datum efter",
                "HOUR_OF_DAY": "Timme",
                "LENGEND_VALUES": "Förklaringsvärden",
                "MAX": "Max.",
                "MEAN": "Medel",
                "MIN": "Min.",
                "MISCONFIGURED_DATA": "Datakällan har felkonfigurerats för denna visualisering.",
                "MISCONFIGURED_FILTERS": "Ogiltiga filter",
                "MODIFY_CUSTOM_PALETTES": "Ändra anpassade paletter",
                "MON": "Mån",
                "MONDAY": "Måndag",
                "MONTH": "Månad",
                "NONE": "Inget",
                "NO_FILE_ID_ERROR": "Visualiseringen kräver att en bild infogas i undersökningen",
                "NO_RESULTS_TO_SHOW": "Inga resultat att visa",
                "NPS": "Net Promoter Score®",
                "NPS_GROUP": "NPS®-grupp",
                "NUMERIC_VALUE": "Numeriskt värde",
                "PALETTE_REMOVED": "Palett borttagen",
                "PERCENTAGE": "Procentandel",
                "PERCENTAGE_OF_CHOICES": "Procentandel för alternativ",
                "PERCENTAGE_OF_RESPONSES": "Procentandel för svar",
                "QUARTER": "Kvartal",
                "REMOVE": "Ta bort",
                "RESPONSE_COUNT": "Antal svar",
                "RESULTS_PER_PAGE": "Resultat per sida",
                "RETRIEVING_DATA_ELLIPSIS": "Hämtar data ...",
                "REVERSE_COLORS": "Omvända färger",
                "ROW_VALUES": "Radvärden",
                "SAT": "Lör",
                "SATURDAY": "Lördag",
                "SAVE": "Spara",
                "SELECTED_CHOICE": "Valt alternativ",
                "SELECT_FIELD": "Välj fält",
                "SELECT_METRIC": "Mätetal",
                "SEQUENTIAL": "Sekventiell",
                "SET_START_COLOR": "Ange startfärg",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "Visar undersökningsurvalsdata ...",
                "SUM": "Summa",
                "SUN": "Sön",
                "SUNDAY": "Söndag",
                "SURVEY_EMBEDDEDDATA": "Inbäddade data",
                "SURVEY_METADATA": "Metadata för undersökning",
                "TEXT_ENTRY": "Textpost",
                "THURS": "Tors",
                "THURSDAY": "Torsdag",
                "TITLE": "Titel",
                "TUES": "Tis",
                "TUESDAY": "Tisdag",
                "UNBOUNDED_DOMAIN": "För många värden att visa.",
                "UNBOUNDED_DOMAIN_HELP": "För att lägga till det här fältet i resultatrapporter kan du lägga till ett filter i rapporten för att visa färre värden för \"{{ed_field_name}}\" eller uppdatera variabeltypen för inbäddade data \"{{ed_field_name}}\" i undersökningsflödet, för att göra detta fält till en strängtyp eller numerisk typ.",
                "UNDO": "Ångra",
                "USE_CHOICE_TOTALS": "Använd alternativ totalt",
                "USE_RESPONDENT_TOTALS": "Använd respondenter totalt",
                "VISUALIZATION": "Visualisering",
                "VISUALIZATION_BARCHART": "Stapeldiagram",
                "VISUALIZATION_BREAKDOWNBAR": "Fördelningsstapel",
                "VISUALIZATION_GAUGE": "Mätardiagram",
                "VISUALIZATION_HEATMAP": "Värmekarta",
                "VISUALIZATION_LINECHART": "Linjediagram",
                "VISUALIZATION_PAGINATEDTABLE": "Paginerad tabell",
                "VISUALIZATION_PIE": "Cirkeldiagram",
                "VISUALIZATION_SIMPLETABLE": "Enkel tabell",
                "VISUALIZATION_STATSTABLE": "Statistiktabell",
                "VISUALIZATION_TEXTHIGHLIGHTS": "Textmarkeringar",
                "VISUALIZATION_WORDCLOUD": "Ordmoln",
                "WED": "Ons",
                "WEDNESDAY": "Onsdag",
                "WEEK": "Vecka",
                "WEIGHTING": "Viktning",
                "WRONG_QUESTION_TYPE_ERROR": "Visualiseringstypen kan inte användas för denna fråga",
                "YEAR": "År"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "Genomsnitt",
                "CHOICE_COUNT": "Antal alternativ",
                "COUNT": "Antal",
                "DISPLAY_OPTIONS": "Visa alternativ",
                "MAX": "Max.",
                "MIN": "Min.",
                "NPS": "NPS®",
                "PAGE_OF": "Sida: %1 av %2",
                "PERCENT": "Procentandel",
                "RESPONSE_COUNT": "Antal svar",
                "ROWS_PER_TABLE": "Rader per tabell",
                "SHOWING_ROWS_OF": "Visar rad %1 - %2 av %3",
                "SHOW_PERCENTAGES": "Visa procentandelar",
                "SHOW_RECODES": "Visa omkodningsvärden",
                "SHOW_ROW_NUMBERS": "Visa radnummer",
                "SUM": "Summa",
                "TOTAL": "Totalt",
                "TRANSPOSE": "Transponera",
                "USE_COLUMN_TOTALS": "Använd Kolumn totalt",
                "USE_ROW_TOTALS": "Använd Rad totalt",
                "VALUE": "Värde"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "Stigande",
                "COUNT": "Antal",
                "DESCENDING": "Fallande",
                "DIAGONAL": "Diagonalt",
                "DISPLAY_OPTIONS": "Visa alternativ",
                "ERROR_COLON": "Fel:",
                "ERROR_GENERIC": "Ett fel uppstod vid inläsningen av visualiseringen.",
                "HORIZONTAL": "Horisontell",
                "HORIZONTAL_BARS": "Horisontella staplar",
                "INCORRECTLY_CONFIGURED": "Välj ett värde för att visa diagram",
                "LEGEND_AUTO": "Automatisk",
                "LEGEND_BOTTOM": "Nere",
                "LEGEND_INSET": "Infällt",
                "LEGEND_RIGHT": "Höger",
                "NORMALIZE_TO_PERCENTAGES": "Normalisera till procentandelar",
                "SHOW_BAR_LABELS": "Visa stapeletiketter",
                "SHOW_LEGEND": "Visa förklaring",
                "SHOW_X_AXIS": "Visa X-axel",
                "SHOW_Y_AXIS": "Visa Y-axel",
                "SORT_BAR_VALUES": "Sortera stapelvärden",
                "STACKED_BARS": "Grupperade staplar",
                "TRANSPOSE": "Transponera",
                "TRUNCATE_LABELS": "Trunkera etiketter",
                "VERTICAL": "Vertikal"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "Alla övriga",
                "COULD_NOT_LOAD_DATA": "Kunde inte läsa in data med specificerad konfiguration – testa med ett annat källfält eller ett större dataintervall.",
                "GROUPING_PERCENTAGE_THRESHOLD": "Tröskelvärde för gruppering av procentandelar",
                "NO_DATA": "Inga data",
                "RADIUS": "Inre radie",
                "SHOW_AS_PERCENTAGES": "Visa som procentandelar"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "Stäng",
                "DOWNLOAD_CSV": "Hämta CSV",
                "DOWNLOAD_ZIP": "Hämta alla filer",
                "NO_DATA": "Inga data",
                "PAGE_OF": "Sida: %1 av %2",
                "RESULTS_PER_PAGE": "Resultat per sida",
                "SHOWING_RECORDS_OF": "Visar %1 - %2 av %3 poster",
                "SINGLE_RESPONSE": "Enkelt svar",
                "VIEW_RESPONSE": "Visa svar"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "Visningsalternativ",
                "ERROR_COLON": "Fel:",
                "ERROR_GENERIC": "Ett fel uppstod vid inläsningen av visualiseringen.",
                "HORIZONTAL_BARS": "Horisontella staplar",
                "INCORRECTLY_CONFIGURED": "Välj ett värde för att visa diagram",
                "LEGEND_AUTO": "Automatisk",
                "LEGEND_BOTTOM": "Nere",
                "LEGEND_INSET": "Infällt",
                "LEGEND_RIGHT": "Höger",
                "NORMALIZE_TO_PERCENTAGES": "Normalisera till procentandelar",
                "SHOW_AREA": "Visa område",
                "SHOW_LEGEND": "Visa förklaring",
                "SHOW_X_AXIS": "Visa X-axel",
                "SHOW_Y_AXIS": "Visa Y-axel",
                "SMOOTH_LINES": "Utjämnade linjer",
                "SORT_X_AXIS_LABELS": "Sortera X-axeletiketter",
                "STACKED_BARS": "Grupperade staplar",
                "TRANSPOSE": "Transponera"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "Blockläge",
                "BLUR": "Suddighet",
                "COULD_NOT_LOAD_DATA": "Kunde inte läsa in data med specificerad konfiguration – testa med ett annat källfält eller ett större dataintervall.",
                "FIELD": "Fält",
                "RADIUS": "Radie",
                "SHOW_REGIONS": "Visa regioner",
                "SHOW_REGION_LABELS": "Visa regionsetiketter"
            },
            "GAUGEWIDGET": {
                "MAX": "Max.",
                "MIN": "Min.",
                "VALUE_RANGES": "Värdeintervall"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "Etiketter nedtill",
                "CATEGORY_NAME": "Kategorinamn",
                "ERROR_COLON": "Fel:",
                "INCLUDE_HIDDEN_GROUPS": "Inkludera dolda grupper i procentsatser",
                "LARGE_LABELS": "Stora etiketter",
                "NO": "Nej",
                "PERCENT": "Procent",
                "RESPONSE_COUNT": "Antal svar",
                "RESPONSE_COUNT_WITH_VALUE": "{{ responseCount }} svar",
                "SMALL_LABELS": "Små etiketter",
                "YES": "Ja"
            }
        });
        $cache.put('TH', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "รหัสการเข้าถึง",
                "ACCESS_CODE_PROTECTION": "การป้องกันด้วยรหัสการเข้าถึง",
                "ADD": "เพิ่ม",
                "ADD_BREAKOUT": "เพิ่มการแบ่งรายงาน",
                "ADD_NOTE": "เพิ่มบันทึก",
                "ADD_SCHEDULED_REPORT": "เพิ่มรายงานตามกำหนดการ",
                "ADD_WIDGET": "เพิ่มการแสดงผล",
                "ALL_PROJECTS": "โครงการทั้งหมด",
                "ALL_QUESTIONS": "หน้าคำถาม",
                "ANSWER": "คำตอบ",
                "ANY_CHANGES_LOST": "การเปลี่ยนแปลงใดๆ ในรายงานจะสูญหายไปหากคุณออกจากแพลตฟอร์ม Qualtrics XM",
                "APPENDED_COPY_IN_PARENS": "(คัดลอก)",
                "AREA_CHART": "แผนภูมิพื้นที่",
                "AREA_CHART_DESC": "แผนภูมิเส้นสองแกนที่มีการแรเงาพื้นที่ใต้เส้นข้อมูล",
                "ATTACHMENT": "สิ่งที่แนบ",
                "BACKUP_CURRENT_REPORT": "เก็บบันทึกสำเนาสำรองของรายงานนี้ก่อนที่จะส่งผลต่อการแสดงผล",
                "BACKUP_CURRENT_REPORT_LINE2": "หมายเหตุ: สำเนาสำรองจะถูกตั้งชื่อว่า \"{{nameOfReportCopy}}\"",
                "BACK_TO_REPORTS": "กลับไปยังรายงาน",
                "BACK_TO_TOP": "กลับไปที่ด้านบน",
                "BACK_TO_VIEW_RESULTS": "กลับไปที่ 'ดูผลลัพธ์' เดิม",
                "BAR_CHART": "แผนภูมิแท่ง",
                "BAR_CHART_DESC": "แผนภูมิแท่งสองแกนที่ช่วยให้สามารถกำหนดรูปแบบเพิ่มเติม เช่น การเปลี่ยนตำแหน่งแกนและการจัดเรียงจุดข้อมูลใหม่",
                "BREAKDOWN_BAR_CHART": "แผนภูมิแท่งแยกย่อย",
                "BREAKDOWN_BAR_CHART_DESC": "แผนภูมิแท่งแบบเรียงซ้อนแนวนอนที่นิยมใช้กันมากที่สุดเพื่อเป็นทางเลือกแทนแผนภูมิวงกลมสำหรับการถ่วงน้ำหนักตัววัดซึ่งกันและกัน",
                "CANCEL": "ยกเลิก",
                "CANCEL_CONF_TEXT": "คุณแน่ใจหรือไม่ว่าต้องการยกเลิก?<br/>การเปลี่ยนแปลงทั้งหมดจะหายไป",
                "CANCEL_EDITS": "ยกเลิกการแก้ไข",
                "CHART": "แผนภูมิ",
                "CHOICE": "ตัวเลือก",
                "CHOICES_COUNT_METRIC": "จำนวนตัวเลือก",
                "CHOOSE_PAGES_TO_DISPLAY": "เลือกหน้าที่จะแสดง",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "รายงานนี้มี {{maxReportPageCount}} หน้า แต่ผลลัพธ์สามารถมีได้ไม่เกิน {{reportSizeLimit}} หน้า กรุณาเลือกชุดย่อยภายในขีดจำกัด",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "รายงานสามารถมีได้ไม่เกิน {{reportSizeLimit}} หน้า กรุณาเลือกหน้าที่คุณต้องการ",
                "CLEAR_ALL": "ล้างทั้งหมด",
                "CLOSE": "ปิด",
                "CLOUD": "คำอธิบายสำหรับ CLOUD",
                "COLLABORATED_NEW": "เจ้าของแบบสำรวจนี้ใช้แพลตฟอร์ม Qualtrics XM! รายงานสำหรับแบบสำรวจนี้จะได้รับการแก้ไขโดยใช้ผลลัพธ์ใหม่",
                "COMMA_SEPARATED_LIST": "รายการที่คั่นด้วยเครื่องหมายจุลภาค",
                "COMPACTNESS": "แบบอักษรและระยะห่าง",
                "COMPACTNESS_INFO": "การกำหนดค่านี้มีผลต่อช่องว่างภายในตาราง ขนาดแบบอักษร และขนาดแท่งในแผนภูมิ นอกจากนี้ยังนำไปใช้กับการอิมปอร์ตส่วนใหญ่ด้วย",
                "CONFIRM": "ตกลง",
                "CONFIRM_DELETE": "ยืนยันการลบ",
                "CONFIRM_DELETE_PAGE": "คุณแน่ใจหรือไม่ว่าต้องการลบหน้านี้?",
                "CONTINUE": "ดำเนินการต่อ",
                "CONTINUE_EDITING": "ดำเนินการแก้ไขต่อ",
                "COPY": "คัดลอก",
                "COPY_OF_REPORT_NAME": "สำเนาของ '{{nameOfCurrentReport}}'",
                "COPY_REPORT": "คัดลอกรายงาน",
                "COPY_REPORT_ELLIPSIS": "คัดลอกรายงาน...",
                "COPY_TO_NEW_REPORT": "คัดลอกไปยังรายงานใหม่...",
                "CREATE": "สร้าง",
                "CREATED": "สร้างแล้ว",
                "CREATE_CUSTOM_PAGE": "สร้างหน้าที่ปรับแต่งได้",
                "CREATE_NEW_REPORT": "สร้างรายงานใหม่",
                "CREATE_NEW_REPORT_ELLIPSIS": "สร้างรายงานใหม่...",
                "CSV_FILE": "ไฟล์ CSV",
                "CUSTOM_PAGES": "หน้าที่ปรับแต่งได้",
                "DATE": "วันที่",
                "DEFAULT_PALETTE": "ชุดแบบสีตั้งต้น",
                "DEFAULT_REPORT": "รายงานตั้งต้น",
                "DEFAULT_VISUALIZATIONS": "การแสดงผลตั้งต้น",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "รายการเหล่านี้คือประเภทการแสดงผลตั้งต้นที่ใช้ในการสร้างรายงานผลลัพธ์ตั้งต้น การอัพเดทและการนำการกำหนดค่าเหล่านี้ไปใช้จะสร้างรายงานปัจจุบันของคุณใหม่ด้วยการกำหนดค่าตั้งต้นใหม่ คุณจะมีตัวเลือกในการสำรองข้อมูลรายงานปัจจุบันของคุณ",
                "DEFAULT_VISUALIZATIONS_NOTE": "หมายเหตุ: ไม่ใช่ทุกประเภทการแสดงผลที่สามารถใช้ได้กับคำถามทุกประเภท การแสดงผลที่ไม่ใช่ค่าตั้งต้นบางอย่างอาจถูกแทนที่โดยอัตโนมัติ",
                "DEFAULT_VISUALS_DISCLAIMER": "Qualtrics จะอัพเดทรายงานนี้ด้วยการกำหนดค่าการแสดงผลตั้งต้นใหม่",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "การอัพเดทนี้จะส่งผลต่อการแสดงผล {{amountOfWidgetsAffected}} รายการในรายงานนี้",
                "DEFAULT_VISUAL_EDIT_DETECTED": "ตรวจพบการแก้ไขการแสดงผลตั้งต้น",
                "DELETE_BUTTON": "ลบ",
                "DELETE_DISABLED_EXPLANATION": "ไม่อนุญาตให้ลบรายงานที่สร้างขึ้นในอินเตอร์เฟสการรายงานก่อนหน้านี้จนกว่าองค์กรของคุณจะทำการโอนย้ายแบบเต็มไปยังแพลตฟอร์ม Qualtrics XM",
                "DELETE_PAGE": "ลบหน้า",
                "DELETE_PAGE_ELLIPSIS": "ลบหน้า...",
                "DELETE_REPORT": "ลบรายงาน",
                "DELETE_REPORT_ELLIPSIS": "ลบรายงาน...",
                "DELETE_WIDGET_QUESTION": "ลบหรือไม่?",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "ฟิลด์นี้เข้ารหัสลับไว้และไม่สามารถใช้ในการจัดเรียงได้",
                "DISCARD_EDITS": "ละทิ้งการแก้ไข",
                "DISTRIBUTION_PAUSED": "หยุดการกระจายรายงานชั่วคราว",
                "DONE_BUTTON": "เสร็จสิ้น",
                "DONE_EDITING": "การแก้ไขเสร็จสิ้น",
                "DOWNLOAD": "ดาวน์โหลด",
                "DOWNLOAD_AS_CSV": "ดาวน์โหลดเป็น CSV",
                "DOWNLOAD_AS_PDF": "ดาวน์โหลดเป็น PDF",
                "DOWNLOAD_FAILED": "ดาวน์โหลดล้มเหลว",
                "DOWNLOAD_PREVIOUS_EXPORTS": "ดาวน์โหลดการเอ็กซ์ปอร์ตก่อนหน้า...",
                "DO_YOU_WISH_TO_DELETE": "คุณต้องการลบ:",
                "DUPLICATE_PAGE": "ชีทซ้ำ",
                "EDIT_REPORT": "แก้ไขรายงาน",
                "EDIT_REPORT_ELLIPSIS": "แก้ไขรายงาน...",
                "EDIT_VISUALIZATION": "แก้ไขการแสดงผล",
                "EMAIL_ADDRESS": "อีเมล์แอดเดรส",
                "EMAIL_SENT": "ส่งอีเมล์แล้ว...",
                "END_OF_REPORT": "สิ้นสุดการรายงาน",
                "ENTER_NAME": "ป้อนชื่อ",
                "ERROR_COPYING": "มีข้อผิดพลาดในการคัดลอกรายงาน",
                "ERROR_DELETING": "มีข้อผิดพลาดในการลบรายงาน",
                "ERROR_DELETING_EXPORT": "มีข้อผิดพลาดในการลบการเอ็กซ์ปอร์ต",
                "ERROR_HEADING": "ข้อผิดพลาด",
                "ERROR_PUBLISHING": "มีข้อผิดพลาดในการเก็บบันทึกการกำหนดค่า",
                "ERROR_RENAMING": "มีข้อผิดพลาดในการเปลี่ยนชื่อรายงาน",
                "ERROR_REQUESTING_EXPORT": "มีข้อผิดพลาดในการขอการเอ็กซ์ปอร์ต",
                "ERROR_SAVING_GLOBAL_OPTIONS": "มีข้อผิดพลาดในการเก็บบันทึกตัวเลือกการแสดงผลส่วนกลาง",
                "ERROR_SEND_TEST_EMAIL": "มีข้อผิดพลาดในการส่งอีเมล์ทดสอบ",
                "EVERY_FRIDAY": "ทุกวันศุกร์",
                "EVERY_MONDAY": "ทุกวันจันทร์",
                "EVERY_MONTH": "ทุกวันที่ระบุของเดือน",
                "EVERY_SATURDAY": "ทุกวันเสาร์",
                "EVERY_SUNDAY": "ทุกวันอาทิตย์",
                "EVERY_THURSDAY": "ทุกวันพฤหัสบดี",
                "EVERY_TUESDAY": "ทุกวันอังคาร",
                "EVERY_WEDNESDAY": "ทุกวันพุธ",
                "EVERY_WEEK": "ทุกวันที่ระบุของสัปดาห์",
                "EXAMPLE_GROUP_NUM": "กลุ่ม {{num}}",
                "EXAMPLE_SERIES_NUM": "ชุดข้อมูล {{num}}",
                "EXPORT": "เอ็กซ์ปอร์ต",
                "EXPORT_CSV": "CSV (คั่นด้วยเครื่องหมายจุลภาค)",
                "EXPORT_EXCEL_SPREADSHEET": "สเปรดชีท Excel",
                "EXPORT_IMAGE": "เอ็กซ์ปอร์ตรูปภาพ",
                "EXPORT_PAGES": "เอ็กซ์ปอร์ตหน้า",
                "EXPORT_PDF": "เอกสาร PDF",
                "EXPORT_PPT_SLIDES": "สไลด์ PowerPoint",
                "EXPORT_RAW_DATA": "เอ็กซ์ปอร์ตข้อมูลดิบ",
                "EXPORT_REPORT": "เอ็กซ์ปอร์ตรายงาน",
                "EXPORT_VISUALIZATION": "เอ็กซ์ปอร์ตการแสดงผล",
                "EXPORT_WORD_DOC": "เอกสาร Word",
                "FAILED_SAVE_TXT": "ไม่สามารถเก็บบันทึก",
                "FILTERED": "ฟิลเตอร์แล้ว",
                "FIRST_PAGE": "หน้าแรก",
                "FIRST_WEEKDAY": "วันทำงานแรกของเดือน",
                "FROM": "จาก",
                "FROM_EMAIL": "อีเมล์ผู้ส่ง",
                "FROM_NAME": "ชื่อผู้ส่ง",
                "GAUGE_CHART": "แผนภูมิตัววัด",
                "GAUGE_CHART_DESC": "แผนภูมิที่คล้ายเครื่องมือวัดในตัววัดสำหรับเปรียบเทียบค่าปัจจุบันกับค่าเป้าหมายหรือชุดค่าจำกัด",
                "GENERATING_FILE": "กำลังสร้างไฟล์...",
                "GENERATING_IMAGE": "กำลังสร้างรูปภาพ...",
                "GENERATING_PDF": "กำลังสร้าง PDF...",
                "GENERIC_ERROR": "มีข้อผิดพลาดที่ทำให้เราไม่สามารถโหลดโครงการที่คุณขอได้",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "ตัวเลือกส่วนกลาง...",
                "GLOBAL_METRIC": "ตัววัดตั้งต้น",
                "GLOBAL_MODAL_PAGE_TITLE": "ตัวอย่างการแสดงผลโดยใช้ตัวเลือกส่วนกลางสำหรับส่วนผลลัพธ์ของ Qualtrics Research Suite",
                "GLOBAL_MODAL_WIDGET_TITLE": "ชื่อการแสดงผล",
                "GLOBAL_OPTIONS": "ตัวเลือกส่วนกลาง",
                "GLOBAL_PRECISION": "ตำแหน่งทศนิยมตั้งต้น",
                "GLOBAL_SETTINGS_APPLY": "นำการกำหนดค่าตั้งต้นของฉันไปใช้",
                "GLOBAL_SETTINGS_SAVE": "เก็บบันทึกเป็นการกำหนดค่าตั้งต้นของฉัน",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "นำค่าตั้งต้นของ Qualtrics ไปใช้",
                "GROUP": "จัดกลุ่ม",
                "HEAT_MAP_CHART": "แผนภูมิแผนที่ความร้อน",
                "HEAT_MAP_CHART_DESC": "การแสดงผลในรูปแบบ \"ความร้อน\" ที่คลัสเตอร์ซึ่งใช้สำหรับการแม็ปการกระจายอินพุทผู้ใช้ (เช่น การคลิก) ไปยังรูปภาพต้นฉบับ",
                "HIDDEN": "ซ่อนอยู่",
                "HIDDEN_PAGE": "หน้านี้จะไม่ปรากฏในรายงานสาธารณะและจะถูกยกเลิกการเลือกตามค่าตั้งต้นในการเอ็กซ์ปอร์ตรายงาน",
                "HIDE": "ซ่อน",
                "HIDE_ALL_PAGES": "ซ่อนหน้าทั้งหมด",
                "HIDE_PAGE": "ซ่อนหน้า",
                "IMAGE_FILE": "ไฟล์รูปภาพ",
                "INVALID_BRAND_DOMAIN": "โดเมนที่คุณป้อนไม่อยู่ในรายชื่อโดเมนอีเมล์ที่ได้รับอนุมัติของแบรนด์ของคุณ กรุณาติดต่อผู้ดูแลแบรนด์ของคุณเพื่อแก้ไข",
                "INVALID_SPF_RECORD": "โดเมนที่คุณป้อนไม่อนุมัติให้ Qualtrics ทำการส่งจากโดเมนดังกล่าว ซึ่งจะส่งผลต่อความสามารถในการส่ง กรุณาใช้โดเมนอื่นหรือติดต่อ Qualtrics เกี่ยวกับการแก้ไขปัญหานี้",
                "ISSUE_SAVING_REPORTS": "รายงานอย่างน้อยหนึ่งรายการพบปัญหาในการเก็บบันทึก กรุณาลองอีกครั้ง",
                "ISSUE_SENDING_TEST": "มีข้อผิดพลาดในการส่งอีเมล์ทดสอบ กรุณาลองอีกครั้ง",
                "LARGE_SURVEY": "ผลลัพธ์จะไม่ถูกแสดงเนื่องจากแบบสำรวจมีขนาดใหญ่เกินไป",
                "LAST_DAY": "วันสุดท้ายของเดือน",
                "LAST_MODIFIED_COLON_WITH_DATE": "ปรับเปลี่ยนครั้งล่าสุด: %1",
                "LAST_PAGE": "หน้าสุดท้าย",
                "LAST_WEEKDAY": "วันทำงานสุดท้ายของเดือน",
                "LATER": "ในภายหลัง",
                "LEARN_MORE": "เรียนรู้เพิ่มเติม",
                "LINE_CHART": "แผนภูมิเส้น",
                "LINE_CHART_DESC": "แผนภูมิเส้นสองแกนที่ใช้กันทั่วไปเมื่อสร้างกราฟเทียบกับเวลาบนแกน X",
                "LOG_OUT_WARNING": "คลิกที่ใดก็ได้ภายใน {{countdown}} วินาทีเพื่อยังเข้าสู่ระบบอยู่",
                "MESSAGE": "ข้อความ",
                "MONTHLY": "รายเดือน",
                "MOVE_DOWN": "ย้ายการแสดงผลลง",
                "MOVE_PAGE_TO_BOTTOM": "ย้ายไปด้านล่าง",
                "MOVE_PAGE_TO_TOP": "ย้ายไปด้านบน",
                "MOVE_UP": "ย้ายการแสดงผลขึ้น",
                "MY_SURVEYS": "โครงการของฉัน",
                "NAME": "ชื่อ",
                "NEW_CUSTOM_PAGE_NAME": "หน้าใหม่ที่ปรับแต่งได้",
                "NEW_REPORT": "รายงานใหม่",
                "NEXT_PAGE": "หน้าถัดไป",
                "NEXT_RUN": "การดำเนินการถัดไป",
                "NO_EXPORTS": "ยังไม่มีการขอการเอ็กซ์ปอร์ตสำหรับรายงานนี้",
                "NO_ITEMS_TO_DISPLAY": "ไม่มีรายการที่จะแสดง",
                "NO_MATCHING_CUSTOM_PAGES": "ไม่มีหน้าที่ปรับแต่งได้ที่ตรงกัน",
                "NO_MATCHING_PAGES": "ไม่พบหน้าสำหรับการค้นหา",
                "NO_MATCHING_REPORTS": "ไม่มีรายงานที่ตรงกัน",
                "NO_PROJECT": "กรุณาระบุโครงการเพื่อดำเนินการต่อ",
                "NO_PROJECTS_TO_MIGRATE": "ไม่มีโครงการที่จะอัพเดท",
                "NO_QUESTIONS": "ไม่มีคำถามที่ตรงกัน",
                "NO_RESULTS_YET": "ยังไม่มีผลลัพธ์ที่จะแสดง กรุณากระจายแบบสำรวจของคุณเพื่อรวบรวมการตอบกลับ",
                "OFF": "ปิด",
                "ON": "เปิด",
                "PAGES_SELECTED": "หน้าที่เลือก",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "การเลือกนี้จะทำให้รายงานมี {{currentSelectedPageCount}} หน้า ซึ่งสูงกว่าค่าสูงสุดที่อนุญาต {{reportSizeLimit}} กรุณาเลือกช่วงที่มีขนาดเล็กลง",
                "PAGES_SELECTION_INVALID_RANGE": "กรุณาเลือกช่วงที่ถูกต้อง",
                "PAGE_OPTIONS": "ตัวเลือกหน้า",
                "PDF_ROW_TRUNCATION_MESSAGE": "มีแถวสำหรับการเอ็กซ์ปอร์ต PDF มากเกินไป ลองเอ็กซ์ปอร์ตเป็น Word หรือ CSV",
                "PERCENTAGE_METRIC": "เปอร์เซ็นต์",
                "PIE_CHART": "แผนภูมิวงกลม",
                "PIE_CHART_DESC": "การแยกย่อยค่าแบบวงกลมสำหรับจุดข้อมูลที่กำหนด มีประโยชน์สำหรับการวัดสัดส่วนสัมพัทธ์ของค่าที่เลือก",
                "PREVIEW": "แสดงตัวอย่าง",
                "PREVIOUS_PAGE": "หน้าก่อน",
                "PRINT_PAGE": "พิมพ์หน้า",
                "PUBLIC_LINK": "ลิงก์สาธารณะ",
                "PUBLIC_REPORT_AVAILABLE": "มีรายงานสาธารณะ",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "รหัสการเข้าถึง",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "รหัสการเข้าถึงไม่ถูกต้อง กรุณาลองอีกครั้ง",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "ส่ง",
                "PUBLIC_RESULTS_LOGIN_TITLE": "เข้าสู่ระบบรายงานสาธารณะ | ซอฟต์แวร์แบบสำรวจของ Qualtrics",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "ไม่พบรายงานสาธารณะ กรุณาติดต่อเจ้าของรายงานนี้และขอลิงก์ที่ถูกต้อง",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "ไม่พบรายงานสาธารณะ",
                "PUBLIC_RESULTS_NOT_UPDATED": "ลิงก์รายงานสาธารณะและอีเมล์รายงานตามกำหนดการจะไม่ใช้แพลตฟอร์ม Qualtrics XM จนกว่าคุณจะอัพเดท",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "เซสชันหมดอายุ กรุณาเข้าสู่ระบบอีกครั้งเพื่อแสดงตัวอย่างรายงานผลลัพธ์สาธารณะต่อ",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "เซสชันหมดอายุ",
                "PUBLIC_RESULTS_TITLE": "รายงานสาธารณะ",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "คุณไม่มีสิทธิดูหน้านี้ กรุณาติดต่อเจ้าของรายงานนี้และขอให้เจ้าของทำรายงานให้เป็นสาธารณะ",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "รายงานสาธารณะไม่ได้รับอนุญาต",
                "PUBLISHED_LINK_GENERATING_LINK": "กำลังสร้างลิงก์...",
                "PUBLISHED_REPORT_FOUND_HERE": "ทุกคนสามารถดูรายงานนี้ได้ที่ลิงก์ต่อไปนี้:",
                "PUBLISH_REPORT": "จัดการรายงานสาธารณะ",
                "PUBLISH_REPORT_ELLIPSIS": "จัดการรายงานสาธารณะ...",
                "QUESTION": "คำถาม",
                "RANK": "ลำดับ",
                "REMOVE_WIDGET": "ย้ายการแสดงผลออก",
                "RENAME_PAGE": "เปลี่ยนชื่อหน้า",
                "RENAME_REPORT": "เปลี่ยนชื่อรายงาน",
                "RENAME_REPORT_ELLIPSIS": "เปลี่ยนชื่อรายงาน...",
                "REPLY_TO_EMAIL": "อีเมล์ตอบกลับ",
                "REPORT_COLON": "รายงาน:",
                "REPORT_SETTINGS": "การกำหนดค่ารายงาน",
                "REPORT_SETTINGS_ELLIPSIS": "การกำหนดค่ารายงาน...",
                "RESPONSE_COUNTS": "จำนวนการตอบกลับ",
                "RESULTS_DASHBOARDS_BANNER": "และลองใช้เวอร์ชันที่ปรับปรุงขึ้นมาใหม่ของผลลัพธ์แบบสำรวจ ซึ่งมีการแสดงผลข้อมูลและ UI ที่ทันสมัยและเข้าถึงได้ ฟีเจอร์การสำรวจและการวิเคราะห์ใหม่ และอื่นๆ",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "บันทึกการเผยแพร่",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "ดูรายการล่าสุด",
                "RESULTS_OPTIONS": "ตัวเลือกรายงาน",
                "RESULTS_TITLE": "รายงาน",
                "RESUME_DISTRIBUTION": "ดำเนินการกระจายต่อ",
                "REVERT": "แปลงกลับ",
                "RICH_TEXT_LIMIT_REACHED": "ความยาวของเนื้อหาถึงขีดจำกัดแล้ว!",
                "SAVE": "เก็บบันทึก",
                "SAVE_AND_CLOSE": "เก็บบันทึกและปิด",
                "SAVE_AS_CSV": "เก็บบันทึกการแสดงผลเป็น CSV",
                "SAVE_AS_IMAGE": "เก็บบันทึกการแสดงผลเป็นรูปภาพ",
                "SAVE_CONFIRMATION": "เก็บบันทึกการยืนยัน",
                "SAVE_PAGE_AS_ELLIPSIS": "เอ็กซ์ปอร์ตหน้าเป็น...",
                "SAVE_SETTINGS": "เก็บบันทึกการกำหนดค่า",
                "SCHEDULE_REPORT_EMAIL": "จัดกำหนดการอีเมล์รายงาน",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "จัดกำหนดการอีเมล์รายงาน...",
                "SEARCH_ELLIPSIS": "ค้นหา…",
                "SEARCH_PAGES": "ค้นหาคำถาม",
                "SEARCH_PAGES_ELLIPSIS": "ค้นหาหน้า...",
                "SEARCH_REPORTS_ELLIPSIS": "ค้นหารายงาน...",
                "SELECTED": "เลือกแล้ว:",
                "SELECT_ALL": "เลือกทั้งหมด",
                "SELECT_A_FIELD": "เลือกฟิลด์",
                "SELECT_A_WIDGET": "เลือกการแสดงผล",
                "SELECT_PAGES": "เลือกหน้า",
                "SELECT_PAGES_ELLIPSIS": "เลือกหน้า...",
                "SEND": "ส่ง",
                "SEND_TEST_EMAIL": "ส่งอีเมล์ทดสอบ",
                "SETTING_DEFAULT": "ค่าตั้งต้น",
                "SETTING_HIGH": "สูง",
                "SETTING_LARGE": "ใหญ่",
                "SETTING_LOW": "ต่ำ",
                "SETTING_NORMAL": "ปกติ",
                "SETTING_SMALL": "เล็ก",
                "SHARE_REPORT": "แชร์รายงาน",
                "SHOW_ALL_PAGES": "แสดงหน้าทั้งหมด",
                "SHOW_FULL_QTEXT": "แสดงข้อความคำถามแบบเต็มในชื่อเรื่องของหน้า",
                "SIMPLE_TABLE": "ตารางแบบง่าย",
                "SIMPLE_TABLE_DESC": "ตารางแบบยืดหยุ่นที่สามารถแสดงค่าหลายค่าเป็นแถวหรือคอลัมน์",
                "SIZE": "ขนาด",
                "SPLINE_CHART": "แผนภูมิเส้นโค้ง",
                "SPLINE_CHART_DESC": "แผนภูมิเส้นโค้งมนสองแกนที่ใช้กันทั่วไปเมื่อสร้างกราฟเทียบกับเวลาบนแกน x",
                "STATISTICS_TABLE": "ตารางสถิติ",
                "SUBJECT": "หัวเรื่อง",
                "SURVEY_ANALYSIS": "การวิเคราะห์แบบสำรวจ",
                "SURVEY_SUMMARY": "ข้อมูลสรุปแบบสำรวจ",
                "TABLE": "คำอธิบายสำหรับตาราง",
                "TIME": "เวลา",
                "TO": "ถึง",
                "TOTAL": "ยอดรวม",
                "TRANSPOSE_STATS_TABLES": "สลับเปลี่ยนตารางสถิติ",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "สลับเปลี่ยนการแบ่งตารางสถิติ",
                "TRUNCATE_PAGE_TITLES": "ตัดทอนข้อความคำถามในชื่อเรื่องของหน้า",
                "TRY_IT_NOW": "ลองเลย",
                "TYPE": "ประเภท",
                "UNABLE_TO_CHECK_SPF": "ไม่สามารถตรวจสอบเรคคอร์ด SPF กรุณาลองอีกครั้ง",
                "UNAUTHORIZED": "คุณไม่ได้รับอนุญาตให้ดูรายงานนี้ กรุณาติดต่อเจ้าของเพื่อเข้าถึง",
                "UNHIDE_PAGE": "ยกเลิกการซ่อนหน้า",
                "UPDATE": "อัพเดท",
                "UPDATED_SUCCESSFULLY": "อัพเดทได้สำเร็จ!",
                "UPDATE_ALL_IN_THIS_PROJECT": "อัพเดททั้งหมดในโครงการนี้",
                "UPDATE_ALL_PROJECTS": "อัพเดทโครงการทั้งหมด",
                "UPDATE_NOW": "อัพเดทตอนนี้",
                "UPDATE_REPORTS": "อัพเดทรายงาน...",
                "UPDATE_REPORT_ELEMENTS": "อัพเดทลิงก์รายงานสาธารณะและอีเมล์รายงานตามกำหนดการ",
                "UPGRADE_MY_ACCOUNT": "อัพเกรดบัญชีของฉัน",
                "USE_EXPORT_TAGS": "รวมเลขที่คำถาม",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "ใช้ยอดรวมคอลัมน์ในตารางแบบง่าย",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "ใช้จำนวนผู้ตอบในตารางแบบง่าย",
                "USE_WEIGHTED_METRICS": "ใช้ตัววัดแบบถ่วงน้ำหนัก",
                "VIEW": "ดู",
                "WEEKLY": "รายสัปดาห์",
                "WELCOME_TO_NEW_RESULTS": "ยินดีต้อนรับสู่การรายงานบนแพลตฟอร์ม Qualtrics XM",
                "WHEN": "เมื่อ",
                "WIDGET_LOADING": "กำลังโหลด...",
                "WIDGET_OPTIONS_ERR": "ไม่สามารถโหลดตัวเลือกการแสดงผล",
                "WIDGET_TYPE": "การแสดงผล",
                "WORD_CLOUD": "ภาพกลุ่มคำ",
                "WORD_CLOUD_DESC": "การแสดงผลความถี่ของคำแบบถ่วงน้ำหนักในข้อมูลข้อความพร้อมตัวเลือกการให้รหัสสีเพิ่มเติม"
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "กรุณาจำไว้ว่ามีทรัพยากรภายในองค์กรของคุณที่ช่วยในการตีความข้อเสนอแนะ เช่น ฝ่ายทรัพยากรบุคคล ผู้จัดการของคุณ และ/หรือผู้สอนงาน",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "คุณสามารถอ่านข้อเสนอแนะของคุณไปพร้อมกับจิบกาแฟ",
                "ABOUT_YOUR_REPORT_HEADER": "เกี่ยวกับรายงานของคุณ",
                "ABOUT_YOUR_REPORT_LINE1": "ยินดีต้อนรับสู่รายงานข้อเสนอแนะ 360 นี่เป็นโอกาสดีที่จะเติบโตและพัฒนาตัวเองในฐานะมืออาชีพ สำหรับการเตรียมตัวให้พร้อมรับความสำเร็จเมื่อได้รับผลลัพธ์ต่างๆ คุณควรให้เวลากับตัวเองในการอ่านข้อเสนอแนะ ตอนแรกอาจเป็นเรื่องยากที่จะรับฟัง แต่พึงระลึกไว้ว่าจุดประสงค์ของข้อเสนอแนะนี้คือเพื่อเร่งการเติบโตและการพัฒนาของคุณ",
                "ABOUT_YOUR_REPORT_LINE2": "เมื่อคุณอ่านรายงาน ควรคำนึงถึงสิ่งต่อไปนี้",
                "ADD_CONDITIONAL_TEXT": "เพิ่มข้อความแบบมีเงื่อนไข",
                "ADD_CUSTOM_PALETTE": "เพิ่มชุดแบบสีที่ปรับแต่งได้",
                "ADD_DATA_SOURCE": "เพิ่มแหล่งข้อมูล",
                "ADD_FOLLOWING": "เพิ่มสิ่งต่อไปนี้",
                "ADD_LABEL": "เพิ่มป้ายชื่อ",
                "ADVANCED_FILTER": "ฟิลเตอร์ขั้นสูง",
                "AGREEMENT_CHART": "แผนภูมิข้อตกลง",
                "AGREEMENT_CHART_FOOTER": "แผนภูมิข้อตกลงบ่งชี้ความคล้ายคลึงกันของคะแนน แต่ละจุดแสดงให้เห็นว่าแต่ละคนให้คะแนนคุณสำหรับแต่ละรายการอย่างไร ขนาดของจุดแสดงจำนวนผู้ให้คะแนนที่ให้คะแนนนั้นๆ แก่คุณ",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "การตอบกลับ",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "การตอบกลับ",
                "AGREEMENT_CHART_LEGEND_TITLE": "บุคคลอื่นให้คะแนนคุณอย่างไร",
                "ALL": "ทั้งหมด",
                "AND_IF": "และถ้า",
                "ANGLED": "ทำมุม",
                "AREA": "พื้นที่",
                "AUTO": "อัตโนมัติ",
                "AVERAGE": "เฉลี่ย",
                "AXIS_VALUES": "ค่าแกน",
                "BAR": "แท่ง",
                "BASE_WORD_COLOR": "สีคำพื้นฐาน",
                "BLUR": "เบลอ",
                "BOTTOM_BOX": "กลุ่มล่าง",
                "BREAKOUT_HEADERS": "ส่วนหัวการแบ่ง",
                "CANCEL": "ยกเลิก",
                "CATEGORICAL": "ตามหมวด",
                "CATEGORY": "หมวด",
                "CATEGORY_NAME": "ชื่อหมวด",
                "CHANGE_CATEGORIES_ORDER": "เปลี่ยนแปลงลำดับหมวด",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "เปลี่ยนแปลงลำดับหมวดการให้คะแนน",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "เปลี่ยนแปลงลำดับที่ปรากฏในการแสดงผลโดยคลิกที่ด้านซ้ายขององค์ประกอบหมวดการให้คะแนนแล้วลากไปยังตำแหน่งที่ต้องการ",
                "CHANGE_QUESTIONS_ORDER": "เปลี่ยนแปลงลำดับคำถาม",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "เปลี่ยนแปลงลำดับคำถาม",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "เปลี่ยนแปลงลำดับที่ปรากฏในการแสดงผลโดยคลิกที่ด้านซ้ายขององค์ประกอบคำถามแล้วลากไปยังตำแหน่งที่ต้องการ",
                "CHARTS": "แผนภูมิ",
                "CHART_TYPE": "ประเภทแผนภูมิ",
                "CHOICE_COUNT": "จำนวนตัวเลือก",
                "CHOICE_TOTALS": "ตัวเลือกทั้งหมด",
                "CLEAR": "ล้างข้อมูล",
                "CLOSE": "ปิด",
                "COLOR_PALETTE": "ชุดแบบสี",
                "COLUMN_NAMES": "ชื่อคอลัมน์",
                "COLUMN_TOTALS": "ยอดรวมคอลัมน์",
                "COMPARED_FILTER_GROUP": "กลุ่มฟิลเตอร์ที่เปรียบเทียบ",
                "COMPARED_FILTER_GROUPS": "กลุ่มฟิลเตอร์ที่เปรียบเทียบ",
                "COMPARE_WITH": "เปรียบเทียบกับ",
                "COMPETITION_RANKING": "ใช้การจัดอันดับคู่แข่ง",
                "COMPETITION_RANKING_TOOLTIP": "ในกรณีที่เสมอกัน คะแนนที่เท่ากันทั้งหมดจะถูกจัดอยู่ในอันดับเดียวกัน อย่างไรก็ตาม รายการถัดไปในลำดับจะมีอันดับเท่ากับจำนวนรายการทั้งหมดที่อยู่ในอันดับที่สูงกว่าในตาราง บวกหนึ่งรายการ",
                "COMPLETED_RESPONSES": "การตอบกลับที่เสร็จสมบูรณ์",
                "CONDITIONAL_TEXT": "ข้อความแบบมีเงื่อนไข",
                "COUNT": "จำนวน",
                "CREATE": "สร้าง",
                "CUSTOM_PALETTE": "ชุดแบบสีที่ปรับแต่งได้",
                "DATA_SOURCE_TYPE": "ประเภทแหล่งข้อมูล",
                "DATA_SOURCE_TYPE_CATEGORY": "หมวดการให้คะแนน",
                "DATA_SOURCE_TYPE_QUESTION": "คำถาม",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "คำถาม",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "รายการที่จัดอันดับได้",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "หมวดการให้คะแนน",
                "DEFAULT": "ค่าตั้งต้น",
                "DEFAULT_TEXT": "ข้อความตั้งต้น",
                "DELETE": "ลบ",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "ทำความเข้าใจกับข้อเสนอแนะของคุณที่มาจากเพื่อนร่วมงาน ผู้ใต้บังคับบัญชา หัวหน้า ฯลฯ",
                "DIFFERENT_EVALUATORS_HEADER": "ผู้ประเมินรายอื่น",
                "DIRECT_REPORTS": "ผู้ใต้บังคับบัญชา",
                "DISABLED": "ปิดใช้งานแล้ว",
                "DISPLAY_OPTIONS": "ตัวเลือกการแสดง",
                "DISPLAY_THRESHOLD_TEXTS": "แสดงข้อความตามช่องว่างของกลุ่มต่อไปนี้",
                "DIVERGENT": "ความแตกต่าง",
                "DONE": "เสร็จสิ้น",
                "DONT_HEADER": "สิ่งที่ไม่ควรทำ:",
                "DONT_LINE1": "พยายามหาว่าใครพูดอะไร",
                "DONT_LINE2": "โฟกัสที่คะแนน/ข้อคิดเห็นเชิงบวกหรือลบ",
                "DONT_LINE3": "สร้างแผนการพัฒนาให้กับทุกรายการ",
                "DONT_LINE4": "รู้สึกท้อถอยเมื่อคุณมีสิ่งที่ควรปรับปรุง",
                "DONUT": "โดนัท",
                "DOWNLOAD_CSV": "ดาวน์โหลด CSV ดั้งเดิม",
                "DOWNLOAD_ZIP": "ดาวน์โหลดไฟล์ทั้งหมด",
                "DO_HEADER": "สิ่งที่ควรทำ:",
                "DO_LINE1": "ดูข้อเสนอแนะแบบองค์รวม",
                "DO_LINE2": "ระบุธีมในจุดแข็งและสิ่งที่ควรปรับปรุง",
                "DO_LINE3": "จัดลำดับความสำคัญของขอบเขตการโฟกัสสองสามรายการเพื่อเพิ่มในแผนการพัฒนาของคุณ",
                "DO_LINE4": "ทำความเข้าใจว่าทุกคนมีสิ่งที่ควรปรับปรุง",
                "DROPOFF": "การลดลง",
                "DUPLICATE": "ซ้ำ",
                "EDIT_CONDITIONAL_TEXT": "แก้ไขข้อความแบบมีเงื่อนไข",
                "EDIT_CUSTOM_PALETTE": "แก้ไขชุดแบบสีที่ปรับแต่งได้",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "หรือแสดงข้อความต่อไปนี้",
                "ENABLED": "เปิดใช้งานแล้ว",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "เปิดใช้งานการจัดลำดับตามลอจิกการแสดงหมวดผู้ให้คะแนน",
                "ENABLE_ORDERING_FOR": "เปิดใช้งานการจัดลำดับสำหรับ",
                "EQUAL_TO": "เท่ากับ",
                "FIELD": "ฟิลด์",
                "FILTER_NAMES": "ชื่อฟิลเตอร์",
                "FOLLOWING_PARENTHESES": "(ต่อไปนี้)",
                "FOOTER": "ส่วนท้าย",
                "GAP": "ช่องว่าง",
                "GAP_CHART": "แผนภูมิช่องว่าง",
                "GAP_CHART_DESCRIPTION": "แผนภูมิช่องว่างแสดงส่วนต่างของคะแนนระหว่างกลุ่มผู้ให้คะแนนสองกลุ่ม ตัวอย่างเช่น ในกรณีของการให้คะแนนตนเองเทียบกับบุคคลอื่นให้คะแนนคุณ ส่วนต่างเชิงบวก (+) หมายถึงบุคคลอื่นให้คะแนนคุณสูงกว่าคะแนนที่คุณให้ตัวเอง ส่วนต่างเชิงลบ (-) หมายถึงบุคคลอื่นให้คะแนนคุณต่ำกว่าที่คุณให้ตัวเอง",
                "GAP_CHART_FOOTER": "แผนภูมิช่องว่างบ่งชี้ส่วนต่าง +/- ระหว่างผู้ให้คะแนนสองกลุ่ม",
                "GAP_TABLE_DESCRIPTION": "'จุดแข็งที่ซ่อนอยู่' แสดงให้เห็นว่าบุคคลอื่นให้คะแนนคุณสูงกว่าที่คุณให้คะแนนตัวเอง 'ส่วนที่สามารถปรับปรุงได้' แสดงให้เห็นว่าบุคคลอื่นให้คะแนนคุณต่ำกว่าที่คุณให้คะแนนตัวเอง ทั้งสองส่วนถูกจัดลำดับจากช่องว่างที่ใหญ่ที่สุดไปหาเล็กที่สุด",
                "GAP_TABLE_FOOTER": "คอลัมน์แรกของคะแนนบ่งชี้ว่าคุณให้คะแนนตัวเองอย่างไร คอลัมน์ที่สองบ่งชี้คะแนนเฉลี่ยของผู้อื่น คอลัมน์ที่สามบ่งชี้ความแตกต่างระหว่างคะแนนที่คุณให้ตัวเองกับคะแนนที่คนอื่นให้คุณ",
                "GAP_TABLE_TITLE": "จุดแข็งที่ซ่อนอยู่/ส่วนที่สามารถปรับปรุงได้",
                "GREATER_OR_EQUAL": "มากกว่าหรือเท่ากับ",
                "GREATER_THAN": "มากกว่า",
                "GROUP": "กลุ่ม",
                "GROUPED_FOR_ANONYMITY": "จัดกลุ่มสำหรับคำตอบแบบไม่ระบุชื่อ",
                "HEADER_NAMES": "ชื่อส่วนหัว",
                "HIGHEST_SCORES": "คะแนนสูงสุด",
                "HIGHLIGHT_THRESHOLD": "ค่าจำกัดในการไฮไลต์ช่องว่าง",
                "HIGHLOW_TABLE": "คะแนนสูงและต่ำ",
                "HIGHLOW_TABLE_FOOTER": "ในส่วนนี้แสดงพฤติกรรมที่ได้รับคะแนนสูงสุดและต่ำสุดห้าอันดับแรก (จากทุกพฤติกรรม) จากค่าเฉลี่ยของหมวดผู้ให้คะแนนที่เกี่ยวข้อง เมื่อต้องการใช้ประโยชน์จากหน้านี้ให้ได้มากที่สุด ควรมองหาแนวโน้มที่โดดเด่นออกมา ตัวอย่างเช่น ถ้าพฤติกรรมส่วนใหญ่ที่ได้คะแนนต่ำสุดเน้นไปที่หมวดหนึ่งหรือสองหมวด นั่นอาจเป็นส่วนที่ต้องปรับปรุง พฤติกรรมที่ได้คะแนนสูงสุดอาจระบุถึงจุดแข็งซึ่งอาจมีอิทธิพลต่อส่วนอื่นๆ",
                "HIGH_LOW_TABLE_DESCRIPTION": "แผนภูมิสูง/ต่ำจะแสดงรายการตามเรื่องที่บุคคลอื่นให้คะแนนคุณสูงสุดและต่ำสุด",
                "HORIZONTAL": "แนวนอน",
                "HORIZONTAL_AND_VERTICAL": "แนวนอนและแนวตั้ง",
                "HORIZONTAL_BAR": "แถบแนวนอน",
                "HOW_TO_INTERPRET_RESULT_HEADER": "วิธีตีความผลลัพธ์และกำหนดการดำเนินการ:",
                "IF": "ถ้า",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "รวมป้ายชื่อที่ถูกซ่อนไว้ในเปอร์เซ็นต์",
                "INNER_RIM": "ขอบด้านใน",
                "IS": "คือ",
                "IS_NOT": "ไม่ใช่",
                "IS_SAME_AS_SUBJECT": "เหมือนกับผู้รับการประเมิน",
                "ITEM": "รายการ",
                "LABEL": "ป้ายชื่อ",
                "LABELS": "ป้ายชื่อ",
                "LARGE_LABELS": "ป้ายชื่อขนาดใหญ่",
                "LEGEND": "คำอธิบายสัญลักษณ์",
                "LEGEND_POSITION": "ตำแหน่งคำอธิบายสัญลักษณ์",
                "LEGEND_VALUES": "ค่าของคำอธิบายสัญลักษณ์",
                "LESS_OR_EQUAL": "น้อยกว่าหรือเท่ากับ",
                "LESS_THAN": "น้อยกว่า",
                "LINE": "เส้น",
                "LOWEST_SCORES": "คะแนนต่ำสุด",
                "MANAGERS": "ผู้จัดการ",
                "MANUAL_FONT_SIZE": "กำหนดขนาดแบบอักษรด้วยตนเอง",
                "MAX": "สูงสุด",
                "MEAN": "ค่ากลาง",
                "MEDIAN": "มัธยฐาน",
                "METRIC_TYPE": "ประเภทตัววัด",
                "MIN": "ต่ำสุด",
                "MODIFY_CUSTOM_PALETTES": "ปรับเปลี่ยนชุดแบบสีที่ปรับแต่งได้",
                "MOVE_DOWN": "ย้ายลง",
                "MOVE_UP": "ย้ายขึ้น",
                "MULTI_SELECT_ITEMS_SELECTED": "เลือกแล้ว",
                "NEGATIVE_GAPS": "ส่วนที่สามารถปรับปรุงได้",
                "NO": "ไม่ใช่",
                "NONE": "ไม่มี",
                "NOT_APPLICABLE": "ไม่เกี่ยวข้อง",
                "NOT_EQUAL_TO": "ไม่เท่ากับ",
                "NO_DATA_AVAILABLE_WARNING": "ไม่มีข้อมูลที่ใช้ได้",
                "NO_FILTER": "ไม่มีฟิลเตอร์",
                "NO_FILTER_IS_APPLIED": "ไม่มีการนำฟิลเตอร์ไปใช้",
                "NO_VALUE": "ไม่มีค่า",
                "NPS": "Net Promoter Score",
                "NUMBER": "ตัวเลข",
                "NUMBERS": "ตัวเลข",
                "NUMBER_OF_GAPS_NEGATIVE": "จำนวนช่องว่างที่เป็นลบ",
                "NUMBER_OF_GAPS_POSITIVE": "จำนวนช่องว่างที่เป็นบวก",
                "NUMBER_OF_ROWS_HIGH": "จำนวนแถวสูง",
                "NUMBER_OF_ROWS_LOW": "จำนวนแถวต่ำ",
                "OPTIONS": {
                    "HEADER_NAME": "ชื่อส่วนหัว",
                    "LEGEND": "คำอธิบายสัญลักษณ์",
                    "SCALE_AXIS_CHANGER_TITLE": "ช่วง"
                },
                "ORIENTATION": "การวางแนว",
                "OR_IF": "หรือถ้า",
                "OTHER": "อื่นๆ",
                "OTHERS": "อื่นๆ",
                "PAGE_OF": "หน้า: %1 จาก %2",
                "PALETTE_REMOVED": "ย้ายชุดแบบสีออกแล้ว",
                "PEERS": "เพื่อนร่วมงาน",
                "PERCENT": "เปอร์เซ็นต์",
                "PERCENTAGE": "เปอร์เซ็นต์",
                "PERCENTAGE_OF_CHOICES": "เปอร์เซ็นต์ของตัวเลือก",
                "PERCENTAGE_OF_RESPONSES": "เปอร์เซ็นต์ของการตอบกลับ",
                "PERCENT_COMPLETE": "% เสร็จสมบูรณ์",
                "PERSON_METADATA": "เมต้าดาต้าของบุคคล",
                "PERSON_METADATA_EVALUATOR": "ของผู้ประเมิน",
                "PERSON_METADATA_SUBJECT": "ของผู้รับการประเมิน",
                "PERSON_METADATA_VIEWER": "ของผู้ดู",
                "POSITIVE_GAPS": "จุดแข็งที่ซ่อนอยู่",
                "PRIMARY_PARENTHESES": "(หลัก)",
                "QUESTIONS": "คำถาม",
                "RADIUS": "รัศมี",
                "RANK": "ลำดับ",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "คะแนนสูงสุด",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "คะแนนสูงสุด",
                "RANKABLE_ITEMS_ITEM_HAS": "รายการมี",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "รายการอยู่ในอันดับบนสุด",
                "RANKABLE_ITEMS_LOWEST_SCORE": "คะแนนต่ำสุด",
                "RANKABLE_ITEMS_LOWEST_SCORES": "คะแนนต่ำสุด",
                "RATER_CATEGORY_DISPLAY_LOGIC": "ลอจิกการแสดงหมวดผู้ให้คะแนน",
                "RATIO": "อัตราส่วน",
                "RECORD": "เรคคอร์ด",
                "REFERENCE_GROUP": "กลุ่มอ้างอิง",
                "RELATIONSHIP": "ความสัมพันธ์",
                "RELATIONSHIP_FILTERS": "ฟิลเตอร์ความสัมพันธ์",
                "RELATIONSHIP_FILTERS_INFO": "เมื่อต้องการเพิ่มฟิลเตอร์ความสัมพันธ์ (เช่น ผู้ใต้บังคับบัญชา เพื่อนร่วมงาน หรือผู้จัดการ) ให้เลือก 'จัดการฟิลเตอร์ของคุณ' และใช้เงื่อนไขความสัมพันธ์จากเมนูดรอปดาวน์เท่านั้น",
                "REMOVE": "ย้ายออก",
                "REMOVE_DATA_SOURCE": "ย้ายแหล่งข้อมูลออก",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "กรุณาจำไว้ว่ามีทรัพยากรภายในองค์กรของคุณที่ช่วยในการตีความข้อเสนอแนะ เช่น ฝ่ายทรัพยากรบุคคล ผู้จัดการของคุณ และ/หรือผู้สอนงาน",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "คุณสามารถอ่านข้อเสนอแนะของคุณไปพร้อมกับจิบกาแฟ",
                    "ABOUT_YOUR_REPORT_HEADER": "เกี่ยวกับรายงานของคุณ",
                    "ABOUT_YOUR_REPORT_LINE1": "ยินดีต้อนรับสู่รายงานข้อเสนอแนะ 360 นี่เป็นโอกาสดีที่จะเติบโตและพัฒนาตัวเองในฐานะมืออาชีพ สำหรับการเตรียมตัวให้พร้อมรับความสำเร็จเมื่อได้รับผลลัพธ์ต่างๆ คุณควรให้เวลากับตัวเองในการอ่านข้อเสนอแนะ ตอนแรกอาจเป็นเรื่องยากที่จะรับฟัง แต่พึงระลึกไว้ว่าจุดประสงค์ของข้อเสนอแนะนี้คือเพื่อเร่งการเติบโตและการพัฒนาของคุณ",
                    "ABOUT_YOUR_REPORT_LINE2": "เมื่อคุณอ่านรายงาน ควรคำนึงถึงสิ่งต่อไปนี้",
                    "ADVANCED_FILTER": "ฟิลเตอร์ขั้นสูง",
                    "AGREEMENT_CHART": "แผนภูมิข้อตกลง",
                    "AGREEMENT_CHART_FOOTER": "แผนภูมิข้อตกลงบ่งชี้ความคล้ายคลึงกันของคะแนน แต่ละจุดแสดงให้เห็นว่าแต่ละคนให้คะแนนคุณสำหรับแต่ละรายการอย่างไร ขนาดของจุดแสดงจำนวนผู้ให้คะแนนที่ให้คะแนนนั้นๆ แก่คุณ",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "การตอบกลับ",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "การตอบกลับ",
                    "AGREEMENT_CHART_LEGEND_TITLE": "บุคคลอื่นให้คะแนนคุณอย่างไร",
                    "ALL": "ทั้งหมด",
                    "AVERAGE": "เฉลี่ย",
                    "BOTTOM_BOX": "กลุ่มล่าง",
                    "CHOICE_COUNT": "จำนวนตัวเลือก",
                    "CHOICE_TOTALS": "ตัวเลือกทั้งหมด",
                    "COMPARISON": "การเปรียบเทียบ",
                    "COMPARISON_GAP_COLUMN_HEADER": "ช่องว่างการเปรียบเทียบ",
                    "COMPLETED_RESPONSES": "การตอบกลับที่เสร็จสมบูรณ์",
                    "COUNT": "จำนวน",
                    "DEFAULT": "ค่าตั้งต้น",
                    "DEFAULT_TEXT": "ข้อความตั้งต้น",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "ทำความเข้าใจกับข้อเสนอแนะของคุณที่มาจากเพื่อนร่วมงาน ผู้ใต้บังคับบัญชา หัวหน้า ฯลฯ",
                    "DIFFERENT_EVALUATORS_HEADER": "ผู้ประเมินรายอื่น",
                    "DONE": "เสร็จสิ้น",
                    "DONT_HEADER": "สิ่งที่ไม่ควรทำ:",
                    "DONT_LINE1": "พยายามหาว่าใครพูดอะไร",
                    "DONT_LINE2": "โฟกัสที่คะแนน/ข้อคิดเห็นเชิงบวกหรือลบ",
                    "DONT_LINE3": "สร้างแผนการพัฒนาให้กับทุกรายการ",
                    "DONT_LINE4": "รู้สึกท้อถอยเมื่อคุณมีสิ่งที่ควรปรับปรุง",
                    "DO_HEADER": "สิ่งที่ควรทำ:",
                    "DO_LINE1": "ดูข้อเสนอแนะแบบองค์รวม",
                    "DO_LINE2": "ระบุธีมในจุดแข็งและสิ่งที่ควรปรับปรุง",
                    "DO_LINE3": "จัดลำดับความสำคัญของขอบเขตการโฟกัสสองสามรายการเพื่อเพิ่มในแผนการพัฒนาของคุณ",
                    "DO_LINE4": "ทำความเข้าใจว่าทุกคนมีสิ่งที่ควรปรับปรุง",
                    "FIELD": "ฟิลด์",
                    "GAP": "ช่องว่าง",
                    "GAP_CHART": "แผนภูมิช่องว่าง",
                    "GAP_CHART_DESCRIPTION": "แผนภูมิช่องว่างแสดงส่วนต่างของคะแนนระหว่างกลุ่มผู้ให้คะแนนสองกลุ่ม ตัวอย่างเช่น ในกรณีของการให้คะแนนตนเองเทียบกับบุคคลอื่นให้คะแนนคุณ ส่วนต่างเชิงบวก (+) หมายถึงบุคคลอื่นให้คะแนนคุณสูงกว่าคะแนนที่คุณให้ตัวเอง ส่วนต่างเชิงลบ (-) หมายถึงบุคคลอื่นให้คะแนนคุณต่ำกว่าที่คุณให้ตัวเอง",
                    "GAP_CHART_FOOTER": "แผนภูมิช่องว่างบ่งชี้ส่วนต่าง +/- ระหว่างผู้ให้คะแนนสองกลุ่ม",
                    "GAP_TABLE_DESCRIPTION": "'จุดแข็งที่ซ่อนอยู่' แสดงให้เห็นว่าบุคคลอื่นให้คะแนนคุณสูงกว่าที่คุณให้คะแนนตัวเอง 'ส่วนที่สามารถปรับปรุงได้' แสดงให้เห็นว่าบุคคลอื่นให้คะแนนคุณต่ำกว่าที่คุณให้คะแนนตัวเอง ทั้งสองส่วนถูกจัดลำดับจากช่องว่างที่ใหญ่ที่สุดไปหาเล็กที่สุด",
                    "GAP_TABLE_FOOTER": "คอลัมน์แรกของคะแนนบ่งชี้ว่าคุณให้คะแนนตัวเองอย่างไร คอลัมน์ที่สองบ่งชี้คะแนนเฉลี่ยของผู้อื่น คอลัมน์ที่สามบ่งชี้ความแตกต่างระหว่างคะแนนที่คุณให้ตัวเองกับคะแนนที่คนอื่นให้คุณ",
                    "GAP_TABLE_TITLE": "จุดแข็งที่ซ่อนอยู่/ส่วนที่สามารถปรับปรุงได้",
                    "GROUP": "กลุ่ม",
                    "HIDE_REPORT_ALERT": "คุณมีคุณสมบัติไม่ตรงตามข้อกำหนดในการดูรายงานของคุณ กรุณาติดต่อผู้ดูแลระบบขององค์กรของคุณ",
                    "HIGHEST_SCORES": "คะแนนสูงสุด",
                    "HIGHLOW_TABLE": "คะแนนสูงและต่ำ",
                    "HIGHLOW_TABLE_FOOTER": "ในส่วนนี้แสดงพฤติกรรมที่ได้รับคะแนนสูงสุดและต่ำสุดห้าอันดับแรก (จากทุกพฤติกรรม) จากค่าเฉลี่ยของหมวดผู้ให้คะแนนที่เกี่ยวข้อง เมื่อต้องการใช้ประโยชน์จากหน้านี้ให้ได้มากที่สุด ควรมองหาแนวโน้มที่โดดเด่นออกมา ตัวอย่างเช่น ถ้าพฤติกรรมส่วนใหญ่ที่ได้คะแนนต่ำสุดเน้นไปที่หมวดหนึ่งหรือสองหมวด นั่นอาจเป็นส่วนที่ต้องปรับปรุง พฤติกรรมที่ได้คะแนนสูงสุดอาจระบุถึงจุดแข็งซึ่งอาจมีอิทธิพลต่อส่วนอื่นๆ",
                    "HIGH_LOW_TABLE_DESCRIPTION": "แผนภูมิสูง/ต่ำจะแสดงรายการตามเรื่องที่บุคคลอื่นให้คะแนนคุณสูงสุดและต่ำสุด",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "วิธีตีความผลลัพธ์และกำหนดการดำเนินการ:",
                    "ITEM": "รายการ",
                    "LOWEST_SCORES": "คะแนนต่ำสุด",
                    "MAX": "สูงสุด",
                    "MEAN": "ค่ากลาง",
                    "MEDIAN": "มัธยฐาน",
                    "MIN": "ต่ำสุด",
                    "NEGATIVE_GAPS": "ส่วนที่สามารถปรับปรุงได้",
                    "NO_COMPARISON_SET": "ไม่มีชุดเปรียบเทียบ",
                    "NO_DATA_AVAILABLE_WARNING": "ไม่มีข้อมูลที่ใช้ได้",
                    "NO_FILTER_IS_APPLIED": "ไม่มีการนำฟิลเตอร์ไปใช้",
                    "NO_VALUE": "ไม่มีค่า",
                    "NPS": "Net Promoter Score",
                    "OTHERS": "อื่นๆ",
                    "PERCENTAGE": "เปอร์เซ็นต์",
                    "PERCENTAGE_OF_CHOICES": "เปอร์เซ็นต์ของตัวเลือก",
                    "PERCENTAGE_OF_RESPONSES": "เปอร์เซ็นต์ของการตอบกลับ",
                    "PERCENT_COMPLETE": "% เสร็จสมบูรณ์",
                    "POSITIVE_GAPS": "จุดแข็งที่ซ่อนอยู่",
                    "QUESTIONS": "คำถาม",
                    "RANK": "ลำดับ",
                    "RELATIONSHIPS": {
                        "ANYONE": "ใครก็ได้",
                        "DIRECT_REPORT": "ผู้ใต้บังคับบัญชา",
                        "MANAGER": "ผู้จัดการ",
                        "PEER": "เพื่อนร่วมงาน",
                        "SELF": "ตนเอง"
                    },
                    "REPORT_SUMMARY": "ข้อมูลสรุปรายงาน",
                    "REPORT_SUMMARY_TABLE_FOOTER": "เปรียบเทียบจำนวนคนที่ทำการประเมินของคุณเสร็จแล้วกับจำนวนคนที่ได้รับเชิญให้เข้าร่วมทำการประเมิน",
                    "REPORT_SUMMARY_TABLE_HEADER": "สถิติผู้ตอบ",
                    "RESPONSES": "การตอบกลับ",
                    "RESPONSE_COUNT": "{{responseCount}} การตอบกลับ",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> การตอบกลับ",
                    "SCORING_CATEGORY": "หมวดการให้คะแนน",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "ไม่มีการตอบกลับในหมวดนี้",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "ไม่มีการตอบกลับสำหรับคำถามนี้",
                    "SCORING_OVERVIEW": "ภาพรวมการให้คะแนน",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "คุณและผู้ประเมินรายอื่นคิดว่าส่วนนี้เป็นจุดแข็งที่สุด",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "จุดแข็งที่ทราบ",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "ส่วนที่สามารถปรับปรุงได้ที่ทราบหมายถึงการให้คะแนนตนเองและการให้คะแนนจากผู้อื่นนั้นต่ำกว่าค่าเฉลี่ยสำหรับความสามารถนี้",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "ส่วนที่สามารถปรับปรุงได้ที่ทราบ",
                    "SCORING_OVERVIEW_DESCRIPTION": "ข้อมูลข้างต้นคือความสามารถหรือพฤติกรรมที่คุณได้รับการประเมินโดยเป็นส่วนหนึ่งของกระบวนการให้ข้อเสนอแนะแบบมีผู้ให้คะแนนหลายรายนี้ การให้คะแนนเปรียบเทียบจะมาจากทั้งกลุ่ม",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "ช่องว่างต่ำสุด",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "ส่วนต่างต่ำสุดระหว่างกลุ่มอ้างอิงสำหรับข้อความที่จะแสดง",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "ส่วนที่แสดงเป็นช่วงคะแนนสำหรับความสามารถ/พฤติกรรม โดยแถบจะแสดงค่าตัวเลขเฉลี่ย",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "จุดแข็งที่ยังไม่ทราบมาจากผลต่างระหว่างการให้คะแนนตนเองกับการให้คะแนนจากผู้อื่น",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "จุดแข็งที่ยังไม่ทราบ",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "ส่วนที่สามารถปรับปรุงได้ที่ยังไม่ทราบมาจากผลต่างระหว่างการให้คะแนนตนเองกับการให้คะแนนจากผู้อื่น",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "ส่วนที่สามารถปรับปรุงได้ที่ยังไม่ทราบ",
                    "SELF": "ตนเอง",
                    "SELF_ASSESSMENT": "การประเมินตนเอง",
                    "STANDARD_DEVIATION": "ค่าเบี่ยงเบนมาตรฐาน",
                    "SUM": "ผลรวม",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "ทำความคุ้นเคยกับสเกลการให้คะแนนเพื่อให้แน่ใจว่าตีความถูกต้อง",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "จดบันทึกสเกล",
                    "THINGS_YOU_WILL_SEE_HEADER": "สิ่งที่คุณจะเห็น:",
                    "THREE_SIXTY_PERCENTILE": "เปอร์เซ็นต์ไทล์",
                    "TOP_BOTTOM_BOX": "กลุ่มบน/กลุ่มล่าง",
                    "TOP_BOX": "กลุ่มบน",
                    "TOTAL": "ยอดรวม",
                    "TO_DO": "สิ่งที่ต้องทำ",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "เชิงคุณภาพ: ข้อเสนอแนะนี้จะอยู่ในรูปแบบข้อคิดเห็นที่เป็นข้อความแบบเปิด",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "เชิงปริมาณ: ข้อเสนอแนะนี้จะเป็นตัวเลข และสามารถแสดงเป็นกราฟ แผนภูมิแท่ง ตาราง และอื่นๆ",
                    "TYPES_OF_FEEDBACK_HEADER": "ข้อเสนอแนะประเภทต่างๆ",
                    "VALUE": "ค่า",
                    "VARIANCE": "ผลต่าง",
                    "YOUR_RATINGS": "การให้คะแนนของคุณ"
                },
                "REPORT_SUMMARY": "ข้อมูลสรุปรายงาน",
                "REPORT_SUMMARY_TABLE_FOOTER": "เปรียบเทียบจำนวนคนที่ทำการประเมินของคุณเสร็จแล้วกับจำนวนคนที่ได้รับเชิญให้เข้าร่วมทำการประเมิน",
                "REPORT_SUMMARY_TABLE_HEADER": "สถิติผู้ตอบ",
                "RESET": "รีเซ็ต",
                "RESPONDENT_TOTALS": "ยอดรวมผู้ตอบ",
                "RESPONSES": "การตอบกลับ",
                "RESPONSE_COUNT": "{{responseCount}} การตอบกลับ",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> การตอบกลับ",
                "RESULT": "ผลลัพธ์",
                "REVERSE_COLORS": "กลับสี",
                "ROW_TOTALS": "ยอดรวมแถว",
                "SAVE": "เก็บบันทึก",
                "SAVE_AND_APPLY": "เก็บบันทึกและนำไปใช้",
                "SCORING_CATEGORY": "หมวดการให้คะแนน",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "ไม่มีการตอบกลับในหมวดนี้",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "ไม่มีการตอบกลับสำหรับคำถามนี้",
                "SCORING_OVERVIEW": "ภาพรวมการให้คะแนน",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "คุณและผู้ประเมินรายอื่นคิดว่าส่วนนี้เป็นจุดแข็งที่สุด",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "จุดแข็งที่ทราบ",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "ส่วนที่สามารถปรับปรุงได้ที่ทราบหมายถึงการให้คะแนนตนเองและการให้คะแนนจากผู้อื่นนั้นต่ำกว่าค่าเฉลี่ยสำหรับความสามารถนี้",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "ส่วนที่สามารถปรับปรุงได้ที่ทราบ",
                "SCORING_OVERVIEW_DESCRIPTION": "ข้อมูลข้างต้นคือความสามารถหรือพฤติกรรมที่คุณได้รับการประเมินโดยเป็นส่วนหนึ่งของกระบวนการให้ข้อเสนอแนะแบบมีผู้ให้คะแนนหลายรายนี้ การให้คะแนนเปรียบเทียบจะมาจากทั้งกลุ่ม",
                "SCORING_OVERVIEW_MINIMUM_GAP": "ช่องว่างต่ำสุด",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "ส่วนต่างต่ำสุดระหว่างกลุ่มอ้างอิงสำหรับข้อความที่จะแสดง",
                "SCORING_OVERVIEW_TABLE_FOOTER": "ส่วนที่แสดงเป็นช่วงคะแนนสำหรับความสามารถ/พฤติกรรม โดยแถบจะแสดงค่าตัวเลขเฉลี่ย",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "จุดแข็งที่ยังไม่ทราบมาจากผลต่างระหว่างการให้คะแนนตนเองกับการให้คะแนนจากผู้อื่น",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "จุดแข็งที่ยังไม่ทราบ",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "ส่วนที่สามารถปรับปรุงได้ที่ยังไม่ทราบมาจากผลต่างระหว่างการให้คะแนนตนเองกับการให้คะแนนจากผู้อื่น",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "ส่วนที่สามารถปรับปรุงได้ที่ยังไม่ทราบ",
                "SELECT_CATEGORIES": "กรุณาเลือกหมวดการให้คะแนน...",
                "SELECT_CATEGORY": "กรุณาเลือกหมวดการให้คะแนน...",
                "SELECT_CONDITION_TYPE": "เลือกประเภทเงื่อนไข",
                "SELECT_DATA_SOURCE": "เลือกแหล่งข้อมูล",
                "SELECT_DATA_SOURCE_TYPE": "เลือกประเภทแหล่งข้อมูล",
                "SELECT_FILTER": "เลือกฟิลเตอร์",
                "SELECT_FILTERS": "เลือกฟิลเตอร์",
                "SELECT_OPERATOR_TYPE": "เลือกประเภทตัวดำเนินการ",
                "SELECT_PERSON": "เลือกบุคคล",
                "SELECT_PERSON_METADATA": "เลือกเมต้าดาต้าบุคคล",
                "SELECT_QUESTION": "เลือกคำถาม",
                "SELECT_QUESTIONS": "กรุณาเลือกคำถาม...",
                "SELECT_RATIO_OR_DROPOFF": "เลือกอัตราส่วนหรือการลดลง",
                "SELECT_RELATIONSHIP": "เลือกความสัมพันธ์",
                "SELECT_SCORING_CATEGORY": "เลือกหมวดการให้คะแนน",
                "SELF": "ตนเอง",
                "SELF_ASSESSMENT": "การประเมินตนเอง",
                "SEQUENTIAL": "ตามลำดับ",
                "SETUP_COMPARISON": "กำหนดค่าการเปรียบเทียบ",
                "SETUP_COMPARISONS": "กำหนดค่าการเปรียบเทียบ",
                "SET_START_COLOR": "กำหนดสีเริ่มต้น",
                "SHOULD_SHOW_FOOTER": "แสดงส่วนท้าย",
                "SHOULD_SHOW_SCORING_CATEGORY": "แสดงหมวดการให้คะแนน",
                "SHOWING_RECORDS_OF": "กำลังแสดงเรคคอร์ด %1 - %2 จาก %3",
                "SHOW_COMPARISON_GAP": "แสดงคอลัมน์ช่องว่างการเปรียบเทียบ",
                "SHOW_DATA_LABEL": "แสดงค่าข้อมูล",
                "SHOW_PERCENTAGES": "แสดงเปอร์เซ็นต์",
                "SHOW_THE_FOLLOWING_TEXT": "จากนั้นแสดงข้อความต่อไปนี้",
                "SHOW_TIES": "แสดงความสัมพันธ์",
                "SHOW_X_AXIS": "แสดงแกน X",
                "SHOW_Y_AXIS": "แสดงแกน Y",
                "SMALL_LABELS": "ป้ายชื่อขนาดเล็ก",
                "SORT": "จัดเรียง",
                "SPLINE": "เส้นโค้ง",
                "STACK_CHART": "แผนภูมิแบบซ้อน",
                "STANDARD_DEVIATION": "ค่าเบี่ยงเบนมาตรฐาน",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "จุดอ่อนน้อยกว่า",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "แก้ไขข้อความค่าจำกัด",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "ข้อความค่าจำกัด",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "เปิดใช้งานข้อความค่าจำกัด",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "จุดแข็งมากกว่า",
                "SUM": "ผลรวม",
                "SUMMARY": "ข้อมูลสรุป",
                "TABLES": "ตาราง",
                "TABLE_TOTALS": "ยอดรวมตาราง",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "ทำความคุ้นเคยกับสเกลการให้คะแนนเพื่อให้แน่ใจว่าตีความถูกต้อง",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "จดบันทึกสเกล",
                "TEXT": "ข้อความ",
                "THINGS_YOU_WILL_SEE_HEADER": "สิ่งที่คุณจะเห็น:",
                "TOP_BOTTOM_BOX": "กลุ่มบน/กลุ่มล่าง",
                "TOP_BOX": "กลุ่มบน",
                "TOTAL": "ยอดรวม",
                "TOTAL_COUNTS": "จำนวนรวม",
                "TO_DO": "สิ่งที่ต้องทำ",
                "TRANSPOSE": "สลับเปลี่ยนแถวกับคอลัมน์",
                "TRANSPOSE_TABLE": "สลับเปลี่ยนตาราง",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "เชิงคุณภาพ: ข้อเสนอแนะนี้จะอยู่ในรูปแบบข้อคิดเห็นที่เป็นข้อความแบบเปิด",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "เชิงปริมาณ: ข้อเสนอแนะนี้จะเป็นตัวเลข และสามารถแสดงเป็นกราฟ แผนภูมิแท่ง ตาราง และอื่นๆ",
                "TYPES_OF_FEEDBACK_HEADER": "ข้อเสนอแนะประเภทต่างๆ",
                "UNDO": "เลิกทำ",
                "USE_COMPARISON": "ใช้การเปรียบเทียบ",
                "USE_LABELS_FOR_SCALES": "ใช้ป้ายชื่อสำหรับสเกล",
                "VALUES": "ค่า",
                "VALUE_RANGES": "ช่วงค่า",
                "VARIANCE": "ผลต่าง",
                "VERTICAL": "แนวตั้ง",
                "VERTICAL_RANGE": "ช่วงแนวตั้ง",
                "WARNING_DATA_OUT_OF_RANGE": "คำเตือน: ค่าข้อมูลเกินการกำหนดรูปแบบช่วง",
                "WIDGET_ERROR": {
                    "ERROR": "มีข้อผิดพลาดที่ไม่คาดคิดเกิดขึ้น",
                    "MISCONFIGURED": "Widget นี้ได้รับการกำหนดรูปแบบอย่างไม่ถูกต้อง กรุณาตรวจสอบการกำหนดรูปแบบ Widget ของคุณ",
                    "NEW": "กรุณากำหนดรูปแบบ Widget",
                    "NO_DATA": "ไม่พบข้อมูล - ฟิลเตอร์ของคุณอาจเป็นแบบเฉพาะเกินไป!"
                },
                "WIDGET_NAME": {
                    "BAR": "แผนภูมิแท่ง",
                    "BREAKDOWNBAR": "แผนภูมิแท่งแยกย่อย",
                    "DATA_TABLE": "ตารางข้อมูล",
                    "FUNNEL_CHART": "แผนภูมิ Funnel",
                    "GAUGE": "แผนภูมิตัววัด",
                    "GRID": "ตารางผลลัพธ์",
                    "HEATMAP": "แผนที่ความร้อน",
                    "LINE": "แผนภูมิเส้น",
                    "NEEDS_BASED": "ตามความต้องการ",
                    "PIE": "แผนภูมิวงกลม",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "ตัวประมาณการราคา (Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "ตัวสร้างรายได้สูงสุด (Gabor Granger)",
                    "SCORING_OVERVIEW_CHART": "แผนภูมิ",
                    "SCORING_OVERVIEW_TABLE": "ตาราง",
                    "STATS_TABLE": "ตารางสถิติ",
                    "WORDCLOUD": "ภาพกลุ่มคำ"
                },
                "WORD_ROTATION": "การหมุนคำ",
                "WORD_SPACING": "ระยะห่างคำ",
                "YES": "ใช่",
                "YOUR_RATINGS": "การให้คะแนนของคุณ"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "เพิ่ม",
                "ADD_A_WORD": "เพิ่มคำ",
                "COLOR": "สี",
                "DELETE_ALL": "ลบทั้งหมด",
                "EDIT_STOP_WORDS": "แก้ไขคำหยุด",
                "MAX_WORDS": "จำนวนคำสูงสุด",
                "ROTATION_ANGLED": "ทำมุม",
                "ROTATION_HORIZONTAL": "แนวนอน",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "แนวนอนและแนวตั้ง",
                "WORD_ORIENTATION": "การวางแนวคำ"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "สีแบคกราวน์",
                "DISPLAY_OPTIONS": "ตัวเลือกการแสดง",
                "INVERT_FONT_COLORS": "สลับสีแบบอักษรที่มีความเปรียบต่างต่ำ",
                "PAGE": "หน้า",
                "PAGINATE": "ใส่เลขหน้า"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "เฉลี่ย",
                "BOTTOM_BOX_METRIC": "กลุ่มล่าง",
                "COLUMNS": "คอลัมน์",
                "COUNT_METRIC": "การตอบกลับทั้งหมด",
                "FIELD_NAME": "ฟิลด์",
                "MAX_METRIC": "สูงสุด",
                "MIN_METRIC": "ต่ำสุด",
                "SHOW_RECODES": "แสดงค่าการเปลี่ยนรหัสข้อมูล",
                "SHOW_ROW_NUMBERS": "แสดงเลขที่แถว",
                "STD_DEV_METRIC": "ค่าเบี่ยงเบนมาตรฐาน",
                "TOP_BOX_METRIC": "กลุ่มบน",
                "TRANSPOSE_BREAKOUTS": "สลับเปลี่ยนการแบ่ง",
                "TRANSPOSE_TABLE": "สลับเปลี่ยนตาราง",
                "VAR_METRIC": "ผลต่าง"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "คอลัมน์เพิ่มเติม",
                "ADD_COLUMNS": "เพิ่มคอลัมน์เพิ่มเติม",
                "ADD_CUSTOM_PALETTE": "เพิ่มชุดแบบสีที่ปรับแต่งได้",
                "ALL_CHOICES": "ตัวเลือกทั้งหมด",
                "ALL_GROUPS": "กลุ่มทั้งหมด",
                "ALL_RECODES": "การเปลี่ยนรหัสข้อมูลทั้งหมด",
                "AUTOMATIC": "ค่าตั้งต้น",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "ค่าตั้งต้น - คลิกเพื่อแก้ไข",
                "AXIS_VALUES": "ค่าแกน",
                "BREAKOUT_BY": "แบ่งตาม",
                "CANCEL": "ยกเลิก",
                "CATEGORICAL": "ตามหมวด",
                "CHOICES": "ตัวเลือก",
                "CHOICE_COUNT": "จำนวนตัวเลือก",
                "COLOR_PALETTE": "ชุดแบบสี",
                "COLUMN_VALUES": "ค่าคอลัมน์",
                "CONTACT_FIELDS": "ฟิลด์ผู้ติดต่อ",
                "COUNT": "จำนวน",
                "CREATE": "สร้าง",
                "CUSTOM": "ปรับแต่งได้",
                "CUSTOM_PALETTE": "ชุดแบบสีที่ปรับแต่งได้",
                "DATA_SOURCE": "แหล่งข้อมูล",
                "DAY": "วัน",
                "DAY_OF_WEEK": "วันในสัปดาห์",
                "DECIMAL_PRECISION": "ตำแหน่งทศนิยม",
                "DEFAULT": "ค่าตั้งต้น",
                "DISABLED": "ปิดใช้งานแล้ว",
                "DIVERGENT": "ความแตกต่าง",
                "EDIT_CUSTOM_PALETTE": "แก้ไขชุดแบบสีที่ปรับแต่งได้",
                "ENABLED": "เปิดใช้งานแล้ว",
                "ERROR_LOADING_DATA": "เกิดข้อผิดพลาดในการโหลดข้อมูล",
                "FILE_SIZE": "ขนาด",
                "FILE_TYPE": "ประเภท",
                "FRI": "ศ.",
                "FRIDAY": "ศุกร์",
                "GROUP_DATE_BY": "จัดกลุ่มวันที่ตาม",
                "HOUR_OF_DAY": "ชั่วโมงในวัน",
                "LENGEND_VALUES": "ค่าคำอธิบายสัญลักษณ์",
                "MAX": "สูงสุด",
                "MEAN": "ค่ากลาง",
                "MIN": "ต่ำสุด",
                "MISCONFIGURED_DATA": "แหล่งข้อมูลถูกกำหนดรูปแบบไม่ถูกต้องสำหรับการแสดงผลนี้",
                "MISCONFIGURED_FILTERS": "ฟิลเตอร์ไม่ถูกต้อง",
                "MODIFY_CUSTOM_PALETTES": "ปรับเปลี่ยนชุดแบบสีที่ปรับแต่งได้",
                "MON": "จ.",
                "MONDAY": "จันทร์",
                "MONTH": "เดือน",
                "NONE": "ไม่มี",
                "NO_FILE_ID_ERROR": "การแสดงผลนี้ต้องมีการกำหนดค่ารูปภาพในแบบสำรวจ",
                "NO_RESULTS_TO_SHOW": "ไม่มีผลลัพธ์ที่จะแสดง",
                "NPS": "Net Promoter Score®",
                "NPS_GROUP": "กลุ่ม NPS®",
                "NUMERIC_VALUE": "ค่าตัวเลข",
                "PALETTE_REMOVED": "ย้ายชุดแบบสีออกแล้ว",
                "PERCENTAGE": "เปอร์เซ็นต์",
                "PERCENTAGE_OF_CHOICES": "เปอร์เซ็นต์ของตัวเลือก",
                "PERCENTAGE_OF_RESPONSES": "เปอร์เซ็นต์ของการตอบกลับ",
                "QUARTER": "ไตรมาส",
                "REMOVE": "ย้ายออก",
                "RESPONSE_COUNT": "จำนวนการตอบกลับ",
                "RESULTS_PER_PAGE": "ผลลัพธ์ต่อหน้า",
                "RETRIEVING_DATA_ELLIPSIS": "กำลังดึงข้อมูล...",
                "REVERSE_COLORS": "กลับสี",
                "ROW_VALUES": "ค่าแถว",
                "SAT": "ส.",
                "SATURDAY": "เสาร์",
                "SAVE": "เก็บบันทึก",
                "SELECTED_CHOICE": "ตัวเลือกที่เลือกไว้",
                "SELECT_FIELD": "เลือกฟิลด์",
                "SELECT_METRIC": "ตัววัด",
                "SEQUENTIAL": "ตามลำดับ",
                "SET_START_COLOR": "กำหนดสีเริ่มต้น",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "กำลังแสดงข้อมูลตัวอย่าง...",
                "SUM": "ผลรวม",
                "SUN": "อา.",
                "SUNDAY": "อาทิตย์",
                "SURVEY_EMBEDDEDDATA": "ข้อมูลฝังตัว",
                "SURVEY_METADATA": "เมต้าดาต้าแบบสำรวจ",
                "TEXT_ENTRY": "รายการข้อความ",
                "THURS": "พฤ.",
                "THURSDAY": "พฤหัสบดี",
                "TITLE": "ชื่อเรื่อง",
                "TUES": "อ.",
                "TUESDAY": "อังคาร",
                "UNBOUNDED_DOMAIN": "มีค่าที่จะแสดงมากเกินไป",
                "UNBOUNDED_DOMAIN_HELP": "เมื่อต้องการเพิ่มฟิลด์นี้ในรายงานผลลัพธ์ คุณสามารถเพิ่มฟิลเตอร์ในรายงานเพื่อแสดงค่าน้อยลงสำหรับ \"{{ed_field_name}}\" หรืออัพเดทประเภทตัวแปรข้อมูลฝังตัวของ \"{{ed_field_name}}\" ในโฟลว์แบบสำรวจของคุณเพื่อทำให้ฟิลด์นี้เป็นประเภทสตริงหรือตัวเลข",
                "UNDO": "เลิกทำ",
                "USE_CHOICE_TOTALS": "ใช้ตัวเลือกทั้งหมด",
                "USE_RESPONDENT_TOTALS": "ใช้ผู้ตอบทั้งหมด",
                "VISUALIZATION": "การแสดงผล",
                "VISUALIZATION_BARCHART": "แผนภูมิแท่ง",
                "VISUALIZATION_BREAKDOWNBAR": "แผนภูมิแท่งแยกย่อย",
                "VISUALIZATION_GAUGE": "แผนภูมิตัววัด",
                "VISUALIZATION_HEATMAP": "แผนที่ความร้อน",
                "VISUALIZATION_LINECHART": "แผนภูมิเส้น",
                "VISUALIZATION_PAGINATEDTABLE": "ตารางแบบแบ่งหน้า",
                "VISUALIZATION_PIE": "แผนภูมิวงกลม",
                "VISUALIZATION_SIMPLETABLE": "ตารางแบบง่าย",
                "VISUALIZATION_STATSTABLE": "ตารางสถิติ",
                "VISUALIZATION_TEXTHIGHLIGHTS": "ไฮไลต์ข้อความ",
                "VISUALIZATION_WORDCLOUD": "ภาพกลุ่มคำ",
                "WED": "พ.",
                "WEDNESDAY": "พุธ",
                "WEEK": "สัปดาห์",
                "WEIGHTING": "การถ่วงน้ำหนัก",
                "WRONG_QUESTION_TYPE_ERROR": "ไม่สามารถใช้ประเภทการแสดงผลนี้สำหรับคำถามนี้",
                "YEAR": "ปี"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "ค่าเฉลี่ย",
                "CHOICE_COUNT": "จำนวนตัวเลือก",
                "COUNT": "จำนวน",
                "DISPLAY_OPTIONS": "ตัวเลือกการแสดง",
                "MAX": "สูงสุด",
                "MIN": "ต่ำสุด",
                "NPS": "NPS®",
                "PAGE_OF": "หน้า: %1 จาก %2",
                "PERCENT": "เปอร์เซ็นต์",
                "RESPONSE_COUNT": "จำนวนการตอบกลับ",
                "ROWS_PER_TABLE": "แถวต่อตาราง",
                "SHOWING_ROWS_OF": "กำลังแสดงแถว %1 - %2 จาก %3",
                "SHOW_PERCENTAGES": "แสดงเปอร์เซ็นต์",
                "SHOW_RECODES": "แสดงค่าการเปลี่ยนรหัสข้อมูล",
                "SHOW_ROW_NUMBERS": "แสดงเลขที่แถว",
                "SUM": "ผลรวม",
                "TOTAL": "ยอดรวม",
                "TRANSPOSE": "สลับเปลี่ยนแถวกับคอลัมน์",
                "USE_COLUMN_TOTALS": "ใช้ยอดรวมคอลัมน์",
                "USE_ROW_TOTALS": "ใช้ยอดรวมแถว",
                "VALUE": "ค่า"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "จากน้อยไปหามาก",
                "COUNT": "จำนวน",
                "DESCENDING": "จากมากไปหาน้อย",
                "DIAGONAL": "ทแยงมุม",
                "DISPLAY_OPTIONS": "ตัวเลือกการแสดง",
                "ERROR_COLON": "ข้อผิดพลาด:",
                "ERROR_GENERIC": "มีข้อผิดพลาดเกิดขึ้นขณะโหลดการแสดงผล",
                "HORIZONTAL": "แนวนอน",
                "HORIZONTAL_BARS": "แถบแนวนอน",
                "INCORRECTLY_CONFIGURED": "เลือกค่าเพื่อแสดงแผนภูมิ",
                "LEGEND_AUTO": "อัตโนมัติ",
                "LEGEND_BOTTOM": "ด้านล่าง",
                "LEGEND_INSET": "ขอบใน",
                "LEGEND_RIGHT": "ด้านขวา",
                "NORMALIZE_TO_PERCENTAGES": "นอร์มัลไลซ์เป็นเปอร์เซ็นต์",
                "SHOW_BAR_LABELS": "แสดงป้ายชื่อแถบ",
                "SHOW_LEGEND": "แสดงคำอธิบายสัญลักษณ์",
                "SHOW_X_AXIS": "แสดงแกน X",
                "SHOW_Y_AXIS": "แสดงแกน Y",
                "SORT_BAR_VALUES": "จัดเรียงค่าแถบ",
                "STACKED_BARS": "แท่งแบบเรียงซ้อน",
                "TRANSPOSE": "สลับเปลี่ยนแถวกับคอลัมน์",
                "TRUNCATE_LABELS": "ตัดป้ายชื่อให้สั้นลง",
                "VERTICAL": "แนวตั้ง"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "อื่นๆ ทั้งหมด",
                "COULD_NOT_LOAD_DATA": "ไม่สามารถโหลดข้อมูลที่มีการกำหนดรูปแบบที่ระบุ — ลองใช้ฟิลด์ต้นทางอื่นหรือช่วงวันที่ที่กว้างขึ้น",
                "GROUPING_PERCENTAGE_THRESHOLD": "ค่าจำกัดเปอร์เซ็นต์การจัดกลุ่ม",
                "NO_DATA": "ไม่มีข้อมูล",
                "RADIUS": "รัศมีด้านใน",
                "SHOW_AS_PERCENTAGES": "แสดงเป็นเปอร์เซ็นต์"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "ปิด",
                "DOWNLOAD_CSV": "ดาวน์โหลด CSV",
                "DOWNLOAD_ZIP": "ดาวน์โหลดไฟล์ทั้งหมด",
                "NO_DATA": "ไม่มีข้อมูล",
                "PAGE_OF": "หน้า: %1 จาก %2",
                "RESULTS_PER_PAGE": "ผลลัพธ์ต่อหน้า",
                "SHOWING_RECORDS_OF": "กำลังแสดงเรคคอร์ด %1 - %2 จาก %3",
                "SINGLE_RESPONSE": "การตอบกลับเดียว",
                "VIEW_RESPONSE": "ดูการตอบกลับ"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "ตัวเลือกการแสดง",
                "ERROR_COLON": "ข้อผิดพลาด:",
                "ERROR_GENERIC": "มีข้อผิดพลาดเกิดขึ้นขณะโหลดการแสดงผล",
                "HORIZONTAL_BARS": "แถบแนวนอน",
                "INCORRECTLY_CONFIGURED": "เลือกค่าเพื่อแสดงแผนภูมิ",
                "LEGEND_AUTO": "อัตโนมัติ",
                "LEGEND_BOTTOM": "ด้านล่าง",
                "LEGEND_INSET": "ขอบใน",
                "LEGEND_RIGHT": "ด้านขวา",
                "NORMALIZE_TO_PERCENTAGES": "นอร์มัลไลซ์เป็นเปอร์เซ็นต์",
                "SHOW_AREA": "แสดงพื้นที่",
                "SHOW_LEGEND": "แสดงคำอธิบายสัญลักษณ์",
                "SHOW_X_AXIS": "แสดงแกน X",
                "SHOW_Y_AXIS": "แสดงแกน Y",
                "SMOOTH_LINES": "เส้นเรียบ",
                "SORT_X_AXIS_LABELS": "จัดเรียงป้ายชื่อแกน X",
                "STACKED_BARS": "แท่งแบบเรียงซ้อน",
                "TRANSPOSE": "สลับเปลี่ยนแถวกับคอลัมน์"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "โหมดบล็อค",
                "BLUR": "เบลอ",
                "COULD_NOT_LOAD_DATA": "ไม่สามารถโหลดข้อมูลที่มีการกำหนดรูปแบบที่ระบุ — ลองใช้ฟิลด์ต้นทางอื่นหรือช่วงวันที่ที่กว้างขึ้น",
                "FIELD": "ฟิลด์",
                "RADIUS": "รัศมี",
                "SHOW_REGIONS": "แสดงภูมิภาค",
                "SHOW_REGION_LABELS": "แสดงป้ายชื่อภูมิภาค"
            },
            "GAUGEWIDGET": {
                "MAX": "สูงสุด",
                "MIN": "ต่ำสุด",
                "VALUE_RANGES": "ช่วงค่า"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "ป้ายชื่อด้านล่าง",
                "CATEGORY_NAME": "ชื่อหมวด",
                "ERROR_COLON": "ข้อผิดพลาด:",
                "INCLUDE_HIDDEN_GROUPS": "รวมกลุ่มที่ซ่อนในเปอร์เซ็นต์",
                "LARGE_LABELS": "ป้ายชื่อขนาดใหญ่",
                "NO": "ไม่ใช่",
                "PERCENT": "เปอร์เซ็นต์",
                "RESPONSE_COUNT": "จำนวนการตอบกลับ",
                "RESPONSE_COUNT_WITH_VALUE": "{{ responseCount }} การตอบกลับ",
                "SMALL_LABELS": "ป้ายชื่อขนาดเล็ก",
                "YES": "ใช่"
            }
        });
        $cache.put('ZH-S', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "访问代码",
                "ACCESS_CODE_PROTECTION": "访问代码保护",
                "ADD": "添加",
                "ADD_BREAKOUT": "添加报告分类",
                "ADD_NOTE": "添加注释",
                "ADD_SCHEDULED_REPORT": "添加计划报告",
                "ADD_WIDGET": "添加可视化对象",
                "ALL_PROJECTS": "全部项目",
                "ALL_QUESTIONS": "问题页面",
                "ANSWER": "答案",
                "ANY_CHANGES_LOST": "如果离开 Qualtrics XM Platform，对报告所做的任何更改都将丢失。",
                "APPENDED_COPY_IN_PARENS": "（副本）",
                "AREA_CHART": "面积图",
                "AREA_CHART_DESC": "线下填充带面积的两轴线形图。",
                "ATTACHMENT": "附件",
                "BACKUP_CURRENT_REPORT": "在影响可视化对象之前保存此报告的备份副本。",
                "BACKUP_CURRENT_REPORT_LINE2": "备注：备份副本将被命名为“{{nameOfReportCopy}}”",
                "BACK_TO_REPORTS": "返回到报告",
                "BACK_TO_TOP": "返回到顶部",
                "BACK_TO_VIEW_RESULTS": "返回到之前查看的结果",
                "BAR_CHART": "条形图",
                "BAR_CHART_DESC": "两轴条形图允许使用其他配置，如轴转换和数据点重排。",
                "BREAKDOWN_BAR_CHART": "细分条形图",
                "BREAKDOWN_BAR_CHART_DESC": "水平堆叠条形图最常用于直观对比加权度量，可替代饼图。",
                "CANCEL": "取消",
                "CANCEL_CONF_TEXT": "您确定要取消吗?<br/>所有更改都将丢失。",
                "CANCEL_EDITS": "取消编辑",
                "CHART": "图表",
                "CHOICE": "选择",
                "CHOICES_COUNT_METRIC": "选择计数",
                "CHOOSE_PAGES_TO_DISPLAY": "选择要显示的页面",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "本报告包含 {{maxReportPageCount}} 页，但“结果”仅可包含最多 {{reportSizeLimit}}。请选择限制范围内的子集。",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "报告最多仅可包含 {{reportSizeLimit}} 页，请选择想要的页数。",
                "CLEAR_ALL": "全部清除",
                "CLOSE": "关闭",
                "CLOUD": "云描述",
                "COLLABORATED_NEW": "此调查的所有者正在使用 Qualtrics XM Platform！此调查的报告将使用新结果编辑。",
                "COMMA_SEPARATED_LIST": "逗号分隔清单",
                "COMPACTNESS": "字体和间距",
                "COMPACTNESS_INFO": "此设置会影响图表中的表格内边距、字号和条形大小。它还将应用到大多数导出文件中。",
                "CONFIRM": "确定",
                "CONFIRM_DELETE": "确认删除",
                "CONFIRM_DELETE_PAGE": "您确定要删除此页面吗？",
                "CONTINUE": "继续",
                "CONTINUE_EDITING": "继续编辑",
                "COPY": "复制",
                "COPY_OF_REPORT_NAME": "{{nameOfCurrentReport}} 副本",
                "COPY_REPORT": "复制报告",
                "COPY_REPORT_ELLIPSIS": "复制报告...",
                "COPY_TO_NEW_REPORT": "复制到新报告...",
                "CREATE": "创建",
                "CREATED": "已创建",
                "CREATE_CUSTOM_PAGE": "创建自定义页面",
                "CREATE_NEW_REPORT": "创建新报告",
                "CREATE_NEW_REPORT_ELLIPSIS": "创建新报告...",
                "CSV_FILE": "CSV 文件",
                "CUSTOM_PAGES": "自定义页面",
                "DATE": "日期",
                "DEFAULT_PALETTE": "默认调色板",
                "DEFAULT_REPORT": "默认报告",
                "DEFAULT_VISUALIZATIONS": "默认可视化对象",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "这些是用于构建默认结果报告的默认可视化对象类型。更新并应用这些设置将会以新的默认设置重新构建您的当前报告。您将看到备份当前报告的选项。",
                "DEFAULT_VISUALIZATIONS_NOTE": "备注：并非每种可视化对象类型都适用于所有问题类型。某些非默认可视化对象可能会被自动替换。",
                "DEFAULT_VISUALS_DISCLAIMER": "Qualtrics 将以新的默认可视化对象设置更新此报告。",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "此更新将影响该报告中的 {{amountOfWidgetsAffected}} 个可视化对象。",
                "DEFAULT_VISUAL_EDIT_DETECTED": "检测到默认可视化对象发生修改",
                "DELETE_BUTTON": "删除",
                "DELETE_DISABLED_EXPLANATION": "在您的组织全部迁移到 Qualtrics XM Platform 完成后，您才能删除在先前报告界面中创建的报告。",
                "DELETE_PAGE": "删除页面",
                "DELETE_PAGE_ELLIPSIS": "删除页面...",
                "DELETE_REPORT": "删除报告",
                "DELETE_REPORT_ELLIPSIS": "删除报告...",
                "DELETE_WIDGET_QUESTION": "删除？",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "此字段已加密，无法用于排序。",
                "DISCARD_EDITS": "放弃编辑",
                "DISTRIBUTION_PAUSED": "报告分发已暂停。",
                "DONE_BUTTON": "完成",
                "DONE_EDITING": "编辑完成",
                "DOWNLOAD": "下载",
                "DOWNLOAD_AS_CSV": "下载为 CSV 文件",
                "DOWNLOAD_AS_PDF": "下载为 PDF 文件",
                "DOWNLOAD_FAILED": "下载失败",
                "DOWNLOAD_PREVIOUS_EXPORTS": "下载之前的导出文件...",
                "DO_YOU_WISH_TO_DELETE": "您是否要删除：",
                "DUPLICATE_PAGE": "复制工作表",
                "EDIT_REPORT": "编辑报告",
                "EDIT_REPORT_ELLIPSIS": "编辑报告...",
                "EDIT_VISUALIZATION": "编辑可视化对象",
                "EMAIL_ADDRESS": "电子邮件地址",
                "EMAIL_SENT": "电子邮件已发送...",
                "END_OF_REPORT": "报告结束",
                "ENTER_NAME": "输入名称",
                "ERROR_COPYING": "复制报告时出错。",
                "ERROR_DELETING": "删除报告时出错。",
                "ERROR_DELETING_EXPORT": "删除导出文件时出错。",
                "ERROR_HEADING": "错误",
                "ERROR_PUBLISHING": "保存设置时出错。",
                "ERROR_RENAMING": "重命名报告时出错。",
                "ERROR_REQUESTING_EXPORT": "请求导出时出错。",
                "ERROR_SAVING_GLOBAL_OPTIONS": "保存全局可视化对象选项时出错。",
                "ERROR_SEND_TEST_EMAIL": "发送测试电子邮件时出错。",
                "EVERY_FRIDAY": "每周五",
                "EVERY_MONDAY": "每周一",
                "EVERY_MONTH": "每月的",
                "EVERY_SATURDAY": "每周六",
                "EVERY_SUNDAY": "每周日",
                "EVERY_THURSDAY": "每周四",
                "EVERY_TUESDAY": "每周二",
                "EVERY_WEDNESDAY": "每周三",
                "EVERY_WEEK": "每周，间隔",
                "EXAMPLE_GROUP_NUM": "组 {{num}}",
                "EXAMPLE_SERIES_NUM": "序列 {{num}}",
                "EXPORT": "导出",
                "EXPORT_CSV": "CSV（逗号分隔）",
                "EXPORT_EXCEL_SPREADSHEET": "Excel 电子表格",
                "EXPORT_IMAGE": "导出图像",
                "EXPORT_PAGES": "导出页面",
                "EXPORT_PDF": "PDF 文档",
                "EXPORT_PPT_SLIDES": "PowerPoint 幻灯片",
                "EXPORT_RAW_DATA": "导出原始数据",
                "EXPORT_REPORT": "导出报告",
                "EXPORT_VISUALIZATION": "导出可视化对象",
                "EXPORT_WORD_DOC": "Word 文档",
                "FAILED_SAVE_TXT": "保存失败",
                "FILTERED": "已过滤",
                "FIRST_PAGE": "首页",
                "FIRST_WEEKDAY": "每月第一个工作日",
                "FROM": "从",
                "FROM_EMAIL": "来自电子邮件",
                "FROM_NAME": "发件人姓名",
                "GAUGE_CHART": "量表图",
                "GAUGE_CHART_DESC": "一种类似于度量测量工具的图表，用于比较当前值与目标值或一系列阈值。",
                "GENERATING_FILE": "正在生成文件...",
                "GENERATING_IMAGE": "正在生成图像...",
                "GENERATING_PDF": "正在生成 PDF...",
                "GENERIC_ERROR": "出错，无法加载您请求的项目。",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "全局选项...",
                "GLOBAL_METRIC": "默认度量",
                "GLOBAL_MODAL_PAGE_TITLE": "使用 Qualtrics Research Suite“结果”部分全局选项的可视化对象示例",
                "GLOBAL_MODAL_WIDGET_TITLE": "可视化对象标题",
                "GLOBAL_OPTIONS": "全局选项",
                "GLOBAL_PRECISION": "默认小数位数",
                "GLOBAL_SETTINGS_APPLY": "应用我的默认设置",
                "GLOBAL_SETTINGS_SAVE": "另存为我的默认设置",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "应用 Qualtrics 默认设置",
                "GROUP": "组",
                "HEAT_MAP_CHART": "热图图表",
                "HEAT_MAP_CHART_DESC": "成簇的“热量”型可视化对象，用于将用户输入的分布（如点击率）映射到原始图像。",
                "HIDDEN": "隐藏",
                "HIDDEN_PAGE": "此页面不会显示在公开报告中，在报告导出中被默认为取消选中。",
                "HIDE": "隐藏",
                "HIDE_ALL_PAGES": "隐藏全部页面",
                "HIDE_PAGE": "隐藏页面",
                "IMAGE_FILE": "图像文件",
                "INVALID_BRAND_DOMAIN": "您输入的域不在您品牌的获批电子邮件域清单中。请联系您的品牌管理员解决此问题。",
                "INVALID_SPF_RECORD": "您输入的域尚未批准 Qualtrics 从其发送电子邮件。这种情况会影响邮件送达。请使用其他域或联系 Qualtrics 处理此问题。",
                "ISSUE_SAVING_REPORTS": "一个或多个报告保存时遇到问题。请重试。",
                "ISSUE_SENDING_TEST": "发送测试电子邮件时出错。请重试。",
                "LARGE_SURVEY": "由于调查过大，将不显示结果。",
                "LAST_DAY": "每月最后一天",
                "LAST_MODIFIED_COLON_WITH_DATE": "上次修改时间：%1",
                "LAST_PAGE": "末页",
                "LAST_WEEKDAY": "每月最后一个工作日",
                "LATER": "稍后",
                "LEARN_MORE": "了解更多",
                "LINE_CHART": "线形图",
                "LINE_CHART_DESC": "根据 X 轴上的时间绘图时常用的两轴线形图。",
                "LOG_OUT_WARNING": "在 {{countdown}} 秒钟内点击任意位置可保持登录状态",
                "MESSAGE": "消息",
                "MONTHLY": "每月",
                "MOVE_DOWN": "下移可视化对象",
                "MOVE_PAGE_TO_BOTTOM": "移至底部",
                "MOVE_PAGE_TO_TOP": "移至顶部",
                "MOVE_UP": "上移可视化对象",
                "MY_SURVEYS": "我的项目",
                "NAME": "名称",
                "NEW_CUSTOM_PAGE_NAME": "新建自定义页面",
                "NEW_REPORT": "新建报告",
                "NEXT_PAGE": "下一页",
                "NEXT_RUN": "下一次运行",
                "NO_EXPORTS": "尚未请求导出此报告。",
                "NO_ITEMS_TO_DISPLAY": "没有可显示的项目",
                "NO_MATCHING_CUSTOM_PAGES": "没有匹配的自定义页面",
                "NO_MATCHING_PAGES": "未找到搜索页面",
                "NO_MATCHING_REPORTS": "没有匹配的报告。",
                "NO_PROJECT": "请指定一个项目以继续。",
                "NO_PROJECTS_TO_MIGRATE": "没有可更新的项目。",
                "NO_QUESTIONS": "没有匹配的问题",
                "NO_RESULTS_YET": "没有可显示的结果。请分发您的调查以收集回复。",
                "OFF": "关",
                "ON": "开",
                "PAGES_SELECTED": "选定页面",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "此选择将让报告包含 {{currentSelectedPageCount}} 页，超出了允许的最大值 {{reportSizeLimit}}。请选择较小的范围。",
                "PAGES_SELECTION_INVALID_RANGE": "请选择一个有效范围。",
                "PAGE_OPTIONS": "页面选项",
                "PDF_ROW_TRUNCATION_MESSAGE": "作为 PDF 行导出过多，尝试导出为 Word 或 CSV",
                "PERCENTAGE_METRIC": "百分比",
                "PIE_CHART": "饼图",
                "PIE_CHART_DESC": "给定数据点的值的圆形细分图。适用于测量选定值的相对比例。",
                "PREVIEW": "预览",
                "PREVIOUS_PAGE": "上一页",
                "PRINT_PAGE": "打印页面",
                "PUBLIC_LINK": "公共链接",
                "PUBLIC_REPORT_AVAILABLE": "公开报告可用",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "访问代码",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "访问代码不正确。请重试。",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "提交",
                "PUBLIC_RESULTS_LOGIN_TITLE": "公开报告登录 | Qualtrics 调查软件",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "未找到公开报告。请联系此报告的所有者让他们提供有效链接。",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "未找到公开报告",
                "PUBLIC_RESULTS_NOT_UPDATED": "更新公开报告链接和计划报告电子邮件后才能使用 Qualtrics XM Platform。",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "会话已过期。请重新登录，以继续预览公开结果报告。",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "会话过期",
                "PUBLIC_RESULTS_TITLE": "公开报告",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "您没有查看此页面的权限。请联系此报告的所有者让他们公开报告。",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "公开报告未授权",
                "PUBLISHED_LINK_GENERATING_LINK": "正在生成链接...",
                "PUBLISHED_REPORT_FOUND_HERE": "公开报告可通过以下链接访问：",
                "PUBLISH_REPORT": "管理公开报告",
                "PUBLISH_REPORT_ELLIPSIS": "管理公开报告...",
                "QUESTION": "问题",
                "RANK": "排序",
                "REMOVE_WIDGET": "移除可视化对象",
                "RENAME_PAGE": "重命名页面",
                "RENAME_REPORT": "重命名报告",
                "RENAME_REPORT_ELLIPSIS": "重命名报告...",
                "REPLY_TO_EMAIL": "回复电子邮件",
                "REPORT_COLON": "报告：",
                "REPORT_SETTINGS": "报告设置",
                "REPORT_SETTINGS_ELLIPSIS": "报告设置...",
                "RESPONSE_COUNTS": "回复计数",
                "RESULTS_DASHBOARDS_BANNER": "并尝试使用全新的改进版调查结果，其中包含现代化、便于访问的 UI 和数据可视化对象、新的分析和探索功能等。",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "发行说明",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "查看最新",
                "RESULTS_OPTIONS": "报告选项",
                "RESULTS_TITLE": "报告",
                "RESUME_DISTRIBUTION": "继续分发",
                "REVERT": "还原",
                "RICH_TEXT_LIMIT_REACHED": "内容长度已达到限值！",
                "SAVE": "保存",
                "SAVE_AND_CLOSE": "保存并关闭",
                "SAVE_AS_CSV": "将可视化对象另存为 CSV 文件",
                "SAVE_AS_IMAGE": "将可视化对象另存为图像",
                "SAVE_CONFIRMATION": "保存确认",
                "SAVE_PAGE_AS_ELLIPSIS": "导出页面为...",
                "SAVE_SETTINGS": "保存设置",
                "SCHEDULE_REPORT_EMAIL": "计划报告电子邮件",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "计划报告电子邮件...",
                "SEARCH_ELLIPSIS": "搜索...",
                "SEARCH_PAGES": "搜索问题",
                "SEARCH_PAGES_ELLIPSIS": "搜索页面...",
                "SEARCH_REPORTS_ELLIPSIS": "搜索报告...",
                "SELECTED": "已选定：",
                "SELECT_ALL": "全选",
                "SELECT_A_FIELD": "选择一个字段",
                "SELECT_A_WIDGET": "选择一个可视化对象",
                "SELECT_PAGES": "选择页面",
                "SELECT_PAGES_ELLIPSIS": "选择页面...",
                "SEND": "发送",
                "SEND_TEST_EMAIL": "发送测试电子邮件",
                "SETTING_DEFAULT": "默认",
                "SETTING_HIGH": "高",
                "SETTING_LARGE": "大",
                "SETTING_LOW": "低",
                "SETTING_NORMAL": "正常",
                "SETTING_SMALL": "小",
                "SHARE_REPORT": "分享报告",
                "SHOW_ALL_PAGES": "显示全部页面",
                "SHOW_FULL_QTEXT": "在页面标题中显示完整问题文本",
                "SIMPLE_TABLE": "简单表",
                "SIMPLE_TABLE_DESC": "可将多个值显示为行或列的灵活表。",
                "SIZE": "大小",
                "SPLINE_CHART": "样条图",
                "SPLINE_CHART_DESC": "根据 X 轴上的时间绘图时常用的两轴圆角线形图。",
                "STATISTICS_TABLE": "统计表",
                "SUBJECT": "对象",
                "SURVEY_ANALYSIS": "调查分析",
                "SURVEY_SUMMARY": "调查概要",
                "TABLE": "表描述",
                "TIME": "时间",
                "TO": "收件人",
                "TOTAL": "总计",
                "TRANSPOSE_STATS_TABLES": "转置统计表",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "转置统计表分类",
                "TRUNCATE_PAGE_TITLES": "缩短页面标题中的问题文本",
                "TRY_IT_NOW": "立即试用",
                "TYPE": "类型",
                "UNABLE_TO_CHECK_SPF": "无法检查 SPF 记录。请重试。",
                "UNAUTHORIZED": "您不能查看此报告。请联系相应所有者获取访问权限。",
                "UNHIDE_PAGE": "取消隐藏页面",
                "UPDATE": "更新",
                "UPDATED_SUCCESSFULLY": "更新成功。",
                "UPDATE_ALL_IN_THIS_PROJECT": "更新此项目中的全部内容",
                "UPDATE_ALL_PROJECTS": "更新全部项目",
                "UPDATE_NOW": "立即更新",
                "UPDATE_REPORTS": "更新报告...",
                "UPDATE_REPORT_ELEMENTS": "更新公开报告链接和计划报告电子邮件",
                "UPGRADE_MY_ACCOUNT": "升级我的帐户",
                "USE_EXPORT_TAGS": "包括问题编号",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "使用简单表列总计",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "使用简单表调查对象总计",
                "USE_WEIGHTED_METRICS": "使用加权指标",
                "VIEW": "查看",
                "WEEKLY": "每周",
                "WELCOME_TO_NEW_RESULTS": "欢迎使用 Qualtrics XM Platform 报告！",
                "WHEN": "时间",
                "WIDGET_LOADING": "正在加载...",
                "WIDGET_OPTIONS_ERR": "加载可视化对象选项失败",
                "WIDGET_TYPE": "可视化对象",
                "WORD_CLOUD": "文字云",
                "WORD_CLOUD_DESC": "文本数据中文字频率的加权可视化对象，包含附加颜色编码选项。"
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "请记住，公司有可以帮助您解读反馈的资源，例如：人力资源合作伙伴、您的经理和/或导师。",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "倒一杯咖啡，然后深入研究反馈。",
                "ABOUT_YOUR_REPORT_HEADER": "关于报告",
                "ABOUT_YOUR_REPORT_LINE1": "欢迎使用 360 反馈报告。这是一个有助于自己成长、发展为专业人士的好机会。为确保检查细致并获得成功的结果，请留出足够的时间来查看反馈。收集反馈总会遇到困难，但是请记住，此反馈旨在帮助您更快地成长和发展。",
                "ABOUT_YOUR_REPORT_LINE2": "查看报告时，请注意以下几点。",
                "ADD_CONDITIONAL_TEXT": "添加条件文本",
                "ADD_CUSTOM_PALETTE": "添加自定义调色板",
                "ADD_DATA_SOURCE": "添加数据源",
                "ADD_FOLLOWING": "添加以下项",
                "ADD_LABEL": "添加标签",
                "ADVANCED_FILTER": "高级过滤器",
                "AGREEMENT_CHART": "协议图",
                "AGREEMENT_CHART_FOOTER": "协议图表示得分的相似性。每个点代表人员如何评价您的每个项目。点的大小显示有多少个评分者提供特定的评分。",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "回复",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "回复",
                "AGREEMENT_CHART_LEGEND_TITLE": "他人对您的评价",
                "ALL": "全部",
                "AND_IF": "And if",
                "ANGLED": "倾斜",
                "AREA": "面积图",
                "AUTO": "自动",
                "AVERAGE": "平均值",
                "AXIS_VALUES": "坐标轴值",
                "BAR": "条形图",
                "BASE_WORD_COLOR": "文字基色",
                "BLUR": "模糊",
                "BOTTOM_BOX": "低位评分",
                "BREAKOUT_HEADERS": "分类标头",
                "CANCEL": "取消",
                "CATEGORICAL": "分类",
                "CATEGORY": "类别",
                "CATEGORY_NAME": "类别名称",
                "CHANGE_CATEGORIES_ORDER": "更改类别顺序",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "更改评分类别顺序",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "点击评分类别元素的左侧并将其拖动到所需位置，更改在可视化对象中显示的顺序。",
                "CHANGE_QUESTIONS_ORDER": "更改问题顺序",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "更改问题顺序",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "点击问题元素的左侧并将其拖动到所需位置，更改在可视化对象中显示的顺序。",
                "CHARTS": "图表",
                "CHART_TYPE": "图表类型",
                "CHOICE_COUNT": "选择计数",
                "CHOICE_TOTALS": "选择总计",
                "CLEAR": "清除",
                "CLOSE": "关闭",
                "COLOR_PALETTE": "调色板",
                "COLUMN_NAMES": "列名称",
                "COLUMN_TOTALS": "列总计",
                "COMPARED_FILTER_GROUP": "比较过滤器组",
                "COMPARED_FILTER_GROUPS": "比较过滤器组",
                "COMPARE_WITH": "比较对象",
                "COMPETITION_RANKING": "使用竞争排名",
                "COMPETITION_RANKING_TOOLTIP": "如果出现平局，所有相同的分数都将获得相同的排名。但是，下一个后续项目的排名将等于：表中排名较高的项目总数加一。",
                "COMPLETED_RESPONSES": "已完成回复",
                "CONDITIONAL_TEXT": "条件文本",
                "COUNT": "计数",
                "CREATE": "创建",
                "CUSTOM_PALETTE": "自定义调色板",
                "DATA_SOURCE_TYPE": "数据源类型",
                "DATA_SOURCE_TYPE_CATEGORY": "评分类别",
                "DATA_SOURCE_TYPE_QUESTION": "问题",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "问题",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "可排名项目",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "评分类别",
                "DEFAULT": "默认",
                "DEFAULT_TEXT": "默认文本",
                "DELETE": "删除",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "了解反馈的来源，即：来自同级同事、直接下属、领导等",
                "DIFFERENT_EVALUATORS_HEADER": "不同的评估者",
                "DIRECT_REPORTS": "直接下属",
                "DISABLED": "禁用",
                "DISPLAY_OPTIONS": "显示选项",
                "DISPLAY_THRESHOLD_TEXTS": "根据以下组差距显示文本",
                "DIVERGENT": "发散式",
                "DONE": "完成",
                "DONT_HEADER": "请勿：",
                "DONT_LINE1": "尝试查明反馈内容及提供反馈的人员",
                "DONT_LINE2": "过于关注某一项正面或负面的得分/评论",
                "DONT_LINE3": "围绕每个项目制定发展计划",
                "DONT_LINE4": "因有待改进之处而气馁",
                "DONUT": "圆环",
                "DOWNLOAD_CSV": "下载旧版 CSV",
                "DOWNLOAD_ZIP": "下载全部文件",
                "DO_HEADER": "请：",
                "DO_LINE1": "整体看待反馈",
                "DO_LINE2": "确定强项和有待改进之处的主题",
                "DO_LINE3": "优先考虑几个重点区域，并将其添加到发展计划中",
                "DO_LINE4": "明白“人无完人”的道理",
                "DROPOFF": "下降率",
                "DUPLICATE": "重复",
                "EDIT_CONDITIONAL_TEXT": "编辑条件文本",
                "EDIT_CUSTOM_PALETTE": "编辑自定义调色板",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "否则显示以下文本",
                "ENABLED": "已启用",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "启用按评分者分类显示逻辑排序",
                "ENABLE_ORDERING_FOR": "启用以下项的排序：",
                "EQUAL_TO": "等于",
                "FIELD": "字段",
                "FILTER_NAMES": "过滤器名称",
                "FOLLOWING_PARENTHESES": "（以下）",
                "FOOTER": "页脚",
                "GAP": "差距",
                "GAP_CHART": "差距图",
                "GAP_CHART_DESCRIPTION": "差距图显示两个评分者组之间得分的差异。例如，对于自我评价与他人对您的评价，正 (+) 差异表示他人对您的评价高于您的自我评价。负 (-) 差异表示他人对您的评价低于您的自我评价。",
                "GAP_CHART_FOOTER": "差距图表示两个评分者组之间的 +/- 差异。",
                "GAP_TABLE_DESCRIPTION": "隐藏的强项表明他人对您的评价高于您的自我评价。改进领域表明他人对您的评价低于您的自我评价。两个部分按最大差距到最小差距排名。",
                "GAP_TABLE_FOOTER": "得分的第一列表示您对自己的评分。第二列表示其他人的平均评分。第三列表示您对自己的评分与其他人对您的评分之间的差异。",
                "GAP_TABLE_TITLE": "隐藏的强项/改进领域",
                "GREATER_OR_EQUAL": "大于或等于",
                "GREATER_THAN": "大于",
                "GROUP": "组",
                "GROUPED_FOR_ANONYMITY": "已匿名分组",
                "HEADER_NAMES": "标头名称",
                "HIGHEST_SCORES": "最高分",
                "HIGHLIGHT_THRESHOLD": "高亮显示差距的阈值",
                "HIGHLOW_TABLE": "高低分",
                "HIGHLOW_TABLE_FOOTER": "此部分显示适用评分者分类平均值中（在所有行为中）评分最高和最低的五种行为。为充分利用此页面，找出可能出现的趋势会有所帮助。例如，如果评分最低的大多数行为集中在一两个分类中；这些就可能是需要改进的领域。评分最高的行为可以识别出在其他领域中可以利用的强项。",
                "HIGH_LOW_TABLE_DESCRIPTION": "高/低图根据他人对您评价最高和最低的领域显示项目。",
                "HORIZONTAL": "水平",
                "HORIZONTAL_AND_VERTICAL": "水平和垂直",
                "HORIZONTAL_BAR": "水平条形图",
                "HOW_TO_INTERPRET_RESULT_HEADER": "如何解读反馈结果并确定措施：",
                "IF": "If",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "包括百分比形式的隐藏标签",
                "INNER_RIM": "内环",
                "IS": "是",
                "IS_NOT": "不是",
                "IS_SAME_AS_SUBJECT": "与对象相同",
                "ITEM": "项目",
                "LABEL": "标签",
                "LABELS": "标签",
                "LARGE_LABELS": "大标签",
                "LEGEND": "图例",
                "LEGEND_POSITION": "图例位置",
                "LEGEND_VALUES": "图例值",
                "LESS_OR_EQUAL": "小于或等于",
                "LESS_THAN": "小于",
                "LINE": "线图",
                "LOWEST_SCORES": "最低分",
                "MANAGERS": "经理",
                "MANUAL_FONT_SIZE": "手动设置字号",
                "MAX": "最大值",
                "MEAN": "平均值",
                "MEDIAN": "中位数",
                "METRIC_TYPE": "指标类型",
                "MIN": "最小值",
                "MODIFY_CUSTOM_PALETTES": "修改自定义调色板",
                "MOVE_DOWN": "下移",
                "MOVE_UP": "上移",
                "MULTI_SELECT_ITEMS_SELECTED": "已选择项",
                "NEGATIVE_GAPS": "改进领域",
                "NO": "否",
                "NONE": "无",
                "NOT_APPLICABLE": "不适用",
                "NOT_EQUAL_TO": "不等于",
                "NO_DATA_AVAILABLE_WARNING": "无可用数据",
                "NO_FILTER": "无过滤器",
                "NO_FILTER_IS_APPLIED": "未应用过滤器。",
                "NO_VALUE": "无值",
                "NPS": "净推荐值",
                "NUMBER": "编号",
                "NUMBERS": "编号",
                "NUMBER_OF_GAPS_NEGATIVE": "负差距数量",
                "NUMBER_OF_GAPS_POSITIVE": "正差距数量",
                "NUMBER_OF_ROWS_HIGH": "高行数量",
                "NUMBER_OF_ROWS_LOW": "低行数量",
                "OPTIONS": {
                    "HEADER_NAME": "标头名称",
                    "LEGEND": "图例",
                    "SCALE_AXIS_CHANGER_TITLE": "范围"
                },
                "ORIENTATION": "方向",
                "OR_IF": "Or if",
                "OTHER": "其他",
                "OTHERS": "其他",
                "PAGE_OF": "页码：%1/%2",
                "PALETTE_REMOVED": "调色板已移除",
                "PEERS": "同级同事",
                "PERCENT": "百分比",
                "PERCENTAGE": "百分比",
                "PERCENTAGE_OF_CHOICES": "选择百分比",
                "PERCENTAGE_OF_RESPONSES": "回复百分比",
                "PERCENT_COMPLETE": "% 完成",
                "PERSON_METADATA": "个人元数据",
                "PERSON_METADATA_EVALUATOR": "评估者",
                "PERSON_METADATA_SUBJECT": "对象",
                "PERSON_METADATA_VIEWER": "查看者",
                "POSITIVE_GAPS": "隐藏的强项",
                "PRIMARY_PARENTHESES": "（主要）",
                "QUESTIONS": "问题",
                "RADIUS": "半径",
                "RANK": "排序",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "最高分",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "最高分",
                "RANKABLE_ITEMS_ITEM_HAS": "项目有",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "项目在前",
                "RANKABLE_ITEMS_LOWEST_SCORE": "最低分",
                "RANKABLE_ITEMS_LOWEST_SCORES": "最低分",
                "RATER_CATEGORY_DISPLAY_LOGIC": "评分者分类显示逻辑",
                "RATIO": "比率",
                "RECORD": "记录",
                "REFERENCE_GROUP": "参照组",
                "RELATIONSHIP": "关系",
                "RELATIONSHIP_FILTERS": "关系过滤器",
                "RELATIONSHIP_FILTERS_INFO": "要添加关系过滤器（例如直接下属、同级同事或经理），请选择“管理过滤器”，然后从下拉菜单中仅使用“关系条件”。",
                "REMOVE": "删除",
                "REMOVE_DATA_SOURCE": "移除数据源",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "请记住，公司有可以帮助您解读反馈的资源，例如：人力资源合作伙伴、您的经理和/或导师。",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "倒一杯咖啡，然后深入研究反馈。",
                    "ABOUT_YOUR_REPORT_HEADER": "关于报告",
                    "ABOUT_YOUR_REPORT_LINE1": "欢迎使用 360 反馈报告。这是一个有助于自己成长、发展为专业人士的好机会。为确保检查细致并获得成功的结果，请留出足够的时间来查看反馈。收集反馈总会遇到困难，但是请记住，此反馈旨在帮助您更快地成长和发展。",
                    "ABOUT_YOUR_REPORT_LINE2": "查看报告时，请注意以下几点。",
                    "ADVANCED_FILTER": "高级过滤器",
                    "AGREEMENT_CHART": "协议图",
                    "AGREEMENT_CHART_FOOTER": "协议图表示得分的相似性。每个点代表人员如何评价您的每个项目。点的大小显示有多少个评分者提供特定的评分。",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "回复",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "回复",
                    "AGREEMENT_CHART_LEGEND_TITLE": "他人对您的评价",
                    "ALL": "全部",
                    "AVERAGE": "平均值",
                    "BOTTOM_BOX": "低位评分",
                    "CHOICE_COUNT": "选择计数",
                    "CHOICE_TOTALS": "选择总计",
                    "COMPARISON": "比较",
                    "COMPARISON_GAP_COLUMN_HEADER": "比较差距",
                    "COMPLETED_RESPONSES": "已完成回复",
                    "COUNT": "计数",
                    "DEFAULT": "默认",
                    "DEFAULT_TEXT": "默认文本",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "了解反馈的来源，即：来自同级同事、直接下属、领导等",
                    "DIFFERENT_EVALUATORS_HEADER": "不同的评估者",
                    "DONE": "完成",
                    "DONT_HEADER": "请勿：",
                    "DONT_LINE1": "尝试查明反馈内容及提供反馈的人员",
                    "DONT_LINE2": "过于关注某一项正面或负面的得分/评论",
                    "DONT_LINE3": "围绕每个项目制定发展计划",
                    "DONT_LINE4": "因有待改进之处而气馁",
                    "DO_HEADER": "请：",
                    "DO_LINE1": "整体看待反馈",
                    "DO_LINE2": "确定强项和有待改进之处的主题",
                    "DO_LINE3": "优先考虑几个重点区域，并将其添加到发展计划中",
                    "DO_LINE4": "明白“人无完人”的道理",
                    "FIELD": "字段",
                    "GAP": "差距",
                    "GAP_CHART": "差距图",
                    "GAP_CHART_DESCRIPTION": "差距图显示两个评分者组之间得分的差异。例如，对于自我评价与他人对您的评价，正 (+) 差异表示他人对您的评价高于您的自我评价。负 (-) 差异表示他人对您的评价低于您的自我评价。",
                    "GAP_CHART_FOOTER": "差距图表示两个评分者组之间的 +/- 差异。",
                    "GAP_TABLE_DESCRIPTION": "隐藏的强项表明他人对您的评价高于您的自我评价。改进领域表明他人对您的评价低于您的自我评价。两个部分按最大差距到最小差距排名。",
                    "GAP_TABLE_FOOTER": "得分的第一列表示您对自己的评分。第二列表示其他人的平均评分。第三列表示您对自己的评分与其他人对您的评分之间的差异。",
                    "GAP_TABLE_TITLE": "隐藏的强项/改进领域",
                    "GROUP": "组",
                    "HIDE_REPORT_ALERT": "您不符合查看报告的要求。请联系组织管理员。",
                    "HIGHEST_SCORES": "最高分",
                    "HIGHLOW_TABLE": "高低分",
                    "HIGHLOW_TABLE_FOOTER": "此部分显示适用评分者分类平均值中（在所有行为中）评分最高和最低的五种行为。为充分利用此页面，找出可能出现的趋势会有所帮助。例如，如果评分最低的大多数行为集中在一两个分类中；这些就可能是需要改进的领域。评分最高的行为可以识别出在其他领域中可以利用的强项。",
                    "HIGH_LOW_TABLE_DESCRIPTION": "高/低图根据他人对您评价最高和最低的领域显示项目。",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "如何解读反馈结果并确定措施：",
                    "ITEM": "项目",
                    "LOWEST_SCORES": "最低分",
                    "MAX": "最大值",
                    "MEAN": "平均值",
                    "MEDIAN": "中位数",
                    "MIN": "最小值",
                    "NEGATIVE_GAPS": "改进领域",
                    "NO_COMPARISON_SET": "未设置比较",
                    "NO_DATA_AVAILABLE_WARNING": "无可用数据",
                    "NO_FILTER_IS_APPLIED": "未应用过滤器。",
                    "NO_VALUE": "无值",
                    "NPS": "净推荐值",
                    "OTHERS": "其他",
                    "PERCENTAGE": "百分比",
                    "PERCENTAGE_OF_CHOICES": "选择百分比",
                    "PERCENTAGE_OF_RESPONSES": "回复百分比",
                    "PERCENT_COMPLETE": "% 完成",
                    "POSITIVE_GAPS": "隐藏的强项",
                    "QUESTIONS": "问题",
                    "RANK": "排序",
                    "RELATIONSHIPS": {
                        "ANYONE": "任何人",
                        "DIRECT_REPORT": "直接下属",
                        "MANAGER": "经理",
                        "PEER": "同级同事",
                        "SELF": "本人"
                    },
                    "REPORT_SUMMARY": "报告概要",
                    "REPORT_SUMMARY_TABLE_FOOTER": "比较完成评估的人数与受邀参与评估的人数。",
                    "REPORT_SUMMARY_TABLE_HEADER": "调查对象统计",
                    "RESPONSES": "回复",
                    "RESPONSE_COUNT": "{{responseCount}} 个回复",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> 个回复",
                    "SCORING_CATEGORY": "评分类别",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "没有此类别的回复",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "没有此问题的回复",
                    "SCORING_OVERVIEW": "评分概览",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "您和其他评估者认为此领域是最大强项。",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "公认的强项",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "公认的改进领域意味着自我评估和他人评估均低于此能力的平均水平。",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "公认的改进领域",
                    "SCORING_OVERVIEW_DESCRIPTION": "以上是您在多评分者反馈过程中所评估的能力或行为。比较评估按组提供。",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "最小差距",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "显示文本的参考组之间的最小差异。",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "显示的是每种能力/行为的得分范围。水平条表示数值平均值。",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "不为人知的强项来自自我评估与他人评估之间的差异。",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "不为人知的强项",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "不为人知的改进领域来自自我评估与他人评估之间的差异。",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "不为人知的改进领域",
                    "SELF": "本人",
                    "SELF_ASSESSMENT": "自我评估",
                    "STANDARD_DEVIATION": "标准偏差",
                    "SUM": "总和",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "熟悉评估尺度，以确保准确的解读",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "记录尺度",
                    "THINGS_YOU_WILL_SEE_HEADER": "您将看到的内容：",
                    "THREE_SIXTY_PERCENTILE": "百分位",
                    "TOP_BOTTOM_BOX": "高/低位评分",
                    "TOP_BOX": "高位评分",
                    "TOTAL": "总计",
                    "TO_DO": "待完成",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "定性：反馈采用开放文本备注的形式",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "定量：反馈为数字反馈，可以用图形、条形图、表等表示。",
                    "TYPES_OF_FEEDBACK_HEADER": "各种类型的反馈",
                    "VALUE": "值",
                    "VARIANCE": "差异",
                    "YOUR_RATINGS": "您的评估"
                },
                "REPORT_SUMMARY": "报告概要",
                "REPORT_SUMMARY_TABLE_FOOTER": "比较完成评估的人数与受邀参与评估的人数。",
                "REPORT_SUMMARY_TABLE_HEADER": "调查对象统计",
                "RESET": "重置",
                "RESPONDENT_TOTALS": "调查对象总计",
                "RESPONSES": "回复",
                "RESPONSE_COUNT": "{{responseCount}} 个回复",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> 个回复",
                "RESULT": "结果",
                "REVERSE_COLORS": "反转颜色",
                "ROW_TOTALS": "行总计",
                "SAVE": "保存",
                "SAVE_AND_APPLY": "保存并应用",
                "SCORING_CATEGORY": "评分类别",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "没有此类别的回复",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "没有此问题的回复",
                "SCORING_OVERVIEW": "评分概览",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "您和其他评估者认为此领域是最大强项。",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "公认的强项",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "公认的改进领域意味着自我评估和他人评估均低于此能力的平均水平。",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "公认的改进领域",
                "SCORING_OVERVIEW_DESCRIPTION": "以上是您在多评分者反馈过程中所评估的能力或行为。比较评估按组提供。",
                "SCORING_OVERVIEW_MINIMUM_GAP": "最小差距",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "显示文本的参考组之间的最小差异。",
                "SCORING_OVERVIEW_TABLE_FOOTER": "显示的是每种能力/行为的得分范围。水平条表示数值平均值。",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "不为人知的强项来自自我评估与他人评估之间的差异。",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "不为人知的强项",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "不为人知的改进领域来自自我评估与他人评估之间的差异。",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "不为人知的改进领域",
                "SELECT_CATEGORIES": "请选择评分类别...",
                "SELECT_CATEGORY": "请选择评分类别...",
                "SELECT_CONDITION_TYPE": "选择条件类型",
                "SELECT_DATA_SOURCE": "选择数据源",
                "SELECT_DATA_SOURCE_TYPE": "选择数据源类型",
                "SELECT_FILTER": "选择过滤器",
                "SELECT_FILTERS": "选择过滤器",
                "SELECT_OPERATOR_TYPE": "选择运算符类型",
                "SELECT_PERSON": "选择人员",
                "SELECT_PERSON_METADATA": "选择人员元数据",
                "SELECT_QUESTION": "选择问题",
                "SELECT_QUESTIONS": "请选择问题...",
                "SELECT_RATIO_OR_DROPOFF": "选择比率或下降率",
                "SELECT_RELATIONSHIP": "选择关系",
                "SELECT_SCORING_CATEGORY": "选择评分类别",
                "SELF": "本人",
                "SELF_ASSESSMENT": "自我评估",
                "SEQUENTIAL": "顺序",
                "SETUP_COMPARISON": "设置比较",
                "SETUP_COMPARISONS": "设置比较",
                "SET_START_COLOR": "设置开始颜色",
                "SHOULD_SHOW_FOOTER": "显示页脚",
                "SHOULD_SHOW_SCORING_CATEGORY": "显示评分类别",
                "SHOWING_RECORDS_OF": "显示记录：%1 - %2 个，共 %3 个",
                "SHOW_COMPARISON_GAP": "显示比较差距列",
                "SHOW_DATA_LABEL": "显示数据值",
                "SHOW_PERCENTAGES": "显示百分比",
                "SHOW_THE_FOLLOWING_TEXT": "则显示以下文本",
                "SHOW_TIES": "显示联系",
                "SHOW_X_AXIS": "显示 X 轴",
                "SHOW_Y_AXIS": "显示 Y 轴",
                "SMALL_LABELS": "小标签",
                "SORT": "排序",
                "SPLINE": "样条图",
                "STACK_CHART": "堆叠图",
                "STANDARD_DEVIATION": "标准偏差",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "弱项 - 低于",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "编辑阈值文本",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "阈值文本",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "启用阈值文本",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "强项 - 高于",
                "SUM": "总和",
                "SUMMARY": "概要",
                "TABLES": "表格",
                "TABLE_TOTALS": "表格总数",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "熟悉评估尺度，以确保准确的解读",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "记录尺度",
                "TEXT": "文本",
                "THINGS_YOU_WILL_SEE_HEADER": "您将看到的内容：",
                "TOP_BOTTOM_BOX": "上端范围/下端范围",
                "TOP_BOX": "高位评分",
                "TOTAL": "总计",
                "TOTAL_COUNTS": "总计数",
                "TO_DO": "待完成",
                "TRANSPOSE": "转置",
                "TRANSPOSE_TABLE": "转置表",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "定性：反馈采用开放文本备注的形式",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "定量：反馈为数字反馈，可以用图形、条形图、表等表示。",
                "TYPES_OF_FEEDBACK_HEADER": "各种类型的反馈",
                "UNDO": "撤消",
                "USE_COMPARISON": "使用比较",
                "USE_LABELS_FOR_SCALES": "使用尺度标签",
                "VALUES": "值",
                "VALUE_RANGES": "值范围",
                "VARIANCE": "差异",
                "VERTICAL": "垂直",
                "VERTICAL_RANGE": "垂直范围",
                "WARNING_DATA_OUT_OF_RANGE": "警告： 数据值超出范围配置",
                "WIDGET_ERROR": {
                    "ERROR": "出现意外错误",
                    "MISCONFIGURED": "此小组件配置不正确。请检查您的小组件配置。",
                    "NEW": "请配置小组件",
                    "NO_DATA": "未找到数据 - 您的过滤器可能过于狭隘！"
                },
                "WIDGET_NAME": {
                    "BAR": "条形图",
                    "BREAKDOWNBAR": "细分条形图",
                    "DATA_TABLE": "数据表",
                    "FUNNEL_CHART": "漏斗图",
                    "GAUGE": "量表图",
                    "GRID": "结果表",
                    "HEATMAP": "热图",
                    "LINE": "线形图",
                    "NEEDS_BASED": "需求导向",
                    "PIE": "饼图",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "价格估算器 (Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "收入最大化器 (Gabor Granger)",
                    "SCORING_OVERVIEW_CHART": "图表",
                    "SCORING_OVERVIEW_TABLE": "表格",
                    "STATS_TABLE": "统计表",
                    "WORDCLOUD": "文字云"
                },
                "WORD_ROTATION": "文字旋转",
                "WORD_SPACING": "字间距",
                "YES": "是",
                "YOUR_RATINGS": "您的评估"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "添加",
                "ADD_A_WORD": "添加文字",
                "COLOR": "颜色",
                "DELETE_ALL": "全部删除",
                "EDIT_STOP_WORDS": "编辑终止词",
                "MAX_WORDS": "最大字数",
                "ROTATION_ANGLED": "倾斜",
                "ROTATION_HORIZONTAL": "水平",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "水平和垂直",
                "WORD_ORIENTATION": "文字方向"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "背景色",
                "DISPLAY_OPTIONS": "显示选项",
                "INVERT_FONT_COLORS": "反转低对比度字体颜色",
                "PAGE": "第  页",
                "PAGINATE": "分页"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "平均值",
                "BOTTOM_BOX_METRIC": "下方框",
                "COLUMNS": "列",
                "COUNT_METRIC": "总回复",
                "FIELD_NAME": "字段",
                "MAX_METRIC": "最大值",
                "MIN_METRIC": "最小值",
                "SHOW_RECODES": "显示重新编码值",
                "SHOW_ROW_NUMBERS": "显示行编号",
                "STD_DEV_METRIC": "标准差",
                "TOP_BOX_METRIC": "上方框",
                "TRANSPOSE_BREAKOUTS": "转置分类",
                "TRANSPOSE_TABLE": "转置表格",
                "VAR_METRIC": "方差"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "附加列",
                "ADD_COLUMNS": "添加附加列",
                "ADD_CUSTOM_PALETTE": "添加自定义调色板",
                "ALL_CHOICES": "全部选择",
                "ALL_GROUPS": "所有组",
                "ALL_RECODES": "全部记录",
                "AUTOMATIC": "默认",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "默认值 - 点击编辑",
                "AXIS_VALUES": "坐标轴值",
                "BREAKOUT_BY": "分类方式",
                "CANCEL": "取消",
                "CATEGORICAL": "分类",
                "CHOICES": "选择",
                "CHOICE_COUNT": "选择计数",
                "COLOR_PALETTE": "调色板",
                "COLUMN_VALUES": "列值",
                "CONTACT_FIELDS": "联系人字段",
                "COUNT": "计数",
                "CREATE": "创建",
                "CUSTOM": "自定义",
                "CUSTOM_PALETTE": "自定义调色板",
                "DATA_SOURCE": "数据源",
                "DAY": "天",
                "DAY_OF_WEEK": "星期",
                "DECIMAL_PRECISION": "小数位",
                "DEFAULT": "默认",
                "DISABLED": "禁用",
                "DIVERGENT": "发散式",
                "EDIT_CUSTOM_PALETTE": "编辑自定义调色板",
                "ENABLED": "已启用",
                "ERROR_LOADING_DATA": "加载数据时出错",
                "FILE_SIZE": "大小",
                "FILE_TYPE": "类型",
                "FRI": "周五",
                "FRIDAY": "星期五",
                "GROUP_DATE_BY": "日期分组方式",
                "HOUR_OF_DAY": "时间",
                "LENGEND_VALUES": "图例值",
                "MAX": "最大值",
                "MEAN": "平均值",
                "MIN": "最小值",
                "MISCONFIGURED_DATA": "此可视化对象的数据源配置错误。",
                "MISCONFIGURED_FILTERS": "过滤器无效",
                "MODIFY_CUSTOM_PALETTES": "修改自定义调色板",
                "MON": "周一",
                "MONDAY": "星期一",
                "MONTH": "月",
                "NONE": "无",
                "NO_FILE_ID_ERROR": "此可视化对象需要在调查中设置图像",
                "NO_RESULTS_TO_SHOW": "没有可显示的结果",
                "NPS": "净推荐值®",
                "NPS_GROUP": "NPS® 组",
                "NUMERIC_VALUE": "数值",
                "PALETTE_REMOVED": "调色板已移除",
                "PERCENTAGE": "百分比",
                "PERCENTAGE_OF_CHOICES": "选择百分比",
                "PERCENTAGE_OF_RESPONSES": "回复百分比",
                "QUARTER": "季度",
                "REMOVE": "删除",
                "RESPONSE_COUNT": "回复计数",
                "RESULTS_PER_PAGE": "每页结果数",
                "RETRIEVING_DATA_ELLIPSIS": "正在检索数据...",
                "REVERSE_COLORS": "反转颜色",
                "ROW_VALUES": "行值",
                "SAT": "周六",
                "SATURDAY": "星期六",
                "SAVE": "保存",
                "SELECTED_CHOICE": "选定的选择",
                "SELECT_FIELD": "选择字段",
                "SELECT_METRIC": "度量",
                "SEQUENTIAL": "顺序",
                "SET_START_COLOR": "设置开始颜色",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "正在显示采样数据...",
                "SUM": "总和",
                "SUN": "周日",
                "SUNDAY": "星期日",
                "SURVEY_EMBEDDEDDATA": "嵌入式数据",
                "SURVEY_METADATA": "调查元数据",
                "TEXT_ENTRY": "文本输入",
                "THURS": "周四",
                "THURSDAY": "星期四",
                "TITLE": "标题",
                "TUES": "周二",
                "TUESDAY": "星期二",
                "UNBOUNDED_DOMAIN": "要显示的值过多。",
                "UNBOUNDED_DOMAIN_HELP": "要将此字段添加到结果报告，您可以将过滤器添加到报告以显示更少的“{{ed_field_name}}”值，或更新您的调查流程中的“{{ed_field_name}}”嵌入式数据变量类型以使此字段成为字符串或数字类型。",
                "UNDO": "撤消",
                "USE_CHOICE_TOTALS": "使用选择总计",
                "USE_RESPONDENT_TOTALS": "使用调查对象总计",
                "VISUALIZATION": "可视化对象",
                "VISUALIZATION_BARCHART": "条形图",
                "VISUALIZATION_BREAKDOWNBAR": "细分条形图",
                "VISUALIZATION_GAUGE": "量表图",
                "VISUALIZATION_HEATMAP": "热图",
                "VISUALIZATION_LINECHART": "线形图",
                "VISUALIZATION_PAGINATEDTABLE": "编页表",
                "VISUALIZATION_PIE": "饼图",
                "VISUALIZATION_SIMPLETABLE": "简单表",
                "VISUALIZATION_STATSTABLE": "统计表",
                "VISUALIZATION_TEXTHIGHLIGHTS": "文本高亮显示",
                "VISUALIZATION_WORDCLOUD": "文字云",
                "WED": "周三",
                "WEDNESDAY": "星期三",
                "WEEK": "周",
                "WEIGHTING": "加权",
                "WRONG_QUESTION_TYPE_ERROR": "此可视化对象类型无法用于此问题",
                "YEAR": "年"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "平均值",
                "CHOICE_COUNT": "选择计数",
                "COUNT": "计数",
                "DISPLAY_OPTIONS": "显示选项",
                "MAX": "最大值",
                "MIN": "最小值",
                "NPS": "NPS®",
                "PAGE_OF": "页码：%1/%2",
                "PERCENT": "百分比",
                "RESPONSE_COUNT": "回复计数",
                "ROWS_PER_TABLE": "表格行数",
                "SHOWING_ROWS_OF": "显示行数：%1 - %2 行，共 %3 行",
                "SHOW_PERCENTAGES": "显示百分比",
                "SHOW_RECODES": "显示重新编码值",
                "SHOW_ROW_NUMBERS": "显示行编号",
                "SUM": "总和",
                "TOTAL": "总计",
                "TRANSPOSE": "转置",
                "USE_COLUMN_TOTALS": "使用列总数",
                "USE_ROW_TOTALS": "使用行总数",
                "VALUE": "值"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "升序",
                "COUNT": "计数",
                "DESCENDING": "降序",
                "DIAGONAL": "对角线",
                "DISPLAY_OPTIONS": "显示选项",
                "ERROR_COLON": "错误：",
                "ERROR_GENERIC": "加载可视化对象时出错。",
                "HORIZONTAL": "水平",
                "HORIZONTAL_BARS": "水平条形图",
                "INCORRECTLY_CONFIGURED": "选择一个值以显示图表",
                "LEGEND_AUTO": "自动",
                "LEGEND_BOTTOM": "底部",
                "LEGEND_INSET": "插入",
                "LEGEND_RIGHT": "右侧",
                "NORMALIZE_TO_PERCENTAGES": "标准化为百分比",
                "SHOW_BAR_LABELS": "显示柱标签",
                "SHOW_LEGEND": "显示图例",
                "SHOW_X_AXIS": "显示 X 轴",
                "SHOW_Y_AXIS": "显示 Y 轴",
                "SORT_BAR_VALUES": "排序柱值",
                "STACKED_BARS": "堆积条形图",
                "TRANSPOSE": "转置",
                "TRUNCATE_LABELS": "截短标签",
                "VERTICAL": "垂直"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "其他全部",
                "COULD_NOT_LOAD_DATA": "无法加载具有指定配置的数据 — 请尝试其他源字段或更大日期范围。",
                "GROUPING_PERCENTAGE_THRESHOLD": "分组百分比阈值",
                "NO_DATA": "无数据",
                "RADIUS": "内径",
                "SHOW_AS_PERCENTAGES": "显示为百分比"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "关闭",
                "DOWNLOAD_CSV": "下载 CSV",
                "DOWNLOAD_ZIP": "下载全部文件",
                "NO_DATA": "无数据",
                "PAGE_OF": "页码：%1/%2",
                "RESULTS_PER_PAGE": "每页结果数",
                "SHOWING_RECORDS_OF": "显示记录：%1 - %2 个，共 %3 个",
                "SINGLE_RESPONSE": "单一回复",
                "VIEW_RESPONSE": "查看回复"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "显示选项",
                "ERROR_COLON": "错误：",
                "ERROR_GENERIC": "加载可视化对象时出错。",
                "HORIZONTAL_BARS": "水平条形图",
                "INCORRECTLY_CONFIGURED": "选择一个值以显示图表",
                "LEGEND_AUTO": "自动",
                "LEGEND_BOTTOM": "底部",
                "LEGEND_INSET": "插入",
                "LEGEND_RIGHT": "右侧",
                "NORMALIZE_TO_PERCENTAGES": "标准化为百分比",
                "SHOW_AREA": "显示面积",
                "SHOW_LEGEND": "显示图例",
                "SHOW_X_AXIS": "显示 X 轴",
                "SHOW_Y_AXIS": "显示 Y 轴",
                "SMOOTH_LINES": "平滑线",
                "SORT_X_AXIS_LABELS": "X 轴标签排序",
                "STACKED_BARS": "堆积条形图",
                "TRANSPOSE": "转置"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "问题组模式",
                "BLUR": "模糊",
                "COULD_NOT_LOAD_DATA": "无法加载具有指定配置的数据 — 请尝试其他源字段或更大日期范围。",
                "FIELD": "字段",
                "RADIUS": "半径",
                "SHOW_REGIONS": "显示地区",
                "SHOW_REGION_LABELS": "显示区域标签"
            },
            "GAUGEWIDGET": {
                "MAX": "最大值",
                "MIN": "最小值",
                "VALUE_RANGES": "值范围"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "底部标签",
                "CATEGORY_NAME": "类别名称",
                "ERROR_COLON": "错误：",
                "INCLUDE_HIDDEN_GROUPS": "包括百分比形式的隐藏组",
                "LARGE_LABELS": "大标签",
                "NO": "否",
                "PERCENT": "百分比",
                "RESPONSE_COUNT": "回复计数",
                "RESPONSE_COUNT_WITH_VALUE": "{{ responseCount }} 个回复",
                "SMALL_LABELS": "小标签",
                "YES": "是"
            }
        });
        $cache.put('ZH-T', {
            "VIEWRESULTS": {
                "ACCESS_CODE_PROMPT": "存取代碼",
                "ACCESS_CODE_PROTECTION": "存取代碼保護",
                "ADD": "新增",
                "ADD_BREAKOUT": "新增報表細分",
                "ADD_NOTE": "新增附註",
                "ADD_SCHEDULED_REPORT": "新增排程的報表",
                "ADD_WIDGET": "新增視覺效果",
                "ALL_PROJECTS": "所有專案",
                "ALL_QUESTIONS": "問題頁面",
                "ANSWER": "答案",
                "ANY_CHANGES_LOST": "如果您離開 Qualtrics XM 平台，將遺失報表的所有變更。",
                "APPENDED_COPY_IN_PARENS": "(複製)",
                "AREA_CHART": "區域圖",
                "AREA_CHART_DESC": "雙軸折線圖，填入線下方的區域。",
                "ATTACHMENT": "附件",
                "BACKUP_CURRENT_REPORT": "在影響視覺效果前儲存此報表的備份副本",
                "BACKUP_CURRENT_REPORT_LINE2": "附註：備份副本將命名為「{{nameOfReportCopy}}」",
                "BACK_TO_REPORTS": "回到報表",
                "BACK_TO_TOP": "返回頂部",
                "BACK_TO_VIEW_RESULTS": "回到舊檢視結果",
                "BAR_CHART": "條圖",
                "BAR_CHART_DESC": "雙軸條圖允許進行其他配置，例如軸位移和資料點重新排列。",
                "BREAKDOWN_BAR_CHART": "解析長條圖",
                "BREAKDOWN_BAR_CHART_DESC": "水平堆疊條圖最常用於表示度量值互相之間的視覺加權，是圓餅圖的備用圖。",
                "CANCEL": "取消",
                "CANCEL_CONF_TEXT": "您確定要取消嗎?<br/>所有變更將會遺失。",
                "CANCEL_EDITS": "取消編輯",
                "CHART": "圖表",
                "CHOICE": "選擇",
                "CHOICES_COUNT_METRIC": "選項計數",
                "CHOOSE_PAGES_TO_DISPLAY": "選擇要顯示的頁面",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_EXISTING_REPORT": "此報表包含 {{maxReportPageCount}} 頁，但結果最多只能包含 {{reportSizeLimit}} 頁。請在限制範圍內選擇一個子集。",
                "CHOOSE_PAGES_TO_DISPLAY_INFO_NEW_REPORT": "報表最多只可包含 {{reportSizeLimit}} 頁，請選擇您需要的頁面。",
                "CLEAR_ALL": "清除所有項目",
                "CLOSE": "關閉",
                "CLOUD": "雲簡介",
                "COLLABORATED_NEW": "此調查的所有者正在使用 Qualtrics XM 平台！將使用新結果來編輯此調查的報表。",
                "COMMA_SEPARATED_LIST": "逗點區隔清單",
                "COMPACTNESS": "字體及空格",
                "COMPACTNESS_INFO": "此設定會影響表格邊框間距、字體大小及圖表的直條大小。此設定同時會套用至大多數匯出。",
                "CONFIRM": "確定",
                "CONFIRM_DELETE": "確認刪除",
                "CONFIRM_DELETE_PAGE": "您確定要刪除此頁面嗎?",
                "CONTINUE": "繼續",
                "CONTINUE_EDITING": "繼續編輯",
                "COPY": "複製",
                "COPY_OF_REPORT_NAME": "{{nameOfCurrentReport}} 副本",
                "COPY_REPORT": "複製報表",
                "COPY_REPORT_ELLIPSIS": "複製報表...",
                "COPY_TO_NEW_REPORT": "複製到新報表...",
                "CREATE": "建立",
                "CREATED": "已建立",
                "CREATE_CUSTOM_PAGE": "建立自訂頁面",
                "CREATE_NEW_REPORT": "建立新報表",
                "CREATE_NEW_REPORT_ELLIPSIS": "建立新報表...",
                "CSV_FILE": "CSV 檔案",
                "CUSTOM_PAGES": "自訂頁面",
                "DATE": "日期",
                "DEFAULT_PALETTE": "預設顏色選用區",
                "DEFAULT_REPORT": "預設報表",
                "DEFAULT_VISUALIZATIONS": "預設視覺效果",
                "DEFAULT_VISUALIZATIONS_DESCRIPTION": "這些是用於建構預設結果報表的預設視覺效果類型。更新和套用這些設定將使用新的預設設定重新建置當前報表。您可以選擇備份您當前的報表。",
                "DEFAULT_VISUALIZATIONS_NOTE": "附註：並非所有視覺效果類型都可用於所有問題類型。某些非預設視覺效果可能自動替換。",
                "DEFAULT_VISUALS_DISCLAIMER": "Qualtrics 將使用新的預設視覺效果設定更新此報表。",
                "DEFAULT_VISUALS_DISCLAIMER_LINE2": "此更新將影響此報表中的 {{amountOfWidgetsAffected}} 個視覺效果。",
                "DEFAULT_VISUAL_EDIT_DETECTED": "偵測到預設視覺效果編輯",
                "DELETE_BUTTON": "刪除",
                "DELETE_DISABLED_EXPLANATION": "在您的組織完整移轉至 Qualtrics XM 平台之後，您才可刪除在之前報表介面中建立的報表。",
                "DELETE_PAGE": "刪除頁面",
                "DELETE_PAGE_ELLIPSIS": "刪除頁面...",
                "DELETE_REPORT": "刪除報表",
                "DELETE_REPORT_ELLIPSIS": "刪除報表...",
                "DELETE_WIDGET_QUESTION": "刪除？",
                "DISABLE_ENCRYPTED_FIELD_SORT_TOOLTIP": "此欄位已加密，並無法用於排序。",
                "DISCARD_EDITS": "廢棄編輯",
                "DISTRIBUTION_PAUSED": "報表發佈已暫停。",
                "DONE_BUTTON": "完成",
                "DONE_EDITING": "完成編輯",
                "DOWNLOAD": "下載",
                "DOWNLOAD_AS_CSV": "下載為 CSV",
                "DOWNLOAD_AS_PDF": "下載為 PDF",
                "DOWNLOAD_FAILED": "下載失敗",
                "DOWNLOAD_PREVIOUS_EXPORTS": "下載之前的匯出...",
                "DO_YOU_WISH_TO_DELETE": "您是否希望刪除：",
                "DUPLICATE_PAGE": "重複工作表",
                "EDIT_REPORT": "編輯報表",
                "EDIT_REPORT_ELLIPSIS": "編輯報表...",
                "EDIT_VISUALIZATION": "編輯視覺效果",
                "EMAIL_ADDRESS": "電子郵件地址",
                "EMAIL_SENT": "已傳送電子郵件...",
                "END_OF_REPORT": "報表結束",
                "ENTER_NAME": "輸入名稱",
                "ERROR_COPYING": "複製報表時發生錯誤。",
                "ERROR_DELETING": "刪除報表時發生錯誤。",
                "ERROR_DELETING_EXPORT": "刪除匯出時發生錯誤。",
                "ERROR_HEADING": "錯誤",
                "ERROR_PUBLISHING": "儲存設定時發生錯誤。",
                "ERROR_RENAMING": "重新命名報表時發生錯誤。",
                "ERROR_REQUESTING_EXPORT": "要求匯出時發生錯誤。",
                "ERROR_SAVING_GLOBAL_OPTIONS": "儲存全域視覺效果選項時發生錯誤。",
                "ERROR_SEND_TEST_EMAIL": "傳送測試電子郵件時發生錯誤。",
                "EVERY_FRIDAY": "每周五",
                "EVERY_MONDAY": "每周一",
                "EVERY_MONTH": "每月某天",
                "EVERY_SATURDAY": "每周六",
                "EVERY_SUNDAY": "每周日",
                "EVERY_THURSDAY": "每周四",
                "EVERY_TUESDAY": "每周二",
                "EVERY_WEDNESDAY": "每周三",
                "EVERY_WEEK": "每星期某天",
                "EXAMPLE_GROUP_NUM": "群組 {{num}}",
                "EXAMPLE_SERIES_NUM": "系列 {{num}}",
                "EXPORT": "匯出",
                "EXPORT_CSV": "CSV (逗號分隔)",
                "EXPORT_EXCEL_SPREADSHEET": "Excel 工作表",
                "EXPORT_IMAGE": "匯出影像",
                "EXPORT_PAGES": "匯出頁面",
                "EXPORT_PDF": "PDF 文件",
                "EXPORT_PPT_SLIDES": "PowerPoint 投影片",
                "EXPORT_RAW_DATA": "匯出原始資料",
                "EXPORT_REPORT": "匯出報表",
                "EXPORT_VISUALIZATION": "匯出視覺效果",
                "EXPORT_WORD_DOC": "Word 文件",
                "FAILED_SAVE_TXT": "儲存失敗",
                "FILTERED": "已篩選",
                "FIRST_PAGE": "第一頁",
                "FIRST_WEEKDAY": "月份的第一個週末",
                "FROM": "發件者",
                "FROM_EMAIL": "發件者電子郵件",
                "FROM_NAME": "發件者名稱",
                "GAUGE_CHART": "儀錶圖",
                "GAUGE_CHART_DESC": "類似於量規測量工具的圖表，用於將現行值與目標或閾值系列進行比較。",
                "GENERATING_FILE": "正在產生檔案...",
                "GENERATING_IMAGE": "正在產生影像...",
                "GENERATING_PDF": "正在產生 PDF...",
                "GENERIC_ERROR": "發生錯誤，導致無法載入所要求的專案。",
                "GLOBAL_CONTAINER_OPTIONS_ELLIPSIS": "全域選項...",
                "GLOBAL_METRIC": "預設度量值",
                "GLOBAL_MODAL_PAGE_TITLE": "範例視覺效果，此示例將全域選項用於 Qualtrics 研究套件的「結果」部分",
                "GLOBAL_MODAL_WIDGET_TITLE": "視覺效果標題",
                "GLOBAL_OPTIONS": "全域選項",
                "GLOBAL_PRECISION": "預設小數位數",
                "GLOBAL_SETTINGS_APPLY": "套用我的預設設定",
                "GLOBAL_SETTINGS_SAVE": "另存為我的預設設定",
                "GLOBAL_SETTINGS_USE_QDEFAULT": "套用 Qualtrics 預設值",
                "GROUP": "群組",
                "HEAT_MAP_CHART": "熱圖圖表",
                "HEAT_MAP_CHART_DESC": "叢集式「熱圖」樣式視覺效果，用於將使用者輸入 (例如點擊) 的發佈對映至原始影像。",
                "HIDDEN": "已隱藏",
                "HIDDEN_PAGE": "此頁面不會出現在公開報告中，並且依預設會在報表匯出中取消選擇此頁面。",
                "HIDE": "隱藏",
                "HIDE_ALL_PAGES": "隱藏所有頁面",
                "HIDE_PAGE": "隱藏頁面",
                "IMAGE_FILE": "影像檔案",
                "INVALID_BRAND_DOMAIN": "您輸入的網域不在已核准電子郵件網域的品牌清單中。請聯絡您的品牌管理員進行修復。",
                "INVALID_SPF_RECORD": "您輸入的網域沒有傳送經過核准的 Qualtrics。這將影響可交付性。請使用另一網域或聯絡 Qualtrics 來解決此問題。",
                "ISSUE_SAVING_REPORTS": "一個或多個報表在儲存時遇到問題。請再試一次。",
                "ISSUE_SENDING_TEST": "傳送測試電子郵件時發生錯誤。請再試一次。",
                "LARGE_SURVEY": "由於調查過大，因此將無法顯示結果。",
                "LAST_DAY": "月份的最後一天",
                "LAST_MODIFIED_COLON_WITH_DATE": "最近一次修改：%1",
                "LAST_PAGE": "最後一頁",
                "LAST_WEEKDAY": "月份的最後一個週末",
                "LATER": "隨後",
                "LEARN_MORE": "瞭解更多",
                "LINE_CHART": "折線圖",
                "LINE_CHART_DESC": "在 X 軸上根據時間作圖時通常使用雙軸折線圖。",
                "LOG_OUT_WARNING": "在 {{countdown}} 秒內按一下任何位置以保持登入狀態",
                "MESSAGE": "訊息",
                "MONTHLY": "每月",
                "MOVE_DOWN": "將視覺效果向下移動",
                "MOVE_PAGE_TO_BOTTOM": "移至底端",
                "MOVE_PAGE_TO_TOP": "移至頂上",
                "MOVE_UP": "將視覺效果向上移動",
                "MY_SURVEYS": "我的專案",
                "NAME": "名稱",
                "NEW_CUSTOM_PAGE_NAME": "新建自訂頁面",
                "NEW_REPORT": "新建報表",
                "NEXT_PAGE": "下一個頁面",
                "NEXT_RUN": "下一次執行",
                "NO_EXPORTS": "尚未針對此報表要求任何匯出。",
                "NO_ITEMS_TO_DISPLAY": "沒有要顯示的項目",
                "NO_MATCHING_CUSTOM_PAGES": "沒有相符的自訂頁面",
                "NO_MATCHING_PAGES": "搜尋未找到任何頁面",
                "NO_MATCHING_REPORTS": "沒有相符的報表。",
                "NO_PROJECT": "請指定一個專案以繼續。",
                "NO_PROJECTS_TO_MIGRATE": "沒有要更新的專案。",
                "NO_QUESTIONS": "沒有相符的問題",
                "NO_RESULTS_YET": "尚沒有要顯示的結果。請發佈您的調查以收集回應。",
                "OFF": "關閉",
                "ON": "開啟",
                "PAGES_SELECTED": "所選頁碼",
                "PAGES_SELECTION_EXCEED_LIMIT_WARNING": "此選擇將使報表包含 {{currentSelectedPageCount}} 頁，高於允許的最多 {{reportSizeLimit}} 頁。請選擇較小的範圍。",
                "PAGES_SELECTION_INVALID_RANGE": "請選擇有效的範圍。",
                "PAGE_OPTIONS": "頁面選項",
                "PDF_ROW_TRUNCATION_MESSAGE": "PDF 匯出列數過多，請嘗試匯出至 Word 或 CSV。",
                "PERCENTAGE_METRIC": "百分比",
                "PIE_CHART": "圓餅圖",
                "PIE_CHART_DESC": "指定資料點的循環細分值。對測量所選值的相對比例相當實用。",
                "PREVIEW": "預覽",
                "PREVIOUS_PAGE": "上一個頁面",
                "PRINT_PAGE": "列印頁面",
                "PUBLIC_LINK": "公開連結",
                "PUBLIC_REPORT_AVAILABLE": "公開報告可用",
                "PUBLIC_RESULTS_LOGIN_ACCESS_CODE": "存取代碼",
                "PUBLIC_RESULTS_LOGIN_FAILED_AUTHENITCATION": "存取代碼不正確或過期。請重試。",
                "PUBLIC_RESULTS_LOGIN_SUBMIT": "提交",
                "PUBLIC_RESULTS_LOGIN_TITLE": "公開報告登入 | Qualtrics 調查軟體",
                "PUBLIC_RESULTS_NOT_FOUND_MESSAGE": "未找到公開報告。請聯絡此報表的所有者，並要求所有者提供有效連結。",
                "PUBLIC_RESULTS_NOT_FOUND_TITLE": "找不到公開報告",
                "PUBLIC_RESULTS_NOT_UPDATED": "公開報告連結和排程的報表電子郵件將不使用 Qualtrics XM 平台，直到您進行更新。",
                "PUBLIC_RESULTS_SESSION_EXPIRED_MESSAGE": "工作階段已過期。請再次登入以繼續預覽公開結果報表。",
                "PUBLIC_RESULTS_SESSION_EXPIRED_TITLE": "工作階段已過期",
                "PUBLIC_RESULTS_TITLE": "公開報告",
                "PUBLIC_RESULTS_UNAUTHORIZED_MESSAGE": "您未獲授權，無法查看此頁面。請聯絡此報表的所有者並要求所有者將此報表設為公開。",
                "PUBLIC_RESULTS_UNAUTHORIZED_TITLE": "未授權公開報告",
                "PUBLISHED_LINK_GENERATING_LINK": "正在產生連結...",
                "PUBLISHED_REPORT_FOUND_HERE": "任何人可於以下連結檢視此報表：",
                "PUBLISH_REPORT": "管理公開報告",
                "PUBLISH_REPORT_ELLIPSIS": "管理公開報告...",
                "QUESTION": "問題",
                "RANK": "評級",
                "REMOVE_WIDGET": "移除視覺效果",
                "RENAME_PAGE": "重新命名頁面",
                "RENAME_REPORT": "重新命名報表",
                "RENAME_REPORT_ELLIPSIS": "重新命名報表...",
                "REPLY_TO_EMAIL": "回覆電子郵件",
                "REPORT_COLON": "報表：",
                "REPORT_SETTINGS": "報表設定",
                "REPORT_SETTINGS_ELLIPSIS": "報表設定...",
                "RESPONSE_COUNTS": "回應計數",
                "RESULTS_DASHBOARDS_BANNER": "並試用改善的調查結果版本，此版本具備現代化且易於存取的使用者介面以及資料視覺效果，全新的分析及探索等功能。",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_LINK": "發行資訊",
                "RESULTS_DASHBOARDS_BANNER_RELEASE_NOTES_PREFIX": "檢視最新",
                "RESULTS_OPTIONS": "報表選項",
                "RESULTS_TITLE": "報告",
                "RESUME_DISTRIBUTION": "恢復發佈",
                "REVERT": "反向",
                "RICH_TEXT_LIMIT_REACHED": "內容長度已達到限制！",
                "SAVE": "儲存",
                "SAVE_AND_CLOSE": "儲存並關閉",
                "SAVE_AS_CSV": "將視覺效果儲存為 CSV",
                "SAVE_AS_IMAGE": "將視覺效果儲存為影像",
                "SAVE_CONFIRMATION": "儲存確認",
                "SAVE_PAGE_AS_ELLIPSIS": "將頁面匯出為...",
                "SAVE_SETTINGS": "儲存設定",
                "SCHEDULE_REPORT_EMAIL": "排程報表電子郵件",
                "SCHEDULE_REPORT_EMAIL_ELLIPSIS": "排程報表電子郵件...",
                "SEARCH_ELLIPSIS": "搜尋...",
                "SEARCH_PAGES": "搜尋問題",
                "SEARCH_PAGES_ELLIPSIS": "搜尋頁面...",
                "SEARCH_REPORTS_ELLIPSIS": "搜尋報表...",
                "SELECTED": "已選擇：",
                "SELECT_ALL": "全部選擇",
                "SELECT_A_FIELD": "選擇一個欄位",
                "SELECT_A_WIDGET": "選擇一個視覺效果",
                "SELECT_PAGES": "選擇頁面",
                "SELECT_PAGES_ELLIPSIS": "選擇頁面...",
                "SEND": "傳送",
                "SEND_TEST_EMAIL": "傳送測試電子郵件",
                "SETTING_DEFAULT": "預設",
                "SETTING_HIGH": "高",
                "SETTING_LARGE": "大型",
                "SETTING_LOW": "低",
                "SETTING_NORMAL": "正常",
                "SETTING_SMALL": "小型",
                "SHARE_REPORT": "共享報表",
                "SHOW_ALL_PAGES": "顯示所有頁面",
                "SHOW_FULL_QTEXT": "顯示頁面標題中的完整問題內文",
                "SIMPLE_TABLE": "簡易表格",
                "SIMPLE_TABLE_DESC": "一種彈性表格，可以列或欄的形式顯示多個值。",
                "SIZE": "大小",
                "SPLINE_CHART": "樣條圖",
                "SPLINE_CHART_DESC": "在 X 軸上根據時間作圖時通常使用雙軸曲線圖。",
                "STATISTICS_TABLE": "統計資料表格",
                "SUBJECT": "調查對象",
                "SURVEY_ANALYSIS": "調查分析",
                "SURVEY_SUMMARY": "調查摘要",
                "TABLE": "表格的說明",
                "TIME": "時間",
                "TO": "致",
                "TOTAL": "總計",
                "TRANSPOSE_STATS_TABLES": "轉置統計表",
                "TRANSPOSE_STATS_TABLE_BREAKOUTS": "轉置統計表分組",
                "TRUNCATE_PAGE_TITLES": "截斷頁面標題中的問題內文",
                "TRY_IT_NOW": "立即嘗試",
                "TYPE": "類型",
                "UNABLE_TO_CHECK_SPF": "無法檢查 SPF 記錄。請再試一次。",
                "UNAUTHORIZED": "不允許您檢視此報表。請聯絡所有者以獲取存取權。",
                "UNHIDE_PAGE": "取消隱藏頁面",
                "UPDATE": "更新",
                "UPDATED_SUCCESSFULLY": "已成功更新。",
                "UPDATE_ALL_IN_THIS_PROJECT": "更新此專案中的所有內容",
                "UPDATE_ALL_PROJECTS": "更新所有專案",
                "UPDATE_NOW": "立即更新",
                "UPDATE_REPORTS": "更新報表...",
                "UPDATE_REPORT_ELEMENTS": "更新公開報告連結和排程的報表電子郵件",
                "UPGRADE_MY_ACCOUNT": "升級我的帳戶",
                "USE_EXPORT_TAGS": "包含問題數",
                "USE_SIMPLE_TABLE_COLUMN_TOTALS": "使用簡易表格欄總計",
                "USE_SIMPLE_TABLE_RESPONDENT_COUNTS": "使用簡易表格受訪者計數",
                "USE_WEIGHTED_METRICS": "使用加權度量值",
                "VIEW": "檢視",
                "WEEKLY": "每週",
                "WELCOME_TO_NEW_RESULTS": "歡迎使用 Qualtrics XM 平台報表功能！",
                "WHEN": "時間",
                "WIDGET_LOADING": "正在載入...",
                "WIDGET_OPTIONS_ERR": "載入視覺效果選項失敗",
                "WIDGET_TYPE": "視覺效果",
                "WORD_CLOUD": "文字雲",
                "WORD_CLOUD_DESC": "文字資料中 (具有其他顏色編碼選項) 文字頻率的加權視覺效果。"
            },
            "AWA": {
                "ABOUT_YOUR_REPORT_FOOTER_LINE1": "請記得，貴公司有些資源可協助您解讀這些意見反應，例如 HR 夥伴、主管和/或前輩。",
                "ABOUT_YOUR_REPORT_FOOTER_LINE2": "先沖杯咖啡，再接著研讀意見反應吧。",
                "ABOUT_YOUR_REPORT_HEADER": "關於您的報表",
                "ABOUT_YOUR_REPORT_LINE1": "歡迎閱讀您的 360 意見反應報表，這是個邁向專業的絕佳成長機會。請騰出充足的時間仔細閱讀意見反應，探索結果，以便為下一步的成就鋪路。某些意見反應起初或許不易接受，但還請記得，這份意見反應的目的是輔助您的成長與發展更加順利。",
                "ABOUT_YOUR_REPORT_LINE2": "在您瀏覽報表之際，請記得下列幾點。",
                "ADD_CONDITIONAL_TEXT": "新增條件文字",
                "ADD_CUSTOM_PALETTE": "新增自訂選用區",
                "ADD_DATA_SOURCE": "新增資料來源",
                "ADD_FOLLOWING": "新增其次",
                "ADD_LABEL": "新增標籤",
                "ADVANCED_FILTER": "進階篩選器",
                "AGREEMENT_CHART": "同意度表",
                "AGREEMENT_CHART_FOOTER": "同意度表可呈現分數變異性。各點代表每位人員針對各項目給您的評比。點的大小顯示提供特定評比分數的的評估者人數。",
                "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "回應",
                "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "回應",
                "AGREEMENT_CHART_LEGEND_TITLE": "來自其他人員的評比",
                "ALL": "所有",
                "AND_IF": "且如果",
                "ANGLED": "有角度的",
                "AREA": "區域圖",
                "AUTO": "自動",
                "AVERAGE": "平均",
                "AXIS_VALUES": "軸值",
                "BAR": "條圖",
                "BASE_WORD_COLOR": "基本文字顏色",
                "BLUR": "模糊",
                "BOTTOM_BOX": "底部方塊",
                "BREAKOUT_HEADERS": "分類標題",
                "CANCEL": "取消",
                "CATEGORICAL": "分類的",
                "CATEGORY": "類別",
                "CATEGORY_NAME": "類別名稱",
                "CHANGE_CATEGORIES_ORDER": "變更類別順序",
                "CHANGE_CATEGORIES_ORDER_MODAL_HEADER": "變更評分類別順序",
                "CHANGE_CATEGORIES_ORDER_MODAL_INSTRUCTIONS": "按一下評分類別元素左側並拖曳到想要的位置，以變更在視覺化中顯示的順序。",
                "CHANGE_QUESTIONS_ORDER": "變更問題順序",
                "CHANGE_QUESTIONS_ORDER_MODAL_HEADER": "變更問題順序",
                "CHANGE_QUESTIONS_ORDER_MODAL_INSTRUCTIONS": "按一下問題元素左側並拖曳到想要的位置，以變更在視覺化中顯示的順序。",
                "CHARTS": "圖表",
                "CHART_TYPE": "圖表類型",
                "CHOICE_COUNT": "選項計數",
                "CHOICE_TOTALS": "選項總計",
                "CLEAR": "清除",
                "CLOSE": "關閉",
                "COLOR_PALETTE": "顏色選用區",
                "COLUMN_NAMES": "欄位名稱",
                "COLUMN_TOTALS": "欄總計",
                "COMPARED_FILTER_GROUP": "已比較篩選條件群組",
                "COMPARED_FILTER_GROUPS": "已比較篩選條件群組",
                "COMPARE_WITH": "相較於",
                "COMPETITION_RANKING": "使用競爭排名",
                "COMPETITION_RANKING_TOOLTIP": "在平局事件中，所有相同的評分都會給予相同排名。然而，下個後續項目的排名將會等於：表格中排名較高的項目總數加一。",
                "COMPLETED_RESPONSES": "完成的回應",
                "CONDITIONAL_TEXT": "條件文字",
                "COUNT": "計數",
                "CREATE": "建立",
                "CUSTOM_PALETTE": "自訂選用區",
                "DATA_SOURCE_TYPE": "資料來源類型",
                "DATA_SOURCE_TYPE_CATEGORY": "評分類別",
                "DATA_SOURCE_TYPE_QUESTION": "問題",
                "DATA_SOURCE_TYPE_QUESTION_SINGULAR": "問題",
                "DATA_SOURCE_TYPE_RANKABLE_ITEMS": "可評級項目",
                "DATA_SOURCE_TYPE_SINGLE_CATEGORY": "評分類別",
                "DEFAULT": "預設",
                "DEFAULT_TEXT": "預設文字",
                "DELETE": "刪除",
                "DIFFERENT_EVALUATORS_DESCRIPTION": "瞭解提供意見反應的對象：同儕、部屬或主管等",
                "DIFFERENT_EVALUATORS_HEADER": "不同評估人",
                "DIRECT_REPORTS": "直接部屬",
                "DISABLED": "已停用",
                "DISPLAY_OPTIONS": "顯示選項",
                "DISPLAY_THRESHOLD_TEXTS": "按照下列群組差距顯示文字",
                "DIVERGENT": "分散的",
                "DONE": "完成",
                "DONT_HEADER": "請勿：",
                "DONT_LINE1": "嘗試推敲意見提供的對象",
                "DONT_LINE2": "著重於單則正向或負向分數/註解",
                "DONT_LINE3": "為每個項目擬定發展計劃",
                "DONT_LINE4": "認為失去改善機會而挫折",
                "DONUT": "圓環圖",
                "DOWNLOAD_CSV": "下載舊版 CSV",
                "DOWNLOAD_ZIP": "下載所有檔案",
                "DO_HEADER": "請：",
                "DO_LINE1": "全方位綜觀意見反應",
                "DO_LINE2": "找出重點強項，以及改善的機會",
                "DO_LINE3": "排出幾個首要的重點領域，擬定發展計劃",
                "DO_LINE4": "瞭解每個人都有改善的機會",
                "DROPOFF": "下降",
                "DUPLICATE": "重複",
                "EDIT_CONDITIONAL_TEXT": "編輯條件文字",
                "EDIT_CUSTOM_PALETTE": "編輯自訂選用區",
                "ELSE_SHOW_THE_FOLLOWING_TEXT": "否則顯示下列文字",
                "ENABLED": "已啟用",
                "ENABLE_ORDERING_BY_RATER_CATEGORY": "按照評估者類別顯示邏輯啟用順序",
                "ENABLE_ORDERING_FOR": "啟用排序",
                "EQUAL_TO": "等於",
                "FIELD": "欄位",
                "FILTER_NAMES": "篩選器名稱",
                "FOLLOWING_PARENTHESES": "(其次)",
                "FOOTER": "頁尾",
                "GAP": "差距",
                "GAP_CHART": "差距圖",
                "GAP_CHART_DESCRIPTION": "差距圖會顯示兩個評估者群組的分數差異。例如，若為自我評估 vs. 他人對您的評估，正值(+) 差異表示他人對您的評估高於您對自己的評估，負值(-) 差異則表示他人對您的評估低於您對自己的評估。",
                "GAP_CHART_FOOTER": "差距圖顯示兩個評價者群組之間的正/負值差異。",
                "GAP_TABLE_DESCRIPTION": "隱藏的強項表示，在該領域他人對您的評估高於您對自己的評估。改善範圍則表示，該領域他人對您的評估低於您對自己的評估。兩個區段皆由最大到最小差距來排列。",
                "GAP_TABLE_FOOTER": "分數的第一欄顯示您的自我評分。第二欄為其他人的平均分數。第三欄則是您的自我評分與他人給您評分之間的差異。",
                "GAP_TABLE_TITLE": "隱藏的強度/改善範圍",
                "GREATER_OR_EQUAL": "大於或等於",
                "GREATER_THAN": "大於",
                "GROUP": "群組",
                "GROUPED_FOR_ANONYMITY": "匿名分組",
                "HEADER_NAMES": "標題名稱",
                "HIGHEST_SCORES": "最高評分",
                "HIGHLIGHT_THRESHOLD": "強調顯示差距的閥值",
                "HIGHLOW_TABLE": "高低表",
                "HIGHLOW_TABLE_FOOTER": "此區段顯示適用的評定者類別平均值中，5 種最高評比與最低評比的行為（在所有行為中）。若要從此頁面取得最多資訊，尋找可能顯露的趨勢會非常有用。例如，如果大部分最低評比的行為集中在一種或兩種類別中，則可能存在一些需要開發的區域。最高評比的行為可以識別可在其他區域中加以充分利用的優勢。",
                "HIGH_LOW_TABLE_DESCRIPTION": "高低表會依據他人對您最高與最低的評估，顯示該領域的項目。",
                "HORIZONTAL": "水平",
                "HORIZONTAL_AND_VERTICAL": "水平和垂直",
                "HORIZONTAL_BAR": "水平條圖",
                "HOW_TO_INTERPRET_RESULT_HEADER": "如何解讀結果與決定行動：",
                "IF": "如果",
                "INCLUDE_HIDDEN_LABELS_IN_PERCENTS": "在百分比中包括隱藏的標籤",
                "INNER_RIM": "內緣",
                "IS": "是",
                "IS_NOT": "不是",
                "IS_SAME_AS_SUBJECT": "與調查對象相同",
                "ITEM": "項目",
                "LABEL": "標籤",
                "LABELS": "標籤",
                "LARGE_LABELS": "大型標籤",
                "LEGEND": "圖註",
                "LEGEND_POSITION": "圖例位置",
                "LEGEND_VALUES": "圖例值",
                "LESS_OR_EQUAL": "小於或等於",
                "LESS_THAN": "小於",
                "LINE": "折線圖",
                "LOWEST_SCORES": "最低評分",
                "MANAGERS": "管理者",
                "MANUAL_FONT_SIZE": "手動設定字體大小",
                "MAX": "最大",
                "MEAN": "中等",
                "MEDIAN": "中位數",
                "METRIC_TYPE": "指標類型",
                "MIN": "最小",
                "MODIFY_CUSTOM_PALETTES": "修改自訂選用區",
                "MOVE_DOWN": "向下移動",
                "MOVE_UP": "向上移動",
                "MULTI_SELECT_ITEMS_SELECTED": "已選擇",
                "NEGATIVE_GAPS": "改善範圍",
                "NO": "否",
                "NONE": "無",
                "NOT_APPLICABLE": "無",
                "NOT_EQUAL_TO": "不等於",
                "NO_DATA_AVAILABLE_WARNING": "沒有可用資料",
                "NO_FILTER": "無篩選條件",
                "NO_FILTER_IS_APPLIED": "未套用篩選器。",
                "NO_VALUE": "沒有值",
                "NPS": "淨推薦值",
                "NUMBER": "數字",
                "NUMBERS": "數字",
                "NUMBER_OF_GAPS_NEGATIVE": "負面差異數目",
                "NUMBER_OF_GAPS_POSITIVE": "正面差異數目",
                "NUMBER_OF_ROWS_HIGH": "高列數量",
                "NUMBER_OF_ROWS_LOW": "低列數量",
                "OPTIONS": {
                    "HEADER_NAME": "標頭名稱",
                    "LEGEND": "圖註",
                    "SCALE_AXIS_CHANGER_TITLE": "範圍"
                },
                "ORIENTATION": "方向",
                "OR_IF": "或如果",
                "OTHER": "其他",
                "OTHERS": "其他人員",
                "PAGE_OF": "頁碼：第 %1 頁 (共 %2 頁)",
                "PALETTE_REMOVED": "已移除選用區",
                "PEERS": "同級",
                "PERCENT": "百分比",
                "PERCENTAGE": "百分比",
                "PERCENTAGE_OF_CHOICES": "選項的百分比",
                "PERCENTAGE_OF_RESPONSES": "回應的百分比",
                "PERCENT_COMPLETE": "完成百分比",
                "PERSON_METADATA": "人員中繼資料",
                "PERSON_METADATA_EVALUATOR": "評估人的",
                "PERSON_METADATA_SUBJECT": "調查對象的",
                "PERSON_METADATA_VIEWER": "檢閱者的",
                "POSITIVE_GAPS": "隱藏的強度",
                "PRIMARY_PARENTHESES": "(主要)",
                "QUESTIONS": "問題",
                "RADIUS": "半徑",
                "RANK": "評級",
                "RANKABLE_ITEMS_HIGHEST_SCORE": "最高評分",
                "RANKABLE_ITEMS_HIGHEST_SCORES": "最高評分",
                "RANKABLE_ITEMS_ITEM_HAS": "項目有",
                "RANKABLE_ITEMS_ITEM_IS_IN_TOP": "項目在頂部",
                "RANKABLE_ITEMS_LOWEST_SCORE": "最低評分",
                "RANKABLE_ITEMS_LOWEST_SCORES": "最低評分",
                "RATER_CATEGORY_DISPLAY_LOGIC": "評估者類別顯示邏輯",
                "RATIO": "比率",
                "RECORD": "記錄",
                "REFERENCE_GROUP": "參考群組",
                "RELATIONSHIP": "關係",
                "RELATIONSHIP_FILTERS": "關係篩選器",
                "RELATIONSHIP_FILTERS_INFO": "若要新增關係篩選器 (例如直接部屬、同儕或主管)，請選取「管理」篩選器，然後僅使用下拉式清單的「關係」條件。",
                "REMOVE": "移除",
                "REMOVE_DATA_SOURCE": "移除資料來源",
                "REPORT_ONLY": {
                    "ABOUT_YOUR_REPORT_FOOTER_LINE1": "請記得，貴公司有些資源可協助您解讀這些意見反應，例如 HR 夥伴、主管和/或前輩。",
                    "ABOUT_YOUR_REPORT_FOOTER_LINE2": "先沖杯咖啡，再接著研讀意見反應吧。",
                    "ABOUT_YOUR_REPORT_HEADER": "關於您的報表",
                    "ABOUT_YOUR_REPORT_LINE1": "歡迎閱讀您的 360 意見反應報表，這是個邁向專業的絕佳成長機會。請騰出充足的時間仔細閱讀意見反應，探索結果，以便為下一步的成就鋪路。某些意見反應起初或許不易接受，但還請記得，這份意見反應的目的是輔助您的成長與發展更加順利。",
                    "ABOUT_YOUR_REPORT_LINE2": "在您瀏覽報表之際，請記得下列幾點。",
                    "ADVANCED_FILTER": "進階篩選器",
                    "AGREEMENT_CHART": "同意度表",
                    "AGREEMENT_CHART_FOOTER": "同意度表可呈現分數變異性。各點代表每位人員針對各項目給您的評比。點的大小顯示提供特定評比分數的的評估者人數。",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_PLURAL": "回應",
                    "AGREEMENT_CHART_LEGEND_RESPONSE_SINGULAR": "回應",
                    "AGREEMENT_CHART_LEGEND_TITLE": "來自其他人員的評比",
                    "ALL": "全部",
                    "AVERAGE": "平均",
                    "BOTTOM_BOX": "底部方塊",
                    "CHOICE_COUNT": "選項計數",
                    "CHOICE_TOTALS": "選項總計",
                    "COMPARISON": "比較",
                    "COMPARISON_GAP_COLUMN_HEADER": "比較差距",
                    "COMPLETED_RESPONSES": "完成的回應",
                    "COUNT": "計數",
                    "DEFAULT": "預設",
                    "DEFAULT_TEXT": "預設文字",
                    "DIFFERENT_EVALUATORS_DESCRIPTION": "瞭解提供意見反應的對象：同儕、部屬或主管等",
                    "DIFFERENT_EVALUATORS_HEADER": "不同評估人",
                    "DONE": "完成",
                    "DONT_HEADER": "請勿：",
                    "DONT_LINE1": "嘗試推敲意見提供的對象",
                    "DONT_LINE2": "著重於單則正向或負向分數/註解",
                    "DONT_LINE3": "為每個項目擬定發展計劃",
                    "DONT_LINE4": "認為失去改善機會而挫折",
                    "DO_HEADER": "請：",
                    "DO_LINE1": "全方位綜觀意見反應",
                    "DO_LINE2": "找出重點強項，以及改善的機會",
                    "DO_LINE3": "排出幾個首要的重點領域，擬定發展計劃",
                    "DO_LINE4": "瞭解每個人都有改善的機會",
                    "FIELD": "欄位",
                    "GAP": "差距",
                    "GAP_CHART": "差距圖",
                    "GAP_CHART_DESCRIPTION": "差距圖會顯示兩個評估者群組的分數差異。例如，若為自我評估 vs. 他人對您的評估，正值(+) 差異表示他人對您的評估高於您對自己的評估，負值(-) 差異則表示他人對您的評估低於您對自己的評估。",
                    "GAP_CHART_FOOTER": "差距圖顯示兩個評價者群組之間的正/負值差異。",
                    "GAP_TABLE_DESCRIPTION": "隱藏的強項表示，在該領域他人對您的評估高於您對自己的評估。改善範圍則表示，該領域他人對您的評估低於您對自己的評估。兩個區段皆由最大到最小差距來排列。",
                    "GAP_TABLE_FOOTER": "分數的第一欄顯示您的自我評分。第二欄為其他人的平均分數。第三欄則是您的自我評分與他人給您評分之間的差異。",
                    "GAP_TABLE_TITLE": "隱藏的強項/改善範圍",
                    "GROUP": "群組",
                    "HIDE_REPORT_ALERT": "您不符合需求，無法檢視報告。請聯絡組織管理者。",
                    "HIGHEST_SCORES": "最高評分",
                    "HIGHLOW_TABLE": "高低表",
                    "HIGHLOW_TABLE_FOOTER": "此區段顯示適用的評定者類別平均值中，5 種最高評比與最低評比的行為 (在所有行為中)。若要從此頁面取得最多資訊，尋找可能顯露的趨勢會非常有用。例如，如果大部分最低評比的行為集中在一種或兩種類別中，則可能存在需要發展的領域。最高評比的行為可以識別可在其他領域中加以充分利用的優勢。",
                    "HIGH_LOW_TABLE_DESCRIPTION": "高低表會依據他人對您最高與最低的評估，顯示該領域的項目。",
                    "HOW_TO_INTERPRET_RESULT_HEADER": "如何解讀結果與決定行動：",
                    "ITEM": "項目",
                    "LOWEST_SCORES": "最低評分",
                    "MAX": "最大",
                    "MEAN": "中等",
                    "MEDIAN": "中位數",
                    "MIN": "最小",
                    "NEGATIVE_GAPS": "改善範圍",
                    "NO_COMPARISON_SET": "未設定比較",
                    "NO_DATA_AVAILABLE_WARNING": "沒有可用資料",
                    "NO_FILTER_IS_APPLIED": "未套用篩選器。",
                    "NO_VALUE": "沒有值",
                    "NPS": "淨推薦值",
                    "OTHERS": "其他",
                    "PERCENTAGE": "百分比",
                    "PERCENTAGE_OF_CHOICES": "選項的百分比",
                    "PERCENTAGE_OF_RESPONSES": "回應的百分比",
                    "PERCENT_COMPLETE": "完成百分比",
                    "POSITIVE_GAPS": "隱藏的強度",
                    "QUESTIONS": "問題",
                    "RANK": "評級",
                    "RELATIONSHIPS": {
                        "ANYONE": "任何人",
                        "DIRECT_REPORT": "直接部屬",
                        "MANAGER": "經理",
                        "PEER": "同級",
                        "SELF": "自己"
                    },
                    "REPORT_SUMMARY": "報告摘要",
                    "REPORT_SUMMARY_TABLE_FOOTER": "比較完成評估的人數和邀請參與的人數。",
                    "REPORT_SUMMARY_TABLE_HEADER": "受訪者統計",
                    "RESPONSES": "回應",
                    "RESPONSE_COUNT": "{{responseCount}} 個回應",
                    "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> 個回應",
                    "SCORING_CATEGORY": "評分類別",
                    "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "此類別沒有回應",
                    "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "此問題沒有回應",
                    "SCORING_OVERVIEW": "評分概觀",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH": "您與其他評估者皆認為此領域為最強項。",
                    "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "明確強項",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS": "明確改善範圍表示自我評估與他人評估皆認為低於此能力的平均。",
                    "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "明確改善範圍",
                    "SCORING_OVERVIEW_DESCRIPTION": "以上即是多位評估者意見反應流程中，您受到評估的能力/行為。評比的比較結果會依群組提供。",
                    "SCORING_OVERVIEW_MINIMUM_GAP": "最小差距",
                    "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "用來顯示參考群組之間最小差異的文字。",
                    "SCORING_OVERVIEW_TABLE_FOOTER": "顯示各項能力/行為的評分範圍資料。長條形代表數值平均值。",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "不明確強項表示自我評估與他人評估有所不同。",
                    "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "不明確強項",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "不明確改善範圍表示自我評估與他人評估有所不同。",
                    "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "不明確改善範圍",
                    "SELF": "自己",
                    "SELF_ASSESSMENT": "自我評估",
                    "STANDARD_DEVIATION": "標準差",
                    "SUM": "總計",
                    "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "請瞭解評估範圍，以確保解讀精確",
                    "TAKE_NOTE_OF_THE_SCALE_HEADER": "記下範圍",
                    "THINGS_YOU_WILL_SEE_HEADER": "您將會看到：",
                    "THREE_SIXTY_PERCENTILE": "百分位",
                    "TOP_BOTTOM_BOX": "最高得分選項/最低得分選項",
                    "TOP_BOX": "最高得分選項",
                    "TOTAL": "總計",
                    "TO_DO": "待辦事項",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "定性：此意見反應的形式將為開放式文字註解",
                    "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "定量：此意見反應將為數值，且可以圖表、長條圖、表格等方式呈現",
                    "TYPES_OF_FEEDBACK_HEADER": "意見反應的各種類型",
                    "VALUE": "值",
                    "VARIANCE": "偏差",
                    "YOUR_RATINGS": "您的評估"
                },
                "REPORT_SUMMARY": "報告摘要",
                "REPORT_SUMMARY_TABLE_FOOTER": "比較完成評估的人數和邀請參與的人數。",
                "REPORT_SUMMARY_TABLE_HEADER": "受訪者統計",
                "RESET": "重設",
                "RESPONDENT_TOTALS": "受訪者總計",
                "RESPONSES": "回應",
                "RESPONSE_COUNT": "{{responseCount}} 個回應",
                "RESPONSE_COUNT_HTML": "<span class='response-count-value'>{{responseCount}}</span> 個回應",
                "RESULT": "結果",
                "REVERSE_COLORS": "反向顏色",
                "ROW_TOTALS": "列總計",
                "SAVE": "儲存",
                "SAVE_AND_APPLY": "儲存並套用",
                "SCORING_CATEGORY": "評分類別",
                "SCORING_CATEGORY_NO_RESPONSES_CATEGORY": "此類別沒有回應",
                "SCORING_CATEGORY_NO_RESPONSES_QUESTION": "此問題沒有回應",
                "SCORING_OVERVIEW": "評分概觀",
                "SCORING_OVERVIEW_CLEAR_STRENGTH": "您與其他評估者皆認為此領域為最強項。",
                "SCORING_OVERVIEW_CLEAR_STRENGTH_LABEL": "明確強項",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS": "明確改善範圍表示自我評估與他人評估皆認為低於此能力的平均。",
                "SCORING_OVERVIEW_CLEAR_WEAKNESS_LABEL": "明確改善範圍",
                "SCORING_OVERVIEW_DESCRIPTION": "以上即是多位評估者意見反應流程中，您受到評估的能力/行為。評比的比較結果會依群組提供。",
                "SCORING_OVERVIEW_MINIMUM_GAP": "最小差距",
                "SCORING_OVERVIEW_MINIMUM_GAP_INFO": "用來顯示參考群組之間最小差異的文字。",
                "SCORING_OVERVIEW_TABLE_FOOTER": "顯示各項能力/行為的評分範圍資料。長條形代表數值平均值。",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH": "不明確強項表示自我評估與他人評估有所不同。",
                "SCORING_OVERVIEW_UNRECOGNIZED_STRENGTH_LABEL": "不明確強項",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS": "不明確改善範圍表示自我評估與他人評估有所不同。",
                "SCORING_OVERVIEW_UNRECOGNIZED_WEAKNESS_LABEL": "不明確改善範圍",
                "SELECT_CATEGORIES": "請選擇評分類別...",
                "SELECT_CATEGORY": "請選取評分類別...",
                "SELECT_CONDITION_TYPE": "選擇條件類型",
                "SELECT_DATA_SOURCE": "選取資料來源",
                "SELECT_DATA_SOURCE_TYPE": "選取資料來源類型",
                "SELECT_FILTER": "選擇篩選條件",
                "SELECT_FILTERS": "選擇篩選條件",
                "SELECT_OPERATOR_TYPE": "選擇運算子類型",
                "SELECT_PERSON": "選擇人員",
                "SELECT_PERSON_METADATA": "選取人員中繼資料",
                "SELECT_QUESTION": "選擇問題",
                "SELECT_QUESTIONS": "請選取問題...",
                "SELECT_RATIO_OR_DROPOFF": "選擇比率或下降",
                "SELECT_RELATIONSHIP": "選擇關係",
                "SELECT_SCORING_CATEGORY": "選擇評分類別",
                "SELF": "自己",
                "SELF_ASSESSMENT": "自我評估",
                "SEQUENTIAL": "按順序的",
                "SETUP_COMPARISON": "設定比較",
                "SETUP_COMPARISONS": "設定比較",
                "SET_START_COLOR": "設定開始顏色",
                "SHOULD_SHOW_FOOTER": "顯示頁尾",
                "SHOULD_SHOW_SCORING_CATEGORY": "顯示評分類別",
                "SHOWING_RECORDS_OF": "顯示記錄：%1-%2 (共 %3 個)",
                "SHOW_COMPARISON_GAP": "顯示比較差距欄",
                "SHOW_DATA_LABEL": "顯示資料值",
                "SHOW_PERCENTAGES": "顯示百分比",
                "SHOW_THE_FOLLOWING_TEXT": "然後顯示下列文字",
                "SHOW_TIES": "顯示關聯",
                "SHOW_X_AXIS": "顯示 X 軸",
                "SHOW_Y_AXIS": "顯示 Y 軸",
                "SMALL_LABELS": "小型標籤",
                "SORT": "排序",
                "SPLINE": "曲線圖",
                "STACK_CHART": "堆疊圖",
                "STANDARD_DEVIATION": "標準差",
                "STRENGTHS_BLIND_SPOTS_BOTTOM_THRESHOLD": "弱項 (小於)",
                "STRENGTHS_BLIND_SPOTS_EDIT_THRESHOLD_TEXTS": "編輯閥值文字",
                "STRENGTHS_BLIND_SPOTS_THRESHOLD_TEXTS": "閥值文字",
                "STRENGTHS_BLIND_SPOTS_TOGGLE_LABEL": "啟用閥值文字",
                "STRENGTHS_BLIND_SPOTS_TOP_THRESHOLD": "強項 (大於)",
                "SUM": "總計",
                "SUMMARY": "摘要",
                "TABLES": "表",
                "TABLE_TOTALS": "表格總計",
                "TAKE_NOTE_OF_THE_SCALE_DESCRIPTION": "請瞭解評估範圍，以確保解讀精確",
                "TAKE_NOTE_OF_THE_SCALE_HEADER": "記下範圍",
                "TEXT": "文字",
                "THINGS_YOU_WILL_SEE_HEADER": "您將會看到：",
                "TOP_BOTTOM_BOX": "頂部方塊/低部方塊",
                "TOP_BOX": "最高得分選項",
                "TOTAL": "總計",
                "TOTAL_COUNTS": "總計",
                "TO_DO": "待辦事項",
                "TRANSPOSE": "置換",
                "TRANSPOSE_TABLE": "置換表格",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUALITATIVE": "定性：此意見反應的形式將為開放式文字註解",
                "TYPES_OF_FEEDBACK_DESCRIPTION_QUANTITATIVE": "定量：此意見反應將為數值，且可以圖表、長條圖、表格等方式呈現",
                "TYPES_OF_FEEDBACK_HEADER": "意見反應的各種類型",
                "UNDO": "復原",
                "USE_COMPARISON": "使用比較",
                "USE_LABELS_FOR_SCALES": "為量表使用標籤",
                "VALUES": "值",
                "VALUE_RANGES": "值範圍",
                "VARIANCE": "偏差",
                "VERTICAL": "垂直",
                "VERTICAL_RANGE": "垂直範圍",
                "WARNING_DATA_OUT_OF_RANGE": "警告： 超出範圍配置的資料值",
                "WIDGET_ERROR": {
                    "ERROR": "發生非預期錯誤",
                    "MISCONFIGURED": "未正確配置此小組件。請檢查您的小組件配置。",
                    "NEW": "請配置小組件",
                    "NO_DATA": "未找到資料-您的篩選器可能太具有排他性！"
                },
                "WIDGET_NAME": {
                    "BAR": "條圖",
                    "BREAKDOWNBAR": "解析長條圖",
                    "DATA_TABLE": "資料表",
                    "FUNNEL_CHART": "漏斗圖",
                    "GAUGE": "儀錶圖",
                    "GRID": "結果表格",
                    "HEATMAP": "熱圖",
                    "LINE": "折線圖",
                    "NEEDS_BASED": "需求依據",
                    "PIE": "圓餅圖",
                    "PRICE_ESTIMATOR_VAN_WESTENDORP": "價格估算工具 (Van Westendorp)",
                    "REVENUE_MAXIMIZER_GABOR_GRANGER": "收益最大化工具 (Gabor Granger)",
                    "SCORING_OVERVIEW_CHART": "圖表",
                    "SCORING_OVERVIEW_TABLE": "表格",
                    "STATS_TABLE": "統計資料表格",
                    "WORDCLOUD": "文字雲"
                },
                "WORD_ROTATION": "單字旋轉",
                "WORD_SPACING": "單字空格",
                "YES": "是",
                "YOUR_RATINGS": "您的評估"
            },
            "WORDCLOUDWIDGET": {
                "ADD": "新增",
                "ADD_A_WORD": "新增文字",
                "COLOR": "顏色",
                "DELETE_ALL": "全部刪除",
                "EDIT_STOP_WORDS": "編輯結束文字",
                "MAX_WORDS": "字數上限",
                "ROTATION_ANGLED": "有角度的",
                "ROTATION_HORIZONTAL": "水平",
                "ROTATION_HORIZONTAL_AND_VERTICAL": "水平和垂直",
                "WORD_ORIENTATION": "文字方向"
            },
            "TEXTHIGHLIGHTSWIDGET": {
                "BACKGROUND_COLORS": "背景顏色",
                "DISPLAY_OPTIONS": "顯示選項",
                "INVERT_FONT_COLORS": "逆轉低對比度字體顏色",
                "PAGE": "頁面",
                "PAGINATE": "分頁"
            },
            "STATSTABLEWIDGET": {
                "AVG_METRIC": "中等",
                "BOTTOM_BOX_METRIC": "底部方塊",
                "COLUMNS": "欄",
                "COUNT_METRIC": "總回應數",
                "FIELD_NAME": "欄位",
                "MAX_METRIC": "最大",
                "MIN_METRIC": "最小",
                "SHOW_RECODES": "顯示重新編碼值",
                "SHOW_ROW_NUMBERS": "顯示列號",
                "STD_DEV_METRIC": "標準偏差",
                "TOP_BOX_METRIC": "頂部方塊",
                "TRANSPOSE_BREAKOUTS": "置換分離項",
                "TRANSPOSE_TABLE": "置換表",
                "VAR_METRIC": "偏差"
            },
            "SOURCECONFIGDEP": {
                "ADDITIONAL_COLUMNS": "其他欄",
                "ADD_COLUMNS": "新增其他欄",
                "ADD_CUSTOM_PALETTE": "新增自訂選用區",
                "ALL_CHOICES": "所有選項",
                "ALL_GROUPS": "所有群組",
                "ALL_RECODES": "所有重新編碼",
                "AUTOMATIC": "預設",
                "AUTOMATIC_DASH_CLICK_TO_EDIT": "預設-按一下即可進行編輯",
                "AXIS_VALUES": "軸值",
                "BREAKOUT_BY": "細分依據",
                "CANCEL": "取消",
                "CATEGORICAL": "分類的",
                "CHOICES": "選項",
                "CHOICE_COUNT": "選項計數",
                "COLOR_PALETTE": "顏色選用區",
                "COLUMN_VALUES": "行值",
                "CONTACT_FIELDS": "聯絡人欄位",
                "COUNT": "計數",
                "CREATE": "建立",
                "CUSTOM": "自訂",
                "CUSTOM_PALETTE": "自訂選用區",
                "DATA_SOURCE": "資料來源",
                "DAY": "天",
                "DAY_OF_WEEK": "星期",
                "DECIMAL_PRECISION": "小數位數",
                "DEFAULT": "預設",
                "DISABLED": "已停用",
                "DIVERGENT": "分散的",
                "EDIT_CUSTOM_PALETTE": "編輯自訂選用區",
                "ENABLED": "已啟用",
                "ERROR_LOADING_DATA": "載入資料時發生錯誤",
                "FILE_SIZE": "大小",
                "FILE_TYPE": "類型",
                "FRI": "周五",
                "FRIDAY": "周五",
                "GROUP_DATE_BY": "日期分組依據",
                "HOUR_OF_DAY": "一天中的小時",
                "LENGEND_VALUES": "圖注值",
                "MAX": "最大",
                "MEAN": "中等",
                "MIN": "最小",
                "MISCONFIGURED_DATA": "此視覺效果的資料來源設定錯誤。",
                "MISCONFIGURED_FILTERS": "無效的篩選器",
                "MODIFY_CUSTOM_PALETTES": "修改自訂選用區",
                "MON": "周一",
                "MONDAY": "周一",
                "MONTH": "月",
                "NONE": "無",
                "NO_FILE_ID_ERROR": "此視覺效果需要在調查中設定影像",
                "NO_RESULTS_TO_SHOW": "沒有要顯示的結果",
                "NPS": "Net Promoter Score®",
                "NPS_GROUP": "NPS®群組",
                "NUMERIC_VALUE": "數值",
                "PALETTE_REMOVED": "已移除選用區",
                "PERCENTAGE": "百分比",
                "PERCENTAGE_OF_CHOICES": "選項的百分比",
                "PERCENTAGE_OF_RESPONSES": "回應的百分比",
                "QUARTER": "季度",
                "REMOVE": "移除",
                "RESPONSE_COUNT": "回應計數",
                "RESULTS_PER_PAGE": "每頁結果數",
                "RETRIEVING_DATA_ELLIPSIS": "正在擷取資料...",
                "REVERSE_COLORS": "反向顏色",
                "ROW_VALUES": "列值",
                "SAT": "周六",
                "SATURDAY": "周六",
                "SAVE": "儲存",
                "SELECTED_CHOICE": "所選選項",
                "SELECT_FIELD": "選取欄位",
                "SELECT_METRIC": "度量值",
                "SEQUENTIAL": "按順序的",
                "SET_START_COLOR": "設定開始顏色",
                "SHOWING_SAMPLE_DATA_ELLIPSIS": "正在顯示樣本資料...",
                "SUM": "總計",
                "SUN": "周日",
                "SUNDAY": "周日",
                "SURVEY_EMBEDDEDDATA": "嵌入式資料",
                "SURVEY_METADATA": "調查中繼資料",
                "TEXT_ENTRY": "文字輸入",
                "THURS": "周四",
                "THURSDAY": "周四",
                "TITLE": "標題",
                "TUES": "周二",
                "TUESDAY": "周二",
                "UNBOUNDED_DOMAIN": "太多顯示數值。",
                "UNBOUNDED_DOMAIN_HELP": "將此欄位新增至結果報告，您可將篩選新增至報告以顯示「{{ed_field_name}}」的較少值或更新您的調查流程中「{{ed_field_name}}」的嵌入式資料變數類型，以便讓此欄位變為字串或數字類型。",
                "UNDO": "復原",
                "USE_CHOICE_TOTALS": "使用選項總計",
                "USE_RESPONDENT_TOTALS": "使用受訪者總計",
                "VISUALIZATION": "視覺效果",
                "VISUALIZATION_BARCHART": "條圖",
                "VISUALIZATION_BREAKDOWNBAR": "解析長條圖",
                "VISUALIZATION_GAUGE": "儀錶圖",
                "VISUALIZATION_HEATMAP": "熱圖",
                "VISUALIZATION_LINECHART": "折線圖",
                "VISUALIZATION_PAGINATEDTABLE": "編頁表格",
                "VISUALIZATION_PIE": "圓餅圖",
                "VISUALIZATION_SIMPLETABLE": "簡易表格",
                "VISUALIZATION_STATSTABLE": "統計資料表格",
                "VISUALIZATION_TEXTHIGHLIGHTS": "文字反白",
                "VISUALIZATION_WORDCLOUD": "文字雲",
                "WED": "周三",
                "WEDNESDAY": "週三",
                "WEEK": "週",
                "WEIGHTING": "加權",
                "WRONG_QUESTION_TYPE_ERROR": "此視覺效果類型不可用於此問題",
                "YEAR": "年份"
            },
            "SIMPLETABLEWIDGET": {
                "AVG": "平均",
                "CHOICE_COUNT": "選項計數",
                "COUNT": "計數",
                "DISPLAY_OPTIONS": "顯示選項",
                "MAX": "最大",
                "MIN": "最小",
                "NPS": "NPS®",
                "PAGE_OF": "頁碼：第 %1 頁 (共 %2 頁)",
                "PERCENT": "百分比",
                "RESPONSE_COUNT": "回應計數",
                "ROWS_PER_TABLE": "各表格的行數",
                "SHOWING_ROWS_OF": "顯示列：%1-%2 (共 %3 個)",
                "SHOW_PERCENTAGES": "顯示百分比",
                "SHOW_RECODES": "顯示重新編碼值",
                "SHOW_ROW_NUMBERS": "顯示列號",
                "SUM": "總計",
                "TOTAL": "總計",
                "TRANSPOSE": "置換",
                "USE_COLUMN_TOTALS": "使用行總和",
                "USE_ROW_TOTALS": "使用列總和",
                "VALUE": "值"
            },
            "BARCHARTWIDGET": {
                "ASCENDING": "上升",
                "COUNT": "計數",
                "DESCENDING": "下降",
                "DIAGONAL": "對角",
                "DISPLAY_OPTIONS": "顯示選項",
                "ERROR_COLON": "錯誤：",
                "ERROR_GENERIC": "載入視覺效果時發生錯誤。",
                "HORIZONTAL": "水平",
                "HORIZONTAL_BARS": "水平條",
                "INCORRECTLY_CONFIGURED": "選擇值以顯示圖表",
                "LEGEND_AUTO": "自動",
                "LEGEND_BOTTOM": "底部",
                "LEGEND_INSET": "嵌入",
                "LEGEND_RIGHT": "右",
                "NORMALIZE_TO_PERCENTAGES": "正規化為百分比",
                "SHOW_BAR_LABELS": "顯示條欄標籤",
                "SHOW_LEGEND": "顯示圖注",
                "SHOW_X_AXIS": "顯示 X 軸",
                "SHOW_Y_AXIS": "顯示 Y 軸",
                "SORT_BAR_VALUES": "對條欄值進行排序",
                "STACKED_BARS": "堆疊條",
                "TRANSPOSE": "置換",
                "TRUNCATE_LABELS": "截斷標籤",
                "VERTICAL": "垂直"
            },
            "PIEWIDGET": {
                "ALL_OTHERS": "所有其他",
                "COULD_NOT_LOAD_DATA": "無法使用指定的配置載入資料：請嘗試不同的來源欄位或更大的日期範圍。",
                "GROUPING_PERCENTAGE_THRESHOLD": "分組百分比閥值",
                "NO_DATA": "無資料",
                "RADIUS": "內半徑",
                "SHOW_AS_PERCENTAGES": "顯示為百分比"
            },
            "PAGINATEDTABLEWIDGET": {
                "CLOSE": "關閉",
                "DOWNLOAD_CSV": "下載 CSV",
                "DOWNLOAD_ZIP": "下載所有檔案",
                "NO_DATA": "無資料",
                "PAGE_OF": "頁碼：第 %1 頁 (共 %2 頁)",
                "RESULTS_PER_PAGE": "每頁結果數",
                "SHOWING_RECORDS_OF": "顯示記錄：%1-%2 (共 %3 個)",
                "SINGLE_RESPONSE": "單個回應",
                "VIEW_RESPONSE": "檢視回應"
            },
            "LINECHARTWIDGET": {
                "DISPLAY_OPTIONS": "顯示選項",
                "ERROR_COLON": "錯誤：",
                "ERROR_GENERIC": "載入視覺效果時發生錯誤。",
                "HORIZONTAL_BARS": "水平條",
                "INCORRECTLY_CONFIGURED": "選擇值以顯示圖表",
                "LEGEND_AUTO": "自動",
                "LEGEND_BOTTOM": "底部",
                "LEGEND_INSET": "嵌入",
                "LEGEND_RIGHT": "右",
                "NORMALIZE_TO_PERCENTAGES": "正規化為百分比",
                "SHOW_AREA": "顯示區域",
                "SHOW_LEGEND": "顯示圖注",
                "SHOW_X_AXIS": "顯示 X 軸",
                "SHOW_Y_AXIS": "顯示 Y 軸",
                "SMOOTH_LINES": "平滑線",
                "SORT_X_AXIS_LABELS": "排序 X 軸標籤",
                "STACKED_BARS": "堆疊條",
                "TRANSPOSE": "置換"
            },
            "HEATMAPWIDGET": {
                "BLOCK_MODE": "區塊模式",
                "BLUR": "模糊",
                "COULD_NOT_LOAD_DATA": "無法使用指定的配置載入資料：請嘗試不同的來源欄位或更大的日期範圍。",
                "FIELD": "欄位",
                "RADIUS": "半徑",
                "SHOW_REGIONS": "顯示區域",
                "SHOW_REGION_LABELS": "顯示區域標籤"
            },
            "GAUGEWIDGET": {
                "MAX": "最大",
                "MIN": "最小",
                "VALUE_RANGES": "值範圍"
            },
            "BREAKDOWNBARWIDGET": {
                "BOTTOM_LABELS": "底部標籤",
                "CATEGORY_NAME": "類別名稱",
                "ERROR_COLON": "錯誤：",
                "INCLUDE_HIDDEN_GROUPS": "在百分比中包含隱藏的群組",
                "LARGE_LABELS": "大型標籤",
                "NO": "否",
                "PERCENT": "百分比",
                "RESPONSE_COUNT": "回應計數",
                "RESPONSE_COUNT_WITH_VALUE": "{{ responseCount }} 個回應",
                "SMALL_LABELS": "小型標籤",
                "YES": "是"
            }
        });
        return $cache;
    }]);
